var kE = Object.defineProperty;
var RE = (r, t, a) => t in r ? kE(r, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : r[t] = a;
var Ky = (r, t, a) => RE(r, typeof t != "symbol" ? t + "" : t, a);
var zv = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function eh(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var p5 = { exports: {} }, Mg = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Z8;
function zE() {
  if (Z8) return Mg;
  Z8 = 1;
  var r = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function a(i, s, h) {
    var d = null;
    if (h !== void 0 && (d = "" + h), s.key !== void 0 && (d = "" + s.key), "key" in s) {
      h = {};
      for (var y in s)
        y !== "key" && (h[y] = s[y]);
    } else h = s;
    return s = h.ref, {
      $$typeof: r,
      type: i,
      key: d,
      ref: s !== void 0 ? s : null,
      props: h
    };
  }
  return Mg.Fragment = t, Mg.jsx = a, Mg.jsxs = a, Mg;
}
var _g = {}, g5 = { exports: {} }, qt = {};
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var F8;
function CE() {
  if (F8) return qt;
  F8 = 1;
  var r = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), h = Symbol.for("react.consumer"), d = Symbol.for("react.context"), y = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), b = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), T = Symbol.iterator;
  function R(C) {
    return C === null || typeof C != "object" ? null : (C = T && C[T] || C["@@iterator"], typeof C == "function" ? C : null);
  }
  var E = {
    isMounted: function() {
      return !1;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, O = Object.assign, L = {};
  function G(C, Y, ie) {
    this.props = C, this.context = Y, this.refs = L, this.updater = ie || E;
  }
  G.prototype.isReactComponent = {}, G.prototype.setState = function(C, Y) {
    if (typeof C != "object" && typeof C != "function" && C != null)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, C, Y, "setState");
  }, G.prototype.forceUpdate = function(C) {
    this.updater.enqueueForceUpdate(this, C, "forceUpdate");
  };
  function V() {
  }
  V.prototype = G.prototype;
  function I(C, Y, ie) {
    this.props = C, this.context = Y, this.refs = L, this.updater = ie || E;
  }
  var $ = I.prototype = new V();
  $.constructor = I, O($, G.prototype), $.isPureReactComponent = !0;
  var ce = Array.isArray, se = { H: null, A: null, T: null, S: null, V: null }, te = Object.prototype.hasOwnProperty;
  function Ce(C, Y, ie, N, Me, _e) {
    return ie = _e.ref, {
      $$typeof: r,
      type: C,
      key: Y,
      ref: ie !== void 0 ? ie : null,
      props: _e
    };
  }
  function ve(C, Y) {
    return Ce(
      C.type,
      Y,
      void 0,
      void 0,
      void 0,
      C.props
    );
  }
  function Ne(C) {
    return typeof C == "object" && C !== null && C.$$typeof === r;
  }
  function ee(C) {
    var Y = { "=": "=0", ":": "=2" };
    return "$" + C.replace(/[=:]/g, function(ie) {
      return Y[ie];
    });
  }
  var De = /\/+/g;
  function de(C, Y) {
    return typeof C == "object" && C !== null && C.key != null ? ee("" + C.key) : Y.toString(36);
  }
  function Ye() {
  }
  function Te(C) {
    switch (C.status) {
      case "fulfilled":
        return C.value;
      case "rejected":
        throw C.reason;
      default:
        switch (typeof C.status == "string" ? C.then(Ye, Ye) : (C.status = "pending", C.then(
          function(Y) {
            C.status === "pending" && (C.status = "fulfilled", C.value = Y);
          },
          function(Y) {
            C.status === "pending" && (C.status = "rejected", C.reason = Y);
          }
        )), C.status) {
          case "fulfilled":
            return C.value;
          case "rejected":
            throw C.reason;
        }
    }
    throw C;
  }
  function re(C, Y, ie, N, Me) {
    var _e = typeof C;
    (_e === "undefined" || _e === "boolean") && (C = null);
    var Se = !1;
    if (C === null) Se = !0;
    else
      switch (_e) {
        case "bigint":
        case "string":
        case "number":
          Se = !0;
          break;
        case "object":
          switch (C.$$typeof) {
            case r:
            case t:
              Se = !0;
              break;
            case x:
              return Se = C._init, re(
                Se(C._payload),
                Y,
                ie,
                N,
                Me
              );
          }
      }
    if (Se)
      return Me = Me(C), Se = N === "" ? "." + de(C, 0) : N, ce(Me) ? (ie = "", Se != null && (ie = Se.replace(De, "$&/") + "/"), re(Me, Y, ie, "", function(ht) {
        return ht;
      })) : Me != null && (Ne(Me) && (Me = ve(
        Me,
        ie + (Me.key == null || C && C.key === Me.key ? "" : ("" + Me.key).replace(
          De,
          "$&/"
        ) + "/") + Se
      )), Y.push(Me)), 1;
    Se = 0;
    var Ge = N === "" ? "." : N + ":";
    if (ce(C))
      for (var rt = 0; rt < C.length; rt++)
        N = C[rt], _e = Ge + de(N, rt), Se += re(
          N,
          Y,
          ie,
          _e,
          Me
        );
    else if (rt = R(C), typeof rt == "function")
      for (C = rt.call(C), rt = 0; !(N = C.next()).done; )
        N = N.value, _e = Ge + de(N, rt++), Se += re(
          N,
          Y,
          ie,
          _e,
          Me
        );
    else if (_e === "object") {
      if (typeof C.then == "function")
        return re(
          Te(C),
          Y,
          ie,
          N,
          Me
        );
      throw Y = String(C), Error(
        "Objects are not valid as a React child (found: " + (Y === "[object Object]" ? "object with keys {" + Object.keys(C).join(", ") + "}" : Y) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return Se;
  }
  function J(C, Y, ie) {
    if (C == null) return C;
    var N = [], Me = 0;
    return re(C, N, "", "", function(_e) {
      return Y.call(ie, _e, Me++);
    }), N;
  }
  function X(C) {
    if (C._status === -1) {
      var Y = C._result;
      Y = Y(), Y.then(
        function(ie) {
          (C._status === 0 || C._status === -1) && (C._status = 1, C._result = ie);
        },
        function(ie) {
          (C._status === 0 || C._status === -1) && (C._status = 2, C._result = ie);
        }
      ), C._status === -1 && (C._status = 0, C._result = Y);
    }
    if (C._status === 1) return C._result.default;
    throw C._result;
  }
  var W = typeof reportError == "function" ? reportError : function(C) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var Y = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof C == "object" && C !== null && typeof C.message == "string" ? String(C.message) : String(C),
        error: C
      });
      if (!window.dispatchEvent(Y)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", C);
      return;
    }
    console.error(C);
  };
  function be() {
  }
  return qt.Children = {
    map: J,
    forEach: function(C, Y, ie) {
      J(
        C,
        function() {
          Y.apply(this, arguments);
        },
        ie
      );
    },
    count: function(C) {
      var Y = 0;
      return J(C, function() {
        Y++;
      }), Y;
    },
    toArray: function(C) {
      return J(C, function(Y) {
        return Y;
      }) || [];
    },
    only: function(C) {
      if (!Ne(C))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return C;
    }
  }, qt.Component = G, qt.Fragment = a, qt.Profiler = s, qt.PureComponent = I, qt.StrictMode = i, qt.Suspense = g, qt.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = se, qt.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(C) {
      return se.H.useMemoCache(C);
    }
  }, qt.cache = function(C) {
    return function() {
      return C.apply(null, arguments);
    };
  }, qt.cloneElement = function(C, Y, ie) {
    if (C == null)
      throw Error(
        "The argument must be a React element, but you passed " + C + "."
      );
    var N = O({}, C.props), Me = C.key, _e = void 0;
    if (Y != null)
      for (Se in Y.ref !== void 0 && (_e = void 0), Y.key !== void 0 && (Me = "" + Y.key), Y)
        !te.call(Y, Se) || Se === "key" || Se === "__self" || Se === "__source" || Se === "ref" && Y.ref === void 0 || (N[Se] = Y[Se]);
    var Se = arguments.length - 2;
    if (Se === 1) N.children = ie;
    else if (1 < Se) {
      for (var Ge = Array(Se), rt = 0; rt < Se; rt++)
        Ge[rt] = arguments[rt + 2];
      N.children = Ge;
    }
    return Ce(C.type, Me, void 0, void 0, _e, N);
  }, qt.createContext = function(C) {
    return C = {
      $$typeof: d,
      _currentValue: C,
      _currentValue2: C,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, C.Provider = C, C.Consumer = {
      $$typeof: h,
      _context: C
    }, C;
  }, qt.createElement = function(C, Y, ie) {
    var N, Me = {}, _e = null;
    if (Y != null)
      for (N in Y.key !== void 0 && (_e = "" + Y.key), Y)
        te.call(Y, N) && N !== "key" && N !== "__self" && N !== "__source" && (Me[N] = Y[N]);
    var Se = arguments.length - 2;
    if (Se === 1) Me.children = ie;
    else if (1 < Se) {
      for (var Ge = Array(Se), rt = 0; rt < Se; rt++)
        Ge[rt] = arguments[rt + 2];
      Me.children = Ge;
    }
    if (C && C.defaultProps)
      for (N in Se = C.defaultProps, Se)
        Me[N] === void 0 && (Me[N] = Se[N]);
    return Ce(C, _e, void 0, void 0, null, Me);
  }, qt.createRef = function() {
    return { current: null };
  }, qt.forwardRef = function(C) {
    return { $$typeof: y, render: C };
  }, qt.isValidElement = Ne, qt.lazy = function(C) {
    return {
      $$typeof: x,
      _payload: { _status: -1, _result: C },
      _init: X
    };
  }, qt.memo = function(C, Y) {
    return {
      $$typeof: b,
      type: C,
      compare: Y === void 0 ? null : Y
    };
  }, qt.startTransition = function(C) {
    var Y = se.T, ie = {};
    se.T = ie;
    try {
      var N = C(), Me = se.S;
      Me !== null && Me(ie, N), typeof N == "object" && N !== null && typeof N.then == "function" && N.then(be, W);
    } catch (_e) {
      W(_e);
    } finally {
      se.T = Y;
    }
  }, qt.unstable_useCacheRefresh = function() {
    return se.H.useCacheRefresh();
  }, qt.use = function(C) {
    return se.H.use(C);
  }, qt.useActionState = function(C, Y, ie) {
    return se.H.useActionState(C, Y, ie);
  }, qt.useCallback = function(C, Y) {
    return se.H.useCallback(C, Y);
  }, qt.useContext = function(C) {
    return se.H.useContext(C);
  }, qt.useDebugValue = function() {
  }, qt.useDeferredValue = function(C, Y) {
    return se.H.useDeferredValue(C, Y);
  }, qt.useEffect = function(C, Y, ie) {
    var N = se.H;
    if (typeof ie == "function")
      throw Error(
        "useEffect CRUD overload is not enabled in this build of React."
      );
    return N.useEffect(C, Y);
  }, qt.useId = function() {
    return se.H.useId();
  }, qt.useImperativeHandle = function(C, Y, ie) {
    return se.H.useImperativeHandle(C, Y, ie);
  }, qt.useInsertionEffect = function(C, Y) {
    return se.H.useInsertionEffect(C, Y);
  }, qt.useLayoutEffect = function(C, Y) {
    return se.H.useLayoutEffect(C, Y);
  }, qt.useMemo = function(C, Y) {
    return se.H.useMemo(C, Y);
  }, qt.useOptimistic = function(C, Y) {
    return se.H.useOptimistic(C, Y);
  }, qt.useReducer = function(C, Y, ie) {
    return se.H.useReducer(C, Y, ie);
  }, qt.useRef = function(C) {
    return se.H.useRef(C);
  }, qt.useState = function(C) {
    return se.H.useState(C);
  }, qt.useSyncExternalStore = function(C, Y, ie) {
    return se.H.useSyncExternalStore(
      C,
      Y,
      ie
    );
  }, qt.useTransition = function() {
    return se.H.useTransition();
  }, qt.version = "19.1.0", qt;
}
var Hg = { exports: {} };
Hg.exports;
var P8;
function ME() {
  return P8 || (P8 = 1, function(r, t) {
    var a = {};
    /**
     * @license React
     * react.development.js
     *
     * Copyright (c) Meta Platforms, Inc. and affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    a.NODE_ENV !== "production" && function() {
      function i(B, ue) {
        Object.defineProperty(d.prototype, B, {
          get: function() {
            console.warn(
              "%s(...) is deprecated in plain JavaScript React classes. %s",
              ue[0],
              ue[1]
            );
          }
        });
      }
      function s(B) {
        return B === null || typeof B != "object" ? null : (B = wn && B[wn] || B["@@iterator"], typeof B == "function" ? B : null);
      }
      function h(B, ue) {
        B = (B = B.constructor) && (B.displayName || B.name) || "ReactClass";
        var Ie = B + "." + ue;
        Dr[Ie] || (console.error(
          "Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.",
          ue,
          B
        ), Dr[Ie] = !0);
      }
      function d(B, ue, Ie) {
        this.props = B, this.context = ue, this.refs = xr, this.updater = Ie || jn;
      }
      function y() {
      }
      function g(B, ue, Ie) {
        this.props = B, this.context = ue, this.refs = xr, this.updater = Ie || jn;
      }
      function b(B) {
        return "" + B;
      }
      function x(B) {
        try {
          b(B);
          var ue = !1;
        } catch {
          ue = !0;
        }
        if (ue) {
          ue = console;
          var Ie = ue.error, Qe = typeof Symbol == "function" && Symbol.toStringTag && B[Symbol.toStringTag] || B.constructor.name || "Object";
          return Ie.call(
            ue,
            "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
            Qe
          ), b(B);
        }
      }
      function T(B) {
        if (B == null) return null;
        if (typeof B == "function")
          return B.$$typeof === El ? null : B.displayName || B.name || null;
        if (typeof B == "string") return B;
        switch (B) {
          case Y:
            return "Fragment";
          case N:
            return "Profiler";
          case ie:
            return "StrictMode";
          case Ge:
            return "Suspense";
          case rt:
            return "SuspenseList";
          case St:
            return "Activity";
        }
        if (typeof B == "object")
          switch (typeof B.tag == "number" && console.error(
            "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
          ), B.$$typeof) {
            case C:
              return "Portal";
            case _e:
              return (B.displayName || "Context") + ".Provider";
            case Me:
              return (B._context.displayName || "Context") + ".Consumer";
            case Se:
              var ue = B.render;
              return B = B.displayName, B || (B = ue.displayName || ue.name || "", B = B !== "" ? "ForwardRef(" + B + ")" : "ForwardRef"), B;
            case ht:
              return ue = B.displayName || null, ue !== null ? ue : T(B.type) || "Memo";
            case vt:
              ue = B._payload, B = B._init;
              try {
                return T(B(ue));
              } catch {
              }
          }
        return null;
      }
      function R(B) {
        if (B === Y) return "<>";
        if (typeof B == "object" && B !== null && B.$$typeof === vt)
          return "<...>";
        try {
          var ue = T(B);
          return ue ? "<" + ue + ">" : "<...>";
        } catch {
          return "<...>";
        }
      }
      function E() {
        var B = xt.A;
        return B === null ? null : B.getOwner();
      }
      function O() {
        return Error("react-stack-top-frame");
      }
      function L(B) {
        if (nl.call(B, "key")) {
          var ue = Object.getOwnPropertyDescriptor(B, "key").get;
          if (ue && ue.isReactWarning) return !1;
        }
        return B.key !== void 0;
      }
      function G(B, ue) {
        function Ie() {
          cr || (cr = !0, console.error(
            "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
            ue
          ));
        }
        Ie.isReactWarning = !0, Object.defineProperty(B, "key", {
          get: Ie,
          configurable: !0
        });
      }
      function V() {
        var B = T(this.type);
        return ke[B] || (ke[B] = !0, console.error(
          "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
        )), B = this.props.ref, B !== void 0 ? B : null;
      }
      function I(B, ue, Ie, Qe, et, Ht, kt, Pt) {
        return Ie = Ht.ref, B = {
          $$typeof: be,
          type: B,
          key: ue,
          props: Ht,
          _owner: et
        }, (Ie !== void 0 ? Ie : null) !== null ? Object.defineProperty(B, "ref", {
          enumerable: !1,
          get: V
        }) : Object.defineProperty(B, "ref", { enumerable: !1, value: null }), B._store = {}, Object.defineProperty(B._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: 0
        }), Object.defineProperty(B, "_debugInfo", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: null
        }), Object.defineProperty(B, "_debugStack", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: kt
        }), Object.defineProperty(B, "_debugTask", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: Pt
        }), Object.freeze && (Object.freeze(B.props), Object.freeze(B)), B;
      }
      function $(B, ue) {
        return ue = I(
          B.type,
          ue,
          void 0,
          void 0,
          B._owner,
          B.props,
          B._debugStack,
          B._debugTask
        ), B._store && (ue._store.validated = B._store.validated), ue;
      }
      function ce(B) {
        return typeof B == "object" && B !== null && B.$$typeof === be;
      }
      function se(B) {
        var ue = { "=": "=0", ":": "=2" };
        return "$" + B.replace(/[=:]/g, function(Ie) {
          return ue[Ie];
        });
      }
      function te(B, ue) {
        return typeof B == "object" && B !== null && B.key != null ? (x(B.key), se("" + B.key)) : ue.toString(36);
      }
      function Ce() {
      }
      function ve(B) {
        switch (B.status) {
          case "fulfilled":
            return B.value;
          case "rejected":
            throw B.reason;
          default:
            switch (typeof B.status == "string" ? B.then(Ce, Ce) : (B.status = "pending", B.then(
              function(ue) {
                B.status === "pending" && (B.status = "fulfilled", B.value = ue);
              },
              function(ue) {
                B.status === "pending" && (B.status = "rejected", B.reason = ue);
              }
            )), B.status) {
              case "fulfilled":
                return B.value;
              case "rejected":
                throw B.reason;
            }
        }
        throw B;
      }
      function Ne(B, ue, Ie, Qe, et) {
        var Ht = typeof B;
        (Ht === "undefined" || Ht === "boolean") && (B = null);
        var kt = !1;
        if (B === null) kt = !0;
        else
          switch (Ht) {
            case "bigint":
            case "string":
            case "number":
              kt = !0;
              break;
            case "object":
              switch (B.$$typeof) {
                case be:
                case C:
                  kt = !0;
                  break;
                case vt:
                  return kt = B._init, Ne(
                    kt(B._payload),
                    ue,
                    Ie,
                    Qe,
                    et
                  );
              }
          }
        if (kt) {
          kt = B, et = et(kt);
          var Pt = Qe === "" ? "." + te(kt, 0) : Qe;
          return sr(et) ? (Ie = "", Pt != null && (Ie = Pt.replace(Qt, "$&/") + "/"), Ne(et, ue, Ie, "", function(tr) {
            return tr;
          })) : et != null && (ce(et) && (et.key != null && (kt && kt.key === et.key || x(et.key)), Ie = $(
            et,
            Ie + (et.key == null || kt && kt.key === et.key ? "" : ("" + et.key).replace(
              Qt,
              "$&/"
            ) + "/") + Pt
          ), Qe !== "" && kt != null && ce(kt) && kt.key == null && kt._store && !kt._store.validated && (Ie._store.validated = 2), et = Ie), ue.push(et)), 1;
        }
        if (kt = 0, Pt = Qe === "" ? "." : Qe + ":", sr(B))
          for (var Tt = 0; Tt < B.length; Tt++)
            Qe = B[Tt], Ht = Pt + te(Qe, Tt), kt += Ne(
              Qe,
              ue,
              Ie,
              Ht,
              et
            );
        else if (Tt = s(B), typeof Tt == "function")
          for (Tt === B.entries && (st || console.warn(
            "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
          ), st = !0), B = Tt.call(B), Tt = 0; !(Qe = B.next()).done; )
            Qe = Qe.value, Ht = Pt + te(Qe, Tt++), kt += Ne(
              Qe,
              ue,
              Ie,
              Ht,
              et
            );
        else if (Ht === "object") {
          if (typeof B.then == "function")
            return Ne(
              ve(B),
              ue,
              Ie,
              Qe,
              et
            );
          throw ue = String(B), Error(
            "Objects are not valid as a React child (found: " + (ue === "[object Object]" ? "object with keys {" + Object.keys(B).join(", ") + "}" : ue) + "). If you meant to render a collection of children, use an array instead."
          );
        }
        return kt;
      }
      function ee(B, ue, Ie) {
        if (B == null) return B;
        var Qe = [], et = 0;
        return Ne(B, Qe, "", "", function(Ht) {
          return ue.call(Ie, Ht, et++);
        }), Qe;
      }
      function De(B) {
        if (B._status === -1) {
          var ue = B._result;
          ue = ue(), ue.then(
            function(Ie) {
              (B._status === 0 || B._status === -1) && (B._status = 1, B._result = Ie);
            },
            function(Ie) {
              (B._status === 0 || B._status === -1) && (B._status = 2, B._result = Ie);
            }
          ), B._status === -1 && (B._status = 0, B._result = ue);
        }
        if (B._status === 1)
          return ue = B._result, ue === void 0 && console.error(
            `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`,
            ue
          ), "default" in ue || console.error(
            `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`,
            ue
          ), ue.default;
        throw B._result;
      }
      function de() {
        var B = xt.H;
        return B === null && console.error(
          `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
        ), B;
      }
      function Ye() {
      }
      function Te(B) {
        if (fr === null)
          try {
            var ue = ("require" + Math.random()).slice(0, 7);
            fr = (r && r[ue]).call(
              r,
              "timers"
            ).setImmediate;
          } catch {
            fr = function(Qe) {
              La === !1 && (La = !0, typeof MessageChannel > "u" && console.error(
                "This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."
              ));
              var et = new MessageChannel();
              et.port1.onmessage = Qe, et.port2.postMessage(void 0);
            };
          }
        return fr(B);
      }
      function re(B) {
        return 1 < B.length && typeof AggregateError == "function" ? new AggregateError(B) : B[0];
      }
      function J(B, ue) {
        ue !== Nr - 1 && console.error(
          "You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "
        ), Nr = ue;
      }
      function X(B, ue, Ie) {
        var Qe = xt.actQueue;
        if (Qe !== null)
          if (Qe.length !== 0)
            try {
              W(Qe), Te(function() {
                return X(B, ue, Ie);
              });
              return;
            } catch (et) {
              xt.thrownErrors.push(et);
            }
          else xt.actQueue = null;
        0 < xt.thrownErrors.length ? (Qe = re(xt.thrownErrors), xt.thrownErrors.length = 0, Ie(Qe)) : ue(B);
      }
      function W(B) {
        if (!hn) {
          hn = !0;
          var ue = 0;
          try {
            for (; ue < B.length; ue++) {
              var Ie = B[ue];
              do {
                xt.didUsePromise = !1;
                var Qe = Ie(!1);
                if (Qe !== null) {
                  if (xt.didUsePromise) {
                    B[ue] = Ie, B.splice(0, ue);
                    return;
                  }
                  Ie = Qe;
                } else break;
              } while (!0);
            }
            B.length = 0;
          } catch (et) {
            B.splice(0, ue + 1), xt.thrownErrors.push(et);
          } finally {
            hn = !1;
          }
        }
      }
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
      var be = Symbol.for("react.transitional.element"), C = Symbol.for("react.portal"), Y = Symbol.for("react.fragment"), ie = Symbol.for("react.strict_mode"), N = Symbol.for("react.profiler"), Me = Symbol.for("react.consumer"), _e = Symbol.for("react.context"), Se = Symbol.for("react.forward_ref"), Ge = Symbol.for("react.suspense"), rt = Symbol.for("react.suspense_list"), ht = Symbol.for("react.memo"), vt = Symbol.for("react.lazy"), St = Symbol.for("react.activity"), wn = Symbol.iterator, Dr = {}, jn = {
        isMounted: function() {
          return !1;
        },
        enqueueForceUpdate: function(B) {
          h(B, "forceUpdate");
        },
        enqueueReplaceState: function(B) {
          h(B, "replaceState");
        },
        enqueueSetState: function(B) {
          h(B, "setState");
        }
      }, Gn = Object.assign, xr = {};
      Object.freeze(xr), d.prototype.isReactComponent = {}, d.prototype.setState = function(B, ue) {
        if (typeof B != "object" && typeof B != "function" && B != null)
          throw Error(
            "takes an object of state variables to update or a function which returns an object of state variables."
          );
        this.updater.enqueueSetState(this, B, ue, "setState");
      }, d.prototype.forceUpdate = function(B) {
        this.updater.enqueueForceUpdate(this, B, "forceUpdate");
      };
      var Bt = {
        isMounted: [
          "isMounted",
          "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
          "replaceState",
          "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
      }, er;
      for (er in Bt)
        Bt.hasOwnProperty(er) && i(er, Bt[er]);
      y.prototype = d.prototype, Bt = g.prototype = new y(), Bt.constructor = g, Gn(Bt, d.prototype), Bt.isPureReactComponent = !0;
      var sr = Array.isArray, El = Symbol.for("react.client.reference"), xt = {
        H: null,
        A: null,
        T: null,
        S: null,
        V: null,
        actQueue: null,
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1,
        didUsePromise: !1,
        thrownErrors: [],
        getCurrentStack: null,
        recentlyCreatedOwnerStacks: 0
      }, nl = Object.prototype.hasOwnProperty, Tn = console.createTask ? console.createTask : function() {
        return null;
      };
      Bt = {
        "react-stack-bottom-frame": function(B) {
          return B();
        }
      };
      var cr, rl, ke = {}, je = Bt["react-stack-bottom-frame"].bind(Bt, O)(), ut = Tn(R(O)), st = !1, Qt = /\/+/g, Zn = typeof reportError == "function" ? reportError : function(B) {
        if (typeof window == "object" && typeof window.ErrorEvent == "function") {
          var ue = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: typeof B == "object" && B !== null && typeof B.message == "string" ? String(B.message) : String(B),
            error: B
          });
          if (!window.dispatchEvent(ue)) return;
        } else if (typeof process == "object" && typeof process.emit == "function") {
          process.emit("uncaughtException", B);
          return;
        }
        console.error(B);
      }, La = !1, fr = null, Nr = 0, Hn = !1, hn = !1, hr = typeof queueMicrotask == "function" ? function(B) {
        queueMicrotask(function() {
          return queueMicrotask(B);
        });
      } : Te;
      Bt = Object.freeze({
        __proto__: null,
        c: function(B) {
          return de().useMemoCache(B);
        }
      }), t.Children = {
        map: ee,
        forEach: function(B, ue, Ie) {
          ee(
            B,
            function() {
              ue.apply(this, arguments);
            },
            Ie
          );
        },
        count: function(B) {
          var ue = 0;
          return ee(B, function() {
            ue++;
          }), ue;
        },
        toArray: function(B) {
          return ee(B, function(ue) {
            return ue;
          }) || [];
        },
        only: function(B) {
          if (!ce(B))
            throw Error(
              "React.Children.only expected to receive a single React element child."
            );
          return B;
        }
      }, t.Component = d, t.Fragment = Y, t.Profiler = N, t.PureComponent = g, t.StrictMode = ie, t.Suspense = Ge, t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = xt, t.__COMPILER_RUNTIME = Bt, t.act = function(B) {
        var ue = xt.actQueue, Ie = Nr;
        Nr++;
        var Qe = xt.actQueue = ue !== null ? ue : [], et = !1;
        try {
          var Ht = B();
        } catch (Tt) {
          xt.thrownErrors.push(Tt);
        }
        if (0 < xt.thrownErrors.length)
          throw J(ue, Ie), B = re(xt.thrownErrors), xt.thrownErrors.length = 0, B;
        if (Ht !== null && typeof Ht == "object" && typeof Ht.then == "function") {
          var kt = Ht;
          return hr(function() {
            et || Hn || (Hn = !0, console.error(
              "You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"
            ));
          }), {
            then: function(Tt, tr) {
              et = !0, kt.then(
                function(ai) {
                  if (J(ue, Ie), Ie === 0) {
                    try {
                      W(Qe), Te(function() {
                        return X(
                          ai,
                          Tt,
                          tr
                        );
                      });
                    } catch (li) {
                      xt.thrownErrors.push(li);
                    }
                    if (0 < xt.thrownErrors.length) {
                      var Hm = re(
                        xt.thrownErrors
                      );
                      xt.thrownErrors.length = 0, tr(Hm);
                    }
                  } else Tt(ai);
                },
                function(ai) {
                  J(ue, Ie), 0 < xt.thrownErrors.length && (ai = re(
                    xt.thrownErrors
                  ), xt.thrownErrors.length = 0), tr(ai);
                }
              );
            }
          };
        }
        var Pt = Ht;
        if (J(ue, Ie), Ie === 0 && (W(Qe), Qe.length !== 0 && hr(function() {
          et || Hn || (Hn = !0, console.error(
            "A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"
          ));
        }), xt.actQueue = null), 0 < xt.thrownErrors.length)
          throw B = re(xt.thrownErrors), xt.thrownErrors.length = 0, B;
        return {
          then: function(Tt, tr) {
            et = !0, Ie === 0 ? (xt.actQueue = Qe, Te(function() {
              return X(
                Pt,
                Tt,
                tr
              );
            })) : Tt(Pt);
          }
        };
      }, t.cache = function(B) {
        return function() {
          return B.apply(null, arguments);
        };
      }, t.captureOwnerStack = function() {
        var B = xt.getCurrentStack;
        return B === null ? null : B();
      }, t.cloneElement = function(B, ue, Ie) {
        if (B == null)
          throw Error(
            "The argument must be a React element, but you passed " + B + "."
          );
        var Qe = Gn({}, B.props), et = B.key, Ht = B._owner;
        if (ue != null) {
          var kt;
          e: {
            if (nl.call(ue, "ref") && (kt = Object.getOwnPropertyDescriptor(
              ue,
              "ref"
            ).get) && kt.isReactWarning) {
              kt = !1;
              break e;
            }
            kt = ue.ref !== void 0;
          }
          kt && (Ht = E()), L(ue) && (x(ue.key), et = "" + ue.key);
          for (Pt in ue)
            !nl.call(ue, Pt) || Pt === "key" || Pt === "__self" || Pt === "__source" || Pt === "ref" && ue.ref === void 0 || (Qe[Pt] = ue[Pt]);
        }
        var Pt = arguments.length - 2;
        if (Pt === 1) Qe.children = Ie;
        else if (1 < Pt) {
          kt = Array(Pt);
          for (var Tt = 0; Tt < Pt; Tt++)
            kt[Tt] = arguments[Tt + 2];
          Qe.children = kt;
        }
        for (Qe = I(
          B.type,
          et,
          void 0,
          void 0,
          Ht,
          Qe,
          B._debugStack,
          B._debugTask
        ), et = 2; et < arguments.length; et++)
          Ht = arguments[et], ce(Ht) && Ht._store && (Ht._store.validated = 1);
        return Qe;
      }, t.createContext = function(B) {
        return B = {
          $$typeof: _e,
          _currentValue: B,
          _currentValue2: B,
          _threadCount: 0,
          Provider: null,
          Consumer: null
        }, B.Provider = B, B.Consumer = {
          $$typeof: Me,
          _context: B
        }, B._currentRenderer = null, B._currentRenderer2 = null, B;
      }, t.createElement = function(B, ue, Ie) {
        for (var Qe = 2; Qe < arguments.length; Qe++) {
          var et = arguments[Qe];
          ce(et) && et._store && (et._store.validated = 1);
        }
        if (Qe = {}, et = null, ue != null)
          for (Tt in rl || !("__self" in ue) || "key" in ue || (rl = !0, console.warn(
            "Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform"
          )), L(ue) && (x(ue.key), et = "" + ue.key), ue)
            nl.call(ue, Tt) && Tt !== "key" && Tt !== "__self" && Tt !== "__source" && (Qe[Tt] = ue[Tt]);
        var Ht = arguments.length - 2;
        if (Ht === 1) Qe.children = Ie;
        else if (1 < Ht) {
          for (var kt = Array(Ht), Pt = 0; Pt < Ht; Pt++)
            kt[Pt] = arguments[Pt + 2];
          Object.freeze && Object.freeze(kt), Qe.children = kt;
        }
        if (B && B.defaultProps)
          for (Tt in Ht = B.defaultProps, Ht)
            Qe[Tt] === void 0 && (Qe[Tt] = Ht[Tt]);
        et && G(
          Qe,
          typeof B == "function" ? B.displayName || B.name || "Unknown" : B
        );
        var Tt = 1e4 > xt.recentlyCreatedOwnerStacks++;
        return I(
          B,
          et,
          void 0,
          void 0,
          E(),
          Qe,
          Tt ? Error("react-stack-top-frame") : je,
          Tt ? Tn(R(B)) : ut
        );
      }, t.createRef = function() {
        var B = { current: null };
        return Object.seal(B), B;
      }, t.forwardRef = function(B) {
        B != null && B.$$typeof === ht ? console.error(
          "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))."
        ) : typeof B != "function" ? console.error(
          "forwardRef requires a render function but was given %s.",
          B === null ? "null" : typeof B
        ) : B.length !== 0 && B.length !== 2 && console.error(
          "forwardRef render functions accept exactly two parameters: props and ref. %s",
          B.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."
        ), B != null && B.defaultProps != null && console.error(
          "forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?"
        );
        var ue = { $$typeof: Se, render: B }, Ie;
        return Object.defineProperty(ue, "displayName", {
          enumerable: !1,
          configurable: !0,
          get: function() {
            return Ie;
          },
          set: function(Qe) {
            Ie = Qe, B.name || B.displayName || (Object.defineProperty(B, "name", { value: Qe }), B.displayName = Qe);
          }
        }), ue;
      }, t.isValidElement = ce, t.lazy = function(B) {
        return {
          $$typeof: vt,
          _payload: { _status: -1, _result: B },
          _init: De
        };
      }, t.memo = function(B, ue) {
        B == null && console.error(
          "memo: The first argument must be a component. Instead received: %s",
          B === null ? "null" : typeof B
        ), ue = {
          $$typeof: ht,
          type: B,
          compare: ue === void 0 ? null : ue
        };
        var Ie;
        return Object.defineProperty(ue, "displayName", {
          enumerable: !1,
          configurable: !0,
          get: function() {
            return Ie;
          },
          set: function(Qe) {
            Ie = Qe, B.name || B.displayName || (Object.defineProperty(B, "name", { value: Qe }), B.displayName = Qe);
          }
        }), ue;
      }, t.startTransition = function(B) {
        var ue = xt.T, Ie = {};
        xt.T = Ie, Ie._updatedFibers = /* @__PURE__ */ new Set();
        try {
          var Qe = B(), et = xt.S;
          et !== null && et(Ie, Qe), typeof Qe == "object" && Qe !== null && typeof Qe.then == "function" && Qe.then(Ye, Zn);
        } catch (Ht) {
          Zn(Ht);
        } finally {
          ue === null && Ie._updatedFibers && (B = Ie._updatedFibers.size, Ie._updatedFibers.clear(), 10 < B && console.warn(
            "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
          )), xt.T = ue;
        }
      }, t.unstable_useCacheRefresh = function() {
        return de().useCacheRefresh();
      }, t.use = function(B) {
        return de().use(B);
      }, t.useActionState = function(B, ue, Ie) {
        return de().useActionState(
          B,
          ue,
          Ie
        );
      }, t.useCallback = function(B, ue) {
        return de().useCallback(B, ue);
      }, t.useContext = function(B) {
        var ue = de();
        return B.$$typeof === Me && console.error(
          "Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?"
        ), ue.useContext(B);
      }, t.useDebugValue = function(B, ue) {
        return de().useDebugValue(B, ue);
      }, t.useDeferredValue = function(B, ue) {
        return de().useDeferredValue(B, ue);
      }, t.useEffect = function(B, ue, Ie) {
        B == null && console.warn(
          "React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?"
        );
        var Qe = de();
        if (typeof Ie == "function")
          throw Error(
            "useEffect CRUD overload is not enabled in this build of React."
          );
        return Qe.useEffect(B, ue);
      }, t.useId = function() {
        return de().useId();
      }, t.useImperativeHandle = function(B, ue, Ie) {
        return de().useImperativeHandle(B, ue, Ie);
      }, t.useInsertionEffect = function(B, ue) {
        return B == null && console.warn(
          "React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?"
        ), de().useInsertionEffect(B, ue);
      }, t.useLayoutEffect = function(B, ue) {
        return B == null && console.warn(
          "React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?"
        ), de().useLayoutEffect(B, ue);
      }, t.useMemo = function(B, ue) {
        return de().useMemo(B, ue);
      }, t.useOptimistic = function(B, ue) {
        return de().useOptimistic(B, ue);
      }, t.useReducer = function(B, ue, Ie) {
        return de().useReducer(B, ue, Ie);
      }, t.useRef = function(B) {
        return de().useRef(B);
      }, t.useState = function(B) {
        return de().useState(B);
      }, t.useSyncExternalStore = function(B, ue, Ie) {
        return de().useSyncExternalStore(
          B,
          ue,
          Ie
        );
      }, t.useTransition = function() {
        return de().useTransition();
      }, t.version = "19.1.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    }();
  }(Hg, Hg.exports)), Hg.exports;
}
var _E = {};
_E.NODE_ENV === "production" ? g5.exports = CE() : g5.exports = ME();
var zt = g5.exports;
const br = /* @__PURE__ */ eh(zt);
var K8;
function OE() {
  if (K8) return _g;
  K8 = 1;
  var r = {};
  /**
   * @license React
   * react-jsx-runtime.development.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return r.NODE_ENV !== "production" && function() {
    function t(Y) {
      if (Y == null) return null;
      if (typeof Y == "function")
        return Y.$$typeof === De ? null : Y.displayName || Y.name || null;
      if (typeof Y == "string") return Y;
      switch (Y) {
        case G:
          return "Fragment";
        case I:
          return "Profiler";
        case V:
          return "StrictMode";
        case te:
          return "Suspense";
        case Ce:
          return "SuspenseList";
        case ee:
          return "Activity";
      }
      if (typeof Y == "object")
        switch (typeof Y.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), Y.$$typeof) {
          case L:
            return "Portal";
          case ce:
            return (Y.displayName || "Context") + ".Provider";
          case $:
            return (Y._context.displayName || "Context") + ".Consumer";
          case se:
            var ie = Y.render;
            return Y = Y.displayName, Y || (Y = ie.displayName || ie.name || "", Y = Y !== "" ? "ForwardRef(" + Y + ")" : "ForwardRef"), Y;
          case ve:
            return ie = Y.displayName || null, ie !== null ? ie : t(Y.type) || "Memo";
          case Ne:
            ie = Y._payload, Y = Y._init;
            try {
              return t(Y(ie));
            } catch {
            }
        }
      return null;
    }
    function a(Y) {
      return "" + Y;
    }
    function i(Y) {
      try {
        a(Y);
        var ie = !1;
      } catch {
        ie = !0;
      }
      if (ie) {
        ie = console;
        var N = ie.error, Me = typeof Symbol == "function" && Symbol.toStringTag && Y[Symbol.toStringTag] || Y.constructor.name || "Object";
        return N.call(
          ie,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          Me
        ), a(Y);
      }
    }
    function s(Y) {
      if (Y === G) return "<>";
      if (typeof Y == "object" && Y !== null && Y.$$typeof === Ne)
        return "<...>";
      try {
        var ie = t(Y);
        return ie ? "<" + ie + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function h() {
      var Y = de.A;
      return Y === null ? null : Y.getOwner();
    }
    function d() {
      return Error("react-stack-top-frame");
    }
    function y(Y) {
      if (Ye.call(Y, "key")) {
        var ie = Object.getOwnPropertyDescriptor(Y, "key").get;
        if (ie && ie.isReactWarning) return !1;
      }
      return Y.key !== void 0;
    }
    function g(Y, ie) {
      function N() {
        J || (J = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          ie
        ));
      }
      N.isReactWarning = !0, Object.defineProperty(Y, "key", {
        get: N,
        configurable: !0
      });
    }
    function b() {
      var Y = t(this.type);
      return X[Y] || (X[Y] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), Y = this.props.ref, Y !== void 0 ? Y : null;
    }
    function x(Y, ie, N, Me, _e, Se, Ge, rt) {
      return N = Se.ref, Y = {
        $$typeof: O,
        type: Y,
        key: ie,
        props: Se,
        _owner: _e
      }, (N !== void 0 ? N : null) !== null ? Object.defineProperty(Y, "ref", {
        enumerable: !1,
        get: b
      }) : Object.defineProperty(Y, "ref", { enumerable: !1, value: null }), Y._store = {}, Object.defineProperty(Y._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(Y, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(Y, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Ge
      }), Object.defineProperty(Y, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: rt
      }), Object.freeze && (Object.freeze(Y.props), Object.freeze(Y)), Y;
    }
    function T(Y, ie, N, Me, _e, Se, Ge, rt) {
      var ht = ie.children;
      if (ht !== void 0)
        if (Me)
          if (Te(ht)) {
            for (Me = 0; Me < ht.length; Me++)
              R(ht[Me]);
            Object.freeze && Object.freeze(ht);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else R(ht);
      if (Ye.call(ie, "key")) {
        ht = t(Y);
        var vt = Object.keys(ie).filter(function(wn) {
          return wn !== "key";
        });
        Me = 0 < vt.length ? "{key: someKey, " + vt.join(": ..., ") + ": ...}" : "{key: someKey}", C[ht + Me] || (vt = 0 < vt.length ? "{" + vt.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          Me,
          ht,
          vt,
          ht
        ), C[ht + Me] = !0);
      }
      if (ht = null, N !== void 0 && (i(N), ht = "" + N), y(ie) && (i(ie.key), ht = "" + ie.key), "key" in ie) {
        N = {};
        for (var St in ie)
          St !== "key" && (N[St] = ie[St]);
      } else N = ie;
      return ht && g(
        N,
        typeof Y == "function" ? Y.displayName || Y.name || "Unknown" : Y
      ), x(
        Y,
        ht,
        Se,
        _e,
        h(),
        N,
        Ge,
        rt
      );
    }
    function R(Y) {
      typeof Y == "object" && Y !== null && Y.$$typeof === O && Y._store && (Y._store.validated = 1);
    }
    var E = zt, O = Symbol.for("react.transitional.element"), L = Symbol.for("react.portal"), G = Symbol.for("react.fragment"), V = Symbol.for("react.strict_mode"), I = Symbol.for("react.profiler"), $ = Symbol.for("react.consumer"), ce = Symbol.for("react.context"), se = Symbol.for("react.forward_ref"), te = Symbol.for("react.suspense"), Ce = Symbol.for("react.suspense_list"), ve = Symbol.for("react.memo"), Ne = Symbol.for("react.lazy"), ee = Symbol.for("react.activity"), De = Symbol.for("react.client.reference"), de = E.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Ye = Object.prototype.hasOwnProperty, Te = Array.isArray, re = console.createTask ? console.createTask : function() {
      return null;
    };
    E = {
      "react-stack-bottom-frame": function(Y) {
        return Y();
      }
    };
    var J, X = {}, W = E["react-stack-bottom-frame"].bind(
      E,
      d
    )(), be = re(s(d)), C = {};
    _g.Fragment = G, _g.jsx = function(Y, ie, N, Me, _e) {
      var Se = 1e4 > de.recentlyCreatedOwnerStacks++;
      return T(
        Y,
        ie,
        N,
        !1,
        Me,
        _e,
        Se ? Error("react-stack-top-frame") : W,
        Se ? re(s(Y)) : be
      );
    }, _g.jsxs = function(Y, ie, N, Me, _e) {
      var Se = 1e4 > de.recentlyCreatedOwnerStacks++;
      return T(
        Y,
        ie,
        N,
        !0,
        Me,
        _e,
        Se ? Error("react-stack-top-frame") : W,
        Se ? re(s(Y)) : be
      );
    };
  }(), _g;
}
var DE = {};
DE.NODE_ENV === "production" ? p5.exports = zE() : p5.exports = OE();
var He = p5.exports, y5 = { exports: {} }, Og = {}, Jy = { exports: {} }, E6 = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var J8;
function NE() {
  return J8 || (J8 = 1, function(r) {
    function t(J, X) {
      var W = J.length;
      J.push(X);
      e: for (; 0 < W; ) {
        var be = W - 1 >>> 1, C = J[be];
        if (0 < s(C, X))
          J[be] = X, J[W] = C, W = be;
        else break e;
      }
    }
    function a(J) {
      return J.length === 0 ? null : J[0];
    }
    function i(J) {
      if (J.length === 0) return null;
      var X = J[0], W = J.pop();
      if (W !== X) {
        J[0] = W;
        e: for (var be = 0, C = J.length, Y = C >>> 1; be < Y; ) {
          var ie = 2 * (be + 1) - 1, N = J[ie], Me = ie + 1, _e = J[Me];
          if (0 > s(N, W))
            Me < C && 0 > s(_e, N) ? (J[be] = _e, J[Me] = W, be = Me) : (J[be] = N, J[ie] = W, be = ie);
          else if (Me < C && 0 > s(_e, W))
            J[be] = _e, J[Me] = W, be = Me;
          else break e;
        }
      }
      return X;
    }
    function s(J, X) {
      var W = J.sortIndex - X.sortIndex;
      return W !== 0 ? W : J.id - X.id;
    }
    if (r.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var h = performance;
      r.unstable_now = function() {
        return h.now();
      };
    } else {
      var d = Date, y = d.now();
      r.unstable_now = function() {
        return d.now() - y;
      };
    }
    var g = [], b = [], x = 1, T = null, R = 3, E = !1, O = !1, L = !1, G = !1, V = typeof setTimeout == "function" ? setTimeout : null, I = typeof clearTimeout == "function" ? clearTimeout : null, $ = typeof setImmediate < "u" ? setImmediate : null;
    function ce(J) {
      for (var X = a(b); X !== null; ) {
        if (X.callback === null) i(b);
        else if (X.startTime <= J)
          i(b), X.sortIndex = X.expirationTime, t(g, X);
        else break;
        X = a(b);
      }
    }
    function se(J) {
      if (L = !1, ce(J), !O)
        if (a(g) !== null)
          O = !0, te || (te = !0, de());
        else {
          var X = a(b);
          X !== null && re(se, X.startTime - J);
        }
    }
    var te = !1, Ce = -1, ve = 5, Ne = -1;
    function ee() {
      return G ? !0 : !(r.unstable_now() - Ne < ve);
    }
    function De() {
      if (G = !1, te) {
        var J = r.unstable_now();
        Ne = J;
        var X = !0;
        try {
          e: {
            O = !1, L && (L = !1, I(Ce), Ce = -1), E = !0;
            var W = R;
            try {
              t: {
                for (ce(J), T = a(g); T !== null && !(T.expirationTime > J && ee()); ) {
                  var be = T.callback;
                  if (typeof be == "function") {
                    T.callback = null, R = T.priorityLevel;
                    var C = be(
                      T.expirationTime <= J
                    );
                    if (J = r.unstable_now(), typeof C == "function") {
                      T.callback = C, ce(J), X = !0;
                      break t;
                    }
                    T === a(g) && i(g), ce(J);
                  } else i(g);
                  T = a(g);
                }
                if (T !== null) X = !0;
                else {
                  var Y = a(b);
                  Y !== null && re(
                    se,
                    Y.startTime - J
                  ), X = !1;
                }
              }
              break e;
            } finally {
              T = null, R = W, E = !1;
            }
            X = void 0;
          }
        } finally {
          X ? de() : te = !1;
        }
      }
    }
    var de;
    if (typeof $ == "function")
      de = function() {
        $(De);
      };
    else if (typeof MessageChannel < "u") {
      var Ye = new MessageChannel(), Te = Ye.port2;
      Ye.port1.onmessage = De, de = function() {
        Te.postMessage(null);
      };
    } else
      de = function() {
        V(De, 0);
      };
    function re(J, X) {
      Ce = V(function() {
        J(r.unstable_now());
      }, X);
    }
    r.unstable_IdlePriority = 5, r.unstable_ImmediatePriority = 1, r.unstable_LowPriority = 4, r.unstable_NormalPriority = 3, r.unstable_Profiling = null, r.unstable_UserBlockingPriority = 2, r.unstable_cancelCallback = function(J) {
      J.callback = null;
    }, r.unstable_forceFrameRate = function(J) {
      0 > J || 125 < J ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : ve = 0 < J ? Math.floor(1e3 / J) : 5;
    }, r.unstable_getCurrentPriorityLevel = function() {
      return R;
    }, r.unstable_next = function(J) {
      switch (R) {
        case 1:
        case 2:
        case 3:
          var X = 3;
          break;
        default:
          X = R;
      }
      var W = R;
      R = X;
      try {
        return J();
      } finally {
        R = W;
      }
    }, r.unstable_requestPaint = function() {
      G = !0;
    }, r.unstable_runWithPriority = function(J, X) {
      switch (J) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          J = 3;
      }
      var W = R;
      R = J;
      try {
        return X();
      } finally {
        R = W;
      }
    }, r.unstable_scheduleCallback = function(J, X, W) {
      var be = r.unstable_now();
      switch (typeof W == "object" && W !== null ? (W = W.delay, W = typeof W == "number" && 0 < W ? be + W : be) : W = be, J) {
        case 1:
          var C = -1;
          break;
        case 2:
          C = 250;
          break;
        case 5:
          C = 1073741823;
          break;
        case 4:
          C = 1e4;
          break;
        default:
          C = 5e3;
      }
      return C = W + C, J = {
        id: x++,
        callback: X,
        priorityLevel: J,
        startTime: W,
        expirationTime: C,
        sortIndex: -1
      }, W > be ? (J.sortIndex = W, t(b, J), a(g) === null && J === a(b) && (L ? (I(Ce), Ce = -1) : L = !0, re(se, W - be))) : (J.sortIndex = C, t(g, J), O || E || (O = !0, te || (te = !0, de()))), J;
    }, r.unstable_shouldYield = ee, r.unstable_wrapCallback = function(J) {
      var X = R;
      return function() {
        var W = R;
        R = X;
        try {
          return J.apply(this, arguments);
        } finally {
          R = W;
        }
      };
    };
  }(E6)), E6;
}
var A6 = {}, W8;
function LE() {
  return W8 || (W8 = 1, function(r) {
    var t = {};
    /**
     * @license React
     * scheduler.development.js
     *
     * Copyright (c) Meta Platforms, Inc. and affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    t.NODE_ENV !== "production" && function() {
      function a() {
        if (te = !1, ee) {
          var X = r.unstable_now();
          Ye = X;
          var W = !0;
          try {
            e: {
              ce = !1, se && (se = !1, ve(De), De = -1), $ = !0;
              var be = I;
              try {
                t: {
                  for (y(X), V = s(O); V !== null && !(V.expirationTime > X && b()); ) {
                    var C = V.callback;
                    if (typeof C == "function") {
                      V.callback = null, I = V.priorityLevel;
                      var Y = C(
                        V.expirationTime <= X
                      );
                      if (X = r.unstable_now(), typeof Y == "function") {
                        V.callback = Y, y(X), W = !0;
                        break t;
                      }
                      V === s(O) && h(O), y(X);
                    } else h(O);
                    V = s(O);
                  }
                  if (V !== null) W = !0;
                  else {
                    var ie = s(L);
                    ie !== null && x(
                      g,
                      ie.startTime - X
                    ), W = !1;
                  }
                }
                break e;
              } finally {
                V = null, I = be, $ = !1;
              }
              W = void 0;
            }
          } finally {
            W ? Te() : ee = !1;
          }
        }
      }
      function i(X, W) {
        var be = X.length;
        X.push(W);
        e: for (; 0 < be; ) {
          var C = be - 1 >>> 1, Y = X[C];
          if (0 < d(Y, W))
            X[C] = W, X[be] = Y, be = C;
          else break e;
        }
      }
      function s(X) {
        return X.length === 0 ? null : X[0];
      }
      function h(X) {
        if (X.length === 0) return null;
        var W = X[0], be = X.pop();
        if (be !== W) {
          X[0] = be;
          e: for (var C = 0, Y = X.length, ie = Y >>> 1; C < ie; ) {
            var N = 2 * (C + 1) - 1, Me = X[N], _e = N + 1, Se = X[_e];
            if (0 > d(Me, be))
              _e < Y && 0 > d(Se, Me) ? (X[C] = Se, X[_e] = be, C = _e) : (X[C] = Me, X[N] = be, C = N);
            else if (_e < Y && 0 > d(Se, be))
              X[C] = Se, X[_e] = be, C = _e;
            else break e;
          }
        }
        return W;
      }
      function d(X, W) {
        var be = X.sortIndex - W.sortIndex;
        return be !== 0 ? be : X.id - W.id;
      }
      function y(X) {
        for (var W = s(L); W !== null; ) {
          if (W.callback === null) h(L);
          else if (W.startTime <= X)
            h(L), W.sortIndex = W.expirationTime, i(O, W);
          else break;
          W = s(L);
        }
      }
      function g(X) {
        if (se = !1, y(X), !ce)
          if (s(O) !== null)
            ce = !0, ee || (ee = !0, Te());
          else {
            var W = s(L);
            W !== null && x(
              g,
              W.startTime - X
            );
          }
      }
      function b() {
        return te ? !0 : !(r.unstable_now() - Ye < de);
      }
      function x(X, W) {
        De = Ce(function() {
          X(r.unstable_now());
        }, W);
      }
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error()), r.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
        var T = performance;
        r.unstable_now = function() {
          return T.now();
        };
      } else {
        var R = Date, E = R.now();
        r.unstable_now = function() {
          return R.now() - E;
        };
      }
      var O = [], L = [], G = 1, V = null, I = 3, $ = !1, ce = !1, se = !1, te = !1, Ce = typeof setTimeout == "function" ? setTimeout : null, ve = typeof clearTimeout == "function" ? clearTimeout : null, Ne = typeof setImmediate < "u" ? setImmediate : null, ee = !1, De = -1, de = 5, Ye = -1;
      if (typeof Ne == "function")
        var Te = function() {
          Ne(a);
        };
      else if (typeof MessageChannel < "u") {
        var re = new MessageChannel(), J = re.port2;
        re.port1.onmessage = a, Te = function() {
          J.postMessage(null);
        };
      } else
        Te = function() {
          Ce(a, 0);
        };
      r.unstable_IdlePriority = 5, r.unstable_ImmediatePriority = 1, r.unstable_LowPriority = 4, r.unstable_NormalPriority = 3, r.unstable_Profiling = null, r.unstable_UserBlockingPriority = 2, r.unstable_cancelCallback = function(X) {
        X.callback = null;
      }, r.unstable_forceFrameRate = function(X) {
        0 > X || 125 < X ? console.error(
          "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
        ) : de = 0 < X ? Math.floor(1e3 / X) : 5;
      }, r.unstable_getCurrentPriorityLevel = function() {
        return I;
      }, r.unstable_next = function(X) {
        switch (I) {
          case 1:
          case 2:
          case 3:
            var W = 3;
            break;
          default:
            W = I;
        }
        var be = I;
        I = W;
        try {
          return X();
        } finally {
          I = be;
        }
      }, r.unstable_requestPaint = function() {
        te = !0;
      }, r.unstable_runWithPriority = function(X, W) {
        switch (X) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            X = 3;
        }
        var be = I;
        I = X;
        try {
          return W();
        } finally {
          I = be;
        }
      }, r.unstable_scheduleCallback = function(X, W, be) {
        var C = r.unstable_now();
        switch (typeof be == "object" && be !== null ? (be = be.delay, be = typeof be == "number" && 0 < be ? C + be : C) : be = C, X) {
          case 1:
            var Y = -1;
            break;
          case 2:
            Y = 250;
            break;
          case 5:
            Y = 1073741823;
            break;
          case 4:
            Y = 1e4;
            break;
          default:
            Y = 5e3;
        }
        return Y = be + Y, X = {
          id: G++,
          callback: W,
          priorityLevel: X,
          startTime: be,
          expirationTime: Y,
          sortIndex: -1
        }, be > C ? (X.sortIndex = be, i(L, X), s(O) === null && X === s(L) && (se ? (ve(De), De = -1) : se = !0, x(g, be - C))) : (X.sortIndex = Y, i(O, X), ce || $ || (ce = !0, ee || (ee = !0, Te()))), X;
      }, r.unstable_shouldYield = b, r.unstable_wrapCallback = function(X) {
        var W = I;
        return function() {
          var be = I;
          I = W;
          try {
            return X.apply(this, arguments);
          } finally {
            I = be;
          }
        };
      }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    }();
  }(A6)), A6;
}
var e2;
function vS() {
  if (e2) return Jy.exports;
  e2 = 1;
  var r = {};
  return r.NODE_ENV === "production" ? Jy.exports = NE() : Jy.exports = LE(), Jy.exports;
}
var Wy = { exports: {} }, _a = {};
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var t2;
function BE() {
  if (t2) return _a;
  t2 = 1;
  var r = zt;
  function t(g) {
    var b = "https://react.dev/errors/" + g;
    if (1 < arguments.length) {
      b += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var x = 2; x < arguments.length; x++)
        b += "&args[]=" + encodeURIComponent(arguments[x]);
    }
    return "Minified React error #" + g + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function a() {
  }
  var i = {
    d: {
      f: a,
      r: function() {
        throw Error(t(522));
      },
      D: a,
      C: a,
      L: a,
      m: a,
      X: a,
      S: a,
      M: a
    },
    p: 0,
    findDOMNode: null
  }, s = Symbol.for("react.portal");
  function h(g, b, x) {
    var T = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: s,
      key: T == null ? null : "" + T,
      children: g,
      containerInfo: b,
      implementation: x
    };
  }
  var d = r.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function y(g, b) {
    if (g === "font") return "";
    if (typeof b == "string")
      return b === "use-credentials" ? b : "";
  }
  return _a.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = i, _a.createPortal = function(g, b) {
    var x = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!b || b.nodeType !== 1 && b.nodeType !== 9 && b.nodeType !== 11)
      throw Error(t(299));
    return h(g, b, null, x);
  }, _a.flushSync = function(g) {
    var b = d.T, x = i.p;
    try {
      if (d.T = null, i.p = 2, g) return g();
    } finally {
      d.T = b, i.p = x, i.d.f();
    }
  }, _a.preconnect = function(g, b) {
    typeof g == "string" && (b ? (b = b.crossOrigin, b = typeof b == "string" ? b === "use-credentials" ? b : "" : void 0) : b = null, i.d.C(g, b));
  }, _a.prefetchDNS = function(g) {
    typeof g == "string" && i.d.D(g);
  }, _a.preinit = function(g, b) {
    if (typeof g == "string" && b && typeof b.as == "string") {
      var x = b.as, T = y(x, b.crossOrigin), R = typeof b.integrity == "string" ? b.integrity : void 0, E = typeof b.fetchPriority == "string" ? b.fetchPriority : void 0;
      x === "style" ? i.d.S(
        g,
        typeof b.precedence == "string" ? b.precedence : void 0,
        {
          crossOrigin: T,
          integrity: R,
          fetchPriority: E
        }
      ) : x === "script" && i.d.X(g, {
        crossOrigin: T,
        integrity: R,
        fetchPriority: E,
        nonce: typeof b.nonce == "string" ? b.nonce : void 0
      });
    }
  }, _a.preinitModule = function(g, b) {
    if (typeof g == "string")
      if (typeof b == "object" && b !== null) {
        if (b.as == null || b.as === "script") {
          var x = y(
            b.as,
            b.crossOrigin
          );
          i.d.M(g, {
            crossOrigin: x,
            integrity: typeof b.integrity == "string" ? b.integrity : void 0,
            nonce: typeof b.nonce == "string" ? b.nonce : void 0
          });
        }
      } else b == null && i.d.M(g);
  }, _a.preload = function(g, b) {
    if (typeof g == "string" && typeof b == "object" && b !== null && typeof b.as == "string") {
      var x = b.as, T = y(x, b.crossOrigin);
      i.d.L(g, x, {
        crossOrigin: T,
        integrity: typeof b.integrity == "string" ? b.integrity : void 0,
        nonce: typeof b.nonce == "string" ? b.nonce : void 0,
        type: typeof b.type == "string" ? b.type : void 0,
        fetchPriority: typeof b.fetchPriority == "string" ? b.fetchPriority : void 0,
        referrerPolicy: typeof b.referrerPolicy == "string" ? b.referrerPolicy : void 0,
        imageSrcSet: typeof b.imageSrcSet == "string" ? b.imageSrcSet : void 0,
        imageSizes: typeof b.imageSizes == "string" ? b.imageSizes : void 0,
        media: typeof b.media == "string" ? b.media : void 0
      });
    }
  }, _a.preloadModule = function(g, b) {
    if (typeof g == "string")
      if (b) {
        var x = y(b.as, b.crossOrigin);
        i.d.m(g, {
          as: typeof b.as == "string" && b.as !== "script" ? b.as : void 0,
          crossOrigin: x,
          integrity: typeof b.integrity == "string" ? b.integrity : void 0
        });
      } else i.d.m(g);
  }, _a.requestFormReset = function(g) {
    i.d.r(g);
  }, _a.unstable_batchedUpdates = function(g, b) {
    return g(b);
  }, _a.useFormState = function(g, b, x) {
    return d.H.useFormState(g, b, x);
  }, _a.useFormStatus = function() {
    return d.H.useHostTransitionStatus();
  }, _a.version = "19.1.0", _a;
}
var Oa = {}, n2;
function HE() {
  if (n2) return Oa;
  n2 = 1;
  var r = {};
  /**
   * @license React
   * react-dom.development.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return r.NODE_ENV !== "production" && function() {
    function t() {
    }
    function a(R) {
      return "" + R;
    }
    function i(R, E, O) {
      var L = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      try {
        a(L);
        var G = !1;
      } catch {
        G = !0;
      }
      return G && (console.error(
        "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
        typeof Symbol == "function" && Symbol.toStringTag && L[Symbol.toStringTag] || L.constructor.name || "Object"
      ), a(L)), {
        $$typeof: x,
        key: L == null ? null : "" + L,
        children: R,
        containerInfo: E,
        implementation: O
      };
    }
    function s(R, E) {
      if (R === "font") return "";
      if (typeof E == "string")
        return E === "use-credentials" ? E : "";
    }
    function h(R) {
      return R === null ? "`null`" : R === void 0 ? "`undefined`" : R === "" ? "an empty string" : 'something with type "' + typeof R + '"';
    }
    function d(R) {
      return R === null ? "`null`" : R === void 0 ? "`undefined`" : R === "" ? "an empty string" : typeof R == "string" ? JSON.stringify(R) : typeof R == "number" ? "`" + R + "`" : 'something with type "' + typeof R + '"';
    }
    function y() {
      var R = T.H;
      return R === null && console.error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      ), R;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var g = zt, b = {
      d: {
        f: t,
        r: function() {
          throw Error(
            "Invalid form element. requestFormReset must be passed a form that was rendered by React."
          );
        },
        D: t,
        C: t,
        L: t,
        m: t,
        X: t,
        S: t,
        M: t
      },
      p: 0,
      findDOMNode: null
    }, x = Symbol.for("react.portal"), T = g.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"
    ), Oa.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = b, Oa.createPortal = function(R, E) {
      var O = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!E || E.nodeType !== 1 && E.nodeType !== 9 && E.nodeType !== 11)
        throw Error("Target container is not a DOM element.");
      return i(R, E, null, O);
    }, Oa.flushSync = function(R) {
      var E = T.T, O = b.p;
      try {
        if (T.T = null, b.p = 2, R)
          return R();
      } finally {
        T.T = E, b.p = O, b.d.f() && console.error(
          "flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."
        );
      }
    }, Oa.preconnect = function(R, E) {
      typeof R == "string" && R ? E != null && typeof E != "object" ? console.error(
        "ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.",
        d(E)
      ) : E != null && typeof E.crossOrigin != "string" && console.error(
        "ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.",
        h(E.crossOrigin)
      ) : console.error(
        "ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        h(R)
      ), typeof R == "string" && (E ? (E = E.crossOrigin, E = typeof E == "string" ? E === "use-credentials" ? E : "" : void 0) : E = null, b.d.C(R, E));
    }, Oa.prefetchDNS = function(R) {
      if (typeof R != "string" || !R)
        console.error(
          "ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
          h(R)
        );
      else if (1 < arguments.length) {
        var E = arguments[1];
        typeof E == "object" && E.hasOwnProperty("crossOrigin") ? console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          d(E)
        ) : console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          d(E)
        );
      }
      typeof R == "string" && b.d.D(R);
    }, Oa.preinit = function(R, E) {
      if (typeof R == "string" && R ? E == null || typeof E != "object" ? console.error(
        "ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.",
        d(E)
      ) : E.as !== "style" && E.as !== "script" && console.error(
        'ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".',
        d(E.as)
      ) : console.error(
        "ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        h(R)
      ), typeof R == "string" && E && typeof E.as == "string") {
        var O = E.as, L = s(O, E.crossOrigin), G = typeof E.integrity == "string" ? E.integrity : void 0, V = typeof E.fetchPriority == "string" ? E.fetchPriority : void 0;
        O === "style" ? b.d.S(
          R,
          typeof E.precedence == "string" ? E.precedence : void 0,
          {
            crossOrigin: L,
            integrity: G,
            fetchPriority: V
          }
        ) : O === "script" && b.d.X(R, {
          crossOrigin: L,
          integrity: G,
          fetchPriority: V,
          nonce: typeof E.nonce == "string" ? E.nonce : void 0
        });
      }
    }, Oa.preinitModule = function(R, E) {
      var O = "";
      if (typeof R == "string" && R || (O += " The `href` argument encountered was " + h(R) + "."), E !== void 0 && typeof E != "object" ? O += " The `options` argument encountered was " + h(E) + "." : E && "as" in E && E.as !== "script" && (O += " The `as` option encountered was " + d(E.as) + "."), O)
        console.error(
          "ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s",
          O
        );
      else
        switch (O = E && typeof E.as == "string" ? E.as : "script", O) {
          case "script":
            break;
          default:
            O = d(O), console.error(
              'ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)',
              O,
              R
            );
        }
      typeof R == "string" && (typeof E == "object" && E !== null ? (E.as == null || E.as === "script") && (O = s(
        E.as,
        E.crossOrigin
      ), b.d.M(R, {
        crossOrigin: O,
        integrity: typeof E.integrity == "string" ? E.integrity : void 0,
        nonce: typeof E.nonce == "string" ? E.nonce : void 0
      })) : E == null && b.d.M(R));
    }, Oa.preload = function(R, E) {
      var O = "";
      if (typeof R == "string" && R || (O += " The `href` argument encountered was " + h(R) + "."), E == null || typeof E != "object" ? O += " The `options` argument encountered was " + h(E) + "." : typeof E.as == "string" && E.as || (O += " The `as` option encountered was " + h(E.as) + "."), O && console.error(
        'ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s',
        O
      ), typeof R == "string" && typeof E == "object" && E !== null && typeof E.as == "string") {
        O = E.as;
        var L = s(
          O,
          E.crossOrigin
        );
        b.d.L(R, O, {
          crossOrigin: L,
          integrity: typeof E.integrity == "string" ? E.integrity : void 0,
          nonce: typeof E.nonce == "string" ? E.nonce : void 0,
          type: typeof E.type == "string" ? E.type : void 0,
          fetchPriority: typeof E.fetchPriority == "string" ? E.fetchPriority : void 0,
          referrerPolicy: typeof E.referrerPolicy == "string" ? E.referrerPolicy : void 0,
          imageSrcSet: typeof E.imageSrcSet == "string" ? E.imageSrcSet : void 0,
          imageSizes: typeof E.imageSizes == "string" ? E.imageSizes : void 0,
          media: typeof E.media == "string" ? E.media : void 0
        });
      }
    }, Oa.preloadModule = function(R, E) {
      var O = "";
      typeof R == "string" && R || (O += " The `href` argument encountered was " + h(R) + "."), E !== void 0 && typeof E != "object" ? O += " The `options` argument encountered was " + h(E) + "." : E && "as" in E && typeof E.as != "string" && (O += " The `as` option encountered was " + h(E.as) + "."), O && console.error(
        'ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s',
        O
      ), typeof R == "string" && (E ? (O = s(
        E.as,
        E.crossOrigin
      ), b.d.m(R, {
        as: typeof E.as == "string" && E.as !== "script" ? E.as : void 0,
        crossOrigin: O,
        integrity: typeof E.integrity == "string" ? E.integrity : void 0
      })) : b.d.m(R));
    }, Oa.requestFormReset = function(R) {
      b.d.r(R);
    }, Oa.unstable_batchedUpdates = function(R, E) {
      return R(E);
    }, Oa.useFormState = function(R, E, O) {
      return y().useFormState(R, E, O);
    }, Oa.useFormStatus = function() {
      return y().useHostTransitionStatus();
    }, Oa.version = "19.1.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }(), Oa;
}
var r2;
function bS() {
  if (r2) return Wy.exports;
  r2 = 1;
  var r = {};
  function t() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (r.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t);
      } catch (a) {
        console.error(a);
      }
    }
  }
  return r.NODE_ENV === "production" ? (t(), Wy.exports = BE()) : Wy.exports = HE(), Wy.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var a2;
function UE() {
  if (a2) return Og;
  a2 = 1;
  var r = vS(), t = zt, a = bS();
  function i(l) {
    var o = "https://react.dev/errors/" + l;
    if (1 < arguments.length) {
      o += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var c = 2; c < arguments.length; c++)
        o += "&args[]=" + encodeURIComponent(arguments[c]);
    }
    return "Minified React error #" + l + "; visit " + o + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function s(l) {
    return !(!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11);
  }
  function h(l) {
    var o = l, c = l;
    if (l.alternate) for (; o.return; ) o = o.return;
    else {
      l = o;
      do
        o = l, o.flags & 4098 && (c = o.return), l = o.return;
      while (l);
    }
    return o.tag === 3 ? c : null;
  }
  function d(l) {
    if (l.tag === 13) {
      var o = l.memoizedState;
      if (o === null && (l = l.alternate, l !== null && (o = l.memoizedState)), o !== null) return o.dehydrated;
    }
    return null;
  }
  function y(l) {
    if (h(l) !== l)
      throw Error(i(188));
  }
  function g(l) {
    var o = l.alternate;
    if (!o) {
      if (o = h(l), o === null) throw Error(i(188));
      return o !== l ? null : l;
    }
    for (var c = l, m = o; ; ) {
      var S = c.return;
      if (S === null) break;
      var w = S.alternate;
      if (w === null) {
        if (m = S.return, m !== null) {
          c = m;
          continue;
        }
        break;
      }
      if (S.child === w.child) {
        for (w = S.child; w; ) {
          if (w === c) return y(S), l;
          if (w === m) return y(S), o;
          w = w.sibling;
        }
        throw Error(i(188));
      }
      if (c.return !== m.return) c = S, m = w;
      else {
        for (var _ = !1, H = S.child; H; ) {
          if (H === c) {
            _ = !0, c = S, m = w;
            break;
          }
          if (H === m) {
            _ = !0, m = S, c = w;
            break;
          }
          H = H.sibling;
        }
        if (!_) {
          for (H = w.child; H; ) {
            if (H === c) {
              _ = !0, c = w, m = S;
              break;
            }
            if (H === m) {
              _ = !0, m = w, c = S;
              break;
            }
            H = H.sibling;
          }
          if (!_) throw Error(i(189));
        }
      }
      if (c.alternate !== m) throw Error(i(190));
    }
    if (c.tag !== 3) throw Error(i(188));
    return c.stateNode.current === c ? l : o;
  }
  function b(l) {
    var o = l.tag;
    if (o === 5 || o === 26 || o === 27 || o === 6) return l;
    for (l = l.child; l !== null; ) {
      if (o = b(l), o !== null) return o;
      l = l.sibling;
    }
    return null;
  }
  var x = Object.assign, T = Symbol.for("react.element"), R = Symbol.for("react.transitional.element"), E = Symbol.for("react.portal"), O = Symbol.for("react.fragment"), L = Symbol.for("react.strict_mode"), G = Symbol.for("react.profiler"), V = Symbol.for("react.provider"), I = Symbol.for("react.consumer"), $ = Symbol.for("react.context"), ce = Symbol.for("react.forward_ref"), se = Symbol.for("react.suspense"), te = Symbol.for("react.suspense_list"), Ce = Symbol.for("react.memo"), ve = Symbol.for("react.lazy"), Ne = Symbol.for("react.activity"), ee = Symbol.for("react.memo_cache_sentinel"), De = Symbol.iterator;
  function de(l) {
    return l === null || typeof l != "object" ? null : (l = De && l[De] || l["@@iterator"], typeof l == "function" ? l : null);
  }
  var Ye = Symbol.for("react.client.reference");
  function Te(l) {
    if (l == null) return null;
    if (typeof l == "function")
      return l.$$typeof === Ye ? null : l.displayName || l.name || null;
    if (typeof l == "string") return l;
    switch (l) {
      case O:
        return "Fragment";
      case G:
        return "Profiler";
      case L:
        return "StrictMode";
      case se:
        return "Suspense";
      case te:
        return "SuspenseList";
      case Ne:
        return "Activity";
    }
    if (typeof l == "object")
      switch (l.$$typeof) {
        case E:
          return "Portal";
        case $:
          return (l.displayName || "Context") + ".Provider";
        case I:
          return (l._context.displayName || "Context") + ".Consumer";
        case ce:
          var o = l.render;
          return l = l.displayName, l || (l = o.displayName || o.name || "", l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef"), l;
        case Ce:
          return o = l.displayName || null, o !== null ? o : Te(l.type) || "Memo";
        case ve:
          o = l._payload, l = l._init;
          try {
            return Te(l(o));
          } catch {
          }
      }
    return null;
  }
  var re = Array.isArray, J = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, X = a.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, W = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, be = [], C = -1;
  function Y(l) {
    return { current: l };
  }
  function ie(l) {
    0 > C || (l.current = be[C], be[C] = null, C--);
  }
  function N(l, o) {
    C++, be[C] = l.current, l.current = o;
  }
  var Me = Y(null), _e = Y(null), Se = Y(null), Ge = Y(null);
  function rt(l, o) {
    switch (N(Se, o), N(_e, l), N(Me, null), o.nodeType) {
      case 9:
      case 11:
        l = (l = o.documentElement) && (l = l.namespaceURI) ? mi(l) : 0;
        break;
      default:
        if (l = o.tagName, o = o.namespaceURI)
          o = mi(o), l = du(o, l);
        else
          switch (l) {
            case "svg":
              l = 1;
              break;
            case "math":
              l = 2;
              break;
            default:
              l = 0;
          }
    }
    ie(Me), N(Me, l);
  }
  function ht() {
    ie(Me), ie(_e), ie(Se);
  }
  function vt(l) {
    l.memoizedState !== null && N(Ge, l);
    var o = Me.current, c = du(o, l.type);
    o !== c && (N(_e, l), N(Me, c));
  }
  function St(l) {
    _e.current === l && (ie(Me), ie(_e)), Ge.current === l && (ie(Ge), Gr._currentValue = W);
  }
  var wn = Object.prototype.hasOwnProperty, Dr = r.unstable_scheduleCallback, jn = r.unstable_cancelCallback, Gn = r.unstable_shouldYield, xr = r.unstable_requestPaint, Bt = r.unstable_now, er = r.unstable_getCurrentPriorityLevel, sr = r.unstable_ImmediatePriority, El = r.unstable_UserBlockingPriority, xt = r.unstable_NormalPriority, nl = r.unstable_LowPriority, Tn = r.unstable_IdlePriority, cr = r.log, rl = r.unstable_setDisableYieldValue, ke = null, je = null;
  function ut(l) {
    if (typeof cr == "function" && rl(l), je && typeof je.setStrictMode == "function")
      try {
        je.setStrictMode(ke, l);
      } catch {
      }
  }
  var st = Math.clz32 ? Math.clz32 : La, Qt = Math.log, Zn = Math.LN2;
  function La(l) {
    return l >>>= 0, l === 0 ? 32 : 31 - (Qt(l) / Zn | 0) | 0;
  }
  var fr = 256, Nr = 4194304;
  function Hn(l) {
    var o = l & 42;
    if (o !== 0) return o;
    switch (l & -l) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l & 4194048;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return l & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return l;
    }
  }
  function hn(l, o, c) {
    var m = l.pendingLanes;
    if (m === 0) return 0;
    var S = 0, w = l.suspendedLanes, _ = l.pingedLanes;
    l = l.warmLanes;
    var H = m & 134217727;
    return H !== 0 ? (m = H & ~w, m !== 0 ? S = Hn(m) : (_ &= H, _ !== 0 ? S = Hn(_) : c || (c = H & ~l, c !== 0 && (S = Hn(c))))) : (H = m & ~w, H !== 0 ? S = Hn(H) : _ !== 0 ? S = Hn(_) : c || (c = m & ~l, c !== 0 && (S = Hn(c)))), S === 0 ? 0 : o !== 0 && o !== S && !(o & w) && (w = S & -S, c = o & -o, w >= c || w === 32 && (c & 4194048) !== 0) ? o : S;
  }
  function hr(l, o) {
    return (l.pendingLanes & ~(l.suspendedLanes & ~l.pingedLanes) & o) === 0;
  }
  function B(l, o) {
    switch (l) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return o + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return o + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function ue() {
    var l = fr;
    return fr <<= 1, !(fr & 4194048) && (fr = 256), l;
  }
  function Ie() {
    var l = Nr;
    return Nr <<= 1, !(Nr & 62914560) && (Nr = 4194304), l;
  }
  function Qe(l) {
    for (var o = [], c = 0; 31 > c; c++) o.push(l);
    return o;
  }
  function et(l, o) {
    l.pendingLanes |= o, o !== 268435456 && (l.suspendedLanes = 0, l.pingedLanes = 0, l.warmLanes = 0);
  }
  function Ht(l, o, c, m, S, w) {
    var _ = l.pendingLanes;
    l.pendingLanes = c, l.suspendedLanes = 0, l.pingedLanes = 0, l.warmLanes = 0, l.expiredLanes &= c, l.entangledLanes &= c, l.errorRecoveryDisabledLanes &= c, l.shellSuspendCounter = 0;
    var H = l.entanglements, Z = l.expirationTimes, fe = l.hiddenUpdates;
    for (c = _ & ~c; 0 < c; ) {
      var Oe = 31 - st(c), Be = 1 << Oe;
      H[Oe] = 0, Z[Oe] = -1;
      var me = fe[Oe];
      if (me !== null)
        for (fe[Oe] = null, Oe = 0; Oe < me.length; Oe++) {
          var we = me[Oe];
          we !== null && (we.lane &= -536870913);
        }
      c &= ~Be;
    }
    m !== 0 && kt(l, m, 0), w !== 0 && S === 0 && l.tag !== 0 && (l.suspendedLanes |= w & ~(_ & ~o));
  }
  function kt(l, o, c) {
    l.pendingLanes |= o, l.suspendedLanes &= ~o;
    var m = 31 - st(o);
    l.entangledLanes |= o, l.entanglements[m] = l.entanglements[m] | 1073741824 | c & 4194090;
  }
  function Pt(l, o) {
    var c = l.entangledLanes |= o;
    for (l = l.entanglements; c; ) {
      var m = 31 - st(c), S = 1 << m;
      S & o | l[m] & o && (l[m] |= o), c &= ~S;
    }
  }
  function Tt(l) {
    switch (l) {
      case 2:
        l = 1;
        break;
      case 8:
        l = 4;
        break;
      case 32:
        l = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        l = 128;
        break;
      case 268435456:
        l = 134217728;
        break;
      default:
        l = 0;
    }
    return l;
  }
  function tr(l) {
    return l &= -l, 2 < l ? 8 < l ? l & 134217727 ? 32 : 268435456 : 8 : 2;
  }
  function ai() {
    var l = X.p;
    return l !== 0 ? l : (l = window.event, l === void 0 ? 32 : dy(l.type));
  }
  function Hm(l, o) {
    var c = X.p;
    try {
      return X.p = l, o();
    } finally {
      X.p = c;
    }
  }
  var li = Math.random().toString(36).slice(2), bn = "__reactFiber$" + li, Zr = "__reactProps$" + li, Eo = "__reactContainer$" + li, Um = "__reactEvents$" + li, o4 = "__reactListeners$" + li, s4 = "__reactHandles$" + li, s0 = "__reactResources$" + li, c0 = "__reactMarker$" + li;
  function at(l) {
    delete l[bn], delete l[Zr], delete l[Um], delete l[o4], delete l[s4];
  }
  function Ru(l) {
    var o = l[bn];
    if (o) return o;
    for (var c = l.parentNode; c; ) {
      if (o = c[Eo] || c[bn]) {
        if (c = o.alternate, o.child !== null || c !== null && c.child !== null)
          for (l = us(l); l !== null; ) {
            if (c = l[bn]) return c;
            l = us(l);
          }
        return o;
      }
      l = c, c = l.parentNode;
    }
    return null;
  }
  function Lr(l) {
    if (l = l[bn] || l[Eo]) {
      var o = l.tag;
      if (o === 5 || o === 6 || o === 13 || o === 26 || o === 27 || o === 3)
        return l;
    }
    return null;
  }
  function Ms(l) {
    var o = l.tag;
    if (o === 5 || o === 26 || o === 27 || o === 6) return l.stateNode;
    throw Error(i(33));
  }
  function _s(l) {
    var o = l[s0];
    return o || (o = l[s0] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), o;
  }
  function Fn(l) {
    l[c0] = !0;
  }
  var qm = /* @__PURE__ */ new Set(), f0 = {};
  function wr(l, o) {
    Ao(l, o), Ao(l + "Capture", o);
  }
  function Ao(l, o) {
    for (f0[l] = o, l = 0; l < o.length; l++)
      qm.add(o[l]);
  }
  var jm = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), Gm = {}, ah = {};
  function c4(l) {
    return wn.call(ah, l) ? !0 : wn.call(Gm, l) ? !1 : jm.test(l) ? ah[l] = !0 : (Gm[l] = !0, !1);
  }
  function h0(l, o, c) {
    if (c4(o))
      if (c === null) l.removeAttribute(o);
      else {
        switch (typeof c) {
          case "undefined":
          case "function":
          case "symbol":
            l.removeAttribute(o);
            return;
          case "boolean":
            var m = o.toLowerCase().slice(0, 5);
            if (m !== "data-" && m !== "aria-") {
              l.removeAttribute(o);
              return;
            }
        }
        l.setAttribute(o, "" + c);
      }
  }
  function Gi(l, o, c) {
    if (c === null) l.removeAttribute(o);
    else {
      switch (typeof c) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(o);
          return;
      }
      l.setAttribute(o, "" + c);
    }
  }
  function ii(l, o, c, m) {
    if (m === null) l.removeAttribute(c);
    else {
      switch (typeof m) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(c);
          return;
      }
      l.setAttributeNS(o, c, "" + m);
    }
  }
  var lh, Vm;
  function ko(l) {
    if (lh === void 0)
      try {
        throw Error();
      } catch (c) {
        var o = c.stack.trim().match(/\n( *(at )?)/);
        lh = o && o[1] || "", Vm = -1 < c.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < c.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + lh + l + Vm;
  }
  var ih = !1;
  function na(l, o) {
    if (!l || ih) return "";
    ih = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var m = {
        DetermineComponentFrameRoot: function() {
          try {
            if (o) {
              var Be = function() {
                throw Error();
              };
              if (Object.defineProperty(Be.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(Be, []);
                } catch (we) {
                  var me = we;
                }
                Reflect.construct(l, [], Be);
              } else {
                try {
                  Be.call();
                } catch (we) {
                  me = we;
                }
                l.call(Be.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (we) {
                me = we;
              }
              (Be = l()) && typeof Be.catch == "function" && Be.catch(function() {
              });
            }
          } catch (we) {
            if (we && me && typeof we.stack == "string")
              return [we.stack, me.stack];
          }
          return [null, null];
        }
      };
      m.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var S = Object.getOwnPropertyDescriptor(
        m.DetermineComponentFrameRoot,
        "name"
      );
      S && S.configurable && Object.defineProperty(
        m.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var w = m.DetermineComponentFrameRoot(), _ = w[0], H = w[1];
      if (_ && H) {
        var Z = _.split(`
`), fe = H.split(`
`);
        for (S = m = 0; m < Z.length && !Z[m].includes("DetermineComponentFrameRoot"); )
          m++;
        for (; S < fe.length && !fe[S].includes(
          "DetermineComponentFrameRoot"
        ); )
          S++;
        if (m === Z.length || S === fe.length)
          for (m = Z.length - 1, S = fe.length - 1; 1 <= m && 0 <= S && Z[m] !== fe[S]; )
            S--;
        for (; 1 <= m && 0 <= S; m--, S--)
          if (Z[m] !== fe[S]) {
            if (m !== 1 || S !== 1)
              do
                if (m--, S--, 0 > S || Z[m] !== fe[S]) {
                  var Oe = `
` + Z[m].replace(" at new ", " at ");
                  return l.displayName && Oe.includes("<anonymous>") && (Oe = Oe.replace("<anonymous>", l.displayName)), Oe;
                }
              while (1 <= m && 0 <= S);
            break;
          }
      }
    } finally {
      ih = !1, Error.prepareStackTrace = c;
    }
    return (c = l ? l.displayName || l.name : "") ? ko(c) : "";
  }
  function Os(l) {
    switch (l.tag) {
      case 26:
      case 27:
      case 5:
        return ko(l.type);
      case 16:
        return ko("Lazy");
      case 13:
        return ko("Suspense");
      case 19:
        return ko("SuspenseList");
      case 0:
      case 15:
        return na(l.type, !1);
      case 11:
        return na(l.type.render, !1);
      case 1:
        return na(l.type, !0);
      case 31:
        return ko("Activity");
      default:
        return "";
    }
  }
  function zu(l) {
    try {
      var o = "";
      do
        o += Os(l), l = l.return;
      while (l);
      return o;
    } catch (c) {
      return `
Error generating stack: ` + c.message + `
` + c.stack;
    }
  }
  function Ba(l) {
    switch (typeof l) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return l;
      case "object":
        return l;
      default:
        return "";
    }
  }
  function Ds(l) {
    var o = l.type;
    return (l = l.nodeName) && l.toLowerCase() === "input" && (o === "checkbox" || o === "radio");
  }
  function uh(l) {
    var o = Ds(l) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(
      l.constructor.prototype,
      o
    ), m = "" + l[o];
    if (!l.hasOwnProperty(o) && typeof c < "u" && typeof c.get == "function" && typeof c.set == "function") {
      var S = c.get, w = c.set;
      return Object.defineProperty(l, o, {
        configurable: !0,
        get: function() {
          return S.call(this);
        },
        set: function(_) {
          m = "" + _, w.call(this, _);
        }
      }), Object.defineProperty(l, o, {
        enumerable: c.enumerable
      }), {
        getValue: function() {
          return m;
        },
        setValue: function(_) {
          m = "" + _;
        },
        stopTracking: function() {
          l._valueTracker = null, delete l[o];
        }
      };
    }
  }
  function Ns(l) {
    l._valueTracker || (l._valueTracker = uh(l));
  }
  function Ls(l) {
    if (!l) return !1;
    var o = l._valueTracker;
    if (!o) return !0;
    var c = o.getValue(), m = "";
    return l && (m = Ds(l) ? l.checked ? "true" : "false" : l.value), l = m, l !== c ? (o.setValue(l), !0) : !1;
  }
  function Vi(l) {
    if (l = l || (typeof document < "u" ? document : void 0), typeof l > "u") return null;
    try {
      return l.activeElement || l.body;
    } catch {
      return l.body;
    }
  }
  var Ym = /[\n"\\]/g;
  function al(l) {
    return l.replace(
      Ym,
      function(o) {
        return "\\" + o.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function Im(l, o, c, m, S, w, _, H) {
    l.name = "", _ != null && typeof _ != "function" && typeof _ != "symbol" && typeof _ != "boolean" ? l.type = _ : l.removeAttribute("type"), o != null ? _ === "number" ? (o === 0 && l.value === "" || l.value != o) && (l.value = "" + Ba(o)) : l.value !== "" + Ba(o) && (l.value = "" + Ba(o)) : _ !== "submit" && _ !== "reset" || l.removeAttribute("value"), o != null ? d0(l, _, Ba(o)) : c != null ? d0(l, _, Ba(c)) : m != null && l.removeAttribute("value"), S == null && w != null && (l.defaultChecked = !!w), S != null && (l.checked = S && typeof S != "function" && typeof S != "symbol"), H != null && typeof H != "function" && typeof H != "symbol" && typeof H != "boolean" ? l.name = "" + Ba(H) : l.removeAttribute("name");
  }
  function $m(l, o, c, m, S, w, _, H) {
    if (w != null && typeof w != "function" && typeof w != "symbol" && typeof w != "boolean" && (l.type = w), o != null || c != null) {
      if (!(w !== "submit" && w !== "reset" || o != null))
        return;
      c = c != null ? "" + Ba(c) : "", o = o != null ? "" + Ba(o) : c, H || o === l.value || (l.value = o), l.defaultValue = o;
    }
    m = m ?? S, m = typeof m != "function" && typeof m != "symbol" && !!m, l.checked = H ? l.checked : !!m, l.defaultChecked = !!m, _ != null && typeof _ != "function" && typeof _ != "symbol" && typeof _ != "boolean" && (l.name = _);
  }
  function d0(l, o, c) {
    o === "number" && Vi(l.ownerDocument) === l || l.defaultValue === "" + c || (l.defaultValue = "" + c);
  }
  function Cu(l, o, c, m) {
    if (l = l.options, o) {
      o = {};
      for (var S = 0; S < c.length; S++)
        o["$" + c[S]] = !0;
      for (c = 0; c < l.length; c++)
        S = o.hasOwnProperty("$" + l[c].value), l[c].selected !== S && (l[c].selected = S), S && m && (l[c].defaultSelected = !0);
    } else {
      for (c = "" + Ba(c), o = null, S = 0; S < l.length; S++) {
        if (l[S].value === c) {
          l[S].selected = !0, m && (l[S].defaultSelected = !0);
          return;
        }
        o !== null || l[S].disabled || (o = l[S]);
      }
      o !== null && (o.selected = !0);
    }
  }
  function Xm(l, o, c) {
    if (o != null && (o = "" + Ba(o), o !== l.value && (l.value = o), c == null)) {
      l.defaultValue !== o && (l.defaultValue = o);
      return;
    }
    l.defaultValue = c != null ? "" + Ba(c) : "";
  }
  function Qm(l, o, c, m) {
    if (o == null) {
      if (m != null) {
        if (c != null) throw Error(i(92));
        if (re(m)) {
          if (1 < m.length) throw Error(i(93));
          m = m[0];
        }
        c = m;
      }
      c == null && (c = ""), o = c;
    }
    c = Ba(o), l.defaultValue = c, m = l.textContent, m === c && m !== "" && m !== null && (l.value = m);
  }
  function Ro(l, o) {
    if (o) {
      var c = l.firstChild;
      if (c && c === l.lastChild && c.nodeType === 3) {
        c.nodeValue = o;
        return;
      }
    }
    l.textContent = o;
  }
  var a3 = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function Zm(l, o, c) {
    var m = o.indexOf("--") === 0;
    c == null || typeof c == "boolean" || c === "" ? m ? l.setProperty(o, "") : o === "float" ? l.cssFloat = "" : l[o] = "" : m ? l.setProperty(o, c) : typeof c != "number" || c === 0 || a3.has(o) ? o === "float" ? l.cssFloat = c : l[o] = ("" + c).trim() : l[o] = c + "px";
  }
  function oh(l, o, c) {
    if (o != null && typeof o != "object")
      throw Error(i(62));
    if (l = l.style, c != null) {
      for (var m in c)
        !c.hasOwnProperty(m) || o != null && o.hasOwnProperty(m) || (m.indexOf("--") === 0 ? l.setProperty(m, "") : m === "float" ? l.cssFloat = "" : l[m] = "");
      for (var S in o)
        m = o[S], o.hasOwnProperty(S) && c[S] !== m && Zm(l, S, m);
    } else
      for (var w in o)
        o.hasOwnProperty(w) && Zm(l, w, o[w]);
  }
  function Bs(l) {
    if (l.indexOf("-") === -1) return !1;
    switch (l) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var m0 = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), l3 = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function p0(l) {
    return l3.test("" + l) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : l;
  }
  var sh = null;
  function zo(l) {
    return l = l.target || l.srcElement || window, l.correspondingUseElement && (l = l.correspondingUseElement), l.nodeType === 3 ? l.parentNode : l;
  }
  var Co = null, Hs = null;
  function f4(l) {
    var o = Lr(l);
    if (o && (l = o.stateNode)) {
      var c = l[Zr] || null;
      e: switch (l = o.stateNode, o.type) {
        case "input":
          if (Im(
            l,
            c.value,
            c.defaultValue,
            c.defaultValue,
            c.checked,
            c.defaultChecked,
            c.type,
            c.name
          ), o = c.name, c.type === "radio" && o != null) {
            for (c = l; c.parentNode; ) c = c.parentNode;
            for (c = c.querySelectorAll(
              'input[name="' + al(
                "" + o
              ) + '"][type="radio"]'
            ), o = 0; o < c.length; o++) {
              var m = c[o];
              if (m !== l && m.form === l.form) {
                var S = m[Zr] || null;
                if (!S) throw Error(i(90));
                Im(
                  m,
                  S.value,
                  S.defaultValue,
                  S.defaultValue,
                  S.checked,
                  S.defaultChecked,
                  S.type,
                  S.name
                );
              }
            }
            for (o = 0; o < c.length; o++)
              m = c[o], m.form === l.form && Ls(m);
          }
          break e;
        case "textarea":
          Xm(l, c.value, c.defaultValue);
          break e;
        case "select":
          o = c.value, o != null && Cu(l, !!c.multiple, o, !1);
      }
    }
  }
  var Fm = !1;
  function h4(l, o, c) {
    if (Fm) return l(o, c);
    Fm = !0;
    try {
      var m = l(o);
      return m;
    } finally {
      if (Fm = !1, (Co !== null || Hs !== null) && (uf(), Co && (o = Co, l = Hs, Hs = Co = null, f4(o), l)))
        for (o = 0; o < l.length; o++) f4(l[o]);
    }
  }
  function Yi(l, o) {
    var c = l.stateNode;
    if (c === null) return null;
    var m = c[Zr] || null;
    if (m === null) return null;
    c = m[o];
    e: switch (o) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (m = !m.disabled) || (l = l.type, m = !(l === "button" || l === "input" || l === "select" || l === "textarea")), l = !m;
        break e;
      default:
        l = !1;
    }
    if (l) return null;
    if (c && typeof c != "function")
      throw Error(
        i(231, o, typeof c)
      );
    return c;
  }
  var Al = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), ch = !1;
  if (Al)
    try {
      var Us = {};
      Object.defineProperty(Us, "passive", {
        get: function() {
          ch = !0;
        }
      }), window.addEventListener("test", Us, Us), window.removeEventListener("test", Us, Us);
    } catch {
      ch = !1;
    }
  var ll = null, fh = null, Mo = null;
  function g0() {
    if (Mo) return Mo;
    var l, o = fh, c = o.length, m, S = "value" in ll ? ll.value : ll.textContent, w = S.length;
    for (l = 0; l < c && o[l] === S[l]; l++) ;
    var _ = c - l;
    for (m = 1; m <= _ && o[c - m] === S[w - m]; m++) ;
    return Mo = S.slice(l, 1 < m ? 1 - m : void 0);
  }
  function y0(l) {
    var o = l.keyCode;
    return "charCode" in l ? (l = l.charCode, l === 0 && o === 13 && (l = 13)) : l = o, l === 10 && (l = 13), 32 <= l || l === 13 ? l : 0;
  }
  function Br() {
    return !0;
  }
  function d4() {
    return !1;
  }
  function Fr(l) {
    function o(c, m, S, w, _) {
      this._reactName = c, this._targetInst = S, this.type = m, this.nativeEvent = w, this.target = _, this.currentTarget = null;
      for (var H in l)
        l.hasOwnProperty(H) && (c = l[H], this[H] = c ? c(w) : w[H]);
      return this.isDefaultPrevented = (w.defaultPrevented != null ? w.defaultPrevented : w.returnValue === !1) ? Br : d4, this.isPropagationStopped = d4, this;
    }
    return x(o.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var c = this.nativeEvent;
        c && (c.preventDefault ? c.preventDefault() : typeof c.returnValue != "unknown" && (c.returnValue = !1), this.isDefaultPrevented = Br);
      },
      stopPropagation: function() {
        var c = this.nativeEvent;
        c && (c.stopPropagation ? c.stopPropagation() : typeof c.cancelBubble != "unknown" && (c.cancelBubble = !0), this.isPropagationStopped = Br);
      },
      persist: function() {
      },
      isPersistent: Br
    }), o;
  }
  var Mu = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(l) {
      return l.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, v0 = Fr(Mu), b0 = x({}, Mu, { view: 0, detail: 0 }), i3 = Fr(b0), hh, Pm, qs, dh = x({}, b0, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: mh,
    button: 0,
    buttons: 0,
    relatedTarget: function(l) {
      return l.relatedTarget === void 0 ? l.fromElement === l.srcElement ? l.toElement : l.fromElement : l.relatedTarget;
    },
    movementX: function(l) {
      return "movementX" in l ? l.movementX : (l !== qs && (qs && l.type === "mousemove" ? (hh = l.screenX - qs.screenX, Pm = l.screenY - qs.screenY) : Pm = hh = 0, qs = l), hh);
    },
    movementY: function(l) {
      return "movementY" in l ? l.movementY : Pm;
    }
  }), S0 = Fr(dh), m4 = x({}, dh, { dataTransfer: 0 }), p4 = Fr(m4), g4 = x({}, b0, { relatedTarget: 0 }), Km = Fr(g4), u3 = x({}, Mu, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), o3 = Fr(u3), s3 = x({}, Mu, {
    clipboardData: function(l) {
      return "clipboardData" in l ? l.clipboardData : window.clipboardData;
    }
  }), c3 = Fr(s3), x0 = x({}, Mu, { data: 0 }), Jm = Fr(x0), y4 = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, v4 = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, b4 = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function Wm(l) {
    var o = this.nativeEvent;
    return o.getModifierState ? o.getModifierState(l) : (l = b4[l]) ? !!o[l] : !1;
  }
  function mh() {
    return Wm;
  }
  var _o = x({}, b0, {
    key: function(l) {
      if (l.key) {
        var o = y4[l.key] || l.key;
        if (o !== "Unidentified") return o;
      }
      return l.type === "keypress" ? (l = y0(l), l === 13 ? "Enter" : String.fromCharCode(l)) : l.type === "keydown" || l.type === "keyup" ? v4[l.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: mh,
    charCode: function(l) {
      return l.type === "keypress" ? y0(l) : 0;
    },
    keyCode: function(l) {
      return l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    },
    which: function(l) {
      return l.type === "keypress" ? y0(l) : l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    }
  }), Oo = Fr(_o), kl = x({}, dh, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), fa = Fr(kl), ph = x({}, b0, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: mh
  }), gh = Fr(ph), e1 = x({}, Mu, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), ha = Fr(e1), S4 = x({}, dh, {
    deltaX: function(l) {
      return "deltaX" in l ? l.deltaX : "wheelDeltaX" in l ? -l.wheelDeltaX : 0;
    },
    deltaY: function(l) {
      return "deltaY" in l ? l.deltaY : "wheelDeltaY" in l ? -l.wheelDeltaY : "wheelDelta" in l ? -l.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), yh = Fr(S4), Do = x({}, Mu, {
    newState: 0,
    oldState: 0
  }), t1 = Fr(Do), x4 = [9, 13, 27, 32], vh = Al && "CompositionEvent" in window, No = null;
  Al && "documentMode" in document && (No = document.documentMode);
  var f3 = Al && "TextEvent" in window && !No, bh = Al && (!vh || No && 8 < No && 11 >= No), ui = " ", n1 = !1;
  function Sh(l, o) {
    switch (l) {
      case "keyup":
        return x4.indexOf(o.keyCode) !== -1;
      case "keydown":
        return o.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function w0(l) {
    return l = l.detail, typeof l == "object" && "data" in l ? l.data : null;
  }
  var il = !1;
  function r1(l, o) {
    switch (l) {
      case "compositionend":
        return w0(o);
      case "keypress":
        return o.which !== 32 ? null : (n1 = !0, ui);
      case "textInput":
        return l = o.data, l === ui && n1 ? null : l;
      default:
        return null;
    }
  }
  function a1(l, o) {
    if (il)
      return l === "compositionend" || !vh && Sh(l, o) ? (l = g0(), Mo = fh = ll = null, il = !1, l) : null;
    switch (l) {
      case "paste":
        return null;
      case "keypress":
        if (!(o.ctrlKey || o.altKey || o.metaKey) || o.ctrlKey && o.altKey) {
          if (o.char && 1 < o.char.length)
            return o.char;
          if (o.which) return String.fromCharCode(o.which);
        }
        return null;
      case "compositionend":
        return bh && o.locale !== "ko" ? null : o.data;
      default:
        return null;
    }
  }
  var Lo = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function l1(l) {
    var o = l && l.nodeName && l.nodeName.toLowerCase();
    return o === "input" ? !!Lo[l.type] : o === "textarea";
  }
  function xh(l, o, c, m) {
    Co ? Hs ? Hs.push(m) : Hs = [m] : Co = m, o = ao(o, "onChange"), 0 < o.length && (c = new v0(
      "onChange",
      "change",
      null,
      c,
      m
    ), l.push({ event: c, listeners: o }));
  }
  var Bo = null, Rl = null;
  function Ho(l) {
    hu(l, 0);
  }
  function js(l) {
    var o = Ms(l);
    if (Ls(o)) return l;
  }
  function _u(l, o) {
    if (l === "change") return o;
  }
  var i1 = !1;
  if (Al) {
    var wh;
    if (Al) {
      var Uo = "oninput" in document;
      if (!Uo) {
        var Gs = document.createElement("div");
        Gs.setAttribute("oninput", "return;"), Uo = typeof Gs.oninput == "function";
      }
      wh = Uo;
    } else wh = !1;
    i1 = wh && (!document.documentMode || 9 < document.documentMode);
  }
  function u1() {
    Bo && (Bo.detachEvent("onpropertychange", Vs), Rl = Bo = null);
  }
  function Vs(l) {
    if (l.propertyName === "value" && js(Rl)) {
      var o = [];
      xh(
        o,
        Rl,
        l,
        zo(l)
      ), h4(Ho, o);
    }
  }
  function w4(l, o, c) {
    l === "focusin" ? (u1(), Bo = o, Rl = c, Bo.attachEvent("onpropertychange", Vs)) : l === "focusout" && u1();
  }
  function Th(l) {
    if (l === "selectionchange" || l === "keyup" || l === "keydown")
      return js(Rl);
  }
  function Ou(l, o) {
    if (l === "click") return js(o);
  }
  function Ii(l, o) {
    if (l === "input" || l === "change")
      return js(o);
  }
  function o1(l, o) {
    return l === o && (l !== 0 || 1 / l === 1 / o) || l !== l && o !== o;
  }
  var ra = typeof Object.is == "function" ? Object.is : o1;
  function $i(l, o) {
    if (ra(l, o)) return !0;
    if (typeof l != "object" || l === null || typeof o != "object" || o === null)
      return !1;
    var c = Object.keys(l), m = Object.keys(o);
    if (c.length !== m.length) return !1;
    for (m = 0; m < c.length; m++) {
      var S = c[m];
      if (!wn.call(o, S) || !ra(l[S], o[S]))
        return !1;
    }
    return !0;
  }
  function T0(l) {
    for (; l && l.firstChild; ) l = l.firstChild;
    return l;
  }
  function Du(l, o) {
    var c = T0(l);
    l = 0;
    for (var m; c; ) {
      if (c.nodeType === 3) {
        if (m = l + c.textContent.length, l <= o && m >= o)
          return { node: c, offset: o - l };
        l = m;
      }
      e: {
        for (; c; ) {
          if (c.nextSibling) {
            c = c.nextSibling;
            break e;
          }
          c = c.parentNode;
        }
        c = void 0;
      }
      c = T0(c);
    }
  }
  function En(l, o) {
    return l && o ? l === o ? !0 : l && l.nodeType === 3 ? !1 : o && o.nodeType === 3 ? En(l, o.parentNode) : "contains" in l ? l.contains(o) : l.compareDocumentPosition ? !!(l.compareDocumentPosition(o) & 16) : !1 : !1;
  }
  function E0(l) {
    l = l != null && l.ownerDocument != null && l.ownerDocument.defaultView != null ? l.ownerDocument.defaultView : window;
    for (var o = Vi(l.document); o instanceof l.HTMLIFrameElement; ) {
      try {
        var c = typeof o.contentWindow.location.href == "string";
      } catch {
        c = !1;
      }
      if (c) l = o.contentWindow;
      else break;
      o = Vi(l.document);
    }
    return o;
  }
  function Eh(l) {
    var o = l && l.nodeName && l.nodeName.toLowerCase();
    return o && (o === "input" && (l.type === "text" || l.type === "search" || l.type === "tel" || l.type === "url" || l.type === "password") || o === "textarea" || l.contentEditable === "true");
  }
  var s1 = Al && "documentMode" in document && 11 >= document.documentMode, ul = null, qo = null, Ha = null, Ys = !1;
  function Is(l, o, c) {
    var m = c.window === c ? c.document : c.nodeType === 9 ? c : c.ownerDocument;
    Ys || ul == null || ul !== Vi(m) || (m = ul, "selectionStart" in m && Eh(m) ? m = { start: m.selectionStart, end: m.selectionEnd } : (m = (m.ownerDocument && m.ownerDocument.defaultView || window).getSelection(), m = {
      anchorNode: m.anchorNode,
      anchorOffset: m.anchorOffset,
      focusNode: m.focusNode,
      focusOffset: m.focusOffset
    }), Ha && $i(Ha, m) || (Ha = m, m = ao(qo, "onSelect"), 0 < m.length && (o = new v0(
      "onSelect",
      "select",
      null,
      o,
      c
    ), l.push({ event: o, listeners: m }), o.target = ul)));
  }
  function Xi(l, o) {
    var c = {};
    return c[l.toLowerCase()] = o.toLowerCase(), c["Webkit" + l] = "webkit" + o, c["Moz" + l] = "moz" + o, c;
  }
  var Nu = {
    animationend: Xi("Animation", "AnimationEnd"),
    animationiteration: Xi("Animation", "AnimationIteration"),
    animationstart: Xi("Animation", "AnimationStart"),
    transitionrun: Xi("Transition", "TransitionRun"),
    transitionstart: Xi("Transition", "TransitionStart"),
    transitioncancel: Xi("Transition", "TransitionCancel"),
    transitionend: Xi("Transition", "TransitionEnd")
  }, Ah = {}, zl = {};
  Al && (zl = document.createElement("div").style, "AnimationEvent" in window || (delete Nu.animationend.animation, delete Nu.animationiteration.animation, delete Nu.animationstart.animation), "TransitionEvent" in window || delete Nu.transitionend.transition);
  function Pr(l) {
    if (Ah[l]) return Ah[l];
    if (!Nu[l]) return l;
    var o = Nu[l], c;
    for (c in o)
      if (o.hasOwnProperty(c) && c in zl)
        return Ah[l] = o[c];
    return l;
  }
  var A0 = Pr("animationend"), T4 = Pr("animationiteration"), c1 = Pr("animationstart"), h3 = Pr("transitionrun"), f1 = Pr("transitionstart"), kh = Pr("transitioncancel"), h1 = Pr("transitionend"), d1 = /* @__PURE__ */ new Map(), Rh = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  Rh.push("scrollEnd");
  function da(l, o) {
    d1.set(l, o), wr(o, [l]);
  }
  var m1 = /* @__PURE__ */ new WeakMap();
  function Ua(l, o) {
    if (typeof l == "object" && l !== null) {
      var c = m1.get(l);
      return c !== void 0 ? c : (o = {
        value: l,
        source: o,
        stack: zu(o)
      }, m1.set(l, o), o);
    }
    return {
      value: l,
      source: o,
      stack: zu(o)
    };
  }
  var qa = [], Lu = 0, k0 = 0;
  function Cl() {
    for (var l = Lu, o = k0 = Lu = 0; o < l; ) {
      var c = qa[o];
      qa[o++] = null;
      var m = qa[o];
      qa[o++] = null;
      var S = qa[o];
      qa[o++] = null;
      var w = qa[o];
      if (qa[o++] = null, m !== null && S !== null) {
        var _ = m.pending;
        _ === null ? S.next = S : (S.next = _.next, _.next = S), m.pending = S;
      }
      w !== 0 && $s(c, S, w);
    }
  }
  function Ml(l, o, c, m) {
    qa[Lu++] = l, qa[Lu++] = o, qa[Lu++] = c, qa[Lu++] = m, k0 |= m, l.lanes |= m, l = l.alternate, l !== null && (l.lanes |= m);
  }
  function jo(l, o, c, m) {
    return Ml(l, o, c, m), Bu(l);
  }
  function Qi(l, o) {
    return Ml(l, null, null, o), Bu(l);
  }
  function $s(l, o, c) {
    l.lanes |= c;
    var m = l.alternate;
    m !== null && (m.lanes |= c);
    for (var S = !1, w = l.return; w !== null; )
      w.childLanes |= c, m = w.alternate, m !== null && (m.childLanes |= c), w.tag === 22 && (l = w.stateNode, l === null || l._visibility & 1 || (S = !0)), l = w, w = w.return;
    return l.tag === 3 ? (w = l.stateNode, S && o !== null && (S = 31 - st(c), l = w.hiddenUpdates, m = l[S], m === null ? l[S] = [o] : m.push(o), o.lane = c | 536870912), w) : null;
  }
  function Bu(l) {
    if (50 < Ec)
      throw Ec = 0, md = null, Error(i(185));
    for (var o = l.return; o !== null; )
      l = o, o = l.return;
    return l.tag === 3 ? l.stateNode : null;
  }
  var Go = {};
  function d3(l, o, c, m) {
    this.tag = l, this.key = c, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = o, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = m, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function ma(l, o, c, m) {
    return new d3(l, o, c, m);
  }
  function zh(l) {
    return l = l.prototype, !(!l || !l.isReactComponent);
  }
  function _l(l, o) {
    var c = l.alternate;
    return c === null ? (c = ma(
      l.tag,
      o,
      l.key,
      l.mode
    ), c.elementType = l.elementType, c.type = l.type, c.stateNode = l.stateNode, c.alternate = l, l.alternate = c) : (c.pendingProps = o, c.type = l.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null), c.flags = l.flags & 65011712, c.childLanes = l.childLanes, c.lanes = l.lanes, c.child = l.child, c.memoizedProps = l.memoizedProps, c.memoizedState = l.memoizedState, c.updateQueue = l.updateQueue, o = l.dependencies, c.dependencies = o === null ? null : { lanes: o.lanes, firstContext: o.firstContext }, c.sibling = l.sibling, c.index = l.index, c.ref = l.ref, c.refCleanup = l.refCleanup, c;
  }
  function Ch(l, o) {
    l.flags &= 65011714;
    var c = l.alternate;
    return c === null ? (l.childLanes = 0, l.lanes = o, l.child = null, l.subtreeFlags = 0, l.memoizedProps = null, l.memoizedState = null, l.updateQueue = null, l.dependencies = null, l.stateNode = null) : (l.childLanes = c.childLanes, l.lanes = c.lanes, l.child = c.child, l.subtreeFlags = 0, l.deletions = null, l.memoizedProps = c.memoizedProps, l.memoizedState = c.memoizedState, l.updateQueue = c.updateQueue, l.type = c.type, o = c.dependencies, l.dependencies = o === null ? null : {
      lanes: o.lanes,
      firstContext: o.firstContext
    }), l;
  }
  function Ot(l, o, c, m, S, w) {
    var _ = 0;
    if (m = l, typeof l == "function") zh(l) && (_ = 1);
    else if (typeof l == "string")
      _ = iy(
        l,
        c,
        Me.current
      ) ? 26 : l === "html" || l === "head" || l === "body" ? 27 : 5;
    else
      e: switch (l) {
        case Ne:
          return l = ma(31, c, o, S), l.elementType = Ne, l.lanes = w, l;
        case O:
          return Ue(c.children, S, w, o);
        case L:
          _ = 8, S |= 24;
          break;
        case G:
          return l = ma(12, c, o, S | 2), l.elementType = G, l.lanes = w, l;
        case se:
          return l = ma(13, c, o, S), l.elementType = se, l.lanes = w, l;
        case te:
          return l = ma(19, c, o, S), l.elementType = te, l.lanes = w, l;
        default:
          if (typeof l == "object" && l !== null)
            switch (l.$$typeof) {
              case V:
              case $:
                _ = 10;
                break e;
              case I:
                _ = 9;
                break e;
              case ce:
                _ = 11;
                break e;
              case Ce:
                _ = 14;
                break e;
              case ve:
                _ = 16, m = null;
                break e;
            }
          _ = 29, c = Error(
            i(130, l === null ? "null" : typeof l, "")
          ), m = null;
      }
    return o = ma(_, c, o, S), o.elementType = l, o.type = m, o.lanes = w, o;
  }
  function Ue(l, o, c, m) {
    return l = ma(7, l, m, o), l.lanes = c, l;
  }
  function Hu(l, o, c) {
    return l = ma(6, l, null, o), l.lanes = c, l;
  }
  function Xs(l, o, c) {
    return o = ma(
      4,
      l.children !== null ? l.children : [],
      l.key,
      o
    ), o.lanes = c, o.stateNode = {
      containerInfo: l.containerInfo,
      pendingChildren: null,
      implementation: l.implementation
    }, o;
  }
  var Sn = [], Uu = 0, Qs = null, R0 = 0, pa = [], ol = 0, Zi = null, Ol = 1, Dl = "";
  function nr(l, o) {
    Sn[Uu++] = R0, Sn[Uu++] = Qs, Qs = l, R0 = o;
  }
  function sn(l, o, c) {
    pa[ol++] = Ol, pa[ol++] = Dl, pa[ol++] = Zi, Zi = l;
    var m = Ol;
    l = Dl;
    var S = 32 - st(m) - 1;
    m &= ~(1 << S), c += 1;
    var w = 32 - st(o) + S;
    if (30 < w) {
      var _ = S - S % 5;
      w = (m & (1 << _) - 1).toString(32), m >>= _, S -= _, Ol = 1 << 32 - st(o) + S | c << S | m, Dl = w + l;
    } else
      Ol = 1 << w | c << S | m, Dl = l;
  }
  function z0(l) {
    l.return !== null && (nr(l, 1), sn(l, 1, 0));
  }
  function Vo(l) {
    for (; l === Qs; )
      Qs = Sn[--Uu], Sn[Uu] = null, R0 = Sn[--Uu], Sn[Uu] = null;
    for (; l === Zi; )
      Zi = pa[--ol], pa[ol] = null, Dl = pa[--ol], pa[ol] = null, Ol = pa[--ol], pa[ol] = null;
  }
  var Vn = null, dn = null, Dt = !1, Fi = null, aa = !1, C0 = Error(i(519));
  function Nl(l) {
    var o = Error(i(418, ""));
    throw Ps(Ua(o, l)), C0;
  }
  function Mh(l) {
    var o = l.stateNode, c = l.type, m = l.memoizedProps;
    switch (o[bn] = l, o[Zr] = m, c) {
      case "dialog":
        Ct("cancel", o), Ct("close", o);
        break;
      case "iframe":
      case "object":
      case "embed":
        Ct("load", o);
        break;
      case "video":
      case "audio":
        for (c = 0; c < Et.length; c++)
          Ct(Et[c], o);
        break;
      case "source":
        Ct("error", o);
        break;
      case "img":
      case "image":
      case "link":
        Ct("error", o), Ct("load", o);
        break;
      case "details":
        Ct("toggle", o);
        break;
      case "input":
        Ct("invalid", o), $m(
          o,
          m.value,
          m.defaultValue,
          m.checked,
          m.defaultChecked,
          m.type,
          m.name,
          !0
        ), Ns(o);
        break;
      case "select":
        Ct("invalid", o);
        break;
      case "textarea":
        Ct("invalid", o), Qm(o, m.value, m.defaultValue, m.children), Ns(o);
    }
    c = m.children, typeof c != "string" && typeof c != "number" && typeof c != "bigint" || o.textContent === "" + c || m.suppressHydrationWarning === !0 || ry(o.textContent, c) ? (m.popover != null && (Ct("beforetoggle", o), Ct("toggle", o)), m.onScroll != null && Ct("scroll", o), m.onScrollEnd != null && Ct("scrollend", o), m.onClick != null && (o.onclick = pf), o = !0) : o = !1, o || Nl(l);
  }
  function M0(l) {
    for (Vn = l.return; Vn; )
      switch (Vn.tag) {
        case 5:
        case 13:
          aa = !1;
          return;
        case 27:
        case 3:
          aa = !0;
          return;
        default:
          Vn = Vn.return;
      }
  }
  function Zs(l) {
    if (l !== Vn) return !1;
    if (!Dt) return M0(l), Dt = !0, !1;
    var o = l.tag, c;
    if ((c = o !== 3 && o !== 27) && ((c = o === 5) && (c = l.type, c = !(c !== "form" && c !== "button") || is(l.type, l.memoizedProps)), c = !c), c && dn && Nl(l), M0(l), o === 13) {
      if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(i(317));
      e: {
        for (l = l.nextSibling, o = 0; l; ) {
          if (l.nodeType === 8)
            if (c = l.data, c === "/$") {
              if (o === 0) {
                dn = Ql(l.nextSibling);
                break e;
              }
              o--;
            } else
              c !== "$" && c !== "$!" && c !== "$?" || o++;
          l = l.nextSibling;
        }
        dn = null;
      }
    } else
      o === 27 ? (o = dn, qr(l.type) ? (l = Np, Np = null, dn = l) : dn = o) : dn = Vn ? Ql(l.stateNode.nextSibling) : null;
    return !0;
  }
  function Fs() {
    dn = Vn = null, Dt = !1;
  }
  function p1() {
    var l = Fi;
    return l !== null && (ia === null ? ia = l : ia.push.apply(
      ia,
      l
    ), Fi = null), l;
  }
  function Ps(l) {
    Fi === null ? Fi = [l] : Fi.push(l);
  }
  var _h = Y(null), Pi = null, Ll = null;
  function oi(l, o, c) {
    N(_h, o._currentValue), o._currentValue = c;
  }
  function si(l) {
    l._currentValue = _h.current, ie(_h);
  }
  function Oh(l, o, c) {
    for (; l !== null; ) {
      var m = l.alternate;
      if ((l.childLanes & o) !== o ? (l.childLanes |= o, m !== null && (m.childLanes |= o)) : m !== null && (m.childLanes & o) !== o && (m.childLanes |= o), l === c) break;
      l = l.return;
    }
  }
  function Dh(l, o, c, m) {
    var S = l.child;
    for (S !== null && (S.return = l); S !== null; ) {
      var w = S.dependencies;
      if (w !== null) {
        var _ = S.child;
        w = w.firstContext;
        e: for (; w !== null; ) {
          var H = w;
          w = S;
          for (var Z = 0; Z < o.length; Z++)
            if (H.context === o[Z]) {
              w.lanes |= c, H = w.alternate, H !== null && (H.lanes |= c), Oh(
                w.return,
                c,
                l
              ), m || (_ = null);
              break e;
            }
          w = H.next;
        }
      } else if (S.tag === 18) {
        if (_ = S.return, _ === null) throw Error(i(341));
        _.lanes |= c, w = _.alternate, w !== null && (w.lanes |= c), Oh(_, c, l), _ = null;
      } else _ = S.child;
      if (_ !== null) _.return = S;
      else
        for (_ = S; _ !== null; ) {
          if (_ === l) {
            _ = null;
            break;
          }
          if (S = _.sibling, S !== null) {
            S.return = _.return, _ = S;
            break;
          }
          _ = _.return;
        }
      S = _;
    }
  }
  function _0(l, o, c, m) {
    l = null;
    for (var S = o, w = !1; S !== null; ) {
      if (!w) {
        if (S.flags & 524288) w = !0;
        else if (S.flags & 262144) break;
      }
      if (S.tag === 10) {
        var _ = S.alternate;
        if (_ === null) throw Error(i(387));
        if (_ = _.memoizedProps, _ !== null) {
          var H = S.type;
          ra(S.pendingProps.value, _.value) || (l !== null ? l.push(H) : l = [H]);
        }
      } else if (S === Ge.current) {
        if (_ = S.alternate, _ === null) throw Error(i(387));
        _.memoizedState.memoizedState !== S.memoizedState.memoizedState && (l !== null ? l.push(Gr) : l = [Gr]);
      }
      S = S.return;
    }
    l !== null && Dh(
      o,
      l,
      c,
      m
    ), o.flags |= 262144;
  }
  function O0(l) {
    for (l = l.firstContext; l !== null; ) {
      if (!ra(
        l.context._currentValue,
        l.memoizedValue
      ))
        return !0;
      l = l.next;
    }
    return !1;
  }
  function qu(l) {
    Pi = l, Ll = null, l = l.dependencies, l !== null && (l.firstContext = null);
  }
  function Hr(l) {
    return g1(Pi, l);
  }
  function Ks(l, o) {
    return Pi === null && qu(l), g1(l, o);
  }
  function g1(l, o) {
    var c = o._currentValue;
    if (o = { context: o, memoizedValue: c, next: null }, Ll === null) {
      if (l === null) throw Error(i(308));
      Ll = o, l.dependencies = { lanes: 0, firstContext: o }, l.flags |= 524288;
    } else Ll = Ll.next = o;
    return c;
  }
  var E4 = typeof AbortController < "u" ? AbortController : function() {
    var l = [], o = this.signal = {
      aborted: !1,
      addEventListener: function(c, m) {
        l.push(m);
      }
    };
    this.abort = function() {
      o.aborted = !0, l.forEach(function(c) {
        return c();
      });
    };
  }, Js = r.unstable_scheduleCallback, Nh = r.unstable_NormalPriority, rr = {
    $$typeof: $,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function y1() {
    return {
      controller: new E4(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function ju(l) {
    l.refCount--, l.refCount === 0 && Js(Nh, function() {
      l.controller.abort();
    });
  }
  var ci = null, Ws = 0, Gu = 0, sl = null;
  function ga(l, o) {
    if (ci === null) {
      var c = ci = [];
      Ws = 0, Gu = Ed(), sl = {
        status: "pending",
        value: void 0,
        then: function(m) {
          c.push(m);
        }
      };
    }
    return Ws++, o.then(D0, D0), o;
  }
  function D0() {
    if (--Ws === 0 && ci !== null) {
      sl !== null && (sl.status = "fulfilled");
      var l = ci;
      ci = null, Gu = 0, sl = null;
      for (var o = 0; o < l.length; o++) (0, l[o])();
    }
  }
  function v1(l, o) {
    var c = [], m = {
      status: "pending",
      value: null,
      reason: null,
      then: function(S) {
        c.push(S);
      }
    };
    return l.then(
      function() {
        m.status = "fulfilled", m.value = o;
        for (var S = 0; S < c.length; S++) (0, c[S])(o);
      },
      function(S) {
        for (m.status = "rejected", m.reason = S, S = 0; S < c.length; S++)
          (0, c[S])(void 0);
      }
    ), m;
  }
  var b1 = J.S;
  J.S = function(l, o) {
    typeof o == "object" && o !== null && typeof o.then == "function" && ga(l, o), b1 !== null && b1(l, o);
  };
  var Ki = Y(null);
  function ec() {
    var l = Ki.current;
    return l !== null ? l : pn.pooledCache;
  }
  function tc(l, o) {
    o === null ? N(Ki, Ki.current) : N(Ki, o.pool);
  }
  function N0() {
    var l = ec();
    return l === null ? null : { parent: rr._currentValue, pool: l };
  }
  var Yo = Error(i(460)), L0 = Error(i(474)), nc = Error(i(542)), Lh = { then: function() {
  } };
  function S1(l) {
    return l = l.status, l === "fulfilled" || l === "rejected";
  }
  function rc() {
  }
  function x1(l, o, c) {
    switch (c = l[c], c === void 0 ? l.push(o) : c !== o && (o.then(rc, rc), o = c), o.status) {
      case "fulfilled":
        return o.value;
      case "rejected":
        throw l = o.reason, w1(l), l;
      default:
        if (typeof o.status == "string") o.then(rc, rc);
        else {
          if (l = pn, l !== null && 100 < l.shellSuspendCounter)
            throw Error(i(482));
          l = o, l.status = "pending", l.then(
            function(m) {
              if (o.status === "pending") {
                var S = o;
                S.status = "fulfilled", S.value = m;
              }
            },
            function(m) {
              if (o.status === "pending") {
                var S = o;
                S.status = "rejected", S.reason = m;
              }
            }
          );
        }
        switch (o.status) {
          case "fulfilled":
            return o.value;
          case "rejected":
            throw l = o.reason, w1(l), l;
        }
        throw ac = o, Yo;
    }
  }
  var ac = null;
  function Bh() {
    if (ac === null) throw Error(i(459));
    var l = ac;
    return ac = null, l;
  }
  function w1(l) {
    if (l === Yo || l === nc)
      throw Error(i(483));
  }
  var Ji = !1;
  function B0(l) {
    l.updateQueue = {
      baseState: l.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function Hh(l, o) {
    l = l.updateQueue, o.updateQueue === l && (o.updateQueue = {
      baseState: l.baseState,
      firstBaseUpdate: l.firstBaseUpdate,
      lastBaseUpdate: l.lastBaseUpdate,
      shared: l.shared,
      callbacks: null
    });
  }
  function Wi(l) {
    return { lane: l, tag: 0, payload: null, callback: null, next: null };
  }
  function ya(l, o, c) {
    var m = l.updateQueue;
    if (m === null) return null;
    if (m = m.shared, cn & 2) {
      var S = m.pending;
      return S === null ? o.next = o : (o.next = S.next, S.next = o), m.pending = o, o = Bu(l), $s(l, null, c), o;
    }
    return Ml(l, m, o, c), Bu(l);
  }
  function Io(l, o, c) {
    if (o = o.updateQueue, o !== null && (o = o.shared, (c & 4194048) !== 0)) {
      var m = o.lanes;
      m &= l.pendingLanes, c |= m, o.lanes = c, Pt(l, c);
    }
  }
  function H0(l, o) {
    var c = l.updateQueue, m = l.alternate;
    if (m !== null && (m = m.updateQueue, c === m)) {
      var S = null, w = null;
      if (c = c.firstBaseUpdate, c !== null) {
        do {
          var _ = {
            lane: c.lane,
            tag: c.tag,
            payload: c.payload,
            callback: null,
            next: null
          };
          w === null ? S = w = _ : w = w.next = _, c = c.next;
        } while (c !== null);
        w === null ? S = w = o : w = w.next = o;
      } else S = w = o;
      c = {
        baseState: m.baseState,
        firstBaseUpdate: S,
        lastBaseUpdate: w,
        shared: m.shared,
        callbacks: m.callbacks
      }, l.updateQueue = c;
      return;
    }
    l = c.lastBaseUpdate, l === null ? c.firstBaseUpdate = o : l.next = o, c.lastBaseUpdate = o;
  }
  var T1 = !1;
  function U0() {
    if (T1) {
      var l = sl;
      if (l !== null) throw l;
    }
  }
  function lc(l, o, c, m) {
    T1 = !1;
    var S = l.updateQueue;
    Ji = !1;
    var w = S.firstBaseUpdate, _ = S.lastBaseUpdate, H = S.shared.pending;
    if (H !== null) {
      S.shared.pending = null;
      var Z = H, fe = Z.next;
      Z.next = null, _ === null ? w = fe : _.next = fe, _ = Z;
      var Oe = l.alternate;
      Oe !== null && (Oe = Oe.updateQueue, H = Oe.lastBaseUpdate, H !== _ && (H === null ? Oe.firstBaseUpdate = fe : H.next = fe, Oe.lastBaseUpdate = Z));
    }
    if (w !== null) {
      var Be = S.baseState;
      _ = 0, Oe = fe = Z = null, H = w;
      do {
        var me = H.lane & -536870913, we = me !== H.lane;
        if (we ? (Wt & me) === me : (m & me) === me) {
          me !== 0 && me === Gu && (T1 = !0), Oe !== null && (Oe = Oe.next = {
            lane: 0,
            tag: H.tag,
            payload: H.payload,
            callback: null,
            next: null
          });
          e: {
            var mt = l, ct = H;
            me = o;
            var un = c;
            switch (ct.tag) {
              case 1:
                if (mt = ct.payload, typeof mt == "function") {
                  Be = mt.call(un, Be, me);
                  break e;
                }
                Be = mt;
                break e;
              case 3:
                mt.flags = mt.flags & -65537 | 128;
              case 0:
                if (mt = ct.payload, me = typeof mt == "function" ? mt.call(un, Be, me) : mt, me == null) break e;
                Be = x({}, Be, me);
                break e;
              case 2:
                Ji = !0;
            }
          }
          me = H.callback, me !== null && (l.flags |= 64, we && (l.flags |= 8192), we = S.callbacks, we === null ? S.callbacks = [me] : we.push(me));
        } else
          we = {
            lane: me,
            tag: H.tag,
            payload: H.payload,
            callback: H.callback,
            next: null
          }, Oe === null ? (fe = Oe = we, Z = Be) : Oe = Oe.next = we, _ |= me;
        if (H = H.next, H === null) {
          if (H = S.shared.pending, H === null)
            break;
          we = H, H = we.next, we.next = null, S.lastBaseUpdate = we, S.shared.pending = null;
        }
      } while (!0);
      Oe === null && (Z = Be), S.baseState = Z, S.firstBaseUpdate = fe, S.lastBaseUpdate = Oe, w === null && (S.shared.lanes = 0), Ku |= _, l.lanes = _, l.memoizedState = Be;
    }
  }
  function ic(l, o) {
    if (typeof l != "function")
      throw Error(i(191, l));
    l.call(o);
  }
  function Uh(l, o) {
    var c = l.callbacks;
    if (c !== null)
      for (l.callbacks = null, l = 0; l < c.length; l++)
        ic(c[l], o);
  }
  var eu = Y(null), q0 = Y(0);
  function E1(l, o) {
    l = su, N(q0, l), N(eu, o), su = l | o.baseLanes;
  }
  function dr() {
    N(q0, su), N(eu, eu.current);
  }
  function uc() {
    su = q0.current, ie(eu), ie(q0);
  }
  var Bl = 0, Rt = null, an = null, Un = null, $o = !1, Xo = !1, va = !1, j0 = 0, cl = 0, ba = null, qh = 0;
  function qn() {
    throw Error(i(321));
  }
  function G0(l, o) {
    if (o === null) return !1;
    for (var c = 0; c < o.length && c < l.length; c++)
      if (!ra(l[c], o[c])) return !1;
    return !0;
  }
  function jh(l, o, c, m, S, w) {
    return Bl = w, Rt = o, o.memoizedState = null, o.updateQueue = null, o.lanes = 0, J.H = l === null || l.memoizedState === null ? O4 : Y1, va = !1, w = c(m, S), va = !1, Xo && (w = Vu(
      o,
      c,
      m,
      S
    )), A1(l), w;
  }
  function A1(l) {
    J.H = K0;
    var o = an !== null && an.next !== null;
    if (Bl = 0, Un = an = Rt = null, $o = !1, cl = 0, ba = null, o) throw Error(i(300));
    l === null || Vt || (l = l.dependencies, l !== null && O0(l) && (Vt = !0));
  }
  function Vu(l, o, c, m) {
    Rt = l;
    var S = 0;
    do {
      if (Xo && (ba = null), cl = 0, Xo = !1, 25 <= S) throw Error(i(301));
      if (S += 1, Un = an = null, l.updateQueue != null) {
        var w = l.updateQueue;
        w.lastEffect = null, w.events = null, w.stores = null, w.memoCache != null && (w.memoCache.index = 0);
      }
      J.H = D4, w = o(c, m);
    } while (Xo);
    return w;
  }
  function A4() {
    var l = J.H, o = l.useState()[0];
    return o = typeof o.then == "function" ? Qo(o) : o, l = l.useState()[0], (an !== null ? an.memoizedState : null) !== l && (Rt.flags |= 1024), o;
  }
  function Gh() {
    var l = j0 !== 0;
    return j0 = 0, l;
  }
  function Vh(l, o, c) {
    o.updateQueue = l.updateQueue, o.flags &= -2053, l.lanes &= ~c;
  }
  function oc(l) {
    if ($o) {
      for (l = l.memoizedState; l !== null; ) {
        var o = l.queue;
        o !== null && (o.pending = null), l = l.next;
      }
      $o = !1;
    }
    Bl = 0, Un = an = Rt = null, Xo = !1, cl = j0 = 0, ba = null;
  }
  function la() {
    var l = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return Un === null ? Rt.memoizedState = Un = l : Un = Un.next = l, Un;
  }
  function Yn() {
    if (an === null) {
      var l = Rt.alternate;
      l = l !== null ? l.memoizedState : null;
    } else l = an.next;
    var o = Un === null ? Rt.memoizedState : Un.next;
    if (o !== null)
      Un = o, an = l;
    else {
      if (l === null)
        throw Rt.alternate === null ? Error(i(467)) : Error(i(310));
      an = l, l = {
        memoizedState: an.memoizedState,
        baseState: an.baseState,
        baseQueue: an.baseQueue,
        queue: an.queue,
        next: null
      }, Un === null ? Rt.memoizedState = Un = l : Un = Un.next = l;
    }
    return Un;
  }
  function V0() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function Qo(l) {
    var o = cl;
    return cl += 1, ba === null && (ba = []), l = x1(ba, l, o), o = Rt, (Un === null ? o.memoizedState : Un.next) === null && (o = o.alternate, J.H = o === null || o.memoizedState === null ? O4 : Y1), l;
  }
  function Yh(l) {
    if (l !== null && typeof l == "object") {
      if (typeof l.then == "function") return Qo(l);
      if (l.$$typeof === $) return Hr(l);
    }
    throw Error(i(438, String(l)));
  }
  function mr(l) {
    var o = null, c = Rt.updateQueue;
    if (c !== null && (o = c.memoCache), o == null) {
      var m = Rt.alternate;
      m !== null && (m = m.updateQueue, m !== null && (m = m.memoCache, m != null && (o = {
        data: m.data.map(function(S) {
          return S.slice();
        }),
        index: 0
      })));
    }
    if (o == null && (o = { data: [], index: 0 }), c === null && (c = V0(), Rt.updateQueue = c), c.memoCache = o, c = o.data[o.index], c === void 0)
      for (c = o.data[o.index] = Array(l), m = 0; m < l; m++)
        c[m] = ee;
    return o.index++, c;
  }
  function fi(l, o) {
    return typeof o == "function" ? o(l) : o;
  }
  function Y0(l) {
    var o = Yn();
    return Ih(o, an, l);
  }
  function Ih(l, o, c) {
    var m = l.queue;
    if (m === null) throw Error(i(311));
    m.lastRenderedReducer = c;
    var S = l.baseQueue, w = m.pending;
    if (w !== null) {
      if (S !== null) {
        var _ = S.next;
        S.next = w.next, w.next = _;
      }
      o.baseQueue = S = w, m.pending = null;
    }
    if (w = l.baseState, S === null) l.memoizedState = w;
    else {
      o = S.next;
      var H = _ = null, Z = null, fe = o, Oe = !1;
      do {
        var Be = fe.lane & -536870913;
        if (Be !== fe.lane ? (Wt & Be) === Be : (Bl & Be) === Be) {
          var me = fe.revertLane;
          if (me === 0)
            Z !== null && (Z = Z.next = {
              lane: 0,
              revertLane: 0,
              action: fe.action,
              hasEagerState: fe.hasEagerState,
              eagerState: fe.eagerState,
              next: null
            }), Be === Gu && (Oe = !0);
          else if ((Bl & me) === me) {
            fe = fe.next, me === Gu && (Oe = !0);
            continue;
          } else
            Be = {
              lane: 0,
              revertLane: fe.revertLane,
              action: fe.action,
              hasEagerState: fe.hasEagerState,
              eagerState: fe.eagerState,
              next: null
            }, Z === null ? (H = Z = Be, _ = w) : Z = Z.next = Be, Rt.lanes |= me, Ku |= me;
          Be = fe.action, va && c(w, Be), w = fe.hasEagerState ? fe.eagerState : c(w, Be);
        } else
          me = {
            lane: Be,
            revertLane: fe.revertLane,
            action: fe.action,
            hasEagerState: fe.hasEagerState,
            eagerState: fe.eagerState,
            next: null
          }, Z === null ? (H = Z = me, _ = w) : Z = Z.next = me, Rt.lanes |= Be, Ku |= Be;
        fe = fe.next;
      } while (fe !== null && fe !== o);
      if (Z === null ? _ = w : Z.next = H, !ra(w, l.memoizedState) && (Vt = !0, Oe && (c = sl, c !== null)))
        throw c;
      l.memoizedState = w, l.baseState = _, l.baseQueue = Z, m.lastRenderedState = w;
    }
    return S === null && (m.lanes = 0), [l.memoizedState, m.dispatch];
  }
  function $h(l) {
    var o = Yn(), c = o.queue;
    if (c === null) throw Error(i(311));
    c.lastRenderedReducer = l;
    var m = c.dispatch, S = c.pending, w = o.memoizedState;
    if (S !== null) {
      c.pending = null;
      var _ = S = S.next;
      do
        w = l(w, _.action), _ = _.next;
      while (_ !== S);
      ra(w, o.memoizedState) || (Vt = !0), o.memoizedState = w, o.baseQueue === null && (o.baseState = w), c.lastRenderedState = w;
    }
    return [w, m];
  }
  function k1(l, o, c) {
    var m = Rt, S = Yn(), w = Dt;
    if (w) {
      if (c === void 0) throw Error(i(407));
      c = c();
    } else c = o();
    var _ = !ra(
      (an || S).memoizedState,
      c
    );
    _ && (S.memoizedState = c, Vt = !0), S = S.queue;
    var H = R1.bind(null, m, S, l);
    if (tu(2048, 8, H, [l]), S.getSnapshot !== o || _ || Un !== null && Un.memoizedState.tag & 1) {
      if (m.flags |= 2048, Yu(
        9,
        fl(),
        Xh.bind(
          null,
          m,
          S,
          c,
          o
        ),
        null
      ), pn === null) throw Error(i(349));
      w || Bl & 124 || I0(m, o, c);
    }
    return c;
  }
  function I0(l, o, c) {
    l.flags |= 16384, l = { getSnapshot: o, value: c }, o = Rt.updateQueue, o === null ? (o = V0(), Rt.updateQueue = o, o.stores = [l]) : (c = o.stores, c === null ? o.stores = [l] : c.push(l));
  }
  function Xh(l, o, c, m) {
    o.value = c, o.getSnapshot = m, z1(o) && C1(l);
  }
  function R1(l, o, c) {
    return c(function() {
      z1(o) && C1(l);
    });
  }
  function z1(l) {
    var o = l.getSnapshot;
    l = l.value;
    try {
      var c = o();
      return !ra(l, c);
    } catch {
      return !0;
    }
  }
  function C1(l) {
    var o = Qi(l, 2);
    o !== null && Ra(o, l, 2);
  }
  function $0(l) {
    var o = la();
    if (typeof l == "function") {
      var c = l;
      if (l = c(), va) {
        ut(!0);
        try {
          c();
        } finally {
          ut(!1);
        }
      }
    }
    return o.memoizedState = o.baseState = l, o.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: fi,
      lastRenderedState: l
    }, o;
  }
  function Qh(l, o, c, m) {
    return l.baseState = c, Ih(
      l,
      an,
      typeof m == "function" ? m : fi
    );
  }
  function M1(l, o, c, m, S) {
    if (fc(l)) throw Error(i(485));
    if (l = o.action, l !== null) {
      var w = {
        payload: S,
        action: l,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(_) {
          w.listeners.push(_);
        }
      };
      J.T !== null ? c(!0) : w.isTransition = !1, m(w), c = o.pending, c === null ? (w.next = o.pending = w, _1(o, w)) : (w.next = c.next, o.pending = c.next = w);
    }
  }
  function _1(l, o) {
    var c = o.action, m = o.payload, S = l.state;
    if (o.isTransition) {
      var w = J.T, _ = {};
      J.T = _;
      try {
        var H = c(S, m), Z = J.S;
        Z !== null && Z(_, H), Zh(l, o, H);
      } catch (fe) {
        Q0(l, o, fe);
      } finally {
        J.T = w;
      }
    } else
      try {
        w = c(S, m), Zh(l, o, w);
      } catch (fe) {
        Q0(l, o, fe);
      }
  }
  function Zh(l, o, c) {
    c !== null && typeof c == "object" && typeof c.then == "function" ? c.then(
      function(m) {
        X0(l, o, m);
      },
      function(m) {
        return Q0(l, o, m);
      }
    ) : X0(l, o, c);
  }
  function X0(l, o, c) {
    o.status = "fulfilled", o.value = c, O1(o), l.state = c, o = l.pending, o !== null && (c = o.next, c === o ? l.pending = null : (c = c.next, o.next = c, _1(l, c)));
  }
  function Q0(l, o, c) {
    var m = l.pending;
    if (l.pending = null, m !== null) {
      m = m.next;
      do
        o.status = "rejected", o.reason = c, O1(o), o = o.next;
      while (o !== m);
    }
    l.action = null;
  }
  function O1(l) {
    l = l.listeners;
    for (var o = 0; o < l.length; o++) (0, l[o])();
  }
  function D1(l, o) {
    return o;
  }
  function Fh(l, o) {
    if (Dt) {
      var c = pn.formState;
      if (c !== null) {
        e: {
          var m = Rt;
          if (Dt) {
            if (dn) {
              t: {
                for (var S = dn, w = aa; S.nodeType !== 8; ) {
                  if (!w) {
                    S = null;
                    break t;
                  }
                  if (S = Ql(
                    S.nextSibling
                  ), S === null) {
                    S = null;
                    break t;
                  }
                }
                w = S.data, S = w === "F!" || w === "F" ? S : null;
              }
              if (S) {
                dn = Ql(
                  S.nextSibling
                ), m = S.data === "F!";
                break e;
              }
            }
            Nl(m);
          }
          m = !1;
        }
        m && (o = c[0]);
      }
    }
    return c = la(), c.memoizedState = c.baseState = o, m = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: D1,
      lastRenderedState: o
    }, c.queue = m, c = Jh.bind(
      null,
      Rt,
      m
    ), m.dispatch = c, m = $0(!1), w = F0.bind(
      null,
      Rt,
      !1,
      m.queue
    ), m = la(), S = {
      state: o,
      dispatch: null,
      action: l,
      pending: null
    }, m.queue = S, c = M1.bind(
      null,
      Rt,
      S,
      w,
      c
    ), S.dispatch = c, m.memoizedState = l, [o, c, !1];
  }
  function N1(l) {
    var o = Yn();
    return hi(o, an, l);
  }
  function hi(l, o, c) {
    if (o = Ih(
      l,
      o,
      D1
    )[0], l = Y0(fi)[0], typeof o == "object" && o !== null && typeof o.then == "function")
      try {
        var m = Qo(o);
      } catch (_) {
        throw _ === Yo ? nc : _;
      }
    else m = o;
    o = Yn();
    var S = o.queue, w = S.dispatch;
    return c !== o.memoizedState && (Rt.flags |= 2048, Yu(
      9,
      fl(),
      L1.bind(null, S, c),
      null
    )), [m, w, l];
  }
  function L1(l, o) {
    l.action = o;
  }
  function k4(l) {
    var o = Yn(), c = an;
    if (c !== null)
      return hi(o, c, l);
    Yn(), o = o.memoizedState, c = Yn();
    var m = c.queue.dispatch;
    return c.memoizedState = l, [o, m, !1];
  }
  function Yu(l, o, c, m) {
    return l = { tag: l, create: c, deps: m, inst: o, next: null }, o = Rt.updateQueue, o === null && (o = V0(), Rt.updateQueue = o), c = o.lastEffect, c === null ? o.lastEffect = l.next = l : (m = c.next, c.next = l, l.next = m, o.lastEffect = l), l;
  }
  function fl() {
    return { destroy: void 0, resource: void 0 };
  }
  function B1() {
    return Yn().memoizedState;
  }
  function Zo(l, o, c, m) {
    var S = la();
    m = m === void 0 ? null : m, Rt.flags |= l, S.memoizedState = Yu(
      1 | o,
      fl(),
      c,
      m
    );
  }
  function tu(l, o, c, m) {
    var S = Yn();
    m = m === void 0 ? null : m;
    var w = S.memoizedState.inst;
    an !== null && m !== null && G0(m, an.memoizedState.deps) ? S.memoizedState = Yu(o, w, c, m) : (Rt.flags |= l, S.memoizedState = Yu(
      1 | o,
      w,
      c,
      m
    ));
  }
  function An(l, o) {
    Zo(8390656, 8, l, o);
  }
  function R4(l, o) {
    tu(2048, 8, l, o);
  }
  function z4(l, o) {
    return tu(4, 2, l, o);
  }
  function H1(l, o) {
    return tu(4, 4, l, o);
  }
  function Hl(l, o) {
    if (typeof o == "function") {
      l = l();
      var c = o(l);
      return function() {
        typeof c == "function" ? c() : o(null);
      };
    }
    if (o != null)
      return l = l(), o.current = l, function() {
        o.current = null;
      };
  }
  function U1(l, o, c) {
    c = c != null ? c.concat([l]) : null, tu(4, 4, Hl.bind(null, o, l), c);
  }
  function Z0() {
  }
  function sc(l, o) {
    var c = Yn();
    o = o === void 0 ? null : o;
    var m = c.memoizedState;
    return o !== null && G0(o, m[1]) ? m[0] : (c.memoizedState = [l, o], l);
  }
  function Fo(l, o) {
    var c = Yn();
    o = o === void 0 ? null : o;
    var m = c.memoizedState;
    if (o !== null && G0(o, m[1]))
      return m[0];
    if (m = l(), va) {
      ut(!0);
      try {
        l();
      } finally {
        ut(!1);
      }
    }
    return c.memoizedState = [m, o], m;
  }
  function Ph(l, o, c) {
    return c === void 0 || Bl & 1073741824 ? l.memoizedState = o : (l.memoizedState = c, l = $4(), Rt.lanes |= l, Ku |= l, c);
  }
  function Kh(l, o, c, m) {
    return ra(c, o) ? c : eu.current !== null ? (l = Ph(l, c, m), ra(l, o) || (Vt = !0), l) : Bl & 42 ? (l = $4(), Rt.lanes |= l, Ku |= l, o) : (Vt = !0, l.memoizedState = c);
  }
  function q1(l, o, c, m, S) {
    var w = X.p;
    X.p = w !== 0 && 8 > w ? w : 8;
    var _ = J.T, H = {};
    J.T = H, F0(l, !1, o, c);
    try {
      var Z = S(), fe = J.S;
      if (fe !== null && fe(H, Z), Z !== null && typeof Z == "object" && typeof Z.then == "function") {
        var Oe = v1(
          Z,
          m
        );
        cc(
          l,
          o,
          Oe,
          Ia(l)
        );
      } else
        cc(
          l,
          o,
          m,
          Ia(l)
        );
    } catch (Be) {
      cc(
        l,
        o,
        { then: function() {
        }, status: "rejected", reason: Be },
        Ia()
      );
    } finally {
      X.p = w, J.T = _;
    }
  }
  function m3() {
  }
  function j1(l, o, c, m) {
    if (l.tag !== 5) throw Error(i(476));
    var S = G1(l).queue;
    q1(
      l,
      S,
      o,
      W,
      c === null ? m3 : function() {
        return C4(l), c(m);
      }
    );
  }
  function G1(l) {
    var o = l.memoizedState;
    if (o !== null) return o;
    o = {
      memoizedState: W,
      baseState: W,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: fi,
        lastRenderedState: W
      },
      next: null
    };
    var c = {};
    return o.next = {
      memoizedState: c,
      baseState: c,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: fi,
        lastRenderedState: c
      },
      next: null
    }, l.memoizedState = o, l = l.alternate, l !== null && (l.memoizedState = o), o;
  }
  function C4(l) {
    var o = G1(l).next.queue;
    cc(l, o, {}, Ia());
  }
  function Po() {
    return Hr(Gr);
  }
  function Ul() {
    return Yn().memoizedState;
  }
  function V1() {
    return Yn().memoizedState;
  }
  function p3(l) {
    for (var o = l.return; o !== null; ) {
      switch (o.tag) {
        case 24:
        case 3:
          var c = Ia();
          l = Wi(c);
          var m = ya(o, l, c);
          m !== null && (Ra(m, o, c), Io(m, o, c)), o = { cache: y1() }, l.payload = o;
          return;
      }
      o = o.return;
    }
  }
  function M4(l, o, c) {
    var m = Ia();
    c = {
      lane: m,
      revertLane: 0,
      action: c,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, fc(l) ? P0(o, c) : (c = jo(l, o, c, m), c !== null && (Ra(c, l, m), _4(c, o, m)));
  }
  function Jh(l, o, c) {
    var m = Ia();
    cc(l, o, c, m);
  }
  function cc(l, o, c, m) {
    var S = {
      lane: m,
      revertLane: 0,
      action: c,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (fc(l)) P0(o, S);
    else {
      var w = l.alternate;
      if (l.lanes === 0 && (w === null || w.lanes === 0) && (w = o.lastRenderedReducer, w !== null))
        try {
          var _ = o.lastRenderedState, H = w(_, c);
          if (S.hasEagerState = !0, S.eagerState = H, ra(H, _))
            return Ml(l, o, S, 0), pn === null && Cl(), !1;
        } catch {
        } finally {
        }
      if (c = jo(l, o, S, m), c !== null)
        return Ra(c, l, m), _4(c, o, m), !0;
    }
    return !1;
  }
  function F0(l, o, c, m) {
    if (m = {
      lane: 2,
      revertLane: Ed(),
      action: m,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, fc(l)) {
      if (o) throw Error(i(479));
    } else
      o = jo(
        l,
        c,
        m,
        2
      ), o !== null && Ra(o, l, 2);
  }
  function fc(l) {
    var o = l.alternate;
    return l === Rt || o !== null && o === Rt;
  }
  function P0(l, o) {
    Xo = $o = !0;
    var c = l.pending;
    c === null ? o.next = o : (o.next = c.next, c.next = o), l.pending = o;
  }
  function _4(l, o, c) {
    if (c & 4194048) {
      var m = o.lanes;
      m &= l.pendingLanes, c |= m, o.lanes = c, Pt(l, c);
    }
  }
  var K0 = {
    readContext: Hr,
    use: Yh,
    useCallback: qn,
    useContext: qn,
    useEffect: qn,
    useImperativeHandle: qn,
    useLayoutEffect: qn,
    useInsertionEffect: qn,
    useMemo: qn,
    useReducer: qn,
    useRef: qn,
    useState: qn,
    useDebugValue: qn,
    useDeferredValue: qn,
    useTransition: qn,
    useSyncExternalStore: qn,
    useId: qn,
    useHostTransitionStatus: qn,
    useFormState: qn,
    useActionState: qn,
    useOptimistic: qn,
    useMemoCache: qn,
    useCacheRefresh: qn
  }, O4 = {
    readContext: Hr,
    use: Yh,
    useCallback: function(l, o) {
      return la().memoizedState = [
        l,
        o === void 0 ? null : o
      ], l;
    },
    useContext: Hr,
    useEffect: An,
    useImperativeHandle: function(l, o, c) {
      c = c != null ? c.concat([l]) : null, Zo(
        4194308,
        4,
        Hl.bind(null, o, l),
        c
      );
    },
    useLayoutEffect: function(l, o) {
      return Zo(4194308, 4, l, o);
    },
    useInsertionEffect: function(l, o) {
      Zo(4, 2, l, o);
    },
    useMemo: function(l, o) {
      var c = la();
      o = o === void 0 ? null : o;
      var m = l();
      if (va) {
        ut(!0);
        try {
          l();
        } finally {
          ut(!1);
        }
      }
      return c.memoizedState = [m, o], m;
    },
    useReducer: function(l, o, c) {
      var m = la();
      if (c !== void 0) {
        var S = c(o);
        if (va) {
          ut(!0);
          try {
            c(o);
          } finally {
            ut(!1);
          }
        }
      } else S = o;
      return m.memoizedState = m.baseState = S, l = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: l,
        lastRenderedState: S
      }, m.queue = l, l = l.dispatch = M4.bind(
        null,
        Rt,
        l
      ), [m.memoizedState, l];
    },
    useRef: function(l) {
      var o = la();
      return l = { current: l }, o.memoizedState = l;
    },
    useState: function(l) {
      l = $0(l);
      var o = l.queue, c = Jh.bind(null, Rt, o);
      return o.dispatch = c, [l.memoizedState, c];
    },
    useDebugValue: Z0,
    useDeferredValue: function(l, o) {
      var c = la();
      return Ph(c, l, o);
    },
    useTransition: function() {
      var l = $0(!1);
      return l = q1.bind(
        null,
        Rt,
        l.queue,
        !0,
        !1
      ), la().memoizedState = l, [!1, l];
    },
    useSyncExternalStore: function(l, o, c) {
      var m = Rt, S = la();
      if (Dt) {
        if (c === void 0)
          throw Error(i(407));
        c = c();
      } else {
        if (c = o(), pn === null)
          throw Error(i(349));
        Wt & 124 || I0(m, o, c);
      }
      S.memoizedState = c;
      var w = { value: c, getSnapshot: o };
      return S.queue = w, An(R1.bind(null, m, w, l), [
        l
      ]), m.flags |= 2048, Yu(
        9,
        fl(),
        Xh.bind(
          null,
          m,
          w,
          c,
          o
        ),
        null
      ), c;
    },
    useId: function() {
      var l = la(), o = pn.identifierPrefix;
      if (Dt) {
        var c = Dl, m = Ol;
        c = (m & ~(1 << 32 - st(m) - 1)).toString(32) + c, o = "«" + o + "R" + c, c = j0++, 0 < c && (o += "H" + c.toString(32)), o += "»";
      } else
        c = qh++, o = "«" + o + "r" + c.toString(32) + "»";
      return l.memoizedState = o;
    },
    useHostTransitionStatus: Po,
    useFormState: Fh,
    useActionState: Fh,
    useOptimistic: function(l) {
      var o = la();
      o.memoizedState = o.baseState = l;
      var c = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return o.queue = c, o = F0.bind(
        null,
        Rt,
        !0,
        c
      ), c.dispatch = o, [l, o];
    },
    useMemoCache: mr,
    useCacheRefresh: function() {
      return la().memoizedState = p3.bind(
        null,
        Rt
      );
    }
  }, Y1 = {
    readContext: Hr,
    use: Yh,
    useCallback: sc,
    useContext: Hr,
    useEffect: R4,
    useImperativeHandle: U1,
    useInsertionEffect: z4,
    useLayoutEffect: H1,
    useMemo: Fo,
    useReducer: Y0,
    useRef: B1,
    useState: function() {
      return Y0(fi);
    },
    useDebugValue: Z0,
    useDeferredValue: function(l, o) {
      var c = Yn();
      return Kh(
        c,
        an.memoizedState,
        l,
        o
      );
    },
    useTransition: function() {
      var l = Y0(fi)[0], o = Yn().memoizedState;
      return [
        typeof l == "boolean" ? l : Qo(l),
        o
      ];
    },
    useSyncExternalStore: k1,
    useId: Ul,
    useHostTransitionStatus: Po,
    useFormState: N1,
    useActionState: N1,
    useOptimistic: function(l, o) {
      var c = Yn();
      return Qh(c, an, l, o);
    },
    useMemoCache: mr,
    useCacheRefresh: V1
  }, D4 = {
    readContext: Hr,
    use: Yh,
    useCallback: sc,
    useContext: Hr,
    useEffect: R4,
    useImperativeHandle: U1,
    useInsertionEffect: z4,
    useLayoutEffect: H1,
    useMemo: Fo,
    useReducer: $h,
    useRef: B1,
    useState: function() {
      return $h(fi);
    },
    useDebugValue: Z0,
    useDeferredValue: function(l, o) {
      var c = Yn();
      return an === null ? Ph(c, l, o) : Kh(
        c,
        an.memoizedState,
        l,
        o
      );
    },
    useTransition: function() {
      var l = $h(fi)[0], o = Yn().memoizedState;
      return [
        typeof l == "boolean" ? l : Qo(l),
        o
      ];
    },
    useSyncExternalStore: k1,
    useId: Ul,
    useHostTransitionStatus: Po,
    useFormState: k4,
    useActionState: k4,
    useOptimistic: function(l, o) {
      var c = Yn();
      return an !== null ? Qh(c, an, l, o) : (c.baseState = l, [l, c.queue.dispatch]);
    },
    useMemoCache: mr,
    useCacheRefresh: V1
  }, Sa = null, hc = 0;
  function J0(l) {
    var o = hc;
    return hc += 1, Sa === null && (Sa = []), x1(Sa, l, o);
  }
  function W0(l, o) {
    o = o.props.ref, l.ref = o !== void 0 ? o : null;
  }
  function dc(l, o) {
    throw o.$$typeof === T ? Error(i(525)) : (l = Object.prototype.toString.call(o), Error(
      i(
        31,
        l === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : l
      )
    ));
  }
  function xa(l) {
    var o = l._init;
    return o(l._payload);
  }
  function I1(l) {
    function o(oe, ae) {
      if (l) {
        var he = oe.deletions;
        he === null ? (oe.deletions = [ae], oe.flags |= 16) : he.push(ae);
      }
    }
    function c(oe, ae) {
      if (!l) return null;
      for (; ae !== null; )
        o(oe, ae), ae = ae.sibling;
      return null;
    }
    function m(oe) {
      for (var ae = /* @__PURE__ */ new Map(); oe !== null; )
        oe.key !== null ? ae.set(oe.key, oe) : ae.set(oe.index, oe), oe = oe.sibling;
      return ae;
    }
    function S(oe, ae) {
      return oe = _l(oe, ae), oe.index = 0, oe.sibling = null, oe;
    }
    function w(oe, ae, he) {
      return oe.index = he, l ? (he = oe.alternate, he !== null ? (he = he.index, he < ae ? (oe.flags |= 67108866, ae) : he) : (oe.flags |= 67108866, ae)) : (oe.flags |= 1048576, ae);
    }
    function _(oe) {
      return l && oe.alternate === null && (oe.flags |= 67108866), oe;
    }
    function H(oe, ae, he, Le) {
      return ae === null || ae.tag !== 6 ? (ae = Hu(he, oe.mode, Le), ae.return = oe, ae) : (ae = S(ae, he), ae.return = oe, ae);
    }
    function Z(oe, ae, he, Le) {
      var Je = he.type;
      return Je === O ? Oe(
        oe,
        ae,
        he.props.children,
        Le,
        he.key
      ) : ae !== null && (ae.elementType === Je || typeof Je == "object" && Je !== null && Je.$$typeof === ve && xa(Je) === ae.type) ? (ae = S(ae, he.props), W0(ae, he), ae.return = oe, ae) : (ae = Ot(
        he.type,
        he.key,
        he.props,
        null,
        oe.mode,
        Le
      ), W0(ae, he), ae.return = oe, ae);
    }
    function fe(oe, ae, he, Le) {
      return ae === null || ae.tag !== 4 || ae.stateNode.containerInfo !== he.containerInfo || ae.stateNode.implementation !== he.implementation ? (ae = Xs(he, oe.mode, Le), ae.return = oe, ae) : (ae = S(ae, he.children || []), ae.return = oe, ae);
    }
    function Oe(oe, ae, he, Le, Je) {
      return ae === null || ae.tag !== 7 ? (ae = Ue(
        he,
        oe.mode,
        Le,
        Je
      ), ae.return = oe, ae) : (ae = S(ae, he), ae.return = oe, ae);
    }
    function Be(oe, ae, he) {
      if (typeof ae == "string" && ae !== "" || typeof ae == "number" || typeof ae == "bigint")
        return ae = Hu(
          "" + ae,
          oe.mode,
          he
        ), ae.return = oe, ae;
      if (typeof ae == "object" && ae !== null) {
        switch (ae.$$typeof) {
          case R:
            return he = Ot(
              ae.type,
              ae.key,
              ae.props,
              null,
              oe.mode,
              he
            ), W0(he, ae), he.return = oe, he;
          case E:
            return ae = Xs(
              ae,
              oe.mode,
              he
            ), ae.return = oe, ae;
          case ve:
            var Le = ae._init;
            return ae = Le(ae._payload), Be(oe, ae, he);
        }
        if (re(ae) || de(ae))
          return ae = Ue(
            ae,
            oe.mode,
            he,
            null
          ), ae.return = oe, ae;
        if (typeof ae.then == "function")
          return Be(oe, J0(ae), he);
        if (ae.$$typeof === $)
          return Be(
            oe,
            Ks(oe, ae),
            he
          );
        dc(oe, ae);
      }
      return null;
    }
    function me(oe, ae, he, Le) {
      var Je = ae !== null ? ae.key : null;
      if (typeof he == "string" && he !== "" || typeof he == "number" || typeof he == "bigint")
        return Je !== null ? null : H(oe, ae, "" + he, Le);
      if (typeof he == "object" && he !== null) {
        switch (he.$$typeof) {
          case R:
            return he.key === Je ? Z(oe, ae, he, Le) : null;
          case E:
            return he.key === Je ? fe(oe, ae, he, Le) : null;
          case ve:
            return Je = he._init, he = Je(he._payload), me(oe, ae, he, Le);
        }
        if (re(he) || de(he))
          return Je !== null ? null : Oe(oe, ae, he, Le, null);
        if (typeof he.then == "function")
          return me(
            oe,
            ae,
            J0(he),
            Le
          );
        if (he.$$typeof === $)
          return me(
            oe,
            ae,
            Ks(oe, he),
            Le
          );
        dc(oe, he);
      }
      return null;
    }
    function we(oe, ae, he, Le, Je) {
      if (typeof Le == "string" && Le !== "" || typeof Le == "number" || typeof Le == "bigint")
        return oe = oe.get(he) || null, H(ae, oe, "" + Le, Je);
      if (typeof Le == "object" && Le !== null) {
        switch (Le.$$typeof) {
          case R:
            return oe = oe.get(
              Le.key === null ? he : Le.key
            ) || null, Z(ae, oe, Le, Je);
          case E:
            return oe = oe.get(
              Le.key === null ? he : Le.key
            ) || null, fe(ae, oe, Le, Je);
          case ve:
            var Nt = Le._init;
            return Le = Nt(Le._payload), we(
              oe,
              ae,
              he,
              Le,
              Je
            );
        }
        if (re(Le) || de(Le))
          return oe = oe.get(he) || null, Oe(ae, oe, Le, Je, null);
        if (typeof Le.then == "function")
          return we(
            oe,
            ae,
            he,
            J0(Le),
            Je
          );
        if (Le.$$typeof === $)
          return we(
            oe,
            ae,
            he,
            Ks(ae, Le),
            Je
          );
        dc(ae, Le);
      }
      return null;
    }
    function mt(oe, ae, he, Le) {
      for (var Je = null, Nt = null, ot = ae, pt = ae = 0, zr = null; ot !== null && pt < he.length; pt++) {
        ot.index > pt ? (zr = ot, ot = null) : zr = ot.sibling;
        var nn = me(
          oe,
          ot,
          he[pt],
          Le
        );
        if (nn === null) {
          ot === null && (ot = zr);
          break;
        }
        l && ot && nn.alternate === null && o(oe, ot), ae = w(nn, ae, pt), Nt === null ? Je = nn : Nt.sibling = nn, Nt = nn, ot = zr;
      }
      if (pt === he.length)
        return c(oe, ot), Dt && nr(oe, pt), Je;
      if (ot === null) {
        for (; pt < he.length; pt++)
          ot = Be(oe, he[pt], Le), ot !== null && (ae = w(
            ot,
            ae,
            pt
          ), Nt === null ? Je = ot : Nt.sibling = ot, Nt = ot);
        return Dt && nr(oe, pt), Je;
      }
      for (ot = m(ot); pt < he.length; pt++)
        zr = we(
          ot,
          oe,
          pt,
          he[pt],
          Le
        ), zr !== null && (l && zr.alternate !== null && ot.delete(
          zr.key === null ? pt : zr.key
        ), ae = w(
          zr,
          ae,
          pt
        ), Nt === null ? Je = zr : Nt.sibling = zr, Nt = zr);
      return l && ot.forEach(function(xi) {
        return o(oe, xi);
      }), Dt && nr(oe, pt), Je;
    }
    function ct(oe, ae, he, Le) {
      if (he == null) throw Error(i(151));
      for (var Je = null, Nt = null, ot = ae, pt = ae = 0, zr = null, nn = he.next(); ot !== null && !nn.done; pt++, nn = he.next()) {
        ot.index > pt ? (zr = ot, ot = null) : zr = ot.sibling;
        var xi = me(oe, ot, nn.value, Le);
        if (xi === null) {
          ot === null && (ot = zr);
          break;
        }
        l && ot && xi.alternate === null && o(oe, ot), ae = w(xi, ae, pt), Nt === null ? Je = xi : Nt.sibling = xi, Nt = xi, ot = zr;
      }
      if (nn.done)
        return c(oe, ot), Dt && nr(oe, pt), Je;
      if (ot === null) {
        for (; !nn.done; pt++, nn = he.next())
          nn = Be(oe, nn.value, Le), nn !== null && (ae = w(nn, ae, pt), Nt === null ? Je = nn : Nt.sibling = nn, Nt = nn);
        return Dt && nr(oe, pt), Je;
      }
      for (ot = m(ot); !nn.done; pt++, nn = he.next())
        nn = we(ot, oe, pt, nn.value, Le), nn !== null && (l && nn.alternate !== null && ot.delete(nn.key === null ? pt : nn.key), ae = w(nn, ae, pt), Nt === null ? Je = nn : Nt.sibling = nn, Nt = nn);
      return l && ot.forEach(function(A3) {
        return o(oe, A3);
      }), Dt && nr(oe, pt), Je;
    }
    function un(oe, ae, he, Le) {
      if (typeof he == "object" && he !== null && he.type === O && he.key === null && (he = he.props.children), typeof he == "object" && he !== null) {
        switch (he.$$typeof) {
          case R:
            e: {
              for (var Je = he.key; ae !== null; ) {
                if (ae.key === Je) {
                  if (Je = he.type, Je === O) {
                    if (ae.tag === 7) {
                      c(
                        oe,
                        ae.sibling
                      ), Le = S(
                        ae,
                        he.props.children
                      ), Le.return = oe, oe = Le;
                      break e;
                    }
                  } else if (ae.elementType === Je || typeof Je == "object" && Je !== null && Je.$$typeof === ve && xa(Je) === ae.type) {
                    c(
                      oe,
                      ae.sibling
                    ), Le = S(ae, he.props), W0(Le, he), Le.return = oe, oe = Le;
                    break e;
                  }
                  c(oe, ae);
                  break;
                } else o(oe, ae);
                ae = ae.sibling;
              }
              he.type === O ? (Le = Ue(
                he.props.children,
                oe.mode,
                Le,
                he.key
              ), Le.return = oe, oe = Le) : (Le = Ot(
                he.type,
                he.key,
                he.props,
                null,
                oe.mode,
                Le
              ), W0(Le, he), Le.return = oe, oe = Le);
            }
            return _(oe);
          case E:
            e: {
              for (Je = he.key; ae !== null; ) {
                if (ae.key === Je)
                  if (ae.tag === 4 && ae.stateNode.containerInfo === he.containerInfo && ae.stateNode.implementation === he.implementation) {
                    c(
                      oe,
                      ae.sibling
                    ), Le = S(ae, he.children || []), Le.return = oe, oe = Le;
                    break e;
                  } else {
                    c(oe, ae);
                    break;
                  }
                else o(oe, ae);
                ae = ae.sibling;
              }
              Le = Xs(he, oe.mode, Le), Le.return = oe, oe = Le;
            }
            return _(oe);
          case ve:
            return Je = he._init, he = Je(he._payload), un(
              oe,
              ae,
              he,
              Le
            );
        }
        if (re(he))
          return mt(
            oe,
            ae,
            he,
            Le
          );
        if (de(he)) {
          if (Je = de(he), typeof Je != "function") throw Error(i(150));
          return he = Je.call(he), ct(
            oe,
            ae,
            he,
            Le
          );
        }
        if (typeof he.then == "function")
          return un(
            oe,
            ae,
            J0(he),
            Le
          );
        if (he.$$typeof === $)
          return un(
            oe,
            ae,
            Ks(oe, he),
            Le
          );
        dc(oe, he);
      }
      return typeof he == "string" && he !== "" || typeof he == "number" || typeof he == "bigint" ? (he = "" + he, ae !== null && ae.tag === 6 ? (c(oe, ae.sibling), Le = S(ae, he), Le.return = oe, oe = Le) : (c(oe, ae), Le = Hu(he, oe.mode, Le), Le.return = oe, oe = Le), _(oe)) : c(oe, ae);
    }
    return function(oe, ae, he, Le) {
      try {
        hc = 0;
        var Je = un(
          oe,
          ae,
          he,
          Le
        );
        return Sa = null, Je;
      } catch (ot) {
        if (ot === Yo || ot === nc) throw ot;
        var Nt = ma(29, ot, null, oe.mode);
        return Nt.lanes = Le, Nt.return = oe, Nt;
      } finally {
      }
    };
  }
  var Tr = I1(!0), $1 = I1(!1), ar = Y(null), ql = null;
  function wa(l) {
    var o = l.alternate;
    N(Pn, Pn.current & 1), N(ar, l), ql === null && (o === null || eu.current !== null || o.memoizedState !== null) && (ql = l);
  }
  function X1(l) {
    if (l.tag === 22) {
      if (N(Pn, Pn.current), N(ar, l), ql === null) {
        var o = l.alternate;
        o !== null && o.memoizedState !== null && (ql = l);
      }
    } else Kr();
  }
  function Kr() {
    N(Pn, Pn.current), N(ar, ar.current);
  }
  function jl(l) {
    ie(ar), ql === l && (ql = null), ie(Pn);
  }
  var Pn = Y(0);
  function ja(l) {
    for (var o = l; o !== null; ) {
      if (o.tag === 13) {
        var c = o.memoizedState;
        if (c !== null && (c = c.dehydrated, c === null || c.data === "$?" || Op(c)))
          return o;
      } else if (o.tag === 19 && o.memoizedProps.revealOrder !== void 0) {
        if (o.flags & 128) return o;
      } else if (o.child !== null) {
        o.child.return = o, o = o.child;
        continue;
      }
      if (o === l) break;
      for (; o.sibling === null; ) {
        if (o.return === null || o.return === l) return null;
        o = o.return;
      }
      o.sibling.return = o.return, o = o.sibling;
    }
    return null;
  }
  function Wh(l, o, c, m) {
    o = l.memoizedState, c = c(m, o), c = c == null ? o : x({}, o, c), l.memoizedState = c, l.lanes === 0 && (l.updateQueue.baseState = c);
  }
  var Iu = {
    enqueueSetState: function(l, o, c) {
      l = l._reactInternals;
      var m = Ia(), S = Wi(m);
      S.payload = o, c != null && (S.callback = c), o = ya(l, S, m), o !== null && (Ra(o, l, m), Io(o, l, m));
    },
    enqueueReplaceState: function(l, o, c) {
      l = l._reactInternals;
      var m = Ia(), S = Wi(m);
      S.tag = 1, S.payload = o, c != null && (S.callback = c), o = ya(l, S, m), o !== null && (Ra(o, l, m), Io(o, l, m));
    },
    enqueueForceUpdate: function(l, o) {
      l = l._reactInternals;
      var c = Ia(), m = Wi(c);
      m.tag = 2, o != null && (m.callback = o), o = ya(l, m, c), o !== null && (Ra(o, l, c), Io(o, l, c));
    }
  };
  function Q1(l, o, c, m, S, w, _) {
    return l = l.stateNode, typeof l.shouldComponentUpdate == "function" ? l.shouldComponentUpdate(m, w, _) : o.prototype && o.prototype.isPureReactComponent ? !$i(c, m) || !$i(S, w) : !0;
  }
  function mc(l, o, c, m) {
    l = o.state, typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps(c, m), typeof o.UNSAFE_componentWillReceiveProps == "function" && o.UNSAFE_componentWillReceiveProps(c, m), o.state !== l && Iu.enqueueReplaceState(o, o.state, null);
  }
  function hl(l, o) {
    var c = o;
    if ("ref" in o) {
      c = {};
      for (var m in o)
        m !== "ref" && (c[m] = o[m]);
    }
    if (l = l.defaultProps) {
      c === o && (c = x({}, c));
      for (var S in l)
        c[S] === void 0 && (c[S] = l[S]);
    }
    return c;
  }
  var ef = typeof reportError == "function" ? reportError : function(l) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var o = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof l == "object" && l !== null && typeof l.message == "string" ? String(l.message) : String(l),
        error: l
      });
      if (!window.dispatchEvent(o)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", l);
      return;
    }
    console.error(l);
  };
  function Z1(l) {
    ef(l);
  }
  function pc(l) {
    console.error(l);
  }
  function F1(l) {
    ef(l);
  }
  function Ko(l, o) {
    try {
      var c = l.onUncaughtError;
      c(o.value, { componentStack: o.stack });
    } catch (m) {
      setTimeout(function() {
        throw m;
      });
    }
  }
  function P1(l, o, c) {
    try {
      var m = l.onCaughtError;
      m(c.value, {
        componentStack: c.stack,
        errorBoundary: o.tag === 1 ? o.stateNode : null
      });
    } catch (S) {
      setTimeout(function() {
        throw S;
      });
    }
  }
  function ed(l, o, c) {
    return c = Wi(c), c.tag = 3, c.payload = { element: null }, c.callback = function() {
      Ko(l, o);
    }, c;
  }
  function N4(l) {
    return l = Wi(l), l.tag = 3, l;
  }
  function K1(l, o, c, m) {
    var S = c.type.getDerivedStateFromError;
    if (typeof S == "function") {
      var w = m.value;
      l.payload = function() {
        return S(w);
      }, l.callback = function() {
        P1(o, c, m);
      };
    }
    var _ = c.stateNode;
    _ !== null && typeof _.componentDidCatch == "function" && (l.callback = function() {
      P1(o, c, m), typeof S != "function" && (di === null ? di = /* @__PURE__ */ new Set([this]) : di.add(this));
      var H = m.stack;
      this.componentDidCatch(m.value, {
        componentStack: H !== null ? H : ""
      });
    });
  }
  function Ga(l, o, c, m, S) {
    if (c.flags |= 32768, m !== null && typeof m == "object" && typeof m.then == "function") {
      if (o = c.alternate, o !== null && _0(
        o,
        c,
        S,
        !0
      ), c = ar.current, c !== null) {
        switch (c.tag) {
          case 13:
            return ql === null ? to() : c.alternate === null && $n === 0 && ($n = 3), c.flags &= -257, c.flags |= 65536, c.lanes = S, m === Lh ? c.flags |= 16384 : (o = c.updateQueue, o === null ? c.updateQueue = /* @__PURE__ */ new Set([m]) : o.add(m), sf(l, m, S)), !1;
          case 22:
            return c.flags |= 65536, m === Lh ? c.flags |= 16384 : (o = c.updateQueue, o === null ? (o = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([m])
            }, c.updateQueue = o) : (c = o.retryQueue, c === null ? o.retryQueue = /* @__PURE__ */ new Set([m]) : c.add(m)), sf(l, m, S)), !1;
        }
        throw Error(i(435, c.tag));
      }
      return sf(l, m, S), to(), !1;
    }
    if (Dt)
      return o = ar.current, o !== null ? (!(o.flags & 65536) && (o.flags |= 256), o.flags |= 65536, o.lanes = S, m !== C0 && (l = Error(i(422), { cause: m }), Ps(Ua(l, c)))) : (m !== C0 && (o = Error(i(423), {
        cause: m
      }), Ps(
        Ua(o, c)
      )), l = l.current.alternate, l.flags |= 65536, S &= -S, l.lanes |= S, m = Ua(m, c), S = ed(
        l.stateNode,
        m,
        S
      ), H0(l, S), $n !== 4 && ($n = 2)), !1;
    var w = Error(i(520), { cause: m });
    if (w = Ua(w, c), lf === null ? lf = [w] : lf.push(w), $n !== 4 && ($n = 2), o === null) return !0;
    m = Ua(m, c), c = o;
    do {
      switch (c.tag) {
        case 3:
          return c.flags |= 65536, l = S & -S, c.lanes |= l, l = ed(c.stateNode, m, l), H0(c, l), !1;
        case 1:
          if (o = c.type, w = c.stateNode, (c.flags & 128) === 0 && (typeof o.getDerivedStateFromError == "function" || w !== null && typeof w.componentDidCatch == "function" && (di === null || !di.has(w))))
            return c.flags |= 65536, S &= -S, c.lanes |= S, S = N4(S), K1(
              S,
              l,
              c,
              m
            ), H0(c, S), !1;
      }
      c = c.return;
    } while (c !== null);
    return !1;
  }
  var J1 = Error(i(461)), Vt = !1;
  function Er(l, o, c, m) {
    o.child = l === null ? $1(o, null, c, m) : Tr(
      o,
      l.child,
      c,
      m
    );
  }
  function W1(l, o, c, m, S) {
    c = c.render;
    var w = o.ref;
    if ("ref" in m) {
      var _ = {};
      for (var H in m)
        H !== "ref" && (_[H] = m[H]);
    } else _ = m;
    return qu(o), m = jh(
      l,
      o,
      c,
      _,
      w,
      S
    ), H = Gh(), l !== null && !Vt ? (Vh(l, o, S), Gl(l, o, S)) : (Dt && H && z0(o), o.flags |= 1, Er(l, o, m, S), o.child);
  }
  function L4(l, o, c, m, S) {
    if (l === null) {
      var w = c.type;
      return typeof w == "function" && !zh(w) && w.defaultProps === void 0 && c.compare === null ? (o.tag = 15, o.type = w, nu(
        l,
        o,
        w,
        m,
        S
      )) : (l = Ot(
        c.type,
        null,
        m,
        o,
        o.mode,
        S
      ), l.ref = o.ref, l.return = o, o.child = l);
    }
    if (w = l.child, !id(l, S)) {
      var _ = w.memoizedProps;
      if (c = c.compare, c = c !== null ? c : $i, c(_, m) && l.ref === o.ref)
        return Gl(l, o, S);
    }
    return o.flags |= 1, l = _l(w, m), l.ref = o.ref, l.return = o, o.child = l;
  }
  function nu(l, o, c, m, S) {
    if (l !== null) {
      var w = l.memoizedProps;
      if ($i(w, m) && l.ref === o.ref)
        if (Vt = !1, o.pendingProps = m = w, id(l, S))
          l.flags & 131072 && (Vt = !0);
        else
          return o.lanes = l.lanes, Gl(l, o, S);
    }
    return nd(
      l,
      o,
      c,
      m,
      S
    );
  }
  function Jo(l, o, c) {
    var m = o.pendingProps, S = m.children, w = l !== null ? l.memoizedState : null;
    if (m.mode === "hidden") {
      if (o.flags & 128) {
        if (m = w !== null ? w.baseLanes | c : c, l !== null) {
          for (S = o.child = l.child, w = 0; S !== null; )
            w = w | S.lanes | S.childLanes, S = S.sibling;
          o.childLanes = w & ~m;
        } else o.childLanes = 0, o.child = null;
        return td(
          l,
          o,
          m,
          c
        );
      }
      if (c & 536870912)
        o.memoizedState = { baseLanes: 0, cachePool: null }, l !== null && tc(
          o,
          w !== null ? w.cachePool : null
        ), w !== null ? E1(o, w) : dr(), X1(o);
      else
        return o.lanes = o.childLanes = 536870912, td(
          l,
          o,
          w !== null ? w.baseLanes | c : c,
          c
        );
    } else
      w !== null ? (tc(o, w.cachePool), E1(o, w), Kr(), o.memoizedState = null) : (l !== null && tc(o, null), dr(), Kr());
    return Er(l, o, S, c), o.child;
  }
  function td(l, o, c, m) {
    var S = ec();
    return S = S === null ? null : { parent: rr._currentValue, pool: S }, o.memoizedState = {
      baseLanes: c,
      cachePool: S
    }, l !== null && tc(o, null), dr(), X1(o), l !== null && _0(l, o, m, !0), null;
  }
  function ru(l, o) {
    var c = o.ref;
    if (c === null)
      l !== null && l.ref !== null && (o.flags |= 4194816);
    else {
      if (typeof c != "function" && typeof c != "object")
        throw Error(i(284));
      (l === null || l.ref !== c) && (o.flags |= 4194816);
    }
  }
  function nd(l, o, c, m, S) {
    return qu(o), c = jh(
      l,
      o,
      c,
      m,
      void 0,
      S
    ), m = Gh(), l !== null && !Vt ? (Vh(l, o, S), Gl(l, o, S)) : (Dt && m && z0(o), o.flags |= 1, Er(l, o, c, S), o.child);
  }
  function ep(l, o, c, m, S, w) {
    return qu(o), o.updateQueue = null, c = Vu(
      o,
      m,
      c,
      S
    ), A1(l), m = Gh(), l !== null && !Vt ? (Vh(l, o, w), Gl(l, o, w)) : (Dt && m && z0(o), o.flags |= 1, Er(l, o, c, w), o.child);
  }
  function tp(l, o, c, m, S) {
    if (qu(o), o.stateNode === null) {
      var w = Go, _ = c.contextType;
      typeof _ == "object" && _ !== null && (w = Hr(_)), w = new c(m, w), o.memoizedState = w.state !== null && w.state !== void 0 ? w.state : null, w.updater = Iu, o.stateNode = w, w._reactInternals = o, w = o.stateNode, w.props = m, w.state = o.memoizedState, w.refs = {}, B0(o), _ = c.contextType, w.context = typeof _ == "object" && _ !== null ? Hr(_) : Go, w.state = o.memoizedState, _ = c.getDerivedStateFromProps, typeof _ == "function" && (Wh(
        o,
        c,
        _,
        m
      ), w.state = o.memoizedState), typeof c.getDerivedStateFromProps == "function" || typeof w.getSnapshotBeforeUpdate == "function" || typeof w.UNSAFE_componentWillMount != "function" && typeof w.componentWillMount != "function" || (_ = w.state, typeof w.componentWillMount == "function" && w.componentWillMount(), typeof w.UNSAFE_componentWillMount == "function" && w.UNSAFE_componentWillMount(), _ !== w.state && Iu.enqueueReplaceState(w, w.state, null), lc(o, m, w, S), U0(), w.state = o.memoizedState), typeof w.componentDidMount == "function" && (o.flags |= 4194308), m = !0;
    } else if (l === null) {
      w = o.stateNode;
      var H = o.memoizedProps, Z = hl(c, H);
      w.props = Z;
      var fe = w.context, Oe = c.contextType;
      _ = Go, typeof Oe == "object" && Oe !== null && (_ = Hr(Oe));
      var Be = c.getDerivedStateFromProps;
      Oe = typeof Be == "function" || typeof w.getSnapshotBeforeUpdate == "function", H = o.pendingProps !== H, Oe || typeof w.UNSAFE_componentWillReceiveProps != "function" && typeof w.componentWillReceiveProps != "function" || (H || fe !== _) && mc(
        o,
        w,
        m,
        _
      ), Ji = !1;
      var me = o.memoizedState;
      w.state = me, lc(o, m, w, S), U0(), fe = o.memoizedState, H || me !== fe || Ji ? (typeof Be == "function" && (Wh(
        o,
        c,
        Be,
        m
      ), fe = o.memoizedState), (Z = Ji || Q1(
        o,
        c,
        Z,
        m,
        me,
        fe,
        _
      )) ? (Oe || typeof w.UNSAFE_componentWillMount != "function" && typeof w.componentWillMount != "function" || (typeof w.componentWillMount == "function" && w.componentWillMount(), typeof w.UNSAFE_componentWillMount == "function" && w.UNSAFE_componentWillMount()), typeof w.componentDidMount == "function" && (o.flags |= 4194308)) : (typeof w.componentDidMount == "function" && (o.flags |= 4194308), o.memoizedProps = m, o.memoizedState = fe), w.props = m, w.state = fe, w.context = _, m = Z) : (typeof w.componentDidMount == "function" && (o.flags |= 4194308), m = !1);
    } else {
      w = o.stateNode, Hh(l, o), _ = o.memoizedProps, Oe = hl(c, _), w.props = Oe, Be = o.pendingProps, me = w.context, fe = c.contextType, Z = Go, typeof fe == "object" && fe !== null && (Z = Hr(fe)), H = c.getDerivedStateFromProps, (fe = typeof H == "function" || typeof w.getSnapshotBeforeUpdate == "function") || typeof w.UNSAFE_componentWillReceiveProps != "function" && typeof w.componentWillReceiveProps != "function" || (_ !== Be || me !== Z) && mc(
        o,
        w,
        m,
        Z
      ), Ji = !1, me = o.memoizedState, w.state = me, lc(o, m, w, S), U0();
      var we = o.memoizedState;
      _ !== Be || me !== we || Ji || l !== null && l.dependencies !== null && O0(l.dependencies) ? (typeof H == "function" && (Wh(
        o,
        c,
        H,
        m
      ), we = o.memoizedState), (Oe = Ji || Q1(
        o,
        c,
        Oe,
        m,
        me,
        we,
        Z
      ) || l !== null && l.dependencies !== null && O0(l.dependencies)) ? (fe || typeof w.UNSAFE_componentWillUpdate != "function" && typeof w.componentWillUpdate != "function" || (typeof w.componentWillUpdate == "function" && w.componentWillUpdate(m, we, Z), typeof w.UNSAFE_componentWillUpdate == "function" && w.UNSAFE_componentWillUpdate(
        m,
        we,
        Z
      )), typeof w.componentDidUpdate == "function" && (o.flags |= 4), typeof w.getSnapshotBeforeUpdate == "function" && (o.flags |= 1024)) : (typeof w.componentDidUpdate != "function" || _ === l.memoizedProps && me === l.memoizedState || (o.flags |= 4), typeof w.getSnapshotBeforeUpdate != "function" || _ === l.memoizedProps && me === l.memoizedState || (o.flags |= 1024), o.memoizedProps = m, o.memoizedState = we), w.props = m, w.state = we, w.context = Z, m = Oe) : (typeof w.componentDidUpdate != "function" || _ === l.memoizedProps && me === l.memoizedState || (o.flags |= 4), typeof w.getSnapshotBeforeUpdate != "function" || _ === l.memoizedProps && me === l.memoizedState || (o.flags |= 1024), m = !1);
    }
    return w = m, ru(l, o), m = (o.flags & 128) !== 0, w || m ? (w = o.stateNode, c = m && typeof c.getDerivedStateFromError != "function" ? null : w.render(), o.flags |= 1, l !== null && m ? (o.child = Tr(
      o,
      l.child,
      null,
      S
    ), o.child = Tr(
      o,
      null,
      c,
      S
    )) : Er(l, o, c, S), o.memoizedState = w.state, l = o.child) : l = Gl(
      l,
      o,
      S
    ), l;
  }
  function rd(l, o, c, m) {
    return Fs(), o.flags |= 256, Er(l, o, c, m), o.child;
  }
  var tf = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function ad(l) {
    return { baseLanes: l, cachePool: N0() };
  }
  function np(l, o, c) {
    return l = l !== null ? l.childLanes & ~c : 0, o && (l |= pr), l;
  }
  function B4(l, o, c) {
    var m = o.pendingProps, S = !1, w = (o.flags & 128) !== 0, _;
    if ((_ = w) || (_ = l !== null && l.memoizedState === null ? !1 : (Pn.current & 2) !== 0), _ && (S = !0, o.flags &= -129), _ = (o.flags & 32) !== 0, o.flags &= -33, l === null) {
      if (Dt) {
        if (S ? wa(o) : Kr(), Dt) {
          var H = dn, Z;
          if (Z = H) {
            e: {
              for (Z = H, H = aa; Z.nodeType !== 8; ) {
                if (!H) {
                  H = null;
                  break e;
                }
                if (Z = Ql(
                  Z.nextSibling
                ), Z === null) {
                  H = null;
                  break e;
                }
              }
              H = Z;
            }
            H !== null ? (o.memoizedState = {
              dehydrated: H,
              treeContext: Zi !== null ? { id: Ol, overflow: Dl } : null,
              retryLane: 536870912,
              hydrationErrors: null
            }, Z = ma(
              18,
              null,
              null,
              0
            ), Z.stateNode = H, Z.return = o, o.child = Z, Vn = o, dn = null, Z = !0) : Z = !1;
          }
          Z || Nl(o);
        }
        if (H = o.memoizedState, H !== null && (H = H.dehydrated, H !== null))
          return Op(H) ? o.lanes = 32 : o.lanes = 536870912, null;
        jl(o);
      }
      return H = m.children, m = m.fallback, S ? (Kr(), S = o.mode, H = nf(
        { mode: "hidden", children: H },
        S
      ), m = Ue(
        m,
        S,
        c,
        null
      ), H.return = o, m.return = o, H.sibling = m, o.child = H, S = o.child, S.memoizedState = ad(c), S.childLanes = np(
        l,
        _,
        c
      ), o.memoizedState = tf, m) : (wa(o), ld(o, H));
    }
    if (Z = l.memoizedState, Z !== null && (H = Z.dehydrated, H !== null)) {
      if (w)
        o.flags & 256 ? (wa(o), o.flags &= -257, o = rp(
          l,
          o,
          c
        )) : o.memoizedState !== null ? (Kr(), o.child = l.child, o.flags |= 128, o = null) : (Kr(), S = m.fallback, H = o.mode, m = nf(
          { mode: "visible", children: m.children },
          H
        ), S = Ue(
          S,
          H,
          c,
          null
        ), S.flags |= 2, m.return = o, S.return = o, m.sibling = S, o.child = m, Tr(
          o,
          l.child,
          null,
          c
        ), m = o.child, m.memoizedState = ad(c), m.childLanes = np(
          l,
          _,
          c
        ), o.memoizedState = tf, o = S);
      else if (wa(o), Op(H)) {
        if (_ = H.nextSibling && H.nextSibling.dataset, _) var fe = _.dgst;
        _ = fe, m = Error(i(419)), m.stack = "", m.digest = _, Ps({ value: m, source: null, stack: null }), o = rp(
          l,
          o,
          c
        );
      } else if (Vt || _0(l, o, c, !1), _ = (c & l.childLanes) !== 0, Vt || _) {
        if (_ = pn, _ !== null && (m = c & -c, m = m & 42 ? 1 : Tt(m), m = m & (_.suspendedLanes | c) ? 0 : m, m !== 0 && m !== Z.retryLane))
          throw Z.retryLane = m, Qi(l, m), Ra(_, l, m), J1;
        H.data === "$?" || to(), o = rp(
          l,
          o,
          c
        );
      } else
        H.data === "$?" ? (o.flags |= 192, o.child = l.child, o = null) : (l = Z.treeContext, dn = Ql(
          H.nextSibling
        ), Vn = o, Dt = !0, Fi = null, aa = !1, l !== null && (pa[ol++] = Ol, pa[ol++] = Dl, pa[ol++] = Zi, Ol = l.id, Dl = l.overflow, Zi = o), o = ld(
          o,
          m.children
        ), o.flags |= 4096);
      return o;
    }
    return S ? (Kr(), S = m.fallback, H = o.mode, Z = l.child, fe = Z.sibling, m = _l(Z, {
      mode: "hidden",
      children: m.children
    }), m.subtreeFlags = Z.subtreeFlags & 65011712, fe !== null ? S = _l(fe, S) : (S = Ue(
      S,
      H,
      c,
      null
    ), S.flags |= 2), S.return = o, m.return = o, m.sibling = S, o.child = m, m = S, S = o.child, H = l.child.memoizedState, H === null ? H = ad(c) : (Z = H.cachePool, Z !== null ? (fe = rr._currentValue, Z = Z.parent !== fe ? { parent: fe, pool: fe } : Z) : Z = N0(), H = {
      baseLanes: H.baseLanes | c,
      cachePool: Z
    }), S.memoizedState = H, S.childLanes = np(
      l,
      _,
      c
    ), o.memoizedState = tf, m) : (wa(o), c = l.child, l = c.sibling, c = _l(c, {
      mode: "visible",
      children: m.children
    }), c.return = o, c.sibling = null, l !== null && (_ = o.deletions, _ === null ? (o.deletions = [l], o.flags |= 16) : _.push(l)), o.child = c, o.memoizedState = null, c);
  }
  function ld(l, o) {
    return o = nf(
      { mode: "visible", children: o },
      l.mode
    ), o.return = l, l.child = o;
  }
  function nf(l, o) {
    return l = ma(22, l, null, o), l.lanes = 0, l.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }, l;
  }
  function rp(l, o, c) {
    return Tr(o, l.child, null, c), l = ld(
      o,
      o.pendingProps.children
    ), l.flags |= 2, o.memoizedState = null, l;
  }
  function Wo(l, o, c) {
    l.lanes |= o;
    var m = l.alternate;
    m !== null && (m.lanes |= o), Oh(l.return, o, c);
  }
  function gc(l, o, c, m, S) {
    var w = l.memoizedState;
    w === null ? l.memoizedState = {
      isBackwards: o,
      rendering: null,
      renderingStartTime: 0,
      last: m,
      tail: c,
      tailMode: S
    } : (w.isBackwards = o, w.rendering = null, w.renderingStartTime = 0, w.last = m, w.tail = c, w.tailMode = S);
  }
  function ap(l, o, c) {
    var m = o.pendingProps, S = m.revealOrder, w = m.tail;
    if (Er(l, o, m.children, c), m = Pn.current, m & 2)
      m = m & 1 | 2, o.flags |= 128;
    else {
      if (l !== null && l.flags & 128)
        e: for (l = o.child; l !== null; ) {
          if (l.tag === 13)
            l.memoizedState !== null && Wo(l, c, o);
          else if (l.tag === 19)
            Wo(l, c, o);
          else if (l.child !== null) {
            l.child.return = l, l = l.child;
            continue;
          }
          if (l === o) break e;
          for (; l.sibling === null; ) {
            if (l.return === null || l.return === o)
              break e;
            l = l.return;
          }
          l.sibling.return = l.return, l = l.sibling;
        }
      m &= 1;
    }
    switch (N(Pn, m), S) {
      case "forwards":
        for (c = o.child, S = null; c !== null; )
          l = c.alternate, l !== null && ja(l) === null && (S = c), c = c.sibling;
        c = S, c === null ? (S = o.child, o.child = null) : (S = c.sibling, c.sibling = null), gc(
          o,
          !1,
          S,
          c,
          w
        );
        break;
      case "backwards":
        for (c = null, S = o.child, o.child = null; S !== null; ) {
          if (l = S.alternate, l !== null && ja(l) === null) {
            o.child = S;
            break;
          }
          l = S.sibling, S.sibling = c, c = S, S = l;
        }
        gc(
          o,
          !0,
          c,
          null,
          w
        );
        break;
      case "together":
        gc(o, !1, null, null, void 0);
        break;
      default:
        o.memoizedState = null;
    }
    return o.child;
  }
  function Gl(l, o, c) {
    if (l !== null && (o.dependencies = l.dependencies), Ku |= o.lanes, !(c & o.childLanes))
      if (l !== null) {
        if (_0(
          l,
          o,
          c,
          !1
        ), (c & o.childLanes) === 0)
          return null;
      } else return null;
    if (l !== null && o.child !== l.child)
      throw Error(i(153));
    if (o.child !== null) {
      for (l = o.child, c = _l(l, l.pendingProps), o.child = c, c.return = o; l.sibling !== null; )
        l = l.sibling, c = c.sibling = _l(l, l.pendingProps), c.return = o;
      c.sibling = null;
    }
    return o.child;
  }
  function id(l, o) {
    return l.lanes & o ? !0 : (l = l.dependencies, !!(l !== null && O0(l)));
  }
  function H4(l, o, c) {
    switch (o.tag) {
      case 3:
        rt(o, o.stateNode.containerInfo), oi(o, rr, l.memoizedState.cache), Fs();
        break;
      case 27:
      case 5:
        vt(o);
        break;
      case 4:
        rt(o, o.stateNode.containerInfo);
        break;
      case 10:
        oi(
          o,
          o.type,
          o.memoizedProps.value
        );
        break;
      case 13:
        var m = o.memoizedState;
        if (m !== null)
          return m.dehydrated !== null ? (wa(o), o.flags |= 128, null) : c & o.child.childLanes ? B4(l, o, c) : (wa(o), l = Gl(
            l,
            o,
            c
          ), l !== null ? l.sibling : null);
        wa(o);
        break;
      case 19:
        var S = (l.flags & 128) !== 0;
        if (m = (c & o.childLanes) !== 0, m || (_0(
          l,
          o,
          c,
          !1
        ), m = (c & o.childLanes) !== 0), S) {
          if (m)
            return ap(
              l,
              o,
              c
            );
          o.flags |= 128;
        }
        if (S = o.memoizedState, S !== null && (S.rendering = null, S.tail = null, S.lastEffect = null), N(Pn, Pn.current), m) break;
        return null;
      case 22:
      case 23:
        return o.lanes = 0, Jo(l, o, c);
      case 24:
        oi(o, rr, l.memoizedState.cache);
    }
    return Gl(l, o, c);
  }
  function lp(l, o, c) {
    if (l !== null)
      if (l.memoizedProps !== o.pendingProps)
        Vt = !0;
      else {
        if (!id(l, c) && !(o.flags & 128))
          return Vt = !1, H4(
            l,
            o,
            c
          );
        Vt = !!(l.flags & 131072);
      }
    else
      Vt = !1, Dt && o.flags & 1048576 && sn(o, R0, o.index);
    switch (o.lanes = 0, o.tag) {
      case 16:
        e: {
          l = o.pendingProps;
          var m = o.elementType, S = m._init;
          if (m = S(m._payload), o.type = m, typeof m == "function")
            zh(m) ? (l = hl(m, l), o.tag = 1, o = tp(
              null,
              o,
              m,
              l,
              c
            )) : (o.tag = 0, o = nd(
              null,
              o,
              m,
              l,
              c
            ));
          else {
            if (m != null) {
              if (S = m.$$typeof, S === ce) {
                o.tag = 11, o = W1(
                  null,
                  o,
                  m,
                  l,
                  c
                );
                break e;
              } else if (S === Ce) {
                o.tag = 14, o = L4(
                  null,
                  o,
                  m,
                  l,
                  c
                );
                break e;
              }
            }
            throw o = Te(m) || m, Error(i(306, o, ""));
          }
        }
        return o;
      case 0:
        return nd(
          l,
          o,
          o.type,
          o.pendingProps,
          c
        );
      case 1:
        return m = o.type, S = hl(
          m,
          o.pendingProps
        ), tp(
          l,
          o,
          m,
          S,
          c
        );
      case 3:
        e: {
          if (rt(
            o,
            o.stateNode.containerInfo
          ), l === null) throw Error(i(387));
          m = o.pendingProps;
          var w = o.memoizedState;
          S = w.element, Hh(l, o), lc(o, m, null, c);
          var _ = o.memoizedState;
          if (m = _.cache, oi(o, rr, m), m !== w.cache && Dh(
            o,
            [rr],
            c,
            !0
          ), U0(), m = _.element, w.isDehydrated)
            if (w = {
              element: m,
              isDehydrated: !1,
              cache: _.cache
            }, o.updateQueue.baseState = w, o.memoizedState = w, o.flags & 256) {
              o = rd(
                l,
                o,
                m,
                c
              );
              break e;
            } else if (m !== S) {
              S = Ua(
                Error(i(424)),
                o
              ), Ps(S), o = rd(
                l,
                o,
                m,
                c
              );
              break e;
            } else {
              switch (l = o.stateNode.containerInfo, l.nodeType) {
                case 9:
                  l = l.body;
                  break;
                default:
                  l = l.nodeName === "HTML" ? l.ownerDocument.body : l;
              }
              for (dn = Ql(l.firstChild), Vn = o, Dt = !0, Fi = null, aa = !0, c = $1(
                o,
                null,
                m,
                c
              ), o.child = c; c; )
                c.flags = c.flags & -3 | 4096, c = c.sibling;
            }
          else {
            if (Fs(), m === S) {
              o = Gl(
                l,
                o,
                c
              );
              break e;
            }
            Er(
              l,
              o,
              m,
              c
            );
          }
          o = o.child;
        }
        return o;
      case 26:
        return ru(l, o), l === null ? (c = Nd(
          o.type,
          null,
          o.pendingProps,
          null
        )) ? o.memoizedState = c : Dt || (c = o.type, l = o.pendingProps, m = _c(
          Se.current
        ).createElement(c), m[bn] = o, m[Zr] = l, ye(m, c, l), Fn(m), o.stateNode = m) : o.memoizedState = Nd(
          o.type,
          l.memoizedProps,
          o.pendingProps,
          l.memoizedState
        ), null;
      case 27:
        return vt(o), l === null && Dt && (m = o.stateNode = jr(
          o.type,
          o.pendingProps,
          Se.current
        ), Vn = o, aa = !0, S = dn, qr(o.type) ? (Np = S, dn = Ql(
          m.firstChild
        )) : dn = S), Er(
          l,
          o,
          o.pendingProps.children,
          c
        ), ru(l, o), l === null && (o.flags |= 4194304), o.child;
      case 5:
        return l === null && Dt && ((S = m = dn) && (m = _p(
          m,
          o.type,
          o.pendingProps,
          aa
        ), m !== null ? (o.stateNode = m, Vn = o, dn = Ql(
          m.firstChild
        ), aa = !1, S = !0) : S = !1), S || Nl(o)), vt(o), S = o.type, w = o.pendingProps, _ = l !== null ? l.memoizedProps : null, m = w.children, is(S, w) ? m = null : _ !== null && is(S, _) && (o.flags |= 32), o.memoizedState !== null && (S = jh(
          l,
          o,
          A4,
          null,
          null,
          c
        ), Gr._currentValue = S), ru(l, o), Er(l, o, m, c), o.child;
      case 6:
        return l === null && Dt && ((l = c = dn) && (c = Oc(
          c,
          o.pendingProps,
          aa
        ), c !== null ? (o.stateNode = c, Vn = o, dn = null, l = !0) : l = !1), l || Nl(o)), null;
      case 13:
        return B4(l, o, c);
      case 4:
        return rt(
          o,
          o.stateNode.containerInfo
        ), m = o.pendingProps, l === null ? o.child = Tr(
          o,
          null,
          m,
          c
        ) : Er(
          l,
          o,
          m,
          c
        ), o.child;
      case 11:
        return W1(
          l,
          o,
          o.type,
          o.pendingProps,
          c
        );
      case 7:
        return Er(
          l,
          o,
          o.pendingProps,
          c
        ), o.child;
      case 8:
        return Er(
          l,
          o,
          o.pendingProps.children,
          c
        ), o.child;
      case 12:
        return Er(
          l,
          o,
          o.pendingProps.children,
          c
        ), o.child;
      case 10:
        return m = o.pendingProps, oi(o, o.type, m.value), Er(
          l,
          o,
          m.children,
          c
        ), o.child;
      case 9:
        return S = o.type._context, m = o.pendingProps.children, qu(o), S = Hr(S), m = m(S), o.flags |= 1, Er(l, o, m, c), o.child;
      case 14:
        return L4(
          l,
          o,
          o.type,
          o.pendingProps,
          c
        );
      case 15:
        return nu(
          l,
          o,
          o.type,
          o.pendingProps,
          c
        );
      case 19:
        return ap(l, o, c);
      case 31:
        return m = o.pendingProps, c = o.mode, m = {
          mode: m.mode,
          children: m.children
        }, l === null ? (c = nf(
          m,
          c
        ), c.ref = o.ref, o.child = c, c.return = o, o = c) : (c = _l(l.child, m), c.ref = o.ref, o.child = c, c.return = o, o = c), o;
      case 22:
        return Jo(l, o, c);
      case 24:
        return qu(o), m = Hr(rr), l === null ? (S = ec(), S === null && (S = pn, w = y1(), S.pooledCache = w, w.refCount++, w !== null && (S.pooledCacheLanes |= c), S = w), o.memoizedState = {
          parent: m,
          cache: S
        }, B0(o), oi(o, rr, S)) : (l.lanes & c && (Hh(l, o), lc(o, null, null, c), U0()), S = l.memoizedState, w = o.memoizedState, S.parent !== m ? (S = { parent: m, cache: m }, o.memoizedState = S, o.lanes === 0 && (o.memoizedState = o.updateQueue.baseState = S), oi(o, rr, m)) : (m = w.cache, oi(o, rr, m), m !== S.cache && Dh(
          o,
          [rr],
          c,
          !0
        ))), Er(
          l,
          o,
          o.pendingProps.children,
          c
        ), o.child;
      case 29:
        throw o.pendingProps;
    }
    throw Error(i(156, o.tag));
  }
  function au(l) {
    l.flags |= 4;
  }
  function ip(l, o) {
    if (o.type !== "stylesheet" || o.state.loading & 4)
      l.flags &= -16777217;
    else if (l.flags |= 16777216, !Up(o)) {
      if (o = ar.current, o !== null && ((Wt & 4194048) === Wt ? ql !== null : (Wt & 62914560) !== Wt && !(Wt & 536870912) || o !== ql))
        throw ac = Lh, L0;
      l.flags |= 8192;
    }
  }
  function $u(l, o) {
    o !== null && (l.flags |= 4), l.flags & 16384 && (o = l.tag !== 22 ? Ie() : 536870912, l.lanes |= o, wc |= o);
  }
  function yc(l, o) {
    if (!Dt)
      switch (l.tailMode) {
        case "hidden":
          o = l.tail;
          for (var c = null; o !== null; )
            o.alternate !== null && (c = o), o = o.sibling;
          c === null ? l.tail = null : c.sibling = null;
          break;
        case "collapsed":
          c = l.tail;
          for (var m = null; c !== null; )
            c.alternate !== null && (m = c), c = c.sibling;
          m === null ? o || l.tail === null ? l.tail = null : l.tail.sibling = null : m.sibling = null;
      }
  }
  function On(l) {
    var o = l.alternate !== null && l.alternate.child === l.child, c = 0, m = 0;
    if (o)
      for (var S = l.child; S !== null; )
        c |= S.lanes | S.childLanes, m |= S.subtreeFlags & 65011712, m |= S.flags & 65011712, S.return = l, S = S.sibling;
    else
      for (S = l.child; S !== null; )
        c |= S.lanes | S.childLanes, m |= S.subtreeFlags, m |= S.flags, S.return = l, S = S.sibling;
    return l.subtreeFlags |= m, l.childLanes = c, o;
  }
  function mn(l, o, c) {
    var m = o.pendingProps;
    switch (Vo(o), o.tag) {
      case 31:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return On(o), null;
      case 1:
        return On(o), null;
      case 3:
        return c = o.stateNode, m = null, l !== null && (m = l.memoizedState.cache), o.memoizedState.cache !== m && (o.flags |= 2048), si(rr), ht(), c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), (l === null || l.child === null) && (Zs(o) ? au(o) : l === null || l.memoizedState.isDehydrated && !(o.flags & 256) || (o.flags |= 1024, p1())), On(o), null;
      case 26:
        return c = o.memoizedState, l === null ? (au(o), c !== null ? (On(o), ip(o, c)) : (On(o), o.flags &= -16777217)) : c ? c !== l.memoizedState ? (au(o), On(o), ip(o, c)) : (On(o), o.flags &= -16777217) : (l.memoizedProps !== m && au(o), On(o), o.flags &= -16777217), null;
      case 27:
        St(o), c = Se.current;
        var S = o.type;
        if (l !== null && o.stateNode != null)
          l.memoizedProps !== m && au(o);
        else {
          if (!m) {
            if (o.stateNode === null)
              throw Error(i(166));
            return On(o), null;
          }
          l = Me.current, Zs(o) ? Mh(o) : (l = jr(S, m, c), o.stateNode = l, au(o));
        }
        return On(o), null;
      case 5:
        if (St(o), c = o.type, l !== null && o.stateNode != null)
          l.memoizedProps !== m && au(o);
        else {
          if (!m) {
            if (o.stateNode === null)
              throw Error(i(166));
            return On(o), null;
          }
          if (l = Me.current, Zs(o))
            Mh(o);
          else {
            switch (S = _c(
              Se.current
            ), l) {
              case 1:
                l = S.createElementNS(
                  "http://www.w3.org/2000/svg",
                  c
                );
                break;
              case 2:
                l = S.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  c
                );
                break;
              default:
                switch (c) {
                  case "svg":
                    l = S.createElementNS(
                      "http://www.w3.org/2000/svg",
                      c
                    );
                    break;
                  case "math":
                    l = S.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      c
                    );
                    break;
                  case "script":
                    l = S.createElement("div"), l.innerHTML = "<script><\/script>", l = l.removeChild(l.firstChild);
                    break;
                  case "select":
                    l = typeof m.is == "string" ? S.createElement("select", { is: m.is }) : S.createElement("select"), m.multiple ? l.multiple = !0 : m.size && (l.size = m.size);
                    break;
                  default:
                    l = typeof m.is == "string" ? S.createElement(c, { is: m.is }) : S.createElement(c);
                }
            }
            l[bn] = o, l[Zr] = m;
            e: for (S = o.child; S !== null; ) {
              if (S.tag === 5 || S.tag === 6)
                l.appendChild(S.stateNode);
              else if (S.tag !== 4 && S.tag !== 27 && S.child !== null) {
                S.child.return = S, S = S.child;
                continue;
              }
              if (S === o) break e;
              for (; S.sibling === null; ) {
                if (S.return === null || S.return === o)
                  break e;
                S = S.return;
              }
              S.sibling.return = S.return, S = S.sibling;
            }
            o.stateNode = l;
            e: switch (ye(l, c, m), c) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                l = !!m.autoFocus;
                break e;
              case "img":
                l = !0;
                break e;
              default:
                l = !1;
            }
            l && au(o);
          }
        }
        return On(o), o.flags &= -16777217, null;
      case 6:
        if (l && o.stateNode != null)
          l.memoizedProps !== m && au(o);
        else {
          if (typeof m != "string" && o.stateNode === null)
            throw Error(i(166));
          if (l = Se.current, Zs(o)) {
            if (l = o.stateNode, c = o.memoizedProps, m = null, S = Vn, S !== null)
              switch (S.tag) {
                case 27:
                case 5:
                  m = S.memoizedProps;
              }
            l[bn] = o, l = !!(l.nodeValue === c || m !== null && m.suppressHydrationWarning === !0 || ry(l.nodeValue, c)), l || Nl(o);
          } else
            l = _c(l).createTextNode(
              m
            ), l[bn] = o, o.stateNode = l;
        }
        return On(o), null;
      case 13:
        if (m = o.memoizedState, l === null || l.memoizedState !== null && l.memoizedState.dehydrated !== null) {
          if (S = Zs(o), m !== null && m.dehydrated !== null) {
            if (l === null) {
              if (!S) throw Error(i(318));
              if (S = o.memoizedState, S = S !== null ? S.dehydrated : null, !S) throw Error(i(317));
              S[bn] = o;
            } else
              Fs(), !(o.flags & 128) && (o.memoizedState = null), o.flags |= 4;
            On(o), S = !1;
          } else
            S = p1(), l !== null && l.memoizedState !== null && (l.memoizedState.hydrationErrors = S), S = !0;
          if (!S)
            return o.flags & 256 ? (jl(o), o) : (jl(o), null);
        }
        if (jl(o), o.flags & 128)
          return o.lanes = c, o;
        if (c = m !== null, l = l !== null && l.memoizedState !== null, c) {
          m = o.child, S = null, m.alternate !== null && m.alternate.memoizedState !== null && m.alternate.memoizedState.cachePool !== null && (S = m.alternate.memoizedState.cachePool.pool);
          var w = null;
          m.memoizedState !== null && m.memoizedState.cachePool !== null && (w = m.memoizedState.cachePool.pool), w !== S && (m.flags |= 2048);
        }
        return c !== l && c && (o.child.flags |= 8192), $u(o, o.updateQueue), On(o), null;
      case 4:
        return ht(), l === null && df(o.stateNode.containerInfo), On(o), null;
      case 10:
        return si(o.type), On(o), null;
      case 19:
        if (ie(Pn), S = o.memoizedState, S === null) return On(o), null;
        if (m = (o.flags & 128) !== 0, w = S.rendering, w === null)
          if (m) yc(S, !1);
          else {
            if ($n !== 0 || l !== null && l.flags & 128)
              for (l = o.child; l !== null; ) {
                if (w = ja(l), w !== null) {
                  for (o.flags |= 128, yc(S, !1), l = w.updateQueue, o.updateQueue = l, $u(o, l), o.subtreeFlags = 0, l = c, c = o.child; c !== null; )
                    Ch(c, l), c = c.sibling;
                  return N(
                    Pn,
                    Pn.current & 1 | 2
                  ), o.child;
                }
                l = l.sibling;
              }
            S.tail !== null && Bt() > fd && (o.flags |= 128, m = !0, yc(S, !1), o.lanes = 4194304);
          }
        else {
          if (!m)
            if (l = ja(w), l !== null) {
              if (o.flags |= 128, m = !0, l = l.updateQueue, o.updateQueue = l, $u(o, l), yc(S, !0), S.tail === null && S.tailMode === "hidden" && !w.alternate && !Dt)
                return On(o), null;
            } else
              2 * Bt() - S.renderingStartTime > fd && c !== 536870912 && (o.flags |= 128, m = !0, yc(S, !1), o.lanes = 4194304);
          S.isBackwards ? (w.sibling = o.child, o.child = w) : (l = S.last, l !== null ? l.sibling = w : o.child = w, S.last = w);
        }
        return S.tail !== null ? (o = S.tail, S.rendering = o, S.tail = o.sibling, S.renderingStartTime = Bt(), o.sibling = null, l = Pn.current, N(Pn, m ? l & 1 | 2 : l & 1), o) : (On(o), null);
      case 22:
      case 23:
        return jl(o), uc(), m = o.memoizedState !== null, l !== null ? l.memoizedState !== null !== m && (o.flags |= 8192) : m && (o.flags |= 8192), m ? c & 536870912 && !(o.flags & 128) && (On(o), o.subtreeFlags & 6 && (o.flags |= 8192)) : On(o), c = o.updateQueue, c !== null && $u(o, c.retryQueue), c = null, l !== null && l.memoizedState !== null && l.memoizedState.cachePool !== null && (c = l.memoizedState.cachePool.pool), m = null, o.memoizedState !== null && o.memoizedState.cachePool !== null && (m = o.memoizedState.cachePool.pool), m !== c && (o.flags |= 2048), l !== null && ie(Ki), null;
      case 24:
        return c = null, l !== null && (c = l.memoizedState.cache), o.memoizedState.cache !== c && (o.flags |= 2048), si(rr), On(o), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(i(156, o.tag));
  }
  function up(l, o) {
    switch (Vo(o), o.tag) {
      case 1:
        return l = o.flags, l & 65536 ? (o.flags = l & -65537 | 128, o) : null;
      case 3:
        return si(rr), ht(), l = o.flags, l & 65536 && !(l & 128) ? (o.flags = l & -65537 | 128, o) : null;
      case 26:
      case 27:
      case 5:
        return St(o), null;
      case 13:
        if (jl(o), l = o.memoizedState, l !== null && l.dehydrated !== null) {
          if (o.alternate === null)
            throw Error(i(340));
          Fs();
        }
        return l = o.flags, l & 65536 ? (o.flags = l & -65537 | 128, o) : null;
      case 19:
        return ie(Pn), null;
      case 4:
        return ht(), null;
      case 10:
        return si(o.type), null;
      case 22:
      case 23:
        return jl(o), uc(), l !== null && ie(Ki), l = o.flags, l & 65536 ? (o.flags = l & -65537 | 128, o) : null;
      case 24:
        return si(rr), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function U4(l, o) {
    switch (Vo(o), o.tag) {
      case 3:
        si(rr), ht();
        break;
      case 26:
      case 27:
      case 5:
        St(o);
        break;
      case 4:
        ht();
        break;
      case 13:
        jl(o);
        break;
      case 19:
        ie(Pn);
        break;
      case 10:
        si(o.type);
        break;
      case 22:
      case 23:
        jl(o), uc(), l !== null && ie(Ki);
        break;
      case 24:
        si(rr);
    }
  }
  function vc(l, o) {
    try {
      var c = o.updateQueue, m = c !== null ? c.lastEffect : null;
      if (m !== null) {
        var S = m.next;
        c = S;
        do {
          if ((c.tag & l) === l) {
            m = void 0;
            var w = c.create, _ = c.inst;
            m = w(), _.destroy = m;
          }
          c = c.next;
        } while (c !== S);
      }
    } catch (H) {
      gn(o, o.return, H);
    }
  }
  function Xu(l, o, c) {
    try {
      var m = o.updateQueue, S = m !== null ? m.lastEffect : null;
      if (S !== null) {
        var w = S.next;
        m = w;
        do {
          if ((m.tag & l) === l) {
            var _ = m.inst, H = _.destroy;
            if (H !== void 0) {
              _.destroy = void 0, S = o;
              var Z = c, fe = H;
              try {
                fe();
              } catch (Oe) {
                gn(
                  S,
                  Z,
                  Oe
                );
              }
            }
          }
          m = m.next;
        } while (m !== w);
      }
    } catch (Oe) {
      gn(o, o.return, Oe);
    }
  }
  function q4(l) {
    var o = l.updateQueue;
    if (o !== null) {
      var c = l.stateNode;
      try {
        Uh(o, c);
      } catch (m) {
        gn(l, l.return, m);
      }
    }
  }
  function ud(l, o, c) {
    c.props = hl(
      l.type,
      l.memoizedProps
    ), c.state = l.memoizedState;
    try {
      c.componentWillUnmount();
    } catch (m) {
      gn(l, o, m);
    }
  }
  function bc(l, o) {
    try {
      var c = l.ref;
      if (c !== null) {
        switch (l.tag) {
          case 26:
          case 27:
          case 5:
            var m = l.stateNode;
            break;
          case 30:
            m = l.stateNode;
            break;
          default:
            m = l.stateNode;
        }
        typeof c == "function" ? l.refCleanup = c(m) : c.current = m;
      }
    } catch (S) {
      gn(l, o, S);
    }
  }
  function Vl(l, o) {
    var c = l.ref, m = l.refCleanup;
    if (c !== null)
      if (typeof m == "function")
        try {
          m();
        } catch (S) {
          gn(l, o, S);
        } finally {
          l.refCleanup = null, l = l.alternate, l != null && (l.refCleanup = null);
        }
      else if (typeof c == "function")
        try {
          c(null);
        } catch (S) {
          gn(l, o, S);
        }
      else c.current = null;
  }
  function op(l) {
    var o = l.type, c = l.memoizedProps, m = l.stateNode;
    try {
      e: switch (o) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          c.autoFocus && m.focus();
          break e;
        case "img":
          c.src ? m.src = c.src : c.srcSet && (m.srcset = c.srcSet);
      }
    } catch (S) {
      gn(l, l.return, S);
    }
  }
  function es(l, o, c) {
    try {
      var m = l.stateNode;
      ln(m, l.type, c, o), m[Zr] = o;
    } catch (S) {
      gn(l, l.return, S);
    }
  }
  function j4(l) {
    return l.tag === 5 || l.tag === 3 || l.tag === 26 || l.tag === 27 && qr(l.type) || l.tag === 4;
  }
  function sp(l) {
    e: for (; ; ) {
      for (; l.sibling === null; ) {
        if (l.return === null || j4(l.return)) return null;
        l = l.return;
      }
      for (l.sibling.return = l.return, l = l.sibling; l.tag !== 5 && l.tag !== 6 && l.tag !== 18; ) {
        if (l.tag === 27 && qr(l.type) || l.flags & 2 || l.child === null || l.tag === 4) continue e;
        l.child.return = l, l = l.child;
      }
      if (!(l.flags & 2)) return l.stateNode;
    }
  }
  function dl(l, o, c) {
    var m = l.tag;
    if (m === 5 || m === 6)
      l = l.stateNode, o ? (c.nodeType === 9 ? c.body : c.nodeName === "HTML" ? c.ownerDocument.body : c).insertBefore(l, o) : (o = c.nodeType === 9 ? c.body : c.nodeName === "HTML" ? c.ownerDocument.body : c, o.appendChild(l), c = c._reactRootContainer, c != null || o.onclick !== null || (o.onclick = pf));
    else if (m !== 4 && (m === 27 && qr(l.type) && (c = l.stateNode, o = null), l = l.child, l !== null))
      for (dl(l, o, c), l = l.sibling; l !== null; )
        dl(l, o, c), l = l.sibling;
  }
  function Qu(l, o, c) {
    var m = l.tag;
    if (m === 5 || m === 6)
      l = l.stateNode, o ? c.insertBefore(l, o) : c.appendChild(l);
    else if (m !== 4 && (m === 27 && qr(l.type) && (c = l.stateNode), l = l.child, l !== null))
      for (Qu(l, o, c), l = l.sibling; l !== null; )
        Qu(l, o, c), l = l.sibling;
  }
  function G4(l) {
    var o = l.stateNode, c = l.memoizedProps;
    try {
      for (var m = l.type, S = o.attributes; S.length; )
        o.removeAttributeNode(S[0]);
      ye(o, m, c), o[bn] = l, o[Zr] = c;
    } catch (w) {
      gn(l, l.return, w);
    }
  }
  var Yl = !1, In = !1, od = !1, cp = typeof WeakSet == "function" ? WeakSet : Set, lr = null;
  function V4(l, o) {
    if (l = l.containerInfo, Cp = Tf, l = E0(l), Eh(l)) {
      if ("selectionStart" in l)
        var c = {
          start: l.selectionStart,
          end: l.selectionEnd
        };
      else
        e: {
          c = (c = l.ownerDocument) && c.defaultView || window;
          var m = c.getSelection && c.getSelection();
          if (m && m.rangeCount !== 0) {
            c = m.anchorNode;
            var S = m.anchorOffset, w = m.focusNode;
            m = m.focusOffset;
            try {
              c.nodeType, w.nodeType;
            } catch {
              c = null;
              break e;
            }
            var _ = 0, H = -1, Z = -1, fe = 0, Oe = 0, Be = l, me = null;
            t: for (; ; ) {
              for (var we; Be !== c || S !== 0 && Be.nodeType !== 3 || (H = _ + S), Be !== w || m !== 0 && Be.nodeType !== 3 || (Z = _ + m), Be.nodeType === 3 && (_ += Be.nodeValue.length), (we = Be.firstChild) !== null; )
                me = Be, Be = we;
              for (; ; ) {
                if (Be === l) break t;
                if (me === c && ++fe === S && (H = _), me === w && ++Oe === m && (Z = _), (we = Be.nextSibling) !== null) break;
                Be = me, me = Be.parentNode;
              }
              Be = we;
            }
            c = H === -1 || Z === -1 ? null : { start: H, end: Z };
          } else c = null;
        }
      c = c || { start: 0, end: 0 };
    } else c = null;
    for (gf = { focusedElem: l, selectionRange: c }, Tf = !1, lr = o; lr !== null; )
      if (o = lr, l = o.child, (o.subtreeFlags & 1024) !== 0 && l !== null)
        l.return = o, lr = l;
      else
        for (; lr !== null; ) {
          switch (o = lr, w = o.alternate, l = o.flags, o.tag) {
            case 0:
              break;
            case 11:
            case 15:
              break;
            case 1:
              if (l & 1024 && w !== null) {
                l = void 0, c = o, S = w.memoizedProps, w = w.memoizedState, m = c.stateNode;
                try {
                  var mt = hl(
                    c.type,
                    S,
                    c.elementType === c.type
                  );
                  l = m.getSnapshotBeforeUpdate(
                    mt,
                    w
                  ), m.__reactInternalSnapshotBeforeUpdate = l;
                } catch (ct) {
                  gn(
                    c,
                    c.return,
                    ct
                  );
                }
              }
              break;
            case 3:
              if (l & 1024) {
                if (l = o.stateNode.containerInfo, c = l.nodeType, c === 9)
                  yf(l);
                else if (c === 1)
                  switch (l.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      yf(l);
                      break;
                    default:
                      l.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if (l & 1024) throw Error(i(163));
          }
          if (l = o.sibling, l !== null) {
            l.return = o.return, lr = l;
            break;
          }
          lr = o.return;
        }
  }
  function sd(l, o, c) {
    var m = c.flags;
    switch (c.tag) {
      case 0:
      case 11:
      case 15:
        lu(l, c), m & 4 && vc(5, c);
        break;
      case 1:
        if (lu(l, c), m & 4)
          if (l = c.stateNode, o === null)
            try {
              l.componentDidMount();
            } catch (_) {
              gn(c, c.return, _);
            }
          else {
            var S = hl(
              c.type,
              o.memoizedProps
            );
            o = o.memoizedState;
            try {
              l.componentDidUpdate(
                S,
                o,
                l.__reactInternalSnapshotBeforeUpdate
              );
            } catch (_) {
              gn(
                c,
                c.return,
                _
              );
            }
          }
        m & 64 && q4(c), m & 512 && bc(c, c.return);
        break;
      case 3:
        if (lu(l, c), m & 64 && (l = c.updateQueue, l !== null)) {
          if (o = null, c.child !== null)
            switch (c.child.tag) {
              case 27:
              case 5:
                o = c.child.stateNode;
                break;
              case 1:
                o = c.child.stateNode;
            }
          try {
            Uh(l, o);
          } catch (_) {
            gn(c, c.return, _);
          }
        }
        break;
      case 27:
        o === null && m & 4 && G4(c);
      case 26:
      case 5:
        lu(l, c), o === null && m & 4 && op(c), m & 512 && bc(c, c.return);
        break;
      case 12:
        lu(l, c);
        break;
      case 13:
        lu(l, c), m & 4 && Yt(l, c), m & 64 && (l = c.memoizedState, l !== null && (l = l.dehydrated, l !== null && (c = ey.bind(
          null,
          c
        ), Dp(l, c))));
        break;
      case 22:
        if (m = c.memoizedState !== null || Yl, !m) {
          o = o !== null && o.memoizedState !== null || In, S = Yl;
          var w = In;
          Yl = m, (In = o) && !w ? Rn(
            l,
            c,
            (c.subtreeFlags & 8772) !== 0
          ) : lu(l, c), Yl = S, In = w;
        }
        break;
      case 30:
        break;
      default:
        lu(l, c);
    }
  }
  function fp(l) {
    var o = l.alternate;
    o !== null && (l.alternate = null, fp(o)), l.child = null, l.deletions = null, l.sibling = null, l.tag === 5 && (o = l.stateNode, o !== null && at(o)), l.stateNode = null, l.return = null, l.dependencies = null, l.memoizedProps = null, l.memoizedState = null, l.pendingProps = null, l.stateNode = null, l.updateQueue = null;
  }
  var kn = null, Ta = !1;
  function ml(l, o, c) {
    for (c = c.child; c !== null; )
      hp(l, o, c), c = c.sibling;
  }
  function hp(l, o, c) {
    if (je && typeof je.onCommitFiberUnmount == "function")
      try {
        je.onCommitFiberUnmount(ke, c);
      } catch {
      }
    switch (c.tag) {
      case 26:
        In || Vl(c, o), ml(
          l,
          o,
          c
        ), c.memoizedState ? c.memoizedState.count-- : c.stateNode && (c = c.stateNode, c.parentNode.removeChild(c));
        break;
      case 27:
        In || Vl(c, o);
        var m = kn, S = Ta;
        qr(c.type) && (kn = c.stateNode, Ta = !1), ml(
          l,
          o,
          c
        ), Pe(c.stateNode), kn = m, Ta = S;
        break;
      case 5:
        In || Vl(c, o);
      case 6:
        if (m = kn, S = Ta, kn = null, ml(
          l,
          o,
          c
        ), kn = m, Ta = S, kn !== null)
          if (Ta)
            try {
              (kn.nodeType === 9 ? kn.body : kn.nodeName === "HTML" ? kn.ownerDocument.body : kn).removeChild(c.stateNode);
            } catch (w) {
              gn(
                c,
                o,
                w
              );
            }
          else
            try {
              kn.removeChild(c.stateNode);
            } catch (w) {
              gn(
                c,
                o,
                w
              );
            }
        break;
      case 18:
        kn !== null && (Ta ? (l = kn, ly(
          l.nodeType === 9 ? l.body : l.nodeName === "HTML" ? l.ownerDocument.body : l,
          c.stateNode
        ), Uc(l)) : ly(kn, c.stateNode));
        break;
      case 4:
        m = kn, S = Ta, kn = c.stateNode.containerInfo, Ta = !0, ml(
          l,
          o,
          c
        ), kn = m, Ta = S;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        In || Xu(2, c, o), In || Xu(4, c, o), ml(
          l,
          o,
          c
        );
        break;
      case 1:
        In || (Vl(c, o), m = c.stateNode, typeof m.componentWillUnmount == "function" && ud(
          c,
          o,
          m
        )), ml(
          l,
          o,
          c
        );
        break;
      case 21:
        ml(
          l,
          o,
          c
        );
        break;
      case 22:
        In = (m = In) || c.memoizedState !== null, ml(
          l,
          o,
          c
        ), In = m;
        break;
      default:
        ml(
          l,
          o,
          c
        );
    }
  }
  function Yt(l, o) {
    if (o.memoizedState === null && (l = o.alternate, l !== null && (l = l.memoizedState, l !== null && (l = l.dehydrated, l !== null))))
      try {
        Uc(l);
      } catch (c) {
        gn(o, o.return, c);
      }
  }
  function dp(l) {
    switch (l.tag) {
      case 13:
      case 19:
        var o = l.stateNode;
        return o === null && (o = l.stateNode = new cp()), o;
      case 22:
        return l = l.stateNode, o = l._retryCache, o === null && (o = l._retryCache = new cp()), o;
      default:
        throw Error(i(435, l.tag));
    }
  }
  function rf(l, o) {
    var c = dp(l);
    o.forEach(function(m) {
      var S = g3.bind(null, l, m);
      c.has(m) || (c.add(m), m.then(S, S));
    });
  }
  function Ea(l, o) {
    var c = o.deletions;
    if (c !== null)
      for (var m = 0; m < c.length; m++) {
        var S = c[m], w = l, _ = o, H = _;
        e: for (; H !== null; ) {
          switch (H.tag) {
            case 27:
              if (qr(H.type)) {
                kn = H.stateNode, Ta = !1;
                break e;
              }
              break;
            case 5:
              kn = H.stateNode, Ta = !1;
              break e;
            case 3:
            case 4:
              kn = H.stateNode.containerInfo, Ta = !0;
              break e;
          }
          H = H.return;
        }
        if (kn === null) throw Error(i(160));
        hp(w, _, S), kn = null, Ta = !1, w = S.alternate, w !== null && (w.return = null), S.return = null;
      }
    if (o.subtreeFlags & 13878)
      for (o = o.child; o !== null; )
        Sc(o, l), o = o.sibling;
  }
  var Va = null;
  function Sc(l, o) {
    var c = l.alternate, m = l.flags;
    switch (l.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        Ea(o, l), Jr(l), m & 4 && (Xu(3, l, l.return), vc(3, l), Xu(5, l, l.return));
        break;
      case 1:
        Ea(o, l), Jr(l), m & 512 && (In || c === null || Vl(c, c.return)), m & 64 && Yl && (l = l.updateQueue, l !== null && (m = l.callbacks, m !== null && (c = l.shared.hiddenCallbacks, l.shared.hiddenCallbacks = c === null ? m : c.concat(m))));
        break;
      case 26:
        var S = Va;
        if (Ea(o, l), Jr(l), m & 512 && (In || c === null || Vl(c, c.return)), m & 4) {
          var w = c !== null ? c.memoizedState : null;
          if (m = l.memoizedState, c === null)
            if (m === null)
              if (l.stateNode === null) {
                e: {
                  m = l.type, c = l.memoizedProps, S = S.ownerDocument || S;
                  t: switch (m) {
                    case "title":
                      w = S.getElementsByTagName("title")[0], (!w || w[c0] || w[bn] || w.namespaceURI === "http://www.w3.org/2000/svg" || w.hasAttribute("itemprop")) && (w = S.createElement(m), S.head.insertBefore(
                        w,
                        S.querySelector("head > title")
                      )), ye(w, m, c), w[bn] = l, Fn(w), m = w;
                      break e;
                    case "link":
                      var _ = Nc(
                        "link",
                        "href",
                        S
                      ).get(m + (c.href || ""));
                      if (_) {
                        for (var H = 0; H < _.length; H++)
                          if (w = _[H], w.getAttribute("href") === (c.href == null || c.href === "" ? null : c.href) && w.getAttribute("rel") === (c.rel == null ? null : c.rel) && w.getAttribute("title") === (c.title == null ? null : c.title) && w.getAttribute("crossorigin") === (c.crossOrigin == null ? null : c.crossOrigin)) {
                            _.splice(H, 1);
                            break t;
                          }
                      }
                      w = S.createElement(m), ye(w, m, c), S.head.appendChild(w);
                      break;
                    case "meta":
                      if (_ = Nc(
                        "meta",
                        "content",
                        S
                      ).get(m + (c.content || ""))) {
                        for (H = 0; H < _.length; H++)
                          if (w = _[H], w.getAttribute("content") === (c.content == null ? null : "" + c.content) && w.getAttribute("name") === (c.name == null ? null : c.name) && w.getAttribute("property") === (c.property == null ? null : c.property) && w.getAttribute("http-equiv") === (c.httpEquiv == null ? null : c.httpEquiv) && w.getAttribute("charset") === (c.charSet == null ? null : c.charSet)) {
                            _.splice(H, 1);
                            break t;
                          }
                      }
                      w = S.createElement(m), ye(w, m, c), S.head.appendChild(w);
                      break;
                    default:
                      throw Error(i(468, m));
                  }
                  w[bn] = l, Fn(w), m = w;
                }
                l.stateNode = m;
              } else
                Hp(
                  S,
                  l.type,
                  l.stateNode
                );
            else
              l.stateNode = Ld(
                S,
                m,
                l.memoizedProps
              );
          else
            w !== m ? (w === null ? c.stateNode !== null && (c = c.stateNode, c.parentNode.removeChild(c)) : w.count--, m === null ? Hp(
              S,
              l.type,
              l.stateNode
            ) : Ld(
              S,
              m,
              l.memoizedProps
            )) : m === null && l.stateNode !== null && es(
              l,
              l.memoizedProps,
              c.memoizedProps
            );
        }
        break;
      case 27:
        Ea(o, l), Jr(l), m & 512 && (In || c === null || Vl(c, c.return)), c !== null && m & 4 && es(
          l,
          l.memoizedProps,
          c.memoizedProps
        );
        break;
      case 5:
        if (Ea(o, l), Jr(l), m & 512 && (In || c === null || Vl(c, c.return)), l.flags & 32) {
          S = l.stateNode;
          try {
            Ro(S, "");
          } catch (we) {
            gn(l, l.return, we);
          }
        }
        m & 4 && l.stateNode != null && (S = l.memoizedProps, es(
          l,
          S,
          c !== null ? c.memoizedProps : S
        )), m & 1024 && (od = !0);
        break;
      case 6:
        if (Ea(o, l), Jr(l), m & 4) {
          if (l.stateNode === null)
            throw Error(i(162));
          m = l.memoizedProps, c = l.stateNode;
          try {
            c.nodeValue = m;
          } catch (we) {
            gn(l, l.return, we);
          }
        }
        break;
      case 3:
        if (Sf = null, S = Va, Va = kr(o.containerInfo), Ea(o, l), Va = S, Jr(l), m & 4 && c !== null && c.memoizedState.isDehydrated)
          try {
            Uc(o.containerInfo);
          } catch (we) {
            gn(l, l.return, we);
          }
        od && (od = !1, ts(l));
        break;
      case 4:
        m = Va, Va = kr(
          l.stateNode.containerInfo
        ), Ea(o, l), Jr(l), Va = m;
        break;
      case 12:
        Ea(o, l), Jr(l);
        break;
      case 13:
        Ea(o, l), Jr(l), l.child.flags & 8192 && l.memoizedState !== null != (c !== null && c.memoizedState !== null) && (bp = Bt()), m & 4 && (m = l.updateQueue, m !== null && (l.updateQueue = null, rf(l, m)));
        break;
      case 22:
        S = l.memoizedState !== null;
        var Z = c !== null && c.memoizedState !== null, fe = Yl, Oe = In;
        if (Yl = fe || S, In = Oe || Z, Ea(o, l), In = Oe, Yl = fe, Jr(l), m & 8192)
          e: for (o = l.stateNode, o._visibility = S ? o._visibility & -2 : o._visibility | 1, S && (c === null || Z || Yl || In || iu(l)), c = null, o = l; ; ) {
            if (o.tag === 5 || o.tag === 26) {
              if (c === null) {
                Z = c = o;
                try {
                  if (w = Z.stateNode, S)
                    _ = w.style, typeof _.setProperty == "function" ? _.setProperty("display", "none", "important") : _.display = "none";
                  else {
                    H = Z.stateNode;
                    var Be = Z.memoizedProps.style, me = Be != null && Be.hasOwnProperty("display") ? Be.display : null;
                    H.style.display = me == null || typeof me == "boolean" ? "" : ("" + me).trim();
                  }
                } catch (we) {
                  gn(Z, Z.return, we);
                }
              }
            } else if (o.tag === 6) {
              if (c === null) {
                Z = o;
                try {
                  Z.stateNode.nodeValue = S ? "" : Z.memoizedProps;
                } catch (we) {
                  gn(Z, Z.return, we);
                }
              }
            } else if ((o.tag !== 22 && o.tag !== 23 || o.memoizedState === null || o === l) && o.child !== null) {
              o.child.return = o, o = o.child;
              continue;
            }
            if (o === l) break e;
            for (; o.sibling === null; ) {
              if (o.return === null || o.return === l) break e;
              c === o && (c = null), o = o.return;
            }
            c === o && (c = null), o.sibling.return = o.return, o = o.sibling;
          }
        m & 4 && (m = l.updateQueue, m !== null && (c = m.retryQueue, c !== null && (m.retryQueue = null, rf(l, c))));
        break;
      case 19:
        Ea(o, l), Jr(l), m & 4 && (m = l.updateQueue, m !== null && (l.updateQueue = null, rf(l, m)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        Ea(o, l), Jr(l);
    }
  }
  function Jr(l) {
    var o = l.flags;
    if (o & 2) {
      try {
        for (var c, m = l.return; m !== null; ) {
          if (j4(m)) {
            c = m;
            break;
          }
          m = m.return;
        }
        if (c == null) throw Error(i(160));
        switch (c.tag) {
          case 27:
            var S = c.stateNode, w = sp(l);
            Qu(l, w, S);
            break;
          case 5:
            var _ = c.stateNode;
            c.flags & 32 && (Ro(_, ""), c.flags &= -33);
            var H = sp(l);
            Qu(l, H, _);
            break;
          case 3:
          case 4:
            var Z = c.stateNode.containerInfo, fe = sp(l);
            dl(
              l,
              fe,
              Z
            );
            break;
          default:
            throw Error(i(161));
        }
      } catch (Oe) {
        gn(l, l.return, Oe);
      }
      l.flags &= -3;
    }
    o & 4096 && (l.flags &= -4097);
  }
  function ts(l) {
    if (l.subtreeFlags & 1024)
      for (l = l.child; l !== null; ) {
        var o = l;
        ts(o), o.tag === 5 && o.flags & 1024 && o.stateNode.reset(), l = l.sibling;
      }
  }
  function lu(l, o) {
    if (o.subtreeFlags & 8772)
      for (o = o.child; o !== null; )
        sd(l, o.alternate, o), o = o.sibling;
  }
  function iu(l) {
    for (l = l.child; l !== null; ) {
      var o = l;
      switch (o.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Xu(4, o, o.return), iu(o);
          break;
        case 1:
          Vl(o, o.return);
          var c = o.stateNode;
          typeof c.componentWillUnmount == "function" && ud(
            o,
            o.return,
            c
          ), iu(o);
          break;
        case 27:
          Pe(o.stateNode);
        case 26:
        case 5:
          Vl(o, o.return), iu(o);
          break;
        case 22:
          o.memoizedState === null && iu(o);
          break;
        case 30:
          iu(o);
          break;
        default:
          iu(o);
      }
      l = l.sibling;
    }
  }
  function Rn(l, o, c) {
    for (c = c && (o.subtreeFlags & 8772) !== 0, o = o.child; o !== null; ) {
      var m = o.alternate, S = l, w = o, _ = w.flags;
      switch (w.tag) {
        case 0:
        case 11:
        case 15:
          Rn(
            S,
            w,
            c
          ), vc(4, w);
          break;
        case 1:
          if (Rn(
            S,
            w,
            c
          ), m = w, S = m.stateNode, typeof S.componentDidMount == "function")
            try {
              S.componentDidMount();
            } catch (fe) {
              gn(m, m.return, fe);
            }
          if (m = w, S = m.updateQueue, S !== null) {
            var H = m.stateNode;
            try {
              var Z = S.shared.hiddenCallbacks;
              if (Z !== null)
                for (S.shared.hiddenCallbacks = null, S = 0; S < Z.length; S++)
                  ic(Z[S], H);
            } catch (fe) {
              gn(m, m.return, fe);
            }
          }
          c && _ & 64 && q4(w), bc(w, w.return);
          break;
        case 27:
          G4(w);
        case 26:
        case 5:
          Rn(
            S,
            w,
            c
          ), c && m === null && _ & 4 && op(w), bc(w, w.return);
          break;
        case 12:
          Rn(
            S,
            w,
            c
          );
          break;
        case 13:
          Rn(
            S,
            w,
            c
          ), c && _ & 4 && Yt(S, w);
          break;
        case 22:
          w.memoizedState === null && Rn(
            S,
            w,
            c
          ), bc(w, w.return);
          break;
        case 30:
          break;
        default:
          Rn(
            S,
            w,
            c
          );
      }
      o = o.sibling;
    }
  }
  function mp(l, o) {
    var c = null;
    l !== null && l.memoizedState !== null && l.memoizedState.cachePool !== null && (c = l.memoizedState.cachePool.pool), l = null, o.memoizedState !== null && o.memoizedState.cachePool !== null && (l = o.memoizedState.cachePool.pool), l !== c && (l != null && l.refCount++, c != null && ju(c));
  }
  function pl(l, o) {
    l = null, o.alternate !== null && (l = o.alternate.memoizedState.cache), o = o.memoizedState.cache, o !== l && (o.refCount++, l != null && ju(l));
  }
  function Il(l, o, c, m) {
    if (o.subtreeFlags & 10256)
      for (o = o.child; o !== null; )
        uu(
          l,
          o,
          c,
          m
        ), o = o.sibling;
  }
  function uu(l, o, c, m) {
    var S = o.flags;
    switch (o.tag) {
      case 0:
      case 11:
      case 15:
        Il(
          l,
          o,
          c,
          m
        ), S & 2048 && vc(9, o);
        break;
      case 1:
        Il(
          l,
          o,
          c,
          m
        );
        break;
      case 3:
        Il(
          l,
          o,
          c,
          m
        ), S & 2048 && (l = null, o.alternate !== null && (l = o.alternate.memoizedState.cache), o = o.memoizedState.cache, o !== l && (o.refCount++, l != null && ju(l)));
        break;
      case 12:
        if (S & 2048) {
          Il(
            l,
            o,
            c,
            m
          ), l = o.stateNode;
          try {
            var w = o.memoizedProps, _ = w.id, H = w.onPostCommit;
            typeof H == "function" && H(
              _,
              o.alternate === null ? "mount" : "update",
              l.passiveEffectDuration,
              -0
            );
          } catch (Z) {
            gn(o, o.return, Z);
          }
        } else
          Il(
            l,
            o,
            c,
            m
          );
        break;
      case 13:
        Il(
          l,
          o,
          c,
          m
        );
        break;
      case 23:
        break;
      case 22:
        w = o.stateNode, _ = o.alternate, o.memoizedState !== null ? w._visibility & 2 ? Il(
          l,
          o,
          c,
          m
        ) : Zu(l, o) : w._visibility & 2 ? Il(
          l,
          o,
          c,
          m
        ) : (w._visibility |= 2, ns(
          l,
          o,
          c,
          m,
          (o.subtreeFlags & 10256) !== 0
        )), S & 2048 && mp(_, o);
        break;
      case 24:
        Il(
          l,
          o,
          c,
          m
        ), S & 2048 && pl(o.alternate, o);
        break;
      default:
        Il(
          l,
          o,
          c,
          m
        );
    }
  }
  function ns(l, o, c, m, S) {
    for (S = S && (o.subtreeFlags & 10256) !== 0, o = o.child; o !== null; ) {
      var w = l, _ = o, H = c, Z = m, fe = _.flags;
      switch (_.tag) {
        case 0:
        case 11:
        case 15:
          ns(
            w,
            _,
            H,
            Z,
            S
          ), vc(8, _);
          break;
        case 23:
          break;
        case 22:
          var Oe = _.stateNode;
          _.memoizedState !== null ? Oe._visibility & 2 ? ns(
            w,
            _,
            H,
            Z,
            S
          ) : Zu(
            w,
            _
          ) : (Oe._visibility |= 2, ns(
            w,
            _,
            H,
            Z,
            S
          )), S && fe & 2048 && mp(
            _.alternate,
            _
          );
          break;
        case 24:
          ns(
            w,
            _,
            H,
            Z,
            S
          ), S && fe & 2048 && pl(_.alternate, _);
          break;
        default:
          ns(
            w,
            _,
            H,
            Z,
            S
          );
      }
      o = o.sibling;
    }
  }
  function Zu(l, o) {
    if (o.subtreeFlags & 10256)
      for (o = o.child; o !== null; ) {
        var c = l, m = o, S = m.flags;
        switch (m.tag) {
          case 22:
            Zu(c, m), S & 2048 && mp(
              m.alternate,
              m
            );
            break;
          case 24:
            Zu(c, m), S & 2048 && pl(m.alternate, m);
            break;
          default:
            Zu(c, m);
        }
        o = o.sibling;
      }
  }
  var en = 8192;
  function Fu(l) {
    if (l.subtreeFlags & en)
      for (l = l.child; l !== null; )
        Ar(l), l = l.sibling;
  }
  function Ar(l) {
    switch (l.tag) {
      case 26:
        Fu(l), l.flags & en && l.memoizedState !== null && oy(
          Va,
          l.memoizedState,
          l.memoizedProps
        );
        break;
      case 5:
        Fu(l);
        break;
      case 3:
      case 4:
        var o = Va;
        Va = kr(l.stateNode.containerInfo), Fu(l), Va = o;
        break;
      case 22:
        l.memoizedState === null && (o = l.alternate, o !== null && o.memoizedState !== null ? (o = en, en = 16777216, Fu(l), en = o) : Fu(l));
        break;
      default:
        Fu(l);
    }
  }
  function Y4(l) {
    var o = l.alternate;
    if (o !== null && (l = o.child, l !== null)) {
      o.child = null;
      do
        o = l.sibling, l.sibling = null, l = o;
      while (l !== null);
    }
  }
  function xc(l) {
    var o = l.deletions;
    if (l.flags & 16) {
      if (o !== null)
        for (var c = 0; c < o.length; c++) {
          var m = o[c];
          lr = m, Ya(
            m,
            l
          );
        }
      Y4(l);
    }
    if (l.subtreeFlags & 10256)
      for (l = l.child; l !== null; )
        cd(l), l = l.sibling;
  }
  function cd(l) {
    switch (l.tag) {
      case 0:
      case 11:
      case 15:
        xc(l), l.flags & 2048 && Xu(9, l, l.return);
        break;
      case 3:
        xc(l);
        break;
      case 12:
        xc(l);
        break;
      case 22:
        var o = l.stateNode;
        l.memoizedState !== null && o._visibility & 2 && (l.return === null || l.return.tag !== 13) ? (o._visibility &= -3, af(l)) : xc(l);
        break;
      default:
        xc(l);
    }
  }
  function af(l) {
    var o = l.deletions;
    if (l.flags & 16) {
      if (o !== null)
        for (var c = 0; c < o.length; c++) {
          var m = o[c];
          lr = m, Ya(
            m,
            l
          );
        }
      Y4(l);
    }
    for (l = l.child; l !== null; ) {
      switch (o = l, o.tag) {
        case 0:
        case 11:
        case 15:
          Xu(8, o, o.return), af(o);
          break;
        case 22:
          c = o.stateNode, c._visibility & 2 && (c._visibility &= -3, af(o));
          break;
        default:
          af(o);
      }
      l = l.sibling;
    }
  }
  function Ya(l, o) {
    for (; lr !== null; ) {
      var c = lr;
      switch (c.tag) {
        case 0:
        case 11:
        case 15:
          Xu(8, c, o);
          break;
        case 23:
        case 22:
          if (c.memoizedState !== null && c.memoizedState.cachePool !== null) {
            var m = c.memoizedState.cachePool.pool;
            m != null && m.refCount++;
          }
          break;
        case 24:
          ju(c.memoizedState.cache);
      }
      if (m = c.child, m !== null) m.return = c, lr = m;
      else
        e: for (c = l; lr !== null; ) {
          m = lr;
          var S = m.sibling, w = m.return;
          if (fp(m), m === c) {
            lr = null;
            break e;
          }
          if (S !== null) {
            S.return = w, lr = S;
            break e;
          }
          lr = w;
        }
    }
  }
  var I4 = {
    getCacheForType: function(l) {
      var o = Hr(rr), c = o.data.get(l);
      return c === void 0 && (c = l(), o.data.set(l, c)), c;
    }
  }, pp = typeof WeakMap == "function" ? WeakMap : Map, cn = 0, pn = null, It = null, Wt = 0, tn = 0, Aa = null, ou = !1, Pu = !1, gp = !1, su = 0, $n = 0, Ku = 0, Ju = 0, yp = 0, pr = 0, wc = 0, lf = null, ia = null, vp = !1, bp = 0, fd = 1 / 0, hd = null, di = null, Ur = 0, Wu = null, eo = null, Tc = 0, ka = 0, dd = null, Sp = null, Ec = 0, md = null;
  function Ia() {
    if (cn & 2 && Wt !== 0)
      return Wt & -Wt;
    if (J.T !== null) {
      var l = Gu;
      return l !== 0 ? l : Ed();
    }
    return ai();
  }
  function $4() {
    pr === 0 && (pr = !(Wt & 536870912) || Dt ? ue() : 536870912);
    var l = ar.current;
    return l !== null && (l.flags |= 32), pr;
  }
  function Ra(l, o, c) {
    (l === pn && (tn === 2 || tn === 9) || l.cancelPendingCommit !== null) && ($l(l, 0), cu(
      l,
      Wt,
      pr,
      !1
    )), et(l, c), (!(cn & 2) || l !== pn) && (l === pn && (!(cn & 2) && (Ju |= c), $n === 4 && cu(
      l,
      Wt,
      pr,
      !1
    )), Xl(l));
  }
  function X4(l, o, c) {
    if (cn & 6) throw Error(i(327));
    var m = !c && (o & 124) === 0 && (o & l.expiredLanes) === 0 || hr(l, o), S = m ? gd(l, o) : rs(l, o, !0), w = m;
    do {
      if (S === 0) {
        Pu && !m && cu(l, o, 0, !1);
        break;
      } else {
        if (c = l.current.alternate, w && !pd(c)) {
          S = rs(l, o, !1), w = !1;
          continue;
        }
        if (S === 2) {
          if (w = o, l.errorRecoveryDisabledLanes & w)
            var _ = 0;
          else
            _ = l.pendingLanes & -536870913, _ = _ !== 0 ? _ : _ & 536870912 ? 536870912 : 0;
          if (_ !== 0) {
            o = _;
            e: {
              var H = l;
              S = lf;
              var Z = H.current.memoizedState.isDehydrated;
              if (Z && ($l(H, _).flags |= 256), _ = rs(
                H,
                _,
                !1
              ), _ !== 2) {
                if (gp && !Z) {
                  H.errorRecoveryDisabledLanes |= w, Ju |= w, S = 4;
                  break e;
                }
                w = ia, ia = S, w !== null && (ia === null ? ia = w : ia.push.apply(
                  ia,
                  w
                ));
              }
              S = _;
            }
            if (w = !1, S !== 2) continue;
          }
        }
        if (S === 1) {
          $l(l, 0), cu(l, o, 0, !0);
          break;
        }
        e: {
          switch (m = l, w = S, w) {
            case 0:
            case 1:
              throw Error(i(345));
            case 4:
              if ((o & 4194048) !== o) break;
            case 6:
              cu(
                m,
                o,
                pr,
                !ou
              );
              break e;
            case 2:
              ia = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(i(329));
          }
          if ((o & 62914560) === o && (S = bp + 300 - Bt(), 10 < S)) {
            if (cu(
              m,
              o,
              pr,
              !ou
            ), hn(m, 0, !0) !== 0) break e;
            m.timeoutHandle = gi(
              Ac.bind(
                null,
                m,
                c,
                ia,
                hd,
                vp,
                o,
                pr,
                Ju,
                wc,
                ou,
                w,
                2,
                -0,
                0
              ),
              S
            );
            break e;
          }
          Ac(
            m,
            c,
            ia,
            hd,
            vp,
            o,
            pr,
            Ju,
            wc,
            ou,
            w,
            0,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    Xl(l);
  }
  function Ac(l, o, c, m, S, w, _, H, Z, fe, Oe, Be, me, we) {
    if (l.timeoutHandle = -1, Be = o.subtreeFlags, (Be & 8192 || (Be & 16785408) === 16785408) && (Lc = { stylesheets: null, count: 0, unsuspend: uy }, Ar(o), Be = sy(), Be !== null)) {
      l.cancelPendingCommit = Be(
        F4.bind(
          null,
          l,
          o,
          w,
          c,
          m,
          S,
          _,
          H,
          Z,
          Oe,
          1,
          me,
          we
        )
      ), cu(l, w, _, !fe);
      return;
    }
    F4(
      l,
      o,
      w,
      c,
      m,
      S,
      _,
      H,
      Z
    );
  }
  function pd(l) {
    for (var o = l; ; ) {
      var c = o.tag;
      if ((c === 0 || c === 11 || c === 15) && o.flags & 16384 && (c = o.updateQueue, c !== null && (c = c.stores, c !== null)))
        for (var m = 0; m < c.length; m++) {
          var S = c[m], w = S.getSnapshot;
          S = S.value;
          try {
            if (!ra(w(), S)) return !1;
          } catch {
            return !1;
          }
        }
      if (c = o.child, o.subtreeFlags & 16384 && c !== null)
        c.return = o, o = c;
      else {
        if (o === l) break;
        for (; o.sibling === null; ) {
          if (o.return === null || o.return === l) return !0;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
    }
    return !0;
  }
  function cu(l, o, c, m) {
    o &= ~yp, o &= ~Ju, l.suspendedLanes |= o, l.pingedLanes &= ~o, m && (l.warmLanes |= o), m = l.expirationTimes;
    for (var S = o; 0 < S; ) {
      var w = 31 - st(S), _ = 1 << w;
      m[w] = -1, S &= ~_;
    }
    c !== 0 && kt(l, c, o);
  }
  function uf() {
    return cn & 6 ? !0 : (fu(0), !1);
  }
  function kc() {
    if (It !== null) {
      if (tn === 0)
        var l = It.return;
      else
        l = It, Ll = Pi = null, oc(l), Sa = null, hc = 0, l = It;
      for (; l !== null; )
        U4(l.alternate, l), l = l.return;
      It = null;
    }
  }
  function $l(l, o) {
    var c = l.timeoutHandle;
    c !== -1 && (l.timeoutHandle = -1, Mp(c)), c = l.cancelPendingCommit, c !== null && (l.cancelPendingCommit = null, c()), kc(), pn = l, It = c = _l(l.current, null), Wt = o, tn = 0, Aa = null, ou = !1, Pu = hr(l, o), gp = !1, wc = pr = yp = Ju = Ku = $n = 0, ia = lf = null, vp = !1, o & 8 && (o |= o & 32);
    var m = l.entangledLanes;
    if (m !== 0)
      for (l = l.entanglements, m &= o; 0 < m; ) {
        var S = 31 - st(m), w = 1 << S;
        o |= l[S], m &= ~w;
      }
    return su = o, Cl(), c;
  }
  function Rc(l, o) {
    Rt = null, J.H = K0, o === Yo || o === nc ? (o = Bh(), tn = 3) : o === L0 ? (o = Bh(), tn = 4) : tn = o === J1 ? 8 : o !== null && typeof o == "object" && typeof o.then == "function" ? 6 : 1, Aa = o, It === null && ($n = 1, Ko(
      l,
      Ua(o, l.current)
    ));
  }
  function xp() {
    var l = J.H;
    return J.H = K0, l === null ? K0 : l;
  }
  function Q4() {
    var l = J.A;
    return J.A = I4, l;
  }
  function to() {
    $n = 4, ou || (Wt & 4194048) !== Wt && ar.current !== null || (Pu = !0), !(Ku & 134217727) && !(Ju & 134217727) || pn === null || cu(
      pn,
      Wt,
      pr,
      !1
    );
  }
  function rs(l, o, c) {
    var m = cn;
    cn |= 2;
    var S = xp(), w = Q4();
    (pn !== l || Wt !== o) && (hd = null, $l(l, o)), o = !1;
    var _ = $n;
    e: do
      try {
        if (tn !== 0 && It !== null) {
          var H = It, Z = Aa;
          switch (tn) {
            case 8:
              kc(), _ = 6;
              break e;
            case 3:
            case 2:
            case 9:
            case 6:
              ar.current === null && (o = !0);
              var fe = tn;
              if (tn = 0, Aa = null, as(l, H, Z, fe), c && Pu) {
                _ = 0;
                break e;
              }
              break;
            default:
              fe = tn, tn = 0, Aa = null, as(l, H, Z, fe);
          }
        }
        Z4(), _ = $n;
        break;
      } catch (Oe) {
        Rc(l, Oe);
      }
    while (!0);
    return o && l.shellSuspendCounter++, Ll = Pi = null, cn = m, J.H = S, J.A = w, It === null && (pn = null, Wt = 0, Cl()), _;
  }
  function Z4() {
    for (; It !== null; ) yd(It);
  }
  function gd(l, o) {
    var c = cn;
    cn |= 2;
    var m = xp(), S = Q4();
    pn !== l || Wt !== o ? (hd = null, fd = Bt() + 500, $l(l, o)) : Pu = hr(
      l,
      o
    );
    e: do
      try {
        if (tn !== 0 && It !== null) {
          o = It;
          var w = Aa;
          t: switch (tn) {
            case 1:
              tn = 0, Aa = null, as(l, o, w, 1);
              break;
            case 2:
            case 9:
              if (S1(w)) {
                tn = 0, Aa = null, Tp(o);
                break;
              }
              o = function() {
                tn !== 2 && tn !== 9 || pn !== l || (tn = 7), Xl(l);
              }, w.then(o, o);
              break e;
            case 3:
              tn = 7;
              break e;
            case 4:
              tn = 5;
              break e;
            case 7:
              S1(w) ? (tn = 0, Aa = null, Tp(o)) : (tn = 0, Aa = null, as(l, o, w, 7));
              break;
            case 5:
              var _ = null;
              switch (It.tag) {
                case 26:
                  _ = It.memoizedState;
                case 5:
                case 27:
                  var H = It;
                  if (!_ || Up(_)) {
                    tn = 0, Aa = null;
                    var Z = H.sibling;
                    if (Z !== null) It = Z;
                    else {
                      var fe = H.return;
                      fe !== null ? (It = fe, vd(fe)) : It = null;
                    }
                    break t;
                  }
              }
              tn = 0, Aa = null, as(l, o, w, 5);
              break;
            case 6:
              tn = 0, Aa = null, as(l, o, w, 6);
              break;
            case 8:
              kc(), $n = 6;
              break e;
            default:
              throw Error(i(462));
          }
        }
        wp();
        break;
      } catch (Oe) {
        Rc(l, Oe);
      }
    while (!0);
    return Ll = Pi = null, J.H = m, J.A = S, cn = c, It !== null ? 0 : (pn = null, Wt = 0, Cl(), $n);
  }
  function wp() {
    for (; It !== null && !Gn(); )
      yd(It);
  }
  function yd(l) {
    var o = lp(l.alternate, l, su);
    l.memoizedProps = l.pendingProps, o === null ? vd(l) : It = o;
  }
  function Tp(l) {
    var o = l, c = o.alternate;
    switch (o.tag) {
      case 15:
      case 0:
        o = ep(
          c,
          o,
          o.pendingProps,
          o.type,
          void 0,
          Wt
        );
        break;
      case 11:
        o = ep(
          c,
          o,
          o.pendingProps,
          o.type.render,
          o.ref,
          Wt
        );
        break;
      case 5:
        oc(o);
      default:
        U4(c, o), o = It = Ch(o, su), o = lp(c, o, su);
    }
    l.memoizedProps = l.pendingProps, o === null ? vd(l) : It = o;
  }
  function as(l, o, c, m) {
    Ll = Pi = null, oc(o), Sa = null, hc = 0;
    var S = o.return;
    try {
      if (Ga(
        l,
        S,
        o,
        c,
        Wt
      )) {
        $n = 1, Ko(
          l,
          Ua(c, l.current)
        ), It = null;
        return;
      }
    } catch (w) {
      if (S !== null) throw It = S, w;
      $n = 1, Ko(
        l,
        Ua(c, l.current)
      ), It = null;
      return;
    }
    o.flags & 32768 ? (Dt || m === 1 ? l = !0 : Pu || Wt & 536870912 ? l = !1 : (ou = l = !0, (m === 2 || m === 9 || m === 3 || m === 6) && (m = ar.current, m !== null && m.tag === 13 && (m.flags |= 16384))), Ep(o, l)) : vd(o);
  }
  function vd(l) {
    var o = l;
    do {
      if (o.flags & 32768) {
        Ep(
          o,
          ou
        );
        return;
      }
      l = o.return;
      var c = mn(
        o.alternate,
        o,
        su
      );
      if (c !== null) {
        It = c;
        return;
      }
      if (o = o.sibling, o !== null) {
        It = o;
        return;
      }
      It = o = l;
    } while (o !== null);
    $n === 0 && ($n = 5);
  }
  function Ep(l, o) {
    do {
      var c = up(l.alternate, l);
      if (c !== null) {
        c.flags &= 32767, It = c;
        return;
      }
      if (c = l.return, c !== null && (c.flags |= 32768, c.subtreeFlags = 0, c.deletions = null), !o && (l = l.sibling, l !== null)) {
        It = l;
        return;
      }
      It = l = c;
    } while (l !== null);
    $n = 6, It = null;
  }
  function F4(l, o, c, m, S, w, _, H, Z) {
    l.cancelPendingCommit = null;
    do
      Sd();
    while (Ur !== 0);
    if (cn & 6) throw Error(i(327));
    if (o !== null) {
      if (o === l.current) throw Error(i(177));
      if (w = o.lanes | o.childLanes, w |= k0, Ht(
        l,
        c,
        w,
        _,
        H,
        Z
      ), l === pn && (It = pn = null, Wt = 0), eo = o, Wu = l, Tc = c, ka = w, dd = S, Sp = m, o.subtreeFlags & 10256 || o.flags & 10256 ? (l.callbackNode = null, l.callbackPriority = 0, y3(xt, function() {
        return J4(), null;
      })) : (l.callbackNode = null, l.callbackPriority = 0), m = (o.flags & 13878) !== 0, o.subtreeFlags & 13878 || m) {
        m = J.T, J.T = null, S = X.p, X.p = 2, _ = cn, cn |= 4;
        try {
          V4(l, o, c);
        } finally {
          cn = _, X.p = S, J.T = m;
        }
      }
      Ur = 1, P4(), K4(), of();
    }
  }
  function P4() {
    if (Ur === 1) {
      Ur = 0;
      var l = Wu, o = eo, c = (o.flags & 13878) !== 0;
      if (o.subtreeFlags & 13878 || c) {
        c = J.T, J.T = null;
        var m = X.p;
        X.p = 2;
        var S = cn;
        cn |= 4;
        try {
          Sc(o, l);
          var w = gf, _ = E0(l.containerInfo), H = w.focusedElem, Z = w.selectionRange;
          if (_ !== H && H && H.ownerDocument && En(
            H.ownerDocument.documentElement,
            H
          )) {
            if (Z !== null && Eh(H)) {
              var fe = Z.start, Oe = Z.end;
              if (Oe === void 0 && (Oe = fe), "selectionStart" in H)
                H.selectionStart = fe, H.selectionEnd = Math.min(
                  Oe,
                  H.value.length
                );
              else {
                var Be = H.ownerDocument || document, me = Be && Be.defaultView || window;
                if (me.getSelection) {
                  var we = me.getSelection(), mt = H.textContent.length, ct = Math.min(Z.start, mt), un = Z.end === void 0 ? ct : Math.min(Z.end, mt);
                  !we.extend && ct > un && (_ = un, un = ct, ct = _);
                  var oe = Du(
                    H,
                    ct
                  ), ae = Du(
                    H,
                    un
                  );
                  if (oe && ae && (we.rangeCount !== 1 || we.anchorNode !== oe.node || we.anchorOffset !== oe.offset || we.focusNode !== ae.node || we.focusOffset !== ae.offset)) {
                    var he = Be.createRange();
                    he.setStart(oe.node, oe.offset), we.removeAllRanges(), ct > un ? (we.addRange(he), we.extend(ae.node, ae.offset)) : (he.setEnd(ae.node, ae.offset), we.addRange(he));
                  }
                }
              }
            }
            for (Be = [], we = H; we = we.parentNode; )
              we.nodeType === 1 && Be.push({
                element: we,
                left: we.scrollLeft,
                top: we.scrollTop
              });
            for (typeof H.focus == "function" && H.focus(), H = 0; H < Be.length; H++) {
              var Le = Be[H];
              Le.element.scrollLeft = Le.left, Le.element.scrollTop = Le.top;
            }
          }
          Tf = !!Cp, gf = Cp = null;
        } finally {
          cn = S, X.p = m, J.T = c;
        }
      }
      l.current = o, Ur = 2;
    }
  }
  function K4() {
    if (Ur === 2) {
      Ur = 0;
      var l = Wu, o = eo, c = (o.flags & 8772) !== 0;
      if (o.subtreeFlags & 8772 || c) {
        c = J.T, J.T = null;
        var m = X.p;
        X.p = 2;
        var S = cn;
        cn |= 4;
        try {
          sd(l, o.alternate, o);
        } finally {
          cn = S, X.p = m, J.T = c;
        }
      }
      Ur = 3;
    }
  }
  function of() {
    if (Ur === 4 || Ur === 3) {
      Ur = 0, xr();
      var l = Wu, o = eo, c = Tc, m = Sp;
      o.subtreeFlags & 10256 || o.flags & 10256 ? Ur = 5 : (Ur = 0, eo = Wu = null, bd(l, l.pendingLanes));
      var S = l.pendingLanes;
      if (S === 0 && (di = null), tr(c), o = o.stateNode, je && typeof je.onCommitFiberRoot == "function")
        try {
          je.onCommitFiberRoot(
            ke,
            o,
            void 0,
            (o.current.flags & 128) === 128
          );
        } catch {
        }
      if (m !== null) {
        o = J.T, S = X.p, X.p = 2, J.T = null;
        try {
          for (var w = l.onRecoverableError, _ = 0; _ < m.length; _++) {
            var H = m[_];
            w(H.value, {
              componentStack: H.stack
            });
          }
        } finally {
          J.T = o, X.p = S;
        }
      }
      Tc & 3 && Sd(), Xl(l), S = l.pendingLanes, c & 4194090 && S & 42 ? l === md ? Ec++ : (Ec = 0, md = l) : Ec = 0, fu(0);
    }
  }
  function bd(l, o) {
    (l.pooledCacheLanes &= o) === 0 && (o = l.pooledCache, o != null && (l.pooledCache = null, ju(o)));
  }
  function Sd(l) {
    return P4(), K4(), of(), J4();
  }
  function J4() {
    if (Ur !== 5) return !1;
    var l = Wu, o = ka;
    ka = 0;
    var c = tr(Tc), m = J.T, S = X.p;
    try {
      X.p = 32 > c ? 32 : c, J.T = null, c = dd, dd = null;
      var w = Wu, _ = Tc;
      if (Ur = 0, eo = Wu = null, Tc = 0, cn & 6) throw Error(i(331));
      var H = cn;
      if (cn |= 4, cd(w.current), uu(
        w,
        w.current,
        _,
        c
      ), cn = H, fu(0, !1), je && typeof je.onPostCommitFiberRoot == "function")
        try {
          je.onPostCommitFiberRoot(ke, w);
        } catch {
        }
      return !0;
    } finally {
      X.p = S, J.T = m, bd(l, o);
    }
  }
  function Ap(l, o, c) {
    o = Ua(c, o), o = ed(l.stateNode, o, 2), l = ya(l, o, 2), l !== null && (et(l, 2), Xl(l));
  }
  function gn(l, o, c) {
    if (l.tag === 3)
      Ap(l, l, c);
    else
      for (; o !== null; ) {
        if (o.tag === 3) {
          Ap(
            o,
            l,
            c
          );
          break;
        } else if (o.tag === 1) {
          var m = o.stateNode;
          if (typeof o.type.getDerivedStateFromError == "function" || typeof m.componentDidCatch == "function" && (di === null || !di.has(m))) {
            l = Ua(c, l), c = N4(2), m = ya(o, c, 2), m !== null && (K1(
              c,
              m,
              o,
              l
            ), et(m, 2), Xl(m));
            break;
          }
        }
        o = o.return;
      }
  }
  function sf(l, o, c) {
    var m = l.pingCache;
    if (m === null) {
      m = l.pingCache = new pp();
      var S = /* @__PURE__ */ new Set();
      m.set(o, S);
    } else
      S = m.get(o), S === void 0 && (S = /* @__PURE__ */ new Set(), m.set(o, S));
    S.has(c) || (gp = !0, S.add(c), l = W4.bind(null, l, o, c), o.then(l, l));
  }
  function W4(l, o, c) {
    var m = l.pingCache;
    m !== null && m.delete(o), l.pingedLanes |= l.suspendedLanes & c, l.warmLanes &= ~c, pn === l && (Wt & c) === c && ($n === 4 || $n === 3 && (Wt & 62914560) === Wt && 300 > Bt() - bp ? !(cn & 2) && $l(l, 0) : yp |= c, wc === Wt && (wc = 0)), Xl(l);
  }
  function xd(l, o) {
    o === 0 && (o = Ie()), l = Qi(l, o), l !== null && (et(l, o), Xl(l));
  }
  function ey(l) {
    var o = l.memoizedState, c = 0;
    o !== null && (c = o.retryLane), xd(l, c);
  }
  function g3(l, o) {
    var c = 0;
    switch (l.tag) {
      case 13:
        var m = l.stateNode, S = l.memoizedState;
        S !== null && (c = S.retryLane);
        break;
      case 19:
        m = l.stateNode;
        break;
      case 22:
        m = l.stateNode._retryCache;
        break;
      default:
        throw Error(i(314));
    }
    m !== null && m.delete(o), xd(l, c);
  }
  function y3(l, o) {
    return Dr(l, o);
  }
  var wd = null, zc = null, cf = !1, Cc = !1, ff = !1, no = 0;
  function Xl(l) {
    l !== zc && l.next === null && (zc === null ? wd = zc = l : zc = zc.next = l), Cc = !0, cf || (cf = !0, Td());
  }
  function fu(l, o) {
    if (!ff && Cc) {
      ff = !0;
      do
        for (var c = !1, m = wd; m !== null; ) {
          if (l !== 0) {
            var S = m.pendingLanes;
            if (S === 0) var w = 0;
            else {
              var _ = m.suspendedLanes, H = m.pingedLanes;
              w = (1 << 31 - st(42 | l) + 1) - 1, w &= S & ~(_ & ~H), w = w & 201326741 ? w & 201326741 | 1 : w ? w | 2 : 0;
            }
            w !== 0 && (c = !0, ty(m, w));
          } else
            w = Wt, w = hn(
              m,
              m === pn ? w : 0,
              m.cancelPendingCommit !== null || m.timeoutHandle !== -1
            ), !(w & 3) || hr(m, w) || (c = !0, ty(m, w));
          m = m.next;
        }
      while (c);
      ff = !1;
    }
  }
  function v3() {
    kp();
  }
  function kp() {
    Cc = cf = !1;
    var l = 0;
    no !== 0 && (_d() && (l = no), no = 0);
    for (var o = Bt(), c = null, m = wd; m !== null; ) {
      var S = m.next, w = hf(m, o);
      w === 0 ? (m.next = null, c === null ? wd = S : c.next = S, S === null && (zc = c)) : (c = m, (l !== 0 || w & 3) && (Cc = !0)), m = S;
    }
    fu(l);
  }
  function hf(l, o) {
    for (var c = l.suspendedLanes, m = l.pingedLanes, S = l.expirationTimes, w = l.pendingLanes & -62914561; 0 < w; ) {
      var _ = 31 - st(w), H = 1 << _, Z = S[_];
      Z === -1 ? (!(H & c) || H & m) && (S[_] = B(H, o)) : Z <= o && (l.expiredLanes |= H), w &= ~H;
    }
    if (o = pn, c = Wt, c = hn(
      l,
      l === o ? c : 0,
      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
    ), m = l.callbackNode, c === 0 || l === o && (tn === 2 || tn === 9) || l.cancelPendingCommit !== null)
      return m !== null && m !== null && jn(m), l.callbackNode = null, l.callbackPriority = 0;
    if (!(c & 3) || hr(l, c)) {
      if (o = c & -c, o === l.callbackPriority) return o;
      switch (m !== null && jn(m), tr(c)) {
        case 2:
        case 8:
          c = El;
          break;
        case 32:
          c = xt;
          break;
        case 268435456:
          c = Tn;
          break;
        default:
          c = xt;
      }
      return m = Rp.bind(null, l), c = Dr(c, m), l.callbackPriority = o, l.callbackNode = c, o;
    }
    return m !== null && m !== null && jn(m), l.callbackPriority = 2, l.callbackNode = null, 2;
  }
  function Rp(l, o) {
    if (Ur !== 0 && Ur !== 5)
      return l.callbackNode = null, l.callbackPriority = 0, null;
    var c = l.callbackNode;
    if (Sd() && l.callbackNode !== c)
      return null;
    var m = Wt;
    return m = hn(
      l,
      l === pn ? m : 0,
      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
    ), m === 0 ? null : (X4(l, m, o), hf(l, Bt()), l.callbackNode != null && l.callbackNode === c ? Rp.bind(null, l) : null);
  }
  function ty(l, o) {
    if (Sd()) return null;
    X4(l, o, !0);
  }
  function Td() {
    x3(function() {
      cn & 6 ? Dr(
        sr,
        v3
      ) : kp();
    });
  }
  function Ed() {
    return no === 0 && (no = ue()), no;
  }
  function Mc(l) {
    return l == null || typeof l == "symbol" || typeof l == "boolean" ? null : typeof l == "function" ? l : p0("" + l);
  }
  function Ad(l, o) {
    var c = o.ownerDocument.createElement("input");
    return c.name = o.name, c.value = o.value, l.id && c.setAttribute("form", l.id), o.parentNode.insertBefore(c, o), l = new FormData(l), c.parentNode.removeChild(c), l;
  }
  function kd(l, o, c, m, S) {
    if (o === "submit" && c && c.stateNode === S) {
      var w = Mc(
        (S[Zr] || null).action
      ), _ = m.submitter;
      _ && (o = (o = _[Zr] || null) ? Mc(o.formAction) : _.getAttribute("formAction"), o !== null && (w = o, _ = null));
      var H = new v0(
        "action",
        "action",
        null,
        m,
        S
      );
      l.push({
        event: H,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (m.defaultPrevented) {
                if (no !== 0) {
                  var Z = _ ? Ad(S, _) : new FormData(S);
                  j1(
                    c,
                    {
                      pending: !0,
                      data: Z,
                      method: S.method,
                      action: w
                    },
                    null,
                    Z
                  );
                }
              } else
                typeof w == "function" && (H.preventDefault(), Z = _ ? Ad(S, _) : new FormData(S), j1(
                  c,
                  {
                    pending: !0,
                    data: Z,
                    method: S.method,
                    action: w
                  },
                  w,
                  Z
                ));
            },
            currentTarget: S
          }
        ]
      });
    }
  }
  for (var Rd = 0; Rd < Rh.length; Rd++) {
    var Xn = Rh[Rd], zp = Xn.toLowerCase(), b3 = Xn[0].toUpperCase() + Xn.slice(1);
    da(
      zp,
      "on" + b3
    );
  }
  da(A0, "onAnimationEnd"), da(T4, "onAnimationIteration"), da(c1, "onAnimationStart"), da("dblclick", "onDoubleClick"), da("focusin", "onFocus"), da("focusout", "onBlur"), da(h3, "onTransitionRun"), da(f1, "onTransitionStart"), da(kh, "onTransitionCancel"), da(h1, "onTransitionEnd"), Ao("onMouseEnter", ["mouseout", "mouseover"]), Ao("onMouseLeave", ["mouseout", "mouseover"]), Ao("onPointerEnter", ["pointerout", "pointerover"]), Ao("onPointerLeave", ["pointerout", "pointerover"]), wr(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), wr(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), wr("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), wr(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), wr(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), wr(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var Et = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), S3 = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Et)
  );
  function hu(l, o) {
    o = (o & 4) !== 0;
    for (var c = 0; c < l.length; c++) {
      var m = l[c], S = m.event;
      m = m.listeners;
      e: {
        var w = void 0;
        if (o)
          for (var _ = m.length - 1; 0 <= _; _--) {
            var H = m[_], Z = H.instance, fe = H.currentTarget;
            if (H = H.listener, Z !== w && S.isPropagationStopped())
              break e;
            w = H, S.currentTarget = fe;
            try {
              w(S);
            } catch (Oe) {
              ef(Oe);
            }
            S.currentTarget = null, w = Z;
          }
        else
          for (_ = 0; _ < m.length; _++) {
            if (H = m[_], Z = H.instance, fe = H.currentTarget, H = H.listener, Z !== w && S.isPropagationStopped())
              break e;
            w = H, S.currentTarget = fe;
            try {
              w(S);
            } catch (Oe) {
              ef(Oe);
            }
            S.currentTarget = null, w = Z;
          }
      }
    }
  }
  function Ct(l, o) {
    var c = o[Um];
    c === void 0 && (c = o[Um] = /* @__PURE__ */ new Set());
    var m = l + "__bubble";
    c.has(m) || (ny(o, l, 2, !1), c.add(m));
  }
  function ro(l, o, c) {
    var m = 0;
    o && (m |= 4), ny(
      c,
      l,
      m,
      o
    );
  }
  var ls = "_reactListening" + Math.random().toString(36).slice(2);
  function df(l) {
    if (!l[ls]) {
      l[ls] = !0, qm.forEach(function(c) {
        c !== "selectionchange" && (S3.has(c) || ro(c, !1, l), ro(c, !0, l));
      });
      var o = l.nodeType === 9 ? l : l.ownerDocument;
      o === null || o[ls] || (o[ls] = !0, ro("selectionchange", !1, o));
    }
  }
  function ny(l, o, c, m) {
    switch (dy(o)) {
      case 2:
        var S = fy;
        break;
      case 8:
        S = hy;
        break;
      default:
        S = qd;
    }
    c = S.bind(
      null,
      o,
      c,
      l
    ), S = void 0, !ch || o !== "touchstart" && o !== "touchmove" && o !== "wheel" || (S = !0), m ? S !== void 0 ? l.addEventListener(o, c, {
      capture: !0,
      passive: S
    }) : l.addEventListener(o, c, !0) : S !== void 0 ? l.addEventListener(o, c, {
      passive: S
    }) : l.addEventListener(o, c, !1);
  }
  function mf(l, o, c, m, S) {
    var w = m;
    if (!(o & 1) && !(o & 2) && m !== null)
      e: for (; ; ) {
        if (m === null) return;
        var _ = m.tag;
        if (_ === 3 || _ === 4) {
          var H = m.stateNode.containerInfo;
          if (H === S) break;
          if (_ === 4)
            for (_ = m.return; _ !== null; ) {
              var Z = _.tag;
              if ((Z === 3 || Z === 4) && _.stateNode.containerInfo === S)
                return;
              _ = _.return;
            }
          for (; H !== null; ) {
            if (_ = Ru(H), _ === null) return;
            if (Z = _.tag, Z === 5 || Z === 6 || Z === 26 || Z === 27) {
              m = w = _;
              continue e;
            }
            H = H.parentNode;
          }
        }
        m = m.return;
      }
    h4(function() {
      var fe = w, Oe = zo(c), Be = [];
      e: {
        var me = d1.get(l);
        if (me !== void 0) {
          var we = v0, mt = l;
          switch (l) {
            case "keypress":
              if (y0(c) === 0) break e;
            case "keydown":
            case "keyup":
              we = Oo;
              break;
            case "focusin":
              mt = "focus", we = Km;
              break;
            case "focusout":
              mt = "blur", we = Km;
              break;
            case "beforeblur":
            case "afterblur":
              we = Km;
              break;
            case "click":
              if (c.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              we = S0;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              we = p4;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              we = gh;
              break;
            case A0:
            case T4:
            case c1:
              we = o3;
              break;
            case h1:
              we = ha;
              break;
            case "scroll":
            case "scrollend":
              we = i3;
              break;
            case "wheel":
              we = yh;
              break;
            case "copy":
            case "cut":
            case "paste":
              we = c3;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              we = fa;
              break;
            case "toggle":
            case "beforetoggle":
              we = t1;
          }
          var ct = (o & 4) !== 0, un = !ct && (l === "scroll" || l === "scrollend"), oe = ct ? me !== null ? me + "Capture" : null : me;
          ct = [];
          for (var ae = fe, he; ae !== null; ) {
            var Le = ae;
            if (he = Le.stateNode, Le = Le.tag, Le !== 5 && Le !== 26 && Le !== 27 || he === null || oe === null || (Le = Yi(ae, oe), Le != null && ct.push(
              za(ae, Le, he)
            )), un) break;
            ae = ae.return;
          }
          0 < ct.length && (me = new we(
            me,
            mt,
            null,
            c,
            Oe
          ), Be.push({ event: me, listeners: ct }));
        }
      }
      if (!(o & 7)) {
        e: {
          if (me = l === "mouseover" || l === "pointerover", we = l === "mouseout" || l === "pointerout", me && c !== sh && (mt = c.relatedTarget || c.fromElement) && (Ru(mt) || mt[Eo]))
            break e;
          if ((we || me) && (me = Oe.window === Oe ? Oe : (me = Oe.ownerDocument) ? me.defaultView || me.parentWindow : window, we ? (mt = c.relatedTarget || c.toElement, we = fe, mt = mt ? Ru(mt) : null, mt !== null && (un = h(mt), ct = mt.tag, mt !== un || ct !== 5 && ct !== 27 && ct !== 6) && (mt = null)) : (we = null, mt = fe), we !== mt)) {
            if (ct = S0, Le = "onMouseLeave", oe = "onMouseEnter", ae = "mouse", (l === "pointerout" || l === "pointerover") && (ct = fa, Le = "onPointerLeave", oe = "onPointerEnter", ae = "pointer"), un = we == null ? me : Ms(we), he = mt == null ? me : Ms(mt), me = new ct(
              Le,
              ae + "leave",
              we,
              c,
              Oe
            ), me.target = un, me.relatedTarget = he, Le = null, Ru(Oe) === fe && (ct = new ct(
              oe,
              ae + "enter",
              mt,
              c,
              Oe
            ), ct.target = he, ct.relatedTarget = un, Le = ct), un = Le, we && mt)
              t: {
                for (ct = we, oe = mt, ae = 0, he = ct; he; he = lo(he))
                  ae++;
                for (he = 0, Le = oe; Le; Le = lo(Le))
                  he++;
                for (; 0 < ae - he; )
                  ct = lo(ct), ae--;
                for (; 0 < he - ae; )
                  oe = lo(oe), he--;
                for (; ae--; ) {
                  if (ct === oe || oe !== null && ct === oe.alternate)
                    break t;
                  ct = lo(ct), oe = lo(oe);
                }
                ct = null;
              }
            else ct = null;
            we !== null && zd(
              Be,
              me,
              we,
              ct,
              !1
            ), mt !== null && un !== null && zd(
              Be,
              un,
              mt,
              ct,
              !0
            );
          }
        }
        e: {
          if (me = fe ? Ms(fe) : window, we = me.nodeName && me.nodeName.toLowerCase(), we === "select" || we === "input" && me.type === "file")
            var Je = _u;
          else if (l1(me))
            if (i1)
              Je = Ii;
            else {
              Je = Th;
              var Nt = w4;
            }
          else
            we = me.nodeName, !we || we.toLowerCase() !== "input" || me.type !== "checkbox" && me.type !== "radio" ? fe && Bs(fe.elementType) && (Je = _u) : Je = Ou;
          if (Je && (Je = Je(l, fe))) {
            xh(
              Be,
              Je,
              c,
              Oe
            );
            break e;
          }
          Nt && Nt(l, me, fe), l === "focusout" && fe && me.type === "number" && fe.memoizedProps.value != null && d0(me, "number", me.value);
        }
        switch (Nt = fe ? Ms(fe) : window, l) {
          case "focusin":
            (l1(Nt) || Nt.contentEditable === "true") && (ul = Nt, qo = fe, Ha = null);
            break;
          case "focusout":
            Ha = qo = ul = null;
            break;
          case "mousedown":
            Ys = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Ys = !1, Is(Be, c, Oe);
            break;
          case "selectionchange":
            if (s1) break;
          case "keydown":
          case "keyup":
            Is(Be, c, Oe);
        }
        var ot;
        if (vh)
          e: {
            switch (l) {
              case "compositionstart":
                var pt = "onCompositionStart";
                break e;
              case "compositionend":
                pt = "onCompositionEnd";
                break e;
              case "compositionupdate":
                pt = "onCompositionUpdate";
                break e;
            }
            pt = void 0;
          }
        else
          il ? Sh(l, c) && (pt = "onCompositionEnd") : l === "keydown" && c.keyCode === 229 && (pt = "onCompositionStart");
        pt && (bh && c.locale !== "ko" && (il || pt !== "onCompositionStart" ? pt === "onCompositionEnd" && il && (ot = g0()) : (ll = Oe, fh = "value" in ll ? ll.value : ll.textContent, il = !0)), Nt = ao(fe, pt), 0 < Nt.length && (pt = new Jm(
          pt,
          l,
          null,
          c,
          Oe
        ), Be.push({ event: pt, listeners: Nt }), ot ? pt.data = ot : (ot = w0(c), ot !== null && (pt.data = ot)))), (ot = f3 ? r1(l, c) : a1(l, c)) && (pt = ao(fe, "onBeforeInput"), 0 < pt.length && (Nt = new Jm(
          "onBeforeInput",
          "beforeinput",
          null,
          c,
          Oe
        ), Be.push({
          event: Nt,
          listeners: pt
        }), Nt.data = ot)), kd(
          Be,
          l,
          fe,
          c,
          Oe
        );
      }
      hu(Be, o);
    });
  }
  function za(l, o, c) {
    return {
      instance: l,
      listener: o,
      currentTarget: c
    };
  }
  function ao(l, o) {
    for (var c = o + "Capture", m = []; l !== null; ) {
      var S = l, w = S.stateNode;
      if (S = S.tag, S !== 5 && S !== 26 && S !== 27 || w === null || (S = Yi(l, c), S != null && m.unshift(
        za(l, S, w)
      ), S = Yi(l, o), S != null && m.push(
        za(l, S, w)
      )), l.tag === 3) return m;
      l = l.return;
    }
    return [];
  }
  function lo(l) {
    if (l === null) return null;
    do
      l = l.return;
    while (l && l.tag !== 5 && l.tag !== 27);
    return l || null;
  }
  function zd(l, o, c, m, S) {
    for (var w = o._reactName, _ = []; c !== null && c !== m; ) {
      var H = c, Z = H.alternate, fe = H.stateNode;
      if (H = H.tag, Z !== null && Z === m) break;
      H !== 5 && H !== 26 && H !== 27 || fe === null || (Z = fe, S ? (fe = Yi(c, w), fe != null && _.unshift(
        za(c, fe, Z)
      )) : S || (fe = Yi(c, w), fe != null && _.push(
        za(c, fe, Z)
      ))), c = c.return;
    }
    _.length !== 0 && l.push({ event: o, listeners: _ });
  }
  var Cd = /\r\n?/g, $a = /\u0000|\uFFFD/g;
  function Md(l) {
    return (typeof l == "string" ? l : "" + l).replace(Cd, `
`).replace($a, "");
  }
  function ry(l, o) {
    return o = Md(o), Md(l) === o;
  }
  function pf() {
  }
  function yn(l, o, c, m, S, w) {
    switch (c) {
      case "children":
        typeof m == "string" ? o === "body" || o === "textarea" && m === "" || Ro(l, m) : (typeof m == "number" || typeof m == "bigint") && o !== "body" && Ro(l, "" + m);
        break;
      case "className":
        Gi(l, "class", m);
        break;
      case "tabIndex":
        Gi(l, "tabindex", m);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Gi(l, c, m);
        break;
      case "style":
        oh(l, m, w);
        break;
      case "data":
        if (o !== "object") {
          Gi(l, "data", m);
          break;
        }
      case "src":
      case "href":
        if (m === "" && (o !== "a" || c !== "href")) {
          l.removeAttribute(c);
          break;
        }
        if (m == null || typeof m == "function" || typeof m == "symbol" || typeof m == "boolean") {
          l.removeAttribute(c);
          break;
        }
        m = p0("" + m), l.setAttribute(c, m);
        break;
      case "action":
      case "formAction":
        if (typeof m == "function") {
          l.setAttribute(
            c,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof w == "function" && (c === "formAction" ? (o !== "input" && yn(l, o, "name", S.name, S, null), yn(
            l,
            o,
            "formEncType",
            S.formEncType,
            S,
            null
          ), yn(
            l,
            o,
            "formMethod",
            S.formMethod,
            S,
            null
          ), yn(
            l,
            o,
            "formTarget",
            S.formTarget,
            S,
            null
          )) : (yn(l, o, "encType", S.encType, S, null), yn(l, o, "method", S.method, S, null), yn(l, o, "target", S.target, S, null)));
        if (m == null || typeof m == "symbol" || typeof m == "boolean") {
          l.removeAttribute(c);
          break;
        }
        m = p0("" + m), l.setAttribute(c, m);
        break;
      case "onClick":
        m != null && (l.onclick = pf);
        break;
      case "onScroll":
        m != null && Ct("scroll", l);
        break;
      case "onScrollEnd":
        m != null && Ct("scrollend", l);
        break;
      case "dangerouslySetInnerHTML":
        if (m != null) {
          if (typeof m != "object" || !("__html" in m))
            throw Error(i(61));
          if (c = m.__html, c != null) {
            if (S.children != null) throw Error(i(60));
            l.innerHTML = c;
          }
        }
        break;
      case "multiple":
        l.multiple = m && typeof m != "function" && typeof m != "symbol";
        break;
      case "muted":
        l.muted = m && typeof m != "function" && typeof m != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (m == null || typeof m == "function" || typeof m == "boolean" || typeof m == "symbol") {
          l.removeAttribute("xlink:href");
          break;
        }
        c = p0("" + m), l.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          c
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        m != null && typeof m != "function" && typeof m != "symbol" ? l.setAttribute(c, "" + m) : l.removeAttribute(c);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        m && typeof m != "function" && typeof m != "symbol" ? l.setAttribute(c, "") : l.removeAttribute(c);
        break;
      case "capture":
      case "download":
        m === !0 ? l.setAttribute(c, "") : m !== !1 && m != null && typeof m != "function" && typeof m != "symbol" ? l.setAttribute(c, m) : l.removeAttribute(c);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        m != null && typeof m != "function" && typeof m != "symbol" && !isNaN(m) && 1 <= m ? l.setAttribute(c, m) : l.removeAttribute(c);
        break;
      case "rowSpan":
      case "start":
        m == null || typeof m == "function" || typeof m == "symbol" || isNaN(m) ? l.removeAttribute(c) : l.setAttribute(c, m);
        break;
      case "popover":
        Ct("beforetoggle", l), Ct("toggle", l), h0(l, "popover", m);
        break;
      case "xlinkActuate":
        ii(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          m
        );
        break;
      case "xlinkArcrole":
        ii(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          m
        );
        break;
      case "xlinkRole":
        ii(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          m
        );
        break;
      case "xlinkShow":
        ii(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          m
        );
        break;
      case "xlinkTitle":
        ii(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          m
        );
        break;
      case "xlinkType":
        ii(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          m
        );
        break;
      case "xmlBase":
        ii(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          m
        );
        break;
      case "xmlLang":
        ii(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          m
        );
        break;
      case "xmlSpace":
        ii(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          m
        );
        break;
      case "is":
        h0(l, "is", m);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < c.length) || c[0] !== "o" && c[0] !== "O" || c[1] !== "n" && c[1] !== "N") && (c = m0.get(c) || c, h0(l, c, m));
    }
  }
  function gr(l, o, c, m, S, w) {
    switch (c) {
      case "style":
        oh(l, m, w);
        break;
      case "dangerouslySetInnerHTML":
        if (m != null) {
          if (typeof m != "object" || !("__html" in m))
            throw Error(i(61));
          if (c = m.__html, c != null) {
            if (S.children != null) throw Error(i(60));
            l.innerHTML = c;
          }
        }
        break;
      case "children":
        typeof m == "string" ? Ro(l, m) : (typeof m == "number" || typeof m == "bigint") && Ro(l, "" + m);
        break;
      case "onScroll":
        m != null && Ct("scroll", l);
        break;
      case "onScrollEnd":
        m != null && Ct("scrollend", l);
        break;
      case "onClick":
        m != null && (l.onclick = pf);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!f0.hasOwnProperty(c))
          e: {
            if (c[0] === "o" && c[1] === "n" && (S = c.endsWith("Capture"), o = c.slice(2, S ? c.length - 7 : void 0), w = l[Zr] || null, w = w != null ? w[c] : null, typeof w == "function" && l.removeEventListener(o, w, S), typeof m == "function")) {
              typeof w != "function" && w !== null && (c in l ? l[c] = null : l.hasAttribute(c) && l.removeAttribute(c)), l.addEventListener(o, m, S);
              break e;
            }
            c in l ? l[c] = m : m === !0 ? l.setAttribute(c, "") : h0(l, c, m);
          }
    }
  }
  function ye(l, o, c) {
    switch (o) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        Ct("error", l), Ct("load", l);
        var m = !1, S = !1, w;
        for (w in c)
          if (c.hasOwnProperty(w)) {
            var _ = c[w];
            if (_ != null)
              switch (w) {
                case "src":
                  m = !0;
                  break;
                case "srcSet":
                  S = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(i(137, o));
                default:
                  yn(l, o, w, _, c, null);
              }
          }
        S && yn(l, o, "srcSet", c.srcSet, c, null), m && yn(l, o, "src", c.src, c, null);
        return;
      case "input":
        Ct("invalid", l);
        var H = w = _ = S = null, Z = null, fe = null;
        for (m in c)
          if (c.hasOwnProperty(m)) {
            var Oe = c[m];
            if (Oe != null)
              switch (m) {
                case "name":
                  S = Oe;
                  break;
                case "type":
                  _ = Oe;
                  break;
                case "checked":
                  Z = Oe;
                  break;
                case "defaultChecked":
                  fe = Oe;
                  break;
                case "value":
                  w = Oe;
                  break;
                case "defaultValue":
                  H = Oe;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (Oe != null)
                    throw Error(i(137, o));
                  break;
                default:
                  yn(l, o, m, Oe, c, null);
              }
          }
        $m(
          l,
          w,
          H,
          Z,
          fe,
          _,
          S,
          !1
        ), Ns(l);
        return;
      case "select":
        Ct("invalid", l), m = _ = w = null;
        for (S in c)
          if (c.hasOwnProperty(S) && (H = c[S], H != null))
            switch (S) {
              case "value":
                w = H;
                break;
              case "defaultValue":
                _ = H;
                break;
              case "multiple":
                m = H;
              default:
                yn(l, o, S, H, c, null);
            }
        o = w, c = _, l.multiple = !!m, o != null ? Cu(l, !!m, o, !1) : c != null && Cu(l, !!m, c, !0);
        return;
      case "textarea":
        Ct("invalid", l), w = S = m = null;
        for (_ in c)
          if (c.hasOwnProperty(_) && (H = c[_], H != null))
            switch (_) {
              case "value":
                m = H;
                break;
              case "defaultValue":
                S = H;
                break;
              case "children":
                w = H;
                break;
              case "dangerouslySetInnerHTML":
                if (H != null) throw Error(i(91));
                break;
              default:
                yn(l, o, _, H, c, null);
            }
        Qm(l, m, S, w), Ns(l);
        return;
      case "option":
        for (Z in c)
          if (c.hasOwnProperty(Z) && (m = c[Z], m != null))
            switch (Z) {
              case "selected":
                l.selected = m && typeof m != "function" && typeof m != "symbol";
                break;
              default:
                yn(l, o, Z, m, c, null);
            }
        return;
      case "dialog":
        Ct("beforetoggle", l), Ct("toggle", l), Ct("cancel", l), Ct("close", l);
        break;
      case "iframe":
      case "object":
        Ct("load", l);
        break;
      case "video":
      case "audio":
        for (m = 0; m < Et.length; m++)
          Ct(Et[m], l);
        break;
      case "image":
        Ct("error", l), Ct("load", l);
        break;
      case "details":
        Ct("toggle", l);
        break;
      case "embed":
      case "source":
      case "link":
        Ct("error", l), Ct("load", l);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (fe in c)
          if (c.hasOwnProperty(fe) && (m = c[fe], m != null))
            switch (fe) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(i(137, o));
              default:
                yn(l, o, fe, m, c, null);
            }
        return;
      default:
        if (Bs(o)) {
          for (Oe in c)
            c.hasOwnProperty(Oe) && (m = c[Oe], m !== void 0 && gr(
              l,
              o,
              Oe,
              m,
              c,
              void 0
            ));
          return;
        }
    }
    for (H in c)
      c.hasOwnProperty(H) && (m = c[H], m != null && yn(l, o, H, m, c, null));
  }
  function ln(l, o, c, m) {
    switch (o) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var S = null, w = null, _ = null, H = null, Z = null, fe = null, Oe = null;
        for (we in c) {
          var Be = c[we];
          if (c.hasOwnProperty(we) && Be != null)
            switch (we) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                Z = Be;
              default:
                m.hasOwnProperty(we) || yn(l, o, we, null, m, Be);
            }
        }
        for (var me in m) {
          var we = m[me];
          if (Be = c[me], m.hasOwnProperty(me) && (we != null || Be != null))
            switch (me) {
              case "type":
                w = we;
                break;
              case "name":
                S = we;
                break;
              case "checked":
                fe = we;
                break;
              case "defaultChecked":
                Oe = we;
                break;
              case "value":
                _ = we;
                break;
              case "defaultValue":
                H = we;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (we != null)
                  throw Error(i(137, o));
                break;
              default:
                we !== Be && yn(
                  l,
                  o,
                  me,
                  we,
                  m,
                  Be
                );
            }
        }
        Im(
          l,
          _,
          H,
          Z,
          fe,
          Oe,
          w,
          S
        );
        return;
      case "select":
        we = _ = H = me = null;
        for (w in c)
          if (Z = c[w], c.hasOwnProperty(w) && Z != null)
            switch (w) {
              case "value":
                break;
              case "multiple":
                we = Z;
              default:
                m.hasOwnProperty(w) || yn(
                  l,
                  o,
                  w,
                  null,
                  m,
                  Z
                );
            }
        for (S in m)
          if (w = m[S], Z = c[S], m.hasOwnProperty(S) && (w != null || Z != null))
            switch (S) {
              case "value":
                me = w;
                break;
              case "defaultValue":
                H = w;
                break;
              case "multiple":
                _ = w;
              default:
                w !== Z && yn(
                  l,
                  o,
                  S,
                  w,
                  m,
                  Z
                );
            }
        o = H, c = _, m = we, me != null ? Cu(l, !!c, me, !1) : !!m != !!c && (o != null ? Cu(l, !!c, o, !0) : Cu(l, !!c, c ? [] : "", !1));
        return;
      case "textarea":
        we = me = null;
        for (H in c)
          if (S = c[H], c.hasOwnProperty(H) && S != null && !m.hasOwnProperty(H))
            switch (H) {
              case "value":
                break;
              case "children":
                break;
              default:
                yn(l, o, H, null, m, S);
            }
        for (_ in m)
          if (S = m[_], w = c[_], m.hasOwnProperty(_) && (S != null || w != null))
            switch (_) {
              case "value":
                me = S;
                break;
              case "defaultValue":
                we = S;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (S != null) throw Error(i(91));
                break;
              default:
                S !== w && yn(l, o, _, S, m, w);
            }
        Xm(l, me, we);
        return;
      case "option":
        for (var mt in c)
          if (me = c[mt], c.hasOwnProperty(mt) && me != null && !m.hasOwnProperty(mt))
            switch (mt) {
              case "selected":
                l.selected = !1;
                break;
              default:
                yn(
                  l,
                  o,
                  mt,
                  null,
                  m,
                  me
                );
            }
        for (Z in m)
          if (me = m[Z], we = c[Z], m.hasOwnProperty(Z) && me !== we && (me != null || we != null))
            switch (Z) {
              case "selected":
                l.selected = me && typeof me != "function" && typeof me != "symbol";
                break;
              default:
                yn(
                  l,
                  o,
                  Z,
                  me,
                  m,
                  we
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var ct in c)
          me = c[ct], c.hasOwnProperty(ct) && me != null && !m.hasOwnProperty(ct) && yn(l, o, ct, null, m, me);
        for (fe in m)
          if (me = m[fe], we = c[fe], m.hasOwnProperty(fe) && me !== we && (me != null || we != null))
            switch (fe) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (me != null)
                  throw Error(i(137, o));
                break;
              default:
                yn(
                  l,
                  o,
                  fe,
                  me,
                  m,
                  we
                );
            }
        return;
      default:
        if (Bs(o)) {
          for (var un in c)
            me = c[un], c.hasOwnProperty(un) && me !== void 0 && !m.hasOwnProperty(un) && gr(
              l,
              o,
              un,
              void 0,
              m,
              me
            );
          for (Oe in m)
            me = m[Oe], we = c[Oe], !m.hasOwnProperty(Oe) || me === we || me === void 0 && we === void 0 || gr(
              l,
              o,
              Oe,
              me,
              m,
              we
            );
          return;
        }
    }
    for (var oe in c)
      me = c[oe], c.hasOwnProperty(oe) && me != null && !m.hasOwnProperty(oe) && yn(l, o, oe, null, m, me);
    for (Be in m)
      me = m[Be], we = c[Be], !m.hasOwnProperty(Be) || me === we || me == null && we == null || yn(l, o, Be, me, m, we);
  }
  var Cp = null, gf = null;
  function _c(l) {
    return l.nodeType === 9 ? l : l.ownerDocument;
  }
  function mi(l) {
    switch (l) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function du(l, o) {
    if (l === 0)
      switch (o) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return l === 1 && o === "foreignObject" ? 0 : l;
  }
  function is(l, o) {
    return l === "textarea" || l === "noscript" || typeof o.children == "string" || typeof o.children == "number" || typeof o.children == "bigint" || typeof o.dangerouslySetInnerHTML == "object" && o.dangerouslySetInnerHTML !== null && o.dangerouslySetInnerHTML.__html != null;
  }
  var pi = null;
  function _d() {
    var l = window.event;
    return l && l.type === "popstate" ? l === pi ? !1 : (pi = l, !0) : (pi = null, !1);
  }
  var gi = typeof setTimeout == "function" ? setTimeout : void 0, Mp = typeof clearTimeout == "function" ? clearTimeout : void 0, ay = typeof Promise == "function" ? Promise : void 0, x3 = typeof queueMicrotask == "function" ? queueMicrotask : typeof ay < "u" ? function(l) {
    return ay.resolve(null).then(l).catch(w3);
  } : gi;
  function w3(l) {
    setTimeout(function() {
      throw l;
    });
  }
  function qr(l) {
    return l === "head";
  }
  function ly(l, o) {
    var c = o, m = 0, S = 0;
    do {
      var w = c.nextSibling;
      if (l.removeChild(c), w && w.nodeType === 8)
        if (c = w.data, c === "/$") {
          if (0 < m && 8 > m) {
            c = m;
            var _ = l.ownerDocument;
            if (c & 1 && Pe(_.documentElement), c & 2 && Pe(_.body), c & 4)
              for (c = _.head, Pe(c), _ = c.firstChild; _; ) {
                var H = _.nextSibling, Z = _.nodeName;
                _[c0] || Z === "SCRIPT" || Z === "STYLE" || Z === "LINK" && _.rel.toLowerCase() === "stylesheet" || c.removeChild(_), _ = H;
              }
          }
          if (S === 0) {
            l.removeChild(w), Uc(o);
            return;
          }
          S--;
        } else
          c === "$" || c === "$?" || c === "$!" ? S++ : m = c.charCodeAt(0) - 48;
      else m = 0;
      c = w;
    } while (c);
    Uc(o);
  }
  function yf(l) {
    var o = l.firstChild;
    for (o && o.nodeType === 10 && (o = o.nextSibling); o; ) {
      var c = o;
      switch (o = o.nextSibling, c.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          yf(c), at(c);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (c.rel.toLowerCase() === "stylesheet") continue;
      }
      l.removeChild(c);
    }
  }
  function _p(l, o, c, m) {
    for (; l.nodeType === 1; ) {
      var S = c;
      if (l.nodeName.toLowerCase() !== o.toLowerCase()) {
        if (!m && (l.nodeName !== "INPUT" || l.type !== "hidden"))
          break;
      } else if (m) {
        if (!l[c0])
          switch (o) {
            case "meta":
              if (!l.hasAttribute("itemprop")) break;
              return l;
            case "link":
              if (w = l.getAttribute("rel"), w === "stylesheet" && l.hasAttribute("data-precedence"))
                break;
              if (w !== S.rel || l.getAttribute("href") !== (S.href == null || S.href === "" ? null : S.href) || l.getAttribute("crossorigin") !== (S.crossOrigin == null ? null : S.crossOrigin) || l.getAttribute("title") !== (S.title == null ? null : S.title))
                break;
              return l;
            case "style":
              if (l.hasAttribute("data-precedence")) break;
              return l;
            case "script":
              if (w = l.getAttribute("src"), (w !== (S.src == null ? null : S.src) || l.getAttribute("type") !== (S.type == null ? null : S.type) || l.getAttribute("crossorigin") !== (S.crossOrigin == null ? null : S.crossOrigin)) && w && l.hasAttribute("async") && !l.hasAttribute("itemprop"))
                break;
              return l;
            default:
              return l;
          }
      } else if (o === "input" && l.type === "hidden") {
        var w = S.name == null ? null : "" + S.name;
        if (S.type === "hidden" && l.getAttribute("name") === w)
          return l;
      } else return l;
      if (l = Ql(l.nextSibling), l === null) break;
    }
    return null;
  }
  function Oc(l, o, c) {
    if (o === "") return null;
    for (; l.nodeType !== 3; )
      if ((l.nodeType !== 1 || l.nodeName !== "INPUT" || l.type !== "hidden") && !c || (l = Ql(l.nextSibling), l === null)) return null;
    return l;
  }
  function Op(l) {
    return l.data === "$!" || l.data === "$?" && l.ownerDocument.readyState === "complete";
  }
  function Dp(l, o) {
    var c = l.ownerDocument;
    if (l.data !== "$?" || c.readyState === "complete")
      o();
    else {
      var m = function() {
        o(), c.removeEventListener("DOMContentLoaded", m);
      };
      c.addEventListener("DOMContentLoaded", m), l._reactRetry = m;
    }
  }
  function Ql(l) {
    for (; l != null; l = l.nextSibling) {
      var o = l.nodeType;
      if (o === 1 || o === 3) break;
      if (o === 8) {
        if (o = l.data, o === "$" || o === "$!" || o === "$?" || o === "F!" || o === "F")
          break;
        if (o === "/$") return null;
      }
    }
    return l;
  }
  var Np = null;
  function us(l) {
    l = l.previousSibling;
    for (var o = 0; l; ) {
      if (l.nodeType === 8) {
        var c = l.data;
        if (c === "$" || c === "$!" || c === "$?") {
          if (o === 0) return l;
          o--;
        } else c === "/$" && o++;
      }
      l = l.previousSibling;
    }
    return null;
  }
  function jr(l, o, c) {
    switch (o = _c(c), l) {
      case "html":
        if (l = o.documentElement, !l) throw Error(i(452));
        return l;
      case "head":
        if (l = o.head, !l) throw Error(i(453));
        return l;
      case "body":
        if (l = o.body, !l) throw Error(i(454));
        return l;
      default:
        throw Error(i(451));
    }
  }
  function Pe(l) {
    for (var o = l.attributes; o.length; )
      l.removeAttributeNode(o[0]);
    at(l);
  }
  var Kn = /* @__PURE__ */ new Map(), gl = /* @__PURE__ */ new Set();
  function kr(l) {
    return typeof l.getRootNode == "function" ? l.getRootNode() : l.nodeType === 9 ? l : l.ownerDocument;
  }
  var mu = X.d;
  X.d = {
    f: T3,
    r: Od,
    D: yi,
    C: gu,
    L: Dd,
    m: io,
    X: Ca,
    S: Wr,
    M: uo
  };
  function T3() {
    var l = mu.f(), o = uf();
    return l || o;
  }
  function Od(l) {
    var o = Lr(l);
    o !== null && o.tag === 5 && o.type === "form" ? C4(o) : mu.r(l);
  }
  var pu = typeof document > "u" ? null : document;
  function Xa(l, o, c) {
    var m = pu;
    if (m && typeof o == "string" && o) {
      var S = al(o);
      S = 'link[rel="' + l + '"][href="' + S + '"]', typeof c == "string" && (S += '[crossorigin="' + c + '"]'), gl.has(S) || (gl.add(S), l = { rel: l, crossOrigin: c, href: o }, m.querySelector(S) === null && (o = m.createElement("link"), ye(o, "link", l), Fn(o), m.head.appendChild(o)));
    }
  }
  function yi(l) {
    mu.D(l), Xa("dns-prefetch", l, null);
  }
  function gu(l, o) {
    mu.C(l, o), Xa("preconnect", l, o);
  }
  function Dd(l, o, c) {
    mu.L(l, o, c);
    var m = pu;
    if (m && l && o) {
      var S = 'link[rel="preload"][as="' + al(o) + '"]';
      o === "image" && c && c.imageSrcSet ? (S += '[imagesrcset="' + al(
        c.imageSrcSet
      ) + '"]', typeof c.imageSizes == "string" && (S += '[imagesizes="' + al(
        c.imageSizes
      ) + '"]')) : S += '[href="' + al(l) + '"]';
      var w = S;
      switch (o) {
        case "style":
          w = Dc(l);
          break;
        case "script":
          w = os(l);
      }
      Kn.has(w) || (l = x(
        {
          rel: "preload",
          href: o === "image" && c && c.imageSrcSet ? void 0 : l,
          as: o
        },
        c
      ), Kn.set(w, l), m.querySelector(S) !== null || o === "style" && m.querySelector(vf(w)) || o === "script" && m.querySelector(Zl(w)) || (o = m.createElement("link"), ye(o, "link", l), Fn(o), m.head.appendChild(o)));
    }
  }
  function io(l, o) {
    mu.m(l, o);
    var c = pu;
    if (c && l) {
      var m = o && typeof o.as == "string" ? o.as : "script", S = 'link[rel="modulepreload"][as="' + al(m) + '"][href="' + al(l) + '"]', w = S;
      switch (m) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          w = os(l);
      }
      if (!Kn.has(w) && (l = x({ rel: "modulepreload", href: l }, o), Kn.set(w, l), c.querySelector(S) === null)) {
        switch (m) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (c.querySelector(Zl(w)))
              return;
        }
        m = c.createElement("link"), ye(m, "link", l), Fn(m), c.head.appendChild(m);
      }
    }
  }
  function Wr(l, o, c) {
    mu.S(l, o, c);
    var m = pu;
    if (m && l) {
      var S = _s(m).hoistableStyles, w = Dc(l);
      o = o || "default";
      var _ = S.get(w);
      if (!_) {
        var H = { loading: 0, preload: null };
        if (_ = m.querySelector(
          vf(w)
        ))
          H.loading = 5;
        else {
          l = x(
            { rel: "stylesheet", href: l, "data-precedence": o },
            c
          ), (c = Kn.get(w)) && Bp(l, c);
          var Z = _ = m.createElement("link");
          Fn(Z), ye(Z, "link", l), Z._p = new Promise(function(fe, Oe) {
            Z.onload = fe, Z.onerror = Oe;
          }), Z.addEventListener("load", function() {
            H.loading |= 1;
          }), Z.addEventListener("error", function() {
            H.loading |= 2;
          }), H.loading |= 4, Bd(_, o, m);
        }
        _ = {
          type: "stylesheet",
          instance: _,
          count: 1,
          state: H
        }, S.set(w, _);
      }
    }
  }
  function Ca(l, o) {
    mu.X(l, o);
    var c = pu;
    if (c && l) {
      var m = _s(c).hoistableScripts, S = os(l), w = m.get(S);
      w || (w = c.querySelector(Zl(S)), w || (l = x({ src: l, async: !0 }, o), (o = Kn.get(S)) && Hd(l, o), w = c.createElement("script"), Fn(w), ye(w, "link", l), c.head.appendChild(w)), w = {
        type: "script",
        instance: w,
        count: 1,
        state: null
      }, m.set(S, w));
    }
  }
  function uo(l, o) {
    mu.M(l, o);
    var c = pu;
    if (c && l) {
      var m = _s(c).hoistableScripts, S = os(l), w = m.get(S);
      w || (w = c.querySelector(Zl(S)), w || (l = x({ src: l, async: !0, type: "module" }, o), (o = Kn.get(S)) && Hd(l, o), w = c.createElement("script"), Fn(w), ye(w, "link", l), c.head.appendChild(w)), w = {
        type: "script",
        instance: w,
        count: 1,
        state: null
      }, m.set(S, w));
    }
  }
  function Nd(l, o, c, m) {
    var S = (S = Se.current) ? kr(S) : null;
    if (!S) throw Error(i(446));
    switch (l) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof c.precedence == "string" && typeof c.href == "string" ? (o = Dc(c.href), c = _s(
          S
        ).hoistableStyles, m = c.get(o), m || (m = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, c.set(o, m)), m) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (c.rel === "stylesheet" && typeof c.href == "string" && typeof c.precedence == "string") {
          l = Dc(c.href);
          var w = _s(
            S
          ).hoistableStyles, _ = w.get(l);
          if (_ || (S = S.ownerDocument || S, _ = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, w.set(l, _), (w = S.querySelector(
            vf(l)
          )) && !w._p && (_.instance = w, _.state.loading = 5), Kn.has(l) || (c = {
            rel: "preload",
            as: "style",
            href: c.href,
            crossOrigin: c.crossOrigin,
            integrity: c.integrity,
            media: c.media,
            hrefLang: c.hrefLang,
            referrerPolicy: c.referrerPolicy
          }, Kn.set(l, c), w || bf(
            S,
            l,
            c,
            _.state
          ))), o && m === null)
            throw Error(i(528, ""));
          return _;
        }
        if (o && m !== null)
          throw Error(i(529, ""));
        return null;
      case "script":
        return o = c.async, c = c.src, typeof c == "string" && o && typeof o != "function" && typeof o != "symbol" ? (o = os(c), c = _s(
          S
        ).hoistableScripts, m = c.get(o), m || (m = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, c.set(o, m)), m) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(i(444, l));
    }
  }
  function Dc(l) {
    return 'href="' + al(l) + '"';
  }
  function vf(l) {
    return 'link[rel="stylesheet"][' + l + "]";
  }
  function Lp(l) {
    return x({}, l, {
      "data-precedence": l.precedence,
      precedence: null
    });
  }
  function bf(l, o, c, m) {
    l.querySelector('link[rel="preload"][as="style"][' + o + "]") ? m.loading = 1 : (o = l.createElement("link"), m.preload = o, o.addEventListener("load", function() {
      return m.loading |= 1;
    }), o.addEventListener("error", function() {
      return m.loading |= 2;
    }), ye(o, "link", c), Fn(o), l.head.appendChild(o));
  }
  function os(l) {
    return '[src="' + al(l) + '"]';
  }
  function Zl(l) {
    return "script[async]" + l;
  }
  function Ld(l, o, c) {
    if (o.count++, o.instance === null)
      switch (o.type) {
        case "style":
          var m = l.querySelector(
            'style[data-href~="' + al(c.href) + '"]'
          );
          if (m)
            return o.instance = m, Fn(m), m;
          var S = x({}, c, {
            "data-href": c.href,
            "data-precedence": c.precedence,
            href: null,
            precedence: null
          });
          return m = (l.ownerDocument || l).createElement(
            "style"
          ), Fn(m), ye(m, "style", S), Bd(m, c.precedence, l), o.instance = m;
        case "stylesheet":
          S = Dc(c.href);
          var w = l.querySelector(
            vf(S)
          );
          if (w)
            return o.state.loading |= 4, o.instance = w, Fn(w), w;
          m = Lp(c), (S = Kn.get(S)) && Bp(m, S), w = (l.ownerDocument || l).createElement("link"), Fn(w);
          var _ = w;
          return _._p = new Promise(function(H, Z) {
            _.onload = H, _.onerror = Z;
          }), ye(w, "link", m), o.state.loading |= 4, Bd(w, c.precedence, l), o.instance = w;
        case "script":
          return w = os(c.src), (S = l.querySelector(
            Zl(w)
          )) ? (o.instance = S, Fn(S), S) : (m = c, (S = Kn.get(w)) && (m = x({}, c), Hd(m, S)), l = l.ownerDocument || l, S = l.createElement("script"), Fn(S), ye(S, "link", m), l.head.appendChild(S), o.instance = S);
        case "void":
          return null;
        default:
          throw Error(i(443, o.type));
      }
    else
      o.type === "stylesheet" && !(o.state.loading & 4) && (m = o.instance, o.state.loading |= 4, Bd(m, c.precedence, l));
    return o.instance;
  }
  function Bd(l, o, c) {
    for (var m = c.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), S = m.length ? m[m.length - 1] : null, w = S, _ = 0; _ < m.length; _++) {
      var H = m[_];
      if (H.dataset.precedence === o) w = H;
      else if (w !== S) break;
    }
    w ? w.parentNode.insertBefore(l, w.nextSibling) : (o = c.nodeType === 9 ? c.head : c, o.insertBefore(l, o.firstChild));
  }
  function Bp(l, o) {
    l.crossOrigin == null && (l.crossOrigin = o.crossOrigin), l.referrerPolicy == null && (l.referrerPolicy = o.referrerPolicy), l.title == null && (l.title = o.title);
  }
  function Hd(l, o) {
    l.crossOrigin == null && (l.crossOrigin = o.crossOrigin), l.referrerPolicy == null && (l.referrerPolicy = o.referrerPolicy), l.integrity == null && (l.integrity = o.integrity);
  }
  var Sf = null;
  function Nc(l, o, c) {
    if (Sf === null) {
      var m = /* @__PURE__ */ new Map(), S = Sf = /* @__PURE__ */ new Map();
      S.set(c, m);
    } else
      S = Sf, m = S.get(c), m || (m = /* @__PURE__ */ new Map(), S.set(c, m));
    if (m.has(l)) return m;
    for (m.set(l, null), c = c.getElementsByTagName(l), S = 0; S < c.length; S++) {
      var w = c[S];
      if (!(w[c0] || w[bn] || l === "link" && w.getAttribute("rel") === "stylesheet") && w.namespaceURI !== "http://www.w3.org/2000/svg") {
        var _ = w.getAttribute(o) || "";
        _ = l + _;
        var H = m.get(_);
        H ? H.push(w) : m.set(_, [w]);
      }
    }
    return m;
  }
  function Hp(l, o, c) {
    l = l.ownerDocument || l, l.head.insertBefore(
      c,
      o === "title" ? l.querySelector("head > title") : null
    );
  }
  function iy(l, o, c) {
    if (c === 1 || o.itemProp != null) return !1;
    switch (l) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof o.precedence != "string" || typeof o.href != "string" || o.href === "")
          break;
        return !0;
      case "link":
        if (typeof o.rel != "string" || typeof o.href != "string" || o.href === "" || o.onLoad || o.onError)
          break;
        switch (o.rel) {
          case "stylesheet":
            return l = o.disabled, typeof o.precedence == "string" && l == null;
          default:
            return !0;
        }
      case "script":
        if (o.async && typeof o.async != "function" && typeof o.async != "symbol" && !o.onLoad && !o.onError && o.src && typeof o.src == "string")
          return !0;
    }
    return !1;
  }
  function Up(l) {
    return !(l.type === "stylesheet" && !(l.state.loading & 3));
  }
  var Lc = null;
  function uy() {
  }
  function oy(l, o, c) {
    if (Lc === null) throw Error(i(475));
    var m = Lc;
    if (o.type === "stylesheet" && (typeof c.media != "string" || matchMedia(c.media).matches !== !1) && !(o.state.loading & 4)) {
      if (o.instance === null) {
        var S = Dc(c.href), w = l.querySelector(
          vf(S)
        );
        if (w) {
          l = w._p, l !== null && typeof l == "object" && typeof l.then == "function" && (m.count++, m = Bc.bind(m), l.then(m, m)), o.state.loading |= 4, o.instance = w, Fn(w);
          return;
        }
        w = l.ownerDocument || l, c = Lp(c), (S = Kn.get(S)) && Bp(c, S), w = w.createElement("link"), Fn(w);
        var _ = w;
        _._p = new Promise(function(H, Z) {
          _.onload = H, _.onerror = Z;
        }), ye(w, "link", c), o.instance = w;
      }
      m.stylesheets === null && (m.stylesheets = /* @__PURE__ */ new Map()), m.stylesheets.set(o, l), (l = o.state.preload) && !(o.state.loading & 3) && (m.count++, o = Bc.bind(m), l.addEventListener("load", o), l.addEventListener("error", o));
    }
  }
  function sy() {
    if (Lc === null) throw Error(i(475));
    var l = Lc;
    return l.stylesheets && l.count === 0 && wf(l, l.stylesheets), 0 < l.count ? function(o) {
      var c = setTimeout(function() {
        if (l.stylesheets && wf(l, l.stylesheets), l.unsuspend) {
          var m = l.unsuspend;
          l.unsuspend = null, m();
        }
      }, 6e4);
      return l.unsuspend = o, function() {
        l.unsuspend = null, clearTimeout(c);
      };
    } : null;
  }
  function Bc() {
    if (this.count--, this.count === 0) {
      if (this.stylesheets) wf(this, this.stylesheets);
      else if (this.unsuspend) {
        var l = this.unsuspend;
        this.unsuspend = null, l();
      }
    }
  }
  var xf = null;
  function wf(l, o) {
    l.stylesheets = null, l.unsuspend !== null && (l.count++, xf = /* @__PURE__ */ new Map(), o.forEach(qp, l), xf = null, Bc.call(l));
  }
  function qp(l, o) {
    if (!(o.state.loading & 4)) {
      var c = xf.get(l);
      if (c) var m = c.get(null);
      else {
        c = /* @__PURE__ */ new Map(), xf.set(l, c);
        for (var S = l.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), w = 0; w < S.length; w++) {
          var _ = S[w];
          (_.nodeName === "LINK" || _.getAttribute("media") !== "not all") && (c.set(_.dataset.precedence, _), m = _);
        }
        m && c.set(null, m);
      }
      S = o.instance, _ = S.getAttribute("data-precedence"), w = c.get(_) || m, w === m && c.set(null, S), c.set(_, S), this.count++, m = Bc.bind(this), S.addEventListener("load", m), S.addEventListener("error", m), w ? w.parentNode.insertBefore(S, w.nextSibling) : (l = l.nodeType === 9 ? l.head : l, l.insertBefore(S, l.firstChild)), o.state.loading |= 4;
    }
  }
  var Gr = {
    $$typeof: $,
    Provider: null,
    Consumer: null,
    _currentValue: W,
    _currentValue2: W,
    _threadCount: 0
  };
  function vi(l, o, c, m, S, w, _, H) {
    this.tag = 1, this.containerInfo = l, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Qe(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Qe(0), this.hiddenUpdates = Qe(null), this.identifierPrefix = m, this.onUncaughtError = S, this.onCaughtError = w, this.onRecoverableError = _, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = H, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function cy(l, o, c, m, S, w, _, H, Z, fe, Oe, Be) {
    return l = new vi(
      l,
      o,
      c,
      _,
      H,
      Z,
      fe,
      Be
    ), o = 1, w === !0 && (o |= 24), w = ma(3, null, null, o), l.current = w, w.stateNode = l, o = y1(), o.refCount++, l.pooledCache = o, o.refCount++, w.memoizedState = {
      element: m,
      isDehydrated: c,
      cache: o
    }, B0(w), l;
  }
  function jp(l) {
    return l ? (l = Go, l) : Go;
  }
  function Gp(l, o, c, m, S, w) {
    S = jp(S), m.context === null ? m.context = S : m.pendingContext = S, m = Wi(o), m.payload = { element: c }, w = w === void 0 ? null : w, w !== null && (m.callback = w), c = ya(l, m, o), c !== null && (Ra(c, l, o), Io(c, l, o));
  }
  function Vp(l, o) {
    if (l = l.memoizedState, l !== null && l.dehydrated !== null) {
      var c = l.retryLane;
      l.retryLane = c !== 0 && c < o ? c : o;
    }
  }
  function Ud(l, o) {
    Vp(l, o), (l = l.alternate) && Vp(l, o);
  }
  function Yp(l) {
    if (l.tag === 13) {
      var o = Qi(l, 67108864);
      o !== null && Ra(o, l, 67108864), Ud(l, 67108864);
    }
  }
  var Tf = !0;
  function fy(l, o, c, m) {
    var S = J.T;
    J.T = null;
    var w = X.p;
    try {
      X.p = 2, qd(l, o, c, m);
    } finally {
      X.p = w, J.T = S;
    }
  }
  function hy(l, o, c, m) {
    var S = J.T;
    J.T = null;
    var w = X.p;
    try {
      X.p = 8, qd(l, o, c, m);
    } finally {
      X.p = w, J.T = S;
    }
  }
  function qd(l, o, c, m) {
    if (Tf) {
      var S = Ip(m);
      if (S === null)
        mf(
          l,
          o,
          m,
          Ef,
          c
        ), Xp(l, m);
      else if (Qp(
        S,
        l,
        o,
        c,
        m
      ))
        m.stopPropagation();
      else if (Xp(l, m), o & 4 && -1 < E3.indexOf(l)) {
        for (; S !== null; ) {
          var w = Lr(S);
          if (w !== null)
            switch (w.tag) {
              case 3:
                if (w = w.stateNode, w.current.memoizedState.isDehydrated) {
                  var _ = Hn(w.pendingLanes);
                  if (_ !== 0) {
                    var H = w;
                    for (H.pendingLanes |= 2, H.entangledLanes |= 2; _; ) {
                      var Z = 1 << 31 - st(_);
                      H.entanglements[1] |= Z, _ &= ~Z;
                    }
                    Xl(w), !(cn & 6) && (fd = Bt() + 500, fu(0));
                  }
                }
                break;
              case 13:
                H = Qi(w, 2), H !== null && Ra(H, w, 2), uf(), Ud(w, 2);
            }
          if (w = Ip(m), w === null && mf(
            l,
            o,
            m,
            Ef,
            c
          ), w === S) break;
          S = w;
        }
        S !== null && m.stopPropagation();
      } else
        mf(
          l,
          o,
          m,
          null,
          c
        );
    }
  }
  function Ip(l) {
    return l = zo(l), $p(l);
  }
  var Ef = null;
  function $p(l) {
    if (Ef = null, l = Ru(l), l !== null) {
      var o = h(l);
      if (o === null) l = null;
      else {
        var c = o.tag;
        if (c === 13) {
          if (l = d(o), l !== null) return l;
          l = null;
        } else if (c === 3) {
          if (o.stateNode.current.memoizedState.isDehydrated)
            return o.tag === 3 ? o.stateNode.containerInfo : null;
          l = null;
        } else o !== l && (l = null);
      }
    }
    return Ef = l, null;
  }
  function dy(l) {
    switch (l) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (er()) {
          case sr:
            return 2;
          case El:
            return 8;
          case xt:
          case nl:
            return 32;
          case Tn:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var jd = !1, Fl = null, bi = null, yu = null, Hc = /* @__PURE__ */ new Map(), Af = /* @__PURE__ */ new Map(), oo = [], E3 = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function Xp(l, o) {
    switch (l) {
      case "focusin":
      case "focusout":
        Fl = null;
        break;
      case "dragenter":
      case "dragleave":
        bi = null;
        break;
      case "mouseover":
      case "mouseout":
        yu = null;
        break;
      case "pointerover":
      case "pointerout":
        Hc.delete(o.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Af.delete(o.pointerId);
    }
  }
  function Si(l, o, c, m, S, w) {
    return l === null || l.nativeEvent !== w ? (l = {
      blockedOn: o,
      domEventName: c,
      eventSystemFlags: m,
      nativeEvent: w,
      targetContainers: [S]
    }, o !== null && (o = Lr(o), o !== null && Yp(o)), l) : (l.eventSystemFlags |= m, o = l.targetContainers, S !== null && o.indexOf(S) === -1 && o.push(S), l);
  }
  function Qp(l, o, c, m, S) {
    switch (o) {
      case "focusin":
        return Fl = Si(
          Fl,
          l,
          o,
          c,
          m,
          S
        ), !0;
      case "dragenter":
        return bi = Si(
          bi,
          l,
          o,
          c,
          m,
          S
        ), !0;
      case "mouseover":
        return yu = Si(
          yu,
          l,
          o,
          c,
          m,
          S
        ), !0;
      case "pointerover":
        var w = S.pointerId;
        return Hc.set(
          w,
          Si(
            Hc.get(w) || null,
            l,
            o,
            c,
            m,
            S
          )
        ), !0;
      case "gotpointercapture":
        return w = S.pointerId, Af.set(
          w,
          Si(
            Af.get(w) || null,
            l,
            o,
            c,
            m,
            S
          )
        ), !0;
    }
    return !1;
  }
  function Zp(l) {
    var o = Ru(l.target);
    if (o !== null) {
      var c = h(o);
      if (c !== null) {
        if (o = c.tag, o === 13) {
          if (o = d(c), o !== null) {
            l.blockedOn = o, Hm(l.priority, function() {
              if (c.tag === 13) {
                var m = Ia();
                m = Tt(m);
                var S = Qi(c, m);
                S !== null && Ra(S, c, m), Ud(c, m);
              }
            });
            return;
          }
        } else if (o === 3 && c.stateNode.current.memoizedState.isDehydrated) {
          l.blockedOn = c.tag === 3 ? c.stateNode.containerInfo : null;
          return;
        }
      }
    }
    l.blockedOn = null;
  }
  function kf(l) {
    if (l.blockedOn !== null) return !1;
    for (var o = l.targetContainers; 0 < o.length; ) {
      var c = Ip(l.nativeEvent);
      if (c === null) {
        c = l.nativeEvent;
        var m = new c.constructor(
          c.type,
          c
        );
        sh = m, c.target.dispatchEvent(m), sh = null;
      } else
        return o = Lr(c), o !== null && Yp(o), l.blockedOn = c, !1;
      o.shift();
    }
    return !0;
  }
  function Fp(l, o, c) {
    kf(l) && c.delete(o);
  }
  function Gd() {
    jd = !1, Fl !== null && kf(Fl) && (Fl = null), bi !== null && kf(bi) && (bi = null), yu !== null && kf(yu) && (yu = null), Hc.forEach(Fp), Af.forEach(Fp);
  }
  function vu(l, o) {
    l.blockedOn === o && (l.blockedOn = null, jd || (jd = !0, r.unstable_scheduleCallback(
      r.unstable_NormalPriority,
      Gd
    )));
  }
  var Vd = null;
  function Rf(l) {
    Vd !== l && (Vd = l, r.unstable_scheduleCallback(
      r.unstable_NormalPriority,
      function() {
        Vd === l && (Vd = null);
        for (var o = 0; o < l.length; o += 3) {
          var c = l[o], m = l[o + 1], S = l[o + 2];
          if (typeof m != "function") {
            if ($p(m || c) === null)
              continue;
            break;
          }
          var w = Lr(c);
          w !== null && (l.splice(o, 3), o -= 3, j1(
            w,
            {
              pending: !0,
              data: S,
              method: c.method,
              action: m
            },
            m,
            S
          ));
        }
      }
    ));
  }
  function Uc(l) {
    function o(Z) {
      return vu(Z, l);
    }
    Fl !== null && vu(Fl, l), bi !== null && vu(bi, l), yu !== null && vu(yu, l), Hc.forEach(o), Af.forEach(o);
    for (var c = 0; c < oo.length; c++) {
      var m = oo[c];
      m.blockedOn === l && (m.blockedOn = null);
    }
    for (; 0 < oo.length && (c = oo[0], c.blockedOn === null); )
      Zp(c), c.blockedOn === null && oo.shift();
    if (c = (l.ownerDocument || l).$$reactFormReplay, c != null)
      for (m = 0; m < c.length; m += 3) {
        var S = c[m], w = c[m + 1], _ = S[Zr] || null;
        if (typeof w == "function")
          _ || Rf(c);
        else if (_) {
          var H = null;
          if (w && w.hasAttribute("formAction")) {
            if (S = w, _ = w[Zr] || null)
              H = _.formAction;
            else if ($p(S) !== null) continue;
          } else H = _.action;
          typeof H == "function" ? c[m + 1] = H : (c.splice(m, 3), m -= 3), Rf(c);
        }
      }
  }
  function so(l) {
    this._internalRoot = l;
  }
  Yd.prototype.render = so.prototype.render = function(l) {
    var o = this._internalRoot;
    if (o === null) throw Error(i(409));
    var c = o.current, m = Ia();
    Gp(c, m, l, o, null, null);
  }, Yd.prototype.unmount = so.prototype.unmount = function() {
    var l = this._internalRoot;
    if (l !== null) {
      this._internalRoot = null;
      var o = l.containerInfo;
      Gp(l.current, 2, null, l, null, null), uf(), o[Eo] = null;
    }
  };
  function Yd(l) {
    this._internalRoot = l;
  }
  Yd.prototype.unstable_scheduleHydration = function(l) {
    if (l) {
      var o = ai();
      l = { blockedOn: null, target: l, priority: o };
      for (var c = 0; c < oo.length && o !== 0 && o < oo[c].priority; c++) ;
      oo.splice(c, 0, l), c === 0 && Zp(l);
    }
  };
  var my = t.version;
  if (my !== "19.1.0")
    throw Error(
      i(
        527,
        my,
        "19.1.0"
      )
    );
  X.findDOMNode = function(l) {
    var o = l._reactInternals;
    if (o === void 0)
      throw typeof l.render == "function" ? Error(i(188)) : (l = Object.keys(l).join(","), Error(i(268, l)));
    return l = g(o), l = l !== null ? b(l) : null, l = l === null ? null : l.stateNode, l;
  };
  var py = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: J,
    reconcilerVersion: "19.1.0"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Rr = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Rr.isDisabled && Rr.supportsFiber)
      try {
        ke = Rr.inject(
          py
        ), je = Rr;
      } catch {
      }
  }
  return Og.createRoot = function(l, o) {
    if (!s(l)) throw Error(i(299));
    var c = !1, m = "", S = Z1, w = pc, _ = F1, H = null;
    return o != null && (o.unstable_strictMode === !0 && (c = !0), o.identifierPrefix !== void 0 && (m = o.identifierPrefix), o.onUncaughtError !== void 0 && (S = o.onUncaughtError), o.onCaughtError !== void 0 && (w = o.onCaughtError), o.onRecoverableError !== void 0 && (_ = o.onRecoverableError), o.unstable_transitionCallbacks !== void 0 && (H = o.unstable_transitionCallbacks)), o = cy(
      l,
      1,
      !1,
      null,
      null,
      c,
      m,
      S,
      w,
      _,
      H,
      null
    ), l[Eo] = o.current, df(l), new so(o);
  }, Og.hydrateRoot = function(l, o, c) {
    if (!s(l)) throw Error(i(299));
    var m = !1, S = "", w = Z1, _ = pc, H = F1, Z = null, fe = null;
    return c != null && (c.unstable_strictMode === !0 && (m = !0), c.identifierPrefix !== void 0 && (S = c.identifierPrefix), c.onUncaughtError !== void 0 && (w = c.onUncaughtError), c.onCaughtError !== void 0 && (_ = c.onCaughtError), c.onRecoverableError !== void 0 && (H = c.onRecoverableError), c.unstable_transitionCallbacks !== void 0 && (Z = c.unstable_transitionCallbacks), c.formState !== void 0 && (fe = c.formState)), o = cy(
      l,
      1,
      !0,
      o,
      c ?? null,
      m,
      S,
      w,
      _,
      H,
      Z,
      fe
    ), o.context = jp(null), c = o.current, m = Ia(), m = Tt(m), S = Wi(m), S.callback = null, ya(c, S, m), c = m, o.current.lanes = c, et(o, c), Xl(o), l[Eo] = o.current, df(l), new Yd(o);
  }, Og.version = "19.1.0", Og;
}
var Dg = {}, l2;
function qE() {
  if (l2) return Dg;
  l2 = 1;
  var r = {};
  /**
   * @license React
   * react-dom-client.development.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return r.NODE_ENV !== "production" && function() {
    function t(e, n) {
      for (e = e.memoizedState; e !== null && 0 < n; )
        e = e.next, n--;
      return e;
    }
    function a(e, n, u, f) {
      if (u >= n.length) return f;
      var p = n[u], v = gr(e) ? e.slice() : Et({}, e);
      return v[p] = a(e[p], n, u + 1, f), v;
    }
    function i(e, n, u) {
      if (n.length !== u.length)
        console.warn("copyWithRename() expects paths of the same length");
      else {
        for (var f = 0; f < u.length - 1; f++)
          if (n[f] !== u[f]) {
            console.warn(
              "copyWithRename() expects paths to be the same except for the deepest key"
            );
            return;
          }
        return s(e, n, u, 0);
      }
    }
    function s(e, n, u, f) {
      var p = n[f], v = gr(e) ? e.slice() : Et({}, e);
      return f + 1 === n.length ? (v[u[f]] = v[p], gr(v) ? v.splice(p, 1) : delete v[p]) : v[p] = s(
        e[p],
        n,
        u,
        f + 1
      ), v;
    }
    function h(e, n, u) {
      var f = n[u], p = gr(e) ? e.slice() : Et({}, e);
      return u + 1 === n.length ? (gr(p) ? p.splice(f, 1) : delete p[f], p) : (p[f] = h(e[f], n, u + 1), p);
    }
    function d() {
      return !1;
    }
    function y() {
      return null;
    }
    function g() {
    }
    function b() {
      console.error(
        "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks"
      );
    }
    function x() {
      console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      );
    }
    function T() {
    }
    function R(e) {
      var n = [];
      return e.forEach(function(u) {
        n.push(u);
      }), n.sort().join(", ");
    }
    function E(e, n, u, f) {
      return new f3(e, n, u, f);
    }
    function O(e, n) {
      e.context === qc && (sf(e.current, 2, n, e, null, null), Jo());
    }
    function L(e, n) {
      if (Ti !== null) {
        var u = n.staleFamilies;
        n = n.updatedFamilies, $u(), No(
          e.current,
          n,
          u
        ), Jo();
      }
    }
    function G(e) {
      Ti = e;
    }
    function V(e) {
      return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
    }
    function I(e) {
      var n = e, u = e;
      if (e.alternate) for (; n.return; ) n = n.return;
      else {
        e = n;
        do
          n = e, n.flags & 4098 && (u = n.return), e = n.return;
        while (e);
      }
      return n.tag === 3 ? u : null;
    }
    function $(e) {
      if (e.tag === 13) {
        var n = e.memoizedState;
        if (n === null && (e = e.alternate, e !== null && (n = e.memoizedState)), n !== null) return n.dehydrated;
      }
      return null;
    }
    function ce(e) {
      if (I(e) !== e)
        throw Error("Unable to find node on an unmounted component.");
    }
    function se(e) {
      var n = e.alternate;
      if (!n) {
        if (n = I(e), n === null)
          throw Error("Unable to find node on an unmounted component.");
        return n !== e ? null : e;
      }
      for (var u = e, f = n; ; ) {
        var p = u.return;
        if (p === null) break;
        var v = p.alternate;
        if (v === null) {
          if (f = p.return, f !== null) {
            u = f;
            continue;
          }
          break;
        }
        if (p.child === v.child) {
          for (v = p.child; v; ) {
            if (v === u) return ce(p), e;
            if (v === f) return ce(p), n;
            v = v.sibling;
          }
          throw Error("Unable to find node on an unmounted component.");
        }
        if (u.return !== f.return) u = p, f = v;
        else {
          for (var k = !1, M = p.child; M; ) {
            if (M === u) {
              k = !0, u = p, f = v;
              break;
            }
            if (M === f) {
              k = !0, f = p, u = v;
              break;
            }
            M = M.sibling;
          }
          if (!k) {
            for (M = v.child; M; ) {
              if (M === u) {
                k = !0, u = v, f = p;
                break;
              }
              if (M === f) {
                k = !0, f = v, u = p;
                break;
              }
              M = M.sibling;
            }
            if (!k)
              throw Error(
                "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue."
              );
          }
        }
        if (u.alternate !== f)
          throw Error(
            "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue."
          );
      }
      if (u.tag !== 3)
        throw Error("Unable to find node on an unmounted component.");
      return u.stateNode.current === u ? e : n;
    }
    function te(e) {
      var n = e.tag;
      if (n === 5 || n === 26 || n === 27 || n === 6) return e;
      for (e = e.child; e !== null; ) {
        if (n = te(e), n !== null) return n;
        e = e.sibling;
      }
      return null;
    }
    function Ce(e) {
      return e === null || typeof e != "object" ? null : (e = pf && e[pf] || e["@@iterator"], typeof e == "function" ? e : null);
    }
    function ve(e) {
      if (e == null) return null;
      if (typeof e == "function")
        return e.$$typeof === yn ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case ro:
          return "Fragment";
        case df:
          return "Profiler";
        case ls:
          return "StrictMode";
        case lo:
          return "Suspense";
        case zd:
          return "SuspenseList";
        case Md:
          return "Activity";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case Ct:
            return "Portal";
          case za:
            return (e.displayName || "Context") + ".Provider";
          case mf:
            return (e._context.displayName || "Context") + ".Consumer";
          case ao:
            var n = e.render;
            return e = e.displayName, e || (e = n.displayName || n.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case Cd:
            return n = e.displayName || null, n !== null ? n : ve(e.type) || "Memo";
          case $a:
            n = e._payload, e = e._init;
            try {
              return ve(e(n));
            } catch {
            }
        }
      return null;
    }
    function Ne(e) {
      return typeof e.tag == "number" ? ee(e) : typeof e.name == "string" ? e.name : null;
    }
    function ee(e) {
      var n = e.type;
      switch (e.tag) {
        case 31:
          return "Activity";
        case 24:
          return "Cache";
        case 9:
          return (n._context.displayName || "Context") + ".Consumer";
        case 10:
          return (n.displayName || "Context") + ".Provider";
        case 18:
          return "DehydratedFragment";
        case 11:
          return e = n.render, e = e.displayName || e.name || "", n.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 26:
        case 27:
        case 5:
          return n;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return ve(n);
        case 8:
          return n === ls ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 14:
        case 15:
          if (typeof n == "function")
            return n.displayName || n.name || null;
          if (typeof n == "string") return n;
          break;
        case 29:
          if (n = e._debugInfo, n != null) {
            for (var u = n.length - 1; 0 <= u; u--)
              if (typeof n[u].name == "string") return n[u].name;
          }
          if (e.return !== null)
            return ee(e.return);
      }
      return null;
    }
    function De(e) {
      return { current: e };
    }
    function de(e, n) {
      0 > mi ? console.error("Unexpected pop.") : (n !== _c[mi] && console.error("Unexpected Fiber popped."), e.current = gf[mi], gf[mi] = null, _c[mi] = null, mi--);
    }
    function Ye(e, n, u) {
      mi++, gf[mi] = e.current, _c[mi] = u, e.current = n;
    }
    function Te(e) {
      return e === null && console.error(
        "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue."
      ), e;
    }
    function re(e, n) {
      Ye(pi, n, e), Ye(is, e, e), Ye(du, null, e);
      var u = n.nodeType;
      switch (u) {
        case 9:
        case 11:
          u = u === 9 ? "#document" : "#fragment", n = (n = n.documentElement) && (n = n.namespaceURI) ? Aa(n) : ys;
          break;
        default:
          if (u = n.tagName, n = n.namespaceURI)
            n = Aa(n), n = ou(
              n,
              u
            );
          else
            switch (u) {
              case "svg":
                n = ym;
                break;
              case "math":
                n = Iy;
                break;
              default:
                n = ys;
            }
      }
      u = u.toLowerCase(), u = Qm(null, u), u = {
        context: n,
        ancestorInfo: u
      }, de(du, e), Ye(du, u, e);
    }
    function J(e) {
      de(du, e), de(is, e), de(pi, e);
    }
    function X() {
      return Te(du.current);
    }
    function W(e) {
      e.memoizedState !== null && Ye(_d, e, e);
      var n = Te(du.current), u = e.type, f = ou(n.context, u);
      u = Qm(n.ancestorInfo, u), f = { context: f, ancestorInfo: u }, n !== f && (Ye(is, e, e), Ye(du, f, e));
    }
    function be(e) {
      is.current === e && (de(du, e), de(is, e)), _d.current === e && (de(_d, e), Rg._currentValue = Xf);
    }
    function C(e) {
      return typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
    }
    function Y(e) {
      try {
        return ie(e), !1;
      } catch {
        return !0;
      }
    }
    function ie(e) {
      return "" + e;
    }
    function N(e, n) {
      if (Y(e))
        return console.error(
          "The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.",
          n,
          C(e)
        ), ie(e);
    }
    function Me(e, n) {
      if (Y(e))
        return console.error(
          "The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.",
          n,
          C(e)
        ), ie(e);
    }
    function _e(e) {
      if (Y(e))
        return console.error(
          "Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.",
          C(e)
        ), ie(e);
    }
    function Se(e) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
      var n = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (n.isDisabled) return !0;
      if (!n.supportsFiber)
        return console.error(
          "The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"
        ), !0;
      try {
        us = n.inject(e), jr = n;
      } catch (u) {
        console.error("React instrumentation encountered an error: %s.", u);
      }
      return !!n.checkDCE;
    }
    function Ge(e) {
      if (typeof Ql == "function" && Np(e), jr && typeof jr.setStrictMode == "function")
        try {
          jr.setStrictMode(us, e);
        } catch (n) {
          Kn || (Kn = !0, console.error(
            "React instrumentation encountered an error: %s",
            n
          ));
        }
    }
    function rt(e) {
      Pe = e;
    }
    function ht() {
      Pe !== null && typeof Pe.markCommitStopped == "function" && Pe.markCommitStopped();
    }
    function vt(e) {
      Pe !== null && typeof Pe.markComponentRenderStarted == "function" && Pe.markComponentRenderStarted(e);
    }
    function St() {
      Pe !== null && typeof Pe.markComponentRenderStopped == "function" && Pe.markComponentRenderStopped();
    }
    function wn(e) {
      Pe !== null && typeof Pe.markRenderStarted == "function" && Pe.markRenderStarted(e);
    }
    function Dr() {
      Pe !== null && typeof Pe.markRenderStopped == "function" && Pe.markRenderStopped();
    }
    function jn(e, n) {
      Pe !== null && typeof Pe.markStateUpdateScheduled == "function" && Pe.markStateUpdateScheduled(e, n);
    }
    function Gn(e) {
      return e >>>= 0, e === 0 ? 32 : 31 - (mu(e) / T3 | 0) | 0;
    }
    function xr(e) {
      if (e & 1) return "SyncHydrationLane";
      if (e & 2) return "Sync";
      if (e & 4) return "InputContinuousHydration";
      if (e & 8) return "InputContinuous";
      if (e & 16) return "DefaultHydration";
      if (e & 32) return "Default";
      if (e & 128) return "TransitionHydration";
      if (e & 4194048) return "Transition";
      if (e & 62914560) return "Retry";
      if (e & 67108864) return "SelectiveHydration";
      if (e & 134217728) return "IdleHydration";
      if (e & 268435456) return "Idle";
      if (e & 536870912) return "Offscreen";
      if (e & 1073741824) return "Deferred";
    }
    function Bt(e) {
      var n = e & 42;
      if (n !== 0) return n;
      switch (e & -e) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
          return 64;
        case 128:
          return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return e & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return e & 62914560;
        case 67108864:
          return 67108864;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 0;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), e;
      }
    }
    function er(e, n, u) {
      var f = e.pendingLanes;
      if (f === 0) return 0;
      var p = 0, v = e.suspendedLanes, k = e.pingedLanes;
      e = e.warmLanes;
      var M = f & 134217727;
      return M !== 0 ? (f = M & ~v, f !== 0 ? p = Bt(f) : (k &= M, k !== 0 ? p = Bt(k) : u || (u = M & ~e, u !== 0 && (p = Bt(u))))) : (M = f & ~v, M !== 0 ? p = Bt(M) : k !== 0 ? p = Bt(k) : u || (u = f & ~e, u !== 0 && (p = Bt(u)))), p === 0 ? 0 : n !== 0 && n !== p && !(n & v) && (v = p & -p, u = n & -n, v >= u || v === 32 && (u & 4194048) !== 0) ? n : p;
    }
    function sr(e, n) {
      return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & n) === 0;
    }
    function El(e, n) {
      switch (e) {
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
          return n + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return n + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), -1;
      }
    }
    function xt() {
      var e = Od;
      return Od <<= 1, !(Od & 4194048) && (Od = 256), e;
    }
    function nl() {
      var e = pu;
      return pu <<= 1, !(pu & 62914560) && (pu = 4194304), e;
    }
    function Tn(e) {
      for (var n = [], u = 0; 31 > u; u++) n.push(e);
      return n;
    }
    function cr(e, n) {
      e.pendingLanes |= n, n !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
    }
    function rl(e, n, u, f, p, v) {
      var k = e.pendingLanes;
      e.pendingLanes = u, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= u, e.entangledLanes &= u, e.errorRecoveryDisabledLanes &= u, e.shellSuspendCounter = 0;
      var M = e.entanglements, q = e.expirationTimes, j = e.hiddenUpdates;
      for (u = k & ~u; 0 < u; ) {
        var xe = 31 - kr(u), Ae = 1 << xe;
        M[xe] = 0, q[xe] = -1;
        var pe = j[xe];
        if (pe !== null)
          for (j[xe] = null, xe = 0; xe < pe.length; xe++) {
            var Re = pe[xe];
            Re !== null && (Re.lane &= -536870913);
          }
        u &= ~Ae;
      }
      f !== 0 && ke(e, f, 0), v !== 0 && p === 0 && e.tag !== 0 && (e.suspendedLanes |= v & ~(k & ~n));
    }
    function ke(e, n, u) {
      e.pendingLanes |= n, e.suspendedLanes &= ~n;
      var f = 31 - kr(n);
      e.entangledLanes |= n, e.entanglements[f] = e.entanglements[f] | 1073741824 | u & 4194090;
    }
    function je(e, n) {
      var u = e.entangledLanes |= n;
      for (e = e.entanglements; u; ) {
        var f = 31 - kr(u), p = 1 << f;
        p & n | e[f] & n && (e[f] |= n), u &= ~p;
      }
    }
    function ut(e) {
      switch (e) {
        case 2:
          e = 1;
          break;
        case 8:
          e = 4;
          break;
        case 32:
          e = 16;
          break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          e = 128;
          break;
        case 268435456:
          e = 134217728;
          break;
        default:
          e = 0;
      }
      return e;
    }
    function st(e, n, u) {
      if (gl)
        for (e = e.pendingUpdatersLaneMap; 0 < u; ) {
          var f = 31 - kr(u), p = 1 << f;
          e[f].add(n), u &= ~p;
        }
    }
    function Qt(e, n) {
      if (gl)
        for (var u = e.pendingUpdatersLaneMap, f = e.memoizedUpdaters; 0 < n; ) {
          var p = 31 - kr(n);
          e = 1 << p, p = u[p], 0 < p.size && (p.forEach(function(v) {
            var k = v.alternate;
            k !== null && f.has(k) || f.add(v);
          }), p.clear()), n &= ~e;
        }
    }
    function Zn(e) {
      return e &= -e, Xa < e ? yi < e ? e & 134217727 ? gu : Dd : yi : Xa;
    }
    function La() {
      var e = ln.p;
      return e !== 0 ? e : (e = window.event, e === void 0 ? gu : no(e.type));
    }
    function fr(e, n) {
      var u = ln.p;
      try {
        return ln.p = e, n();
      } finally {
        ln.p = u;
      }
    }
    function Nr(e) {
      delete e[Wr], delete e[Ca], delete e[Nd], delete e[Dc], delete e[vf];
    }
    function Hn(e) {
      var n = e[Wr];
      if (n) return n;
      for (var u = e.parentNode; u; ) {
        if (n = u[uo] || u[Wr]) {
          if (u = n.alternate, n.child !== null || u !== null && u.child !== null)
            for (e = md(e); e !== null; ) {
              if (u = e[Wr])
                return u;
              e = md(e);
            }
          return n;
        }
        e = u, u = e.parentNode;
      }
      return null;
    }
    function hn(e) {
      if (e = e[Wr] || e[uo]) {
        var n = e.tag;
        if (n === 5 || n === 6 || n === 13 || n === 26 || n === 27 || n === 3)
          return e;
      }
      return null;
    }
    function hr(e) {
      var n = e.tag;
      if (n === 5 || n === 26 || n === 27 || n === 6)
        return e.stateNode;
      throw Error("getNodeFromInstance: Invalid argument.");
    }
    function B(e) {
      var n = e[Lp];
      return n || (n = e[Lp] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), n;
    }
    function ue(e) {
      e[bf] = !0;
    }
    function Ie(e, n) {
      Qe(e, n), Qe(e + "Capture", n);
    }
    function Qe(e, n) {
      Zl[e] && console.error(
        "EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.",
        e
      ), Zl[e] = n;
      var u = e.toLowerCase();
      for (Ld[u] = e, e === "onDoubleClick" && (Ld.ondblclick = e), e = 0; e < n.length; e++)
        os.add(n[e]);
    }
    function et(e, n) {
      Bd[n.type] || n.onChange || n.onInput || n.readOnly || n.disabled || n.value == null || console.error(
        e === "select" ? "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`." : "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."
      ), n.onChange || n.readOnly || n.disabled || n.checked == null || console.error(
        "You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`."
      );
    }
    function Ht(e) {
      return gi.call(Sf, e) ? !0 : gi.call(Hd, e) ? !1 : Bp.test(e) ? Sf[e] = !0 : (Hd[e] = !0, console.error("Invalid attribute name: `%s`", e), !1);
    }
    function kt(e, n, u) {
      if (Ht(n)) {
        if (!e.hasAttribute(n)) {
          switch (typeof u) {
            case "symbol":
            case "object":
              return u;
            case "function":
              return u;
            case "boolean":
              if (u === !1) return u;
          }
          return u === void 0 ? void 0 : null;
        }
        return e = e.getAttribute(n), e === "" && u === !0 ? !0 : (N(u, n), e === "" + u ? u : e);
      }
    }
    function Pt(e, n, u) {
      if (Ht(n))
        if (u === null) e.removeAttribute(n);
        else {
          switch (typeof u) {
            case "undefined":
            case "function":
            case "symbol":
              e.removeAttribute(n);
              return;
            case "boolean":
              var f = n.toLowerCase().slice(0, 5);
              if (f !== "data-" && f !== "aria-") {
                e.removeAttribute(n);
                return;
              }
          }
          N(u, n), e.setAttribute(n, "" + u);
        }
    }
    function Tt(e, n, u) {
      if (u === null) e.removeAttribute(n);
      else {
        switch (typeof u) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            e.removeAttribute(n);
            return;
        }
        N(u, n), e.setAttribute(n, "" + u);
      }
    }
    function tr(e, n, u, f) {
      if (f === null) e.removeAttribute(u);
      else {
        switch (typeof f) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            e.removeAttribute(u);
            return;
        }
        N(f, u), e.setAttributeNS(n, u, "" + f);
      }
    }
    function ai() {
    }
    function Hm() {
      if (Nc === 0) {
        Hp = console.log, iy = console.info, Up = console.warn, Lc = console.error, uy = console.group, oy = console.groupCollapsed, sy = console.groupEnd;
        var e = {
          configurable: !0,
          enumerable: !0,
          value: ai,
          writable: !0
        };
        Object.defineProperties(console, {
          info: e,
          log: e,
          warn: e,
          error: e,
          group: e,
          groupCollapsed: e,
          groupEnd: e
        });
      }
      Nc++;
    }
    function li() {
      if (Nc--, Nc === 0) {
        var e = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: Et({}, e, { value: Hp }),
          info: Et({}, e, { value: iy }),
          warn: Et({}, e, { value: Up }),
          error: Et({}, e, { value: Lc }),
          group: Et({}, e, { value: uy }),
          groupCollapsed: Et({}, e, { value: oy }),
          groupEnd: Et({}, e, { value: sy })
        });
      }
      0 > Nc && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function bn(e) {
      if (Bc === void 0)
        try {
          throw Error();
        } catch (u) {
          var n = u.stack.trim().match(/\n( *(at )?)/);
          Bc = n && n[1] || "", xf = -1 < u.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < u.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + Bc + e + xf;
    }
    function Zr(e, n) {
      if (!e || wf) return "";
      var u = qp.get(e);
      if (u !== void 0) return u;
      wf = !0, u = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var f = null;
      f = ye.H, ye.H = null, Hm();
      try {
        var p = {
          DetermineComponentFrameRoot: function() {
            try {
              if (n) {
                var pe = function() {
                  throw Error();
                };
                if (Object.defineProperty(pe.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(pe, []);
                  } catch (tt) {
                    var Re = tt;
                  }
                  Reflect.construct(e, [], pe);
                } else {
                  try {
                    pe.call();
                  } catch (tt) {
                    Re = tt;
                  }
                  e.call(pe.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (tt) {
                  Re = tt;
                }
                (pe = e()) && typeof pe.catch == "function" && pe.catch(function() {
                });
              }
            } catch (tt) {
              if (tt && Re && typeof tt.stack == "string")
                return [tt.stack, Re.stack];
            }
            return [null, null];
          }
        };
        p.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var v = Object.getOwnPropertyDescriptor(
          p.DetermineComponentFrameRoot,
          "name"
        );
        v && v.configurable && Object.defineProperty(
          p.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var k = p.DetermineComponentFrameRoot(), M = k[0], q = k[1];
        if (M && q) {
          var j = M.split(`
`), xe = q.split(`
`);
          for (k = v = 0; v < j.length && !j[v].includes(
            "DetermineComponentFrameRoot"
          ); )
            v++;
          for (; k < xe.length && !xe[k].includes(
            "DetermineComponentFrameRoot"
          ); )
            k++;
          if (v === j.length || k === xe.length)
            for (v = j.length - 1, k = xe.length - 1; 1 <= v && 0 <= k && j[v] !== xe[k]; )
              k--;
          for (; 1 <= v && 0 <= k; v--, k--)
            if (j[v] !== xe[k]) {
              if (v !== 1 || k !== 1)
                do
                  if (v--, k--, 0 > k || j[v] !== xe[k]) {
                    var Ae = `
` + j[v].replace(
                      " at new ",
                      " at "
                    );
                    return e.displayName && Ae.includes("<anonymous>") && (Ae = Ae.replace("<anonymous>", e.displayName)), typeof e == "function" && qp.set(e, Ae), Ae;
                  }
                while (1 <= v && 0 <= k);
              break;
            }
        }
      } finally {
        wf = !1, ye.H = f, li(), Error.prepareStackTrace = u;
      }
      return j = (j = e ? e.displayName || e.name : "") ? bn(j) : "", typeof e == "function" && qp.set(e, j), j;
    }
    function Eo(e) {
      var n = Error.prepareStackTrace;
      if (Error.prepareStackTrace = void 0, e = e.stack, Error.prepareStackTrace = n, e.startsWith(`Error: react-stack-top-frame
`) && (e = e.slice(29)), n = e.indexOf(`
`), n !== -1 && (e = e.slice(n + 1)), n = e.indexOf("react-stack-bottom-frame"), n !== -1 && (n = e.lastIndexOf(
        `
`,
        n
      )), n !== -1)
        e = e.slice(0, n);
      else return "";
      return e;
    }
    function Um(e) {
      switch (e.tag) {
        case 26:
        case 27:
        case 5:
          return bn(e.type);
        case 16:
          return bn("Lazy");
        case 13:
          return bn("Suspense");
        case 19:
          return bn("SuspenseList");
        case 0:
        case 15:
          return Zr(e.type, !1);
        case 11:
          return Zr(e.type.render, !1);
        case 1:
          return Zr(e.type, !0);
        case 31:
          return bn("Activity");
        default:
          return "";
      }
    }
    function o4(e) {
      try {
        var n = "";
        do {
          n += Um(e);
          var u = e._debugInfo;
          if (u)
            for (var f = u.length - 1; 0 <= f; f--) {
              var p = u[f];
              if (typeof p.name == "string") {
                var v = n, k = p.env, M = bn(
                  p.name + (k ? " [" + k + "]" : "")
                );
                n = v + M;
              }
            }
          e = e.return;
        } while (e);
        return n;
      } catch (q) {
        return `
Error generating stack: ` + q.message + `
` + q.stack;
      }
    }
    function s4(e) {
      return (e = e ? e.displayName || e.name : "") ? bn(e) : "";
    }
    function s0() {
      if (Gr === null) return null;
      var e = Gr._debugOwner;
      return e != null ? Ne(e) : null;
    }
    function c0() {
      if (Gr === null) return "";
      var e = Gr;
      try {
        var n = "";
        switch (e.tag === 6 && (e = e.return), e.tag) {
          case 26:
          case 27:
          case 5:
            n += bn(e.type);
            break;
          case 13:
            n += bn("Suspense");
            break;
          case 19:
            n += bn("SuspenseList");
            break;
          case 31:
            n += bn("Activity");
            break;
          case 30:
          case 0:
          case 15:
          case 1:
            e._debugOwner || n !== "" || (n += s4(
              e.type
            ));
            break;
          case 11:
            e._debugOwner || n !== "" || (n += s4(
              e.type.render
            ));
        }
        for (; e; )
          if (typeof e.tag == "number") {
            var u = e;
            e = u._debugOwner;
            var f = u._debugStack;
            e && f && (typeof f != "string" && (u._debugStack = f = Eo(f)), f !== "" && (n += `
` + f));
          } else if (e.debugStack != null) {
            var p = e.debugStack;
            (e = e.owner) && p && (n += `
` + Eo(p));
          } else break;
        var v = n;
      } catch (k) {
        v = `
Error generating stack: ` + k.message + `
` + k.stack;
      }
      return v;
    }
    function at(e, n, u, f, p, v, k) {
      var M = Gr;
      Ru(e);
      try {
        return e !== null && e._debugTask ? e._debugTask.run(
          n.bind(null, u, f, p, v, k)
        ) : n(u, f, p, v, k);
      } finally {
        Ru(M);
      }
      throw Error(
        "runWithFiberInDEV should never be called in production. This is a bug in React."
      );
    }
    function Ru(e) {
      ye.getCurrentStack = e === null ? null : c0, vi = !1, Gr = e;
    }
    function Lr(e) {
      switch (typeof e) {
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return e;
        case "object":
          return _e(e), e;
        default:
          return "";
      }
    }
    function Ms(e) {
      var n = e.type;
      return (e = e.nodeName) && e.toLowerCase() === "input" && (n === "checkbox" || n === "radio");
    }
    function _s(e) {
      var n = Ms(e) ? "checked" : "value", u = Object.getOwnPropertyDescriptor(
        e.constructor.prototype,
        n
      );
      _e(e[n]);
      var f = "" + e[n];
      if (!e.hasOwnProperty(n) && typeof u < "u" && typeof u.get == "function" && typeof u.set == "function") {
        var p = u.get, v = u.set;
        return Object.defineProperty(e, n, {
          configurable: !0,
          get: function() {
            return p.call(this);
          },
          set: function(k) {
            _e(k), f = "" + k, v.call(this, k);
          }
        }), Object.defineProperty(e, n, {
          enumerable: u.enumerable
        }), {
          getValue: function() {
            return f;
          },
          setValue: function(k) {
            _e(k), f = "" + k;
          },
          stopTracking: function() {
            e._valueTracker = null, delete e[n];
          }
        };
      }
    }
    function Fn(e) {
      e._valueTracker || (e._valueTracker = _s(e));
    }
    function qm(e) {
      if (!e) return !1;
      var n = e._valueTracker;
      if (!n) return !0;
      var u = n.getValue(), f = "";
      return e && (f = Ms(e) ? e.checked ? "true" : "false" : e.value), e = f, e !== u ? (n.setValue(e), !0) : !1;
    }
    function f0(e) {
      if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
      try {
        return e.activeElement || e.body;
      } catch {
        return e.body;
      }
    }
    function wr(e) {
      return e.replace(
        cy,
        function(n) {
          return "\\" + n.charCodeAt(0).toString(16) + " ";
        }
      );
    }
    function Ao(e, n) {
      n.checked === void 0 || n.defaultChecked === void 0 || Gp || (console.error(
        "%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        s0() || "A component",
        n.type
      ), Gp = !0), n.value === void 0 || n.defaultValue === void 0 || jp || (console.error(
        "%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        s0() || "A component",
        n.type
      ), jp = !0);
    }
    function jm(e, n, u, f, p, v, k, M) {
      e.name = "", k != null && typeof k != "function" && typeof k != "symbol" && typeof k != "boolean" ? (N(k, "type"), e.type = k) : e.removeAttribute("type"), n != null ? k === "number" ? (n === 0 && e.value === "" || e.value != n) && (e.value = "" + Lr(n)) : e.value !== "" + Lr(n) && (e.value = "" + Lr(n)) : k !== "submit" && k !== "reset" || e.removeAttribute("value"), n != null ? ah(e, k, Lr(n)) : u != null ? ah(e, k, Lr(u)) : f != null && e.removeAttribute("value"), p == null && v != null && (e.defaultChecked = !!v), p != null && (e.checked = p && typeof p != "function" && typeof p != "symbol"), M != null && typeof M != "function" && typeof M != "symbol" && typeof M != "boolean" ? (N(M, "name"), e.name = "" + Lr(M)) : e.removeAttribute("name");
    }
    function Gm(e, n, u, f, p, v, k, M) {
      if (v != null && typeof v != "function" && typeof v != "symbol" && typeof v != "boolean" && (N(v, "type"), e.type = v), n != null || u != null) {
        if (!(v !== "submit" && v !== "reset" || n != null))
          return;
        u = u != null ? "" + Lr(u) : "", n = n != null ? "" + Lr(n) : u, M || n === e.value || (e.value = n), e.defaultValue = n;
      }
      f = f ?? p, f = typeof f != "function" && typeof f != "symbol" && !!f, e.checked = M ? e.checked : !!f, e.defaultChecked = !!f, k != null && typeof k != "function" && typeof k != "symbol" && typeof k != "boolean" && (N(k, "name"), e.name = k);
    }
    function ah(e, n, u) {
      n === "number" && f0(e.ownerDocument) === e || e.defaultValue === "" + u || (e.defaultValue = "" + u);
    }
    function c4(e, n) {
      n.value == null && (typeof n.children == "object" && n.children !== null ? zp.Children.forEach(n.children, function(u) {
        u == null || typeof u == "string" || typeof u == "number" || typeof u == "bigint" || Ud || (Ud = !0, console.error(
          "Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."
        ));
      }) : n.dangerouslySetInnerHTML == null || Yp || (Yp = !0, console.error(
        "Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."
      ))), n.selected == null || Vp || (console.error(
        "Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."
      ), Vp = !0);
    }
    function h0() {
      var e = s0();
      return e ? `

Check the render method of \`` + e + "`." : "";
    }
    function Gi(e, n, u, f) {
      if (e = e.options, n) {
        n = {};
        for (var p = 0; p < u.length; p++)
          n["$" + u[p]] = !0;
        for (u = 0; u < e.length; u++)
          p = n.hasOwnProperty("$" + e[u].value), e[u].selected !== p && (e[u].selected = p), p && f && (e[u].defaultSelected = !0);
      } else {
        for (u = "" + Lr(u), n = null, p = 0; p < e.length; p++) {
          if (e[p].value === u) {
            e[p].selected = !0, f && (e[p].defaultSelected = !0);
            return;
          }
          n !== null || e[p].disabled || (n = e[p]);
        }
        n !== null && (n.selected = !0);
      }
    }
    function ii(e, n) {
      for (e = 0; e < fy.length; e++) {
        var u = fy[e];
        if (n[u] != null) {
          var f = gr(n[u]);
          n.multiple && !f ? console.error(
            "The `%s` prop supplied to <select> must be an array if `multiple` is true.%s",
            u,
            h0()
          ) : !n.multiple && f && console.error(
            "The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s",
            u,
            h0()
          );
        }
      }
      n.value === void 0 || n.defaultValue === void 0 || Tf || (console.error(
        "Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"
      ), Tf = !0);
    }
    function lh(e, n) {
      n.value === void 0 || n.defaultValue === void 0 || hy || (console.error(
        "%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components",
        s0() || "A component"
      ), hy = !0), n.children != null && n.value == null && console.error(
        "Use the `defaultValue` or `value` props instead of setting children on <textarea>."
      );
    }
    function Vm(e, n, u) {
      if (n != null && (n = "" + Lr(n), n !== e.value && (e.value = n), u == null)) {
        e.defaultValue !== n && (e.defaultValue = n);
        return;
      }
      e.defaultValue = u != null ? "" + Lr(u) : "";
    }
    function ko(e, n, u, f) {
      if (n == null) {
        if (f != null) {
          if (u != null)
            throw Error(
              "If you supply `defaultValue` on a <textarea>, do not pass children."
            );
          if (gr(f)) {
            if (1 < f.length)
              throw Error("<textarea> can only have at most one child.");
            f = f[0];
          }
          u = f;
        }
        u == null && (u = ""), n = u;
      }
      u = Lr(n), e.defaultValue = u, f = e.textContent, f === u && f !== "" && f !== null && (e.value = f);
    }
    function ih(e, n) {
      return e.serverProps === void 0 && e.serverTail.length === 0 && e.children.length === 1 && 3 < e.distanceFromLeaf && e.distanceFromLeaf > 15 - n ? ih(e.children[0], n) : e;
    }
    function na(e) {
      return "  " + "  ".repeat(e);
    }
    function Os(e) {
      return "+ " + "  ".repeat(e);
    }
    function zu(e) {
      return "- " + "  ".repeat(e);
    }
    function Ba(e) {
      switch (e.tag) {
        case 26:
        case 27:
        case 5:
          return e.type;
        case 16:
          return "Lazy";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 0:
        case 15:
          return e = e.type, e.displayName || e.name || null;
        case 11:
          return e = e.type.render, e.displayName || e.name || null;
        case 1:
          return e = e.type, e.displayName || e.name || null;
        default:
          return null;
      }
    }
    function Ds(e, n) {
      return qd.test(e) ? (e = JSON.stringify(e), e.length > n - 2 ? 8 > n ? '{"..."}' : "{" + e.slice(0, n - 7) + '..."}' : "{" + e + "}") : e.length > n ? 5 > n ? '{"..."}' : e.slice(0, n - 3) + "..." : e;
    }
    function uh(e, n, u) {
      var f = 120 - 2 * u;
      if (n === null)
        return Os(u) + Ds(e, f) + `
`;
      if (typeof n == "string") {
        for (var p = 0; p < n.length && p < e.length && n.charCodeAt(p) === e.charCodeAt(p); p++) ;
        return p > f - 8 && 10 < p && (e = "..." + e.slice(p - 8), n = "..." + n.slice(p - 8)), Os(u) + Ds(e, f) + `
` + zu(u) + Ds(n, f) + `
`;
      }
      return na(u) + Ds(e, f) + `
`;
    }
    function Ns(e) {
      return Object.prototype.toString.call(e).replace(/^\[object (.*)\]$/, function(n, u) {
        return u;
      });
    }
    function Ls(e, n) {
      switch (typeof e) {
        case "string":
          return e = JSON.stringify(e), e.length > n ? 5 > n ? '"..."' : e.slice(0, n - 4) + '..."' : e;
        case "object":
          if (e === null) return "null";
          if (gr(e)) return "[...]";
          if (e.$$typeof === hu)
            return (n = ve(e.type)) ? "<" + n + ">" : "<...>";
          var u = Ns(e);
          if (u === "Object") {
            u = "", n -= 2;
            for (var f in e)
              if (e.hasOwnProperty(f)) {
                var p = JSON.stringify(f);
                if (p !== '"' + f + '"' && (f = p), n -= f.length - 2, p = Ls(
                  e[f],
                  15 > n ? n : 15
                ), n -= p.length, 0 > n) {
                  u += u === "" ? "..." : ", ...";
                  break;
                }
                u += (u === "" ? "" : ",") + f + ":" + p;
              }
            return "{" + u + "}";
          }
          return u;
        case "function":
          return (n = e.displayName || e.name) ? "function " + n : "function";
        default:
          return String(e);
      }
    }
    function Vi(e, n) {
      return typeof e != "string" || qd.test(e) ? "{" + Ls(e, n - 2) + "}" : e.length > n - 2 ? 5 > n ? '"..."' : '"' + e.slice(0, n - 5) + '..."' : '"' + e + '"';
    }
    function Ym(e, n, u) {
      var f = 120 - u.length - e.length, p = [], v;
      for (v in n)
        if (n.hasOwnProperty(v) && v !== "children") {
          var k = Vi(
            n[v],
            120 - u.length - v.length - 1
          );
          f -= v.length + k.length + 2, p.push(v + "=" + k);
        }
      return p.length === 0 ? u + "<" + e + `>
` : 0 < f ? u + "<" + e + " " + p.join(" ") + `>
` : u + "<" + e + `
` + u + "  " + p.join(`
` + u + "  ") + `
` + u + `>
`;
    }
    function al(e, n, u) {
      var f = "", p = Et({}, n), v;
      for (v in e)
        if (e.hasOwnProperty(v)) {
          delete p[v];
          var k = 120 - 2 * u - v.length - 2, M = Ls(e[v], k);
          n.hasOwnProperty(v) ? (k = Ls(n[v], k), f += Os(u) + v + ": " + M + `
`, f += zu(u) + v + ": " + k + `
`) : f += Os(u) + v + ": " + M + `
`;
        }
      for (var q in p)
        p.hasOwnProperty(q) && (e = Ls(
          p[q],
          120 - 2 * u - q.length - 2
        ), f += zu(u) + q + ": " + e + `
`);
      return f;
    }
    function Im(e, n, u, f) {
      var p = "", v = /* @__PURE__ */ new Map();
      for (j in u)
        u.hasOwnProperty(j) && v.set(
          j.toLowerCase(),
          j
        );
      if (v.size === 1 && v.has("children"))
        p += Ym(
          e,
          n,
          na(f)
        );
      else {
        for (var k in n)
          if (n.hasOwnProperty(k) && k !== "children") {
            var M = 120 - 2 * (f + 1) - k.length - 1, q = v.get(k.toLowerCase());
            if (q !== void 0) {
              v.delete(k.toLowerCase());
              var j = n[k];
              q = u[q];
              var xe = Vi(
                j,
                M
              );
              M = Vi(
                q,
                M
              ), typeof j == "object" && j !== null && typeof q == "object" && q !== null && Ns(j) === "Object" && Ns(q) === "Object" && (2 < Object.keys(j).length || 2 < Object.keys(q).length || -1 < xe.indexOf("...") || -1 < M.indexOf("...")) ? p += na(f + 1) + k + `={{
` + al(
                j,
                q,
                f + 2
              ) + na(f + 1) + `}}
` : (p += Os(f + 1) + k + "=" + xe + `
`, p += zu(f + 1) + k + "=" + M + `
`);
            } else
              p += na(f + 1) + k + "=" + Vi(n[k], M) + `
`;
          }
        v.forEach(function(Ae) {
          if (Ae !== "children") {
            var pe = 120 - 2 * (f + 1) - Ae.length - 1;
            p += zu(f + 1) + Ae + "=" + Vi(u[Ae], pe) + `
`;
          }
        }), p = p === "" ? na(f) + "<" + e + `>
` : na(f) + "<" + e + `
` + p + na(f) + `>
`;
      }
      return e = u.children, n = n.children, typeof e == "string" || typeof e == "number" || typeof e == "bigint" ? (v = "", (typeof n == "string" || typeof n == "number" || typeof n == "bigint") && (v = "" + n), p += uh(v, "" + e, f + 1)) : (typeof n == "string" || typeof n == "number" || typeof n == "bigint") && (p = e == null ? p + uh("" + n, null, f + 1) : p + uh("" + n, void 0, f + 1)), p;
    }
    function $m(e, n) {
      var u = Ba(e);
      if (u === null) {
        for (u = "", e = e.child; e; )
          u += $m(e, n), e = e.sibling;
        return u;
      }
      return na(n) + "<" + u + `>
`;
    }
    function d0(e, n) {
      var u = ih(e, n);
      if (u !== e && (e.children.length !== 1 || e.children[0] !== u))
        return na(n) + `...
` + d0(u, n + 1);
      u = "";
      var f = e.fiber._debugInfo;
      if (f)
        for (var p = 0; p < f.length; p++) {
          var v = f[p].name;
          typeof v == "string" && (u += na(n) + "<" + v + `>
`, n++);
        }
      if (f = "", p = e.fiber.pendingProps, e.fiber.tag === 6)
        f = uh(p, e.serverProps, n), n++;
      else if (v = Ba(e.fiber), v !== null)
        if (e.serverProps === void 0) {
          f = n;
          var k = 120 - 2 * f - v.length - 2, M = "";
          for (j in p)
            if (p.hasOwnProperty(j) && j !== "children") {
              var q = Vi(p[j], 15);
              if (k -= j.length + q.length + 2, 0 > k) {
                M += " ...";
                break;
              }
              M += " " + j + "=" + q;
            }
          f = na(f) + "<" + v + M + `>
`, n++;
        } else
          e.serverProps === null ? (f = Ym(
            v,
            p,
            Os(n)
          ), n++) : typeof e.serverProps == "string" ? console.error(
            "Should not have matched a non HostText fiber to a Text node. This is a bug in React."
          ) : (f = Im(
            v,
            p,
            e.serverProps,
            n
          ), n++);
      var j = "";
      for (p = e.fiber.child, v = 0; p && v < e.children.length; )
        k = e.children[v], k.fiber === p ? (j += d0(k, n), v++) : j += $m(p, n), p = p.sibling;
      for (p && 0 < e.children.length && (j += na(n) + `...
`), p = e.serverTail, e.serverProps === null && n--, e = 0; e < p.length; e++)
        v = p[e], j = typeof v == "string" ? j + (zu(n) + Ds(v, 120 - 2 * n) + `
`) : j + Ym(
          v.type,
          v.props,
          zu(n)
        );
      return u + f + j;
    }
    function Cu(e) {
      try {
        return `

` + d0(e, 0);
      } catch {
        return "";
      }
    }
    function Xm(e, n, u) {
      for (var f = n, p = null, v = 0; f; )
        f === e && (v = 0), p = {
          fiber: f,
          children: p !== null ? [p] : [],
          serverProps: f === n ? u : f === e ? null : void 0,
          serverTail: [],
          distanceFromLeaf: v
        }, v++, f = f.return;
      return p !== null ? Cu(p).replaceAll(/^[+-]/gm, ">") : "";
    }
    function Qm(e, n) {
      var u = Et({}, e || jd), f = { tag: n };
      return Ef.indexOf(n) !== -1 && (u.aTagInScope = null, u.buttonTagInScope = null, u.nobrTagInScope = null), $p.indexOf(n) !== -1 && (u.pTagInButtonScope = null), Ip.indexOf(n) !== -1 && n !== "address" && n !== "div" && n !== "p" && (u.listItemTagAutoclosing = null, u.dlItemTagAutoclosing = null), u.current = f, n === "form" && (u.formTag = f), n === "a" && (u.aTagInScope = f), n === "button" && (u.buttonTagInScope = f), n === "nobr" && (u.nobrTagInScope = f), n === "p" && (u.pTagInButtonScope = f), n === "li" && (u.listItemTagAutoclosing = f), (n === "dd" || n === "dt") && (u.dlItemTagAutoclosing = f), n === "#document" || n === "html" ? u.containerTagInScope = null : u.containerTagInScope || (u.containerTagInScope = f), e !== null || n !== "#document" && n !== "html" && n !== "body" ? u.implicitRootScope === !0 && (u.implicitRootScope = !1) : u.implicitRootScope = !0, u;
    }
    function Ro(e, n, u) {
      switch (n) {
        case "select":
          return e === "hr" || e === "option" || e === "optgroup" || e === "script" || e === "template" || e === "#text";
        case "optgroup":
          return e === "option" || e === "#text";
        case "option":
          return e === "#text";
        case "tr":
          return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
        case "tbody":
        case "thead":
        case "tfoot":
          return e === "tr" || e === "style" || e === "script" || e === "template";
        case "colgroup":
          return e === "col" || e === "template";
        case "table":
          return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
        case "head":
          return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
        case "html":
          if (u) break;
          return e === "head" || e === "body" || e === "frameset";
        case "frameset":
          return e === "frame";
        case "#document":
          if (!u) return e === "html";
      }
      switch (e) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return n !== "h1" && n !== "h2" && n !== "h3" && n !== "h4" && n !== "h5" && n !== "h6";
        case "rp":
        case "rt":
          return dy.indexOf(n) === -1;
        case "caption":
        case "col":
        case "colgroup":
        case "frameset":
        case "frame":
        case "tbody":
        case "td":
        case "tfoot":
        case "th":
        case "thead":
        case "tr":
          return n == null;
        case "head":
          return u || n === null;
        case "html":
          return u && n === "#document" || n === null;
        case "body":
          return u && (n === "#document" || n === "html") || n === null;
      }
      return !0;
    }
    function a3(e, n) {
      switch (e) {
        case "address":
        case "article":
        case "aside":
        case "blockquote":
        case "center":
        case "details":
        case "dialog":
        case "dir":
        case "div":
        case "dl":
        case "fieldset":
        case "figcaption":
        case "figure":
        case "footer":
        case "header":
        case "hgroup":
        case "main":
        case "menu":
        case "nav":
        case "ol":
        case "p":
        case "section":
        case "summary":
        case "ul":
        case "pre":
        case "listing":
        case "table":
        case "hr":
        case "xmp":
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return n.pTagInButtonScope;
        case "form":
          return n.formTag || n.pTagInButtonScope;
        case "li":
          return n.listItemTagAutoclosing;
        case "dd":
        case "dt":
          return n.dlItemTagAutoclosing;
        case "button":
          return n.buttonTagInScope;
        case "a":
          return n.aTagInScope;
        case "nobr":
          return n.nobrTagInScope;
      }
      return null;
    }
    function Zm(e, n) {
      for (; e; ) {
        switch (e.tag) {
          case 5:
          case 26:
          case 27:
            if (e.type === n) return e;
        }
        e = e.return;
      }
      return null;
    }
    function oh(e, n) {
      n = n || jd;
      var u = n.current;
      if (n = (u = Ro(
        e,
        u && u.tag,
        n.implicitRootScope
      ) ? null : u) ? null : a3(e, n), n = u || n, !n) return !0;
      var f = n.tag;
      if (n = String(!!u) + "|" + e + "|" + f, Fl[n]) return !1;
      Fl[n] = !0;
      var p = (n = Gr) ? Zm(n.return, f) : null, v = n !== null && p !== null ? Xm(p, n, null) : "", k = "<" + e + ">";
      return u ? (u = "", f === "table" && e === "tr" && (u += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error(
        `In HTML, %s cannot be a child of <%s>.%s
This will cause a hydration error.%s`,
        k,
        f,
        u,
        v
      )) : console.error(
        `In HTML, %s cannot be a descendant of <%s>.
This will cause a hydration error.%s`,
        k,
        f,
        v
      ), n && (e = n.return, p === null || e === null || p === e && e._debugOwner === n._debugOwner || at(p, function() {
        console.error(
          `<%s> cannot contain a nested %s.
See this log for the ancestor stack trace.`,
          f,
          k
        );
      })), !1;
    }
    function Bs(e, n, u) {
      if (u || Ro("#text", n, !1))
        return !0;
      if (u = "#text|" + n, Fl[u]) return !1;
      Fl[u] = !0;
      var f = (u = Gr) ? Zm(u, n) : null;
      return u = u !== null && f !== null ? Xm(
        f,
        u,
        u.tag !== 6 ? { children: null } : null
      ) : "", /\S/.test(e) ? console.error(
        `In HTML, text nodes cannot be a child of <%s>.
This will cause a hydration error.%s`,
        n,
        u
      ) : console.error(
        `In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.
This will cause a hydration error.%s`,
        n,
        u
      ), !1;
    }
    function m0(e, n) {
      if (n) {
        var u = e.firstChild;
        if (u && u === e.lastChild && u.nodeType === 3) {
          u.nodeValue = n;
          return;
        }
      }
      e.textContent = n;
    }
    function l3(e) {
      return e.replace(E3, function(n, u) {
        return u.toUpperCase();
      });
    }
    function p0(e, n, u) {
      var f = n.indexOf("--") === 0;
      f || (-1 < n.indexOf("-") ? Si.hasOwnProperty(n) && Si[n] || (Si[n] = !0, console.error(
        "Unsupported style property %s. Did you mean %s?",
        n,
        l3(n.replace(oo, "ms-"))
      )) : Af.test(n) ? Si.hasOwnProperty(n) && Si[n] || (Si[n] = !0, console.error(
        "Unsupported vendor-prefixed style property %s. Did you mean %s?",
        n,
        n.charAt(0).toUpperCase() + n.slice(1)
      )) : !Xp.test(u) || Qp.hasOwnProperty(u) && Qp[u] || (Qp[u] = !0, console.error(
        `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
        n,
        u.replace(Xp, "")
      )), typeof u == "number" && (isNaN(u) ? Zp || (Zp = !0, console.error(
        "`NaN` is an invalid value for the `%s` css style property.",
        n
      )) : isFinite(u) || kf || (kf = !0, console.error(
        "`Infinity` is an invalid value for the `%s` css style property.",
        n
      )))), u == null || typeof u == "boolean" || u === "" ? f ? e.setProperty(n, "") : n === "float" ? e.cssFloat = "" : e[n] = "" : f ? e.setProperty(n, u) : typeof u != "number" || u === 0 || Fp.has(n) ? n === "float" ? e.cssFloat = u : (Me(u, n), e[n] = ("" + u).trim()) : e[n] = u + "px";
    }
    function sh(e, n, u) {
      if (n != null && typeof n != "object")
        throw Error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      if (n && Object.freeze(n), e = e.style, u != null) {
        if (n) {
          var f = {};
          if (u) {
            for (var p in u)
              if (u.hasOwnProperty(p) && !n.hasOwnProperty(p))
                for (var v = bi[p] || [p], k = 0; k < v.length; k++)
                  f[v[k]] = p;
          }
          for (var M in n)
            if (n.hasOwnProperty(M) && (!u || u[M] !== n[M]))
              for (p = bi[M] || [M], v = 0; v < p.length; v++)
                f[p[v]] = M;
          M = {};
          for (var q in n)
            for (p = bi[q] || [q], v = 0; v < p.length; v++)
              M[p[v]] = q;
          q = {};
          for (var j in f)
            if (p = f[j], (v = M[j]) && p !== v && (k = p + "," + v, !q[k])) {
              q[k] = !0, k = console;
              var xe = n[p];
              k.error.call(
                k,
                "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",
                xe == null || typeof xe == "boolean" || xe === "" ? "Removing" : "Updating",
                p,
                v
              );
            }
        }
        for (var Ae in u)
          !u.hasOwnProperty(Ae) || n != null && n.hasOwnProperty(Ae) || (Ae.indexOf("--") === 0 ? e.setProperty(Ae, "") : Ae === "float" ? e.cssFloat = "" : e[Ae] = "");
        for (var pe in n)
          j = n[pe], n.hasOwnProperty(pe) && u[pe] !== j && p0(e, pe, j);
      } else
        for (f in n)
          n.hasOwnProperty(f) && p0(e, f, n[f]);
    }
    function zo(e) {
      if (e.indexOf("-") === -1) return !1;
      switch (e) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    function Co(e) {
      return Vd.get(e) || e;
    }
    function Hs(e, n) {
      if (gi.call(so, n) && so[n])
        return !0;
      if (my.test(n)) {
        if (e = "aria-" + n.slice(4).toLowerCase(), e = Uc.hasOwnProperty(e) ? e : null, e == null)
          return console.error(
            "Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",
            n
          ), so[n] = !0;
        if (n !== e)
          return console.error(
            "Invalid ARIA attribute `%s`. Did you mean `%s`?",
            n,
            e
          ), so[n] = !0;
      }
      if (Yd.test(n)) {
        if (e = n.toLowerCase(), e = Uc.hasOwnProperty(e) ? e : null, e == null) return so[n] = !0, !1;
        n !== e && (console.error(
          "Unknown ARIA attribute `%s`. Did you mean `%s`?",
          n,
          e
        ), so[n] = !0);
      }
      return !0;
    }
    function f4(e, n) {
      var u = [], f;
      for (f in n)
        Hs(e, f) || u.push(f);
      n = u.map(function(p) {
        return "`" + p + "`";
      }).join(", "), u.length === 1 ? console.error(
        "Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        n,
        e
      ) : 1 < u.length && console.error(
        "Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        n,
        e
      );
    }
    function Fm(e, n, u, f) {
      if (gi.call(Rr, n) && Rr[n])
        return !0;
      var p = n.toLowerCase();
      if (p === "onfocusin" || p === "onfocusout")
        return console.error(
          "React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."
        ), Rr[n] = !0;
      if (typeof u == "function" && (e === "form" && n === "action" || e === "input" && n === "formAction" || e === "button" && n === "formAction"))
        return !0;
      if (f != null) {
        if (e = f.possibleRegistrationNames, f.registrationNameDependencies.hasOwnProperty(n))
          return !0;
        if (f = e.hasOwnProperty(p) ? e[p] : null, f != null)
          return console.error(
            "Invalid event handler property `%s`. Did you mean `%s`?",
            n,
            f
          ), Rr[n] = !0;
        if (l.test(n))
          return console.error(
            "Unknown event handler property `%s`. It will be ignored.",
            n
          ), Rr[n] = !0;
      } else if (l.test(n))
        return o.test(n) && console.error(
          "Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",
          n
        ), Rr[n] = !0;
      if (c.test(n) || m.test(n)) return !0;
      if (p === "innerhtml")
        return console.error(
          "Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."
        ), Rr[n] = !0;
      if (p === "aria")
        return console.error(
          "The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."
        ), Rr[n] = !0;
      if (p === "is" && u !== null && u !== void 0 && typeof u != "string")
        return console.error(
          "Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",
          typeof u
        ), Rr[n] = !0;
      if (typeof u == "number" && isNaN(u))
        return console.error(
          "Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",
          n
        ), Rr[n] = !0;
      if (Rf.hasOwnProperty(p)) {
        if (p = Rf[p], p !== n)
          return console.error(
            "Invalid DOM property `%s`. Did you mean `%s`?",
            n,
            p
          ), Rr[n] = !0;
      } else if (n !== p)
        return console.error(
          "React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",
          n,
          p
        ), Rr[n] = !0;
      switch (n) {
        case "dangerouslySetInnerHTML":
        case "children":
        case "style":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          return !0;
        case "innerText":
        case "textContent":
          return !0;
      }
      switch (typeof u) {
        case "boolean":
          switch (n) {
            case "autoFocus":
            case "checked":
            case "multiple":
            case "muted":
            case "selected":
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
            case "capture":
            case "download":
            case "inert":
              return !0;
            default:
              return p = n.toLowerCase().slice(0, 5), p === "data-" || p === "aria-" ? !0 : (u ? console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                u,
                n,
                n,
                u,
                n
              ) : console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                u,
                n,
                n,
                u,
                n,
                n,
                n
              ), Rr[n] = !0);
          }
        case "function":
        case "symbol":
          return Rr[n] = !0, !1;
        case "string":
          if (u === "false" || u === "true") {
            switch (n) {
              case "checked":
              case "selected":
              case "multiple":
              case "muted":
              case "allowFullScreen":
              case "async":
              case "autoPlay":
              case "controls":
              case "default":
              case "defer":
              case "disabled":
              case "disablePictureInPicture":
              case "disableRemotePlayback":
              case "formNoValidate":
              case "hidden":
              case "loop":
              case "noModule":
              case "noValidate":
              case "open":
              case "playsInline":
              case "readOnly":
              case "required":
              case "reversed":
              case "scoped":
              case "seamless":
              case "itemScope":
              case "inert":
                break;
              default:
                return !0;
            }
            console.error(
              "Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",
              u,
              n,
              u === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".',
              n,
              u
            ), Rr[n] = !0;
          }
      }
      return !0;
    }
    function h4(e, n, u) {
      var f = [], p;
      for (p in n)
        Fm(e, p, n[p], u) || f.push(p);
      n = f.map(function(v) {
        return "`" + v + "`";
      }).join(", "), f.length === 1 ? console.error(
        "Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        n,
        e
      ) : 1 < f.length && console.error(
        "Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        n,
        e
      );
    }
    function Yi(e) {
      return S.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
    }
    function Al(e) {
      return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
    }
    function ch(e) {
      var n = hn(e);
      if (n && (e = n.stateNode)) {
        var u = e[Ca] || null;
        e: switch (e = n.stateNode, n.type) {
          case "input":
            if (jm(
              e,
              u.value,
              u.defaultValue,
              u.defaultValue,
              u.checked,
              u.defaultChecked,
              u.type,
              u.name
            ), n = u.name, u.type === "radio" && n != null) {
              for (u = e; u.parentNode; ) u = u.parentNode;
              for (N(n, "name"), u = u.querySelectorAll(
                'input[name="' + wr(
                  "" + n
                ) + '"][type="radio"]'
              ), n = 0; n < u.length; n++) {
                var f = u[n];
                if (f !== e && f.form === e.form) {
                  var p = f[Ca] || null;
                  if (!p)
                    throw Error(
                      "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported."
                    );
                  jm(
                    f,
                    p.value,
                    p.defaultValue,
                    p.defaultValue,
                    p.checked,
                    p.defaultChecked,
                    p.type,
                    p.name
                  );
                }
              }
              for (n = 0; n < u.length; n++)
                f = u[n], f.form === e.form && qm(f);
            }
            break e;
          case "textarea":
            Vm(e, u.value, u.defaultValue);
            break e;
          case "select":
            n = u.value, n != null && Gi(e, !!u.multiple, n, !1);
        }
      }
    }
    function Us(e, n, u) {
      if (Z) return e(n, u);
      Z = !0;
      try {
        var f = e(n);
        return f;
      } finally {
        if (Z = !1, (_ !== null || H !== null) && (Jo(), _ && (n = _, e = H, H = _ = null, ch(n), e)))
          for (n = 0; n < e.length; n++) ch(e[n]);
      }
    }
    function ll(e, n) {
      var u = e.stateNode;
      if (u === null) return null;
      var f = u[Ca] || null;
      if (f === null) return null;
      u = f[n];
      e: switch (n) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (f = !f.disabled) || (e = e.type, f = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !f;
          break e;
        default:
          e = !1;
      }
      if (e) return null;
      if (u && typeof u != "function")
        throw Error(
          "Expected `" + n + "` listener to be a function, instead got a value of `" + typeof u + "` type."
        );
      return u;
    }
    function fh() {
      if (mt) return mt;
      var e, n = we, u = n.length, f, p = "value" in me ? me.value : me.textContent, v = p.length;
      for (e = 0; e < u && n[e] === p[e]; e++) ;
      var k = u - e;
      for (f = 1; f <= k && n[u - f] === p[v - f]; f++) ;
      return mt = p.slice(e, 1 < f ? 1 - f : void 0);
    }
    function Mo(e) {
      var n = e.keyCode;
      return "charCode" in e ? (e = e.charCode, e === 0 && n === 13 && (e = 13)) : e = n, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
    }
    function g0() {
      return !0;
    }
    function y0() {
      return !1;
    }
    function Br(e) {
      function n(u, f, p, v, k) {
        this._reactName = u, this._targetInst = p, this.type = f, this.nativeEvent = v, this.target = k, this.currentTarget = null;
        for (var M in e)
          e.hasOwnProperty(M) && (u = e[M], this[M] = u ? u(v) : v[M]);
        return this.isDefaultPrevented = (v.defaultPrevented != null ? v.defaultPrevented : v.returnValue === !1) ? g0 : y0, this.isPropagationStopped = y0, this;
      }
      return Et(n.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var u = this.nativeEvent;
          u && (u.preventDefault ? u.preventDefault() : typeof u.returnValue != "unknown" && (u.returnValue = !1), this.isDefaultPrevented = g0);
        },
        stopPropagation: function() {
          var u = this.nativeEvent;
          u && (u.stopPropagation ? u.stopPropagation() : typeof u.cancelBubble != "unknown" && (u.cancelBubble = !0), this.isPropagationStopped = g0);
        },
        persist: function() {
        },
        isPersistent: g0
      }), n;
    }
    function d4(e) {
      var n = this.nativeEvent;
      return n.getModifierState ? n.getModifierState(e) : (e = RT[e]) ? !!n[e] : !1;
    }
    function Fr() {
      return d4;
    }
    function Mu(e, n) {
      switch (e) {
        case "keyup":
          return qT.indexOf(n.keyCode) !== -1;
        case "keydown":
          return n.keyCode !== J7;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function v0(e) {
      return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
    }
    function b0(e, n) {
      switch (e) {
        case "compositionend":
          return v0(n);
        case "keypress":
          return n.which !== eb ? null : (nb = !0, tb);
        case "textInput":
          return e = n.data, e === tb && nb ? null : e;
        default:
          return null;
      }
    }
    function i3(e, n) {
      if (Id)
        return e === "compositionend" || !k3 && Mu(e, n) ? (e = fh(), mt = we = me = null, Id = !1, e) : null;
      switch (e) {
        case "paste":
          return null;
        case "keypress":
          if (!(n.ctrlKey || n.altKey || n.metaKey) || n.ctrlKey && n.altKey) {
            if (n.char && 1 < n.char.length)
              return n.char;
            if (n.which)
              return String.fromCharCode(n.which);
          }
          return null;
        case "compositionend":
          return W7 && n.locale !== "ko" ? null : n.data;
        default:
          return null;
      }
    }
    function hh(e) {
      var n = e && e.nodeName && e.nodeName.toLowerCase();
      return n === "input" ? !!GT[e.type] : n === "textarea";
    }
    function Pm(e) {
      if (!fe) return !1;
      e = "on" + e;
      var n = e in document;
      return n || (n = document.createElement("div"), n.setAttribute(e, "return;"), n = typeof n[e] == "function"), n;
    }
    function qs(e, n, u, f) {
      _ ? H ? H.push(f) : H = [f] : _ = f, n = Jr(n, "onChange"), 0 < n.length && (u = new un(
        "onChange",
        "change",
        null,
        u,
        f
      ), e.push({ event: u, listeners: n }));
    }
    function dh(e) {
      hp(e, 0);
    }
    function S0(e) {
      var n = hr(e);
      if (qm(n)) return e;
    }
    function m4(e, n) {
      if (e === "change") return n;
    }
    function p4() {
      Kp && (Kp.detachEvent("onpropertychange", g4), Jp = Kp = null);
    }
    function g4(e) {
      if (e.propertyName === "value" && S0(Jp)) {
        var n = [];
        qs(
          n,
          Jp,
          e,
          Al(e)
        ), Us(dh, n);
      }
    }
    function Km(e, n, u) {
      e === "focusin" ? (p4(), Kp = n, Jp = u, Kp.attachEvent("onpropertychange", g4)) : e === "focusout" && p4();
    }
    function u3(e) {
      if (e === "selectionchange" || e === "keyup" || e === "keydown")
        return S0(Jp);
    }
    function o3(e, n) {
      if (e === "click") return S0(n);
    }
    function s3(e, n) {
      if (e === "input" || e === "change")
        return S0(n);
    }
    function c3(e, n) {
      return e === n && (e !== 0 || 1 / e === 1 / n) || e !== e && n !== n;
    }
    function x0(e, n) {
      if (Qa(e, n)) return !0;
      if (typeof e != "object" || e === null || typeof n != "object" || n === null)
        return !1;
      var u = Object.keys(e), f = Object.keys(n);
      if (u.length !== f.length) return !1;
      for (f = 0; f < u.length; f++) {
        var p = u[f];
        if (!gi.call(n, p) || !Qa(e[p], n[p]))
          return !1;
      }
      return !0;
    }
    function Jm(e) {
      for (; e && e.firstChild; ) e = e.firstChild;
      return e;
    }
    function y4(e, n) {
      var u = Jm(e);
      e = 0;
      for (var f; u; ) {
        if (u.nodeType === 3) {
          if (f = e + u.textContent.length, e <= n && f >= n)
            return { node: u, offset: n - e };
          e = f;
        }
        e: {
          for (; u; ) {
            if (u.nextSibling) {
              u = u.nextSibling;
              break e;
            }
            u = u.parentNode;
          }
          u = void 0;
        }
        u = Jm(u);
      }
    }
    function v4(e, n) {
      return e && n ? e === n ? !0 : e && e.nodeType === 3 ? !1 : n && n.nodeType === 3 ? v4(e, n.parentNode) : "contains" in e ? e.contains(n) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(n) & 16) : !1 : !1;
    }
    function b4(e) {
      e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
      for (var n = f0(e.document); n instanceof e.HTMLIFrameElement; ) {
        try {
          var u = typeof n.contentWindow.location.href == "string";
        } catch {
          u = !1;
        }
        if (u) e = n.contentWindow;
        else break;
        n = f0(e.document);
      }
      return n;
    }
    function Wm(e) {
      var n = e && e.nodeName && e.nodeName.toLowerCase();
      return n && (n === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || n === "textarea" || e.contentEditable === "true");
    }
    function mh(e, n, u) {
      var f = u.window === u ? u.document : u.nodeType === 9 ? u : u.ownerDocument;
      z3 || $d == null || $d !== f0(f) || (f = $d, "selectionStart" in f && Wm(f) ? f = { start: f.selectionStart, end: f.selectionEnd } : (f = (f.ownerDocument && f.ownerDocument.defaultView || window).getSelection(), f = {
        anchorNode: f.anchorNode,
        anchorOffset: f.anchorOffset,
        focusNode: f.focusNode,
        focusOffset: f.focusOffset
      }), Wp && x0(Wp, f) || (Wp = f, f = Jr(R3, "onSelect"), 0 < f.length && (n = new un(
        "onSelect",
        "select",
        null,
        n,
        u
      ), e.push({ event: n, listeners: f }), n.target = $d)));
    }
    function _o(e, n) {
      var u = {};
      return u[e.toLowerCase()] = n.toLowerCase(), u["Webkit" + e] = "webkit" + n, u["Moz" + e] = "moz" + n, u;
    }
    function Oo(e) {
      if (C3[e]) return C3[e];
      if (!Xd[e]) return e;
      var n = Xd[e], u;
      for (u in n)
        if (n.hasOwnProperty(u) && u in ab)
          return C3[e] = n[u];
      return e;
    }
    function kl(e, n) {
      sb.set(e, n), Ie(n, [e]);
    }
    function fa(e, n) {
      if (typeof e == "object" && e !== null) {
        var u = _3.get(e);
        return u !== void 0 ? u : (n = {
          value: e,
          source: n,
          stack: o4(n)
        }, _3.set(e, n), n);
      }
      return {
        value: e,
        source: n,
        stack: o4(n)
      };
    }
    function ph() {
      for (var e = Qd, n = D3 = Qd = 0; n < e; ) {
        var u = wi[n];
        wi[n++] = null;
        var f = wi[n];
        wi[n++] = null;
        var p = wi[n];
        wi[n++] = null;
        var v = wi[n];
        if (wi[n++] = null, f !== null && p !== null) {
          var k = f.pending;
          k === null ? p.next = p : (p.next = k.next, k.next = p), f.pending = p;
        }
        v !== 0 && S4(u, p, v);
      }
    }
    function gh(e, n, u, f) {
      wi[Qd++] = e, wi[Qd++] = n, wi[Qd++] = u, wi[Qd++] = f, D3 |= f, e.lanes |= f, e = e.alternate, e !== null && (e.lanes |= f);
    }
    function e1(e, n, u, f) {
      return gh(e, n, u, f), yh(e);
    }
    function ha(e, n) {
      return gh(e, null, null, n), yh(e);
    }
    function S4(e, n, u) {
      e.lanes |= u;
      var f = e.alternate;
      f !== null && (f.lanes |= u);
      for (var p = !1, v = e.return; v !== null; )
        v.childLanes |= u, f = v.alternate, f !== null && (f.childLanes |= u), v.tag === 22 && (e = v.stateNode, e === null || e._visibility & O3 || (p = !0)), e = v, v = v.return;
      return e.tag === 3 ? (v = e.stateNode, p && n !== null && (p = 31 - kr(u), e = v.hiddenUpdates, f = e[p], f === null ? e[p] = [n] : f.push(n), n.lane = u | 536870912), v) : null;
    }
    function yh(e) {
      if (xg > cE)
        throw Gf = xg = 0, wg = s6 = null, Error(
          "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops."
        );
      Gf > fE && (Gf = 0, wg = null, console.error(
        "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."
      )), e.alternate === null && e.flags & 4098 && op(e);
      for (var n = e, u = n.return; u !== null; )
        n.alternate === null && n.flags & 4098 && op(e), n = u, u = n.return;
      return n.tag === 3 ? n.stateNode : null;
    }
    function Do(e) {
      if (Ti === null) return e;
      var n = Ti(e);
      return n === void 0 ? e : n.current;
    }
    function t1(e) {
      if (Ti === null) return e;
      var n = Ti(e);
      return n === void 0 ? e != null && typeof e.render == "function" && (n = Do(e.render), e.render !== n) ? (n = { $$typeof: ao, render: n }, e.displayName !== void 0 && (n.displayName = e.displayName), n) : e : n.current;
    }
    function x4(e, n) {
      if (Ti === null) return !1;
      var u = e.elementType;
      n = n.type;
      var f = !1, p = typeof n == "object" && n !== null ? n.$$typeof : null;
      switch (e.tag) {
        case 1:
          typeof n == "function" && (f = !0);
          break;
        case 0:
          (typeof n == "function" || p === $a) && (f = !0);
          break;
        case 11:
          (p === ao || p === $a) && (f = !0);
          break;
        case 14:
        case 15:
          (p === Cd || p === $a) && (f = !0);
          break;
        default:
          return !1;
      }
      return !!(f && (e = Ti(u), e !== void 0 && e === Ti(n)));
    }
    function vh(e) {
      Ti !== null && typeof WeakSet == "function" && (Zd === null && (Zd = /* @__PURE__ */ new WeakSet()), Zd.add(e));
    }
    function No(e, n, u) {
      var f = e.alternate, p = e.child, v = e.sibling, k = e.tag, M = e.type, q = null;
      switch (k) {
        case 0:
        case 15:
        case 1:
          q = M;
          break;
        case 11:
          q = M.render;
      }
      if (Ti === null)
        throw Error("Expected resolveFamily to be set during hot reload.");
      var j = !1;
      M = !1, q !== null && (q = Ti(q), q !== void 0 && (u.has(q) ? M = !0 : n.has(q) && (k === 1 ? M = !0 : j = !0))), Zd !== null && (Zd.has(e) || f !== null && Zd.has(f)) && (M = !0), M && (e._debugNeedsRemount = !0), (M || j) && (f = ha(e, 2), f !== null && Vt(f, e, 2)), p === null || M || No(
        p,
        n,
        u
      ), v !== null && No(
        v,
        n,
        u
      );
    }
    function f3(e, n, u, f) {
      this.tag = e, this.key = u, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = n, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = f, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null, this.actualDuration = -0, this.actualStartTime = -1.1, this.treeBaseDuration = this.selfBaseDuration = -0, this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, fb || typeof Object.preventExtensions != "function" || Object.preventExtensions(this);
    }
    function bh(e) {
      return e = e.prototype, !(!e || !e.isReactComponent);
    }
    function ui(e, n) {
      var u = e.alternate;
      switch (u === null ? (u = E(
        e.tag,
        n,
        e.key,
        e.mode
      ), u.elementType = e.elementType, u.type = e.type, u.stateNode = e.stateNode, u._debugOwner = e._debugOwner, u._debugStack = e._debugStack, u._debugTask = e._debugTask, u._debugHookTypes = e._debugHookTypes, u.alternate = e, e.alternate = u) : (u.pendingProps = n, u.type = e.type, u.flags = 0, u.subtreeFlags = 0, u.deletions = null, u.actualDuration = -0, u.actualStartTime = -1.1), u.flags = e.flags & 65011712, u.childLanes = e.childLanes, u.lanes = e.lanes, u.child = e.child, u.memoizedProps = e.memoizedProps, u.memoizedState = e.memoizedState, u.updateQueue = e.updateQueue, n = e.dependencies, u.dependencies = n === null ? null : {
        lanes: n.lanes,
        firstContext: n.firstContext,
        _debugThenableState: n._debugThenableState
      }, u.sibling = e.sibling, u.index = e.index, u.ref = e.ref, u.refCleanup = e.refCleanup, u.selfBaseDuration = e.selfBaseDuration, u.treeBaseDuration = e.treeBaseDuration, u._debugInfo = e._debugInfo, u._debugNeedsRemount = e._debugNeedsRemount, u.tag) {
        case 0:
        case 15:
          u.type = Do(e.type);
          break;
        case 1:
          u.type = Do(e.type);
          break;
        case 11:
          u.type = t1(e.type);
      }
      return u;
    }
    function n1(e, n) {
      e.flags &= 65011714;
      var u = e.alternate;
      return u === null ? (e.childLanes = 0, e.lanes = n, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0) : (e.childLanes = u.childLanes, e.lanes = u.lanes, e.child = u.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = u.memoizedProps, e.memoizedState = u.memoizedState, e.updateQueue = u.updateQueue, e.type = u.type, n = u.dependencies, e.dependencies = n === null ? null : {
        lanes: n.lanes,
        firstContext: n.firstContext,
        _debugThenableState: n._debugThenableState
      }, e.selfBaseDuration = u.selfBaseDuration, e.treeBaseDuration = u.treeBaseDuration), e;
    }
    function Sh(e, n, u, f, p, v) {
      var k = 0, M = e;
      if (typeof e == "function")
        bh(e) && (k = 1), M = Do(M);
      else if (typeof e == "string")
        k = X(), k = vd(e, u, k) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
      else
        e: switch (e) {
          case Md:
            return n = E(31, u, n, p), n.elementType = Md, n.lanes = v, n;
          case ro:
            return il(
              u.children,
              p,
              v,
              n
            );
          case ls:
            k = 8, p |= Ma, p |= bu;
            break;
          case df:
            return e = u, f = p, typeof e.id != "string" && console.error(
              'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
              typeof e.id
            ), n = E(12, e, n, f | ua), n.elementType = df, n.lanes = v, n.stateNode = { effectDuration: 0, passiveEffectDuration: 0 }, n;
          case lo:
            return n = E(13, u, n, p), n.elementType = lo, n.lanes = v, n;
          case zd:
            return n = E(19, u, n, p), n.elementType = zd, n.lanes = v, n;
          default:
            if (typeof e == "object" && e !== null)
              switch (e.$$typeof) {
                case ny:
                case za:
                  k = 10;
                  break e;
                case mf:
                  k = 9;
                  break e;
                case ao:
                  k = 11, M = t1(M);
                  break e;
                case Cd:
                  k = 14;
                  break e;
                case $a:
                  k = 16, M = null;
                  break e;
              }
            M = "", (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (M += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), e === null ? u = "null" : gr(e) ? u = "array" : e !== void 0 && e.$$typeof === hu ? (u = "<" + (ve(e.type) || "Unknown") + " />", M = " Did you accidentally export a JSX literal instead of a component?") : u = typeof e, (k = f ? Ne(f) : null) && (M += `

Check the render method of \`` + k + "`."), k = 29, u = Error(
              "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (u + "." + M)
            ), M = null;
        }
      return n = E(k, u, n, p), n.elementType = e, n.type = M, n.lanes = v, n._debugOwner = f, n;
    }
    function w0(e, n, u) {
      return n = Sh(
        e.type,
        e.key,
        e.props,
        e._owner,
        n,
        u
      ), n._debugOwner = e._owner, n._debugStack = e._debugStack, n._debugTask = e._debugTask, n;
    }
    function il(e, n, u, f) {
      return e = E(7, e, f, n), e.lanes = u, e;
    }
    function r1(e, n, u) {
      return e = E(6, e, null, n), e.lanes = u, e;
    }
    function a1(e, n, u) {
      return n = E(
        4,
        e.children !== null ? e.children : [],
        e.key,
        n
      ), n.lanes = u, n.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        implementation: e.implementation
      }, n;
    }
    function Lo(e, n) {
      Rl(), Fd[Pd++] = yy, Fd[Pd++] = gy, gy = e, yy = n;
    }
    function l1(e, n, u) {
      Rl(), Ei[Ai++] = ss, Ei[Ai++] = cs, Ei[Ai++] = Cf, Cf = e;
      var f = ss;
      e = cs;
      var p = 32 - kr(f) - 1;
      f &= ~(1 << p), u += 1;
      var v = 32 - kr(n) + p;
      if (30 < v) {
        var k = p - p % 5;
        v = (f & (1 << k) - 1).toString(32), f >>= k, p -= k, ss = 1 << 32 - kr(n) + p | u << p | f, cs = v + e;
      } else
        ss = 1 << v | u << p | f, cs = e;
    }
    function xh(e) {
      Rl(), e.return !== null && (Lo(e, 1), l1(e, 1, 0));
    }
    function Bo(e) {
      for (; e === gy; )
        gy = Fd[--Pd], Fd[Pd] = null, yy = Fd[--Pd], Fd[Pd] = null;
      for (; e === Cf; )
        Cf = Ei[--Ai], Ei[Ai] = null, cs = Ei[--Ai], Ei[Ai] = null, ss = Ei[--Ai], Ei[Ai] = null;
    }
    function Rl() {
      rn || console.error(
        "Expected to be hydrating. This is a bug in React. Please file an issue."
      );
    }
    function Ho(e, n) {
      if (e.return === null) {
        if (ki === null)
          ki = {
            fiber: e,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf: n
          };
        else {
          if (ki.fiber !== e)
            throw Error(
              "Saw multiple hydration diff roots in a pass. This is a bug in React."
            );
          ki.distanceFromLeaf > n && (ki.distanceFromLeaf = n);
        }
        return ki;
      }
      var u = Ho(
        e.return,
        n + 1
      ).children;
      return 0 < u.length && u[u.length - 1].fiber === e ? (u = u[u.length - 1], u.distanceFromLeaf > n && (u.distanceFromLeaf = n), u) : (n = {
        fiber: e,
        children: [],
        serverProps: void 0,
        serverTail: [],
        distanceFromLeaf: n
      }, u.push(n), n);
    }
    function js(e, n) {
      fs || (e = Ho(e, 0), e.serverProps = null, n !== null && (n = dd(n), e.serverTail.push(n)));
    }
    function _u(e) {
      var n = "", u = ki;
      throw u !== null && (ki = null, n = Cu(u)), Vs(
        fa(
          Error(
            `Hydration failed because the server rendered HTML didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

https://react.dev/link/hydration-mismatch` + n
          ),
          e
        )
      ), N3;
    }
    function i1(e) {
      var n = e.stateNode, u = e.type, f = e.memoizedProps;
      switch (n[Wr] = e, n[Ca] = f, iu(u, f), u) {
        case "dialog":
          Yt("cancel", n), Yt("close", n);
          break;
        case "iframe":
        case "object":
        case "embed":
          Yt("load", n);
          break;
        case "video":
        case "audio":
          for (u = 0; u < Tg.length; u++)
            Yt(Tg[u], n);
          break;
        case "source":
          Yt("error", n);
          break;
        case "img":
        case "image":
        case "link":
          Yt("error", n), Yt("load", n);
          break;
        case "details":
          Yt("toggle", n);
          break;
        case "input":
          et("input", f), Yt("invalid", n), Ao(n, f), Gm(
            n,
            f.value,
            f.defaultValue,
            f.checked,
            f.defaultChecked,
            f.type,
            f.name,
            !0
          ), Fn(n);
          break;
        case "option":
          c4(n, f);
          break;
        case "select":
          et("select", f), Yt("invalid", n), ii(n, f);
          break;
        case "textarea":
          et("textarea", f), Yt("invalid", n), lh(n, f), ko(
            n,
            f.value,
            f.defaultValue,
            f.children
          ), Fn(n);
      }
      u = f.children, typeof u != "string" && typeof u != "number" && typeof u != "bigint" || n.textContent === "" + u || f.suppressHydrationWarning === !0 || ns(n.textContent, u) ? (f.popover != null && (Yt("beforetoggle", n), Yt("toggle", n)), f.onScroll != null && Yt("scroll", n), f.onScrollEnd != null && Yt("scrollend", n), f.onClick != null && (n.onclick = Zu), n = !0) : n = !1, n || _u(e);
    }
    function wh(e) {
      for (Za = e.return; Za; )
        switch (Za.tag) {
          case 5:
          case 13:
            co = !1;
            return;
          case 27:
          case 3:
            co = !0;
            return;
          default:
            Za = Za.return;
        }
    }
    function Uo(e) {
      if (e !== Za) return !1;
      if (!rn)
        return wh(e), rn = !0, !1;
      var n = e.tag, u;
      if ((u = n !== 3 && n !== 27) && ((u = n === 5) && (u = e.type, u = !(u !== "form" && u !== "button") || Pu(e.type, e.memoizedProps)), u = !u), u && ir) {
        for (u = ir; u; ) {
          var f = Ho(e, 0), p = dd(u);
          f.serverTail.push(p), u = p.type === "Suspense" ? Ec(u) : ka(u.nextSibling);
        }
        _u(e);
      }
      if (wh(e), n === 13) {
        if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        ir = Ec(e);
      } else
        n === 27 ? (n = ir, pr(e.type) ? (e = x6, x6 = null, ir = e) : ir = n) : ir = Za ? ka(e.stateNode.nextSibling) : null;
      return !0;
    }
    function Gs() {
      ir = Za = null, fs = rn = !1;
    }
    function u1() {
      var e = Mf;
      return e !== null && (Ka === null ? Ka = e : Ka.push.apply(
        Ka,
        e
      ), Mf = null), e;
    }
    function Vs(e) {
      Mf === null ? Mf = [e] : Mf.push(e);
    }
    function w4() {
      var e = ki;
      if (e !== null) {
        ki = null;
        for (var n = Cu(e); 0 < e.children.length; )
          e = e.children[0];
        at(e.fiber, function() {
          console.error(
            `A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

%s%s`,
            "https://react.dev/link/hydration-mismatch",
            n
          );
        });
      }
    }
    function Th() {
      Kd = vy = null, Jd = !1;
    }
    function Ou(e, n, u) {
      Ye(L3, n._currentValue, e), n._currentValue = u, Ye(B3, n._currentRenderer, e), n._currentRenderer !== void 0 && n._currentRenderer !== null && n._currentRenderer !== pb && console.error(
        "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
      ), n._currentRenderer = pb;
    }
    function Ii(e, n) {
      e._currentValue = L3.current;
      var u = B3.current;
      de(B3, n), e._currentRenderer = u, de(L3, n);
    }
    function o1(e, n, u) {
      for (; e !== null; ) {
        var f = e.alternate;
        if ((e.childLanes & n) !== n ? (e.childLanes |= n, f !== null && (f.childLanes |= n)) : f !== null && (f.childLanes & n) !== n && (f.childLanes |= n), e === u) break;
        e = e.return;
      }
      e !== u && console.error(
        "Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function ra(e, n, u, f) {
      var p = e.child;
      for (p !== null && (p.return = e); p !== null; ) {
        var v = p.dependencies;
        if (v !== null) {
          var k = p.child;
          v = v.firstContext;
          e: for (; v !== null; ) {
            var M = v;
            v = p;
            for (var q = 0; q < n.length; q++)
              if (M.context === n[q]) {
                v.lanes |= u, M = v.alternate, M !== null && (M.lanes |= u), o1(
                  v.return,
                  u,
                  e
                ), f || (k = null);
                break e;
              }
            v = M.next;
          }
        } else if (p.tag === 18) {
          if (k = p.return, k === null)
            throw Error(
              "We just came from a parent so we must have had a parent. This is a bug in React."
            );
          k.lanes |= u, v = k.alternate, v !== null && (v.lanes |= u), o1(
            k,
            u,
            e
          ), k = null;
        } else k = p.child;
        if (k !== null) k.return = p;
        else
          for (k = p; k !== null; ) {
            if (k === e) {
              k = null;
              break;
            }
            if (p = k.sibling, p !== null) {
              p.return = k.return, k = p;
              break;
            }
            k = k.return;
          }
        p = k;
      }
    }
    function $i(e, n, u, f) {
      e = null;
      for (var p = n, v = !1; p !== null; ) {
        if (!v) {
          if (p.flags & 524288) v = !0;
          else if (p.flags & 262144) break;
        }
        if (p.tag === 10) {
          var k = p.alternate;
          if (k === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          if (k = k.memoizedProps, k !== null) {
            var M = p.type;
            Qa(p.pendingProps.value, k.value) || (e !== null ? e.push(M) : e = [M]);
          }
        } else if (p === _d.current) {
          if (k = p.alternate, k === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          k.memoizedState.memoizedState !== p.memoizedState.memoizedState && (e !== null ? e.push(Rg) : e = [Rg]);
        }
        p = p.return;
      }
      e !== null && ra(
        n,
        e,
        u,
        f
      ), n.flags |= 262144;
    }
    function T0(e) {
      for (e = e.firstContext; e !== null; ) {
        if (!Qa(
          e.context._currentValue,
          e.memoizedValue
        ))
          return !0;
        e = e.next;
      }
      return !1;
    }
    function Du(e) {
      vy = e, Kd = null, e = e.dependencies, e !== null && (e.firstContext = null);
    }
    function En(e) {
      return Jd && console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      ), Eh(vy, e);
    }
    function E0(e, n) {
      return vy === null && Du(e), Eh(e, n);
    }
    function Eh(e, n) {
      var u = n._currentValue;
      if (n = { context: n, memoizedValue: u, next: null }, Kd === null) {
        if (e === null)
          throw Error(
            "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
          );
        Kd = n, e.dependencies = {
          lanes: 0,
          firstContext: n,
          _debugThenableState: null
        }, e.flags |= 524288;
      } else Kd = Kd.next = n;
      return u;
    }
    function s1() {
      return {
        controller: new FT(),
        data: /* @__PURE__ */ new Map(),
        refCount: 0
      };
    }
    function ul(e) {
      e.controller.signal.aborted && console.warn(
        "A cache instance was retained after it was already freed. This likely indicates a bug in React."
      ), e.refCount++;
    }
    function qo(e) {
      e.refCount--, 0 > e.refCount && console.warn(
        "A cache instance was released after it was already freed. This likely indicates a bug in React."
      ), e.refCount === 0 && PT(KT, function() {
        e.controller.abort();
      });
    }
    function Ha() {
      var e = _f;
      return _f = 0, e;
    }
    function Ys(e) {
      var n = _f;
      return _f = e, n;
    }
    function Is(e) {
      var n = _f;
      return _f += e, n;
    }
    function Xi(e) {
      yl = Wd(), 0 > e.actualStartTime && (e.actualStartTime = yl);
    }
    function Nu(e) {
      if (0 <= yl) {
        var n = Wd() - yl;
        e.actualDuration += n, e.selfBaseDuration = n, yl = -1;
      }
    }
    function Ah(e) {
      if (0 <= yl) {
        var n = Wd() - yl;
        e.actualDuration += n, yl = -1;
      }
    }
    function zl() {
      if (0 <= yl) {
        var e = Wd() - yl;
        yl = -1, _f += e;
      }
    }
    function Pr() {
      yl = Wd();
    }
    function A0(e) {
      for (var n = e.child; n; )
        e.actualDuration += n.actualDuration, n = n.sibling;
    }
    function T4(e, n) {
      if (eg === null) {
        var u = eg = [];
        H3 = 0, Of = sd(), em = {
          status: "pending",
          value: void 0,
          then: function(f) {
            u.push(f);
          }
        };
      }
      return H3++, n.then(c1, c1), n;
    }
    function c1() {
      if (--H3 === 0 && eg !== null) {
        em !== null && (em.status = "fulfilled");
        var e = eg;
        eg = null, Of = 0, em = null;
        for (var n = 0; n < e.length; n++) (0, e[n])();
      }
    }
    function h3(e, n) {
      var u = [], f = {
        status: "pending",
        value: null,
        reason: null,
        then: function(p) {
          u.push(p);
        }
      };
      return e.then(
        function() {
          f.status = "fulfilled", f.value = n;
          for (var p = 0; p < u.length; p++) (0, u[p])(n);
        },
        function(p) {
          for (f.status = "rejected", f.reason = p, p = 0; p < u.length; p++)
            (0, u[p])(void 0);
        }
      ), f;
    }
    function f1() {
      var e = Df.current;
      return e !== null ? e : zn.pooledCache;
    }
    function kh(e, n) {
      n === null ? Ye(Df, Df.current, e) : Ye(Df, n.pool, e);
    }
    function h1() {
      var e = f1();
      return e === null ? null : { parent: Vr._currentValue, pool: e };
    }
    function d1() {
      return { didWarnAboutUncachedPromise: !1, thenables: [] };
    }
    function Rh(e) {
      return e = e.status, e === "fulfilled" || e === "rejected";
    }
    function da() {
    }
    function m1(e, n, u) {
      ye.actQueue !== null && (ye.didUsePromise = !0);
      var f = e.thenables;
      switch (u = f[u], u === void 0 ? f.push(n) : u !== n && (e.didWarnAboutUncachedPromise || (e.didWarnAboutUncachedPromise = !0, console.error(
        "A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework."
      )), n.then(da, da), n = u), n.status) {
        case "fulfilled":
          return n.value;
        case "rejected":
          throw e = n.reason, qa(e), e;
        default:
          if (typeof n.status == "string")
            n.then(da, da);
          else {
            if (e = zn, e !== null && 100 < e.shellSuspendCounter)
              throw Error(
                "An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
              );
            e = n, e.status = "pending", e.then(
              function(p) {
                if (n.status === "pending") {
                  var v = n;
                  v.status = "fulfilled", v.value = p;
                }
              },
              function(p) {
                if (n.status === "pending") {
                  var v = n;
                  v.status = "rejected", v.reason = p;
                }
              }
            );
          }
          switch (n.status) {
            case "fulfilled":
              return n.value;
            case "rejected":
              throw e = n.reason, qa(e), e;
          }
          throw og = n, Ey = !0, ug;
      }
    }
    function Ua() {
      if (og === null)
        throw Error(
          "Expected a suspended thenable. This is a bug in React. Please file an issue."
        );
      var e = og;
      return og = null, Ey = !1, e;
    }
    function qa(e) {
      if (e === ug || e === Ty)
        throw Error(
          "Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
        );
    }
    function Lu(e) {
      e.updateQueue = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: { pending: null, lanes: 0, hiddenCallbacks: null },
        callbacks: null
      };
    }
    function k0(e, n) {
      e = e.updateQueue, n.updateQueue === e && (n.updateQueue = {
        baseState: e.baseState,
        firstBaseUpdate: e.firstBaseUpdate,
        lastBaseUpdate: e.lastBaseUpdate,
        shared: e.shared,
        callbacks: null
      });
    }
    function Cl(e) {
      return {
        lane: e,
        tag: Sb,
        payload: null,
        callback: null,
        next: null
      };
    }
    function Ml(e, n, u) {
      var f = e.updateQueue;
      if (f === null) return null;
      if (f = f.shared, j3 === f && !Tb) {
        var p = ee(e);
        console.error(
          `An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.

Please update the following component: %s`,
          p
        ), Tb = !0;
      }
      return (fn & Pa) !== Pl ? (p = f.pending, p === null ? n.next = n : (n.next = p.next, p.next = n), f.pending = n, n = yh(e), S4(e, null, u), n) : (gh(e, f, n, u), yh(e));
    }
    function jo(e, n, u) {
      if (n = n.updateQueue, n !== null && (n = n.shared, (u & 4194048) !== 0)) {
        var f = n.lanes;
        f &= e.pendingLanes, u |= f, n.lanes = u, je(e, u);
      }
    }
    function Qi(e, n) {
      var u = e.updateQueue, f = e.alternate;
      if (f !== null && (f = f.updateQueue, u === f)) {
        var p = null, v = null;
        if (u = u.firstBaseUpdate, u !== null) {
          do {
            var k = {
              lane: u.lane,
              tag: u.tag,
              payload: u.payload,
              callback: null,
              next: null
            };
            v === null ? p = v = k : v = v.next = k, u = u.next;
          } while (u !== null);
          v === null ? p = v = n : v = v.next = n;
        } else p = v = n;
        u = {
          baseState: f.baseState,
          firstBaseUpdate: p,
          lastBaseUpdate: v,
          shared: f.shared,
          callbacks: f.callbacks
        }, e.updateQueue = u;
        return;
      }
      e = u.lastBaseUpdate, e === null ? u.firstBaseUpdate = n : e.next = n, u.lastBaseUpdate = n;
    }
    function $s() {
      if (G3) {
        var e = em;
        if (e !== null) throw e;
      }
    }
    function Bu(e, n, u, f) {
      G3 = !1;
      var p = e.updateQueue;
      jc = !1, j3 = p.shared;
      var v = p.firstBaseUpdate, k = p.lastBaseUpdate, M = p.shared.pending;
      if (M !== null) {
        p.shared.pending = null;
        var q = M, j = q.next;
        q.next = null, k === null ? v = j : k.next = j, k = q;
        var xe = e.alternate;
        xe !== null && (xe = xe.updateQueue, M = xe.lastBaseUpdate, M !== k && (M === null ? xe.firstBaseUpdate = j : M.next = j, xe.lastBaseUpdate = q));
      }
      if (v !== null) {
        var Ae = p.baseState;
        k = 0, xe = j = q = null, M = v;
        do {
          var pe = M.lane & -536870913, Re = pe !== M.lane;
          if (Re ? (Zt & pe) === pe : (f & pe) === pe) {
            pe !== 0 && pe === Of && (G3 = !0), xe !== null && (xe = xe.next = {
              lane: 0,
              tag: M.tag,
              payload: M.payload,
              callback: null,
              next: null
            });
            e: {
              pe = e;
              var tt = M, bt = n, Cn = u;
              switch (tt.tag) {
                case xb:
                  if (tt = tt.payload, typeof tt == "function") {
                    Jd = !0;
                    var Kt = tt.call(
                      Cn,
                      Ae,
                      bt
                    );
                    if (pe.mode & Ma) {
                      Ge(!0);
                      try {
                        tt.call(Cn, Ae, bt);
                      } finally {
                        Ge(!1);
                      }
                    }
                    Jd = !1, Ae = Kt;
                    break e;
                  }
                  Ae = tt;
                  break e;
                case q3:
                  pe.flags = pe.flags & -65537 | 128;
                case Sb:
                  if (Kt = tt.payload, typeof Kt == "function") {
                    if (Jd = !0, tt = Kt.call(
                      Cn,
                      Ae,
                      bt
                    ), pe.mode & Ma) {
                      Ge(!0);
                      try {
                        Kt.call(Cn, Ae, bt);
                      } finally {
                        Ge(!1);
                      }
                    }
                    Jd = !1;
                  } else tt = Kt;
                  if (tt == null) break e;
                  Ae = Et({}, Ae, tt);
                  break e;
                case wb:
                  jc = !0;
              }
            }
            pe = M.callback, pe !== null && (e.flags |= 64, Re && (e.flags |= 8192), Re = p.callbacks, Re === null ? p.callbacks = [pe] : Re.push(pe));
          } else
            Re = {
              lane: pe,
              tag: M.tag,
              payload: M.payload,
              callback: M.callback,
              next: null
            }, xe === null ? (j = xe = Re, q = Ae) : xe = xe.next = Re, k |= pe;
          if (M = M.next, M === null) {
            if (M = p.shared.pending, M === null)
              break;
            Re = M, M = Re.next, Re.next = null, p.lastBaseUpdate = Re, p.shared.pending = null;
          }
        } while (!0);
        xe === null && (q = Ae), p.baseState = q, p.firstBaseUpdate = j, p.lastBaseUpdate = xe, v === null && (p.shared.lanes = 0), Ic |= k, e.lanes = k, e.memoizedState = Ae;
      }
      j3 = null;
    }
    function Go(e, n) {
      if (typeof e != "function")
        throw Error(
          "Invalid argument passed as callback. Expected a function. Instead received: " + e
        );
      e.call(n);
    }
    function d3(e, n) {
      var u = e.shared.hiddenCallbacks;
      if (u !== null)
        for (e.shared.hiddenCallbacks = null, e = 0; e < u.length; e++)
          Go(u[e], n);
    }
    function ma(e, n) {
      var u = e.callbacks;
      if (u !== null)
        for (e.callbacks = null, e = 0; e < u.length; e++)
          Go(u[e], n);
    }
    function zh(e, n) {
      var u = mo;
      Ye(Ay, u, e), Ye(tm, n, e), mo = u | n.baseLanes;
    }
    function _l(e) {
      Ye(Ay, mo, e), Ye(
        tm,
        tm.current,
        e
      );
    }
    function Ch(e) {
      mo = Ay.current, de(tm, e), de(Ay, e);
    }
    function Ot() {
      var e = Ee;
      Ci === null ? Ci = [e] : Ci.push(e);
    }
    function Ue() {
      var e = Ee;
      if (Ci !== null && (ds++, Ci[ds] !== e)) {
        var n = ee(At);
        if (!Eb.has(n) && (Eb.add(n), Ci !== null)) {
          for (var u = "", f = 0; f <= ds; f++) {
            var p = Ci[f], v = f === ds ? e : p;
            for (p = f + 1 + ". " + p; 30 > p.length; )
              p += " ";
            p += v + `
`, u += p;
          }
          console.error(
            `React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`,
            n,
            u
          );
        }
      }
    }
    function Hu(e) {
      e == null || gr(e) || console.error(
        "%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",
        Ee,
        typeof e
      );
    }
    function Xs() {
      var e = ee(At);
      kb.has(e) || (kb.add(e), console.error(
        "ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.",
        e
      ));
    }
    function Sn() {
      throw Error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      );
    }
    function Uu(e, n) {
      if (cg) return !1;
      if (n === null)
        return console.error(
          "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
          Ee
        ), !1;
      e.length !== n.length && console.error(
        `The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`,
        Ee,
        "[" + n.join(", ") + "]",
        "[" + e.join(", ") + "]"
      );
      for (var u = 0; u < n.length && u < e.length; u++)
        if (!Qa(e[u], n[u])) return !1;
      return !0;
    }
    function Qs(e, n, u, f, p, v) {
      Gc = v, At = n, Ci = e !== null ? e._debugHookTypes : null, ds = -1, cg = e !== null && e.type !== n.type, (Object.prototype.toString.call(u) === "[object AsyncFunction]" || Object.prototype.toString.call(u) === "[object AsyncGeneratorFunction]") && (v = ee(At), V3.has(v) || (V3.add(v), console.error(
        "%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.",
        v === null ? "An unknown Component" : "<" + v + ">"
      ))), n.memoizedState = null, n.updateQueue = null, n.lanes = 0, ye.H = e !== null && e.memoizedState !== null ? I3 : Ci !== null ? Rb : Y3, Lf = v = (n.mode & Ma) !== Dn;
      var k = $3(u, f, p);
      if (Lf = !1, rm && (k = pa(
        n,
        u,
        f,
        p
      )), v) {
        Ge(!0);
        try {
          k = pa(
            n,
            u,
            f,
            p
          );
        } finally {
          Ge(!1);
        }
      }
      return R0(e, n), k;
    }
    function R0(e, n) {
      n._debugHookTypes = Ci, n.dependencies === null ? hs !== null && (n.dependencies = {
        lanes: 0,
        firstContext: null,
        _debugThenableState: hs
      }) : n.dependencies._debugThenableState = hs, ye.H = zy;
      var u = xn !== null && xn.next !== null;
      if (Gc = 0, Ci = Ee = Cr = xn = At = null, ds = -1, e !== null && (e.flags & 65011712) !== (n.flags & 65011712) && console.error(
        "Internal React error: Expected static flag was missing. Please notify the React team."
      ), ky = !1, sg = 0, hs = null, u)
        throw Error(
          "Rendered fewer hooks than expected. This may be caused by an accidental early return statement."
        );
      e === null || ea || (e = e.dependencies, e !== null && T0(e) && (ea = !0)), Ey ? (Ey = !1, e = !0) : e = !1, e && (n = ee(n) || "Unknown", Ab.has(n) || V3.has(n) || (Ab.add(n), console.error(
        "`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary."
      )));
    }
    function pa(e, n, u, f) {
      At = e;
      var p = 0;
      do {
        if (rm && (hs = null), sg = 0, rm = !1, p >= WT)
          throw Error(
            "Too many re-renders. React limits the number of renders to prevent an infinite loop."
          );
        if (p += 1, cg = !1, Cr = xn = null, e.updateQueue != null) {
          var v = e.updateQueue;
          v.lastEffect = null, v.events = null, v.stores = null, v.memoCache != null && (v.memoCache.index = 0);
        }
        ds = -1, ye.H = zb, v = $3(n, u, f);
      } while (rm);
      return v;
    }
    function ol() {
      var e = ye.H, n = e.useState()[0];
      return n = typeof n.then == "function" ? Vo(n) : n, e = e.useState()[0], (xn !== null ? xn.memoizedState : null) !== e && (At.flags |= 1024), n;
    }
    function Zi() {
      var e = Ry !== 0;
      return Ry = 0, e;
    }
    function Ol(e, n, u) {
      n.updateQueue = e.updateQueue, n.flags = (n.mode & bu) !== Dn ? n.flags & -402655237 : n.flags & -2053, e.lanes &= ~u;
    }
    function Dl(e) {
      if (ky) {
        for (e = e.memoizedState; e !== null; ) {
          var n = e.queue;
          n !== null && (n.pending = null), e = e.next;
        }
        ky = !1;
      }
      Gc = 0, Ci = Cr = xn = At = null, ds = -1, Ee = null, rm = !1, sg = Ry = 0, hs = null;
    }
    function nr() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Cr === null ? At.memoizedState = Cr = e : Cr = Cr.next = e, Cr;
    }
    function sn() {
      if (xn === null) {
        var e = At.alternate;
        e = e !== null ? e.memoizedState : null;
      } else e = xn.next;
      var n = Cr === null ? At.memoizedState : Cr.next;
      if (n !== null)
        Cr = n, xn = e;
      else {
        if (e === null)
          throw At.alternate === null ? Error(
            "Update hook called on initial render. This is likely a bug in React. Please file an issue."
          ) : Error("Rendered more hooks than during the previous render.");
        xn = e, e = {
          memoizedState: xn.memoizedState,
          baseState: xn.baseState,
          baseQueue: xn.baseQueue,
          queue: xn.queue,
          next: null
        }, Cr === null ? At.memoizedState = Cr = e : Cr = Cr.next = e;
      }
      return Cr;
    }
    function z0() {
      return { lastEffect: null, events: null, stores: null, memoCache: null };
    }
    function Vo(e) {
      var n = sg;
      return sg += 1, hs === null && (hs = d1()), e = m1(hs, e, n), n = At, (Cr === null ? n.memoizedState : Cr.next) === null && (n = n.alternate, ye.H = n !== null && n.memoizedState !== null ? I3 : Y3), e;
    }
    function Vn(e) {
      if (e !== null && typeof e == "object") {
        if (typeof e.then == "function") return Vo(e);
        if (e.$$typeof === za) return En(e);
      }
      throw Error("An unsupported type was passed to use(): " + String(e));
    }
    function dn(e) {
      var n = null, u = At.updateQueue;
      if (u !== null && (n = u.memoCache), n == null) {
        var f = At.alternate;
        f !== null && (f = f.updateQueue, f !== null && (f = f.memoCache, f != null && (n = {
          data: f.data.map(function(p) {
            return p.slice();
          }),
          index: 0
        })));
      }
      if (n == null && (n = { data: [], index: 0 }), u === null && (u = z0(), At.updateQueue = u), u.memoCache = n, u = n.data[n.index], u === void 0 || cg)
        for (u = n.data[n.index] = Array(e), f = 0; f < e; f++)
          u[f] = ry;
      else
        u.length !== e && console.error(
          "Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.",
          u.length,
          e
        );
      return n.index++, u;
    }
    function Dt(e, n) {
      return typeof n == "function" ? n(e) : n;
    }
    function Fi(e, n, u) {
      var f = nr();
      if (u !== void 0) {
        var p = u(n);
        if (Lf) {
          Ge(!0);
          try {
            u(n);
          } finally {
            Ge(!1);
          }
        }
      } else p = n;
      return f.memoizedState = f.baseState = p, e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: p
      }, f.queue = e, e = e.dispatch = U0.bind(
        null,
        At,
        e
      ), [f.memoizedState, e];
    }
    function aa(e) {
      var n = sn();
      return C0(n, xn, e);
    }
    function C0(e, n, u) {
      var f = e.queue;
      if (f === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      f.lastRenderedReducer = u;
      var p = e.baseQueue, v = f.pending;
      if (v !== null) {
        if (p !== null) {
          var k = p.next;
          p.next = v.next, v.next = k;
        }
        n.baseQueue !== p && console.error(
          "Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."
        ), n.baseQueue = p = v, f.pending = null;
      }
      if (v = e.baseState, p === null) e.memoizedState = v;
      else {
        n = p.next;
        var M = k = null, q = null, j = n, xe = !1;
        do {
          var Ae = j.lane & -536870913;
          if (Ae !== j.lane ? (Zt & Ae) === Ae : (Gc & Ae) === Ae) {
            var pe = j.revertLane;
            if (pe === 0)
              q !== null && (q = q.next = {
                lane: 0,
                revertLane: 0,
                action: j.action,
                hasEagerState: j.hasEagerState,
                eagerState: j.eagerState,
                next: null
              }), Ae === Of && (xe = !0);
            else if ((Gc & pe) === pe) {
              j = j.next, pe === Of && (xe = !0);
              continue;
            } else
              Ae = {
                lane: 0,
                revertLane: j.revertLane,
                action: j.action,
                hasEagerState: j.hasEagerState,
                eagerState: j.eagerState,
                next: null
              }, q === null ? (M = q = Ae, k = v) : q = q.next = Ae, At.lanes |= pe, Ic |= pe;
            Ae = j.action, Lf && u(v, Ae), v = j.hasEagerState ? j.eagerState : u(v, Ae);
          } else
            pe = {
              lane: Ae,
              revertLane: j.revertLane,
              action: j.action,
              hasEagerState: j.hasEagerState,
              eagerState: j.eagerState,
              next: null
            }, q === null ? (M = q = pe, k = v) : q = q.next = pe, At.lanes |= Ae, Ic |= Ae;
          j = j.next;
        } while (j !== null && j !== n);
        if (q === null ? k = v : q.next = M, !Qa(v, e.memoizedState) && (ea = !0, xe && (u = em, u !== null)))
          throw u;
        e.memoizedState = v, e.baseState = k, e.baseQueue = q, f.lastRenderedState = v;
      }
      return p === null && (f.lanes = 0), [e.memoizedState, f.dispatch];
    }
    function Nl(e) {
      var n = sn(), u = n.queue;
      if (u === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      u.lastRenderedReducer = e;
      var f = u.dispatch, p = u.pending, v = n.memoizedState;
      if (p !== null) {
        u.pending = null;
        var k = p = p.next;
        do
          v = e(v, k.action), k = k.next;
        while (k !== p);
        Qa(v, n.memoizedState) || (ea = !0), n.memoizedState = v, n.baseQueue === null && (n.baseState = v), u.lastRenderedState = v;
      }
      return [v, f];
    }
    function Mh(e, n, u) {
      var f = At, p = nr();
      if (rn) {
        if (u === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        var v = u();
        nm || v === u() || (console.error(
          "The result of getServerSnapshot should be cached to avoid an infinite loop"
        ), nm = !0);
      } else {
        if (v = n(), nm || (u = n(), Qa(v, u) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), nm = !0)), zn === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        Zt & 124 || Zs(f, n, v);
      }
      return p.memoizedState = v, u = { value: v, getSnapshot: n }, p.queue = u, D0(
        p1.bind(null, f, u, e),
        [e]
      ), f.flags |= 2048, ci(
        zi | Yr,
        Ws(),
        Fs.bind(
          null,
          f,
          u,
          v,
          n
        ),
        null
      ), v;
    }
    function M0(e, n, u) {
      var f = At, p = sn(), v = rn;
      if (v) {
        if (u === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        u = u();
      } else if (u = n(), !nm) {
        var k = n();
        Qa(u, k) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), nm = !0);
      }
      (k = !Qa(
        (xn || p).memoizedState,
        u
      )) && (p.memoizedState = u, ea = !0), p = p.queue;
      var M = p1.bind(null, f, p, e);
      if (ga(2048, Yr, M, [e]), p.getSnapshot !== n || k || Cr !== null && Cr.memoizedState.tag & zi) {
        if (f.flags |= 2048, ci(
          zi | Yr,
          Ws(),
          Fs.bind(
            null,
            f,
            p,
            u,
            n
          ),
          null
        ), zn === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        v || Gc & 124 || Zs(f, n, u);
      }
      return u;
    }
    function Zs(e, n, u) {
      e.flags |= 16384, e = { getSnapshot: n, value: u }, n = At.updateQueue, n === null ? (n = z0(), At.updateQueue = n, n.stores = [e]) : (u = n.stores, u === null ? n.stores = [e] : u.push(e));
    }
    function Fs(e, n, u, f) {
      n.value = u, n.getSnapshot = f, Ps(n) && _h(e);
    }
    function p1(e, n, u) {
      return u(function() {
        Ps(n) && _h(e);
      });
    }
    function Ps(e) {
      var n = e.getSnapshot;
      e = e.value;
      try {
        var u = n();
        return !Qa(e, u);
      } catch {
        return !0;
      }
    }
    function _h(e) {
      var n = ha(e, 2);
      n !== null && Vt(n, e, 2);
    }
    function Pi(e) {
      var n = nr();
      if (typeof e == "function") {
        var u = e;
        if (e = u(), Lf) {
          Ge(!0);
          try {
            u();
          } finally {
            Ge(!1);
          }
        }
      }
      return n.memoizedState = n.baseState = e, n.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Dt,
        lastRenderedState: e
      }, n;
    }
    function Ll(e) {
      e = Pi(e);
      var n = e.queue, u = lc.bind(null, At, n);
      return n.dispatch = u, [e.memoizedState, u];
    }
    function oi(e) {
      var n = nr();
      n.memoizedState = n.baseState = e;
      var u = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return n.queue = u, n = Uh.bind(
        null,
        At,
        !0,
        u
      ), u.dispatch = n, [e, n];
    }
    function si(e, n) {
      var u = sn();
      return Oh(u, xn, e, n);
    }
    function Oh(e, n, u, f) {
      return e.baseState = u, C0(
        e,
        xn,
        typeof f == "function" ? f : Dt
      );
    }
    function Dh(e, n) {
      var u = sn();
      return xn !== null ? Oh(u, xn, e, n) : (u.baseState = e, [e, u.queue.dispatch]);
    }
    function _0(e, n, u, f, p) {
      if (eu(e))
        throw Error("Cannot update form state while rendering.");
      if (e = n.action, e !== null) {
        var v = {
          payload: p,
          action: e,
          next: null,
          isTransition: !0,
          status: "pending",
          value: null,
          reason: null,
          listeners: [],
          then: function(k) {
            v.listeners.push(k);
          }
        };
        ye.T !== null ? u(!0) : v.isTransition = !1, f(v), u = n.pending, u === null ? (v.next = n.pending = v, O0(n, v)) : (v.next = u.next, n.pending = u.next = v);
      }
    }
    function O0(e, n) {
      var u = n.action, f = n.payload, p = e.state;
      if (n.isTransition) {
        var v = ye.T, k = {};
        ye.T = k, ye.T._updatedFibers = /* @__PURE__ */ new Set();
        try {
          var M = u(p, f), q = ye.S;
          q !== null && q(k, M), qu(e, n, M);
        } catch (j) {
          Ks(e, n, j);
        } finally {
          ye.T = v, v === null && k._updatedFibers && (e = k._updatedFibers.size, k._updatedFibers.clear(), 10 < e && console.warn(
            "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
          ));
        }
      } else
        try {
          k = u(p, f), qu(e, n, k);
        } catch (j) {
          Ks(e, n, j);
        }
    }
    function qu(e, n, u) {
      u !== null && typeof u == "object" && typeof u.then == "function" ? (u.then(
        function(f) {
          Hr(e, n, f);
        },
        function(f) {
          return Ks(e, n, f);
        }
      ), n.isTransition || console.error(
        "An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop."
      )) : Hr(e, n, u);
    }
    function Hr(e, n, u) {
      n.status = "fulfilled", n.value = u, g1(n), e.state = u, n = e.pending, n !== null && (u = n.next, u === n ? e.pending = null : (u = u.next, n.next = u, O0(e, u)));
    }
    function Ks(e, n, u) {
      var f = e.pending;
      if (e.pending = null, f !== null) {
        f = f.next;
        do
          n.status = "rejected", n.reason = u, g1(n), n = n.next;
        while (n !== f);
      }
      e.action = null;
    }
    function g1(e) {
      e = e.listeners;
      for (var n = 0; n < e.length; n++) (0, e[n])();
    }
    function E4(e, n) {
      return n;
    }
    function Js(e, n) {
      if (rn) {
        var u = zn.formState;
        if (u !== null) {
          e: {
            var f = At;
            if (rn) {
              if (ir) {
                t: {
                  for (var p = ir, v = co; p.nodeType !== 8; ) {
                    if (!v) {
                      p = null;
                      break t;
                    }
                    if (p = ka(
                      p.nextSibling
                    ), p === null) {
                      p = null;
                      break t;
                    }
                  }
                  v = p.data, p = v === y6 || v === k8 ? p : null;
                }
                if (p) {
                  ir = ka(
                    p.nextSibling
                  ), f = p.data === y6;
                  break e;
                }
              }
              _u(f);
            }
            f = !1;
          }
          f && (n = u[0]);
        }
      }
      return u = nr(), u.memoizedState = u.baseState = n, f = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: E4,
        lastRenderedState: n
      }, u.queue = f, u = lc.bind(
        null,
        At,
        f
      ), f.dispatch = u, f = Pi(!1), v = Uh.bind(
        null,
        At,
        !1,
        f.queue
      ), f = nr(), p = {
        state: n,
        dispatch: null,
        action: e,
        pending: null
      }, f.queue = p, u = _0.bind(
        null,
        At,
        p,
        v,
        u
      ), p.dispatch = u, f.memoizedState = e, [n, u, !1];
    }
    function Nh(e) {
      var n = sn();
      return rr(n, xn, e);
    }
    function rr(e, n, u) {
      if (n = C0(
        e,
        n,
        E4
      )[0], e = aa(Dt)[0], typeof n == "object" && n !== null && typeof n.then == "function")
        try {
          var f = Vo(n);
        } catch (k) {
          throw k === ug ? Ty : k;
        }
      else f = n;
      n = sn();
      var p = n.queue, v = p.dispatch;
      return u !== n.memoizedState && (At.flags |= 2048, ci(
        zi | Yr,
        Ws(),
        y1.bind(null, p, u),
        null
      )), [f, v, e];
    }
    function y1(e, n) {
      e.action = n;
    }
    function ju(e) {
      var n = sn(), u = xn;
      if (u !== null)
        return rr(n, u, e);
      sn(), n = n.memoizedState, u = sn();
      var f = u.queue.dispatch;
      return u.memoizedState = e, [n, f, !1];
    }
    function ci(e, n, u, f) {
      return e = {
        tag: e,
        create: u,
        deps: f,
        inst: n,
        next: null
      }, n = At.updateQueue, n === null && (n = z0(), At.updateQueue = n), u = n.lastEffect, u === null ? n.lastEffect = e.next = e : (f = u.next, u.next = e, e.next = f, n.lastEffect = e), e;
    }
    function Ws() {
      return { destroy: void 0, resource: void 0 };
    }
    function Gu(e) {
      var n = nr();
      return e = { current: e }, n.memoizedState = e;
    }
    function sl(e, n, u, f) {
      var p = nr();
      f = f === void 0 ? null : f, At.flags |= e, p.memoizedState = ci(
        zi | n,
        Ws(),
        u,
        f
      );
    }
    function ga(e, n, u, f) {
      var p = sn();
      f = f === void 0 ? null : f;
      var v = p.memoizedState.inst;
      xn !== null && f !== null && Uu(f, xn.memoizedState.deps) ? p.memoizedState = ci(n, v, u, f) : (At.flags |= e, p.memoizedState = ci(
        zi | n,
        v,
        u,
        f
      ));
    }
    function D0(e, n) {
      (At.mode & bu) !== Dn && (At.mode & cb) === Dn ? sl(276826112, Yr, e, n) : sl(8390656, Yr, e, n);
    }
    function v1(e, n) {
      var u = 4194308;
      return (At.mode & bu) !== Dn && (u |= 134217728), sl(u, oa, e, n);
    }
    function b1(e, n) {
      if (typeof n == "function") {
        e = e();
        var u = n(e);
        return function() {
          typeof u == "function" ? u() : n(null);
        };
      }
      if (n != null)
        return n.hasOwnProperty("current") || console.error(
          "Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.",
          "an object with keys {" + Object.keys(n).join(", ") + "}"
        ), e = e(), n.current = e, function() {
          n.current = null;
        };
    }
    function Ki(e, n, u) {
      typeof n != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        n !== null ? typeof n : "null"
      ), u = u != null ? u.concat([e]) : null;
      var f = 4194308;
      (At.mode & bu) !== Dn && (f |= 134217728), sl(
        f,
        oa,
        b1.bind(null, n, e),
        u
      );
    }
    function ec(e, n, u) {
      typeof n != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        n !== null ? typeof n : "null"
      ), u = u != null ? u.concat([e]) : null, ga(
        4,
        oa,
        b1.bind(null, n, e),
        u
      );
    }
    function tc(e, n) {
      return nr().memoizedState = [
        e,
        n === void 0 ? null : n
      ], e;
    }
    function N0(e, n) {
      var u = sn();
      n = n === void 0 ? null : n;
      var f = u.memoizedState;
      return n !== null && Uu(n, f[1]) ? f[0] : (u.memoizedState = [e, n], e);
    }
    function Yo(e, n) {
      var u = nr();
      n = n === void 0 ? null : n;
      var f = e();
      if (Lf) {
        Ge(!0);
        try {
          e();
        } finally {
          Ge(!1);
        }
      }
      return u.memoizedState = [f, n], f;
    }
    function L0(e, n) {
      var u = sn();
      n = n === void 0 ? null : n;
      var f = u.memoizedState;
      if (n !== null && Uu(n, f[1]))
        return f[0];
      if (f = e(), Lf) {
        Ge(!0);
        try {
          e();
        } finally {
          Ge(!1);
        }
      }
      return u.memoizedState = [f, n], f;
    }
    function nc(e, n) {
      var u = nr();
      return rc(u, e, n);
    }
    function Lh(e, n) {
      var u = sn();
      return x1(
        u,
        xn.memoizedState,
        e,
        n
      );
    }
    function S1(e, n) {
      var u = sn();
      return xn === null ? rc(u, e, n) : x1(
        u,
        xn.memoizedState,
        e,
        n
      );
    }
    function rc(e, n, u) {
      return u === void 0 || Gc & 1073741824 ? e.memoizedState = n : (e.memoizedState = u, e = J1(), At.lanes |= e, Ic |= e, u);
    }
    function x1(e, n, u, f) {
      return Qa(u, n) ? u : tm.current !== null ? (e = rc(e, u, f), Qa(e, n) || (ea = !0), e) : Gc & 42 ? (e = J1(), At.lanes |= e, Ic |= e, n) : (ea = !0, e.memoizedState = u);
    }
    function ac(e, n, u, f, p) {
      var v = ln.p;
      ln.p = v !== 0 && v < yi ? v : yi;
      var k = ye.T, M = {};
      ye.T = M, Uh(e, !1, n, u), M._updatedFibers = /* @__PURE__ */ new Set();
      try {
        var q = p(), j = ye.S;
        if (j !== null && j(M, q), q !== null && typeof q == "object" && typeof q.then == "function") {
          var xe = h3(
            q,
            f
          );
          ic(
            e,
            n,
            xe,
            Ga(e)
          );
        } else
          ic(
            e,
            n,
            f,
            Ga(e)
          );
      } catch (Ae) {
        ic(
          e,
          n,
          { then: function() {
          }, status: "rejected", reason: Ae },
          Ga(e)
        );
      } finally {
        ln.p = v, ye.T = k, k === null && M._updatedFibers && (e = M._updatedFibers.size, M._updatedFibers.clear(), 10 < e && console.warn(
          "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
        ));
      }
    }
    function Bh(e, n, u, f) {
      if (e.tag !== 5)
        throw Error(
          "Expected the form instance to be a HostComponent. This is a bug in React."
        );
      var p = w1(e).queue;
      ac(
        e,
        p,
        n,
        Xf,
        u === null ? T : function() {
          return Ji(e), u(f);
        }
      );
    }
    function w1(e) {
      var n = e.memoizedState;
      if (n !== null) return n;
      n = {
        memoizedState: Xf,
        baseState: Xf,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: Dt,
          lastRenderedState: Xf
        },
        next: null
      };
      var u = {};
      return n.next = {
        memoizedState: u,
        baseState: u,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: Dt,
          lastRenderedState: u
        },
        next: null
      }, e.memoizedState = n, e = e.alternate, e !== null && (e.memoizedState = n), n;
    }
    function Ji(e) {
      ye.T === null && console.error(
        "requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition."
      );
      var n = w1(e).next.queue;
      ic(
        e,
        n,
        {},
        Ga(e)
      );
    }
    function B0() {
      var e = Pi(!1);
      return e = ac.bind(
        null,
        At,
        e.queue,
        !0,
        !1
      ), nr().memoizedState = e, [!1, e];
    }
    function Hh() {
      var e = aa(Dt)[0], n = sn().memoizedState;
      return [
        typeof e == "boolean" ? e : Vo(e),
        n
      ];
    }
    function Wi() {
      var e = Nl(Dt)[0], n = sn().memoizedState;
      return [
        typeof e == "boolean" ? e : Vo(e),
        n
      ];
    }
    function ya() {
      return En(Rg);
    }
    function Io() {
      var e = nr(), n = zn.identifierPrefix;
      if (rn) {
        var u = cs, f = ss;
        u = (f & ~(1 << 32 - kr(f) - 1)).toString(32) + u, n = "«" + n + "R" + u, u = Ry++, 0 < u && (n += "H" + u.toString(32)), n += "»";
      } else
        u = JT++, n = "«" + n + "r" + u.toString(32) + "»";
      return e.memoizedState = n;
    }
    function H0() {
      return nr().memoizedState = T1.bind(
        null,
        At
      );
    }
    function T1(e, n) {
      for (var u = e.return; u !== null; ) {
        switch (u.tag) {
          case 24:
          case 3:
            var f = Ga(u);
            e = Cl(f);
            var p = Ml(u, e, f);
            p !== null && (Vt(p, u, f), jo(p, u, f)), u = s1(), n != null && p !== null && console.error(
              "The seed argument is not enabled outside experimental channels."
            ), e.payload = { cache: u };
            return;
        }
        u = u.return;
      }
    }
    function U0(e, n, u) {
      var f = arguments;
      typeof f[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), f = Ga(e);
      var p = {
        lane: f,
        revertLane: 0,
        action: u,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      eu(e) ? q0(n, p) : (p = e1(e, n, p, f), p !== null && (Vt(p, e, f), E1(p, n, f))), jn(e, f);
    }
    function lc(e, n, u) {
      var f = arguments;
      typeof f[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), f = Ga(e), ic(e, n, u, f), jn(e, f);
    }
    function ic(e, n, u, f) {
      var p = {
        lane: f,
        revertLane: 0,
        action: u,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (eu(e)) q0(n, p);
      else {
        var v = e.alternate;
        if (e.lanes === 0 && (v === null || v.lanes === 0) && (v = n.lastRenderedReducer, v !== null)) {
          var k = ye.H;
          ye.H = xu;
          try {
            var M = n.lastRenderedState, q = v(M, u);
            if (p.hasEagerState = !0, p.eagerState = q, Qa(q, M))
              return gh(e, n, p, 0), zn === null && ph(), !1;
          } catch {
          } finally {
            ye.H = k;
          }
        }
        if (u = e1(e, n, p, f), u !== null)
          return Vt(u, e, f), E1(u, n, f), !0;
      }
      return !1;
    }
    function Uh(e, n, u, f) {
      if (ye.T === null && Of === 0 && console.error(
        "An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition."
      ), f = {
        lane: 2,
        revertLane: sd(),
        action: f,
        hasEagerState: !1,
        eagerState: null,
        next: null
      }, eu(e)) {
        if (n)
          throw Error("Cannot update optimistic state while rendering.");
        console.error("Cannot call startTransition while rendering.");
      } else
        n = e1(
          e,
          u,
          f,
          2
        ), n !== null && Vt(n, e, 2);
      jn(e, 2);
    }
    function eu(e) {
      var n = e.alternate;
      return e === At || n !== null && n === At;
    }
    function q0(e, n) {
      rm = ky = !0;
      var u = e.pending;
      u === null ? n.next = n : (n.next = u.next, u.next = n), e.pending = n;
    }
    function E1(e, n, u) {
      if (u & 4194048) {
        var f = n.lanes;
        f &= e.pendingLanes, u |= f, n.lanes = u, je(e, u);
      }
    }
    function dr(e) {
      var n = Ut;
      return e != null && (Ut = n === null ? e : n.concat(e)), n;
    }
    function uc(e, n, u) {
      for (var f = Object.keys(e.props), p = 0; p < f.length; p++) {
        var v = f[p];
        if (v !== "children" && v !== "key") {
          n === null && (n = w0(e, u.mode, 0), n._debugInfo = Ut, n.return = u), at(
            n,
            function(k) {
              console.error(
                "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",
                k
              );
            },
            v
          );
          break;
        }
      }
    }
    function Bl(e) {
      var n = fg;
      return fg += 1, am === null && (am = d1()), m1(am, e, n);
    }
    function Rt(e, n) {
      n = n.props.ref, e.ref = n !== void 0 ? n : null;
    }
    function an(e, n) {
      throw n.$$typeof === S3 ? Error(
        `A React Element from an older version of React was rendered. This is not supported. It can happen if:
- Multiple copies of the "react" package is used.
- A library pre-bundled an old copy of "react" or "react/jsx-runtime".
- A compiler tries to "inline" JSX instead of using the runtime.`
      ) : (e = Object.prototype.toString.call(n), Error(
        "Objects are not valid as a React child (found: " + (e === "[object Object]" ? "object with keys {" + Object.keys(n).join(", ") + "}" : e) + "). If you meant to render a collection of children, use an array instead."
      ));
    }
    function Un(e, n) {
      var u = ee(e) || "Component";
      Yb[u] || (Yb[u] = !0, n = n.displayName || n.name || "Component", e.tag === 3 ? console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  root.render(%s)`,
        n,
        n,
        n
      ) : console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  <%s>{%s}</%s>`,
        n,
        n,
        u,
        n,
        u
      ));
    }
    function $o(e, n) {
      var u = ee(e) || "Component";
      Ib[u] || (Ib[u] = !0, n = String(n), e.tag === 3 ? console.error(
        `Symbols are not valid as a React child.
  root.render(%s)`,
        n
      ) : console.error(
        `Symbols are not valid as a React child.
  <%s>%s</%s>`,
        u,
        n,
        u
      ));
    }
    function Xo(e) {
      function n(F, K) {
        if (e) {
          var ne = F.deletions;
          ne === null ? (F.deletions = [K], F.flags |= 16) : ne.push(K);
        }
      }
      function u(F, K) {
        if (!e) return null;
        for (; K !== null; )
          n(F, K), K = K.sibling;
        return null;
      }
      function f(F) {
        for (var K = /* @__PURE__ */ new Map(); F !== null; )
          F.key !== null ? K.set(F.key, F) : K.set(F.index, F), F = F.sibling;
        return K;
      }
      function p(F, K) {
        return F = ui(F, K), F.index = 0, F.sibling = null, F;
      }
      function v(F, K, ne) {
        return F.index = ne, e ? (ne = F.alternate, ne !== null ? (ne = ne.index, ne < K ? (F.flags |= 67108866, K) : ne) : (F.flags |= 67108866, K)) : (F.flags |= 1048576, K);
      }
      function k(F) {
        return e && F.alternate === null && (F.flags |= 67108866), F;
      }
      function M(F, K, ne, ze) {
        return K === null || K.tag !== 6 ? (K = r1(
          ne,
          F.mode,
          ze
        ), K.return = F, K._debugOwner = F, K._debugTask = F._debugTask, K._debugInfo = Ut, K) : (K = p(K, ne), K.return = F, K._debugInfo = Ut, K);
      }
      function q(F, K, ne, ze) {
        var Ze = ne.type;
        return Ze === ro ? (K = xe(
          F,
          K,
          ne.props.children,
          ze,
          ne.key
        ), uc(ne, K, F), K) : K !== null && (K.elementType === Ze || x4(K, ne) || typeof Ze == "object" && Ze !== null && Ze.$$typeof === $a && Vc(Ze) === K.type) ? (K = p(K, ne.props), Rt(K, ne), K.return = F, K._debugOwner = ne._owner, K._debugInfo = Ut, K) : (K = w0(ne, F.mode, ze), Rt(K, ne), K.return = F, K._debugInfo = Ut, K);
      }
      function j(F, K, ne, ze) {
        return K === null || K.tag !== 4 || K.stateNode.containerInfo !== ne.containerInfo || K.stateNode.implementation !== ne.implementation ? (K = a1(ne, F.mode, ze), K.return = F, K._debugInfo = Ut, K) : (K = p(K, ne.children || []), K.return = F, K._debugInfo = Ut, K);
      }
      function xe(F, K, ne, ze, Ze) {
        return K === null || K.tag !== 7 ? (K = il(
          ne,
          F.mode,
          ze,
          Ze
        ), K.return = F, K._debugOwner = F, K._debugTask = F._debugTask, K._debugInfo = Ut, K) : (K = p(K, ne), K.return = F, K._debugInfo = Ut, K);
      }
      function Ae(F, K, ne) {
        if (typeof K == "string" && K !== "" || typeof K == "number" || typeof K == "bigint")
          return K = r1(
            "" + K,
            F.mode,
            ne
          ), K.return = F, K._debugOwner = F, K._debugTask = F._debugTask, K._debugInfo = Ut, K;
        if (typeof K == "object" && K !== null) {
          switch (K.$$typeof) {
            case hu:
              return ne = w0(
                K,
                F.mode,
                ne
              ), Rt(ne, K), ne.return = F, F = dr(K._debugInfo), ne._debugInfo = Ut, Ut = F, ne;
            case Ct:
              return K = a1(
                K,
                F.mode,
                ne
              ), K.return = F, K._debugInfo = Ut, K;
            case $a:
              var ze = dr(K._debugInfo);
              return K = Vc(K), F = Ae(F, K, ne), Ut = ze, F;
          }
          if (gr(K) || Ce(K))
            return ne = il(
              K,
              F.mode,
              ne,
              null
            ), ne.return = F, ne._debugOwner = F, ne._debugTask = F._debugTask, F = dr(K._debugInfo), ne._debugInfo = Ut, Ut = F, ne;
          if (typeof K.then == "function")
            return ze = dr(K._debugInfo), F = Ae(
              F,
              Bl(K),
              ne
            ), Ut = ze, F;
          if (K.$$typeof === za)
            return Ae(
              F,
              E0(F, K),
              ne
            );
          an(F, K);
        }
        return typeof K == "function" && Un(F, K), typeof K == "symbol" && $o(F, K), null;
      }
      function pe(F, K, ne, ze) {
        var Ze = K !== null ? K.key : null;
        if (typeof ne == "string" && ne !== "" || typeof ne == "number" || typeof ne == "bigint")
          return Ze !== null ? null : M(F, K, "" + ne, ze);
        if (typeof ne == "object" && ne !== null) {
          switch (ne.$$typeof) {
            case hu:
              return ne.key === Ze ? (Ze = dr(ne._debugInfo), F = q(
                F,
                K,
                ne,
                ze
              ), Ut = Ze, F) : null;
            case Ct:
              return ne.key === Ze ? j(F, K, ne, ze) : null;
            case $a:
              return Ze = dr(ne._debugInfo), ne = Vc(ne), F = pe(
                F,
                K,
                ne,
                ze
              ), Ut = Ze, F;
          }
          if (gr(ne) || Ce(ne))
            return Ze !== null ? null : (Ze = dr(ne._debugInfo), F = xe(
              F,
              K,
              ne,
              ze,
              null
            ), Ut = Ze, F);
          if (typeof ne.then == "function")
            return Ze = dr(ne._debugInfo), F = pe(
              F,
              K,
              Bl(ne),
              ze
            ), Ut = Ze, F;
          if (ne.$$typeof === za)
            return pe(
              F,
              K,
              E0(F, ne),
              ze
            );
          an(F, ne);
        }
        return typeof ne == "function" && Un(F, ne), typeof ne == "symbol" && $o(F, ne), null;
      }
      function Re(F, K, ne, ze, Ze) {
        if (typeof ze == "string" && ze !== "" || typeof ze == "number" || typeof ze == "bigint")
          return F = F.get(ne) || null, M(K, F, "" + ze, Ze);
        if (typeof ze == "object" && ze !== null) {
          switch (ze.$$typeof) {
            case hu:
              return ne = F.get(
                ze.key === null ? ne : ze.key
              ) || null, F = dr(ze._debugInfo), K = q(
                K,
                ne,
                ze,
                Ze
              ), Ut = F, K;
            case Ct:
              return F = F.get(
                ze.key === null ? ne : ze.key
              ) || null, j(K, F, ze, Ze);
            case $a:
              var Mt = dr(ze._debugInfo);
              return ze = Vc(ze), K = Re(
                F,
                K,
                ne,
                ze,
                Ze
              ), Ut = Mt, K;
          }
          if (gr(ze) || Ce(ze))
            return ne = F.get(ne) || null, F = dr(ze._debugInfo), K = xe(
              K,
              ne,
              ze,
              Ze,
              null
            ), Ut = F, K;
          if (typeof ze.then == "function")
            return Mt = dr(ze._debugInfo), K = Re(
              F,
              K,
              ne,
              Bl(ze),
              Ze
            ), Ut = Mt, K;
          if (ze.$$typeof === za)
            return Re(
              F,
              K,
              ne,
              E0(K, ze),
              Ze
            );
          an(K, ze);
        }
        return typeof ze == "function" && Un(K, ze), typeof ze == "symbol" && $o(K, ze), null;
      }
      function tt(F, K, ne, ze) {
        if (typeof ne != "object" || ne === null) return ze;
        switch (ne.$$typeof) {
          case hu:
          case Ct:
            g(F, K, ne);
            var Ze = ne.key;
            if (typeof Ze != "string") break;
            if (ze === null) {
              ze = /* @__PURE__ */ new Set(), ze.add(Ze);
              break;
            }
            if (!ze.has(Ze)) {
              ze.add(Ze);
              break;
            }
            at(K, function() {
              console.error(
                "Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.",
                Ze
              );
            });
            break;
          case $a:
            ne = Vc(ne), tt(F, K, ne, ze);
        }
        return ze;
      }
      function bt(F, K, ne, ze) {
        for (var Ze = null, Mt = null, nt = null, _t = K, Lt = K = 0, Nn = null; _t !== null && Lt < ne.length; Lt++) {
          _t.index > Lt ? (Nn = _t, _t = null) : Nn = _t.sibling;
          var vr = pe(
            F,
            _t,
            ne[Lt],
            ze
          );
          if (vr === null) {
            _t === null && (_t = Nn);
            break;
          }
          Ze = tt(
            F,
            vr,
            ne[Lt],
            Ze
          ), e && _t && vr.alternate === null && n(F, _t), K = v(vr, K, Lt), nt === null ? Mt = vr : nt.sibling = vr, nt = vr, _t = Nn;
        }
        if (Lt === ne.length)
          return u(F, _t), rn && Lo(F, Lt), Mt;
        if (_t === null) {
          for (; Lt < ne.length; Lt++)
            _t = Ae(F, ne[Lt], ze), _t !== null && (Ze = tt(
              F,
              _t,
              ne[Lt],
              Ze
            ), K = v(
              _t,
              K,
              Lt
            ), nt === null ? Mt = _t : nt.sibling = _t, nt = _t);
          return rn && Lo(F, Lt), Mt;
        }
        for (_t = f(_t); Lt < ne.length; Lt++)
          Nn = Re(
            _t,
            F,
            Lt,
            ne[Lt],
            ze
          ), Nn !== null && (Ze = tt(
            F,
            Nn,
            ne[Lt],
            Ze
          ), e && Nn.alternate !== null && _t.delete(
            Nn.key === null ? Lt : Nn.key
          ), K = v(
            Nn,
            K,
            Lt
          ), nt === null ? Mt = Nn : nt.sibling = Nn, nt = Nn);
        return e && _t.forEach(function(bs) {
          return n(F, bs);
        }), rn && Lo(F, Lt), Mt;
      }
      function Cn(F, K, ne, ze) {
        if (ne == null)
          throw Error("An iterable object provided no iterator.");
        for (var Ze = null, Mt = null, nt = K, _t = K = 0, Lt = null, Nn = null, vr = ne.next(); nt !== null && !vr.done; _t++, vr = ne.next()) {
          nt.index > _t ? (Lt = nt, nt = null) : Lt = nt.sibling;
          var bs = pe(F, nt, vr.value, ze);
          if (bs === null) {
            nt === null && (nt = Lt);
            break;
          }
          Nn = tt(
            F,
            bs,
            vr.value,
            Nn
          ), e && nt && bs.alternate === null && n(F, nt), K = v(bs, K, _t), Mt === null ? Ze = bs : Mt.sibling = bs, Mt = bs, nt = Lt;
        }
        if (vr.done)
          return u(F, nt), rn && Lo(F, _t), Ze;
        if (nt === null) {
          for (; !vr.done; _t++, vr = ne.next())
            nt = Ae(F, vr.value, ze), nt !== null && (Nn = tt(
              F,
              nt,
              vr.value,
              Nn
            ), K = v(
              nt,
              K,
              _t
            ), Mt === null ? Ze = nt : Mt.sibling = nt, Mt = nt);
          return rn && Lo(F, _t), Ze;
        }
        for (nt = f(nt); !vr.done; _t++, vr = ne.next())
          Lt = Re(
            nt,
            F,
            _t,
            vr.value,
            ze
          ), Lt !== null && (Nn = tt(
            F,
            Lt,
            vr.value,
            Nn
          ), e && Lt.alternate !== null && nt.delete(
            Lt.key === null ? _t : Lt.key
          ), K = v(
            Lt,
            K,
            _t
          ), Mt === null ? Ze = Lt : Mt.sibling = Lt, Mt = Lt);
        return e && nt.forEach(function(AE) {
          return n(F, AE);
        }), rn && Lo(F, _t), Ze;
      }
      function Kt(F, K, ne, ze) {
        if (typeof ne == "object" && ne !== null && ne.type === ro && ne.key === null && (uc(ne, null, F), ne = ne.props.children), typeof ne == "object" && ne !== null) {
          switch (ne.$$typeof) {
            case hu:
              var Ze = dr(ne._debugInfo);
              e: {
                for (var Mt = ne.key; K !== null; ) {
                  if (K.key === Mt) {
                    if (Mt = ne.type, Mt === ro) {
                      if (K.tag === 7) {
                        u(
                          F,
                          K.sibling
                        ), ze = p(
                          K,
                          ne.props.children
                        ), ze.return = F, ze._debugOwner = ne._owner, ze._debugInfo = Ut, uc(ne, ze, F), F = ze;
                        break e;
                      }
                    } else if (K.elementType === Mt || x4(
                      K,
                      ne
                    ) || typeof Mt == "object" && Mt !== null && Mt.$$typeof === $a && Vc(Mt) === K.type) {
                      u(
                        F,
                        K.sibling
                      ), ze = p(K, ne.props), Rt(ze, ne), ze.return = F, ze._debugOwner = ne._owner, ze._debugInfo = Ut, F = ze;
                      break e;
                    }
                    u(F, K);
                    break;
                  } else n(F, K);
                  K = K.sibling;
                }
                ne.type === ro ? (ze = il(
                  ne.props.children,
                  F.mode,
                  ze,
                  ne.key
                ), ze.return = F, ze._debugOwner = F, ze._debugTask = F._debugTask, ze._debugInfo = Ut, uc(ne, ze, F), F = ze) : (ze = w0(
                  ne,
                  F.mode,
                  ze
                ), Rt(ze, ne), ze.return = F, ze._debugInfo = Ut, F = ze);
              }
              return F = k(F), Ut = Ze, F;
            case Ct:
              e: {
                for (Ze = ne, ne = Ze.key; K !== null; ) {
                  if (K.key === ne)
                    if (K.tag === 4 && K.stateNode.containerInfo === Ze.containerInfo && K.stateNode.implementation === Ze.implementation) {
                      u(
                        F,
                        K.sibling
                      ), ze = p(
                        K,
                        Ze.children || []
                      ), ze.return = F, F = ze;
                      break e;
                    } else {
                      u(F, K);
                      break;
                    }
                  else n(F, K);
                  K = K.sibling;
                }
                ze = a1(
                  Ze,
                  F.mode,
                  ze
                ), ze.return = F, F = ze;
              }
              return k(F);
            case $a:
              return Ze = dr(ne._debugInfo), ne = Vc(ne), F = Kt(
                F,
                K,
                ne,
                ze
              ), Ut = Ze, F;
          }
          if (gr(ne))
            return Ze = dr(ne._debugInfo), F = bt(
              F,
              K,
              ne,
              ze
            ), Ut = Ze, F;
          if (Ce(ne)) {
            if (Ze = dr(ne._debugInfo), Mt = Ce(ne), typeof Mt != "function")
              throw Error(
                "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue."
              );
            var nt = Mt.call(ne);
            return nt === ne ? (F.tag !== 0 || Object.prototype.toString.call(F.type) !== "[object GeneratorFunction]" || Object.prototype.toString.call(nt) !== "[object Generator]") && (Gb || console.error(
              "Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."
            ), Gb = !0) : ne.entries !== Mt || Q3 || (console.error(
              "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
            ), Q3 = !0), F = Cn(
              F,
              K,
              nt,
              ze
            ), Ut = Ze, F;
          }
          if (typeof ne.then == "function")
            return Ze = dr(ne._debugInfo), F = Kt(
              F,
              K,
              Bl(ne),
              ze
            ), Ut = Ze, F;
          if (ne.$$typeof === za)
            return Kt(
              F,
              K,
              E0(F, ne),
              ze
            );
          an(F, ne);
        }
        return typeof ne == "string" && ne !== "" || typeof ne == "number" || typeof ne == "bigint" ? (Ze = "" + ne, K !== null && K.tag === 6 ? (u(
          F,
          K.sibling
        ), ze = p(K, Ze), ze.return = F, F = ze) : (u(F, K), ze = r1(
          Ze,
          F.mode,
          ze
        ), ze.return = F, ze._debugOwner = F, ze._debugTask = F._debugTask, ze._debugInfo = Ut, F = ze), k(F)) : (typeof ne == "function" && Un(F, ne), typeof ne == "symbol" && $o(F, ne), u(F, K));
      }
      return function(F, K, ne, ze) {
        var Ze = Ut;
        Ut = null;
        try {
          fg = 0;
          var Mt = Kt(
            F,
            K,
            ne,
            ze
          );
          return am = null, Mt;
        } catch (Nn) {
          if (Nn === ug || Nn === Ty) throw Nn;
          var nt = E(29, Nn, null, F.mode);
          nt.lanes = ze, nt.return = F;
          var _t = nt._debugInfo = Ut;
          if (nt._debugOwner = F._debugOwner, nt._debugTask = F._debugTask, _t != null) {
            for (var Lt = _t.length - 1; 0 <= Lt; Lt--)
              if (typeof _t[Lt].stack == "string") {
                nt._debugOwner = _t[Lt], nt._debugTask = _t[Lt].debugTask;
                break;
              }
          }
          return nt;
        } finally {
          Ut = Ze;
        }
      };
    }
    function va(e) {
      var n = e.alternate;
      Ye(
        Ir,
        Ir.current & im,
        e
      ), Ye(Mi, e, e), ho === null && (n === null || tm.current !== null || n.memoizedState !== null) && (ho = e);
    }
    function j0(e) {
      if (e.tag === 22) {
        if (Ye(Ir, Ir.current, e), Ye(Mi, e, e), ho === null) {
          var n = e.alternate;
          n !== null && n.memoizedState !== null && (ho = e);
        }
      } else cl(e);
    }
    function cl(e) {
      Ye(Ir, Ir.current, e), Ye(
        Mi,
        Mi.current,
        e
      );
    }
    function ba(e) {
      de(Mi, e), ho === e && (ho = null), de(Ir, e);
    }
    function qh(e) {
      for (var n = e; n !== null; ) {
        if (n.tag === 13) {
          var u = n.memoizedState;
          if (u !== null && (u = u.dehydrated, u === null || u.data === gs || eo(u)))
            return n;
        } else if (n.tag === 19 && n.memoizedProps.revealOrder !== void 0) {
          if (n.flags & 128) return n;
        } else if (n.child !== null) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === e) break;
        for (; n.sibling === null; ) {
          if (n.return === null || n.return === e) return null;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
      return null;
    }
    function qn(e) {
      if (e !== null && typeof e != "function") {
        var n = String(e);
        n8.has(n) || (n8.add(n), console.error(
          "Expected the last optional `callback` argument to be a function. Instead received: %s.",
          e
        ));
      }
    }
    function G0(e, n, u, f) {
      var p = e.memoizedState, v = u(f, p);
      if (e.mode & Ma) {
        Ge(!0);
        try {
          v = u(f, p);
        } finally {
          Ge(!1);
        }
      }
      v === void 0 && (n = ve(n) || "Component", Jb.has(n) || (Jb.add(n), console.error(
        "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
        n
      ))), p = v == null ? p : Et({}, p, v), e.memoizedState = p, e.lanes === 0 && (e.updateQueue.baseState = p);
    }
    function jh(e, n, u, f, p, v, k) {
      var M = e.stateNode;
      if (typeof M.shouldComponentUpdate == "function") {
        if (u = M.shouldComponentUpdate(
          f,
          v,
          k
        ), e.mode & Ma) {
          Ge(!0);
          try {
            u = M.shouldComponentUpdate(
              f,
              v,
              k
            );
          } finally {
            Ge(!1);
          }
        }
        return u === void 0 && console.error(
          "%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",
          ve(n) || "Component"
        ), u;
      }
      return n.prototype && n.prototype.isPureReactComponent ? !x0(u, f) || !x0(p, v) : !0;
    }
    function A1(e, n, u, f) {
      var p = n.state;
      typeof n.componentWillReceiveProps == "function" && n.componentWillReceiveProps(u, f), typeof n.UNSAFE_componentWillReceiveProps == "function" && n.UNSAFE_componentWillReceiveProps(u, f), n.state !== p && (e = ee(e) || "Component", Qb.has(e) || (Qb.add(e), console.error(
        "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
        e
      )), Z3.enqueueReplaceState(
        n,
        n.state,
        null
      ));
    }
    function Vu(e, n) {
      var u = n;
      if ("ref" in n) {
        u = {};
        for (var f in n)
          f !== "ref" && (u[f] = n[f]);
      }
      if (e = e.defaultProps) {
        u === n && (u = Et({}, u));
        for (var p in e)
          u[p] === void 0 && (u[p] = e[p]);
      }
      return u;
    }
    function A4(e) {
      F3(e), console.warn(
        `%s

%s
`,
        um ? "An error occurred in the <" + um + "> component." : "An error occurred in one of your React components.",
        `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://react.dev/link/error-boundaries to learn more about error boundaries.`
      );
    }
    function Gh(e) {
      var n = um ? "The above error occurred in the <" + um + "> component." : "The above error occurred in one of your React components.", u = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((P3 || "Anonymous") + ".");
      if (typeof e == "object" && e !== null && typeof e.environmentName == "string") {
        var f = e.environmentName;
        e = [
          `%o

%s

%s
`,
          e,
          n,
          u
        ].slice(0), typeof e[0] == "string" ? e.splice(
          0,
          1,
          N8 + e[0],
          L8,
          Qy + f + Qy,
          B8
        ) : e.splice(
          0,
          0,
          N8,
          L8,
          Qy + f + Qy,
          B8
        ), e.unshift(console), f = TE.apply(console.error, e), f();
      } else
        console.error(
          `%o

%s

%s
`,
          e,
          n,
          u
        );
    }
    function Vh(e) {
      F3(e);
    }
    function oc(e, n) {
      try {
        um = n.source ? ee(n.source) : null, P3 = null;
        var u = n.value;
        if (ye.actQueue !== null)
          ye.thrownErrors.push(u);
        else {
          var f = e.onUncaughtError;
          f(u, { componentStack: n.stack });
        }
      } catch (p) {
        setTimeout(function() {
          throw p;
        });
      }
    }
    function la(e, n, u) {
      try {
        um = u.source ? ee(u.source) : null, P3 = ee(n);
        var f = e.onCaughtError;
        f(u.value, {
          componentStack: u.stack,
          errorBoundary: n.tag === 1 ? n.stateNode : null
        });
      } catch (p) {
        setTimeout(function() {
          throw p;
        });
      }
    }
    function Yn(e, n, u) {
      return u = Cl(u), u.tag = q3, u.payload = { element: null }, u.callback = function() {
        at(n.source, oc, e, n);
      }, u;
    }
    function V0(e) {
      return e = Cl(e), e.tag = q3, e;
    }
    function Qo(e, n, u, f) {
      var p = u.type.getDerivedStateFromError;
      if (typeof p == "function") {
        var v = f.value;
        e.payload = function() {
          return p(v);
        }, e.callback = function() {
          vh(u), at(
            f.source,
            la,
            n,
            u,
            f
          );
        };
      }
      var k = u.stateNode;
      k !== null && typeof k.componentDidCatch == "function" && (e.callback = function() {
        vh(u), at(
          f.source,
          la,
          n,
          u,
          f
        ), typeof p != "function" && (Xc === null ? Xc = /* @__PURE__ */ new Set([this]) : Xc.add(this)), eE(this, f), typeof p == "function" || !(u.lanes & 2) && console.error(
          "%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",
          ee(u) || "Unknown"
        );
      });
    }
    function Yh(e, n, u, f, p) {
      if (u.flags |= 32768, gl && es(e, p), f !== null && typeof f == "object" && typeof f.then == "function") {
        if (n = u.alternate, n !== null && $i(
          n,
          u,
          p,
          !0
        ), rn && (fs = !0), u = Mi.current, u !== null) {
          switch (u.tag) {
            case 13:
              return ho === null ? rd() : u.alternate === null && ur === ps && (ur = e6), u.flags &= -257, u.flags |= 65536, u.lanes = p, f === U3 ? u.flags |= 16384 : (n = u.updateQueue, n === null ? u.updateQueue = /* @__PURE__ */ new Set([f]) : n.add(f), up(e, f, p)), !1;
            case 22:
              return u.flags |= 65536, f === U3 ? u.flags |= 16384 : (n = u.updateQueue, n === null ? (n = {
                transitions: null,
                markerInstances: null,
                retryQueue: /* @__PURE__ */ new Set([f])
              }, u.updateQueue = n) : (u = n.retryQueue, u === null ? n.retryQueue = /* @__PURE__ */ new Set([f]) : u.add(f)), up(e, f, p)), !1;
          }
          throw Error(
            "Unexpected Suspense handler tag (" + u.tag + "). This is a bug in React."
          );
        }
        return up(e, f, p), rd(), !1;
      }
      if (rn)
        return fs = !0, n = Mi.current, n !== null ? (!(n.flags & 65536) && (n.flags |= 256), n.flags |= 65536, n.lanes = p, f !== N3 && Vs(
          fa(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.",
              { cause: f }
            ),
            u
          )
        )) : (f !== N3 && Vs(
          fa(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering the entire root.",
              { cause: f }
            ),
            u
          )
        ), e = e.current.alternate, e.flags |= 65536, p &= -p, e.lanes |= p, f = fa(f, u), p = Yn(
          e.stateNode,
          f,
          p
        ), Qi(e, p), ur !== Bf && (ur = fm)), !1;
      var v = fa(
        Error(
          "There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.",
          { cause: f }
        ),
        u
      );
      if (bg === null ? bg = [v] : bg.push(v), ur !== Bf && (ur = fm), n === null) return !0;
      f = fa(f, u), u = n;
      do {
        switch (u.tag) {
          case 3:
            return u.flags |= 65536, e = p & -p, u.lanes |= e, e = Yn(
              u.stateNode,
              f,
              e
            ), Qi(u, e), !1;
          case 1:
            if (n = u.type, v = u.stateNode, (u.flags & 128) === 0 && (typeof n.getDerivedStateFromError == "function" || v !== null && typeof v.componentDidCatch == "function" && (Xc === null || !Xc.has(v))))
              return u.flags |= 65536, p &= -p, u.lanes |= p, p = V0(p), Qo(
                p,
                e,
                u,
                f
              ), Qi(u, p), !1;
        }
        u = u.return;
      } while (u !== null);
      return !1;
    }
    function mr(e, n, u, f) {
      n.child = e === null ? $b(n, null, u, f) : lm(
        n,
        e.child,
        u,
        f
      );
    }
    function fi(e, n, u, f, p) {
      u = u.render;
      var v = n.ref;
      if ("ref" in f) {
        var k = {};
        for (var M in f)
          M !== "ref" && (k[M] = f[M]);
      } else k = f;
      return Du(n), vt(n), f = Qs(
        e,
        n,
        u,
        k,
        v,
        p
      ), M = Zi(), St(), e !== null && !ea ? (Ol(e, n, p), hi(e, n, p)) : (rn && M && xh(n), n.flags |= 1, mr(e, n, f, p), n.child);
    }
    function Y0(e, n, u, f, p) {
      if (e === null) {
        var v = u.type;
        return typeof v == "function" && !bh(v) && v.defaultProps === void 0 && u.compare === null ? (u = Do(v), n.tag = 15, n.type = u, $0(n, v), Ih(
          e,
          n,
          u,
          f,
          p
        )) : (e = Sh(
          u.type,
          null,
          f,
          n,
          n.mode,
          p
        ), e.ref = n.ref, e.return = n, n.child = e);
      }
      if (v = e.child, !L1(e, p)) {
        var k = v.memoizedProps;
        if (u = u.compare, u = u !== null ? u : x0, u(k, f) && e.ref === n.ref)
          return hi(
            e,
            n,
            p
          );
      }
      return n.flags |= 1, e = ui(v, f), e.ref = n.ref, e.return = n, n.child = e;
    }
    function Ih(e, n, u, f, p) {
      if (e !== null) {
        var v = e.memoizedProps;
        if (x0(v, f) && e.ref === n.ref && n.type === e.type)
          if (ea = !1, n.pendingProps = f = v, L1(e, p))
            e.flags & 131072 && (ea = !0);
          else
            return n.lanes = e.lanes, hi(e, n, p);
      }
      return Xh(
        e,
        n,
        u,
        f,
        p
      );
    }
    function $h(e, n, u) {
      var f = n.pendingProps, p = f.children, v = e !== null ? e.memoizedState : null;
      if (f.mode === "hidden") {
        if (n.flags & 128) {
          if (f = v !== null ? v.baseLanes | u : u, e !== null) {
            for (p = n.child = e.child, v = 0; p !== null; )
              v = v | p.lanes | p.childLanes, p = p.sibling;
            n.childLanes = v & ~f;
          } else n.childLanes = 0, n.child = null;
          return k1(
            e,
            n,
            f,
            u
          );
        }
        if (u & 536870912)
          n.memoizedState = { baseLanes: 0, cachePool: null }, e !== null && kh(
            n,
            v !== null ? v.cachePool : null
          ), v !== null ? zh(n, v) : _l(n), j0(n);
        else
          return n.lanes = n.childLanes = 536870912, k1(
            e,
            n,
            v !== null ? v.baseLanes | u : u,
            u
          );
      } else
        v !== null ? (kh(n, v.cachePool), zh(n, v), cl(n), n.memoizedState = null) : (e !== null && kh(n, null), _l(n), cl(n));
      return mr(e, n, p, u), n.child;
    }
    function k1(e, n, u, f) {
      var p = f1();
      return p = p === null ? null : {
        parent: Vr._currentValue,
        pool: p
      }, n.memoizedState = {
        baseLanes: u,
        cachePool: p
      }, e !== null && kh(n, null), _l(n), j0(n), e !== null && $i(e, n, f, !0), null;
    }
    function I0(e, n) {
      var u = n.ref;
      if (u === null)
        e !== null && e.ref !== null && (n.flags |= 4194816);
      else {
        if (typeof u != "function" && typeof u != "object")
          throw Error(
            "Expected ref to be a function, an object returned by React.createRef(), or undefined/null."
          );
        (e === null || e.ref !== u) && (n.flags |= 4194816);
      }
    }
    function Xh(e, n, u, f, p) {
      if (u.prototype && typeof u.prototype.render == "function") {
        var v = ve(u) || "Unknown";
        a8[v] || (console.error(
          "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
          v,
          v
        ), a8[v] = !0);
      }
      return n.mode & Ma && Su.recordLegacyContextWarning(
        n,
        null
      ), e === null && ($0(n, n.type), u.contextTypes && (v = ve(u) || "Unknown", i8[v] || (i8[v] = !0, console.error(
        "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)",
        v
      )))), Du(n), vt(n), u = Qs(
        e,
        n,
        u,
        f,
        void 0,
        p
      ), f = Zi(), St(), e !== null && !ea ? (Ol(e, n, p), hi(e, n, p)) : (rn && f && xh(n), n.flags |= 1, mr(e, n, u, p), n.child);
    }
    function R1(e, n, u, f, p, v) {
      return Du(n), vt(n), ds = -1, cg = e !== null && e.type !== n.type, n.updateQueue = null, u = pa(
        n,
        f,
        u,
        p
      ), R0(e, n), f = Zi(), St(), e !== null && !ea ? (Ol(e, n, v), hi(e, n, v)) : (rn && f && xh(n), n.flags |= 1, mr(e, n, u, v), n.child);
    }
    function z1(e, n, u, f, p) {
      switch (y(n)) {
        case !1:
          var v = n.stateNode, k = new n.type(
            n.memoizedProps,
            v.context
          ).state;
          v.updater.enqueueSetState(v, k, null);
          break;
        case !0:
          n.flags |= 128, n.flags |= 65536, v = Error("Simulated error coming from DevTools");
          var M = p & -p;
          if (n.lanes |= M, k = zn, k === null)
            throw Error(
              "Expected a work-in-progress root. This is a bug in React. Please file an issue."
            );
          M = V0(M), Qo(
            M,
            k,
            n,
            fa(v, n)
          ), Qi(n, M);
      }
      if (Du(n), n.stateNode === null) {
        if (k = qc, v = u.contextType, "contextType" in u && v !== null && (v === void 0 || v.$$typeof !== za) && !t8.has(u) && (t8.add(u), M = v === void 0 ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof v != "object" ? " However, it is set to a " + typeof v + "." : v.$$typeof === mf ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(v).join(", ") + "}.", console.error(
          "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
          ve(u) || "Component",
          M
        )), typeof v == "object" && v !== null && (k = En(v)), v = new u(f, k), n.mode & Ma) {
          Ge(!0);
          try {
            v = new u(f, k);
          } finally {
            Ge(!1);
          }
        }
        if (k = n.memoizedState = v.state !== null && v.state !== void 0 ? v.state : null, v.updater = Z3, n.stateNode = v, v._reactInternals = n, v._reactInternalInstance = Xb, typeof u.getDerivedStateFromProps == "function" && k === null && (k = ve(u) || "Component", Zb.has(k) || (Zb.add(k), console.error(
          "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
          k,
          v.state === null ? "null" : "undefined",
          k
        ))), typeof u.getDerivedStateFromProps == "function" || typeof v.getSnapshotBeforeUpdate == "function") {
          var q = M = k = null;
          if (typeof v.componentWillMount == "function" && v.componentWillMount.__suppressDeprecationWarning !== !0 ? k = "componentWillMount" : typeof v.UNSAFE_componentWillMount == "function" && (k = "UNSAFE_componentWillMount"), typeof v.componentWillReceiveProps == "function" && v.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? M = "componentWillReceiveProps" : typeof v.UNSAFE_componentWillReceiveProps == "function" && (M = "UNSAFE_componentWillReceiveProps"), typeof v.componentWillUpdate == "function" && v.componentWillUpdate.__suppressDeprecationWarning !== !0 ? q = "componentWillUpdate" : typeof v.UNSAFE_componentWillUpdate == "function" && (q = "UNSAFE_componentWillUpdate"), k !== null || M !== null || q !== null) {
            v = ve(u) || "Component";
            var j = typeof u.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            Pb.has(v) || (Pb.add(v), console.error(
              `Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://react.dev/link/unsafe-component-lifecycles`,
              v,
              j,
              k !== null ? `
  ` + k : "",
              M !== null ? `
  ` + M : "",
              q !== null ? `
  ` + q : ""
            ));
          }
        }
        v = n.stateNode, k = ve(u) || "Component", v.render || (u.prototype && typeof u.prototype.render == "function" ? console.error(
          "No `render` method found on the %s instance: did you accidentally return an object from the constructor?",
          k
        ) : console.error(
          "No `render` method found on the %s instance: you may have forgotten to define `render`.",
          k
        )), !v.getInitialState || v.getInitialState.isReactClassApproved || v.state || console.error(
          "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
          k
        ), v.getDefaultProps && !v.getDefaultProps.isReactClassApproved && console.error(
          "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
          k
        ), v.contextType && console.error(
          "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
          k
        ), u.childContextTypes && !e8.has(u) && (e8.add(u), console.error(
          "%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)",
          k
        )), u.contextTypes && !Wb.has(u) && (Wb.add(u), console.error(
          "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)",
          k
        )), typeof v.componentShouldUpdate == "function" && console.error(
          "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
          k
        ), u.prototype && u.prototype.isPureReactComponent && typeof v.shouldComponentUpdate < "u" && console.error(
          "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
          ve(u) || "A pure component"
        ), typeof v.componentDidUnmount == "function" && console.error(
          "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
          k
        ), typeof v.componentDidReceiveProps == "function" && console.error(
          "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
          k
        ), typeof v.componentWillRecieveProps == "function" && console.error(
          "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
          k
        ), typeof v.UNSAFE_componentWillRecieveProps == "function" && console.error(
          "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
          k
        ), M = v.props !== f, v.props !== void 0 && M && console.error(
          "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
          k
        ), v.defaultProps && console.error(
          "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
          k,
          k
        ), typeof v.getSnapshotBeforeUpdate != "function" || typeof v.componentDidUpdate == "function" || Fb.has(u) || (Fb.add(u), console.error(
          "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
          ve(u)
        )), typeof v.getDerivedStateFromProps == "function" && console.error(
          "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          k
        ), typeof v.getDerivedStateFromError == "function" && console.error(
          "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          k
        ), typeof u.getSnapshotBeforeUpdate == "function" && console.error(
          "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
          k
        ), (M = v.state) && (typeof M != "object" || gr(M)) && console.error("%s.state: must be set to an object or null", k), typeof v.getChildContext == "function" && typeof u.childContextTypes != "object" && console.error(
          "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
          k
        ), v = n.stateNode, v.props = f, v.state = n.memoizedState, v.refs = {}, Lu(n), k = u.contextType, v.context = typeof k == "object" && k !== null ? En(k) : qc, v.state === f && (k = ve(u) || "Component", Kb.has(k) || (Kb.add(k), console.error(
          "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
          k
        ))), n.mode & Ma && Su.recordLegacyContextWarning(
          n,
          v
        ), Su.recordUnsafeLifecycleWarnings(
          n,
          v
        ), v.state = n.memoizedState, k = u.getDerivedStateFromProps, typeof k == "function" && (G0(
          n,
          u,
          k,
          f
        ), v.state = n.memoizedState), typeof u.getDerivedStateFromProps == "function" || typeof v.getSnapshotBeforeUpdate == "function" || typeof v.UNSAFE_componentWillMount != "function" && typeof v.componentWillMount != "function" || (k = v.state, typeof v.componentWillMount == "function" && v.componentWillMount(), typeof v.UNSAFE_componentWillMount == "function" && v.UNSAFE_componentWillMount(), k !== v.state && (console.error(
          "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
          ee(n) || "Component"
        ), Z3.enqueueReplaceState(
          v,
          v.state,
          null
        )), Bu(n, f, v, p), $s(), v.state = n.memoizedState), typeof v.componentDidMount == "function" && (n.flags |= 4194308), (n.mode & bu) !== Dn && (n.flags |= 134217728), v = !0;
      } else if (e === null) {
        v = n.stateNode;
        var xe = n.memoizedProps;
        M = Vu(u, xe), v.props = M;
        var Ae = v.context;
        q = u.contextType, k = qc, typeof q == "object" && q !== null && (k = En(q)), j = u.getDerivedStateFromProps, q = typeof j == "function" || typeof v.getSnapshotBeforeUpdate == "function", xe = n.pendingProps !== xe, q || typeof v.UNSAFE_componentWillReceiveProps != "function" && typeof v.componentWillReceiveProps != "function" || (xe || Ae !== k) && A1(
          n,
          v,
          f,
          k
        ), jc = !1;
        var pe = n.memoizedState;
        v.state = pe, Bu(n, f, v, p), $s(), Ae = n.memoizedState, xe || pe !== Ae || jc ? (typeof j == "function" && (G0(
          n,
          u,
          j,
          f
        ), Ae = n.memoizedState), (M = jc || jh(
          n,
          u,
          M,
          f,
          pe,
          Ae,
          k
        )) ? (q || typeof v.UNSAFE_componentWillMount != "function" && typeof v.componentWillMount != "function" || (typeof v.componentWillMount == "function" && v.componentWillMount(), typeof v.UNSAFE_componentWillMount == "function" && v.UNSAFE_componentWillMount()), typeof v.componentDidMount == "function" && (n.flags |= 4194308), (n.mode & bu) !== Dn && (n.flags |= 134217728)) : (typeof v.componentDidMount == "function" && (n.flags |= 4194308), (n.mode & bu) !== Dn && (n.flags |= 134217728), n.memoizedProps = f, n.memoizedState = Ae), v.props = f, v.state = Ae, v.context = k, v = M) : (typeof v.componentDidMount == "function" && (n.flags |= 4194308), (n.mode & bu) !== Dn && (n.flags |= 134217728), v = !1);
      } else {
        v = n.stateNode, k0(e, n), k = n.memoizedProps, q = Vu(u, k), v.props = q, j = n.pendingProps, pe = v.context, Ae = u.contextType, M = qc, typeof Ae == "object" && Ae !== null && (M = En(Ae)), xe = u.getDerivedStateFromProps, (Ae = typeof xe == "function" || typeof v.getSnapshotBeforeUpdate == "function") || typeof v.UNSAFE_componentWillReceiveProps != "function" && typeof v.componentWillReceiveProps != "function" || (k !== j || pe !== M) && A1(
          n,
          v,
          f,
          M
        ), jc = !1, pe = n.memoizedState, v.state = pe, Bu(n, f, v, p), $s();
        var Re = n.memoizedState;
        k !== j || pe !== Re || jc || e !== null && e.dependencies !== null && T0(e.dependencies) ? (typeof xe == "function" && (G0(
          n,
          u,
          xe,
          f
        ), Re = n.memoizedState), (q = jc || jh(
          n,
          u,
          q,
          f,
          pe,
          Re,
          M
        ) || e !== null && e.dependencies !== null && T0(e.dependencies)) ? (Ae || typeof v.UNSAFE_componentWillUpdate != "function" && typeof v.componentWillUpdate != "function" || (typeof v.componentWillUpdate == "function" && v.componentWillUpdate(f, Re, M), typeof v.UNSAFE_componentWillUpdate == "function" && v.UNSAFE_componentWillUpdate(
          f,
          Re,
          M
        )), typeof v.componentDidUpdate == "function" && (n.flags |= 4), typeof v.getSnapshotBeforeUpdate == "function" && (n.flags |= 1024)) : (typeof v.componentDidUpdate != "function" || k === e.memoizedProps && pe === e.memoizedState || (n.flags |= 4), typeof v.getSnapshotBeforeUpdate != "function" || k === e.memoizedProps && pe === e.memoizedState || (n.flags |= 1024), n.memoizedProps = f, n.memoizedState = Re), v.props = f, v.state = Re, v.context = M, v = q) : (typeof v.componentDidUpdate != "function" || k === e.memoizedProps && pe === e.memoizedState || (n.flags |= 4), typeof v.getSnapshotBeforeUpdate != "function" || k === e.memoizedProps && pe === e.memoizedState || (n.flags |= 1024), v = !1);
      }
      if (M = v, I0(e, n), k = (n.flags & 128) !== 0, M || k) {
        if (M = n.stateNode, Ru(n), k && typeof u.getDerivedStateFromError != "function")
          u = null, yl = -1;
        else {
          if (vt(n), u = _b(M), n.mode & Ma) {
            Ge(!0);
            try {
              _b(M);
            } finally {
              Ge(!1);
            }
          }
          St();
        }
        n.flags |= 1, e !== null && k ? (n.child = lm(
          n,
          e.child,
          null,
          p
        ), n.child = lm(
          n,
          null,
          u,
          p
        )) : mr(e, n, u, p), n.memoizedState = M.state, e = n.child;
      } else
        e = hi(
          e,
          n,
          p
        );
      return p = n.stateNode, v && p.props !== f && (om || console.error(
        "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
        ee(n) || "a component"
      ), om = !0), e;
    }
    function C1(e, n, u, f) {
      return Gs(), n.flags |= 256, mr(e, n, u, f), n.child;
    }
    function $0(e, n) {
      n && n.childContextTypes && console.error(
        `childContextTypes cannot be defined on a function component.
  %s.childContextTypes = ...`,
        n.displayName || n.name || "Component"
      ), typeof n.getDerivedStateFromProps == "function" && (e = ve(n) || "Unknown", u8[e] || (console.error(
        "%s: Function components do not support getDerivedStateFromProps.",
        e
      ), u8[e] = !0)), typeof n.contextType == "object" && n.contextType !== null && (n = ve(n) || "Unknown", l8[n] || (console.error(
        "%s: Function components do not support contextType.",
        n
      ), l8[n] = !0));
    }
    function Qh(e) {
      return { baseLanes: e, cachePool: h1() };
    }
    function M1(e, n, u) {
      return e = e !== null ? e.childLanes & ~u : 0, n && (e |= Jl), e;
    }
    function _1(e, n, u) {
      var f, p = n.pendingProps;
      d(n) && (n.flags |= 128);
      var v = !1, k = (n.flags & 128) !== 0;
      if ((f = k) || (f = e !== null && e.memoizedState === null ? !1 : (Ir.current & hg) !== 0), f && (v = !0, n.flags &= -129), f = (n.flags & 32) !== 0, n.flags &= -33, e === null) {
        if (rn) {
          if (v ? va(n) : cl(n), rn) {
            var M = ir, q;
            if (!(q = !M)) {
              e: {
                var j = M;
                for (q = co; j.nodeType !== 8; ) {
                  if (!q) {
                    q = null;
                    break e;
                  }
                  if (j = ka(j.nextSibling), j === null) {
                    q = null;
                    break e;
                  }
                }
                q = j;
              }
              q !== null ? (Rl(), n.memoizedState = {
                dehydrated: q,
                treeContext: Cf !== null ? { id: ss, overflow: cs } : null,
                retryLane: 536870912,
                hydrationErrors: null
              }, j = E(18, null, null, Dn), j.stateNode = q, j.return = n, n.child = j, Za = n, ir = null, q = !0) : q = !1, q = !q;
            }
            q && (js(
              n,
              M
            ), _u(n));
          }
          if (M = n.memoizedState, M !== null && (M = M.dehydrated, M !== null))
            return eo(M) ? n.lanes = 32 : n.lanes = 536870912, null;
          ba(n);
        }
        return M = p.children, p = p.fallback, v ? (cl(n), v = n.mode, M = X0(
          {
            mode: "hidden",
            children: M
          },
          v
        ), p = il(
          p,
          v,
          u,
          null
        ), M.return = n, p.return = n, M.sibling = p, n.child = M, v = n.child, v.memoizedState = Qh(u), v.childLanes = M1(
          e,
          f,
          u
        ), n.memoizedState = J3, p) : (va(n), Zh(
          n,
          M
        ));
      }
      var xe = e.memoizedState;
      if (xe !== null && (M = xe.dehydrated, M !== null)) {
        if (k)
          n.flags & 256 ? (va(n), n.flags &= -257, n = Q0(
            e,
            n,
            u
          )) : n.memoizedState !== null ? (cl(n), n.child = e.child, n.flags |= 128, n = null) : (cl(n), v = p.fallback, M = n.mode, p = X0(
            {
              mode: "visible",
              children: p.children
            },
            M
          ), v = il(
            v,
            M,
            u,
            null
          ), v.flags |= 2, p.return = n, v.return = n, p.sibling = v, n.child = p, lm(
            n,
            e.child,
            null,
            u
          ), p = n.child, p.memoizedState = Qh(u), p.childLanes = M1(
            e,
            f,
            u
          ), n.memoizedState = J3, n = v);
        else if (va(n), rn && console.error(
          "We should not be hydrating here. This is a bug in React. Please file a bug."
        ), eo(M)) {
          if (f = M.nextSibling && M.nextSibling.dataset, f) {
            q = f.dgst;
            var Ae = f.msg;
            j = f.stck;
            var pe = f.cstck;
          }
          M = Ae, f = q, p = j, q = v = pe, v = Error(M || "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."), v.stack = p || "", v.digest = f, f = q === void 0 ? null : q, p = {
            value: v,
            source: null,
            stack: f
          }, typeof f == "string" && _3.set(
            v,
            p
          ), Vs(p), n = Q0(
            e,
            n,
            u
          );
        } else if (ea || $i(
          e,
          n,
          u,
          !1
        ), f = (u & e.childLanes) !== 0, ea || f) {
          if (f = zn, f !== null && (p = u & -u, p = p & 42 ? 1 : ut(
            p
          ), p = p & (f.suspendedLanes | u) ? 0 : p, p !== 0 && p !== xe.retryLane))
            throw xe.retryLane = p, ha(
              e,
              p
            ), Vt(
              f,
              e,
              p
            ), r8;
          M.data === gs || rd(), n = Q0(
            e,
            n,
            u
          );
        } else
          M.data === gs ? (n.flags |= 192, n.child = e.child, n = null) : (e = xe.treeContext, ir = ka(
            M.nextSibling
          ), Za = n, rn = !0, Mf = null, fs = !1, ki = null, co = !1, e !== null && (Rl(), Ei[Ai++] = ss, Ei[Ai++] = cs, Ei[Ai++] = Cf, ss = e.id, cs = e.overflow, Cf = n), n = Zh(
            n,
            p.children
          ), n.flags |= 4096);
        return n;
      }
      return v ? (cl(n), v = p.fallback, M = n.mode, q = e.child, j = q.sibling, p = ui(
        q,
        {
          mode: "hidden",
          children: p.children
        }
      ), p.subtreeFlags = q.subtreeFlags & 65011712, j !== null ? v = ui(
        j,
        v
      ) : (v = il(
        v,
        M,
        u,
        null
      ), v.flags |= 2), v.return = n, p.return = n, p.sibling = v, n.child = p, p = v, v = n.child, M = e.child.memoizedState, M === null ? M = Qh(u) : (q = M.cachePool, q !== null ? (j = Vr._currentValue, q = q.parent !== j ? { parent: j, pool: j } : q) : q = h1(), M = {
        baseLanes: M.baseLanes | u,
        cachePool: q
      }), v.memoizedState = M, v.childLanes = M1(
        e,
        f,
        u
      ), n.memoizedState = J3, p) : (va(n), u = e.child, e = u.sibling, u = ui(u, {
        mode: "visible",
        children: p.children
      }), u.return = n, u.sibling = null, e !== null && (f = n.deletions, f === null ? (n.deletions = [e], n.flags |= 16) : f.push(e)), n.child = u, n.memoizedState = null, u);
    }
    function Zh(e, n) {
      return n = X0(
        { mode: "visible", children: n },
        e.mode
      ), n.return = e, e.child = n;
    }
    function X0(e, n) {
      return e = E(22, e, null, n), e.lanes = 0, e.stateNode = {
        _visibility: O3,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      }, e;
    }
    function Q0(e, n, u) {
      return lm(n, e.child, null, u), e = Zh(
        n,
        n.pendingProps.children
      ), e.flags |= 2, n.memoizedState = null, e;
    }
    function O1(e, n, u) {
      e.lanes |= n;
      var f = e.alternate;
      f !== null && (f.lanes |= n), o1(
        e.return,
        n,
        u
      );
    }
    function D1(e, n) {
      var u = gr(e);
      return e = !u && typeof Ce(e) == "function", u || e ? (u = u ? "array" : "iterable", console.error(
        "A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",
        u,
        n,
        u
      ), !1) : !0;
    }
    function Fh(e, n, u, f, p) {
      var v = e.memoizedState;
      v === null ? e.memoizedState = {
        isBackwards: n,
        rendering: null,
        renderingStartTime: 0,
        last: f,
        tail: u,
        tailMode: p
      } : (v.isBackwards = n, v.rendering = null, v.renderingStartTime = 0, v.last = f, v.tail = u, v.tailMode = p);
    }
    function N1(e, n, u) {
      var f = n.pendingProps, p = f.revealOrder, v = f.tail;
      if (f = f.children, p !== void 0 && p !== "forwards" && p !== "backwards" && p !== "together" && !o8[p])
        if (o8[p] = !0, typeof p == "string")
          switch (p.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
                p,
                p.toLowerCase()
              );
              break;
            case "forward":
            case "backward":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
                p,
                p.toLowerCase()
              );
              break;
            default:
              console.error(
                '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
                p
              );
          }
        else
          console.error(
            '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
            p
          );
      v === void 0 || K3[v] || (v !== "collapsed" && v !== "hidden" ? (K3[v] = !0, console.error(
        '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?',
        v
      )) : p !== "forwards" && p !== "backwards" && (K3[v] = !0, console.error(
        '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
        v
      )));
      e: if ((p === "forwards" || p === "backwards") && f !== void 0 && f !== null && f !== !1)
        if (gr(f)) {
          for (var k = 0; k < f.length; k++)
            if (!D1(f[k], k)) break e;
        } else if (k = Ce(f), typeof k == "function") {
          if (k = k.call(f))
            for (var M = k.next(), q = 0; !M.done; M = k.next()) {
              if (!D1(M.value, q)) break e;
              q++;
            }
        } else
          console.error(
            'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
            p
          );
      if (mr(e, n, f, u), f = Ir.current, f & hg)
        f = f & im | hg, n.flags |= 128;
      else {
        if (e !== null && e.flags & 128)
          e: for (e = n.child; e !== null; ) {
            if (e.tag === 13)
              e.memoizedState !== null && O1(
                e,
                u,
                n
              );
            else if (e.tag === 19)
              O1(e, u, n);
            else if (e.child !== null) {
              e.child.return = e, e = e.child;
              continue;
            }
            if (e === n) break e;
            for (; e.sibling === null; ) {
              if (e.return === null || e.return === n)
                break e;
              e = e.return;
            }
            e.sibling.return = e.return, e = e.sibling;
          }
        f &= im;
      }
      switch (Ye(Ir, f, n), p) {
        case "forwards":
          for (u = n.child, p = null; u !== null; )
            e = u.alternate, e !== null && qh(e) === null && (p = u), u = u.sibling;
          u = p, u === null ? (p = n.child, n.child = null) : (p = u.sibling, u.sibling = null), Fh(
            n,
            !1,
            p,
            u,
            v
          );
          break;
        case "backwards":
          for (u = null, p = n.child, n.child = null; p !== null; ) {
            if (e = p.alternate, e !== null && qh(e) === null) {
              n.child = p;
              break;
            }
            e = p.sibling, p.sibling = u, u = p, p = e;
          }
          Fh(
            n,
            !0,
            u,
            null,
            v
          );
          break;
        case "together":
          Fh(n, !1, null, null, void 0);
          break;
        default:
          n.memoizedState = null;
      }
      return n.child;
    }
    function hi(e, n, u) {
      if (e !== null && (n.dependencies = e.dependencies), yl = -1, Ic |= n.lanes, !(u & n.childLanes))
        if (e !== null) {
          if ($i(
            e,
            n,
            u,
            !1
          ), (u & n.childLanes) === 0)
            return null;
        } else return null;
      if (e !== null && n.child !== e.child)
        throw Error("Resuming work not yet implemented.");
      if (n.child !== null) {
        for (e = n.child, u = ui(e, e.pendingProps), n.child = u, u.return = n; e.sibling !== null; )
          e = e.sibling, u = u.sibling = ui(e, e.pendingProps), u.return = n;
        u.sibling = null;
      }
      return n.child;
    }
    function L1(e, n) {
      return e.lanes & n ? !0 : (e = e.dependencies, !!(e !== null && T0(e)));
    }
    function k4(e, n, u) {
      switch (n.tag) {
        case 3:
          re(
            n,
            n.stateNode.containerInfo
          ), Ou(
            n,
            Vr,
            e.memoizedState.cache
          ), Gs();
          break;
        case 27:
        case 5:
          W(n);
          break;
        case 4:
          re(
            n,
            n.stateNode.containerInfo
          );
          break;
        case 10:
          Ou(
            n,
            n.type,
            n.memoizedProps.value
          );
          break;
        case 12:
          u & n.childLanes && (n.flags |= 4), n.flags |= 2048;
          var f = n.stateNode;
          f.effectDuration = -0, f.passiveEffectDuration = -0;
          break;
        case 13:
          if (f = n.memoizedState, f !== null)
            return f.dehydrated !== null ? (va(n), n.flags |= 128, null) : u & n.child.childLanes ? _1(
              e,
              n,
              u
            ) : (va(n), e = hi(
              e,
              n,
              u
            ), e !== null ? e.sibling : null);
          va(n);
          break;
        case 19:
          var p = (e.flags & 128) !== 0;
          if (f = (u & n.childLanes) !== 0, f || ($i(
            e,
            n,
            u,
            !1
          ), f = (u & n.childLanes) !== 0), p) {
            if (f)
              return N1(
                e,
                n,
                u
              );
            n.flags |= 128;
          }
          if (p = n.memoizedState, p !== null && (p.rendering = null, p.tail = null, p.lastEffect = null), Ye(
            Ir,
            Ir.current,
            n
          ), f) break;
          return null;
        case 22:
        case 23:
          return n.lanes = 0, $h(e, n, u);
        case 24:
          Ou(
            n,
            Vr,
            e.memoizedState.cache
          );
      }
      return hi(e, n, u);
    }
    function Yu(e, n, u) {
      if (n._debugNeedsRemount && e !== null) {
        u = Sh(
          n.type,
          n.key,
          n.pendingProps,
          n._debugOwner || null,
          n.mode,
          n.lanes
        ), u._debugStack = n._debugStack, u._debugTask = n._debugTask;
        var f = n.return;
        if (f === null) throw Error("Cannot swap the root fiber.");
        if (e.alternate = null, n.alternate = null, u.index = n.index, u.sibling = n.sibling, u.return = n.return, u.ref = n.ref, u._debugInfo = n._debugInfo, n === f.child)
          f.child = u;
        else {
          var p = f.child;
          if (p === null)
            throw Error("Expected parent to have a child.");
          for (; p.sibling !== n; )
            if (p = p.sibling, p === null)
              throw Error("Expected to find the previous sibling.");
          p.sibling = u;
        }
        return n = f.deletions, n === null ? (f.deletions = [e], f.flags |= 16) : n.push(e), u.flags |= 2, u;
      }
      if (e !== null)
        if (e.memoizedProps !== n.pendingProps || n.type !== e.type)
          ea = !0;
        else {
          if (!L1(e, u) && !(n.flags & 128))
            return ea = !1, k4(
              e,
              n,
              u
            );
          ea = !!(e.flags & 131072);
        }
      else
        ea = !1, (f = rn) && (Rl(), f = (n.flags & 1048576) !== 0), f && (f = n.index, Rl(), l1(n, yy, f));
      switch (n.lanes = 0, n.tag) {
        case 16:
          e: if (f = n.pendingProps, e = Vc(n.elementType), n.type = e, typeof e == "function")
            bh(e) ? (f = Vu(
              e,
              f
            ), n.tag = 1, n.type = e = Do(e), n = z1(
              null,
              n,
              e,
              f,
              u
            )) : (n.tag = 0, $0(n, e), n.type = e = Do(e), n = Xh(
              null,
              n,
              e,
              f,
              u
            ));
          else {
            if (e != null) {
              if (p = e.$$typeof, p === ao) {
                n.tag = 11, n.type = e = t1(e), n = fi(
                  null,
                  n,
                  e,
                  f,
                  u
                );
                break e;
              } else if (p === Cd) {
                n.tag = 14, n = Y0(
                  null,
                  n,
                  e,
                  f,
                  u
                );
                break e;
              }
            }
            throw n = "", e !== null && typeof e == "object" && e.$$typeof === $a && (n = " Did you wrap a component in React.lazy() more than once?"), e = ve(e) || e, Error(
              "Element type is invalid. Received a promise that resolves to: " + e + ". Lazy element type must resolve to a class or function." + n
            );
          }
          return n;
        case 0:
          return Xh(
            e,
            n,
            n.type,
            n.pendingProps,
            u
          );
        case 1:
          return f = n.type, p = Vu(
            f,
            n.pendingProps
          ), z1(
            e,
            n,
            f,
            p,
            u
          );
        case 3:
          e: {
            if (re(
              n,
              n.stateNode.containerInfo
            ), e === null)
              throw Error(
                "Should have a current fiber. This is a bug in React."
              );
            f = n.pendingProps;
            var v = n.memoizedState;
            p = v.element, k0(e, n), Bu(n, f, null, u);
            var k = n.memoizedState;
            if (f = k.cache, Ou(n, Vr, f), f !== v.cache && ra(
              n,
              [Vr],
              u,
              !0
            ), $s(), f = k.element, v.isDehydrated)
              if (v = {
                element: f,
                isDehydrated: !1,
                cache: k.cache
              }, n.updateQueue.baseState = v, n.memoizedState = v, n.flags & 256) {
                n = C1(
                  e,
                  n,
                  f,
                  u
                );
                break e;
              } else if (f !== p) {
                p = fa(
                  Error(
                    "This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."
                  ),
                  n
                ), Vs(p), n = C1(
                  e,
                  n,
                  f,
                  u
                );
                break e;
              } else {
                switch (e = n.stateNode.containerInfo, e.nodeType) {
                  case 9:
                    e = e.body;
                    break;
                  default:
                    e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
                }
                for (ir = ka(e.firstChild), Za = n, rn = !0, Mf = null, fs = !1, ki = null, co = !0, e = $b(
                  n,
                  null,
                  f,
                  u
                ), n.child = e; e; )
                  e.flags = e.flags & -3 | 4096, e = e.sibling;
              }
            else {
              if (Gs(), f === p) {
                n = hi(
                  e,
                  n,
                  u
                );
                break e;
              }
              mr(
                e,
                n,
                f,
                u
              );
            }
            n = n.child;
          }
          return n;
        case 26:
          return I0(e, n), e === null ? (e = uf(
            n.type,
            null,
            n.pendingProps,
            null
          )) ? n.memoizedState = e : rn || (e = n.type, u = n.pendingProps, f = Te(
            pi.current
          ), f = tn(
            f
          ).createElement(e), f[Wr] = n, f[Ca] = u, Ar(f, e, u), ue(f), n.stateNode = f) : n.memoizedState = uf(
            n.type,
            e.memoizedProps,
            n.pendingProps,
            e.memoizedState
          ), null;
        case 27:
          return W(n), e === null && rn && (f = Te(pi.current), p = X(), f = n.stateNode = Ra(
            n.type,
            n.pendingProps,
            f,
            p,
            !1
          ), fs || (p = It(
            f,
            n.type,
            n.pendingProps,
            p
          ), p !== null && (Ho(n, 0).serverProps = p)), Za = n, co = !0, p = ir, pr(n.type) ? (x6 = p, ir = ka(
            f.firstChild
          )) : ir = p), mr(
            e,
            n,
            n.pendingProps.children,
            u
          ), I0(e, n), e === null && (n.flags |= 4194304), n.child;
        case 5:
          return e === null && rn && (v = X(), f = oh(
            n.type,
            v.ancestorInfo
          ), p = ir, (k = !p) || (k = Ur(
            p,
            n.type,
            n.pendingProps,
            co
          ), k !== null ? (n.stateNode = k, fs || (v = It(
            k,
            n.type,
            n.pendingProps,
            v
          ), v !== null && (Ho(n, 0).serverProps = v)), Za = n, ir = ka(
            k.firstChild
          ), co = !1, v = !0) : v = !1, k = !v), k && (f && js(n, p), _u(n))), W(n), p = n.type, v = n.pendingProps, k = e !== null ? e.memoizedProps : null, f = v.children, Pu(p, v) ? f = null : k !== null && Pu(p, k) && (n.flags |= 32), n.memoizedState !== null && (p = Qs(
            e,
            n,
            ol,
            null,
            null,
            u
          ), Rg._currentValue = p), I0(e, n), mr(
            e,
            n,
            f,
            u
          ), n.child;
        case 6:
          return e === null && rn && (e = n.pendingProps, u = X(), f = u.ancestorInfo.current, e = f != null ? Bs(
            e,
            f.tag,
            u.ancestorInfo.implicitRootScope
          ) : !0, u = ir, (f = !u) || (f = Wu(
            u,
            n.pendingProps,
            co
          ), f !== null ? (n.stateNode = f, Za = n, ir = null, f = !0) : f = !1, f = !f), f && (e && js(n, u), _u(n))), null;
        case 13:
          return _1(e, n, u);
        case 4:
          return re(
            n,
            n.stateNode.containerInfo
          ), f = n.pendingProps, e === null ? n.child = lm(
            n,
            null,
            f,
            u
          ) : mr(
            e,
            n,
            f,
            u
          ), n.child;
        case 11:
          return fi(
            e,
            n,
            n.type,
            n.pendingProps,
            u
          );
        case 7:
          return mr(
            e,
            n,
            n.pendingProps,
            u
          ), n.child;
        case 8:
          return mr(
            e,
            n,
            n.pendingProps.children,
            u
          ), n.child;
        case 12:
          return n.flags |= 4, n.flags |= 2048, f = n.stateNode, f.effectDuration = -0, f.passiveEffectDuration = -0, mr(
            e,
            n,
            n.pendingProps.children,
            u
          ), n.child;
        case 10:
          return f = n.type, p = n.pendingProps, v = p.value, "value" in p || s8 || (s8 = !0, console.error(
            "The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"
          )), Ou(n, f, v), mr(
            e,
            n,
            p.children,
            u
          ), n.child;
        case 9:
          return p = n.type._context, f = n.pendingProps.children, typeof f != "function" && console.error(
            "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
          ), Du(n), p = En(p), vt(n), f = $3(
            f,
            p,
            void 0
          ), St(), n.flags |= 1, mr(
            e,
            n,
            f,
            u
          ), n.child;
        case 14:
          return Y0(
            e,
            n,
            n.type,
            n.pendingProps,
            u
          );
        case 15:
          return Ih(
            e,
            n,
            n.type,
            n.pendingProps,
            u
          );
        case 19:
          return N1(
            e,
            n,
            u
          );
        case 31:
          return f = n.pendingProps, u = n.mode, f = {
            mode: f.mode,
            children: f.children
          }, e === null ? (e = X0(
            f,
            u
          ), e.ref = n.ref, n.child = e, e.return = n, n = e) : (e = ui(e.child, f), e.ref = n.ref, n.child = e, e.return = n, n = e), n;
        case 22:
          return $h(e, n, u);
        case 24:
          return Du(n), f = En(Vr), e === null ? (p = f1(), p === null && (p = zn, v = s1(), p.pooledCache = v, ul(v), v !== null && (p.pooledCacheLanes |= u), p = v), n.memoizedState = {
            parent: f,
            cache: p
          }, Lu(n), Ou(n, Vr, p)) : (e.lanes & u && (k0(e, n), Bu(n, null, null, u), $s()), p = e.memoizedState, v = n.memoizedState, p.parent !== f ? (p = {
            parent: f,
            cache: f
          }, n.memoizedState = p, n.lanes === 0 && (n.memoizedState = n.updateQueue.baseState = p), Ou(n, Vr, f)) : (f = v.cache, Ou(n, Vr, f), f !== p.cache && ra(
            n,
            [Vr],
            u,
            !0
          ))), mr(
            e,
            n,
            n.pendingProps.children,
            u
          ), n.child;
        case 29:
          throw n.pendingProps;
      }
      throw Error(
        "Unknown unit of work tag (" + n.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function fl(e) {
      e.flags |= 4;
    }
    function B1(e, n) {
      if (n.type !== "stylesheet" || (n.state.loading & _i) !== $f)
        e.flags &= -16777217;
      else if (e.flags |= 16777216, !Ep(n)) {
        if (n = Mi.current, n !== null && ((Zt & 4194048) === Zt ? ho !== null : (Zt & 62914560) !== Zt && !(Zt & 536870912) || n !== ho))
          throw og = U3, bb;
        e.flags |= 8192;
      }
    }
    function Zo(e, n) {
      n !== null && (e.flags |= 4), e.flags & 16384 && (n = e.tag !== 22 ? nl() : 536870912, e.lanes |= n, qf |= n);
    }
    function tu(e, n) {
      if (!rn)
        switch (e.tailMode) {
          case "hidden":
            n = e.tail;
            for (var u = null; n !== null; )
              n.alternate !== null && (u = n), n = n.sibling;
            u === null ? e.tail = null : u.sibling = null;
            break;
          case "collapsed":
            u = e.tail;
            for (var f = null; u !== null; )
              u.alternate !== null && (f = u), u = u.sibling;
            f === null ? n || e.tail === null ? e.tail = null : e.tail.sibling = null : f.sibling = null;
        }
    }
    function An(e) {
      var n = e.alternate !== null && e.alternate.child === e.child, u = 0, f = 0;
      if (n)
        if ((e.mode & ua) !== Dn) {
          for (var p = e.selfBaseDuration, v = e.child; v !== null; )
            u |= v.lanes | v.childLanes, f |= v.subtreeFlags & 65011712, f |= v.flags & 65011712, p += v.treeBaseDuration, v = v.sibling;
          e.treeBaseDuration = p;
        } else
          for (p = e.child; p !== null; )
            u |= p.lanes | p.childLanes, f |= p.subtreeFlags & 65011712, f |= p.flags & 65011712, p.return = e, p = p.sibling;
      else if ((e.mode & ua) !== Dn) {
        p = e.actualDuration, v = e.selfBaseDuration;
        for (var k = e.child; k !== null; )
          u |= k.lanes | k.childLanes, f |= k.subtreeFlags, f |= k.flags, p += k.actualDuration, v += k.treeBaseDuration, k = k.sibling;
        e.actualDuration = p, e.treeBaseDuration = v;
      } else
        for (p = e.child; p !== null; )
          u |= p.lanes | p.childLanes, f |= p.subtreeFlags, f |= p.flags, p.return = e, p = p.sibling;
      return e.subtreeFlags |= f, e.childLanes = u, n;
    }
    function R4(e, n, u) {
      var f = n.pendingProps;
      switch (Bo(n), n.tag) {
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return An(n), null;
        case 1:
          return An(n), null;
        case 3:
          return u = n.stateNode, f = null, e !== null && (f = e.memoizedState.cache), n.memoizedState.cache !== f && (n.flags |= 2048), Ii(Vr, n), J(n), u.pendingContext && (u.context = u.pendingContext, u.pendingContext = null), (e === null || e.child === null) && (Uo(n) ? (w4(), fl(n)) : e === null || e.memoizedState.isDehydrated && !(n.flags & 256) || (n.flags |= 1024, u1())), An(n), null;
        case 26:
          return u = n.memoizedState, e === null ? (fl(n), u !== null ? (An(n), B1(
            n,
            u
          )) : (An(n), n.flags &= -16777217)) : u ? u !== e.memoizedState ? (fl(n), An(n), B1(
            n,
            u
          )) : (An(n), n.flags &= -16777217) : (e.memoizedProps !== f && fl(n), An(n), n.flags &= -16777217), null;
        case 27:
          be(n), u = Te(pi.current);
          var p = n.type;
          if (e !== null && n.stateNode != null)
            e.memoizedProps !== f && fl(n);
          else {
            if (!f) {
              if (n.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return An(n), null;
            }
            e = X(), Uo(n) ? i1(n) : (e = Ra(
              p,
              f,
              u,
              e,
              !0
            ), n.stateNode = e, fl(n));
          }
          return An(n), null;
        case 5:
          if (be(n), u = n.type, e !== null && n.stateNode != null)
            e.memoizedProps !== f && fl(n);
          else {
            if (!f) {
              if (n.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return An(n), null;
            }
            if (p = X(), Uo(n))
              i1(n);
            else {
              switch (e = Te(pi.current), oh(u, p.ancestorInfo), p = p.context, e = tn(e), p) {
                case ym:
                  e = e.createElementNS(vu, u);
                  break;
                case Iy:
                  e = e.createElementNS(
                    Gd,
                    u
                  );
                  break;
                default:
                  switch (u) {
                    case "svg":
                      e = e.createElementNS(
                        vu,
                        u
                      );
                      break;
                    case "math":
                      e = e.createElementNS(
                        Gd,
                        u
                      );
                      break;
                    case "script":
                      e = e.createElement("div"), e.innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild);
                      break;
                    case "select":
                      e = typeof f.is == "string" ? e.createElement("select", { is: f.is }) : e.createElement("select"), f.multiple ? e.multiple = !0 : f.size && (e.size = f.size);
                      break;
                    default:
                      e = typeof f.is == "string" ? e.createElement(u, {
                        is: f.is
                      }) : e.createElement(u), u.indexOf("-") === -1 && (u !== u.toLowerCase() && console.error(
                        "<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",
                        u
                      ), Object.prototype.toString.call(e) !== "[object HTMLUnknownElement]" || gi.call(
                        z8,
                        u
                      ) || (z8[u] = !0, console.error(
                        "The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.",
                        u
                      )));
                  }
              }
              e[Wr] = n, e[Ca] = f;
              e: for (p = n.child; p !== null; ) {
                if (p.tag === 5 || p.tag === 6)
                  e.appendChild(p.stateNode);
                else if (p.tag !== 4 && p.tag !== 27 && p.child !== null) {
                  p.child.return = p, p = p.child;
                  continue;
                }
                if (p === n) break e;
                for (; p.sibling === null; ) {
                  if (p.return === null || p.return === n)
                    break e;
                  p = p.return;
                }
                p.sibling.return = p.return, p = p.sibling;
              }
              n.stateNode = e;
              e: switch (Ar(e, u, f), u) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  e = !!f.autoFocus;
                  break e;
                case "img":
                  e = !0;
                  break e;
                default:
                  e = !1;
              }
              e && fl(n);
            }
          }
          return An(n), n.flags &= -16777217, null;
        case 6:
          if (e && n.stateNode != null)
            e.memoizedProps !== f && fl(n);
          else {
            if (typeof f != "string" && n.stateNode === null)
              throw Error(
                "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
              );
            if (e = Te(pi.current), u = X(), Uo(n)) {
              e = n.stateNode, u = n.memoizedProps, p = !fs, f = null;
              var v = Za;
              if (v !== null)
                switch (v.tag) {
                  case 3:
                    p && (p = Sp(
                      e,
                      u,
                      f
                    ), p !== null && (Ho(n, 0).serverProps = p));
                    break;
                  case 27:
                  case 5:
                    f = v.memoizedProps, p && (p = Sp(
                      e,
                      u,
                      f
                    ), p !== null && (Ho(
                      n,
                      0
                    ).serverProps = p));
                }
              e[Wr] = n, e = !!(e.nodeValue === u || f !== null && f.suppressHydrationWarning === !0 || ns(e.nodeValue, u)), e || _u(n);
            } else
              p = u.ancestorInfo.current, p != null && Bs(
                f,
                p.tag,
                u.ancestorInfo.implicitRootScope
              ), e = tn(e).createTextNode(
                f
              ), e[Wr] = n, n.stateNode = e;
          }
          return An(n), null;
        case 13:
          if (f = n.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
            if (p = Uo(n), f !== null && f.dehydrated !== null) {
              if (e === null) {
                if (!p)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                if (p = n.memoizedState, p = p !== null ? p.dehydrated : null, !p)
                  throw Error(
                    "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                p[Wr] = n, An(n), (n.mode & ua) !== Dn && f !== null && (p = n.child, p !== null && (n.treeBaseDuration -= p.treeBaseDuration));
              } else
                w4(), Gs(), !(n.flags & 128) && (n.memoizedState = null), n.flags |= 4, An(n), (n.mode & ua) !== Dn && f !== null && (p = n.child, p !== null && (n.treeBaseDuration -= p.treeBaseDuration));
              p = !1;
            } else
              p = u1(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = p), p = !0;
            if (!p)
              return n.flags & 256 ? (ba(n), n) : (ba(n), null);
          }
          return ba(n), n.flags & 128 ? (n.lanes = u, (n.mode & ua) !== Dn && A0(n), n) : (u = f !== null, e = e !== null && e.memoizedState !== null, u && (f = n.child, p = null, f.alternate !== null && f.alternate.memoizedState !== null && f.alternate.memoizedState.cachePool !== null && (p = f.alternate.memoizedState.cachePool.pool), v = null, f.memoizedState !== null && f.memoizedState.cachePool !== null && (v = f.memoizedState.cachePool.pool), v !== p && (f.flags |= 2048)), u !== e && u && (n.child.flags |= 8192), Zo(n, n.updateQueue), An(n), (n.mode & ua) !== Dn && u && (e = n.child, e !== null && (n.treeBaseDuration -= e.treeBaseDuration)), null);
        case 4:
          return J(n), e === null && rf(
            n.stateNode.containerInfo
          ), An(n), null;
        case 10:
          return Ii(n.type, n), An(n), null;
        case 19:
          if (de(Ir, n), p = n.memoizedState, p === null) return An(n), null;
          if (f = (n.flags & 128) !== 0, v = p.rendering, v === null)
            if (f) tu(p, !1);
            else {
              if (ur !== ps || e !== null && e.flags & 128)
                for (e = n.child; e !== null; ) {
                  if (v = qh(e), v !== null) {
                    for (n.flags |= 128, tu(p, !1), e = v.updateQueue, n.updateQueue = e, Zo(n, e), n.subtreeFlags = 0, e = u, u = n.child; u !== null; )
                      n1(u, e), u = u.sibling;
                    return Ye(
                      Ir,
                      Ir.current & im | hg,
                      n
                    ), n.child;
                  }
                  e = e.sibling;
                }
              p.tail !== null && qr() > Oy && (n.flags |= 128, f = !0, tu(p, !1), n.lanes = 4194304);
            }
          else {
            if (!f)
              if (e = qh(v), e !== null) {
                if (n.flags |= 128, f = !0, e = e.updateQueue, n.updateQueue = e, Zo(n, e), tu(p, !0), p.tail === null && p.tailMode === "hidden" && !v.alternate && !rn)
                  return An(n), null;
              } else
                2 * qr() - p.renderingStartTime > Oy && u !== 536870912 && (n.flags |= 128, f = !0, tu(p, !1), n.lanes = 4194304);
            p.isBackwards ? (v.sibling = n.child, n.child = v) : (e = p.last, e !== null ? e.sibling = v : n.child = v, p.last = v);
          }
          return p.tail !== null ? (e = p.tail, p.rendering = e, p.tail = e.sibling, p.renderingStartTime = qr(), e.sibling = null, u = Ir.current, u = f ? u & im | hg : u & im, Ye(Ir, u, n), e) : (An(n), null);
        case 22:
        case 23:
          return ba(n), Ch(n), f = n.memoizedState !== null, e !== null ? e.memoizedState !== null !== f && (n.flags |= 8192) : f && (n.flags |= 8192), f ? u & 536870912 && !(n.flags & 128) && (An(n), n.subtreeFlags & 6 && (n.flags |= 8192)) : An(n), u = n.updateQueue, u !== null && Zo(n, u.retryQueue), u = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (u = e.memoizedState.cachePool.pool), f = null, n.memoizedState !== null && n.memoizedState.cachePool !== null && (f = n.memoizedState.cachePool.pool), f !== u && (n.flags |= 2048), e !== null && de(Df, n), null;
        case 24:
          return u = null, e !== null && (u = e.memoizedState.cache), n.memoizedState.cache !== u && (n.flags |= 2048), Ii(Vr, n), An(n), null;
        case 25:
          return null;
        case 30:
          return null;
      }
      throw Error(
        "Unknown unit of work tag (" + n.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function z4(e, n) {
      switch (Bo(n), n.tag) {
        case 1:
          return e = n.flags, e & 65536 ? (n.flags = e & -65537 | 128, (n.mode & ua) !== Dn && A0(n), n) : null;
        case 3:
          return Ii(Vr, n), J(n), e = n.flags, e & 65536 && !(e & 128) ? (n.flags = e & -65537 | 128, n) : null;
        case 26:
        case 27:
        case 5:
          return be(n), null;
        case 13:
          if (ba(n), e = n.memoizedState, e !== null && e.dehydrated !== null) {
            if (n.alternate === null)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            Gs();
          }
          return e = n.flags, e & 65536 ? (n.flags = e & -65537 | 128, (n.mode & ua) !== Dn && A0(n), n) : null;
        case 19:
          return de(Ir, n), null;
        case 4:
          return J(n), null;
        case 10:
          return Ii(n.type, n), null;
        case 22:
        case 23:
          return ba(n), Ch(n), e !== null && de(Df, n), e = n.flags, e & 65536 ? (n.flags = e & -65537 | 128, (n.mode & ua) !== Dn && A0(n), n) : null;
        case 24:
          return Ii(Vr, n), null;
        case 25:
          return null;
        default:
          return null;
      }
    }
    function H1(e, n) {
      switch (Bo(n), n.tag) {
        case 3:
          Ii(Vr, n), J(n);
          break;
        case 26:
        case 27:
        case 5:
          be(n);
          break;
        case 4:
          J(n);
          break;
        case 13:
          ba(n);
          break;
        case 19:
          de(Ir, n);
          break;
        case 10:
          Ii(n.type, n);
          break;
        case 22:
        case 23:
          ba(n), Ch(n), e !== null && de(Df, n);
          break;
        case 24:
          Ii(Vr, n);
      }
    }
    function Hl(e) {
      return (e.mode & ua) !== Dn;
    }
    function U1(e, n) {
      Hl(e) ? (Pr(), sc(n, e), zl()) : sc(n, e);
    }
    function Z0(e, n, u) {
      Hl(e) ? (Pr(), Fo(
        u,
        e,
        n
      ), zl()) : Fo(
        u,
        e,
        n
      );
    }
    function sc(e, n) {
      try {
        var u = n.updateQueue, f = u !== null ? u.lastEffect : null;
        if (f !== null) {
          var p = f.next;
          u = p;
          do {
            if ((u.tag & e) === e && ((e & Yr) !== Ri ? Pe !== null && typeof Pe.markComponentPassiveEffectMountStarted == "function" && Pe.markComponentPassiveEffectMountStarted(
              n
            ) : (e & oa) !== Ri && Pe !== null && typeof Pe.markComponentLayoutEffectMountStarted == "function" && Pe.markComponentLayoutEffectMountStarted(
              n
            ), f = void 0, (e & Fa) !== Ri && (pm = !0), f = at(
              n,
              tE,
              u
            ), (e & Fa) !== Ri && (pm = !1), (e & Yr) !== Ri ? Pe !== null && typeof Pe.markComponentPassiveEffectMountStopped == "function" && Pe.markComponentPassiveEffectMountStopped() : (e & oa) !== Ri && Pe !== null && typeof Pe.markComponentLayoutEffectMountStopped == "function" && Pe.markComponentLayoutEffectMountStopped(), f !== void 0 && typeof f != "function")) {
              var v = void 0;
              v = u.tag & oa ? "useLayoutEffect" : u.tag & Fa ? "useInsertionEffect" : "useEffect";
              var k = void 0;
              k = f === null ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof f.then == "function" ? `

It looks like you wrote ` + v + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + v + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching` : " You returned: " + f, at(
                n,
                function(M, q) {
                  console.error(
                    "%s must not return anything besides a function, which is used for clean-up.%s",
                    M,
                    q
                  );
                },
                v,
                k
              );
            }
            u = u.next;
          } while (u !== p);
        }
      } catch (M) {
        mn(n, n.return, M);
      }
    }
    function Fo(e, n, u) {
      try {
        var f = n.updateQueue, p = f !== null ? f.lastEffect : null;
        if (p !== null) {
          var v = p.next;
          f = v;
          do {
            if ((f.tag & e) === e) {
              var k = f.inst, M = k.destroy;
              M !== void 0 && (k.destroy = void 0, (e & Yr) !== Ri ? Pe !== null && typeof Pe.markComponentPassiveEffectUnmountStarted == "function" && Pe.markComponentPassiveEffectUnmountStarted(
                n
              ) : (e & oa) !== Ri && Pe !== null && typeof Pe.markComponentLayoutEffectUnmountStarted == "function" && Pe.markComponentLayoutEffectUnmountStarted(
                n
              ), (e & Fa) !== Ri && (pm = !0), p = n, at(
                p,
                nE,
                p,
                u,
                M
              ), (e & Fa) !== Ri && (pm = !1), (e & Yr) !== Ri ? Pe !== null && typeof Pe.markComponentPassiveEffectUnmountStopped == "function" && Pe.markComponentPassiveEffectUnmountStopped() : (e & oa) !== Ri && Pe !== null && typeof Pe.markComponentLayoutEffectUnmountStopped == "function" && Pe.markComponentLayoutEffectUnmountStopped());
            }
            f = f.next;
          } while (f !== v);
        }
      } catch (q) {
        mn(n, n.return, q);
      }
    }
    function Ph(e, n) {
      Hl(e) ? (Pr(), sc(n, e), zl()) : sc(n, e);
    }
    function Kh(e, n, u) {
      Hl(e) ? (Pr(), Fo(
        u,
        e,
        n
      ), zl()) : Fo(
        u,
        e,
        n
      );
    }
    function q1(e) {
      var n = e.updateQueue;
      if (n !== null) {
        var u = e.stateNode;
        e.type.defaultProps || "ref" in e.memoizedProps || om || (u.props !== e.memoizedProps && console.error(
          "Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
          ee(e) || "instance"
        ), u.state !== e.memoizedState && console.error(
          "Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
          ee(e) || "instance"
        ));
        try {
          at(
            e,
            ma,
            n,
            u
          );
        } catch (f) {
          mn(e, e.return, f);
        }
      }
    }
    function m3(e, n, u) {
      return e.getSnapshotBeforeUpdate(n, u);
    }
    function j1(e, n) {
      var u = n.memoizedProps, f = n.memoizedState;
      n = e.stateNode, e.type.defaultProps || "ref" in e.memoizedProps || om || (n.props !== e.memoizedProps && console.error(
        "Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
        ee(e) || "instance"
      ), n.state !== e.memoizedState && console.error(
        "Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
        ee(e) || "instance"
      ));
      try {
        var p = Vu(
          e.type,
          u,
          e.elementType === e.type
        ), v = at(
          e,
          m3,
          n,
          p,
          f
        );
        u = c8, v !== void 0 || u.has(e.type) || (u.add(e.type), at(e, function() {
          console.error(
            "%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",
            ee(e)
          );
        })), n.__reactInternalSnapshotBeforeUpdate = v;
      } catch (k) {
        mn(e, e.return, k);
      }
    }
    function G1(e, n, u) {
      u.props = Vu(
        e.type,
        e.memoizedProps
      ), u.state = e.memoizedState, Hl(e) ? (Pr(), at(
        e,
        Hb,
        e,
        n,
        u
      ), zl()) : at(
        e,
        Hb,
        e,
        n,
        u
      );
    }
    function C4(e) {
      var n = e.ref;
      if (n !== null) {
        switch (e.tag) {
          case 26:
          case 27:
          case 5:
            var u = e.stateNode;
            break;
          case 30:
            u = e.stateNode;
            break;
          default:
            u = e.stateNode;
        }
        if (typeof n == "function")
          if (Hl(e))
            try {
              Pr(), e.refCleanup = n(u);
            } finally {
              zl();
            }
          else e.refCleanup = n(u);
        else
          typeof n == "string" ? console.error("String refs are no longer supported.") : n.hasOwnProperty("current") || console.error(
            "Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",
            ee(e)
          ), n.current = u;
      }
    }
    function Po(e, n) {
      try {
        at(e, C4, e);
      } catch (u) {
        mn(e, n, u);
      }
    }
    function Ul(e, n) {
      var u = e.ref, f = e.refCleanup;
      if (u !== null)
        if (typeof f == "function")
          try {
            if (Hl(e))
              try {
                Pr(), at(e, f);
              } finally {
                zl(e);
              }
            else at(e, f);
          } catch (p) {
            mn(e, n, p);
          } finally {
            e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
          }
        else if (typeof u == "function")
          try {
            if (Hl(e))
              try {
                Pr(), at(e, u, null);
              } finally {
                zl(e);
              }
            else at(e, u, null);
          } catch (p) {
            mn(e, n, p);
          }
        else u.current = null;
    }
    function V1(e, n, u, f) {
      var p = e.memoizedProps, v = p.id, k = p.onCommit;
      p = p.onRender, n = n === null ? "mount" : "update", Sy && (n = "nested-update"), typeof p == "function" && p(
        v,
        n,
        e.actualDuration,
        e.treeBaseDuration,
        e.actualStartTime,
        u
      ), typeof k == "function" && k(
        e.memoizedProps.id,
        n,
        f,
        u
      );
    }
    function p3(e, n, u, f) {
      var p = e.memoizedProps;
      e = p.id, p = p.onPostCommit, n = n === null ? "mount" : "update", Sy && (n = "nested-update"), typeof p == "function" && p(
        e,
        n,
        f,
        u
      );
    }
    function M4(e) {
      var n = e.type, u = e.memoizedProps, f = e.stateNode;
      try {
        at(
          e,
          $n,
          f,
          n,
          u,
          e
        );
      } catch (p) {
        mn(e, e.return, p);
      }
    }
    function Jh(e, n, u) {
      try {
        at(
          e,
          Ku,
          e.stateNode,
          e.type,
          u,
          n,
          e
        );
      } catch (f) {
        mn(e, e.return, f);
      }
    }
    function cc(e) {
      return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && pr(e.type) || e.tag === 4;
    }
    function F0(e) {
      e: for (; ; ) {
        for (; e.sibling === null; ) {
          if (e.return === null || cc(e.return)) return null;
          e = e.return;
        }
        for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
          if (e.tag === 27 && pr(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue e;
          e.child.return = e, e = e.child;
        }
        if (!(e.flags & 2)) return e.stateNode;
      }
    }
    function fc(e, n, u) {
      var f = e.tag;
      if (f === 5 || f === 6)
        e = e.stateNode, n ? (u.nodeType === 9 ? u.body : u.nodeName === "HTML" ? u.ownerDocument.body : u).insertBefore(e, n) : (n = u.nodeType === 9 ? u.body : u.nodeName === "HTML" ? u.ownerDocument.body : u, n.appendChild(e), u = u._reactRootContainer, u != null || n.onclick !== null || (n.onclick = Zu));
      else if (f !== 4 && (f === 27 && pr(e.type) && (u = e.stateNode, n = null), e = e.child, e !== null))
        for (fc(e, n, u), e = e.sibling; e !== null; )
          fc(e, n, u), e = e.sibling;
    }
    function P0(e, n, u) {
      var f = e.tag;
      if (f === 5 || f === 6)
        e = e.stateNode, n ? u.insertBefore(e, n) : u.appendChild(e);
      else if (f !== 4 && (f === 27 && pr(e.type) && (u = e.stateNode), e = e.child, e !== null))
        for (P0(e, n, u), e = e.sibling; e !== null; )
          P0(e, n, u), e = e.sibling;
    }
    function _4(e) {
      for (var n, u = e.return; u !== null; ) {
        if (cc(u)) {
          n = u;
          break;
        }
        u = u.return;
      }
      if (n == null)
        throw Error(
          "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
        );
      switch (n.tag) {
        case 27:
          n = n.stateNode, u = F0(e), P0(
            e,
            u,
            n
          );
          break;
        case 5:
          u = n.stateNode, n.flags & 32 && (Ju(u), n.flags &= -33), n = F0(e), P0(
            e,
            n,
            u
          );
          break;
        case 3:
        case 4:
          n = n.stateNode.containerInfo, u = F0(e), fc(
            e,
            u,
            n
          );
          break;
        default:
          throw Error(
            "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue."
          );
      }
    }
    function K0(e) {
      var n = e.stateNode, u = e.memoizedProps;
      try {
        at(
          e,
          X4,
          e.type,
          u,
          n,
          e
        );
      } catch (f) {
        mn(e, e.return, f);
      }
    }
    function O4(e, n) {
      if (e = e.containerInfo, v6 = Zy, e = b4(e), Wm(e)) {
        if ("selectionStart" in e)
          var u = {
            start: e.selectionStart,
            end: e.selectionEnd
          };
        else
          e: {
            u = (u = e.ownerDocument) && u.defaultView || window;
            var f = u.getSelection && u.getSelection();
            if (f && f.rangeCount !== 0) {
              u = f.anchorNode;
              var p = f.anchorOffset, v = f.focusNode;
              f = f.focusOffset;
              try {
                u.nodeType, v.nodeType;
              } catch {
                u = null;
                break e;
              }
              var k = 0, M = -1, q = -1, j = 0, xe = 0, Ae = e, pe = null;
              t: for (; ; ) {
                for (var Re; Ae !== u || p !== 0 && Ae.nodeType !== 3 || (M = k + p), Ae !== v || f !== 0 && Ae.nodeType !== 3 || (q = k + f), Ae.nodeType === 3 && (k += Ae.nodeValue.length), (Re = Ae.firstChild) !== null; )
                  pe = Ae, Ae = Re;
                for (; ; ) {
                  if (Ae === e) break t;
                  if (pe === u && ++j === p && (M = k), pe === v && ++xe === f && (q = k), (Re = Ae.nextSibling) !== null) break;
                  Ae = pe, pe = Ae.parentNode;
                }
                Ae = Re;
              }
              u = M === -1 || q === -1 ? null : { start: M, end: q };
            } else u = null;
          }
        u = u || { start: 0, end: 0 };
      } else u = null;
      for (b6 = {
        focusedElem: e,
        selectionRange: u
      }, Zy = !1, ta = n; ta !== null; )
        if (n = ta, e = n.child, (n.subtreeFlags & 1024) !== 0 && e !== null)
          e.return = n, ta = e;
        else
          for (; ta !== null; ) {
            switch (e = n = ta, u = e.alternate, p = e.flags, e.tag) {
              case 0:
                break;
              case 11:
              case 15:
                break;
              case 1:
                p & 1024 && u !== null && j1(e, u);
                break;
              case 3:
                if (p & 1024) {
                  if (e = e.stateNode.containerInfo, u = e.nodeType, u === 9)
                    di(e);
                  else if (u === 1)
                    switch (e.nodeName) {
                      case "HEAD":
                      case "HTML":
                      case "BODY":
                        di(e);
                        break;
                      default:
                        e.textContent = "";
                    }
                }
                break;
              case 5:
              case 26:
              case 27:
              case 6:
              case 4:
              case 17:
                break;
              default:
                if (p & 1024)
                  throw Error(
                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue."
                  );
            }
            if (e = n.sibling, e !== null) {
              e.return = n.return, ta = e;
              break;
            }
            ta = n.return;
          }
    }
    function Y1(e, n, u) {
      var f = u.flags;
      switch (u.tag) {
        case 0:
        case 11:
        case 15:
          ar(e, u), f & 4 && U1(u, oa | zi);
          break;
        case 1:
          if (ar(e, u), f & 4)
            if (e = u.stateNode, n === null)
              u.type.defaultProps || "ref" in u.memoizedProps || om || (e.props !== u.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                ee(u) || "instance"
              ), e.state !== u.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                ee(u) || "instance"
              )), Hl(u) ? (Pr(), at(
                u,
                X3,
                u,
                e
              ), zl()) : at(
                u,
                X3,
                u,
                e
              );
            else {
              var p = Vu(
                u.type,
                n.memoizedProps
              );
              n = n.memoizedState, u.type.defaultProps || "ref" in u.memoizedProps || om || (e.props !== u.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                ee(u) || "instance"
              ), e.state !== u.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                ee(u) || "instance"
              )), Hl(u) ? (Pr(), at(
                u,
                Nb,
                u,
                e,
                p,
                n,
                e.__reactInternalSnapshotBeforeUpdate
              ), zl()) : at(
                u,
                Nb,
                u,
                e,
                p,
                n,
                e.__reactInternalSnapshotBeforeUpdate
              );
            }
          f & 64 && q1(u), f & 512 && Po(u, u.return);
          break;
        case 3:
          if (n = Ha(), ar(e, u), f & 64 && (f = u.updateQueue, f !== null)) {
            if (p = null, u.child !== null)
              switch (u.child.tag) {
                case 27:
                case 5:
                  p = u.child.stateNode;
                  break;
                case 1:
                  p = u.child.stateNode;
              }
            try {
              at(
                u,
                ma,
                f,
                p
              );
            } catch (k) {
              mn(u, u.return, k);
            }
          }
          e.effectDuration += Ys(n);
          break;
        case 27:
          n === null && f & 4 && K0(u);
        case 26:
        case 5:
          ar(e, u), n === null && f & 4 && M4(u), f & 512 && Po(u, u.return);
          break;
        case 12:
          if (f & 4) {
            f = Ha(), ar(e, u), e = u.stateNode, e.effectDuration += Is(f);
            try {
              at(
                u,
                V1,
                u,
                n,
                by,
                e.effectDuration
              );
            } catch (k) {
              mn(u, u.return, k);
            }
          } else ar(e, u);
          break;
        case 13:
          ar(e, u), f & 4 && J0(e, u), f & 64 && (e = u.memoizedState, e !== null && (e = e.dehydrated, e !== null && (u = Xu.bind(
            null,
            u
          ), Tc(e, u))));
          break;
        case 22:
          if (f = u.memoizedState !== null || ms, !f) {
            n = n !== null && n.memoizedState !== null || yr, p = ms;
            var v = yr;
            ms = f, (yr = n) && !v ? Kr(
              e,
              u,
              (u.subtreeFlags & 8772) !== 0
            ) : ar(e, u), ms = p, yr = v;
          }
          break;
        case 30:
          break;
        default:
          ar(e, u);
      }
    }
    function D4(e) {
      var n = e.alternate;
      n !== null && (e.alternate = null, D4(n)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (n = e.stateNode, n !== null && Nr(n)), e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
    }
    function Sa(e, n, u) {
      for (u = u.child; u !== null; )
        hc(
          e,
          n,
          u
        ), u = u.sibling;
    }
    function hc(e, n, u) {
      if (jr && typeof jr.onCommitFiberUnmount == "function")
        try {
          jr.onCommitFiberUnmount(us, u);
        } catch (v) {
          Kn || (Kn = !0, console.error(
            "React instrumentation encountered an error: %s",
            v
          ));
        }
      switch (u.tag) {
        case 26:
          yr || Ul(u, n), Sa(
            e,
            n,
            u
          ), u.memoizedState ? u.memoizedState.count-- : u.stateNode && (u = u.stateNode, u.parentNode.removeChild(u));
          break;
        case 27:
          yr || Ul(u, n);
          var f = Mr, p = vl;
          pr(u.type) && (Mr = u.stateNode, vl = !1), Sa(
            e,
            n,
            u
          ), at(
            u,
            Ac,
            u.stateNode
          ), Mr = f, vl = p;
          break;
        case 5:
          yr || Ul(u, n);
        case 6:
          if (f = Mr, p = vl, Mr = null, Sa(
            e,
            n,
            u
          ), Mr = f, vl = p, Mr !== null)
            if (vl)
              try {
                at(
                  u,
                  lf,
                  Mr,
                  u.stateNode
                );
              } catch (v) {
                mn(
                  u,
                  n,
                  v
                );
              }
            else
              try {
                at(
                  u,
                  wc,
                  Mr,
                  u.stateNode
                );
              } catch (v) {
                mn(
                  u,
                  n,
                  v
                );
              }
          break;
        case 18:
          Mr !== null && (vl ? (e = Mr, ia(
            e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e,
            u.stateNode
          ), Mc(e)) : ia(Mr, u.stateNode));
          break;
        case 4:
          f = Mr, p = vl, Mr = u.stateNode.containerInfo, vl = !0, Sa(
            e,
            n,
            u
          ), Mr = f, vl = p;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          yr || Fo(
            Fa,
            u,
            n
          ), yr || Z0(
            u,
            n,
            oa
          ), Sa(
            e,
            n,
            u
          );
          break;
        case 1:
          yr || (Ul(u, n), f = u.stateNode, typeof f.componentWillUnmount == "function" && G1(
            u,
            n,
            f
          )), Sa(
            e,
            n,
            u
          );
          break;
        case 21:
          Sa(
            e,
            n,
            u
          );
          break;
        case 22:
          yr = (f = yr) || u.memoizedState !== null, Sa(
            e,
            n,
            u
          ), yr = f;
          break;
        default:
          Sa(
            e,
            n,
            u
          );
      }
    }
    function J0(e, n) {
      if (n.memoizedState === null && (e = n.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null))))
        try {
          at(
            n,
            $4,
            e
          );
        } catch (u) {
          mn(n, n.return, u);
        }
    }
    function W0(e) {
      switch (e.tag) {
        case 13:
        case 19:
          var n = e.stateNode;
          return n === null && (n = e.stateNode = new f8()), n;
        case 22:
          return e = e.stateNode, n = e._retryCache, n === null && (n = e._retryCache = new f8()), n;
        default:
          throw Error(
            "Unexpected Suspense handler tag (" + e.tag + "). This is a bug in React."
          );
      }
    }
    function dc(e, n) {
      var u = W0(e);
      n.forEach(function(f) {
        var p = q4.bind(null, e, f);
        if (!u.has(f)) {
          if (u.add(f), gl)
            if (sm !== null && cm !== null)
              es(cm, sm);
            else
              throw Error(
                "Expected finished root and lanes to be set. This is a bug in React."
              );
          f.then(p, p);
        }
      });
    }
    function xa(e, n) {
      var u = n.deletions;
      if (u !== null)
        for (var f = 0; f < u.length; f++) {
          var p = e, v = n, k = u[f], M = v;
          e: for (; M !== null; ) {
            switch (M.tag) {
              case 27:
                if (pr(M.type)) {
                  Mr = M.stateNode, vl = !1;
                  break e;
                }
                break;
              case 5:
                Mr = M.stateNode, vl = !1;
                break e;
              case 3:
              case 4:
                Mr = M.stateNode.containerInfo, vl = !0;
                break e;
            }
            M = M.return;
          }
          if (Mr === null)
            throw Error(
              "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
            );
          hc(p, v, k), Mr = null, vl = !1, p = k, v = p.alternate, v !== null && (v.return = null), p.return = null;
        }
      if (n.subtreeFlags & 13878)
        for (n = n.child; n !== null; )
          I1(n, e), n = n.sibling;
    }
    function I1(e, n) {
      var u = e.alternate, f = e.flags;
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          xa(n, e), Tr(e), f & 4 && (Fo(
            Fa | zi,
            e,
            e.return
          ), sc(Fa | zi, e), Z0(
            e,
            e.return,
            oa | zi
          ));
          break;
        case 1:
          xa(n, e), Tr(e), f & 512 && (yr || u === null || Ul(u, u.return)), f & 64 && ms && (e = e.updateQueue, e !== null && (f = e.callbacks, f !== null && (u = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = u === null ? f : u.concat(f))));
          break;
        case 26:
          var p = wu;
          if (xa(n, e), Tr(e), f & 512 && (yr || u === null || Ul(u, u.return)), f & 4)
            if (n = u !== null ? u.memoizedState : null, f = e.memoizedState, u === null)
              if (f === null)
                if (e.stateNode === null) {
                  e: {
                    f = e.type, u = e.memoizedProps, n = p.ownerDocument || p;
                    t: switch (f) {
                      case "title":
                        p = n.getElementsByTagName("title")[0], (!p || p[bf] || p[Wr] || p.namespaceURI === vu || p.hasAttribute("itemprop")) && (p = n.createElement(f), n.head.insertBefore(
                          p,
                          n.querySelector("head > title")
                        )), Ar(p, f, u), p[Wr] = e, ue(p), f = p;
                        break e;
                      case "link":
                        var v = Tp(
                          "link",
                          "href",
                          n
                        ).get(f + (u.href || ""));
                        if (v) {
                          for (var k = 0; k < v.length; k++)
                            if (p = v[k], p.getAttribute("href") === (u.href == null || u.href === "" ? null : u.href) && p.getAttribute("rel") === (u.rel == null ? null : u.rel) && p.getAttribute("title") === (u.title == null ? null : u.title) && p.getAttribute("crossorigin") === (u.crossOrigin == null ? null : u.crossOrigin)) {
                              v.splice(k, 1);
                              break t;
                            }
                        }
                        p = n.createElement(f), Ar(p, f, u), n.head.appendChild(p);
                        break;
                      case "meta":
                        if (v = Tp(
                          "meta",
                          "content",
                          n
                        ).get(f + (u.content || ""))) {
                          for (k = 0; k < v.length; k++)
                            if (p = v[k], N(
                              u.content,
                              "content"
                            ), p.getAttribute("content") === (u.content == null ? null : "" + u.content) && p.getAttribute("name") === (u.name == null ? null : u.name) && p.getAttribute("property") === (u.property == null ? null : u.property) && p.getAttribute("http-equiv") === (u.httpEquiv == null ? null : u.httpEquiv) && p.getAttribute("charset") === (u.charSet == null ? null : u.charSet)) {
                              v.splice(k, 1);
                              break t;
                            }
                        }
                        p = n.createElement(f), Ar(p, f, u), n.head.appendChild(p);
                        break;
                      default:
                        throw Error(
                          'getNodesForType encountered a type it did not expect: "' + f + '". This is a bug in React.'
                        );
                    }
                    p[Wr] = e, ue(p), f = p;
                  }
                  e.stateNode = f;
                } else
                  as(
                    p,
                    e.type,
                    e.stateNode
                  );
              else
                e.stateNode = Z4(
                  p,
                  f,
                  e.memoizedProps
                );
            else
              n !== f ? (n === null ? u.stateNode !== null && (u = u.stateNode, u.parentNode.removeChild(u)) : n.count--, f === null ? as(
                p,
                e.type,
                e.stateNode
              ) : Z4(
                p,
                f,
                e.memoizedProps
              )) : f === null && e.stateNode !== null && Jh(
                e,
                e.memoizedProps,
                u.memoizedProps
              );
          break;
        case 27:
          xa(n, e), Tr(e), f & 512 && (yr || u === null || Ul(u, u.return)), u !== null && f & 4 && Jh(
            e,
            e.memoizedProps,
            u.memoizedProps
          );
          break;
        case 5:
          if (xa(n, e), Tr(e), f & 512 && (yr || u === null || Ul(u, u.return)), e.flags & 32) {
            n = e.stateNode;
            try {
              at(e, Ju, n);
            } catch (xe) {
              mn(e, e.return, xe);
            }
          }
          f & 4 && e.stateNode != null && (n = e.memoizedProps, Jh(
            e,
            n,
            u !== null ? u.memoizedProps : n
          )), f & 1024 && (W3 = !0, e.type !== "form" && console.error(
            "Unexpected host component type. Expected a form. This is a bug in React."
          ));
          break;
        case 6:
          if (xa(n, e), Tr(e), f & 4) {
            if (e.stateNode === null)
              throw Error(
                "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue."
              );
            f = e.memoizedProps, u = u !== null ? u.memoizedProps : f, n = e.stateNode;
            try {
              at(
                e,
                yp,
                n,
                u,
                f
              );
            } catch (xe) {
              mn(e, e.return, xe);
            }
          }
          break;
        case 3:
          if (p = Ha(), $y = null, v = wu, wu = pd(n.containerInfo), xa(n, e), wu = v, Tr(e), f & 4 && u !== null && u.memoizedState.isDehydrated)
            try {
              at(
                e,
                Ia,
                n.containerInfo
              );
            } catch (xe) {
              mn(e, e.return, xe);
            }
          W3 && (W3 = !1, $1(e)), n.effectDuration += Ys(p);
          break;
        case 4:
          f = wu, wu = pd(
            e.stateNode.containerInfo
          ), xa(n, e), Tr(e), wu = f;
          break;
        case 12:
          f = Ha(), xa(n, e), Tr(e), e.stateNode.effectDuration += Is(f);
          break;
        case 13:
          xa(n, e), Tr(e), e.child.flags & 8192 && e.memoizedState !== null != (u !== null && u.memoizedState !== null) && (l6 = qr()), f & 4 && (f = e.updateQueue, f !== null && (e.updateQueue = null, dc(e, f)));
          break;
        case 22:
          p = e.memoizedState !== null;
          var M = u !== null && u.memoizedState !== null, q = ms, j = yr;
          if (ms = q || p, yr = j || M, xa(n, e), yr = j, ms = q, Tr(e), f & 8192)
            e: for (n = e.stateNode, n._visibility = p ? n._visibility & -2 : n._visibility | O3, p && (u === null || M || ms || yr || wa(e)), u = null, n = e; ; ) {
              if (n.tag === 5 || n.tag === 26) {
                if (u === null) {
                  M = u = n;
                  try {
                    v = M.stateNode, p ? at(M, vp, v) : at(
                      M,
                      fd,
                      M.stateNode,
                      M.memoizedProps
                    );
                  } catch (xe) {
                    mn(M, M.return, xe);
                  }
                }
              } else if (n.tag === 6) {
                if (u === null) {
                  M = n;
                  try {
                    k = M.stateNode, p ? at(M, bp, k) : at(
                      M,
                      hd,
                      k,
                      M.memoizedProps
                    );
                  } catch (xe) {
                    mn(M, M.return, xe);
                  }
                }
              } else if ((n.tag !== 22 && n.tag !== 23 || n.memoizedState === null || n === e) && n.child !== null) {
                n.child.return = n, n = n.child;
                continue;
              }
              if (n === e) break e;
              for (; n.sibling === null; ) {
                if (n.return === null || n.return === e)
                  break e;
                u === n && (u = null), n = n.return;
              }
              u === n && (u = null), n.sibling.return = n.return, n = n.sibling;
            }
          f & 4 && (f = e.updateQueue, f !== null && (u = f.retryQueue, u !== null && (f.retryQueue = null, dc(e, u))));
          break;
        case 19:
          xa(n, e), Tr(e), f & 4 && (f = e.updateQueue, f !== null && (e.updateQueue = null, dc(e, f)));
          break;
        case 30:
          break;
        case 21:
          break;
        default:
          xa(n, e), Tr(e);
      }
    }
    function Tr(e) {
      var n = e.flags;
      if (n & 2) {
        try {
          at(e, _4, e);
        } catch (u) {
          mn(e, e.return, u);
        }
        e.flags &= -3;
      }
      n & 4096 && (e.flags &= -4097);
    }
    function $1(e) {
      if (e.subtreeFlags & 1024)
        for (e = e.child; e !== null; ) {
          var n = e;
          $1(n), n.tag === 5 && n.flags & 1024 && n.stateNode.reset(), e = e.sibling;
        }
    }
    function ar(e, n) {
      if (n.subtreeFlags & 8772)
        for (n = n.child; n !== null; )
          Y1(e, n.alternate, n), n = n.sibling;
    }
    function ql(e) {
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Z0(
            e,
            e.return,
            oa
          ), wa(e);
          break;
        case 1:
          Ul(e, e.return);
          var n = e.stateNode;
          typeof n.componentWillUnmount == "function" && G1(
            e,
            e.return,
            n
          ), wa(e);
          break;
        case 27:
          at(
            e,
            Ac,
            e.stateNode
          );
        case 26:
        case 5:
          Ul(e, e.return), wa(e);
          break;
        case 22:
          e.memoizedState === null && wa(e);
          break;
        case 30:
          wa(e);
          break;
        default:
          wa(e);
      }
    }
    function wa(e) {
      for (e = e.child; e !== null; )
        ql(e), e = e.sibling;
    }
    function X1(e, n, u, f) {
      var p = u.flags;
      switch (u.tag) {
        case 0:
        case 11:
        case 15:
          Kr(
            e,
            u,
            f
          ), U1(u, oa);
          break;
        case 1:
          if (Kr(
            e,
            u,
            f
          ), n = u.stateNode, typeof n.componentDidMount == "function" && at(
            u,
            X3,
            u,
            n
          ), n = u.updateQueue, n !== null) {
            e = u.stateNode;
            try {
              at(
                u,
                d3,
                n,
                e
              );
            } catch (v) {
              mn(u, u.return, v);
            }
          }
          f && p & 64 && q1(u), Po(u, u.return);
          break;
        case 27:
          K0(u);
        case 26:
        case 5:
          Kr(
            e,
            u,
            f
          ), f && n === null && p & 4 && M4(u), Po(u, u.return);
          break;
        case 12:
          if (f && p & 4) {
            p = Ha(), Kr(
              e,
              u,
              f
            ), f = u.stateNode, f.effectDuration += Is(p);
            try {
              at(
                u,
                V1,
                u,
                n,
                by,
                f.effectDuration
              );
            } catch (v) {
              mn(u, u.return, v);
            }
          } else
            Kr(
              e,
              u,
              f
            );
          break;
        case 13:
          Kr(
            e,
            u,
            f
          ), f && p & 4 && J0(e, u);
          break;
        case 22:
          u.memoizedState === null && Kr(
            e,
            u,
            f
          ), Po(u, u.return);
          break;
        case 30:
          break;
        default:
          Kr(
            e,
            u,
            f
          );
      }
    }
    function Kr(e, n, u) {
      for (u = u && (n.subtreeFlags & 8772) !== 0, n = n.child; n !== null; )
        X1(
          e,
          n.alternate,
          n,
          u
        ), n = n.sibling;
    }
    function jl(e, n) {
      var u = null;
      e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (u = e.memoizedState.cachePool.pool), e = null, n.memoizedState !== null && n.memoizedState.cachePool !== null && (e = n.memoizedState.cachePool.pool), e !== u && (e != null && ul(e), u != null && qo(u));
    }
    function Pn(e, n) {
      e = null, n.alternate !== null && (e = n.alternate.memoizedState.cache), n = n.memoizedState.cache, n !== e && (ul(n), e != null && qo(e));
    }
    function ja(e, n, u, f) {
      if (n.subtreeFlags & 10256)
        for (n = n.child; n !== null; )
          Wh(
            e,
            n,
            u,
            f
          ), n = n.sibling;
    }
    function Wh(e, n, u, f) {
      var p = n.flags;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          ja(
            e,
            n,
            u,
            f
          ), p & 2048 && Ph(n, Yr | zi);
          break;
        case 1:
          ja(
            e,
            n,
            u,
            f
          );
          break;
        case 3:
          var v = Ha();
          ja(
            e,
            n,
            u,
            f
          ), p & 2048 && (u = null, n.alternate !== null && (u = n.alternate.memoizedState.cache), n = n.memoizedState.cache, n !== u && (ul(n), u != null && qo(u))), e.passiveEffectDuration += Ys(v);
          break;
        case 12:
          if (p & 2048) {
            p = Ha(), ja(
              e,
              n,
              u,
              f
            ), e = n.stateNode, e.passiveEffectDuration += Is(p);
            try {
              at(
                n,
                p3,
                n,
                n.alternate,
                by,
                e.passiveEffectDuration
              );
            } catch (M) {
              mn(n, n.return, M);
            }
          } else
            ja(
              e,
              n,
              u,
              f
            );
          break;
        case 13:
          ja(
            e,
            n,
            u,
            f
          );
          break;
        case 23:
          break;
        case 22:
          v = n.stateNode;
          var k = n.alternate;
          n.memoizedState !== null ? v._visibility & zf ? ja(
            e,
            n,
            u,
            f
          ) : mc(
            e,
            n
          ) : v._visibility & zf ? ja(
            e,
            n,
            u,
            f
          ) : (v._visibility |= zf, Iu(
            e,
            n,
            u,
            f,
            (n.subtreeFlags & 10256) !== 0
          )), p & 2048 && jl(k, n);
          break;
        case 24:
          ja(
            e,
            n,
            u,
            f
          ), p & 2048 && Pn(n.alternate, n);
          break;
        default:
          ja(
            e,
            n,
            u,
            f
          );
      }
    }
    function Iu(e, n, u, f, p) {
      for (p = p && (n.subtreeFlags & 10256) !== 0, n = n.child; n !== null; )
        Q1(
          e,
          n,
          u,
          f,
          p
        ), n = n.sibling;
    }
    function Q1(e, n, u, f, p) {
      var v = n.flags;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          Iu(
            e,
            n,
            u,
            f,
            p
          ), Ph(n, Yr);
          break;
        case 23:
          break;
        case 22:
          var k = n.stateNode;
          n.memoizedState !== null ? k._visibility & zf ? Iu(
            e,
            n,
            u,
            f,
            p
          ) : mc(
            e,
            n
          ) : (k._visibility |= zf, Iu(
            e,
            n,
            u,
            f,
            p
          )), p && v & 2048 && jl(
            n.alternate,
            n
          );
          break;
        case 24:
          Iu(
            e,
            n,
            u,
            f,
            p
          ), p && v & 2048 && Pn(n.alternate, n);
          break;
        default:
          Iu(
            e,
            n,
            u,
            f,
            p
          );
      }
    }
    function mc(e, n) {
      if (n.subtreeFlags & 10256)
        for (n = n.child; n !== null; ) {
          var u = e, f = n, p = f.flags;
          switch (f.tag) {
            case 22:
              mc(
                u,
                f
              ), p & 2048 && jl(
                f.alternate,
                f
              );
              break;
            case 24:
              mc(
                u,
                f
              ), p & 2048 && Pn(
                f.alternate,
                f
              );
              break;
            default:
              mc(
                u,
                f
              );
          }
          n = n.sibling;
        }
    }
    function hl(e) {
      if (e.subtreeFlags & dg)
        for (e = e.child; e !== null; )
          ef(e), e = e.sibling;
    }
    function ef(e) {
      switch (e.tag) {
        case 26:
          hl(e), e.flags & dg && e.memoizedState !== null && P4(
            wu,
            e.memoizedState,
            e.memoizedProps
          );
          break;
        case 5:
          hl(e);
          break;
        case 3:
        case 4:
          var n = wu;
          wu = pd(
            e.stateNode.containerInfo
          ), hl(e), wu = n;
          break;
        case 22:
          e.memoizedState === null && (n = e.alternate, n !== null && n.memoizedState !== null ? (n = dg, dg = 16777216, hl(e), dg = n) : hl(e));
          break;
        default:
          hl(e);
      }
    }
    function Z1(e) {
      var n = e.alternate;
      if (n !== null && (e = n.child, e !== null)) {
        n.child = null;
        do
          n = e.sibling, e.sibling = null, e = n;
        while (e !== null);
      }
    }
    function pc(e) {
      var n = e.deletions;
      if (e.flags & 16) {
        if (n !== null)
          for (var u = 0; u < n.length; u++) {
            var f = n[u];
            ta = f, ed(
              f,
              e
            );
          }
        Z1(e);
      }
      if (e.subtreeFlags & 10256)
        for (e = e.child; e !== null; )
          F1(e), e = e.sibling;
    }
    function F1(e) {
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          pc(e), e.flags & 2048 && Kh(
            e,
            e.return,
            Yr | zi
          );
          break;
        case 3:
          var n = Ha();
          pc(e), e.stateNode.passiveEffectDuration += Ys(n);
          break;
        case 12:
          n = Ha(), pc(e), e.stateNode.passiveEffectDuration += Is(n);
          break;
        case 22:
          n = e.stateNode, e.memoizedState !== null && n._visibility & zf && (e.return === null || e.return.tag !== 13) ? (n._visibility &= -3, Ko(e)) : pc(e);
          break;
        default:
          pc(e);
      }
    }
    function Ko(e) {
      var n = e.deletions;
      if (e.flags & 16) {
        if (n !== null)
          for (var u = 0; u < n.length; u++) {
            var f = n[u];
            ta = f, ed(
              f,
              e
            );
          }
        Z1(e);
      }
      for (e = e.child; e !== null; )
        P1(e), e = e.sibling;
    }
    function P1(e) {
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          Kh(
            e,
            e.return,
            Yr
          ), Ko(e);
          break;
        case 22:
          var n = e.stateNode;
          n._visibility & zf && (n._visibility &= -3, Ko(e));
          break;
        default:
          Ko(e);
      }
    }
    function ed(e, n) {
      for (; ta !== null; ) {
        var u = ta, f = u;
        switch (f.tag) {
          case 0:
          case 11:
          case 15:
            Kh(
              f,
              n,
              Yr
            );
            break;
          case 23:
          case 22:
            f.memoizedState !== null && f.memoizedState.cachePool !== null && (f = f.memoizedState.cachePool.pool, f != null && ul(f));
            break;
          case 24:
            qo(f.memoizedState.cache);
        }
        if (f = u.child, f !== null) f.return = u, ta = f;
        else
          e: for (u = e; ta !== null; ) {
            f = ta;
            var p = f.sibling, v = f.return;
            if (D4(f), f === u) {
              ta = null;
              break e;
            }
            if (p !== null) {
              p.return = v, ta = p;
              break e;
            }
            ta = v;
          }
      }
    }
    function N4() {
      aE.forEach(function(e) {
        return e();
      });
    }
    function K1() {
      var e = typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0;
      return e || ye.actQueue === null || console.error(
        "The current testing environment is not configured to support act(...)"
      ), e;
    }
    function Ga(e) {
      if ((fn & Pa) !== Pl && Zt !== 0)
        return Zt & -Zt;
      var n = ye.T;
      return n !== null ? (n._updatedFibers || (n._updatedFibers = /* @__PURE__ */ new Set()), n._updatedFibers.add(e), e = Of, e !== 0 ? e : sd()) : La();
    }
    function J1() {
      Jl === 0 && (Jl = !(Zt & 536870912) || rn ? xt() : 536870912);
      var e = Mi.current;
      return e !== null && (e.flags |= 32), Jl;
    }
    function Vt(e, n, u) {
      if (pm && console.error("useInsertionEffect must not schedule updates."), c6 && (Dy = !0), (e === zn && (vn === Hf || vn === Uf) || e.cancelPendingCommit !== null) && (ru(e, 0), nu(
        e,
        Zt,
        Jl,
        !1
      )), cr(e, u), fn & Pa && e === zn) {
        if (vi)
          switch (n.tag) {
            case 0:
            case 11:
            case 15:
              e = $t && ee($t) || "Unknown", x8.has(e) || (x8.add(e), n = ee(n) || "Unknown", console.error(
                "Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render",
                n,
                e,
                e
              ));
              break;
            case 1:
              S8 || (console.error(
                "Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."
              ), S8 = !0);
          }
      } else
        gl && st(e, n, u), sp(n), e === zn && ((fn & Pa) === Pl && ($c |= u), ur === Bf && nu(
          e,
          Zt,
          Jl,
          !1
        )), dl(e);
    }
    function Er(e, n, u) {
      if ((fn & (Pa | Tu)) !== Pl)
        throw Error("Should not already be working.");
      var f = !u && (n & 124) === 0 && (n & e.expiredLanes) === 0 || sr(e, n), p = f ? np(e, n) : tf(e, n, !0), v = f;
      do {
        if (p === ps) {
          dm && !f && nu(e, n, 0, !1);
          break;
        } else {
          if (u = e.current.alternate, v && !L4(u)) {
            p = tf(e, n, !1), v = !1;
            continue;
          }
          if (p === fm) {
            if (v = n, e.errorRecoveryDisabledLanes & v)
              var k = 0;
            else
              k = e.pendingLanes & -536870913, k = k !== 0 ? k : k & 536870912 ? 536870912 : 0;
            if (k !== 0) {
              n = k;
              e: {
                p = e;
                var M = k;
                k = bg;
                var q = p.current.memoizedState.isDehydrated;
                if (q && (ru(
                  p,
                  M
                ).flags |= 256), M = tf(
                  p,
                  M,
                  !1
                ), M !== fm) {
                  if (r6 && !q) {
                    p.errorRecoveryDisabledLanes |= v, $c |= v, p = Bf;
                    break e;
                  }
                  p = Ka, Ka = k, p !== null && (Ka === null ? Ka = p : Ka.push.apply(
                    Ka,
                    p
                  ));
                }
                p = M;
              }
              if (v = !1, p !== fm) continue;
            }
          }
          if (p === pg) {
            ru(e, 0), nu(e, n, 0, !0);
            break;
          }
          e: {
            switch (f = e, p) {
              case ps:
              case pg:
                throw Error("Root did not complete. This is a bug in React.");
              case Bf:
                if ((n & 4194048) !== n) break;
              case My:
                nu(
                  f,
                  n,
                  Jl,
                  !Yc
                );
                break e;
              case fm:
                Ka = null;
                break;
              case e6:
              case h8:
                break;
              default:
                throw Error("Unknown root exit status.");
            }
            if (ye.actQueue !== null)
              Gl(
                f,
                u,
                n,
                Ka,
                Sg,
                _y,
                Jl,
                $c,
                qf
              );
            else {
              if ((n & 62914560) === n && (v = l6 + m8 - qr(), 10 < v)) {
                if (nu(
                  f,
                  n,
                  Jl,
                  !Yc
                ), er(f, 0, !0) !== 0) break e;
                f.timeoutHandle = C8(
                  W1.bind(
                    null,
                    f,
                    u,
                    Ka,
                    Sg,
                    _y,
                    n,
                    Jl,
                    $c,
                    qf,
                    Yc,
                    p,
                    oE,
                    gb,
                    0
                  ),
                  v
                );
                break e;
              }
              W1(
                f,
                u,
                Ka,
                Sg,
                _y,
                n,
                Jl,
                $c,
                qf,
                Yc,
                p,
                iE,
                gb,
                0
              );
            }
          }
        }
        break;
      } while (!0);
      dl(e);
    }
    function W1(e, n, u, f, p, v, k, M, q, j, xe, Ae, pe, Re) {
      if (e.timeoutHandle = If, Ae = n.subtreeFlags, (Ae & 8192 || (Ae & 16785408) === 16785408) && (kg = { stylesheets: null, count: 0, unsuspend: F4 }, ef(n), Ae = K4(), Ae !== null)) {
        e.cancelPendingCommit = Ae(
          Gl.bind(
            null,
            e,
            n,
            v,
            u,
            f,
            p,
            k,
            M,
            q,
            xe,
            uE,
            pe,
            Re
          )
        ), nu(
          e,
          v,
          k,
          !j
        );
        return;
      }
      Gl(
        e,
        n,
        v,
        u,
        f,
        p,
        k,
        M,
        q
      );
    }
    function L4(e) {
      for (var n = e; ; ) {
        var u = n.tag;
        if ((u === 0 || u === 11 || u === 15) && n.flags & 16384 && (u = n.updateQueue, u !== null && (u = u.stores, u !== null)))
          for (var f = 0; f < u.length; f++) {
            var p = u[f], v = p.getSnapshot;
            p = p.value;
            try {
              if (!Qa(v(), p)) return !1;
            } catch {
              return !1;
            }
          }
        if (u = n.child, n.subtreeFlags & 16384 && u !== null)
          u.return = n, n = u;
        else {
          if (n === e) break;
          for (; n.sibling === null; ) {
            if (n.return === null || n.return === e) return !0;
            n = n.return;
          }
          n.sibling.return = n.return, n = n.sibling;
        }
      }
      return !0;
    }
    function nu(e, n, u, f) {
      n &= ~a6, n &= ~$c, e.suspendedLanes |= n, e.pingedLanes &= ~n, f && (e.warmLanes |= n), f = e.expirationTimes;
      for (var p = n; 0 < p; ) {
        var v = 31 - kr(p), k = 1 << v;
        f[v] = -1, p &= ~k;
      }
      u !== 0 && ke(e, u, n);
    }
    function Jo() {
      return (fn & (Pa | Tu)) === Pl ? (Qu(0), !1) : !0;
    }
    function td() {
      if ($t !== null) {
        if (vn === bl)
          var e = $t.return;
        else
          e = $t, Th(), Dl(e), am = null, fg = 0, e = $t;
        for (; e !== null; )
          H1(e.alternate, e), e = e.return;
        $t = null;
      }
    }
    function ru(e, n) {
      var u = e.timeoutHandle;
      u !== If && (e.timeoutHandle = If, xE(u)), u = e.cancelPendingCommit, u !== null && (e.cancelPendingCommit = null, u()), td(), zn = e, $t = u = ui(e.current, null), Zt = n, vn = bl, Kl = null, Yc = !1, dm = sr(e, n), r6 = !1, ur = ps, qf = Jl = a6 = $c = Ic = 0, Ka = bg = null, _y = !1, n & 8 && (n |= n & 32);
      var f = e.entangledLanes;
      if (f !== 0)
        for (e = e.entanglements, f &= n; 0 < f; ) {
          var p = 31 - kr(f), v = 1 << p;
          n |= e[p], f &= ~v;
        }
      return mo = n, ph(), n = mb(), 1e3 < n - db && (ye.recentlyCreatedOwnerStacks = 0, db = n), Su.discardPendingWarnings(), u;
    }
    function nd(e, n) {
      At = null, ye.H = zy, ye.getCurrentStack = null, vi = !1, Gr = null, n === ug || n === Ty ? (n = Ua(), vn = yg) : n === bb ? (n = Ua(), vn = d8) : vn = n === r8 ? n6 : n !== null && typeof n == "object" && typeof n.then == "function" ? hm : gg, Kl = n;
      var u = $t;
      if (u === null)
        ur = pg, oc(
          e,
          fa(n, e.current)
        );
      else
        switch (u.mode & ua && Nu(u), St(), vn) {
          case gg:
            Pe !== null && typeof Pe.markComponentErrored == "function" && Pe.markComponentErrored(
              u,
              n,
              Zt
            );
            break;
          case Hf:
          case Uf:
          case yg:
          case hm:
          case vg:
            Pe !== null && typeof Pe.markComponentSuspended == "function" && Pe.markComponentSuspended(
              u,
              n,
              Zt
            );
        }
    }
    function ep() {
      var e = ye.H;
      return ye.H = zy, e === null ? zy : e;
    }
    function tp() {
      var e = ye.A;
      return ye.A = rE, e;
    }
    function rd() {
      ur = Bf, Yc || (Zt & 4194048) !== Zt && Mi.current !== null || (dm = !0), !(Ic & 134217727) && !($c & 134217727) || zn === null || nu(
        zn,
        Zt,
        Jl,
        !1
      );
    }
    function tf(e, n, u) {
      var f = fn;
      fn |= Pa;
      var p = ep(), v = tp();
      if (zn !== e || Zt !== n) {
        if (gl) {
          var k = e.memoizedUpdaters;
          0 < k.size && (es(e, Zt), k.clear()), Qt(e, n);
        }
        Sg = null, ru(e, n);
      }
      wn(n), n = !1, k = ur;
      e: do
        try {
          if (vn !== bl && $t !== null) {
            var M = $t, q = Kl;
            switch (vn) {
              case n6:
                td(), k = My;
                break e;
              case yg:
              case Hf:
              case Uf:
              case hm:
                Mi.current === null && (n = !0);
                var j = vn;
                if (vn = bl, Kl = null, Wo(e, M, q, j), u && dm) {
                  k = ps;
                  break e;
                }
                break;
              default:
                j = vn, vn = bl, Kl = null, Wo(e, M, q, j);
            }
          }
          ad(), k = ur;
          break;
        } catch (xe) {
          nd(e, xe);
        }
      while (!0);
      return n && e.shellSuspendCounter++, Th(), fn = f, ye.H = p, ye.A = v, Dr(), $t === null && (zn = null, Zt = 0, ph()), k;
    }
    function ad() {
      for (; $t !== null; ) ld($t);
    }
    function np(e, n) {
      var u = fn;
      fn |= Pa;
      var f = ep(), p = tp();
      if (zn !== e || Zt !== n) {
        if (gl) {
          var v = e.memoizedUpdaters;
          0 < v.size && (es(e, Zt), v.clear()), Qt(e, n);
        }
        Sg = null, Oy = qr() + p8, ru(e, n);
      } else
        dm = sr(
          e,
          n
        );
      wn(n);
      e: do
        try {
          if (vn !== bl && $t !== null)
            t: switch (n = $t, v = Kl, vn) {
              case gg:
                vn = bl, Kl = null, Wo(
                  e,
                  n,
                  v,
                  gg
                );
                break;
              case Hf:
              case Uf:
                if (Rh(v)) {
                  vn = bl, Kl = null, nf(n);
                  break;
                }
                n = function() {
                  vn !== Hf && vn !== Uf || zn !== e || (vn = vg), dl(e);
                }, v.then(n, n);
                break e;
              case yg:
                vn = vg;
                break e;
              case d8:
                vn = t6;
                break e;
              case vg:
                Rh(v) ? (vn = bl, Kl = null, nf(n)) : (vn = bl, Kl = null, Wo(
                  e,
                  n,
                  v,
                  vg
                ));
                break;
              case t6:
                var k = null;
                switch ($t.tag) {
                  case 26:
                    k = $t.memoizedState;
                  case 5:
                  case 27:
                    var M = $t;
                    if (!k || Ep(k)) {
                      vn = bl, Kl = null;
                      var q = M.sibling;
                      if (q !== null) $t = q;
                      else {
                        var j = M.return;
                        j !== null ? ($t = j, gc(j)) : $t = null;
                      }
                      break t;
                    }
                    break;
                  default:
                    console.error(
                      "Unexpected type of fiber triggered a suspensey commit. This is a bug in React."
                    );
                }
                vn = bl, Kl = null, Wo(
                  e,
                  n,
                  v,
                  t6
                );
                break;
              case hm:
                vn = bl, Kl = null, Wo(
                  e,
                  n,
                  v,
                  hm
                );
                break;
              case n6:
                td(), ur = My;
                break e;
              default:
                throw Error(
                  "Unexpected SuspendedReason. This is a bug in React."
                );
            }
          ye.actQueue !== null ? ad() : B4();
          break;
        } catch (xe) {
          nd(e, xe);
        }
      while (!0);
      return Th(), ye.H = f, ye.A = p, fn = u, $t !== null ? (Pe !== null && typeof Pe.markRenderYielded == "function" && Pe.markRenderYielded(), ps) : (Dr(), zn = null, Zt = 0, ph(), ur);
    }
    function B4() {
      for (; $t !== null && !x3(); )
        ld($t);
    }
    function ld(e) {
      var n = e.alternate;
      (e.mode & ua) !== Dn ? (Xi(e), n = at(
        e,
        Yu,
        n,
        e,
        mo
      ), Nu(e)) : n = at(
        e,
        Yu,
        n,
        e,
        mo
      ), e.memoizedProps = e.pendingProps, n === null ? gc(e) : $t = n;
    }
    function nf(e) {
      var n = at(e, rp, e);
      e.memoizedProps = e.pendingProps, n === null ? gc(e) : $t = n;
    }
    function rp(e) {
      var n = e.alternate, u = (e.mode & ua) !== Dn;
      switch (u && Xi(e), e.tag) {
        case 15:
        case 0:
          n = R1(
            n,
            e,
            e.pendingProps,
            e.type,
            void 0,
            Zt
          );
          break;
        case 11:
          n = R1(
            n,
            e,
            e.pendingProps,
            e.type.render,
            e.ref,
            Zt
          );
          break;
        case 5:
          Dl(e);
        default:
          H1(n, e), e = $t = n1(e, mo), n = Yu(n, e, mo);
      }
      return u && Nu(e), n;
    }
    function Wo(e, n, u, f) {
      Th(), Dl(n), am = null, fg = 0;
      var p = n.return;
      try {
        if (Yh(
          e,
          p,
          n,
          u,
          Zt
        )) {
          ur = pg, oc(
            e,
            fa(u, e.current)
          ), $t = null;
          return;
        }
      } catch (v) {
        if (p !== null) throw $t = p, v;
        ur = pg, oc(
          e,
          fa(u, e.current)
        ), $t = null;
        return;
      }
      n.flags & 32768 ? (rn || f === gg ? e = !0 : dm || Zt & 536870912 ? e = !1 : (Yc = e = !0, (f === Hf || f === Uf || f === yg || f === hm) && (f = Mi.current, f !== null && f.tag === 13 && (f.flags |= 16384))), ap(n, e)) : gc(n);
    }
    function gc(e) {
      var n = e;
      do {
        if (n.flags & 32768) {
          ap(
            n,
            Yc
          );
          return;
        }
        var u = n.alternate;
        if (e = n.return, Xi(n), u = at(
          n,
          R4,
          u,
          n,
          mo
        ), (n.mode & ua) !== Dn && Ah(n), u !== null) {
          $t = u;
          return;
        }
        if (n = n.sibling, n !== null) {
          $t = n;
          return;
        }
        $t = n = e;
      } while (n !== null);
      ur === ps && (ur = h8);
    }
    function ap(e, n) {
      do {
        var u = z4(e.alternate, e);
        if (u !== null) {
          u.flags &= 32767, $t = u;
          return;
        }
        if ((e.mode & ua) !== Dn) {
          Ah(e), u = e.actualDuration;
          for (var f = e.child; f !== null; )
            u += f.actualDuration, f = f.sibling;
          e.actualDuration = u;
        }
        if (u = e.return, u !== null && (u.flags |= 32768, u.subtreeFlags = 0, u.deletions = null), !n && (e = e.sibling, e !== null)) {
          $t = e;
          return;
        }
        $t = e = u;
      } while (e !== null);
      ur = My, $t = null;
    }
    function Gl(e, n, u, f, p, v, k, M, q) {
      e.cancelPendingCommit = null;
      do
        $u();
      while (sa !== jf);
      if (Su.flushLegacyContextWarning(), Su.flushPendingUnsafeLifecycleWarnings(), (fn & (Pa | Tu)) !== Pl)
        throw Error("Should not already be working.");
      if (Pe !== null && typeof Pe.markCommitStarted == "function" && Pe.markCommitStarted(u), n === null) ht();
      else {
        if (u === 0 && console.error(
          "finishedLanes should not be empty during a commit. This is a bug in React."
        ), n === e.current)
          throw Error(
            "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue."
          );
        if (v = n.lanes | n.childLanes, v |= D3, rl(
          e,
          u,
          v,
          k,
          M,
          q
        ), e === zn && ($t = zn = null, Zt = 0), mm = n, Qc = e, Zc = u, u6 = v, o6 = p, b8 = f, n.subtreeFlags & 10256 || n.flags & 10256 ? (e.callbackNode = null, e.callbackPriority = 0, j4(Oc, function() {
          return yc(), null;
        })) : (e.callbackNode = null, e.callbackPriority = 0), by = Wd(), f = (n.flags & 13878) !== 0, n.subtreeFlags & 13878 || f) {
          f = ye.T, ye.T = null, p = ln.p, ln.p = Xa, k = fn, fn |= Tu;
          try {
            O4(e, n, u);
          } finally {
            fn = k, ln.p = p, ye.T = f;
          }
        }
        sa = g8, id(), H4(), lp();
      }
    }
    function id() {
      if (sa === g8) {
        sa = jf;
        var e = Qc, n = mm, u = Zc, f = (n.flags & 13878) !== 0;
        if (n.subtreeFlags & 13878 || f) {
          f = ye.T, ye.T = null;
          var p = ln.p;
          ln.p = Xa;
          var v = fn;
          fn |= Tu;
          try {
            sm = u, cm = e, I1(n, e), cm = sm = null, u = b6;
            var k = b4(e.containerInfo), M = u.focusedElem, q = u.selectionRange;
            if (k !== M && M && M.ownerDocument && v4(
              M.ownerDocument.documentElement,
              M
            )) {
              if (q !== null && Wm(M)) {
                var j = q.start, xe = q.end;
                if (xe === void 0 && (xe = j), "selectionStart" in M)
                  M.selectionStart = j, M.selectionEnd = Math.min(
                    xe,
                    M.value.length
                  );
                else {
                  var Ae = M.ownerDocument || document, pe = Ae && Ae.defaultView || window;
                  if (pe.getSelection) {
                    var Re = pe.getSelection(), tt = M.textContent.length, bt = Math.min(
                      q.start,
                      tt
                    ), Cn = q.end === void 0 ? bt : Math.min(q.end, tt);
                    !Re.extend && bt > Cn && (k = Cn, Cn = bt, bt = k);
                    var Kt = y4(
                      M,
                      bt
                    ), F = y4(
                      M,
                      Cn
                    );
                    if (Kt && F && (Re.rangeCount !== 1 || Re.anchorNode !== Kt.node || Re.anchorOffset !== Kt.offset || Re.focusNode !== F.node || Re.focusOffset !== F.offset)) {
                      var K = Ae.createRange();
                      K.setStart(Kt.node, Kt.offset), Re.removeAllRanges(), bt > Cn ? (Re.addRange(K), Re.extend(F.node, F.offset)) : (K.setEnd(F.node, F.offset), Re.addRange(K));
                    }
                  }
                }
              }
              for (Ae = [], Re = M; Re = Re.parentNode; )
                Re.nodeType === 1 && Ae.push({
                  element: Re,
                  left: Re.scrollLeft,
                  top: Re.scrollTop
                });
              for (typeof M.focus == "function" && M.focus(), M = 0; M < Ae.length; M++) {
                var ne = Ae[M];
                ne.element.scrollLeft = ne.left, ne.element.scrollTop = ne.top;
              }
            }
            Zy = !!v6, b6 = v6 = null;
          } finally {
            fn = v, ln.p = p, ye.T = f;
          }
        }
        e.current = n, sa = y8;
      }
    }
    function H4() {
      if (sa === y8) {
        sa = jf;
        var e = Qc, n = mm, u = Zc, f = (n.flags & 8772) !== 0;
        if (n.subtreeFlags & 8772 || f) {
          f = ye.T, ye.T = null;
          var p = ln.p;
          ln.p = Xa;
          var v = fn;
          fn |= Tu;
          try {
            Pe !== null && typeof Pe.markLayoutEffectsStarted == "function" && Pe.markLayoutEffectsStarted(u), sm = u, cm = e, Y1(
              e,
              n.alternate,
              n
            ), cm = sm = null, Pe !== null && typeof Pe.markLayoutEffectsStopped == "function" && Pe.markLayoutEffectsStopped();
          } finally {
            fn = v, ln.p = p, ye.T = f;
          }
        }
        sa = v8;
      }
    }
    function lp() {
      if (sa === sE || sa === v8) {
        sa = jf, w3();
        var e = Qc, n = mm, u = Zc, f = b8, p = (n.subtreeFlags & 10256) !== 0 || (n.flags & 10256) !== 0;
        p ? sa = i6 : (sa = jf, mm = Qc = null, ip(e, e.pendingLanes), Gf = 0, wg = null);
        var v = e.pendingLanes;
        if (v === 0 && (Xc = null), p || Vl(e), p = Zn(u), n = n.stateNode, jr && typeof jr.onCommitFiberRoot == "function")
          try {
            var k = (n.current.flags & 128) === 128;
            switch (p) {
              case Xa:
                var M = yf;
                break;
              case yi:
                M = _p;
                break;
              case gu:
                M = Oc;
                break;
              case Dd:
                M = Dp;
                break;
              default:
                M = Oc;
            }
            jr.onCommitFiberRoot(
              us,
              n,
              M,
              k
            );
          } catch (Ae) {
            Kn || (Kn = !0, console.error(
              "React instrumentation encountered an error: %s",
              Ae
            ));
          }
        if (gl && e.memoizedUpdaters.clear(), N4(), f !== null) {
          k = ye.T, M = ln.p, ln.p = Xa, ye.T = null;
          try {
            var q = e.onRecoverableError;
            for (n = 0; n < f.length; n++) {
              var j = f[n], xe = au(j.stack);
              at(
                j.source,
                q,
                j.value,
                xe
              );
            }
          } finally {
            ye.T = k, ln.p = M;
          }
        }
        Zc & 3 && $u(), dl(e), v = e.pendingLanes, u & 4194090 && v & 42 ? (xy = !0, e === s6 ? xg++ : (xg = 0, s6 = e)) : xg = 0, Qu(0), ht();
      }
    }
    function au(e) {
      return e = { componentStack: e }, Object.defineProperty(e, "digest", {
        get: function() {
          console.error(
            'You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.'
          );
        }
      }), e;
    }
    function ip(e, n) {
      (e.pooledCacheLanes &= n) === 0 && (n = e.pooledCache, n != null && (e.pooledCache = null, qo(n)));
    }
    function $u(e) {
      return id(), H4(), lp(), yc();
    }
    function yc() {
      if (sa !== i6) return !1;
      var e = Qc, n = u6;
      u6 = 0;
      var u = Zn(Zc), f = gu > u ? gu : u;
      u = ye.T;
      var p = ln.p;
      try {
        ln.p = f, ye.T = null, f = o6, o6 = null;
        var v = Qc, k = Zc;
        if (sa = jf, mm = Qc = null, Zc = 0, (fn & (Pa | Tu)) !== Pl)
          throw Error("Cannot flush passive effects while already rendering.");
        c6 = !0, Dy = !1, Pe !== null && typeof Pe.markPassiveEffectsStarted == "function" && Pe.markPassiveEffectsStarted(k);
        var M = fn;
        if (fn |= Tu, F1(v.current), Wh(
          v,
          v.current,
          k,
          f
        ), Pe !== null && typeof Pe.markPassiveEffectsStopped == "function" && Pe.markPassiveEffectsStopped(), Vl(v), fn = M, Qu(0, !1), Dy ? v === wg ? Gf++ : (Gf = 0, wg = v) : Gf = 0, Dy = c6 = !1, jr && typeof jr.onPostCommitFiberRoot == "function")
          try {
            jr.onPostCommitFiberRoot(us, v);
          } catch (j) {
            Kn || (Kn = !0, console.error(
              "React instrumentation encountered an error: %s",
              j
            ));
          }
        var q = v.current.stateNode;
        return q.effectDuration = 0, q.passiveEffectDuration = 0, !0;
      } finally {
        ln.p = p, ye.T = u, ip(e, n);
      }
    }
    function On(e, n, u) {
      n = fa(u, n), n = Yn(e.stateNode, n, 2), e = Ml(e, n, 2), e !== null && (cr(e, 2), dl(e));
    }
    function mn(e, n, u) {
      if (pm = !1, e.tag === 3)
        On(e, e, u);
      else {
        for (; n !== null; ) {
          if (n.tag === 3) {
            On(
              n,
              e,
              u
            );
            return;
          }
          if (n.tag === 1) {
            var f = n.stateNode;
            if (typeof n.type.getDerivedStateFromError == "function" || typeof f.componentDidCatch == "function" && (Xc === null || !Xc.has(f))) {
              e = fa(u, e), u = V0(2), f = Ml(n, u, 2), f !== null && (Qo(
                u,
                f,
                n,
                e
              ), cr(f, 2), dl(f));
              return;
            }
          }
          n = n.return;
        }
        console.error(
          `Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`,
          u
        );
      }
    }
    function up(e, n, u) {
      var f = e.pingCache;
      if (f === null) {
        f = e.pingCache = new lE();
        var p = /* @__PURE__ */ new Set();
        f.set(n, p);
      } else
        p = f.get(n), p === void 0 && (p = /* @__PURE__ */ new Set(), f.set(n, p));
      p.has(u) || (r6 = !0, p.add(u), f = U4.bind(null, e, n, u), gl && es(e, u), n.then(f, f));
    }
    function U4(e, n, u) {
      var f = e.pingCache;
      f !== null && f.delete(n), e.pingedLanes |= e.suspendedLanes & u, e.warmLanes &= ~u, K1() && ye.actQueue === null && console.error(
        `A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`
      ), zn === e && (Zt & u) === u && (ur === Bf || ur === e6 && (Zt & 62914560) === Zt && qr() - l6 < m8 ? (fn & Pa) === Pl && ru(e, 0) : a6 |= u, qf === Zt && (qf = 0)), dl(e);
    }
    function vc(e, n) {
      n === 0 && (n = nl()), e = ha(e, n), e !== null && (cr(e, n), dl(e));
    }
    function Xu(e) {
      var n = e.memoizedState, u = 0;
      n !== null && (u = n.retryLane), vc(e, u);
    }
    function q4(e, n) {
      var u = 0;
      switch (e.tag) {
        case 13:
          var f = e.stateNode, p = e.memoizedState;
          p !== null && (u = p.retryLane);
          break;
        case 19:
          f = e.stateNode;
          break;
        case 22:
          f = e.stateNode._retryCache;
          break;
        default:
          throw Error(
            "Pinged unknown suspense boundary type. This is probably a bug in React."
          );
      }
      f !== null && f.delete(n), vc(e, u);
    }
    function ud(e, n, u) {
      if (n.subtreeFlags & 67117056)
        for (n = n.child; n !== null; ) {
          var f = e, p = n, v = p.type === ls;
          v = u || v, p.tag !== 22 ? p.flags & 67108864 ? v && at(
            p,
            bc,
            f,
            p,
            (p.mode & cb) === Dn
          ) : ud(
            f,
            p,
            v
          ) : p.memoizedState === null && (v && p.flags & 8192 ? at(
            p,
            bc,
            f,
            p
          ) : p.subtreeFlags & 67108864 && at(
            p,
            ud,
            f,
            p,
            v
          )), n = n.sibling;
        }
    }
    function bc(e, n) {
      var u = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : !0;
      Ge(!0);
      try {
        ql(n), u && P1(n), X1(e, n.alternate, n, !1), u && Q1(e, n, 0, null, !1, 0);
      } finally {
        Ge(!1);
      }
    }
    function Vl(e) {
      var n = !0;
      e.current.mode & (Ma | bu) || (n = !1), ud(
        e,
        e.current,
        n
      );
    }
    function op(e) {
      if ((fn & Pa) === Pl) {
        var n = e.tag;
        if (n === 3 || n === 1 || n === 0 || n === 11 || n === 14 || n === 15) {
          if (n = ee(e) || "ReactComponent", Ny !== null) {
            if (Ny.has(n)) return;
            Ny.add(n);
          } else Ny = /* @__PURE__ */ new Set([n]);
          at(e, function() {
            console.error(
              "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead."
            );
          });
        }
      }
    }
    function es(e, n) {
      gl && e.memoizedUpdaters.forEach(function(u) {
        st(e, u, n);
      });
    }
    function j4(e, n) {
      var u = ye.actQueue;
      return u !== null ? (u.push(n), hE) : Mp(e, n);
    }
    function sp(e) {
      K1() && ye.actQueue === null && at(e, function() {
        console.error(
          `An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`,
          ee(e)
        );
      });
    }
    function dl(e) {
      e !== gm && e.next === null && (gm === null ? Ly = gm = e : gm = gm.next = e), By = !0, ye.actQueue !== null ? h6 || (h6 = !0, V4()) : f6 || (f6 = !0, V4());
    }
    function Qu(e, n) {
      if (!d6 && By) {
        d6 = !0;
        do
          for (var u = !1, f = Ly; f !== null; ) {
            if (e !== 0) {
              var p = f.pendingLanes;
              if (p === 0) var v = 0;
              else {
                var k = f.suspendedLanes, M = f.pingedLanes;
                v = (1 << 31 - kr(42 | e) + 1) - 1, v &= p & ~(k & ~M), v = v & 201326741 ? v & 201326741 | 1 : v ? v | 2 : 0;
              }
              v !== 0 && (u = !0, cp(f, v));
            } else
              v = Zt, v = er(
                f,
                f === zn ? v : 0,
                f.cancelPendingCommit !== null || f.timeoutHandle !== If
              ), !(v & 3) || sr(f, v) || (u = !0, cp(f, v));
            f = f.next;
          }
        while (u);
        d6 = !1;
      }
    }
    function G4() {
      Yl();
    }
    function Yl() {
      By = h6 = f6 = !1;
      var e = 0;
      Vf !== 0 && (gp() && (e = Vf), Vf = 0);
      for (var n = qr(), u = null, f = Ly; f !== null; ) {
        var p = f.next, v = In(f, n);
        v === 0 ? (f.next = null, u === null ? Ly = p : u.next = p, p === null && (gm = u)) : (u = f, (e !== 0 || v & 3) && (By = !0)), f = p;
      }
      Qu(e);
    }
    function In(e, n) {
      for (var u = e.suspendedLanes, f = e.pingedLanes, p = e.expirationTimes, v = e.pendingLanes & -62914561; 0 < v; ) {
        var k = 31 - kr(v), M = 1 << k, q = p[k];
        q === -1 ? (!(M & u) || M & f) && (p[k] = El(M, n)) : q <= n && (e.expiredLanes |= M), v &= ~M;
      }
      if (n = zn, u = Zt, u = er(
        e,
        e === n ? u : 0,
        e.cancelPendingCommit !== null || e.timeoutHandle !== If
      ), f = e.callbackNode, u === 0 || e === n && (vn === Hf || vn === Uf) || e.cancelPendingCommit !== null)
        return f !== null && lr(f), e.callbackNode = null, e.callbackPriority = 0;
      if (!(u & 3) || sr(e, u)) {
        if (n = u & -u, n !== e.callbackPriority || ye.actQueue !== null && f !== m6)
          lr(f);
        else return n;
        switch (Zn(u)) {
          case Xa:
          case yi:
            u = _p;
            break;
          case gu:
            u = Oc;
            break;
          case Dd:
            u = Dp;
            break;
          default:
            u = Oc;
        }
        return f = od.bind(null, e), ye.actQueue !== null ? (ye.actQueue.push(f), u = m6) : u = Mp(u, f), e.callbackPriority = n, e.callbackNode = u, n;
      }
      return f !== null && lr(f), e.callbackPriority = 2, e.callbackNode = null, 2;
    }
    function od(e, n) {
      if (xy = Sy = !1, sa !== jf && sa !== i6)
        return e.callbackNode = null, e.callbackPriority = 0, null;
      var u = e.callbackNode;
      if ($u() && e.callbackNode !== u)
        return null;
      var f = Zt;
      return f = er(
        e,
        e === zn ? f : 0,
        e.cancelPendingCommit !== null || e.timeoutHandle !== If
      ), f === 0 ? null : (Er(
        e,
        f,
        n
      ), In(e, qr()), e.callbackNode != null && e.callbackNode === u ? od.bind(null, e) : null);
    }
    function cp(e, n) {
      if ($u()) return null;
      Sy = xy, xy = !1, Er(e, n, !0);
    }
    function lr(e) {
      e !== m6 && e !== null && ay(e);
    }
    function V4() {
      ye.actQueue !== null && ye.actQueue.push(function() {
        return Yl(), null;
      }), wE(function() {
        (fn & (Pa | Tu)) !== Pl ? Mp(
          yf,
          G4
        ) : Yl();
      });
    }
    function sd() {
      return Vf === 0 && (Vf = xt()), Vf;
    }
    function fp(e) {
      return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : (N(e, "action"), Yi("" + e));
    }
    function kn(e, n) {
      var u = n.ownerDocument.createElement("input");
      return u.name = n.name, u.value = n.value, e.id && u.setAttribute("form", e.id), n.parentNode.insertBefore(u, n), e = new FormData(e), u.parentNode.removeChild(u), e;
    }
    function Ta(e, n, u, f, p) {
      if (n === "submit" && u && u.stateNode === p) {
        var v = fp(
          (p[Ca] || null).action
        ), k = f.submitter;
        k && (n = (n = k[Ca] || null) ? fp(n.formAction) : k.getAttribute("formAction"), n !== null && (v = n, k = null));
        var M = new un(
          "action",
          "action",
          null,
          f,
          p
        );
        e.push({
          event: M,
          listeners: [
            {
              instance: null,
              listener: function() {
                if (f.defaultPrevented) {
                  if (Vf !== 0) {
                    var q = k ? kn(
                      p,
                      k
                    ) : new FormData(p), j = {
                      pending: !0,
                      data: q,
                      method: p.method,
                      action: v
                    };
                    Object.freeze(j), Bh(
                      u,
                      j,
                      null,
                      q
                    );
                  }
                } else
                  typeof v == "function" && (M.preventDefault(), q = k ? kn(
                    p,
                    k
                  ) : new FormData(p), j = {
                    pending: !0,
                    data: q,
                    method: p.method,
                    action: v
                  }, Object.freeze(j), Bh(
                    u,
                    j,
                    v,
                    q
                  ));
              },
              currentTarget: p
            }
          ]
        });
      }
    }
    function ml(e, n, u) {
      e.currentTarget = u;
      try {
        n(e);
      } catch (f) {
        F3(f);
      }
      e.currentTarget = null;
    }
    function hp(e, n) {
      n = (n & 4) !== 0;
      for (var u = 0; u < e.length; u++) {
        var f = e[u];
        e: {
          var p = void 0, v = f.event;
          if (f = f.listeners, n)
            for (var k = f.length - 1; 0 <= k; k--) {
              var M = f[k], q = M.instance, j = M.currentTarget;
              if (M = M.listener, q !== p && v.isPropagationStopped())
                break e;
              q !== null ? at(
                q,
                ml,
                v,
                M,
                j
              ) : ml(v, M, j), p = q;
            }
          else
            for (k = 0; k < f.length; k++) {
              if (M = f[k], q = M.instance, j = M.currentTarget, M = M.listener, q !== p && v.isPropagationStopped())
                break e;
              q !== null ? at(
                q,
                ml,
                v,
                M,
                j
              ) : ml(v, M, j), p = q;
            }
        }
      }
    }
    function Yt(e, n) {
      p6.has(e) || console.error(
        'Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',
        e
      );
      var u = n[Nd];
      u === void 0 && (u = n[Nd] = /* @__PURE__ */ new Set());
      var f = e + "__bubble";
      u.has(f) || (Ea(n, e, 2, !1), u.add(f));
    }
    function dp(e, n, u) {
      p6.has(e) && !n && console.error(
        'Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',
        e
      );
      var f = 0;
      n && (f |= 4), Ea(
        u,
        e,
        f,
        n
      );
    }
    function rf(e) {
      if (!e[Hy]) {
        e[Hy] = !0, os.forEach(function(u) {
          u !== "selectionchange" && (p6.has(u) || dp(u, !1, e), dp(u, !0, e));
        });
        var n = e.nodeType === 9 ? e : e.ownerDocument;
        n === null || n[Hy] || (n[Hy] = !0, dp("selectionchange", !1, n));
      }
    }
    function Ea(e, n, u, f) {
      switch (no(n)) {
        case Xa:
          var p = wd;
          break;
        case yi:
          p = zc;
          break;
        default:
          p = cf;
      }
      u = p.bind(
        null,
        n,
        u,
        e
      ), p = void 0, !Oe || n !== "touchstart" && n !== "touchmove" && n !== "wheel" || (p = !0), f ? p !== void 0 ? e.addEventListener(n, u, {
        capture: !0,
        passive: p
      }) : e.addEventListener(n, u, !0) : p !== void 0 ? e.addEventListener(n, u, {
        passive: p
      }) : e.addEventListener(
        n,
        u,
        !1
      );
    }
    function Va(e, n, u, f, p) {
      var v = f;
      if (!(n & 1) && !(n & 2) && f !== null)
        e: for (; ; ) {
          if (f === null) return;
          var k = f.tag;
          if (k === 3 || k === 4) {
            var M = f.stateNode.containerInfo;
            if (M === p) break;
            if (k === 4)
              for (k = f.return; k !== null; ) {
                var q = k.tag;
                if ((q === 3 || q === 4) && k.stateNode.containerInfo === p)
                  return;
                k = k.return;
              }
            for (; M !== null; ) {
              if (k = Hn(M), k === null) return;
              if (q = k.tag, q === 5 || q === 6 || q === 26 || q === 27) {
                f = v = k;
                continue e;
              }
              M = M.parentNode;
            }
          }
          f = f.return;
        }
      Us(function() {
        var j = v, xe = Al(u), Ae = [];
        e: {
          var pe = sb.get(e);
          if (pe !== void 0) {
            var Re = un, tt = e;
            switch (e) {
              case "keypress":
                if (Mo(u) === 0) break e;
              case "keydown":
              case "keyup":
                Re = CT;
                break;
              case "focusin":
                tt = "focus", Re = xi;
                break;
              case "focusout":
                tt = "blur", Re = xi;
                break;
              case "beforeblur":
              case "afterblur":
                Re = xi;
                break;
              case "click":
                if (u.button === 2) break e;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                Re = ot;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                Re = zr;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                Re = OT;
                break;
              case lb:
              case ib:
              case ub:
                Re = ST;
                break;
              case ob:
                Re = NT;
                break;
              case "scroll":
              case "scrollend":
                Re = ae;
                break;
              case "wheel":
                Re = BT;
                break;
              case "copy":
              case "cut":
              case "paste":
                Re = wT;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                Re = K7;
                break;
              case "toggle":
              case "beforetoggle":
                Re = UT;
            }
            var bt = (n & 4) !== 0, Cn = !bt && (e === "scroll" || e === "scrollend"), Kt = bt ? pe !== null ? pe + "Capture" : null : pe;
            bt = [];
            for (var F = j, K; F !== null; ) {
              var ne = F;
              if (K = ne.stateNode, ne = ne.tag, ne !== 5 && ne !== 26 && ne !== 27 || K === null || Kt === null || (ne = ll(F, Kt), ne != null && bt.push(
                Sc(
                  F,
                  ne,
                  K
                )
              )), Cn) break;
              F = F.return;
            }
            0 < bt.length && (pe = new Re(
              pe,
              tt,
              null,
              u,
              xe
            ), Ae.push({
              event: pe,
              listeners: bt
            }));
          }
        }
        if (!(n & 7)) {
          e: {
            if (pe = e === "mouseover" || e === "pointerover", Re = e === "mouseout" || e === "pointerout", pe && u !== w && (tt = u.relatedTarget || u.fromElement) && (Hn(tt) || tt[uo]))
              break e;
            if ((Re || pe) && (pe = xe.window === xe ? xe : (pe = xe.ownerDocument) ? pe.defaultView || pe.parentWindow : window, Re ? (tt = u.relatedTarget || u.toElement, Re = j, tt = tt ? Hn(tt) : null, tt !== null && (Cn = I(tt), bt = tt.tag, tt !== Cn || bt !== 5 && bt !== 27 && bt !== 6) && (tt = null)) : (Re = null, tt = j), Re !== tt)) {
              if (bt = ot, ne = "onMouseLeave", Kt = "onMouseEnter", F = "mouse", (e === "pointerout" || e === "pointerover") && (bt = K7, ne = "onPointerLeave", Kt = "onPointerEnter", F = "pointer"), Cn = Re == null ? pe : hr(Re), K = tt == null ? pe : hr(tt), pe = new bt(
                ne,
                F + "leave",
                Re,
                u,
                xe
              ), pe.target = Cn, pe.relatedTarget = K, ne = null, Hn(xe) === j && (bt = new bt(
                Kt,
                F + "enter",
                tt,
                u,
                xe
              ), bt.target = K, bt.relatedTarget = Cn, ne = bt), Cn = ne, Re && tt)
                t: {
                  for (bt = Re, Kt = tt, F = 0, K = bt; K; K = ts(K))
                    F++;
                  for (K = 0, ne = Kt; ne; ne = ts(ne))
                    K++;
                  for (; 0 < F - K; )
                    bt = ts(bt), F--;
                  for (; 0 < K - F; )
                    Kt = ts(Kt), K--;
                  for (; F--; ) {
                    if (bt === Kt || Kt !== null && bt === Kt.alternate)
                      break t;
                    bt = ts(bt), Kt = ts(Kt);
                  }
                  bt = null;
                }
              else bt = null;
              Re !== null && lu(
                Ae,
                pe,
                Re,
                bt,
                !1
              ), tt !== null && Cn !== null && lu(
                Ae,
                Cn,
                tt,
                bt,
                !0
              );
            }
          }
          e: {
            if (pe = j ? hr(j) : window, Re = pe.nodeName && pe.nodeName.toLowerCase(), Re === "select" || Re === "input" && pe.type === "file")
              var ze = m4;
            else if (hh(pe))
              if (rb)
                ze = s3;
              else {
                ze = u3;
                var Ze = Km;
              }
            else
              Re = pe.nodeName, !Re || Re.toLowerCase() !== "input" || pe.type !== "checkbox" && pe.type !== "radio" ? j && zo(j.elementType) && (ze = m4) : ze = o3;
            if (ze && (ze = ze(e, j))) {
              qs(
                Ae,
                ze,
                u,
                xe
              );
              break e;
            }
            Ze && Ze(e, pe, j), e === "focusout" && j && pe.type === "number" && j.memoizedProps.value != null && ah(pe, "number", pe.value);
          }
          switch (Ze = j ? hr(j) : window, e) {
            case "focusin":
              (hh(Ze) || Ze.contentEditable === "true") && ($d = Ze, R3 = j, Wp = null);
              break;
            case "focusout":
              Wp = R3 = $d = null;
              break;
            case "mousedown":
              z3 = !0;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              z3 = !1, mh(
                Ae,
                u,
                xe
              );
              break;
            case "selectionchange":
              if (VT) break;
            case "keydown":
            case "keyup":
              mh(
                Ae,
                u,
                xe
              );
          }
          var Mt;
          if (k3)
            e: {
              switch (e) {
                case "compositionstart":
                  var nt = "onCompositionStart";
                  break e;
                case "compositionend":
                  nt = "onCompositionEnd";
                  break e;
                case "compositionupdate":
                  nt = "onCompositionUpdate";
                  break e;
              }
              nt = void 0;
            }
          else
            Id ? Mu(e, u) && (nt = "onCompositionEnd") : e === "keydown" && u.keyCode === J7 && (nt = "onCompositionStart");
          nt && (W7 && u.locale !== "ko" && (Id || nt !== "onCompositionStart" ? nt === "onCompositionEnd" && Id && (Mt = fh()) : (me = xe, we = "value" in me ? me.value : me.textContent, Id = !0)), Ze = Jr(
            j,
            nt
          ), 0 < Ze.length && (nt = new P7(
            nt,
            e,
            null,
            u,
            xe
          ), Ae.push({
            event: nt,
            listeners: Ze
          }), Mt ? nt.data = Mt : (Mt = v0(u), Mt !== null && (nt.data = Mt)))), (Mt = jT ? b0(e, u) : i3(e, u)) && (nt = Jr(
            j,
            "onBeforeInput"
          ), 0 < nt.length && (Ze = new ET(
            "onBeforeInput",
            "beforeinput",
            null,
            u,
            xe
          ), Ae.push({
            event: Ze,
            listeners: nt
          }), Ze.data = Mt)), Ta(
            Ae,
            e,
            j,
            u,
            xe
          );
        }
        hp(Ae, n);
      });
    }
    function Sc(e, n, u) {
      return {
        instance: e,
        listener: n,
        currentTarget: u
      };
    }
    function Jr(e, n) {
      for (var u = n + "Capture", f = []; e !== null; ) {
        var p = e, v = p.stateNode;
        if (p = p.tag, p !== 5 && p !== 26 && p !== 27 || v === null || (p = ll(e, u), p != null && f.unshift(
          Sc(e, p, v)
        ), p = ll(e, n), p != null && f.push(
          Sc(e, p, v)
        )), e.tag === 3) return f;
        e = e.return;
      }
      return [];
    }
    function ts(e) {
      if (e === null) return null;
      do
        e = e.return;
      while (e && e.tag !== 5 && e.tag !== 27);
      return e || null;
    }
    function lu(e, n, u, f, p) {
      for (var v = n._reactName, k = []; u !== null && u !== f; ) {
        var M = u, q = M.alternate, j = M.stateNode;
        if (M = M.tag, q !== null && q === f) break;
        M !== 5 && M !== 26 && M !== 27 || j === null || (q = j, p ? (j = ll(u, v), j != null && k.unshift(
          Sc(u, j, q)
        )) : p || (j = ll(u, v), j != null && k.push(
          Sc(u, j, q)
        ))), u = u.return;
      }
      k.length !== 0 && e.push({ event: n, listeners: k });
    }
    function iu(e, n) {
      f4(e, n), e !== "input" && e !== "textarea" && e !== "select" || n == null || n.value !== null || py || (py = !0, e === "select" && n.multiple ? console.error(
        "`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",
        e
      ) : console.error(
        "`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",
        e
      ));
      var u = {
        registrationNameDependencies: Zl,
        possibleRegistrationNames: Ld
      };
      zo(e) || typeof n.is == "string" || h4(e, n, u), n.contentEditable && !n.suppressContentEditableWarning && n.children != null && console.error(
        "A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."
      );
    }
    function Rn(e, n, u, f) {
      n !== u && (u = uu(u), uu(n) !== u && (f[e] = n));
    }
    function mp(e, n, u) {
      n.forEach(function(f) {
        u[xc(f)] = f === "style" ? cd(e) : e.getAttribute(f);
      });
    }
    function pl(e, n) {
      n === !1 ? console.error(
        "Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.",
        e,
        e,
        e
      ) : console.error(
        "Expected `%s` listener to be a function, instead got a value of `%s` type.",
        e,
        typeof n
      );
    }
    function Il(e, n) {
      return e = e.namespaceURI === Gd || e.namespaceURI === vu ? e.ownerDocument.createElementNS(
        e.namespaceURI,
        e.tagName
      ) : e.ownerDocument.createElement(e.tagName), e.innerHTML = n, e.innerHTML;
    }
    function uu(e) {
      return Y(e) && (console.error(
        "The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.",
        C(e)
      ), ie(e)), (typeof e == "string" ? e : "" + e).replace(dE, `
`).replace(mE, "");
    }
    function ns(e, n) {
      return n = uu(n), uu(e) === n;
    }
    function Zu() {
    }
    function en(e, n, u, f, p, v) {
      switch (u) {
        case "children":
          typeof f == "string" ? (Bs(f, n, !1), n === "body" || n === "textarea" && f === "" || m0(e, f)) : (typeof f == "number" || typeof f == "bigint") && (Bs("" + f, n, !1), n !== "body" && m0(e, "" + f));
          break;
        case "className":
          Tt(e, "class", f);
          break;
        case "tabIndex":
          Tt(e, "tabindex", f);
          break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
          Tt(e, u, f);
          break;
        case "style":
          sh(e, f, v);
          break;
        case "data":
          if (n !== "object") {
            Tt(e, "data", f);
            break;
          }
        case "src":
        case "href":
          if (f === "" && (n !== "a" || u !== "href")) {
            console.error(
              u === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              u,
              u
            ), e.removeAttribute(u);
            break;
          }
          if (f == null || typeof f == "function" || typeof f == "symbol" || typeof f == "boolean") {
            e.removeAttribute(u);
            break;
          }
          N(f, u), f = Yi("" + f), e.setAttribute(u, f);
          break;
        case "action":
        case "formAction":
          if (f != null && (n === "form" ? u === "formAction" ? console.error(
            "You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>."
          ) : typeof f == "function" && (p.encType == null && p.method == null || jy || (jy = !0, console.error(
            "Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden."
          )), p.target == null || qy || (qy = !0, console.error(
            "Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."
          ))) : n === "input" || n === "button" ? u === "action" ? console.error(
            "You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>."
          ) : n !== "input" || p.type === "submit" || p.type === "image" || Uy ? n !== "button" || p.type == null || p.type === "submit" || Uy ? typeof f == "function" && (p.name == null || E8 || (E8 = !0, console.error(
            'Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.'
          )), p.formEncType == null && p.formMethod == null || jy || (jy = !0, console.error(
            "Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden."
          )), p.formTarget == null || qy || (qy = !0, console.error(
            "Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."
          ))) : (Uy = !0, console.error(
            'A button can only specify a formAction along with type="submit" or no type.'
          )) : (Uy = !0, console.error(
            'An input can only specify a formAction along with type="submit" or type="image".'
          )) : console.error(
            u === "action" ? "You can only pass the action prop to <form>." : "You can only pass the formAction prop to <input> or <button>."
          )), typeof f == "function") {
            e.setAttribute(
              u,
              "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
            );
            break;
          } else
            typeof v == "function" && (u === "formAction" ? (n !== "input" && en(e, n, "name", p.name, p, null), en(
              e,
              n,
              "formEncType",
              p.formEncType,
              p,
              null
            ), en(
              e,
              n,
              "formMethod",
              p.formMethod,
              p,
              null
            ), en(
              e,
              n,
              "formTarget",
              p.formTarget,
              p,
              null
            )) : (en(
              e,
              n,
              "encType",
              p.encType,
              p,
              null
            ), en(e, n, "method", p.method, p, null), en(
              e,
              n,
              "target",
              p.target,
              p,
              null
            )));
          if (f == null || typeof f == "symbol" || typeof f == "boolean") {
            e.removeAttribute(u);
            break;
          }
          N(f, u), f = Yi("" + f), e.setAttribute(u, f);
          break;
        case "onClick":
          f != null && (typeof f != "function" && pl(u, f), e.onclick = Zu);
          break;
        case "onScroll":
          f != null && (typeof f != "function" && pl(u, f), Yt("scroll", e));
          break;
        case "onScrollEnd":
          f != null && (typeof f != "function" && pl(u, f), Yt("scrollend", e));
          break;
        case "dangerouslySetInnerHTML":
          if (f != null) {
            if (typeof f != "object" || !("__html" in f))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (u = f.__html, u != null) {
              if (p.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              e.innerHTML = u;
            }
          }
          break;
        case "multiple":
          e.multiple = f && typeof f != "function" && typeof f != "symbol";
          break;
        case "muted":
          e.muted = f && typeof f != "function" && typeof f != "symbol";
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          break;
        case "autoFocus":
          break;
        case "xlinkHref":
          if (f == null || typeof f == "function" || typeof f == "boolean" || typeof f == "symbol") {
            e.removeAttribute("xlink:href");
            break;
          }
          N(f, u), u = Yi("" + f), e.setAttributeNS(Yf, "xlink:href", u);
          break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
          f != null && typeof f != "function" && typeof f != "symbol" ? (N(f, u), e.setAttribute(u, "" + f)) : e.removeAttribute(u);
          break;
        case "inert":
          f !== "" || Gy[u] || (Gy[u] = !0, console.error(
            "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
            u
          ));
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
          f && typeof f != "function" && typeof f != "symbol" ? e.setAttribute(u, "") : e.removeAttribute(u);
          break;
        case "capture":
        case "download":
          f === !0 ? e.setAttribute(u, "") : f !== !1 && f != null && typeof f != "function" && typeof f != "symbol" ? (N(f, u), e.setAttribute(u, f)) : e.removeAttribute(u);
          break;
        case "cols":
        case "rows":
        case "size":
        case "span":
          f != null && typeof f != "function" && typeof f != "symbol" && !isNaN(f) && 1 <= f ? (N(f, u), e.setAttribute(u, f)) : e.removeAttribute(u);
          break;
        case "rowSpan":
        case "start":
          f == null || typeof f == "function" || typeof f == "symbol" || isNaN(f) ? e.removeAttribute(u) : (N(f, u), e.setAttribute(u, f));
          break;
        case "popover":
          Yt("beforetoggle", e), Yt("toggle", e), Pt(e, "popover", f);
          break;
        case "xlinkActuate":
          tr(
            e,
            Yf,
            "xlink:actuate",
            f
          );
          break;
        case "xlinkArcrole":
          tr(
            e,
            Yf,
            "xlink:arcrole",
            f
          );
          break;
        case "xlinkRole":
          tr(
            e,
            Yf,
            "xlink:role",
            f
          );
          break;
        case "xlinkShow":
          tr(
            e,
            Yf,
            "xlink:show",
            f
          );
          break;
        case "xlinkTitle":
          tr(
            e,
            Yf,
            "xlink:title",
            f
          );
          break;
        case "xlinkType":
          tr(
            e,
            Yf,
            "xlink:type",
            f
          );
          break;
        case "xmlBase":
          tr(
            e,
            g6,
            "xml:base",
            f
          );
          break;
        case "xmlLang":
          tr(
            e,
            g6,
            "xml:lang",
            f
          );
          break;
        case "xmlSpace":
          tr(
            e,
            g6,
            "xml:space",
            f
          );
          break;
        case "is":
          v != null && console.error(
            'Cannot update the "is" prop after it has been initialized.'
          ), Pt(e, "is", f);
          break;
        case "innerText":
        case "textContent":
          break;
        case "popoverTarget":
          A8 || f == null || typeof f != "object" || (A8 = !0, console.error(
            "The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.",
            f
          ));
        default:
          !(2 < u.length) || u[0] !== "o" && u[0] !== "O" || u[1] !== "n" && u[1] !== "N" ? (u = Co(u), Pt(e, u, f)) : Zl.hasOwnProperty(u) && f != null && typeof f != "function" && pl(u, f);
      }
    }
    function Fu(e, n, u, f, p, v) {
      switch (u) {
        case "style":
          sh(e, f, v);
          break;
        case "dangerouslySetInnerHTML":
          if (f != null) {
            if (typeof f != "object" || !("__html" in f))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (u = f.__html, u != null) {
              if (p.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              e.innerHTML = u;
            }
          }
          break;
        case "children":
          typeof f == "string" ? m0(e, f) : (typeof f == "number" || typeof f == "bigint") && m0(e, "" + f);
          break;
        case "onScroll":
          f != null && (typeof f != "function" && pl(u, f), Yt("scroll", e));
          break;
        case "onScrollEnd":
          f != null && (typeof f != "function" && pl(u, f), Yt("scrollend", e));
          break;
        case "onClick":
          f != null && (typeof f != "function" && pl(u, f), e.onclick = Zu);
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
          break;
        case "innerText":
        case "textContent":
          break;
        default:
          if (Zl.hasOwnProperty(u))
            f != null && typeof f != "function" && pl(u, f);
          else
            e: {
              if (u[0] === "o" && u[1] === "n" && (p = u.endsWith("Capture"), n = u.slice(2, p ? u.length - 7 : void 0), v = e[Ca] || null, v = v != null ? v[u] : null, typeof v == "function" && e.removeEventListener(n, v, p), typeof f == "function")) {
                typeof v != "function" && v !== null && (u in e ? e[u] = null : e.hasAttribute(u) && e.removeAttribute(u)), e.addEventListener(n, f, p);
                break e;
              }
              u in e ? e[u] = f : f === !0 ? e.setAttribute(u, "") : Pt(e, u, f);
            }
      }
    }
    function Ar(e, n, u) {
      switch (iu(n, u), n) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "img":
          Yt("error", e), Yt("load", e);
          var f = !1, p = !1, v;
          for (v in u)
            if (u.hasOwnProperty(v)) {
              var k = u[v];
              if (k != null)
                switch (v) {
                  case "src":
                    f = !0;
                    break;
                  case "srcSet":
                    p = !0;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      n + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  default:
                    en(e, n, v, k, u, null);
                }
            }
          p && en(e, n, "srcSet", u.srcSet, u, null), f && en(e, n, "src", u.src, u, null);
          return;
        case "input":
          et("input", u), Yt("invalid", e);
          var M = v = k = p = null, q = null, j = null;
          for (f in u)
            if (u.hasOwnProperty(f)) {
              var xe = u[f];
              if (xe != null)
                switch (f) {
                  case "name":
                    p = xe;
                    break;
                  case "type":
                    k = xe;
                    break;
                  case "checked":
                    q = xe;
                    break;
                  case "defaultChecked":
                    j = xe;
                    break;
                  case "value":
                    v = xe;
                    break;
                  case "defaultValue":
                    M = xe;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    if (xe != null)
                      throw Error(
                        n + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                      );
                    break;
                  default:
                    en(e, n, f, xe, u, null);
                }
            }
          Ao(e, u), Gm(
            e,
            v,
            M,
            q,
            j,
            k,
            p,
            !1
          ), Fn(e);
          return;
        case "select":
          et("select", u), Yt("invalid", e), f = k = v = null;
          for (p in u)
            if (u.hasOwnProperty(p) && (M = u[p], M != null))
              switch (p) {
                case "value":
                  v = M;
                  break;
                case "defaultValue":
                  k = M;
                  break;
                case "multiple":
                  f = M;
                default:
                  en(
                    e,
                    n,
                    p,
                    M,
                    u,
                    null
                  );
              }
          ii(e, u), n = v, u = k, e.multiple = !!f, n != null ? Gi(e, !!f, n, !1) : u != null && Gi(e, !!f, u, !0);
          return;
        case "textarea":
          et("textarea", u), Yt("invalid", e), v = p = f = null;
          for (k in u)
            if (u.hasOwnProperty(k) && (M = u[k], M != null))
              switch (k) {
                case "value":
                  f = M;
                  break;
                case "defaultValue":
                  p = M;
                  break;
                case "children":
                  v = M;
                  break;
                case "dangerouslySetInnerHTML":
                  if (M != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  en(
                    e,
                    n,
                    k,
                    M,
                    u,
                    null
                  );
              }
          lh(e, u), ko(e, f, p, v), Fn(e);
          return;
        case "option":
          c4(e, u);
          for (q in u)
            if (u.hasOwnProperty(q) && (f = u[q], f != null))
              switch (q) {
                case "selected":
                  e.selected = f && typeof f != "function" && typeof f != "symbol";
                  break;
                default:
                  en(e, n, q, f, u, null);
              }
          return;
        case "dialog":
          Yt("beforetoggle", e), Yt("toggle", e), Yt("cancel", e), Yt("close", e);
          break;
        case "iframe":
        case "object":
          Yt("load", e);
          break;
        case "video":
        case "audio":
          for (f = 0; f < Tg.length; f++)
            Yt(Tg[f], e);
          break;
        case "image":
          Yt("error", e), Yt("load", e);
          break;
        case "details":
          Yt("toggle", e);
          break;
        case "embed":
        case "source":
        case "link":
          Yt("error", e), Yt("load", e);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
          for (j in u)
            if (u.hasOwnProperty(j) && (f = u[j], f != null))
              switch (j) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(
                    n + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                  );
                default:
                  en(e, n, j, f, u, null);
              }
          return;
        default:
          if (zo(n)) {
            for (xe in u)
              u.hasOwnProperty(xe) && (f = u[xe], f !== void 0 && Fu(
                e,
                n,
                xe,
                f,
                u,
                void 0
              ));
            return;
          }
      }
      for (M in u)
        u.hasOwnProperty(M) && (f = u[M], f != null && en(e, n, M, f, u, null));
    }
    function Y4(e, n, u, f) {
      switch (iu(n, f), n) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "input":
          var p = null, v = null, k = null, M = null, q = null, j = null, xe = null;
          for (Re in u) {
            var Ae = u[Re];
            if (u.hasOwnProperty(Re) && Ae != null)
              switch (Re) {
                case "checked":
                  break;
                case "value":
                  break;
                case "defaultValue":
                  q = Ae;
                default:
                  f.hasOwnProperty(Re) || en(
                    e,
                    n,
                    Re,
                    null,
                    f,
                    Ae
                  );
              }
          }
          for (var pe in f) {
            var Re = f[pe];
            if (Ae = u[pe], f.hasOwnProperty(pe) && (Re != null || Ae != null))
              switch (pe) {
                case "type":
                  v = Re;
                  break;
                case "name":
                  p = Re;
                  break;
                case "checked":
                  j = Re;
                  break;
                case "defaultChecked":
                  xe = Re;
                  break;
                case "value":
                  k = Re;
                  break;
                case "defaultValue":
                  M = Re;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (Re != null)
                    throw Error(
                      n + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  Re !== Ae && en(
                    e,
                    n,
                    pe,
                    Re,
                    f,
                    Ae
                  );
              }
          }
          n = u.type === "checkbox" || u.type === "radio" ? u.checked != null : u.value != null, f = f.type === "checkbox" || f.type === "radio" ? f.checked != null : f.value != null, n || !f || T8 || (console.error(
            "A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), T8 = !0), !n || f || w8 || (console.error(
            "A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), w8 = !0), jm(
            e,
            k,
            M,
            q,
            j,
            xe,
            v,
            p
          );
          return;
        case "select":
          Re = k = M = pe = null;
          for (v in u)
            if (q = u[v], u.hasOwnProperty(v) && q != null)
              switch (v) {
                case "value":
                  break;
                case "multiple":
                  Re = q;
                default:
                  f.hasOwnProperty(v) || en(
                    e,
                    n,
                    v,
                    null,
                    f,
                    q
                  );
              }
          for (p in f)
            if (v = f[p], q = u[p], f.hasOwnProperty(p) && (v != null || q != null))
              switch (p) {
                case "value":
                  pe = v;
                  break;
                case "defaultValue":
                  M = v;
                  break;
                case "multiple":
                  k = v;
                default:
                  v !== q && en(
                    e,
                    n,
                    p,
                    v,
                    f,
                    q
                  );
              }
          f = M, n = k, u = Re, pe != null ? Gi(e, !!n, pe, !1) : !!u != !!n && (f != null ? Gi(e, !!n, f, !0) : Gi(e, !!n, n ? [] : "", !1));
          return;
        case "textarea":
          Re = pe = null;
          for (M in u)
            if (p = u[M], u.hasOwnProperty(M) && p != null && !f.hasOwnProperty(M))
              switch (M) {
                case "value":
                  break;
                case "children":
                  break;
                default:
                  en(e, n, M, null, f, p);
              }
          for (k in f)
            if (p = f[k], v = u[k], f.hasOwnProperty(k) && (p != null || v != null))
              switch (k) {
                case "value":
                  pe = p;
                  break;
                case "defaultValue":
                  Re = p;
                  break;
                case "children":
                  break;
                case "dangerouslySetInnerHTML":
                  if (p != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  p !== v && en(e, n, k, p, f, v);
              }
          Vm(e, pe, Re);
          return;
        case "option":
          for (var tt in u)
            if (pe = u[tt], u.hasOwnProperty(tt) && pe != null && !f.hasOwnProperty(tt))
              switch (tt) {
                case "selected":
                  e.selected = !1;
                  break;
                default:
                  en(
                    e,
                    n,
                    tt,
                    null,
                    f,
                    pe
                  );
              }
          for (q in f)
            if (pe = f[q], Re = u[q], f.hasOwnProperty(q) && pe !== Re && (pe != null || Re != null))
              switch (q) {
                case "selected":
                  e.selected = pe && typeof pe != "function" && typeof pe != "symbol";
                  break;
                default:
                  en(
                    e,
                    n,
                    q,
                    pe,
                    f,
                    Re
                  );
              }
          return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
          for (var bt in u)
            pe = u[bt], u.hasOwnProperty(bt) && pe != null && !f.hasOwnProperty(bt) && en(
              e,
              n,
              bt,
              null,
              f,
              pe
            );
          for (j in f)
            if (pe = f[j], Re = u[j], f.hasOwnProperty(j) && pe !== Re && (pe != null || Re != null))
              switch (j) {
                case "children":
                case "dangerouslySetInnerHTML":
                  if (pe != null)
                    throw Error(
                      n + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  en(
                    e,
                    n,
                    j,
                    pe,
                    f,
                    Re
                  );
              }
          return;
        default:
          if (zo(n)) {
            for (var Cn in u)
              pe = u[Cn], u.hasOwnProperty(Cn) && pe !== void 0 && !f.hasOwnProperty(Cn) && Fu(
                e,
                n,
                Cn,
                void 0,
                f,
                pe
              );
            for (xe in f)
              pe = f[xe], Re = u[xe], !f.hasOwnProperty(xe) || pe === Re || pe === void 0 && Re === void 0 || Fu(
                e,
                n,
                xe,
                pe,
                f,
                Re
              );
            return;
          }
      }
      for (var Kt in u)
        pe = u[Kt], u.hasOwnProperty(Kt) && pe != null && !f.hasOwnProperty(Kt) && en(e, n, Kt, null, f, pe);
      for (Ae in f)
        pe = f[Ae], Re = u[Ae], !f.hasOwnProperty(Ae) || pe === Re || pe == null && Re == null || en(e, n, Ae, pe, f, Re);
    }
    function xc(e) {
      switch (e) {
        case "class":
          return "className";
        case "for":
          return "htmlFor";
        default:
          return e;
      }
    }
    function cd(e) {
      var n = {};
      e = e.style;
      for (var u = 0; u < e.length; u++) {
        var f = e[u];
        n[f] = e.getPropertyValue(f);
      }
      return n;
    }
    function af(e, n, u) {
      if (n != null && typeof n != "object")
        console.error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      else {
        var f, p = f = "", v;
        for (v in n)
          if (n.hasOwnProperty(v)) {
            var k = n[v];
            k != null && typeof k != "boolean" && k !== "" && (v.indexOf("--") === 0 ? (Me(k, v), f += p + v + ":" + ("" + k).trim()) : typeof k != "number" || k === 0 || Fp.has(v) ? (Me(k, v), f += p + v.replace(yu, "-$1").toLowerCase().replace(Hc, "-ms-") + ":" + ("" + k).trim()) : f += p + v.replace(yu, "-$1").toLowerCase().replace(Hc, "-ms-") + ":" + k + "px", p = ";");
          }
        f = f || null, n = e.getAttribute("style"), n !== f && (f = uu(f), uu(n) !== f && (u.style = cd(e)));
      }
    }
    function Ya(e, n, u, f, p, v) {
      if (p.delete(u), e = e.getAttribute(u), e === null)
        switch (typeof f) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (f != null)
        switch (typeof f) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (N(f, n), e === "" + f)
              return;
        }
      Rn(n, e, f, v);
    }
    function I4(e, n, u, f, p, v) {
      if (p.delete(u), e = e.getAttribute(u), e === null) {
        switch (typeof f) {
          case "function":
          case "symbol":
            return;
        }
        if (!f) return;
      } else
        switch (typeof f) {
          case "function":
          case "symbol":
            break;
          default:
            if (f) return;
        }
      Rn(n, e, f, v);
    }
    function pp(e, n, u, f, p, v) {
      if (p.delete(u), e = e.getAttribute(u), e === null)
        switch (typeof f) {
          case "undefined":
          case "function":
          case "symbol":
            return;
        }
      else if (f != null)
        switch (typeof f) {
          case "function":
          case "symbol":
            break;
          default:
            if (N(f, u), e === "" + f)
              return;
        }
      Rn(n, e, f, v);
    }
    function cn(e, n, u, f, p, v) {
      if (p.delete(u), e = e.getAttribute(u), e === null)
        switch (typeof f) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
          default:
            if (isNaN(f)) return;
        }
      else if (f != null)
        switch (typeof f) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (!isNaN(f) && (N(f, n), e === "" + f))
              return;
        }
      Rn(n, e, f, v);
    }
    function pn(e, n, u, f, p, v) {
      if (p.delete(u), e = e.getAttribute(u), e === null)
        switch (typeof f) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (f != null)
        switch (typeof f) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (N(f, n), u = Yi("" + f), e === u)
              return;
        }
      Rn(n, e, f, v);
    }
    function It(e, n, u, f) {
      for (var p = {}, v = /* @__PURE__ */ new Set(), k = e.attributes, M = 0; M < k.length; M++)
        switch (k[M].name.toLowerCase()) {
          case "value":
            break;
          case "checked":
            break;
          case "selected":
            break;
          default:
            v.add(k[M].name);
        }
      if (zo(n)) {
        for (var q in u)
          if (u.hasOwnProperty(q)) {
            var j = u[q];
            if (j != null) {
              if (Zl.hasOwnProperty(q))
                typeof j != "function" && pl(q, j);
              else if (u.suppressHydrationWarning !== !0)
                switch (q) {
                  case "children":
                    typeof j != "string" && typeof j != "number" || Rn(
                      "children",
                      e.textContent,
                      j,
                      p
                    );
                    continue;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "defaultValue":
                  case "defaultChecked":
                  case "innerHTML":
                  case "ref":
                    continue;
                  case "dangerouslySetInnerHTML":
                    k = e.innerHTML, j = j ? j.__html : void 0, j != null && (j = Il(e, j), Rn(
                      q,
                      k,
                      j,
                      p
                    ));
                    continue;
                  case "style":
                    v.delete(q), af(e, j, p);
                    continue;
                  case "offsetParent":
                  case "offsetTop":
                  case "offsetLeft":
                  case "offsetWidth":
                  case "offsetHeight":
                  case "isContentEditable":
                  case "outerText":
                  case "outerHTML":
                    v.delete(q.toLowerCase()), console.error(
                      "Assignment to read-only property will result in a no-op: `%s`",
                      q
                    );
                    continue;
                  case "className":
                    v.delete("class"), k = kt(
                      e,
                      "class",
                      j
                    ), Rn(
                      "className",
                      k,
                      j,
                      p
                    );
                    continue;
                  default:
                    f.context === ys && n !== "svg" && n !== "math" ? v.delete(q.toLowerCase()) : v.delete(q), k = kt(
                      e,
                      q,
                      j
                    ), Rn(
                      q,
                      k,
                      j,
                      p
                    );
                }
            }
          }
      } else
        for (j in u)
          if (u.hasOwnProperty(j) && (q = u[j], q != null)) {
            if (Zl.hasOwnProperty(j))
              typeof q != "function" && pl(j, q);
            else if (u.suppressHydrationWarning !== !0)
              switch (j) {
                case "children":
                  typeof q != "string" && typeof q != "number" || Rn(
                    "children",
                    e.textContent,
                    q,
                    p
                  );
                  continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                  continue;
                case "dangerouslySetInnerHTML":
                  k = e.innerHTML, q = q ? q.__html : void 0, q != null && (q = Il(e, q), k !== q && (p[j] = { __html: k }));
                  continue;
                case "className":
                  Ya(
                    e,
                    j,
                    "class",
                    q,
                    v,
                    p
                  );
                  continue;
                case "tabIndex":
                  Ya(
                    e,
                    j,
                    "tabindex",
                    q,
                    v,
                    p
                  );
                  continue;
                case "style":
                  v.delete(j), af(e, q, p);
                  continue;
                case "multiple":
                  v.delete(j), Rn(
                    j,
                    e.multiple,
                    q,
                    p
                  );
                  continue;
                case "muted":
                  v.delete(j), Rn(
                    j,
                    e.muted,
                    q,
                    p
                  );
                  continue;
                case "autoFocus":
                  v.delete("autofocus"), Rn(
                    j,
                    e.autofocus,
                    q,
                    p
                  );
                  continue;
                case "data":
                  if (n !== "object") {
                    v.delete(j), k = e.getAttribute("data"), Rn(
                      j,
                      k,
                      q,
                      p
                    );
                    continue;
                  }
                case "src":
                case "href":
                  if (!(q !== "" || n === "a" && j === "href" || n === "object" && j === "data")) {
                    console.error(
                      j === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                      j,
                      j
                    );
                    continue;
                  }
                  pn(
                    e,
                    j,
                    j,
                    q,
                    v,
                    p
                  );
                  continue;
                case "action":
                case "formAction":
                  if (k = e.getAttribute(j), typeof q == "function") {
                    v.delete(j.toLowerCase()), j === "formAction" ? (v.delete("name"), v.delete("formenctype"), v.delete("formmethod"), v.delete("formtarget")) : (v.delete("enctype"), v.delete("method"), v.delete("target"));
                    continue;
                  } else if (k === pE) {
                    v.delete(j.toLowerCase()), Rn(
                      j,
                      "function",
                      q,
                      p
                    );
                    continue;
                  }
                  pn(
                    e,
                    j,
                    j.toLowerCase(),
                    q,
                    v,
                    p
                  );
                  continue;
                case "xlinkHref":
                  pn(
                    e,
                    j,
                    "xlink:href",
                    q,
                    v,
                    p
                  );
                  continue;
                case "contentEditable":
                  pp(
                    e,
                    j,
                    "contenteditable",
                    q,
                    v,
                    p
                  );
                  continue;
                case "spellCheck":
                  pp(
                    e,
                    j,
                    "spellcheck",
                    q,
                    v,
                    p
                  );
                  continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                  pp(
                    e,
                    j,
                    j,
                    q,
                    v,
                    p
                  );
                  continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                  I4(
                    e,
                    j,
                    j.toLowerCase(),
                    q,
                    v,
                    p
                  );
                  continue;
                case "capture":
                case "download":
                  e: {
                    M = e;
                    var xe = k = j, Ae = p;
                    if (v.delete(xe), M = M.getAttribute(xe), M === null)
                      switch (typeof q) {
                        case "undefined":
                        case "function":
                        case "symbol":
                          break e;
                        default:
                          if (q === !1) break e;
                      }
                    else if (q != null)
                      switch (typeof q) {
                        case "function":
                        case "symbol":
                          break;
                        case "boolean":
                          if (q === !0 && M === "") break e;
                          break;
                        default:
                          if (N(q, k), M === "" + q)
                            break e;
                      }
                    Rn(
                      k,
                      M,
                      q,
                      Ae
                    );
                  }
                  continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                  e: {
                    if (M = e, xe = k = j, Ae = p, v.delete(xe), M = M.getAttribute(xe), M === null)
                      switch (typeof q) {
                        case "undefined":
                        case "function":
                        case "symbol":
                        case "boolean":
                          break e;
                        default:
                          if (isNaN(q) || 1 > q) break e;
                      }
                    else if (q != null)
                      switch (typeof q) {
                        case "function":
                        case "symbol":
                        case "boolean":
                          break;
                        default:
                          if (!(isNaN(q) || 1 > q) && (N(q, k), M === "" + q))
                            break e;
                      }
                    Rn(
                      k,
                      M,
                      q,
                      Ae
                    );
                  }
                  continue;
                case "rowSpan":
                  cn(
                    e,
                    j,
                    "rowspan",
                    q,
                    v,
                    p
                  );
                  continue;
                case "start":
                  cn(
                    e,
                    j,
                    j,
                    q,
                    v,
                    p
                  );
                  continue;
                case "xHeight":
                  Ya(
                    e,
                    j,
                    "x-height",
                    q,
                    v,
                    p
                  );
                  continue;
                case "xlinkActuate":
                  Ya(
                    e,
                    j,
                    "xlink:actuate",
                    q,
                    v,
                    p
                  );
                  continue;
                case "xlinkArcrole":
                  Ya(
                    e,
                    j,
                    "xlink:arcrole",
                    q,
                    v,
                    p
                  );
                  continue;
                case "xlinkRole":
                  Ya(
                    e,
                    j,
                    "xlink:role",
                    q,
                    v,
                    p
                  );
                  continue;
                case "xlinkShow":
                  Ya(
                    e,
                    j,
                    "xlink:show",
                    q,
                    v,
                    p
                  );
                  continue;
                case "xlinkTitle":
                  Ya(
                    e,
                    j,
                    "xlink:title",
                    q,
                    v,
                    p
                  );
                  continue;
                case "xlinkType":
                  Ya(
                    e,
                    j,
                    "xlink:type",
                    q,
                    v,
                    p
                  );
                  continue;
                case "xmlBase":
                  Ya(
                    e,
                    j,
                    "xml:base",
                    q,
                    v,
                    p
                  );
                  continue;
                case "xmlLang":
                  Ya(
                    e,
                    j,
                    "xml:lang",
                    q,
                    v,
                    p
                  );
                  continue;
                case "xmlSpace":
                  Ya(
                    e,
                    j,
                    "xml:space",
                    q,
                    v,
                    p
                  );
                  continue;
                case "inert":
                  q !== "" || Gy[j] || (Gy[j] = !0, console.error(
                    "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
                    j
                  )), I4(
                    e,
                    j,
                    j,
                    q,
                    v,
                    p
                  );
                  continue;
                default:
                  if (!(2 < j.length) || j[0] !== "o" && j[0] !== "O" || j[1] !== "n" && j[1] !== "N") {
                    M = Co(j), k = !1, f.context === ys && n !== "svg" && n !== "math" ? v.delete(M.toLowerCase()) : (xe = j.toLowerCase(), xe = Rf.hasOwnProperty(
                      xe
                    ) && Rf[xe] || null, xe !== null && xe !== j && (k = !0, v.delete(xe)), v.delete(M));
                    e: if (xe = e, Ae = M, M = q, Ht(Ae))
                      if (xe.hasAttribute(Ae))
                        xe = xe.getAttribute(
                          Ae
                        ), N(
                          M,
                          Ae
                        ), M = xe === "" + M ? M : xe;
                      else {
                        switch (typeof M) {
                          case "function":
                          case "symbol":
                            break e;
                          case "boolean":
                            if (xe = Ae.toLowerCase().slice(0, 5), xe !== "data-" && xe !== "aria-")
                              break e;
                        }
                        M = M === void 0 ? void 0 : null;
                      }
                    else M = void 0;
                    k || Rn(
                      j,
                      M,
                      q,
                      p
                    );
                  }
              }
          }
      return 0 < v.size && u.suppressHydrationWarning !== !0 && mp(e, v, p), Object.keys(p).length === 0 ? null : p;
    }
    function Wt(e, n) {
      switch (e.length) {
        case 0:
          return "";
        case 1:
          return e[0];
        case 2:
          return e[0] + " " + n + " " + e[1];
        default:
          return e.slice(0, -1).join(", ") + ", " + n + " " + e[e.length - 1];
      }
    }
    function tn(e) {
      return e.nodeType === 9 ? e : e.ownerDocument;
    }
    function Aa(e) {
      switch (e) {
        case vu:
          return ym;
        case Gd:
          return Iy;
        default:
          return ys;
      }
    }
    function ou(e, n) {
      if (e === ys)
        switch (n) {
          case "svg":
            return ym;
          case "math":
            return Iy;
          default:
            return ys;
        }
      return e === ym && n === "foreignObject" ? ys : e;
    }
    function Pu(e, n) {
      return e === "textarea" || e === "noscript" || typeof n.children == "string" || typeof n.children == "number" || typeof n.children == "bigint" || typeof n.dangerouslySetInnerHTML == "object" && n.dangerouslySetInnerHTML !== null && n.dangerouslySetInnerHTML.__html != null;
    }
    function gp() {
      var e = window.event;
      return e && e.type === "popstate" ? e === S6 ? !1 : (S6 = e, !0) : (S6 = null, !1);
    }
    function su(e) {
      setTimeout(function() {
        throw e;
      });
    }
    function $n(e, n, u) {
      switch (n) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          u.autoFocus && e.focus();
          break;
        case "img":
          u.src ? e.src = u.src : u.srcSet && (e.srcset = u.srcSet);
      }
    }
    function Ku(e, n, u, f) {
      Y4(e, n, u, f), e[Ca] = f;
    }
    function Ju(e) {
      m0(e, "");
    }
    function yp(e, n, u) {
      e.nodeValue = u;
    }
    function pr(e) {
      return e === "head";
    }
    function wc(e, n) {
      e.removeChild(n);
    }
    function lf(e, n) {
      (e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e).removeChild(n);
    }
    function ia(e, n) {
      var u = n, f = 0, p = 0;
      do {
        var v = u.nextSibling;
        if (e.removeChild(u), v && v.nodeType === 8)
          if (u = v.data, u === Yy) {
            if (0 < f && 8 > f) {
              u = f;
              var k = e.ownerDocument;
              if (u & yE && Ac(k.documentElement), u & vE && Ac(k.body), u & bE)
                for (u = k.head, Ac(u), k = u.firstChild; k; ) {
                  var M = k.nextSibling, q = k.nodeName;
                  k[bf] || q === "SCRIPT" || q === "STYLE" || q === "LINK" && k.rel.toLowerCase() === "stylesheet" || u.removeChild(k), k = M;
                }
            }
            if (p === 0) {
              e.removeChild(v), Mc(n);
              return;
            }
            p--;
          } else
            u === Vy || u === gs || u === Eg ? p++ : f = u.charCodeAt(0) - 48;
        else f = 0;
        u = v;
      } while (u);
      Mc(n);
    }
    function vp(e) {
      e = e.style, typeof e.setProperty == "function" ? e.setProperty("display", "none", "important") : e.display = "none";
    }
    function bp(e) {
      e.nodeValue = "";
    }
    function fd(e, n) {
      n = n[SE], n = n != null && n.hasOwnProperty("display") ? n.display : null, e.style.display = n == null || typeof n == "boolean" ? "" : ("" + n).trim();
    }
    function hd(e, n) {
      e.nodeValue = n;
    }
    function di(e) {
      var n = e.firstChild;
      for (n && n.nodeType === 10 && (n = n.nextSibling); n; ) {
        var u = n;
        switch (n = n.nextSibling, u.nodeName) {
          case "HTML":
          case "HEAD":
          case "BODY":
            di(u), Nr(u);
            continue;
          case "SCRIPT":
          case "STYLE":
            continue;
          case "LINK":
            if (u.rel.toLowerCase() === "stylesheet") continue;
        }
        e.removeChild(u);
      }
    }
    function Ur(e, n, u, f) {
      for (; e.nodeType === 1; ) {
        var p = u;
        if (e.nodeName.toLowerCase() !== n.toLowerCase()) {
          if (!f && (e.nodeName !== "INPUT" || e.type !== "hidden"))
            break;
        } else if (f) {
          if (!e[bf])
            switch (n) {
              case "meta":
                if (!e.hasAttribute("itemprop")) break;
                return e;
              case "link":
                if (v = e.getAttribute("rel"), v === "stylesheet" && e.hasAttribute("data-precedence"))
                  break;
                if (v !== p.rel || e.getAttribute("href") !== (p.href == null || p.href === "" ? null : p.href) || e.getAttribute("crossorigin") !== (p.crossOrigin == null ? null : p.crossOrigin) || e.getAttribute("title") !== (p.title == null ? null : p.title))
                  break;
                return e;
              case "style":
                if (e.hasAttribute("data-precedence")) break;
                return e;
              case "script":
                if (v = e.getAttribute("src"), (v !== (p.src == null ? null : p.src) || e.getAttribute("type") !== (p.type == null ? null : p.type) || e.getAttribute("crossorigin") !== (p.crossOrigin == null ? null : p.crossOrigin)) && v && e.hasAttribute("async") && !e.hasAttribute("itemprop"))
                  break;
                return e;
              default:
                return e;
            }
        } else if (n === "input" && e.type === "hidden") {
          N(p.name, "name");
          var v = p.name == null ? null : "" + p.name;
          if (p.type === "hidden" && e.getAttribute("name") === v)
            return e;
        } else return e;
        if (e = ka(e.nextSibling), e === null) break;
      }
      return null;
    }
    function Wu(e, n, u) {
      if (n === "") return null;
      for (; e.nodeType !== 3; )
        if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !u || (e = ka(e.nextSibling), e === null)) return null;
      return e;
    }
    function eo(e) {
      return e.data === Eg || e.data === gs && e.ownerDocument.readyState === R8;
    }
    function Tc(e, n) {
      var u = e.ownerDocument;
      if (e.data !== gs || u.readyState === R8)
        n();
      else {
        var f = function() {
          n(), u.removeEventListener("DOMContentLoaded", f);
        };
        u.addEventListener("DOMContentLoaded", f), e._reactRetry = f;
      }
    }
    function ka(e) {
      for (; e != null; e = e.nextSibling) {
        var n = e.nodeType;
        if (n === 1 || n === 3) break;
        if (n === 8) {
          if (n = e.data, n === Vy || n === Eg || n === gs || n === y6 || n === k8)
            break;
          if (n === Yy) return null;
        }
      }
      return e;
    }
    function dd(e) {
      if (e.nodeType === 1) {
        for (var n = e.nodeName.toLowerCase(), u = {}, f = e.attributes, p = 0; p < f.length; p++) {
          var v = f[p];
          u[xc(v.name)] = v.name.toLowerCase() === "style" ? cd(e) : v.value;
        }
        return { type: n, props: u };
      }
      return e.nodeType === 8 ? { type: "Suspense", props: {} } : e.nodeValue;
    }
    function Sp(e, n, u) {
      return u === null || u[gE] !== !0 ? (e.nodeValue === n ? e = null : (n = uu(n), e = uu(e.nodeValue) === n ? null : e.nodeValue), e) : null;
    }
    function Ec(e) {
      e = e.nextSibling;
      for (var n = 0; e; ) {
        if (e.nodeType === 8) {
          var u = e.data;
          if (u === Yy) {
            if (n === 0)
              return ka(e.nextSibling);
            n--;
          } else
            u !== Vy && u !== Eg && u !== gs || n++;
        }
        e = e.nextSibling;
      }
      return null;
    }
    function md(e) {
      e = e.previousSibling;
      for (var n = 0; e; ) {
        if (e.nodeType === 8) {
          var u = e.data;
          if (u === Vy || u === Eg || u === gs) {
            if (n === 0) return e;
            n--;
          } else u === Yy && n++;
        }
        e = e.previousSibling;
      }
      return null;
    }
    function Ia(e) {
      Mc(e);
    }
    function $4(e) {
      Mc(e);
    }
    function Ra(e, n, u, f, p) {
      switch (p && oh(e, f.ancestorInfo), n = tn(u), e) {
        case "html":
          if (e = n.documentElement, !e)
            throw Error(
              "React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return e;
        case "head":
          if (e = n.head, !e)
            throw Error(
              "React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return e;
        case "body":
          if (e = n.body, !e)
            throw Error(
              "React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return e;
        default:
          throw Error(
            "resolveSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
    }
    function X4(e, n, u, f) {
      if (!u[uo] && hn(u)) {
        var p = u.tagName.toLowerCase();
        console.error(
          "You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.",
          p,
          p,
          p
        );
      }
      switch (e) {
        case "html":
        case "head":
        case "body":
          break;
        default:
          console.error(
            "acquireSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
      for (p = u.attributes; p.length; )
        u.removeAttributeNode(p[0]);
      Ar(u, e, n), u[Wr] = f, u[Ca] = n;
    }
    function Ac(e) {
      for (var n = e.attributes; n.length; )
        e.removeAttributeNode(n[0]);
      Nr(e);
    }
    function pd(e) {
      return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
    }
    function cu(e, n, u) {
      var f = vm;
      if (f && typeof n == "string" && n) {
        var p = wr(n);
        p = 'link[rel="' + e + '"][href="' + p + '"]', typeof u == "string" && (p += '[crossorigin="' + u + '"]'), D8.has(p) || (D8.add(p), e = { rel: e, crossOrigin: u, href: n }, f.querySelector(p) === null && (n = f.createElement("link"), Ar(n, "link", e), ue(n), f.head.appendChild(n)));
      }
    }
    function uf(e, n, u, f) {
      var p = (p = pi.current) ? pd(p) : null;
      if (!p)
        throw Error(
          '"resourceRoot" was expected to exist. This is a bug in React.'
        );
      switch (e) {
        case "meta":
        case "title":
          return null;
        case "style":
          return typeof u.precedence == "string" && typeof u.href == "string" ? (u = $l(u.href), n = B(p).hoistableStyles, f = n.get(u), f || (f = {
            type: "style",
            instance: null,
            count: 0,
            state: null
          }, n.set(u, f)), f) : { type: "void", instance: null, count: 0, state: null };
        case "link":
          if (u.rel === "stylesheet" && typeof u.href == "string" && typeof u.precedence == "string") {
            e = $l(u.href);
            var v = B(p).hoistableStyles, k = v.get(e);
            if (!k && (p = p.ownerDocument || p, k = {
              type: "stylesheet",
              instance: null,
              count: 0,
              state: { loading: $f, preload: null }
            }, v.set(e, k), (v = p.querySelector(
              Rc(e)
            )) && !v._p && (k.instance = v, k.state.loading = Ag | _i), !Oi.has(e))) {
              var M = {
                rel: "preload",
                as: "style",
                href: u.href,
                crossOrigin: u.crossOrigin,
                integrity: u.integrity,
                media: u.media,
                hrefLang: u.hrefLang,
                referrerPolicy: u.referrerPolicy
              };
              Oi.set(e, M), v || Q4(
                p,
                e,
                M,
                k.state
              );
            }
            if (n && f === null)
              throw u = `

  - ` + kc(n) + `
  + ` + kc(u), Error(
                "Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + u
              );
            return k;
          }
          if (n && f !== null)
            throw u = `

  - ` + kc(n) + `
  + ` + kc(u), Error(
              "Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + u
            );
          return null;
        case "script":
          return n = u.async, u = u.src, typeof u == "string" && n && typeof n != "function" && typeof n != "symbol" ? (u = to(u), n = B(p).hoistableScripts, f = n.get(u), f || (f = {
            type: "script",
            instance: null,
            count: 0,
            state: null
          }, n.set(u, f)), f) : { type: "void", instance: null, count: 0, state: null };
        default:
          throw Error(
            'getResource encountered a type it did not expect: "' + e + '". this is a bug in React.'
          );
      }
    }
    function kc(e) {
      var n = 0, u = "<link";
      return typeof e.rel == "string" ? (n++, u += ' rel="' + e.rel + '"') : gi.call(e, "rel") && (n++, u += ' rel="' + (e.rel === null ? "null" : "invalid type " + typeof e.rel) + '"'), typeof e.href == "string" ? (n++, u += ' href="' + e.href + '"') : gi.call(e, "href") && (n++, u += ' href="' + (e.href === null ? "null" : "invalid type " + typeof e.href) + '"'), typeof e.precedence == "string" ? (n++, u += ' precedence="' + e.precedence + '"') : gi.call(e, "precedence") && (n++, u += " precedence={" + (e.precedence === null ? "null" : "invalid type " + typeof e.precedence) + "}"), Object.getOwnPropertyNames(e).length > n && (u += " ..."), u + " />";
    }
    function $l(e) {
      return 'href="' + wr(e) + '"';
    }
    function Rc(e) {
      return 'link[rel="stylesheet"][' + e + "]";
    }
    function xp(e) {
      return Et({}, e, {
        "data-precedence": e.precedence,
        precedence: null
      });
    }
    function Q4(e, n, u, f) {
      e.querySelector(
        'link[rel="preload"][as="style"][' + n + "]"
      ) ? f.loading = Ag : (n = e.createElement("link"), f.preload = n, n.addEventListener("load", function() {
        return f.loading |= Ag;
      }), n.addEventListener("error", function() {
        return f.loading |= _8;
      }), Ar(n, "link", u), ue(n), e.head.appendChild(n));
    }
    function to(e) {
      return '[src="' + wr(e) + '"]';
    }
    function rs(e) {
      return "script[async]" + e;
    }
    function Z4(e, n, u) {
      if (n.count++, n.instance === null)
        switch (n.type) {
          case "style":
            var f = e.querySelector(
              'style[data-href~="' + wr(u.href) + '"]'
            );
            if (f)
              return n.instance = f, ue(f), f;
            var p = Et({}, u, {
              "data-href": u.href,
              "data-precedence": u.precedence,
              href: null,
              precedence: null
            });
            return f = (e.ownerDocument || e).createElement("style"), ue(f), Ar(f, "style", p), gd(f, u.precedence, e), n.instance = f;
          case "stylesheet":
            p = $l(u.href);
            var v = e.querySelector(
              Rc(p)
            );
            if (v)
              return n.state.loading |= _i, n.instance = v, ue(v), v;
            f = xp(u), (p = Oi.get(p)) && wp(f, p), v = (e.ownerDocument || e).createElement("link"), ue(v);
            var k = v;
            return k._p = new Promise(function(M, q) {
              k.onload = M, k.onerror = q;
            }), Ar(v, "link", f), n.state.loading |= _i, gd(v, u.precedence, e), n.instance = v;
          case "script":
            return v = to(u.src), (p = e.querySelector(
              rs(v)
            )) ? (n.instance = p, ue(p), p) : (f = u, (p = Oi.get(v)) && (f = Et({}, u), yd(f, p)), e = e.ownerDocument || e, p = e.createElement("script"), ue(p), Ar(p, "link", f), e.head.appendChild(p), n.instance = p);
          case "void":
            return null;
          default:
            throw Error(
              'acquireResource encountered a resource type it did not expect: "' + n.type + '". this is a bug in React.'
            );
        }
      else
        n.type === "stylesheet" && (n.state.loading & _i) === $f && (f = n.instance, n.state.loading |= _i, gd(f, u.precedence, e));
      return n.instance;
    }
    function gd(e, n, u) {
      for (var f = u.querySelectorAll(
        'link[rel="stylesheet"][data-precedence],style[data-precedence]'
      ), p = f.length ? f[f.length - 1] : null, v = p, k = 0; k < f.length; k++) {
        var M = f[k];
        if (M.dataset.precedence === n) v = M;
        else if (v !== p) break;
      }
      v ? v.parentNode.insertBefore(e, v.nextSibling) : (n = u.nodeType === 9 ? u.head : u, n.insertBefore(e, n.firstChild));
    }
    function wp(e, n) {
      e.crossOrigin == null && (e.crossOrigin = n.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = n.referrerPolicy), e.title == null && (e.title = n.title);
    }
    function yd(e, n) {
      e.crossOrigin == null && (e.crossOrigin = n.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = n.referrerPolicy), e.integrity == null && (e.integrity = n.integrity);
    }
    function Tp(e, n, u) {
      if ($y === null) {
        var f = /* @__PURE__ */ new Map(), p = $y = /* @__PURE__ */ new Map();
        p.set(u, f);
      } else
        p = $y, f = p.get(u), f || (f = /* @__PURE__ */ new Map(), p.set(u, f));
      if (f.has(e)) return f;
      for (f.set(e, null), u = u.getElementsByTagName(e), p = 0; p < u.length; p++) {
        var v = u[p];
        if (!(v[bf] || v[Wr] || e === "link" && v.getAttribute("rel") === "stylesheet") && v.namespaceURI !== vu) {
          var k = v.getAttribute(n) || "";
          k = e + k;
          var M = f.get(k);
          M ? M.push(v) : f.set(k, [v]);
        }
      }
      return f;
    }
    function as(e, n, u) {
      e = e.ownerDocument || e, e.head.insertBefore(
        u,
        n === "title" ? e.querySelector("head > title") : null
      );
    }
    function vd(e, n, u) {
      var f = !u.ancestorInfo.containerTagInScope;
      if (u.context === ym || n.itemProp != null)
        return !f || n.itemProp == null || e !== "meta" && e !== "title" && e !== "style" && e !== "link" && e !== "script" || console.error(
          "Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.",
          e,
          e
        ), !1;
      switch (e) {
        case "meta":
        case "title":
          return !0;
        case "style":
          if (typeof n.precedence != "string" || typeof n.href != "string" || n.href === "") {
            f && console.error(
              'Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.'
            );
            break;
          }
          return !0;
        case "link":
          if (typeof n.rel != "string" || typeof n.href != "string" || n.href === "" || n.onLoad || n.onError) {
            if (n.rel === "stylesheet" && typeof n.precedence == "string") {
              e = n.href;
              var p = n.onError, v = n.disabled;
              u = [], n.onLoad && u.push("`onLoad`"), p && u.push("`onError`"), v != null && u.push("`disabled`"), p = Wt(u, "and"), p += u.length === 1 ? " prop" : " props", v = u.length === 1 ? "an " + p : "the " + p, u.length && console.error(
                'React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.',
                e,
                v,
                p
              );
            }
            f && (typeof n.rel != "string" || typeof n.href != "string" || n.href === "" ? console.error(
              "Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag"
            ) : (n.onError || n.onLoad) && console.error(
              "Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ));
            break;
          }
          switch (n.rel) {
            case "stylesheet":
              return e = n.precedence, n = n.disabled, typeof e != "string" && f && console.error(
                'Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'
              ), typeof e == "string" && n == null;
            default:
              return !0;
          }
        case "script":
          if (e = n.async && typeof n.async != "function" && typeof n.async != "symbol", !e || n.onLoad || n.onError || !n.src || typeof n.src != "string") {
            f && (e ? n.onLoad || n.onError ? console.error(
              "Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              "Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              'Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'
            ));
            break;
          }
          return !0;
        case "noscript":
        case "template":
          f && console.error(
            "Cannot render <%s> outside the main document. Try moving it into the root <head> tag.",
            e
          );
      }
      return !1;
    }
    function Ep(e) {
      return !(e.type === "stylesheet" && (e.state.loading & O8) === $f);
    }
    function F4() {
    }
    function P4(e, n, u) {
      if (kg === null)
        throw Error(
          "Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug."
        );
      var f = kg;
      if (n.type === "stylesheet" && (typeof u.media != "string" || matchMedia(u.media).matches !== !1) && (n.state.loading & _i) === $f) {
        if (n.instance === null) {
          var p = $l(u.href), v = e.querySelector(
            Rc(p)
          );
          if (v) {
            e = v._p, e !== null && typeof e == "object" && typeof e.then == "function" && (f.count++, f = of.bind(f), e.then(f, f)), n.state.loading |= _i, n.instance = v, ue(v);
            return;
          }
          v = e.ownerDocument || e, u = xp(u), (p = Oi.get(p)) && wp(u, p), v = v.createElement("link"), ue(v);
          var k = v;
          k._p = new Promise(function(M, q) {
            k.onload = M, k.onerror = q;
          }), Ar(v, "link", u), n.instance = v;
        }
        f.stylesheets === null && (f.stylesheets = /* @__PURE__ */ new Map()), f.stylesheets.set(n, e), (e = n.state.preload) && (n.state.loading & O8) === $f && (f.count++, n = of.bind(f), e.addEventListener("load", n), e.addEventListener("error", n));
      }
    }
    function K4() {
      if (kg === null)
        throw Error(
          "Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug."
        );
      var e = kg;
      return e.stylesheets && e.count === 0 && bd(e, e.stylesheets), 0 < e.count ? function(n) {
        var u = setTimeout(function() {
          if (e.stylesheets && bd(e, e.stylesheets), e.unsuspend) {
            var f = e.unsuspend;
            e.unsuspend = null, f();
          }
        }, 6e4);
        return e.unsuspend = n, function() {
          e.unsuspend = null, clearTimeout(u);
        };
      } : null;
    }
    function of() {
      if (this.count--, this.count === 0) {
        if (this.stylesheets)
          bd(this, this.stylesheets);
        else if (this.unsuspend) {
          var e = this.unsuspend;
          this.unsuspend = null, e();
        }
      }
    }
    function bd(e, n) {
      e.stylesheets = null, e.unsuspend !== null && (e.count++, Xy = /* @__PURE__ */ new Map(), n.forEach(Sd, e), Xy = null, of.call(e));
    }
    function Sd(e, n) {
      if (!(n.state.loading & _i)) {
        var u = Xy.get(e);
        if (u) var f = u.get(w6);
        else {
          u = /* @__PURE__ */ new Map(), Xy.set(e, u);
          for (var p = e.querySelectorAll(
            "link[data-precedence],style[data-precedence]"
          ), v = 0; v < p.length; v++) {
            var k = p[v];
            (k.nodeName === "LINK" || k.getAttribute("media") !== "not all") && (u.set(k.dataset.precedence, k), f = k);
          }
          f && u.set(w6, f);
        }
        p = n.instance, k = p.getAttribute("data-precedence"), v = u.get(k) || f, v === f && u.set(w6, p), u.set(k, p), this.count++, f = of.bind(this), p.addEventListener("load", f), p.addEventListener("error", f), v ? v.parentNode.insertBefore(p, v.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(p, e.firstChild)), n.state.loading |= _i;
      }
    }
    function J4(e, n, u, f, p, v, k, M) {
      for (this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = If, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Tn(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Tn(0), this.hiddenUpdates = Tn(null), this.identifierPrefix = f, this.onUncaughtError = p, this.onCaughtError = v, this.onRecoverableError = k, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = M, this.incompleteTransitions = /* @__PURE__ */ new Map(), this.passiveEffectDuration = this.effectDuration = -0, this.memoizedUpdaters = /* @__PURE__ */ new Set(), e = this.pendingUpdatersLaneMap = [], n = 0; 31 > n; n++) e.push(/* @__PURE__ */ new Set());
      this._debugRootType = u ? "hydrateRoot()" : "createRoot()";
    }
    function Ap(e, n, u, f, p, v, k, M, q, j, xe, Ae) {
      return e = new J4(
        e,
        n,
        u,
        k,
        M,
        q,
        j,
        Ae
      ), n = XT, v === !0 && (n |= Ma | bu), gl && (n |= ua), v = E(3, null, null, n), e.current = v, v.stateNode = e, n = s1(), ul(n), e.pooledCache = n, ul(n), v.memoizedState = {
        element: f,
        isDehydrated: u,
        cache: n
      }, Lu(v), e;
    }
    function gn(e) {
      return e ? (e = qc, e) : qc;
    }
    function sf(e, n, u, f, p, v) {
      if (jr && typeof jr.onScheduleFiberRoot == "function")
        try {
          jr.onScheduleFiberRoot(us, f, u);
        } catch (k) {
          Kn || (Kn = !0, console.error(
            "React instrumentation encountered an error: %s",
            k
          ));
        }
      Pe !== null && typeof Pe.markRenderScheduled == "function" && Pe.markRenderScheduled(n), p = gn(p), f.context === null ? f.context = p : f.pendingContext = p, vi && Gr !== null && !H8 && (H8 = !0, console.error(
        `Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`,
        ee(Gr) || "Unknown"
      )), f = Cl(n), f.payload = { element: u }, v = v === void 0 ? null : v, v !== null && (typeof v != "function" && console.error(
        "Expected the last optional `callback` argument to be a function. Instead received: %s.",
        v
      ), f.callback = v), u = Ml(e, f, n), u !== null && (Vt(u, e, n), jo(u, e, n));
    }
    function W4(e, n) {
      if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
        var u = e.retryLane;
        e.retryLane = u !== 0 && u < n ? u : n;
      }
    }
    function xd(e, n) {
      W4(e, n), (e = e.alternate) && W4(e, n);
    }
    function ey(e) {
      if (e.tag === 13) {
        var n = ha(e, 67108864);
        n !== null && Vt(n, e, 67108864), xd(e, 67108864);
      }
    }
    function g3() {
      return Gr;
    }
    function y3() {
      for (var e = /* @__PURE__ */ new Map(), n = 1, u = 0; 31 > u; u++) {
        var f = xr(n);
        e.set(n, f), n *= 2;
      }
      return e;
    }
    function wd(e, n, u, f) {
      var p = ye.T;
      ye.T = null;
      var v = ln.p;
      try {
        ln.p = Xa, cf(e, n, u, f);
      } finally {
        ln.p = v, ye.T = p;
      }
    }
    function zc(e, n, u, f) {
      var p = ye.T;
      ye.T = null;
      var v = ln.p;
      try {
        ln.p = yi, cf(e, n, u, f);
      } finally {
        ln.p = v, ye.T = p;
      }
    }
    function cf(e, n, u, f) {
      if (Zy) {
        var p = Cc(f);
        if (p === null)
          Va(
            e,
            n,
            f,
            Fy,
            u
          ), Xl(e, f);
        else if (v3(
          p,
          e,
          n,
          u,
          f
        ))
          f.stopPropagation();
        else if (Xl(e, f), n & 4 && -1 < EE.indexOf(e)) {
          for (; p !== null; ) {
            var v = hn(p);
            if (v !== null)
              switch (v.tag) {
                case 3:
                  if (v = v.stateNode, v.current.memoizedState.isDehydrated) {
                    var k = Bt(v.pendingLanes);
                    if (k !== 0) {
                      var M = v;
                      for (M.pendingLanes |= 2, M.entangledLanes |= 2; k; ) {
                        var q = 1 << 31 - kr(k);
                        M.entanglements[1] |= q, k &= ~q;
                      }
                      dl(v), (fn & (Pa | Tu)) === Pl && (Oy = qr() + p8, Qu(0));
                    }
                  }
                  break;
                case 13:
                  M = ha(v, 2), M !== null && Vt(M, v, 2), Jo(), xd(v, 2);
              }
            if (v = Cc(f), v === null && Va(
              e,
              n,
              f,
              Fy,
              u
            ), v === p) break;
            p = v;
          }
          p !== null && f.stopPropagation();
        } else
          Va(
            e,
            n,
            f,
            null,
            u
          );
      }
    }
    function Cc(e) {
      return e = Al(e), ff(e);
    }
    function ff(e) {
      if (Fy = null, e = Hn(e), e !== null) {
        var n = I(e);
        if (n === null) e = null;
        else {
          var u = n.tag;
          if (u === 13) {
            if (e = $(n), e !== null) return e;
            e = null;
          } else if (u === 3) {
            if (n.stateNode.current.memoizedState.isDehydrated)
              return n.tag === 3 ? n.stateNode.containerInfo : null;
            e = null;
          } else n !== e && (e = null);
        }
      }
      return Fy = e, null;
    }
    function no(e) {
      switch (e) {
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Xa;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return yi;
        case "message":
          switch (ly()) {
            case yf:
              return Xa;
            case _p:
              return yi;
            case Oc:
            case Op:
              return gu;
            case Dp:
              return Dd;
            default:
              return gu;
          }
        default:
          return gu;
      }
    }
    function Xl(e, n) {
      switch (e) {
        case "focusin":
        case "focusout":
          Fc = null;
          break;
        case "dragenter":
        case "dragleave":
          Pc = null;
          break;
        case "mouseover":
        case "mouseout":
          Kc = null;
          break;
        case "pointerover":
        case "pointerout":
          zg.delete(n.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          Cg.delete(n.pointerId);
      }
    }
    function fu(e, n, u, f, p, v) {
      return e === null || e.nativeEvent !== v ? (e = {
        blockedOn: n,
        domEventName: u,
        eventSystemFlags: f,
        nativeEvent: v,
        targetContainers: [p]
      }, n !== null && (n = hn(n), n !== null && ey(n)), e) : (e.eventSystemFlags |= f, n = e.targetContainers, p !== null && n.indexOf(p) === -1 && n.push(p), e);
    }
    function v3(e, n, u, f, p) {
      switch (n) {
        case "focusin":
          return Fc = fu(
            Fc,
            e,
            n,
            u,
            f,
            p
          ), !0;
        case "dragenter":
          return Pc = fu(
            Pc,
            e,
            n,
            u,
            f,
            p
          ), !0;
        case "mouseover":
          return Kc = fu(
            Kc,
            e,
            n,
            u,
            f,
            p
          ), !0;
        case "pointerover":
          var v = p.pointerId;
          return zg.set(
            v,
            fu(
              zg.get(v) || null,
              e,
              n,
              u,
              f,
              p
            )
          ), !0;
        case "gotpointercapture":
          return v = p.pointerId, Cg.set(
            v,
            fu(
              Cg.get(v) || null,
              e,
              n,
              u,
              f,
              p
            )
          ), !0;
      }
      return !1;
    }
    function kp(e) {
      var n = Hn(e.target);
      if (n !== null) {
        var u = I(n);
        if (u !== null) {
          if (n = u.tag, n === 13) {
            if (n = $(u), n !== null) {
              e.blockedOn = n, fr(e.priority, function() {
                if (u.tag === 13) {
                  var f = Ga(u);
                  f = ut(f);
                  var p = ha(
                    u,
                    f
                  );
                  p !== null && Vt(p, u, f), xd(u, f);
                }
              });
              return;
            }
          } else if (n === 3 && u.stateNode.current.memoizedState.isDehydrated) {
            e.blockedOn = u.tag === 3 ? u.stateNode.containerInfo : null;
            return;
          }
        }
      }
      e.blockedOn = null;
    }
    function hf(e) {
      if (e.blockedOn !== null) return !1;
      for (var n = e.targetContainers; 0 < n.length; ) {
        var u = Cc(e.nativeEvent);
        if (u === null) {
          u = e.nativeEvent;
          var f = new u.constructor(
            u.type,
            u
          ), p = f;
          w !== null && console.error(
            "Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."
          ), w = p, u.target.dispatchEvent(f), w === null && console.error(
            "Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."
          ), w = null;
        } else
          return n = hn(u), n !== null && ey(n), e.blockedOn = u, !1;
        n.shift();
      }
      return !0;
    }
    function Rp(e, n, u) {
      hf(e) && u.delete(n);
    }
    function ty() {
      T6 = !1, Fc !== null && hf(Fc) && (Fc = null), Pc !== null && hf(Pc) && (Pc = null), Kc !== null && hf(Kc) && (Kc = null), zg.forEach(Rp), Cg.forEach(Rp);
    }
    function Td(e, n) {
      e.blockedOn === n && (e.blockedOn = null, T6 || (T6 = !0, Xn.unstable_scheduleCallback(
        Xn.unstable_NormalPriority,
        ty
      )));
    }
    function Ed(e) {
      Py !== e && (Py = e, Xn.unstable_scheduleCallback(
        Xn.unstable_NormalPriority,
        function() {
          Py === e && (Py = null);
          for (var n = 0; n < e.length; n += 3) {
            var u = e[n], f = e[n + 1], p = e[n + 2];
            if (typeof f != "function") {
              if (ff(f || u) === null)
                continue;
              break;
            }
            var v = hn(u);
            v !== null && (e.splice(n, 3), n -= 3, u = {
              pending: !0,
              data: p,
              method: u.method,
              action: f
            }, Object.freeze(u), Bh(
              v,
              u,
              f,
              p
            ));
          }
        }
      ));
    }
    function Mc(e) {
      function n(q) {
        return Td(q, e);
      }
      Fc !== null && Td(Fc, e), Pc !== null && Td(Pc, e), Kc !== null && Td(Kc, e), zg.forEach(n), Cg.forEach(n);
      for (var u = 0; u < Jc.length; u++) {
        var f = Jc[u];
        f.blockedOn === e && (f.blockedOn = null);
      }
      for (; 0 < Jc.length && (u = Jc[0], u.blockedOn === null); )
        kp(u), u.blockedOn === null && Jc.shift();
      if (u = (e.ownerDocument || e).$$reactFormReplay, u != null)
        for (f = 0; f < u.length; f += 3) {
          var p = u[f], v = u[f + 1], k = p[Ca] || null;
          if (typeof v == "function")
            k || Ed(u);
          else if (k) {
            var M = null;
            if (v && v.hasAttribute("formAction")) {
              if (p = v, k = v[Ca] || null)
                M = k.formAction;
              else if (ff(p) !== null) continue;
            } else M = k.action;
            typeof M == "function" ? u[f + 1] = M : (u.splice(f, 3), f -= 3), Ed(u);
          }
        }
    }
    function Ad(e) {
      this._internalRoot = e;
    }
    function kd(e) {
      this._internalRoot = e;
    }
    function Rd(e) {
      e[uo] && (e._reactRootContainer ? console.error(
        "You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported."
      ) : console.error(
        "You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."
      ));
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Xn = vS(), zp = zt, b3 = bS(), Et = Object.assign, S3 = Symbol.for("react.element"), hu = Symbol.for("react.transitional.element"), Ct = Symbol.for("react.portal"), ro = Symbol.for("react.fragment"), ls = Symbol.for("react.strict_mode"), df = Symbol.for("react.profiler"), ny = Symbol.for("react.provider"), mf = Symbol.for("react.consumer"), za = Symbol.for("react.context"), ao = Symbol.for("react.forward_ref"), lo = Symbol.for("react.suspense"), zd = Symbol.for("react.suspense_list"), Cd = Symbol.for("react.memo"), $a = Symbol.for("react.lazy"), Md = Symbol.for("react.activity"), ry = Symbol.for("react.memo_cache_sentinel"), pf = Symbol.iterator, yn = Symbol.for("react.client.reference"), gr = Array.isArray, ye = zp.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ln = b3.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Cp = Object.freeze({
      pending: !1,
      data: null,
      method: null,
      action: null
    }), gf = [], _c = [], mi = -1, du = De(null), is = De(null), pi = De(null), _d = De(null), gi = Object.prototype.hasOwnProperty, Mp = Xn.unstable_scheduleCallback, ay = Xn.unstable_cancelCallback, x3 = Xn.unstable_shouldYield, w3 = Xn.unstable_requestPaint, qr = Xn.unstable_now, ly = Xn.unstable_getCurrentPriorityLevel, yf = Xn.unstable_ImmediatePriority, _p = Xn.unstable_UserBlockingPriority, Oc = Xn.unstable_NormalPriority, Op = Xn.unstable_LowPriority, Dp = Xn.unstable_IdlePriority, Ql = Xn.log, Np = Xn.unstable_setDisableYieldValue, us = null, jr = null, Pe = null, Kn = !1, gl = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u", kr = Math.clz32 ? Math.clz32 : Gn, mu = Math.log, T3 = Math.LN2, Od = 256, pu = 4194304, Xa = 2, yi = 8, gu = 32, Dd = 268435456, io = Math.random().toString(36).slice(2), Wr = "__reactFiber$" + io, Ca = "__reactProps$" + io, uo = "__reactContainer$" + io, Nd = "__reactEvents$" + io, Dc = "__reactListeners$" + io, vf = "__reactHandles$" + io, Lp = "__reactResources$" + io, bf = "__reactMarker$" + io, os = /* @__PURE__ */ new Set(), Zl = {}, Ld = {}, Bd = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    }, Bp = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), Hd = {}, Sf = {}, Nc = 0, Hp, iy, Up, Lc, uy, oy, sy;
    ai.__reactDisabledLog = !0;
    var Bc, xf, wf = !1, qp = new (typeof WeakMap == "function" ? WeakMap : Map)(), Gr = null, vi = !1, cy = /[\n"\\]/g, jp = !1, Gp = !1, Vp = !1, Ud = !1, Yp = !1, Tf = !1, fy = ["value", "defaultValue"], hy = !1, qd = /["'&<>\n\t]|^\s|\s$/, Ip = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(
      " "
    ), Ef = "applet caption html table td th marquee object template foreignObject desc title".split(
      " "
    ), $p = Ef.concat(["button"]), dy = "dd dt li option optgroup p rp rt".split(" "), jd = {
      current: null,
      formTag: null,
      aTagInScope: null,
      buttonTagInScope: null,
      nobrTagInScope: null,
      pTagInButtonScope: null,
      listItemTagAutoclosing: null,
      dlItemTagAutoclosing: null,
      containerTagInScope: null,
      implicitRootScope: !1
    }, Fl = {}, bi = {
      animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(
        " "
      ),
      background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(
        " "
      ),
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(
        " "
      ),
      borderBlockEnd: [
        "borderBlockEndColor",
        "borderBlockEndStyle",
        "borderBlockEndWidth"
      ],
      borderBlockStart: [
        "borderBlockStartColor",
        "borderBlockStartStyle",
        "borderBlockStartWidth"
      ],
      borderBottom: [
        "borderBottomColor",
        "borderBottomStyle",
        "borderBottomWidth"
      ],
      borderColor: [
        "borderBottomColor",
        "borderLeftColor",
        "borderRightColor",
        "borderTopColor"
      ],
      borderImage: [
        "borderImageOutset",
        "borderImageRepeat",
        "borderImageSlice",
        "borderImageSource",
        "borderImageWidth"
      ],
      borderInlineEnd: [
        "borderInlineEndColor",
        "borderInlineEndStyle",
        "borderInlineEndWidth"
      ],
      borderInlineStart: [
        "borderInlineStartColor",
        "borderInlineStartStyle",
        "borderInlineStartWidth"
      ],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: [
        "borderBottomLeftRadius",
        "borderBottomRightRadius",
        "borderTopLeftRadius",
        "borderTopRightRadius"
      ],
      borderRight: [
        "borderRightColor",
        "borderRightStyle",
        "borderRightWidth"
      ],
      borderStyle: [
        "borderBottomStyle",
        "borderLeftStyle",
        "borderRightStyle",
        "borderTopStyle"
      ],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: [
        "borderBottomWidth",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth"
      ],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(
        " "
      ),
      fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(
        " "
      ),
      gap: ["columnGap", "rowGap"],
      grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(
        " "
      ),
      gridArea: [
        "gridColumnEnd",
        "gridColumnStart",
        "gridRowEnd",
        "gridRowStart"
      ],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: [
        "gridTemplateAreas",
        "gridTemplateColumns",
        "gridTemplateRows"
      ],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(
        " "
      ),
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: [
        "textDecorationColor",
        "textDecorationLine",
        "textDecorationStyle"
      ],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: [
        "transitionDelay",
        "transitionDuration",
        "transitionProperty",
        "transitionTimingFunction"
      ],
      wordWrap: ["overflowWrap"]
    }, yu = /([A-Z])/g, Hc = /^ms-/, Af = /^(?:webkit|moz|o)[A-Z]/, oo = /^-ms-/, E3 = /-(.)/g, Xp = /;\s*$/, Si = {}, Qp = {}, Zp = !1, kf = !1, Fp = new Set(
      "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
        " "
      )
    ), Gd = "http://www.w3.org/1998/Math/MathML", vu = "http://www.w3.org/2000/svg", Vd = /* @__PURE__ */ new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"]
    ]), Rf = {
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      fetchpriority: "fetchPriority",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      inert: "inert",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      popover: "popover",
      popovertarget: "popoverTarget",
      popovertargetaction: "popoverTargetAction",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      transformorigin: "transformOrigin",
      "transform-origin": "transformOrigin",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Uc = {
      "aria-current": 0,
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      "aria-hidden": 0,
      "aria-invalid": 0,
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, so = {}, Yd = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), my = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), py = !1, Rr = {}, l = /^on./, o = /^on[^A-Z]/, c = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), m = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), S = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, w = null, _ = null, H = null, Z = !1, fe = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), Oe = !1;
    if (fe)
      try {
        var Be = {};
        Object.defineProperty(Be, "passive", {
          get: function() {
            Oe = !0;
          }
        }), window.addEventListener("test", Be, Be), window.removeEventListener("test", Be, Be);
      } catch {
        Oe = !1;
      }
    var me = null, we = null, mt = null, ct = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, un = Br(ct), oe = Et({}, ct, { view: 0, detail: 0 }), ae = Br(oe), he, Le, Je, Nt = Et({}, oe, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Fr,
      button: 0,
      buttons: 0,
      relatedTarget: function(e) {
        return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
      },
      movementX: function(e) {
        return "movementX" in e ? e.movementX : (e !== Je && (Je && e.type === "mousemove" ? (he = e.screenX - Je.screenX, Le = e.screenY - Je.screenY) : Le = he = 0, Je = e), he);
      },
      movementY: function(e) {
        return "movementY" in e ? e.movementY : Le;
      }
    }), ot = Br(Nt), pt = Et({}, Nt, { dataTransfer: 0 }), zr = Br(pt), nn = Et({}, oe, { relatedTarget: 0 }), xi = Br(nn), A3 = Et({}, ct, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), ST = Br(A3), xT = Et({}, ct, {
      clipboardData: function(e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      }
    }), wT = Br(xT), TT = Et({}, ct, { data: 0 }), P7 = Br(
      TT
    ), ET = P7, AT = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, kT = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    }, RT = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    }, zT = Et({}, oe, {
      key: function(e) {
        if (e.key) {
          var n = AT[e.key] || e.key;
          if (n !== "Unidentified") return n;
        }
        return e.type === "keypress" ? (e = Mo(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? kT[e.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Fr,
      charCode: function(e) {
        return e.type === "keypress" ? Mo(e) : 0;
      },
      keyCode: function(e) {
        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      },
      which: function(e) {
        return e.type === "keypress" ? Mo(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      }
    }), CT = Br(zT), MT = Et({}, Nt, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), K7 = Br(MT), _T = Et({}, oe, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Fr
    }), OT = Br(_T), DT = Et({}, ct, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), NT = Br(DT), LT = Et({}, Nt, {
      deltaX: function(e) {
        return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
      },
      deltaY: function(e) {
        return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }), BT = Br(LT), HT = Et({}, ct, {
      newState: 0,
      oldState: 0
    }), UT = Br(HT), qT = [9, 13, 27, 32], J7 = 229, k3 = fe && "CompositionEvent" in window, Pp = null;
    fe && "documentMode" in document && (Pp = document.documentMode);
    var jT = fe && "TextEvent" in window && !Pp, W7 = fe && (!k3 || Pp && 8 < Pp && 11 >= Pp), eb = 32, tb = String.fromCharCode(eb), nb = !1, Id = !1, GT = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    }, Kp = null, Jp = null, rb = !1;
    fe && (rb = Pm("input") && (!document.documentMode || 9 < document.documentMode));
    var Qa = typeof Object.is == "function" ? Object.is : c3, VT = fe && "documentMode" in document && 11 >= document.documentMode, $d = null, R3 = null, Wp = null, z3 = !1, Xd = {
      animationend: _o("Animation", "AnimationEnd"),
      animationiteration: _o("Animation", "AnimationIteration"),
      animationstart: _o("Animation", "AnimationStart"),
      transitionrun: _o("Transition", "TransitionRun"),
      transitionstart: _o("Transition", "TransitionStart"),
      transitioncancel: _o("Transition", "TransitionCancel"),
      transitionend: _o("Transition", "TransitionEnd")
    }, C3 = {}, ab = {};
    fe && (ab = document.createElement("div").style, "AnimationEvent" in window || (delete Xd.animationend.animation, delete Xd.animationiteration.animation, delete Xd.animationstart.animation), "TransitionEvent" in window || delete Xd.transitionend.transition);
    var lb = Oo("animationend"), ib = Oo("animationiteration"), ub = Oo("animationstart"), YT = Oo("transitionrun"), IT = Oo("transitionstart"), $T = Oo("transitioncancel"), ob = Oo("transitionend"), sb = /* @__PURE__ */ new Map(), M3 = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
      " "
    );
    M3.push("scrollEnd");
    var _3 = /* @__PURE__ */ new WeakMap(), O3 = 1, zf = 2, wi = [], Qd = 0, D3 = 0, qc = {};
    Object.freeze(qc);
    var Ti = null, Zd = null, Dn = 0, XT = 1, ua = 2, Ma = 8, bu = 16, cb = 64, fb = !1;
    try {
      var hb = Object.preventExtensions({});
    } catch {
      fb = !0;
    }
    var Fd = [], Pd = 0, gy = null, yy = 0, Ei = [], Ai = 0, Cf = null, ss = 1, cs = "", Za = null, ir = null, rn = !1, fs = !1, ki = null, Mf = null, co = !1, N3 = Error(
      "Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), db = 0;
    if (typeof performance == "object" && typeof performance.now == "function")
      var QT = performance, mb = function() {
        return QT.now();
      };
    else {
      var ZT = Date;
      mb = function() {
        return ZT.now();
      };
    }
    var L3 = De(null), B3 = De(null), pb = {}, vy = null, Kd = null, Jd = !1, FT = typeof AbortController < "u" ? AbortController : function() {
      var e = [], n = this.signal = {
        aborted: !1,
        addEventListener: function(u, f) {
          e.push(f);
        }
      };
      this.abort = function() {
        n.aborted = !0, e.forEach(function(u) {
          return u();
        });
      };
    }, PT = Xn.unstable_scheduleCallback, KT = Xn.unstable_NormalPriority, Vr = {
      $$typeof: za,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
      _currentRenderer: null,
      _currentRenderer2: null
    }, Wd = Xn.unstable_now, gb = -0, by = -0, yl = -1.1, _f = -0, Sy = !1, xy = !1, eg = null, H3 = 0, Of = 0, em = null, yb = ye.S;
    ye.S = function(e, n) {
      typeof n == "object" && n !== null && typeof n.then == "function" && T4(e, n), yb !== null && yb(e, n);
    };
    var Df = De(null), Su = {
      recordUnsafeLifecycleWarnings: function() {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function() {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    }, tg = [], ng = [], rg = [], ag = [], lg = [], ig = [], Nf = /* @__PURE__ */ new Set();
    Su.recordUnsafeLifecycleWarnings = function(e, n) {
      Nf.has(e.type) || (typeof n.componentWillMount == "function" && n.componentWillMount.__suppressDeprecationWarning !== !0 && tg.push(e), e.mode & Ma && typeof n.UNSAFE_componentWillMount == "function" && ng.push(e), typeof n.componentWillReceiveProps == "function" && n.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && rg.push(e), e.mode & Ma && typeof n.UNSAFE_componentWillReceiveProps == "function" && ag.push(e), typeof n.componentWillUpdate == "function" && n.componentWillUpdate.__suppressDeprecationWarning !== !0 && lg.push(e), e.mode & Ma && typeof n.UNSAFE_componentWillUpdate == "function" && ig.push(e));
    }, Su.flushPendingUnsafeLifecycleWarnings = function() {
      var e = /* @__PURE__ */ new Set();
      0 < tg.length && (tg.forEach(function(M) {
        e.add(
          ee(M) || "Component"
        ), Nf.add(M.type);
      }), tg = []);
      var n = /* @__PURE__ */ new Set();
      0 < ng.length && (ng.forEach(function(M) {
        n.add(
          ee(M) || "Component"
        ), Nf.add(M.type);
      }), ng = []);
      var u = /* @__PURE__ */ new Set();
      0 < rg.length && (rg.forEach(function(M) {
        u.add(
          ee(M) || "Component"
        ), Nf.add(M.type);
      }), rg = []);
      var f = /* @__PURE__ */ new Set();
      0 < ag.length && (ag.forEach(
        function(M) {
          f.add(
            ee(M) || "Component"
          ), Nf.add(M.type);
        }
      ), ag = []);
      var p = /* @__PURE__ */ new Set();
      0 < lg.length && (lg.forEach(function(M) {
        p.add(
          ee(M) || "Component"
        ), Nf.add(M.type);
      }), lg = []);
      var v = /* @__PURE__ */ new Set();
      if (0 < ig.length && (ig.forEach(function(M) {
        v.add(
          ee(M) || "Component"
        ), Nf.add(M.type);
      }), ig = []), 0 < n.size) {
        var k = R(
          n
        );
        console.error(
          `Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`,
          k
        );
      }
      0 < f.size && (k = R(
        f
      ), console.error(
        `Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state

Please update the following components: %s`,
        k
      )), 0 < v.size && (k = R(
        v
      ), console.error(
        `Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`,
        k
      )), 0 < e.size && (k = R(e), console.warn(
        `componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        k
      )), 0 < u.size && (k = R(
        u
      ), console.warn(
        `componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        k
      )), 0 < p.size && (k = R(p), console.warn(
        `componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        k
      ));
    };
    var wy = /* @__PURE__ */ new Map(), vb = /* @__PURE__ */ new Set();
    Su.recordLegacyContextWarning = function(e, n) {
      for (var u = null, f = e; f !== null; )
        f.mode & Ma && (u = f), f = f.return;
      u === null ? console.error(
        "Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue."
      ) : !vb.has(e.type) && (f = wy.get(u), e.type.contextTypes != null || e.type.childContextTypes != null || n !== null && typeof n.getChildContext == "function") && (f === void 0 && (f = [], wy.set(u, f)), f.push(e));
    }, Su.flushLegacyContextWarning = function() {
      wy.forEach(function(e) {
        if (e.length !== 0) {
          var n = e[0], u = /* @__PURE__ */ new Set();
          e.forEach(function(p) {
            u.add(ee(p) || "Component"), vb.add(p.type);
          });
          var f = R(u);
          at(n, function() {
            console.error(
              `Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://react.dev/link/legacy-context`,
              f
            );
          });
        }
      });
    }, Su.discardPendingWarnings = function() {
      tg = [], ng = [], rg = [], ag = [], lg = [], ig = [], wy = /* @__PURE__ */ new Map();
    };
    var ug = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
    ), bb = Error(
      "Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), Ty = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."
    ), U3 = {
      then: function() {
        console.error(
          'Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.'
        );
      }
    }, og = null, Ey = !1, Ri = 0, zi = 1, Fa = 2, oa = 4, Yr = 8, Sb = 0, xb = 1, wb = 2, q3 = 3, jc = !1, Tb = !1, j3 = null, G3 = !1, tm = De(null), Ay = De(0), nm, Eb = /* @__PURE__ */ new Set(), Ab = /* @__PURE__ */ new Set(), V3 = /* @__PURE__ */ new Set(), kb = /* @__PURE__ */ new Set(), Gc = 0, At = null, xn = null, Cr = null, ky = !1, rm = !1, Lf = !1, Ry = 0, sg = 0, hs = null, JT = 0, WT = 25, Ee = null, Ci = null, ds = -1, cg = !1, zy = {
      readContext: En,
      use: Vn,
      useCallback: Sn,
      useContext: Sn,
      useEffect: Sn,
      useImperativeHandle: Sn,
      useLayoutEffect: Sn,
      useInsertionEffect: Sn,
      useMemo: Sn,
      useReducer: Sn,
      useRef: Sn,
      useState: Sn,
      useDebugValue: Sn,
      useDeferredValue: Sn,
      useTransition: Sn,
      useSyncExternalStore: Sn,
      useId: Sn,
      useHostTransitionStatus: Sn,
      useFormState: Sn,
      useActionState: Sn,
      useOptimistic: Sn,
      useMemoCache: Sn,
      useCacheRefresh: Sn
    }, Y3 = null, Rb = null, I3 = null, zb = null, fo = null, xu = null, Cy = null;
    Y3 = {
      readContext: function(e) {
        return En(e);
      },
      use: Vn,
      useCallback: function(e, n) {
        return Ee = "useCallback", Ot(), Hu(n), tc(e, n);
      },
      useContext: function(e) {
        return Ee = "useContext", Ot(), En(e);
      },
      useEffect: function(e, n) {
        return Ee = "useEffect", Ot(), Hu(n), D0(e, n);
      },
      useImperativeHandle: function(e, n, u) {
        return Ee = "useImperativeHandle", Ot(), Hu(u), Ki(e, n, u);
      },
      useInsertionEffect: function(e, n) {
        Ee = "useInsertionEffect", Ot(), Hu(n), sl(4, Fa, e, n);
      },
      useLayoutEffect: function(e, n) {
        return Ee = "useLayoutEffect", Ot(), Hu(n), v1(e, n);
      },
      useMemo: function(e, n) {
        Ee = "useMemo", Ot(), Hu(n);
        var u = ye.H;
        ye.H = fo;
        try {
          return Yo(e, n);
        } finally {
          ye.H = u;
        }
      },
      useReducer: function(e, n, u) {
        Ee = "useReducer", Ot();
        var f = ye.H;
        ye.H = fo;
        try {
          return Fi(e, n, u);
        } finally {
          ye.H = f;
        }
      },
      useRef: function(e) {
        return Ee = "useRef", Ot(), Gu(e);
      },
      useState: function(e) {
        Ee = "useState", Ot();
        var n = ye.H;
        ye.H = fo;
        try {
          return Ll(e);
        } finally {
          ye.H = n;
        }
      },
      useDebugValue: function() {
        Ee = "useDebugValue", Ot();
      },
      useDeferredValue: function(e, n) {
        return Ee = "useDeferredValue", Ot(), nc(e, n);
      },
      useTransition: function() {
        return Ee = "useTransition", Ot(), B0();
      },
      useSyncExternalStore: function(e, n, u) {
        return Ee = "useSyncExternalStore", Ot(), Mh(
          e,
          n,
          u
        );
      },
      useId: function() {
        return Ee = "useId", Ot(), Io();
      },
      useFormState: function(e, n) {
        return Ee = "useFormState", Ot(), Xs(), Js(e, n);
      },
      useActionState: function(e, n) {
        return Ee = "useActionState", Ot(), Js(e, n);
      },
      useOptimistic: function(e) {
        return Ee = "useOptimistic", Ot(), oi(e);
      },
      useHostTransitionStatus: ya,
      useMemoCache: dn,
      useCacheRefresh: function() {
        return Ee = "useCacheRefresh", Ot(), H0();
      }
    }, Rb = {
      readContext: function(e) {
        return En(e);
      },
      use: Vn,
      useCallback: function(e, n) {
        return Ee = "useCallback", Ue(), tc(e, n);
      },
      useContext: function(e) {
        return Ee = "useContext", Ue(), En(e);
      },
      useEffect: function(e, n) {
        return Ee = "useEffect", Ue(), D0(e, n);
      },
      useImperativeHandle: function(e, n, u) {
        return Ee = "useImperativeHandle", Ue(), Ki(e, n, u);
      },
      useInsertionEffect: function(e, n) {
        Ee = "useInsertionEffect", Ue(), sl(4, Fa, e, n);
      },
      useLayoutEffect: function(e, n) {
        return Ee = "useLayoutEffect", Ue(), v1(e, n);
      },
      useMemo: function(e, n) {
        Ee = "useMemo", Ue();
        var u = ye.H;
        ye.H = fo;
        try {
          return Yo(e, n);
        } finally {
          ye.H = u;
        }
      },
      useReducer: function(e, n, u) {
        Ee = "useReducer", Ue();
        var f = ye.H;
        ye.H = fo;
        try {
          return Fi(e, n, u);
        } finally {
          ye.H = f;
        }
      },
      useRef: function(e) {
        return Ee = "useRef", Ue(), Gu(e);
      },
      useState: function(e) {
        Ee = "useState", Ue();
        var n = ye.H;
        ye.H = fo;
        try {
          return Ll(e);
        } finally {
          ye.H = n;
        }
      },
      useDebugValue: function() {
        Ee = "useDebugValue", Ue();
      },
      useDeferredValue: function(e, n) {
        return Ee = "useDeferredValue", Ue(), nc(e, n);
      },
      useTransition: function() {
        return Ee = "useTransition", Ue(), B0();
      },
      useSyncExternalStore: function(e, n, u) {
        return Ee = "useSyncExternalStore", Ue(), Mh(
          e,
          n,
          u
        );
      },
      useId: function() {
        return Ee = "useId", Ue(), Io();
      },
      useActionState: function(e, n) {
        return Ee = "useActionState", Ue(), Js(e, n);
      },
      useFormState: function(e, n) {
        return Ee = "useFormState", Ue(), Xs(), Js(e, n);
      },
      useOptimistic: function(e) {
        return Ee = "useOptimistic", Ue(), oi(e);
      },
      useHostTransitionStatus: ya,
      useMemoCache: dn,
      useCacheRefresh: function() {
        return Ee = "useCacheRefresh", Ue(), H0();
      }
    }, I3 = {
      readContext: function(e) {
        return En(e);
      },
      use: Vn,
      useCallback: function(e, n) {
        return Ee = "useCallback", Ue(), N0(e, n);
      },
      useContext: function(e) {
        return Ee = "useContext", Ue(), En(e);
      },
      useEffect: function(e, n) {
        Ee = "useEffect", Ue(), ga(2048, Yr, e, n);
      },
      useImperativeHandle: function(e, n, u) {
        return Ee = "useImperativeHandle", Ue(), ec(e, n, u);
      },
      useInsertionEffect: function(e, n) {
        return Ee = "useInsertionEffect", Ue(), ga(4, Fa, e, n);
      },
      useLayoutEffect: function(e, n) {
        return Ee = "useLayoutEffect", Ue(), ga(4, oa, e, n);
      },
      useMemo: function(e, n) {
        Ee = "useMemo", Ue();
        var u = ye.H;
        ye.H = xu;
        try {
          return L0(e, n);
        } finally {
          ye.H = u;
        }
      },
      useReducer: function(e, n, u) {
        Ee = "useReducer", Ue();
        var f = ye.H;
        ye.H = xu;
        try {
          return aa(e, n, u);
        } finally {
          ye.H = f;
        }
      },
      useRef: function() {
        return Ee = "useRef", Ue(), sn().memoizedState;
      },
      useState: function() {
        Ee = "useState", Ue();
        var e = ye.H;
        ye.H = xu;
        try {
          return aa(Dt);
        } finally {
          ye.H = e;
        }
      },
      useDebugValue: function() {
        Ee = "useDebugValue", Ue();
      },
      useDeferredValue: function(e, n) {
        return Ee = "useDeferredValue", Ue(), Lh(e, n);
      },
      useTransition: function() {
        return Ee = "useTransition", Ue(), Hh();
      },
      useSyncExternalStore: function(e, n, u) {
        return Ee = "useSyncExternalStore", Ue(), M0(
          e,
          n,
          u
        );
      },
      useId: function() {
        return Ee = "useId", Ue(), sn().memoizedState;
      },
      useFormState: function(e) {
        return Ee = "useFormState", Ue(), Xs(), Nh(e);
      },
      useActionState: function(e) {
        return Ee = "useActionState", Ue(), Nh(e);
      },
      useOptimistic: function(e, n) {
        return Ee = "useOptimistic", Ue(), si(e, n);
      },
      useHostTransitionStatus: ya,
      useMemoCache: dn,
      useCacheRefresh: function() {
        return Ee = "useCacheRefresh", Ue(), sn().memoizedState;
      }
    }, zb = {
      readContext: function(e) {
        return En(e);
      },
      use: Vn,
      useCallback: function(e, n) {
        return Ee = "useCallback", Ue(), N0(e, n);
      },
      useContext: function(e) {
        return Ee = "useContext", Ue(), En(e);
      },
      useEffect: function(e, n) {
        Ee = "useEffect", Ue(), ga(2048, Yr, e, n);
      },
      useImperativeHandle: function(e, n, u) {
        return Ee = "useImperativeHandle", Ue(), ec(e, n, u);
      },
      useInsertionEffect: function(e, n) {
        return Ee = "useInsertionEffect", Ue(), ga(4, Fa, e, n);
      },
      useLayoutEffect: function(e, n) {
        return Ee = "useLayoutEffect", Ue(), ga(4, oa, e, n);
      },
      useMemo: function(e, n) {
        Ee = "useMemo", Ue();
        var u = ye.H;
        ye.H = Cy;
        try {
          return L0(e, n);
        } finally {
          ye.H = u;
        }
      },
      useReducer: function(e, n, u) {
        Ee = "useReducer", Ue();
        var f = ye.H;
        ye.H = Cy;
        try {
          return Nl(e, n, u);
        } finally {
          ye.H = f;
        }
      },
      useRef: function() {
        return Ee = "useRef", Ue(), sn().memoizedState;
      },
      useState: function() {
        Ee = "useState", Ue();
        var e = ye.H;
        ye.H = Cy;
        try {
          return Nl(Dt);
        } finally {
          ye.H = e;
        }
      },
      useDebugValue: function() {
        Ee = "useDebugValue", Ue();
      },
      useDeferredValue: function(e, n) {
        return Ee = "useDeferredValue", Ue(), S1(e, n);
      },
      useTransition: function() {
        return Ee = "useTransition", Ue(), Wi();
      },
      useSyncExternalStore: function(e, n, u) {
        return Ee = "useSyncExternalStore", Ue(), M0(
          e,
          n,
          u
        );
      },
      useId: function() {
        return Ee = "useId", Ue(), sn().memoizedState;
      },
      useFormState: function(e) {
        return Ee = "useFormState", Ue(), Xs(), ju(e);
      },
      useActionState: function(e) {
        return Ee = "useActionState", Ue(), ju(e);
      },
      useOptimistic: function(e, n) {
        return Ee = "useOptimistic", Ue(), Dh(e, n);
      },
      useHostTransitionStatus: ya,
      useMemoCache: dn,
      useCacheRefresh: function() {
        return Ee = "useCacheRefresh", Ue(), sn().memoizedState;
      }
    }, fo = {
      readContext: function(e) {
        return x(), En(e);
      },
      use: function(e) {
        return b(), Vn(e);
      },
      useCallback: function(e, n) {
        return Ee = "useCallback", b(), Ot(), tc(e, n);
      },
      useContext: function(e) {
        return Ee = "useContext", b(), Ot(), En(e);
      },
      useEffect: function(e, n) {
        return Ee = "useEffect", b(), Ot(), D0(e, n);
      },
      useImperativeHandle: function(e, n, u) {
        return Ee = "useImperativeHandle", b(), Ot(), Ki(e, n, u);
      },
      useInsertionEffect: function(e, n) {
        Ee = "useInsertionEffect", b(), Ot(), sl(4, Fa, e, n);
      },
      useLayoutEffect: function(e, n) {
        return Ee = "useLayoutEffect", b(), Ot(), v1(e, n);
      },
      useMemo: function(e, n) {
        Ee = "useMemo", b(), Ot();
        var u = ye.H;
        ye.H = fo;
        try {
          return Yo(e, n);
        } finally {
          ye.H = u;
        }
      },
      useReducer: function(e, n, u) {
        Ee = "useReducer", b(), Ot();
        var f = ye.H;
        ye.H = fo;
        try {
          return Fi(e, n, u);
        } finally {
          ye.H = f;
        }
      },
      useRef: function(e) {
        return Ee = "useRef", b(), Ot(), Gu(e);
      },
      useState: function(e) {
        Ee = "useState", b(), Ot();
        var n = ye.H;
        ye.H = fo;
        try {
          return Ll(e);
        } finally {
          ye.H = n;
        }
      },
      useDebugValue: function() {
        Ee = "useDebugValue", b(), Ot();
      },
      useDeferredValue: function(e, n) {
        return Ee = "useDeferredValue", b(), Ot(), nc(e, n);
      },
      useTransition: function() {
        return Ee = "useTransition", b(), Ot(), B0();
      },
      useSyncExternalStore: function(e, n, u) {
        return Ee = "useSyncExternalStore", b(), Ot(), Mh(
          e,
          n,
          u
        );
      },
      useId: function() {
        return Ee = "useId", b(), Ot(), Io();
      },
      useFormState: function(e, n) {
        return Ee = "useFormState", b(), Ot(), Js(e, n);
      },
      useActionState: function(e, n) {
        return Ee = "useActionState", b(), Ot(), Js(e, n);
      },
      useOptimistic: function(e) {
        return Ee = "useOptimistic", b(), Ot(), oi(e);
      },
      useMemoCache: function(e) {
        return b(), dn(e);
      },
      useHostTransitionStatus: ya,
      useCacheRefresh: function() {
        return Ee = "useCacheRefresh", Ot(), H0();
      }
    }, xu = {
      readContext: function(e) {
        return x(), En(e);
      },
      use: function(e) {
        return b(), Vn(e);
      },
      useCallback: function(e, n) {
        return Ee = "useCallback", b(), Ue(), N0(e, n);
      },
      useContext: function(e) {
        return Ee = "useContext", b(), Ue(), En(e);
      },
      useEffect: function(e, n) {
        Ee = "useEffect", b(), Ue(), ga(2048, Yr, e, n);
      },
      useImperativeHandle: function(e, n, u) {
        return Ee = "useImperativeHandle", b(), Ue(), ec(e, n, u);
      },
      useInsertionEffect: function(e, n) {
        return Ee = "useInsertionEffect", b(), Ue(), ga(4, Fa, e, n);
      },
      useLayoutEffect: function(e, n) {
        return Ee = "useLayoutEffect", b(), Ue(), ga(4, oa, e, n);
      },
      useMemo: function(e, n) {
        Ee = "useMemo", b(), Ue();
        var u = ye.H;
        ye.H = xu;
        try {
          return L0(e, n);
        } finally {
          ye.H = u;
        }
      },
      useReducer: function(e, n, u) {
        Ee = "useReducer", b(), Ue();
        var f = ye.H;
        ye.H = xu;
        try {
          return aa(e, n, u);
        } finally {
          ye.H = f;
        }
      },
      useRef: function() {
        return Ee = "useRef", b(), Ue(), sn().memoizedState;
      },
      useState: function() {
        Ee = "useState", b(), Ue();
        var e = ye.H;
        ye.H = xu;
        try {
          return aa(Dt);
        } finally {
          ye.H = e;
        }
      },
      useDebugValue: function() {
        Ee = "useDebugValue", b(), Ue();
      },
      useDeferredValue: function(e, n) {
        return Ee = "useDeferredValue", b(), Ue(), Lh(e, n);
      },
      useTransition: function() {
        return Ee = "useTransition", b(), Ue(), Hh();
      },
      useSyncExternalStore: function(e, n, u) {
        return Ee = "useSyncExternalStore", b(), Ue(), M0(
          e,
          n,
          u
        );
      },
      useId: function() {
        return Ee = "useId", b(), Ue(), sn().memoizedState;
      },
      useFormState: function(e) {
        return Ee = "useFormState", b(), Ue(), Nh(e);
      },
      useActionState: function(e) {
        return Ee = "useActionState", b(), Ue(), Nh(e);
      },
      useOptimistic: function(e, n) {
        return Ee = "useOptimistic", b(), Ue(), si(e, n);
      },
      useMemoCache: function(e) {
        return b(), dn(e);
      },
      useHostTransitionStatus: ya,
      useCacheRefresh: function() {
        return Ee = "useCacheRefresh", Ue(), sn().memoizedState;
      }
    }, Cy = {
      readContext: function(e) {
        return x(), En(e);
      },
      use: function(e) {
        return b(), Vn(e);
      },
      useCallback: function(e, n) {
        return Ee = "useCallback", b(), Ue(), N0(e, n);
      },
      useContext: function(e) {
        return Ee = "useContext", b(), Ue(), En(e);
      },
      useEffect: function(e, n) {
        Ee = "useEffect", b(), Ue(), ga(2048, Yr, e, n);
      },
      useImperativeHandle: function(e, n, u) {
        return Ee = "useImperativeHandle", b(), Ue(), ec(e, n, u);
      },
      useInsertionEffect: function(e, n) {
        return Ee = "useInsertionEffect", b(), Ue(), ga(4, Fa, e, n);
      },
      useLayoutEffect: function(e, n) {
        return Ee = "useLayoutEffect", b(), Ue(), ga(4, oa, e, n);
      },
      useMemo: function(e, n) {
        Ee = "useMemo", b(), Ue();
        var u = ye.H;
        ye.H = xu;
        try {
          return L0(e, n);
        } finally {
          ye.H = u;
        }
      },
      useReducer: function(e, n, u) {
        Ee = "useReducer", b(), Ue();
        var f = ye.H;
        ye.H = xu;
        try {
          return Nl(e, n, u);
        } finally {
          ye.H = f;
        }
      },
      useRef: function() {
        return Ee = "useRef", b(), Ue(), sn().memoizedState;
      },
      useState: function() {
        Ee = "useState", b(), Ue();
        var e = ye.H;
        ye.H = xu;
        try {
          return Nl(Dt);
        } finally {
          ye.H = e;
        }
      },
      useDebugValue: function() {
        Ee = "useDebugValue", b(), Ue();
      },
      useDeferredValue: function(e, n) {
        return Ee = "useDeferredValue", b(), Ue(), S1(e, n);
      },
      useTransition: function() {
        return Ee = "useTransition", b(), Ue(), Wi();
      },
      useSyncExternalStore: function(e, n, u) {
        return Ee = "useSyncExternalStore", b(), Ue(), M0(
          e,
          n,
          u
        );
      },
      useId: function() {
        return Ee = "useId", b(), Ue(), sn().memoizedState;
      },
      useFormState: function(e) {
        return Ee = "useFormState", b(), Ue(), ju(e);
      },
      useActionState: function(e) {
        return Ee = "useActionState", b(), Ue(), ju(e);
      },
      useOptimistic: function(e, n) {
        return Ee = "useOptimistic", b(), Ue(), Dh(e, n);
      },
      useMemoCache: function(e) {
        return b(), dn(e);
      },
      useHostTransitionStatus: ya,
      useCacheRefresh: function() {
        return Ee = "useCacheRefresh", Ue(), sn().memoizedState;
      }
    };
    var Cb = {
      "react-stack-bottom-frame": function(e, n, u) {
        var f = vi;
        vi = !0;
        try {
          return e(n, u);
        } finally {
          vi = f;
        }
      }
    }, $3 = Cb["react-stack-bottom-frame"].bind(Cb), Mb = {
      "react-stack-bottom-frame": function(e) {
        var n = vi;
        vi = !0;
        try {
          return e.render();
        } finally {
          vi = n;
        }
      }
    }, _b = Mb["react-stack-bottom-frame"].bind(Mb), Ob = {
      "react-stack-bottom-frame": function(e, n) {
        try {
          n.componentDidMount();
        } catch (u) {
          mn(e, e.return, u);
        }
      }
    }, X3 = Ob["react-stack-bottom-frame"].bind(Ob), Db = {
      "react-stack-bottom-frame": function(e, n, u, f, p) {
        try {
          n.componentDidUpdate(u, f, p);
        } catch (v) {
          mn(e, e.return, v);
        }
      }
    }, Nb = Db["react-stack-bottom-frame"].bind(Db), Lb = {
      "react-stack-bottom-frame": function(e, n) {
        var u = n.stack;
        e.componentDidCatch(n.value, {
          componentStack: u !== null ? u : ""
        });
      }
    }, eE = Lb["react-stack-bottom-frame"].bind(Lb), Bb = {
      "react-stack-bottom-frame": function(e, n, u) {
        try {
          u.componentWillUnmount();
        } catch (f) {
          mn(e, n, f);
        }
      }
    }, Hb = Bb["react-stack-bottom-frame"].bind(Bb), Ub = {
      "react-stack-bottom-frame": function(e) {
        e.resourceKind != null && console.error(
          "Expected only SimpleEffects when enableUseEffectCRUDOverload is disabled, got %s",
          e.resourceKind
        );
        var n = e.create;
        return e = e.inst, n = n(), e.destroy = n;
      }
    }, tE = Ub["react-stack-bottom-frame"].bind(Ub), qb = {
      "react-stack-bottom-frame": function(e, n, u) {
        try {
          u();
        } catch (f) {
          mn(e, n, f);
        }
      }
    }, nE = qb["react-stack-bottom-frame"].bind(qb), jb = {
      "react-stack-bottom-frame": function(e) {
        var n = e._init;
        return n(e._payload);
      }
    }, Vc = jb["react-stack-bottom-frame"].bind(jb), am = null, fg = 0, Ut = null, Q3, Gb = Q3 = !1, Vb = {}, Yb = {}, Ib = {};
    g = function(e, n, u) {
      if (u !== null && typeof u == "object" && u._store && (!u._store.validated && u.key == null || u._store.validated === 2)) {
        if (typeof u._store != "object")
          throw Error(
            "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue."
          );
        u._store.validated = 1;
        var f = ee(e), p = f || "null";
        if (!Vb[p]) {
          Vb[p] = !0, u = u._owner, e = e._debugOwner;
          var v = "";
          e && typeof e.tag == "number" && (p = ee(e)) && (v = `

Check the render method of \`` + p + "`."), v || f && (v = `

Check the top-level render call using <` + f + ">.");
          var k = "";
          u != null && e !== u && (f = null, typeof u.tag == "number" ? f = ee(u) : typeof u.name == "string" && (f = u.name), f && (k = " It was passed a child from " + f + ".")), at(n, function() {
            console.error(
              'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
              v,
              k
            );
          });
        }
      }
    };
    var lm = Xo(!0), $b = Xo(!1), Mi = De(null), ho = null, im = 1, hg = 2, Ir = De(0), Xb = {}, Qb = /* @__PURE__ */ new Set(), Zb = /* @__PURE__ */ new Set(), Fb = /* @__PURE__ */ new Set(), Pb = /* @__PURE__ */ new Set(), Kb = /* @__PURE__ */ new Set(), Jb = /* @__PURE__ */ new Set(), Wb = /* @__PURE__ */ new Set(), e8 = /* @__PURE__ */ new Set(), t8 = /* @__PURE__ */ new Set(), n8 = /* @__PURE__ */ new Set();
    Object.freeze(Xb);
    var Z3 = {
      enqueueSetState: function(e, n, u) {
        e = e._reactInternals;
        var f = Ga(e), p = Cl(f);
        p.payload = n, u != null && (qn(u), p.callback = u), n = Ml(e, p, f), n !== null && (Vt(n, e, f), jo(n, e, f)), jn(e, f);
      },
      enqueueReplaceState: function(e, n, u) {
        e = e._reactInternals;
        var f = Ga(e), p = Cl(f);
        p.tag = xb, p.payload = n, u != null && (qn(u), p.callback = u), n = Ml(e, p, f), n !== null && (Vt(n, e, f), jo(n, e, f)), jn(e, f);
      },
      enqueueForceUpdate: function(e, n) {
        e = e._reactInternals;
        var u = Ga(e), f = Cl(u);
        f.tag = wb, n != null && (qn(n), f.callback = n), n = Ml(e, f, u), n !== null && (Vt(n, e, u), jo(n, e, u)), Pe !== null && typeof Pe.markForceUpdateScheduled == "function" && Pe.markForceUpdateScheduled(e, u);
      }
    }, F3 = typeof reportError == "function" ? reportError : function(e) {
      if (typeof window == "object" && typeof window.ErrorEvent == "function") {
        var n = new window.ErrorEvent("error", {
          bubbles: !0,
          cancelable: !0,
          message: typeof e == "object" && e !== null && typeof e.message == "string" ? String(e.message) : String(e),
          error: e
        });
        if (!window.dispatchEvent(n)) return;
      } else if (typeof process == "object" && typeof process.emit == "function") {
        process.emit("uncaughtException", e);
        return;
      }
      console.error(e);
    }, um = null, P3 = null, r8 = Error(
      "This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."
    ), ea = !1, a8 = {}, l8 = {}, i8 = {}, u8 = {}, om = !1, o8 = {}, K3 = {}, J3 = {
      dehydrated: null,
      treeContext: null,
      retryLane: 0,
      hydrationErrors: null
    }, s8 = !1, c8 = null;
    c8 = /* @__PURE__ */ new Set();
    var ms = !1, yr = !1, W3 = !1, f8 = typeof WeakSet == "function" ? WeakSet : Set, ta = null, sm = null, cm = null, Mr = null, vl = !1, wu = null, dg = 8192, rE = {
      getCacheForType: function(e) {
        var n = En(Vr), u = n.data.get(e);
        return u === void 0 && (u = e(), n.data.set(e, u)), u;
      },
      getOwner: function() {
        return Gr;
      }
    };
    if (typeof Symbol == "function" && Symbol.for) {
      var mg = Symbol.for;
      mg("selector.component"), mg("selector.has_pseudo_class"), mg("selector.role"), mg("selector.test_id"), mg("selector.text");
    }
    var aE = [], lE = typeof WeakMap == "function" ? WeakMap : Map, Pl = 0, Pa = 2, Tu = 4, ps = 0, pg = 1, fm = 2, e6 = 3, Bf = 4, My = 6, h8 = 5, fn = Pl, zn = null, $t = null, Zt = 0, bl = 0, gg = 1, Hf = 2, yg = 3, d8 = 4, t6 = 5, hm = 6, vg = 7, n6 = 8, Uf = 9, vn = bl, Kl = null, Yc = !1, dm = !1, r6 = !1, mo = 0, ur = ps, Ic = 0, $c = 0, a6 = 0, Jl = 0, qf = 0, bg = null, Ka = null, _y = !1, l6 = 0, m8 = 300, Oy = 1 / 0, p8 = 500, Sg = null, Xc = null, iE = 0, uE = 1, oE = 2, jf = 0, g8 = 1, y8 = 2, v8 = 3, sE = 4, i6 = 5, sa = 0, Qc = null, mm = null, Zc = 0, u6 = 0, o6 = null, b8 = null, cE = 50, xg = 0, s6 = null, c6 = !1, Dy = !1, fE = 50, Gf = 0, wg = null, pm = !1, Ny = null, S8 = !1, x8 = /* @__PURE__ */ new Set(), hE = {}, Ly = null, gm = null, f6 = !1, h6 = !1, By = !1, d6 = !1, Vf = 0, m6 = {};
    (function() {
      for (var e = 0; e < M3.length; e++) {
        var n = M3[e], u = n.toLowerCase();
        n = n[0].toUpperCase() + n.slice(1), kl(u, "on" + n);
      }
      kl(lb, "onAnimationEnd"), kl(ib, "onAnimationIteration"), kl(ub, "onAnimationStart"), kl("dblclick", "onDoubleClick"), kl("focusin", "onFocus"), kl("focusout", "onBlur"), kl(YT, "onTransitionRun"), kl(IT, "onTransitionStart"), kl($T, "onTransitionCancel"), kl(ob, "onTransitionEnd");
    })(), Qe("onMouseEnter", ["mouseout", "mouseover"]), Qe("onMouseLeave", ["mouseout", "mouseover"]), Qe("onPointerEnter", ["pointerout", "pointerover"]), Qe("onPointerLeave", ["pointerout", "pointerover"]), Ie(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(
        " "
      )
    ), Ie(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " "
      )
    ), Ie("onBeforeInput", [
      "compositionend",
      "keypress",
      "textInput",
      "paste"
    ]), Ie(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" ")
    ), Ie(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" ")
    ), Ie(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
    );
    var Tg = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
      " "
    ), p6 = new Set(
      "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Tg)
    ), Hy = "_reactListening" + Math.random().toString(36).slice(2), w8 = !1, T8 = !1, Uy = !1, E8 = !1, qy = !1, jy = !1, A8 = !1, Gy = {}, dE = /\r\n?/g, mE = /\u0000|\uFFFD/g, Yf = "http://www.w3.org/1999/xlink", g6 = "http://www.w3.org/XML/1998/namespace", pE = "javascript:throw new Error('React form unexpectedly submitted.')", gE = "suppressHydrationWarning", Vy = "$", Yy = "/$", gs = "$?", Eg = "$!", yE = 1, vE = 2, bE = 4, y6 = "F!", k8 = "F", R8 = "complete", SE = "style", ys = 0, ym = 1, Iy = 2, v6 = null, b6 = null, z8 = { dialog: !0, webview: !0 }, S6 = null, C8 = typeof setTimeout == "function" ? setTimeout : void 0, xE = typeof clearTimeout == "function" ? clearTimeout : void 0, If = -1, M8 = typeof Promise == "function" ? Promise : void 0, wE = typeof queueMicrotask == "function" ? queueMicrotask : typeof M8 < "u" ? function(e) {
      return M8.resolve(null).then(e).catch(su);
    } : C8, x6 = null, $f = 0, Ag = 1, _8 = 2, O8 = 3, _i = 4, Oi = /* @__PURE__ */ new Map(), D8 = /* @__PURE__ */ new Set(), vs = ln.d;
    ln.d = {
      f: function() {
        var e = vs.f(), n = Jo();
        return e || n;
      },
      r: function(e) {
        var n = hn(e);
        n !== null && n.tag === 5 && n.type === "form" ? Ji(n) : vs.r(e);
      },
      D: function(e) {
        vs.D(e), cu("dns-prefetch", e, null);
      },
      C: function(e, n) {
        vs.C(e, n), cu("preconnect", e, n);
      },
      L: function(e, n, u) {
        vs.L(e, n, u);
        var f = vm;
        if (f && e && n) {
          var p = 'link[rel="preload"][as="' + wr(n) + '"]';
          n === "image" && u && u.imageSrcSet ? (p += '[imagesrcset="' + wr(
            u.imageSrcSet
          ) + '"]', typeof u.imageSizes == "string" && (p += '[imagesizes="' + wr(
            u.imageSizes
          ) + '"]')) : p += '[href="' + wr(e) + '"]';
          var v = p;
          switch (n) {
            case "style":
              v = $l(e);
              break;
            case "script":
              v = to(e);
          }
          Oi.has(v) || (e = Et(
            {
              rel: "preload",
              href: n === "image" && u && u.imageSrcSet ? void 0 : e,
              as: n
            },
            u
          ), Oi.set(v, e), f.querySelector(p) !== null || n === "style" && f.querySelector(
            Rc(v)
          ) || n === "script" && f.querySelector(rs(v)) || (n = f.createElement("link"), Ar(n, "link", e), ue(n), f.head.appendChild(n)));
        }
      },
      m: function(e, n) {
        vs.m(e, n);
        var u = vm;
        if (u && e) {
          var f = n && typeof n.as == "string" ? n.as : "script", p = 'link[rel="modulepreload"][as="' + wr(f) + '"][href="' + wr(e) + '"]', v = p;
          switch (f) {
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
              v = to(e);
          }
          if (!Oi.has(v) && (e = Et({ rel: "modulepreload", href: e }, n), Oi.set(v, e), u.querySelector(p) === null)) {
            switch (f) {
              case "audioworklet":
              case "paintworklet":
              case "serviceworker":
              case "sharedworker":
              case "worker":
              case "script":
                if (u.querySelector(rs(v)))
                  return;
            }
            f = u.createElement("link"), Ar(f, "link", e), ue(f), u.head.appendChild(f);
          }
        }
      },
      X: function(e, n) {
        vs.X(e, n);
        var u = vm;
        if (u && e) {
          var f = B(u).hoistableScripts, p = to(e), v = f.get(p);
          v || (v = u.querySelector(
            rs(p)
          ), v || (e = Et({ src: e, async: !0 }, n), (n = Oi.get(p)) && yd(e, n), v = u.createElement("script"), ue(v), Ar(v, "link", e), u.head.appendChild(v)), v = {
            type: "script",
            instance: v,
            count: 1,
            state: null
          }, f.set(p, v));
        }
      },
      S: function(e, n, u) {
        vs.S(e, n, u);
        var f = vm;
        if (f && e) {
          var p = B(f).hoistableStyles, v = $l(e);
          n = n || "default";
          var k = p.get(v);
          if (!k) {
            var M = { loading: $f, preload: null };
            if (k = f.querySelector(
              Rc(v)
            ))
              M.loading = Ag | _i;
            else {
              e = Et(
                {
                  rel: "stylesheet",
                  href: e,
                  "data-precedence": n
                },
                u
              ), (u = Oi.get(v)) && wp(e, u);
              var q = k = f.createElement("link");
              ue(q), Ar(q, "link", e), q._p = new Promise(function(j, xe) {
                q.onload = j, q.onerror = xe;
              }), q.addEventListener("load", function() {
                M.loading |= Ag;
              }), q.addEventListener("error", function() {
                M.loading |= _8;
              }), M.loading |= _i, gd(k, n, f);
            }
            k = {
              type: "stylesheet",
              instance: k,
              count: 1,
              state: M
            }, p.set(v, k);
          }
        }
      },
      M: function(e, n) {
        vs.M(e, n);
        var u = vm;
        if (u && e) {
          var f = B(u).hoistableScripts, p = to(e), v = f.get(p);
          v || (v = u.querySelector(
            rs(p)
          ), v || (e = Et({ src: e, async: !0, type: "module" }, n), (n = Oi.get(p)) && yd(e, n), v = u.createElement("script"), ue(v), Ar(v, "link", e), u.head.appendChild(v)), v = {
            type: "script",
            instance: v,
            count: 1,
            state: null
          }, f.set(p, v));
        }
      }
    };
    var vm = typeof document > "u" ? null : document, $y = null, kg = null, w6 = null, Xy = null, Xf = Cp, Rg = {
      $$typeof: za,
      Provider: null,
      Consumer: null,
      _currentValue: Xf,
      _currentValue2: Xf,
      _threadCount: 0
    }, N8 = "%c%s%c ", L8 = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", B8 = "", Qy = " ", TE = Function.prototype.bind, H8 = !1, U8 = null, q8 = null, j8 = null, G8 = null, V8 = null, Y8 = null, I8 = null, $8 = null, X8 = null;
    U8 = function(e, n, u, f) {
      n = t(e, n), n !== null && (u = a(n.memoizedState, u, 0, f), n.memoizedState = u, n.baseState = u, e.memoizedProps = Et({}, e.memoizedProps), u = ha(e, 2), u !== null && Vt(u, e, 2));
    }, q8 = function(e, n, u) {
      n = t(e, n), n !== null && (u = h(n.memoizedState, u, 0), n.memoizedState = u, n.baseState = u, e.memoizedProps = Et({}, e.memoizedProps), u = ha(e, 2), u !== null && Vt(u, e, 2));
    }, j8 = function(e, n, u, f) {
      n = t(e, n), n !== null && (u = i(n.memoizedState, u, f), n.memoizedState = u, n.baseState = u, e.memoizedProps = Et({}, e.memoizedProps), u = ha(e, 2), u !== null && Vt(u, e, 2));
    }, G8 = function(e, n, u) {
      e.pendingProps = a(e.memoizedProps, n, 0, u), e.alternate && (e.alternate.pendingProps = e.pendingProps), n = ha(e, 2), n !== null && Vt(n, e, 2);
    }, V8 = function(e, n) {
      e.pendingProps = h(e.memoizedProps, n, 0), e.alternate && (e.alternate.pendingProps = e.pendingProps), n = ha(e, 2), n !== null && Vt(n, e, 2);
    }, Y8 = function(e, n, u) {
      e.pendingProps = i(
        e.memoizedProps,
        n,
        u
      ), e.alternate && (e.alternate.pendingProps = e.pendingProps), n = ha(e, 2), n !== null && Vt(n, e, 2);
    }, I8 = function(e) {
      var n = ha(e, 2);
      n !== null && Vt(n, e, 2);
    }, $8 = function(e) {
      y = e;
    }, X8 = function(e) {
      d = e;
    };
    var Zy = !0, Fy = null, T6 = !1, Fc = null, Pc = null, Kc = null, zg = /* @__PURE__ */ new Map(), Cg = /* @__PURE__ */ new Map(), Jc = [], EE = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
      " "
    ), Py = null;
    if (kd.prototype.render = Ad.prototype.render = function(e) {
      var n = this._internalRoot;
      if (n === null) throw Error("Cannot update an unmounted root.");
      var u = arguments;
      typeof u[1] == "function" ? console.error(
        "does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ) : V(u[1]) ? console.error(
        "You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root."
      ) : typeof u[1] < "u" && console.error(
        "You passed a second argument to root.render(...) but it only accepts one argument."
      ), u = e;
      var f = n.current, p = Ga(f);
      sf(f, p, u, n, null, null);
    }, kd.prototype.unmount = Ad.prototype.unmount = function() {
      var e = arguments;
      if (typeof e[0] == "function" && console.error(
        "does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ), e = this._internalRoot, e !== null) {
        this._internalRoot = null;
        var n = e.containerInfo;
        (fn & (Pa | Tu)) !== Pl && console.error(
          "Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."
        ), sf(e.current, 2, null, e, null, null), Jo(), n[uo] = null;
      }
    }, kd.prototype.unstable_scheduleHydration = function(e) {
      if (e) {
        var n = La();
        e = { blockedOn: null, target: e, priority: n };
        for (var u = 0; u < Jc.length && n !== 0 && n < Jc[u].priority; u++) ;
        Jc.splice(u, 0, e), u === 0 && kp(e);
      }
    }, function() {
      var e = zp.version;
      if (e !== "19.1.0")
        throw Error(
          `Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:
  - react:      ` + (e + `
  - react-dom:  19.1.0
Learn more: https://react.dev/warnings/version-mismatch`)
        );
    }(), typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills"
    ), ln.findDOMNode = function(e) {
      var n = e._reactInternals;
      if (n === void 0)
        throw typeof e.render == "function" ? Error("Unable to find node on an unmounted component.") : (e = Object.keys(e).join(","), Error(
          "Argument appears to not be a ReactComponent. Keys: " + e
        ));
      return e = se(n), e = e !== null ? te(e) : null, e = e === null ? null : e.stateNode, e;
    }, !function() {
      var e = {
        bundleType: 1,
        version: "19.1.0",
        rendererPackageName: "react-dom",
        currentDispatcherRef: ye,
        reconcilerVersion: "19.1.0"
      };
      return e.overrideHookState = U8, e.overrideHookStateDeletePath = q8, e.overrideHookStateRenamePath = j8, e.overrideProps = G8, e.overridePropsDeletePath = V8, e.overridePropsRenamePath = Y8, e.scheduleUpdate = I8, e.setErrorHandler = $8, e.setSuspenseHandler = X8, e.scheduleRefresh = L, e.scheduleRoot = O, e.setRefreshHandler = G, e.getCurrentFiber = g3, e.getLaneLabelMap = y3, e.injectProfilingHooks = rt, Se(e);
    }() && fe && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && navigator.userAgent.indexOf("Edge") === -1 || -1 < navigator.userAgent.indexOf("Firefox"))) {
      var Q8 = window.location.protocol;
      /^(https?|file):$/.test(Q8) && console.info(
        "%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + (Q8 === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq` : ""),
        "font-weight:bold"
      );
    }
    Dg.createRoot = function(e, n) {
      if (!V(e))
        throw Error("Target container is not a DOM element.");
      Rd(e);
      var u = !1, f = "", p = A4, v = Gh, k = Vh, M = null;
      return n != null && (n.hydrate ? console.warn(
        "hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead."
      ) : typeof n == "object" && n !== null && n.$$typeof === hu && console.error(
        `You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`
      ), n.unstable_strictMode === !0 && (u = !0), n.identifierPrefix !== void 0 && (f = n.identifierPrefix), n.onUncaughtError !== void 0 && (p = n.onUncaughtError), n.onCaughtError !== void 0 && (v = n.onCaughtError), n.onRecoverableError !== void 0 && (k = n.onRecoverableError), n.unstable_transitionCallbacks !== void 0 && (M = n.unstable_transitionCallbacks)), n = Ap(
        e,
        1,
        !1,
        null,
        null,
        u,
        f,
        p,
        v,
        k,
        M,
        null
      ), e[uo] = n.current, rf(e), new Ad(n);
    }, Dg.hydrateRoot = function(e, n, u) {
      if (!V(e))
        throw Error("Target container is not a DOM element.");
      Rd(e), n === void 0 && console.error(
        "Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)"
      );
      var f = !1, p = "", v = A4, k = Gh, M = Vh, q = null, j = null;
      return u != null && (u.unstable_strictMode === !0 && (f = !0), u.identifierPrefix !== void 0 && (p = u.identifierPrefix), u.onUncaughtError !== void 0 && (v = u.onUncaughtError), u.onCaughtError !== void 0 && (k = u.onCaughtError), u.onRecoverableError !== void 0 && (M = u.onRecoverableError), u.unstable_transitionCallbacks !== void 0 && (q = u.unstable_transitionCallbacks), u.formState !== void 0 && (j = u.formState)), n = Ap(
        e,
        1,
        !0,
        n,
        u ?? null,
        f,
        p,
        v,
        k,
        M,
        q,
        j
      ), n.context = gn(null), u = n.current, f = Ga(u), f = ut(f), p = Cl(f), p.callback = null, Ml(u, p, f), u = f, n.current.lanes = u, cr(n, u), dl(n), e[uo] = n.current, rf(e), new kd(n);
    }, Dg.version = "19.1.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }(), Dg;
}
var SS = {};
function xS() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (SS.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(xS);
    } catch (r) {
      console.error(r);
    }
  }
}
SS.NODE_ENV === "production" ? (xS(), y5.exports = UE()) : y5.exports = qE();
var jE = y5.exports;
const GE = /* @__PURE__ */ eh(jE);
var qv = { exports: {} }, wS = {};
function Bi(r, t) {
  typeof t == "boolean" && (t = { forever: t }), this._originalTimeouts = JSON.parse(JSON.stringify(r)), this._timeouts = r, this._options = t || {}, this._maxRetryTime = t && t.maxRetryTime || 1 / 0, this._fn = null, this._errors = [], this._attempts = 1, this._operationTimeout = null, this._operationTimeoutCb = null, this._timeout = null, this._operationStart = null, this._timer = null, this._options.forever && (this._cachedTimeouts = this._timeouts.slice(0));
}
var VE = Bi;
Bi.prototype.reset = function() {
  this._attempts = 1, this._timeouts = this._originalTimeouts.slice(0);
};
Bi.prototype.stop = function() {
  this._timeout && clearTimeout(this._timeout), this._timer && clearTimeout(this._timer), this._timeouts = [], this._cachedTimeouts = null;
};
Bi.prototype.retry = function(r) {
  if (this._timeout && clearTimeout(this._timeout), !r)
    return !1;
  var t = (/* @__PURE__ */ new Date()).getTime();
  if (r && t - this._operationStart >= this._maxRetryTime)
    return this._errors.push(r), this._errors.unshift(new Error("RetryOperation timeout occurred")), !1;
  this._errors.push(r);
  var a = this._timeouts.shift();
  if (a === void 0)
    if (this._cachedTimeouts)
      this._errors.splice(0, this._errors.length - 1), a = this._cachedTimeouts.slice(-1);
    else
      return !1;
  var i = this;
  return this._timer = setTimeout(function() {
    i._attempts++, i._operationTimeoutCb && (i._timeout = setTimeout(function() {
      i._operationTimeoutCb(i._attempts);
    }, i._operationTimeout), i._options.unref && i._timeout.unref()), i._fn(i._attempts);
  }, a), this._options.unref && this._timer.unref(), !0;
};
Bi.prototype.attempt = function(r, t) {
  this._fn = r, t && (t.timeout && (this._operationTimeout = t.timeout), t.cb && (this._operationTimeoutCb = t.cb));
  var a = this;
  this._operationTimeoutCb && (this._timeout = setTimeout(function() {
    a._operationTimeoutCb();
  }, a._operationTimeout)), this._operationStart = (/* @__PURE__ */ new Date()).getTime(), this._fn(this._attempts);
};
Bi.prototype.try = function(r) {
  console.log("Using RetryOperation.try() is deprecated"), this.attempt(r);
};
Bi.prototype.start = function(r) {
  console.log("Using RetryOperation.start() is deprecated"), this.attempt(r);
};
Bi.prototype.start = Bi.prototype.try;
Bi.prototype.errors = function() {
  return this._errors;
};
Bi.prototype.attempts = function() {
  return this._attempts;
};
Bi.prototype.mainError = function() {
  if (this._errors.length === 0)
    return null;
  for (var r = {}, t = null, a = 0, i = 0; i < this._errors.length; i++) {
    var s = this._errors[i], h = s.message, d = (r[h] || 0) + 1;
    r[h] = d, d >= a && (t = s, a = d);
  }
  return t;
};
(function(r) {
  var t = VE;
  r.operation = function(a) {
    var i = r.timeouts(a);
    return new t(i, {
      forever: a && (a.forever || a.retries === 1 / 0),
      unref: a && a.unref,
      maxRetryTime: a && a.maxRetryTime
    });
  }, r.timeouts = function(a) {
    if (a instanceof Array)
      return [].concat(a);
    var i = {
      retries: 10,
      factor: 2,
      minTimeout: 1 * 1e3,
      maxTimeout: 1 / 0,
      randomize: !1
    };
    for (var s in a)
      i[s] = a[s];
    if (i.minTimeout > i.maxTimeout)
      throw new Error("minTimeout is greater than maxTimeout");
    for (var h = [], d = 0; d < i.retries; d++)
      h.push(this.createTimeout(d, i));
    return a && a.forever && !h.length && h.push(this.createTimeout(d, i)), h.sort(function(y, g) {
      return y - g;
    }), h;
  }, r.createTimeout = function(a, i) {
    var s = i.randomize ? Math.random() + 1 : 1, h = Math.round(s * Math.max(i.minTimeout, 1) * Math.pow(i.factor, a));
    return h = Math.min(h, i.maxTimeout), h;
  }, r.wrap = function(a, i, s) {
    if (i instanceof Array && (s = i, i = null), !s) {
      s = [];
      for (var h in a)
        typeof a[h] == "function" && s.push(h);
    }
    for (var d = 0; d < s.length; d++) {
      var y = s[d], g = a[y];
      a[y] = (function(x) {
        var T = r.operation(i), R = Array.prototype.slice.call(arguments, 1), E = R.pop();
        R.push(function(O) {
          T.retry(O) || (O && (arguments[0] = T.mainError()), E.apply(this, arguments));
        }), T.attempt(function() {
          x.apply(a, R);
        });
      }).bind(a, g), a[y].options = i;
    }
  };
})(wS);
var YE = wS;
const IE = YE, $E = [
  "Failed to fetch",
  // Chrome
  "NetworkError when attempting to fetch resource.",
  // Firefox
  "The Internet connection appears to be offline.",
  // Safari
  "Network request failed"
  // `cross-fetch`
];
let TS = class extends Error {
  constructor(t) {
    super(), t instanceof Error ? (this.originalError = t, { message: t } = t) : (this.originalError = new Error(t), this.originalError.stack = this.stack), this.name = "AbortError", this.message = t;
  }
};
const XE = (r, t, a) => {
  const i = a.retries - (t - 1);
  return r.attemptNumber = t, r.retriesLeft = i, r;
}, QE = (r) => $E.includes(r), ES = (r, t) => new Promise((a, i) => {
  t = {
    onFailedAttempt: () => {
    },
    retries: 10,
    ...t
  };
  const s = IE.operation(t);
  s.attempt(async (h) => {
    try {
      a(await r(h));
    } catch (d) {
      if (!(d instanceof Error)) {
        i(new TypeError(`Non-error was thrown: "${d}". You should only throw errors.`));
        return;
      }
      if (d instanceof TS)
        s.stop(), i(d.originalError);
      else if (d instanceof TypeError && !QE(d.message))
        s.stop(), i(d);
      else {
        XE(d, h, t);
        try {
          await t.onFailedAttempt(d);
        } catch (y) {
          i(y);
          return;
        }
        s.retry(d) || i(s.mainError());
      }
    }
  });
});
qv.exports = ES;
qv.exports.default = ES;
qv.exports.AbortError = TS;
var ZE = qv.exports;
const FE = /* @__PURE__ */ eh(ZE);
var AS = {}, kS = { exports: {} };
(function(r) {
  var t = Object.prototype.hasOwnProperty, a = "~";
  function i() {
  }
  Object.create && (i.prototype = /* @__PURE__ */ Object.create(null), new i().__proto__ || (a = !1));
  function s(g, b, x) {
    this.fn = g, this.context = b, this.once = x || !1;
  }
  function h(g, b, x, T, R) {
    if (typeof x != "function")
      throw new TypeError("The listener must be a function");
    var E = new s(x, T || g, R), O = a ? a + b : b;
    return g._events[O] ? g._events[O].fn ? g._events[O] = [g._events[O], E] : g._events[O].push(E) : (g._events[O] = E, g._eventsCount++), g;
  }
  function d(g, b) {
    --g._eventsCount === 0 ? g._events = new i() : delete g._events[b];
  }
  function y() {
    this._events = new i(), this._eventsCount = 0;
  }
  y.prototype.eventNames = function() {
    var b = [], x, T;
    if (this._eventsCount === 0) return b;
    for (T in x = this._events)
      t.call(x, T) && b.push(a ? T.slice(1) : T);
    return Object.getOwnPropertySymbols ? b.concat(Object.getOwnPropertySymbols(x)) : b;
  }, y.prototype.listeners = function(b) {
    var x = a ? a + b : b, T = this._events[x];
    if (!T) return [];
    if (T.fn) return [T.fn];
    for (var R = 0, E = T.length, O = new Array(E); R < E; R++)
      O[R] = T[R].fn;
    return O;
  }, y.prototype.listenerCount = function(b) {
    var x = a ? a + b : b, T = this._events[x];
    return T ? T.fn ? 1 : T.length : 0;
  }, y.prototype.emit = function(b, x, T, R, E, O) {
    var L = a ? a + b : b;
    if (!this._events[L]) return !1;
    var G = this._events[L], V = arguments.length, I, $;
    if (G.fn) {
      switch (G.once && this.removeListener(b, G.fn, void 0, !0), V) {
        case 1:
          return G.fn.call(G.context), !0;
        case 2:
          return G.fn.call(G.context, x), !0;
        case 3:
          return G.fn.call(G.context, x, T), !0;
        case 4:
          return G.fn.call(G.context, x, T, R), !0;
        case 5:
          return G.fn.call(G.context, x, T, R, E), !0;
        case 6:
          return G.fn.call(G.context, x, T, R, E, O), !0;
      }
      for ($ = 1, I = new Array(V - 1); $ < V; $++)
        I[$ - 1] = arguments[$];
      G.fn.apply(G.context, I);
    } else {
      var ce = G.length, se;
      for ($ = 0; $ < ce; $++)
        switch (G[$].once && this.removeListener(b, G[$].fn, void 0, !0), V) {
          case 1:
            G[$].fn.call(G[$].context);
            break;
          case 2:
            G[$].fn.call(G[$].context, x);
            break;
          case 3:
            G[$].fn.call(G[$].context, x, T);
            break;
          case 4:
            G[$].fn.call(G[$].context, x, T, R);
            break;
          default:
            if (!I) for (se = 1, I = new Array(V - 1); se < V; se++)
              I[se - 1] = arguments[se];
            G[$].fn.apply(G[$].context, I);
        }
    }
    return !0;
  }, y.prototype.on = function(b, x, T) {
    return h(this, b, x, T, !1);
  }, y.prototype.once = function(b, x, T) {
    return h(this, b, x, T, !0);
  }, y.prototype.removeListener = function(b, x, T, R) {
    var E = a ? a + b : b;
    if (!this._events[E]) return this;
    if (!x)
      return d(this, E), this;
    var O = this._events[E];
    if (O.fn)
      O.fn === x && (!R || O.once) && (!T || O.context === T) && d(this, E);
    else {
      for (var L = 0, G = [], V = O.length; L < V; L++)
        (O[L].fn !== x || R && !O[L].once || T && O[L].context !== T) && G.push(O[L]);
      G.length ? this._events[E] = G.length === 1 ? G[0] : G : d(this, E);
    }
    return this;
  }, y.prototype.removeAllListeners = function(b) {
    var x;
    return b ? (x = a ? a + b : b, this._events[x] && d(this, x)) : (this._events = new i(), this._eventsCount = 0), this;
  }, y.prototype.off = y.prototype.removeListener, y.prototype.addListener = y.prototype.on, y.prefixed = a, y.EventEmitter = y, r.exports = y;
})(kS);
var PE = kS.exports, jv = { exports: {} }, KE = (r, t) => (t = t || (() => {
}), r.then(
  (a) => new Promise((i) => {
    i(t());
  }).then(() => a),
  (a) => new Promise((i) => {
    i(t());
  }).then(() => {
    throw a;
  })
));
const JE = KE;
let RS = class extends Error {
  constructor(t) {
    super(t), this.name = "TimeoutError";
  }
};
const zS = (r, t, a) => new Promise((i, s) => {
  if (typeof t != "number" || t < 0)
    throw new TypeError("Expected `milliseconds` to be a positive number");
  if (t === 1 / 0) {
    i(r);
    return;
  }
  const h = setTimeout(() => {
    if (typeof a == "function") {
      try {
        i(a());
      } catch (g) {
        s(g);
      }
      return;
    }
    const d = typeof a == "string" ? a : `Promise timed out after ${t} milliseconds`, y = a instanceof Error ? a : new RS(d);
    typeof r.cancel == "function" && r.cancel(), s(y);
  }, t);
  JE(
    // eslint-disable-next-line promise/prefer-await-to-then
    r.then(i, s),
    () => {
      clearTimeout(h);
    }
  );
});
jv.exports = zS;
jv.exports.default = zS;
jv.exports.TimeoutError = RS;
var WE = jv.exports, $5 = {}, X5 = {};
Object.defineProperty(X5, "__esModule", { value: !0 });
function eA(r, t, a) {
  let i = 0, s = r.length;
  for (; s > 0; ) {
    const h = s / 2 | 0;
    let d = i + h;
    a(r[d], t) <= 0 ? (i = ++d, s -= h + 1) : s = h;
  }
  return i;
}
X5.default = eA;
Object.defineProperty($5, "__esModule", { value: !0 });
const tA = X5;
let nA = class {
  constructor() {
    this._queue = [];
  }
  enqueue(t, a) {
    a = Object.assign({ priority: 0 }, a);
    const i = {
      priority: a.priority,
      run: t
    };
    if (this.size && this._queue[this.size - 1].priority >= a.priority) {
      this._queue.push(i);
      return;
    }
    const s = tA.default(this._queue, i, (h, d) => d.priority - h.priority);
    this._queue.splice(s, 0, i);
  }
  dequeue() {
    const t = this._queue.shift();
    return t == null ? void 0 : t.run;
  }
  filter(t) {
    return this._queue.filter((a) => a.priority === t.priority).map((a) => a.run);
  }
  get size() {
    return this._queue.length;
  }
};
$5.default = nA;
Object.defineProperty(AS, "__esModule", { value: !0 });
const rA = PE, CS = WE, aA = $5, ev = () => {
}, lA = new CS.TimeoutError();
let iA = class extends rA {
  constructor(t) {
    var a, i, s, h;
    if (super(), this._intervalCount = 0, this._intervalEnd = 0, this._pendingCount = 0, this._resolveEmpty = ev, this._resolveIdle = ev, t = Object.assign({ carryoverConcurrencyCount: !1, intervalCap: 1 / 0, interval: 0, concurrency: 1 / 0, autoStart: !0, queueClass: aA.default }, t), !(typeof t.intervalCap == "number" && t.intervalCap >= 1))
      throw new TypeError(`Expected \`intervalCap\` to be a number from 1 and up, got \`${(i = (a = t.intervalCap) === null || a === void 0 ? void 0 : a.toString()) !== null && i !== void 0 ? i : ""}\` (${typeof t.intervalCap})`);
    if (t.interval === void 0 || !(Number.isFinite(t.interval) && t.interval >= 0))
      throw new TypeError(`Expected \`interval\` to be a finite number >= 0, got \`${(h = (s = t.interval) === null || s === void 0 ? void 0 : s.toString()) !== null && h !== void 0 ? h : ""}\` (${typeof t.interval})`);
    this._carryoverConcurrencyCount = t.carryoverConcurrencyCount, this._isIntervalIgnored = t.intervalCap === 1 / 0 || t.interval === 0, this._intervalCap = t.intervalCap, this._interval = t.interval, this._queue = new t.queueClass(), this._queueClass = t.queueClass, this.concurrency = t.concurrency, this._timeout = t.timeout, this._throwOnTimeout = t.throwOnTimeout === !0, this._isPaused = t.autoStart === !1;
  }
  get _doesIntervalAllowAnother() {
    return this._isIntervalIgnored || this._intervalCount < this._intervalCap;
  }
  get _doesConcurrentAllowAnother() {
    return this._pendingCount < this._concurrency;
  }
  _next() {
    this._pendingCount--, this._tryToStartAnother(), this.emit("next");
  }
  _resolvePromises() {
    this._resolveEmpty(), this._resolveEmpty = ev, this._pendingCount === 0 && (this._resolveIdle(), this._resolveIdle = ev, this.emit("idle"));
  }
  _onResumeInterval() {
    this._onInterval(), this._initializeIntervalIfNeeded(), this._timeoutId = void 0;
  }
  _isIntervalPaused() {
    const t = Date.now();
    if (this._intervalId === void 0) {
      const a = this._intervalEnd - t;
      if (a < 0)
        this._intervalCount = this._carryoverConcurrencyCount ? this._pendingCount : 0;
      else
        return this._timeoutId === void 0 && (this._timeoutId = setTimeout(() => {
          this._onResumeInterval();
        }, a)), !0;
    }
    return !1;
  }
  _tryToStartAnother() {
    if (this._queue.size === 0)
      return this._intervalId && clearInterval(this._intervalId), this._intervalId = void 0, this._resolvePromises(), !1;
    if (!this._isPaused) {
      const t = !this._isIntervalPaused();
      if (this._doesIntervalAllowAnother && this._doesConcurrentAllowAnother) {
        const a = this._queue.dequeue();
        return a ? (this.emit("active"), a(), t && this._initializeIntervalIfNeeded(), !0) : !1;
      }
    }
    return !1;
  }
  _initializeIntervalIfNeeded() {
    this._isIntervalIgnored || this._intervalId !== void 0 || (this._intervalId = setInterval(() => {
      this._onInterval();
    }, this._interval), this._intervalEnd = Date.now() + this._interval);
  }
  _onInterval() {
    this._intervalCount === 0 && this._pendingCount === 0 && this._intervalId && (clearInterval(this._intervalId), this._intervalId = void 0), this._intervalCount = this._carryoverConcurrencyCount ? this._pendingCount : 0, this._processQueue();
  }
  /**
  Executes all queued functions until it reaches the limit.
  */
  _processQueue() {
    for (; this._tryToStartAnother(); )
      ;
  }
  get concurrency() {
    return this._concurrency;
  }
  set concurrency(t) {
    if (!(typeof t == "number" && t >= 1))
      throw new TypeError(`Expected \`concurrency\` to be a number from 1 and up, got \`${t}\` (${typeof t})`);
    this._concurrency = t, this._processQueue();
  }
  /**
  Adds a sync or async task to the queue. Always returns a promise.
  */
  async add(t, a = {}) {
    return new Promise((i, s) => {
      const h = async () => {
        this._pendingCount++, this._intervalCount++;
        try {
          const d = this._timeout === void 0 && a.timeout === void 0 ? t() : CS.default(Promise.resolve(t()), a.timeout === void 0 ? this._timeout : a.timeout, () => {
            (a.throwOnTimeout === void 0 ? this._throwOnTimeout : a.throwOnTimeout) && s(lA);
          });
          i(await d);
        } catch (d) {
          s(d);
        }
        this._next();
      };
      this._queue.enqueue(h, a), this._tryToStartAnother(), this.emit("add");
    });
  }
  /**
      Same as `.add()`, but accepts an array of sync or async functions.
  
      @returns A promise that resolves when all functions are resolved.
      */
  async addAll(t, a) {
    return Promise.all(t.map(async (i) => this.add(i, a)));
  }
  /**
  Start (or resume) executing enqueued tasks within concurrency limit. No need to call this if queue is not paused (via `options.autoStart = false` or by `.pause()` method.)
  */
  start() {
    return this._isPaused ? (this._isPaused = !1, this._processQueue(), this) : this;
  }
  /**
  Put queue execution on hold.
  */
  pause() {
    this._isPaused = !0;
  }
  /**
  Clear the queue.
  */
  clear() {
    this._queue = new this._queueClass();
  }
  /**
      Can be called multiple times. Useful if you for example add additional items at a later time.
  
      @returns A promise that settles when the queue becomes empty.
      */
  async onEmpty() {
    if (this._queue.size !== 0)
      return new Promise((t) => {
        const a = this._resolveEmpty;
        this._resolveEmpty = () => {
          a(), t();
        };
      });
  }
  /**
      The difference with `.onEmpty` is that `.onIdle` guarantees that all work from the queue has finished. `.onEmpty` merely signals that the queue is empty, but it could mean that some promises haven't completed yet.
  
      @returns A promise that settles when the queue becomes empty, and all promises have completed; `queue.size === 0 && queue.pending === 0`.
      */
  async onIdle() {
    if (!(this._pendingCount === 0 && this._queue.size === 0))
      return new Promise((t) => {
        const a = this._resolveIdle;
        this._resolveIdle = () => {
          a(), t();
        };
      });
  }
  /**
  Size of the queue.
  */
  get size() {
    return this._queue.size;
  }
  /**
      Size of the queue, filtered by the given options.
  
      For example, this can be used to find the number of items remaining in the queue with a specific priority level.
      */
  sizeBy(t) {
    return this._queue.filter(t).length;
  }
  /**
  Number of pending promises.
  */
  get pending() {
    return this._pendingCount;
  }
  /**
  Whether the queue is currently paused.
  */
  get isPaused() {
    return this._isPaused;
  }
  get timeout() {
    return this._timeout;
  }
  /**
  Set the timeout for future operations.
  */
  set timeout(t) {
    this._timeout = t;
  }
};
var k6 = AS.default = iA;
const uA = (...r) => fetch(...r), oA = Symbol.for("lg:fetch_implementation"), sA = () => globalThis[oA] ?? uA, cA = [
  400,
  // Bad Request
  401,
  // Unauthorized
  402,
  // Payment required
  403,
  // Forbidden
  404,
  // Not Found
  405,
  // Method Not Allowed
  406,
  // Not Acceptable
  407,
  // Proxy Authentication Required
  408,
  // Request Timeout
  409,
  // Conflict
  422
  // Unprocessable Entity
];
function fA(r) {
  return r == null || typeof r != "object" ? !1 : "status" in r && "statusText" in r && "text" in r;
}
class Ig extends Error {
  constructor(t, a, i) {
    super(`HTTP ${t}: ${a}`), Object.defineProperty(this, "status", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "text", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "response", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.status = t, this.text = a, this.response = i;
  }
  static async fromResponse(t, a) {
    try {
      return new Ig(t.status, await t.text(), a != null && a.includeResponse ? t : void 0);
    } catch {
      return new Ig(t.status, t.statusText, a != null && a.includeResponse ? t : void 0);
    }
  }
}
class hA {
  constructor(t) {
    Object.defineProperty(this, "maxConcurrency", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "maxRetries", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "queue", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "onFailedResponseHook", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "customFetch", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxConcurrency = t.maxConcurrency ?? 1 / 0, this.maxRetries = t.maxRetries ?? 4, "default" in k6 ? this.queue = new k6.default({
      concurrency: this.maxConcurrency
    }) : this.queue = new k6({ concurrency: this.maxConcurrency }), this.onFailedResponseHook = t == null ? void 0 : t.onFailedResponseHook, this.customFetch = t.fetch;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  call(t, ...a) {
    const i = this.onFailedResponseHook;
    return this.queue.add(() => FE(() => t(...a).catch(async (s) => {
      throw s instanceof Error ? s : fA(s) ? await Ig.fromResponse(s, {
        includeResponse: !!i
      }) : new Error(s);
    }), {
      async onFailedAttempt(s) {
        if (s.message.startsWith("Cancel") || s.message.startsWith("TimeoutError") || s.message.startsWith("AbortError") || (s == null ? void 0 : s.code) === "ECONNABORTED")
          throw s;
        if (s instanceof Ig) {
          if (cA.includes(s.status))
            throw s;
          i && s.response && await i(s.response);
        }
      },
      // If needed we can change some of the defaults here,
      // but they're quite sensible.
      retries: this.maxRetries,
      randomize: !0
    }), { throwOnTimeout: !0 });
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callWithOptions(t, a, ...i) {
    return t.signal ? Promise.race([
      this.call(a, ...i),
      new Promise((s, h) => {
        var d;
        (d = t.signal) == null || d.addEventListener("abort", () => {
          h(new Error("AbortError"));
        });
      })
    ]) : this.call(a, ...i);
  }
  fetch(...t) {
    const a = this.customFetch ?? sA();
    return this.call(() => a(...t).then((i) => i.ok ? i : Promise.reject(i)));
  }
}
var R6 = {};
function dA(r) {
  try {
    return typeof process < "u" ? (
      // eslint-disable-next-line no-process-env
      R6 == null ? void 0 : R6[r]
    ) : void 0;
  } catch {
    return;
  }
}
function mA(...r) {
  const t = r.filter((i) => i != null);
  if (t.length === 0)
    return;
  if (t.length === 1)
    return t[0];
  const a = new AbortController();
  for (const i of r) {
    if (i != null && i.aborted)
      return a.abort(i.reason), a.signal;
    i == null || i.addEventListener("abort", () => a.abort(i.reason), {
      once: !0
    });
  }
  return a.signal;
}
const Ug = 13, v5 = 10, pA = 0, i2 = 58, gA = 32, yA = [Ug, v5];
class u2 extends TransformStream {
  constructor() {
    let t = [], a = !1;
    super({
      start() {
        t = [], a = !1;
      },
      transform(i, s) {
        let h = i;
        if (a && (h = wv([[Ug], h]), a = !1), h.length > 0 && h.at(-1) === Ug && (a = !0, h = h.subarray(0, -1)), !h.length)
          return;
        const d = yA.includes(h.at(-1)), y = h.length - 1, { lines: g } = h.reduce((b, x, T) => (b.from > T || ((x === Ug || x === v5) && (b.lines.push(h.subarray(b.from, T)), x === Ug && h[T + 1] === v5 ? b.from = T + 2 : b.from = T + 1), T === y && b.from <= y && b.lines.push(h.subarray(b.from))), b), { lines: [], from: 0 });
        if (g.length === 1 && !d) {
          t.push(g[0]);
          return;
        }
        t.length && (t.push(g[0]), g[0] = wv(t), t = []), d || g.length && (t = [g.pop()]);
        for (const b of g)
          s.enqueue(b);
      },
      flush(i) {
        t.length && i.enqueue(wv(t));
      }
    });
  }
}
class o2 extends TransformStream {
  constructor() {
    let t = "", a = [], i = "", s = null;
    const h = new TextDecoder();
    super({
      transform(d, y) {
        if (!d.length) {
          if (!t && !a.length && !i && s == null)
            return;
          const T = {
            event: t,
            data: a.length ? s2(h, a) : null
          };
          t = "", a = [], s = null, y.enqueue(T);
          return;
        }
        if (d[0] === i2)
          return;
        const g = d.indexOf(i2);
        if (g === -1)
          return;
        const b = h.decode(d.subarray(0, g));
        let x = d.subarray(g + 1);
        if (x[0] === gA && (x = x.subarray(1)), b === "event")
          t = h.decode(x);
        else if (b === "data")
          a.push(x);
        else if (b === "id")
          x.indexOf(pA) === -1 && (i = h.decode(x));
        else if (b === "retry") {
          const T = Number.parseInt(h.decode(x));
          Number.isNaN(T) || (s = T);
        }
      },
      flush(d) {
        t && d.enqueue({
          event: t,
          data: a.length ? s2(h, a) : null
        });
      }
    });
  }
}
function wv(r) {
  const t = r.reduce((s, h) => s + h.length, 0);
  let a = new Uint8Array(t), i = 0;
  for (const s of r)
    a.set(s, i), i += s.length;
  return a;
}
function s2(r, t) {
  return JSON.parse(r.decode(wv(t)));
}
class $g extends ReadableStream {
  constructor() {
    super(...arguments), Object.defineProperty(this, "reader", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    });
  }
  ensureReader() {
    this.reader || (this.reader = this.getReader());
  }
  async next() {
    this.ensureReader();
    try {
      const t = await this.reader.read();
      return t.done ? (this.reader.releaseLock(), {
        done: !0,
        value: void 0
      }) : {
        done: !1,
        value: t.value
      };
    } catch (t) {
      throw this.reader.releaseLock(), t;
    }
  }
  async return() {
    if (this.ensureReader(), this.locked) {
      const t = this.reader.cancel();
      this.reader.releaseLock(), await t;
    }
    return { done: !0, value: void 0 };
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async throw(t) {
    if (this.ensureReader(), this.locked) {
      const a = this.reader.cancel();
      this.reader.releaseLock(), await a;
    }
    throw t;
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore Not present in Node 18 types, required in latest Node 22
  async [Symbol.asyncDispose]() {
    await this.return();
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  static fromReadableStream(t) {
    const a = t.getReader();
    return new $g({
      start(i) {
        return s();
        function s() {
          return a.read().then(({ done: h, value: d }) => {
            if (h) {
              i.close();
              return;
            }
            return i.enqueue(d), s();
          });
        }
      },
      cancel() {
        a.releaseLock();
      }
    });
  }
  static fromAsyncGenerator(t) {
    return new $g({
      async pull(a) {
        const { value: i, done: s } = await t.next();
        s && a.close(), a.enqueue(i);
      },
      async cancel(a) {
        await t.return(a);
      }
    });
  }
}
function vA(r) {
  if (r)
    return r;
  const t = ["LANGGRAPH", "LANGSMITH", "LANGCHAIN"];
  for (const a of t) {
    const i = dA(`${a}_API_KEY`);
    if (i)
      return i.trim().replace(/^["']|["']$/g, "");
  }
}
class zm {
  constructor(t) {
    var h;
    Object.defineProperty(this, "asyncCaller", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "timeoutMs", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "apiUrl", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "defaultHeaders", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    });
    const a = {
      maxRetries: 4,
      maxConcurrency: 4,
      ...t == null ? void 0 : t.callerOptions
    };
    let i = "http://localhost:8123";
    if (!(t != null && t.apiUrl) && typeof globalThis == "object" && globalThis != null) {
      const d = Symbol.for("langgraph_api:fetch"), y = Symbol.for("langgraph_api:url"), g = globalThis;
      g[d] && (a.fetch ?? (a.fetch = g[d])), g[y] && (i = g[y]);
    }
    this.asyncCaller = new hA(a), this.timeoutMs = t == null ? void 0 : t.timeoutMs, this.apiUrl = ((h = t == null ? void 0 : t.apiUrl) == null ? void 0 : h.replace(/\/$/, "")) || i, this.defaultHeaders = (t == null ? void 0 : t.defaultHeaders) || {};
    const s = vA(t == null ? void 0 : t.apiKey);
    s && (this.defaultHeaders["X-Api-Key"] = s);
  }
  prepareFetchOptions(t, a) {
    const i = {
      ...a,
      headers: { ...this.defaultHeaders, ...a == null ? void 0 : a.headers }
    };
    i.json && (i.body = JSON.stringify(i.json), i.headers = {
      ...i.headers,
      "Content-Type": "application/json"
    }, delete i.json);
    let s = null;
    typeof (a == null ? void 0 : a.timeoutMs) < "u" ? a.timeoutMs != null && (s = AbortSignal.timeout(a.timeoutMs)) : this.timeoutMs != null && (s = AbortSignal.timeout(this.timeoutMs)), i.signal = mA(s, i.signal);
    const h = new URL(`${this.apiUrl}${t}`);
    if (i.params) {
      for (const [d, y] of Object.entries(i.params)) {
        if (y == null)
          continue;
        let g = typeof y == "string" || typeof y == "number" ? y.toString() : JSON.stringify(y);
        h.searchParams.append(d, g);
      }
      delete i.params;
    }
    return [h, i];
  }
  async fetch(t, a) {
    const i = await this.asyncCaller.fetch(...this.prepareFetchOptions(t, a));
    if (!(i.status === 202 || i.status === 204))
      return i.json();
  }
}
class bA extends zm {
  /**
   *
   * @param threadId The ID of the thread.
   * @param assistantId Assistant ID to use for this cron job.
   * @param payload Payload for creating a cron job.
   * @returns The created background run.
   */
  async createForThread(t, a, i) {
    const s = {
      schedule: i == null ? void 0 : i.schedule,
      input: i == null ? void 0 : i.input,
      config: i == null ? void 0 : i.config,
      metadata: i == null ? void 0 : i.metadata,
      assistant_id: a,
      interrupt_before: i == null ? void 0 : i.interruptBefore,
      interrupt_after: i == null ? void 0 : i.interruptAfter,
      webhook: i == null ? void 0 : i.webhook,
      multitask_strategy: i == null ? void 0 : i.multitaskStrategy,
      if_not_exists: i == null ? void 0 : i.ifNotExists,
      checkpoint_during: i == null ? void 0 : i.checkpointDuring
    };
    return this.fetch(`/threads/${t}/runs/crons`, {
      method: "POST",
      json: s
    });
  }
  /**
   *
   * @param assistantId Assistant ID to use for this cron job.
   * @param payload Payload for creating a cron job.
   * @returns
   */
  async create(t, a) {
    const i = {
      schedule: a == null ? void 0 : a.schedule,
      input: a == null ? void 0 : a.input,
      config: a == null ? void 0 : a.config,
      metadata: a == null ? void 0 : a.metadata,
      assistant_id: t,
      interrupt_before: a == null ? void 0 : a.interruptBefore,
      interrupt_after: a == null ? void 0 : a.interruptAfter,
      webhook: a == null ? void 0 : a.webhook,
      multitask_strategy: a == null ? void 0 : a.multitaskStrategy,
      if_not_exists: a == null ? void 0 : a.ifNotExists,
      checkpoint_during: a == null ? void 0 : a.checkpointDuring
    };
    return this.fetch("/runs/crons", {
      method: "POST",
      json: i
    });
  }
  /**
   *
   * @param cronId Cron ID of Cron job to delete.
   */
  async delete(t) {
    await this.fetch(`/runs/crons/${t}`, {
      method: "DELETE"
    });
  }
  /**
   *
   * @param query Query options.
   * @returns List of crons.
   */
  async search(t) {
    return this.fetch("/runs/crons/search", {
      method: "POST",
      json: {
        assistant_id: (t == null ? void 0 : t.assistantId) ?? void 0,
        thread_id: (t == null ? void 0 : t.threadId) ?? void 0,
        limit: (t == null ? void 0 : t.limit) ?? 10,
        offset: (t == null ? void 0 : t.offset) ?? 0
      }
    });
  }
}
class SA extends zm {
  /**
   * Get an assistant by ID.
   *
   * @param assistantId The ID of the assistant.
   * @returns Assistant
   */
  async get(t) {
    return this.fetch(`/assistants/${t}`);
  }
  /**
   * Get the JSON representation of the graph assigned to a runnable
   * @param assistantId The ID of the assistant.
   * @param options.xray Whether to include subgraphs in the serialized graph representation. If an integer value is provided, only subgraphs with a depth less than or equal to the value will be included.
   * @returns Serialized graph
   */
  async getGraph(t, a) {
    return this.fetch(`/assistants/${t}/graph`, {
      params: { xray: a == null ? void 0 : a.xray }
    });
  }
  /**
   * Get the state and config schema of the graph assigned to a runnable
   * @param assistantId The ID of the assistant.
   * @returns Graph schema
   */
  async getSchemas(t) {
    return this.fetch(`/assistants/${t}/schemas`);
  }
  /**
   * Get the schemas of an assistant by ID.
   *
   * @param assistantId The ID of the assistant to get the schema of.
   * @param options Additional options for getting subgraphs, such as namespace or recursion extraction.
   * @returns The subgraphs of the assistant.
   */
  async getSubgraphs(t, a) {
    return a != null && a.namespace ? this.fetch(`/assistants/${t}/subgraphs/${a.namespace}`, { params: { recurse: a == null ? void 0 : a.recurse } }) : this.fetch(`/assistants/${t}/subgraphs`, {
      params: { recurse: a == null ? void 0 : a.recurse }
    });
  }
  /**
   * Create a new assistant.
   * @param payload Payload for creating an assistant.
   * @returns The created assistant.
   */
  async create(t) {
    return this.fetch("/assistants", {
      method: "POST",
      json: {
        graph_id: t.graphId,
        config: t.config,
        metadata: t.metadata,
        assistant_id: t.assistantId,
        if_exists: t.ifExists,
        name: t.name,
        description: t.description
      }
    });
  }
  /**
   * Update an assistant.
   * @param assistantId ID of the assistant.
   * @param payload Payload for updating the assistant.
   * @returns The updated assistant.
   */
  async update(t, a) {
    return this.fetch(`/assistants/${t}`, {
      method: "PATCH",
      json: {
        graph_id: a.graphId,
        config: a.config,
        metadata: a.metadata,
        name: a.name,
        description: a.description
      }
    });
  }
  /**
   * Delete an assistant.
   *
   * @param assistantId ID of the assistant.
   */
  async delete(t) {
    return this.fetch(`/assistants/${t}`, {
      method: "DELETE"
    });
  }
  /**
   * List assistants.
   * @param query Query options.
   * @returns List of assistants.
   */
  async search(t) {
    return this.fetch("/assistants/search", {
      method: "POST",
      json: {
        graph_id: (t == null ? void 0 : t.graphId) ?? void 0,
        metadata: (t == null ? void 0 : t.metadata) ?? void 0,
        limit: (t == null ? void 0 : t.limit) ?? 10,
        offset: (t == null ? void 0 : t.offset) ?? 0,
        sort_by: (t == null ? void 0 : t.sortBy) ?? void 0,
        sort_order: (t == null ? void 0 : t.sortOrder) ?? void 0
      }
    });
  }
  /**
   * List all versions of an assistant.
   *
   * @param assistantId ID of the assistant.
   * @returns List of assistant versions.
   */
  async getVersions(t, a) {
    return this.fetch(`/assistants/${t}/versions`, {
      method: "POST",
      json: {
        metadata: (a == null ? void 0 : a.metadata) ?? void 0,
        limit: (a == null ? void 0 : a.limit) ?? 10,
        offset: (a == null ? void 0 : a.offset) ?? 0
      }
    });
  }
  /**
   * Change the version of an assistant.
   *
   * @param assistantId ID of the assistant.
   * @param version The version to change to.
   * @returns The updated assistant.
   */
  async setLatest(t, a) {
    return this.fetch(`/assistants/${t}/latest`, {
      method: "POST",
      json: { version: a }
    });
  }
}
class xA extends zm {
  /**
   * Get a thread by ID.
   *
   * @param threadId ID of the thread.
   * @returns The thread.
   */
  async get(t) {
    return this.fetch(`/threads/${t}`);
  }
  /**
   * Create a new thread.
   *
   * @param payload Payload for creating a thread.
   * @returns The created thread.
   */
  async create(t) {
    var a;
    return this.fetch("/threads", {
      method: "POST",
      json: {
        metadata: {
          ...t == null ? void 0 : t.metadata,
          graph_id: t == null ? void 0 : t.graphId
        },
        thread_id: t == null ? void 0 : t.threadId,
        if_exists: t == null ? void 0 : t.ifExists,
        supersteps: (a = t == null ? void 0 : t.supersteps) == null ? void 0 : a.map((i) => ({
          updates: i.updates.map((s) => ({
            values: s.values,
            command: s.command,
            as_node: s.asNode
          }))
        }))
      }
    });
  }
  /**
   * Copy an existing thread
   * @param threadId ID of the thread to be copied
   * @returns Newly copied thread
   */
  async copy(t) {
    return this.fetch(`/threads/${t}/copy`, {
      method: "POST"
    });
  }
  /**
   * Update a thread.
   *
   * @param threadId ID of the thread.
   * @param payload Payload for updating the thread.
   * @returns The updated thread.
   */
  async update(t, a) {
    return this.fetch(`/threads/${t}`, {
      method: "PATCH",
      json: { metadata: a == null ? void 0 : a.metadata }
    });
  }
  /**
   * Delete a thread.
   *
   * @param threadId ID of the thread.
   */
  async delete(t) {
    return this.fetch(`/threads/${t}`, {
      method: "DELETE"
    });
  }
  /**
   * List threads
   *
   * @param query Query options
   * @returns List of threads
   */
  async search(t) {
    return this.fetch("/threads/search", {
      method: "POST",
      json: {
        metadata: (t == null ? void 0 : t.metadata) ?? void 0,
        limit: (t == null ? void 0 : t.limit) ?? 10,
        offset: (t == null ? void 0 : t.offset) ?? 0,
        status: t == null ? void 0 : t.status,
        sort_by: t == null ? void 0 : t.sortBy,
        sort_order: t == null ? void 0 : t.sortOrder
      }
    });
  }
  /**
   * Get state for a thread.
   *
   * @param threadId ID of the thread.
   * @returns Thread state.
   */
  async getState(t, a, i) {
    return a != null ? typeof a != "string" ? this.fetch(`/threads/${t}/state/checkpoint`, {
      method: "POST",
      json: { checkpoint: a, subgraphs: i == null ? void 0 : i.subgraphs }
    }) : this.fetch(`/threads/${t}/state/${a}`, { params: { subgraphs: i == null ? void 0 : i.subgraphs } }) : this.fetch(`/threads/${t}/state`, {
      params: { subgraphs: i == null ? void 0 : i.subgraphs }
    });
  }
  /**
   * Add state to a thread.
   *
   * @param threadId The ID of the thread.
   * @returns
   */
  async updateState(t, a) {
    return this.fetch(`/threads/${t}/state`, {
      method: "POST",
      json: {
        values: a.values,
        checkpoint_id: a.checkpointId,
        checkpoint: a.checkpoint,
        as_node: a == null ? void 0 : a.asNode
      }
    });
  }
  /**
   * Patch the metadata of a thread.
   *
   * @param threadIdOrConfig Thread ID or config to patch the state of.
   * @param metadata Metadata to patch the state with.
   */
  async patchState(t, a) {
    var s;
    let i;
    if (typeof t != "string") {
      if (typeof ((s = t.configurable) == null ? void 0 : s.thread_id) != "string")
        throw new Error("Thread ID is required when updating state with a config.");
      i = t.configurable.thread_id;
    } else
      i = t;
    return this.fetch(`/threads/${i}/state`, {
      method: "PATCH",
      json: { metadata: a }
    });
  }
  /**
   * Get all past states for a thread.
   *
   * @param threadId ID of the thread.
   * @param options Additional options.
   * @returns List of thread states.
   */
  async getHistory(t, a) {
    return this.fetch(`/threads/${t}/history`, {
      method: "POST",
      json: {
        limit: (a == null ? void 0 : a.limit) ?? 10,
        before: a == null ? void 0 : a.before,
        metadata: a == null ? void 0 : a.metadata,
        checkpoint: a == null ? void 0 : a.checkpoint
      }
    });
  }
}
class wA extends zm {
  /**
   * Create a run and stream the results.
   *
   * @param threadId The ID of the thread.
   * @param assistantId Assistant ID to use for this run.
   * @param payload Payload for creating a run.
   */
  async *stream(t, a, i) {
    const s = {
      input: i == null ? void 0 : i.input,
      command: i == null ? void 0 : i.command,
      config: i == null ? void 0 : i.config,
      metadata: i == null ? void 0 : i.metadata,
      stream_mode: i == null ? void 0 : i.streamMode,
      stream_subgraphs: i == null ? void 0 : i.streamSubgraphs,
      feedback_keys: i == null ? void 0 : i.feedbackKeys,
      assistant_id: a,
      interrupt_before: i == null ? void 0 : i.interruptBefore,
      interrupt_after: i == null ? void 0 : i.interruptAfter,
      checkpoint: i == null ? void 0 : i.checkpoint,
      checkpoint_id: i == null ? void 0 : i.checkpointId,
      webhook: i == null ? void 0 : i.webhook,
      multitask_strategy: i == null ? void 0 : i.multitaskStrategy,
      on_completion: i == null ? void 0 : i.onCompletion,
      on_disconnect: i == null ? void 0 : i.onDisconnect,
      after_seconds: i == null ? void 0 : i.afterSeconds,
      if_not_exists: i == null ? void 0 : i.ifNotExists,
      checkpoint_during: i == null ? void 0 : i.checkpointDuring
    }, h = t == null ? "/runs/stream" : `/threads/${t}/runs/stream`, y = ((await this.asyncCaller.fetch(...this.prepareFetchOptions(h, {
      method: "POST",
      json: s,
      timeoutMs: null,
      signal: i == null ? void 0 : i.signal
    }))).body || new ReadableStream({ start: (g) => g.close() })).pipeThrough(new u2()).pipeThrough(new o2());
    yield* $g.fromReadableStream(y);
  }
  /**
   * Create a run.
   *
   * @param threadId The ID of the thread.
   * @param assistantId Assistant ID to use for this run.
   * @param payload Payload for creating a run.
   * @returns The created run.
   */
  async create(t, a, i) {
    const s = {
      input: i == null ? void 0 : i.input,
      command: i == null ? void 0 : i.command,
      config: i == null ? void 0 : i.config,
      metadata: i == null ? void 0 : i.metadata,
      stream_mode: i == null ? void 0 : i.streamMode,
      stream_subgraphs: i == null ? void 0 : i.streamSubgraphs,
      assistant_id: a,
      interrupt_before: i == null ? void 0 : i.interruptBefore,
      interrupt_after: i == null ? void 0 : i.interruptAfter,
      webhook: i == null ? void 0 : i.webhook,
      checkpoint: i == null ? void 0 : i.checkpoint,
      checkpoint_id: i == null ? void 0 : i.checkpointId,
      multitask_strategy: i == null ? void 0 : i.multitaskStrategy,
      after_seconds: i == null ? void 0 : i.afterSeconds,
      if_not_exists: i == null ? void 0 : i.ifNotExists,
      checkpoint_during: i == null ? void 0 : i.checkpointDuring
    };
    return this.fetch(`/threads/${t}/runs`, {
      method: "POST",
      json: s,
      signal: i == null ? void 0 : i.signal
    });
  }
  /**
   * Create a batch of stateless background runs.
   *
   * @param payloads An array of payloads for creating runs.
   * @returns An array of created runs.
   */
  async createBatch(t) {
    const a = t.map((i) => ({ ...i, assistant_id: i.assistantId })).map((i) => Object.fromEntries(Object.entries(i).filter(([s, h]) => h !== void 0)));
    return this.fetch("/runs/batch", {
      method: "POST",
      json: a
    });
  }
  /**
   * Create a run and wait for it to complete.
   *
   * @param threadId The ID of the thread.
   * @param assistantId Assistant ID to use for this run.
   * @param payload Payload for creating a run.
   * @returns The last values chunk of the thread.
   */
  async wait(t, a, i) {
    var g, b;
    const s = {
      input: i == null ? void 0 : i.input,
      command: i == null ? void 0 : i.command,
      config: i == null ? void 0 : i.config,
      metadata: i == null ? void 0 : i.metadata,
      assistant_id: a,
      interrupt_before: i == null ? void 0 : i.interruptBefore,
      interrupt_after: i == null ? void 0 : i.interruptAfter,
      checkpoint: i == null ? void 0 : i.checkpoint,
      checkpoint_id: i == null ? void 0 : i.checkpointId,
      webhook: i == null ? void 0 : i.webhook,
      multitask_strategy: i == null ? void 0 : i.multitaskStrategy,
      on_completion: i == null ? void 0 : i.onCompletion,
      on_disconnect: i == null ? void 0 : i.onDisconnect,
      after_seconds: i == null ? void 0 : i.afterSeconds,
      if_not_exists: i == null ? void 0 : i.ifNotExists,
      checkpoint_during: i == null ? void 0 : i.checkpointDuring
    }, h = t == null ? "/runs/wait" : `/threads/${t}/runs/wait`, d = await this.fetch(h, {
      method: "POST",
      json: s,
      timeoutMs: null,
      signal: i == null ? void 0 : i.signal
    });
    if (((i == null ? void 0 : i.raiseError) !== void 0 ? i.raiseError : !0) && "__error__" in d && typeof d.__error__ == "object" && d.__error__ && "error" in d.__error__ && "message" in d.__error__)
      throw new Error(`${(g = d.__error__) == null ? void 0 : g.error}: ${(b = d.__error__) == null ? void 0 : b.message}`);
    return d;
  }
  /**
   * List all runs for a thread.
   *
   * @param threadId The ID of the thread.
   * @param options Filtering and pagination options.
   * @returns List of runs.
   */
  async list(t, a) {
    return this.fetch(`/threads/${t}/runs`, {
      params: {
        limit: (a == null ? void 0 : a.limit) ?? 10,
        offset: (a == null ? void 0 : a.offset) ?? 0,
        status: (a == null ? void 0 : a.status) ?? void 0
      }
    });
  }
  /**
   * Get a run by ID.
   *
   * @param threadId The ID of the thread.
   * @param runId The ID of the run.
   * @returns The run.
   */
  async get(t, a) {
    return this.fetch(`/threads/${t}/runs/${a}`);
  }
  /**
   * Cancel a run.
   *
   * @param threadId The ID of the thread.
   * @param runId The ID of the run.
   * @param wait Whether to block when canceling
   * @param action Action to take when cancelling the run. Possible values are `interrupt` or `rollback`. Default is `interrupt`.
   * @returns
   */
  async cancel(t, a, i = !1, s = "interrupt") {
    return this.fetch(`/threads/${t}/runs/${a}/cancel`, {
      method: "POST",
      params: {
        wait: i ? "1" : "0",
        action: s
      }
    });
  }
  /**
   * Block until a run is done.
   *
   * @param threadId The ID of the thread.
   * @param runId The ID of the run.
   * @returns
   */
  async join(t, a, i) {
    return this.fetch(`/threads/${t}/runs/${a}/join`, {
      timeoutMs: null,
      signal: i == null ? void 0 : i.signal
    });
  }
  /**
   * Stream output from a run in real-time, until the run is done.
   * Output is not buffered, so any output produced before this call will
   * not be received here.
   *
   * @param threadId The ID of the thread.
   * @param runId The ID of the run.
   * @param options Additional options for controlling the stream behavior:
   *   - signal: An AbortSignal that can be used to cancel the stream request
   *   - cancelOnDisconnect: When true, automatically cancels the run if the client disconnects from the stream
   *   - streamMode: Controls what types of events to receive from the stream (can be a single mode or array of modes)
   *        Must be a subset of the stream modes passed when creating the run. Background runs default to having the union of all
   *        stream modes enabled.
   * @returns An async generator yielding stream parts.
   */
  async *joinStream(t, a, i) {
    const s = typeof i == "object" && i != null && i instanceof AbortSignal ? { signal: i } : i, d = ((await this.asyncCaller.fetch(...this.prepareFetchOptions(`/threads/${t}/runs/${a}/stream`, {
      method: "GET",
      timeoutMs: null,
      signal: s == null ? void 0 : s.signal,
      params: {
        cancel_on_disconnect: s != null && s.cancelOnDisconnect ? "1" : "0",
        stream_mode: s == null ? void 0 : s.streamMode
      }
    }))).body || new ReadableStream({ start: (y) => y.close() })).pipeThrough(new u2()).pipeThrough(new o2());
    yield* $g.fromReadableStream(d);
  }
  /**
   * Delete a run.
   *
   * @param threadId The ID of the thread.
   * @param runId The ID of the run.
   * @returns
   */
  async delete(t, a) {
    return this.fetch(`/threads/${t}/runs/${a}`, {
      method: "DELETE"
    });
  }
}
class TA extends zm {
  /**
   * Store or update an item.
   *
   * @param namespace A list of strings representing the namespace path.
   * @param key The unique identifier for the item within the namespace.
   * @param value A dictionary containing the item's data.
   * @param options.index Controls search indexing - null (use defaults), false (disable), or list of field paths to index.
   * @param options.ttl Optional time-to-live in minutes for the item, or null for no expiration.
   * @returns Promise<void>
   *
   * @example
   * ```typescript
   * await client.store.putItem(
   *   ["documents", "user123"],
   *   "item456",
   *   { title: "My Document", content: "Hello World" },
   *   { ttl: 60 } // expires in 60 minutes
   * );
   * ```
   */
  async putItem(t, a, i, s) {
    t.forEach((d) => {
      if (d.includes("."))
        throw new Error(`Invalid namespace label '${d}'. Namespace labels cannot contain periods ('.')`);
    });
    const h = {
      namespace: t,
      key: a,
      value: i,
      index: s == null ? void 0 : s.index,
      ttl: s == null ? void 0 : s.ttl
    };
    return this.fetch("/store/items", {
      method: "PUT",
      json: h
    });
  }
  /**
   * Retrieve a single item.
   *
   * @param namespace A list of strings representing the namespace path.
   * @param key The unique identifier for the item.
   * @param options.refreshTtl Whether to refresh the TTL on this read operation. If null, uses the store's default behavior.
   * @returns Promise<Item>
   *
   * @example
   * ```typescript
   * const item = await client.store.getItem(
   *   ["documents", "user123"],
   *   "item456",
   *   { refreshTtl: true }
   * );
   * console.log(item);
   * // {
   * //   namespace: ["documents", "user123"],
   * //   key: "item456",
   * //   value: { title: "My Document", content: "Hello World" },
   * //   createdAt: "2024-07-30T12:00:00Z",
   * //   updatedAt: "2024-07-30T12:00:00Z"
   * // }
   * ```
   */
  async getItem(t, a, i) {
    t.forEach((d) => {
      if (d.includes("."))
        throw new Error(`Invalid namespace label '${d}'. Namespace labels cannot contain periods ('.')`);
    });
    const s = {
      namespace: t.join("."),
      key: a
    };
    (i == null ? void 0 : i.refreshTtl) !== void 0 && (s.refresh_ttl = i.refreshTtl);
    const h = await this.fetch("/store/items", {
      params: s
    });
    return h ? {
      ...h,
      createdAt: h.created_at,
      updatedAt: h.updated_at
    } : null;
  }
  /**
   * Delete an item.
   *
   * @param namespace A list of strings representing the namespace path.
   * @param key The unique identifier for the item.
   * @returns Promise<void>
   */
  async deleteItem(t, a) {
    return t.forEach((i) => {
      if (i.includes("."))
        throw new Error(`Invalid namespace label '${i}'. Namespace labels cannot contain periods ('.')`);
    }), this.fetch("/store/items", {
      method: "DELETE",
      json: { namespace: t, key: a }
    });
  }
  /**
   * Search for items within a namespace prefix.
   *
   * @param namespacePrefix List of strings representing the namespace prefix.
   * @param options.filter Optional dictionary of key-value pairs to filter results.
   * @param options.limit Maximum number of items to return (default is 10).
   * @param options.offset Number of items to skip before returning results (default is 0).
   * @param options.query Optional search query.
   * @param options.refreshTtl Whether to refresh the TTL on items returned by this search. If null, uses the store's default behavior.
   * @returns Promise<SearchItemsResponse>
   *
   * @example
   * ```typescript
   * const results = await client.store.searchItems(
   *   ["documents"],
   *   {
   *     filter: { author: "John Doe" },
   *     limit: 5,
   *     refreshTtl: true
   *   }
   * );
   * console.log(results);
   * // {
   * //   items: [
   * //     {
   * //       namespace: ["documents", "user123"],
   * //       key: "item789",
   * //       value: { title: "Another Document", author: "John Doe" },
   * //       createdAt: "2024-07-30T12:00:00Z",
   * //       updatedAt: "2024-07-30T12:00:00Z"
   * //     },
   * //     // ... additional items ...
   * //   ]
   * // }
   * ```
   */
  async searchItems(t, a) {
    const i = {
      namespace_prefix: t,
      filter: a == null ? void 0 : a.filter,
      limit: (a == null ? void 0 : a.limit) ?? 10,
      offset: (a == null ? void 0 : a.offset) ?? 0,
      query: a == null ? void 0 : a.query,
      refresh_ttl: a == null ? void 0 : a.refreshTtl
    };
    return {
      items: (await this.fetch("/store/items/search", {
        method: "POST",
        json: i
      })).items.map((h) => ({
        ...h,
        createdAt: h.created_at,
        updatedAt: h.updated_at
      }))
    };
  }
  /**
   * List namespaces with optional match conditions.
   *
   * @param options.prefix Optional list of strings representing the prefix to filter namespaces.
   * @param options.suffix Optional list of strings representing the suffix to filter namespaces.
   * @param options.maxDepth Optional integer specifying the maximum depth of namespaces to return.
   * @param options.limit Maximum number of namespaces to return (default is 100).
   * @param options.offset Number of namespaces to skip before returning results (default is 0).
   * @returns Promise<ListNamespaceResponse>
   */
  async listNamespaces(t) {
    const a = {
      prefix: t == null ? void 0 : t.prefix,
      suffix: t == null ? void 0 : t.suffix,
      max_depth: t == null ? void 0 : t.maxDepth,
      limit: (t == null ? void 0 : t.limit) ?? 100,
      offset: (t == null ? void 0 : t.offset) ?? 0
    };
    return this.fetch("/store/namespaces", {
      method: "POST",
      json: a
    });
  }
}
class Jf extends zm {
  static getOrCached(t, a) {
    if (Jf.promiseCache[t] != null)
      return Jf.promiseCache[t];
    const i = a();
    return Jf.promiseCache[t] = i, i;
  }
  async getComponent(t, a) {
    return Jf.getOrCached(`${this.apiUrl}-${t}-${a}`, async () => (await this.asyncCaller.fetch(...this.prepareFetchOptions(`/ui/${t}`, {
      headers: {
        Accept: "text/html",
        "Content-Type": "application/json"
      },
      method: "POST",
      json: { name: a }
    }))).text());
  }
}
Object.defineProperty(Jf, "promiseCache", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: {}
});
class EA {
  constructor(t) {
    Object.defineProperty(this, "assistants", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "threads", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "runs", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "crons", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "store", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "~ui", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.assistants = new SA(t), this.threads = new xA(t), this.runs = new wA(t), this.crons = new bA(t), this.store = new TA(t), this["~ui"] = new Jf(t);
  }
}
function AA(r) {
  if (typeof r > "u")
    return null;
  try {
    return JSON.parse(r);
  } catch {
  }
  let t = "";
  const a = [];
  let i = !1, s = !1;
  for (let h of r) {
    if (i)
      h === '"' && !s ? i = !1 : h === `
` && !s ? h = "\\n" : h === "\\" ? s = !s : s = !1;
    else if (h === '"')
      i = !0, s = !1;
    else if (h === "{")
      a.push("}");
    else if (h === "[")
      a.push("]");
    else if (h === "}" || h === "]")
      if (a && a[a.length - 1] === h)
        a.pop();
      else
        return null;
    t += h;
  }
  i && (t += '"');
  for (let h = a.length - 1; h >= 0; h -= 1)
    t += a[h];
  try {
    return JSON.parse(t);
  } catch {
    return null;
  }
}
var kA = function(r, t) {
  if (typeof r != "string")
    throw new TypeError("Expected a string");
  return t = typeof t > "u" ? "_" : t, r.replace(/([a-z\d])([A-Z])/g, "$1" + t + "$2").replace(/([A-Z]+)([A-Z][a-z\d]+)/g, "$1" + t + "$2").toLowerCase();
};
const RA = /* @__PURE__ */ eh(kA);
var MS = { exports: {} };
const zA = /[\p{Lu}]/u, CA = /[\p{Ll}]/u, c2 = /^[\p{Lu}](?![\p{Lu}])/gu, _S = /([\p{Alpha}\p{N}_]|$)/u, OS = /[_.\- ]+/, MA = new RegExp("^" + OS.source), f2 = new RegExp(OS.source + _S.source, "gu"), h2 = new RegExp("\\d+" + _S.source, "gu"), _A = (r, t, a) => {
  let i = !1, s = !1, h = !1;
  for (let d = 0; d < r.length; d++) {
    const y = r[d];
    i && zA.test(y) ? (r = r.slice(0, d) + "-" + r.slice(d), i = !1, h = s, s = !0, d++) : s && h && CA.test(y) ? (r = r.slice(0, d - 1) + "-" + r.slice(d - 1), h = s, s = !1, i = !0) : (i = t(y) === y && a(y) !== y, h = s, s = a(y) === y && t(y) !== y);
  }
  return r;
}, OA = (r, t) => (c2.lastIndex = 0, r.replace(c2, (a) => t(a))), DA = (r, t) => (f2.lastIndex = 0, h2.lastIndex = 0, r.replace(f2, (a, i) => t(i)).replace(h2, (a) => t(a))), DS = (r, t) => {
  if (!(typeof r == "string" || Array.isArray(r)))
    throw new TypeError("Expected the input to be `string | string[]`");
  if (t = {
    pascalCase: !1,
    preserveConsecutiveUppercase: !1,
    ...t
  }, Array.isArray(r) ? r = r.map((h) => h.trim()).filter((h) => h.length).join("-") : r = r.trim(), r.length === 0)
    return "";
  const a = t.locale === !1 ? (h) => h.toLowerCase() : (h) => h.toLocaleLowerCase(t.locale), i = t.locale === !1 ? (h) => h.toUpperCase() : (h) => h.toLocaleUpperCase(t.locale);
  return r.length === 1 ? t.pascalCase ? i(r) : a(r) : (r !== a(r) && (r = _A(r, a, i)), r = r.replace(MA, ""), t.preserveConsecutiveUppercase ? r = OA(r, a) : r = a(r), t.pascalCase && (r = i(r.charAt(0)) + r.slice(1)), DA(r, i));
};
MS.exports = DS;
MS.exports.default = DS;
function NA(r, t) {
  return (t == null ? void 0 : t[r]) || RA(r);
}
function LA(r, t, a) {
  const i = {};
  for (const s in r)
    Object.hasOwn(r, s) && (i[t(s, a)] = r[s]);
  return i;
}
function d2(r) {
  return Array.isArray(r) ? [...r] : { ...r };
}
function BA(r, t) {
  const a = d2(r);
  for (const [i, s] of Object.entries(t)) {
    const [h, ...d] = i.split(".").reverse();
    let y = a;
    for (const g of d.reverse()) {
      if (y[g] === void 0)
        break;
      y[g] = d2(y[g]), y = y[g];
    }
    y[h] !== void 0 && (y[h] = {
      lc: 1,
      type: "secret",
      id: [s]
    });
  }
  return a;
}
function HA(r) {
  const t = Object.getPrototypeOf(r);
  return typeof r.lc_name == "function" && (typeof t.lc_name != "function" || r.lc_name() !== t.lc_name()) ? r.lc_name() : r.name;
}
class Q5 {
  /**
   * The name of the serializable. Override to provide an alias or
   * to preserve the serialized module name in minified environments.
   *
   * Implemented as a static method to support loading logic.
   */
  static lc_name() {
    return this.name;
  }
  /**
   * The final serialized identifier for the module.
   */
  get lc_id() {
    return [
      ...this.lc_namespace,
      HA(this.constructor)
    ];
  }
  /**
   * A map of secrets, which will be omitted from serialization.
   * Keys are paths to the secret in constructor args, e.g. "foo.bar.baz".
   * Values are the secret ids, which will be used when deserializing.
   */
  get lc_secrets() {
  }
  /**
   * A map of additional attributes to merge with constructor args.
   * Keys are the attribute names, e.g. "foo".
   * Values are the attribute values, which will be serialized.
   * These attributes need to be accepted by the constructor as arguments.
   */
  get lc_attributes() {
  }
  /**
   * A map of aliases for constructor args.
   * Keys are the attribute names, e.g. "foo".
   * Values are the alias that will replace the key in serialization.
   * This is used to eg. make argument names match Python.
   */
  get lc_aliases() {
  }
  /**
   * A manual list of keys that should be serialized.
   * If not overridden, all fields passed into the constructor will be serialized.
   */
  get lc_serializable_keys() {
  }
  constructor(t, ...a) {
    Object.defineProperty(this, "lc_serializable", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: !1
    }), Object.defineProperty(this, "lc_kwargs", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.lc_serializable_keys !== void 0 ? this.lc_kwargs = Object.fromEntries(Object.entries(t || {}).filter(([i]) => {
      var s;
      return (s = this.lc_serializable_keys) == null ? void 0 : s.includes(i);
    })) : this.lc_kwargs = t ?? {};
  }
  toJSON() {
    if (!this.lc_serializable)
      return this.toJSONNotImplemented();
    if (
      // eslint-disable-next-line no-instanceof/no-instanceof
      this.lc_kwargs instanceof Q5 || typeof this.lc_kwargs != "object" || Array.isArray(this.lc_kwargs)
    )
      return this.toJSONNotImplemented();
    const t = {}, a = {}, i = Object.keys(this.lc_kwargs).reduce((s, h) => (s[h] = h in this ? this[h] : this.lc_kwargs[h], s), {});
    for (let s = Object.getPrototypeOf(this); s; s = Object.getPrototypeOf(s))
      Object.assign(t, Reflect.get(s, "lc_aliases", this)), Object.assign(a, Reflect.get(s, "lc_secrets", this)), Object.assign(i, Reflect.get(s, "lc_attributes", this));
    return Object.keys(a).forEach((s) => {
      let h = this, d = i;
      const [y, ...g] = s.split(".").reverse();
      for (const b of g.reverse()) {
        if (!(b in h) || h[b] === void 0)
          return;
        (!(b in d) || d[b] === void 0) && (typeof h[b] == "object" && h[b] != null ? d[b] = {} : Array.isArray(h[b]) && (d[b] = [])), h = h[b], d = d[b];
      }
      y in h && h[y] !== void 0 && (d[y] = d[y] || h[y]);
    }), {
      lc: 1,
      type: "constructor",
      id: this.lc_id,
      kwargs: LA(Object.keys(a).length ? BA(i, a) : i, NA, t)
    };
  }
  toJSONNotImplemented() {
    return {
      lc: 1,
      type: "not_implemented",
      id: this.lc_id
    };
  }
}
function m2(r) {
  return typeof r == "object" && r !== null && "type" in r && typeof r.type == "string" && "source_type" in r && (r.source_type === "url" || r.source_type === "base64" || r.source_type === "text" || r.source_type === "id");
}
function Jg(r, t) {
  return typeof r == "string" ? r === "" ? t : typeof t == "string" ? r + t : Array.isArray(t) && t.some((a) => m2(a)) ? [
    {
      type: "text",
      source_type: "text",
      text: r
    },
    ...t
  ] : [{ type: "text", text: r }, ...t] : Array.isArray(t) ? Z5(r, t) ?? [
    ...r,
    ...t
  ] : t === "" ? r : Array.isArray(r) && r.some((a) => m2(a)) ? [
    ...r,
    {
      type: "file",
      source_type: "text",
      text: t
    }
  ] : [...r, { type: "text", text: t }];
}
function UA(r, t) {
  function a(i, s) {
    if (typeof i != "object" || i === null || i === void 0)
      return i;
    if (s >= t)
      return Array.isArray(i) ? "[Array]" : "[Object]";
    if (Array.isArray(i))
      return i.map((d) => a(d, s + 1));
    const h = {};
    for (const d of Object.keys(i))
      h[d] = a(i[d], s + 1);
    return h;
  }
  return JSON.stringify(a(r, 0), null, 2);
}
class Cm extends Q5 {
  get lc_aliases() {
    return {
      additional_kwargs: "additional_kwargs",
      response_metadata: "response_metadata"
    };
  }
  /**
   * Get text content of the message.
   */
  get text() {
    return typeof this.content == "string" ? this.content : Array.isArray(this.content) ? this.content.map((t) => typeof t == "string" ? t : t.type === "text" ? t.text : "").join("") : "";
  }
  /** The type of the message. */
  getType() {
    return this._getType();
  }
  constructor(t, a) {
    typeof t == "string" && (t = {
      content: t,
      additional_kwargs: a,
      response_metadata: {}
    }), t.additional_kwargs || (t.additional_kwargs = {}), t.response_metadata || (t.response_metadata = {}), super(t), Object.defineProperty(this, "lc_namespace", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: ["langchain_core", "messages"]
    }), Object.defineProperty(this, "lc_serializable", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: !0
    }), Object.defineProperty(this, "content", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "additional_kwargs", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "response_metadata", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "id", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = t.name, this.content = t.content, this.additional_kwargs = t.additional_kwargs, this.response_metadata = t.response_metadata, this.id = t.id;
  }
  toDict() {
    return {
      type: this._getType(),
      data: this.toJSON().kwargs
    };
  }
  static lc_name() {
    return "BaseMessage";
  }
  // Can't be protected for silly reasons
  get _printableFields() {
    return {
      id: this.id,
      content: this.content,
      name: this.name,
      additional_kwargs: this.additional_kwargs,
      response_metadata: this.response_metadata
    };
  }
  // this private method is used to update the ID for the runtime
  // value as well as in lc_kwargs for serialisation
  _updateId(t) {
    this.id = t, this.lc_kwargs.id = t;
  }
  get [Symbol.toStringTag]() {
    return this.constructor.lc_name();
  }
  // Override the default behavior of console.log
  [Symbol.for("nodejs.util.inspect.custom")](t) {
    if (t === null)
      return this;
    const a = UA(this._printableFields, Math.max(4, t));
    return `${this.constructor.lc_name()} ${a}`;
  }
}
function Hi(r, t) {
  const a = { ...r };
  for (const [i, s] of Object.entries(t))
    if (a[i] == null)
      a[i] = s;
    else {
      if (s == null)
        continue;
      if (typeof a[i] != typeof s || Array.isArray(a[i]) !== Array.isArray(s))
        throw new Error(`field[${i}] already exists in the message chunk, but with a different type.`);
      if (typeof a[i] == "string") {
        if (i === "type")
          continue;
        a[i] += s;
      } else if (typeof a[i] == "object" && !Array.isArray(a[i]))
        a[i] = Hi(a[i], s);
      else if (Array.isArray(a[i]))
        a[i] = Z5(a[i], s);
      else {
        if (a[i] === s)
          continue;
        console.warn(`field[${i}] already exists in this message chunk and value has unsupported type.`);
      }
    }
  return a;
}
function Z5(r, t) {
  if (!(r === void 0 && t === void 0)) {
    if (r === void 0 || t === void 0)
      return r || t;
    {
      const a = [...r];
      for (const i of t)
        if (typeof i == "object" && "index" in i && typeof i.index == "number") {
          const s = a.findIndex((h) => h.index === i.index);
          s !== -1 ? a[s] = Hi(a[s], i) : a.push(i);
        } else {
          if (typeof i == "object" && "text" in i && i.text === "")
            continue;
          a.push(i);
        }
      return a;
    }
  }
}
class Wg extends Cm {
}
function qA(r) {
  return typeof r.role == "string";
}
function NS(r) {
  return typeof (r == null ? void 0 : r._getType) == "function";
}
function jA(r) {
  return NS(r) && typeof r.concat == "function";
}
class GA extends Cm {
  static lc_name() {
    return "ToolMessage";
  }
  get lc_aliases() {
    return { tool_call_id: "tool_call_id" };
  }
  constructor(t, a, i) {
    typeof t == "string" && (t = { content: t, name: i, tool_call_id: a }), super(t), Object.defineProperty(this, "lc_direct_tool_output", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: !0
    }), Object.defineProperty(this, "status", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "tool_call_id", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "artifact", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.tool_call_id = t.tool_call_id, this.artifact = t.artifact, this.status = t.status;
  }
  _getType() {
    return "tool";
  }
  static isInstance(t) {
    return t._getType() === "tool";
  }
  get _printableFields() {
    return {
      ...super._printableFields,
      tool_call_id: this.tool_call_id,
      artifact: this.artifact
    };
  }
}
function VA(r) {
  const t = [], a = [];
  for (const i of r)
    if (i.function) {
      const s = i.function.name;
      try {
        const h = JSON.parse(i.function.arguments), d = {
          name: s || "",
          args: h || {},
          id: i.id
        };
        t.push(d);
      } catch {
        a.push({
          name: s,
          args: i.function.arguments,
          id: i.id,
          error: "Malformed args."
        });
      }
    } else
      continue;
  return [t, a];
}
class p2 extends Cm {
  get lc_aliases() {
    return {
      ...super.lc_aliases,
      tool_calls: "tool_calls",
      invalid_tool_calls: "invalid_tool_calls"
    };
  }
  constructor(t, a) {
    var s;
    let i;
    if (typeof t == "string")
      i = {
        content: t,
        tool_calls: [],
        invalid_tool_calls: [],
        additional_kwargs: a ?? {}
      };
    else {
      i = t;
      const h = (s = i.additional_kwargs) == null ? void 0 : s.tool_calls, d = i.tool_calls;
      h != null && h.length > 0 && (d === void 0 || d.length === 0) && console.warn([
        "New LangChain packages are available that more efficiently handle",
        `tool calling.

Please upgrade your packages to versions that set`,
        "message tool calls. e.g., `yarn add @langchain/anthropic`,",
        "yarn add @langchain/openai`, etc."
      ].join(" "));
      try {
        if (h != null && d === void 0) {
          const [y, g] = VA(h);
          i.tool_calls = y ?? [], i.invalid_tool_calls = g ?? [];
        } else
          i.tool_calls = i.tool_calls ?? [], i.invalid_tool_calls = i.invalid_tool_calls ?? [];
      } catch {
        i.tool_calls = [], i.invalid_tool_calls = [];
      }
    }
    super(i), Object.defineProperty(this, "tool_calls", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: []
    }), Object.defineProperty(this, "invalid_tool_calls", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: []
    }), Object.defineProperty(this, "usage_metadata", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), typeof i != "string" && (this.tool_calls = i.tool_calls ?? this.tool_calls, this.invalid_tool_calls = i.invalid_tool_calls ?? this.invalid_tool_calls), this.usage_metadata = i.usage_metadata;
  }
  static lc_name() {
    return "AIMessage";
  }
  _getType() {
    return "ai";
  }
  get _printableFields() {
    return {
      ...super._printableFields,
      tool_calls: this.tool_calls,
      invalid_tool_calls: this.invalid_tool_calls,
      usage_metadata: this.usage_metadata
    };
  }
}
class F5 extends Wg {
  constructor(t) {
    let a;
    if (typeof t == "string")
      a = {
        content: t,
        tool_calls: [],
        invalid_tool_calls: [],
        tool_call_chunks: []
      };
    else if (t.tool_call_chunks === void 0)
      a = {
        ...t,
        tool_calls: t.tool_calls ?? [],
        invalid_tool_calls: [],
        tool_call_chunks: [],
        usage_metadata: t.usage_metadata !== void 0 ? t.usage_metadata : void 0
      };
    else {
      const i = [], s = [];
      for (const h of t.tool_call_chunks) {
        let d = {};
        try {
          if (d = AA(h.args || "{}"), d === null || typeof d != "object" || Array.isArray(d))
            throw new Error("Malformed tool call chunk args.");
          i.push({
            name: h.name ?? "",
            args: d,
            id: h.id,
            type: "tool_call"
          });
        } catch {
          s.push({
            name: h.name,
            args: h.args,
            id: h.id,
            error: "Malformed args.",
            type: "invalid_tool_call"
          });
        }
      }
      a = {
        ...t,
        tool_calls: i,
        invalid_tool_calls: s,
        usage_metadata: t.usage_metadata !== void 0 ? t.usage_metadata : void 0
      };
    }
    super(a), Object.defineProperty(this, "tool_calls", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: []
    }), Object.defineProperty(this, "invalid_tool_calls", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: []
    }), Object.defineProperty(this, "tool_call_chunks", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: []
    }), Object.defineProperty(this, "usage_metadata", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.tool_call_chunks = a.tool_call_chunks ?? this.tool_call_chunks, this.tool_calls = a.tool_calls ?? this.tool_calls, this.invalid_tool_calls = a.invalid_tool_calls ?? this.invalid_tool_calls, this.usage_metadata = a.usage_metadata;
  }
  get lc_aliases() {
    return {
      ...super.lc_aliases,
      tool_calls: "tool_calls",
      invalid_tool_calls: "invalid_tool_calls",
      tool_call_chunks: "tool_call_chunks"
    };
  }
  static lc_name() {
    return "AIMessageChunk";
  }
  _getType() {
    return "ai";
  }
  get _printableFields() {
    return {
      ...super._printableFields,
      tool_calls: this.tool_calls,
      tool_call_chunks: this.tool_call_chunks,
      invalid_tool_calls: this.invalid_tool_calls,
      usage_metadata: this.usage_metadata
    };
  }
  concat(t) {
    var i, s, h, d, y, g, b, x, T, R, E, O, L, G, V, I, $, ce, se, te, Ce, ve, Ne, ee, De, de, Ye, Te, re, J, X, W, be, C, Y, ie, N, Me, _e, Se;
    const a = {
      content: Jg(this.content, t.content),
      additional_kwargs: Hi(this.additional_kwargs, t.additional_kwargs),
      response_metadata: Hi(this.response_metadata, t.response_metadata),
      tool_call_chunks: [],
      id: this.id ?? t.id
    };
    if (this.tool_call_chunks !== void 0 || t.tool_call_chunks !== void 0) {
      const Ge = Z5(this.tool_call_chunks, t.tool_call_chunks);
      Ge !== void 0 && Ge.length > 0 && (a.tool_call_chunks = Ge);
    }
    if (this.usage_metadata !== void 0 || t.usage_metadata !== void 0) {
      const Ge = {
        ...(((s = (i = this.usage_metadata) == null ? void 0 : i.input_token_details) == null ? void 0 : s.audio) !== void 0 || ((d = (h = t.usage_metadata) == null ? void 0 : h.input_token_details) == null ? void 0 : d.audio) !== void 0) && {
          audio: (((g = (y = this.usage_metadata) == null ? void 0 : y.input_token_details) == null ? void 0 : g.audio) ?? 0) + (((x = (b = t.usage_metadata) == null ? void 0 : b.input_token_details) == null ? void 0 : x.audio) ?? 0)
        },
        ...(((R = (T = this.usage_metadata) == null ? void 0 : T.input_token_details) == null ? void 0 : R.cache_read) !== void 0 || ((O = (E = t.usage_metadata) == null ? void 0 : E.input_token_details) == null ? void 0 : O.cache_read) !== void 0) && {
          cache_read: (((G = (L = this.usage_metadata) == null ? void 0 : L.input_token_details) == null ? void 0 : G.cache_read) ?? 0) + (((I = (V = t.usage_metadata) == null ? void 0 : V.input_token_details) == null ? void 0 : I.cache_read) ?? 0)
        },
        ...(((ce = ($ = this.usage_metadata) == null ? void 0 : $.input_token_details) == null ? void 0 : ce.cache_creation) !== void 0 || ((te = (se = t.usage_metadata) == null ? void 0 : se.input_token_details) == null ? void 0 : te.cache_creation) !== void 0) && {
          cache_creation: (((ve = (Ce = this.usage_metadata) == null ? void 0 : Ce.input_token_details) == null ? void 0 : ve.cache_creation) ?? 0) + (((ee = (Ne = t.usage_metadata) == null ? void 0 : Ne.input_token_details) == null ? void 0 : ee.cache_creation) ?? 0)
        }
      }, rt = {
        ...(((de = (De = this.usage_metadata) == null ? void 0 : De.output_token_details) == null ? void 0 : de.audio) !== void 0 || ((Te = (Ye = t.usage_metadata) == null ? void 0 : Ye.output_token_details) == null ? void 0 : Te.audio) !== void 0) && {
          audio: (((J = (re = this.usage_metadata) == null ? void 0 : re.output_token_details) == null ? void 0 : J.audio) ?? 0) + (((W = (X = t.usage_metadata) == null ? void 0 : X.output_token_details) == null ? void 0 : W.audio) ?? 0)
        },
        ...(((C = (be = this.usage_metadata) == null ? void 0 : be.output_token_details) == null ? void 0 : C.reasoning) !== void 0 || ((ie = (Y = t.usage_metadata) == null ? void 0 : Y.output_token_details) == null ? void 0 : ie.reasoning) !== void 0) && {
          reasoning: (((Me = (N = this.usage_metadata) == null ? void 0 : N.output_token_details) == null ? void 0 : Me.reasoning) ?? 0) + (((Se = (_e = t.usage_metadata) == null ? void 0 : _e.output_token_details) == null ? void 0 : Se.reasoning) ?? 0)
        }
      }, ht = this.usage_metadata ?? {
        input_tokens: 0,
        output_tokens: 0,
        total_tokens: 0
      }, vt = t.usage_metadata ?? {
        input_tokens: 0,
        output_tokens: 0,
        total_tokens: 0
      }, St = {
        input_tokens: ht.input_tokens + vt.input_tokens,
        output_tokens: ht.output_tokens + vt.output_tokens,
        total_tokens: ht.total_tokens + vt.total_tokens,
        // Do not include `input_token_details` / `output_token_details` keys in combined fields
        // unless their values are defined.
        ...Object.keys(Ge).length > 0 && {
          input_token_details: Ge
        },
        ...Object.keys(rt).length > 0 && {
          output_token_details: rt
        }
      };
      a.usage_metadata = St;
    }
    return new F5(a);
  }
}
class P5 extends Cm {
  static lc_name() {
    return "ChatMessage";
  }
  static _chatMessageClass() {
    return P5;
  }
  constructor(t, a) {
    typeof t == "string" && (t = { content: t, role: a }), super(t), Object.defineProperty(this, "role", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.role = t.role;
  }
  _getType() {
    return "generic";
  }
  static isInstance(t) {
    return t._getType() === "generic";
  }
  get _printableFields() {
    return {
      ...super._printableFields,
      role: this.role
    };
  }
}
class K5 extends Wg {
  static lc_name() {
    return "ChatMessageChunk";
  }
  constructor(t, a) {
    typeof t == "string" && (t = { content: t, role: a }), super(t), Object.defineProperty(this, "role", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.role = t.role;
  }
  _getType() {
    return "generic";
  }
  concat(t) {
    return new K5({
      content: Jg(this.content, t.content),
      additional_kwargs: Hi(this.additional_kwargs, t.additional_kwargs),
      response_metadata: Hi(this.response_metadata, t.response_metadata),
      role: this.role,
      id: this.id ?? t.id
    });
  }
  get _printableFields() {
    return {
      ...super._printableFields,
      role: this.role
    };
  }
}
class J5 extends Wg {
  static lc_name() {
    return "FunctionMessageChunk";
  }
  _getType() {
    return "function";
  }
  concat(t) {
    return new J5({
      content: Jg(this.content, t.content),
      additional_kwargs: Hi(this.additional_kwargs, t.additional_kwargs),
      response_metadata: Hi(this.response_metadata, t.response_metadata),
      name: this.name ?? "",
      id: this.id ?? t.id
    });
  }
}
class LS extends Cm {
  static lc_name() {
    return "HumanMessage";
  }
  _getType() {
    return "human";
  }
  constructor(t, a) {
    super(t, a);
  }
}
class W5 extends Wg {
  static lc_name() {
    return "HumanMessageChunk";
  }
  _getType() {
    return "human";
  }
  constructor(t, a) {
    super(t, a);
  }
  concat(t) {
    return new W5({
      content: Jg(this.content, t.content),
      additional_kwargs: Hi(this.additional_kwargs, t.additional_kwargs),
      response_metadata: Hi(this.response_metadata, t.response_metadata),
      id: this.id ?? t.id
    });
  }
}
class g2 extends Cm {
  static lc_name() {
    return "SystemMessage";
  }
  _getType() {
    return "system";
  }
  constructor(t, a) {
    super(t, a);
  }
}
class e7 extends Wg {
  static lc_name() {
    return "SystemMessageChunk";
  }
  _getType() {
    return "system";
  }
  constructor(t, a) {
    super(t, a);
  }
  concat(t) {
    return new e7({
      content: Jg(this.content, t.content),
      additional_kwargs: Hi(this.additional_kwargs, t.additional_kwargs),
      response_metadata: Hi(this.response_metadata, t.response_metadata),
      id: this.id ?? t.id
    });
  }
}
function YA(r, t) {
  return r.lc_error_code = t, r.message = `${r.message}

Troubleshooting URL: https://js.langchain.com/docs/troubleshooting/errors/${t}/
`, r;
}
function IA(r) {
  return !!(r && typeof r == "object" && "type" in r && r.type === "tool_call");
}
function $A(r) {
  return IA(r) ? r : typeof r.id == "string" && r.type === "function" && typeof r.function == "object" && r.function !== null && "arguments" in r.function && typeof r.function.arguments == "string" && "name" in r.function && typeof r.function.name == "string" ? {
    id: r.id,
    args: JSON.parse(r.function.arguments),
    name: r.function.name,
    type: "tool_call"
  } : r;
}
function XA(r) {
  return typeof r == "object" && r != null && r.lc === 1 && Array.isArray(r.id) && r.kwargs != null && typeof r.kwargs == "object";
}
function z6(r) {
  let t, a;
  if (XA(r)) {
    const i = r.id.at(-1);
    i === "HumanMessage" || i === "HumanMessageChunk" ? t = "user" : i === "AIMessage" || i === "AIMessageChunk" ? t = "assistant" : i === "SystemMessage" || i === "SystemMessageChunk" ? t = "system" : i === "FunctionMessage" || i === "FunctionMessageChunk" ? t = "function" : i === "ToolMessage" || i === "ToolMessageChunk" ? t = "tool" : t = "unknown", a = r.kwargs;
  } else {
    const { type: i, ...s } = r;
    t = i, a = s;
  }
  if (t === "human" || t === "user")
    return new LS(a);
  if (t === "ai" || t === "assistant") {
    const { tool_calls: i, ...s } = a;
    if (!Array.isArray(i))
      return new p2(a);
    const h = i.map($A);
    return new p2({ ...s, tool_calls: h });
  } else {
    if (t === "system")
      return new g2(a);
    if (t === "developer")
      return new g2({
        ...a,
        additional_kwargs: {
          ...a.additional_kwargs,
          __openai_role__: "developer"
        }
      });
    if (t === "tool" && "tool_call_id" in a)
      return new GA({
        ...a,
        content: a.content,
        tool_call_id: a.tool_call_id,
        name: a.name
      });
    throw YA(new Error(`Unable to coerce message from array: only human, AI, system, developer, or tool message coercion is currently supported.

Received: ${JSON.stringify(r, null, 2)}`), "MESSAGE_COERCION_FAILURE");
  }
}
function QA(r) {
  if (typeof r == "string")
    return new LS(r);
  if (NS(r))
    return r;
  if (Array.isArray(r)) {
    const [t, a] = r;
    return z6({ type: t, content: a });
  } else if (qA(r)) {
    const { role: t, ...a } = r;
    return z6({ ...a, type: t });
  } else
    return z6(r);
}
function ZA(r) {
  var a;
  const t = r._getType();
  if (t === "human")
    return new W5({ ...r });
  if (t === "ai") {
    let i = {
      ...r
    };
    return "tool_calls" in i && (i = {
      ...i,
      tool_call_chunks: (a = i.tool_calls) == null ? void 0 : a.map((s) => ({
        ...s,
        type: "tool_call_chunk",
        index: void 0,
        args: JSON.stringify(s.args)
      }))
    }), new F5({ ...i });
  } else {
    if (t === "system")
      return new e7({ ...r });
    if (t === "function")
      return new J5({ ...r });
    if (P5.isInstance(r))
      return new K5({ ...r });
    throw new Error("Unknown message type.");
  }
}
var t7 = { exports: {} }, BS = {};
function Ui(r, t) {
  typeof t == "boolean" && (t = { forever: t }), this._originalTimeouts = JSON.parse(JSON.stringify(r)), this._timeouts = r, this._options = t || {}, this._maxRetryTime = t && t.maxRetryTime || 1 / 0, this._fn = null, this._errors = [], this._attempts = 1, this._operationTimeout = null, this._operationTimeoutCb = null, this._timeout = null, this._operationStart = null, this._timer = null, this._options.forever && (this._cachedTimeouts = this._timeouts.slice(0));
}
var FA = Ui;
Ui.prototype.reset = function() {
  this._attempts = 1, this._timeouts = this._originalTimeouts.slice(0);
};
Ui.prototype.stop = function() {
  this._timeout && clearTimeout(this._timeout), this._timer && clearTimeout(this._timer), this._timeouts = [], this._cachedTimeouts = null;
};
Ui.prototype.retry = function(r) {
  if (this._timeout && clearTimeout(this._timeout), !r)
    return !1;
  var t = (/* @__PURE__ */ new Date()).getTime();
  if (r && t - this._operationStart >= this._maxRetryTime)
    return this._errors.push(r), this._errors.unshift(new Error("RetryOperation timeout occurred")), !1;
  this._errors.push(r);
  var a = this._timeouts.shift();
  if (a === void 0)
    if (this._cachedTimeouts)
      this._errors.splice(0, this._errors.length - 1), a = this._cachedTimeouts.slice(-1);
    else
      return !1;
  var i = this;
  return this._timer = setTimeout(function() {
    i._attempts++, i._operationTimeoutCb && (i._timeout = setTimeout(function() {
      i._operationTimeoutCb(i._attempts);
    }, i._operationTimeout), i._options.unref && i._timeout.unref()), i._fn(i._attempts);
  }, a), this._options.unref && this._timer.unref(), !0;
};
Ui.prototype.attempt = function(r, t) {
  this._fn = r, t && (t.timeout && (this._operationTimeout = t.timeout), t.cb && (this._operationTimeoutCb = t.cb));
  var a = this;
  this._operationTimeoutCb && (this._timeout = setTimeout(function() {
    a._operationTimeoutCb();
  }, a._operationTimeout)), this._operationStart = (/* @__PURE__ */ new Date()).getTime(), this._fn(this._attempts);
};
Ui.prototype.try = function(r) {
  console.log("Using RetryOperation.try() is deprecated"), this.attempt(r);
};
Ui.prototype.start = function(r) {
  console.log("Using RetryOperation.start() is deprecated"), this.attempt(r);
};
Ui.prototype.start = Ui.prototype.try;
Ui.prototype.errors = function() {
  return this._errors;
};
Ui.prototype.attempts = function() {
  return this._attempts;
};
Ui.prototype.mainError = function() {
  if (this._errors.length === 0)
    return null;
  for (var r = {}, t = null, a = 0, i = 0; i < this._errors.length; i++) {
    var s = this._errors[i], h = s.message, d = (r[h] || 0) + 1;
    r[h] = d, d >= a && (t = s, a = d);
  }
  return t;
};
(function(r) {
  var t = FA;
  r.operation = function(a) {
    var i = r.timeouts(a);
    return new t(i, {
      forever: a && (a.forever || a.retries === 1 / 0),
      unref: a && a.unref,
      maxRetryTime: a && a.maxRetryTime
    });
  }, r.timeouts = function(a) {
    if (a instanceof Array)
      return [].concat(a);
    var i = {
      retries: 10,
      factor: 2,
      minTimeout: 1 * 1e3,
      maxTimeout: 1 / 0,
      randomize: !1
    };
    for (var s in a)
      i[s] = a[s];
    if (i.minTimeout > i.maxTimeout)
      throw new Error("minTimeout is greater than maxTimeout");
    for (var h = [], d = 0; d < i.retries; d++)
      h.push(this.createTimeout(d, i));
    return a && a.forever && !h.length && h.push(this.createTimeout(d, i)), h.sort(function(y, g) {
      return y - g;
    }), h;
  }, r.createTimeout = function(a, i) {
    var s = i.randomize ? Math.random() + 1 : 1, h = Math.round(s * Math.max(i.minTimeout, 1) * Math.pow(i.factor, a));
    return h = Math.min(h, i.maxTimeout), h;
  }, r.wrap = function(a, i, s) {
    if (i instanceof Array && (s = i, i = null), !s) {
      s = [];
      for (var h in a)
        typeof a[h] == "function" && s.push(h);
    }
    for (var d = 0; d < s.length; d++) {
      var y = s[d], g = a[y];
      a[y] = (function(x) {
        var T = r.operation(i), R = Array.prototype.slice.call(arguments, 1), E = R.pop();
        R.push(function(O) {
          T.retry(O) || (O && (arguments[0] = T.mainError()), E.apply(this, arguments));
        }), T.attempt(function() {
          x.apply(a, R);
        });
      }).bind(a, g), a[y].options = i;
    }
  };
})(BS);
var PA = BS;
const KA = PA, JA = [
  "Failed to fetch",
  // Chrome
  "NetworkError when attempting to fetch resource.",
  // Firefox
  "The Internet connection appears to be offline.",
  // Safari
  "Network request failed"
  // `cross-fetch`
];
class HS extends Error {
  constructor(t) {
    super(), t instanceof Error ? (this.originalError = t, { message: t } = t) : (this.originalError = new Error(t), this.originalError.stack = this.stack), this.name = "AbortError", this.message = t;
  }
}
const WA = (r, t, a) => {
  const i = a.retries - (t - 1);
  return r.attemptNumber = t, r.retriesLeft = i, r;
}, ek = (r) => JA.includes(r), US = (r, t) => new Promise((a, i) => {
  t = {
    onFailedAttempt: () => {
    },
    retries: 10,
    ...t
  };
  const s = KA.operation(t);
  s.attempt(async (h) => {
    try {
      a(await r(h));
    } catch (d) {
      if (!(d instanceof Error)) {
        i(new TypeError(`Non-error was thrown: "${d}". You should only throw errors.`));
        return;
      }
      if (d instanceof HS)
        s.stop(), i(d.originalError);
      else if (d instanceof TypeError && !ek(d.message))
        s.stop(), i(d);
      else {
        WA(d, h, t);
        try {
          await t.onFailedAttempt(d);
        } catch (y) {
          i(y);
          return;
        }
        s.retry(d) || i(s.mainError());
      }
    }
  });
});
t7.exports = US;
t7.exports.default = US;
t7.exports.AbortError = HS;
var qS = {}, jS = { exports: {} };
(function(r) {
  var t = Object.prototype.hasOwnProperty, a = "~";
  function i() {
  }
  Object.create && (i.prototype = /* @__PURE__ */ Object.create(null), new i().__proto__ || (a = !1));
  function s(g, b, x) {
    this.fn = g, this.context = b, this.once = x || !1;
  }
  function h(g, b, x, T, R) {
    if (typeof x != "function")
      throw new TypeError("The listener must be a function");
    var E = new s(x, T || g, R), O = a ? a + b : b;
    return g._events[O] ? g._events[O].fn ? g._events[O] = [g._events[O], E] : g._events[O].push(E) : (g._events[O] = E, g._eventsCount++), g;
  }
  function d(g, b) {
    --g._eventsCount === 0 ? g._events = new i() : delete g._events[b];
  }
  function y() {
    this._events = new i(), this._eventsCount = 0;
  }
  y.prototype.eventNames = function() {
    var b = [], x, T;
    if (this._eventsCount === 0) return b;
    for (T in x = this._events)
      t.call(x, T) && b.push(a ? T.slice(1) : T);
    return Object.getOwnPropertySymbols ? b.concat(Object.getOwnPropertySymbols(x)) : b;
  }, y.prototype.listeners = function(b) {
    var x = a ? a + b : b, T = this._events[x];
    if (!T) return [];
    if (T.fn) return [T.fn];
    for (var R = 0, E = T.length, O = new Array(E); R < E; R++)
      O[R] = T[R].fn;
    return O;
  }, y.prototype.listenerCount = function(b) {
    var x = a ? a + b : b, T = this._events[x];
    return T ? T.fn ? 1 : T.length : 0;
  }, y.prototype.emit = function(b, x, T, R, E, O) {
    var L = a ? a + b : b;
    if (!this._events[L]) return !1;
    var G = this._events[L], V = arguments.length, I, $;
    if (G.fn) {
      switch (G.once && this.removeListener(b, G.fn, void 0, !0), V) {
        case 1:
          return G.fn.call(G.context), !0;
        case 2:
          return G.fn.call(G.context, x), !0;
        case 3:
          return G.fn.call(G.context, x, T), !0;
        case 4:
          return G.fn.call(G.context, x, T, R), !0;
        case 5:
          return G.fn.call(G.context, x, T, R, E), !0;
        case 6:
          return G.fn.call(G.context, x, T, R, E, O), !0;
      }
      for ($ = 1, I = new Array(V - 1); $ < V; $++)
        I[$ - 1] = arguments[$];
      G.fn.apply(G.context, I);
    } else {
      var ce = G.length, se;
      for ($ = 0; $ < ce; $++)
        switch (G[$].once && this.removeListener(b, G[$].fn, void 0, !0), V) {
          case 1:
            G[$].fn.call(G[$].context);
            break;
          case 2:
            G[$].fn.call(G[$].context, x);
            break;
          case 3:
            G[$].fn.call(G[$].context, x, T);
            break;
          case 4:
            G[$].fn.call(G[$].context, x, T, R);
            break;
          default:
            if (!I) for (se = 1, I = new Array(V - 1); se < V; se++)
              I[se - 1] = arguments[se];
            G[$].fn.apply(G[$].context, I);
        }
    }
    return !0;
  }, y.prototype.on = function(b, x, T) {
    return h(this, b, x, T, !1);
  }, y.prototype.once = function(b, x, T) {
    return h(this, b, x, T, !0);
  }, y.prototype.removeListener = function(b, x, T, R) {
    var E = a ? a + b : b;
    if (!this._events[E]) return this;
    if (!x)
      return d(this, E), this;
    var O = this._events[E];
    if (O.fn)
      O.fn === x && (!R || O.once) && (!T || O.context === T) && d(this, E);
    else {
      for (var L = 0, G = [], V = O.length; L < V; L++)
        (O[L].fn !== x || R && !O[L].once || T && O[L].context !== T) && G.push(O[L]);
      G.length ? this._events[E] = G.length === 1 ? G[0] : G : d(this, E);
    }
    return this;
  }, y.prototype.removeAllListeners = function(b) {
    var x;
    return b ? (x = a ? a + b : b, this._events[x] && d(this, x)) : (this._events = new i(), this._eventsCount = 0), this;
  }, y.prototype.off = y.prototype.removeListener, y.prototype.addListener = y.prototype.on, y.prefixed = a, y.EventEmitter = y, r.exports = y;
})(jS);
var tk = jS.exports, Gv = { exports: {} }, nk = (r, t) => (t = t || (() => {
}), r.then(
  (a) => new Promise((i) => {
    i(t());
  }).then(() => a),
  (a) => new Promise((i) => {
    i(t());
  }).then(() => {
    throw a;
  })
));
const rk = nk;
class GS extends Error {
  constructor(t) {
    super(t), this.name = "TimeoutError";
  }
}
const VS = (r, t, a) => new Promise((i, s) => {
  if (typeof t != "number" || t < 0)
    throw new TypeError("Expected `milliseconds` to be a positive number");
  if (t === 1 / 0) {
    i(r);
    return;
  }
  const h = setTimeout(() => {
    if (typeof a == "function") {
      try {
        i(a());
      } catch (g) {
        s(g);
      }
      return;
    }
    const d = typeof a == "string" ? a : `Promise timed out after ${t} milliseconds`, y = a instanceof Error ? a : new GS(d);
    typeof r.cancel == "function" && r.cancel(), s(y);
  }, t);
  rk(
    // eslint-disable-next-line promise/prefer-await-to-then
    r.then(i, s),
    () => {
      clearTimeout(h);
    }
  );
});
Gv.exports = VS;
Gv.exports.default = VS;
Gv.exports.TimeoutError = GS;
var ak = Gv.exports, n7 = {}, r7 = {};
Object.defineProperty(r7, "__esModule", { value: !0 });
function lk(r, t, a) {
  let i = 0, s = r.length;
  for (; s > 0; ) {
    const h = s / 2 | 0;
    let d = i + h;
    a(r[d], t) <= 0 ? (i = ++d, s -= h + 1) : s = h;
  }
  return i;
}
r7.default = lk;
Object.defineProperty(n7, "__esModule", { value: !0 });
const ik = r7;
class uk {
  constructor() {
    this._queue = [];
  }
  enqueue(t, a) {
    a = Object.assign({ priority: 0 }, a);
    const i = {
      priority: a.priority,
      run: t
    };
    if (this.size && this._queue[this.size - 1].priority >= a.priority) {
      this._queue.push(i);
      return;
    }
    const s = ik.default(this._queue, i, (h, d) => d.priority - h.priority);
    this._queue.splice(s, 0, i);
  }
  dequeue() {
    const t = this._queue.shift();
    return t == null ? void 0 : t.run;
  }
  filter(t) {
    return this._queue.filter((a) => a.priority === t.priority).map((a) => a.run);
  }
  get size() {
    return this._queue.length;
  }
}
n7.default = uk;
Object.defineProperty(qS, "__esModule", { value: !0 });
const ok = tk, YS = ak, sk = n7, tv = () => {
}, ck = new YS.TimeoutError();
class fk extends ok {
  constructor(t) {
    var a, i, s, h;
    if (super(), this._intervalCount = 0, this._intervalEnd = 0, this._pendingCount = 0, this._resolveEmpty = tv, this._resolveIdle = tv, t = Object.assign({ carryoverConcurrencyCount: !1, intervalCap: 1 / 0, interval: 0, concurrency: 1 / 0, autoStart: !0, queueClass: sk.default }, t), !(typeof t.intervalCap == "number" && t.intervalCap >= 1))
      throw new TypeError(`Expected \`intervalCap\` to be a number from 1 and up, got \`${(i = (a = t.intervalCap) === null || a === void 0 ? void 0 : a.toString()) !== null && i !== void 0 ? i : ""}\` (${typeof t.intervalCap})`);
    if (t.interval === void 0 || !(Number.isFinite(t.interval) && t.interval >= 0))
      throw new TypeError(`Expected \`interval\` to be a finite number >= 0, got \`${(h = (s = t.interval) === null || s === void 0 ? void 0 : s.toString()) !== null && h !== void 0 ? h : ""}\` (${typeof t.interval})`);
    this._carryoverConcurrencyCount = t.carryoverConcurrencyCount, this._isIntervalIgnored = t.intervalCap === 1 / 0 || t.interval === 0, this._intervalCap = t.intervalCap, this._interval = t.interval, this._queue = new t.queueClass(), this._queueClass = t.queueClass, this.concurrency = t.concurrency, this._timeout = t.timeout, this._throwOnTimeout = t.throwOnTimeout === !0, this._isPaused = t.autoStart === !1;
  }
  get _doesIntervalAllowAnother() {
    return this._isIntervalIgnored || this._intervalCount < this._intervalCap;
  }
  get _doesConcurrentAllowAnother() {
    return this._pendingCount < this._concurrency;
  }
  _next() {
    this._pendingCount--, this._tryToStartAnother(), this.emit("next");
  }
  _resolvePromises() {
    this._resolveEmpty(), this._resolveEmpty = tv, this._pendingCount === 0 && (this._resolveIdle(), this._resolveIdle = tv, this.emit("idle"));
  }
  _onResumeInterval() {
    this._onInterval(), this._initializeIntervalIfNeeded(), this._timeoutId = void 0;
  }
  _isIntervalPaused() {
    const t = Date.now();
    if (this._intervalId === void 0) {
      const a = this._intervalEnd - t;
      if (a < 0)
        this._intervalCount = this._carryoverConcurrencyCount ? this._pendingCount : 0;
      else
        return this._timeoutId === void 0 && (this._timeoutId = setTimeout(() => {
          this._onResumeInterval();
        }, a)), !0;
    }
    return !1;
  }
  _tryToStartAnother() {
    if (this._queue.size === 0)
      return this._intervalId && clearInterval(this._intervalId), this._intervalId = void 0, this._resolvePromises(), !1;
    if (!this._isPaused) {
      const t = !this._isIntervalPaused();
      if (this._doesIntervalAllowAnother && this._doesConcurrentAllowAnother) {
        const a = this._queue.dequeue();
        return a ? (this.emit("active"), a(), t && this._initializeIntervalIfNeeded(), !0) : !1;
      }
    }
    return !1;
  }
  _initializeIntervalIfNeeded() {
    this._isIntervalIgnored || this._intervalId !== void 0 || (this._intervalId = setInterval(() => {
      this._onInterval();
    }, this._interval), this._intervalEnd = Date.now() + this._interval);
  }
  _onInterval() {
    this._intervalCount === 0 && this._pendingCount === 0 && this._intervalId && (clearInterval(this._intervalId), this._intervalId = void 0), this._intervalCount = this._carryoverConcurrencyCount ? this._pendingCount : 0, this._processQueue();
  }
  /**
  Executes all queued functions until it reaches the limit.
  */
  _processQueue() {
    for (; this._tryToStartAnother(); )
      ;
  }
  get concurrency() {
    return this._concurrency;
  }
  set concurrency(t) {
    if (!(typeof t == "number" && t >= 1))
      throw new TypeError(`Expected \`concurrency\` to be a number from 1 and up, got \`${t}\` (${typeof t})`);
    this._concurrency = t, this._processQueue();
  }
  /**
  Adds a sync or async task to the queue. Always returns a promise.
  */
  async add(t, a = {}) {
    return new Promise((i, s) => {
      const h = async () => {
        this._pendingCount++, this._intervalCount++;
        try {
          const d = this._timeout === void 0 && a.timeout === void 0 ? t() : YS.default(Promise.resolve(t()), a.timeout === void 0 ? this._timeout : a.timeout, () => {
            (a.throwOnTimeout === void 0 ? this._throwOnTimeout : a.throwOnTimeout) && s(ck);
          });
          i(await d);
        } catch (d) {
          s(d);
        }
        this._next();
      };
      this._queue.enqueue(h, a), this._tryToStartAnother(), this.emit("add");
    });
  }
  /**
      Same as `.add()`, but accepts an array of sync or async functions.
  
      @returns A promise that resolves when all functions are resolved.
      */
  async addAll(t, a) {
    return Promise.all(t.map(async (i) => this.add(i, a)));
  }
  /**
  Start (or resume) executing enqueued tasks within concurrency limit. No need to call this if queue is not paused (via `options.autoStart = false` or by `.pause()` method.)
  */
  start() {
    return this._isPaused ? (this._isPaused = !1, this._processQueue(), this) : this;
  }
  /**
  Put queue execution on hold.
  */
  pause() {
    this._isPaused = !0;
  }
  /**
  Clear the queue.
  */
  clear() {
    this._queue = new this._queueClass();
  }
  /**
      Can be called multiple times. Useful if you for example add additional items at a later time.
  
      @returns A promise that settles when the queue becomes empty.
      */
  async onEmpty() {
    if (this._queue.size !== 0)
      return new Promise((t) => {
        const a = this._resolveEmpty;
        this._resolveEmpty = () => {
          a(), t();
        };
      });
  }
  /**
      The difference with `.onEmpty` is that `.onIdle` guarantees that all work from the queue has finished. `.onEmpty` merely signals that the queue is empty, but it could mean that some promises haven't completed yet.
  
      @returns A promise that settles when the queue becomes empty, and all promises have completed; `queue.size === 0 && queue.pending === 0`.
      */
  async onIdle() {
    if (!(this._pendingCount === 0 && this._queue.size === 0))
      return new Promise((t) => {
        const a = this._resolveIdle;
        this._resolveIdle = () => {
          a(), t();
        };
      });
  }
  /**
  Size of the queue.
  */
  get size() {
    return this._queue.size;
  }
  /**
      Size of the queue, filtered by the given options.
  
      For example, this can be used to find the number of items remaining in the queue with a specific priority level.
      */
  sizeBy(t) {
    return this._queue.filter(t).length;
  }
  /**
  Number of pending promises.
  */
  get pending() {
    return this._pendingCount;
  }
  /**
  Whether the queue is currently paused.
  */
  get isPaused() {
    return this._isPaused;
  }
  get timeout() {
    return this._timeout;
  }
  /**
  Set the timeout for future operations.
  */
  set timeout(t) {
    this._timeout = t;
  }
}
qS.default = fk;
var b5 = { exports: {} };
const hk = "2.0.0", IS = 256, dk = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
9007199254740991, mk = 16, pk = IS - 6, gk = [
  "major",
  "premajor",
  "minor",
  "preminor",
  "patch",
  "prepatch",
  "prerelease"
];
var Vv = {
  MAX_LENGTH: IS,
  MAX_SAFE_COMPONENT_LENGTH: mk,
  MAX_SAFE_BUILD_LENGTH: pk,
  MAX_SAFE_INTEGER: dk,
  RELEASE_TYPES: gk,
  SEMVER_SPEC_VERSION: hk,
  FLAG_INCLUDE_PRERELEASE: 1,
  FLAG_LOOSE: 2
}, C6 = {};
const yk = typeof process == "object" && C6 && C6.NODE_DEBUG && /\bsemver\b/i.test(C6.NODE_DEBUG) ? (...r) => console.error("SEMVER", ...r) : () => {
};
var Yv = yk;
(function(r, t) {
  const {
    MAX_SAFE_COMPONENT_LENGTH: a,
    MAX_SAFE_BUILD_LENGTH: i,
    MAX_LENGTH: s
  } = Vv, h = Yv;
  t = r.exports = {};
  const d = t.re = [], y = t.safeRe = [], g = t.src = [], b = t.safeSrc = [], x = t.t = {};
  let T = 0;
  const R = "[a-zA-Z0-9-]", E = [
    ["\\s", 1],
    ["\\d", s],
    [R, i]
  ], O = (G) => {
    for (const [V, I] of E)
      G = G.split(`${V}*`).join(`${V}{0,${I}}`).split(`${V}+`).join(`${V}{1,${I}}`);
    return G;
  }, L = (G, V, I) => {
    const $ = O(V), ce = T++;
    h(G, ce, V), x[G] = ce, g[ce] = V, b[ce] = $, d[ce] = new RegExp(V, I ? "g" : void 0), y[ce] = new RegExp($, I ? "g" : void 0);
  };
  L("NUMERICIDENTIFIER", "0|[1-9]\\d*"), L("NUMERICIDENTIFIERLOOSE", "\\d+"), L("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${R}*`), L("MAINVERSION", `(${g[x.NUMERICIDENTIFIER]})\\.(${g[x.NUMERICIDENTIFIER]})\\.(${g[x.NUMERICIDENTIFIER]})`), L("MAINVERSIONLOOSE", `(${g[x.NUMERICIDENTIFIERLOOSE]})\\.(${g[x.NUMERICIDENTIFIERLOOSE]})\\.(${g[x.NUMERICIDENTIFIERLOOSE]})`), L("PRERELEASEIDENTIFIER", `(?:${g[x.NONNUMERICIDENTIFIER]}|${g[x.NUMERICIDENTIFIER]})`), L("PRERELEASEIDENTIFIERLOOSE", `(?:${g[x.NONNUMERICIDENTIFIER]}|${g[x.NUMERICIDENTIFIERLOOSE]})`), L("PRERELEASE", `(?:-(${g[x.PRERELEASEIDENTIFIER]}(?:\\.${g[x.PRERELEASEIDENTIFIER]})*))`), L("PRERELEASELOOSE", `(?:-?(${g[x.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${g[x.PRERELEASEIDENTIFIERLOOSE]})*))`), L("BUILDIDENTIFIER", `${R}+`), L("BUILD", `(?:\\+(${g[x.BUILDIDENTIFIER]}(?:\\.${g[x.BUILDIDENTIFIER]})*))`), L("FULLPLAIN", `v?${g[x.MAINVERSION]}${g[x.PRERELEASE]}?${g[x.BUILD]}?`), L("FULL", `^${g[x.FULLPLAIN]}$`), L("LOOSEPLAIN", `[v=\\s]*${g[x.MAINVERSIONLOOSE]}${g[x.PRERELEASELOOSE]}?${g[x.BUILD]}?`), L("LOOSE", `^${g[x.LOOSEPLAIN]}$`), L("GTLT", "((?:<|>)?=?)"), L("XRANGEIDENTIFIERLOOSE", `${g[x.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), L("XRANGEIDENTIFIER", `${g[x.NUMERICIDENTIFIER]}|x|X|\\*`), L("XRANGEPLAIN", `[v=\\s]*(${g[x.XRANGEIDENTIFIER]})(?:\\.(${g[x.XRANGEIDENTIFIER]})(?:\\.(${g[x.XRANGEIDENTIFIER]})(?:${g[x.PRERELEASE]})?${g[x.BUILD]}?)?)?`), L("XRANGEPLAINLOOSE", `[v=\\s]*(${g[x.XRANGEIDENTIFIERLOOSE]})(?:\\.(${g[x.XRANGEIDENTIFIERLOOSE]})(?:\\.(${g[x.XRANGEIDENTIFIERLOOSE]})(?:${g[x.PRERELEASELOOSE]})?${g[x.BUILD]}?)?)?`), L("XRANGE", `^${g[x.GTLT]}\\s*${g[x.XRANGEPLAIN]}$`), L("XRANGELOOSE", `^${g[x.GTLT]}\\s*${g[x.XRANGEPLAINLOOSE]}$`), L("COERCEPLAIN", `(^|[^\\d])(\\d{1,${a}})(?:\\.(\\d{1,${a}}))?(?:\\.(\\d{1,${a}}))?`), L("COERCE", `${g[x.COERCEPLAIN]}(?:$|[^\\d])`), L("COERCEFULL", g[x.COERCEPLAIN] + `(?:${g[x.PRERELEASE]})?(?:${g[x.BUILD]})?(?:$|[^\\d])`), L("COERCERTL", g[x.COERCE], !0), L("COERCERTLFULL", g[x.COERCEFULL], !0), L("LONETILDE", "(?:~>?)"), L("TILDETRIM", `(\\s*)${g[x.LONETILDE]}\\s+`, !0), t.tildeTrimReplace = "$1~", L("TILDE", `^${g[x.LONETILDE]}${g[x.XRANGEPLAIN]}$`), L("TILDELOOSE", `^${g[x.LONETILDE]}${g[x.XRANGEPLAINLOOSE]}$`), L("LONECARET", "(?:\\^)"), L("CARETTRIM", `(\\s*)${g[x.LONECARET]}\\s+`, !0), t.caretTrimReplace = "$1^", L("CARET", `^${g[x.LONECARET]}${g[x.XRANGEPLAIN]}$`), L("CARETLOOSE", `^${g[x.LONECARET]}${g[x.XRANGEPLAINLOOSE]}$`), L("COMPARATORLOOSE", `^${g[x.GTLT]}\\s*(${g[x.LOOSEPLAIN]})$|^$`), L("COMPARATOR", `^${g[x.GTLT]}\\s*(${g[x.FULLPLAIN]})$|^$`), L("COMPARATORTRIM", `(\\s*)${g[x.GTLT]}\\s*(${g[x.LOOSEPLAIN]}|${g[x.XRANGEPLAIN]})`, !0), t.comparatorTrimReplace = "$1$2$3", L("HYPHENRANGE", `^\\s*(${g[x.XRANGEPLAIN]})\\s+-\\s+(${g[x.XRANGEPLAIN]})\\s*$`), L("HYPHENRANGELOOSE", `^\\s*(${g[x.XRANGEPLAINLOOSE]})\\s+-\\s+(${g[x.XRANGEPLAINLOOSE]})\\s*$`), L("STAR", "(<|>)?=?\\s*\\*"), L("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), L("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(b5, b5.exports);
var e4 = b5.exports;
const vk = Object.freeze({ loose: !0 }), bk = Object.freeze({}), Sk = (r) => r ? typeof r != "object" ? vk : r : bk;
var a7 = Sk;
const y2 = /^[0-9]+$/, $S = (r, t) => {
  const a = y2.test(r), i = y2.test(t);
  return a && i && (r = +r, t = +t), r === t ? 0 : a && !i ? -1 : i && !a ? 1 : r < t ? -1 : 1;
}, xk = (r, t) => $S(t, r);
var XS = {
  compareIdentifiers: $S,
  rcompareIdentifiers: xk
};
const nv = Yv, { MAX_LENGTH: v2, MAX_SAFE_INTEGER: rv } = Vv, { safeRe: av, t: lv } = e4, wk = a7, { compareIdentifiers: bm } = XS;
let Tk = class po {
  constructor(t, a) {
    if (a = wk(a), t instanceof po) {
      if (t.loose === !!a.loose && t.includePrerelease === !!a.includePrerelease)
        return t;
      t = t.version;
    } else if (typeof t != "string")
      throw new TypeError(`Invalid version. Must be a string. Got type "${typeof t}".`);
    if (t.length > v2)
      throw new TypeError(
        `version is longer than ${v2} characters`
      );
    nv("SemVer", t, a), this.options = a, this.loose = !!a.loose, this.includePrerelease = !!a.includePrerelease;
    const i = t.trim().match(a.loose ? av[lv.LOOSE] : av[lv.FULL]);
    if (!i)
      throw new TypeError(`Invalid Version: ${t}`);
    if (this.raw = t, this.major = +i[1], this.minor = +i[2], this.patch = +i[3], this.major > rv || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > rv || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > rv || this.patch < 0)
      throw new TypeError("Invalid patch version");
    i[4] ? this.prerelease = i[4].split(".").map((s) => {
      if (/^[0-9]+$/.test(s)) {
        const h = +s;
        if (h >= 0 && h < rv)
          return h;
      }
      return s;
    }) : this.prerelease = [], this.build = i[5] ? i[5].split(".") : [], this.format();
  }
  format() {
    return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
  }
  toString() {
    return this.version;
  }
  compare(t) {
    if (nv("SemVer.compare", this.version, this.options, t), !(t instanceof po)) {
      if (typeof t == "string" && t === this.version)
        return 0;
      t = new po(t, this.options);
    }
    return t.version === this.version ? 0 : this.compareMain(t) || this.comparePre(t);
  }
  compareMain(t) {
    return t instanceof po || (t = new po(t, this.options)), bm(this.major, t.major) || bm(this.minor, t.minor) || bm(this.patch, t.patch);
  }
  comparePre(t) {
    if (t instanceof po || (t = new po(t, this.options)), this.prerelease.length && !t.prerelease.length)
      return -1;
    if (!this.prerelease.length && t.prerelease.length)
      return 1;
    if (!this.prerelease.length && !t.prerelease.length)
      return 0;
    let a = 0;
    do {
      const i = this.prerelease[a], s = t.prerelease[a];
      if (nv("prerelease compare", a, i, s), i === void 0 && s === void 0)
        return 0;
      if (s === void 0)
        return 1;
      if (i === void 0)
        return -1;
      if (i === s)
        continue;
      return bm(i, s);
    } while (++a);
  }
  compareBuild(t) {
    t instanceof po || (t = new po(t, this.options));
    let a = 0;
    do {
      const i = this.build[a], s = t.build[a];
      if (nv("build compare", a, i, s), i === void 0 && s === void 0)
        return 0;
      if (s === void 0)
        return 1;
      if (i === void 0)
        return -1;
      if (i === s)
        continue;
      return bm(i, s);
    } while (++a);
  }
  // preminor will bump the version up to the next minor release, and immediately
  // down to pre-release. premajor and prepatch work the same way.
  inc(t, a, i) {
    if (t.startsWith("pre")) {
      if (!a && i === !1)
        throw new Error("invalid increment argument: identifier is empty");
      if (a) {
        const s = `-${a}`.match(this.options.loose ? av[lv.PRERELEASELOOSE] : av[lv.PRERELEASE]);
        if (!s || s[1] !== a)
          throw new Error(`invalid identifier: ${a}`);
      }
    }
    switch (t) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", a, i);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", a, i);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", a, i), this.inc("pre", a, i);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", a, i), this.inc("pre", a, i);
        break;
      case "release":
        if (this.prerelease.length === 0)
          throw new Error(`version ${this.raw} is not a prerelease`);
        this.prerelease.length = 0;
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre": {
        const s = Number(i) ? 1 : 0;
        if (this.prerelease.length === 0)
          this.prerelease = [s];
        else {
          let h = this.prerelease.length;
          for (; --h >= 0; )
            typeof this.prerelease[h] == "number" && (this.prerelease[h]++, h = -2);
          if (h === -1) {
            if (a === this.prerelease.join(".") && i === !1)
              throw new Error("invalid increment argument: identifier already exists");
            this.prerelease.push(s);
          }
        }
        if (a) {
          let h = [a, s];
          i === !1 && (h = [a]), bm(this.prerelease[0], a) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = h) : this.prerelease = h;
        }
        break;
      }
      default:
        throw new Error(`invalid increment argument: ${t}`);
    }
    return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
  }
};
var l7 = Tk;
const b2 = l7, Ek = (r, t, a) => new b2(r, a).compare(new b2(t, a));
var Mm = Ek;
const Ak = Mm, kk = (r, t, a) => Ak(r, t, a) > 0;
var Rk = kk;
const zk = Mm, Ck = (r, t, a) => zk(r, t, a) < 0;
var Mk = Ck;
const _k = Mm, Ok = (r, t, a) => _k(r, t, a) === 0;
var Dk = Ok;
const Nk = Mm, Lk = (r, t, a) => Nk(r, t, a) !== 0;
var Bk = Lk;
const Hk = Mm, Uk = (r, t, a) => Hk(r, t, a) >= 0;
var qk = Uk;
const jk = Mm, Gk = (r, t, a) => jk(r, t, a) <= 0;
var Vk = Gk;
const Yk = Dk, Ik = Bk, $k = Rk, Xk = qk, Qk = Mk, Zk = Vk, Fk = (r, t, a, i) => {
  switch (t) {
    case "===":
      return typeof r == "object" && (r = r.version), typeof a == "object" && (a = a.version), r === a;
    case "!==":
      return typeof r == "object" && (r = r.version), typeof a == "object" && (a = a.version), r !== a;
    case "":
    case "=":
    case "==":
      return Yk(r, a, i);
    case "!=":
      return Ik(r, a, i);
    case ">":
      return $k(r, a, i);
    case ">=":
      return Xk(r, a, i);
    case "<":
      return Qk(r, a, i);
    case "<=":
      return Zk(r, a, i);
    default:
      throw new TypeError(`Invalid operator: ${t}`);
  }
};
var Pk = Fk;
const { safeRe: XH, t: QH } = e4;
class Kk {
  constructor() {
    this.max = 1e3, this.map = /* @__PURE__ */ new Map();
  }
  get(t) {
    const a = this.map.get(t);
    if (a !== void 0)
      return this.map.delete(t), this.map.set(t, a), a;
  }
  delete(t) {
    return this.map.delete(t);
  }
  set(t, a) {
    if (!this.delete(t) && a !== void 0) {
      if (this.map.size >= this.max) {
        const s = this.map.keys().next().value;
        this.delete(s);
      }
      this.map.set(t, a);
    }
    return this;
  }
}
var Jk = Kk, M6, S2;
function ku() {
  if (S2) return M6;
  S2 = 1;
  const r = /\s+/g;
  class t {
    constructor(re, J) {
      if (J = s(J), re instanceof t)
        return re.loose === !!J.loose && re.includePrerelease === !!J.includePrerelease ? re : new t(re.raw, J);
      if (re instanceof h)
        return this.raw = re.value, this.set = [[re]], this.formatted = void 0, this;
      if (this.options = J, this.loose = !!J.loose, this.includePrerelease = !!J.includePrerelease, this.raw = re.trim().replace(r, " "), this.set = this.raw.split("||").map((X) => this.parseRange(X.trim())).filter((X) => X.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        const X = this.set[0];
        if (this.set = this.set.filter((W) => !L(W[0])), this.set.length === 0)
          this.set = [X];
        else if (this.set.length > 1) {
          for (const W of this.set)
            if (W.length === 1 && G(W[0])) {
              this.set = [W];
              break;
            }
        }
      }
      this.formatted = void 0;
    }
    get range() {
      if (this.formatted === void 0) {
        this.formatted = "";
        for (let re = 0; re < this.set.length; re++) {
          re > 0 && (this.formatted += "||");
          const J = this.set[re];
          for (let X = 0; X < J.length; X++)
            X > 0 && (this.formatted += " "), this.formatted += J[X].toString().trim();
        }
      }
      return this.formatted;
    }
    format() {
      return this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(re) {
      const X = ((this.options.includePrerelease && E) | (this.options.loose && O)) + ":" + re, W = i.get(X);
      if (W)
        return W;
      const be = this.options.loose, C = be ? g[b.HYPHENRANGELOOSE] : g[b.HYPHENRANGE];
      re = re.replace(C, de(this.options.includePrerelease)), d("hyphen replace", re), re = re.replace(g[b.COMPARATORTRIM], x), d("comparator trim", re), re = re.replace(g[b.TILDETRIM], T), d("tilde trim", re), re = re.replace(g[b.CARETTRIM], R), d("caret trim", re);
      let Y = re.split(" ").map((_e) => I(_e, this.options)).join(" ").split(/\s+/).map((_e) => De(_e, this.options));
      be && (Y = Y.filter((_e) => (d("loose invalid filter", _e, this.options), !!_e.match(g[b.COMPARATORLOOSE])))), d("range list", Y);
      const ie = /* @__PURE__ */ new Map(), N = Y.map((_e) => new h(_e, this.options));
      for (const _e of N) {
        if (L(_e))
          return [_e];
        ie.set(_e.value, _e);
      }
      ie.size > 1 && ie.has("") && ie.delete("");
      const Me = [...ie.values()];
      return i.set(X, Me), Me;
    }
    intersects(re, J) {
      if (!(re instanceof t))
        throw new TypeError("a Range is required");
      return this.set.some((X) => V(X, J) && re.set.some((W) => V(W, J) && X.every((be) => W.every((C) => be.intersects(C, J)))));
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(re) {
      if (!re)
        return !1;
      if (typeof re == "string")
        try {
          re = new y(re, this.options);
        } catch {
          return !1;
        }
      for (let J = 0; J < this.set.length; J++)
        if (Ye(this.set[J], re, this.options))
          return !0;
      return !1;
    }
  }
  M6 = t;
  const a = Jk, i = new a(), s = a7, h = Iv(), d = Yv, y = l7, {
    safeRe: g,
    t: b,
    comparatorTrimReplace: x,
    tildeTrimReplace: T,
    caretTrimReplace: R
  } = e4, { FLAG_INCLUDE_PRERELEASE: E, FLAG_LOOSE: O } = Vv, L = (Te) => Te.value === "<0.0.0-0", G = (Te) => Te.value === "", V = (Te, re) => {
    let J = !0;
    const X = Te.slice();
    let W = X.pop();
    for (; J && X.length; )
      J = X.every((be) => W.intersects(be, re)), W = X.pop();
    return J;
  }, I = (Te, re) => (d("comp", Te, re), Te = te(Te, re), d("caret", Te), Te = ce(Te, re), d("tildes", Te), Te = ve(Te, re), d("xrange", Te), Te = ee(Te, re), d("stars", Te), Te), $ = (Te) => !Te || Te.toLowerCase() === "x" || Te === "*", ce = (Te, re) => Te.trim().split(/\s+/).map((J) => se(J, re)).join(" "), se = (Te, re) => {
    const J = re.loose ? g[b.TILDELOOSE] : g[b.TILDE];
    return Te.replace(J, (X, W, be, C, Y) => {
      d("tilde", Te, X, W, be, C, Y);
      let ie;
      return $(W) ? ie = "" : $(be) ? ie = `>=${W}.0.0 <${+W + 1}.0.0-0` : $(C) ? ie = `>=${W}.${be}.0 <${W}.${+be + 1}.0-0` : Y ? (d("replaceTilde pr", Y), ie = `>=${W}.${be}.${C}-${Y} <${W}.${+be + 1}.0-0`) : ie = `>=${W}.${be}.${C} <${W}.${+be + 1}.0-0`, d("tilde return", ie), ie;
    });
  }, te = (Te, re) => Te.trim().split(/\s+/).map((J) => Ce(J, re)).join(" "), Ce = (Te, re) => {
    d("caret", Te, re);
    const J = re.loose ? g[b.CARETLOOSE] : g[b.CARET], X = re.includePrerelease ? "-0" : "";
    return Te.replace(J, (W, be, C, Y, ie) => {
      d("caret", Te, W, be, C, Y, ie);
      let N;
      return $(be) ? N = "" : $(C) ? N = `>=${be}.0.0${X} <${+be + 1}.0.0-0` : $(Y) ? be === "0" ? N = `>=${be}.${C}.0${X} <${be}.${+C + 1}.0-0` : N = `>=${be}.${C}.0${X} <${+be + 1}.0.0-0` : ie ? (d("replaceCaret pr", ie), be === "0" ? C === "0" ? N = `>=${be}.${C}.${Y}-${ie} <${be}.${C}.${+Y + 1}-0` : N = `>=${be}.${C}.${Y}-${ie} <${be}.${+C + 1}.0-0` : N = `>=${be}.${C}.${Y}-${ie} <${+be + 1}.0.0-0`) : (d("no pr"), be === "0" ? C === "0" ? N = `>=${be}.${C}.${Y}${X} <${be}.${C}.${+Y + 1}-0` : N = `>=${be}.${C}.${Y}${X} <${be}.${+C + 1}.0-0` : N = `>=${be}.${C}.${Y} <${+be + 1}.0.0-0`), d("caret return", N), N;
    });
  }, ve = (Te, re) => (d("replaceXRanges", Te, re), Te.split(/\s+/).map((J) => Ne(J, re)).join(" ")), Ne = (Te, re) => {
    Te = Te.trim();
    const J = re.loose ? g[b.XRANGELOOSE] : g[b.XRANGE];
    return Te.replace(J, (X, W, be, C, Y, ie) => {
      d("xRange", Te, X, W, be, C, Y, ie);
      const N = $(be), Me = N || $(C), _e = Me || $(Y), Se = _e;
      return W === "=" && Se && (W = ""), ie = re.includePrerelease ? "-0" : "", N ? W === ">" || W === "<" ? X = "<0.0.0-0" : X = "*" : W && Se ? (Me && (C = 0), Y = 0, W === ">" ? (W = ">=", Me ? (be = +be + 1, C = 0, Y = 0) : (C = +C + 1, Y = 0)) : W === "<=" && (W = "<", Me ? be = +be + 1 : C = +C + 1), W === "<" && (ie = "-0"), X = `${W + be}.${C}.${Y}${ie}`) : Me ? X = `>=${be}.0.0${ie} <${+be + 1}.0.0-0` : _e && (X = `>=${be}.${C}.0${ie} <${be}.${+C + 1}.0-0`), d("xRange return", X), X;
    });
  }, ee = (Te, re) => (d("replaceStars", Te, re), Te.trim().replace(g[b.STAR], "")), De = (Te, re) => (d("replaceGTE0", Te, re), Te.trim().replace(g[re.includePrerelease ? b.GTE0PRE : b.GTE0], "")), de = (Te) => (re, J, X, W, be, C, Y, ie, N, Me, _e, Se) => ($(X) ? J = "" : $(W) ? J = `>=${X}.0.0${Te ? "-0" : ""}` : $(be) ? J = `>=${X}.${W}.0${Te ? "-0" : ""}` : C ? J = `>=${J}` : J = `>=${J}${Te ? "-0" : ""}`, $(N) ? ie = "" : $(Me) ? ie = `<${+N + 1}.0.0-0` : $(_e) ? ie = `<${N}.${+Me + 1}.0-0` : Se ? ie = `<=${N}.${Me}.${_e}-${Se}` : Te ? ie = `<${N}.${Me}.${+_e + 1}-0` : ie = `<=${ie}`, `${J} ${ie}`.trim()), Ye = (Te, re, J) => {
    for (let X = 0; X < Te.length; X++)
      if (!Te[X].test(re))
        return !1;
    if (re.prerelease.length && !J.includePrerelease) {
      for (let X = 0; X < Te.length; X++)
        if (d(Te[X].semver), Te[X].semver !== h.ANY && Te[X].semver.prerelease.length > 0) {
          const W = Te[X].semver;
          if (W.major === re.major && W.minor === re.minor && W.patch === re.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return M6;
}
var _6, x2;
function Iv() {
  if (x2) return _6;
  x2 = 1;
  const r = Symbol("SemVer ANY");
  class t {
    static get ANY() {
      return r;
    }
    constructor(x, T) {
      if (T = a(T), x instanceof t) {
        if (x.loose === !!T.loose)
          return x;
        x = x.value;
      }
      x = x.trim().split(/\s+/).join(" "), d("comparator", x, T), this.options = T, this.loose = !!T.loose, this.parse(x), this.semver === r ? this.value = "" : this.value = this.operator + this.semver.version, d("comp", this);
    }
    parse(x) {
      const T = this.options.loose ? i[s.COMPARATORLOOSE] : i[s.COMPARATOR], R = x.match(T);
      if (!R)
        throw new TypeError(`Invalid comparator: ${x}`);
      this.operator = R[1] !== void 0 ? R[1] : "", this.operator === "=" && (this.operator = ""), R[2] ? this.semver = new y(R[2], this.options.loose) : this.semver = r;
    }
    toString() {
      return this.value;
    }
    test(x) {
      if (d("Comparator.test", x, this.options.loose), this.semver === r || x === r)
        return !0;
      if (typeof x == "string")
        try {
          x = new y(x, this.options);
        } catch {
          return !1;
        }
      return h(x, this.operator, this.semver, this.options);
    }
    intersects(x, T) {
      if (!(x instanceof t))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new g(x.value, T).test(this.value) : x.operator === "" ? x.value === "" ? !0 : new g(this.value, T).test(x.semver) : (T = a(T), T.includePrerelease && (this.value === "<0.0.0-0" || x.value === "<0.0.0-0") || !T.includePrerelease && (this.value.startsWith("<0.0.0") || x.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && x.operator.startsWith(">") || this.operator.startsWith("<") && x.operator.startsWith("<") || this.semver.version === x.semver.version && this.operator.includes("=") && x.operator.includes("=") || h(this.semver, "<", x.semver, T) && this.operator.startsWith(">") && x.operator.startsWith("<") || h(this.semver, ">", x.semver, T) && this.operator.startsWith("<") && x.operator.startsWith(">")));
    }
  }
  _6 = t;
  const a = a7, { safeRe: i, t: s } = e4, h = Pk, d = Yv, y = l7, g = ku();
  return _6;
}
ku();
ku();
ku();
ku();
ku();
ku();
const Wk = Iv(), { ANY: ZH } = Wk;
ku();
ku();
ku();
const i7 = Iv(), { ANY: FH } = i7;
new i7(">=0.0.0-0");
new i7(">=0.0.0");
const O6 = e4, w2 = Vv, T2 = XS;
Iv();
ku();
O6.re, O6.src, O6.t, w2.SEMVER_SPEC_VERSION, w2.RELEASE_TYPES, T2.compareIdentifiers, T2.rcompareIdentifiers;
new TextEncoder();
var u7 = { exports: {} };
u7.exports;
(function(r) {
  const a = (h = 0) => (d) => `\x1B[${38 + h};5;${d}m`, i = (h = 0) => (d, y, g) => `\x1B[${38 + h};2;${d};${y};${g}m`;
  function s() {
    const h = /* @__PURE__ */ new Map(), d = {
      modifier: {
        reset: [0, 0],
        // 21 isn't widely supported and 22 does the same thing
        bold: [1, 22],
        dim: [2, 22],
        italic: [3, 23],
        underline: [4, 24],
        overline: [53, 55],
        inverse: [7, 27],
        hidden: [8, 28],
        strikethrough: [9, 29]
      },
      color: {
        black: [30, 39],
        red: [31, 39],
        green: [32, 39],
        yellow: [33, 39],
        blue: [34, 39],
        magenta: [35, 39],
        cyan: [36, 39],
        white: [37, 39],
        // Bright color
        blackBright: [90, 39],
        redBright: [91, 39],
        greenBright: [92, 39],
        yellowBright: [93, 39],
        blueBright: [94, 39],
        magentaBright: [95, 39],
        cyanBright: [96, 39],
        whiteBright: [97, 39]
      },
      bgColor: {
        bgBlack: [40, 49],
        bgRed: [41, 49],
        bgGreen: [42, 49],
        bgYellow: [43, 49],
        bgBlue: [44, 49],
        bgMagenta: [45, 49],
        bgCyan: [46, 49],
        bgWhite: [47, 49],
        // Bright color
        bgBlackBright: [100, 49],
        bgRedBright: [101, 49],
        bgGreenBright: [102, 49],
        bgYellowBright: [103, 49],
        bgBlueBright: [104, 49],
        bgMagentaBright: [105, 49],
        bgCyanBright: [106, 49],
        bgWhiteBright: [107, 49]
      }
    };
    d.color.gray = d.color.blackBright, d.bgColor.bgGray = d.bgColor.bgBlackBright, d.color.grey = d.color.blackBright, d.bgColor.bgGrey = d.bgColor.bgBlackBright;
    for (const [y, g] of Object.entries(d)) {
      for (const [b, x] of Object.entries(g))
        d[b] = {
          open: `\x1B[${x[0]}m`,
          close: `\x1B[${x[1]}m`
        }, g[b] = d[b], h.set(x[0], x[1]);
      Object.defineProperty(d, y, {
        value: g,
        enumerable: !1
      });
    }
    return Object.defineProperty(d, "codes", {
      value: h,
      enumerable: !1
    }), d.color.close = "\x1B[39m", d.bgColor.close = "\x1B[49m", d.color.ansi256 = a(), d.color.ansi16m = i(), d.bgColor.ansi256 = a(10), d.bgColor.ansi16m = i(10), Object.defineProperties(d, {
      rgbToAnsi256: {
        value: (y, g, b) => y === g && g === b ? y < 8 ? 16 : y > 248 ? 231 : Math.round((y - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(y / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5),
        enumerable: !1
      },
      hexToRgb: {
        value: (y) => {
          const g = /(?<colorString>[a-f\d]{6}|[a-f\d]{3})/i.exec(y.toString(16));
          if (!g)
            return [0, 0, 0];
          let { colorString: b } = g.groups;
          b.length === 3 && (b = b.split("").map((T) => T + T).join(""));
          const x = Number.parseInt(b, 16);
          return [
            x >> 16 & 255,
            x >> 8 & 255,
            x & 255
          ];
        },
        enumerable: !1
      },
      hexToAnsi256: {
        value: (y) => d.rgbToAnsi256(...d.hexToRgb(y)),
        enumerable: !1
      }
    }), d;
  }
  Object.defineProperty(r, "exports", {
    enumerable: !0,
    get: s
  });
})(u7);
var eR = u7.exports;
const tR = /* @__PURE__ */ eh(eR), { color: PH } = tR;
new Set("ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvxyz0123456789");
class D6 extends Error {
  constructor(t) {
    super(t.message), this.name = t.name ?? t.error ?? "StreamError";
  }
  static isStructuredError(t) {
    return typeof t == "object" && t != null && "message" in t;
  }
}
function nR(r) {
  try {
    return ZA(r);
  } catch {
    return null;
  }
}
class rR {
  constructor() {
    Object.defineProperty(this, "chunks", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: {}
    }), this.chunks = {};
  }
  add(t) {
    var h, d;
    t.type.endsWith("MessageChunk") && (t.type = t.type.slice(0, -12).toLowerCase());
    const a = QA(t), i = nR(a), s = (i ?? a).id;
    if (!s)
      return console.warn("No message ID found for chunk, ignoring in state", t), null;
    if ((h = this.chunks)[s] ?? (h[s] = {}), i) {
      const y = this.chunks[s].chunk;
      this.chunks[s].chunk = ((d = jA(y) ? y : null) == null ? void 0 : d.concat(i)) ?? i;
    } else
      this.chunks[s].chunk = a;
    return s;
  }
  clear() {
    this.chunks = {};
  }
  get(t, a) {
    var i;
    return this.chunks[t] == null ? null : ((i = this.chunks[t]).index ?? (i.index = a), this.chunks[t]);
  }
}
const aR = (r) => {
  const { type: t, data: a } = r.toDict();
  return { ...a, type: t };
};
function lR(r) {
  return [...new Set(r)];
}
function iR(r, t) {
  for (let a = r.length - 1; a >= 0; a--)
    if (t(r[a]))
      return a;
  return -1;
}
function uR(r) {
  const t = {};
  r.forEach((d) => {
    var g;
    const y = ((g = d.parent_checkpoint) == null ? void 0 : g.checkpoint_id) ?? "$";
    t[y] ?? (t[y] = []), t[y].push(d);
  });
  const a = { type: "sequence", items: [] }, i = [{ id: "$", sequence: a, path: [] }], s = [], h = /* @__PURE__ */ new Set();
  for (; i.length > 0; ) {
    const d = i.shift();
    if (h.has(d.id))
      continue;
    h.add(d.id);
    const y = t[d.id];
    if (y == null || y.length === 0)
      continue;
    let g;
    y.length > 1 && (g = { type: "fork", items: [] }, d.sequence.items.push(g));
    for (const b of y) {
      const x = b.checkpoint.checkpoint_id;
      let T = d.sequence, R = d.path;
      g != null && (T = { type: "sequence", items: [] }, g.items.unshift(T), R = R.slice(), R.push(x), s.push(R)), T.items.push({ type: "node", value: b, path: R }), i.push({ id: x, sequence: T, path: R });
    }
  }
  return { rootSequence: a, paths: s };
}
const N6 = ">", E2 = "$";
function oR(r, t, a) {
  var b;
  const i = a.split(N6), s = {};
  for (const x of t) {
    const T = x.at(-2) ?? E2;
    s[T] ?? (s[T] = []), s[T].unshift(x);
  }
  const h = [], d = {}, y = i.slice(), g = [...r.items];
  for (; g.length > 0; ) {
    const x = g.shift();
    if (x.type === "node" && (h.push(x.value), d[x.value.checkpoint.checkpoint_id] = {
      branch: x.path.join(N6),
      branchOptions: (x.path.length > 0 ? s[x.path.at(-2) ?? E2] ?? [] : []).map((T) => T.join(N6))
    }), x.type === "fork") {
      const T = y.shift(), R = T != null ? x.items.findIndex((O) => {
        const L = O.items.at(0);
        return !L || L.type !== "node" ? !1 : L.value.checkpoint.checkpoint_id === T;
      }) : -1, E = ((b = x.items.at(R)) == null ? void 0 : b.items) ?? [];
      g.push(...E);
    }
  }
  return { history: h, branchByCheckpoint: d };
}
function sR(r, t) {
  return r.threads.getHistory(t, { limit: 1e3 });
}
function cR(r, t, a, i) {
  const [s, h] = zt.useState([]), d = zt.useCallback((y) => {
    var g;
    return y != null ? sR(t, y).then((b) => (h(b), b)) : (h([]), (g = a.current) == null || g.call(a), Promise.resolve([]));
  }, []);
  return zt.useEffect(() => {
    i.current || d(r);
  }, [d, i, r]), {
    data: s,
    mutate: (y) => d(y ?? r)
  };
}
const fR = (r) => {
  const [t, a] = zt.useState((r == null ? void 0 : r.threadId) ?? null), i = zt.useRef(r == null ? void 0 : r.onThreadId);
  i.current = r == null ? void 0 : r.onThreadId;
  const s = zt.useCallback((h) => {
    var d;
    a(h), (d = i.current) == null || d.call(i, h);
  }, []);
  return !r || !("threadId" in r) ? [t, s] : [r.threadId ?? null, s];
};
function hR(r) {
  let { assistantId: t, messagesKey: a, onError: i, onFinish: s } = r;
  a ?? (a = "messages");
  const h = zt.useMemo(() => r.client ?? new EA({
    apiUrl: r.apiUrl,
    apiKey: r.apiKey,
    callerOptions: r.callerOptions,
    defaultHeaders: r.defaultHeaders
  }), [
    r.client,
    r.apiKey,
    r.apiUrl,
    r.callerOptions,
    r.defaultHeaders
  ]), [d, y] = fR(r), [g, b] = zt.useState(""), [x, T] = zt.useState(!1), [R, E] = zt.useState(void 0), [O, L] = zt.useState(null), G = zt.useRef(new rR()), V = zt.useRef(!1), I = zt.useRef(null), $ = zt.useRef([]), ce = zt.useCallback((..._e) => {
    for (const Se of _e)
      $.current.includes(Se) || $.current.push(Se);
  }, []), se = r.onUpdateEvent != null, te = r.onCustomEvent != null, Ce = r.onLangChainEvent != null, ve = r.onDebugEvent != null, Ne = zt.useMemo(() => {
    const _e = [];
    return se && _e.push("updates"), te && _e.push("custom"), Ce && _e.push("events"), ve && _e.push("debug"), _e;
  }, [
    se,
    te,
    Ce,
    ve
  ]), ee = zt.useRef(null);
  ee.current = () => {
    E(void 0), L(null);
  };
  const De = cR(d, h, ee, V), de = zt.useMemo(() => (_e) => Array.isArray(_e[a]) ? _e[a] : [], [a]), { rootSequence: Ye, paths: Te } = uR(De.data), { history: re, branchByCheckpoint: J } = oR(Ye, Te, g), X = re.at(-1), W = (X == null ? void 0 : X.values) ?? {}, be = (() => {
    var Se, Ge;
    const _e = (Ge = (Se = X == null ? void 0 : X.tasks) == null ? void 0 : Se.at(-1)) == null ? void 0 : Ge.error;
    if (_e != null) {
      try {
        const rt = JSON.parse(_e);
        return D6.isStructuredError(rt) ? new D6(rt) : rt;
      } catch {
      }
      return _e;
    }
  })(), C = (() => {
    const _e = /* @__PURE__ */ new Set();
    return de(W).map((Se, Ge) => {
      var Dr, jn;
      const rt = Se.id ?? Ge, ht = iR(De.data, (Gn) => de(Gn.values).map((xr, Bt) => xr.id ?? Bt).includes(rt)), vt = De.data[ht];
      let St = vt ? J[vt.checkpoint.checkpoint_id] : void 0;
      (Dr = St == null ? void 0 : St.branch) != null && Dr.length || (St = void 0);
      const wn = (jn = St == null ? void 0 : St.branchOptions) == null ? void 0 : jn.flat(2).join(",");
      return wn && (_e.has(wn) && (St = void 0), _e.add(wn)), {
        messageId: rt.toString(),
        firstSeenState: vt,
        branch: St == null ? void 0 : St.branch,
        branchOptions: St == null ? void 0 : St.branchOptions
      };
    });
  })(), Y = zt.useCallback(() => {
    I.current != null && I.current.abort(), I.current = null;
  }, []), ie = async (_e, Se) => {
    var Ge, rt, ht, vt, St, wn, Dr, jn;
    try {
      T(!0), E(void 0), V.current = !0, I.current = new AbortController();
      const Gn = (Ge = Se == null ? void 0 : Se.checkpoint) != null && Ge.checkpoint_id ? (ht = J[(rt = Se == null ? void 0 : Se.checkpoint) == null ? void 0 : rt.checkpoint_id]) == null ? void 0 : ht.branch : void 0;
      Gn != null && b(Gn ?? ""), L(() => {
        const Tn = { ...W };
        return (Se == null ? void 0 : Se.optimisticValues) != null ? {
          ...Tn,
          ...typeof Se.optimisticValues == "function" ? Se.optimisticValues(Tn) : Se.optimisticValues
        } : Tn;
      });
      let xr = d;
      if (!xr) {
        const Tn = await h.threads.create();
        y(Tn.thread_id), xr = Tn.thread_id;
      }
      const Bt = lR([
        ...(Se == null ? void 0 : Se.streamMode) ?? [],
        ...$.current,
        ...Ne
      ]), er = (Se == null ? void 0 : Se.checkpoint) ?? (X == null ? void 0 : X.checkpoint) ?? void 0;
      er != null && delete er.thread_id;
      const sr = h.runs.stream(xr, t, {
        input: _e,
        config: Se == null ? void 0 : Se.config,
        command: Se == null ? void 0 : Se.command,
        interruptBefore: Se == null ? void 0 : Se.interruptBefore,
        interruptAfter: Se == null ? void 0 : Se.interruptAfter,
        metadata: Se == null ? void 0 : Se.metadata,
        multitaskStrategy: Se == null ? void 0 : Se.multitaskStrategy,
        onCompletion: Se == null ? void 0 : Se.onCompletion,
        onDisconnect: (Se == null ? void 0 : Se.onDisconnect) ?? "cancel",
        signal: I.current.signal,
        checkpoint: er,
        streamMode: Bt
      });
      let El;
      for await (const { event: Tn, data: cr } of sr) {
        if (Tn === "error") {
          El = new D6(cr);
          break;
        }
        if (Tn === "updates" && ((vt = r.onUpdateEvent) == null || vt.call(r, cr)), Tn === "custom" && ((St = r.onCustomEvent) == null || St.call(r, cr, {
          mutate: (rl) => L((ke) => ke == null ? ke : {
            ...ke,
            ...typeof rl == "function" ? rl(ke) : rl
          })
        })), Tn === "metadata" && ((wn = r.onMetadataEvent) == null || wn.call(r, cr)), Tn === "events" && ((Dr = r.onLangChainEvent) == null || Dr.call(r, cr)), Tn === "debug" && ((jn = r.onDebugEvent) == null || jn.call(r, cr)), Tn === "values" && L(cr), Tn === "messages") {
          const [rl] = cr, ke = G.current.add(rl);
          if (!ke) {
            console.warn("Failed to add message to manager, no message ID found");
            continue;
          }
          L((je) => {
            const ut = { ...W, ...je }, st = de(ut).slice(), { chunk: Qt, index: Zn } = G.current.get(ke, st.length) ?? {};
            return !Qt || Zn == null ? ut : (st[Zn] = aR(Qt), { ...ut, [a]: st });
          });
        }
      }
      const xt = await De.mutate(xr);
      if (L(null), El != null)
        throw El;
      const nl = xt.at(0);
      nl && (s == null || s(nl));
    } catch (Gn) {
      Gn instanceof Error && (Gn.name === "AbortError" || Gn.name === "TimeoutError") || (console.error(Gn), E(Gn), i == null || i(Gn));
    } finally {
      T(!1), G.current.clear(), V.current = !1, I.current = null;
    }
  }, N = R ?? be, Me = O ?? W;
  return {
    get values() {
      return ce("values"), Me;
    },
    client: h,
    assistantId: t,
    error: N,
    isLoading: x,
    stop: Y,
    submit: ie,
    branch: g,
    setBranch: b,
    history: re,
    experimental_branchTree: Ye,
    get interrupt() {
      var Se, Ge;
      if (x)
        return;
      const _e = (Ge = (Se = X == null ? void 0 : X.tasks) == null ? void 0 : Se.at(-1)) == null ? void 0 : Ge.interrupts;
      return _e == null || _e.length === 0 ? !((X == null ? void 0 : X.next) ?? []).length || N != null ? void 0 : { when: "breakpoint" } : _e.at(-1);
    },
    get messages() {
      return ce("messages-tuple", "values"), de(Me);
    },
    getMessagesMetadata(_e, Se) {
      return ce("messages-tuple", "values"), C == null ? void 0 : C.find((Ge) => Ge.messageId === (_e.id ?? Se));
    }
  };
}
const QS = () => {
  const r = window.fetch, t = async (s) => {
    if (!s) return null;
    if (typeof s == "string")
      try {
        return JSON.parse(s);
      } catch {
        return s;
      }
    if (s instanceof FormData) {
      const h = {};
      for (const [d, y] of s.entries())
        h[d] = y;
      return h;
    }
    if (s instanceof ReadableStream)
      return "[ReadableStream - cannot log without consuming]";
    if (s instanceof Blob)
      try {
        const h = await s.text();
        try {
          return JSON.parse(h);
        } catch {
          return h;
        }
      } catch {
        return "[Blob - cannot read content]";
      }
    return s;
  }, a = async (s, h) => {
    const d = (/* @__PURE__ */ new Date()).toISOString(), y = h.method || "GET", g = h.headers || {}, b = h.body;
    if (console.group(`🌐 HTTP ${y} Request - ${d}`), console.log("URL:", s), console.log("Method:", y), console.log("Headers:", g), b)
      try {
        const x = await t(b);
        console.log("Request Body:", x), typeof x == "object" && x !== null && console.log("Request Body (formatted):", JSON.stringify(x, null, 2));
      } catch (x) {
        console.log("Request Body (raw):", b), console.log("Request Body parsing error:", x);
      }
    console.groupEnd();
  }, i = (s, h, d) => {
    const y = (/* @__PURE__ */ new Date()).toISOString(), g = h.status, b = h.statusText;
    console.group(`📥 HTTP Response - ${y}`), console.log("URL:", s), console.log("Status:", `${g} ${b}`), console.log("Headers:", Object.fromEntries(h.headers.entries())), d && (console.log("Response Body:", d), typeof d == "object" && d !== null && console.log("Response Body (formatted):", JSON.stringify(d, null, 2))), console.groupEnd();
  };
  window.fetch = async (s, h) => {
    const d = typeof s == "string" ? s : s.toString();
    await a(d, h || {});
    try {
      const y = await r(s, h), g = y.clone();
      try {
        const b = y.headers.get("content-type");
        if (b && b.includes("application/json")) {
          const x = await g.json();
          i(d, y, x);
        } else
          i(d, y);
      } catch {
        i(d, y);
      }
      return y;
    } catch (y) {
      throw console.error("❌ HTTP Request Failed:", y), y;
    }
  };
};
QS();
QS();
const dR = hR, ZS = zt.createContext(void 0), mR = ({
  children: r,
  apiUrl: t,
  assistantId: a,
  authHash: i,
  threadId: s = null
}) => {
  const [h, d] = zt.useState(s), g = {
    stream: dR({
      apiUrl: t,
      assistantId: a,
      threadId: h,
      defaultHeaders: {
        ...i ? { Authorization: `Bearer ${i}` } : {}
      },
      onThreadId: (b) => {
        d(b);
      }
    }),
    threadId: h,
    setThreadId: d,
    apiUrl: t,
    assistantId: a,
    authHash: i
  };
  return /* @__PURE__ */ He.jsx(ZS.Provider, { value: g, children: r });
}, pR = ({
  children: r,
  apiUrl: t = "http://localhost:2024",
  assistantId: a = "agent",
  authHash: i,
  threadId: s
}) => /* @__PURE__ */ He.jsx(
  mR,
  {
    apiUrl: t,
    assistantId: a,
    authHash: i,
    threadId: s,
    children: r
  }
), o7 = () => {
  const r = zt.useContext(ZS);
  if (r === void 0)
    throw new Error("useStreamContext must be used within a StreamProvider");
  return r;
};
let iv;
const gR = new Uint8Array(16);
function yR() {
  if (!iv && (iv = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !iv))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return iv(gR);
}
const ca = [];
for (let r = 0; r < 256; ++r)
  ca.push((r + 256).toString(16).slice(1));
function vR(r, t = 0) {
  return ca[r[t + 0]] + ca[r[t + 1]] + ca[r[t + 2]] + ca[r[t + 3]] + "-" + ca[r[t + 4]] + ca[r[t + 5]] + "-" + ca[r[t + 6]] + ca[r[t + 7]] + "-" + ca[r[t + 8]] + ca[r[t + 9]] + "-" + ca[r[t + 10]] + ca[r[t + 11]] + ca[r[t + 12]] + ca[r[t + 13]] + ca[r[t + 14]] + ca[r[t + 15]];
}
const bR = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), A2 = {
  randomUUID: bR
};
function SR(r, t, a) {
  if (A2.randomUUID && !r)
    return A2.randomUUID();
  r = r || {};
  const i = r.random || (r.rng || yR)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, vR(i);
}
function L6(r) {
  return {
    id: SR(),
    type: "system",
    content: r,
    createdAt: /* @__PURE__ */ new Date()
  };
}
const Cv = "Ahoj, s čím ti můžu pomoci?";
let FS = Cv, Tv = [];
function xR(r) {
  FS = r, Tv.forEach((t) => t(r));
}
function wR() {
  return FS;
}
function TR(r) {
  return Tv.push(r), () => {
    Tv = Tv.filter((t) => t !== r);
  };
}
const PS = () => {
  const [r, t] = zt.useState([]), [a, i] = zt.useState([]), [s, h] = zt.useState(""), [d, y] = zt.useState(!1), g = zt.useRef(null), { stream: b, setThreadId: x, threadId: T, authHash: R } = o7(), E = zt.useRef(/* @__PURE__ */ new Map()), O = zt.useRef(null);
  zt.useEffect(() => {
    if (b && b.messages) {
      const I = E.current, $ = /* @__PURE__ */ new Map(), ce = b.messages.map((se) => {
        var De;
        const te = se.id || ((De = se.chunk) == null ? void 0 : De.id) || `transient_${Math.random().toString(36).substring(2, 9)}`;
        let Ce;
        const ve = se.tool_calls || se.chunk && se.chunk.tool_calls;
        Ce = se.type, (Array.isArray(ve) && ve.length > 0 || se.tool_call_id) && (Ce = "tool"), Ce !== "tool" && Ce !== "human" && se.name !== "loco_supervisor" && (Ce = "tool");
        const ee = typeof se.content == "string" ? se.content : JSON.stringify(se.content);
        if (I.has(te)) {
          const de = I.get(te);
          if (de.content !== ee || de.type !== Ce) {
            const Ye = {
              ...de,
              content: ee,
              type: Ce
            };
            return $.set(te, Ye), Ye;
          }
          return $.set(te, de), de;
        } else {
          const de = {
            id: te,
            type: Ce,
            content: ee,
            createdAt: /* @__PURE__ */ new Date()
          };
          return $.set(te, de), de;
        }
      });
      E.current = $, (r.length !== ce.length || ce.some((se, te) => se !== r[te])) && t(ce);
    }
  }, [b == null ? void 0 : b.messages, r]), zt.useEffect(() => {
    g.current && !d && g.current.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [r, d, a]);
  const L = zt.useCallback(async () => {
    if (!s.trim() || !b || b.isLoading) return;
    const I = s.trim();
    h("");
    try {
      await b.submit(
        {
          messages: [{ type: "human", content: I }],
          context: { token: R ? { authHash: R } : void 0, testovac: "testovaci context" }
        },
        {
          streamMode: ["values"]
        }
      );
    } catch {
      let ce;
      ce = L6(
        "Omlouváme se, došlo k chybě při odesílání zprávy. Zkuste to prosím znovu nebo kontaktujte podporu."
      );
      const se = `error_${Date.now()}`, te = { ...ce, id: se, createdAt: /* @__PURE__ */ new Date() };
      i((Ce) => [...Ce, te]);
    }
  }, [s, b, h, t, R]), G = () => {
    b && typeof b.stop == "function" && b.stop(), h(""), i([]), t((I) => [
      ...I,
      {
        id: `cancel_${Date.now()}`,
        type: "system",
        content: "Odpověď byla zrušena uživatelem."
      }
    ]);
  }, V = () => {
    x(null), h(""), t([]), i([]);
  };
  return zt.useEffect(() => {
    var I;
    if (t([]), i([]), E.current = /* @__PURE__ */ new Map(), T && !Xg().some((ce) => ce.threadId === T)) {
      let ce = (/* @__PURE__ */ new Date()).toISOString(), se = (I = b == null ? void 0 : b.messages) == null ? void 0 : I.find((Ce) => Ce.type === "human"), te = se && typeof se.content == "string" ? se.content.slice(0, 150) : "";
      k2(T, ce, te);
    }
  }, [T]), zt.useEffect(() => {
    if (!T) return;
    const $ = Xg().find((ce) => ce.threadId === T);
    if ($ && (!$.title || $.title === "")) {
      let ce = r.find((te) => te.type === "human"), se = ce && typeof ce.content == "string" ? ce.content.slice(0, 150) : "";
      se && k2(T, $.createdAt, se);
    }
  }, [r, T]), zt.useEffect(() => {
    if (b && b.error && b.error !== O.current) {
      O.current = b.error;
      let I;
      const $ = typeof b.error == "object" && b.error !== null ? b.error : {}, ce = typeof $ == "object" && "name" in $ ? $.name : "", se = typeof $ == "object" && $.constructor && $.constructor.name ? $.constructor.name : "";
      if (ce === "_HTTPError" || typeof se == "string" && se.includes("HTTP")) {
        const ve = "status" in $ ? $.status : $ && "response" in $ && $.response && $.response.status, Ne = "message" in $ ? $.message : String(b.error);
        I = L6(
          `Omlouváme se, došlo k HTTP chybě při odesílání zprávy (status: ${ve ?? "neznámý"}).
${Ne}`
        );
      } else
        I = L6(
          "Omlouváme se, došlo k chybě při odesílání zprávy. Zkuste to prosím znovu nebo kontaktujte podporu."
        );
      const te = `error_${Date.now()}`, Ce = { ...I, id: te, createdAt: /* @__PURE__ */ new Date() };
      i((ve) => [...ve, Ce]);
    }
  }, [b == null ? void 0 : b.error]), {
    messages: [...r, ...a].sort((I, $) => {
      const ce = I.createdAt ? new Date(I.createdAt).getTime() : 0, se = $.createdAt ? new Date($.createdAt).getTime() : 0;
      return ce - se;
    }),
    inputValue: s,
    setInputValue: h,
    isMinimized: d,
    setIsMinimized: y,
    messagesEndRef: g,
    handleSendMessage: L,
    isLoading: (b == null ? void 0 : b.isLoading) || !1,
    handleCancel: G,
    handleNewChat: V
  };
}, KS = "chatWidgetThreadHistory";
function Xg() {
  try {
    const r = localStorage.getItem(KS);
    if (!r) return [];
    const t = JSON.parse(r);
    return Array.isArray(t) ? t.filter((a) => a && typeof a.threadId == "string" && typeof a.createdAt == "string" && typeof a.title == "string") : [];
  } catch {
    return [];
  }
}
function k2(r, t, a) {
  if (!r) return;
  let i = Xg();
  i = i.filter((s) => s.threadId !== r), i.unshift({ threadId: r, createdAt: t, title: a }), i.length > 20 && (i = i.slice(0, 20)), localStorage.setItem(KS, JSON.stringify(i));
}
function R2(r) {
  const t = [], a = String(r || "");
  let i = a.indexOf(","), s = 0, h = !1;
  for (; !h; ) {
    i === -1 && (i = a.length, h = !0);
    const d = a.slice(s, i).trim();
    (d || !h) && t.push(d), s = i + 1, i = a.indexOf(",", s);
  }
  return t;
}
function ER(r, t) {
  const a = {};
  return (r[r.length - 1] === "" ? [...r, ""] : r).join(
    (a.padRight ? " " : "") + "," + (a.padLeft === !1 ? "" : " ")
  ).trim();
}
const AR = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, kR = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, RR = {};
function z2(r, t) {
  return (RR.jsx ? kR : AR).test(r);
}
const zR = /[ \t\n\f\r]/g;
function CR(r) {
  return typeof r == "object" ? r.type === "text" ? C2(r.value) : !1 : C2(r);
}
function C2(r) {
  return r.replace(zR, "") === "";
}
class t4 {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, a, i) {
    this.normal = a, this.property = t, i && (this.space = i);
  }
}
t4.prototype.normal = {};
t4.prototype.property = {};
t4.prototype.space = void 0;
function JS(r, t) {
  const a = {}, i = {};
  for (const s of r)
    Object.assign(a, s.property), Object.assign(i, s.normal);
  return new t4(a, i, t);
}
function Qg(r) {
  return r.toLowerCase();
}
class wl {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, a) {
    this.attribute = a, this.property = t;
  }
}
wl.prototype.attribute = "";
wl.prototype.booleanish = !1;
wl.prototype.boolean = !1;
wl.prototype.commaOrSpaceSeparated = !1;
wl.prototype.commaSeparated = !1;
wl.prototype.defined = !1;
wl.prototype.mustUseProperty = !1;
wl.prototype.number = !1;
wl.prototype.overloadedBoolean = !1;
wl.prototype.property = "";
wl.prototype.spaceSeparated = !1;
wl.prototype.space = void 0;
let MR = 0;
const jt = th(), _r = th(), S5 = th(), Xe = th(), Ln = th(), Em = th(), Wl = th();
function th() {
  return 2 ** ++MR;
}
const x5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: jt,
  booleanish: _r,
  commaOrSpaceSeparated: Wl,
  commaSeparated: Em,
  number: Xe,
  overloadedBoolean: S5,
  spaceSeparated: Ln
}, Symbol.toStringTag, { value: "Module" })), B6 = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(x5)
);
class s7 extends wl {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, a, i, s) {
    let h = -1;
    if (super(t, a), M2(this, "space", s), typeof i == "number")
      for (; ++h < B6.length; ) {
        const d = B6[h];
        M2(this, B6[h], (i & x5[d]) === x5[d]);
      }
  }
}
s7.prototype.defined = !0;
function M2(r, t, a) {
  a && (r[t] = a);
}
function _m(r) {
  const t = {}, a = {};
  for (const [i, s] of Object.entries(r.properties)) {
    const h = new s7(
      i,
      r.transform(r.attributes || {}, i),
      s,
      r.space
    );
    r.mustUseProperty && r.mustUseProperty.includes(i) && (h.mustUseProperty = !0), t[i] = h, a[Qg(i)] = i, a[Qg(h.attribute)] = i;
  }
  return new t4(t, a, r.space);
}
const WS = _m({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: _r,
    ariaAutoComplete: null,
    ariaBusy: _r,
    ariaChecked: _r,
    ariaColCount: Xe,
    ariaColIndex: Xe,
    ariaColSpan: Xe,
    ariaControls: Ln,
    ariaCurrent: null,
    ariaDescribedBy: Ln,
    ariaDetails: null,
    ariaDisabled: _r,
    ariaDropEffect: Ln,
    ariaErrorMessage: null,
    ariaExpanded: _r,
    ariaFlowTo: Ln,
    ariaGrabbed: _r,
    ariaHasPopup: null,
    ariaHidden: _r,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Ln,
    ariaLevel: Xe,
    ariaLive: null,
    ariaModal: _r,
    ariaMultiLine: _r,
    ariaMultiSelectable: _r,
    ariaOrientation: null,
    ariaOwns: Ln,
    ariaPlaceholder: null,
    ariaPosInSet: Xe,
    ariaPressed: _r,
    ariaReadOnly: _r,
    ariaRelevant: null,
    ariaRequired: _r,
    ariaRoleDescription: Ln,
    ariaRowCount: Xe,
    ariaRowIndex: Xe,
    ariaRowSpan: Xe,
    ariaSelected: _r,
    ariaSetSize: Xe,
    ariaSort: null,
    ariaValueMax: Xe,
    ariaValueMin: Xe,
    ariaValueNow: Xe,
    ariaValueText: null,
    role: null
  },
  transform(r, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function ex(r, t) {
  return t in r ? r[t] : t;
}
function tx(r, t) {
  return ex(r, t.toLowerCase());
}
const _R = _m({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Em,
    acceptCharset: Ln,
    accessKey: Ln,
    action: null,
    allow: null,
    allowFullScreen: jt,
    allowPaymentRequest: jt,
    allowUserMedia: jt,
    alt: null,
    as: null,
    async: jt,
    autoCapitalize: null,
    autoComplete: Ln,
    autoFocus: jt,
    autoPlay: jt,
    blocking: Ln,
    capture: null,
    charSet: null,
    checked: jt,
    cite: null,
    className: Ln,
    cols: Xe,
    colSpan: null,
    content: null,
    contentEditable: _r,
    controls: jt,
    controlsList: Ln,
    coords: Xe | Em,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: jt,
    defer: jt,
    dir: null,
    dirName: null,
    disabled: jt,
    download: S5,
    draggable: _r,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: jt,
    formTarget: null,
    headers: Ln,
    height: Xe,
    hidden: S5,
    high: Xe,
    href: null,
    hrefLang: null,
    htmlFor: Ln,
    httpEquiv: Ln,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: jt,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: jt,
    itemId: null,
    itemProp: Ln,
    itemRef: Ln,
    itemScope: jt,
    itemType: Ln,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: jt,
    low: Xe,
    manifest: null,
    max: null,
    maxLength: Xe,
    media: null,
    method: null,
    min: null,
    minLength: Xe,
    multiple: jt,
    muted: jt,
    name: null,
    nonce: null,
    noModule: jt,
    noValidate: jt,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: jt,
    optimum: Xe,
    pattern: null,
    ping: Ln,
    placeholder: null,
    playsInline: jt,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: jt,
    referrerPolicy: null,
    rel: Ln,
    required: jt,
    reversed: jt,
    rows: Xe,
    rowSpan: Xe,
    sandbox: Ln,
    scope: null,
    scoped: jt,
    seamless: jt,
    selected: jt,
    shadowRootClonable: jt,
    shadowRootDelegatesFocus: jt,
    shadowRootMode: null,
    shape: null,
    size: Xe,
    sizes: null,
    slot: null,
    span: Xe,
    spellCheck: _r,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Xe,
    step: null,
    style: null,
    tabIndex: Xe,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: jt,
    useMap: null,
    value: _r,
    width: Xe,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Ln,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Xe,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Xe,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: jt,
    // Lists. Use CSS to reduce space between items instead
    declare: jt,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Xe,
    // `<img>` and `<object>`
    leftMargin: Xe,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Xe,
    // `<body>`
    marginWidth: Xe,
    // `<body>`
    noResize: jt,
    // `<frame>`
    noHref: jt,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: jt,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: jt,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Xe,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: _r,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Xe,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Xe,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: jt,
    disableRemotePlayback: jt,
    prefix: null,
    property: null,
    results: Xe,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: tx
}), OR = _m({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: Wl,
    accentHeight: Xe,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Xe,
    amplitude: Xe,
    arabicForm: null,
    ascent: Xe,
    attributeName: null,
    attributeType: null,
    azimuth: Xe,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Xe,
    by: null,
    calcMode: null,
    capHeight: Xe,
    className: Ln,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Xe,
    diffuseConstant: Xe,
    direction: null,
    display: null,
    dur: null,
    divisor: Xe,
    dominantBaseline: null,
    download: jt,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Xe,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Xe,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Xe,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Em,
    g2: Em,
    glyphName: Em,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Xe,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Xe,
    horizOriginX: Xe,
    horizOriginY: Xe,
    id: null,
    ideographic: Xe,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Xe,
    k: Xe,
    k1: Xe,
    k2: Xe,
    k3: Xe,
    k4: Xe,
    kernelMatrix: Wl,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Xe,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Xe,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Xe,
    overlineThickness: Xe,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Xe,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Ln,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Xe,
    pointsAtY: Xe,
    pointsAtZ: Xe,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Wl,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Wl,
    rev: Wl,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Wl,
    requiredFeatures: Wl,
    requiredFonts: Wl,
    requiredFormats: Wl,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Xe,
    specularExponent: Xe,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Xe,
    strikethroughThickness: Xe,
    string: null,
    stroke: null,
    strokeDashArray: Wl,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Xe,
    strokeOpacity: Xe,
    strokeWidth: null,
    style: null,
    surfaceScale: Xe,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Wl,
    tabIndex: Xe,
    tableValues: null,
    target: null,
    targetX: Xe,
    targetY: Xe,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Wl,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Xe,
    underlineThickness: Xe,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Xe,
    values: null,
    vAlphabetic: Xe,
    vMathematical: Xe,
    vectorEffect: null,
    vHanging: Xe,
    vIdeographic: Xe,
    version: null,
    vertAdvY: Xe,
    vertOriginX: Xe,
    vertOriginY: Xe,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Xe,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: ex
}), nx = _m({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(r, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), rx = _m({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: tx
}), ax = _m({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(r, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), DR = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, NR = /[A-Z]/g, _2 = /-[a-z]/g, LR = /^data[-\w.:]+$/i;
function lx(r, t) {
  const a = Qg(t);
  let i = t, s = wl;
  if (a in r.normal)
    return r.property[r.normal[a]];
  if (a.length > 4 && a.slice(0, 4) === "data" && LR.test(t)) {
    if (t.charAt(4) === "-") {
      const h = t.slice(5).replace(_2, HR);
      i = "data" + h.charAt(0).toUpperCase() + h.slice(1);
    } else {
      const h = t.slice(4);
      if (!_2.test(h)) {
        let d = h.replace(NR, BR);
        d.charAt(0) !== "-" && (d = "-" + d), t = "data" + d;
      }
    }
    s = s7;
  }
  return new s(i, t);
}
function BR(r) {
  return "-" + r.toLowerCase();
}
function HR(r) {
  return r.charAt(1).toUpperCase();
}
const ix = JS([WS, _R, nx, rx, ax], "html"), $v = JS([WS, OR, nx, rx, ax], "svg");
function O2(r) {
  const t = String(r || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function UR(r) {
  return r.join(" ").trim();
}
var c7 = {}, D2 = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, qR = /\n/g, jR = /^\s*/, GR = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, VR = /^:\s*/, YR = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, IR = /^[;\s]*/, $R = /^\s+|\s+$/g, XR = `
`, N2 = "/", L2 = "*", Kf = "", QR = "comment", ZR = "declaration", FR = function(r, t) {
  if (typeof r != "string")
    throw new TypeError("First argument must be a string");
  if (!r) return [];
  t = t || {};
  var a = 1, i = 1;
  function s(O) {
    var L = O.match(qR);
    L && (a += L.length);
    var G = O.lastIndexOf(XR);
    i = ~G ? O.length - G : i + O.length;
  }
  function h() {
    var O = { line: a, column: i };
    return function(L) {
      return L.position = new d(O), b(), L;
    };
  }
  function d(O) {
    this.start = O, this.end = { line: a, column: i }, this.source = t.source;
  }
  d.prototype.content = r;
  function y(O) {
    var L = new Error(
      t.source + ":" + a + ":" + i + ": " + O
    );
    if (L.reason = O, L.filename = t.source, L.line = a, L.column = i, L.source = r, !t.silent) throw L;
  }
  function g(O) {
    var L = O.exec(r);
    if (L) {
      var G = L[0];
      return s(G), r = r.slice(G.length), L;
    }
  }
  function b() {
    g(jR);
  }
  function x(O) {
    var L;
    for (O = O || []; L = T(); )
      L !== !1 && O.push(L);
    return O;
  }
  function T() {
    var O = h();
    if (!(N2 != r.charAt(0) || L2 != r.charAt(1))) {
      for (var L = 2; Kf != r.charAt(L) && (L2 != r.charAt(L) || N2 != r.charAt(L + 1)); )
        ++L;
      if (L += 2, Kf === r.charAt(L - 1))
        return y("End of comment missing");
      var G = r.slice(2, L - 2);
      return i += 2, s(G), r = r.slice(L), i += 2, O({
        type: QR,
        comment: G
      });
    }
  }
  function R() {
    var O = h(), L = g(GR);
    if (L) {
      if (T(), !g(VR)) return y("property missing ':'");
      var G = g(YR), V = O({
        type: ZR,
        property: B2(L[0].replace(D2, Kf)),
        value: G ? B2(G[0].replace(D2, Kf)) : Kf
      });
      return g(IR), V;
    }
  }
  function E() {
    var O = [];
    x(O);
    for (var L; L = R(); )
      L !== !1 && (O.push(L), x(O));
    return O;
  }
  return b(), E();
};
function B2(r) {
  return r ? r.replace($R, Kf) : Kf;
}
var PR = zv && zv.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(c7, "__esModule", { value: !0 });
c7.default = JR;
var KR = PR(FR);
function JR(r, t) {
  var a = null;
  if (!r || typeof r != "string")
    return a;
  var i = (0, KR.default)(r), s = typeof t == "function";
  return i.forEach(function(h) {
    if (h.type === "declaration") {
      var d = h.property, y = h.value;
      s ? t(d, y, h) : y && (a = a || {}, a[d] = y);
    }
  }), a;
}
var Xv = {};
Object.defineProperty(Xv, "__esModule", { value: !0 });
Xv.camelCase = void 0;
var WR = /^--[a-zA-Z0-9_-]+$/, ez = /-([a-z])/g, tz = /^[^-]+$/, nz = /^-(webkit|moz|ms|o|khtml)-/, rz = /^-(ms)-/, az = function(r) {
  return !r || tz.test(r) || WR.test(r);
}, lz = function(r, t) {
  return t.toUpperCase();
}, H2 = function(r, t) {
  return "".concat(t, "-");
}, iz = function(r, t) {
  return t === void 0 && (t = {}), az(r) ? r : (r = r.toLowerCase(), t.reactCompat ? r = r.replace(rz, H2) : r = r.replace(nz, H2), r.replace(ez, lz));
};
Xv.camelCase = iz;
var uz = zv && zv.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
}, oz = uz(c7), sz = Xv;
function w5(r, t) {
  var a = {};
  return !r || typeof r != "string" || (0, oz.default)(r, function(i, s) {
    i && s && (a[(0, sz.camelCase)(i, t)] = s);
  }), a;
}
w5.default = w5;
var cz = w5;
const fz = /* @__PURE__ */ eh(cz), ux = ox("end"), f7 = ox("start");
function ox(r) {
  return t;
  function t(a) {
    const i = a && a.position && a.position[r] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function hz(r) {
  const t = f7(r), a = ux(r);
  if (t && a)
    return { start: t, end: a };
}
function jg(r) {
  return !r || typeof r != "object" ? "" : "position" in r || "type" in r ? U2(r.position) : "start" in r || "end" in r ? U2(r) : "line" in r || "column" in r ? T5(r) : "";
}
function T5(r) {
  return q2(r && r.line) + ":" + q2(r && r.column);
}
function U2(r) {
  return T5(r && r.start) + "-" + T5(r && r.end);
}
function q2(r) {
  return r && typeof r == "number" ? r : 1;
}
class Na extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, a, i) {
    super(), typeof a == "string" && (i = a, a = void 0);
    let s = "", h = {}, d = !1;
    if (a && ("line" in a && "column" in a ? h = { place: a } : "start" in a && "end" in a ? h = { place: a } : "type" in a ? h = {
      ancestors: [a],
      place: a.position
    } : h = { ...a }), typeof t == "string" ? s = t : !h.cause && t && (d = !0, s = t.message, h.cause = t), !h.ruleId && !h.source && typeof i == "string") {
      const g = i.indexOf(":");
      g === -1 ? h.ruleId = i : (h.source = i.slice(0, g), h.ruleId = i.slice(g + 1));
    }
    if (!h.place && h.ancestors && h.ancestors) {
      const g = h.ancestors[h.ancestors.length - 1];
      g && (h.place = g.position);
    }
    const y = h.place && "start" in h.place ? h.place.start : h.place;
    this.ancestors = h.ancestors || void 0, this.cause = h.cause || void 0, this.column = y ? y.column : void 0, this.fatal = void 0, this.file, this.message = s, this.line = y ? y.line : void 0, this.name = jg(h.place) || "1:1", this.place = h.place || void 0, this.reason = this.message, this.ruleId = h.ruleId || void 0, this.source = h.source || void 0, this.stack = d && h.cause && typeof h.cause.stack == "string" ? h.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Na.prototype.file = "";
Na.prototype.name = "";
Na.prototype.reason = "";
Na.prototype.message = "";
Na.prototype.stack = "";
Na.prototype.column = void 0;
Na.prototype.line = void 0;
Na.prototype.ancestors = void 0;
Na.prototype.cause = void 0;
Na.prototype.fatal = void 0;
Na.prototype.place = void 0;
Na.prototype.ruleId = void 0;
Na.prototype.source = void 0;
const h7 = {}.hasOwnProperty, dz = /* @__PURE__ */ new Map(), mz = /[A-Z]/g, pz = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), gz = /* @__PURE__ */ new Set(["td", "th"]), sx = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function yz(r, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const a = t.filePath || void 0;
  let i;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = Az(a, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = Ez(a, t.jsx, t.jsxs);
  }
  const s = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: i,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: a,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? $v : ix,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, h = cx(s, r, void 0);
  return h && typeof h != "string" ? h : s.create(
    r,
    s.Fragment,
    { children: h || void 0 },
    void 0
  );
}
function cx(r, t, a) {
  if (t.type === "element")
    return vz(r, t, a);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return bz(r, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return xz(r, t, a);
  if (t.type === "mdxjsEsm")
    return Sz(r, t);
  if (t.type === "root")
    return wz(r, t, a);
  if (t.type === "text")
    return Tz(r, t);
}
function vz(r, t, a) {
  const i = r.schema;
  let s = i;
  t.tagName.toLowerCase() === "svg" && i.space === "html" && (s = $v, r.schema = s), r.ancestors.push(t);
  const h = hx(r, t.tagName, !1), d = kz(r, t);
  let y = m7(r, t);
  return pz.has(t.tagName) && (y = y.filter(function(g) {
    return typeof g == "string" ? !CR(g) : !0;
  })), fx(r, d, h, t), d7(d, y), r.ancestors.pop(), r.schema = i, r.create(t, h, d, a);
}
function bz(r, t) {
  if (t.data && t.data.estree && r.evaluater) {
    const i = t.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    r.evaluater.evaluateExpression(i.expression);
  }
  Zg(r, t.position);
}
function Sz(r, t) {
  if (t.data && t.data.estree && r.evaluater)
    return (
      /** @type {Child | undefined} */
      r.evaluater.evaluateProgram(t.data.estree)
    );
  Zg(r, t.position);
}
function xz(r, t, a) {
  const i = r.schema;
  let s = i;
  t.name === "svg" && i.space === "html" && (s = $v, r.schema = s), r.ancestors.push(t);
  const h = t.name === null ? r.Fragment : hx(r, t.name, !0), d = Rz(r, t), y = m7(r, t);
  return fx(r, d, h, t), d7(d, y), r.ancestors.pop(), r.schema = i, r.create(t, h, d, a);
}
function wz(r, t, a) {
  const i = {};
  return d7(i, m7(r, t)), r.create(t, r.Fragment, i, a);
}
function Tz(r, t) {
  return t.value;
}
function fx(r, t, a, i) {
  typeof a != "string" && a !== r.Fragment && r.passNode && (t.node = i);
}
function d7(r, t) {
  if (t.length > 0) {
    const a = t.length > 1 ? t : t[0];
    a && (r.children = a);
  }
}
function Ez(r, t, a) {
  return i;
  function i(s, h, d, y) {
    const b = Array.isArray(d.children) ? a : t;
    return y ? b(h, d, y) : b(h, d);
  }
}
function Az(r, t) {
  return a;
  function a(i, s, h, d) {
    const y = Array.isArray(h.children), g = f7(i);
    return t(
      s,
      h,
      d,
      y,
      {
        columnNumber: g ? g.column - 1 : void 0,
        fileName: r,
        lineNumber: g ? g.line : void 0
      },
      void 0
    );
  }
}
function kz(r, t) {
  const a = {};
  let i, s;
  for (s in t.properties)
    if (s !== "children" && h7.call(t.properties, s)) {
      const h = zz(r, s, t.properties[s]);
      if (h) {
        const [d, y] = h;
        r.tableCellAlignToStyle && d === "align" && typeof y == "string" && gz.has(t.tagName) ? i = y : a[d] = y;
      }
    }
  if (i) {
    const h = (
      /** @type {Style} */
      a.style || (a.style = {})
    );
    h[r.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return a;
}
function Rz(r, t) {
  const a = {};
  for (const i of t.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && r.evaluater) {
        const h = i.data.estree.body[0];
        h.type;
        const d = h.expression;
        d.type;
        const y = d.properties[0];
        y.type, Object.assign(
          a,
          r.evaluater.evaluateExpression(y.argument)
        );
      } else
        Zg(r, t.position);
    else {
      const s = i.name;
      let h;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && r.evaluater) {
          const y = i.value.data.estree.body[0];
          y.type, h = r.evaluater.evaluateExpression(y.expression);
        } else
          Zg(r, t.position);
      else
        h = i.value === null ? !0 : i.value;
      a[s] = /** @type {Props[keyof Props]} */
      h;
    }
  return a;
}
function m7(r, t) {
  const a = [];
  let i = -1;
  const s = r.passKeys ? /* @__PURE__ */ new Map() : dz;
  for (; ++i < t.children.length; ) {
    const h = t.children[i];
    let d;
    if (r.passKeys) {
      const g = h.type === "element" ? h.tagName : h.type === "mdxJsxFlowElement" || h.type === "mdxJsxTextElement" ? h.name : void 0;
      if (g) {
        const b = s.get(g) || 0;
        d = g + "-" + b, s.set(g, b + 1);
      }
    }
    const y = cx(r, h, d);
    y !== void 0 && a.push(y);
  }
  return a;
}
function zz(r, t, a) {
  const i = lx(r.schema, t);
  if (!(a == null || typeof a == "number" && Number.isNaN(a))) {
    if (Array.isArray(a) && (a = i.commaSeparated ? ER(a) : UR(a)), i.property === "style") {
      let s = typeof a == "object" ? a : Cz(r, String(a));
      return r.stylePropertyNameCase === "css" && (s = Mz(s)), ["style", s];
    }
    return [
      r.elementAttributeNameCase === "react" && i.space ? DR[i.property] || i.property : i.attribute,
      a
    ];
  }
}
function Cz(r, t) {
  try {
    return fz(t, { reactCompat: !0 });
  } catch (a) {
    if (r.ignoreInvalidStyle)
      return {};
    const i = (
      /** @type {Error} */
      a
    ), s = new Na("Cannot parse `style` attribute", {
      ancestors: r.ancestors,
      cause: i,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw s.file = r.filePath || void 0, s.url = sx + "#cannot-parse-style-attribute", s;
  }
}
function hx(r, t, a) {
  let i;
  if (!a)
    i = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const s = t.split(".");
    let h = -1, d;
    for (; ++h < s.length; ) {
      const y = z2(s[h]) ? { type: "Identifier", name: s[h] } : { type: "Literal", value: s[h] };
      d = d ? {
        type: "MemberExpression",
        object: d,
        property: y,
        computed: !!(h && y.type === "Literal"),
        optional: !1
      } : y;
    }
    i = d;
  } else
    i = z2(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (i.type === "Literal") {
    const s = (
      /** @type {string | number} */
      i.value
    );
    return h7.call(r.components, s) ? r.components[s] : s;
  }
  if (r.evaluater)
    return r.evaluater.evaluateExpression(i);
  Zg(r);
}
function Zg(r, t) {
  const a = new Na(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: r.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw a.file = r.filePath || void 0, a.url = sx + "#cannot-handle-mdx-estrees-without-createevaluater", a;
}
function Mz(r) {
  const t = {};
  let a;
  for (a in r)
    h7.call(r, a) && (t[_z(a)] = r[a]);
  return t;
}
function _z(r) {
  let t = r.replace(mz, Oz);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function Oz(r) {
  return "-" + r.toLowerCase();
}
const H6 = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, Dz = {};
function p7(r, t) {
  const a = Dz, i = typeof a.includeImageAlt == "boolean" ? a.includeImageAlt : !0, s = typeof a.includeHtml == "boolean" ? a.includeHtml : !0;
  return dx(r, i, s);
}
function dx(r, t, a) {
  if (Nz(r)) {
    if ("value" in r)
      return r.type === "html" && !a ? "" : r.value;
    if (t && "alt" in r && r.alt)
      return r.alt;
    if ("children" in r)
      return j2(r.children, t, a);
  }
  return Array.isArray(r) ? j2(r, t, a) : "";
}
function j2(r, t, a) {
  const i = [];
  let s = -1;
  for (; ++s < r.length; )
    i[s] = dx(r[s], t, a);
  return i.join("");
}
function Nz(r) {
  return !!(r && typeof r == "object");
}
const G2 = document.createElement("i");
function g7(r) {
  const t = "&" + r + ";";
  G2.innerHTML = t;
  const a = G2.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    a.charCodeAt(a.length - 1) === 59 && r !== "semi" || a === t ? !1 : a
  );
}
function ni(r, t, a, i) {
  const s = r.length;
  let h = 0, d;
  if (t < 0 ? t = -t > s ? 0 : s + t : t = t > s ? s : t, a = a > 0 ? a : 0, i.length < 1e4)
    d = Array.from(i), d.unshift(t, a), r.splice(...d);
  else
    for (a && r.splice(t, a); h < i.length; )
      d = i.slice(h, h + 1e4), d.unshift(t, 0), r.splice(...d), h += 1e4, t += 1e4;
}
function Di(r, t) {
  return r.length > 0 ? (ni(r, r.length, 0, t), r) : t;
}
const V2 = {}.hasOwnProperty;
function mx(r) {
  const t = {};
  let a = -1;
  for (; ++a < r.length; )
    Lz(t, r[a]);
  return t;
}
function Lz(r, t) {
  let a;
  for (a in t) {
    const s = (V2.call(r, a) ? r[a] : void 0) || (r[a] = {}), h = t[a];
    let d;
    if (h)
      for (d in h) {
        V2.call(s, d) || (s[d] = []);
        const y = h[d];
        Bz(
          // @ts-expect-error Looks like a list.
          s[d],
          Array.isArray(y) ? y : y ? [y] : []
        );
      }
  }
}
function Bz(r, t) {
  let a = -1;
  const i = [];
  for (; ++a < t.length; )
    (t[a].add === "after" ? r : i).push(t[a]);
  ni(r, 0, 0, i);
}
function px(r, t) {
  const a = Number.parseInt(r, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    a < 9 || a === 11 || a > 13 && a < 32 || // Control character (DEL) of C0, and C1 controls.
    a > 126 && a < 160 || // Lone high surrogates and low surrogates.
    a > 55295 && a < 57344 || // Noncharacters.
    a > 64975 && a < 65008 || /* eslint-disable no-bitwise */
    (a & 65535) === 65535 || (a & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    a > 1114111 ? "�" : String.fromCodePoint(a)
  );
}
function Au(r) {
  return r.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Wa = u0(/[A-Za-z]/), Da = u0(/[\dA-Za-z]/), Hz = u0(/[#-'*+\--9=?A-Z^-~]/);
function Mv(r) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    r !== null && (r < 32 || r === 127)
  );
}
const E5 = u0(/\d/), Uz = u0(/[\dA-Fa-f]/), qz = u0(/[!-/:-@[-`{-~]/);
function ft(r) {
  return r !== null && r < -2;
}
function Mn(r) {
  return r !== null && (r < 0 || r === 32);
}
function Jt(r) {
  return r === -2 || r === -1 || r === 32;
}
const Qv = u0(new RegExp("\\p{P}|\\p{S}", "u")), Wf = u0(/\s/);
function u0(r) {
  return t;
  function t(a) {
    return a !== null && a > -1 && r.test(String.fromCharCode(a));
  }
}
function Om(r) {
  const t = [];
  let a = -1, i = 0, s = 0;
  for (; ++a < r.length; ) {
    const h = r.charCodeAt(a);
    let d = "";
    if (h === 37 && Da(r.charCodeAt(a + 1)) && Da(r.charCodeAt(a + 2)))
      s = 2;
    else if (h < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(h)) || (d = String.fromCharCode(h));
    else if (h > 55295 && h < 57344) {
      const y = r.charCodeAt(a + 1);
      h < 56320 && y > 56319 && y < 57344 ? (d = String.fromCharCode(h, y), s = 1) : d = "�";
    } else
      d = String.fromCharCode(h);
    d && (t.push(r.slice(i, a), encodeURIComponent(d)), i = a + s + 1, d = ""), s && (a += s, s = 0);
  }
  return t.join("") + r.slice(i);
}
function Ft(r, t, a, i) {
  const s = i ? i - 1 : Number.POSITIVE_INFINITY;
  let h = 0;
  return d;
  function d(g) {
    return Jt(g) ? (r.enter(a), y(g)) : t(g);
  }
  function y(g) {
    return Jt(g) && h++ < s ? (r.consume(g), y) : (r.exit(a), t(g));
  }
}
const jz = {
  tokenize: Gz
};
function Gz(r) {
  const t = r.attempt(this.parser.constructs.contentInitial, i, s);
  let a;
  return t;
  function i(y) {
    if (y === null) {
      r.consume(y);
      return;
    }
    return r.enter("lineEnding"), r.consume(y), r.exit("lineEnding"), Ft(r, t, "linePrefix");
  }
  function s(y) {
    return r.enter("paragraph"), h(y);
  }
  function h(y) {
    const g = r.enter("chunkText", {
      contentType: "text",
      previous: a
    });
    return a && (a.next = g), a = g, d(y);
  }
  function d(y) {
    if (y === null) {
      r.exit("chunkText"), r.exit("paragraph"), r.consume(y);
      return;
    }
    return ft(y) ? (r.consume(y), r.exit("chunkText"), h) : (r.consume(y), d);
  }
}
const Vz = {
  tokenize: Yz
}, Y2 = {
  tokenize: Iz
};
function Yz(r) {
  const t = this, a = [];
  let i = 0, s, h, d;
  return y;
  function y($) {
    if (i < a.length) {
      const ce = a[i];
      return t.containerState = ce[1], r.attempt(ce[0].continuation, g, b)($);
    }
    return b($);
  }
  function g($) {
    if (i++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, s && I();
      const ce = t.events.length;
      let se = ce, te;
      for (; se--; )
        if (t.events[se][0] === "exit" && t.events[se][1].type === "chunkFlow") {
          te = t.events[se][1].end;
          break;
        }
      V(i);
      let Ce = ce;
      for (; Ce < t.events.length; )
        t.events[Ce][1].end = {
          ...te
        }, Ce++;
      return ni(t.events, se + 1, 0, t.events.slice(ce)), t.events.length = Ce, b($);
    }
    return y($);
  }
  function b($) {
    if (i === a.length) {
      if (!s)
        return R($);
      if (s.currentConstruct && s.currentConstruct.concrete)
        return O($);
      t.interrupt = !!(s.currentConstruct && !s._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, r.check(Y2, x, T)($);
  }
  function x($) {
    return s && I(), V(i), R($);
  }
  function T($) {
    return t.parser.lazy[t.now().line] = i !== a.length, d = t.now().offset, O($);
  }
  function R($) {
    return t.containerState = {}, r.attempt(Y2, E, O)($);
  }
  function E($) {
    return i++, a.push([t.currentConstruct, t.containerState]), R($);
  }
  function O($) {
    if ($ === null) {
      s && I(), V(0), r.consume($);
      return;
    }
    return s = s || t.parser.flow(t.now()), r.enter("chunkFlow", {
      _tokenizer: s,
      contentType: "flow",
      previous: h
    }), L($);
  }
  function L($) {
    if ($ === null) {
      G(r.exit("chunkFlow"), !0), V(0), r.consume($);
      return;
    }
    return ft($) ? (r.consume($), G(r.exit("chunkFlow")), i = 0, t.interrupt = void 0, y) : (r.consume($), L);
  }
  function G($, ce) {
    const se = t.sliceStream($);
    if (ce && se.push(null), $.previous = h, h && (h.next = $), h = $, s.defineSkip($.start), s.write(se), t.parser.lazy[$.start.line]) {
      let te = s.events.length;
      for (; te--; )
        if (
          // The token starts before the line ending…
          s.events[te][1].start.offset < d && // …and either is not ended yet…
          (!s.events[te][1].end || // …or ends after it.
          s.events[te][1].end.offset > d)
        )
          return;
      const Ce = t.events.length;
      let ve = Ce, Ne, ee;
      for (; ve--; )
        if (t.events[ve][0] === "exit" && t.events[ve][1].type === "chunkFlow") {
          if (Ne) {
            ee = t.events[ve][1].end;
            break;
          }
          Ne = !0;
        }
      for (V(i), te = Ce; te < t.events.length; )
        t.events[te][1].end = {
          ...ee
        }, te++;
      ni(t.events, ve + 1, 0, t.events.slice(Ce)), t.events.length = te;
    }
  }
  function V($) {
    let ce = a.length;
    for (; ce-- > $; ) {
      const se = a[ce];
      t.containerState = se[1], se[0].exit.call(t, r);
    }
    a.length = $;
  }
  function I() {
    s.write([null]), h = void 0, s = void 0, t.containerState._closeFlow = void 0;
  }
}
function Iz(r, t, a) {
  return Ft(r, r.attempt(this.parser.constructs.document, t, a), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function km(r) {
  if (r === null || Mn(r) || Wf(r))
    return 1;
  if (Qv(r))
    return 2;
}
function Zv(r, t, a) {
  const i = [];
  let s = -1;
  for (; ++s < r.length; ) {
    const h = r[s].resolveAll;
    h && !i.includes(h) && (t = h(t, a), i.push(h));
  }
  return t;
}
const A5 = {
  name: "attention",
  resolveAll: $z,
  tokenize: Xz
};
function $z(r, t) {
  let a = -1, i, s, h, d, y, g, b, x;
  for (; ++a < r.length; )
    if (r[a][0] === "enter" && r[a][1].type === "attentionSequence" && r[a][1]._close) {
      for (i = a; i--; )
        if (r[i][0] === "exit" && r[i][1].type === "attentionSequence" && r[i][1]._open && // If the markers are the same:
        t.sliceSerialize(r[i][1]).charCodeAt(0) === t.sliceSerialize(r[a][1]).charCodeAt(0)) {
          if ((r[i][1]._close || r[a][1]._open) && (r[a][1].end.offset - r[a][1].start.offset) % 3 && !((r[i][1].end.offset - r[i][1].start.offset + r[a][1].end.offset - r[a][1].start.offset) % 3))
            continue;
          g = r[i][1].end.offset - r[i][1].start.offset > 1 && r[a][1].end.offset - r[a][1].start.offset > 1 ? 2 : 1;
          const T = {
            ...r[i][1].end
          }, R = {
            ...r[a][1].start
          };
          I2(T, -g), I2(R, g), d = {
            type: g > 1 ? "strongSequence" : "emphasisSequence",
            start: T,
            end: {
              ...r[i][1].end
            }
          }, y = {
            type: g > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...r[a][1].start
            },
            end: R
          }, h = {
            type: g > 1 ? "strongText" : "emphasisText",
            start: {
              ...r[i][1].end
            },
            end: {
              ...r[a][1].start
            }
          }, s = {
            type: g > 1 ? "strong" : "emphasis",
            start: {
              ...d.start
            },
            end: {
              ...y.end
            }
          }, r[i][1].end = {
            ...d.start
          }, r[a][1].start = {
            ...y.end
          }, b = [], r[i][1].end.offset - r[i][1].start.offset && (b = Di(b, [["enter", r[i][1], t], ["exit", r[i][1], t]])), b = Di(b, [["enter", s, t], ["enter", d, t], ["exit", d, t], ["enter", h, t]]), b = Di(b, Zv(t.parser.constructs.insideSpan.null, r.slice(i + 1, a), t)), b = Di(b, [["exit", h, t], ["enter", y, t], ["exit", y, t], ["exit", s, t]]), r[a][1].end.offset - r[a][1].start.offset ? (x = 2, b = Di(b, [["enter", r[a][1], t], ["exit", r[a][1], t]])) : x = 0, ni(r, i - 1, a - i + 3, b), a = i + b.length - x - 2;
          break;
        }
    }
  for (a = -1; ++a < r.length; )
    r[a][1].type === "attentionSequence" && (r[a][1].type = "data");
  return r;
}
function Xz(r, t) {
  const a = this.parser.constructs.attentionMarkers.null, i = this.previous, s = km(i);
  let h;
  return d;
  function d(g) {
    return h = g, r.enter("attentionSequence"), y(g);
  }
  function y(g) {
    if (g === h)
      return r.consume(g), y;
    const b = r.exit("attentionSequence"), x = km(g), T = !x || x === 2 && s || a.includes(g), R = !s || s === 2 && x || a.includes(i);
    return b._open = !!(h === 42 ? T : T && (s || !R)), b._close = !!(h === 42 ? R : R && (x || !T)), t(g);
  }
}
function I2(r, t) {
  r.column += t, r.offset += t, r._bufferIndex += t;
}
const Qz = {
  name: "autolink",
  tokenize: Zz
};
function Zz(r, t, a) {
  let i = 0;
  return s;
  function s(E) {
    return r.enter("autolink"), r.enter("autolinkMarker"), r.consume(E), r.exit("autolinkMarker"), r.enter("autolinkProtocol"), h;
  }
  function h(E) {
    return Wa(E) ? (r.consume(E), d) : E === 64 ? a(E) : b(E);
  }
  function d(E) {
    return E === 43 || E === 45 || E === 46 || Da(E) ? (i = 1, y(E)) : b(E);
  }
  function y(E) {
    return E === 58 ? (r.consume(E), i = 0, g) : (E === 43 || E === 45 || E === 46 || Da(E)) && i++ < 32 ? (r.consume(E), y) : (i = 0, b(E));
  }
  function g(E) {
    return E === 62 ? (r.exit("autolinkProtocol"), r.enter("autolinkMarker"), r.consume(E), r.exit("autolinkMarker"), r.exit("autolink"), t) : E === null || E === 32 || E === 60 || Mv(E) ? a(E) : (r.consume(E), g);
  }
  function b(E) {
    return E === 64 ? (r.consume(E), x) : Hz(E) ? (r.consume(E), b) : a(E);
  }
  function x(E) {
    return Da(E) ? T(E) : a(E);
  }
  function T(E) {
    return E === 46 ? (r.consume(E), i = 0, x) : E === 62 ? (r.exit("autolinkProtocol").type = "autolinkEmail", r.enter("autolinkMarker"), r.consume(E), r.exit("autolinkMarker"), r.exit("autolink"), t) : R(E);
  }
  function R(E) {
    if ((E === 45 || Da(E)) && i++ < 63) {
      const O = E === 45 ? R : T;
      return r.consume(E), O;
    }
    return a(E);
  }
}
const n4 = {
  partial: !0,
  tokenize: Fz
};
function Fz(r, t, a) {
  return i;
  function i(h) {
    return Jt(h) ? Ft(r, s, "linePrefix")(h) : s(h);
  }
  function s(h) {
    return h === null || ft(h) ? t(h) : a(h);
  }
}
const gx = {
  continuation: {
    tokenize: Kz
  },
  exit: Jz,
  name: "blockQuote",
  tokenize: Pz
};
function Pz(r, t, a) {
  const i = this;
  return s;
  function s(d) {
    if (d === 62) {
      const y = i.containerState;
      return y.open || (r.enter("blockQuote", {
        _container: !0
      }), y.open = !0), r.enter("blockQuotePrefix"), r.enter("blockQuoteMarker"), r.consume(d), r.exit("blockQuoteMarker"), h;
    }
    return a(d);
  }
  function h(d) {
    return Jt(d) ? (r.enter("blockQuotePrefixWhitespace"), r.consume(d), r.exit("blockQuotePrefixWhitespace"), r.exit("blockQuotePrefix"), t) : (r.exit("blockQuotePrefix"), t(d));
  }
}
function Kz(r, t, a) {
  const i = this;
  return s;
  function s(d) {
    return Jt(d) ? Ft(r, h, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(d) : h(d);
  }
  function h(d) {
    return r.attempt(gx, t, a)(d);
  }
}
function Jz(r) {
  r.exit("blockQuote");
}
const yx = {
  name: "characterEscape",
  tokenize: Wz
};
function Wz(r, t, a) {
  return i;
  function i(h) {
    return r.enter("characterEscape"), r.enter("escapeMarker"), r.consume(h), r.exit("escapeMarker"), s;
  }
  function s(h) {
    return qz(h) ? (r.enter("characterEscapeValue"), r.consume(h), r.exit("characterEscapeValue"), r.exit("characterEscape"), t) : a(h);
  }
}
const vx = {
  name: "characterReference",
  tokenize: eC
};
function eC(r, t, a) {
  const i = this;
  let s = 0, h, d;
  return y;
  function y(T) {
    return r.enter("characterReference"), r.enter("characterReferenceMarker"), r.consume(T), r.exit("characterReferenceMarker"), g;
  }
  function g(T) {
    return T === 35 ? (r.enter("characterReferenceMarkerNumeric"), r.consume(T), r.exit("characterReferenceMarkerNumeric"), b) : (r.enter("characterReferenceValue"), h = 31, d = Da, x(T));
  }
  function b(T) {
    return T === 88 || T === 120 ? (r.enter("characterReferenceMarkerHexadecimal"), r.consume(T), r.exit("characterReferenceMarkerHexadecimal"), r.enter("characterReferenceValue"), h = 6, d = Uz, x) : (r.enter("characterReferenceValue"), h = 7, d = E5, x(T));
  }
  function x(T) {
    if (T === 59 && s) {
      const R = r.exit("characterReferenceValue");
      return d === Da && !g7(i.sliceSerialize(R)) ? a(T) : (r.enter("characterReferenceMarker"), r.consume(T), r.exit("characterReferenceMarker"), r.exit("characterReference"), t);
    }
    return d(T) && s++ < h ? (r.consume(T), x) : a(T);
  }
}
const $2 = {
  partial: !0,
  tokenize: nC
}, X2 = {
  concrete: !0,
  name: "codeFenced",
  tokenize: tC
};
function tC(r, t, a) {
  const i = this, s = {
    partial: !0,
    tokenize: se
  };
  let h = 0, d = 0, y;
  return g;
  function g(te) {
    return b(te);
  }
  function b(te) {
    const Ce = i.events[i.events.length - 1];
    return h = Ce && Ce[1].type === "linePrefix" ? Ce[2].sliceSerialize(Ce[1], !0).length : 0, y = te, r.enter("codeFenced"), r.enter("codeFencedFence"), r.enter("codeFencedFenceSequence"), x(te);
  }
  function x(te) {
    return te === y ? (d++, r.consume(te), x) : d < 3 ? a(te) : (r.exit("codeFencedFenceSequence"), Jt(te) ? Ft(r, T, "whitespace")(te) : T(te));
  }
  function T(te) {
    return te === null || ft(te) ? (r.exit("codeFencedFence"), i.interrupt ? t(te) : r.check($2, L, ce)(te)) : (r.enter("codeFencedFenceInfo"), r.enter("chunkString", {
      contentType: "string"
    }), R(te));
  }
  function R(te) {
    return te === null || ft(te) ? (r.exit("chunkString"), r.exit("codeFencedFenceInfo"), T(te)) : Jt(te) ? (r.exit("chunkString"), r.exit("codeFencedFenceInfo"), Ft(r, E, "whitespace")(te)) : te === 96 && te === y ? a(te) : (r.consume(te), R);
  }
  function E(te) {
    return te === null || ft(te) ? T(te) : (r.enter("codeFencedFenceMeta"), r.enter("chunkString", {
      contentType: "string"
    }), O(te));
  }
  function O(te) {
    return te === null || ft(te) ? (r.exit("chunkString"), r.exit("codeFencedFenceMeta"), T(te)) : te === 96 && te === y ? a(te) : (r.consume(te), O);
  }
  function L(te) {
    return r.attempt(s, ce, G)(te);
  }
  function G(te) {
    return r.enter("lineEnding"), r.consume(te), r.exit("lineEnding"), V;
  }
  function V(te) {
    return h > 0 && Jt(te) ? Ft(r, I, "linePrefix", h + 1)(te) : I(te);
  }
  function I(te) {
    return te === null || ft(te) ? r.check($2, L, ce)(te) : (r.enter("codeFlowValue"), $(te));
  }
  function $(te) {
    return te === null || ft(te) ? (r.exit("codeFlowValue"), I(te)) : (r.consume(te), $);
  }
  function ce(te) {
    return r.exit("codeFenced"), t(te);
  }
  function se(te, Ce, ve) {
    let Ne = 0;
    return ee;
    function ee(re) {
      return te.enter("lineEnding"), te.consume(re), te.exit("lineEnding"), De;
    }
    function De(re) {
      return te.enter("codeFencedFence"), Jt(re) ? Ft(te, de, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(re) : de(re);
    }
    function de(re) {
      return re === y ? (te.enter("codeFencedFenceSequence"), Ye(re)) : ve(re);
    }
    function Ye(re) {
      return re === y ? (Ne++, te.consume(re), Ye) : Ne >= d ? (te.exit("codeFencedFenceSequence"), Jt(re) ? Ft(te, Te, "whitespace")(re) : Te(re)) : ve(re);
    }
    function Te(re) {
      return re === null || ft(re) ? (te.exit("codeFencedFence"), Ce(re)) : ve(re);
    }
  }
}
function nC(r, t, a) {
  const i = this;
  return s;
  function s(d) {
    return d === null ? a(d) : (r.enter("lineEnding"), r.consume(d), r.exit("lineEnding"), h);
  }
  function h(d) {
    return i.parser.lazy[i.now().line] ? a(d) : t(d);
  }
}
const U6 = {
  name: "codeIndented",
  tokenize: aC
}, rC = {
  partial: !0,
  tokenize: lC
};
function aC(r, t, a) {
  const i = this;
  return s;
  function s(b) {
    return r.enter("codeIndented"), Ft(r, h, "linePrefix", 5)(b);
  }
  function h(b) {
    const x = i.events[i.events.length - 1];
    return x && x[1].type === "linePrefix" && x[2].sliceSerialize(x[1], !0).length >= 4 ? d(b) : a(b);
  }
  function d(b) {
    return b === null ? g(b) : ft(b) ? r.attempt(rC, d, g)(b) : (r.enter("codeFlowValue"), y(b));
  }
  function y(b) {
    return b === null || ft(b) ? (r.exit("codeFlowValue"), d(b)) : (r.consume(b), y);
  }
  function g(b) {
    return r.exit("codeIndented"), t(b);
  }
}
function lC(r, t, a) {
  const i = this;
  return s;
  function s(d) {
    return i.parser.lazy[i.now().line] ? a(d) : ft(d) ? (r.enter("lineEnding"), r.consume(d), r.exit("lineEnding"), s) : Ft(r, h, "linePrefix", 5)(d);
  }
  function h(d) {
    const y = i.events[i.events.length - 1];
    return y && y[1].type === "linePrefix" && y[2].sliceSerialize(y[1], !0).length >= 4 ? t(d) : ft(d) ? s(d) : a(d);
  }
}
const iC = {
  name: "codeText",
  previous: oC,
  resolve: uC,
  tokenize: sC
};
function uC(r) {
  let t = r.length - 4, a = 3, i, s;
  if ((r[a][1].type === "lineEnding" || r[a][1].type === "space") && (r[t][1].type === "lineEnding" || r[t][1].type === "space")) {
    for (i = a; ++i < t; )
      if (r[i][1].type === "codeTextData") {
        r[a][1].type = "codeTextPadding", r[t][1].type = "codeTextPadding", a += 2, t -= 2;
        break;
      }
  }
  for (i = a - 1, t++; ++i <= t; )
    s === void 0 ? i !== t && r[i][1].type !== "lineEnding" && (s = i) : (i === t || r[i][1].type === "lineEnding") && (r[s][1].type = "codeTextData", i !== s + 2 && (r[s][1].end = r[i - 1][1].end, r.splice(s + 2, i - s - 2), t -= i - s - 2, i = s + 2), s = void 0);
  return r;
}
function oC(r) {
  return r !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function sC(r, t, a) {
  let i = 0, s, h;
  return d;
  function d(T) {
    return r.enter("codeText"), r.enter("codeTextSequence"), y(T);
  }
  function y(T) {
    return T === 96 ? (r.consume(T), i++, y) : (r.exit("codeTextSequence"), g(T));
  }
  function g(T) {
    return T === null ? a(T) : T === 32 ? (r.enter("space"), r.consume(T), r.exit("space"), g) : T === 96 ? (h = r.enter("codeTextSequence"), s = 0, x(T)) : ft(T) ? (r.enter("lineEnding"), r.consume(T), r.exit("lineEnding"), g) : (r.enter("codeTextData"), b(T));
  }
  function b(T) {
    return T === null || T === 32 || T === 96 || ft(T) ? (r.exit("codeTextData"), g(T)) : (r.consume(T), b);
  }
  function x(T) {
    return T === 96 ? (r.consume(T), s++, x) : s === i ? (r.exit("codeTextSequence"), r.exit("codeText"), t(T)) : (h.type = "codeTextData", b(T));
  }
}
class cC {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, a) {
    const i = a ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(t, i) : t > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, a, i) {
    const s = a || 0;
    this.setCursor(Math.trunc(t));
    const h = this.right.splice(this.right.length - s, Number.POSITIVE_INFINITY);
    return i && Ng(this.left, i), h.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), Ng(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), Ng(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const a = this.left.splice(t, Number.POSITIVE_INFINITY);
        Ng(this.right, a.reverse());
      } else {
        const a = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        Ng(this.left, a.reverse());
      }
  }
}
function Ng(r, t) {
  let a = 0;
  if (t.length < 1e4)
    r.push(...t);
  else
    for (; a < t.length; )
      r.push(...t.slice(a, a + 1e4)), a += 1e4;
}
function bx(r) {
  const t = {};
  let a = -1, i, s, h, d, y, g, b;
  const x = new cC(r);
  for (; ++a < x.length; ) {
    for (; a in t; )
      a = t[a];
    if (i = x.get(a), a && i[1].type === "chunkFlow" && x.get(a - 1)[1].type === "listItemPrefix" && (g = i[1]._tokenizer.events, h = 0, h < g.length && g[h][1].type === "lineEndingBlank" && (h += 2), h < g.length && g[h][1].type === "content"))
      for (; ++h < g.length && g[h][1].type !== "content"; )
        g[h][1].type === "chunkText" && (g[h][1]._isInFirstContentOfListItem = !0, h++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(t, fC(x, a)), a = t[a], b = !0);
    else if (i[1]._container) {
      for (h = a, s = void 0; h--; )
        if (d = x.get(h), d[1].type === "lineEnding" || d[1].type === "lineEndingBlank")
          d[0] === "enter" && (s && (x.get(s)[1].type = "lineEndingBlank"), d[1].type = "lineEnding", s = h);
        else if (!(d[1].type === "linePrefix" || d[1].type === "listItemIndent")) break;
      s && (i[1].end = {
        ...x.get(s)[1].start
      }, y = x.slice(s, a), y.unshift(i), x.splice(s, a - s + 1, y));
    }
  }
  return ni(r, 0, Number.POSITIVE_INFINITY, x.slice(0)), !b;
}
function fC(r, t) {
  const a = r.get(t)[1], i = r.get(t)[2];
  let s = t - 1;
  const h = [];
  let d = a._tokenizer;
  d || (d = i.parser[a.contentType](a.start), a._contentTypeTextTrailing && (d._contentTypeTextTrailing = !0));
  const y = d.events, g = [], b = {};
  let x, T, R = -1, E = a, O = 0, L = 0;
  const G = [L];
  for (; E; ) {
    for (; r.get(++s)[1] !== E; )
      ;
    h.push(s), E._tokenizer || (x = i.sliceStream(E), E.next || x.push(null), T && d.defineSkip(E.start), E._isInFirstContentOfListItem && (d._gfmTasklistFirstContentOfListItem = !0), d.write(x), E._isInFirstContentOfListItem && (d._gfmTasklistFirstContentOfListItem = void 0)), T = E, E = E.next;
  }
  for (E = a; ++R < y.length; )
    // Find a void token that includes a break.
    y[R][0] === "exit" && y[R - 1][0] === "enter" && y[R][1].type === y[R - 1][1].type && y[R][1].start.line !== y[R][1].end.line && (L = R + 1, G.push(L), E._tokenizer = void 0, E.previous = void 0, E = E.next);
  for (d.events = [], E ? (E._tokenizer = void 0, E.previous = void 0) : G.pop(), R = G.length; R--; ) {
    const V = y.slice(G[R], G[R + 1]), I = h.pop();
    g.push([I, I + V.length - 1]), r.splice(I, 2, V);
  }
  for (g.reverse(), R = -1; ++R < g.length; )
    b[O + g[R][0]] = O + g[R][1], O += g[R][1] - g[R][0] - 1;
  return b;
}
const hC = {
  resolve: mC,
  tokenize: pC
}, dC = {
  partial: !0,
  tokenize: gC
};
function mC(r) {
  return bx(r), r;
}
function pC(r, t) {
  let a;
  return i;
  function i(y) {
    return r.enter("content"), a = r.enter("chunkContent", {
      contentType: "content"
    }), s(y);
  }
  function s(y) {
    return y === null ? h(y) : ft(y) ? r.check(dC, d, h)(y) : (r.consume(y), s);
  }
  function h(y) {
    return r.exit("chunkContent"), r.exit("content"), t(y);
  }
  function d(y) {
    return r.consume(y), r.exit("chunkContent"), a.next = r.enter("chunkContent", {
      contentType: "content",
      previous: a
    }), a = a.next, s;
  }
}
function gC(r, t, a) {
  const i = this;
  return s;
  function s(d) {
    return r.exit("chunkContent"), r.enter("lineEnding"), r.consume(d), r.exit("lineEnding"), Ft(r, h, "linePrefix");
  }
  function h(d) {
    if (d === null || ft(d))
      return a(d);
    const y = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && y && y[1].type === "linePrefix" && y[2].sliceSerialize(y[1], !0).length >= 4 ? t(d) : r.interrupt(i.parser.constructs.flow, a, t)(d);
  }
}
function Sx(r, t, a, i, s, h, d, y, g) {
  const b = g || Number.POSITIVE_INFINITY;
  let x = 0;
  return T;
  function T(V) {
    return V === 60 ? (r.enter(i), r.enter(s), r.enter(h), r.consume(V), r.exit(h), R) : V === null || V === 32 || V === 41 || Mv(V) ? a(V) : (r.enter(i), r.enter(d), r.enter(y), r.enter("chunkString", {
      contentType: "string"
    }), L(V));
  }
  function R(V) {
    return V === 62 ? (r.enter(h), r.consume(V), r.exit(h), r.exit(s), r.exit(i), t) : (r.enter(y), r.enter("chunkString", {
      contentType: "string"
    }), E(V));
  }
  function E(V) {
    return V === 62 ? (r.exit("chunkString"), r.exit(y), R(V)) : V === null || V === 60 || ft(V) ? a(V) : (r.consume(V), V === 92 ? O : E);
  }
  function O(V) {
    return V === 60 || V === 62 || V === 92 ? (r.consume(V), E) : E(V);
  }
  function L(V) {
    return !x && (V === null || V === 41 || Mn(V)) ? (r.exit("chunkString"), r.exit(y), r.exit(d), r.exit(i), t(V)) : x < b && V === 40 ? (r.consume(V), x++, L) : V === 41 ? (r.consume(V), x--, L) : V === null || V === 32 || V === 40 || Mv(V) ? a(V) : (r.consume(V), V === 92 ? G : L);
  }
  function G(V) {
    return V === 40 || V === 41 || V === 92 ? (r.consume(V), L) : L(V);
  }
}
function xx(r, t, a, i, s, h) {
  const d = this;
  let y = 0, g;
  return b;
  function b(E) {
    return r.enter(i), r.enter(s), r.consume(E), r.exit(s), r.enter(h), x;
  }
  function x(E) {
    return y > 999 || E === null || E === 91 || E === 93 && !g || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    E === 94 && !y && "_hiddenFootnoteSupport" in d.parser.constructs ? a(E) : E === 93 ? (r.exit(h), r.enter(s), r.consume(E), r.exit(s), r.exit(i), t) : ft(E) ? (r.enter("lineEnding"), r.consume(E), r.exit("lineEnding"), x) : (r.enter("chunkString", {
      contentType: "string"
    }), T(E));
  }
  function T(E) {
    return E === null || E === 91 || E === 93 || ft(E) || y++ > 999 ? (r.exit("chunkString"), x(E)) : (r.consume(E), g || (g = !Jt(E)), E === 92 ? R : T);
  }
  function R(E) {
    return E === 91 || E === 92 || E === 93 ? (r.consume(E), y++, T) : T(E);
  }
}
function wx(r, t, a, i, s, h) {
  let d;
  return y;
  function y(R) {
    return R === 34 || R === 39 || R === 40 ? (r.enter(i), r.enter(s), r.consume(R), r.exit(s), d = R === 40 ? 41 : R, g) : a(R);
  }
  function g(R) {
    return R === d ? (r.enter(s), r.consume(R), r.exit(s), r.exit(i), t) : (r.enter(h), b(R));
  }
  function b(R) {
    return R === d ? (r.exit(h), g(d)) : R === null ? a(R) : ft(R) ? (r.enter("lineEnding"), r.consume(R), r.exit("lineEnding"), Ft(r, b, "linePrefix")) : (r.enter("chunkString", {
      contentType: "string"
    }), x(R));
  }
  function x(R) {
    return R === d || R === null || ft(R) ? (r.exit("chunkString"), b(R)) : (r.consume(R), R === 92 ? T : x);
  }
  function T(R) {
    return R === d || R === 92 ? (r.consume(R), x) : x(R);
  }
}
function Gg(r, t) {
  let a;
  return i;
  function i(s) {
    return ft(s) ? (r.enter("lineEnding"), r.consume(s), r.exit("lineEnding"), a = !0, i) : Jt(s) ? Ft(r, i, a ? "linePrefix" : "lineSuffix")(s) : t(s);
  }
}
const yC = {
  name: "definition",
  tokenize: bC
}, vC = {
  partial: !0,
  tokenize: SC
};
function bC(r, t, a) {
  const i = this;
  let s;
  return h;
  function h(E) {
    return r.enter("definition"), d(E);
  }
  function d(E) {
    return xx.call(
      i,
      r,
      y,
      // Note: we don’t need to reset the way `markdown-rs` does.
      a,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(E);
  }
  function y(E) {
    return s = Au(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), E === 58 ? (r.enter("definitionMarker"), r.consume(E), r.exit("definitionMarker"), g) : a(E);
  }
  function g(E) {
    return Mn(E) ? Gg(r, b)(E) : b(E);
  }
  function b(E) {
    return Sx(
      r,
      x,
      // Note: we don’t need to reset the way `markdown-rs` does.
      a,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(E);
  }
  function x(E) {
    return r.attempt(vC, T, T)(E);
  }
  function T(E) {
    return Jt(E) ? Ft(r, R, "whitespace")(E) : R(E);
  }
  function R(E) {
    return E === null || ft(E) ? (r.exit("definition"), i.parser.defined.push(s), t(E)) : a(E);
  }
}
function SC(r, t, a) {
  return i;
  function i(y) {
    return Mn(y) ? Gg(r, s)(y) : a(y);
  }
  function s(y) {
    return wx(r, h, a, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(y);
  }
  function h(y) {
    return Jt(y) ? Ft(r, d, "whitespace")(y) : d(y);
  }
  function d(y) {
    return y === null || ft(y) ? t(y) : a(y);
  }
}
const xC = {
  name: "hardBreakEscape",
  tokenize: wC
};
function wC(r, t, a) {
  return i;
  function i(h) {
    return r.enter("hardBreakEscape"), r.consume(h), s;
  }
  function s(h) {
    return ft(h) ? (r.exit("hardBreakEscape"), t(h)) : a(h);
  }
}
const TC = {
  name: "headingAtx",
  resolve: EC,
  tokenize: AC
};
function EC(r, t) {
  let a = r.length - 2, i = 3, s, h;
  return r[i][1].type === "whitespace" && (i += 2), a - 2 > i && r[a][1].type === "whitespace" && (a -= 2), r[a][1].type === "atxHeadingSequence" && (i === a - 1 || a - 4 > i && r[a - 2][1].type === "whitespace") && (a -= i + 1 === a ? 2 : 4), a > i && (s = {
    type: "atxHeadingText",
    start: r[i][1].start,
    end: r[a][1].end
  }, h = {
    type: "chunkText",
    start: r[i][1].start,
    end: r[a][1].end,
    contentType: "text"
  }, ni(r, i, a - i + 1, [["enter", s, t], ["enter", h, t], ["exit", h, t], ["exit", s, t]])), r;
}
function AC(r, t, a) {
  let i = 0;
  return s;
  function s(x) {
    return r.enter("atxHeading"), h(x);
  }
  function h(x) {
    return r.enter("atxHeadingSequence"), d(x);
  }
  function d(x) {
    return x === 35 && i++ < 6 ? (r.consume(x), d) : x === null || Mn(x) ? (r.exit("atxHeadingSequence"), y(x)) : a(x);
  }
  function y(x) {
    return x === 35 ? (r.enter("atxHeadingSequence"), g(x)) : x === null || ft(x) ? (r.exit("atxHeading"), t(x)) : Jt(x) ? Ft(r, y, "whitespace")(x) : (r.enter("atxHeadingText"), b(x));
  }
  function g(x) {
    return x === 35 ? (r.consume(x), g) : (r.exit("atxHeadingSequence"), y(x));
  }
  function b(x) {
    return x === null || x === 35 || Mn(x) ? (r.exit("atxHeadingText"), y(x)) : (r.consume(x), b);
  }
}
const kC = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Q2 = ["pre", "script", "style", "textarea"], RC = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: MC,
  tokenize: _C
}, zC = {
  partial: !0,
  tokenize: DC
}, CC = {
  partial: !0,
  tokenize: OC
};
function MC(r) {
  let t = r.length;
  for (; t-- && !(r[t][0] === "enter" && r[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && r[t - 2][1].type === "linePrefix" && (r[t][1].start = r[t - 2][1].start, r[t + 1][1].start = r[t - 2][1].start, r.splice(t - 2, 2)), r;
}
function _C(r, t, a) {
  const i = this;
  let s, h, d, y, g;
  return b;
  function b(N) {
    return x(N);
  }
  function x(N) {
    return r.enter("htmlFlow"), r.enter("htmlFlowData"), r.consume(N), T;
  }
  function T(N) {
    return N === 33 ? (r.consume(N), R) : N === 47 ? (r.consume(N), h = !0, L) : N === 63 ? (r.consume(N), s = 3, i.interrupt ? t : C) : Wa(N) ? (r.consume(N), d = String.fromCharCode(N), G) : a(N);
  }
  function R(N) {
    return N === 45 ? (r.consume(N), s = 2, E) : N === 91 ? (r.consume(N), s = 5, y = 0, O) : Wa(N) ? (r.consume(N), s = 4, i.interrupt ? t : C) : a(N);
  }
  function E(N) {
    return N === 45 ? (r.consume(N), i.interrupt ? t : C) : a(N);
  }
  function O(N) {
    const Me = "CDATA[";
    return N === Me.charCodeAt(y++) ? (r.consume(N), y === Me.length ? i.interrupt ? t : de : O) : a(N);
  }
  function L(N) {
    return Wa(N) ? (r.consume(N), d = String.fromCharCode(N), G) : a(N);
  }
  function G(N) {
    if (N === null || N === 47 || N === 62 || Mn(N)) {
      const Me = N === 47, _e = d.toLowerCase();
      return !Me && !h && Q2.includes(_e) ? (s = 1, i.interrupt ? t(N) : de(N)) : kC.includes(d.toLowerCase()) ? (s = 6, Me ? (r.consume(N), V) : i.interrupt ? t(N) : de(N)) : (s = 7, i.interrupt && !i.parser.lazy[i.now().line] ? a(N) : h ? I(N) : $(N));
    }
    return N === 45 || Da(N) ? (r.consume(N), d += String.fromCharCode(N), G) : a(N);
  }
  function V(N) {
    return N === 62 ? (r.consume(N), i.interrupt ? t : de) : a(N);
  }
  function I(N) {
    return Jt(N) ? (r.consume(N), I) : ee(N);
  }
  function $(N) {
    return N === 47 ? (r.consume(N), ee) : N === 58 || N === 95 || Wa(N) ? (r.consume(N), ce) : Jt(N) ? (r.consume(N), $) : ee(N);
  }
  function ce(N) {
    return N === 45 || N === 46 || N === 58 || N === 95 || Da(N) ? (r.consume(N), ce) : se(N);
  }
  function se(N) {
    return N === 61 ? (r.consume(N), te) : Jt(N) ? (r.consume(N), se) : $(N);
  }
  function te(N) {
    return N === null || N === 60 || N === 61 || N === 62 || N === 96 ? a(N) : N === 34 || N === 39 ? (r.consume(N), g = N, Ce) : Jt(N) ? (r.consume(N), te) : ve(N);
  }
  function Ce(N) {
    return N === g ? (r.consume(N), g = null, Ne) : N === null || ft(N) ? a(N) : (r.consume(N), Ce);
  }
  function ve(N) {
    return N === null || N === 34 || N === 39 || N === 47 || N === 60 || N === 61 || N === 62 || N === 96 || Mn(N) ? se(N) : (r.consume(N), ve);
  }
  function Ne(N) {
    return N === 47 || N === 62 || Jt(N) ? $(N) : a(N);
  }
  function ee(N) {
    return N === 62 ? (r.consume(N), De) : a(N);
  }
  function De(N) {
    return N === null || ft(N) ? de(N) : Jt(N) ? (r.consume(N), De) : a(N);
  }
  function de(N) {
    return N === 45 && s === 2 ? (r.consume(N), J) : N === 60 && s === 1 ? (r.consume(N), X) : N === 62 && s === 4 ? (r.consume(N), Y) : N === 63 && s === 3 ? (r.consume(N), C) : N === 93 && s === 5 ? (r.consume(N), be) : ft(N) && (s === 6 || s === 7) ? (r.exit("htmlFlowData"), r.check(zC, ie, Ye)(N)) : N === null || ft(N) ? (r.exit("htmlFlowData"), Ye(N)) : (r.consume(N), de);
  }
  function Ye(N) {
    return r.check(CC, Te, ie)(N);
  }
  function Te(N) {
    return r.enter("lineEnding"), r.consume(N), r.exit("lineEnding"), re;
  }
  function re(N) {
    return N === null || ft(N) ? Ye(N) : (r.enter("htmlFlowData"), de(N));
  }
  function J(N) {
    return N === 45 ? (r.consume(N), C) : de(N);
  }
  function X(N) {
    return N === 47 ? (r.consume(N), d = "", W) : de(N);
  }
  function W(N) {
    if (N === 62) {
      const Me = d.toLowerCase();
      return Q2.includes(Me) ? (r.consume(N), Y) : de(N);
    }
    return Wa(N) && d.length < 8 ? (r.consume(N), d += String.fromCharCode(N), W) : de(N);
  }
  function be(N) {
    return N === 93 ? (r.consume(N), C) : de(N);
  }
  function C(N) {
    return N === 62 ? (r.consume(N), Y) : N === 45 && s === 2 ? (r.consume(N), C) : de(N);
  }
  function Y(N) {
    return N === null || ft(N) ? (r.exit("htmlFlowData"), ie(N)) : (r.consume(N), Y);
  }
  function ie(N) {
    return r.exit("htmlFlow"), t(N);
  }
}
function OC(r, t, a) {
  const i = this;
  return s;
  function s(d) {
    return ft(d) ? (r.enter("lineEnding"), r.consume(d), r.exit("lineEnding"), h) : a(d);
  }
  function h(d) {
    return i.parser.lazy[i.now().line] ? a(d) : t(d);
  }
}
function DC(r, t, a) {
  return i;
  function i(s) {
    return r.enter("lineEnding"), r.consume(s), r.exit("lineEnding"), r.attempt(n4, t, a);
  }
}
const NC = {
  name: "htmlText",
  tokenize: LC
};
function LC(r, t, a) {
  const i = this;
  let s, h, d;
  return y;
  function y(C) {
    return r.enter("htmlText"), r.enter("htmlTextData"), r.consume(C), g;
  }
  function g(C) {
    return C === 33 ? (r.consume(C), b) : C === 47 ? (r.consume(C), se) : C === 63 ? (r.consume(C), $) : Wa(C) ? (r.consume(C), ve) : a(C);
  }
  function b(C) {
    return C === 45 ? (r.consume(C), x) : C === 91 ? (r.consume(C), h = 0, O) : Wa(C) ? (r.consume(C), I) : a(C);
  }
  function x(C) {
    return C === 45 ? (r.consume(C), E) : a(C);
  }
  function T(C) {
    return C === null ? a(C) : C === 45 ? (r.consume(C), R) : ft(C) ? (d = T, X(C)) : (r.consume(C), T);
  }
  function R(C) {
    return C === 45 ? (r.consume(C), E) : T(C);
  }
  function E(C) {
    return C === 62 ? J(C) : C === 45 ? R(C) : T(C);
  }
  function O(C) {
    const Y = "CDATA[";
    return C === Y.charCodeAt(h++) ? (r.consume(C), h === Y.length ? L : O) : a(C);
  }
  function L(C) {
    return C === null ? a(C) : C === 93 ? (r.consume(C), G) : ft(C) ? (d = L, X(C)) : (r.consume(C), L);
  }
  function G(C) {
    return C === 93 ? (r.consume(C), V) : L(C);
  }
  function V(C) {
    return C === 62 ? J(C) : C === 93 ? (r.consume(C), V) : L(C);
  }
  function I(C) {
    return C === null || C === 62 ? J(C) : ft(C) ? (d = I, X(C)) : (r.consume(C), I);
  }
  function $(C) {
    return C === null ? a(C) : C === 63 ? (r.consume(C), ce) : ft(C) ? (d = $, X(C)) : (r.consume(C), $);
  }
  function ce(C) {
    return C === 62 ? J(C) : $(C);
  }
  function se(C) {
    return Wa(C) ? (r.consume(C), te) : a(C);
  }
  function te(C) {
    return C === 45 || Da(C) ? (r.consume(C), te) : Ce(C);
  }
  function Ce(C) {
    return ft(C) ? (d = Ce, X(C)) : Jt(C) ? (r.consume(C), Ce) : J(C);
  }
  function ve(C) {
    return C === 45 || Da(C) ? (r.consume(C), ve) : C === 47 || C === 62 || Mn(C) ? Ne(C) : a(C);
  }
  function Ne(C) {
    return C === 47 ? (r.consume(C), J) : C === 58 || C === 95 || Wa(C) ? (r.consume(C), ee) : ft(C) ? (d = Ne, X(C)) : Jt(C) ? (r.consume(C), Ne) : J(C);
  }
  function ee(C) {
    return C === 45 || C === 46 || C === 58 || C === 95 || Da(C) ? (r.consume(C), ee) : De(C);
  }
  function De(C) {
    return C === 61 ? (r.consume(C), de) : ft(C) ? (d = De, X(C)) : Jt(C) ? (r.consume(C), De) : Ne(C);
  }
  function de(C) {
    return C === null || C === 60 || C === 61 || C === 62 || C === 96 ? a(C) : C === 34 || C === 39 ? (r.consume(C), s = C, Ye) : ft(C) ? (d = de, X(C)) : Jt(C) ? (r.consume(C), de) : (r.consume(C), Te);
  }
  function Ye(C) {
    return C === s ? (r.consume(C), s = void 0, re) : C === null ? a(C) : ft(C) ? (d = Ye, X(C)) : (r.consume(C), Ye);
  }
  function Te(C) {
    return C === null || C === 34 || C === 39 || C === 60 || C === 61 || C === 96 ? a(C) : C === 47 || C === 62 || Mn(C) ? Ne(C) : (r.consume(C), Te);
  }
  function re(C) {
    return C === 47 || C === 62 || Mn(C) ? Ne(C) : a(C);
  }
  function J(C) {
    return C === 62 ? (r.consume(C), r.exit("htmlTextData"), r.exit("htmlText"), t) : a(C);
  }
  function X(C) {
    return r.exit("htmlTextData"), r.enter("lineEnding"), r.consume(C), r.exit("lineEnding"), W;
  }
  function W(C) {
    return Jt(C) ? Ft(r, be, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(C) : be(C);
  }
  function be(C) {
    return r.enter("htmlTextData"), d(C);
  }
}
const y7 = {
  name: "labelEnd",
  resolveAll: qC,
  resolveTo: jC,
  tokenize: GC
}, BC = {
  tokenize: VC
}, HC = {
  tokenize: YC
}, UC = {
  tokenize: IC
};
function qC(r) {
  let t = -1;
  const a = [];
  for (; ++t < r.length; ) {
    const i = r[t][1];
    if (a.push(r[t]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const s = i.type === "labelImage" ? 4 : 2;
      i.type = "data", t += s;
    }
  }
  return r.length !== a.length && ni(r, 0, r.length, a), r;
}
function jC(r, t) {
  let a = r.length, i = 0, s, h, d, y;
  for (; a--; )
    if (s = r[a][1], h) {
      if (s.type === "link" || s.type === "labelLink" && s._inactive)
        break;
      r[a][0] === "enter" && s.type === "labelLink" && (s._inactive = !0);
    } else if (d) {
      if (r[a][0] === "enter" && (s.type === "labelImage" || s.type === "labelLink") && !s._balanced && (h = a, s.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else s.type === "labelEnd" && (d = a);
  const g = {
    type: r[h][1].type === "labelLink" ? "link" : "image",
    start: {
      ...r[h][1].start
    },
    end: {
      ...r[r.length - 1][1].end
    }
  }, b = {
    type: "label",
    start: {
      ...r[h][1].start
    },
    end: {
      ...r[d][1].end
    }
  }, x = {
    type: "labelText",
    start: {
      ...r[h + i + 2][1].end
    },
    end: {
      ...r[d - 2][1].start
    }
  };
  return y = [["enter", g, t], ["enter", b, t]], y = Di(y, r.slice(h + 1, h + i + 3)), y = Di(y, [["enter", x, t]]), y = Di(y, Zv(t.parser.constructs.insideSpan.null, r.slice(h + i + 4, d - 3), t)), y = Di(y, [["exit", x, t], r[d - 2], r[d - 1], ["exit", b, t]]), y = Di(y, r.slice(d + 1)), y = Di(y, [["exit", g, t]]), ni(r, h, r.length, y), r;
}
function GC(r, t, a) {
  const i = this;
  let s = i.events.length, h, d;
  for (; s--; )
    if ((i.events[s][1].type === "labelImage" || i.events[s][1].type === "labelLink") && !i.events[s][1]._balanced) {
      h = i.events[s][1];
      break;
    }
  return y;
  function y(R) {
    return h ? h._inactive ? T(R) : (d = i.parser.defined.includes(Au(i.sliceSerialize({
      start: h.end,
      end: i.now()
    }))), r.enter("labelEnd"), r.enter("labelMarker"), r.consume(R), r.exit("labelMarker"), r.exit("labelEnd"), g) : a(R);
  }
  function g(R) {
    return R === 40 ? r.attempt(BC, x, d ? x : T)(R) : R === 91 ? r.attempt(HC, x, d ? b : T)(R) : d ? x(R) : T(R);
  }
  function b(R) {
    return r.attempt(UC, x, T)(R);
  }
  function x(R) {
    return t(R);
  }
  function T(R) {
    return h._balanced = !0, a(R);
  }
}
function VC(r, t, a) {
  return i;
  function i(T) {
    return r.enter("resource"), r.enter("resourceMarker"), r.consume(T), r.exit("resourceMarker"), s;
  }
  function s(T) {
    return Mn(T) ? Gg(r, h)(T) : h(T);
  }
  function h(T) {
    return T === 41 ? x(T) : Sx(r, d, y, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(T);
  }
  function d(T) {
    return Mn(T) ? Gg(r, g)(T) : x(T);
  }
  function y(T) {
    return a(T);
  }
  function g(T) {
    return T === 34 || T === 39 || T === 40 ? wx(r, b, a, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(T) : x(T);
  }
  function b(T) {
    return Mn(T) ? Gg(r, x)(T) : x(T);
  }
  function x(T) {
    return T === 41 ? (r.enter("resourceMarker"), r.consume(T), r.exit("resourceMarker"), r.exit("resource"), t) : a(T);
  }
}
function YC(r, t, a) {
  const i = this;
  return s;
  function s(y) {
    return xx.call(i, r, h, d, "reference", "referenceMarker", "referenceString")(y);
  }
  function h(y) {
    return i.parser.defined.includes(Au(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? t(y) : a(y);
  }
  function d(y) {
    return a(y);
  }
}
function IC(r, t, a) {
  return i;
  function i(h) {
    return r.enter("reference"), r.enter("referenceMarker"), r.consume(h), r.exit("referenceMarker"), s;
  }
  function s(h) {
    return h === 93 ? (r.enter("referenceMarker"), r.consume(h), r.exit("referenceMarker"), r.exit("reference"), t) : a(h);
  }
}
const $C = {
  name: "labelStartImage",
  resolveAll: y7.resolveAll,
  tokenize: XC
};
function XC(r, t, a) {
  const i = this;
  return s;
  function s(y) {
    return r.enter("labelImage"), r.enter("labelImageMarker"), r.consume(y), r.exit("labelImageMarker"), h;
  }
  function h(y) {
    return y === 91 ? (r.enter("labelMarker"), r.consume(y), r.exit("labelMarker"), r.exit("labelImage"), d) : a(y);
  }
  function d(y) {
    return y === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? a(y) : t(y);
  }
}
const QC = {
  name: "labelStartLink",
  resolveAll: y7.resolveAll,
  tokenize: ZC
};
function ZC(r, t, a) {
  const i = this;
  return s;
  function s(d) {
    return r.enter("labelLink"), r.enter("labelMarker"), r.consume(d), r.exit("labelMarker"), r.exit("labelLink"), h;
  }
  function h(d) {
    return d === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? a(d) : t(d);
  }
}
const q6 = {
  name: "lineEnding",
  tokenize: FC
};
function FC(r, t) {
  return a;
  function a(i) {
    return r.enter("lineEnding"), r.consume(i), r.exit("lineEnding"), Ft(r, t, "linePrefix");
  }
}
const Ev = {
  name: "thematicBreak",
  tokenize: PC
};
function PC(r, t, a) {
  let i = 0, s;
  return h;
  function h(b) {
    return r.enter("thematicBreak"), d(b);
  }
  function d(b) {
    return s = b, y(b);
  }
  function y(b) {
    return b === s ? (r.enter("thematicBreakSequence"), g(b)) : i >= 3 && (b === null || ft(b)) ? (r.exit("thematicBreak"), t(b)) : a(b);
  }
  function g(b) {
    return b === s ? (r.consume(b), i++, g) : (r.exit("thematicBreakSequence"), Jt(b) ? Ft(r, y, "whitespace")(b) : y(b));
  }
}
const Sl = {
  continuation: {
    tokenize: eM
  },
  exit: nM,
  name: "list",
  tokenize: WC
}, KC = {
  partial: !0,
  tokenize: rM
}, JC = {
  partial: !0,
  tokenize: tM
};
function WC(r, t, a) {
  const i = this, s = i.events[i.events.length - 1];
  let h = s && s[1].type === "linePrefix" ? s[2].sliceSerialize(s[1], !0).length : 0, d = 0;
  return y;
  function y(E) {
    const O = i.containerState.type || (E === 42 || E === 43 || E === 45 ? "listUnordered" : "listOrdered");
    if (O === "listUnordered" ? !i.containerState.marker || E === i.containerState.marker : E5(E)) {
      if (i.containerState.type || (i.containerState.type = O, r.enter(O, {
        _container: !0
      })), O === "listUnordered")
        return r.enter("listItemPrefix"), E === 42 || E === 45 ? r.check(Ev, a, b)(E) : b(E);
      if (!i.interrupt || E === 49)
        return r.enter("listItemPrefix"), r.enter("listItemValue"), g(E);
    }
    return a(E);
  }
  function g(E) {
    return E5(E) && ++d < 10 ? (r.consume(E), g) : (!i.interrupt || d < 2) && (i.containerState.marker ? E === i.containerState.marker : E === 41 || E === 46) ? (r.exit("listItemValue"), b(E)) : a(E);
  }
  function b(E) {
    return r.enter("listItemMarker"), r.consume(E), r.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || E, r.check(
      n4,
      // Can’t be empty when interrupting.
      i.interrupt ? a : x,
      r.attempt(KC, R, T)
    );
  }
  function x(E) {
    return i.containerState.initialBlankLine = !0, h++, R(E);
  }
  function T(E) {
    return Jt(E) ? (r.enter("listItemPrefixWhitespace"), r.consume(E), r.exit("listItemPrefixWhitespace"), R) : a(E);
  }
  function R(E) {
    return i.containerState.size = h + i.sliceSerialize(r.exit("listItemPrefix"), !0).length, t(E);
  }
}
function eM(r, t, a) {
  const i = this;
  return i.containerState._closeFlow = void 0, r.check(n4, s, h);
  function s(y) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, Ft(r, t, "listItemIndent", i.containerState.size + 1)(y);
  }
  function h(y) {
    return i.containerState.furtherBlankLines || !Jt(y) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, d(y)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, r.attempt(JC, t, d)(y));
  }
  function d(y) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, Ft(r, r.attempt(Sl, t, a), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(y);
  }
}
function tM(r, t, a) {
  const i = this;
  return Ft(r, s, "listItemIndent", i.containerState.size + 1);
  function s(h) {
    const d = i.events[i.events.length - 1];
    return d && d[1].type === "listItemIndent" && d[2].sliceSerialize(d[1], !0).length === i.containerState.size ? t(h) : a(h);
  }
}
function nM(r) {
  r.exit(this.containerState.type);
}
function rM(r, t, a) {
  const i = this;
  return Ft(r, s, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function s(h) {
    const d = i.events[i.events.length - 1];
    return !Jt(h) && d && d[1].type === "listItemPrefixWhitespace" ? t(h) : a(h);
  }
}
const Z2 = {
  name: "setextUnderline",
  resolveTo: aM,
  tokenize: lM
};
function aM(r, t) {
  let a = r.length, i, s, h;
  for (; a--; )
    if (r[a][0] === "enter") {
      if (r[a][1].type === "content") {
        i = a;
        break;
      }
      r[a][1].type === "paragraph" && (s = a);
    } else
      r[a][1].type === "content" && r.splice(a, 1), !h && r[a][1].type === "definition" && (h = a);
  const d = {
    type: "setextHeading",
    start: {
      ...r[i][1].start
    },
    end: {
      ...r[r.length - 1][1].end
    }
  };
  return r[s][1].type = "setextHeadingText", h ? (r.splice(s, 0, ["enter", d, t]), r.splice(h + 1, 0, ["exit", r[i][1], t]), r[i][1].end = {
    ...r[h][1].end
  }) : r[i][1] = d, r.push(["exit", d, t]), r;
}
function lM(r, t, a) {
  const i = this;
  let s;
  return h;
  function h(b) {
    let x = i.events.length, T;
    for (; x--; )
      if (i.events[x][1].type !== "lineEnding" && i.events[x][1].type !== "linePrefix" && i.events[x][1].type !== "content") {
        T = i.events[x][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || T) ? (r.enter("setextHeadingLine"), s = b, d(b)) : a(b);
  }
  function d(b) {
    return r.enter("setextHeadingLineSequence"), y(b);
  }
  function y(b) {
    return b === s ? (r.consume(b), y) : (r.exit("setextHeadingLineSequence"), Jt(b) ? Ft(r, g, "lineSuffix")(b) : g(b));
  }
  function g(b) {
    return b === null || ft(b) ? (r.exit("setextHeadingLine"), t(b)) : a(b);
  }
}
const iM = {
  tokenize: uM
};
function uM(r) {
  const t = this, a = r.attempt(
    // Try to parse a blank line.
    n4,
    i,
    // Try to parse initial flow (essentially, only code).
    r.attempt(this.parser.constructs.flowInitial, s, Ft(r, r.attempt(this.parser.constructs.flow, s, r.attempt(hC, s)), "linePrefix"))
  );
  return a;
  function i(h) {
    if (h === null) {
      r.consume(h);
      return;
    }
    return r.enter("lineEndingBlank"), r.consume(h), r.exit("lineEndingBlank"), t.currentConstruct = void 0, a;
  }
  function s(h) {
    if (h === null) {
      r.consume(h);
      return;
    }
    return r.enter("lineEnding"), r.consume(h), r.exit("lineEnding"), t.currentConstruct = void 0, a;
  }
}
const oM = {
  resolveAll: Ex()
}, sM = Tx("string"), cM = Tx("text");
function Tx(r) {
  return {
    resolveAll: Ex(r === "text" ? fM : void 0),
    tokenize: t
  };
  function t(a) {
    const i = this, s = this.parser.constructs[r], h = a.attempt(s, d, y);
    return d;
    function d(x) {
      return b(x) ? h(x) : y(x);
    }
    function y(x) {
      if (x === null) {
        a.consume(x);
        return;
      }
      return a.enter("data"), a.consume(x), g;
    }
    function g(x) {
      return b(x) ? (a.exit("data"), h(x)) : (a.consume(x), g);
    }
    function b(x) {
      if (x === null)
        return !0;
      const T = s[x];
      let R = -1;
      if (T)
        for (; ++R < T.length; ) {
          const E = T[R];
          if (!E.previous || E.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Ex(r) {
  return t;
  function t(a, i) {
    let s = -1, h;
    for (; ++s <= a.length; )
      h === void 0 ? a[s] && a[s][1].type === "data" && (h = s, s++) : (!a[s] || a[s][1].type !== "data") && (s !== h + 2 && (a[h][1].end = a[s - 1][1].end, a.splice(h + 2, s - h - 2), s = h + 2), h = void 0);
    return r ? r(a, i) : a;
  }
}
function fM(r, t) {
  let a = 0;
  for (; ++a <= r.length; )
    if ((a === r.length || r[a][1].type === "lineEnding") && r[a - 1][1].type === "data") {
      const i = r[a - 1][1], s = t.sliceStream(i);
      let h = s.length, d = -1, y = 0, g;
      for (; h--; ) {
        const b = s[h];
        if (typeof b == "string") {
          for (d = b.length; b.charCodeAt(d - 1) === 32; )
            y++, d--;
          if (d) break;
          d = -1;
        } else if (b === -2)
          g = !0, y++;
        else if (b !== -1) {
          h++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && a === r.length && (y = 0), y) {
        const b = {
          type: a === r.length || g || y < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: h ? d : i.start._bufferIndex + d,
            _index: i.start._index + h,
            line: i.end.line,
            column: i.end.column - y,
            offset: i.end.offset - y
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...b.start
        }, i.start.offset === i.end.offset ? Object.assign(i, b) : (r.splice(a, 0, ["enter", b, t], ["exit", b, t]), a += 2);
      }
      a++;
    }
  return r;
}
const hM = {
  42: Sl,
  43: Sl,
  45: Sl,
  48: Sl,
  49: Sl,
  50: Sl,
  51: Sl,
  52: Sl,
  53: Sl,
  54: Sl,
  55: Sl,
  56: Sl,
  57: Sl,
  62: gx
}, dM = {
  91: yC
}, mM = {
  [-2]: U6,
  [-1]: U6,
  32: U6
}, pM = {
  35: TC,
  42: Ev,
  45: [Z2, Ev],
  60: RC,
  61: Z2,
  95: Ev,
  96: X2,
  126: X2
}, gM = {
  38: vx,
  92: yx
}, yM = {
  [-5]: q6,
  [-4]: q6,
  [-3]: q6,
  33: $C,
  38: vx,
  42: A5,
  60: [Qz, NC],
  91: QC,
  92: [xC, yx],
  93: y7,
  95: A5,
  96: iC
}, vM = {
  null: [A5, oM]
}, bM = {
  null: [42, 95]
}, SM = {
  null: []
}, xM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: bM,
  contentInitial: dM,
  disable: SM,
  document: hM,
  flow: pM,
  flowInitial: mM,
  insideSpan: vM,
  string: gM,
  text: yM
}, Symbol.toStringTag, { value: "Module" }));
function wM(r, t, a) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: a && a.line || 1,
    column: a && a.column || 1,
    offset: a && a.offset || 0
  };
  const s = {}, h = [];
  let d = [], y = [];
  const g = {
    attempt: Ce(se),
    check: Ce(te),
    consume: I,
    enter: $,
    exit: ce,
    interrupt: Ce(te, {
      interrupt: !0
    })
  }, b = {
    code: null,
    containerState: {},
    defineSkip: L,
    events: [],
    now: O,
    parser: r,
    previous: null,
    sliceSerialize: R,
    sliceStream: E,
    write: T
  };
  let x = t.tokenize.call(b, g);
  return t.resolveAll && h.push(t), b;
  function T(De) {
    return d = Di(d, De), G(), d[d.length - 1] !== null ? [] : (ve(t, 0), b.events = Zv(h, b.events, b), b.events);
  }
  function R(De, de) {
    return EM(E(De), de);
  }
  function E(De) {
    return TM(d, De);
  }
  function O() {
    const {
      _bufferIndex: De,
      _index: de,
      line: Ye,
      column: Te,
      offset: re
    } = i;
    return {
      _bufferIndex: De,
      _index: de,
      line: Ye,
      column: Te,
      offset: re
    };
  }
  function L(De) {
    s[De.line] = De.column, ee();
  }
  function G() {
    let De;
    for (; i._index < d.length; ) {
      const de = d[i._index];
      if (typeof de == "string")
        for (De = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === De && i._bufferIndex < de.length; )
          V(de.charCodeAt(i._bufferIndex));
      else
        V(de);
    }
  }
  function V(De) {
    x = x(De);
  }
  function I(De) {
    ft(De) ? (i.line++, i.column = 1, i.offset += De === -3 ? 2 : 1, ee()) : De !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    d[i._index].length && (i._bufferIndex = -1, i._index++)), b.previous = De;
  }
  function $(De, de) {
    const Ye = de || {};
    return Ye.type = De, Ye.start = O(), b.events.push(["enter", Ye, b]), y.push(Ye), Ye;
  }
  function ce(De) {
    const de = y.pop();
    return de.end = O(), b.events.push(["exit", de, b]), de;
  }
  function se(De, de) {
    ve(De, de.from);
  }
  function te(De, de) {
    de.restore();
  }
  function Ce(De, de) {
    return Ye;
    function Ye(Te, re, J) {
      let X, W, be, C;
      return Array.isArray(Te) ? (
        /* c8 ignore next 1 */
        ie(Te)
      ) : "tokenize" in Te ? (
        // Looks like a construct.
        ie([
          /** @type {Construct} */
          Te
        ])
      ) : Y(Te);
      function Y(Se) {
        return Ge;
        function Ge(rt) {
          const ht = rt !== null && Se[rt], vt = rt !== null && Se.null, St = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(ht) ? ht : ht ? [ht] : [],
            ...Array.isArray(vt) ? vt : vt ? [vt] : []
          ];
          return ie(St)(rt);
        }
      }
      function ie(Se) {
        return X = Se, W = 0, Se.length === 0 ? J : N(Se[W]);
      }
      function N(Se) {
        return Ge;
        function Ge(rt) {
          return C = Ne(), be = Se, Se.partial || (b.currentConstruct = Se), Se.name && b.parser.constructs.disable.null.includes(Se.name) ? _e() : Se.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            de ? Object.assign(Object.create(b), de) : b,
            g,
            Me,
            _e
          )(rt);
        }
      }
      function Me(Se) {
        return De(be, C), re;
      }
      function _e(Se) {
        return C.restore(), ++W < X.length ? N(X[W]) : J;
      }
    }
  }
  function ve(De, de) {
    De.resolveAll && !h.includes(De) && h.push(De), De.resolve && ni(b.events, de, b.events.length - de, De.resolve(b.events.slice(de), b)), De.resolveTo && (b.events = De.resolveTo(b.events, b));
  }
  function Ne() {
    const De = O(), de = b.previous, Ye = b.currentConstruct, Te = b.events.length, re = Array.from(y);
    return {
      from: Te,
      restore: J
    };
    function J() {
      i = De, b.previous = de, b.currentConstruct = Ye, b.events.length = Te, y = re, ee();
    }
  }
  function ee() {
    i.line in s && i.column < 2 && (i.column = s[i.line], i.offset += s[i.line] - 1);
  }
}
function TM(r, t) {
  const a = t.start._index, i = t.start._bufferIndex, s = t.end._index, h = t.end._bufferIndex;
  let d;
  if (a === s)
    d = [r[a].slice(i, h)];
  else {
    if (d = r.slice(a, s), i > -1) {
      const y = d[0];
      typeof y == "string" ? d[0] = y.slice(i) : d.shift();
    }
    h > 0 && d.push(r[s].slice(0, h));
  }
  return d;
}
function EM(r, t) {
  let a = -1;
  const i = [];
  let s;
  for (; ++a < r.length; ) {
    const h = r[a];
    let d;
    if (typeof h == "string")
      d = h;
    else switch (h) {
      case -5: {
        d = "\r";
        break;
      }
      case -4: {
        d = `
`;
        break;
      }
      case -3: {
        d = `\r
`;
        break;
      }
      case -2: {
        d = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && s) continue;
        d = " ";
        break;
      }
      default:
        d = String.fromCharCode(h);
    }
    s = h === -2, i.push(d);
  }
  return i.join("");
}
function AM(r) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      mx([xM, ...(r || {}).extensions || []])
    ),
    content: s(jz),
    defined: [],
    document: s(Vz),
    flow: s(iM),
    lazy: {},
    string: s(sM),
    text: s(cM)
  };
  return i;
  function s(h) {
    return d;
    function d(y) {
      return wM(i, h, y);
    }
  }
}
function kM(r) {
  for (; !bx(r); )
    ;
  return r;
}
const F2 = /[\0\t\n\r]/g;
function RM() {
  let r = 1, t = "", a = !0, i;
  return s;
  function s(h, d, y) {
    const g = [];
    let b, x, T, R, E;
    for (h = t + (typeof h == "string" ? h.toString() : new TextDecoder(d || void 0).decode(h)), T = 0, t = "", a && (h.charCodeAt(0) === 65279 && T++, a = void 0); T < h.length; ) {
      if (F2.lastIndex = T, b = F2.exec(h), R = b && b.index !== void 0 ? b.index : h.length, E = h.charCodeAt(R), !b) {
        t = h.slice(T);
        break;
      }
      if (E === 10 && T === R && i)
        g.push(-3), i = void 0;
      else
        switch (i && (g.push(-5), i = void 0), T < R && (g.push(h.slice(T, R)), r += R - T), E) {
          case 0: {
            g.push(65533), r++;
            break;
          }
          case 9: {
            for (x = Math.ceil(r / 4) * 4, g.push(-2); r++ < x; ) g.push(-1);
            break;
          }
          case 10: {
            g.push(-4), r = 1;
            break;
          }
          default:
            i = !0, r = 1;
        }
      T = R + 1;
    }
    return y && (i && g.push(-5), t && g.push(t), g.push(null)), g;
  }
}
const zM = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function CM(r) {
  return r.replace(zM, MM);
}
function MM(r, t, a) {
  if (t)
    return t;
  if (a.charCodeAt(0) === 35) {
    const s = a.charCodeAt(1), h = s === 120 || s === 88;
    return px(a.slice(h ? 2 : 1), h ? 16 : 10);
  }
  return g7(a) || r;
}
const Ax = {}.hasOwnProperty;
function _M(r, t, a) {
  return typeof t != "string" && (a = t, t = void 0), OM(a)(kM(AM(a).document().write(RM()(r, t, !0))));
}
function OM(r) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: h(sr),
      autolinkProtocol: Ne,
      autolinkEmail: Ne,
      atxHeading: h(Gn),
      blockQuote: h(vt),
      characterEscape: Ne,
      characterReference: Ne,
      codeFenced: h(St),
      codeFencedFenceInfo: d,
      codeFencedFenceMeta: d,
      codeIndented: h(St, d),
      codeText: h(wn, d),
      codeTextData: Ne,
      data: Ne,
      codeFlowValue: Ne,
      definition: h(Dr),
      definitionDestinationString: d,
      definitionLabelString: d,
      definitionTitleString: d,
      emphasis: h(jn),
      hardBreakEscape: h(xr),
      hardBreakTrailing: h(xr),
      htmlFlow: h(Bt, d),
      htmlFlowData: Ne,
      htmlText: h(Bt, d),
      htmlTextData: Ne,
      image: h(er),
      label: d,
      link: h(sr),
      listItem: h(xt),
      listItemValue: R,
      listOrdered: h(El, T),
      listUnordered: h(El),
      paragraph: h(nl),
      reference: N,
      referenceString: d,
      resourceDestinationString: d,
      resourceTitleString: d,
      setextHeading: h(Gn),
      strong: h(Tn),
      thematicBreak: h(rl)
    },
    exit: {
      atxHeading: g(),
      atxHeadingSequence: se,
      autolink: g(),
      autolinkEmail: ht,
      autolinkProtocol: rt,
      blockQuote: g(),
      characterEscapeValue: ee,
      characterReferenceMarkerHexadecimal: _e,
      characterReferenceMarkerNumeric: _e,
      characterReferenceValue: Se,
      characterReference: Ge,
      codeFenced: g(G),
      codeFencedFence: L,
      codeFencedFenceInfo: E,
      codeFencedFenceMeta: O,
      codeFlowValue: ee,
      codeIndented: g(V),
      codeText: g(re),
      codeTextData: ee,
      data: ee,
      definition: g(),
      definitionDestinationString: ce,
      definitionLabelString: I,
      definitionTitleString: $,
      emphasis: g(),
      hardBreakEscape: g(de),
      hardBreakTrailing: g(de),
      htmlFlow: g(Ye),
      htmlFlowData: ee,
      htmlText: g(Te),
      htmlTextData: ee,
      image: g(X),
      label: be,
      labelText: W,
      lineEnding: De,
      link: g(J),
      listItem: g(),
      listOrdered: g(),
      listUnordered: g(),
      paragraph: g(),
      referenceString: Me,
      resourceDestinationString: C,
      resourceTitleString: Y,
      resource: ie,
      setextHeading: g(ve),
      setextHeadingLineSequence: Ce,
      setextHeadingText: te,
      strong: g(),
      thematicBreak: g()
    }
  };
  kx(t, (r || {}).mdastExtensions || []);
  const a = {};
  return i;
  function i(ke) {
    let je = {
      type: "root",
      children: []
    };
    const ut = {
      stack: [je],
      tokenStack: [],
      config: t,
      enter: y,
      exit: b,
      buffer: d,
      resume: x,
      data: a
    }, st = [];
    let Qt = -1;
    for (; ++Qt < ke.length; )
      if (ke[Qt][1].type === "listOrdered" || ke[Qt][1].type === "listUnordered")
        if (ke[Qt][0] === "enter")
          st.push(Qt);
        else {
          const Zn = st.pop();
          Qt = s(ke, Zn, Qt);
        }
    for (Qt = -1; ++Qt < ke.length; ) {
      const Zn = t[ke[Qt][0]];
      Ax.call(Zn, ke[Qt][1].type) && Zn[ke[Qt][1].type].call(Object.assign({
        sliceSerialize: ke[Qt][2].sliceSerialize
      }, ut), ke[Qt][1]);
    }
    if (ut.tokenStack.length > 0) {
      const Zn = ut.tokenStack[ut.tokenStack.length - 1];
      (Zn[1] || P2).call(ut, void 0, Zn[0]);
    }
    for (je.position = {
      start: Wc(ke.length > 0 ? ke[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Wc(ke.length > 0 ? ke[ke.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Qt = -1; ++Qt < t.transforms.length; )
      je = t.transforms[Qt](je) || je;
    return je;
  }
  function s(ke, je, ut) {
    let st = je - 1, Qt = -1, Zn = !1, La, fr, Nr, Hn;
    for (; ++st <= ut; ) {
      const hn = ke[st];
      switch (hn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          hn[0] === "enter" ? Qt++ : Qt--, Hn = void 0;
          break;
        }
        case "lineEndingBlank": {
          hn[0] === "enter" && (La && !Hn && !Qt && !Nr && (Nr = st), Hn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Hn = void 0;
      }
      if (!Qt && hn[0] === "enter" && hn[1].type === "listItemPrefix" || Qt === -1 && hn[0] === "exit" && (hn[1].type === "listUnordered" || hn[1].type === "listOrdered")) {
        if (La) {
          let hr = st;
          for (fr = void 0; hr--; ) {
            const B = ke[hr];
            if (B[1].type === "lineEnding" || B[1].type === "lineEndingBlank") {
              if (B[0] === "exit") continue;
              fr && (ke[fr][1].type = "lineEndingBlank", Zn = !0), B[1].type = "lineEnding", fr = hr;
            } else if (!(B[1].type === "linePrefix" || B[1].type === "blockQuotePrefix" || B[1].type === "blockQuotePrefixWhitespace" || B[1].type === "blockQuoteMarker" || B[1].type === "listItemIndent")) break;
          }
          Nr && (!fr || Nr < fr) && (La._spread = !0), La.end = Object.assign({}, fr ? ke[fr][1].start : hn[1].end), ke.splice(fr || st, 0, ["exit", La, hn[2]]), st++, ut++;
        }
        if (hn[1].type === "listItemPrefix") {
          const hr = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, hn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          La = hr, ke.splice(st, 0, ["enter", hr, hn[2]]), st++, ut++, Nr = void 0, Hn = !0;
        }
      }
    }
    return ke[je][1]._spread = Zn, ut;
  }
  function h(ke, je) {
    return ut;
    function ut(st) {
      y.call(this, ke(st), st), je && je.call(this, st);
    }
  }
  function d() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function y(ke, je, ut) {
    this.stack[this.stack.length - 1].children.push(ke), this.stack.push(ke), this.tokenStack.push([je, ut || void 0]), ke.position = {
      start: Wc(je.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function g(ke) {
    return je;
    function je(ut) {
      ke && ke.call(this, ut), b.call(this, ut);
    }
  }
  function b(ke, je) {
    const ut = this.stack.pop(), st = this.tokenStack.pop();
    if (st)
      st[0].type !== ke.type && (je ? je.call(this, ke, st[0]) : (st[1] || P2).call(this, ke, st[0]));
    else throw new Error("Cannot close `" + ke.type + "` (" + jg({
      start: ke.start,
      end: ke.end
    }) + "): it’s not open");
    ut.position.end = Wc(ke.end);
  }
  function x() {
    return p7(this.stack.pop());
  }
  function T() {
    this.data.expectingFirstListItemValue = !0;
  }
  function R(ke) {
    if (this.data.expectingFirstListItemValue) {
      const je = this.stack[this.stack.length - 2];
      je.start = Number.parseInt(this.sliceSerialize(ke), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function E() {
    const ke = this.resume(), je = this.stack[this.stack.length - 1];
    je.lang = ke;
  }
  function O() {
    const ke = this.resume(), je = this.stack[this.stack.length - 1];
    je.meta = ke;
  }
  function L() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function G() {
    const ke = this.resume(), je = this.stack[this.stack.length - 1];
    je.value = ke.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function V() {
    const ke = this.resume(), je = this.stack[this.stack.length - 1];
    je.value = ke.replace(/(\r?\n|\r)$/g, "");
  }
  function I(ke) {
    const je = this.resume(), ut = this.stack[this.stack.length - 1];
    ut.label = je, ut.identifier = Au(this.sliceSerialize(ke)).toLowerCase();
  }
  function $() {
    const ke = this.resume(), je = this.stack[this.stack.length - 1];
    je.title = ke;
  }
  function ce() {
    const ke = this.resume(), je = this.stack[this.stack.length - 1];
    je.url = ke;
  }
  function se(ke) {
    const je = this.stack[this.stack.length - 1];
    if (!je.depth) {
      const ut = this.sliceSerialize(ke).length;
      je.depth = ut;
    }
  }
  function te() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function Ce(ke) {
    const je = this.stack[this.stack.length - 1];
    je.depth = this.sliceSerialize(ke).codePointAt(0) === 61 ? 1 : 2;
  }
  function ve() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function Ne(ke) {
    const ut = this.stack[this.stack.length - 1].children;
    let st = ut[ut.length - 1];
    (!st || st.type !== "text") && (st = cr(), st.position = {
      start: Wc(ke.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ut.push(st)), this.stack.push(st);
  }
  function ee(ke) {
    const je = this.stack.pop();
    je.value += this.sliceSerialize(ke), je.position.end = Wc(ke.end);
  }
  function De(ke) {
    const je = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ut = je.children[je.children.length - 1];
      ut.position.end = Wc(ke.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(je.type) && (Ne.call(this, ke), ee.call(this, ke));
  }
  function de() {
    this.data.atHardBreak = !0;
  }
  function Ye() {
    const ke = this.resume(), je = this.stack[this.stack.length - 1];
    je.value = ke;
  }
  function Te() {
    const ke = this.resume(), je = this.stack[this.stack.length - 1];
    je.value = ke;
  }
  function re() {
    const ke = this.resume(), je = this.stack[this.stack.length - 1];
    je.value = ke;
  }
  function J() {
    const ke = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const je = this.data.referenceType || "shortcut";
      ke.type += "Reference", ke.referenceType = je, delete ke.url, delete ke.title;
    } else
      delete ke.identifier, delete ke.label;
    this.data.referenceType = void 0;
  }
  function X() {
    const ke = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const je = this.data.referenceType || "shortcut";
      ke.type += "Reference", ke.referenceType = je, delete ke.url, delete ke.title;
    } else
      delete ke.identifier, delete ke.label;
    this.data.referenceType = void 0;
  }
  function W(ke) {
    const je = this.sliceSerialize(ke), ut = this.stack[this.stack.length - 2];
    ut.label = CM(je), ut.identifier = Au(je).toLowerCase();
  }
  function be() {
    const ke = this.stack[this.stack.length - 1], je = this.resume(), ut = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ut.type === "link") {
      const st = ke.children;
      ut.children = st;
    } else
      ut.alt = je;
  }
  function C() {
    const ke = this.resume(), je = this.stack[this.stack.length - 1];
    je.url = ke;
  }
  function Y() {
    const ke = this.resume(), je = this.stack[this.stack.length - 1];
    je.title = ke;
  }
  function ie() {
    this.data.inReference = void 0;
  }
  function N() {
    this.data.referenceType = "collapsed";
  }
  function Me(ke) {
    const je = this.resume(), ut = this.stack[this.stack.length - 1];
    ut.label = je, ut.identifier = Au(this.sliceSerialize(ke)).toLowerCase(), this.data.referenceType = "full";
  }
  function _e(ke) {
    this.data.characterReferenceType = ke.type;
  }
  function Se(ke) {
    const je = this.sliceSerialize(ke), ut = this.data.characterReferenceType;
    let st;
    ut ? (st = px(je, ut === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : st = g7(je);
    const Qt = this.stack[this.stack.length - 1];
    Qt.value += st;
  }
  function Ge(ke) {
    const je = this.stack.pop();
    je.position.end = Wc(ke.end);
  }
  function rt(ke) {
    ee.call(this, ke);
    const je = this.stack[this.stack.length - 1];
    je.url = this.sliceSerialize(ke);
  }
  function ht(ke) {
    ee.call(this, ke);
    const je = this.stack[this.stack.length - 1];
    je.url = "mailto:" + this.sliceSerialize(ke);
  }
  function vt() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function St() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function wn() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Dr() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function jn() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Gn() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function xr() {
    return {
      type: "break"
    };
  }
  function Bt() {
    return {
      type: "html",
      value: ""
    };
  }
  function er() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function sr() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function El(ke) {
    return {
      type: "list",
      ordered: ke.type === "listOrdered",
      start: null,
      spread: ke._spread,
      children: []
    };
  }
  function xt(ke) {
    return {
      type: "listItem",
      spread: ke._spread,
      checked: null,
      children: []
    };
  }
  function nl() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Tn() {
    return {
      type: "strong",
      children: []
    };
  }
  function cr() {
    return {
      type: "text",
      value: ""
    };
  }
  function rl() {
    return {
      type: "thematicBreak"
    };
  }
}
function Wc(r) {
  return {
    line: r.line,
    column: r.column,
    offset: r.offset
  };
}
function kx(r, t) {
  let a = -1;
  for (; ++a < t.length; ) {
    const i = t[a];
    Array.isArray(i) ? kx(r, i) : DM(r, i);
  }
}
function DM(r, t) {
  let a;
  for (a in t)
    if (Ax.call(t, a))
      switch (a) {
        case "canContainEols": {
          const i = t[a];
          i && r[a].push(...i);
          break;
        }
        case "transforms": {
          const i = t[a];
          i && r[a].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = t[a];
          i && Object.assign(r[a], i);
          break;
        }
      }
}
function P2(r, t) {
  throw r ? new Error("Cannot close `" + r.type + "` (" + jg({
    start: r.start,
    end: r.end
  }) + "): a different token (`" + t.type + "`, " + jg({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + jg({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function NM(r) {
  const t = this;
  t.parser = a;
  function a(i) {
    return _M(i, {
      ...t.data("settings"),
      ...r,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function LM(r, t) {
  const a = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: r.wrap(r.all(t), !0)
  };
  return r.patch(t, a), r.applyData(t, a);
}
function BM(r, t) {
  const a = { type: "element", tagName: "br", properties: {}, children: [] };
  return r.patch(t, a), [r.applyData(t, a), { type: "text", value: `
` }];
}
function HM(r, t) {
  const a = t.value ? t.value + `
` : "", i = {};
  t.lang && (i.className = ["language-" + t.lang]);
  let s = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: a }]
  };
  return t.meta && (s.data = { meta: t.meta }), r.patch(t, s), s = r.applyData(t, s), s = { type: "element", tagName: "pre", properties: {}, children: [s] }, r.patch(t, s), s;
}
function UM(r, t) {
  const a = {
    type: "element",
    tagName: "del",
    properties: {},
    children: r.all(t)
  };
  return r.patch(t, a), r.applyData(t, a);
}
function qM(r, t) {
  const a = {
    type: "element",
    tagName: "em",
    properties: {},
    children: r.all(t)
  };
  return r.patch(t, a), r.applyData(t, a);
}
function jM(r, t) {
  const a = typeof r.options.clobberPrefix == "string" ? r.options.clobberPrefix : "user-content-", i = String(t.identifier).toUpperCase(), s = Om(i.toLowerCase()), h = r.footnoteOrder.indexOf(i);
  let d, y = r.footnoteCounts.get(i);
  y === void 0 ? (y = 0, r.footnoteOrder.push(i), d = r.footnoteOrder.length) : d = h + 1, y += 1, r.footnoteCounts.set(i, y);
  const g = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + a + "fn-" + s,
      id: a + "fnref-" + s + (y > 1 ? "-" + y : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(d) }]
  };
  r.patch(t, g);
  const b = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [g]
  };
  return r.patch(t, b), r.applyData(t, b);
}
function GM(r, t) {
  const a = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: r.all(t)
  };
  return r.patch(t, a), r.applyData(t, a);
}
function VM(r, t) {
  if (r.options.allowDangerousHtml) {
    const a = { type: "raw", value: t.value };
    return r.patch(t, a), r.applyData(t, a);
  }
}
function Rx(r, t) {
  const a = t.referenceType;
  let i = "]";
  if (a === "collapsed" ? i += "[]" : a === "full" && (i += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + i }];
  const s = r.all(t), h = s[0];
  h && h.type === "text" ? h.value = "[" + h.value : s.unshift({ type: "text", value: "[" });
  const d = s[s.length - 1];
  return d && d.type === "text" ? d.value += i : s.push({ type: "text", value: i }), s;
}
function YM(r, t) {
  const a = String(t.identifier).toUpperCase(), i = r.definitionById.get(a);
  if (!i)
    return Rx(r, t);
  const s = { src: Om(i.url || ""), alt: t.alt };
  i.title !== null && i.title !== void 0 && (s.title = i.title);
  const h = { type: "element", tagName: "img", properties: s, children: [] };
  return r.patch(t, h), r.applyData(t, h);
}
function IM(r, t) {
  const a = { src: Om(t.url) };
  t.alt !== null && t.alt !== void 0 && (a.alt = t.alt), t.title !== null && t.title !== void 0 && (a.title = t.title);
  const i = { type: "element", tagName: "img", properties: a, children: [] };
  return r.patch(t, i), r.applyData(t, i);
}
function $M(r, t) {
  const a = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  r.patch(t, a);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [a]
  };
  return r.patch(t, i), r.applyData(t, i);
}
function XM(r, t) {
  const a = String(t.identifier).toUpperCase(), i = r.definitionById.get(a);
  if (!i)
    return Rx(r, t);
  const s = { href: Om(i.url || "") };
  i.title !== null && i.title !== void 0 && (s.title = i.title);
  const h = {
    type: "element",
    tagName: "a",
    properties: s,
    children: r.all(t)
  };
  return r.patch(t, h), r.applyData(t, h);
}
function QM(r, t) {
  const a = { href: Om(t.url) };
  t.title !== null && t.title !== void 0 && (a.title = t.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: a,
    children: r.all(t)
  };
  return r.patch(t, i), r.applyData(t, i);
}
function ZM(r, t, a) {
  const i = r.all(t), s = a ? FM(a) : zx(t), h = {}, d = [];
  if (typeof t.checked == "boolean") {
    const x = i[0];
    let T;
    x && x.type === "element" && x.tagName === "p" ? T = x : (T = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(T)), T.children.length > 0 && T.children.unshift({ type: "text", value: " " }), T.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), h.className = ["task-list-item"];
  }
  let y = -1;
  for (; ++y < i.length; ) {
    const x = i[y];
    (s || y !== 0 || x.type !== "element" || x.tagName !== "p") && d.push({ type: "text", value: `
` }), x.type === "element" && x.tagName === "p" && !s ? d.push(...x.children) : d.push(x);
  }
  const g = i[i.length - 1];
  g && (s || g.type !== "element" || g.tagName !== "p") && d.push({ type: "text", value: `
` });
  const b = { type: "element", tagName: "li", properties: h, children: d };
  return r.patch(t, b), r.applyData(t, b);
}
function FM(r) {
  let t = !1;
  if (r.type === "list") {
    t = r.spread || !1;
    const a = r.children;
    let i = -1;
    for (; !t && ++i < a.length; )
      t = zx(a[i]);
  }
  return t;
}
function zx(r) {
  const t = r.spread;
  return t ?? r.children.length > 1;
}
function PM(r, t) {
  const a = {}, i = r.all(t);
  let s = -1;
  for (typeof t.start == "number" && t.start !== 1 && (a.start = t.start); ++s < i.length; ) {
    const d = i[s];
    if (d.type === "element" && d.tagName === "li" && d.properties && Array.isArray(d.properties.className) && d.properties.className.includes("task-list-item")) {
      a.className = ["contains-task-list"];
      break;
    }
  }
  const h = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: a,
    children: r.wrap(i, !0)
  };
  return r.patch(t, h), r.applyData(t, h);
}
function KM(r, t) {
  const a = {
    type: "element",
    tagName: "p",
    properties: {},
    children: r.all(t)
  };
  return r.patch(t, a), r.applyData(t, a);
}
function JM(r, t) {
  const a = { type: "root", children: r.wrap(r.all(t)) };
  return r.patch(t, a), r.applyData(t, a);
}
function WM(r, t) {
  const a = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: r.all(t)
  };
  return r.patch(t, a), r.applyData(t, a);
}
function e_(r, t) {
  const a = r.all(t), i = a.shift(), s = [];
  if (i) {
    const d = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: r.wrap([i], !0)
    };
    r.patch(t.children[0], d), s.push(d);
  }
  if (a.length > 0) {
    const d = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: r.wrap(a, !0)
    }, y = f7(t.children[1]), g = ux(t.children[t.children.length - 1]);
    y && g && (d.position = { start: y, end: g }), s.push(d);
  }
  const h = {
    type: "element",
    tagName: "table",
    properties: {},
    children: r.wrap(s, !0)
  };
  return r.patch(t, h), r.applyData(t, h);
}
function t_(r, t, a) {
  const i = a ? a.children : void 0, h = (i ? i.indexOf(t) : 1) === 0 ? "th" : "td", d = a && a.type === "table" ? a.align : void 0, y = d ? d.length : t.children.length;
  let g = -1;
  const b = [];
  for (; ++g < y; ) {
    const T = t.children[g], R = {}, E = d ? d[g] : void 0;
    E && (R.align = E);
    let O = { type: "element", tagName: h, properties: R, children: [] };
    T && (O.children = r.all(T), r.patch(T, O), O = r.applyData(T, O)), b.push(O);
  }
  const x = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: r.wrap(b, !0)
  };
  return r.patch(t, x), r.applyData(t, x);
}
function n_(r, t) {
  const a = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: r.all(t)
  };
  return r.patch(t, a), r.applyData(t, a);
}
const K2 = 9, J2 = 32;
function r_(r) {
  const t = String(r), a = /\r?\n|\r/g;
  let i = a.exec(t), s = 0;
  const h = [];
  for (; i; )
    h.push(
      W2(t.slice(s, i.index), s > 0, !0),
      i[0]
    ), s = i.index + i[0].length, i = a.exec(t);
  return h.push(W2(t.slice(s), s > 0, !1)), h.join("");
}
function W2(r, t, a) {
  let i = 0, s = r.length;
  if (t) {
    let h = r.codePointAt(i);
    for (; h === K2 || h === J2; )
      i++, h = r.codePointAt(i);
  }
  if (a) {
    let h = r.codePointAt(s - 1);
    for (; h === K2 || h === J2; )
      s--, h = r.codePointAt(s - 1);
  }
  return s > i ? r.slice(i, s) : "";
}
function a_(r, t) {
  const a = { type: "text", value: r_(String(t.value)) };
  return r.patch(t, a), r.applyData(t, a);
}
function l_(r, t) {
  const a = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return r.patch(t, a), r.applyData(t, a);
}
const i_ = {
  blockquote: LM,
  break: BM,
  code: HM,
  delete: UM,
  emphasis: qM,
  footnoteReference: jM,
  heading: GM,
  html: VM,
  imageReference: YM,
  image: IM,
  inlineCode: $M,
  linkReference: XM,
  link: QM,
  listItem: ZM,
  list: PM,
  paragraph: KM,
  // @ts-expect-error: root is different, but hard to type.
  root: JM,
  strong: WM,
  table: e_,
  tableCell: n_,
  tableRow: t_,
  text: a_,
  thematicBreak: l_,
  toml: uv,
  yaml: uv,
  definition: uv,
  footnoteDefinition: uv
};
function uv() {
}
const Cx = -1, Fv = 0, Vg = 1, _v = 2, v7 = 3, b7 = 4, S7 = 5, x7 = 6, Mx = 7, _x = 8, e9 = typeof self == "object" ? self : globalThis, u_ = (r, t) => {
  const a = (s, h) => (r.set(h, s), s), i = (s) => {
    if (r.has(s))
      return r.get(s);
    const [h, d] = t[s];
    switch (h) {
      case Fv:
      case Cx:
        return a(d, s);
      case Vg: {
        const y = a([], s);
        for (const g of d)
          y.push(i(g));
        return y;
      }
      case _v: {
        const y = a({}, s);
        for (const [g, b] of d)
          y[i(g)] = i(b);
        return y;
      }
      case v7:
        return a(new Date(d), s);
      case b7: {
        const { source: y, flags: g } = d;
        return a(new RegExp(y, g), s);
      }
      case S7: {
        const y = a(/* @__PURE__ */ new Map(), s);
        for (const [g, b] of d)
          y.set(i(g), i(b));
        return y;
      }
      case x7: {
        const y = a(/* @__PURE__ */ new Set(), s);
        for (const g of d)
          y.add(i(g));
        return y;
      }
      case Mx: {
        const { name: y, message: g } = d;
        return a(new e9[y](g), s);
      }
      case _x:
        return a(BigInt(d), s);
      case "BigInt":
        return a(Object(BigInt(d)), s);
      case "ArrayBuffer":
        return a(new Uint8Array(d).buffer, d);
      case "DataView": {
        const { buffer: y } = new Uint8Array(d);
        return a(new DataView(y), d);
      }
    }
    return a(new e9[h](d), s);
  };
  return i;
}, t9 = (r) => u_(/* @__PURE__ */ new Map(), r)(0), Sm = "", { toString: o_ } = {}, { keys: s_ } = Object, Lg = (r) => {
  const t = typeof r;
  if (t !== "object" || !r)
    return [Fv, t];
  const a = o_.call(r).slice(8, -1);
  switch (a) {
    case "Array":
      return [Vg, Sm];
    case "Object":
      return [_v, Sm];
    case "Date":
      return [v7, Sm];
    case "RegExp":
      return [b7, Sm];
    case "Map":
      return [S7, Sm];
    case "Set":
      return [x7, Sm];
    case "DataView":
      return [Vg, a];
  }
  return a.includes("Array") ? [Vg, a] : a.includes("Error") ? [Mx, a] : [_v, a];
}, ov = ([r, t]) => r === Fv && (t === "function" || t === "symbol"), c_ = (r, t, a, i) => {
  const s = (d, y) => {
    const g = i.push(d) - 1;
    return a.set(y, g), g;
  }, h = (d) => {
    if (a.has(d))
      return a.get(d);
    let [y, g] = Lg(d);
    switch (y) {
      case Fv: {
        let x = d;
        switch (g) {
          case "bigint":
            y = _x, x = d.toString();
            break;
          case "function":
          case "symbol":
            if (r)
              throw new TypeError("unable to serialize " + g);
            x = null;
            break;
          case "undefined":
            return s([Cx], d);
        }
        return s([y, x], d);
      }
      case Vg: {
        if (g) {
          let R = d;
          return g === "DataView" ? R = new Uint8Array(d.buffer) : g === "ArrayBuffer" && (R = new Uint8Array(d)), s([g, [...R]], d);
        }
        const x = [], T = s([y, x], d);
        for (const R of d)
          x.push(h(R));
        return T;
      }
      case _v: {
        if (g)
          switch (g) {
            case "BigInt":
              return s([g, d.toString()], d);
            case "Boolean":
            case "Number":
            case "String":
              return s([g, d.valueOf()], d);
          }
        if (t && "toJSON" in d)
          return h(d.toJSON());
        const x = [], T = s([y, x], d);
        for (const R of s_(d))
          (r || !ov(Lg(d[R]))) && x.push([h(R), h(d[R])]);
        return T;
      }
      case v7:
        return s([y, d.toISOString()], d);
      case b7: {
        const { source: x, flags: T } = d;
        return s([y, { source: x, flags: T }], d);
      }
      case S7: {
        const x = [], T = s([y, x], d);
        for (const [R, E] of d)
          (r || !(ov(Lg(R)) || ov(Lg(E)))) && x.push([h(R), h(E)]);
        return T;
      }
      case x7: {
        const x = [], T = s([y, x], d);
        for (const R of d)
          (r || !ov(Lg(R))) && x.push(h(R));
        return T;
      }
    }
    const { message: b } = d;
    return s([y, { name: g, message: b }], d);
  };
  return h;
}, n9 = (r, { json: t, lossy: a } = {}) => {
  const i = [];
  return c_(!(t || a), !!t, /* @__PURE__ */ new Map(), i)(r), i;
}, Ov = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (r, t) => t && ("json" in t || "lossy" in t) ? t9(n9(r, t)) : structuredClone(r)
) : (r, t) => t9(n9(r, t));
function f_(r, t) {
  const a = [{ type: "text", value: "↩" }];
  return t > 1 && a.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), a;
}
function h_(r, t) {
  return "Back to reference " + (r + 1) + (t > 1 ? "-" + t : "");
}
function d_(r) {
  const t = typeof r.options.clobberPrefix == "string" ? r.options.clobberPrefix : "user-content-", a = r.options.footnoteBackContent || f_, i = r.options.footnoteBackLabel || h_, s = r.options.footnoteLabel || "Footnotes", h = r.options.footnoteLabelTagName || "h2", d = r.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, y = [];
  let g = -1;
  for (; ++g < r.footnoteOrder.length; ) {
    const b = r.footnoteById.get(
      r.footnoteOrder[g]
    );
    if (!b)
      continue;
    const x = r.all(b), T = String(b.identifier).toUpperCase(), R = Om(T.toLowerCase());
    let E = 0;
    const O = [], L = r.footnoteCounts.get(T);
    for (; L !== void 0 && ++E <= L; ) {
      O.length > 0 && O.push({ type: "text", value: " " });
      let I = typeof a == "string" ? a : a(g, E);
      typeof I == "string" && (I = { type: "text", value: I }), O.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + R + (E > 1 ? "-" + E : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(g, E),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(I) ? I : [I]
      });
    }
    const G = x[x.length - 1];
    if (G && G.type === "element" && G.tagName === "p") {
      const I = G.children[G.children.length - 1];
      I && I.type === "text" ? I.value += " " : G.children.push({ type: "text", value: " " }), G.children.push(...O);
    } else
      x.push(...O);
    const V = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + R },
      children: r.wrap(x, !0)
    };
    r.patch(b, V), y.push(V);
  }
  if (y.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: h,
          properties: {
            ...Ov(d),
            id: "footnote-label"
          },
          children: [{ type: "text", value: s }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: r.wrap(y, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const r4 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(r) {
    if (r == null)
      return y_;
    if (typeof r == "function")
      return Pv(r);
    if (typeof r == "object")
      return Array.isArray(r) ? m_(r) : p_(r);
    if (typeof r == "string")
      return g_(r);
    throw new Error("Expected function, string, or object as test");
  }
);
function m_(r) {
  const t = [];
  let a = -1;
  for (; ++a < r.length; )
    t[a] = r4(r[a]);
  return Pv(i);
  function i(...s) {
    let h = -1;
    for (; ++h < t.length; )
      if (t[h].apply(this, s)) return !0;
    return !1;
  }
}
function p_(r) {
  const t = (
    /** @type {Record<string, unknown>} */
    r
  );
  return Pv(a);
  function a(i) {
    const s = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let h;
    for (h in r)
      if (s[h] !== t[h]) return !1;
    return !0;
  }
}
function g_(r) {
  return Pv(t);
  function t(a) {
    return a && a.type === r;
  }
}
function Pv(r) {
  return t;
  function t(a, i, s) {
    return !!(v_(a) && r.call(
      this,
      a,
      typeof i == "number" ? i : void 0,
      s || void 0
    ));
  }
}
function y_() {
  return !0;
}
function v_(r) {
  return r !== null && typeof r == "object" && "type" in r;
}
const Ox = [], b_ = !0, k5 = !1, Dx = "skip";
function w7(r, t, a, i) {
  let s;
  typeof t == "function" && typeof a != "function" ? (i = a, a = t) : s = t;
  const h = r4(s), d = i ? -1 : 1;
  y(r, void 0, [])();
  function y(g, b, x) {
    const T = (
      /** @type {Record<string, unknown>} */
      g && typeof g == "object" ? g : {}
    );
    if (typeof T.type == "string") {
      const E = (
        // `hast`
        typeof T.tagName == "string" ? T.tagName : (
          // `xast`
          typeof T.name == "string" ? T.name : void 0
        )
      );
      Object.defineProperty(R, "name", {
        value: "node (" + (g.type + (E ? "<" + E + ">" : "")) + ")"
      });
    }
    return R;
    function R() {
      let E = Ox, O, L, G;
      if ((!t || h(g, b, x[x.length - 1] || void 0)) && (E = S_(a(g, x)), E[0] === k5))
        return E;
      if ("children" in g && g.children) {
        const V = (
          /** @type {UnistParent} */
          g
        );
        if (V.children && E[0] !== Dx)
          for (L = (i ? V.children.length : -1) + d, G = x.concat(V); L > -1 && L < V.children.length; ) {
            const I = V.children[L];
            if (O = y(I, L, G)(), O[0] === k5)
              return O;
            L = typeof O[1] == "number" ? O[1] : L + d;
          }
      }
      return E;
    }
  }
}
function S_(r) {
  return Array.isArray(r) ? r : typeof r == "number" ? [b_, r] : r == null ? Ox : [r];
}
function T7(r, t, a, i) {
  let s, h, d;
  typeof t == "function" ? (h = void 0, d = t, s = a) : (h = t, d = a, s = i), w7(r, h, y, s);
  function y(g, b) {
    const x = b[b.length - 1], T = x ? x.children.indexOf(g) : void 0;
    return d(g, T, x);
  }
}
const R5 = {}.hasOwnProperty, x_ = {};
function w_(r, t) {
  const a = t || x_, i = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new Map(), d = { ...i_, ...a.handlers }, y = {
    all: b,
    applyData: E_,
    definitionById: i,
    footnoteById: s,
    footnoteCounts: h,
    footnoteOrder: [],
    handlers: d,
    one: g,
    options: a,
    patch: T_,
    wrap: k_
  };
  return T7(r, function(x) {
    if (x.type === "definition" || x.type === "footnoteDefinition") {
      const T = x.type === "definition" ? i : s, R = String(x.identifier).toUpperCase();
      T.has(R) || T.set(R, x);
    }
  }), y;
  function g(x, T) {
    const R = x.type, E = y.handlers[R];
    if (R5.call(y.handlers, R) && E)
      return E(y, x, T);
    if (y.options.passThrough && y.options.passThrough.includes(R)) {
      if ("children" in x) {
        const { children: L, ...G } = x, V = Ov(G);
        return V.children = y.all(x), V;
      }
      return Ov(x);
    }
    return (y.options.unknownHandler || A_)(y, x, T);
  }
  function b(x) {
    const T = [];
    if ("children" in x) {
      const R = x.children;
      let E = -1;
      for (; ++E < R.length; ) {
        const O = y.one(R[E], x);
        if (O) {
          if (E && R[E - 1].type === "break" && (!Array.isArray(O) && O.type === "text" && (O.value = r9(O.value)), !Array.isArray(O) && O.type === "element")) {
            const L = O.children[0];
            L && L.type === "text" && (L.value = r9(L.value));
          }
          Array.isArray(O) ? T.push(...O) : T.push(O);
        }
      }
    }
    return T;
  }
}
function T_(r, t) {
  r.position && (t.position = hz(r));
}
function E_(r, t) {
  let a = t;
  if (r && r.data) {
    const i = r.data.hName, s = r.data.hChildren, h = r.data.hProperties;
    if (typeof i == "string")
      if (a.type === "element")
        a.tagName = i;
      else {
        const d = "children" in a ? a.children : [a];
        a = { type: "element", tagName: i, properties: {}, children: d };
      }
    a.type === "element" && h && Object.assign(a.properties, Ov(h)), "children" in a && a.children && s !== null && s !== void 0 && (a.children = s);
  }
  return a;
}
function A_(r, t) {
  const a = t.data || {}, i = "value" in t && !(R5.call(a, "hProperties") || R5.call(a, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: r.all(t)
  };
  return r.patch(t, i), r.applyData(t, i);
}
function k_(r, t) {
  const a = [];
  let i = -1;
  for (t && a.push({ type: "text", value: `
` }); ++i < r.length; )
    i && a.push({ type: "text", value: `
` }), a.push(r[i]);
  return t && r.length > 0 && a.push({ type: "text", value: `
` }), a;
}
function r9(r) {
  let t = 0, a = r.charCodeAt(t);
  for (; a === 9 || a === 32; )
    t++, a = r.charCodeAt(t);
  return r.slice(t);
}
function a9(r, t) {
  const a = w_(r, t), i = a.one(r, void 0), s = d_(a), h = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return s && h.children.push({ type: "text", value: `
` }, s), h;
}
function R_(r, t) {
  return r && "run" in r ? async function(a, i) {
    const s = (
      /** @type {HastRoot} */
      a9(a, { file: i, ...t })
    );
    await r.run(s, i);
  } : function(a, i) {
    return (
      /** @type {HastRoot} */
      a9(a, { file: i, ...r || t })
    );
  };
}
function l9(r) {
  if (r)
    throw r;
}
var Av = Object.prototype.hasOwnProperty, Nx = Object.prototype.toString, i9 = Object.defineProperty, u9 = Object.getOwnPropertyDescriptor, o9 = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : Nx.call(t) === "[object Array]";
}, s9 = function(t) {
  if (!t || Nx.call(t) !== "[object Object]")
    return !1;
  var a = Av.call(t, "constructor"), i = t.constructor && t.constructor.prototype && Av.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !a && !i)
    return !1;
  var s;
  for (s in t)
    ;
  return typeof s > "u" || Av.call(t, s);
}, c9 = function(t, a) {
  i9 && a.name === "__proto__" ? i9(t, a.name, {
    enumerable: !0,
    configurable: !0,
    value: a.newValue,
    writable: !0
  }) : t[a.name] = a.newValue;
}, f9 = function(t, a) {
  if (a === "__proto__")
    if (Av.call(t, a)) {
      if (u9)
        return u9(t, a).value;
    } else return;
  return t[a];
}, z_ = function r() {
  var t, a, i, s, h, d, y = arguments[0], g = 1, b = arguments.length, x = !1;
  for (typeof y == "boolean" && (x = y, y = arguments[1] || {}, g = 2), (y == null || typeof y != "object" && typeof y != "function") && (y = {}); g < b; ++g)
    if (t = arguments[g], t != null)
      for (a in t)
        i = f9(y, a), s = f9(t, a), y !== s && (x && s && (s9(s) || (h = o9(s))) ? (h ? (h = !1, d = i && o9(i) ? i : []) : d = i && s9(i) ? i : {}, c9(y, { name: a, newValue: r(x, d, s) })) : typeof s < "u" && c9(y, { name: a, newValue: s }));
  return y;
};
const j6 = /* @__PURE__ */ eh(z_);
function z5(r) {
  if (typeof r != "object" || r === null)
    return !1;
  const t = Object.getPrototypeOf(r);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in r) && !(Symbol.iterator in r);
}
function C_() {
  const r = [], t = { run: a, use: i };
  return t;
  function a(...s) {
    let h = -1;
    const d = s.pop();
    if (typeof d != "function")
      throw new TypeError("Expected function as last argument, not " + d);
    y(null, ...s);
    function y(g, ...b) {
      const x = r[++h];
      let T = -1;
      if (g) {
        d(g);
        return;
      }
      for (; ++T < s.length; )
        (b[T] === null || b[T] === void 0) && (b[T] = s[T]);
      s = b, x ? M_(x, y)(...b) : d(null, ...b);
    }
  }
  function i(s) {
    if (typeof s != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + s
      );
    return r.push(s), t;
  }
}
function M_(r, t) {
  let a;
  return i;
  function i(...d) {
    const y = r.length > d.length;
    let g;
    y && d.push(s);
    try {
      g = r.apply(this, d);
    } catch (b) {
      const x = (
        /** @type {Error} */
        b
      );
      if (y && a)
        throw x;
      return s(x);
    }
    y || (g && g.then && typeof g.then == "function" ? g.then(h, s) : g instanceof Error ? s(g) : h(g));
  }
  function s(d, ...y) {
    a || (a = !0, t(d, ...y));
  }
  function h(d) {
    s(null, d);
  }
}
const go = { basename: __, dirname: O_, extname: D_, join: N_, sep: "/" };
function __(r, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  a4(r);
  let a = 0, i = -1, s = r.length, h;
  if (t === void 0 || t.length === 0 || t.length > r.length) {
    for (; s--; )
      if (r.codePointAt(s) === 47) {
        if (h) {
          a = s + 1;
          break;
        }
      } else i < 0 && (h = !0, i = s + 1);
    return i < 0 ? "" : r.slice(a, i);
  }
  if (t === r)
    return "";
  let d = -1, y = t.length - 1;
  for (; s--; )
    if (r.codePointAt(s) === 47) {
      if (h) {
        a = s + 1;
        break;
      }
    } else
      d < 0 && (h = !0, d = s + 1), y > -1 && (r.codePointAt(s) === t.codePointAt(y--) ? y < 0 && (i = s) : (y = -1, i = d));
  return a === i ? i = d : i < 0 && (i = r.length), r.slice(a, i);
}
function O_(r) {
  if (a4(r), r.length === 0)
    return ".";
  let t = -1, a = r.length, i;
  for (; --a; )
    if (r.codePointAt(a) === 47) {
      if (i) {
        t = a;
        break;
      }
    } else i || (i = !0);
  return t < 0 ? r.codePointAt(0) === 47 ? "/" : "." : t === 1 && r.codePointAt(0) === 47 ? "//" : r.slice(0, t);
}
function D_(r) {
  a4(r);
  let t = r.length, a = -1, i = 0, s = -1, h = 0, d;
  for (; t--; ) {
    const y = r.codePointAt(t);
    if (y === 47) {
      if (d) {
        i = t + 1;
        break;
      }
      continue;
    }
    a < 0 && (d = !0, a = t + 1), y === 46 ? s < 0 ? s = t : h !== 1 && (h = 1) : s > -1 && (h = -1);
  }
  return s < 0 || a < 0 || // We saw a non-dot character immediately before the dot.
  h === 0 || // The (right-most) trimmed path component is exactly `..`.
  h === 1 && s === a - 1 && s === i + 1 ? "" : r.slice(s, a);
}
function N_(...r) {
  let t = -1, a;
  for (; ++t < r.length; )
    a4(r[t]), r[t] && (a = a === void 0 ? r[t] : a + "/" + r[t]);
  return a === void 0 ? "." : L_(a);
}
function L_(r) {
  a4(r);
  const t = r.codePointAt(0) === 47;
  let a = B_(r, !t);
  return a.length === 0 && !t && (a = "."), a.length > 0 && r.codePointAt(r.length - 1) === 47 && (a += "/"), t ? "/" + a : a;
}
function B_(r, t) {
  let a = "", i = 0, s = -1, h = 0, d = -1, y, g;
  for (; ++d <= r.length; ) {
    if (d < r.length)
      y = r.codePointAt(d);
    else {
      if (y === 47)
        break;
      y = 47;
    }
    if (y === 47) {
      if (!(s === d - 1 || h === 1)) if (s !== d - 1 && h === 2) {
        if (a.length < 2 || i !== 2 || a.codePointAt(a.length - 1) !== 46 || a.codePointAt(a.length - 2) !== 46) {
          if (a.length > 2) {
            if (g = a.lastIndexOf("/"), g !== a.length - 1) {
              g < 0 ? (a = "", i = 0) : (a = a.slice(0, g), i = a.length - 1 - a.lastIndexOf("/")), s = d, h = 0;
              continue;
            }
          } else if (a.length > 0) {
            a = "", i = 0, s = d, h = 0;
            continue;
          }
        }
        t && (a = a.length > 0 ? a + "/.." : "..", i = 2);
      } else
        a.length > 0 ? a += "/" + r.slice(s + 1, d) : a = r.slice(s + 1, d), i = d - s - 1;
      s = d, h = 0;
    } else y === 46 && h > -1 ? h++ : h = -1;
  }
  return a;
}
function a4(r) {
  if (typeof r != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(r)
    );
}
const H_ = { cwd: U_ };
function U_() {
  return "/";
}
function C5(r) {
  return !!(r !== null && typeof r == "object" && "href" in r && r.href && "protocol" in r && r.protocol && // @ts-expect-error: indexing is fine.
  r.auth === void 0);
}
function q_(r) {
  if (typeof r == "string")
    r = new URL(r);
  else if (!C5(r)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + r + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (r.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return j_(r);
}
function j_(r) {
  if (r.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const t = r.pathname;
  let a = -1;
  for (; ++a < t.length; )
    if (t.codePointAt(a) === 37 && t.codePointAt(a + 1) === 50) {
      const i = t.codePointAt(a + 2);
      if (i === 70 || i === 102) {
        const s = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw s.code = "ERR_INVALID_FILE_URL_PATH", s;
      }
    }
  return decodeURIComponent(t);
}
const G6 = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class Lx {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let a;
    t ? C5(t) ? a = { path: t } : typeof t == "string" || G_(t) ? a = { value: t } : a = t : a = {}, this.cwd = "cwd" in a ? "" : H_.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < G6.length; ) {
      const h = G6[i];
      h in a && a[h] !== void 0 && a[h] !== null && (this[h] = h === "history" ? [...a[h]] : a[h]);
    }
    let s;
    for (s in a)
      G6.includes(s) || (this[s] = a[s]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? go.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    Y6(t, "basename"), V6(t, "basename"), this.path = go.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? go.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    h9(this.basename, "dirname"), this.path = go.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? go.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (V6(t, "extname"), h9(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = go.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    C5(t) && (t = q_(t)), Y6(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? go.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    Y6(t, "stem"), V6(t, "stem"), this.path = go.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, a, i) {
    const s = this.message(t, a, i);
    throw s.fatal = !0, s;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, a, i) {
    const s = this.message(t, a, i);
    return s.fatal = void 0, s;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, a, i) {
    const s = new Na(
      // @ts-expect-error: the overloads are fine.
      t,
      a,
      i
    );
    return this.path && (s.name = this.path + ":" + s.name, s.file = this.path), s.fatal = !1, this.messages.push(s), s;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function V6(r, t) {
  if (r && r.includes(go.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + go.sep + "`"
    );
}
function Y6(r, t) {
  if (!r)
    throw new Error("`" + t + "` cannot be empty");
}
function h9(r, t) {
  if (!r)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function G_(r) {
  return !!(r && typeof r == "object" && "byteLength" in r && "byteOffset" in r);
}
const V_ = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(r) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), s = i[r], h = function() {
      return s.apply(h, arguments);
    };
    return Object.setPrototypeOf(h, i), h;
  }
), Y_ = {}.hasOwnProperty;
class E7 extends V_ {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = C_();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new E7()
    );
    let a = -1;
    for (; ++a < this.attachers.length; ) {
      const i = this.attachers[a];
      t.use(...i);
    }
    return t.data(j6(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, a) {
    return typeof t == "string" ? arguments.length === 2 ? (X6("data", this.frozen), this.namespace[t] = a, this) : Y_.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (X6("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [a, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const s = a.call(t, ...i);
      typeof s == "function" && this.transformers.use(s);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const a = sv(t), i = this.parser || this.Parser;
    return I6("parse", i), i(String(a), a);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, a) {
    const i = this;
    return this.freeze(), I6("process", this.parser || this.Parser), $6("process", this.compiler || this.Compiler), a ? s(void 0, a) : new Promise(s);
    function s(h, d) {
      const y = sv(t), g = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(y)
      );
      i.run(g, y, function(x, T, R) {
        if (x || !T || !R)
          return b(x);
        const E = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          T
        ), O = i.stringify(E, R);
        X_(O) ? R.value = O : R.result = O, b(
          x,
          /** @type {VFileWithOutput<CompileResult>} */
          R
        );
      });
      function b(x, T) {
        x || !T ? d(x) : h ? h(T) : a(void 0, T);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let a = !1, i;
    return this.freeze(), I6("processSync", this.parser || this.Parser), $6("processSync", this.compiler || this.Compiler), this.process(t, s), m9("processSync", "process", a), i;
    function s(h, d) {
      a = !0, l9(h), i = d;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, a, i) {
    d9(t), this.freeze();
    const s = this.transformers;
    return !i && typeof a == "function" && (i = a, a = void 0), i ? h(void 0, i) : new Promise(h);
    function h(d, y) {
      const g = sv(a);
      s.run(t, g, b);
      function b(x, T, R) {
        const E = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          T || t
        );
        x ? y(x) : d ? d(E) : i(void 0, E, R);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, a) {
    let i = !1, s;
    return this.run(t, a, h), m9("runSync", "run", i), s;
    function h(d, y) {
      l9(d), s = y, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, a) {
    this.freeze();
    const i = sv(a), s = this.compiler || this.Compiler;
    return $6("stringify", s), d9(t), s(t, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...a) {
    const i = this.attachers, s = this.namespace;
    if (X6("use", this.frozen), t != null) if (typeof t == "function")
      g(t, a);
    else if (typeof t == "object")
      Array.isArray(t) ? y(t) : d(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function h(b) {
      if (typeof b == "function")
        g(b, []);
      else if (typeof b == "object")
        if (Array.isArray(b)) {
          const [x, ...T] = (
            /** @type {PluginTuple<Array<unknown>>} */
            b
          );
          g(x, T);
        } else
          d(b);
      else
        throw new TypeError("Expected usable value, not `" + b + "`");
    }
    function d(b) {
      if (!("plugins" in b) && !("settings" in b))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      y(b.plugins), b.settings && (s.settings = j6(!0, s.settings, b.settings));
    }
    function y(b) {
      let x = -1;
      if (b != null) if (Array.isArray(b))
        for (; ++x < b.length; ) {
          const T = b[x];
          h(T);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + b + "`");
    }
    function g(b, x) {
      let T = -1, R = -1;
      for (; ++T < i.length; )
        if (i[T][0] === b) {
          R = T;
          break;
        }
      if (R === -1)
        i.push([b, ...x]);
      else if (x.length > 0) {
        let [E, ...O] = x;
        const L = i[R][1];
        z5(L) && z5(E) && (E = j6(!0, L, E)), i[R] = [b, E, ...O];
      }
    }
  }
}
const I_ = new E7().freeze();
function I6(r, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + r + "` without `parser`");
}
function $6(r, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + r + "` without `compiler`");
}
function X6(r, t) {
  if (t)
    throw new Error(
      "Cannot call `" + r + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function d9(r) {
  if (!z5(r) || typeof r.type != "string")
    throw new TypeError("Expected node, got `" + r + "`");
}
function m9(r, t, a) {
  if (!a)
    throw new Error(
      "`" + r + "` finished async. Use `" + t + "` instead"
    );
}
function sv(r) {
  return $_(r) ? r : new Lx(r);
}
function $_(r) {
  return !!(r && typeof r == "object" && "message" in r && "messages" in r);
}
function X_(r) {
  return typeof r == "string" || Q_(r);
}
function Q_(r) {
  return !!(r && typeof r == "object" && "byteLength" in r && "byteOffset" in r);
}
const Z_ = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", p9 = [], g9 = { allowDangerousHtml: !0 }, F_ = /^(https?|ircs?|mailto|xmpp)$/i, P_ = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  { from: "className", id: "remove-classname" },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function K_(r) {
  const t = J_(r), a = W_(r);
  return eO(t.runSync(t.parse(a), a), r);
}
function J_(r) {
  const t = r.rehypePlugins || p9, a = r.remarkPlugins || p9, i = r.remarkRehypeOptions ? { ...r.remarkRehypeOptions, ...g9 } : g9;
  return I_().use(NM).use(a).use(R_, i).use(t);
}
function W_(r) {
  const t = r.children || "", a = new Lx();
  return typeof t == "string" && (a.value = t), a;
}
function eO(r, t) {
  const a = t.allowedElements, i = t.allowElement, s = t.components, h = t.disallowedElements, d = t.skipHtml, y = t.unwrapDisallowed, g = t.urlTransform || tO;
  for (const x of P_)
    Object.hasOwn(t, x.from) && ("" + x.from + (x.to ? "use `" + x.to + "` instead" : "remove it") + Z_ + x.id, void 0);
  return T7(r, b), yz(r, {
    Fragment: He.Fragment,
    components: s,
    ignoreInvalidStyle: !0,
    jsx: He.jsx,
    jsxs: He.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function b(x, T, R) {
    if (x.type === "raw" && R && typeof T == "number")
      return d ? R.children.splice(T, 1) : R.children[T] = { type: "text", value: x.value }, T;
    if (x.type === "element") {
      let E;
      for (E in H6)
        if (Object.hasOwn(H6, E) && Object.hasOwn(x.properties, E)) {
          const O = x.properties[E], L = H6[E];
          (L === null || L.includes(x.tagName)) && (x.properties[E] = g(String(O || ""), E, x));
        }
    }
    if (x.type === "element") {
      let E = a ? !a.includes(x.tagName) : h ? h.includes(x.tagName) : !1;
      if (!E && i && typeof T == "number" && (E = !i(x, T, R)), E && R && typeof T == "number")
        return y && x.children ? R.children.splice(T, 1, ...x.children) : R.children.splice(T, 1), T;
    }
  }
}
function tO(r) {
  const t = r.indexOf(":"), a = r.indexOf("?"), i = r.indexOf("#"), s = r.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    s !== -1 && t > s || a !== -1 && t > a || i !== -1 && t > i || // It is a protocol, it should be allowed.
    F_.test(r.slice(0, t)) ? r : ""
  );
}
function y9(r, t) {
  const a = String(r);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let i = 0, s = a.indexOf(t);
  for (; s !== -1; )
    i++, s = a.indexOf(t, s + t.length);
  return i;
}
function nO(r) {
  if (typeof r != "string")
    throw new TypeError("Expected a string");
  return r.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function rO(r, t, a) {
  const s = r4((a || {}).ignore || []), h = aO(t);
  let d = -1;
  for (; ++d < h.length; )
    w7(r, "text", y);
  function y(b, x) {
    let T = -1, R;
    for (; ++T < x.length; ) {
      const E = x[T], O = R ? R.children : void 0;
      if (s(
        E,
        O ? O.indexOf(E) : void 0,
        R
      ))
        return;
      R = E;
    }
    if (R)
      return g(b, x);
  }
  function g(b, x) {
    const T = x[x.length - 1], R = h[d][0], E = h[d][1];
    let O = 0;
    const G = T.children.indexOf(b);
    let V = !1, I = [];
    R.lastIndex = 0;
    let $ = R.exec(b.value);
    for (; $; ) {
      const ce = $.index, se = {
        index: $.index,
        input: $.input,
        stack: [...x, b]
      };
      let te = E(...$, se);
      if (typeof te == "string" && (te = te.length > 0 ? { type: "text", value: te } : void 0), te === !1 ? R.lastIndex = ce + 1 : (O !== ce && I.push({
        type: "text",
        value: b.value.slice(O, ce)
      }), Array.isArray(te) ? I.push(...te) : te && I.push(te), O = ce + $[0].length, V = !0), !R.global)
        break;
      $ = R.exec(b.value);
    }
    return V ? (O < b.value.length && I.push({ type: "text", value: b.value.slice(O) }), T.children.splice(G, 1, ...I)) : I = [b], G + I.length;
  }
}
function aO(r) {
  const t = [];
  if (!Array.isArray(r))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const a = !r[0] || Array.isArray(r[0]) ? r : [r];
  let i = -1;
  for (; ++i < a.length; ) {
    const s = a[i];
    t.push([lO(s[0]), iO(s[1])]);
  }
  return t;
}
function lO(r) {
  return typeof r == "string" ? new RegExp(nO(r), "g") : r;
}
function iO(r) {
  return typeof r == "function" ? r : function() {
    return r;
  };
}
const Q6 = "phrasing", Z6 = ["autolink", "link", "image", "label"];
function uO() {
  return {
    transforms: [mO],
    enter: {
      literalAutolink: sO,
      literalAutolinkEmail: F6,
      literalAutolinkHttp: F6,
      literalAutolinkWww: F6
    },
    exit: {
      literalAutolink: dO,
      literalAutolinkEmail: hO,
      literalAutolinkHttp: cO,
      literalAutolinkWww: fO
    }
  };
}
function oO() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: Q6,
        notInConstruct: Z6
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: Q6,
        notInConstruct: Z6
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: Q6,
        notInConstruct: Z6
      }
    ]
  };
}
function sO(r) {
  this.enter({ type: "link", title: null, url: "", children: [] }, r);
}
function F6(r) {
  this.config.enter.autolinkProtocol.call(this, r);
}
function cO(r) {
  this.config.exit.autolinkProtocol.call(this, r);
}
function fO(r) {
  this.config.exit.data.call(this, r);
  const t = this.stack[this.stack.length - 1];
  t.type, t.url = "http://" + this.sliceSerialize(r);
}
function hO(r) {
  this.config.exit.autolinkEmail.call(this, r);
}
function dO(r) {
  this.exit(r);
}
function mO(r) {
  rO(
    r,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, pO],
      [new RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), gO]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function pO(r, t, a, i, s) {
  let h = "";
  if (!Bx(s) || (/^w/i.test(t) && (a = t + a, t = "", h = "http://"), !yO(a)))
    return !1;
  const d = vO(a + i);
  if (!d[0]) return !1;
  const y = {
    type: "link",
    title: null,
    url: h + t + d[0],
    children: [{ type: "text", value: t + d[0] }]
  };
  return d[1] ? [y, { type: "text", value: d[1] }] : y;
}
function gO(r, t, a, i) {
  return (
    // Not an expected previous character.
    !Bx(i, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(a) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + a,
      children: [{ type: "text", value: t + "@" + a }]
    }
  );
}
function yO(r) {
  const t = r.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function vO(r) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(r);
  if (!t)
    return [r, void 0];
  r = r.slice(0, t.index);
  let a = t[0], i = a.indexOf(")");
  const s = y9(r, "(");
  let h = y9(r, ")");
  for (; i !== -1 && s > h; )
    r += a.slice(0, i + 1), a = a.slice(i + 1), i = a.indexOf(")"), h++;
  return [r, a];
}
function Bx(r, t) {
  const a = r.input.charCodeAt(r.index - 1);
  return (r.index === 0 || Wf(a) || Qv(a)) && // If it’s an email, the previous character should not be a slash.
  (!t || a !== 47);
}
Hx.peek = RO;
function bO() {
  this.buffer();
}
function SO(r) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, r);
}
function xO() {
  this.buffer();
}
function wO(r) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    r
  );
}
function TO(r) {
  const t = this.resume(), a = this.stack[this.stack.length - 1];
  a.type, a.identifier = Au(
    this.sliceSerialize(r)
  ).toLowerCase(), a.label = t;
}
function EO(r) {
  this.exit(r);
}
function AO(r) {
  const t = this.resume(), a = this.stack[this.stack.length - 1];
  a.type, a.identifier = Au(
    this.sliceSerialize(r)
  ).toLowerCase(), a.label = t;
}
function kO(r) {
  this.exit(r);
}
function RO() {
  return "[";
}
function Hx(r, t, a, i) {
  const s = a.createTracker(i);
  let h = s.move("[^");
  const d = a.enter("footnoteReference"), y = a.enter("reference");
  return h += s.move(
    a.safe(a.associationId(r), { after: "]", before: h })
  ), y(), d(), h += s.move("]"), h;
}
function zO() {
  return {
    enter: {
      gfmFootnoteCallString: bO,
      gfmFootnoteCall: SO,
      gfmFootnoteDefinitionLabelString: xO,
      gfmFootnoteDefinition: wO
    },
    exit: {
      gfmFootnoteCallString: TO,
      gfmFootnoteCall: EO,
      gfmFootnoteDefinitionLabelString: AO,
      gfmFootnoteDefinition: kO
    }
  };
}
function CO(r) {
  let t = !1;
  return r && r.firstLineBlank && (t = !0), {
    handlers: { footnoteDefinition: a, footnoteReference: Hx },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function a(i, s, h, d) {
    const y = h.createTracker(d);
    let g = y.move("[^");
    const b = h.enter("footnoteDefinition"), x = h.enter("label");
    return g += y.move(
      h.safe(h.associationId(i), { before: g, after: "]" })
    ), x(), g += y.move("]:"), i.children && i.children.length > 0 && (y.shift(4), g += y.move(
      (t ? `
` : " ") + h.indentLines(
        h.containerFlow(i, y.current()),
        t ? Ux : MO
      )
    )), b(), g;
  }
}
function MO(r, t, a) {
  return t === 0 ? r : Ux(r, t, a);
}
function Ux(r, t, a) {
  return (a ? "" : "    ") + r;
}
const _O = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
qx.peek = BO;
function OO() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: NO },
    exit: { strikethrough: LO }
  };
}
function DO() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: _O
      }
    ],
    handlers: { delete: qx }
  };
}
function NO(r) {
  this.enter({ type: "delete", children: [] }, r);
}
function LO(r) {
  this.exit(r);
}
function qx(r, t, a, i) {
  const s = a.createTracker(i), h = a.enter("strikethrough");
  let d = s.move("~~");
  return d += a.containerPhrasing(r, {
    ...s.current(),
    before: d,
    after: "~"
  }), d += s.move("~~"), h(), d;
}
function BO() {
  return "~";
}
function HO(r) {
  return r.length;
}
function UO(r, t) {
  const a = t || {}, i = (a.align || []).concat(), s = a.stringLength || HO, h = [], d = [], y = [], g = [];
  let b = 0, x = -1;
  for (; ++x < r.length; ) {
    const L = [], G = [];
    let V = -1;
    for (r[x].length > b && (b = r[x].length); ++V < r[x].length; ) {
      const I = qO(r[x][V]);
      if (a.alignDelimiters !== !1) {
        const $ = s(I);
        G[V] = $, (g[V] === void 0 || $ > g[V]) && (g[V] = $);
      }
      L.push(I);
    }
    d[x] = L, y[x] = G;
  }
  let T = -1;
  if (typeof i == "object" && "length" in i)
    for (; ++T < b; )
      h[T] = v9(i[T]);
  else {
    const L = v9(i);
    for (; ++T < b; )
      h[T] = L;
  }
  T = -1;
  const R = [], E = [];
  for (; ++T < b; ) {
    const L = h[T];
    let G = "", V = "";
    L === 99 ? (G = ":", V = ":") : L === 108 ? G = ":" : L === 114 && (V = ":");
    let I = a.alignDelimiters === !1 ? 1 : Math.max(
      1,
      g[T] - G.length - V.length
    );
    const $ = G + "-".repeat(I) + V;
    a.alignDelimiters !== !1 && (I = G.length + I + V.length, I > g[T] && (g[T] = I), E[T] = I), R[T] = $;
  }
  d.splice(1, 0, R), y.splice(1, 0, E), x = -1;
  const O = [];
  for (; ++x < d.length; ) {
    const L = d[x], G = y[x];
    T = -1;
    const V = [];
    for (; ++T < b; ) {
      const I = L[T] || "";
      let $ = "", ce = "";
      if (a.alignDelimiters !== !1) {
        const se = g[T] - (G[T] || 0), te = h[T];
        te === 114 ? $ = " ".repeat(se) : te === 99 ? se % 2 ? ($ = " ".repeat(se / 2 + 0.5), ce = " ".repeat(se / 2 - 0.5)) : ($ = " ".repeat(se / 2), ce = $) : ce = " ".repeat(se);
      }
      a.delimiterStart !== !1 && !T && V.push("|"), a.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(a.alignDelimiters === !1 && I === "") && (a.delimiterStart !== !1 || T) && V.push(" "), a.alignDelimiters !== !1 && V.push($), V.push(I), a.alignDelimiters !== !1 && V.push(ce), a.padding !== !1 && V.push(" "), (a.delimiterEnd !== !1 || T !== b - 1) && V.push("|");
    }
    O.push(
      a.delimiterEnd === !1 ? V.join("").replace(/ +$/, "") : V.join("")
    );
  }
  return O.join(`
`);
}
function qO(r) {
  return r == null ? "" : String(r);
}
function v9(r) {
  const t = typeof r == "string" ? r.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
function jO(r, t, a, i) {
  const s = a.enter("blockquote"), h = a.createTracker(i);
  h.move("> "), h.shift(2);
  const d = a.indentLines(
    a.containerFlow(r, h.current()),
    GO
  );
  return s(), d;
}
function GO(r, t, a) {
  return ">" + (a ? "" : " ") + r;
}
function VO(r, t) {
  return b9(r, t.inConstruct, !0) && !b9(r, t.notInConstruct, !1);
}
function b9(r, t, a) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return a;
  let i = -1;
  for (; ++i < t.length; )
    if (r.includes(t[i]))
      return !0;
  return !1;
}
function S9(r, t, a, i) {
  let s = -1;
  for (; ++s < a.unsafe.length; )
    if (a.unsafe[s].character === `
` && VO(a.stack, a.unsafe[s]))
      return /[ \t]/.test(i.before) ? "" : " ";
  return `\\
`;
}
function jx(r, t) {
  const a = String(r);
  let i = a.indexOf(t), s = i, h = 0, d = 0;
  if (typeof t != "string")
    throw new TypeError("Expected substring");
  for (; i !== -1; )
    i === s ? ++h > d && (d = h) : h = 1, s = i + t.length, i = a.indexOf(t, s);
  return d;
}
function YO(r, t) {
  return !!(t.options.fences === !1 && r.value && // If there’s no info…
  !r.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(r.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(r.value));
}
function IO(r) {
  const t = r.options.fence || "`";
  if (t !== "`" && t !== "~")
    throw new Error(
      "Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return t;
}
function $O(r, t, a, i) {
  const s = IO(a), h = r.value || "", d = s === "`" ? "GraveAccent" : "Tilde";
  if (YO(r, a)) {
    const T = a.enter("codeIndented"), R = a.indentLines(h, XO);
    return T(), R;
  }
  const y = a.createTracker(i), g = s.repeat(Math.max(jx(h, s) + 1, 3)), b = a.enter("codeFenced");
  let x = y.move(g);
  if (r.lang) {
    const T = a.enter(`codeFencedLang${d}`);
    x += y.move(
      a.safe(r.lang, {
        before: x,
        after: " ",
        encode: ["`"],
        ...y.current()
      })
    ), T();
  }
  if (r.lang && r.meta) {
    const T = a.enter(`codeFencedMeta${d}`);
    x += y.move(" "), x += y.move(
      a.safe(r.meta, {
        before: x,
        after: `
`,
        encode: ["`"],
        ...y.current()
      })
    ), T();
  }
  return x += y.move(`
`), h && (x += y.move(h + `
`)), x += y.move(g), b(), x;
}
function XO(r, t, a) {
  return (a ? "" : "    ") + r;
}
function A7(r) {
  const t = r.options.quote || '"';
  if (t !== '"' && t !== "'")
    throw new Error(
      "Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`"
    );
  return t;
}
function QO(r, t, a, i) {
  const s = A7(a), h = s === '"' ? "Quote" : "Apostrophe", d = a.enter("definition");
  let y = a.enter("label");
  const g = a.createTracker(i);
  let b = g.move("[");
  return b += g.move(
    a.safe(a.associationId(r), {
      before: b,
      after: "]",
      ...g.current()
    })
  ), b += g.move("]: "), y(), // If there’s no url, or…
  !r.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(r.url) ? (y = a.enter("destinationLiteral"), b += g.move("<"), b += g.move(
    a.safe(r.url, { before: b, after: ">", ...g.current() })
  ), b += g.move(">")) : (y = a.enter("destinationRaw"), b += g.move(
    a.safe(r.url, {
      before: b,
      after: r.title ? " " : `
`,
      ...g.current()
    })
  )), y(), r.title && (y = a.enter(`title${h}`), b += g.move(" " + s), b += g.move(
    a.safe(r.title, {
      before: b,
      after: s,
      ...g.current()
    })
  ), b += g.move(s), y()), d(), b;
}
function ZO(r) {
  const t = r.options.emphasis || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return t;
}
function Fg(r) {
  return "&#x" + r.toString(16).toUpperCase() + ";";
}
function Dv(r, t, a) {
  const i = km(r), s = km(t);
  return i === void 0 ? s === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    a === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : s === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : i === 1 ? s === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : s === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : s === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : s === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
Gx.peek = FO;
function Gx(r, t, a, i) {
  const s = ZO(a), h = a.enter("emphasis"), d = a.createTracker(i), y = d.move(s);
  let g = d.move(
    a.containerPhrasing(r, {
      after: s,
      before: y,
      ...d.current()
    })
  );
  const b = g.charCodeAt(0), x = Dv(
    i.before.charCodeAt(i.before.length - 1),
    b,
    s
  );
  x.inside && (g = Fg(b) + g.slice(1));
  const T = g.charCodeAt(g.length - 1), R = Dv(i.after.charCodeAt(0), T, s);
  R.inside && (g = g.slice(0, -1) + Fg(T));
  const E = d.move(s);
  return h(), a.attentionEncodeSurroundingInfo = {
    after: R.outside,
    before: x.outside
  }, y + g + E;
}
function FO(r, t, a) {
  return a.options.emphasis || "*";
}
function PO(r, t) {
  let a = !1;
  return T7(r, function(i) {
    if ("value" in i && /\r?\n|\r/.test(i.value) || i.type === "break")
      return a = !0, k5;
  }), !!((!r.depth || r.depth < 3) && p7(r) && (t.options.setext || a));
}
function KO(r, t, a, i) {
  const s = Math.max(Math.min(6, r.depth || 1), 1), h = a.createTracker(i);
  if (PO(r, a)) {
    const x = a.enter("headingSetext"), T = a.enter("phrasing"), R = a.containerPhrasing(r, {
      ...h.current(),
      before: `
`,
      after: `
`
    });
    return T(), x(), R + `
` + (s === 1 ? "=" : "-").repeat(
      // The whole size…
      R.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(R.lastIndexOf("\r"), R.lastIndexOf(`
`)) + 1)
    );
  }
  const d = "#".repeat(s), y = a.enter("headingAtx"), g = a.enter("phrasing");
  h.move(d + " ");
  let b = a.containerPhrasing(r, {
    before: "# ",
    after: `
`,
    ...h.current()
  });
  return /^[\t ]/.test(b) && (b = Fg(b.charCodeAt(0)) + b.slice(1)), b = b ? d + " " + b : d, a.options.closeAtx && (b += " " + d), g(), y(), b;
}
Vx.peek = JO;
function Vx(r) {
  return r.value || "";
}
function JO() {
  return "<";
}
Yx.peek = WO;
function Yx(r, t, a, i) {
  const s = A7(a), h = s === '"' ? "Quote" : "Apostrophe", d = a.enter("image");
  let y = a.enter("label");
  const g = a.createTracker(i);
  let b = g.move("![");
  return b += g.move(
    a.safe(r.alt, { before: b, after: "]", ...g.current() })
  ), b += g.move("]("), y(), // If there’s no url but there is a title…
  !r.url && r.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(r.url) ? (y = a.enter("destinationLiteral"), b += g.move("<"), b += g.move(
    a.safe(r.url, { before: b, after: ">", ...g.current() })
  ), b += g.move(">")) : (y = a.enter("destinationRaw"), b += g.move(
    a.safe(r.url, {
      before: b,
      after: r.title ? " " : ")",
      ...g.current()
    })
  )), y(), r.title && (y = a.enter(`title${h}`), b += g.move(" " + s), b += g.move(
    a.safe(r.title, {
      before: b,
      after: s,
      ...g.current()
    })
  ), b += g.move(s), y()), b += g.move(")"), d(), b;
}
function WO() {
  return "!";
}
Ix.peek = eD;
function Ix(r, t, a, i) {
  const s = r.referenceType, h = a.enter("imageReference");
  let d = a.enter("label");
  const y = a.createTracker(i);
  let g = y.move("![");
  const b = a.safe(r.alt, {
    before: g,
    after: "]",
    ...y.current()
  });
  g += y.move(b + "]["), d();
  const x = a.stack;
  a.stack = [], d = a.enter("reference");
  const T = a.safe(a.associationId(r), {
    before: g,
    after: "]",
    ...y.current()
  });
  return d(), a.stack = x, h(), s === "full" || !b || b !== T ? g += y.move(T + "]") : s === "shortcut" ? g = g.slice(0, -1) : g += y.move("]"), g;
}
function eD() {
  return "!";
}
$x.peek = tD;
function $x(r, t, a) {
  let i = r.value || "", s = "`", h = -1;
  for (; new RegExp("(^|[^`])" + s + "([^`]|$)").test(i); )
    s += "`";
  for (/[^ \r\n]/.test(i) && (/^[ \r\n]/.test(i) && /[ \r\n]$/.test(i) || /^`|`$/.test(i)) && (i = " " + i + " "); ++h < a.unsafe.length; ) {
    const d = a.unsafe[h], y = a.compilePattern(d);
    let g;
    if (d.atBreak)
      for (; g = y.exec(i); ) {
        let b = g.index;
        i.charCodeAt(b) === 10 && i.charCodeAt(b - 1) === 13 && b--, i = i.slice(0, b) + " " + i.slice(g.index + 1);
      }
  }
  return s + i + s;
}
function tD() {
  return "`";
}
function Xx(r, t) {
  const a = p7(r);
  return !!(!t.options.resourceLink && // If there’s a url…
  r.url && // And there’s a no title…
  !r.title && // And the content of `node` is a single text node…
  r.children && r.children.length === 1 && r.children[0].type === "text" && // And if the url is the same as the content…
  (a === r.url || "mailto:" + a === r.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(r.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(r.url));
}
Qx.peek = nD;
function Qx(r, t, a, i) {
  const s = A7(a), h = s === '"' ? "Quote" : "Apostrophe", d = a.createTracker(i);
  let y, g;
  if (Xx(r, a)) {
    const x = a.stack;
    a.stack = [], y = a.enter("autolink");
    let T = d.move("<");
    return T += d.move(
      a.containerPhrasing(r, {
        before: T,
        after: ">",
        ...d.current()
      })
    ), T += d.move(">"), y(), a.stack = x, T;
  }
  y = a.enter("link"), g = a.enter("label");
  let b = d.move("[");
  return b += d.move(
    a.containerPhrasing(r, {
      before: b,
      after: "](",
      ...d.current()
    })
  ), b += d.move("]("), g(), // If there’s no url but there is a title…
  !r.url && r.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(r.url) ? (g = a.enter("destinationLiteral"), b += d.move("<"), b += d.move(
    a.safe(r.url, { before: b, after: ">", ...d.current() })
  ), b += d.move(">")) : (g = a.enter("destinationRaw"), b += d.move(
    a.safe(r.url, {
      before: b,
      after: r.title ? " " : ")",
      ...d.current()
    })
  )), g(), r.title && (g = a.enter(`title${h}`), b += d.move(" " + s), b += d.move(
    a.safe(r.title, {
      before: b,
      after: s,
      ...d.current()
    })
  ), b += d.move(s), g()), b += d.move(")"), y(), b;
}
function nD(r, t, a) {
  return Xx(r, a) ? "<" : "[";
}
Zx.peek = rD;
function Zx(r, t, a, i) {
  const s = r.referenceType, h = a.enter("linkReference");
  let d = a.enter("label");
  const y = a.createTracker(i);
  let g = y.move("[");
  const b = a.containerPhrasing(r, {
    before: g,
    after: "]",
    ...y.current()
  });
  g += y.move(b + "]["), d();
  const x = a.stack;
  a.stack = [], d = a.enter("reference");
  const T = a.safe(a.associationId(r), {
    before: g,
    after: "]",
    ...y.current()
  });
  return d(), a.stack = x, h(), s === "full" || !b || b !== T ? g += y.move(T + "]") : s === "shortcut" ? g = g.slice(0, -1) : g += y.move("]"), g;
}
function rD() {
  return "[";
}
function k7(r) {
  const t = r.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function aD(r) {
  const t = k7(r), a = r.options.bulletOther;
  if (!a)
    return t === "*" ? "-" : "*";
  if (a !== "*" && a !== "+" && a !== "-")
    throw new Error(
      "Cannot serialize items with `" + a + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (a === t)
    throw new Error(
      "Expected `bullet` (`" + t + "`) and `bulletOther` (`" + a + "`) to be different"
    );
  return a;
}
function lD(r) {
  const t = r.options.bulletOrdered || ".";
  if (t !== "." && t !== ")")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return t;
}
function Fx(r) {
  const t = r.options.rule || "*";
  if (t !== "*" && t !== "-" && t !== "_")
    throw new Error(
      "Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return t;
}
function iD(r, t, a, i) {
  const s = a.enter("list"), h = a.bulletCurrent;
  let d = r.ordered ? lD(a) : k7(a);
  const y = r.ordered ? d === "." ? ")" : "." : aD(a);
  let g = t && a.bulletLastUsed ? d === a.bulletLastUsed : !1;
  if (!r.ordered) {
    const x = r.children ? r.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (d === "*" || d === "-") && // Empty first list item:
      x && (!x.children || !x.children[0]) && // Directly in two other list items:
      a.stack[a.stack.length - 1] === "list" && a.stack[a.stack.length - 2] === "listItem" && a.stack[a.stack.length - 3] === "list" && a.stack[a.stack.length - 4] === "listItem" && // That are each the first child.
      a.indexStack[a.indexStack.length - 1] === 0 && a.indexStack[a.indexStack.length - 2] === 0 && a.indexStack[a.indexStack.length - 3] === 0 && (g = !0), Fx(a) === d && x
    ) {
      let T = -1;
      for (; ++T < r.children.length; ) {
        const R = r.children[T];
        if (R && R.type === "listItem" && R.children && R.children[0] && R.children[0].type === "thematicBreak") {
          g = !0;
          break;
        }
      }
    }
  }
  g && (d = y), a.bulletCurrent = d;
  const b = a.containerFlow(r, i);
  return a.bulletLastUsed = d, a.bulletCurrent = h, s(), b;
}
function uD(r) {
  const t = r.options.listItemIndent || "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function oD(r, t, a, i) {
  const s = uD(a);
  let h = a.bulletCurrent || k7(a);
  t && t.type === "list" && t.ordered && (h = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (a.options.incrementListMarker === !1 ? 0 : t.children.indexOf(r)) + h);
  let d = h.length + 1;
  (s === "tab" || s === "mixed" && (t && t.type === "list" && t.spread || r.spread)) && (d = Math.ceil(d / 4) * 4);
  const y = a.createTracker(i);
  y.move(h + " ".repeat(d - h.length)), y.shift(d);
  const g = a.enter("listItem"), b = a.indentLines(
    a.containerFlow(r, y.current()),
    x
  );
  return g(), b;
  function x(T, R, E) {
    return R ? (E ? "" : " ".repeat(d)) + T : (E ? h : h + " ".repeat(d - h.length)) + T;
  }
}
function sD(r, t, a, i) {
  const s = a.enter("paragraph"), h = a.enter("phrasing"), d = a.containerPhrasing(r, i);
  return h(), s(), d;
}
const cD = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  r4([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function fD(r, t, a, i) {
  return (r.children.some(function(d) {
    return cD(d);
  }) ? a.containerPhrasing : a.containerFlow).call(a, r, i);
}
function hD(r) {
  const t = r.options.strong || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`"
    );
  return t;
}
Px.peek = dD;
function Px(r, t, a, i) {
  const s = hD(a), h = a.enter("strong"), d = a.createTracker(i), y = d.move(s + s);
  let g = d.move(
    a.containerPhrasing(r, {
      after: s,
      before: y,
      ...d.current()
    })
  );
  const b = g.charCodeAt(0), x = Dv(
    i.before.charCodeAt(i.before.length - 1),
    b,
    s
  );
  x.inside && (g = Fg(b) + g.slice(1));
  const T = g.charCodeAt(g.length - 1), R = Dv(i.after.charCodeAt(0), T, s);
  R.inside && (g = g.slice(0, -1) + Fg(T));
  const E = d.move(s + s);
  return h(), a.attentionEncodeSurroundingInfo = {
    after: R.outside,
    before: x.outside
  }, y + g + E;
}
function dD(r, t, a) {
  return a.options.strong || "*";
}
function mD(r, t, a, i) {
  return a.safe(r.value, i);
}
function pD(r) {
  const t = r.options.ruleRepetition || 3;
  if (t < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return t;
}
function gD(r, t, a) {
  const i = (Fx(a) + (a.options.ruleSpaces ? " " : "")).repeat(pD(a));
  return a.options.ruleSpaces ? i.slice(0, -1) : i;
}
const Kx = {
  blockquote: jO,
  break: S9,
  code: $O,
  definition: QO,
  emphasis: Gx,
  hardBreak: S9,
  heading: KO,
  html: Vx,
  image: Yx,
  imageReference: Ix,
  inlineCode: $x,
  link: Qx,
  linkReference: Zx,
  list: iD,
  listItem: oD,
  paragraph: sD,
  root: fD,
  strong: Px,
  text: mD,
  thematicBreak: gD
};
function yD() {
  return {
    enter: {
      table: vD,
      tableData: x9,
      tableHeader: x9,
      tableRow: SD
    },
    exit: {
      codeText: xD,
      table: bD,
      tableData: P6,
      tableHeader: P6,
      tableRow: P6
    }
  };
}
function vD(r) {
  const t = r._align;
  this.enter(
    {
      type: "table",
      align: t.map(function(a) {
        return a === "none" ? null : a;
      }),
      children: []
    },
    r
  ), this.data.inTable = !0;
}
function bD(r) {
  this.exit(r), this.data.inTable = void 0;
}
function SD(r) {
  this.enter({ type: "tableRow", children: [] }, r);
}
function P6(r) {
  this.exit(r);
}
function x9(r) {
  this.enter({ type: "tableCell", children: [] }, r);
}
function xD(r) {
  let t = this.resume();
  this.data.inTable && (t = t.replace(/\\([\\|])/g, wD));
  const a = this.stack[this.stack.length - 1];
  a.type, a.value = t, this.exit(r);
}
function wD(r, t) {
  return t === "|" ? t : r;
}
function TD(r) {
  const t = r || {}, a = t.tableCellPadding, i = t.tablePipeAlign, s = t.stringLength, h = a ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: R,
      table: d,
      tableCell: g,
      tableRow: y
    }
  };
  function d(E, O, L, G) {
    return b(x(E, L, G), E.align);
  }
  function y(E, O, L, G) {
    const V = T(E, L, G), I = b([V]);
    return I.slice(0, I.indexOf(`
`));
  }
  function g(E, O, L, G) {
    const V = L.enter("tableCell"), I = L.enter("phrasing"), $ = L.containerPhrasing(E, {
      ...G,
      before: h,
      after: h
    });
    return I(), V(), $;
  }
  function b(E, O) {
    return UO(E, {
      align: O,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: i,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: a,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: s
    });
  }
  function x(E, O, L) {
    const G = E.children;
    let V = -1;
    const I = [], $ = O.enter("table");
    for (; ++V < G.length; )
      I[V] = T(G[V], O, L);
    return $(), I;
  }
  function T(E, O, L) {
    const G = E.children;
    let V = -1;
    const I = [], $ = O.enter("tableRow");
    for (; ++V < G.length; )
      I[V] = g(G[V], E, O, L);
    return $(), I;
  }
  function R(E, O, L) {
    let G = Kx.inlineCode(E, O, L);
    return L.stack.includes("tableCell") && (G = G.replace(/\|/g, "\\$&")), G;
  }
}
function ED() {
  return {
    exit: {
      taskListCheckValueChecked: w9,
      taskListCheckValueUnchecked: w9,
      paragraph: kD
    }
  };
}
function AD() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: RD }
  };
}
function w9(r) {
  const t = this.stack[this.stack.length - 2];
  t.type, t.checked = r.type === "taskListCheckValueChecked";
}
function kD(r) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const a = this.stack[this.stack.length - 1];
    a.type;
    const i = a.children[0];
    if (i && i.type === "text") {
      const s = t.children;
      let h = -1, d;
      for (; ++h < s.length; ) {
        const y = s[h];
        if (y.type === "paragraph") {
          d = y;
          break;
        }
      }
      d === a && (i.value = i.value.slice(1), i.value.length === 0 ? a.children.shift() : a.position && i.position && typeof i.position.start.offset == "number" && (i.position.start.column++, i.position.start.offset++, a.position.start = Object.assign({}, i.position.start)));
    }
  }
  this.exit(r);
}
function RD(r, t, a, i) {
  const s = r.children[0], h = typeof r.checked == "boolean" && s && s.type === "paragraph", d = "[" + (r.checked ? "x" : " ") + "] ", y = a.createTracker(i);
  h && y.move(d);
  let g = Kx.listItem(r, t, a, {
    ...i,
    ...y.current()
  });
  return h && (g = g.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, b)), g;
  function b(x) {
    return x + d;
  }
}
function zD() {
  return [
    uO(),
    zO(),
    OO(),
    yD(),
    ED()
  ];
}
function CD(r) {
  return {
    extensions: [
      oO(),
      CO(r),
      DO(),
      TD(r),
      AD()
    ]
  };
}
const MD = {
  tokenize: BD,
  partial: !0
}, Jx = {
  tokenize: HD,
  partial: !0
}, Wx = {
  tokenize: UD,
  partial: !0
}, ew = {
  tokenize: qD,
  partial: !0
}, _D = {
  tokenize: jD,
  partial: !0
}, tw = {
  name: "wwwAutolink",
  tokenize: ND,
  previous: rw
}, nw = {
  name: "protocolAutolink",
  tokenize: LD,
  previous: aw
}, zs = {
  name: "emailAutolink",
  tokenize: DD,
  previous: lw
}, So = {};
function OD() {
  return {
    text: So
  };
}
let Qf = 48;
for (; Qf < 123; )
  So[Qf] = zs, Qf++, Qf === 58 ? Qf = 65 : Qf === 91 && (Qf = 97);
So[43] = zs;
So[45] = zs;
So[46] = zs;
So[95] = zs;
So[72] = [zs, nw];
So[104] = [zs, nw];
So[87] = [zs, tw];
So[119] = [zs, tw];
function DD(r, t, a) {
  const i = this;
  let s, h;
  return d;
  function d(T) {
    return !M5(T) || !lw.call(i, i.previous) || R7(i.events) ? a(T) : (r.enter("literalAutolink"), r.enter("literalAutolinkEmail"), y(T));
  }
  function y(T) {
    return M5(T) ? (r.consume(T), y) : T === 64 ? (r.consume(T), g) : a(T);
  }
  function g(T) {
    return T === 46 ? r.check(_D, x, b)(T) : T === 45 || T === 95 || Da(T) ? (h = !0, r.consume(T), g) : x(T);
  }
  function b(T) {
    return r.consume(T), s = !0, g;
  }
  function x(T) {
    return h && s && Wa(i.previous) ? (r.exit("literalAutolinkEmail"), r.exit("literalAutolink"), t(T)) : a(T);
  }
}
function ND(r, t, a) {
  const i = this;
  return s;
  function s(d) {
    return d !== 87 && d !== 119 || !rw.call(i, i.previous) || R7(i.events) ? a(d) : (r.enter("literalAutolink"), r.enter("literalAutolinkWww"), r.check(MD, r.attempt(Jx, r.attempt(Wx, h), a), a)(d));
  }
  function h(d) {
    return r.exit("literalAutolinkWww"), r.exit("literalAutolink"), t(d);
  }
}
function LD(r, t, a) {
  const i = this;
  let s = "", h = !1;
  return d;
  function d(T) {
    return (T === 72 || T === 104) && aw.call(i, i.previous) && !R7(i.events) ? (r.enter("literalAutolink"), r.enter("literalAutolinkHttp"), s += String.fromCodePoint(T), r.consume(T), y) : a(T);
  }
  function y(T) {
    if (Wa(T) && s.length < 5)
      return s += String.fromCodePoint(T), r.consume(T), y;
    if (T === 58) {
      const R = s.toLowerCase();
      if (R === "http" || R === "https")
        return r.consume(T), g;
    }
    return a(T);
  }
  function g(T) {
    return T === 47 ? (r.consume(T), h ? b : (h = !0, g)) : a(T);
  }
  function b(T) {
    return T === null || Mv(T) || Mn(T) || Wf(T) || Qv(T) ? a(T) : r.attempt(Jx, r.attempt(Wx, x), a)(T);
  }
  function x(T) {
    return r.exit("literalAutolinkHttp"), r.exit("literalAutolink"), t(T);
  }
}
function BD(r, t, a) {
  let i = 0;
  return s;
  function s(d) {
    return (d === 87 || d === 119) && i < 3 ? (i++, r.consume(d), s) : d === 46 && i === 3 ? (r.consume(d), h) : a(d);
  }
  function h(d) {
    return d === null ? a(d) : t(d);
  }
}
function HD(r, t, a) {
  let i, s, h;
  return d;
  function d(b) {
    return b === 46 || b === 95 ? r.check(ew, g, y)(b) : b === null || Mn(b) || Wf(b) || b !== 45 && Qv(b) ? g(b) : (h = !0, r.consume(b), d);
  }
  function y(b) {
    return b === 95 ? i = !0 : (s = i, i = void 0), r.consume(b), d;
  }
  function g(b) {
    return s || i || !h ? a(b) : t(b);
  }
}
function UD(r, t) {
  let a = 0, i = 0;
  return s;
  function s(d) {
    return d === 40 ? (a++, r.consume(d), s) : d === 41 && i < a ? h(d) : d === 33 || d === 34 || d === 38 || d === 39 || d === 41 || d === 42 || d === 44 || d === 46 || d === 58 || d === 59 || d === 60 || d === 63 || d === 93 || d === 95 || d === 126 ? r.check(ew, t, h)(d) : d === null || Mn(d) || Wf(d) ? t(d) : (r.consume(d), s);
  }
  function h(d) {
    return d === 41 && i++, r.consume(d), s;
  }
}
function qD(r, t, a) {
  return i;
  function i(y) {
    return y === 33 || y === 34 || y === 39 || y === 41 || y === 42 || y === 44 || y === 46 || y === 58 || y === 59 || y === 63 || y === 95 || y === 126 ? (r.consume(y), i) : y === 38 ? (r.consume(y), h) : y === 93 ? (r.consume(y), s) : (
      // `<` is an end.
      y === 60 || // So is whitespace.
      y === null || Mn(y) || Wf(y) ? t(y) : a(y)
    );
  }
  function s(y) {
    return y === null || y === 40 || y === 91 || Mn(y) || Wf(y) ? t(y) : i(y);
  }
  function h(y) {
    return Wa(y) ? d(y) : a(y);
  }
  function d(y) {
    return y === 59 ? (r.consume(y), i) : Wa(y) ? (r.consume(y), d) : a(y);
  }
}
function jD(r, t, a) {
  return i;
  function i(h) {
    return r.consume(h), s;
  }
  function s(h) {
    return Da(h) ? a(h) : t(h);
  }
}
function rw(r) {
  return r === null || r === 40 || r === 42 || r === 95 || r === 91 || r === 93 || r === 126 || Mn(r);
}
function aw(r) {
  return !Wa(r);
}
function lw(r) {
  return !(r === 47 || M5(r));
}
function M5(r) {
  return r === 43 || r === 45 || r === 46 || r === 95 || Da(r);
}
function R7(r) {
  let t = r.length, a = !1;
  for (; t--; ) {
    const i = r[t][1];
    if ((i.type === "labelLink" || i.type === "labelImage") && !i._balanced) {
      a = !0;
      break;
    }
    if (i._gfmAutolinkLiteralWalkedInto) {
      a = !1;
      break;
    }
  }
  return r.length > 0 && !a && (r[r.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), a;
}
const GD = {
  tokenize: FD,
  partial: !0
};
function VD() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: XD,
        continuation: {
          tokenize: QD
        },
        exit: ZD
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: $D
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: YD,
        resolveTo: ID
      }
    }
  };
}
function YD(r, t, a) {
  const i = this;
  let s = i.events.length;
  const h = i.parser.gfmFootnotes || (i.parser.gfmFootnotes = []);
  let d;
  for (; s--; ) {
    const g = i.events[s][1];
    if (g.type === "labelImage") {
      d = g;
      break;
    }
    if (g.type === "gfmFootnoteCall" || g.type === "labelLink" || g.type === "label" || g.type === "image" || g.type === "link")
      break;
  }
  return y;
  function y(g) {
    if (!d || !d._balanced)
      return a(g);
    const b = Au(i.sliceSerialize({
      start: d.end,
      end: i.now()
    }));
    return b.codePointAt(0) !== 94 || !h.includes(b.slice(1)) ? a(g) : (r.enter("gfmFootnoteCallLabelMarker"), r.consume(g), r.exit("gfmFootnoteCallLabelMarker"), t(g));
  }
}
function ID(r, t) {
  let a = r.length;
  for (; a--; )
    if (r[a][1].type === "labelImage" && r[a][0] === "enter") {
      r[a][1];
      break;
    }
  r[a + 1][1].type = "data", r[a + 3][1].type = "gfmFootnoteCallLabelMarker";
  const i = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, r[a + 3][1].start),
    end: Object.assign({}, r[r.length - 1][1].end)
  }, s = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, r[a + 3][1].end),
    end: Object.assign({}, r[a + 3][1].end)
  };
  s.end.column++, s.end.offset++, s.end._bufferIndex++;
  const h = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, s.end),
    end: Object.assign({}, r[r.length - 1][1].start)
  }, d = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, h.start),
    end: Object.assign({}, h.end)
  }, y = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    r[a + 1],
    r[a + 2],
    ["enter", i, t],
    // The `[`
    r[a + 3],
    r[a + 4],
    // The `^`.
    ["enter", s, t],
    ["exit", s, t],
    // Everything in between.
    ["enter", h, t],
    ["enter", d, t],
    ["exit", d, t],
    ["exit", h, t],
    // The ending (`]`, properly parsed and labelled).
    r[r.length - 2],
    r[r.length - 1],
    ["exit", i, t]
  ];
  return r.splice(a, r.length - a + 1, ...y), r;
}
function $D(r, t, a) {
  const i = this, s = i.parser.gfmFootnotes || (i.parser.gfmFootnotes = []);
  let h = 0, d;
  return y;
  function y(T) {
    return r.enter("gfmFootnoteCall"), r.enter("gfmFootnoteCallLabelMarker"), r.consume(T), r.exit("gfmFootnoteCallLabelMarker"), g;
  }
  function g(T) {
    return T !== 94 ? a(T) : (r.enter("gfmFootnoteCallMarker"), r.consume(T), r.exit("gfmFootnoteCallMarker"), r.enter("gfmFootnoteCallString"), r.enter("chunkString").contentType = "string", b);
  }
  function b(T) {
    if (
      // Too long.
      h > 999 || // Closing brace with nothing.
      T === 93 && !d || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      T === null || T === 91 || Mn(T)
    )
      return a(T);
    if (T === 93) {
      r.exit("chunkString");
      const R = r.exit("gfmFootnoteCallString");
      return s.includes(Au(i.sliceSerialize(R))) ? (r.enter("gfmFootnoteCallLabelMarker"), r.consume(T), r.exit("gfmFootnoteCallLabelMarker"), r.exit("gfmFootnoteCall"), t) : a(T);
    }
    return Mn(T) || (d = !0), h++, r.consume(T), T === 92 ? x : b;
  }
  function x(T) {
    return T === 91 || T === 92 || T === 93 ? (r.consume(T), h++, b) : b(T);
  }
}
function XD(r, t, a) {
  const i = this, s = i.parser.gfmFootnotes || (i.parser.gfmFootnotes = []);
  let h, d = 0, y;
  return g;
  function g(O) {
    return r.enter("gfmFootnoteDefinition")._container = !0, r.enter("gfmFootnoteDefinitionLabel"), r.enter("gfmFootnoteDefinitionLabelMarker"), r.consume(O), r.exit("gfmFootnoteDefinitionLabelMarker"), b;
  }
  function b(O) {
    return O === 94 ? (r.enter("gfmFootnoteDefinitionMarker"), r.consume(O), r.exit("gfmFootnoteDefinitionMarker"), r.enter("gfmFootnoteDefinitionLabelString"), r.enter("chunkString").contentType = "string", x) : a(O);
  }
  function x(O) {
    if (
      // Too long.
      d > 999 || // Closing brace with nothing.
      O === 93 && !y || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      O === null || O === 91 || Mn(O)
    )
      return a(O);
    if (O === 93) {
      r.exit("chunkString");
      const L = r.exit("gfmFootnoteDefinitionLabelString");
      return h = Au(i.sliceSerialize(L)), r.enter("gfmFootnoteDefinitionLabelMarker"), r.consume(O), r.exit("gfmFootnoteDefinitionLabelMarker"), r.exit("gfmFootnoteDefinitionLabel"), R;
    }
    return Mn(O) || (y = !0), d++, r.consume(O), O === 92 ? T : x;
  }
  function T(O) {
    return O === 91 || O === 92 || O === 93 ? (r.consume(O), d++, x) : x(O);
  }
  function R(O) {
    return O === 58 ? (r.enter("definitionMarker"), r.consume(O), r.exit("definitionMarker"), s.includes(h) || s.push(h), Ft(r, E, "gfmFootnoteDefinitionWhitespace")) : a(O);
  }
  function E(O) {
    return t(O);
  }
}
function QD(r, t, a) {
  return r.check(n4, t, r.attempt(GD, t, a));
}
function ZD(r) {
  r.exit("gfmFootnoteDefinition");
}
function FD(r, t, a) {
  const i = this;
  return Ft(r, s, "gfmFootnoteDefinitionIndent", 5);
  function s(h) {
    const d = i.events[i.events.length - 1];
    return d && d[1].type === "gfmFootnoteDefinitionIndent" && d[2].sliceSerialize(d[1], !0).length === 4 ? t(h) : a(h);
  }
}
function PD(r) {
  let a = (r || {}).singleTilde;
  const i = {
    name: "strikethrough",
    tokenize: h,
    resolveAll: s
  };
  return a == null && (a = !0), {
    text: {
      126: i
    },
    insideSpan: {
      null: [i]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function s(d, y) {
    let g = -1;
    for (; ++g < d.length; )
      if (d[g][0] === "enter" && d[g][1].type === "strikethroughSequenceTemporary" && d[g][1]._close) {
        let b = g;
        for (; b--; )
          if (d[b][0] === "exit" && d[b][1].type === "strikethroughSequenceTemporary" && d[b][1]._open && // If the sizes are the same:
          d[g][1].end.offset - d[g][1].start.offset === d[b][1].end.offset - d[b][1].start.offset) {
            d[g][1].type = "strikethroughSequence", d[b][1].type = "strikethroughSequence";
            const x = {
              type: "strikethrough",
              start: Object.assign({}, d[b][1].start),
              end: Object.assign({}, d[g][1].end)
            }, T = {
              type: "strikethroughText",
              start: Object.assign({}, d[b][1].end),
              end: Object.assign({}, d[g][1].start)
            }, R = [["enter", x, y], ["enter", d[b][1], y], ["exit", d[b][1], y], ["enter", T, y]], E = y.parser.constructs.insideSpan.null;
            E && ni(R, R.length, 0, Zv(E, d.slice(b + 1, g), y)), ni(R, R.length, 0, [["exit", T, y], ["enter", d[g][1], y], ["exit", d[g][1], y], ["exit", x, y]]), ni(d, b - 1, g - b + 3, R), g = b + R.length - 2;
            break;
          }
      }
    for (g = -1; ++g < d.length; )
      d[g][1].type === "strikethroughSequenceTemporary" && (d[g][1].type = "data");
    return d;
  }
  function h(d, y, g) {
    const b = this.previous, x = this.events;
    let T = 0;
    return R;
    function R(O) {
      return b === 126 && x[x.length - 1][1].type !== "characterEscape" ? g(O) : (d.enter("strikethroughSequenceTemporary"), E(O));
    }
    function E(O) {
      const L = km(b);
      if (O === 126)
        return T > 1 ? g(O) : (d.consume(O), T++, E);
      if (T < 2 && !a) return g(O);
      const G = d.exit("strikethroughSequenceTemporary"), V = km(O);
      return G._open = !V || V === 2 && !!L, G._close = !L || L === 2 && !!V, y(O);
    }
  }
}
class KD {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(t, a, i) {
    JD(this, t, a, i);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(t) {
    if (this.map.sort(function(h, d) {
      return h[0] - d[0];
    }), this.map.length === 0)
      return;
    let a = this.map.length;
    const i = [];
    for (; a > 0; )
      a -= 1, i.push(t.slice(this.map[a][0] + this.map[a][1]), this.map[a][2]), t.length = this.map[a][0];
    i.push(t.slice()), t.length = 0;
    let s = i.pop();
    for (; s; ) {
      for (const h of s)
        t.push(h);
      s = i.pop();
    }
    this.map.length = 0;
  }
}
function JD(r, t, a, i) {
  let s = 0;
  if (!(a === 0 && i.length === 0)) {
    for (; s < r.map.length; ) {
      if (r.map[s][0] === t) {
        r.map[s][1] += a, r.map[s][2].push(...i);
        return;
      }
      s += 1;
    }
    r.map.push([t, a, i]);
  }
}
function WD(r, t) {
  let a = !1;
  const i = [];
  for (; t < r.length; ) {
    const s = r[t];
    if (a) {
      if (s[0] === "enter")
        s[1].type === "tableContent" && i.push(r[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (s[1].type === "tableContent") {
        if (r[t - 1][1].type === "tableDelimiterMarker") {
          const h = i.length - 1;
          i[h] = i[h] === "left" ? "center" : "right";
        }
      } else if (s[1].type === "tableDelimiterRow")
        break;
    } else s[0] === "enter" && s[1].type === "tableDelimiterRow" && (a = !0);
    t += 1;
  }
  return i;
}
function eN() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: tN,
        resolveAll: nN
      }
    }
  };
}
function tN(r, t, a) {
  const i = this;
  let s = 0, h = 0, d;
  return y;
  function y(ee) {
    let De = i.events.length - 1;
    for (; De > -1; ) {
      const Te = i.events[De][1].type;
      if (Te === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      Te === "linePrefix") De--;
      else break;
    }
    const de = De > -1 ? i.events[De][1].type : null, Ye = de === "tableHead" || de === "tableRow" ? te : g;
    return Ye === te && i.parser.lazy[i.now().line] ? a(ee) : Ye(ee);
  }
  function g(ee) {
    return r.enter("tableHead"), r.enter("tableRow"), b(ee);
  }
  function b(ee) {
    return ee === 124 || (d = !0, h += 1), x(ee);
  }
  function x(ee) {
    return ee === null ? a(ee) : ft(ee) ? h > 1 ? (h = 0, i.interrupt = !0, r.exit("tableRow"), r.enter("lineEnding"), r.consume(ee), r.exit("lineEnding"), E) : a(ee) : Jt(ee) ? Ft(r, x, "whitespace")(ee) : (h += 1, d && (d = !1, s += 1), ee === 124 ? (r.enter("tableCellDivider"), r.consume(ee), r.exit("tableCellDivider"), d = !0, x) : (r.enter("data"), T(ee)));
  }
  function T(ee) {
    return ee === null || ee === 124 || Mn(ee) ? (r.exit("data"), x(ee)) : (r.consume(ee), ee === 92 ? R : T);
  }
  function R(ee) {
    return ee === 92 || ee === 124 ? (r.consume(ee), T) : T(ee);
  }
  function E(ee) {
    return i.interrupt = !1, i.parser.lazy[i.now().line] ? a(ee) : (r.enter("tableDelimiterRow"), d = !1, Jt(ee) ? Ft(r, O, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ee) : O(ee));
  }
  function O(ee) {
    return ee === 45 || ee === 58 ? G(ee) : ee === 124 ? (d = !0, r.enter("tableCellDivider"), r.consume(ee), r.exit("tableCellDivider"), L) : se(ee);
  }
  function L(ee) {
    return Jt(ee) ? Ft(r, G, "whitespace")(ee) : G(ee);
  }
  function G(ee) {
    return ee === 58 ? (h += 1, d = !0, r.enter("tableDelimiterMarker"), r.consume(ee), r.exit("tableDelimiterMarker"), V) : ee === 45 ? (h += 1, V(ee)) : ee === null || ft(ee) ? ce(ee) : se(ee);
  }
  function V(ee) {
    return ee === 45 ? (r.enter("tableDelimiterFiller"), I(ee)) : se(ee);
  }
  function I(ee) {
    return ee === 45 ? (r.consume(ee), I) : ee === 58 ? (d = !0, r.exit("tableDelimiterFiller"), r.enter("tableDelimiterMarker"), r.consume(ee), r.exit("tableDelimiterMarker"), $) : (r.exit("tableDelimiterFiller"), $(ee));
  }
  function $(ee) {
    return Jt(ee) ? Ft(r, ce, "whitespace")(ee) : ce(ee);
  }
  function ce(ee) {
    return ee === 124 ? O(ee) : ee === null || ft(ee) ? !d || s !== h ? se(ee) : (r.exit("tableDelimiterRow"), r.exit("tableHead"), t(ee)) : se(ee);
  }
  function se(ee) {
    return a(ee);
  }
  function te(ee) {
    return r.enter("tableRow"), Ce(ee);
  }
  function Ce(ee) {
    return ee === 124 ? (r.enter("tableCellDivider"), r.consume(ee), r.exit("tableCellDivider"), Ce) : ee === null || ft(ee) ? (r.exit("tableRow"), t(ee)) : Jt(ee) ? Ft(r, Ce, "whitespace")(ee) : (r.enter("data"), ve(ee));
  }
  function ve(ee) {
    return ee === null || ee === 124 || Mn(ee) ? (r.exit("data"), Ce(ee)) : (r.consume(ee), ee === 92 ? Ne : ve);
  }
  function Ne(ee) {
    return ee === 92 || ee === 124 ? (r.consume(ee), ve) : ve(ee);
  }
}
function nN(r, t) {
  let a = -1, i = !0, s = 0, h = [0, 0, 0, 0], d = [0, 0, 0, 0], y = !1, g = 0, b, x, T;
  const R = new KD();
  for (; ++a < r.length; ) {
    const E = r[a], O = E[1];
    E[0] === "enter" ? O.type === "tableHead" ? (y = !1, g !== 0 && (T9(R, t, g, b, x), x = void 0, g = 0), b = {
      type: "table",
      start: Object.assign({}, O.start),
      // Note: correct end is set later.
      end: Object.assign({}, O.end)
    }, R.add(a, 0, [["enter", b, t]])) : O.type === "tableRow" || O.type === "tableDelimiterRow" ? (i = !0, T = void 0, h = [0, 0, 0, 0], d = [0, a + 1, 0, 0], y && (y = !1, x = {
      type: "tableBody",
      start: Object.assign({}, O.start),
      // Note: correct end is set later.
      end: Object.assign({}, O.end)
    }, R.add(a, 0, [["enter", x, t]])), s = O.type === "tableDelimiterRow" ? 2 : x ? 3 : 1) : s && (O.type === "data" || O.type === "tableDelimiterMarker" || O.type === "tableDelimiterFiller") ? (i = !1, d[2] === 0 && (h[1] !== 0 && (d[0] = d[1], T = cv(R, t, h, s, void 0, T), h = [0, 0, 0, 0]), d[2] = a)) : O.type === "tableCellDivider" && (i ? i = !1 : (h[1] !== 0 && (d[0] = d[1], T = cv(R, t, h, s, void 0, T)), h = d, d = [h[1], a, 0, 0])) : O.type === "tableHead" ? (y = !0, g = a) : O.type === "tableRow" || O.type === "tableDelimiterRow" ? (g = a, h[1] !== 0 ? (d[0] = d[1], T = cv(R, t, h, s, a, T)) : d[1] !== 0 && (T = cv(R, t, d, s, a, T)), s = 0) : s && (O.type === "data" || O.type === "tableDelimiterMarker" || O.type === "tableDelimiterFiller") && (d[3] = a);
  }
  for (g !== 0 && T9(R, t, g, b, x), R.consume(t.events), a = -1; ++a < t.events.length; ) {
    const E = t.events[a];
    E[0] === "enter" && E[1].type === "table" && (E[1]._align = WD(t.events, a));
  }
  return r;
}
function cv(r, t, a, i, s, h) {
  const d = i === 1 ? "tableHeader" : i === 2 ? "tableDelimiter" : "tableData", y = "tableContent";
  a[0] !== 0 && (h.end = Object.assign({}, Tm(t.events, a[0])), r.add(a[0], 0, [["exit", h, t]]));
  const g = Tm(t.events, a[1]);
  if (h = {
    type: d,
    start: Object.assign({}, g),
    // Note: correct end is set later.
    end: Object.assign({}, g)
  }, r.add(a[1], 0, [["enter", h, t]]), a[2] !== 0) {
    const b = Tm(t.events, a[2]), x = Tm(t.events, a[3]), T = {
      type: y,
      start: Object.assign({}, b),
      end: Object.assign({}, x)
    };
    if (r.add(a[2], 0, [["enter", T, t]]), i !== 2) {
      const R = t.events[a[2]], E = t.events[a[3]];
      if (R[1].end = Object.assign({}, E[1].end), R[1].type = "chunkText", R[1].contentType = "text", a[3] > a[2] + 1) {
        const O = a[2] + 1, L = a[3] - a[2] - 1;
        r.add(O, L, []);
      }
    }
    r.add(a[3] + 1, 0, [["exit", T, t]]);
  }
  return s !== void 0 && (h.end = Object.assign({}, Tm(t.events, s)), r.add(s, 0, [["exit", h, t]]), h = void 0), h;
}
function T9(r, t, a, i, s) {
  const h = [], d = Tm(t.events, a);
  s && (s.end = Object.assign({}, d), h.push(["exit", s, t])), i.end = Object.assign({}, d), h.push(["exit", i, t]), r.add(a + 1, 0, h);
}
function Tm(r, t) {
  const a = r[t], i = a[0] === "enter" ? "start" : "end";
  return a[1][i];
}
const rN = {
  name: "tasklistCheck",
  tokenize: lN
};
function aN() {
  return {
    text: {
      91: rN
    }
  };
}
function lN(r, t, a) {
  const i = this;
  return s;
  function s(g) {
    return (
      // Exit if there’s stuff before.
      i.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !i._gfmTasklistFirstContentOfListItem ? a(g) : (r.enter("taskListCheck"), r.enter("taskListCheckMarker"), r.consume(g), r.exit("taskListCheckMarker"), h)
    );
  }
  function h(g) {
    return Mn(g) ? (r.enter("taskListCheckValueUnchecked"), r.consume(g), r.exit("taskListCheckValueUnchecked"), d) : g === 88 || g === 120 ? (r.enter("taskListCheckValueChecked"), r.consume(g), r.exit("taskListCheckValueChecked"), d) : a(g);
  }
  function d(g) {
    return g === 93 ? (r.enter("taskListCheckMarker"), r.consume(g), r.exit("taskListCheckMarker"), r.exit("taskListCheck"), y) : a(g);
  }
  function y(g) {
    return ft(g) ? t(g) : Jt(g) ? r.check({
      tokenize: iN
    }, t, a)(g) : a(g);
  }
}
function iN(r, t, a) {
  return Ft(r, i, "whitespace");
  function i(s) {
    return s === null ? a(s) : t(s);
  }
}
function uN(r) {
  return mx([
    OD(),
    VD(),
    PD(r),
    eN(),
    aN()
  ]);
}
const oN = {};
function sN(r) {
  const t = (
    /** @type {Processor<Root>} */
    this
  ), a = r || oN, i = t.data(), s = i.micromarkExtensions || (i.micromarkExtensions = []), h = i.fromMarkdownExtensions || (i.fromMarkdownExtensions = []), d = i.toMarkdownExtensions || (i.toMarkdownExtensions = []);
  s.push(uN(a)), h.push(zD()), d.push(CD(a));
}
const E9 = /[#.]/g;
function cN(r, t) {
  const a = r || "", i = {};
  let s = 0, h, d;
  for (; s < a.length; ) {
    E9.lastIndex = s;
    const y = E9.exec(a), g = a.slice(s, y ? y.index : a.length);
    g && (h ? h === "#" ? i.id = g : Array.isArray(i.className) ? i.className.push(g) : i.className = [g] : d = g, s += g.length), y && (h = y[0], s++);
  }
  return {
    type: "element",
    // @ts-expect-error: tag name is parsed.
    tagName: d || t || "div",
    properties: i,
    children: []
  };
}
function iw(r, t, a) {
  const i = a ? mN(a) : void 0;
  function s(h, d, ...y) {
    let g;
    if (h == null) {
      g = { type: "root", children: [] };
      const b = (
        /** @type {Child} */
        d
      );
      y.unshift(b);
    } else {
      g = cN(h, t);
      const b = g.tagName.toLowerCase(), x = i ? i.get(b) : void 0;
      if (g.tagName = x || b, fN(d))
        y.unshift(d);
      else
        for (const [T, R] of Object.entries(d))
          hN(r, g.properties, T, R);
    }
    for (const b of y)
      _5(g.children, b);
    return g.type === "element" && g.tagName === "template" && (g.content = { type: "root", children: g.children }, g.children = []), g;
  }
  return s;
}
function fN(r) {
  if (r === null || typeof r != "object" || Array.isArray(r))
    return !0;
  if (typeof r.type != "string") return !1;
  const t = (
    /** @type {Record<string, unknown>} */
    r
  ), a = Object.keys(r);
  for (const i of a) {
    const s = t[i];
    if (s && typeof s == "object") {
      if (!Array.isArray(s)) return !0;
      const h = (
        /** @type {ReadonlyArray<unknown>} */
        s
      );
      for (const d of h)
        if (typeof d != "number" && typeof d != "string")
          return !0;
    }
  }
  return !!("children" in r && Array.isArray(r.children));
}
function hN(r, t, a, i) {
  const s = lx(r, a);
  let h;
  if (i != null) {
    if (typeof i == "number") {
      if (Number.isNaN(i)) return;
      h = i;
    } else typeof i == "boolean" ? h = i : typeof i == "string" ? s.spaceSeparated ? h = O2(i) : s.commaSeparated ? h = R2(i) : s.commaOrSpaceSeparated ? h = O2(R2(i).join(" ")) : h = A9(s, s.property, i) : Array.isArray(i) ? h = [...i] : h = s.property === "style" ? dN(i) : String(i);
    if (Array.isArray(h)) {
      const d = [];
      for (const y of h)
        d.push(
          /** @type {number | string} */
          A9(s, s.property, y)
        );
      h = d;
    }
    s.property === "className" && Array.isArray(t.className) && (h = t.className.concat(
      /** @type {Array<number | string> | number | string} */
      h
    )), t[s.property] = h;
  }
}
function _5(r, t) {
  if (t != null) if (typeof t == "number" || typeof t == "string")
    r.push({ type: "text", value: String(t) });
  else if (Array.isArray(t))
    for (const a of t)
      _5(r, a);
  else if (typeof t == "object" && "type" in t)
    t.type === "root" ? _5(r, t.children) : r.push(t);
  else
    throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function A9(r, t, a) {
  if (typeof a == "string") {
    if (r.number && a && !Number.isNaN(Number(a)))
      return Number(a);
    if ((r.boolean || r.overloadedBoolean) && (a === "" || Qg(a) === Qg(t)))
      return !0;
  }
  return a;
}
function dN(r) {
  const t = [];
  for (const [a, i] of Object.entries(r))
    t.push([a, i].join(": "));
  return t.join("; ");
}
function mN(r) {
  const t = /* @__PURE__ */ new Map();
  for (const a of r)
    t.set(a.toLowerCase(), a);
  return t;
}
const pN = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], gN = iw(ix, "div"), yN = iw($v, "g", pN), K6 = {
  html: "http://www.w3.org/1999/xhtml",
  svg: "http://www.w3.org/2000/svg"
};
function vN(r, t) {
  return uw(r, {}) || { type: "root", children: [] };
}
function uw(r, t) {
  const a = bN(r, t);
  return a && t.afterTransform && t.afterTransform(r, a), a;
}
function bN(r, t) {
  switch (r.nodeType) {
    case 1:
      return TN(
        /** @type {Element} */
        r,
        t
      );
    case 3:
      return xN(
        /** @type {Text} */
        r
      );
    case 8:
      return wN(
        /** @type {Comment} */
        r
      );
    case 9:
      return k9(
        /** @type {Document} */
        r,
        t
      );
    case 10:
      return SN();
    case 11:
      return k9(
        /** @type {DocumentFragment} */
        r,
        t
      );
    default:
      return;
  }
}
function k9(r, t) {
  return { type: "root", children: ow(r, t) };
}
function SN() {
  return { type: "doctype" };
}
function xN(r) {
  return { type: "text", value: r.nodeValue || "" };
}
function wN(r) {
  return { type: "comment", value: r.nodeValue || "" };
}
function TN(r, t) {
  const a = r.namespaceURI, i = a === K6.svg ? yN : gN, s = a === K6.html ? r.tagName.toLowerCase() : r.tagName, h = (
    // @ts-expect-error: DOM types are wrong, content can exist.
    a === K6.html && s === "template" ? r.content : r
  ), d = r.getAttributeNames(), y = {};
  let g = -1;
  for (; ++g < d.length; )
    y[d[g]] = r.getAttribute(d[g]) || "";
  return i(s, y, ow(h, t));
}
function ow(r, t) {
  const a = r.childNodes, i = [];
  let s = -1;
  for (; ++s < a.length; ) {
    const h = uw(a[s], t);
    h !== void 0 && i.push(h);
  }
  return i;
}
new DOMParser();
function EN(r, t) {
  const a = AN(r);
  return (
    /** @type {Root} */
    vN(a)
  );
}
function AN(r) {
  const t = document.createElement("template");
  return t.innerHTML = r, t.content;
}
const R9 = (
  // Note: overloads like this are needed to support optional generics.
  /**
   * @type {(
   *   (<Kind extends UnistParent, Check extends Test>(parent: Kind, index: Child<Kind> | number, test: Check) => Matches<Child<Kind>, Check> | undefined) &
   *   (<Kind extends UnistParent>(parent: Kind, index: Child<Kind> | number, test?: null | undefined) => Child<Kind> | undefined)
   * )}
   */
  /**
   * @param {UnistParent} parent
   * @param {UnistNode | number} index
   * @param {Test} [test]
   * @returns {UnistNode | undefined}
   */
  function(r, t, a) {
    const i = r4(a);
    if (!r || !r.type || !r.children)
      throw new Error("Expected parent node");
    if (typeof t == "number") {
      if (t < 0 || t === Number.POSITIVE_INFINITY)
        throw new Error("Expected positive finite number as index");
    } else if (t = r.children.indexOf(t), t < 0)
      throw new Error("Expected child node or index");
    for (; ++t < r.children.length; )
      if (i(r.children[t], t, r))
        return r.children[t];
  }
), nh = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends TestFunction>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & Predicate<Condition, Element>) &
   *   (<Condition extends string>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & {tagName: Condition}) &
   *   ((test?: null | undefined) => (element?: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test | null | undefined} [test]
   * @returns {Check}
   */
  function(r) {
    if (r == null)
      return zN;
    if (typeof r == "string")
      return RN(r);
    if (typeof r == "object")
      return kN(r);
    if (typeof r == "function")
      return z7(r);
    throw new Error("Expected function, string, or array as `test`");
  }
);
function kN(r) {
  const t = [];
  let a = -1;
  for (; ++a < r.length; )
    t[a] = nh(r[a]);
  return z7(i);
  function i(...s) {
    let h = -1;
    for (; ++h < t.length; )
      if (t[h].apply(this, s)) return !0;
    return !1;
  }
}
function RN(r) {
  return z7(t);
  function t(a) {
    return a.tagName === r;
  }
}
function z7(r) {
  return t;
  function t(a, i, s) {
    return !!(CN(a) && r.call(
      this,
      a,
      typeof i == "number" ? i : void 0,
      s || void 0
    ));
  }
}
function zN(r) {
  return !!(r && typeof r == "object" && "type" in r && r.type === "element" && "tagName" in r && typeof r.tagName == "string");
}
function CN(r) {
  return r !== null && typeof r == "object" && "type" in r && "tagName" in r;
}
const z9 = /\n/g, C9 = /[\t ]+/g, O5 = nh("br"), M9 = nh(HN), MN = nh("p"), _9 = nh("tr"), _N = nh([
  // List from: <https://html.spec.whatwg.org/multipage/rendering.html#hidden-elements>
  "datalist",
  "head",
  "noembed",
  "noframes",
  "noscript",
  // Act as if we support scripting.
  "rp",
  "script",
  "style",
  "template",
  "title",
  // Hidden attribute.
  BN,
  // From: <https://html.spec.whatwg.org/multipage/rendering.html#flow-content-3>
  UN
]), sw = nh([
  "address",
  // Flow content
  "article",
  // Sections and headings
  "aside",
  // Sections and headings
  "blockquote",
  // Flow content
  "body",
  // Page
  "caption",
  // `table-caption`
  "center",
  // Flow content (legacy)
  "dd",
  // Lists
  "dialog",
  // Flow content
  "dir",
  // Lists (legacy)
  "dl",
  // Lists
  "dt",
  // Lists
  "div",
  // Flow content
  "figure",
  // Flow content
  "figcaption",
  // Flow content
  "footer",
  // Flow content
  "form,",
  // Flow content
  "h1",
  // Sections and headings
  "h2",
  // Sections and headings
  "h3",
  // Sections and headings
  "h4",
  // Sections and headings
  "h5",
  // Sections and headings
  "h6",
  // Sections and headings
  "header",
  // Flow content
  "hgroup",
  // Sections and headings
  "hr",
  // Flow content
  "html",
  // Page
  "legend",
  // Flow content
  "li",
  // Lists (as `display: list-item`)
  "listing",
  // Flow content (legacy)
  "main",
  // Flow content
  "menu",
  // Lists
  "nav",
  // Sections and headings
  "ol",
  // Lists
  "p",
  // Flow content
  "plaintext",
  // Flow content (legacy)
  "pre",
  // Flow content
  "section",
  // Sections and headings
  "ul",
  // Lists
  "xmp"
  // Flow content (legacy)
]);
function ON(r, t) {
  const a = t || {}, i = "children" in r ? r.children : [], s = sw(r), h = hw(r, {
    whitespace: a.whitespace || "normal"
  }), d = [];
  (r.type === "text" || r.type === "comment") && d.push(
    ...fw(r, {
      breakBefore: !0,
      breakAfter: !0
    })
  );
  let y = -1;
  for (; ++y < i.length; )
    d.push(
      ...cw(
        i[y],
        // @ts-expect-error: `tree` is a parent if we’re here.
        r,
        {
          whitespace: h,
          breakBefore: y ? void 0 : s,
          breakAfter: y < i.length - 1 ? O5(i[y + 1]) : s
        }
      )
    );
  const g = [];
  let b;
  for (y = -1; ++y < d.length; ) {
    const x = d[y];
    typeof x == "number" ? b !== void 0 && x > b && (b = x) : x && (b !== void 0 && b > -1 && g.push(`
`.repeat(b) || " "), b = -1, g.push(x));
  }
  return g.join("");
}
function cw(r, t, a) {
  return r.type === "element" ? DN(r, t, a) : r.type === "text" ? a.whitespace === "normal" ? fw(r, a) : NN(r) : [];
}
function DN(r, t, a) {
  const i = hw(r, a), s = r.children || [];
  let h = -1, d = [];
  if (_N(r))
    return d;
  let y, g;
  for (O5(r) || _9(r) && // @ts-expect-error: something up with types of parents.
  R9(t, r, _9) ? g = `
` : MN(r) ? (y = 2, g = 2) : sw(r) && (y = 1, g = 1); ++h < s.length; )
    d = d.concat(
      cw(s[h], r, {
        whitespace: i,
        breakBefore: h ? void 0 : y,
        breakAfter: h < s.length - 1 ? O5(s[h + 1]) : g
      })
    );
  return M9(r) && // @ts-expect-error: something up with types of parents.
  R9(t, r, M9) && d.push("	"), y && d.unshift(y), g && d.push(g), d;
}
function fw(r, t) {
  const a = String(r.value), i = [], s = [];
  let h = 0;
  for (; h <= a.length; ) {
    z9.lastIndex = h;
    const g = z9.exec(a), b = g && "index" in g ? g.index : a.length;
    i.push(
      // Any sequence of collapsible spaces and tabs immediately preceding or
      // following a segment break is removed.
      LN(
        // […] ignoring bidi formatting characters (characters with the
        // Bidi_Control property [UAX9]: ALM, LTR, RTL, LRE-RLO, LRI-PDI) as if
        // they were not there.
        a.slice(h, b).replace(/[\u061C\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, ""),
        h === 0 ? t.breakBefore : !0,
        b === a.length ? t.breakAfter : !0
      )
    ), h = b + 1;
  }
  let d = -1, y;
  for (; ++d < i.length; )
    i[d].charCodeAt(i[d].length - 1) === 8203 || d < i.length - 1 && i[d + 1].charCodeAt(0) === 8203 ? (s.push(i[d]), y = void 0) : i[d] ? (typeof y == "number" && s.push(y), s.push(i[d]), y = 0) : (d === 0 || d === i.length - 1) && s.push(0);
  return s;
}
function NN(r) {
  return [String(r.value)];
}
function LN(r, t, a) {
  const i = [];
  let s = 0, h;
  for (; s < r.length; ) {
    C9.lastIndex = s;
    const d = C9.exec(r);
    h = d ? d.index : r.length, !s && !h && d && !t && i.push(""), s !== h && i.push(r.slice(s, h)), s = d ? h + d[0].length : h;
  }
  return s !== h && !a && i.push(""), i.join(" ");
}
function hw(r, t) {
  if (r.type === "element") {
    const a = r.properties || {};
    switch (r.tagName) {
      case "listing":
      case "plaintext":
      case "xmp":
        return "pre";
      case "nobr":
        return "nowrap";
      case "pre":
        return a.wrap ? "pre-wrap" : "pre";
      case "td":
      case "th":
        return a.noWrap ? "nowrap" : t.whitespace;
      case "textarea":
        return "pre-wrap";
    }
  }
  return t.whitespace;
}
function BN(r) {
  return !!(r.properties || {}).hidden;
}
function HN(r) {
  return r.tagName === "td" || r.tagName === "th";
}
function UN(r) {
  return r.tagName === "dialog" && !(r.properties || {}).open;
}
class ei {
  // The + prefix indicates that these fields aren't writeable
  // Lexer holding the input string.
  // Start offset, zero-based inclusive.
  // End offset, zero-based exclusive.
  constructor(t, a, i) {
    this.lexer = void 0, this.start = void 0, this.end = void 0, this.lexer = t, this.start = a, this.end = i;
  }
  /**
   * Merges two `SourceLocation`s from location providers, given they are
   * provided in order of appearance.
   * - Returns the first one's location if only the first is provided.
   * - Returns a merged range of the first and the last if both are provided
   *   and their lexers match.
   * - Otherwise, returns null.
   */
  static range(t, a) {
    return a ? !t || !t.loc || !a.loc || t.loc.lexer !== a.loc.lexer ? null : new ei(t.loc.lexer, t.loc.start, a.loc.end) : t && t.loc;
  }
}
class Li {
  // don't expand the token
  // used in \noexpand
  constructor(t, a) {
    this.text = void 0, this.loc = void 0, this.noexpand = void 0, this.treatAsRelax = void 0, this.text = t, this.loc = a;
  }
  /**
   * Given a pair of tokens (this and endToken), compute a `Token` encompassing
   * the whole input range enclosed by these two.
   */
  range(t, a) {
    return new Li(a, ei.range(this, t));
  }
}
class $e {
  // Error start position based on passed-in Token or ParseNode.
  // Length of affected text based on passed-in Token or ParseNode.
  // The underlying error message without any context added.
  constructor(t, a) {
    this.name = void 0, this.position = void 0, this.length = void 0, this.rawMessage = void 0;
    var i = "KaTeX parse error: " + t, s, h, d = a && a.loc;
    if (d && d.start <= d.end) {
      var y = d.lexer.input;
      s = d.start, h = d.end, s === y.length ? i += " at end of input: " : i += " at position " + (s + 1) + ": ";
      var g = y.slice(s, h).replace(/[^]/g, "$&̲"), b;
      s > 15 ? b = "…" + y.slice(s - 15, s) : b = y.slice(0, s);
      var x;
      h + 15 < y.length ? x = y.slice(h, h + 15) + "…" : x = y.slice(h), i += b + g + x;
    }
    var T = new Error(i);
    return T.name = "ParseError", T.__proto__ = $e.prototype, T.position = s, s != null && h != null && (T.length = h - s), T.rawMessage = t, T;
  }
}
$e.prototype.__proto__ = Error.prototype;
var qN = function(t, a) {
  return t.indexOf(a) !== -1;
}, jN = function(t, a) {
  return t === void 0 ? a : t;
}, GN = /([A-Z])/g, VN = function(t) {
  return t.replace(GN, "-$1").toLowerCase();
}, YN = {
  "&": "&amp;",
  ">": "&gt;",
  "<": "&lt;",
  '"': "&quot;",
  "'": "&#x27;"
}, IN = /[&><"']/g;
function $N(r) {
  return String(r).replace(IN, (t) => YN[t]);
}
var dw = function r(t) {
  return t.type === "ordgroup" || t.type === "color" ? t.body.length === 1 ? r(t.body[0]) : t : t.type === "font" ? r(t.body) : t;
}, XN = function(t) {
  var a = dw(t);
  return a.type === "mathord" || a.type === "textord" || a.type === "atom";
}, QN = function(t) {
  if (!t)
    throw new Error("Expected non-null, but got " + String(t));
  return t;
}, ZN = function(t) {
  var a = /^[\x00-\x20]*([^\\/#?]*?)(:|&#0*58|&#x0*3a|&colon)/i.exec(t);
  return a ? a[2] !== ":" || !/^[a-zA-Z][a-zA-Z0-9+\-.]*$/.test(a[1]) ? null : a[1].toLowerCase() : "_relative";
}, dt = {
  contains: qN,
  deflt: jN,
  escape: $N,
  hyphenate: VN,
  getBaseElem: dw,
  isCharacterBox: XN,
  protocolFromUrl: ZN
}, kv = {
  displayMode: {
    type: "boolean",
    description: "Render math in display mode, which puts the math in display style (so \\int and \\sum are large, for example), and centers the math on the page on its own line.",
    cli: "-d, --display-mode"
  },
  output: {
    type: {
      enum: ["htmlAndMathml", "html", "mathml"]
    },
    description: "Determines the markup language of the output.",
    cli: "-F, --format <type>"
  },
  leqno: {
    type: "boolean",
    description: "Render display math in leqno style (left-justified tags)."
  },
  fleqn: {
    type: "boolean",
    description: "Render display math flush left."
  },
  throwOnError: {
    type: "boolean",
    default: !0,
    cli: "-t, --no-throw-on-error",
    cliDescription: "Render errors (in the color given by --error-color) instead of throwing a ParseError exception when encountering an error."
  },
  errorColor: {
    type: "string",
    default: "#cc0000",
    cli: "-c, --error-color <color>",
    cliDescription: "A color string given in the format 'rgb' or 'rrggbb' (no #). This option determines the color of errors rendered by the -t option.",
    cliProcessor: (r) => "#" + r
  },
  macros: {
    type: "object",
    cli: "-m, --macro <def>",
    cliDescription: "Define custom macro of the form '\\foo:expansion' (use multiple -m arguments for multiple macros).",
    cliDefault: [],
    cliProcessor: (r, t) => (t.push(r), t)
  },
  minRuleThickness: {
    type: "number",
    description: "Specifies a minimum thickness, in ems, for fraction lines, `\\sqrt` top lines, `{array}` vertical lines, `\\hline`, `\\hdashline`, `\\underline`, `\\overline`, and the borders of `\\fbox`, `\\boxed`, and `\\fcolorbox`.",
    processor: (r) => Math.max(0, r),
    cli: "--min-rule-thickness <size>",
    cliProcessor: parseFloat
  },
  colorIsTextColor: {
    type: "boolean",
    description: "Makes \\color behave like LaTeX's 2-argument \\textcolor, instead of LaTeX's one-argument \\color mode change.",
    cli: "-b, --color-is-text-color"
  },
  strict: {
    type: [{
      enum: ["warn", "ignore", "error"]
    }, "boolean", "function"],
    description: "Turn on strict / LaTeX faithfulness mode, which throws an error if the input uses features that are not supported by LaTeX.",
    cli: "-S, --strict",
    cliDefault: !1
  },
  trust: {
    type: ["boolean", "function"],
    description: "Trust the input, enabling all HTML features such as \\url.",
    cli: "-T, --trust"
  },
  maxSize: {
    type: "number",
    default: 1 / 0,
    description: "If non-zero, all user-specified sizes, e.g. in \\rule{500em}{500em}, will be capped to maxSize ems. Otherwise, elements and spaces can be arbitrarily large",
    processor: (r) => Math.max(0, r),
    cli: "-s, --max-size <n>",
    cliProcessor: parseInt
  },
  maxExpand: {
    type: "number",
    default: 1e3,
    description: "Limit the number of macro expansions to the specified number, to prevent e.g. infinite macro loops. If set to Infinity, the macro expander will try to fully expand as in LaTeX.",
    processor: (r) => Math.max(0, r),
    cli: "-e, --max-expand <n>",
    cliProcessor: (r) => r === "Infinity" ? 1 / 0 : parseInt(r)
  },
  globalGroup: {
    type: "boolean",
    cli: !1
  }
};
function FN(r) {
  if (r.default)
    return r.default;
  var t = r.type, a = Array.isArray(t) ? t[0] : t;
  if (typeof a != "string")
    return a.enum[0];
  switch (a) {
    case "boolean":
      return !1;
    case "string":
      return "";
    case "number":
      return 0;
    case "object":
      return {};
  }
}
class C7 {
  constructor(t) {
    this.displayMode = void 0, this.output = void 0, this.leqno = void 0, this.fleqn = void 0, this.throwOnError = void 0, this.errorColor = void 0, this.macros = void 0, this.minRuleThickness = void 0, this.colorIsTextColor = void 0, this.strict = void 0, this.trust = void 0, this.maxSize = void 0, this.maxExpand = void 0, this.globalGroup = void 0, t = t || {};
    for (var a in kv)
      if (kv.hasOwnProperty(a)) {
        var i = kv[a];
        this[a] = t[a] !== void 0 ? i.processor ? i.processor(t[a]) : t[a] : FN(i);
      }
  }
  /**
   * Report nonstrict (non-LaTeX-compatible) input.
   * Can safely not be called if `this.strict` is false in JavaScript.
   */
  reportNonstrict(t, a, i) {
    var s = this.strict;
    if (typeof s == "function" && (s = s(t, a, i)), !(!s || s === "ignore")) {
      if (s === !0 || s === "error")
        throw new $e("LaTeX-incompatible input and strict mode is set to 'error': " + (a + " [" + t + "]"), i);
      s === "warn" ? typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (a + " [" + t + "]")) : typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + s + "': " + a + " [" + t + "]"));
    }
  }
  /**
   * Check whether to apply strict (LaTeX-adhering) behavior for unusual
   * input (like `\\`).  Unlike `nonstrict`, will not throw an error;
   * instead, "error" translates to a return value of `true`, while "ignore"
   * translates to a return value of `false`.  May still print a warning:
   * "warn" prints a warning and returns `false`.
   * This is for the second category of `errorCode`s listed in the README.
   */
  useStrictBehavior(t, a, i) {
    var s = this.strict;
    if (typeof s == "function")
      try {
        s = s(t, a, i);
      } catch {
        s = "error";
      }
    return !s || s === "ignore" ? !1 : s === !0 || s === "error" ? !0 : s === "warn" ? (typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (a + " [" + t + "]")), !1) : (typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + s + "': " + a + " [" + t + "]")), !1);
  }
  /**
   * Check whether to test potentially dangerous input, and return
   * `true` (trusted) or `false` (untrusted).  The sole argument `context`
   * should be an object with `command` field specifying the relevant LaTeX
   * command (as a string starting with `\`), and any other arguments, etc.
   * If `context` has a `url` field, a `protocol` field will automatically
   * get added by this function (changing the specified object).
   */
  isTrusted(t) {
    if (t.url && !t.protocol) {
      var a = dt.protocolFromUrl(t.url);
      if (a == null)
        return !1;
      t.protocol = a;
    }
    var i = typeof this.trust == "function" ? this.trust(t) : this.trust;
    return !!i;
  }
}
class e0 {
  constructor(t, a, i) {
    this.id = void 0, this.size = void 0, this.cramped = void 0, this.id = t, this.size = a, this.cramped = i;
  }
  /**
   * Get the style of a superscript given a base in the current style.
   */
  sup() {
    return yo[PN[this.id]];
  }
  /**
   * Get the style of a subscript given a base in the current style.
   */
  sub() {
    return yo[KN[this.id]];
  }
  /**
   * Get the style of a fraction numerator given the fraction in the current
   * style.
   */
  fracNum() {
    return yo[JN[this.id]];
  }
  /**
   * Get the style of a fraction denominator given the fraction in the current
   * style.
   */
  fracDen() {
    return yo[WN[this.id]];
  }
  /**
   * Get the cramped version of a style (in particular, cramping a cramped style
   * doesn't change the style).
   */
  cramp() {
    return yo[eL[this.id]];
  }
  /**
   * Get a text or display version of this style.
   */
  text() {
    return yo[tL[this.id]];
  }
  /**
   * Return true if this style is tightly spaced (scriptstyle/scriptscriptstyle)
   */
  isTight() {
    return this.size >= 2;
  }
}
var M7 = 0, Nv = 1, Am = 2, Ts = 3, Pg = 4, Ni = 5, Rm = 6, el = 7, yo = [new e0(M7, 0, !1), new e0(Nv, 0, !0), new e0(Am, 1, !1), new e0(Ts, 1, !0), new e0(Pg, 2, !1), new e0(Ni, 2, !0), new e0(Rm, 3, !1), new e0(el, 3, !0)], PN = [Pg, Ni, Pg, Ni, Rm, el, Rm, el], KN = [Ni, Ni, Ni, Ni, el, el, el, el], JN = [Am, Ts, Pg, Ni, Rm, el, Rm, el], WN = [Ts, Ts, Ni, Ni, el, el, el, el], eL = [Nv, Nv, Ts, Ts, Ni, Ni, el, el], tL = [M7, Nv, Am, Ts, Am, Ts, Am, Ts], yt = {
  DISPLAY: yo[M7],
  TEXT: yo[Am],
  SCRIPT: yo[Pg],
  SCRIPTSCRIPT: yo[Rm]
}, D5 = [{
  // Latin characters beyond the Latin-1 characters we have metrics for.
  // Needed for Czech, Hungarian and Turkish text, for example.
  name: "latin",
  blocks: [
    [256, 591],
    // Latin Extended-A and Latin Extended-B
    [768, 879]
    // Combining Diacritical marks
  ]
}, {
  // The Cyrillic script used by Russian and related languages.
  // A Cyrillic subset used to be supported as explicitly defined
  // symbols in symbols.js
  name: "cyrillic",
  blocks: [[1024, 1279]]
}, {
  // Armenian
  name: "armenian",
  blocks: [[1328, 1423]]
}, {
  // The Brahmic scripts of South and Southeast Asia
  // Devanagari (0900–097F)
  // Bengali (0980–09FF)
  // Gurmukhi (0A00–0A7F)
  // Gujarati (0A80–0AFF)
  // Oriya (0B00–0B7F)
  // Tamil (0B80–0BFF)
  // Telugu (0C00–0C7F)
  // Kannada (0C80–0CFF)
  // Malayalam (0D00–0D7F)
  // Sinhala (0D80–0DFF)
  // Thai (0E00–0E7F)
  // Lao (0E80–0EFF)
  // Tibetan (0F00–0FFF)
  // Myanmar (1000–109F)
  name: "brahmic",
  blocks: [[2304, 4255]]
}, {
  name: "georgian",
  blocks: [[4256, 4351]]
}, {
  // Chinese and Japanese.
  // The "k" in cjk is for Korean, but we've separated Korean out
  name: "cjk",
  blocks: [
    [12288, 12543],
    // CJK symbols and punctuation, Hiragana, Katakana
    [19968, 40879],
    // CJK ideograms
    [65280, 65376]
    // Fullwidth punctuation
    // TODO: add halfwidth Katakana and Romanji glyphs
  ]
}, {
  // Korean
  name: "hangul",
  blocks: [[44032, 55215]]
}];
function nL(r) {
  for (var t = 0; t < D5.length; t++)
    for (var a = D5[t], i = 0; i < a.blocks.length; i++) {
      var s = a.blocks[i];
      if (r >= s[0] && r <= s[1])
        return a.name;
    }
  return null;
}
var Rv = [];
D5.forEach((r) => r.blocks.forEach((t) => Rv.push(...t)));
function mw(r) {
  for (var t = 0; t < Rv.length; t += 2)
    if (r >= Rv[t] && r <= Rv[t + 1])
      return !0;
  return !1;
}
var xm = 80, rL = function(t, a) {
  return "M95," + (622 + t + a) + `
c-2.7,0,-7.17,-2.7,-13.5,-8c-5.8,-5.3,-9.5,-10,-9.5,-14
c0,-2,0.3,-3.3,1,-4c1.3,-2.7,23.83,-20.7,67.5,-54
c44.2,-33.3,65.8,-50.3,66.5,-51c1.3,-1.3,3,-2,5,-2c4.7,0,8.7,3.3,12,10
s173,378,173,378c0.7,0,35.3,-71,104,-213c68.7,-142,137.5,-285,206.5,-429
c69,-144,104.5,-217.7,106.5,-221
l` + t / 2.075 + " -" + t + `
c5.3,-9.3,12,-14,20,-14
H400000v` + (40 + t) + `H845.2724
s-225.272,467,-225.272,467s-235,486,-235,486c-2.7,4.7,-9,7,-19,7
c-6,0,-10,-1,-12,-3s-194,-422,-194,-422s-65,47,-65,47z
M` + (834 + t) + " " + a + "h400000v" + (40 + t) + "h-400000z";
}, aL = function(t, a) {
  return "M263," + (601 + t + a) + `c0.7,0,18,39.7,52,119
c34,79.3,68.167,158.7,102.5,238c34.3,79.3,51.8,119.3,52.5,120
c340,-704.7,510.7,-1060.3,512,-1067
l` + t / 2.084 + " -" + t + `
c4.7,-7.3,11,-11,19,-11
H40000v` + (40 + t) + `H1012.3
s-271.3,567,-271.3,567c-38.7,80.7,-84,175,-136,283c-52,108,-89.167,185.3,-111.5,232
c-22.3,46.7,-33.8,70.3,-34.5,71c-4.7,4.7,-12.3,7,-23,7s-12,-1,-12,-1
s-109,-253,-109,-253c-72.7,-168,-109.3,-252,-110,-252c-10.7,8,-22,16.7,-34,26
c-22,17.3,-33.3,26,-34,26s-26,-26,-26,-26s76,-59,76,-59s76,-60,76,-60z
M` + (1001 + t) + " " + a + "h400000v" + (40 + t) + "h-400000z";
}, lL = function(t, a) {
  return "M983 " + (10 + t + a) + `
l` + t / 3.13 + " -" + t + `
c4,-6.7,10,-10,18,-10 H400000v` + (40 + t) + `
H1013.1s-83.4,268,-264.1,840c-180.7,572,-277,876.3,-289,913c-4.7,4.7,-12.7,7,-24,7
s-12,0,-12,0c-1.3,-3.3,-3.7,-11.7,-7,-25c-35.3,-125.3,-106.7,-373.3,-214,-744
c-10,12,-21,25,-33,39s-32,39,-32,39c-6,-5.3,-15,-14,-27,-26s25,-30,25,-30
c26.7,-32.7,52,-63,76,-91s52,-60,52,-60s208,722,208,722
c56,-175.3,126.3,-397.3,211,-666c84.7,-268.7,153.8,-488.2,207.5,-658.5
c53.7,-170.3,84.5,-266.8,92.5,-289.5z
M` + (1001 + t) + " " + a + "h400000v" + (40 + t) + "h-400000z";
}, iL = function(t, a) {
  return "M424," + (2398 + t + a) + `
c-1.3,-0.7,-38.5,-172,-111.5,-514c-73,-342,-109.8,-513.3,-110.5,-514
c0,-2,-10.7,14.3,-32,49c-4.7,7.3,-9.8,15.7,-15.5,25c-5.7,9.3,-9.8,16,-12.5,20
s-5,7,-5,7c-4,-3.3,-8.3,-7.7,-13,-13s-13,-13,-13,-13s76,-122,76,-122s77,-121,77,-121
s209,968,209,968c0,-2,84.7,-361.7,254,-1079c169.3,-717.3,254.7,-1077.7,256,-1081
l` + t / 4.223 + " -" + t + `c4,-6.7,10,-10,18,-10 H400000
v` + (40 + t) + `H1014.6
s-87.3,378.7,-272.6,1166c-185.3,787.3,-279.3,1182.3,-282,1185
c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2z M` + (1001 + t) + " " + a + `
h400000v` + (40 + t) + "h-400000z";
}, uL = function(t, a) {
  return "M473," + (2713 + t + a) + `
c339.3,-1799.3,509.3,-2700,510,-2702 l` + t / 5.298 + " -" + t + `
c3.3,-7.3,9.3,-11,18,-11 H400000v` + (40 + t) + `H1017.7
s-90.5,478,-276.2,1466c-185.7,988,-279.5,1483,-281.5,1485c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2c0,-1.3,-5.3,-32,-16,-92c-50.7,-293.3,-119.7,-693.3,-207,-1200
c0,-1.3,-5.3,8.7,-16,30c-10.7,21.3,-21.3,42.7,-32,64s-16,33,-16,33s-26,-26,-26,-26
s76,-153,76,-153s77,-151,77,-151c0.7,0.7,35.7,202,105,604c67.3,400.7,102,602.7,104,
606zM` + (1001 + t) + " " + a + "h400000v" + (40 + t) + "H1017.7z";
}, oL = function(t) {
  var a = t / 2;
  return "M400000 " + t + " H0 L" + a + " 0 l65 45 L145 " + (t - 80) + " H400000z";
}, sL = function(t, a, i) {
  var s = i - 54 - a - t;
  return "M702 " + (t + a) + "H400000" + (40 + t) + `
H742v` + s + `l-4 4-4 4c-.667.7 -2 1.5-4 2.5s-4.167 1.833-6.5 2.5-5.5 1-9.5 1
h-12l-28-84c-16.667-52-96.667 -294.333-240-727l-212 -643 -85 170
c-4-3.333-8.333-7.667-13 -13l-13-13l77-155 77-156c66 199.333 139 419.667
219 661 l218 661zM702 ` + a + "H400000v" + (40 + t) + "H742z";
}, cL = function(t, a, i) {
  a = 1e3 * a;
  var s = "";
  switch (t) {
    case "sqrtMain":
      s = rL(a, xm);
      break;
    case "sqrtSize1":
      s = aL(a, xm);
      break;
    case "sqrtSize2":
      s = lL(a, xm);
      break;
    case "sqrtSize3":
      s = iL(a, xm);
      break;
    case "sqrtSize4":
      s = uL(a, xm);
      break;
    case "sqrtTall":
      s = sL(a, xm, i);
  }
  return s;
}, fL = function(t, a) {
  switch (t) {
    case "⎜":
      return "M291 0 H417 V" + a + " H291z M291 0 H417 V" + a + " H291z";
    case "∣":
      return "M145 0 H188 V" + a + " H145z M145 0 H188 V" + a + " H145z";
    case "∥":
      return "M145 0 H188 V" + a + " H145z M145 0 H188 V" + a + " H145z" + ("M367 0 H410 V" + a + " H367z M367 0 H410 V" + a + " H367z");
    case "⎟":
      return "M457 0 H583 V" + a + " H457z M457 0 H583 V" + a + " H457z";
    case "⎢":
      return "M319 0 H403 V" + a + " H319z M319 0 H403 V" + a + " H319z";
    case "⎥":
      return "M263 0 H347 V" + a + " H263z M263 0 H347 V" + a + " H263z";
    case "⎪":
      return "M384 0 H504 V" + a + " H384z M384 0 H504 V" + a + " H384z";
    case "⏐":
      return "M312 0 H355 V" + a + " H312z M312 0 H355 V" + a + " H312z";
    case "‖":
      return "M257 0 H300 V" + a + " H257z M257 0 H300 V" + a + " H257z" + ("M478 0 H521 V" + a + " H478z M478 0 H521 V" + a + " H478z");
    default:
      return "";
  }
}, O9 = {
  // The doubleleftarrow geometry is from glyph U+21D0 in the font KaTeX Main
  doubleleftarrow: `M262 157
l10-10c34-36 62.7-77 86-123 3.3-8 5-13.3 5-16 0-5.3-6.7-8-20-8-7.3
 0-12.2.5-14.5 1.5-2.3 1-4.8 4.5-7.5 10.5-49.3 97.3-121.7 169.3-217 216-28
 14-57.3 25-88 33-6.7 2-11 3.8-13 5.5-2 1.7-3 4.2-3 7.5s1 5.8 3 7.5
c2 1.7 6.3 3.5 13 5.5 68 17.3 128.2 47.8 180.5 91.5 52.3 43.7 93.8 96.2 124.5
 157.5 9.3 8 15.3 12.3 18 13h6c12-.7 18-4 18-10 0-2-1.7-7-5-15-23.3-46-52-87
-86-123l-10-10h399738v-40H218c328 0 0 0 0 0l-10-8c-26.7-20-65.7-43-117-69 2.7
-2 6-3.7 10-5 36.7-16 72.3-37.3 107-64l10-8h399782v-40z
m8 0v40h399730v-40zm0 194v40h399730v-40z`,
  // doublerightarrow is from glyph U+21D2 in font KaTeX Main
  doublerightarrow: `M399738 392l
-10 10c-34 36-62.7 77-86 123-3.3 8-5 13.3-5 16 0 5.3 6.7 8 20 8 7.3 0 12.2-.5
 14.5-1.5 2.3-1 4.8-4.5 7.5-10.5 49.3-97.3 121.7-169.3 217-216 28-14 57.3-25 88
-33 6.7-2 11-3.8 13-5.5 2-1.7 3-4.2 3-7.5s-1-5.8-3-7.5c-2-1.7-6.3-3.5-13-5.5-68
-17.3-128.2-47.8-180.5-91.5-52.3-43.7-93.8-96.2-124.5-157.5-9.3-8-15.3-12.3-18
-13h-6c-12 .7-18 4-18 10 0 2 1.7 7 5 15 23.3 46 52 87 86 123l10 10H0v40h399782
c-328 0 0 0 0 0l10 8c26.7 20 65.7 43 117 69-2.7 2-6 3.7-10 5-36.7 16-72.3 37.3
-107 64l-10 8H0v40zM0 157v40h399730v-40zm0 194v40h399730v-40z`,
  // leftarrow is from glyph U+2190 in font KaTeX Main
  leftarrow: `M400000 241H110l3-3c68.7-52.7 113.7-120
 135-202 4-14.7 6-23 6-25 0-7.3-7-11-21-11-8 0-13.2.8-15.5 2.5-2.3 1.7-4.2 5.8
-5.5 12.5-1.3 4.7-2.7 10.3-4 17-12 48.7-34.8 92-68.5 130S65.3 228.3 18 247
c-10 4-16 7.7-18 11 0 8.7 6 14.3 18 17 47.3 18.7 87.8 47 121.5 85S196 441.3 208
 490c.7 2 1.3 5 2 9s1.2 6.7 1.5 8c.3 1.3 1 3.3 2 6s2.2 4.5 3.5 5.5c1.3 1 3.3
 1.8 6 2.5s6 1 10 1c14 0 21-3.7 21-11 0-2-2-10.3-6-25-20-79.3-65-146.7-135-202
 l-3-3h399890zM100 241v40h399900v-40z`,
  // overbrace is from glyphs U+23A9/23A8/23A7 in font KaTeX_Size4-Regular
  leftbrace: `M6 548l-6-6v-35l6-11c56-104 135.3-181.3 238-232 57.3-28.7 117
-45 179-50h399577v120H403c-43.3 7-81 15-113 26-100.7 33-179.7 91-237 174-2.7
 5-6 9-10 13-.7 1-7.3 1-20 1H6z`,
  leftbraceunder: `M0 6l6-6h17c12.688 0 19.313.3 20 1 4 4 7.313 8.3 10 13
 35.313 51.3 80.813 93.8 136.5 127.5 55.688 33.7 117.188 55.8 184.5 66.5.688
 0 2 .3 4 1 18.688 2.7 76 4.3 172 5h399450v120H429l-6-1c-124.688-8-235-61.7
-331-161C60.687 138.7 32.312 99.3 7 54L0 41V6z`,
  // overgroup is from the MnSymbol package (public domain)
  leftgroup: `M400000 80
H435C64 80 168.3 229.4 21 260c-5.9 1.2-18 0-18 0-2 0-3-1-3-3v-38C76 61 257 0
 435 0h399565z`,
  leftgroupunder: `M400000 262
H435C64 262 168.3 112.6 21 82c-5.9-1.2-18 0-18 0-2 0-3 1-3 3v38c76 158 257 219
 435 219h399565z`,
  // Harpoons are from glyph U+21BD in font KaTeX Main
  leftharpoon: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3
-3.3 10.2-9.5 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5
-18.3 3-21-1.3-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7
-196 228-6.7 4.7-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40z`,
  leftharpoonplus: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3-3.3 10.2-9.5
 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5-18.3 3-21-1.3
-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7-196 228-6.7 4.7
-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40zM0 435v40h400000v-40z
m0 0v40h400000v-40z`,
  leftharpoondown: `M7 241c-4 4-6.333 8.667-7 14 0 5.333.667 9 2 11s5.333
 5.333 12 10c90.667 54 156 130 196 228 3.333 10.667 6.333 16.333 9 17 2 .667 5
 1 9 1h5c10.667 0 16.667-2 18-6 2-2.667 1-9.667-3-21-32-87.333-82.667-157.667
-152-211l-3-3h399907v-40zM93 281 H400000 v-40L7 241z`,
  leftharpoondownplus: `M7 435c-4 4-6.3 8.7-7 14 0 5.3.7 9 2 11s5.3 5.3 12
 10c90.7 54 156 130 196 228 3.3 10.7 6.3 16.3 9 17 2 .7 5 1 9 1h5c10.7 0 16.7
-2 18-6 2-2.7 1-9.7-3-21-32-87.3-82.7-157.7-152-211l-3-3h399907v-40H7zm93 0
v40h399900v-40zM0 241v40h399900v-40zm0 0v40h399900v-40z`,
  // hook is from glyph U+21A9 in font KaTeX Main
  lefthook: `M400000 281 H103s-33-11.2-61-33.5S0 197.3 0 164s14.2-61.2 42.5
-83.5C70.8 58.2 104 47 142 47 c16.7 0 25 6.7 25 20 0 12-8.7 18.7-26 20-40 3.3
-68.7 15.7-86 37-10 12-15 25.3-15 40 0 22.7 9.8 40.7 29.5 54 19.7 13.3 43.5 21
 71.5 23h399859zM103 281v-40h399897v40z`,
  leftlinesegment: `M40 281 V428 H0 V94 H40 V241 H400000 v40z
M40 281 V428 H0 V94 H40 V241 H400000 v40z`,
  leftmapsto: `M40 281 V448H0V74H40V241H400000v40z
M40 281 V448H0V74H40V241H400000v40z`,
  // tofrom is from glyph U+21C4 in font KaTeX AMS Regular
  leftToFrom: `M0 147h400000v40H0zm0 214c68 40 115.7 95.7 143 167h22c15.3 0 23
-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69-70-101l-7-8h399905v-40H95l7-8
c28.7-32 52-65.7 70-101 10.7-23.3 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 265.3
 68 321 0 361zm0-174v-40h399900v40zm100 154v40h399900v-40z`,
  longequal: `M0 50 h400000 v40H0z m0 194h40000v40H0z
M0 50 h400000 v40H0z m0 194h40000v40H0z`,
  midbrace: `M200428 334
c-100.7-8.3-195.3-44-280-108-55.3-42-101.7-93-139-153l-9-14c-2.7 4-5.7 8.7-9 14
-53.3 86.7-123.7 153-211 199-66.7 36-137.3 56.3-212 62H0V214h199568c178.3-11.7
 311.7-78.3 403-201 6-8 9.7-12 11-12 .7-.7 6.7-1 18-1s17.3.3 18 1c1.3 0 5 4 11
 12 44.7 59.3 101.3 106.3 170 141s145.3 54.3 229 60h199572v120z`,
  midbraceunder: `M199572 214
c100.7 8.3 195.3 44 280 108 55.3 42 101.7 93 139 153l9 14c2.7-4 5.7-8.7 9-14
 53.3-86.7 123.7-153 211-199 66.7-36 137.3-56.3 212-62h199568v120H200432c-178.3
 11.7-311.7 78.3-403 201-6 8-9.7 12-11 12-.7.7-6.7 1-18 1s-17.3-.3-18-1c-1.3 0
-5-4-11-12-44.7-59.3-101.3-106.3-170-141s-145.3-54.3-229-60H0V214z`,
  oiintSize1: `M512.6 71.6c272.6 0 320.3 106.8 320.3 178.2 0 70.8-47.7 177.6
-320.3 177.6S193.1 320.6 193.1 249.8c0-71.4 46.9-178.2 319.5-178.2z
m368.1 178.2c0-86.4-60.9-215.4-368.1-215.4-306.4 0-367.3 129-367.3 215.4 0 85.8
60.9 214.8 367.3 214.8 307.2 0 368.1-129 368.1-214.8z`,
  oiintSize2: `M757.8 100.1c384.7 0 451.1 137.6 451.1 230 0 91.3-66.4 228.8
-451.1 228.8-386.3 0-452.7-137.5-452.7-228.8 0-92.4 66.4-230 452.7-230z
m502.4 230c0-111.2-82.4-277.2-502.4-277.2s-504 166-504 277.2
c0 110 84 276 504 276s502.4-166 502.4-276z`,
  oiiintSize1: `M681.4 71.6c408.9 0 480.5 106.8 480.5 178.2 0 70.8-71.6 177.6
-480.5 177.6S202.1 320.6 202.1 249.8c0-71.4 70.5-178.2 479.3-178.2z
m525.8 178.2c0-86.4-86.8-215.4-525.7-215.4-437.9 0-524.7 129-524.7 215.4 0
85.8 86.8 214.8 524.7 214.8 438.9 0 525.7-129 525.7-214.8z`,
  oiiintSize2: `M1021.2 53c603.6 0 707.8 165.8 707.8 277.2 0 110-104.2 275.8
-707.8 275.8-606 0-710.2-165.8-710.2-275.8C311 218.8 415.2 53 1021.2 53z
m770.4 277.1c0-131.2-126.4-327.6-770.5-327.6S248.4 198.9 248.4 330.1
c0 130 128.8 326.4 772.7 326.4s770.5-196.4 770.5-326.4z`,
  rightarrow: `M0 241v40h399891c-47.3 35.3-84 78-110 128
-16.7 32-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20
 11 8 0 13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7
 39-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85
-40.5-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
 151.7 139 205zm0 0v40h399900v-40z`,
  rightbrace: `M400000 542l
-6 6h-17c-12.7 0-19.3-.3-20-1-4-4-7.3-8.3-10-13-35.3-51.3-80.8-93.8-136.5-127.5
s-117.2-55.8-184.5-66.5c-.7 0-2-.3-4-1-18.7-2.7-76-4.3-172-5H0V214h399571l6 1
c124.7 8 235 61.7 331 161 31.3 33.3 59.7 72.7 85 118l7 13v35z`,
  rightbraceunder: `M399994 0l6 6v35l-6 11c-56 104-135.3 181.3-238 232-57.3
 28.7-117 45-179 50H-300V214h399897c43.3-7 81-15 113-26 100.7-33 179.7-91 237
-174 2.7-5 6-9 10-13 .7-1 7.3-1 20-1h17z`,
  rightgroup: `M0 80h399565c371 0 266.7 149.4 414 180 5.9 1.2 18 0 18 0 2 0
 3-1 3-3v-38c-76-158-257-219-435-219H0z`,
  rightgroupunder: `M0 262h399565c371 0 266.7-149.4 414-180 5.9-1.2 18 0 18
 0 2 0 3 1 3 3v38c-76 158-257 219-435 219H0z`,
  rightharpoon: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3
-3.7-15.3-11-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2
-10.7 0-16.7 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58
 69.2 92 94.5zm0 0v40h399900v-40z`,
  rightharpoonplus: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3-3.7-15.3-11
-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2-10.7 0-16.7
 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58 69.2 92 94.5z
m0 0v40h399900v-40z m100 194v40h399900v-40zm0 0v40h399900v-40z`,
  rightharpoondown: `M399747 511c0 7.3 6.7 11 20 11 8 0 13-.8 15-2.5s4.7-6.8
 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3 8.5-5.8 9.5
-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3-64.7 57-92 95
-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 241v40h399900v-40z`,
  rightharpoondownplus: `M399747 705c0 7.3 6.7 11 20 11 8 0 13-.8
 15-2.5s4.7-6.8 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3
 8.5-5.8 9.5-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3
-64.7 57-92 95-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 435v40h399900v-40z
m0-194v40h400000v-40zm0 0v40h400000v-40z`,
  righthook: `M399859 241c-764 0 0 0 0 0 40-3.3 68.7-15.7 86-37 10-12 15-25.3
 15-40 0-22.7-9.8-40.7-29.5-54-19.7-13.3-43.5-21-71.5-23-17.3-1.3-26-8-26-20 0
-13.3 8.7-20 26-20 38 0 71 11.2 99 33.5 0 0 7 5.6 21 16.7 14 11.2 21 33.5 21
 66.8s-14 61.2-42 83.5c-28 22.3-61 33.5-99 33.5L0 241z M0 281v-40h399859v40z`,
  rightlinesegment: `M399960 241 V94 h40 V428 h-40 V281 H0 v-40z
M399960 241 V94 h40 V428 h-40 V281 H0 v-40z`,
  rightToFrom: `M400000 167c-70.7-42-118-97.7-142-167h-23c-15.3 0-23 .3-23
 1 0 1.3 5.3 13.7 16 37 18 35.3 41.3 69 70 101l7 8H0v40h399905l-7 8c-28.7 32
-52 65.7-70 101-10.7 23.3-16 35.7-16 37 0 .7 7.7 1 23 1h23c24-69.3 71.3-125 142
-167z M100 147v40h399900v-40zM0 341v40h399900v-40z`,
  // twoheadleftarrow is from glyph U+219E in font KaTeX AMS Regular
  twoheadleftarrow: `M0 167c68 40
 115.7 95.7 143 167h22c15.3 0 23-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69
-70-101l-7-8h125l9 7c50.7 39.3 85 86 103 140h46c0-4.7-6.3-18.7-19-42-18-35.3
-40-67.3-66-96l-9-9h399716v-40H284l9-9c26-28.7 48-60.7 66-96 12.7-23.333 19
-37.333 19-42h-46c-18 54-52.3 100.7-103 140l-9 7H95l7-8c28.7-32 52-65.7 70-101
 10.7-23.333 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 71.3 68 127 0 167z`,
  twoheadrightarrow: `M400000 167
c-68-40-115.7-95.7-143-167h-22c-15.3 0-23 .3-23 1 0 1.3 5.3 13.7 16 37 18 35.3
 41.3 69 70 101l7 8h-125l-9-7c-50.7-39.3-85-86-103-140h-46c0 4.7 6.3 18.7 19 42
 18 35.3 40 67.3 66 96l9 9H0v40h399716l-9 9c-26 28.7-48 60.7-66 96-12.7 23.333
-19 37.333-19 42h46c18-54 52.3-100.7 103-140l9-7h125l-7 8c-28.7 32-52 65.7-70
 101-10.7 23.333-16 35.7-16 37 0 .7 7.7 1 23 1h22c27.3-71.3 75-127 143-167z`,
  // tilde1 is a modified version of a glyph from the MnSymbol package
  tilde1: `M200 55.538c-77 0-168 73.953-177 73.953-3 0-7
-2.175-9-5.437L2 97c-1-2-2-4-2-6 0-4 2-7 5-9l20-12C116 12 171 0 207 0c86 0
 114 68 191 68 78 0 168-68 177-68 4 0 7 2 9 5l12 19c1 2.175 2 4.35 2 6.525 0
 4.35-2 7.613-5 9.788l-19 13.05c-92 63.077-116.937 75.308-183 76.128
-68.267.847-113-73.952-191-73.952z`,
  // ditto tilde2, tilde3, & tilde4
  tilde2: `M344 55.266c-142 0-300.638 81.316-311.5 86.418
-8.01 3.762-22.5 10.91-23.5 5.562L1 120c-1-2-1-3-1-4 0-5 3-9 8-10l18.4-9C160.9
 31.9 283 0 358 0c148 0 188 122 331 122s314-97 326-97c4 0 8 2 10 7l7 21.114
c1 2.14 1 3.21 1 4.28 0 5.347-3 9.626-7 10.696l-22.3 12.622C852.6 158.372 751
 181.476 676 181.476c-149 0-189-126.21-332-126.21z`,
  tilde3: `M786 59C457 59 32 175.242 13 175.242c-6 0-10-3.457
-11-10.37L.15 138c-1-7 3-12 10-13l19.2-6.4C378.4 40.7 634.3 0 804.3 0c337 0
 411.8 157 746.8 157 328 0 754-112 773-112 5 0 10 3 11 9l1 14.075c1 8.066-.697
 16.595-6.697 17.492l-21.052 7.31c-367.9 98.146-609.15 122.696-778.15 122.696
 -338 0-409-156.573-744-156.573z`,
  tilde4: `M786 58C457 58 32 177.487 13 177.487c-6 0-10-3.345
-11-10.035L.15 143c-1-7 3-12 10-13l22-6.7C381.2 35 637.15 0 807.15 0c337 0 409
 177 744 177 328 0 754-127 773-127 5 0 10 3 11 9l1 14.794c1 7.805-3 13.38-9
 14.495l-20.7 5.574c-366.85 99.79-607.3 139.372-776.3 139.372-338 0-409
 -175.236-744-175.236z`,
  // vec is from glyph U+20D7 in font KaTeX Main
  vec: `M377 20c0-5.333 1.833-10 5.5-14S391 0 397 0c4.667 0 8.667 1.667 12 5
3.333 2.667 6.667 9 10 19 6.667 24.667 20.333 43.667 41 57 7.333 4.667 11
10.667 11 18 0 6-1 10-3 12s-6.667 5-14 9c-28.667 14.667-53.667 35.667-75 63
-1.333 1.333-3.167 3.5-5.5 6.5s-4 4.833-5 5.5c-1 .667-2.5 1.333-4.5 2s-4.333 1
-7 1c-4.667 0-9.167-1.833-13.5-5.5S337 184 337 178c0-12.667 15.667-32.333 47-59
H213l-171-1c-8.667-6-13-12.333-13-19 0-4.667 4.333-11.333 13-20h359
c-16-25.333-24-45-24-59z`,
  // widehat1 is a modified version of a glyph from the MnSymbol package
  widehat1: `M529 0h5l519 115c5 1 9 5 9 10 0 1-1 2-1 3l-4 22
c-1 5-5 9-11 9h-2L532 67 19 159h-2c-5 0-9-4-11-9l-5-22c-1-6 2-12 8-13z`,
  // ditto widehat2, widehat3, & widehat4
  widehat2: `M1181 0h2l1171 176c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 220h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  widehat3: `M1181 0h2l1171 236c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 280h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  widehat4: `M1181 0h2l1171 296c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 340h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  // widecheck paths are all inverted versions of widehat
  widecheck1: `M529,159h5l519,-115c5,-1,9,-5,9,-10c0,-1,-1,-2,-1,-3l-4,-22c-1,
-5,-5,-9,-11,-9h-2l-512,92l-513,-92h-2c-5,0,-9,4,-11,9l-5,22c-1,6,2,12,8,13z`,
  widecheck2: `M1181,220h2l1171,-176c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,153l-1167,-153h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  widecheck3: `M1181,280h2l1171,-236c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,213l-1167,-213h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  widecheck4: `M1181,340h2l1171,-296c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,273l-1167,-273h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  // The next ten paths support reaction arrows from the mhchem package.
  // Arrows for \ce{<-->} are offset from xAxis by 0.22ex, per mhchem in LaTeX
  // baraboveleftarrow is mostly from glyph U+2190 in font KaTeX Main
  baraboveleftarrow: `M400000 620h-399890l3 -3c68.7 -52.7 113.7 -120 135 -202
c4 -14.7 6 -23 6 -25c0 -7.3 -7 -11 -21 -11c-8 0 -13.2 0.8 -15.5 2.5
c-2.3 1.7 -4.2 5.8 -5.5 12.5c-1.3 4.7 -2.7 10.3 -4 17c-12 48.7 -34.8 92 -68.5 130
s-74.2 66.3 -121.5 85c-10 4 -16 7.7 -18 11c0 8.7 6 14.3 18 17c47.3 18.7 87.8 47
121.5 85s56.5 81.3 68.5 130c0.7 2 1.3 5 2 9s1.2 6.7 1.5 8c0.3 1.3 1 3.3 2 6
s2.2 4.5 3.5 5.5c1.3 1 3.3 1.8 6 2.5s6 1 10 1c14 0 21 -3.7 21 -11
c0 -2 -2 -10.3 -6 -25c-20 -79.3 -65 -146.7 -135 -202l-3 -3h399890z
M100 620v40h399900v-40z M0 241v40h399900v-40zM0 241v40h399900v-40z`,
  // rightarrowabovebar is mostly from glyph U+2192, KaTeX Main
  rightarrowabovebar: `M0 241v40h399891c-47.3 35.3-84 78-110 128-16.7 32
-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20 11 8 0
13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7 39
-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85-40.5
-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
151.7 139 205zm96 379h399894v40H0zm0 0h399904v40H0z`,
  // The short left harpoon has 0.5em (i.e. 500 units) kern on the left end.
  // Ref from mhchem.sty: \rlap{\raisebox{-.22ex}{$\kern0.5em
  baraboveshortleftharpoon: `M507,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17
c2,0.7,5,1,9,1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21
c-32,-87.3,-82.7,-157.7,-152,-211c0,0,-3,-3,-3,-3l399351,0l0,-40
c-398570,0,-399437,0,-399437,0z M593 435 v40 H399500 v-40z
M0 281 v-40 H399908 v40z M0 281 v-40 H399908 v40z`,
  rightharpoonaboveshortbar: `M0,241 l0,40c399126,0,399993,0,399993,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M0 241 v40 H399908 v-40z M0 475 v-40 H399500 v40z M0 475 v-40 H399500 v40z`,
  shortbaraboveleftharpoon: `M7,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17c2,0.7,5,1,9,
1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21c-32,-87.3,-82.7,-157.7,
-152,-211c0,0,-3,-3,-3,-3l399907,0l0,-40c-399126,0,-399993,0,-399993,0z
M93 435 v40 H400000 v-40z M500 241 v40 H400000 v-40z M500 241 v40 H400000 v-40z`,
  shortrightharpoonabovebar: `M53,241l0,40c398570,0,399437,0,399437,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M500 241 v40 H399408 v-40z M500 435 v40 H400000 v-40z`
}, hL = function(t, a) {
  switch (t) {
    case "lbrack":
      return "M403 1759 V84 H666 V0 H319 V1759 v" + a + ` v1759 h347 v-84
H403z M403 1759 V0 H319 V1759 v` + a + " v1759 h84z";
    case "rbrack":
      return "M347 1759 V0 H0 V84 H263 V1759 v" + a + ` v1759 H0 v84 H347z
M347 1759 V0 H263 V1759 v` + a + " v1759 h84z";
    case "vert":
      return "M145 15 v585 v" + a + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -a + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` + a + " v585 h43z";
    case "doublevert":
      return "M145 15 v585 v" + a + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -a + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` + a + ` v585 h43z
M367 15 v585 v` + a + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -a + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M410 15 H367 v585 v` + a + " v585 h43z";
    case "lfloor":
      return "M319 602 V0 H403 V602 v" + a + ` v1715 h263 v84 H319z
MM319 602 V0 H403 V602 v` + a + " v1715 H319z";
    case "rfloor":
      return "M319 602 V0 H403 V602 v" + a + ` v1799 H0 v-84 H319z
MM319 602 V0 H403 V602 v` + a + " v1715 H319z";
    case "lceil":
      return "M403 1759 V84 H666 V0 H319 V1759 v" + a + ` v602 h84z
M403 1759 V0 H319 V1759 v` + a + " v602 h84z";
    case "rceil":
      return "M347 1759 V0 H0 V84 H263 V1759 v" + a + ` v602 h84z
M347 1759 V0 h-84 V1759 v` + a + " v602 h84z";
    case "lparen":
      return `M863,9c0,-2,-2,-5,-6,-9c0,0,-17,0,-17,0c-12.7,0,-19.3,0.3,-20,1
c-5.3,5.3,-10.3,11,-15,17c-242.7,294.7,-395.3,682,-458,1162c-21.3,163.3,-33.3,349,
-36,557 l0,` + (a + 84) + `c0.2,6,0,26,0,60c2,159.3,10,310.7,24,454c53.3,528,210,
949.7,470,1265c4.7,6,9.7,11.7,15,17c0.7,0.7,7,1,19,1c0,0,18,0,18,0c4,-4,6,-7,6,-9
c0,-2.7,-3.3,-8.7,-10,-18c-135.3,-192.7,-235.5,-414.3,-300.5,-665c-65,-250.7,-102.5,
-544.7,-112.5,-882c-2,-104,-3,-167,-3,-189
l0,-` + (a + 92) + `c0,-162.7,5.7,-314,17,-454c20.7,-272,63.7,-513,129,-723c65.3,
-210,155.3,-396.3,270,-559c6.7,-9.3,10,-15.3,10,-18z`;
    case "rparen":
      return `M76,0c-16.7,0,-25,3,-25,9c0,2,2,6.3,6,13c21.3,28.7,42.3,60.3,
63,95c96.7,156.7,172.8,332.5,228.5,527.5c55.7,195,92.8,416.5,111.5,664.5
c11.3,139.3,17,290.7,17,454c0,28,1.7,43,3.3,45l0,` + (a + 9) + `
c-3,4,-3.3,16.7,-3.3,38c0,162,-5.7,313.7,-17,455c-18.7,248,-55.8,469.3,-111.5,664
c-55.7,194.7,-131.8,370.3,-228.5,527c-20.7,34.7,-41.7,66.3,-63,95c-2,3.3,-4,7,-6,11
c0,7.3,5.7,11,17,11c0,0,11,0,11,0c9.3,0,14.3,-0.3,15,-1c5.3,-5.3,10.3,-11,15,-17
c242.7,-294.7,395.3,-681.7,458,-1161c21.3,-164.7,33.3,-350.7,36,-558
l0,-` + (a + 144) + `c-2,-159.3,-10,-310.7,-24,-454c-53.3,-528,-210,-949.7,
-470,-1265c-4.7,-6,-9.7,-11.7,-15,-17c-0.7,-0.7,-6.7,-1,-18,-1z`;
    default:
      throw new Error("Unknown stretchy delimiter.");
  }
};
class l4 {
  // HtmlDomNode
  // Never used; needed for satisfying interface.
  constructor(t) {
    this.children = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, this.children = t, this.classes = [], this.height = 0, this.depth = 0, this.maxFontSize = 0, this.style = {};
  }
  hasClass(t) {
    return dt.contains(this.classes, t);
  }
  /** Convert the fragment into a node. */
  toNode() {
    for (var t = document.createDocumentFragment(), a = 0; a < this.children.length; a++)
      t.appendChild(this.children[a].toNode());
    return t;
  }
  /** Convert the fragment into HTML markup. */
  toMarkup() {
    for (var t = "", a = 0; a < this.children.length; a++)
      t += this.children[a].toMarkup();
    return t;
  }
  /**
   * Converts the math node into a string, similar to innerText. Applies to
   * MathDomNode's only.
   */
  toText() {
    var t = (a) => a.toText();
    return this.children.map(t).join("");
  }
}
var vo = {
  "AMS-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.68889, 0, 0, 0.72222],
    66: [0, 0.68889, 0, 0, 0.66667],
    67: [0, 0.68889, 0, 0, 0.72222],
    68: [0, 0.68889, 0, 0, 0.72222],
    69: [0, 0.68889, 0, 0, 0.66667],
    70: [0, 0.68889, 0, 0, 0.61111],
    71: [0, 0.68889, 0, 0, 0.77778],
    72: [0, 0.68889, 0, 0, 0.77778],
    73: [0, 0.68889, 0, 0, 0.38889],
    74: [0.16667, 0.68889, 0, 0, 0.5],
    75: [0, 0.68889, 0, 0, 0.77778],
    76: [0, 0.68889, 0, 0, 0.66667],
    77: [0, 0.68889, 0, 0, 0.94445],
    78: [0, 0.68889, 0, 0, 0.72222],
    79: [0.16667, 0.68889, 0, 0, 0.77778],
    80: [0, 0.68889, 0, 0, 0.61111],
    81: [0.16667, 0.68889, 0, 0, 0.77778],
    82: [0, 0.68889, 0, 0, 0.72222],
    83: [0, 0.68889, 0, 0, 0.55556],
    84: [0, 0.68889, 0, 0, 0.66667],
    85: [0, 0.68889, 0, 0, 0.72222],
    86: [0, 0.68889, 0, 0, 0.72222],
    87: [0, 0.68889, 0, 0, 1],
    88: [0, 0.68889, 0, 0, 0.72222],
    89: [0, 0.68889, 0, 0, 0.72222],
    90: [0, 0.68889, 0, 0, 0.66667],
    107: [0, 0.68889, 0, 0, 0.55556],
    160: [0, 0, 0, 0, 0.25],
    165: [0, 0.675, 0.025, 0, 0.75],
    174: [0.15559, 0.69224, 0, 0, 0.94666],
    240: [0, 0.68889, 0, 0, 0.55556],
    295: [0, 0.68889, 0, 0, 0.54028],
    710: [0, 0.825, 0, 0, 2.33334],
    732: [0, 0.9, 0, 0, 2.33334],
    770: [0, 0.825, 0, 0, 2.33334],
    771: [0, 0.9, 0, 0, 2.33334],
    989: [0.08167, 0.58167, 0, 0, 0.77778],
    1008: [0, 0.43056, 0.04028, 0, 0.66667],
    8245: [0, 0.54986, 0, 0, 0.275],
    8463: [0, 0.68889, 0, 0, 0.54028],
    8487: [0, 0.68889, 0, 0, 0.72222],
    8498: [0, 0.68889, 0, 0, 0.55556],
    8502: [0, 0.68889, 0, 0, 0.66667],
    8503: [0, 0.68889, 0, 0, 0.44445],
    8504: [0, 0.68889, 0, 0, 0.66667],
    8513: [0, 0.68889, 0, 0, 0.63889],
    8592: [-0.03598, 0.46402, 0, 0, 0.5],
    8594: [-0.03598, 0.46402, 0, 0, 0.5],
    8602: [-0.13313, 0.36687, 0, 0, 1],
    8603: [-0.13313, 0.36687, 0, 0, 1],
    8606: [0.01354, 0.52239, 0, 0, 1],
    8608: [0.01354, 0.52239, 0, 0, 1],
    8610: [0.01354, 0.52239, 0, 0, 1.11111],
    8611: [0.01354, 0.52239, 0, 0, 1.11111],
    8619: [0, 0.54986, 0, 0, 1],
    8620: [0, 0.54986, 0, 0, 1],
    8621: [-0.13313, 0.37788, 0, 0, 1.38889],
    8622: [-0.13313, 0.36687, 0, 0, 1],
    8624: [0, 0.69224, 0, 0, 0.5],
    8625: [0, 0.69224, 0, 0, 0.5],
    8630: [0, 0.43056, 0, 0, 1],
    8631: [0, 0.43056, 0, 0, 1],
    8634: [0.08198, 0.58198, 0, 0, 0.77778],
    8635: [0.08198, 0.58198, 0, 0, 0.77778],
    8638: [0.19444, 0.69224, 0, 0, 0.41667],
    8639: [0.19444, 0.69224, 0, 0, 0.41667],
    8642: [0.19444, 0.69224, 0, 0, 0.41667],
    8643: [0.19444, 0.69224, 0, 0, 0.41667],
    8644: [0.1808, 0.675, 0, 0, 1],
    8646: [0.1808, 0.675, 0, 0, 1],
    8647: [0.1808, 0.675, 0, 0, 1],
    8648: [0.19444, 0.69224, 0, 0, 0.83334],
    8649: [0.1808, 0.675, 0, 0, 1],
    8650: [0.19444, 0.69224, 0, 0, 0.83334],
    8651: [0.01354, 0.52239, 0, 0, 1],
    8652: [0.01354, 0.52239, 0, 0, 1],
    8653: [-0.13313, 0.36687, 0, 0, 1],
    8654: [-0.13313, 0.36687, 0, 0, 1],
    8655: [-0.13313, 0.36687, 0, 0, 1],
    8666: [0.13667, 0.63667, 0, 0, 1],
    8667: [0.13667, 0.63667, 0, 0, 1],
    8669: [-0.13313, 0.37788, 0, 0, 1],
    8672: [-0.064, 0.437, 0, 0, 1.334],
    8674: [-0.064, 0.437, 0, 0, 1.334],
    8705: [0, 0.825, 0, 0, 0.5],
    8708: [0, 0.68889, 0, 0, 0.55556],
    8709: [0.08167, 0.58167, 0, 0, 0.77778],
    8717: [0, 0.43056, 0, 0, 0.42917],
    8722: [-0.03598, 0.46402, 0, 0, 0.5],
    8724: [0.08198, 0.69224, 0, 0, 0.77778],
    8726: [0.08167, 0.58167, 0, 0, 0.77778],
    8733: [0, 0.69224, 0, 0, 0.77778],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8737: [0, 0.69224, 0, 0, 0.72222],
    8738: [0.03517, 0.52239, 0, 0, 0.72222],
    8739: [0.08167, 0.58167, 0, 0, 0.22222],
    8740: [0.25142, 0.74111, 0, 0, 0.27778],
    8741: [0.08167, 0.58167, 0, 0, 0.38889],
    8742: [0.25142, 0.74111, 0, 0, 0.5],
    8756: [0, 0.69224, 0, 0, 0.66667],
    8757: [0, 0.69224, 0, 0, 0.66667],
    8764: [-0.13313, 0.36687, 0, 0, 0.77778],
    8765: [-0.13313, 0.37788, 0, 0, 0.77778],
    8769: [-0.13313, 0.36687, 0, 0, 0.77778],
    8770: [-0.03625, 0.46375, 0, 0, 0.77778],
    8774: [0.30274, 0.79383, 0, 0, 0.77778],
    8776: [-0.01688, 0.48312, 0, 0, 0.77778],
    8778: [0.08167, 0.58167, 0, 0, 0.77778],
    8782: [0.06062, 0.54986, 0, 0, 0.77778],
    8783: [0.06062, 0.54986, 0, 0, 0.77778],
    8785: [0.08198, 0.58198, 0, 0, 0.77778],
    8786: [0.08198, 0.58198, 0, 0, 0.77778],
    8787: [0.08198, 0.58198, 0, 0, 0.77778],
    8790: [0, 0.69224, 0, 0, 0.77778],
    8791: [0.22958, 0.72958, 0, 0, 0.77778],
    8796: [0.08198, 0.91667, 0, 0, 0.77778],
    8806: [0.25583, 0.75583, 0, 0, 0.77778],
    8807: [0.25583, 0.75583, 0, 0, 0.77778],
    8808: [0.25142, 0.75726, 0, 0, 0.77778],
    8809: [0.25142, 0.75726, 0, 0, 0.77778],
    8812: [0.25583, 0.75583, 0, 0, 0.5],
    8814: [0.20576, 0.70576, 0, 0, 0.77778],
    8815: [0.20576, 0.70576, 0, 0, 0.77778],
    8816: [0.30274, 0.79383, 0, 0, 0.77778],
    8817: [0.30274, 0.79383, 0, 0, 0.77778],
    8818: [0.22958, 0.72958, 0, 0, 0.77778],
    8819: [0.22958, 0.72958, 0, 0, 0.77778],
    8822: [0.1808, 0.675, 0, 0, 0.77778],
    8823: [0.1808, 0.675, 0, 0, 0.77778],
    8828: [0.13667, 0.63667, 0, 0, 0.77778],
    8829: [0.13667, 0.63667, 0, 0, 0.77778],
    8830: [0.22958, 0.72958, 0, 0, 0.77778],
    8831: [0.22958, 0.72958, 0, 0, 0.77778],
    8832: [0.20576, 0.70576, 0, 0, 0.77778],
    8833: [0.20576, 0.70576, 0, 0, 0.77778],
    8840: [0.30274, 0.79383, 0, 0, 0.77778],
    8841: [0.30274, 0.79383, 0, 0, 0.77778],
    8842: [0.13597, 0.63597, 0, 0, 0.77778],
    8843: [0.13597, 0.63597, 0, 0, 0.77778],
    8847: [0.03517, 0.54986, 0, 0, 0.77778],
    8848: [0.03517, 0.54986, 0, 0, 0.77778],
    8858: [0.08198, 0.58198, 0, 0, 0.77778],
    8859: [0.08198, 0.58198, 0, 0, 0.77778],
    8861: [0.08198, 0.58198, 0, 0, 0.77778],
    8862: [0, 0.675, 0, 0, 0.77778],
    8863: [0, 0.675, 0, 0, 0.77778],
    8864: [0, 0.675, 0, 0, 0.77778],
    8865: [0, 0.675, 0, 0, 0.77778],
    8872: [0, 0.69224, 0, 0, 0.61111],
    8873: [0, 0.69224, 0, 0, 0.72222],
    8874: [0, 0.69224, 0, 0, 0.88889],
    8876: [0, 0.68889, 0, 0, 0.61111],
    8877: [0, 0.68889, 0, 0, 0.61111],
    8878: [0, 0.68889, 0, 0, 0.72222],
    8879: [0, 0.68889, 0, 0, 0.72222],
    8882: [0.03517, 0.54986, 0, 0, 0.77778],
    8883: [0.03517, 0.54986, 0, 0, 0.77778],
    8884: [0.13667, 0.63667, 0, 0, 0.77778],
    8885: [0.13667, 0.63667, 0, 0, 0.77778],
    8888: [0, 0.54986, 0, 0, 1.11111],
    8890: [0.19444, 0.43056, 0, 0, 0.55556],
    8891: [0.19444, 0.69224, 0, 0, 0.61111],
    8892: [0.19444, 0.69224, 0, 0, 0.61111],
    8901: [0, 0.54986, 0, 0, 0.27778],
    8903: [0.08167, 0.58167, 0, 0, 0.77778],
    8905: [0.08167, 0.58167, 0, 0, 0.77778],
    8906: [0.08167, 0.58167, 0, 0, 0.77778],
    8907: [0, 0.69224, 0, 0, 0.77778],
    8908: [0, 0.69224, 0, 0, 0.77778],
    8909: [-0.03598, 0.46402, 0, 0, 0.77778],
    8910: [0, 0.54986, 0, 0, 0.76042],
    8911: [0, 0.54986, 0, 0, 0.76042],
    8912: [0.03517, 0.54986, 0, 0, 0.77778],
    8913: [0.03517, 0.54986, 0, 0, 0.77778],
    8914: [0, 0.54986, 0, 0, 0.66667],
    8915: [0, 0.54986, 0, 0, 0.66667],
    8916: [0, 0.69224, 0, 0, 0.66667],
    8918: [0.0391, 0.5391, 0, 0, 0.77778],
    8919: [0.0391, 0.5391, 0, 0, 0.77778],
    8920: [0.03517, 0.54986, 0, 0, 1.33334],
    8921: [0.03517, 0.54986, 0, 0, 1.33334],
    8922: [0.38569, 0.88569, 0, 0, 0.77778],
    8923: [0.38569, 0.88569, 0, 0, 0.77778],
    8926: [0.13667, 0.63667, 0, 0, 0.77778],
    8927: [0.13667, 0.63667, 0, 0, 0.77778],
    8928: [0.30274, 0.79383, 0, 0, 0.77778],
    8929: [0.30274, 0.79383, 0, 0, 0.77778],
    8934: [0.23222, 0.74111, 0, 0, 0.77778],
    8935: [0.23222, 0.74111, 0, 0, 0.77778],
    8936: [0.23222, 0.74111, 0, 0, 0.77778],
    8937: [0.23222, 0.74111, 0, 0, 0.77778],
    8938: [0.20576, 0.70576, 0, 0, 0.77778],
    8939: [0.20576, 0.70576, 0, 0, 0.77778],
    8940: [0.30274, 0.79383, 0, 0, 0.77778],
    8941: [0.30274, 0.79383, 0, 0, 0.77778],
    8994: [0.19444, 0.69224, 0, 0, 0.77778],
    8995: [0.19444, 0.69224, 0, 0, 0.77778],
    9416: [0.15559, 0.69224, 0, 0, 0.90222],
    9484: [0, 0.69224, 0, 0, 0.5],
    9488: [0, 0.69224, 0, 0, 0.5],
    9492: [0, 0.37788, 0, 0, 0.5],
    9496: [0, 0.37788, 0, 0, 0.5],
    9585: [0.19444, 0.68889, 0, 0, 0.88889],
    9586: [0.19444, 0.74111, 0, 0, 0.88889],
    9632: [0, 0.675, 0, 0, 0.77778],
    9633: [0, 0.675, 0, 0, 0.77778],
    9650: [0, 0.54986, 0, 0, 0.72222],
    9651: [0, 0.54986, 0, 0, 0.72222],
    9654: [0.03517, 0.54986, 0, 0, 0.77778],
    9660: [0, 0.54986, 0, 0, 0.72222],
    9661: [0, 0.54986, 0, 0, 0.72222],
    9664: [0.03517, 0.54986, 0, 0, 0.77778],
    9674: [0.11111, 0.69224, 0, 0, 0.66667],
    9733: [0.19444, 0.69224, 0, 0, 0.94445],
    10003: [0, 0.69224, 0, 0, 0.83334],
    10016: [0, 0.69224, 0, 0, 0.83334],
    10731: [0.11111, 0.69224, 0, 0, 0.66667],
    10846: [0.19444, 0.75583, 0, 0, 0.61111],
    10877: [0.13667, 0.63667, 0, 0, 0.77778],
    10878: [0.13667, 0.63667, 0, 0, 0.77778],
    10885: [0.25583, 0.75583, 0, 0, 0.77778],
    10886: [0.25583, 0.75583, 0, 0, 0.77778],
    10887: [0.13597, 0.63597, 0, 0, 0.77778],
    10888: [0.13597, 0.63597, 0, 0, 0.77778],
    10889: [0.26167, 0.75726, 0, 0, 0.77778],
    10890: [0.26167, 0.75726, 0, 0, 0.77778],
    10891: [0.48256, 0.98256, 0, 0, 0.77778],
    10892: [0.48256, 0.98256, 0, 0, 0.77778],
    10901: [0.13667, 0.63667, 0, 0, 0.77778],
    10902: [0.13667, 0.63667, 0, 0, 0.77778],
    10933: [0.25142, 0.75726, 0, 0, 0.77778],
    10934: [0.25142, 0.75726, 0, 0, 0.77778],
    10935: [0.26167, 0.75726, 0, 0, 0.77778],
    10936: [0.26167, 0.75726, 0, 0, 0.77778],
    10937: [0.26167, 0.75726, 0, 0, 0.77778],
    10938: [0.26167, 0.75726, 0, 0, 0.77778],
    10949: [0.25583, 0.75583, 0, 0, 0.77778],
    10950: [0.25583, 0.75583, 0, 0, 0.77778],
    10955: [0.28481, 0.79383, 0, 0, 0.77778],
    10956: [0.28481, 0.79383, 0, 0, 0.77778],
    57350: [0.08167, 0.58167, 0, 0, 0.22222],
    57351: [0.08167, 0.58167, 0, 0, 0.38889],
    57352: [0.08167, 0.58167, 0, 0, 0.77778],
    57353: [0, 0.43056, 0.04028, 0, 0.66667],
    57356: [0.25142, 0.75726, 0, 0, 0.77778],
    57357: [0.25142, 0.75726, 0, 0, 0.77778],
    57358: [0.41951, 0.91951, 0, 0, 0.77778],
    57359: [0.30274, 0.79383, 0, 0, 0.77778],
    57360: [0.30274, 0.79383, 0, 0, 0.77778],
    57361: [0.41951, 0.91951, 0, 0, 0.77778],
    57366: [0.25142, 0.75726, 0, 0, 0.77778],
    57367: [0.25142, 0.75726, 0, 0, 0.77778],
    57368: [0.25142, 0.75726, 0, 0, 0.77778],
    57369: [0.25142, 0.75726, 0, 0, 0.77778],
    57370: [0.13597, 0.63597, 0, 0, 0.77778],
    57371: [0.13597, 0.63597, 0, 0, 0.77778]
  },
  "Caligraphic-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.68333, 0, 0.19445, 0.79847],
    66: [0, 0.68333, 0.03041, 0.13889, 0.65681],
    67: [0, 0.68333, 0.05834, 0.13889, 0.52653],
    68: [0, 0.68333, 0.02778, 0.08334, 0.77139],
    69: [0, 0.68333, 0.08944, 0.11111, 0.52778],
    70: [0, 0.68333, 0.09931, 0.11111, 0.71875],
    71: [0.09722, 0.68333, 0.0593, 0.11111, 0.59487],
    72: [0, 0.68333, 965e-5, 0.11111, 0.84452],
    73: [0, 0.68333, 0.07382, 0, 0.54452],
    74: [0.09722, 0.68333, 0.18472, 0.16667, 0.67778],
    75: [0, 0.68333, 0.01445, 0.05556, 0.76195],
    76: [0, 0.68333, 0, 0.13889, 0.68972],
    77: [0, 0.68333, 0, 0.13889, 1.2009],
    78: [0, 0.68333, 0.14736, 0.08334, 0.82049],
    79: [0, 0.68333, 0.02778, 0.11111, 0.79611],
    80: [0, 0.68333, 0.08222, 0.08334, 0.69556],
    81: [0.09722, 0.68333, 0, 0.11111, 0.81667],
    82: [0, 0.68333, 0, 0.08334, 0.8475],
    83: [0, 0.68333, 0.075, 0.13889, 0.60556],
    84: [0, 0.68333, 0.25417, 0, 0.54464],
    85: [0, 0.68333, 0.09931, 0.08334, 0.62583],
    86: [0, 0.68333, 0.08222, 0, 0.61278],
    87: [0, 0.68333, 0.08222, 0.08334, 0.98778],
    88: [0, 0.68333, 0.14643, 0.13889, 0.7133],
    89: [0.09722, 0.68333, 0.08222, 0.08334, 0.66834],
    90: [0, 0.68333, 0.07944, 0.13889, 0.72473],
    160: [0, 0, 0, 0, 0.25]
  },
  "Fraktur-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69141, 0, 0, 0.29574],
    34: [0, 0.69141, 0, 0, 0.21471],
    38: [0, 0.69141, 0, 0, 0.73786],
    39: [0, 0.69141, 0, 0, 0.21201],
    40: [0.24982, 0.74947, 0, 0, 0.38865],
    41: [0.24982, 0.74947, 0, 0, 0.38865],
    42: [0, 0.62119, 0, 0, 0.27764],
    43: [0.08319, 0.58283, 0, 0, 0.75623],
    44: [0, 0.10803, 0, 0, 0.27764],
    45: [0.08319, 0.58283, 0, 0, 0.75623],
    46: [0, 0.10803, 0, 0, 0.27764],
    47: [0.24982, 0.74947, 0, 0, 0.50181],
    48: [0, 0.47534, 0, 0, 0.50181],
    49: [0, 0.47534, 0, 0, 0.50181],
    50: [0, 0.47534, 0, 0, 0.50181],
    51: [0.18906, 0.47534, 0, 0, 0.50181],
    52: [0.18906, 0.47534, 0, 0, 0.50181],
    53: [0.18906, 0.47534, 0, 0, 0.50181],
    54: [0, 0.69141, 0, 0, 0.50181],
    55: [0.18906, 0.47534, 0, 0, 0.50181],
    56: [0, 0.69141, 0, 0, 0.50181],
    57: [0.18906, 0.47534, 0, 0, 0.50181],
    58: [0, 0.47534, 0, 0, 0.21606],
    59: [0.12604, 0.47534, 0, 0, 0.21606],
    61: [-0.13099, 0.36866, 0, 0, 0.75623],
    63: [0, 0.69141, 0, 0, 0.36245],
    65: [0, 0.69141, 0, 0, 0.7176],
    66: [0, 0.69141, 0, 0, 0.88397],
    67: [0, 0.69141, 0, 0, 0.61254],
    68: [0, 0.69141, 0, 0, 0.83158],
    69: [0, 0.69141, 0, 0, 0.66278],
    70: [0.12604, 0.69141, 0, 0, 0.61119],
    71: [0, 0.69141, 0, 0, 0.78539],
    72: [0.06302, 0.69141, 0, 0, 0.7203],
    73: [0, 0.69141, 0, 0, 0.55448],
    74: [0.12604, 0.69141, 0, 0, 0.55231],
    75: [0, 0.69141, 0, 0, 0.66845],
    76: [0, 0.69141, 0, 0, 0.66602],
    77: [0, 0.69141, 0, 0, 1.04953],
    78: [0, 0.69141, 0, 0, 0.83212],
    79: [0, 0.69141, 0, 0, 0.82699],
    80: [0.18906, 0.69141, 0, 0, 0.82753],
    81: [0.03781, 0.69141, 0, 0, 0.82699],
    82: [0, 0.69141, 0, 0, 0.82807],
    83: [0, 0.69141, 0, 0, 0.82861],
    84: [0, 0.69141, 0, 0, 0.66899],
    85: [0, 0.69141, 0, 0, 0.64576],
    86: [0, 0.69141, 0, 0, 0.83131],
    87: [0, 0.69141, 0, 0, 1.04602],
    88: [0, 0.69141, 0, 0, 0.71922],
    89: [0.18906, 0.69141, 0, 0, 0.83293],
    90: [0.12604, 0.69141, 0, 0, 0.60201],
    91: [0.24982, 0.74947, 0, 0, 0.27764],
    93: [0.24982, 0.74947, 0, 0, 0.27764],
    94: [0, 0.69141, 0, 0, 0.49965],
    97: [0, 0.47534, 0, 0, 0.50046],
    98: [0, 0.69141, 0, 0, 0.51315],
    99: [0, 0.47534, 0, 0, 0.38946],
    100: [0, 0.62119, 0, 0, 0.49857],
    101: [0, 0.47534, 0, 0, 0.40053],
    102: [0.18906, 0.69141, 0, 0, 0.32626],
    103: [0.18906, 0.47534, 0, 0, 0.5037],
    104: [0.18906, 0.69141, 0, 0, 0.52126],
    105: [0, 0.69141, 0, 0, 0.27899],
    106: [0, 0.69141, 0, 0, 0.28088],
    107: [0, 0.69141, 0, 0, 0.38946],
    108: [0, 0.69141, 0, 0, 0.27953],
    109: [0, 0.47534, 0, 0, 0.76676],
    110: [0, 0.47534, 0, 0, 0.52666],
    111: [0, 0.47534, 0, 0, 0.48885],
    112: [0.18906, 0.52396, 0, 0, 0.50046],
    113: [0.18906, 0.47534, 0, 0, 0.48912],
    114: [0, 0.47534, 0, 0, 0.38919],
    115: [0, 0.47534, 0, 0, 0.44266],
    116: [0, 0.62119, 0, 0, 0.33301],
    117: [0, 0.47534, 0, 0, 0.5172],
    118: [0, 0.52396, 0, 0, 0.5118],
    119: [0, 0.52396, 0, 0, 0.77351],
    120: [0.18906, 0.47534, 0, 0, 0.38865],
    121: [0.18906, 0.47534, 0, 0, 0.49884],
    122: [0.18906, 0.47534, 0, 0, 0.39054],
    160: [0, 0, 0, 0, 0.25],
    8216: [0, 0.69141, 0, 0, 0.21471],
    8217: [0, 0.69141, 0, 0, 0.21471],
    58112: [0, 0.62119, 0, 0, 0.49749],
    58113: [0, 0.62119, 0, 0, 0.4983],
    58114: [0.18906, 0.69141, 0, 0, 0.33328],
    58115: [0.18906, 0.69141, 0, 0, 0.32923],
    58116: [0.18906, 0.47534, 0, 0, 0.50343],
    58117: [0, 0.69141, 0, 0, 0.33301],
    58118: [0, 0.62119, 0, 0, 0.33409],
    58119: [0, 0.47534, 0, 0, 0.50073]
  },
  "Main-Bold": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.35],
    34: [0, 0.69444, 0, 0, 0.60278],
    35: [0.19444, 0.69444, 0, 0, 0.95833],
    36: [0.05556, 0.75, 0, 0, 0.575],
    37: [0.05556, 0.75, 0, 0, 0.95833],
    38: [0, 0.69444, 0, 0, 0.89444],
    39: [0, 0.69444, 0, 0, 0.31944],
    40: [0.25, 0.75, 0, 0, 0.44722],
    41: [0.25, 0.75, 0, 0, 0.44722],
    42: [0, 0.75, 0, 0, 0.575],
    43: [0.13333, 0.63333, 0, 0, 0.89444],
    44: [0.19444, 0.15556, 0, 0, 0.31944],
    45: [0, 0.44444, 0, 0, 0.38333],
    46: [0, 0.15556, 0, 0, 0.31944],
    47: [0.25, 0.75, 0, 0, 0.575],
    48: [0, 0.64444, 0, 0, 0.575],
    49: [0, 0.64444, 0, 0, 0.575],
    50: [0, 0.64444, 0, 0, 0.575],
    51: [0, 0.64444, 0, 0, 0.575],
    52: [0, 0.64444, 0, 0, 0.575],
    53: [0, 0.64444, 0, 0, 0.575],
    54: [0, 0.64444, 0, 0, 0.575],
    55: [0, 0.64444, 0, 0, 0.575],
    56: [0, 0.64444, 0, 0, 0.575],
    57: [0, 0.64444, 0, 0, 0.575],
    58: [0, 0.44444, 0, 0, 0.31944],
    59: [0.19444, 0.44444, 0, 0, 0.31944],
    60: [0.08556, 0.58556, 0, 0, 0.89444],
    61: [-0.10889, 0.39111, 0, 0, 0.89444],
    62: [0.08556, 0.58556, 0, 0, 0.89444],
    63: [0, 0.69444, 0, 0, 0.54305],
    64: [0, 0.69444, 0, 0, 0.89444],
    65: [0, 0.68611, 0, 0, 0.86944],
    66: [0, 0.68611, 0, 0, 0.81805],
    67: [0, 0.68611, 0, 0, 0.83055],
    68: [0, 0.68611, 0, 0, 0.88194],
    69: [0, 0.68611, 0, 0, 0.75555],
    70: [0, 0.68611, 0, 0, 0.72361],
    71: [0, 0.68611, 0, 0, 0.90416],
    72: [0, 0.68611, 0, 0, 0.9],
    73: [0, 0.68611, 0, 0, 0.43611],
    74: [0, 0.68611, 0, 0, 0.59444],
    75: [0, 0.68611, 0, 0, 0.90138],
    76: [0, 0.68611, 0, 0, 0.69166],
    77: [0, 0.68611, 0, 0, 1.09166],
    78: [0, 0.68611, 0, 0, 0.9],
    79: [0, 0.68611, 0, 0, 0.86388],
    80: [0, 0.68611, 0, 0, 0.78611],
    81: [0.19444, 0.68611, 0, 0, 0.86388],
    82: [0, 0.68611, 0, 0, 0.8625],
    83: [0, 0.68611, 0, 0, 0.63889],
    84: [0, 0.68611, 0, 0, 0.8],
    85: [0, 0.68611, 0, 0, 0.88472],
    86: [0, 0.68611, 0.01597, 0, 0.86944],
    87: [0, 0.68611, 0.01597, 0, 1.18888],
    88: [0, 0.68611, 0, 0, 0.86944],
    89: [0, 0.68611, 0.02875, 0, 0.86944],
    90: [0, 0.68611, 0, 0, 0.70277],
    91: [0.25, 0.75, 0, 0, 0.31944],
    92: [0.25, 0.75, 0, 0, 0.575],
    93: [0.25, 0.75, 0, 0, 0.31944],
    94: [0, 0.69444, 0, 0, 0.575],
    95: [0.31, 0.13444, 0.03194, 0, 0.575],
    97: [0, 0.44444, 0, 0, 0.55902],
    98: [0, 0.69444, 0, 0, 0.63889],
    99: [0, 0.44444, 0, 0, 0.51111],
    100: [0, 0.69444, 0, 0, 0.63889],
    101: [0, 0.44444, 0, 0, 0.52708],
    102: [0, 0.69444, 0.10903, 0, 0.35139],
    103: [0.19444, 0.44444, 0.01597, 0, 0.575],
    104: [0, 0.69444, 0, 0, 0.63889],
    105: [0, 0.69444, 0, 0, 0.31944],
    106: [0.19444, 0.69444, 0, 0, 0.35139],
    107: [0, 0.69444, 0, 0, 0.60694],
    108: [0, 0.69444, 0, 0, 0.31944],
    109: [0, 0.44444, 0, 0, 0.95833],
    110: [0, 0.44444, 0, 0, 0.63889],
    111: [0, 0.44444, 0, 0, 0.575],
    112: [0.19444, 0.44444, 0, 0, 0.63889],
    113: [0.19444, 0.44444, 0, 0, 0.60694],
    114: [0, 0.44444, 0, 0, 0.47361],
    115: [0, 0.44444, 0, 0, 0.45361],
    116: [0, 0.63492, 0, 0, 0.44722],
    117: [0, 0.44444, 0, 0, 0.63889],
    118: [0, 0.44444, 0.01597, 0, 0.60694],
    119: [0, 0.44444, 0.01597, 0, 0.83055],
    120: [0, 0.44444, 0, 0, 0.60694],
    121: [0.19444, 0.44444, 0.01597, 0, 0.60694],
    122: [0, 0.44444, 0, 0, 0.51111],
    123: [0.25, 0.75, 0, 0, 0.575],
    124: [0.25, 0.75, 0, 0, 0.31944],
    125: [0.25, 0.75, 0, 0, 0.575],
    126: [0.35, 0.34444, 0, 0, 0.575],
    160: [0, 0, 0, 0, 0.25],
    163: [0, 0.69444, 0, 0, 0.86853],
    168: [0, 0.69444, 0, 0, 0.575],
    172: [0, 0.44444, 0, 0, 0.76666],
    176: [0, 0.69444, 0, 0, 0.86944],
    177: [0.13333, 0.63333, 0, 0, 0.89444],
    184: [0.17014, 0, 0, 0, 0.51111],
    198: [0, 0.68611, 0, 0, 1.04166],
    215: [0.13333, 0.63333, 0, 0, 0.89444],
    216: [0.04861, 0.73472, 0, 0, 0.89444],
    223: [0, 0.69444, 0, 0, 0.59722],
    230: [0, 0.44444, 0, 0, 0.83055],
    247: [0.13333, 0.63333, 0, 0, 0.89444],
    248: [0.09722, 0.54167, 0, 0, 0.575],
    305: [0, 0.44444, 0, 0, 0.31944],
    338: [0, 0.68611, 0, 0, 1.16944],
    339: [0, 0.44444, 0, 0, 0.89444],
    567: [0.19444, 0.44444, 0, 0, 0.35139],
    710: [0, 0.69444, 0, 0, 0.575],
    711: [0, 0.63194, 0, 0, 0.575],
    713: [0, 0.59611, 0, 0, 0.575],
    714: [0, 0.69444, 0, 0, 0.575],
    715: [0, 0.69444, 0, 0, 0.575],
    728: [0, 0.69444, 0, 0, 0.575],
    729: [0, 0.69444, 0, 0, 0.31944],
    730: [0, 0.69444, 0, 0, 0.86944],
    732: [0, 0.69444, 0, 0, 0.575],
    733: [0, 0.69444, 0, 0, 0.575],
    915: [0, 0.68611, 0, 0, 0.69166],
    916: [0, 0.68611, 0, 0, 0.95833],
    920: [0, 0.68611, 0, 0, 0.89444],
    923: [0, 0.68611, 0, 0, 0.80555],
    926: [0, 0.68611, 0, 0, 0.76666],
    928: [0, 0.68611, 0, 0, 0.9],
    931: [0, 0.68611, 0, 0, 0.83055],
    933: [0, 0.68611, 0, 0, 0.89444],
    934: [0, 0.68611, 0, 0, 0.83055],
    936: [0, 0.68611, 0, 0, 0.89444],
    937: [0, 0.68611, 0, 0, 0.83055],
    8211: [0, 0.44444, 0.03194, 0, 0.575],
    8212: [0, 0.44444, 0.03194, 0, 1.14999],
    8216: [0, 0.69444, 0, 0, 0.31944],
    8217: [0, 0.69444, 0, 0, 0.31944],
    8220: [0, 0.69444, 0, 0, 0.60278],
    8221: [0, 0.69444, 0, 0, 0.60278],
    8224: [0.19444, 0.69444, 0, 0, 0.51111],
    8225: [0.19444, 0.69444, 0, 0, 0.51111],
    8242: [0, 0.55556, 0, 0, 0.34444],
    8407: [0, 0.72444, 0.15486, 0, 0.575],
    8463: [0, 0.69444, 0, 0, 0.66759],
    8465: [0, 0.69444, 0, 0, 0.83055],
    8467: [0, 0.69444, 0, 0, 0.47361],
    8472: [0.19444, 0.44444, 0, 0, 0.74027],
    8476: [0, 0.69444, 0, 0, 0.83055],
    8501: [0, 0.69444, 0, 0, 0.70277],
    8592: [-0.10889, 0.39111, 0, 0, 1.14999],
    8593: [0.19444, 0.69444, 0, 0, 0.575],
    8594: [-0.10889, 0.39111, 0, 0, 1.14999],
    8595: [0.19444, 0.69444, 0, 0, 0.575],
    8596: [-0.10889, 0.39111, 0, 0, 1.14999],
    8597: [0.25, 0.75, 0, 0, 0.575],
    8598: [0.19444, 0.69444, 0, 0, 1.14999],
    8599: [0.19444, 0.69444, 0, 0, 1.14999],
    8600: [0.19444, 0.69444, 0, 0, 1.14999],
    8601: [0.19444, 0.69444, 0, 0, 1.14999],
    8636: [-0.10889, 0.39111, 0, 0, 1.14999],
    8637: [-0.10889, 0.39111, 0, 0, 1.14999],
    8640: [-0.10889, 0.39111, 0, 0, 1.14999],
    8641: [-0.10889, 0.39111, 0, 0, 1.14999],
    8656: [-0.10889, 0.39111, 0, 0, 1.14999],
    8657: [0.19444, 0.69444, 0, 0, 0.70277],
    8658: [-0.10889, 0.39111, 0, 0, 1.14999],
    8659: [0.19444, 0.69444, 0, 0, 0.70277],
    8660: [-0.10889, 0.39111, 0, 0, 1.14999],
    8661: [0.25, 0.75, 0, 0, 0.70277],
    8704: [0, 0.69444, 0, 0, 0.63889],
    8706: [0, 0.69444, 0.06389, 0, 0.62847],
    8707: [0, 0.69444, 0, 0, 0.63889],
    8709: [0.05556, 0.75, 0, 0, 0.575],
    8711: [0, 0.68611, 0, 0, 0.95833],
    8712: [0.08556, 0.58556, 0, 0, 0.76666],
    8715: [0.08556, 0.58556, 0, 0, 0.76666],
    8722: [0.13333, 0.63333, 0, 0, 0.89444],
    8723: [0.13333, 0.63333, 0, 0, 0.89444],
    8725: [0.25, 0.75, 0, 0, 0.575],
    8726: [0.25, 0.75, 0, 0, 0.575],
    8727: [-0.02778, 0.47222, 0, 0, 0.575],
    8728: [-0.02639, 0.47361, 0, 0, 0.575],
    8729: [-0.02639, 0.47361, 0, 0, 0.575],
    8730: [0.18, 0.82, 0, 0, 0.95833],
    8733: [0, 0.44444, 0, 0, 0.89444],
    8734: [0, 0.44444, 0, 0, 1.14999],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8739: [0.25, 0.75, 0, 0, 0.31944],
    8741: [0.25, 0.75, 0, 0, 0.575],
    8743: [0, 0.55556, 0, 0, 0.76666],
    8744: [0, 0.55556, 0, 0, 0.76666],
    8745: [0, 0.55556, 0, 0, 0.76666],
    8746: [0, 0.55556, 0, 0, 0.76666],
    8747: [0.19444, 0.69444, 0.12778, 0, 0.56875],
    8764: [-0.10889, 0.39111, 0, 0, 0.89444],
    8768: [0.19444, 0.69444, 0, 0, 0.31944],
    8771: [222e-5, 0.50222, 0, 0, 0.89444],
    8773: [0.027, 0.638, 0, 0, 0.894],
    8776: [0.02444, 0.52444, 0, 0, 0.89444],
    8781: [222e-5, 0.50222, 0, 0, 0.89444],
    8801: [222e-5, 0.50222, 0, 0, 0.89444],
    8804: [0.19667, 0.69667, 0, 0, 0.89444],
    8805: [0.19667, 0.69667, 0, 0, 0.89444],
    8810: [0.08556, 0.58556, 0, 0, 1.14999],
    8811: [0.08556, 0.58556, 0, 0, 1.14999],
    8826: [0.08556, 0.58556, 0, 0, 0.89444],
    8827: [0.08556, 0.58556, 0, 0, 0.89444],
    8834: [0.08556, 0.58556, 0, 0, 0.89444],
    8835: [0.08556, 0.58556, 0, 0, 0.89444],
    8838: [0.19667, 0.69667, 0, 0, 0.89444],
    8839: [0.19667, 0.69667, 0, 0, 0.89444],
    8846: [0, 0.55556, 0, 0, 0.76666],
    8849: [0.19667, 0.69667, 0, 0, 0.89444],
    8850: [0.19667, 0.69667, 0, 0, 0.89444],
    8851: [0, 0.55556, 0, 0, 0.76666],
    8852: [0, 0.55556, 0, 0, 0.76666],
    8853: [0.13333, 0.63333, 0, 0, 0.89444],
    8854: [0.13333, 0.63333, 0, 0, 0.89444],
    8855: [0.13333, 0.63333, 0, 0, 0.89444],
    8856: [0.13333, 0.63333, 0, 0, 0.89444],
    8857: [0.13333, 0.63333, 0, 0, 0.89444],
    8866: [0, 0.69444, 0, 0, 0.70277],
    8867: [0, 0.69444, 0, 0, 0.70277],
    8868: [0, 0.69444, 0, 0, 0.89444],
    8869: [0, 0.69444, 0, 0, 0.89444],
    8900: [-0.02639, 0.47361, 0, 0, 0.575],
    8901: [-0.02639, 0.47361, 0, 0, 0.31944],
    8902: [-0.02778, 0.47222, 0, 0, 0.575],
    8968: [0.25, 0.75, 0, 0, 0.51111],
    8969: [0.25, 0.75, 0, 0, 0.51111],
    8970: [0.25, 0.75, 0, 0, 0.51111],
    8971: [0.25, 0.75, 0, 0, 0.51111],
    8994: [-0.13889, 0.36111, 0, 0, 1.14999],
    8995: [-0.13889, 0.36111, 0, 0, 1.14999],
    9651: [0.19444, 0.69444, 0, 0, 1.02222],
    9657: [-0.02778, 0.47222, 0, 0, 0.575],
    9661: [0.19444, 0.69444, 0, 0, 1.02222],
    9667: [-0.02778, 0.47222, 0, 0, 0.575],
    9711: [0.19444, 0.69444, 0, 0, 1.14999],
    9824: [0.12963, 0.69444, 0, 0, 0.89444],
    9825: [0.12963, 0.69444, 0, 0, 0.89444],
    9826: [0.12963, 0.69444, 0, 0, 0.89444],
    9827: [0.12963, 0.69444, 0, 0, 0.89444],
    9837: [0, 0.75, 0, 0, 0.44722],
    9838: [0.19444, 0.69444, 0, 0, 0.44722],
    9839: [0.19444, 0.69444, 0, 0, 0.44722],
    10216: [0.25, 0.75, 0, 0, 0.44722],
    10217: [0.25, 0.75, 0, 0, 0.44722],
    10815: [0, 0.68611, 0, 0, 0.9],
    10927: [0.19667, 0.69667, 0, 0, 0.89444],
    10928: [0.19667, 0.69667, 0, 0, 0.89444],
    57376: [0.19444, 0.69444, 0, 0, 0]
  },
  "Main-BoldItalic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.11417, 0, 0.38611],
    34: [0, 0.69444, 0.07939, 0, 0.62055],
    35: [0.19444, 0.69444, 0.06833, 0, 0.94444],
    37: [0.05556, 0.75, 0.12861, 0, 0.94444],
    38: [0, 0.69444, 0.08528, 0, 0.88555],
    39: [0, 0.69444, 0.12945, 0, 0.35555],
    40: [0.25, 0.75, 0.15806, 0, 0.47333],
    41: [0.25, 0.75, 0.03306, 0, 0.47333],
    42: [0, 0.75, 0.14333, 0, 0.59111],
    43: [0.10333, 0.60333, 0.03306, 0, 0.88555],
    44: [0.19444, 0.14722, 0, 0, 0.35555],
    45: [0, 0.44444, 0.02611, 0, 0.41444],
    46: [0, 0.14722, 0, 0, 0.35555],
    47: [0.25, 0.75, 0.15806, 0, 0.59111],
    48: [0, 0.64444, 0.13167, 0, 0.59111],
    49: [0, 0.64444, 0.13167, 0, 0.59111],
    50: [0, 0.64444, 0.13167, 0, 0.59111],
    51: [0, 0.64444, 0.13167, 0, 0.59111],
    52: [0.19444, 0.64444, 0.13167, 0, 0.59111],
    53: [0, 0.64444, 0.13167, 0, 0.59111],
    54: [0, 0.64444, 0.13167, 0, 0.59111],
    55: [0.19444, 0.64444, 0.13167, 0, 0.59111],
    56: [0, 0.64444, 0.13167, 0, 0.59111],
    57: [0, 0.64444, 0.13167, 0, 0.59111],
    58: [0, 0.44444, 0.06695, 0, 0.35555],
    59: [0.19444, 0.44444, 0.06695, 0, 0.35555],
    61: [-0.10889, 0.39111, 0.06833, 0, 0.88555],
    63: [0, 0.69444, 0.11472, 0, 0.59111],
    64: [0, 0.69444, 0.09208, 0, 0.88555],
    65: [0, 0.68611, 0, 0, 0.86555],
    66: [0, 0.68611, 0.0992, 0, 0.81666],
    67: [0, 0.68611, 0.14208, 0, 0.82666],
    68: [0, 0.68611, 0.09062, 0, 0.87555],
    69: [0, 0.68611, 0.11431, 0, 0.75666],
    70: [0, 0.68611, 0.12903, 0, 0.72722],
    71: [0, 0.68611, 0.07347, 0, 0.89527],
    72: [0, 0.68611, 0.17208, 0, 0.8961],
    73: [0, 0.68611, 0.15681, 0, 0.47166],
    74: [0, 0.68611, 0.145, 0, 0.61055],
    75: [0, 0.68611, 0.14208, 0, 0.89499],
    76: [0, 0.68611, 0, 0, 0.69777],
    77: [0, 0.68611, 0.17208, 0, 1.07277],
    78: [0, 0.68611, 0.17208, 0, 0.8961],
    79: [0, 0.68611, 0.09062, 0, 0.85499],
    80: [0, 0.68611, 0.0992, 0, 0.78721],
    81: [0.19444, 0.68611, 0.09062, 0, 0.85499],
    82: [0, 0.68611, 0.02559, 0, 0.85944],
    83: [0, 0.68611, 0.11264, 0, 0.64999],
    84: [0, 0.68611, 0.12903, 0, 0.7961],
    85: [0, 0.68611, 0.17208, 0, 0.88083],
    86: [0, 0.68611, 0.18625, 0, 0.86555],
    87: [0, 0.68611, 0.18625, 0, 1.15999],
    88: [0, 0.68611, 0.15681, 0, 0.86555],
    89: [0, 0.68611, 0.19803, 0, 0.86555],
    90: [0, 0.68611, 0.14208, 0, 0.70888],
    91: [0.25, 0.75, 0.1875, 0, 0.35611],
    93: [0.25, 0.75, 0.09972, 0, 0.35611],
    94: [0, 0.69444, 0.06709, 0, 0.59111],
    95: [0.31, 0.13444, 0.09811, 0, 0.59111],
    97: [0, 0.44444, 0.09426, 0, 0.59111],
    98: [0, 0.69444, 0.07861, 0, 0.53222],
    99: [0, 0.44444, 0.05222, 0, 0.53222],
    100: [0, 0.69444, 0.10861, 0, 0.59111],
    101: [0, 0.44444, 0.085, 0, 0.53222],
    102: [0.19444, 0.69444, 0.21778, 0, 0.4],
    103: [0.19444, 0.44444, 0.105, 0, 0.53222],
    104: [0, 0.69444, 0.09426, 0, 0.59111],
    105: [0, 0.69326, 0.11387, 0, 0.35555],
    106: [0.19444, 0.69326, 0.1672, 0, 0.35555],
    107: [0, 0.69444, 0.11111, 0, 0.53222],
    108: [0, 0.69444, 0.10861, 0, 0.29666],
    109: [0, 0.44444, 0.09426, 0, 0.94444],
    110: [0, 0.44444, 0.09426, 0, 0.64999],
    111: [0, 0.44444, 0.07861, 0, 0.59111],
    112: [0.19444, 0.44444, 0.07861, 0, 0.59111],
    113: [0.19444, 0.44444, 0.105, 0, 0.53222],
    114: [0, 0.44444, 0.11111, 0, 0.50167],
    115: [0, 0.44444, 0.08167, 0, 0.48694],
    116: [0, 0.63492, 0.09639, 0, 0.385],
    117: [0, 0.44444, 0.09426, 0, 0.62055],
    118: [0, 0.44444, 0.11111, 0, 0.53222],
    119: [0, 0.44444, 0.11111, 0, 0.76777],
    120: [0, 0.44444, 0.12583, 0, 0.56055],
    121: [0.19444, 0.44444, 0.105, 0, 0.56166],
    122: [0, 0.44444, 0.13889, 0, 0.49055],
    126: [0.35, 0.34444, 0.11472, 0, 0.59111],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.69444, 0.11473, 0, 0.59111],
    176: [0, 0.69444, 0, 0, 0.94888],
    184: [0.17014, 0, 0, 0, 0.53222],
    198: [0, 0.68611, 0.11431, 0, 1.02277],
    216: [0.04861, 0.73472, 0.09062, 0, 0.88555],
    223: [0.19444, 0.69444, 0.09736, 0, 0.665],
    230: [0, 0.44444, 0.085, 0, 0.82666],
    248: [0.09722, 0.54167, 0.09458, 0, 0.59111],
    305: [0, 0.44444, 0.09426, 0, 0.35555],
    338: [0, 0.68611, 0.11431, 0, 1.14054],
    339: [0, 0.44444, 0.085, 0, 0.82666],
    567: [0.19444, 0.44444, 0.04611, 0, 0.385],
    710: [0, 0.69444, 0.06709, 0, 0.59111],
    711: [0, 0.63194, 0.08271, 0, 0.59111],
    713: [0, 0.59444, 0.10444, 0, 0.59111],
    714: [0, 0.69444, 0.08528, 0, 0.59111],
    715: [0, 0.69444, 0, 0, 0.59111],
    728: [0, 0.69444, 0.10333, 0, 0.59111],
    729: [0, 0.69444, 0.12945, 0, 0.35555],
    730: [0, 0.69444, 0, 0, 0.94888],
    732: [0, 0.69444, 0.11472, 0, 0.59111],
    733: [0, 0.69444, 0.11472, 0, 0.59111],
    915: [0, 0.68611, 0.12903, 0, 0.69777],
    916: [0, 0.68611, 0, 0, 0.94444],
    920: [0, 0.68611, 0.09062, 0, 0.88555],
    923: [0, 0.68611, 0, 0, 0.80666],
    926: [0, 0.68611, 0.15092, 0, 0.76777],
    928: [0, 0.68611, 0.17208, 0, 0.8961],
    931: [0, 0.68611, 0.11431, 0, 0.82666],
    933: [0, 0.68611, 0.10778, 0, 0.88555],
    934: [0, 0.68611, 0.05632, 0, 0.82666],
    936: [0, 0.68611, 0.10778, 0, 0.88555],
    937: [0, 0.68611, 0.0992, 0, 0.82666],
    8211: [0, 0.44444, 0.09811, 0, 0.59111],
    8212: [0, 0.44444, 0.09811, 0, 1.18221],
    8216: [0, 0.69444, 0.12945, 0, 0.35555],
    8217: [0, 0.69444, 0.12945, 0, 0.35555],
    8220: [0, 0.69444, 0.16772, 0, 0.62055],
    8221: [0, 0.69444, 0.07939, 0, 0.62055]
  },
  "Main-Italic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.12417, 0, 0.30667],
    34: [0, 0.69444, 0.06961, 0, 0.51444],
    35: [0.19444, 0.69444, 0.06616, 0, 0.81777],
    37: [0.05556, 0.75, 0.13639, 0, 0.81777],
    38: [0, 0.69444, 0.09694, 0, 0.76666],
    39: [0, 0.69444, 0.12417, 0, 0.30667],
    40: [0.25, 0.75, 0.16194, 0, 0.40889],
    41: [0.25, 0.75, 0.03694, 0, 0.40889],
    42: [0, 0.75, 0.14917, 0, 0.51111],
    43: [0.05667, 0.56167, 0.03694, 0, 0.76666],
    44: [0.19444, 0.10556, 0, 0, 0.30667],
    45: [0, 0.43056, 0.02826, 0, 0.35778],
    46: [0, 0.10556, 0, 0, 0.30667],
    47: [0.25, 0.75, 0.16194, 0, 0.51111],
    48: [0, 0.64444, 0.13556, 0, 0.51111],
    49: [0, 0.64444, 0.13556, 0, 0.51111],
    50: [0, 0.64444, 0.13556, 0, 0.51111],
    51: [0, 0.64444, 0.13556, 0, 0.51111],
    52: [0.19444, 0.64444, 0.13556, 0, 0.51111],
    53: [0, 0.64444, 0.13556, 0, 0.51111],
    54: [0, 0.64444, 0.13556, 0, 0.51111],
    55: [0.19444, 0.64444, 0.13556, 0, 0.51111],
    56: [0, 0.64444, 0.13556, 0, 0.51111],
    57: [0, 0.64444, 0.13556, 0, 0.51111],
    58: [0, 0.43056, 0.0582, 0, 0.30667],
    59: [0.19444, 0.43056, 0.0582, 0, 0.30667],
    61: [-0.13313, 0.36687, 0.06616, 0, 0.76666],
    63: [0, 0.69444, 0.1225, 0, 0.51111],
    64: [0, 0.69444, 0.09597, 0, 0.76666],
    65: [0, 0.68333, 0, 0, 0.74333],
    66: [0, 0.68333, 0.10257, 0, 0.70389],
    67: [0, 0.68333, 0.14528, 0, 0.71555],
    68: [0, 0.68333, 0.09403, 0, 0.755],
    69: [0, 0.68333, 0.12028, 0, 0.67833],
    70: [0, 0.68333, 0.13305, 0, 0.65277],
    71: [0, 0.68333, 0.08722, 0, 0.77361],
    72: [0, 0.68333, 0.16389, 0, 0.74333],
    73: [0, 0.68333, 0.15806, 0, 0.38555],
    74: [0, 0.68333, 0.14028, 0, 0.525],
    75: [0, 0.68333, 0.14528, 0, 0.76888],
    76: [0, 0.68333, 0, 0, 0.62722],
    77: [0, 0.68333, 0.16389, 0, 0.89666],
    78: [0, 0.68333, 0.16389, 0, 0.74333],
    79: [0, 0.68333, 0.09403, 0, 0.76666],
    80: [0, 0.68333, 0.10257, 0, 0.67833],
    81: [0.19444, 0.68333, 0.09403, 0, 0.76666],
    82: [0, 0.68333, 0.03868, 0, 0.72944],
    83: [0, 0.68333, 0.11972, 0, 0.56222],
    84: [0, 0.68333, 0.13305, 0, 0.71555],
    85: [0, 0.68333, 0.16389, 0, 0.74333],
    86: [0, 0.68333, 0.18361, 0, 0.74333],
    87: [0, 0.68333, 0.18361, 0, 0.99888],
    88: [0, 0.68333, 0.15806, 0, 0.74333],
    89: [0, 0.68333, 0.19383, 0, 0.74333],
    90: [0, 0.68333, 0.14528, 0, 0.61333],
    91: [0.25, 0.75, 0.1875, 0, 0.30667],
    93: [0.25, 0.75, 0.10528, 0, 0.30667],
    94: [0, 0.69444, 0.06646, 0, 0.51111],
    95: [0.31, 0.12056, 0.09208, 0, 0.51111],
    97: [0, 0.43056, 0.07671, 0, 0.51111],
    98: [0, 0.69444, 0.06312, 0, 0.46],
    99: [0, 0.43056, 0.05653, 0, 0.46],
    100: [0, 0.69444, 0.10333, 0, 0.51111],
    101: [0, 0.43056, 0.07514, 0, 0.46],
    102: [0.19444, 0.69444, 0.21194, 0, 0.30667],
    103: [0.19444, 0.43056, 0.08847, 0, 0.46],
    104: [0, 0.69444, 0.07671, 0, 0.51111],
    105: [0, 0.65536, 0.1019, 0, 0.30667],
    106: [0.19444, 0.65536, 0.14467, 0, 0.30667],
    107: [0, 0.69444, 0.10764, 0, 0.46],
    108: [0, 0.69444, 0.10333, 0, 0.25555],
    109: [0, 0.43056, 0.07671, 0, 0.81777],
    110: [0, 0.43056, 0.07671, 0, 0.56222],
    111: [0, 0.43056, 0.06312, 0, 0.51111],
    112: [0.19444, 0.43056, 0.06312, 0, 0.51111],
    113: [0.19444, 0.43056, 0.08847, 0, 0.46],
    114: [0, 0.43056, 0.10764, 0, 0.42166],
    115: [0, 0.43056, 0.08208, 0, 0.40889],
    116: [0, 0.61508, 0.09486, 0, 0.33222],
    117: [0, 0.43056, 0.07671, 0, 0.53666],
    118: [0, 0.43056, 0.10764, 0, 0.46],
    119: [0, 0.43056, 0.10764, 0, 0.66444],
    120: [0, 0.43056, 0.12042, 0, 0.46389],
    121: [0.19444, 0.43056, 0.08847, 0, 0.48555],
    122: [0, 0.43056, 0.12292, 0, 0.40889],
    126: [0.35, 0.31786, 0.11585, 0, 0.51111],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.66786, 0.10474, 0, 0.51111],
    176: [0, 0.69444, 0, 0, 0.83129],
    184: [0.17014, 0, 0, 0, 0.46],
    198: [0, 0.68333, 0.12028, 0, 0.88277],
    216: [0.04861, 0.73194, 0.09403, 0, 0.76666],
    223: [0.19444, 0.69444, 0.10514, 0, 0.53666],
    230: [0, 0.43056, 0.07514, 0, 0.71555],
    248: [0.09722, 0.52778, 0.09194, 0, 0.51111],
    338: [0, 0.68333, 0.12028, 0, 0.98499],
    339: [0, 0.43056, 0.07514, 0, 0.71555],
    710: [0, 0.69444, 0.06646, 0, 0.51111],
    711: [0, 0.62847, 0.08295, 0, 0.51111],
    713: [0, 0.56167, 0.10333, 0, 0.51111],
    714: [0, 0.69444, 0.09694, 0, 0.51111],
    715: [0, 0.69444, 0, 0, 0.51111],
    728: [0, 0.69444, 0.10806, 0, 0.51111],
    729: [0, 0.66786, 0.11752, 0, 0.30667],
    730: [0, 0.69444, 0, 0, 0.83129],
    732: [0, 0.66786, 0.11585, 0, 0.51111],
    733: [0, 0.69444, 0.1225, 0, 0.51111],
    915: [0, 0.68333, 0.13305, 0, 0.62722],
    916: [0, 0.68333, 0, 0, 0.81777],
    920: [0, 0.68333, 0.09403, 0, 0.76666],
    923: [0, 0.68333, 0, 0, 0.69222],
    926: [0, 0.68333, 0.15294, 0, 0.66444],
    928: [0, 0.68333, 0.16389, 0, 0.74333],
    931: [0, 0.68333, 0.12028, 0, 0.71555],
    933: [0, 0.68333, 0.11111, 0, 0.76666],
    934: [0, 0.68333, 0.05986, 0, 0.71555],
    936: [0, 0.68333, 0.11111, 0, 0.76666],
    937: [0, 0.68333, 0.10257, 0, 0.71555],
    8211: [0, 0.43056, 0.09208, 0, 0.51111],
    8212: [0, 0.43056, 0.09208, 0, 1.02222],
    8216: [0, 0.69444, 0.12417, 0, 0.30667],
    8217: [0, 0.69444, 0.12417, 0, 0.30667],
    8220: [0, 0.69444, 0.1685, 0, 0.51444],
    8221: [0, 0.69444, 0.06961, 0, 0.51444],
    8463: [0, 0.68889, 0, 0, 0.54028]
  },
  "Main-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.27778],
    34: [0, 0.69444, 0, 0, 0.5],
    35: [0.19444, 0.69444, 0, 0, 0.83334],
    36: [0.05556, 0.75, 0, 0, 0.5],
    37: [0.05556, 0.75, 0, 0, 0.83334],
    38: [0, 0.69444, 0, 0, 0.77778],
    39: [0, 0.69444, 0, 0, 0.27778],
    40: [0.25, 0.75, 0, 0, 0.38889],
    41: [0.25, 0.75, 0, 0, 0.38889],
    42: [0, 0.75, 0, 0, 0.5],
    43: [0.08333, 0.58333, 0, 0, 0.77778],
    44: [0.19444, 0.10556, 0, 0, 0.27778],
    45: [0, 0.43056, 0, 0, 0.33333],
    46: [0, 0.10556, 0, 0, 0.27778],
    47: [0.25, 0.75, 0, 0, 0.5],
    48: [0, 0.64444, 0, 0, 0.5],
    49: [0, 0.64444, 0, 0, 0.5],
    50: [0, 0.64444, 0, 0, 0.5],
    51: [0, 0.64444, 0, 0, 0.5],
    52: [0, 0.64444, 0, 0, 0.5],
    53: [0, 0.64444, 0, 0, 0.5],
    54: [0, 0.64444, 0, 0, 0.5],
    55: [0, 0.64444, 0, 0, 0.5],
    56: [0, 0.64444, 0, 0, 0.5],
    57: [0, 0.64444, 0, 0, 0.5],
    58: [0, 0.43056, 0, 0, 0.27778],
    59: [0.19444, 0.43056, 0, 0, 0.27778],
    60: [0.0391, 0.5391, 0, 0, 0.77778],
    61: [-0.13313, 0.36687, 0, 0, 0.77778],
    62: [0.0391, 0.5391, 0, 0, 0.77778],
    63: [0, 0.69444, 0, 0, 0.47222],
    64: [0, 0.69444, 0, 0, 0.77778],
    65: [0, 0.68333, 0, 0, 0.75],
    66: [0, 0.68333, 0, 0, 0.70834],
    67: [0, 0.68333, 0, 0, 0.72222],
    68: [0, 0.68333, 0, 0, 0.76389],
    69: [0, 0.68333, 0, 0, 0.68056],
    70: [0, 0.68333, 0, 0, 0.65278],
    71: [0, 0.68333, 0, 0, 0.78472],
    72: [0, 0.68333, 0, 0, 0.75],
    73: [0, 0.68333, 0, 0, 0.36111],
    74: [0, 0.68333, 0, 0, 0.51389],
    75: [0, 0.68333, 0, 0, 0.77778],
    76: [0, 0.68333, 0, 0, 0.625],
    77: [0, 0.68333, 0, 0, 0.91667],
    78: [0, 0.68333, 0, 0, 0.75],
    79: [0, 0.68333, 0, 0, 0.77778],
    80: [0, 0.68333, 0, 0, 0.68056],
    81: [0.19444, 0.68333, 0, 0, 0.77778],
    82: [0, 0.68333, 0, 0, 0.73611],
    83: [0, 0.68333, 0, 0, 0.55556],
    84: [0, 0.68333, 0, 0, 0.72222],
    85: [0, 0.68333, 0, 0, 0.75],
    86: [0, 0.68333, 0.01389, 0, 0.75],
    87: [0, 0.68333, 0.01389, 0, 1.02778],
    88: [0, 0.68333, 0, 0, 0.75],
    89: [0, 0.68333, 0.025, 0, 0.75],
    90: [0, 0.68333, 0, 0, 0.61111],
    91: [0.25, 0.75, 0, 0, 0.27778],
    92: [0.25, 0.75, 0, 0, 0.5],
    93: [0.25, 0.75, 0, 0, 0.27778],
    94: [0, 0.69444, 0, 0, 0.5],
    95: [0.31, 0.12056, 0.02778, 0, 0.5],
    97: [0, 0.43056, 0, 0, 0.5],
    98: [0, 0.69444, 0, 0, 0.55556],
    99: [0, 0.43056, 0, 0, 0.44445],
    100: [0, 0.69444, 0, 0, 0.55556],
    101: [0, 0.43056, 0, 0, 0.44445],
    102: [0, 0.69444, 0.07778, 0, 0.30556],
    103: [0.19444, 0.43056, 0.01389, 0, 0.5],
    104: [0, 0.69444, 0, 0, 0.55556],
    105: [0, 0.66786, 0, 0, 0.27778],
    106: [0.19444, 0.66786, 0, 0, 0.30556],
    107: [0, 0.69444, 0, 0, 0.52778],
    108: [0, 0.69444, 0, 0, 0.27778],
    109: [0, 0.43056, 0, 0, 0.83334],
    110: [0, 0.43056, 0, 0, 0.55556],
    111: [0, 0.43056, 0, 0, 0.5],
    112: [0.19444, 0.43056, 0, 0, 0.55556],
    113: [0.19444, 0.43056, 0, 0, 0.52778],
    114: [0, 0.43056, 0, 0, 0.39167],
    115: [0, 0.43056, 0, 0, 0.39445],
    116: [0, 0.61508, 0, 0, 0.38889],
    117: [0, 0.43056, 0, 0, 0.55556],
    118: [0, 0.43056, 0.01389, 0, 0.52778],
    119: [0, 0.43056, 0.01389, 0, 0.72222],
    120: [0, 0.43056, 0, 0, 0.52778],
    121: [0.19444, 0.43056, 0.01389, 0, 0.52778],
    122: [0, 0.43056, 0, 0, 0.44445],
    123: [0.25, 0.75, 0, 0, 0.5],
    124: [0.25, 0.75, 0, 0, 0.27778],
    125: [0.25, 0.75, 0, 0, 0.5],
    126: [0.35, 0.31786, 0, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    163: [0, 0.69444, 0, 0, 0.76909],
    167: [0.19444, 0.69444, 0, 0, 0.44445],
    168: [0, 0.66786, 0, 0, 0.5],
    172: [0, 0.43056, 0, 0, 0.66667],
    176: [0, 0.69444, 0, 0, 0.75],
    177: [0.08333, 0.58333, 0, 0, 0.77778],
    182: [0.19444, 0.69444, 0, 0, 0.61111],
    184: [0.17014, 0, 0, 0, 0.44445],
    198: [0, 0.68333, 0, 0, 0.90278],
    215: [0.08333, 0.58333, 0, 0, 0.77778],
    216: [0.04861, 0.73194, 0, 0, 0.77778],
    223: [0, 0.69444, 0, 0, 0.5],
    230: [0, 0.43056, 0, 0, 0.72222],
    247: [0.08333, 0.58333, 0, 0, 0.77778],
    248: [0.09722, 0.52778, 0, 0, 0.5],
    305: [0, 0.43056, 0, 0, 0.27778],
    338: [0, 0.68333, 0, 0, 1.01389],
    339: [0, 0.43056, 0, 0, 0.77778],
    567: [0.19444, 0.43056, 0, 0, 0.30556],
    710: [0, 0.69444, 0, 0, 0.5],
    711: [0, 0.62847, 0, 0, 0.5],
    713: [0, 0.56778, 0, 0, 0.5],
    714: [0, 0.69444, 0, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0, 0, 0.5],
    729: [0, 0.66786, 0, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.75],
    732: [0, 0.66786, 0, 0, 0.5],
    733: [0, 0.69444, 0, 0, 0.5],
    915: [0, 0.68333, 0, 0, 0.625],
    916: [0, 0.68333, 0, 0, 0.83334],
    920: [0, 0.68333, 0, 0, 0.77778],
    923: [0, 0.68333, 0, 0, 0.69445],
    926: [0, 0.68333, 0, 0, 0.66667],
    928: [0, 0.68333, 0, 0, 0.75],
    931: [0, 0.68333, 0, 0, 0.72222],
    933: [0, 0.68333, 0, 0, 0.77778],
    934: [0, 0.68333, 0, 0, 0.72222],
    936: [0, 0.68333, 0, 0, 0.77778],
    937: [0, 0.68333, 0, 0, 0.72222],
    8211: [0, 0.43056, 0.02778, 0, 0.5],
    8212: [0, 0.43056, 0.02778, 0, 1],
    8216: [0, 0.69444, 0, 0, 0.27778],
    8217: [0, 0.69444, 0, 0, 0.27778],
    8220: [0, 0.69444, 0, 0, 0.5],
    8221: [0, 0.69444, 0, 0, 0.5],
    8224: [0.19444, 0.69444, 0, 0, 0.44445],
    8225: [0.19444, 0.69444, 0, 0, 0.44445],
    8230: [0, 0.123, 0, 0, 1.172],
    8242: [0, 0.55556, 0, 0, 0.275],
    8407: [0, 0.71444, 0.15382, 0, 0.5],
    8463: [0, 0.68889, 0, 0, 0.54028],
    8465: [0, 0.69444, 0, 0, 0.72222],
    8467: [0, 0.69444, 0, 0.11111, 0.41667],
    8472: [0.19444, 0.43056, 0, 0.11111, 0.63646],
    8476: [0, 0.69444, 0, 0, 0.72222],
    8501: [0, 0.69444, 0, 0, 0.61111],
    8592: [-0.13313, 0.36687, 0, 0, 1],
    8593: [0.19444, 0.69444, 0, 0, 0.5],
    8594: [-0.13313, 0.36687, 0, 0, 1],
    8595: [0.19444, 0.69444, 0, 0, 0.5],
    8596: [-0.13313, 0.36687, 0, 0, 1],
    8597: [0.25, 0.75, 0, 0, 0.5],
    8598: [0.19444, 0.69444, 0, 0, 1],
    8599: [0.19444, 0.69444, 0, 0, 1],
    8600: [0.19444, 0.69444, 0, 0, 1],
    8601: [0.19444, 0.69444, 0, 0, 1],
    8614: [0.011, 0.511, 0, 0, 1],
    8617: [0.011, 0.511, 0, 0, 1.126],
    8618: [0.011, 0.511, 0, 0, 1.126],
    8636: [-0.13313, 0.36687, 0, 0, 1],
    8637: [-0.13313, 0.36687, 0, 0, 1],
    8640: [-0.13313, 0.36687, 0, 0, 1],
    8641: [-0.13313, 0.36687, 0, 0, 1],
    8652: [0.011, 0.671, 0, 0, 1],
    8656: [-0.13313, 0.36687, 0, 0, 1],
    8657: [0.19444, 0.69444, 0, 0, 0.61111],
    8658: [-0.13313, 0.36687, 0, 0, 1],
    8659: [0.19444, 0.69444, 0, 0, 0.61111],
    8660: [-0.13313, 0.36687, 0, 0, 1],
    8661: [0.25, 0.75, 0, 0, 0.61111],
    8704: [0, 0.69444, 0, 0, 0.55556],
    8706: [0, 0.69444, 0.05556, 0.08334, 0.5309],
    8707: [0, 0.69444, 0, 0, 0.55556],
    8709: [0.05556, 0.75, 0, 0, 0.5],
    8711: [0, 0.68333, 0, 0, 0.83334],
    8712: [0.0391, 0.5391, 0, 0, 0.66667],
    8715: [0.0391, 0.5391, 0, 0, 0.66667],
    8722: [0.08333, 0.58333, 0, 0, 0.77778],
    8723: [0.08333, 0.58333, 0, 0, 0.77778],
    8725: [0.25, 0.75, 0, 0, 0.5],
    8726: [0.25, 0.75, 0, 0, 0.5],
    8727: [-0.03472, 0.46528, 0, 0, 0.5],
    8728: [-0.05555, 0.44445, 0, 0, 0.5],
    8729: [-0.05555, 0.44445, 0, 0, 0.5],
    8730: [0.2, 0.8, 0, 0, 0.83334],
    8733: [0, 0.43056, 0, 0, 0.77778],
    8734: [0, 0.43056, 0, 0, 1],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8739: [0.25, 0.75, 0, 0, 0.27778],
    8741: [0.25, 0.75, 0, 0, 0.5],
    8743: [0, 0.55556, 0, 0, 0.66667],
    8744: [0, 0.55556, 0, 0, 0.66667],
    8745: [0, 0.55556, 0, 0, 0.66667],
    8746: [0, 0.55556, 0, 0, 0.66667],
    8747: [0.19444, 0.69444, 0.11111, 0, 0.41667],
    8764: [-0.13313, 0.36687, 0, 0, 0.77778],
    8768: [0.19444, 0.69444, 0, 0, 0.27778],
    8771: [-0.03625, 0.46375, 0, 0, 0.77778],
    8773: [-0.022, 0.589, 0, 0, 0.778],
    8776: [-0.01688, 0.48312, 0, 0, 0.77778],
    8781: [-0.03625, 0.46375, 0, 0, 0.77778],
    8784: [-0.133, 0.673, 0, 0, 0.778],
    8801: [-0.03625, 0.46375, 0, 0, 0.77778],
    8804: [0.13597, 0.63597, 0, 0, 0.77778],
    8805: [0.13597, 0.63597, 0, 0, 0.77778],
    8810: [0.0391, 0.5391, 0, 0, 1],
    8811: [0.0391, 0.5391, 0, 0, 1],
    8826: [0.0391, 0.5391, 0, 0, 0.77778],
    8827: [0.0391, 0.5391, 0, 0, 0.77778],
    8834: [0.0391, 0.5391, 0, 0, 0.77778],
    8835: [0.0391, 0.5391, 0, 0, 0.77778],
    8838: [0.13597, 0.63597, 0, 0, 0.77778],
    8839: [0.13597, 0.63597, 0, 0, 0.77778],
    8846: [0, 0.55556, 0, 0, 0.66667],
    8849: [0.13597, 0.63597, 0, 0, 0.77778],
    8850: [0.13597, 0.63597, 0, 0, 0.77778],
    8851: [0, 0.55556, 0, 0, 0.66667],
    8852: [0, 0.55556, 0, 0, 0.66667],
    8853: [0.08333, 0.58333, 0, 0, 0.77778],
    8854: [0.08333, 0.58333, 0, 0, 0.77778],
    8855: [0.08333, 0.58333, 0, 0, 0.77778],
    8856: [0.08333, 0.58333, 0, 0, 0.77778],
    8857: [0.08333, 0.58333, 0, 0, 0.77778],
    8866: [0, 0.69444, 0, 0, 0.61111],
    8867: [0, 0.69444, 0, 0, 0.61111],
    8868: [0, 0.69444, 0, 0, 0.77778],
    8869: [0, 0.69444, 0, 0, 0.77778],
    8872: [0.249, 0.75, 0, 0, 0.867],
    8900: [-0.05555, 0.44445, 0, 0, 0.5],
    8901: [-0.05555, 0.44445, 0, 0, 0.27778],
    8902: [-0.03472, 0.46528, 0, 0, 0.5],
    8904: [5e-3, 0.505, 0, 0, 0.9],
    8942: [0.03, 0.903, 0, 0, 0.278],
    8943: [-0.19, 0.313, 0, 0, 1.172],
    8945: [-0.1, 0.823, 0, 0, 1.282],
    8968: [0.25, 0.75, 0, 0, 0.44445],
    8969: [0.25, 0.75, 0, 0, 0.44445],
    8970: [0.25, 0.75, 0, 0, 0.44445],
    8971: [0.25, 0.75, 0, 0, 0.44445],
    8994: [-0.14236, 0.35764, 0, 0, 1],
    8995: [-0.14236, 0.35764, 0, 0, 1],
    9136: [0.244, 0.744, 0, 0, 0.412],
    9137: [0.244, 0.745, 0, 0, 0.412],
    9651: [0.19444, 0.69444, 0, 0, 0.88889],
    9657: [-0.03472, 0.46528, 0, 0, 0.5],
    9661: [0.19444, 0.69444, 0, 0, 0.88889],
    9667: [-0.03472, 0.46528, 0, 0, 0.5],
    9711: [0.19444, 0.69444, 0, 0, 1],
    9824: [0.12963, 0.69444, 0, 0, 0.77778],
    9825: [0.12963, 0.69444, 0, 0, 0.77778],
    9826: [0.12963, 0.69444, 0, 0, 0.77778],
    9827: [0.12963, 0.69444, 0, 0, 0.77778],
    9837: [0, 0.75, 0, 0, 0.38889],
    9838: [0.19444, 0.69444, 0, 0, 0.38889],
    9839: [0.19444, 0.69444, 0, 0, 0.38889],
    10216: [0.25, 0.75, 0, 0, 0.38889],
    10217: [0.25, 0.75, 0, 0, 0.38889],
    10222: [0.244, 0.744, 0, 0, 0.412],
    10223: [0.244, 0.745, 0, 0, 0.412],
    10229: [0.011, 0.511, 0, 0, 1.609],
    10230: [0.011, 0.511, 0, 0, 1.638],
    10231: [0.011, 0.511, 0, 0, 1.859],
    10232: [0.024, 0.525, 0, 0, 1.609],
    10233: [0.024, 0.525, 0, 0, 1.638],
    10234: [0.024, 0.525, 0, 0, 1.858],
    10236: [0.011, 0.511, 0, 0, 1.638],
    10815: [0, 0.68333, 0, 0, 0.75],
    10927: [0.13597, 0.63597, 0, 0, 0.77778],
    10928: [0.13597, 0.63597, 0, 0, 0.77778],
    57376: [0.19444, 0.69444, 0, 0, 0]
  },
  "Math-BoldItalic": {
    32: [0, 0, 0, 0, 0.25],
    48: [0, 0.44444, 0, 0, 0.575],
    49: [0, 0.44444, 0, 0, 0.575],
    50: [0, 0.44444, 0, 0, 0.575],
    51: [0.19444, 0.44444, 0, 0, 0.575],
    52: [0.19444, 0.44444, 0, 0, 0.575],
    53: [0.19444, 0.44444, 0, 0, 0.575],
    54: [0, 0.64444, 0, 0, 0.575],
    55: [0.19444, 0.44444, 0, 0, 0.575],
    56: [0, 0.64444, 0, 0, 0.575],
    57: [0.19444, 0.44444, 0, 0, 0.575],
    65: [0, 0.68611, 0, 0, 0.86944],
    66: [0, 0.68611, 0.04835, 0, 0.8664],
    67: [0, 0.68611, 0.06979, 0, 0.81694],
    68: [0, 0.68611, 0.03194, 0, 0.93812],
    69: [0, 0.68611, 0.05451, 0, 0.81007],
    70: [0, 0.68611, 0.15972, 0, 0.68889],
    71: [0, 0.68611, 0, 0, 0.88673],
    72: [0, 0.68611, 0.08229, 0, 0.98229],
    73: [0, 0.68611, 0.07778, 0, 0.51111],
    74: [0, 0.68611, 0.10069, 0, 0.63125],
    75: [0, 0.68611, 0.06979, 0, 0.97118],
    76: [0, 0.68611, 0, 0, 0.75555],
    77: [0, 0.68611, 0.11424, 0, 1.14201],
    78: [0, 0.68611, 0.11424, 0, 0.95034],
    79: [0, 0.68611, 0.03194, 0, 0.83666],
    80: [0, 0.68611, 0.15972, 0, 0.72309],
    81: [0.19444, 0.68611, 0, 0, 0.86861],
    82: [0, 0.68611, 421e-5, 0, 0.87235],
    83: [0, 0.68611, 0.05382, 0, 0.69271],
    84: [0, 0.68611, 0.15972, 0, 0.63663],
    85: [0, 0.68611, 0.11424, 0, 0.80027],
    86: [0, 0.68611, 0.25555, 0, 0.67778],
    87: [0, 0.68611, 0.15972, 0, 1.09305],
    88: [0, 0.68611, 0.07778, 0, 0.94722],
    89: [0, 0.68611, 0.25555, 0, 0.67458],
    90: [0, 0.68611, 0.06979, 0, 0.77257],
    97: [0, 0.44444, 0, 0, 0.63287],
    98: [0, 0.69444, 0, 0, 0.52083],
    99: [0, 0.44444, 0, 0, 0.51342],
    100: [0, 0.69444, 0, 0, 0.60972],
    101: [0, 0.44444, 0, 0, 0.55361],
    102: [0.19444, 0.69444, 0.11042, 0, 0.56806],
    103: [0.19444, 0.44444, 0.03704, 0, 0.5449],
    104: [0, 0.69444, 0, 0, 0.66759],
    105: [0, 0.69326, 0, 0, 0.4048],
    106: [0.19444, 0.69326, 0.0622, 0, 0.47083],
    107: [0, 0.69444, 0.01852, 0, 0.6037],
    108: [0, 0.69444, 88e-4, 0, 0.34815],
    109: [0, 0.44444, 0, 0, 1.0324],
    110: [0, 0.44444, 0, 0, 0.71296],
    111: [0, 0.44444, 0, 0, 0.58472],
    112: [0.19444, 0.44444, 0, 0, 0.60092],
    113: [0.19444, 0.44444, 0.03704, 0, 0.54213],
    114: [0, 0.44444, 0.03194, 0, 0.5287],
    115: [0, 0.44444, 0, 0, 0.53125],
    116: [0, 0.63492, 0, 0, 0.41528],
    117: [0, 0.44444, 0, 0, 0.68102],
    118: [0, 0.44444, 0.03704, 0, 0.56666],
    119: [0, 0.44444, 0.02778, 0, 0.83148],
    120: [0, 0.44444, 0, 0, 0.65903],
    121: [0.19444, 0.44444, 0.03704, 0, 0.59028],
    122: [0, 0.44444, 0.04213, 0, 0.55509],
    160: [0, 0, 0, 0, 0.25],
    915: [0, 0.68611, 0.15972, 0, 0.65694],
    916: [0, 0.68611, 0, 0, 0.95833],
    920: [0, 0.68611, 0.03194, 0, 0.86722],
    923: [0, 0.68611, 0, 0, 0.80555],
    926: [0, 0.68611, 0.07458, 0, 0.84125],
    928: [0, 0.68611, 0.08229, 0, 0.98229],
    931: [0, 0.68611, 0.05451, 0, 0.88507],
    933: [0, 0.68611, 0.15972, 0, 0.67083],
    934: [0, 0.68611, 0, 0, 0.76666],
    936: [0, 0.68611, 0.11653, 0, 0.71402],
    937: [0, 0.68611, 0.04835, 0, 0.8789],
    945: [0, 0.44444, 0, 0, 0.76064],
    946: [0.19444, 0.69444, 0.03403, 0, 0.65972],
    947: [0.19444, 0.44444, 0.06389, 0, 0.59003],
    948: [0, 0.69444, 0.03819, 0, 0.52222],
    949: [0, 0.44444, 0, 0, 0.52882],
    950: [0.19444, 0.69444, 0.06215, 0, 0.50833],
    951: [0.19444, 0.44444, 0.03704, 0, 0.6],
    952: [0, 0.69444, 0.03194, 0, 0.5618],
    953: [0, 0.44444, 0, 0, 0.41204],
    954: [0, 0.44444, 0, 0, 0.66759],
    955: [0, 0.69444, 0, 0, 0.67083],
    956: [0.19444, 0.44444, 0, 0, 0.70787],
    957: [0, 0.44444, 0.06898, 0, 0.57685],
    958: [0.19444, 0.69444, 0.03021, 0, 0.50833],
    959: [0, 0.44444, 0, 0, 0.58472],
    960: [0, 0.44444, 0.03704, 0, 0.68241],
    961: [0.19444, 0.44444, 0, 0, 0.6118],
    962: [0.09722, 0.44444, 0.07917, 0, 0.42361],
    963: [0, 0.44444, 0.03704, 0, 0.68588],
    964: [0, 0.44444, 0.13472, 0, 0.52083],
    965: [0, 0.44444, 0.03704, 0, 0.63055],
    966: [0.19444, 0.44444, 0, 0, 0.74722],
    967: [0.19444, 0.44444, 0, 0, 0.71805],
    968: [0.19444, 0.69444, 0.03704, 0, 0.75833],
    969: [0, 0.44444, 0.03704, 0, 0.71782],
    977: [0, 0.69444, 0, 0, 0.69155],
    981: [0.19444, 0.69444, 0, 0, 0.7125],
    982: [0, 0.44444, 0.03194, 0, 0.975],
    1009: [0.19444, 0.44444, 0, 0, 0.6118],
    1013: [0, 0.44444, 0, 0, 0.48333],
    57649: [0, 0.44444, 0, 0, 0.39352],
    57911: [0.19444, 0.44444, 0, 0, 0.43889]
  },
  "Math-Italic": {
    32: [0, 0, 0, 0, 0.25],
    48: [0, 0.43056, 0, 0, 0.5],
    49: [0, 0.43056, 0, 0, 0.5],
    50: [0, 0.43056, 0, 0, 0.5],
    51: [0.19444, 0.43056, 0, 0, 0.5],
    52: [0.19444, 0.43056, 0, 0, 0.5],
    53: [0.19444, 0.43056, 0, 0, 0.5],
    54: [0, 0.64444, 0, 0, 0.5],
    55: [0.19444, 0.43056, 0, 0, 0.5],
    56: [0, 0.64444, 0, 0, 0.5],
    57: [0.19444, 0.43056, 0, 0, 0.5],
    65: [0, 0.68333, 0, 0.13889, 0.75],
    66: [0, 0.68333, 0.05017, 0.08334, 0.75851],
    67: [0, 0.68333, 0.07153, 0.08334, 0.71472],
    68: [0, 0.68333, 0.02778, 0.05556, 0.82792],
    69: [0, 0.68333, 0.05764, 0.08334, 0.7382],
    70: [0, 0.68333, 0.13889, 0.08334, 0.64306],
    71: [0, 0.68333, 0, 0.08334, 0.78625],
    72: [0, 0.68333, 0.08125, 0.05556, 0.83125],
    73: [0, 0.68333, 0.07847, 0.11111, 0.43958],
    74: [0, 0.68333, 0.09618, 0.16667, 0.55451],
    75: [0, 0.68333, 0.07153, 0.05556, 0.84931],
    76: [0, 0.68333, 0, 0.02778, 0.68056],
    77: [0, 0.68333, 0.10903, 0.08334, 0.97014],
    78: [0, 0.68333, 0.10903, 0.08334, 0.80347],
    79: [0, 0.68333, 0.02778, 0.08334, 0.76278],
    80: [0, 0.68333, 0.13889, 0.08334, 0.64201],
    81: [0.19444, 0.68333, 0, 0.08334, 0.79056],
    82: [0, 0.68333, 773e-5, 0.08334, 0.75929],
    83: [0, 0.68333, 0.05764, 0.08334, 0.6132],
    84: [0, 0.68333, 0.13889, 0.08334, 0.58438],
    85: [0, 0.68333, 0.10903, 0.02778, 0.68278],
    86: [0, 0.68333, 0.22222, 0, 0.58333],
    87: [0, 0.68333, 0.13889, 0, 0.94445],
    88: [0, 0.68333, 0.07847, 0.08334, 0.82847],
    89: [0, 0.68333, 0.22222, 0, 0.58056],
    90: [0, 0.68333, 0.07153, 0.08334, 0.68264],
    97: [0, 0.43056, 0, 0, 0.52859],
    98: [0, 0.69444, 0, 0, 0.42917],
    99: [0, 0.43056, 0, 0.05556, 0.43276],
    100: [0, 0.69444, 0, 0.16667, 0.52049],
    101: [0, 0.43056, 0, 0.05556, 0.46563],
    102: [0.19444, 0.69444, 0.10764, 0.16667, 0.48959],
    103: [0.19444, 0.43056, 0.03588, 0.02778, 0.47697],
    104: [0, 0.69444, 0, 0, 0.57616],
    105: [0, 0.65952, 0, 0, 0.34451],
    106: [0.19444, 0.65952, 0.05724, 0, 0.41181],
    107: [0, 0.69444, 0.03148, 0, 0.5206],
    108: [0, 0.69444, 0.01968, 0.08334, 0.29838],
    109: [0, 0.43056, 0, 0, 0.87801],
    110: [0, 0.43056, 0, 0, 0.60023],
    111: [0, 0.43056, 0, 0.05556, 0.48472],
    112: [0.19444, 0.43056, 0, 0.08334, 0.50313],
    113: [0.19444, 0.43056, 0.03588, 0.08334, 0.44641],
    114: [0, 0.43056, 0.02778, 0.05556, 0.45116],
    115: [0, 0.43056, 0, 0.05556, 0.46875],
    116: [0, 0.61508, 0, 0.08334, 0.36111],
    117: [0, 0.43056, 0, 0.02778, 0.57246],
    118: [0, 0.43056, 0.03588, 0.02778, 0.48472],
    119: [0, 0.43056, 0.02691, 0.08334, 0.71592],
    120: [0, 0.43056, 0, 0.02778, 0.57153],
    121: [0.19444, 0.43056, 0.03588, 0.05556, 0.49028],
    122: [0, 0.43056, 0.04398, 0.05556, 0.46505],
    160: [0, 0, 0, 0, 0.25],
    915: [0, 0.68333, 0.13889, 0.08334, 0.61528],
    916: [0, 0.68333, 0, 0.16667, 0.83334],
    920: [0, 0.68333, 0.02778, 0.08334, 0.76278],
    923: [0, 0.68333, 0, 0.16667, 0.69445],
    926: [0, 0.68333, 0.07569, 0.08334, 0.74236],
    928: [0, 0.68333, 0.08125, 0.05556, 0.83125],
    931: [0, 0.68333, 0.05764, 0.08334, 0.77986],
    933: [0, 0.68333, 0.13889, 0.05556, 0.58333],
    934: [0, 0.68333, 0, 0.08334, 0.66667],
    936: [0, 0.68333, 0.11, 0.05556, 0.61222],
    937: [0, 0.68333, 0.05017, 0.08334, 0.7724],
    945: [0, 0.43056, 37e-4, 0.02778, 0.6397],
    946: [0.19444, 0.69444, 0.05278, 0.08334, 0.56563],
    947: [0.19444, 0.43056, 0.05556, 0, 0.51773],
    948: [0, 0.69444, 0.03785, 0.05556, 0.44444],
    949: [0, 0.43056, 0, 0.08334, 0.46632],
    950: [0.19444, 0.69444, 0.07378, 0.08334, 0.4375],
    951: [0.19444, 0.43056, 0.03588, 0.05556, 0.49653],
    952: [0, 0.69444, 0.02778, 0.08334, 0.46944],
    953: [0, 0.43056, 0, 0.05556, 0.35394],
    954: [0, 0.43056, 0, 0, 0.57616],
    955: [0, 0.69444, 0, 0, 0.58334],
    956: [0.19444, 0.43056, 0, 0.02778, 0.60255],
    957: [0, 0.43056, 0.06366, 0.02778, 0.49398],
    958: [0.19444, 0.69444, 0.04601, 0.11111, 0.4375],
    959: [0, 0.43056, 0, 0.05556, 0.48472],
    960: [0, 0.43056, 0.03588, 0, 0.57003],
    961: [0.19444, 0.43056, 0, 0.08334, 0.51702],
    962: [0.09722, 0.43056, 0.07986, 0.08334, 0.36285],
    963: [0, 0.43056, 0.03588, 0, 0.57141],
    964: [0, 0.43056, 0.1132, 0.02778, 0.43715],
    965: [0, 0.43056, 0.03588, 0.02778, 0.54028],
    966: [0.19444, 0.43056, 0, 0.08334, 0.65417],
    967: [0.19444, 0.43056, 0, 0.05556, 0.62569],
    968: [0.19444, 0.69444, 0.03588, 0.11111, 0.65139],
    969: [0, 0.43056, 0.03588, 0, 0.62245],
    977: [0, 0.69444, 0, 0.08334, 0.59144],
    981: [0.19444, 0.69444, 0, 0.08334, 0.59583],
    982: [0, 0.43056, 0.02778, 0, 0.82813],
    1009: [0.19444, 0.43056, 0, 0.08334, 0.51702],
    1013: [0, 0.43056, 0, 0.05556, 0.4059],
    57649: [0, 0.43056, 0, 0.02778, 0.32246],
    57911: [0.19444, 0.43056, 0, 0.08334, 0.38403]
  },
  "SansSerif-Bold": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.36667],
    34: [0, 0.69444, 0, 0, 0.55834],
    35: [0.19444, 0.69444, 0, 0, 0.91667],
    36: [0.05556, 0.75, 0, 0, 0.55],
    37: [0.05556, 0.75, 0, 0, 1.02912],
    38: [0, 0.69444, 0, 0, 0.83056],
    39: [0, 0.69444, 0, 0, 0.30556],
    40: [0.25, 0.75, 0, 0, 0.42778],
    41: [0.25, 0.75, 0, 0, 0.42778],
    42: [0, 0.75, 0, 0, 0.55],
    43: [0.11667, 0.61667, 0, 0, 0.85556],
    44: [0.10556, 0.13056, 0, 0, 0.30556],
    45: [0, 0.45833, 0, 0, 0.36667],
    46: [0, 0.13056, 0, 0, 0.30556],
    47: [0.25, 0.75, 0, 0, 0.55],
    48: [0, 0.69444, 0, 0, 0.55],
    49: [0, 0.69444, 0, 0, 0.55],
    50: [0, 0.69444, 0, 0, 0.55],
    51: [0, 0.69444, 0, 0, 0.55],
    52: [0, 0.69444, 0, 0, 0.55],
    53: [0, 0.69444, 0, 0, 0.55],
    54: [0, 0.69444, 0, 0, 0.55],
    55: [0, 0.69444, 0, 0, 0.55],
    56: [0, 0.69444, 0, 0, 0.55],
    57: [0, 0.69444, 0, 0, 0.55],
    58: [0, 0.45833, 0, 0, 0.30556],
    59: [0.10556, 0.45833, 0, 0, 0.30556],
    61: [-0.09375, 0.40625, 0, 0, 0.85556],
    63: [0, 0.69444, 0, 0, 0.51945],
    64: [0, 0.69444, 0, 0, 0.73334],
    65: [0, 0.69444, 0, 0, 0.73334],
    66: [0, 0.69444, 0, 0, 0.73334],
    67: [0, 0.69444, 0, 0, 0.70278],
    68: [0, 0.69444, 0, 0, 0.79445],
    69: [0, 0.69444, 0, 0, 0.64167],
    70: [0, 0.69444, 0, 0, 0.61111],
    71: [0, 0.69444, 0, 0, 0.73334],
    72: [0, 0.69444, 0, 0, 0.79445],
    73: [0, 0.69444, 0, 0, 0.33056],
    74: [0, 0.69444, 0, 0, 0.51945],
    75: [0, 0.69444, 0, 0, 0.76389],
    76: [0, 0.69444, 0, 0, 0.58056],
    77: [0, 0.69444, 0, 0, 0.97778],
    78: [0, 0.69444, 0, 0, 0.79445],
    79: [0, 0.69444, 0, 0, 0.79445],
    80: [0, 0.69444, 0, 0, 0.70278],
    81: [0.10556, 0.69444, 0, 0, 0.79445],
    82: [0, 0.69444, 0, 0, 0.70278],
    83: [0, 0.69444, 0, 0, 0.61111],
    84: [0, 0.69444, 0, 0, 0.73334],
    85: [0, 0.69444, 0, 0, 0.76389],
    86: [0, 0.69444, 0.01528, 0, 0.73334],
    87: [0, 0.69444, 0.01528, 0, 1.03889],
    88: [0, 0.69444, 0, 0, 0.73334],
    89: [0, 0.69444, 0.0275, 0, 0.73334],
    90: [0, 0.69444, 0, 0, 0.67223],
    91: [0.25, 0.75, 0, 0, 0.34306],
    93: [0.25, 0.75, 0, 0, 0.34306],
    94: [0, 0.69444, 0, 0, 0.55],
    95: [0.35, 0.10833, 0.03056, 0, 0.55],
    97: [0, 0.45833, 0, 0, 0.525],
    98: [0, 0.69444, 0, 0, 0.56111],
    99: [0, 0.45833, 0, 0, 0.48889],
    100: [0, 0.69444, 0, 0, 0.56111],
    101: [0, 0.45833, 0, 0, 0.51111],
    102: [0, 0.69444, 0.07639, 0, 0.33611],
    103: [0.19444, 0.45833, 0.01528, 0, 0.55],
    104: [0, 0.69444, 0, 0, 0.56111],
    105: [0, 0.69444, 0, 0, 0.25556],
    106: [0.19444, 0.69444, 0, 0, 0.28611],
    107: [0, 0.69444, 0, 0, 0.53056],
    108: [0, 0.69444, 0, 0, 0.25556],
    109: [0, 0.45833, 0, 0, 0.86667],
    110: [0, 0.45833, 0, 0, 0.56111],
    111: [0, 0.45833, 0, 0, 0.55],
    112: [0.19444, 0.45833, 0, 0, 0.56111],
    113: [0.19444, 0.45833, 0, 0, 0.56111],
    114: [0, 0.45833, 0.01528, 0, 0.37222],
    115: [0, 0.45833, 0, 0, 0.42167],
    116: [0, 0.58929, 0, 0, 0.40417],
    117: [0, 0.45833, 0, 0, 0.56111],
    118: [0, 0.45833, 0.01528, 0, 0.5],
    119: [0, 0.45833, 0.01528, 0, 0.74445],
    120: [0, 0.45833, 0, 0, 0.5],
    121: [0.19444, 0.45833, 0.01528, 0, 0.5],
    122: [0, 0.45833, 0, 0, 0.47639],
    126: [0.35, 0.34444, 0, 0, 0.55],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.69444, 0, 0, 0.55],
    176: [0, 0.69444, 0, 0, 0.73334],
    180: [0, 0.69444, 0, 0, 0.55],
    184: [0.17014, 0, 0, 0, 0.48889],
    305: [0, 0.45833, 0, 0, 0.25556],
    567: [0.19444, 0.45833, 0, 0, 0.28611],
    710: [0, 0.69444, 0, 0, 0.55],
    711: [0, 0.63542, 0, 0, 0.55],
    713: [0, 0.63778, 0, 0, 0.55],
    728: [0, 0.69444, 0, 0, 0.55],
    729: [0, 0.69444, 0, 0, 0.30556],
    730: [0, 0.69444, 0, 0, 0.73334],
    732: [0, 0.69444, 0, 0, 0.55],
    733: [0, 0.69444, 0, 0, 0.55],
    915: [0, 0.69444, 0, 0, 0.58056],
    916: [0, 0.69444, 0, 0, 0.91667],
    920: [0, 0.69444, 0, 0, 0.85556],
    923: [0, 0.69444, 0, 0, 0.67223],
    926: [0, 0.69444, 0, 0, 0.73334],
    928: [0, 0.69444, 0, 0, 0.79445],
    931: [0, 0.69444, 0, 0, 0.79445],
    933: [0, 0.69444, 0, 0, 0.85556],
    934: [0, 0.69444, 0, 0, 0.79445],
    936: [0, 0.69444, 0, 0, 0.85556],
    937: [0, 0.69444, 0, 0, 0.79445],
    8211: [0, 0.45833, 0.03056, 0, 0.55],
    8212: [0, 0.45833, 0.03056, 0, 1.10001],
    8216: [0, 0.69444, 0, 0, 0.30556],
    8217: [0, 0.69444, 0, 0, 0.30556],
    8220: [0, 0.69444, 0, 0, 0.55834],
    8221: [0, 0.69444, 0, 0, 0.55834]
  },
  "SansSerif-Italic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.05733, 0, 0.31945],
    34: [0, 0.69444, 316e-5, 0, 0.5],
    35: [0.19444, 0.69444, 0.05087, 0, 0.83334],
    36: [0.05556, 0.75, 0.11156, 0, 0.5],
    37: [0.05556, 0.75, 0.03126, 0, 0.83334],
    38: [0, 0.69444, 0.03058, 0, 0.75834],
    39: [0, 0.69444, 0.07816, 0, 0.27778],
    40: [0.25, 0.75, 0.13164, 0, 0.38889],
    41: [0.25, 0.75, 0.02536, 0, 0.38889],
    42: [0, 0.75, 0.11775, 0, 0.5],
    43: [0.08333, 0.58333, 0.02536, 0, 0.77778],
    44: [0.125, 0.08333, 0, 0, 0.27778],
    45: [0, 0.44444, 0.01946, 0, 0.33333],
    46: [0, 0.08333, 0, 0, 0.27778],
    47: [0.25, 0.75, 0.13164, 0, 0.5],
    48: [0, 0.65556, 0.11156, 0, 0.5],
    49: [0, 0.65556, 0.11156, 0, 0.5],
    50: [0, 0.65556, 0.11156, 0, 0.5],
    51: [0, 0.65556, 0.11156, 0, 0.5],
    52: [0, 0.65556, 0.11156, 0, 0.5],
    53: [0, 0.65556, 0.11156, 0, 0.5],
    54: [0, 0.65556, 0.11156, 0, 0.5],
    55: [0, 0.65556, 0.11156, 0, 0.5],
    56: [0, 0.65556, 0.11156, 0, 0.5],
    57: [0, 0.65556, 0.11156, 0, 0.5],
    58: [0, 0.44444, 0.02502, 0, 0.27778],
    59: [0.125, 0.44444, 0.02502, 0, 0.27778],
    61: [-0.13, 0.37, 0.05087, 0, 0.77778],
    63: [0, 0.69444, 0.11809, 0, 0.47222],
    64: [0, 0.69444, 0.07555, 0, 0.66667],
    65: [0, 0.69444, 0, 0, 0.66667],
    66: [0, 0.69444, 0.08293, 0, 0.66667],
    67: [0, 0.69444, 0.11983, 0, 0.63889],
    68: [0, 0.69444, 0.07555, 0, 0.72223],
    69: [0, 0.69444, 0.11983, 0, 0.59722],
    70: [0, 0.69444, 0.13372, 0, 0.56945],
    71: [0, 0.69444, 0.11983, 0, 0.66667],
    72: [0, 0.69444, 0.08094, 0, 0.70834],
    73: [0, 0.69444, 0.13372, 0, 0.27778],
    74: [0, 0.69444, 0.08094, 0, 0.47222],
    75: [0, 0.69444, 0.11983, 0, 0.69445],
    76: [0, 0.69444, 0, 0, 0.54167],
    77: [0, 0.69444, 0.08094, 0, 0.875],
    78: [0, 0.69444, 0.08094, 0, 0.70834],
    79: [0, 0.69444, 0.07555, 0, 0.73611],
    80: [0, 0.69444, 0.08293, 0, 0.63889],
    81: [0.125, 0.69444, 0.07555, 0, 0.73611],
    82: [0, 0.69444, 0.08293, 0, 0.64584],
    83: [0, 0.69444, 0.09205, 0, 0.55556],
    84: [0, 0.69444, 0.13372, 0, 0.68056],
    85: [0, 0.69444, 0.08094, 0, 0.6875],
    86: [0, 0.69444, 0.1615, 0, 0.66667],
    87: [0, 0.69444, 0.1615, 0, 0.94445],
    88: [0, 0.69444, 0.13372, 0, 0.66667],
    89: [0, 0.69444, 0.17261, 0, 0.66667],
    90: [0, 0.69444, 0.11983, 0, 0.61111],
    91: [0.25, 0.75, 0.15942, 0, 0.28889],
    93: [0.25, 0.75, 0.08719, 0, 0.28889],
    94: [0, 0.69444, 0.0799, 0, 0.5],
    95: [0.35, 0.09444, 0.08616, 0, 0.5],
    97: [0, 0.44444, 981e-5, 0, 0.48056],
    98: [0, 0.69444, 0.03057, 0, 0.51667],
    99: [0, 0.44444, 0.08336, 0, 0.44445],
    100: [0, 0.69444, 0.09483, 0, 0.51667],
    101: [0, 0.44444, 0.06778, 0, 0.44445],
    102: [0, 0.69444, 0.21705, 0, 0.30556],
    103: [0.19444, 0.44444, 0.10836, 0, 0.5],
    104: [0, 0.69444, 0.01778, 0, 0.51667],
    105: [0, 0.67937, 0.09718, 0, 0.23889],
    106: [0.19444, 0.67937, 0.09162, 0, 0.26667],
    107: [0, 0.69444, 0.08336, 0, 0.48889],
    108: [0, 0.69444, 0.09483, 0, 0.23889],
    109: [0, 0.44444, 0.01778, 0, 0.79445],
    110: [0, 0.44444, 0.01778, 0, 0.51667],
    111: [0, 0.44444, 0.06613, 0, 0.5],
    112: [0.19444, 0.44444, 0.0389, 0, 0.51667],
    113: [0.19444, 0.44444, 0.04169, 0, 0.51667],
    114: [0, 0.44444, 0.10836, 0, 0.34167],
    115: [0, 0.44444, 0.0778, 0, 0.38333],
    116: [0, 0.57143, 0.07225, 0, 0.36111],
    117: [0, 0.44444, 0.04169, 0, 0.51667],
    118: [0, 0.44444, 0.10836, 0, 0.46111],
    119: [0, 0.44444, 0.10836, 0, 0.68334],
    120: [0, 0.44444, 0.09169, 0, 0.46111],
    121: [0.19444, 0.44444, 0.10836, 0, 0.46111],
    122: [0, 0.44444, 0.08752, 0, 0.43472],
    126: [0.35, 0.32659, 0.08826, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.67937, 0.06385, 0, 0.5],
    176: [0, 0.69444, 0, 0, 0.73752],
    184: [0.17014, 0, 0, 0, 0.44445],
    305: [0, 0.44444, 0.04169, 0, 0.23889],
    567: [0.19444, 0.44444, 0.04169, 0, 0.26667],
    710: [0, 0.69444, 0.0799, 0, 0.5],
    711: [0, 0.63194, 0.08432, 0, 0.5],
    713: [0, 0.60889, 0.08776, 0, 0.5],
    714: [0, 0.69444, 0.09205, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0.09483, 0, 0.5],
    729: [0, 0.67937, 0.07774, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.73752],
    732: [0, 0.67659, 0.08826, 0, 0.5],
    733: [0, 0.69444, 0.09205, 0, 0.5],
    915: [0, 0.69444, 0.13372, 0, 0.54167],
    916: [0, 0.69444, 0, 0, 0.83334],
    920: [0, 0.69444, 0.07555, 0, 0.77778],
    923: [0, 0.69444, 0, 0, 0.61111],
    926: [0, 0.69444, 0.12816, 0, 0.66667],
    928: [0, 0.69444, 0.08094, 0, 0.70834],
    931: [0, 0.69444, 0.11983, 0, 0.72222],
    933: [0, 0.69444, 0.09031, 0, 0.77778],
    934: [0, 0.69444, 0.04603, 0, 0.72222],
    936: [0, 0.69444, 0.09031, 0, 0.77778],
    937: [0, 0.69444, 0.08293, 0, 0.72222],
    8211: [0, 0.44444, 0.08616, 0, 0.5],
    8212: [0, 0.44444, 0.08616, 0, 1],
    8216: [0, 0.69444, 0.07816, 0, 0.27778],
    8217: [0, 0.69444, 0.07816, 0, 0.27778],
    8220: [0, 0.69444, 0.14205, 0, 0.5],
    8221: [0, 0.69444, 316e-5, 0, 0.5]
  },
  "SansSerif-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.31945],
    34: [0, 0.69444, 0, 0, 0.5],
    35: [0.19444, 0.69444, 0, 0, 0.83334],
    36: [0.05556, 0.75, 0, 0, 0.5],
    37: [0.05556, 0.75, 0, 0, 0.83334],
    38: [0, 0.69444, 0, 0, 0.75834],
    39: [0, 0.69444, 0, 0, 0.27778],
    40: [0.25, 0.75, 0, 0, 0.38889],
    41: [0.25, 0.75, 0, 0, 0.38889],
    42: [0, 0.75, 0, 0, 0.5],
    43: [0.08333, 0.58333, 0, 0, 0.77778],
    44: [0.125, 0.08333, 0, 0, 0.27778],
    45: [0, 0.44444, 0, 0, 0.33333],
    46: [0, 0.08333, 0, 0, 0.27778],
    47: [0.25, 0.75, 0, 0, 0.5],
    48: [0, 0.65556, 0, 0, 0.5],
    49: [0, 0.65556, 0, 0, 0.5],
    50: [0, 0.65556, 0, 0, 0.5],
    51: [0, 0.65556, 0, 0, 0.5],
    52: [0, 0.65556, 0, 0, 0.5],
    53: [0, 0.65556, 0, 0, 0.5],
    54: [0, 0.65556, 0, 0, 0.5],
    55: [0, 0.65556, 0, 0, 0.5],
    56: [0, 0.65556, 0, 0, 0.5],
    57: [0, 0.65556, 0, 0, 0.5],
    58: [0, 0.44444, 0, 0, 0.27778],
    59: [0.125, 0.44444, 0, 0, 0.27778],
    61: [-0.13, 0.37, 0, 0, 0.77778],
    63: [0, 0.69444, 0, 0, 0.47222],
    64: [0, 0.69444, 0, 0, 0.66667],
    65: [0, 0.69444, 0, 0, 0.66667],
    66: [0, 0.69444, 0, 0, 0.66667],
    67: [0, 0.69444, 0, 0, 0.63889],
    68: [0, 0.69444, 0, 0, 0.72223],
    69: [0, 0.69444, 0, 0, 0.59722],
    70: [0, 0.69444, 0, 0, 0.56945],
    71: [0, 0.69444, 0, 0, 0.66667],
    72: [0, 0.69444, 0, 0, 0.70834],
    73: [0, 0.69444, 0, 0, 0.27778],
    74: [0, 0.69444, 0, 0, 0.47222],
    75: [0, 0.69444, 0, 0, 0.69445],
    76: [0, 0.69444, 0, 0, 0.54167],
    77: [0, 0.69444, 0, 0, 0.875],
    78: [0, 0.69444, 0, 0, 0.70834],
    79: [0, 0.69444, 0, 0, 0.73611],
    80: [0, 0.69444, 0, 0, 0.63889],
    81: [0.125, 0.69444, 0, 0, 0.73611],
    82: [0, 0.69444, 0, 0, 0.64584],
    83: [0, 0.69444, 0, 0, 0.55556],
    84: [0, 0.69444, 0, 0, 0.68056],
    85: [0, 0.69444, 0, 0, 0.6875],
    86: [0, 0.69444, 0.01389, 0, 0.66667],
    87: [0, 0.69444, 0.01389, 0, 0.94445],
    88: [0, 0.69444, 0, 0, 0.66667],
    89: [0, 0.69444, 0.025, 0, 0.66667],
    90: [0, 0.69444, 0, 0, 0.61111],
    91: [0.25, 0.75, 0, 0, 0.28889],
    93: [0.25, 0.75, 0, 0, 0.28889],
    94: [0, 0.69444, 0, 0, 0.5],
    95: [0.35, 0.09444, 0.02778, 0, 0.5],
    97: [0, 0.44444, 0, 0, 0.48056],
    98: [0, 0.69444, 0, 0, 0.51667],
    99: [0, 0.44444, 0, 0, 0.44445],
    100: [0, 0.69444, 0, 0, 0.51667],
    101: [0, 0.44444, 0, 0, 0.44445],
    102: [0, 0.69444, 0.06944, 0, 0.30556],
    103: [0.19444, 0.44444, 0.01389, 0, 0.5],
    104: [0, 0.69444, 0, 0, 0.51667],
    105: [0, 0.67937, 0, 0, 0.23889],
    106: [0.19444, 0.67937, 0, 0, 0.26667],
    107: [0, 0.69444, 0, 0, 0.48889],
    108: [0, 0.69444, 0, 0, 0.23889],
    109: [0, 0.44444, 0, 0, 0.79445],
    110: [0, 0.44444, 0, 0, 0.51667],
    111: [0, 0.44444, 0, 0, 0.5],
    112: [0.19444, 0.44444, 0, 0, 0.51667],
    113: [0.19444, 0.44444, 0, 0, 0.51667],
    114: [0, 0.44444, 0.01389, 0, 0.34167],
    115: [0, 0.44444, 0, 0, 0.38333],
    116: [0, 0.57143, 0, 0, 0.36111],
    117: [0, 0.44444, 0, 0, 0.51667],
    118: [0, 0.44444, 0.01389, 0, 0.46111],
    119: [0, 0.44444, 0.01389, 0, 0.68334],
    120: [0, 0.44444, 0, 0, 0.46111],
    121: [0.19444, 0.44444, 0.01389, 0, 0.46111],
    122: [0, 0.44444, 0, 0, 0.43472],
    126: [0.35, 0.32659, 0, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.67937, 0, 0, 0.5],
    176: [0, 0.69444, 0, 0, 0.66667],
    184: [0.17014, 0, 0, 0, 0.44445],
    305: [0, 0.44444, 0, 0, 0.23889],
    567: [0.19444, 0.44444, 0, 0, 0.26667],
    710: [0, 0.69444, 0, 0, 0.5],
    711: [0, 0.63194, 0, 0, 0.5],
    713: [0, 0.60889, 0, 0, 0.5],
    714: [0, 0.69444, 0, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0, 0, 0.5],
    729: [0, 0.67937, 0, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.66667],
    732: [0, 0.67659, 0, 0, 0.5],
    733: [0, 0.69444, 0, 0, 0.5],
    915: [0, 0.69444, 0, 0, 0.54167],
    916: [0, 0.69444, 0, 0, 0.83334],
    920: [0, 0.69444, 0, 0, 0.77778],
    923: [0, 0.69444, 0, 0, 0.61111],
    926: [0, 0.69444, 0, 0, 0.66667],
    928: [0, 0.69444, 0, 0, 0.70834],
    931: [0, 0.69444, 0, 0, 0.72222],
    933: [0, 0.69444, 0, 0, 0.77778],
    934: [0, 0.69444, 0, 0, 0.72222],
    936: [0, 0.69444, 0, 0, 0.77778],
    937: [0, 0.69444, 0, 0, 0.72222],
    8211: [0, 0.44444, 0.02778, 0, 0.5],
    8212: [0, 0.44444, 0.02778, 0, 1],
    8216: [0, 0.69444, 0, 0, 0.27778],
    8217: [0, 0.69444, 0, 0, 0.27778],
    8220: [0, 0.69444, 0, 0, 0.5],
    8221: [0, 0.69444, 0, 0, 0.5]
  },
  "Script-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.7, 0.22925, 0, 0.80253],
    66: [0, 0.7, 0.04087, 0, 0.90757],
    67: [0, 0.7, 0.1689, 0, 0.66619],
    68: [0, 0.7, 0.09371, 0, 0.77443],
    69: [0, 0.7, 0.18583, 0, 0.56162],
    70: [0, 0.7, 0.13634, 0, 0.89544],
    71: [0, 0.7, 0.17322, 0, 0.60961],
    72: [0, 0.7, 0.29694, 0, 0.96919],
    73: [0, 0.7, 0.19189, 0, 0.80907],
    74: [0.27778, 0.7, 0.19189, 0, 1.05159],
    75: [0, 0.7, 0.31259, 0, 0.91364],
    76: [0, 0.7, 0.19189, 0, 0.87373],
    77: [0, 0.7, 0.15981, 0, 1.08031],
    78: [0, 0.7, 0.3525, 0, 0.9015],
    79: [0, 0.7, 0.08078, 0, 0.73787],
    80: [0, 0.7, 0.08078, 0, 1.01262],
    81: [0, 0.7, 0.03305, 0, 0.88282],
    82: [0, 0.7, 0.06259, 0, 0.85],
    83: [0, 0.7, 0.19189, 0, 0.86767],
    84: [0, 0.7, 0.29087, 0, 0.74697],
    85: [0, 0.7, 0.25815, 0, 0.79996],
    86: [0, 0.7, 0.27523, 0, 0.62204],
    87: [0, 0.7, 0.27523, 0, 0.80532],
    88: [0, 0.7, 0.26006, 0, 0.94445],
    89: [0, 0.7, 0.2939, 0, 0.70961],
    90: [0, 0.7, 0.24037, 0, 0.8212],
    160: [0, 0, 0, 0, 0.25]
  },
  "Size1-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.35001, 0.85, 0, 0, 0.45834],
    41: [0.35001, 0.85, 0, 0, 0.45834],
    47: [0.35001, 0.85, 0, 0, 0.57778],
    91: [0.35001, 0.85, 0, 0, 0.41667],
    92: [0.35001, 0.85, 0, 0, 0.57778],
    93: [0.35001, 0.85, 0, 0, 0.41667],
    123: [0.35001, 0.85, 0, 0, 0.58334],
    125: [0.35001, 0.85, 0, 0, 0.58334],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.72222, 0, 0, 0.55556],
    732: [0, 0.72222, 0, 0, 0.55556],
    770: [0, 0.72222, 0, 0, 0.55556],
    771: [0, 0.72222, 0, 0, 0.55556],
    8214: [-99e-5, 0.601, 0, 0, 0.77778],
    8593: [1e-5, 0.6, 0, 0, 0.66667],
    8595: [1e-5, 0.6, 0, 0, 0.66667],
    8657: [1e-5, 0.6, 0, 0, 0.77778],
    8659: [1e-5, 0.6, 0, 0, 0.77778],
    8719: [0.25001, 0.75, 0, 0, 0.94445],
    8720: [0.25001, 0.75, 0, 0, 0.94445],
    8721: [0.25001, 0.75, 0, 0, 1.05556],
    8730: [0.35001, 0.85, 0, 0, 1],
    8739: [-599e-5, 0.606, 0, 0, 0.33333],
    8741: [-599e-5, 0.606, 0, 0, 0.55556],
    8747: [0.30612, 0.805, 0.19445, 0, 0.47222],
    8748: [0.306, 0.805, 0.19445, 0, 0.47222],
    8749: [0.306, 0.805, 0.19445, 0, 0.47222],
    8750: [0.30612, 0.805, 0.19445, 0, 0.47222],
    8896: [0.25001, 0.75, 0, 0, 0.83334],
    8897: [0.25001, 0.75, 0, 0, 0.83334],
    8898: [0.25001, 0.75, 0, 0, 0.83334],
    8899: [0.25001, 0.75, 0, 0, 0.83334],
    8968: [0.35001, 0.85, 0, 0, 0.47222],
    8969: [0.35001, 0.85, 0, 0, 0.47222],
    8970: [0.35001, 0.85, 0, 0, 0.47222],
    8971: [0.35001, 0.85, 0, 0, 0.47222],
    9168: [-99e-5, 0.601, 0, 0, 0.66667],
    10216: [0.35001, 0.85, 0, 0, 0.47222],
    10217: [0.35001, 0.85, 0, 0, 0.47222],
    10752: [0.25001, 0.75, 0, 0, 1.11111],
    10753: [0.25001, 0.75, 0, 0, 1.11111],
    10754: [0.25001, 0.75, 0, 0, 1.11111],
    10756: [0.25001, 0.75, 0, 0, 0.83334],
    10758: [0.25001, 0.75, 0, 0, 0.83334]
  },
  "Size2-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.65002, 1.15, 0, 0, 0.59722],
    41: [0.65002, 1.15, 0, 0, 0.59722],
    47: [0.65002, 1.15, 0, 0, 0.81111],
    91: [0.65002, 1.15, 0, 0, 0.47222],
    92: [0.65002, 1.15, 0, 0, 0.81111],
    93: [0.65002, 1.15, 0, 0, 0.47222],
    123: [0.65002, 1.15, 0, 0, 0.66667],
    125: [0.65002, 1.15, 0, 0, 0.66667],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.75, 0, 0, 1],
    732: [0, 0.75, 0, 0, 1],
    770: [0, 0.75, 0, 0, 1],
    771: [0, 0.75, 0, 0, 1],
    8719: [0.55001, 1.05, 0, 0, 1.27778],
    8720: [0.55001, 1.05, 0, 0, 1.27778],
    8721: [0.55001, 1.05, 0, 0, 1.44445],
    8730: [0.65002, 1.15, 0, 0, 1],
    8747: [0.86225, 1.36, 0.44445, 0, 0.55556],
    8748: [0.862, 1.36, 0.44445, 0, 0.55556],
    8749: [0.862, 1.36, 0.44445, 0, 0.55556],
    8750: [0.86225, 1.36, 0.44445, 0, 0.55556],
    8896: [0.55001, 1.05, 0, 0, 1.11111],
    8897: [0.55001, 1.05, 0, 0, 1.11111],
    8898: [0.55001, 1.05, 0, 0, 1.11111],
    8899: [0.55001, 1.05, 0, 0, 1.11111],
    8968: [0.65002, 1.15, 0, 0, 0.52778],
    8969: [0.65002, 1.15, 0, 0, 0.52778],
    8970: [0.65002, 1.15, 0, 0, 0.52778],
    8971: [0.65002, 1.15, 0, 0, 0.52778],
    10216: [0.65002, 1.15, 0, 0, 0.61111],
    10217: [0.65002, 1.15, 0, 0, 0.61111],
    10752: [0.55001, 1.05, 0, 0, 1.51112],
    10753: [0.55001, 1.05, 0, 0, 1.51112],
    10754: [0.55001, 1.05, 0, 0, 1.51112],
    10756: [0.55001, 1.05, 0, 0, 1.11111],
    10758: [0.55001, 1.05, 0, 0, 1.11111]
  },
  "Size3-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.95003, 1.45, 0, 0, 0.73611],
    41: [0.95003, 1.45, 0, 0, 0.73611],
    47: [0.95003, 1.45, 0, 0, 1.04445],
    91: [0.95003, 1.45, 0, 0, 0.52778],
    92: [0.95003, 1.45, 0, 0, 1.04445],
    93: [0.95003, 1.45, 0, 0, 0.52778],
    123: [0.95003, 1.45, 0, 0, 0.75],
    125: [0.95003, 1.45, 0, 0, 0.75],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.75, 0, 0, 1.44445],
    732: [0, 0.75, 0, 0, 1.44445],
    770: [0, 0.75, 0, 0, 1.44445],
    771: [0, 0.75, 0, 0, 1.44445],
    8730: [0.95003, 1.45, 0, 0, 1],
    8968: [0.95003, 1.45, 0, 0, 0.58334],
    8969: [0.95003, 1.45, 0, 0, 0.58334],
    8970: [0.95003, 1.45, 0, 0, 0.58334],
    8971: [0.95003, 1.45, 0, 0, 0.58334],
    10216: [0.95003, 1.45, 0, 0, 0.75],
    10217: [0.95003, 1.45, 0, 0, 0.75]
  },
  "Size4-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [1.25003, 1.75, 0, 0, 0.79167],
    41: [1.25003, 1.75, 0, 0, 0.79167],
    47: [1.25003, 1.75, 0, 0, 1.27778],
    91: [1.25003, 1.75, 0, 0, 0.58334],
    92: [1.25003, 1.75, 0, 0, 1.27778],
    93: [1.25003, 1.75, 0, 0, 0.58334],
    123: [1.25003, 1.75, 0, 0, 0.80556],
    125: [1.25003, 1.75, 0, 0, 0.80556],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.825, 0, 0, 1.8889],
    732: [0, 0.825, 0, 0, 1.8889],
    770: [0, 0.825, 0, 0, 1.8889],
    771: [0, 0.825, 0, 0, 1.8889],
    8730: [1.25003, 1.75, 0, 0, 1],
    8968: [1.25003, 1.75, 0, 0, 0.63889],
    8969: [1.25003, 1.75, 0, 0, 0.63889],
    8970: [1.25003, 1.75, 0, 0, 0.63889],
    8971: [1.25003, 1.75, 0, 0, 0.63889],
    9115: [0.64502, 1.155, 0, 0, 0.875],
    9116: [1e-5, 0.6, 0, 0, 0.875],
    9117: [0.64502, 1.155, 0, 0, 0.875],
    9118: [0.64502, 1.155, 0, 0, 0.875],
    9119: [1e-5, 0.6, 0, 0, 0.875],
    9120: [0.64502, 1.155, 0, 0, 0.875],
    9121: [0.64502, 1.155, 0, 0, 0.66667],
    9122: [-99e-5, 0.601, 0, 0, 0.66667],
    9123: [0.64502, 1.155, 0, 0, 0.66667],
    9124: [0.64502, 1.155, 0, 0, 0.66667],
    9125: [-99e-5, 0.601, 0, 0, 0.66667],
    9126: [0.64502, 1.155, 0, 0, 0.66667],
    9127: [1e-5, 0.9, 0, 0, 0.88889],
    9128: [0.65002, 1.15, 0, 0, 0.88889],
    9129: [0.90001, 0, 0, 0, 0.88889],
    9130: [0, 0.3, 0, 0, 0.88889],
    9131: [1e-5, 0.9, 0, 0, 0.88889],
    9132: [0.65002, 1.15, 0, 0, 0.88889],
    9133: [0.90001, 0, 0, 0, 0.88889],
    9143: [0.88502, 0.915, 0, 0, 1.05556],
    10216: [1.25003, 1.75, 0, 0, 0.80556],
    10217: [1.25003, 1.75, 0, 0, 0.80556],
    57344: [-499e-5, 0.605, 0, 0, 1.05556],
    57345: [-499e-5, 0.605, 0, 0, 1.05556],
    57680: [0, 0.12, 0, 0, 0.45],
    57681: [0, 0.12, 0, 0, 0.45],
    57682: [0, 0.12, 0, 0, 0.45],
    57683: [0, 0.12, 0, 0, 0.45]
  },
  "Typewriter-Regular": {
    32: [0, 0, 0, 0, 0.525],
    33: [0, 0.61111, 0, 0, 0.525],
    34: [0, 0.61111, 0, 0, 0.525],
    35: [0, 0.61111, 0, 0, 0.525],
    36: [0.08333, 0.69444, 0, 0, 0.525],
    37: [0.08333, 0.69444, 0, 0, 0.525],
    38: [0, 0.61111, 0, 0, 0.525],
    39: [0, 0.61111, 0, 0, 0.525],
    40: [0.08333, 0.69444, 0, 0, 0.525],
    41: [0.08333, 0.69444, 0, 0, 0.525],
    42: [0, 0.52083, 0, 0, 0.525],
    43: [-0.08056, 0.53055, 0, 0, 0.525],
    44: [0.13889, 0.125, 0, 0, 0.525],
    45: [-0.08056, 0.53055, 0, 0, 0.525],
    46: [0, 0.125, 0, 0, 0.525],
    47: [0.08333, 0.69444, 0, 0, 0.525],
    48: [0, 0.61111, 0, 0, 0.525],
    49: [0, 0.61111, 0, 0, 0.525],
    50: [0, 0.61111, 0, 0, 0.525],
    51: [0, 0.61111, 0, 0, 0.525],
    52: [0, 0.61111, 0, 0, 0.525],
    53: [0, 0.61111, 0, 0, 0.525],
    54: [0, 0.61111, 0, 0, 0.525],
    55: [0, 0.61111, 0, 0, 0.525],
    56: [0, 0.61111, 0, 0, 0.525],
    57: [0, 0.61111, 0, 0, 0.525],
    58: [0, 0.43056, 0, 0, 0.525],
    59: [0.13889, 0.43056, 0, 0, 0.525],
    60: [-0.05556, 0.55556, 0, 0, 0.525],
    61: [-0.19549, 0.41562, 0, 0, 0.525],
    62: [-0.05556, 0.55556, 0, 0, 0.525],
    63: [0, 0.61111, 0, 0, 0.525],
    64: [0, 0.61111, 0, 0, 0.525],
    65: [0, 0.61111, 0, 0, 0.525],
    66: [0, 0.61111, 0, 0, 0.525],
    67: [0, 0.61111, 0, 0, 0.525],
    68: [0, 0.61111, 0, 0, 0.525],
    69: [0, 0.61111, 0, 0, 0.525],
    70: [0, 0.61111, 0, 0, 0.525],
    71: [0, 0.61111, 0, 0, 0.525],
    72: [0, 0.61111, 0, 0, 0.525],
    73: [0, 0.61111, 0, 0, 0.525],
    74: [0, 0.61111, 0, 0, 0.525],
    75: [0, 0.61111, 0, 0, 0.525],
    76: [0, 0.61111, 0, 0, 0.525],
    77: [0, 0.61111, 0, 0, 0.525],
    78: [0, 0.61111, 0, 0, 0.525],
    79: [0, 0.61111, 0, 0, 0.525],
    80: [0, 0.61111, 0, 0, 0.525],
    81: [0.13889, 0.61111, 0, 0, 0.525],
    82: [0, 0.61111, 0, 0, 0.525],
    83: [0, 0.61111, 0, 0, 0.525],
    84: [0, 0.61111, 0, 0, 0.525],
    85: [0, 0.61111, 0, 0, 0.525],
    86: [0, 0.61111, 0, 0, 0.525],
    87: [0, 0.61111, 0, 0, 0.525],
    88: [0, 0.61111, 0, 0, 0.525],
    89: [0, 0.61111, 0, 0, 0.525],
    90: [0, 0.61111, 0, 0, 0.525],
    91: [0.08333, 0.69444, 0, 0, 0.525],
    92: [0.08333, 0.69444, 0, 0, 0.525],
    93: [0.08333, 0.69444, 0, 0, 0.525],
    94: [0, 0.61111, 0, 0, 0.525],
    95: [0.09514, 0, 0, 0, 0.525],
    96: [0, 0.61111, 0, 0, 0.525],
    97: [0, 0.43056, 0, 0, 0.525],
    98: [0, 0.61111, 0, 0, 0.525],
    99: [0, 0.43056, 0, 0, 0.525],
    100: [0, 0.61111, 0, 0, 0.525],
    101: [0, 0.43056, 0, 0, 0.525],
    102: [0, 0.61111, 0, 0, 0.525],
    103: [0.22222, 0.43056, 0, 0, 0.525],
    104: [0, 0.61111, 0, 0, 0.525],
    105: [0, 0.61111, 0, 0, 0.525],
    106: [0.22222, 0.61111, 0, 0, 0.525],
    107: [0, 0.61111, 0, 0, 0.525],
    108: [0, 0.61111, 0, 0, 0.525],
    109: [0, 0.43056, 0, 0, 0.525],
    110: [0, 0.43056, 0, 0, 0.525],
    111: [0, 0.43056, 0, 0, 0.525],
    112: [0.22222, 0.43056, 0, 0, 0.525],
    113: [0.22222, 0.43056, 0, 0, 0.525],
    114: [0, 0.43056, 0, 0, 0.525],
    115: [0, 0.43056, 0, 0, 0.525],
    116: [0, 0.55358, 0, 0, 0.525],
    117: [0, 0.43056, 0, 0, 0.525],
    118: [0, 0.43056, 0, 0, 0.525],
    119: [0, 0.43056, 0, 0, 0.525],
    120: [0, 0.43056, 0, 0, 0.525],
    121: [0.22222, 0.43056, 0, 0, 0.525],
    122: [0, 0.43056, 0, 0, 0.525],
    123: [0.08333, 0.69444, 0, 0, 0.525],
    124: [0.08333, 0.69444, 0, 0, 0.525],
    125: [0.08333, 0.69444, 0, 0, 0.525],
    126: [0, 0.61111, 0, 0, 0.525],
    127: [0, 0.61111, 0, 0, 0.525],
    160: [0, 0, 0, 0, 0.525],
    176: [0, 0.61111, 0, 0, 0.525],
    184: [0.19445, 0, 0, 0, 0.525],
    305: [0, 0.43056, 0, 0, 0.525],
    567: [0.22222, 0.43056, 0, 0, 0.525],
    711: [0, 0.56597, 0, 0, 0.525],
    713: [0, 0.56555, 0, 0, 0.525],
    714: [0, 0.61111, 0, 0, 0.525],
    715: [0, 0.61111, 0, 0, 0.525],
    728: [0, 0.61111, 0, 0, 0.525],
    730: [0, 0.61111, 0, 0, 0.525],
    770: [0, 0.61111, 0, 0, 0.525],
    771: [0, 0.61111, 0, 0, 0.525],
    776: [0, 0.61111, 0, 0, 0.525],
    915: [0, 0.61111, 0, 0, 0.525],
    916: [0, 0.61111, 0, 0, 0.525],
    920: [0, 0.61111, 0, 0, 0.525],
    923: [0, 0.61111, 0, 0, 0.525],
    926: [0, 0.61111, 0, 0, 0.525],
    928: [0, 0.61111, 0, 0, 0.525],
    931: [0, 0.61111, 0, 0, 0.525],
    933: [0, 0.61111, 0, 0, 0.525],
    934: [0, 0.61111, 0, 0, 0.525],
    936: [0, 0.61111, 0, 0, 0.525],
    937: [0, 0.61111, 0, 0, 0.525],
    8216: [0, 0.61111, 0, 0, 0.525],
    8217: [0, 0.61111, 0, 0, 0.525],
    8242: [0, 0.61111, 0, 0, 0.525],
    9251: [0.11111, 0.21944, 0, 0, 0.525]
  }
}, fv = {
  slant: [0.25, 0.25, 0.25],
  // sigma1
  space: [0, 0, 0],
  // sigma2
  stretch: [0, 0, 0],
  // sigma3
  shrink: [0, 0, 0],
  // sigma4
  xHeight: [0.431, 0.431, 0.431],
  // sigma5
  quad: [1, 1.171, 1.472],
  // sigma6
  extraSpace: [0, 0, 0],
  // sigma7
  num1: [0.677, 0.732, 0.925],
  // sigma8
  num2: [0.394, 0.384, 0.387],
  // sigma9
  num3: [0.444, 0.471, 0.504],
  // sigma10
  denom1: [0.686, 0.752, 1.025],
  // sigma11
  denom2: [0.345, 0.344, 0.532],
  // sigma12
  sup1: [0.413, 0.503, 0.504],
  // sigma13
  sup2: [0.363, 0.431, 0.404],
  // sigma14
  sup3: [0.289, 0.286, 0.294],
  // sigma15
  sub1: [0.15, 0.143, 0.2],
  // sigma16
  sub2: [0.247, 0.286, 0.4],
  // sigma17
  supDrop: [0.386, 0.353, 0.494],
  // sigma18
  subDrop: [0.05, 0.071, 0.1],
  // sigma19
  delim1: [2.39, 1.7, 1.98],
  // sigma20
  delim2: [1.01, 1.157, 1.42],
  // sigma21
  axisHeight: [0.25, 0.25, 0.25],
  // sigma22
  // These font metrics are extracted from TeX by using tftopl on cmex10.tfm;
  // they correspond to the font parameters of the extension fonts (family 3).
  // See the TeXbook, page 441. In AMSTeX, the extension fonts scale; to
  // match cmex7, we'd use cmex7.tfm values for script and scriptscript
  // values.
  defaultRuleThickness: [0.04, 0.049, 0.049],
  // xi8; cmex7: 0.049
  bigOpSpacing1: [0.111, 0.111, 0.111],
  // xi9
  bigOpSpacing2: [0.166, 0.166, 0.166],
  // xi10
  bigOpSpacing3: [0.2, 0.2, 0.2],
  // xi11
  bigOpSpacing4: [0.6, 0.611, 0.611],
  // xi12; cmex7: 0.611
  bigOpSpacing5: [0.1, 0.143, 0.143],
  // xi13; cmex7: 0.143
  // The \sqrt rule width is taken from the height of the surd character.
  // Since we use the same font at all sizes, this thickness doesn't scale.
  sqrtRuleThickness: [0.04, 0.04, 0.04],
  // This value determines how large a pt is, for metrics which are defined
  // in terms of pts.
  // This value is also used in katex.scss; if you change it make sure the
  // values match.
  ptPerEm: [10, 10, 10],
  // The space between adjacent `|` columns in an array definition. From
  // `\showthe\doublerulesep` in LaTeX. Equals 2.0 / ptPerEm.
  doubleRuleSep: [0.2, 0.2, 0.2],
  // The width of separator lines in {array} environments. From
  // `\showthe\arrayrulewidth` in LaTeX. Equals 0.4 / ptPerEm.
  arrayRuleWidth: [0.04, 0.04, 0.04],
  // Two values from LaTeX source2e:
  fboxsep: [0.3, 0.3, 0.3],
  //        3 pt / ptPerEm
  fboxrule: [0.04, 0.04, 0.04]
  // 0.4 pt / ptPerEm
}, D9 = {
  // Latin-1
  Å: "A",
  Ð: "D",
  Þ: "o",
  å: "a",
  ð: "d",
  þ: "o",
  // Cyrillic
  А: "A",
  Б: "B",
  В: "B",
  Г: "F",
  Д: "A",
  Е: "E",
  Ж: "K",
  З: "3",
  И: "N",
  Й: "N",
  К: "K",
  Л: "N",
  М: "M",
  Н: "H",
  О: "O",
  П: "N",
  Р: "P",
  С: "C",
  Т: "T",
  У: "y",
  Ф: "O",
  Х: "X",
  Ц: "U",
  Ч: "h",
  Ш: "W",
  Щ: "W",
  Ъ: "B",
  Ы: "X",
  Ь: "B",
  Э: "3",
  Ю: "X",
  Я: "R",
  а: "a",
  б: "b",
  в: "a",
  г: "r",
  д: "y",
  е: "e",
  ж: "m",
  з: "e",
  и: "n",
  й: "n",
  к: "n",
  л: "n",
  м: "m",
  н: "n",
  о: "o",
  п: "n",
  р: "p",
  с: "c",
  т: "o",
  у: "y",
  ф: "b",
  х: "x",
  ц: "n",
  ч: "n",
  ш: "w",
  щ: "w",
  ъ: "a",
  ы: "m",
  ь: "a",
  э: "e",
  ю: "m",
  я: "r"
};
function dL(r, t) {
  vo[r] = t;
}
function _7(r, t, a) {
  if (!vo[t])
    throw new Error("Font metrics not found for font: " + t + ".");
  var i = r.charCodeAt(0), s = vo[t][i];
  if (!s && r[0] in D9 && (i = D9[r[0]].charCodeAt(0), s = vo[t][i]), !s && a === "text" && mw(i) && (s = vo[t][77]), s)
    return {
      depth: s[0],
      height: s[1],
      italic: s[2],
      skew: s[3],
      width: s[4]
    };
}
var J6 = {};
function mL(r) {
  var t;
  if (r >= 5 ? t = 0 : r >= 3 ? t = 1 : t = 2, !J6[t]) {
    var a = J6[t] = {
      cssEmPerMu: fv.quad[t] / 18
    };
    for (var i in fv)
      fv.hasOwnProperty(i) && (a[i] = fv[i][t]);
  }
  return J6[t];
}
var pL = [
  // Each element contains [textsize, scriptsize, scriptscriptsize].
  // The size mappings are taken from TeX with \normalsize=10pt.
  [1, 1, 1],
  // size1: [5, 5, 5]              \tiny
  [2, 1, 1],
  // size2: [6, 5, 5]
  [3, 1, 1],
  // size3: [7, 5, 5]              \scriptsize
  [4, 2, 1],
  // size4: [8, 6, 5]              \footnotesize
  [5, 2, 1],
  // size5: [9, 6, 5]              \small
  [6, 3, 1],
  // size6: [10, 7, 5]             \normalsize
  [7, 4, 2],
  // size7: [12, 8, 6]             \large
  [8, 6, 3],
  // size8: [14.4, 10, 7]          \Large
  [9, 7, 6],
  // size9: [17.28, 12, 10]        \LARGE
  [10, 8, 7],
  // size10: [20.74, 14.4, 12]     \huge
  [11, 10, 9]
  // size11: [24.88, 20.74, 17.28] \HUGE
], N9 = [
  // fontMetrics.js:getGlobalMetrics also uses size indexes, so if
  // you change size indexes, change that function.
  0.5,
  0.6,
  0.7,
  0.8,
  0.9,
  1,
  1.2,
  1.44,
  1.728,
  2.074,
  2.488
], L9 = function(t, a) {
  return a.size < 2 ? t : pL[t - 1][a.size - 1];
};
class ws {
  // A font family applies to a group of fonts (i.e. SansSerif), while a font
  // represents a specific font (i.e. SansSerif Bold).
  // See: https://tex.stackexchange.com/questions/22350/difference-between-textrm-and-mathrm
  /**
   * The base size index.
   */
  constructor(t) {
    this.style = void 0, this.color = void 0, this.size = void 0, this.textSize = void 0, this.phantom = void 0, this.font = void 0, this.fontFamily = void 0, this.fontWeight = void 0, this.fontShape = void 0, this.sizeMultiplier = void 0, this.maxSize = void 0, this.minRuleThickness = void 0, this._fontMetrics = void 0, this.style = t.style, this.color = t.color, this.size = t.size || ws.BASESIZE, this.textSize = t.textSize || this.size, this.phantom = !!t.phantom, this.font = t.font || "", this.fontFamily = t.fontFamily || "", this.fontWeight = t.fontWeight || "", this.fontShape = t.fontShape || "", this.sizeMultiplier = N9[this.size - 1], this.maxSize = t.maxSize, this.minRuleThickness = t.minRuleThickness, this._fontMetrics = void 0;
  }
  /**
   * Returns a new options object with the same properties as "this".  Properties
   * from "extension" will be copied to the new options object.
   */
  extend(t) {
    var a = {
      style: this.style,
      size: this.size,
      textSize: this.textSize,
      color: this.color,
      phantom: this.phantom,
      font: this.font,
      fontFamily: this.fontFamily,
      fontWeight: this.fontWeight,
      fontShape: this.fontShape,
      maxSize: this.maxSize,
      minRuleThickness: this.minRuleThickness
    };
    for (var i in t)
      t.hasOwnProperty(i) && (a[i] = t[i]);
    return new ws(a);
  }
  /**
   * Return an options object with the given style. If `this.style === style`,
   * returns `this`.
   */
  havingStyle(t) {
    return this.style === t ? this : this.extend({
      style: t,
      size: L9(this.textSize, t)
    });
  }
  /**
   * Return an options object with a cramped version of the current style. If
   * the current style is cramped, returns `this`.
   */
  havingCrampedStyle() {
    return this.havingStyle(this.style.cramp());
  }
  /**
   * Return an options object with the given size and in at least `\textstyle`.
   * Returns `this` if appropriate.
   */
  havingSize(t) {
    return this.size === t && this.textSize === t ? this : this.extend({
      style: this.style.text(),
      size: t,
      textSize: t,
      sizeMultiplier: N9[t - 1]
    });
  }
  /**
   * Like `this.havingSize(BASESIZE).havingStyle(style)`. If `style` is omitted,
   * changes to at least `\textstyle`.
   */
  havingBaseStyle(t) {
    t = t || this.style.text();
    var a = L9(ws.BASESIZE, t);
    return this.size === a && this.textSize === ws.BASESIZE && this.style === t ? this : this.extend({
      style: t,
      size: a
    });
  }
  /**
   * Remove the effect of sizing changes such as \Huge.
   * Keep the effect of the current style, such as \scriptstyle.
   */
  havingBaseSizing() {
    var t;
    switch (this.style.id) {
      case 4:
      case 5:
        t = 3;
        break;
      case 6:
      case 7:
        t = 1;
        break;
      default:
        t = 6;
    }
    return this.extend({
      style: this.style.text(),
      size: t
    });
  }
  /**
   * Create a new options object with the given color.
   */
  withColor(t) {
    return this.extend({
      color: t
    });
  }
  /**
   * Create a new options object with "phantom" set to true.
   */
  withPhantom() {
    return this.extend({
      phantom: !0
    });
  }
  /**
   * Creates a new options object with the given math font or old text font.
   * @type {[type]}
   */
  withFont(t) {
    return this.extend({
      font: t
    });
  }
  /**
   * Create a new options objects with the given fontFamily.
   */
  withTextFontFamily(t) {
    return this.extend({
      fontFamily: t,
      font: ""
    });
  }
  /**
   * Creates a new options object with the given font weight
   */
  withTextFontWeight(t) {
    return this.extend({
      fontWeight: t,
      font: ""
    });
  }
  /**
   * Creates a new options object with the given font weight
   */
  withTextFontShape(t) {
    return this.extend({
      fontShape: t,
      font: ""
    });
  }
  /**
   * Return the CSS sizing classes required to switch from enclosing options
   * `oldOptions` to `this`. Returns an array of classes.
   */
  sizingClasses(t) {
    return t.size !== this.size ? ["sizing", "reset-size" + t.size, "size" + this.size] : [];
  }
  /**
   * Return the CSS sizing classes required to switch to the base size. Like
   * `this.havingSize(BASESIZE).sizingClasses(this)`.
   */
  baseSizingClasses() {
    return this.size !== ws.BASESIZE ? ["sizing", "reset-size" + this.size, "size" + ws.BASESIZE] : [];
  }
  /**
   * Return the font metrics for this size.
   */
  fontMetrics() {
    return this._fontMetrics || (this._fontMetrics = mL(this.size)), this._fontMetrics;
  }
  /**
   * Gets the CSS color of the current options object
   */
  getColor() {
    return this.phantom ? "transparent" : this.color;
  }
}
ws.BASESIZE = 6;
var N5 = {
  // https://en.wikibooks.org/wiki/LaTeX/Lengths and
  // https://tex.stackexchange.com/a/8263
  pt: 1,
  // TeX point
  mm: 7227 / 2540,
  // millimeter
  cm: 7227 / 254,
  // centimeter
  in: 72.27,
  // inch
  bp: 803 / 800,
  // big (PostScript) points
  pc: 12,
  // pica
  dd: 1238 / 1157,
  // didot
  cc: 14856 / 1157,
  // cicero (12 didot)
  nd: 685 / 642,
  // new didot
  nc: 1370 / 107,
  // new cicero (12 new didot)
  sp: 1 / 65536,
  // scaled point (TeX's internal smallest unit)
  // https://tex.stackexchange.com/a/41371
  px: 803 / 800
  // \pdfpxdimen defaults to 1 bp in pdfTeX and LuaTeX
}, gL = {
  ex: !0,
  em: !0,
  mu: !0
}, pw = function(t) {
  return typeof t != "string" && (t = t.unit), t in N5 || t in gL || t === "ex";
}, Wn = function(t, a) {
  var i;
  if (t.unit in N5)
    i = N5[t.unit] / a.fontMetrics().ptPerEm / a.sizeMultiplier;
  else if (t.unit === "mu")
    i = a.fontMetrics().cssEmPerMu;
  else {
    var s;
    if (a.style.isTight() ? s = a.havingStyle(a.style.text()) : s = a, t.unit === "ex")
      i = s.fontMetrics().xHeight;
    else if (t.unit === "em")
      i = s.fontMetrics().quad;
    else
      throw new $e("Invalid unit: '" + t.unit + "'");
    s !== a && (i *= s.sizeMultiplier / a.sizeMultiplier);
  }
  return Math.min(t.number * i, a.maxSize);
}, Fe = function(t) {
  return +t.toFixed(4) + "em";
}, a0 = function(t) {
  return t.filter((a) => a).join(" ");
}, gw = function(t, a, i) {
  if (this.classes = t || [], this.attributes = {}, this.height = 0, this.depth = 0, this.maxFontSize = 0, this.style = i || {}, a) {
    a.style.isTight() && this.classes.push("mtight");
    var s = a.getColor();
    s && (this.style.color = s);
  }
}, yw = function(t) {
  var a = document.createElement(t);
  a.className = a0(this.classes);
  for (var i in this.style)
    this.style.hasOwnProperty(i) && (a.style[i] = this.style[i]);
  for (var s in this.attributes)
    this.attributes.hasOwnProperty(s) && a.setAttribute(s, this.attributes[s]);
  for (var h = 0; h < this.children.length; h++)
    a.appendChild(this.children[h].toNode());
  return a;
}, yL = /[\s"'>/=\x00-\x1f]/, vw = function(t) {
  var a = "<" + t;
  this.classes.length && (a += ' class="' + dt.escape(a0(this.classes)) + '"');
  var i = "";
  for (var s in this.style)
    this.style.hasOwnProperty(s) && (i += dt.hyphenate(s) + ":" + this.style[s] + ";");
  i && (a += ' style="' + dt.escape(i) + '"');
  for (var h in this.attributes)
    if (this.attributes.hasOwnProperty(h)) {
      if (yL.test(h))
        throw new $e("Invalid attribute name '" + h + "'");
      a += " " + h + '="' + dt.escape(this.attributes[h]) + '"';
    }
  a += ">";
  for (var d = 0; d < this.children.length; d++)
    a += this.children[d].toMarkup();
  return a += "</" + t + ">", a;
};
class i4 {
  constructor(t, a, i, s) {
    this.children = void 0, this.attributes = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.width = void 0, this.maxFontSize = void 0, this.style = void 0, gw.call(this, t, i, s), this.children = a || [];
  }
  /**
   * Sets an arbitrary attribute on the span. Warning: use this wisely. Not
   * all browsers support attributes the same, and having too many custom
   * attributes is probably bad.
   */
  setAttribute(t, a) {
    this.attributes[t] = a;
  }
  hasClass(t) {
    return dt.contains(this.classes, t);
  }
  toNode() {
    return yw.call(this, "span");
  }
  toMarkup() {
    return vw.call(this, "span");
  }
}
class O7 {
  constructor(t, a, i, s) {
    this.children = void 0, this.attributes = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, gw.call(this, a, s), this.children = i || [], this.setAttribute("href", t);
  }
  setAttribute(t, a) {
    this.attributes[t] = a;
  }
  hasClass(t) {
    return dt.contains(this.classes, t);
  }
  toNode() {
    return yw.call(this, "a");
  }
  toMarkup() {
    return vw.call(this, "a");
  }
}
class vL {
  constructor(t, a, i) {
    this.src = void 0, this.alt = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, this.alt = a, this.src = t, this.classes = ["mord"], this.style = i;
  }
  hasClass(t) {
    return dt.contains(this.classes, t);
  }
  toNode() {
    var t = document.createElement("img");
    t.src = this.src, t.alt = this.alt, t.className = "mord";
    for (var a in this.style)
      this.style.hasOwnProperty(a) && (t.style[a] = this.style[a]);
    return t;
  }
  toMarkup() {
    var t = '<img src="' + dt.escape(this.src) + '"' + (' alt="' + dt.escape(this.alt) + '"'), a = "";
    for (var i in this.style)
      this.style.hasOwnProperty(i) && (a += dt.hyphenate(i) + ":" + this.style[i] + ";");
    return a && (t += ' style="' + dt.escape(a) + '"'), t += "'/>", t;
  }
}
var bL = {
  î: "ı̂",
  ï: "ı̈",
  í: "ı́",
  // 'ī': '\u0131\u0304', // enable when we add Extended Latin
  ì: "ı̀"
};
class qi {
  constructor(t, a, i, s, h, d, y, g) {
    this.text = void 0, this.height = void 0, this.depth = void 0, this.italic = void 0, this.skew = void 0, this.width = void 0, this.maxFontSize = void 0, this.classes = void 0, this.style = void 0, this.text = t, this.height = a || 0, this.depth = i || 0, this.italic = s || 0, this.skew = h || 0, this.width = d || 0, this.classes = y || [], this.style = g || {}, this.maxFontSize = 0;
    var b = nL(this.text.charCodeAt(0));
    b && this.classes.push(b + "_fallback"), /[îïíì]/.test(this.text) && (this.text = bL[this.text]);
  }
  hasClass(t) {
    return dt.contains(this.classes, t);
  }
  /**
   * Creates a text node or span from a symbol node. Note that a span is only
   * created if it is needed.
   */
  toNode() {
    var t = document.createTextNode(this.text), a = null;
    this.italic > 0 && (a = document.createElement("span"), a.style.marginRight = Fe(this.italic)), this.classes.length > 0 && (a = a || document.createElement("span"), a.className = a0(this.classes));
    for (var i in this.style)
      this.style.hasOwnProperty(i) && (a = a || document.createElement("span"), a.style[i] = this.style[i]);
    return a ? (a.appendChild(t), a) : t;
  }
  /**
   * Creates markup for a symbol node.
   */
  toMarkup() {
    var t = !1, a = "<span";
    this.classes.length && (t = !0, a += ' class="', a += dt.escape(a0(this.classes)), a += '"');
    var i = "";
    this.italic > 0 && (i += "margin-right:" + this.italic + "em;");
    for (var s in this.style)
      this.style.hasOwnProperty(s) && (i += dt.hyphenate(s) + ":" + this.style[s] + ";");
    i && (t = !0, a += ' style="' + dt.escape(i) + '"');
    var h = dt.escape(this.text);
    return t ? (a += ">", a += h, a += "</span>", a) : h;
  }
}
class As {
  constructor(t, a) {
    this.children = void 0, this.attributes = void 0, this.children = t || [], this.attributes = a || {};
  }
  toNode() {
    var t = "http://www.w3.org/2000/svg", a = document.createElementNS(t, "svg");
    for (var i in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, i) && a.setAttribute(i, this.attributes[i]);
    for (var s = 0; s < this.children.length; s++)
      a.appendChild(this.children[s].toNode());
    return a;
  }
  toMarkup() {
    var t = '<svg xmlns="http://www.w3.org/2000/svg"';
    for (var a in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, a) && (t += " " + a + '="' + dt.escape(this.attributes[a]) + '"');
    t += ">";
    for (var i = 0; i < this.children.length; i++)
      t += this.children[i].toMarkup();
    return t += "</svg>", t;
  }
}
class l0 {
  constructor(t, a) {
    this.pathName = void 0, this.alternate = void 0, this.pathName = t, this.alternate = a;
  }
  toNode() {
    var t = "http://www.w3.org/2000/svg", a = document.createElementNS(t, "path");
    return this.alternate ? a.setAttribute("d", this.alternate) : a.setAttribute("d", O9[this.pathName]), a;
  }
  toMarkup() {
    return this.alternate ? '<path d="' + dt.escape(this.alternate) + '"/>' : '<path d="' + dt.escape(O9[this.pathName]) + '"/>';
  }
}
class L5 {
  constructor(t) {
    this.attributes = void 0, this.attributes = t || {};
  }
  toNode() {
    var t = "http://www.w3.org/2000/svg", a = document.createElementNS(t, "line");
    for (var i in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, i) && a.setAttribute(i, this.attributes[i]);
    return a;
  }
  toMarkup() {
    var t = "<line";
    for (var a in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, a) && (t += " " + a + '="' + dt.escape(this.attributes[a]) + '"');
    return t += "/>", t;
  }
}
function B9(r) {
  if (r instanceof qi)
    return r;
  throw new Error("Expected symbolNode but got " + String(r) + ".");
}
function SL(r) {
  if (r instanceof i4)
    return r;
  throw new Error("Expected span<HtmlDomNode> but got " + String(r) + ".");
}
var xL = {
  bin: 1,
  close: 1,
  inner: 1,
  open: 1,
  punct: 1,
  rel: 1
}, wL = {
  "accent-token": 1,
  mathord: 1,
  "op-token": 1,
  spacing: 1,
  textord: 1
}, Bn = {
  math: {},
  text: {}
};
function A(r, t, a, i, s, h) {
  Bn[r][s] = {
    font: t,
    group: a,
    replace: i
  }, h && i && (Bn[r][i] = Bn[r][s]);
}
var z = "math", qe = "text", D = "main", Q = "ams", Qn = "accent-token", We = "bin", tl = "close", Dm = "inner", gt = "mathord", Or = "op-token", ri = "open", Kv = "punct", P = "rel", Cs = "spacing", le = "textord";
A(z, D, P, "≡", "\\equiv", !0);
A(z, D, P, "≺", "\\prec", !0);
A(z, D, P, "≻", "\\succ", !0);
A(z, D, P, "∼", "\\sim", !0);
A(z, D, P, "⊥", "\\perp");
A(z, D, P, "⪯", "\\preceq", !0);
A(z, D, P, "⪰", "\\succeq", !0);
A(z, D, P, "≃", "\\simeq", !0);
A(z, D, P, "∣", "\\mid", !0);
A(z, D, P, "≪", "\\ll", !0);
A(z, D, P, "≫", "\\gg", !0);
A(z, D, P, "≍", "\\asymp", !0);
A(z, D, P, "∥", "\\parallel");
A(z, D, P, "⋈", "\\bowtie", !0);
A(z, D, P, "⌣", "\\smile", !0);
A(z, D, P, "⊑", "\\sqsubseteq", !0);
A(z, D, P, "⊒", "\\sqsupseteq", !0);
A(z, D, P, "≐", "\\doteq", !0);
A(z, D, P, "⌢", "\\frown", !0);
A(z, D, P, "∋", "\\ni", !0);
A(z, D, P, "∝", "\\propto", !0);
A(z, D, P, "⊢", "\\vdash", !0);
A(z, D, P, "⊣", "\\dashv", !0);
A(z, D, P, "∋", "\\owns");
A(z, D, Kv, ".", "\\ldotp");
A(z, D, Kv, "⋅", "\\cdotp");
A(z, D, le, "#", "\\#");
A(qe, D, le, "#", "\\#");
A(z, D, le, "&", "\\&");
A(qe, D, le, "&", "\\&");
A(z, D, le, "ℵ", "\\aleph", !0);
A(z, D, le, "∀", "\\forall", !0);
A(z, D, le, "ℏ", "\\hbar", !0);
A(z, D, le, "∃", "\\exists", !0);
A(z, D, le, "∇", "\\nabla", !0);
A(z, D, le, "♭", "\\flat", !0);
A(z, D, le, "ℓ", "\\ell", !0);
A(z, D, le, "♮", "\\natural", !0);
A(z, D, le, "♣", "\\clubsuit", !0);
A(z, D, le, "℘", "\\wp", !0);
A(z, D, le, "♯", "\\sharp", !0);
A(z, D, le, "♢", "\\diamondsuit", !0);
A(z, D, le, "ℜ", "\\Re", !0);
A(z, D, le, "♡", "\\heartsuit", !0);
A(z, D, le, "ℑ", "\\Im", !0);
A(z, D, le, "♠", "\\spadesuit", !0);
A(z, D, le, "§", "\\S", !0);
A(qe, D, le, "§", "\\S");
A(z, D, le, "¶", "\\P", !0);
A(qe, D, le, "¶", "\\P");
A(z, D, le, "†", "\\dag");
A(qe, D, le, "†", "\\dag");
A(qe, D, le, "†", "\\textdagger");
A(z, D, le, "‡", "\\ddag");
A(qe, D, le, "‡", "\\ddag");
A(qe, D, le, "‡", "\\textdaggerdbl");
A(z, D, tl, "⎱", "\\rmoustache", !0);
A(z, D, ri, "⎰", "\\lmoustache", !0);
A(z, D, tl, "⟯", "\\rgroup", !0);
A(z, D, ri, "⟮", "\\lgroup", !0);
A(z, D, We, "∓", "\\mp", !0);
A(z, D, We, "⊖", "\\ominus", !0);
A(z, D, We, "⊎", "\\uplus", !0);
A(z, D, We, "⊓", "\\sqcap", !0);
A(z, D, We, "∗", "\\ast");
A(z, D, We, "⊔", "\\sqcup", !0);
A(z, D, We, "◯", "\\bigcirc", !0);
A(z, D, We, "∙", "\\bullet", !0);
A(z, D, We, "‡", "\\ddagger");
A(z, D, We, "≀", "\\wr", !0);
A(z, D, We, "⨿", "\\amalg");
A(z, D, We, "&", "\\And");
A(z, D, P, "⟵", "\\longleftarrow", !0);
A(z, D, P, "⇐", "\\Leftarrow", !0);
A(z, D, P, "⟸", "\\Longleftarrow", !0);
A(z, D, P, "⟶", "\\longrightarrow", !0);
A(z, D, P, "⇒", "\\Rightarrow", !0);
A(z, D, P, "⟹", "\\Longrightarrow", !0);
A(z, D, P, "↔", "\\leftrightarrow", !0);
A(z, D, P, "⟷", "\\longleftrightarrow", !0);
A(z, D, P, "⇔", "\\Leftrightarrow", !0);
A(z, D, P, "⟺", "\\Longleftrightarrow", !0);
A(z, D, P, "↦", "\\mapsto", !0);
A(z, D, P, "⟼", "\\longmapsto", !0);
A(z, D, P, "↗", "\\nearrow", !0);
A(z, D, P, "↩", "\\hookleftarrow", !0);
A(z, D, P, "↪", "\\hookrightarrow", !0);
A(z, D, P, "↘", "\\searrow", !0);
A(z, D, P, "↼", "\\leftharpoonup", !0);
A(z, D, P, "⇀", "\\rightharpoonup", !0);
A(z, D, P, "↙", "\\swarrow", !0);
A(z, D, P, "↽", "\\leftharpoondown", !0);
A(z, D, P, "⇁", "\\rightharpoondown", !0);
A(z, D, P, "↖", "\\nwarrow", !0);
A(z, D, P, "⇌", "\\rightleftharpoons", !0);
A(z, Q, P, "≮", "\\nless", !0);
A(z, Q, P, "", "\\@nleqslant");
A(z, Q, P, "", "\\@nleqq");
A(z, Q, P, "⪇", "\\lneq", !0);
A(z, Q, P, "≨", "\\lneqq", !0);
A(z, Q, P, "", "\\@lvertneqq");
A(z, Q, P, "⋦", "\\lnsim", !0);
A(z, Q, P, "⪉", "\\lnapprox", !0);
A(z, Q, P, "⊀", "\\nprec", !0);
A(z, Q, P, "⋠", "\\npreceq", !0);
A(z, Q, P, "⋨", "\\precnsim", !0);
A(z, Q, P, "⪹", "\\precnapprox", !0);
A(z, Q, P, "≁", "\\nsim", !0);
A(z, Q, P, "", "\\@nshortmid");
A(z, Q, P, "∤", "\\nmid", !0);
A(z, Q, P, "⊬", "\\nvdash", !0);
A(z, Q, P, "⊭", "\\nvDash", !0);
A(z, Q, P, "⋪", "\\ntriangleleft");
A(z, Q, P, "⋬", "\\ntrianglelefteq", !0);
A(z, Q, P, "⊊", "\\subsetneq", !0);
A(z, Q, P, "", "\\@varsubsetneq");
A(z, Q, P, "⫋", "\\subsetneqq", !0);
A(z, Q, P, "", "\\@varsubsetneqq");
A(z, Q, P, "≯", "\\ngtr", !0);
A(z, Q, P, "", "\\@ngeqslant");
A(z, Q, P, "", "\\@ngeqq");
A(z, Q, P, "⪈", "\\gneq", !0);
A(z, Q, P, "≩", "\\gneqq", !0);
A(z, Q, P, "", "\\@gvertneqq");
A(z, Q, P, "⋧", "\\gnsim", !0);
A(z, Q, P, "⪊", "\\gnapprox", !0);
A(z, Q, P, "⊁", "\\nsucc", !0);
A(z, Q, P, "⋡", "\\nsucceq", !0);
A(z, Q, P, "⋩", "\\succnsim", !0);
A(z, Q, P, "⪺", "\\succnapprox", !0);
A(z, Q, P, "≆", "\\ncong", !0);
A(z, Q, P, "", "\\@nshortparallel");
A(z, Q, P, "∦", "\\nparallel", !0);
A(z, Q, P, "⊯", "\\nVDash", !0);
A(z, Q, P, "⋫", "\\ntriangleright");
A(z, Q, P, "⋭", "\\ntrianglerighteq", !0);
A(z, Q, P, "", "\\@nsupseteqq");
A(z, Q, P, "⊋", "\\supsetneq", !0);
A(z, Q, P, "", "\\@varsupsetneq");
A(z, Q, P, "⫌", "\\supsetneqq", !0);
A(z, Q, P, "", "\\@varsupsetneqq");
A(z, Q, P, "⊮", "\\nVdash", !0);
A(z, Q, P, "⪵", "\\precneqq", !0);
A(z, Q, P, "⪶", "\\succneqq", !0);
A(z, Q, P, "", "\\@nsubseteqq");
A(z, Q, We, "⊴", "\\unlhd");
A(z, Q, We, "⊵", "\\unrhd");
A(z, Q, P, "↚", "\\nleftarrow", !0);
A(z, Q, P, "↛", "\\nrightarrow", !0);
A(z, Q, P, "⇍", "\\nLeftarrow", !0);
A(z, Q, P, "⇏", "\\nRightarrow", !0);
A(z, Q, P, "↮", "\\nleftrightarrow", !0);
A(z, Q, P, "⇎", "\\nLeftrightarrow", !0);
A(z, Q, P, "△", "\\vartriangle");
A(z, Q, le, "ℏ", "\\hslash");
A(z, Q, le, "▽", "\\triangledown");
A(z, Q, le, "◊", "\\lozenge");
A(z, Q, le, "Ⓢ", "\\circledS");
A(z, Q, le, "®", "\\circledR");
A(qe, Q, le, "®", "\\circledR");
A(z, Q, le, "∡", "\\measuredangle", !0);
A(z, Q, le, "∄", "\\nexists");
A(z, Q, le, "℧", "\\mho");
A(z, Q, le, "Ⅎ", "\\Finv", !0);
A(z, Q, le, "⅁", "\\Game", !0);
A(z, Q, le, "‵", "\\backprime");
A(z, Q, le, "▲", "\\blacktriangle");
A(z, Q, le, "▼", "\\blacktriangledown");
A(z, Q, le, "■", "\\blacksquare");
A(z, Q, le, "⧫", "\\blacklozenge");
A(z, Q, le, "★", "\\bigstar");
A(z, Q, le, "∢", "\\sphericalangle", !0);
A(z, Q, le, "∁", "\\complement", !0);
A(z, Q, le, "ð", "\\eth", !0);
A(qe, D, le, "ð", "ð");
A(z, Q, le, "╱", "\\diagup");
A(z, Q, le, "╲", "\\diagdown");
A(z, Q, le, "□", "\\square");
A(z, Q, le, "□", "\\Box");
A(z, Q, le, "◊", "\\Diamond");
A(z, Q, le, "¥", "\\yen", !0);
A(qe, Q, le, "¥", "\\yen", !0);
A(z, Q, le, "✓", "\\checkmark", !0);
A(qe, Q, le, "✓", "\\checkmark");
A(z, Q, le, "ℶ", "\\beth", !0);
A(z, Q, le, "ℸ", "\\daleth", !0);
A(z, Q, le, "ℷ", "\\gimel", !0);
A(z, Q, le, "ϝ", "\\digamma", !0);
A(z, Q, le, "ϰ", "\\varkappa");
A(z, Q, ri, "┌", "\\@ulcorner", !0);
A(z, Q, tl, "┐", "\\@urcorner", !0);
A(z, Q, ri, "└", "\\@llcorner", !0);
A(z, Q, tl, "┘", "\\@lrcorner", !0);
A(z, Q, P, "≦", "\\leqq", !0);
A(z, Q, P, "⩽", "\\leqslant", !0);
A(z, Q, P, "⪕", "\\eqslantless", !0);
A(z, Q, P, "≲", "\\lesssim", !0);
A(z, Q, P, "⪅", "\\lessapprox", !0);
A(z, Q, P, "≊", "\\approxeq", !0);
A(z, Q, We, "⋖", "\\lessdot");
A(z, Q, P, "⋘", "\\lll", !0);
A(z, Q, P, "≶", "\\lessgtr", !0);
A(z, Q, P, "⋚", "\\lesseqgtr", !0);
A(z, Q, P, "⪋", "\\lesseqqgtr", !0);
A(z, Q, P, "≑", "\\doteqdot");
A(z, Q, P, "≓", "\\risingdotseq", !0);
A(z, Q, P, "≒", "\\fallingdotseq", !0);
A(z, Q, P, "∽", "\\backsim", !0);
A(z, Q, P, "⋍", "\\backsimeq", !0);
A(z, Q, P, "⫅", "\\subseteqq", !0);
A(z, Q, P, "⋐", "\\Subset", !0);
A(z, Q, P, "⊏", "\\sqsubset", !0);
A(z, Q, P, "≼", "\\preccurlyeq", !0);
A(z, Q, P, "⋞", "\\curlyeqprec", !0);
A(z, Q, P, "≾", "\\precsim", !0);
A(z, Q, P, "⪷", "\\precapprox", !0);
A(z, Q, P, "⊲", "\\vartriangleleft");
A(z, Q, P, "⊴", "\\trianglelefteq");
A(z, Q, P, "⊨", "\\vDash", !0);
A(z, Q, P, "⊪", "\\Vvdash", !0);
A(z, Q, P, "⌣", "\\smallsmile");
A(z, Q, P, "⌢", "\\smallfrown");
A(z, Q, P, "≏", "\\bumpeq", !0);
A(z, Q, P, "≎", "\\Bumpeq", !0);
A(z, Q, P, "≧", "\\geqq", !0);
A(z, Q, P, "⩾", "\\geqslant", !0);
A(z, Q, P, "⪖", "\\eqslantgtr", !0);
A(z, Q, P, "≳", "\\gtrsim", !0);
A(z, Q, P, "⪆", "\\gtrapprox", !0);
A(z, Q, We, "⋗", "\\gtrdot");
A(z, Q, P, "⋙", "\\ggg", !0);
A(z, Q, P, "≷", "\\gtrless", !0);
A(z, Q, P, "⋛", "\\gtreqless", !0);
A(z, Q, P, "⪌", "\\gtreqqless", !0);
A(z, Q, P, "≖", "\\eqcirc", !0);
A(z, Q, P, "≗", "\\circeq", !0);
A(z, Q, P, "≜", "\\triangleq", !0);
A(z, Q, P, "∼", "\\thicksim");
A(z, Q, P, "≈", "\\thickapprox");
A(z, Q, P, "⫆", "\\supseteqq", !0);
A(z, Q, P, "⋑", "\\Supset", !0);
A(z, Q, P, "⊐", "\\sqsupset", !0);
A(z, Q, P, "≽", "\\succcurlyeq", !0);
A(z, Q, P, "⋟", "\\curlyeqsucc", !0);
A(z, Q, P, "≿", "\\succsim", !0);
A(z, Q, P, "⪸", "\\succapprox", !0);
A(z, Q, P, "⊳", "\\vartriangleright");
A(z, Q, P, "⊵", "\\trianglerighteq");
A(z, Q, P, "⊩", "\\Vdash", !0);
A(z, Q, P, "∣", "\\shortmid");
A(z, Q, P, "∥", "\\shortparallel");
A(z, Q, P, "≬", "\\between", !0);
A(z, Q, P, "⋔", "\\pitchfork", !0);
A(z, Q, P, "∝", "\\varpropto");
A(z, Q, P, "◀", "\\blacktriangleleft");
A(z, Q, P, "∴", "\\therefore", !0);
A(z, Q, P, "∍", "\\backepsilon");
A(z, Q, P, "▶", "\\blacktriangleright");
A(z, Q, P, "∵", "\\because", !0);
A(z, Q, P, "⋘", "\\llless");
A(z, Q, P, "⋙", "\\gggtr");
A(z, Q, We, "⊲", "\\lhd");
A(z, Q, We, "⊳", "\\rhd");
A(z, Q, P, "≂", "\\eqsim", !0);
A(z, D, P, "⋈", "\\Join");
A(z, Q, P, "≑", "\\Doteq", !0);
A(z, Q, We, "∔", "\\dotplus", !0);
A(z, Q, We, "∖", "\\smallsetminus");
A(z, Q, We, "⋒", "\\Cap", !0);
A(z, Q, We, "⋓", "\\Cup", !0);
A(z, Q, We, "⩞", "\\doublebarwedge", !0);
A(z, Q, We, "⊟", "\\boxminus", !0);
A(z, Q, We, "⊞", "\\boxplus", !0);
A(z, Q, We, "⋇", "\\divideontimes", !0);
A(z, Q, We, "⋉", "\\ltimes", !0);
A(z, Q, We, "⋊", "\\rtimes", !0);
A(z, Q, We, "⋋", "\\leftthreetimes", !0);
A(z, Q, We, "⋌", "\\rightthreetimes", !0);
A(z, Q, We, "⋏", "\\curlywedge", !0);
A(z, Q, We, "⋎", "\\curlyvee", !0);
A(z, Q, We, "⊝", "\\circleddash", !0);
A(z, Q, We, "⊛", "\\circledast", !0);
A(z, Q, We, "⋅", "\\centerdot");
A(z, Q, We, "⊺", "\\intercal", !0);
A(z, Q, We, "⋒", "\\doublecap");
A(z, Q, We, "⋓", "\\doublecup");
A(z, Q, We, "⊠", "\\boxtimes", !0);
A(z, Q, P, "⇢", "\\dashrightarrow", !0);
A(z, Q, P, "⇠", "\\dashleftarrow", !0);
A(z, Q, P, "⇇", "\\leftleftarrows", !0);
A(z, Q, P, "⇆", "\\leftrightarrows", !0);
A(z, Q, P, "⇚", "\\Lleftarrow", !0);
A(z, Q, P, "↞", "\\twoheadleftarrow", !0);
A(z, Q, P, "↢", "\\leftarrowtail", !0);
A(z, Q, P, "↫", "\\looparrowleft", !0);
A(z, Q, P, "⇋", "\\leftrightharpoons", !0);
A(z, Q, P, "↶", "\\curvearrowleft", !0);
A(z, Q, P, "↺", "\\circlearrowleft", !0);
A(z, Q, P, "↰", "\\Lsh", !0);
A(z, Q, P, "⇈", "\\upuparrows", !0);
A(z, Q, P, "↿", "\\upharpoonleft", !0);
A(z, Q, P, "⇃", "\\downharpoonleft", !0);
A(z, D, P, "⊶", "\\origof", !0);
A(z, D, P, "⊷", "\\imageof", !0);
A(z, Q, P, "⊸", "\\multimap", !0);
A(z, Q, P, "↭", "\\leftrightsquigarrow", !0);
A(z, Q, P, "⇉", "\\rightrightarrows", !0);
A(z, Q, P, "⇄", "\\rightleftarrows", !0);
A(z, Q, P, "↠", "\\twoheadrightarrow", !0);
A(z, Q, P, "↣", "\\rightarrowtail", !0);
A(z, Q, P, "↬", "\\looparrowright", !0);
A(z, Q, P, "↷", "\\curvearrowright", !0);
A(z, Q, P, "↻", "\\circlearrowright", !0);
A(z, Q, P, "↱", "\\Rsh", !0);
A(z, Q, P, "⇊", "\\downdownarrows", !0);
A(z, Q, P, "↾", "\\upharpoonright", !0);
A(z, Q, P, "⇂", "\\downharpoonright", !0);
A(z, Q, P, "⇝", "\\rightsquigarrow", !0);
A(z, Q, P, "⇝", "\\leadsto");
A(z, Q, P, "⇛", "\\Rrightarrow", !0);
A(z, Q, P, "↾", "\\restriction");
A(z, D, le, "‘", "`");
A(z, D, le, "$", "\\$");
A(qe, D, le, "$", "\\$");
A(qe, D, le, "$", "\\textdollar");
A(z, D, le, "%", "\\%");
A(qe, D, le, "%", "\\%");
A(z, D, le, "_", "\\_");
A(qe, D, le, "_", "\\_");
A(qe, D, le, "_", "\\textunderscore");
A(z, D, le, "∠", "\\angle", !0);
A(z, D, le, "∞", "\\infty", !0);
A(z, D, le, "′", "\\prime");
A(z, D, le, "△", "\\triangle");
A(z, D, le, "Γ", "\\Gamma", !0);
A(z, D, le, "Δ", "\\Delta", !0);
A(z, D, le, "Θ", "\\Theta", !0);
A(z, D, le, "Λ", "\\Lambda", !0);
A(z, D, le, "Ξ", "\\Xi", !0);
A(z, D, le, "Π", "\\Pi", !0);
A(z, D, le, "Σ", "\\Sigma", !0);
A(z, D, le, "Υ", "\\Upsilon", !0);
A(z, D, le, "Φ", "\\Phi", !0);
A(z, D, le, "Ψ", "\\Psi", !0);
A(z, D, le, "Ω", "\\Omega", !0);
A(z, D, le, "A", "Α");
A(z, D, le, "B", "Β");
A(z, D, le, "E", "Ε");
A(z, D, le, "Z", "Ζ");
A(z, D, le, "H", "Η");
A(z, D, le, "I", "Ι");
A(z, D, le, "K", "Κ");
A(z, D, le, "M", "Μ");
A(z, D, le, "N", "Ν");
A(z, D, le, "O", "Ο");
A(z, D, le, "P", "Ρ");
A(z, D, le, "T", "Τ");
A(z, D, le, "X", "Χ");
A(z, D, le, "¬", "\\neg", !0);
A(z, D, le, "¬", "\\lnot");
A(z, D, le, "⊤", "\\top");
A(z, D, le, "⊥", "\\bot");
A(z, D, le, "∅", "\\emptyset");
A(z, Q, le, "∅", "\\varnothing");
A(z, D, gt, "α", "\\alpha", !0);
A(z, D, gt, "β", "\\beta", !0);
A(z, D, gt, "γ", "\\gamma", !0);
A(z, D, gt, "δ", "\\delta", !0);
A(z, D, gt, "ϵ", "\\epsilon", !0);
A(z, D, gt, "ζ", "\\zeta", !0);
A(z, D, gt, "η", "\\eta", !0);
A(z, D, gt, "θ", "\\theta", !0);
A(z, D, gt, "ι", "\\iota", !0);
A(z, D, gt, "κ", "\\kappa", !0);
A(z, D, gt, "λ", "\\lambda", !0);
A(z, D, gt, "μ", "\\mu", !0);
A(z, D, gt, "ν", "\\nu", !0);
A(z, D, gt, "ξ", "\\xi", !0);
A(z, D, gt, "ο", "\\omicron", !0);
A(z, D, gt, "π", "\\pi", !0);
A(z, D, gt, "ρ", "\\rho", !0);
A(z, D, gt, "σ", "\\sigma", !0);
A(z, D, gt, "τ", "\\tau", !0);
A(z, D, gt, "υ", "\\upsilon", !0);
A(z, D, gt, "ϕ", "\\phi", !0);
A(z, D, gt, "χ", "\\chi", !0);
A(z, D, gt, "ψ", "\\psi", !0);
A(z, D, gt, "ω", "\\omega", !0);
A(z, D, gt, "ε", "\\varepsilon", !0);
A(z, D, gt, "ϑ", "\\vartheta", !0);
A(z, D, gt, "ϖ", "\\varpi", !0);
A(z, D, gt, "ϱ", "\\varrho", !0);
A(z, D, gt, "ς", "\\varsigma", !0);
A(z, D, gt, "φ", "\\varphi", !0);
A(z, D, We, "∗", "*", !0);
A(z, D, We, "+", "+");
A(z, D, We, "−", "-", !0);
A(z, D, We, "⋅", "\\cdot", !0);
A(z, D, We, "∘", "\\circ", !0);
A(z, D, We, "÷", "\\div", !0);
A(z, D, We, "±", "\\pm", !0);
A(z, D, We, "×", "\\times", !0);
A(z, D, We, "∩", "\\cap", !0);
A(z, D, We, "∪", "\\cup", !0);
A(z, D, We, "∖", "\\setminus", !0);
A(z, D, We, "∧", "\\land");
A(z, D, We, "∨", "\\lor");
A(z, D, We, "∧", "\\wedge", !0);
A(z, D, We, "∨", "\\vee", !0);
A(z, D, le, "√", "\\surd");
A(z, D, ri, "⟨", "\\langle", !0);
A(z, D, ri, "∣", "\\lvert");
A(z, D, ri, "∥", "\\lVert");
A(z, D, tl, "?", "?");
A(z, D, tl, "!", "!");
A(z, D, tl, "⟩", "\\rangle", !0);
A(z, D, tl, "∣", "\\rvert");
A(z, D, tl, "∥", "\\rVert");
A(z, D, P, "=", "=");
A(z, D, P, ":", ":");
A(z, D, P, "≈", "\\approx", !0);
A(z, D, P, "≅", "\\cong", !0);
A(z, D, P, "≥", "\\ge");
A(z, D, P, "≥", "\\geq", !0);
A(z, D, P, "←", "\\gets");
A(z, D, P, ">", "\\gt", !0);
A(z, D, P, "∈", "\\in", !0);
A(z, D, P, "", "\\@not");
A(z, D, P, "⊂", "\\subset", !0);
A(z, D, P, "⊃", "\\supset", !0);
A(z, D, P, "⊆", "\\subseteq", !0);
A(z, D, P, "⊇", "\\supseteq", !0);
A(z, Q, P, "⊈", "\\nsubseteq", !0);
A(z, Q, P, "⊉", "\\nsupseteq", !0);
A(z, D, P, "⊨", "\\models");
A(z, D, P, "←", "\\leftarrow", !0);
A(z, D, P, "≤", "\\le");
A(z, D, P, "≤", "\\leq", !0);
A(z, D, P, "<", "\\lt", !0);
A(z, D, P, "→", "\\rightarrow", !0);
A(z, D, P, "→", "\\to");
A(z, Q, P, "≱", "\\ngeq", !0);
A(z, Q, P, "≰", "\\nleq", !0);
A(z, D, Cs, " ", "\\ ");
A(z, D, Cs, " ", "\\space");
A(z, D, Cs, " ", "\\nobreakspace");
A(qe, D, Cs, " ", "\\ ");
A(qe, D, Cs, " ", " ");
A(qe, D, Cs, " ", "\\space");
A(qe, D, Cs, " ", "\\nobreakspace");
A(z, D, Cs, null, "\\nobreak");
A(z, D, Cs, null, "\\allowbreak");
A(z, D, Kv, ",", ",");
A(z, D, Kv, ";", ";");
A(z, Q, We, "⊼", "\\barwedge", !0);
A(z, Q, We, "⊻", "\\veebar", !0);
A(z, D, We, "⊙", "\\odot", !0);
A(z, D, We, "⊕", "\\oplus", !0);
A(z, D, We, "⊗", "\\otimes", !0);
A(z, D, le, "∂", "\\partial", !0);
A(z, D, We, "⊘", "\\oslash", !0);
A(z, Q, We, "⊚", "\\circledcirc", !0);
A(z, Q, We, "⊡", "\\boxdot", !0);
A(z, D, We, "△", "\\bigtriangleup");
A(z, D, We, "▽", "\\bigtriangledown");
A(z, D, We, "†", "\\dagger");
A(z, D, We, "⋄", "\\diamond");
A(z, D, We, "⋆", "\\star");
A(z, D, We, "◃", "\\triangleleft");
A(z, D, We, "▹", "\\triangleright");
A(z, D, ri, "{", "\\{");
A(qe, D, le, "{", "\\{");
A(qe, D, le, "{", "\\textbraceleft");
A(z, D, tl, "}", "\\}");
A(qe, D, le, "}", "\\}");
A(qe, D, le, "}", "\\textbraceright");
A(z, D, ri, "{", "\\lbrace");
A(z, D, tl, "}", "\\rbrace");
A(z, D, ri, "[", "\\lbrack", !0);
A(qe, D, le, "[", "\\lbrack", !0);
A(z, D, tl, "]", "\\rbrack", !0);
A(qe, D, le, "]", "\\rbrack", !0);
A(z, D, ri, "(", "\\lparen", !0);
A(z, D, tl, ")", "\\rparen", !0);
A(qe, D, le, "<", "\\textless", !0);
A(qe, D, le, ">", "\\textgreater", !0);
A(z, D, ri, "⌊", "\\lfloor", !0);
A(z, D, tl, "⌋", "\\rfloor", !0);
A(z, D, ri, "⌈", "\\lceil", !0);
A(z, D, tl, "⌉", "\\rceil", !0);
A(z, D, le, "\\", "\\backslash");
A(z, D, le, "∣", "|");
A(z, D, le, "∣", "\\vert");
A(qe, D, le, "|", "\\textbar", !0);
A(z, D, le, "∥", "\\|");
A(z, D, le, "∥", "\\Vert");
A(qe, D, le, "∥", "\\textbardbl");
A(qe, D, le, "~", "\\textasciitilde");
A(qe, D, le, "\\", "\\textbackslash");
A(qe, D, le, "^", "\\textasciicircum");
A(z, D, P, "↑", "\\uparrow", !0);
A(z, D, P, "⇑", "\\Uparrow", !0);
A(z, D, P, "↓", "\\downarrow", !0);
A(z, D, P, "⇓", "\\Downarrow", !0);
A(z, D, P, "↕", "\\updownarrow", !0);
A(z, D, P, "⇕", "\\Updownarrow", !0);
A(z, D, Or, "∐", "\\coprod");
A(z, D, Or, "⋁", "\\bigvee");
A(z, D, Or, "⋀", "\\bigwedge");
A(z, D, Or, "⨄", "\\biguplus");
A(z, D, Or, "⋂", "\\bigcap");
A(z, D, Or, "⋃", "\\bigcup");
A(z, D, Or, "∫", "\\int");
A(z, D, Or, "∫", "\\intop");
A(z, D, Or, "∬", "\\iint");
A(z, D, Or, "∭", "\\iiint");
A(z, D, Or, "∏", "\\prod");
A(z, D, Or, "∑", "\\sum");
A(z, D, Or, "⨂", "\\bigotimes");
A(z, D, Or, "⨁", "\\bigoplus");
A(z, D, Or, "⨀", "\\bigodot");
A(z, D, Or, "∮", "\\oint");
A(z, D, Or, "∯", "\\oiint");
A(z, D, Or, "∰", "\\oiiint");
A(z, D, Or, "⨆", "\\bigsqcup");
A(z, D, Or, "∫", "\\smallint");
A(qe, D, Dm, "…", "\\textellipsis");
A(z, D, Dm, "…", "\\mathellipsis");
A(qe, D, Dm, "…", "\\ldots", !0);
A(z, D, Dm, "…", "\\ldots", !0);
A(z, D, Dm, "⋯", "\\@cdots", !0);
A(z, D, Dm, "⋱", "\\ddots", !0);
A(z, D, le, "⋮", "\\varvdots");
A(qe, D, le, "⋮", "\\varvdots");
A(z, D, Qn, "ˊ", "\\acute");
A(z, D, Qn, "ˋ", "\\grave");
A(z, D, Qn, "¨", "\\ddot");
A(z, D, Qn, "~", "\\tilde");
A(z, D, Qn, "ˉ", "\\bar");
A(z, D, Qn, "˘", "\\breve");
A(z, D, Qn, "ˇ", "\\check");
A(z, D, Qn, "^", "\\hat");
A(z, D, Qn, "⃗", "\\vec");
A(z, D, Qn, "˙", "\\dot");
A(z, D, Qn, "˚", "\\mathring");
A(z, D, gt, "", "\\@imath");
A(z, D, gt, "", "\\@jmath");
A(z, D, le, "ı", "ı");
A(z, D, le, "ȷ", "ȷ");
A(qe, D, le, "ı", "\\i", !0);
A(qe, D, le, "ȷ", "\\j", !0);
A(qe, D, le, "ß", "\\ss", !0);
A(qe, D, le, "æ", "\\ae", !0);
A(qe, D, le, "œ", "\\oe", !0);
A(qe, D, le, "ø", "\\o", !0);
A(qe, D, le, "Æ", "\\AE", !0);
A(qe, D, le, "Œ", "\\OE", !0);
A(qe, D, le, "Ø", "\\O", !0);
A(qe, D, Qn, "ˊ", "\\'");
A(qe, D, Qn, "ˋ", "\\`");
A(qe, D, Qn, "ˆ", "\\^");
A(qe, D, Qn, "˜", "\\~");
A(qe, D, Qn, "ˉ", "\\=");
A(qe, D, Qn, "˘", "\\u");
A(qe, D, Qn, "˙", "\\.");
A(qe, D, Qn, "¸", "\\c");
A(qe, D, Qn, "˚", "\\r");
A(qe, D, Qn, "ˇ", "\\v");
A(qe, D, Qn, "¨", '\\"');
A(qe, D, Qn, "˝", "\\H");
A(qe, D, Qn, "◯", "\\textcircled");
var bw = {
  "--": !0,
  "---": !0,
  "``": !0,
  "''": !0
};
A(qe, D, le, "–", "--", !0);
A(qe, D, le, "–", "\\textendash");
A(qe, D, le, "—", "---", !0);
A(qe, D, le, "—", "\\textemdash");
A(qe, D, le, "‘", "`", !0);
A(qe, D, le, "‘", "\\textquoteleft");
A(qe, D, le, "’", "'", !0);
A(qe, D, le, "’", "\\textquoteright");
A(qe, D, le, "“", "``", !0);
A(qe, D, le, "“", "\\textquotedblleft");
A(qe, D, le, "”", "''", !0);
A(qe, D, le, "”", "\\textquotedblright");
A(z, D, le, "°", "\\degree", !0);
A(qe, D, le, "°", "\\degree");
A(qe, D, le, "°", "\\textdegree", !0);
A(z, D, le, "£", "\\pounds");
A(z, D, le, "£", "\\mathsterling", !0);
A(qe, D, le, "£", "\\pounds");
A(qe, D, le, "£", "\\textsterling", !0);
A(z, Q, le, "✠", "\\maltese");
A(qe, Q, le, "✠", "\\maltese");
var H9 = '0123456789/@."';
for (var W6 = 0; W6 < H9.length; W6++) {
  var U9 = H9.charAt(W6);
  A(z, D, le, U9, U9);
}
var q9 = '0123456789!@*()-=+";:?/.,';
for (var e5 = 0; e5 < q9.length; e5++) {
  var j9 = q9.charAt(e5);
  A(qe, D, le, j9, j9);
}
var Lv = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
for (var t5 = 0; t5 < Lv.length; t5++) {
  var hv = Lv.charAt(t5);
  A(z, D, gt, hv, hv), A(qe, D, le, hv, hv);
}
A(z, Q, le, "C", "ℂ");
A(qe, Q, le, "C", "ℂ");
A(z, Q, le, "H", "ℍ");
A(qe, Q, le, "H", "ℍ");
A(z, Q, le, "N", "ℕ");
A(qe, Q, le, "N", "ℕ");
A(z, Q, le, "P", "ℙ");
A(qe, Q, le, "P", "ℙ");
A(z, Q, le, "Q", "ℚ");
A(qe, Q, le, "Q", "ℚ");
A(z, Q, le, "R", "ℝ");
A(qe, Q, le, "R", "ℝ");
A(z, Q, le, "Z", "ℤ");
A(qe, Q, le, "Z", "ℤ");
A(z, D, gt, "h", "ℎ");
A(qe, D, gt, "h", "ℎ");
var wt = "";
for (var Ja = 0; Ja < Lv.length; Ja++) {
  var or = Lv.charAt(Ja);
  wt = String.fromCharCode(55349, 56320 + Ja), A(z, D, gt, or, wt), A(qe, D, le, or, wt), wt = String.fromCharCode(55349, 56372 + Ja), A(z, D, gt, or, wt), A(qe, D, le, or, wt), wt = String.fromCharCode(55349, 56424 + Ja), A(z, D, gt, or, wt), A(qe, D, le, or, wt), wt = String.fromCharCode(55349, 56580 + Ja), A(z, D, gt, or, wt), A(qe, D, le, or, wt), wt = String.fromCharCode(55349, 56684 + Ja), A(z, D, gt, or, wt), A(qe, D, le, or, wt), wt = String.fromCharCode(55349, 56736 + Ja), A(z, D, gt, or, wt), A(qe, D, le, or, wt), wt = String.fromCharCode(55349, 56788 + Ja), A(z, D, gt, or, wt), A(qe, D, le, or, wt), wt = String.fromCharCode(55349, 56840 + Ja), A(z, D, gt, or, wt), A(qe, D, le, or, wt), wt = String.fromCharCode(55349, 56944 + Ja), A(z, D, gt, or, wt), A(qe, D, le, or, wt), Ja < 26 && (wt = String.fromCharCode(55349, 56632 + Ja), A(z, D, gt, or, wt), A(qe, D, le, or, wt), wt = String.fromCharCode(55349, 56476 + Ja), A(z, D, gt, or, wt), A(qe, D, le, or, wt));
}
wt = "𝕜";
A(z, D, gt, "k", wt);
A(qe, D, le, "k", wt);
for (var Zf = 0; Zf < 10; Zf++) {
  var t0 = Zf.toString();
  wt = String.fromCharCode(55349, 57294 + Zf), A(z, D, gt, t0, wt), A(qe, D, le, t0, wt), wt = String.fromCharCode(55349, 57314 + Zf), A(z, D, gt, t0, wt), A(qe, D, le, t0, wt), wt = String.fromCharCode(55349, 57324 + Zf), A(z, D, gt, t0, wt), A(qe, D, le, t0, wt), wt = String.fromCharCode(55349, 57334 + Zf), A(z, D, gt, t0, wt), A(qe, D, le, t0, wt);
}
var B5 = "ÐÞþ";
for (var n5 = 0; n5 < B5.length; n5++) {
  var dv = B5.charAt(n5);
  A(z, D, gt, dv, dv), A(qe, D, le, dv, dv);
}
var mv = [
  ["mathbf", "textbf", "Main-Bold"],
  // A-Z bold upright
  ["mathbf", "textbf", "Main-Bold"],
  // a-z bold upright
  ["mathnormal", "textit", "Math-Italic"],
  // A-Z italic
  ["mathnormal", "textit", "Math-Italic"],
  // a-z italic
  ["boldsymbol", "boldsymbol", "Main-BoldItalic"],
  // A-Z bold italic
  ["boldsymbol", "boldsymbol", "Main-BoldItalic"],
  // a-z bold italic
  // Map fancy A-Z letters to script, not calligraphic.
  // This aligns with unicode-math and math fonts (except Cambria Math).
  ["mathscr", "textscr", "Script-Regular"],
  // A-Z script
  ["", "", ""],
  // a-z script.  No font
  ["", "", ""],
  // A-Z bold script. No font
  ["", "", ""],
  // a-z bold script. No font
  ["mathfrak", "textfrak", "Fraktur-Regular"],
  // A-Z Fraktur
  ["mathfrak", "textfrak", "Fraktur-Regular"],
  // a-z Fraktur
  ["mathbb", "textbb", "AMS-Regular"],
  // A-Z double-struck
  ["mathbb", "textbb", "AMS-Regular"],
  // k double-struck
  // Note that we are using a bold font, but font metrics for regular Fraktur.
  ["mathboldfrak", "textboldfrak", "Fraktur-Regular"],
  // A-Z bold Fraktur
  ["mathboldfrak", "textboldfrak", "Fraktur-Regular"],
  // a-z bold Fraktur
  ["mathsf", "textsf", "SansSerif-Regular"],
  // A-Z sans-serif
  ["mathsf", "textsf", "SansSerif-Regular"],
  // a-z sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // A-Z bold sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // a-z bold sans-serif
  ["mathitsf", "textitsf", "SansSerif-Italic"],
  // A-Z italic sans-serif
  ["mathitsf", "textitsf", "SansSerif-Italic"],
  // a-z italic sans-serif
  ["", "", ""],
  // A-Z bold italic sans. No font
  ["", "", ""],
  // a-z bold italic sans. No font
  ["mathtt", "texttt", "Typewriter-Regular"],
  // A-Z monospace
  ["mathtt", "texttt", "Typewriter-Regular"]
  // a-z monospace
], G9 = [
  ["mathbf", "textbf", "Main-Bold"],
  // 0-9 bold
  ["", "", ""],
  // 0-9 double-struck. No KaTeX font.
  ["mathsf", "textsf", "SansSerif-Regular"],
  // 0-9 sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // 0-9 bold sans-serif
  ["mathtt", "texttt", "Typewriter-Regular"]
  // 0-9 monospace
], TL = function(t, a) {
  var i = t.charCodeAt(0), s = t.charCodeAt(1), h = (i - 55296) * 1024 + (s - 56320) + 65536, d = a === "math" ? 0 : 1;
  if (119808 <= h && h < 120484) {
    var y = Math.floor((h - 119808) / 26);
    return [mv[y][2], mv[y][d]];
  } else if (120782 <= h && h <= 120831) {
    var g = Math.floor((h - 120782) / 10);
    return [G9[g][2], G9[g][d]];
  } else {
    if (h === 120485 || h === 120486)
      return [mv[0][2], mv[0][d]];
    if (120486 < h && h < 120782)
      return ["", ""];
    throw new $e("Unsupported character: " + t);
  }
}, Jv = function(t, a, i) {
  return Bn[i][t] && Bn[i][t].replace && (t = Bn[i][t].replace), {
    value: t,
    metrics: _7(t, a, i)
  };
}, Eu = function(t, a, i, s, h) {
  var d = Jv(t, a, i), y = d.metrics;
  t = d.value;
  var g;
  if (y) {
    var b = y.italic;
    (i === "text" || s && s.font === "mathit") && (b = 0), g = new qi(t, y.height, y.depth, b, y.skew, y.width, h);
  } else
    typeof console < "u" && console.warn("No character metrics " + ("for '" + t + "' in style '" + a + "' and mode '" + i + "'")), g = new qi(t, 0, 0, 0, 0, 0, h);
  if (s) {
    g.maxFontSize = s.sizeMultiplier, s.style.isTight() && g.classes.push("mtight");
    var x = s.getColor();
    x && (g.style.color = x);
  }
  return g;
}, EL = function(t, a, i, s) {
  return s === void 0 && (s = []), i.font === "boldsymbol" && Jv(t, "Main-Bold", a).metrics ? Eu(t, "Main-Bold", a, i, s.concat(["mathbf"])) : t === "\\" || Bn[a][t].font === "main" ? Eu(t, "Main-Regular", a, i, s) : Eu(t, "AMS-Regular", a, i, s.concat(["amsrm"]));
}, AL = function(t, a, i, s, h) {
  return h !== "textord" && Jv(t, "Math-BoldItalic", a).metrics ? {
    fontName: "Math-BoldItalic",
    fontClass: "boldsymbol"
  } : {
    fontName: "Main-Bold",
    fontClass: "mathbf"
  };
}, kL = function(t, a, i) {
  var s = t.mode, h = t.text, d = ["mord"], y = s === "math" || s === "text" && a.font, g = y ? a.font : a.fontFamily, b = "", x = "";
  if (h.charCodeAt(0) === 55349 && ([b, x] = TL(h, s)), b.length > 0)
    return Eu(h, b, s, a, d.concat(x));
  if (g) {
    var T, R;
    if (g === "boldsymbol") {
      var E = AL(h, s, a, d, i);
      T = E.fontName, R = [E.fontClass];
    } else y ? (T = ww[g].fontName, R = [g]) : (T = pv(g, a.fontWeight, a.fontShape), R = [g, a.fontWeight, a.fontShape]);
    if (Jv(h, T, s).metrics)
      return Eu(h, T, s, a, d.concat(R));
    if (bw.hasOwnProperty(h) && T.slice(0, 10) === "Typewriter") {
      for (var O = [], L = 0; L < h.length; L++)
        O.push(Eu(h[L], T, s, a, d.concat(R)));
      return xw(O);
    }
  }
  if (i === "mathord")
    return Eu(h, "Math-Italic", s, a, d.concat(["mathnormal"]));
  if (i === "textord") {
    var G = Bn[s][h] && Bn[s][h].font;
    if (G === "ams") {
      var V = pv("amsrm", a.fontWeight, a.fontShape);
      return Eu(h, V, s, a, d.concat("amsrm", a.fontWeight, a.fontShape));
    } else if (G === "main" || !G) {
      var I = pv("textrm", a.fontWeight, a.fontShape);
      return Eu(h, I, s, a, d.concat(a.fontWeight, a.fontShape));
    } else {
      var $ = pv(G, a.fontWeight, a.fontShape);
      return Eu(h, $, s, a, d.concat($, a.fontWeight, a.fontShape));
    }
  } else
    throw new Error("unexpected type: " + i + " in makeOrd");
}, RL = (r, t) => {
  if (a0(r.classes) !== a0(t.classes) || r.skew !== t.skew || r.maxFontSize !== t.maxFontSize)
    return !1;
  if (r.classes.length === 1) {
    var a = r.classes[0];
    if (a === "mbin" || a === "mord")
      return !1;
  }
  for (var i in r.style)
    if (r.style.hasOwnProperty(i) && r.style[i] !== t.style[i])
      return !1;
  for (var s in t.style)
    if (t.style.hasOwnProperty(s) && r.style[s] !== t.style[s])
      return !1;
  return !0;
}, zL = (r) => {
  for (var t = 0; t < r.length - 1; t++) {
    var a = r[t], i = r[t + 1];
    a instanceof qi && i instanceof qi && RL(a, i) && (a.text += i.text, a.height = Math.max(a.height, i.height), a.depth = Math.max(a.depth, i.depth), a.italic = i.italic, r.splice(t + 1, 1), t--);
  }
  return r;
}, D7 = function(t) {
  for (var a = 0, i = 0, s = 0, h = 0; h < t.children.length; h++) {
    var d = t.children[h];
    d.height > a && (a = d.height), d.depth > i && (i = d.depth), d.maxFontSize > s && (s = d.maxFontSize);
  }
  t.height = a, t.depth = i, t.maxFontSize = s;
}, xl = function(t, a, i, s) {
  var h = new i4(t, a, i, s);
  return D7(h), h;
}, Sw = (r, t, a, i) => new i4(r, t, a, i), CL = function(t, a, i) {
  var s = xl([t], [], a);
  return s.height = Math.max(i || a.fontMetrics().defaultRuleThickness, a.minRuleThickness), s.style.borderBottomWidth = Fe(s.height), s.maxFontSize = 1, s;
}, ML = function(t, a, i, s) {
  var h = new O7(t, a, i, s);
  return D7(h), h;
}, xw = function(t) {
  var a = new l4(t);
  return D7(a), a;
}, _L = function(t, a) {
  return t instanceof l4 ? xl([], [t], a) : t;
}, OL = function(t) {
  if (t.positionType === "individualShift") {
    for (var a = t.children, i = [a[0]], s = -a[0].shift - a[0].elem.depth, h = s, d = 1; d < a.length; d++) {
      var y = -a[d].shift - h - a[d].elem.depth, g = y - (a[d - 1].elem.height + a[d - 1].elem.depth);
      h = h + y, i.push({
        type: "kern",
        size: g
      }), i.push(a[d]);
    }
    return {
      children: i,
      depth: s
    };
  }
  var b;
  if (t.positionType === "top") {
    for (var x = t.positionData, T = 0; T < t.children.length; T++) {
      var R = t.children[T];
      x -= R.type === "kern" ? R.size : R.elem.height + R.elem.depth;
    }
    b = x;
  } else if (t.positionType === "bottom")
    b = -t.positionData;
  else {
    var E = t.children[0];
    if (E.type !== "elem")
      throw new Error('First child must have type "elem".');
    if (t.positionType === "shift")
      b = -E.elem.depth - t.positionData;
    else if (t.positionType === "firstBaseline")
      b = -E.elem.depth;
    else
      throw new Error("Invalid positionType " + t.positionType + ".");
  }
  return {
    children: t.children,
    depth: b
  };
}, DL = function(t, a) {
  for (var {
    children: i,
    depth: s
  } = OL(t), h = 0, d = 0; d < i.length; d++) {
    var y = i[d];
    if (y.type === "elem") {
      var g = y.elem;
      h = Math.max(h, g.maxFontSize, g.height);
    }
  }
  h += 2;
  var b = xl(["pstrut"], []);
  b.style.height = Fe(h);
  for (var x = [], T = s, R = s, E = s, O = 0; O < i.length; O++) {
    var L = i[O];
    if (L.type === "kern")
      E += L.size;
    else {
      var G = L.elem, V = L.wrapperClasses || [], I = L.wrapperStyle || {}, $ = xl(V, [b, G], void 0, I);
      $.style.top = Fe(-h - E - G.depth), L.marginLeft && ($.style.marginLeft = L.marginLeft), L.marginRight && ($.style.marginRight = L.marginRight), x.push($), E += G.height + G.depth;
    }
    T = Math.min(T, E), R = Math.max(R, E);
  }
  var ce = xl(["vlist"], x);
  ce.style.height = Fe(R);
  var se;
  if (T < 0) {
    var te = xl([], []), Ce = xl(["vlist"], [te]);
    Ce.style.height = Fe(-T);
    var ve = xl(["vlist-s"], [new qi("​")]);
    se = [xl(["vlist-r"], [ce, ve]), xl(["vlist-r"], [Ce])];
  } else
    se = [xl(["vlist-r"], [ce])];
  var Ne = xl(["vlist-t"], se);
  return se.length === 2 && Ne.classes.push("vlist-t2"), Ne.height = R, Ne.depth = -T, Ne;
}, NL = (r, t) => {
  var a = xl(["mspace"], [], t), i = Wn(r, t);
  return a.style.marginRight = Fe(i), a;
}, pv = function(t, a, i) {
  var s = "";
  switch (t) {
    case "amsrm":
      s = "AMS";
      break;
    case "textrm":
      s = "Main";
      break;
    case "textsf":
      s = "SansSerif";
      break;
    case "texttt":
      s = "Typewriter";
      break;
    default:
      s = t;
  }
  var h;
  return a === "textbf" && i === "textit" ? h = "BoldItalic" : a === "textbf" ? h = "Bold" : a === "textit" ? h = "Italic" : h = "Regular", s + "-" + h;
}, ww = {
  // styles
  mathbf: {
    variant: "bold",
    fontName: "Main-Bold"
  },
  mathrm: {
    variant: "normal",
    fontName: "Main-Regular"
  },
  textit: {
    variant: "italic",
    fontName: "Main-Italic"
  },
  mathit: {
    variant: "italic",
    fontName: "Main-Italic"
  },
  mathnormal: {
    variant: "italic",
    fontName: "Math-Italic"
  },
  mathsfit: {
    variant: "sans-serif-italic",
    fontName: "SansSerif-Italic"
  },
  // "boldsymbol" is missing because they require the use of multiple fonts:
  // Math-BoldItalic and Main-Bold.  This is handled by a special case in
  // makeOrd which ends up calling boldsymbol.
  // families
  mathbb: {
    variant: "double-struck",
    fontName: "AMS-Regular"
  },
  mathcal: {
    variant: "script",
    fontName: "Caligraphic-Regular"
  },
  mathfrak: {
    variant: "fraktur",
    fontName: "Fraktur-Regular"
  },
  mathscr: {
    variant: "script",
    fontName: "Script-Regular"
  },
  mathsf: {
    variant: "sans-serif",
    fontName: "SansSerif-Regular"
  },
  mathtt: {
    variant: "monospace",
    fontName: "Typewriter-Regular"
  }
}, Tw = {
  //   path, width, height
  vec: ["vec", 0.471, 0.714],
  // values from the font glyph
  oiintSize1: ["oiintSize1", 0.957, 0.499],
  // oval to overlay the integrand
  oiintSize2: ["oiintSize2", 1.472, 0.659],
  oiiintSize1: ["oiiintSize1", 1.304, 0.499],
  oiiintSize2: ["oiiintSize2", 1.98, 0.659]
}, LL = function(t, a) {
  var [i, s, h] = Tw[t], d = new l0(i), y = new As([d], {
    width: Fe(s),
    height: Fe(h),
    // Override CSS rule `.katex svg { width: 100% }`
    style: "width:" + Fe(s),
    viewBox: "0 0 " + 1e3 * s + " " + 1e3 * h,
    preserveAspectRatio: "xMinYMin"
  }), g = Sw(["overlay"], [y], a);
  return g.height = h, g.style.height = Fe(h), g.style.width = Fe(s), g;
}, ge = {
  fontMap: ww,
  makeSymbol: Eu,
  mathsym: EL,
  makeSpan: xl,
  makeSvgSpan: Sw,
  makeLineSpan: CL,
  makeAnchor: ML,
  makeFragment: xw,
  wrapFragment: _L,
  makeVList: DL,
  makeOrd: kL,
  makeGlue: NL,
  staticSvg: LL,
  svgData: Tw,
  tryCombineChars: zL
}, Jn = {
  number: 3,
  unit: "mu"
}, Ff = {
  number: 4,
  unit: "mu"
}, Ss = {
  number: 5,
  unit: "mu"
}, BL = {
  mord: {
    mop: Jn,
    mbin: Ff,
    mrel: Ss,
    minner: Jn
  },
  mop: {
    mord: Jn,
    mop: Jn,
    mrel: Ss,
    minner: Jn
  },
  mbin: {
    mord: Ff,
    mop: Ff,
    mopen: Ff,
    minner: Ff
  },
  mrel: {
    mord: Ss,
    mop: Ss,
    mopen: Ss,
    minner: Ss
  },
  mopen: {},
  mclose: {
    mop: Jn,
    mbin: Ff,
    mrel: Ss,
    minner: Jn
  },
  mpunct: {
    mord: Jn,
    mop: Jn,
    mrel: Ss,
    mopen: Jn,
    mclose: Jn,
    mpunct: Jn,
    minner: Jn
  },
  minner: {
    mord: Jn,
    mop: Jn,
    mbin: Ff,
    mrel: Ss,
    mopen: Jn,
    mpunct: Jn,
    minner: Jn
  }
}, HL = {
  mord: {
    mop: Jn
  },
  mop: {
    mord: Jn,
    mop: Jn
  },
  mbin: {},
  mrel: {},
  mopen: {},
  mclose: {
    mop: Jn
  },
  mpunct: {},
  minner: {
    mop: Jn
  }
}, Ew = {}, Bv = {}, Hv = {};
function Ke(r) {
  for (var {
    type: t,
    names: a,
    props: i,
    handler: s,
    htmlBuilder: h,
    mathmlBuilder: d
  } = r, y = {
    type: t,
    numArgs: i.numArgs,
    argTypes: i.argTypes,
    allowedInArgument: !!i.allowedInArgument,
    allowedInText: !!i.allowedInText,
    allowedInMath: i.allowedInMath === void 0 ? !0 : i.allowedInMath,
    numOptionalArgs: i.numOptionalArgs || 0,
    infix: !!i.infix,
    primitive: !!i.primitive,
    handler: s
  }, g = 0; g < a.length; ++g)
    Ew[a[g]] = y;
  t && (h && (Bv[t] = h), d && (Hv[t] = d));
}
function rh(r) {
  var {
    type: t,
    htmlBuilder: a,
    mathmlBuilder: i
  } = r;
  Ke({
    type: t,
    names: [],
    props: {
      numArgs: 0
    },
    handler() {
      throw new Error("Should never be called.");
    },
    htmlBuilder: a,
    mathmlBuilder: i
  });
}
var Uv = function(t) {
  return t.type === "ordgroup" && t.body.length === 1 ? t.body[0] : t;
}, Sr = function(t) {
  return t.type === "ordgroup" ? t.body : [t];
}, ks = ge.makeSpan, UL = ["leftmost", "mbin", "mopen", "mrel", "mop", "mpunct"], qL = ["rightmost", "mrel", "mclose", "mpunct"], jL = {
  display: yt.DISPLAY,
  text: yt.TEXT,
  script: yt.SCRIPT,
  scriptscript: yt.SCRIPTSCRIPT
}, GL = {
  mord: "mord",
  mop: "mop",
  mbin: "mbin",
  mrel: "mrel",
  mopen: "mopen",
  mclose: "mclose",
  mpunct: "mpunct",
  minner: "minner"
}, Qr = function(t, a, i, s) {
  s === void 0 && (s = [null, null]);
  for (var h = [], d = 0; d < t.length; d++) {
    var y = on(t[d], a);
    if (y instanceof l4) {
      var g = y.children;
      h.push(...g);
    } else
      h.push(y);
  }
  if (ge.tryCombineChars(h), !i)
    return h;
  var b = a;
  if (t.length === 1) {
    var x = t[0];
    x.type === "sizing" ? b = a.havingSize(x.size) : x.type === "styling" && (b = a.havingStyle(jL[x.style]));
  }
  var T = ks([s[0] || "leftmost"], [], a), R = ks([s[1] || "rightmost"], [], a), E = i === "root";
  return V9(h, (O, L) => {
    var G = L.classes[0], V = O.classes[0];
    G === "mbin" && dt.contains(qL, V) ? L.classes[0] = "mord" : V === "mbin" && dt.contains(UL, G) && (O.classes[0] = "mord");
  }, {
    node: T
  }, R, E), V9(h, (O, L) => {
    var G = H5(L), V = H5(O), I = G && V ? O.hasClass("mtight") ? HL[G][V] : BL[G][V] : null;
    if (I)
      return ge.makeGlue(I, b);
  }, {
    node: T
  }, R, E), h;
}, V9 = function r(t, a, i, s, h) {
  s && t.push(s);
  for (var d = 0; d < t.length; d++) {
    var y = t[d], g = Aw(y);
    if (g) {
      r(g.children, a, i, null, h);
      continue;
    }
    var b = !y.hasClass("mspace");
    if (b) {
      var x = a(y, i.node);
      x && (i.insertAfter ? i.insertAfter(x) : (t.unshift(x), d++));
    }
    b ? i.node = y : h && y.hasClass("newline") && (i.node = ks(["leftmost"])), i.insertAfter = /* @__PURE__ */ ((T) => (R) => {
      t.splice(T + 1, 0, R), d++;
    })(d);
  }
  s && t.pop();
}, Aw = function(t) {
  return t instanceof l4 || t instanceof O7 || t instanceof i4 && t.hasClass("enclosing") ? t : null;
}, VL = function r(t, a) {
  var i = Aw(t);
  if (i) {
    var s = i.children;
    if (s.length) {
      if (a === "right")
        return r(s[s.length - 1], "right");
      if (a === "left")
        return r(s[0], "left");
    }
  }
  return t;
}, H5 = function(t, a) {
  return t ? (a && (t = VL(t, a)), GL[t.classes[0]] || null) : null;
}, Kg = function(t, a) {
  var i = ["nulldelimiter"].concat(t.baseSizingClasses());
  return ks(a.concat(i));
}, on = function(t, a, i) {
  if (!t)
    return ks();
  if (Bv[t.type]) {
    var s = Bv[t.type](t, a);
    if (i && a.size !== i.size) {
      s = ks(a.sizingClasses(i), [s], a);
      var h = a.sizeMultiplier / i.sizeMultiplier;
      s.height *= h, s.depth *= h;
    }
    return s;
  } else
    throw new $e("Got group of unknown type: '" + t.type + "'");
};
function gv(r, t) {
  var a = ks(["base"], r, t), i = ks(["strut"]);
  return i.style.height = Fe(a.height + a.depth), a.depth && (i.style.verticalAlign = Fe(-a.depth)), a.children.unshift(i), a;
}
function U5(r, t) {
  var a = null;
  r.length === 1 && r[0].type === "tag" && (a = r[0].tag, r = r[0].body);
  var i = Qr(r, t, "root"), s;
  i.length === 2 && i[1].hasClass("tag") && (s = i.pop());
  for (var h = [], d = [], y = 0; y < i.length; y++)
    if (d.push(i[y]), i[y].hasClass("mbin") || i[y].hasClass("mrel") || i[y].hasClass("allowbreak")) {
      for (var g = !1; y < i.length - 1 && i[y + 1].hasClass("mspace") && !i[y + 1].hasClass("newline"); )
        y++, d.push(i[y]), i[y].hasClass("nobreak") && (g = !0);
      g || (h.push(gv(d, t)), d = []);
    } else i[y].hasClass("newline") && (d.pop(), d.length > 0 && (h.push(gv(d, t)), d = []), h.push(i[y]));
  d.length > 0 && h.push(gv(d, t));
  var b;
  a ? (b = gv(Qr(a, t, !0)), b.classes = ["tag"], h.push(b)) : s && h.push(s);
  var x = ks(["katex-html"], h);
  if (x.setAttribute("aria-hidden", "true"), b) {
    var T = b.children[0];
    T.style.height = Fe(x.height + x.depth), x.depth && (T.style.verticalAlign = Fe(-x.depth));
  }
  return x;
}
function kw(r) {
  return new l4(r);
}
class ti {
  constructor(t, a, i) {
    this.type = void 0, this.attributes = void 0, this.children = void 0, this.classes = void 0, this.type = t, this.attributes = {}, this.children = a || [], this.classes = i || [];
  }
  /**
   * Sets an attribute on a MathML node. MathML depends on attributes to convey a
   * semantic content, so this is used heavily.
   */
  setAttribute(t, a) {
    this.attributes[t] = a;
  }
  /**
   * Gets an attribute on a MathML node.
   */
  getAttribute(t) {
    return this.attributes[t];
  }
  /**
   * Converts the math node into a MathML-namespaced DOM element.
   */
  toNode() {
    var t = document.createElementNS("http://www.w3.org/1998/Math/MathML", this.type);
    for (var a in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, a) && t.setAttribute(a, this.attributes[a]);
    this.classes.length > 0 && (t.className = a0(this.classes));
    for (var i = 0; i < this.children.length; i++)
      if (this.children[i] instanceof bo && this.children[i + 1] instanceof bo) {
        for (var s = this.children[i].toText() + this.children[++i].toText(); this.children[i + 1] instanceof bo; )
          s += this.children[++i].toText();
        t.appendChild(new bo(s).toNode());
      } else
        t.appendChild(this.children[i].toNode());
    return t;
  }
  /**
   * Converts the math node into an HTML markup string.
   */
  toMarkup() {
    var t = "<" + this.type;
    for (var a in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, a) && (t += " " + a + '="', t += dt.escape(this.attributes[a]), t += '"');
    this.classes.length > 0 && (t += ' class ="' + dt.escape(a0(this.classes)) + '"'), t += ">";
    for (var i = 0; i < this.children.length; i++)
      t += this.children[i].toMarkup();
    return t += "</" + this.type + ">", t;
  }
  /**
   * Converts the math node into a string, similar to innerText, but escaped.
   */
  toText() {
    return this.children.map((t) => t.toText()).join("");
  }
}
class bo {
  constructor(t) {
    this.text = void 0, this.text = t;
  }
  /**
   * Converts the text node into a DOM text node.
   */
  toNode() {
    return document.createTextNode(this.text);
  }
  /**
   * Converts the text node into escaped HTML markup
   * (representing the text itself).
   */
  toMarkup() {
    return dt.escape(this.toText());
  }
  /**
   * Converts the text node into a string
   * (representing the text itself).
   */
  toText() {
    return this.text;
  }
}
class YL {
  /**
   * Create a Space node with width given in CSS ems.
   */
  constructor(t) {
    this.width = void 0, this.character = void 0, this.width = t, t >= 0.05555 && t <= 0.05556 ? this.character = " " : t >= 0.1666 && t <= 0.1667 ? this.character = " " : t >= 0.2222 && t <= 0.2223 ? this.character = " " : t >= 0.2777 && t <= 0.2778 ? this.character = "  " : t >= -0.05556 && t <= -0.05555 ? this.character = " ⁣" : t >= -0.1667 && t <= -0.1666 ? this.character = " ⁣" : t >= -0.2223 && t <= -0.2222 ? this.character = " ⁣" : t >= -0.2778 && t <= -0.2777 ? this.character = " ⁣" : this.character = null;
  }
  /**
   * Converts the math node into a MathML-namespaced DOM element.
   */
  toNode() {
    if (this.character)
      return document.createTextNode(this.character);
    var t = document.createElementNS("http://www.w3.org/1998/Math/MathML", "mspace");
    return t.setAttribute("width", Fe(this.width)), t;
  }
  /**
   * Converts the math node into an HTML markup string.
   */
  toMarkup() {
    return this.character ? "<mtext>" + this.character + "</mtext>" : '<mspace width="' + Fe(this.width) + '"/>';
  }
  /**
   * Converts the math node into a string, similar to innerText.
   */
  toText() {
    return this.character ? this.character : " ";
  }
}
var Ve = {
  MathNode: ti,
  TextNode: bo,
  SpaceNode: YL,
  newDocumentFragment: kw
}, ji = function(t, a, i) {
  return Bn[a][t] && Bn[a][t].replace && t.charCodeAt(0) !== 55349 && !(bw.hasOwnProperty(t) && i && (i.fontFamily && i.fontFamily.slice(4, 6) === "tt" || i.font && i.font.slice(4, 6) === "tt")) && (t = Bn[a][t].replace), new Ve.TextNode(t);
}, N7 = function(t) {
  return t.length === 1 ? t[0] : new Ve.MathNode("mrow", t);
}, L7 = function(t, a) {
  if (a.fontFamily === "texttt")
    return "monospace";
  if (a.fontFamily === "textsf")
    return a.fontShape === "textit" && a.fontWeight === "textbf" ? "sans-serif-bold-italic" : a.fontShape === "textit" ? "sans-serif-italic" : a.fontWeight === "textbf" ? "bold-sans-serif" : "sans-serif";
  if (a.fontShape === "textit" && a.fontWeight === "textbf")
    return "bold-italic";
  if (a.fontShape === "textit")
    return "italic";
  if (a.fontWeight === "textbf")
    return "bold";
  var i = a.font;
  if (!i || i === "mathnormal")
    return null;
  var s = t.mode;
  if (i === "mathit")
    return "italic";
  if (i === "boldsymbol")
    return t.type === "textord" ? "bold" : "bold-italic";
  if (i === "mathbf")
    return "bold";
  if (i === "mathbb")
    return "double-struck";
  if (i === "mathsfit")
    return "sans-serif-italic";
  if (i === "mathfrak")
    return "fraktur";
  if (i === "mathscr" || i === "mathcal")
    return "script";
  if (i === "mathsf")
    return "sans-serif";
  if (i === "mathtt")
    return "monospace";
  var h = t.text;
  if (dt.contains(["\\imath", "\\jmath"], h))
    return null;
  Bn[s][h] && Bn[s][h].replace && (h = Bn[s][h].replace);
  var d = ge.fontMap[i].fontName;
  return _7(h, d, s) ? ge.fontMap[i].variant : null;
};
function r5(r) {
  if (!r)
    return !1;
  if (r.type === "mi" && r.children.length === 1) {
    var t = r.children[0];
    return t instanceof bo && t.text === ".";
  } else if (r.type === "mo" && r.children.length === 1 && r.getAttribute("separator") === "true" && r.getAttribute("lspace") === "0em" && r.getAttribute("rspace") === "0em") {
    var a = r.children[0];
    return a instanceof bo && a.text === ",";
  } else
    return !1;
}
var Tl = function(t, a, i) {
  if (t.length === 1) {
    var s = _n(t[0], a);
    return i && s instanceof ti && s.type === "mo" && (s.setAttribute("lspace", "0em"), s.setAttribute("rspace", "0em")), [s];
  }
  for (var h = [], d, y = 0; y < t.length; y++) {
    var g = _n(t[y], a);
    if (g instanceof ti && d instanceof ti) {
      if (g.type === "mtext" && d.type === "mtext" && g.getAttribute("mathvariant") === d.getAttribute("mathvariant")) {
        d.children.push(...g.children);
        continue;
      } else if (g.type === "mn" && d.type === "mn") {
        d.children.push(...g.children);
        continue;
      } else if (r5(g) && d.type === "mn") {
        d.children.push(...g.children);
        continue;
      } else if (g.type === "mn" && r5(d))
        g.children = [...d.children, ...g.children], h.pop();
      else if ((g.type === "msup" || g.type === "msub") && g.children.length >= 1 && (d.type === "mn" || r5(d))) {
        var b = g.children[0];
        b instanceof ti && b.type === "mn" && (b.children = [...d.children, ...b.children], h.pop());
      } else if (d.type === "mi" && d.children.length === 1) {
        var x = d.children[0];
        if (x instanceof bo && x.text === "̸" && (g.type === "mo" || g.type === "mi" || g.type === "mn")) {
          var T = g.children[0];
          T instanceof bo && T.text.length > 0 && (T.text = T.text.slice(0, 1) + "̸" + T.text.slice(1), h.pop());
        }
      }
    }
    h.push(g), d = g;
  }
  return h;
}, i0 = function(t, a, i) {
  return N7(Tl(t, a, i));
}, _n = function(t, a) {
  if (!t)
    return new Ve.MathNode("mrow");
  if (Hv[t.type]) {
    var i = Hv[t.type](t, a);
    return i;
  } else
    throw new $e("Got group of unknown type: '" + t.type + "'");
};
function Y9(r, t, a, i, s) {
  var h = Tl(r, a), d;
  h.length === 1 && h[0] instanceof ti && dt.contains(["mrow", "mtable"], h[0].type) ? d = h[0] : d = new Ve.MathNode("mrow", h);
  var y = new Ve.MathNode("annotation", [new Ve.TextNode(t)]);
  y.setAttribute("encoding", "application/x-tex");
  var g = new Ve.MathNode("semantics", [d, y]), b = new Ve.MathNode("math", [g]);
  b.setAttribute("xmlns", "http://www.w3.org/1998/Math/MathML"), i && b.setAttribute("display", "block");
  var x = s ? "katex" : "katex-mathml";
  return ge.makeSpan([x], [b]);
}
var Rw = function(t) {
  return new ws({
    style: t.displayMode ? yt.DISPLAY : yt.TEXT,
    maxSize: t.maxSize,
    minRuleThickness: t.minRuleThickness
  });
}, zw = function(t, a) {
  if (a.displayMode) {
    var i = ["katex-display"];
    a.leqno && i.push("leqno"), a.fleqn && i.push("fleqn"), t = ge.makeSpan(i, [t]);
  }
  return t;
}, IL = function(t, a, i) {
  var s = Rw(i), h;
  if (i.output === "mathml")
    return Y9(t, a, s, i.displayMode, !0);
  if (i.output === "html") {
    var d = U5(t, s);
    h = ge.makeSpan(["katex"], [d]);
  } else {
    var y = Y9(t, a, s, i.displayMode, !1), g = U5(t, s);
    h = ge.makeSpan(["katex"], [y, g]);
  }
  return zw(h, i);
}, $L = function(t, a, i) {
  var s = Rw(i), h = U5(t, s), d = ge.makeSpan(["katex"], [h]);
  return zw(d, i);
}, XL = {
  widehat: "^",
  widecheck: "ˇ",
  widetilde: "~",
  utilde: "~",
  overleftarrow: "←",
  underleftarrow: "←",
  xleftarrow: "←",
  overrightarrow: "→",
  underrightarrow: "→",
  xrightarrow: "→",
  underbrace: "⏟",
  overbrace: "⏞",
  overgroup: "⏠",
  undergroup: "⏡",
  overleftrightarrow: "↔",
  underleftrightarrow: "↔",
  xleftrightarrow: "↔",
  Overrightarrow: "⇒",
  xRightarrow: "⇒",
  overleftharpoon: "↼",
  xleftharpoonup: "↼",
  overrightharpoon: "⇀",
  xrightharpoonup: "⇀",
  xLeftarrow: "⇐",
  xLeftrightarrow: "⇔",
  xhookleftarrow: "↩",
  xhookrightarrow: "↪",
  xmapsto: "↦",
  xrightharpoondown: "⇁",
  xleftharpoondown: "↽",
  xrightleftharpoons: "⇌",
  xleftrightharpoons: "⇋",
  xtwoheadleftarrow: "↞",
  xtwoheadrightarrow: "↠",
  xlongequal: "=",
  xtofrom: "⇄",
  xrightleftarrows: "⇄",
  xrightequilibrium: "⇌",
  // Not a perfect match.
  xleftequilibrium: "⇋",
  // None better available.
  "\\cdrightarrow": "→",
  "\\cdleftarrow": "←",
  "\\cdlongequal": "="
}, QL = function(t) {
  var a = new Ve.MathNode("mo", [new Ve.TextNode(XL[t.replace(/^\\/, "")])]);
  return a.setAttribute("stretchy", "true"), a;
}, ZL = {
  //   path(s), minWidth, height, align
  overrightarrow: [["rightarrow"], 0.888, 522, "xMaxYMin"],
  overleftarrow: [["leftarrow"], 0.888, 522, "xMinYMin"],
  underrightarrow: [["rightarrow"], 0.888, 522, "xMaxYMin"],
  underleftarrow: [["leftarrow"], 0.888, 522, "xMinYMin"],
  xrightarrow: [["rightarrow"], 1.469, 522, "xMaxYMin"],
  "\\cdrightarrow": [["rightarrow"], 3, 522, "xMaxYMin"],
  // CD minwwidth2.5pc
  xleftarrow: [["leftarrow"], 1.469, 522, "xMinYMin"],
  "\\cdleftarrow": [["leftarrow"], 3, 522, "xMinYMin"],
  Overrightarrow: [["doublerightarrow"], 0.888, 560, "xMaxYMin"],
  xRightarrow: [["doublerightarrow"], 1.526, 560, "xMaxYMin"],
  xLeftarrow: [["doubleleftarrow"], 1.526, 560, "xMinYMin"],
  overleftharpoon: [["leftharpoon"], 0.888, 522, "xMinYMin"],
  xleftharpoonup: [["leftharpoon"], 0.888, 522, "xMinYMin"],
  xleftharpoondown: [["leftharpoondown"], 0.888, 522, "xMinYMin"],
  overrightharpoon: [["rightharpoon"], 0.888, 522, "xMaxYMin"],
  xrightharpoonup: [["rightharpoon"], 0.888, 522, "xMaxYMin"],
  xrightharpoondown: [["rightharpoondown"], 0.888, 522, "xMaxYMin"],
  xlongequal: [["longequal"], 0.888, 334, "xMinYMin"],
  "\\cdlongequal": [["longequal"], 3, 334, "xMinYMin"],
  xtwoheadleftarrow: [["twoheadleftarrow"], 0.888, 334, "xMinYMin"],
  xtwoheadrightarrow: [["twoheadrightarrow"], 0.888, 334, "xMaxYMin"],
  overleftrightarrow: [["leftarrow", "rightarrow"], 0.888, 522],
  overbrace: [["leftbrace", "midbrace", "rightbrace"], 1.6, 548],
  underbrace: [["leftbraceunder", "midbraceunder", "rightbraceunder"], 1.6, 548],
  underleftrightarrow: [["leftarrow", "rightarrow"], 0.888, 522],
  xleftrightarrow: [["leftarrow", "rightarrow"], 1.75, 522],
  xLeftrightarrow: [["doubleleftarrow", "doublerightarrow"], 1.75, 560],
  xrightleftharpoons: [["leftharpoondownplus", "rightharpoonplus"], 1.75, 716],
  xleftrightharpoons: [["leftharpoonplus", "rightharpoondownplus"], 1.75, 716],
  xhookleftarrow: [["leftarrow", "righthook"], 1.08, 522],
  xhookrightarrow: [["lefthook", "rightarrow"], 1.08, 522],
  overlinesegment: [["leftlinesegment", "rightlinesegment"], 0.888, 522],
  underlinesegment: [["leftlinesegment", "rightlinesegment"], 0.888, 522],
  overgroup: [["leftgroup", "rightgroup"], 0.888, 342],
  undergroup: [["leftgroupunder", "rightgroupunder"], 0.888, 342],
  xmapsto: [["leftmapsto", "rightarrow"], 1.5, 522],
  xtofrom: [["leftToFrom", "rightToFrom"], 1.75, 528],
  // The next three arrows are from the mhchem package.
  // In mhchem.sty, min-length is 2.0em. But these arrows might appear in the
  // document as \xrightarrow or \xrightleftharpoons. Those have
  // min-length = 1.75em, so we set min-length on these next three to match.
  xrightleftarrows: [["baraboveleftarrow", "rightarrowabovebar"], 1.75, 901],
  xrightequilibrium: [["baraboveshortleftharpoon", "rightharpoonaboveshortbar"], 1.75, 716],
  xleftequilibrium: [["shortbaraboveleftharpoon", "shortrightharpoonabovebar"], 1.75, 716]
}, FL = function(t) {
  return t.type === "ordgroup" ? t.body.length : 1;
}, PL = function(t, a) {
  function i() {
    var y = 4e5, g = t.label.slice(1);
    if (dt.contains(["widehat", "widecheck", "widetilde", "utilde"], g)) {
      var b = t, x = FL(b.base), T, R, E;
      if (x > 5)
        g === "widehat" || g === "widecheck" ? (T = 420, y = 2364, E = 0.42, R = g + "4") : (T = 312, y = 2340, E = 0.34, R = "tilde4");
      else {
        var O = [1, 1, 2, 2, 3, 3][x];
        g === "widehat" || g === "widecheck" ? (y = [0, 1062, 2364, 2364, 2364][O], T = [0, 239, 300, 360, 420][O], E = [0, 0.24, 0.3, 0.3, 0.36, 0.42][O], R = g + O) : (y = [0, 600, 1033, 2339, 2340][O], T = [0, 260, 286, 306, 312][O], E = [0, 0.26, 0.286, 0.3, 0.306, 0.34][O], R = "tilde" + O);
      }
      var L = new l0(R), G = new As([L], {
        width: "100%",
        height: Fe(E),
        viewBox: "0 0 " + y + " " + T,
        preserveAspectRatio: "none"
      });
      return {
        span: ge.makeSvgSpan([], [G], a),
        minWidth: 0,
        height: E
      };
    } else {
      var V = [], I = ZL[g], [$, ce, se] = I, te = se / 1e3, Ce = $.length, ve, Ne;
      if (Ce === 1) {
        var ee = I[3];
        ve = ["hide-tail"], Ne = [ee];
      } else if (Ce === 2)
        ve = ["halfarrow-left", "halfarrow-right"], Ne = ["xMinYMin", "xMaxYMin"];
      else if (Ce === 3)
        ve = ["brace-left", "brace-center", "brace-right"], Ne = ["xMinYMin", "xMidYMin", "xMaxYMin"];
      else
        throw new Error(`Correct katexImagesData or update code here to support
                    ` + Ce + " children.");
      for (var De = 0; De < Ce; De++) {
        var de = new l0($[De]), Ye = new As([de], {
          width: "400em",
          height: Fe(te),
          viewBox: "0 0 " + y + " " + se,
          preserveAspectRatio: Ne[De] + " slice"
        }), Te = ge.makeSvgSpan([ve[De]], [Ye], a);
        if (Ce === 1)
          return {
            span: Te,
            minWidth: ce,
            height: te
          };
        Te.style.height = Fe(te), V.push(Te);
      }
      return {
        span: ge.makeSpan(["stretchy"], V, a),
        minWidth: ce,
        height: te
      };
    }
  }
  var {
    span: s,
    minWidth: h,
    height: d
  } = i();
  return s.height = d, s.style.height = Fe(d), h > 0 && (s.style.minWidth = Fe(h)), s;
}, KL = function(t, a, i, s, h) {
  var d, y = t.height + t.depth + i + s;
  if (/fbox|color|angl/.test(a)) {
    if (d = ge.makeSpan(["stretchy", a], [], h), a === "fbox") {
      var g = h.color && h.getColor();
      g && (d.style.borderColor = g);
    }
  } else {
    var b = [];
    /^[bx]cancel$/.test(a) && b.push(new L5({
      x1: "0",
      y1: "0",
      x2: "100%",
      y2: "100%",
      "stroke-width": "0.046em"
    })), /^x?cancel$/.test(a) && b.push(new L5({
      x1: "0",
      y1: "100%",
      x2: "100%",
      y2: "0",
      "stroke-width": "0.046em"
    }));
    var x = new As(b, {
      width: "100%",
      height: Fe(y)
    });
    d = ge.makeSvgSpan([], [x], h);
  }
  return d.height = y, d.style.height = Fe(y), d;
}, Rs = {
  encloseSpan: KL,
  mathMLnode: QL,
  svgSpan: PL
};
function Gt(r, t) {
  if (!r || r.type !== t)
    throw new Error("Expected node of type " + t + ", but got " + (r ? "node of type " + r.type : String(r)));
  return r;
}
function B7(r) {
  var t = Wv(r);
  if (!t)
    throw new Error("Expected node of symbol group type, but got " + (r ? "node of type " + r.type : String(r)));
  return t;
}
function Wv(r) {
  return r && (r.type === "atom" || wL.hasOwnProperty(r.type)) ? r : null;
}
var H7 = (r, t) => {
  var a, i, s;
  r && r.type === "supsub" ? (i = Gt(r.base, "accent"), a = i.base, r.base = a, s = SL(on(r, t)), r.base = i) : (i = Gt(r, "accent"), a = i.base);
  var h = on(a, t.havingCrampedStyle()), d = i.isShifty && dt.isCharacterBox(a), y = 0;
  if (d) {
    var g = dt.getBaseElem(a), b = on(g, t.havingCrampedStyle());
    y = B9(b).skew;
  }
  var x = i.label === "\\c", T = x ? h.height + h.depth : Math.min(h.height, t.fontMetrics().xHeight), R;
  if (i.isStretchy)
    R = Rs.svgSpan(i, t), R = ge.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: h
      }, {
        type: "elem",
        elem: R,
        wrapperClasses: ["svg-align"],
        wrapperStyle: y > 0 ? {
          width: "calc(100% - " + Fe(2 * y) + ")",
          marginLeft: Fe(2 * y)
        } : void 0
      }]
    }, t);
  else {
    var E, O;
    i.label === "\\vec" ? (E = ge.staticSvg("vec", t), O = ge.svgData.vec[1]) : (E = ge.makeOrd({
      mode: i.mode,
      text: i.label
    }, t, "textord"), E = B9(E), E.italic = 0, O = E.width, x && (T += E.depth)), R = ge.makeSpan(["accent-body"], [E]);
    var L = i.label === "\\textcircled";
    L && (R.classes.push("accent-full"), T = h.height);
    var G = y;
    L || (G -= O / 2), R.style.left = Fe(G), i.label === "\\textcircled" && (R.style.top = ".2em"), R = ge.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: h
      }, {
        type: "kern",
        size: -T
      }, {
        type: "elem",
        elem: R
      }]
    }, t);
  }
  var V = ge.makeSpan(["mord", "accent"], [R], t);
  return s ? (s.children[0] = V, s.height = Math.max(V.height, s.height), s.classes[0] = "mord", s) : V;
}, Cw = (r, t) => {
  var a = r.isStretchy ? Rs.mathMLnode(r.label) : new Ve.MathNode("mo", [ji(r.label, r.mode)]), i = new Ve.MathNode("mover", [_n(r.base, t), a]);
  return i.setAttribute("accent", "true"), i;
}, JL = new RegExp(["\\acute", "\\grave", "\\ddot", "\\tilde", "\\bar", "\\breve", "\\check", "\\hat", "\\vec", "\\dot", "\\mathring"].map((r) => "\\" + r).join("|"));
Ke({
  type: "accent",
  names: ["\\acute", "\\grave", "\\ddot", "\\tilde", "\\bar", "\\breve", "\\check", "\\hat", "\\vec", "\\dot", "\\mathring", "\\widecheck", "\\widehat", "\\widetilde", "\\overrightarrow", "\\overleftarrow", "\\Overrightarrow", "\\overleftrightarrow", "\\overgroup", "\\overlinesegment", "\\overleftharpoon", "\\overrightharpoon"],
  props: {
    numArgs: 1
  },
  handler: (r, t) => {
    var a = Uv(t[0]), i = !JL.test(r.funcName), s = !i || r.funcName === "\\widehat" || r.funcName === "\\widetilde" || r.funcName === "\\widecheck";
    return {
      type: "accent",
      mode: r.parser.mode,
      label: r.funcName,
      isStretchy: i,
      isShifty: s,
      base: a
    };
  },
  htmlBuilder: H7,
  mathmlBuilder: Cw
});
Ke({
  type: "accent",
  names: ["\\'", "\\`", "\\^", "\\~", "\\=", "\\u", "\\.", '\\"', "\\c", "\\r", "\\H", "\\v", "\\textcircled"],
  props: {
    numArgs: 1,
    allowedInText: !0,
    allowedInMath: !0,
    // unless in strict mode
    argTypes: ["primitive"]
  },
  handler: (r, t) => {
    var a = t[0], i = r.parser.mode;
    return i === "math" && (r.parser.settings.reportNonstrict("mathVsTextAccents", "LaTeX's accent " + r.funcName + " works only in text mode"), i = "text"), {
      type: "accent",
      mode: i,
      label: r.funcName,
      isStretchy: !1,
      isShifty: !0,
      base: a
    };
  },
  htmlBuilder: H7,
  mathmlBuilder: Cw
});
Ke({
  type: "accentUnder",
  names: ["\\underleftarrow", "\\underrightarrow", "\\underleftrightarrow", "\\undergroup", "\\underlinesegment", "\\utilde"],
  props: {
    numArgs: 1
  },
  handler: (r, t) => {
    var {
      parser: a,
      funcName: i
    } = r, s = t[0];
    return {
      type: "accentUnder",
      mode: a.mode,
      label: i,
      base: s
    };
  },
  htmlBuilder: (r, t) => {
    var a = on(r.base, t), i = Rs.svgSpan(r, t), s = r.label === "\\utilde" ? 0.12 : 0, h = ge.makeVList({
      positionType: "top",
      positionData: a.height,
      children: [{
        type: "elem",
        elem: i,
        wrapperClasses: ["svg-align"]
      }, {
        type: "kern",
        size: s
      }, {
        type: "elem",
        elem: a
      }]
    }, t);
    return ge.makeSpan(["mord", "accentunder"], [h], t);
  },
  mathmlBuilder: (r, t) => {
    var a = Rs.mathMLnode(r.label), i = new Ve.MathNode("munder", [_n(r.base, t), a]);
    return i.setAttribute("accentunder", "true"), i;
  }
});
var yv = (r) => {
  var t = new Ve.MathNode("mpadded", r ? [r] : []);
  return t.setAttribute("width", "+0.6em"), t.setAttribute("lspace", "0.3em"), t;
};
Ke({
  type: "xArrow",
  names: [
    "\\xleftarrow",
    "\\xrightarrow",
    "\\xLeftarrow",
    "\\xRightarrow",
    "\\xleftrightarrow",
    "\\xLeftrightarrow",
    "\\xhookleftarrow",
    "\\xhookrightarrow",
    "\\xmapsto",
    "\\xrightharpoondown",
    "\\xrightharpoonup",
    "\\xleftharpoondown",
    "\\xleftharpoonup",
    "\\xrightleftharpoons",
    "\\xleftrightharpoons",
    "\\xlongequal",
    "\\xtwoheadrightarrow",
    "\\xtwoheadleftarrow",
    "\\xtofrom",
    // The next 3 functions are here to support the mhchem extension.
    // Direct use of these functions is discouraged and may break someday.
    "\\xrightleftarrows",
    "\\xrightequilibrium",
    "\\xleftequilibrium",
    // The next 3 functions are here only to support the {CD} environment.
    "\\\\cdrightarrow",
    "\\\\cdleftarrow",
    "\\\\cdlongequal"
  ],
  props: {
    numArgs: 1,
    numOptionalArgs: 1
  },
  handler(r, t, a) {
    var {
      parser: i,
      funcName: s
    } = r;
    return {
      type: "xArrow",
      mode: i.mode,
      label: s,
      body: t[0],
      below: a[0]
    };
  },
  // Flow is unable to correctly infer the type of `group`, even though it's
  // unambiguously determined from the passed-in `type` above.
  htmlBuilder(r, t) {
    var a = t.style, i = t.havingStyle(a.sup()), s = ge.wrapFragment(on(r.body, i, t), t), h = r.label.slice(0, 2) === "\\x" ? "x" : "cd";
    s.classes.push(h + "-arrow-pad");
    var d;
    r.below && (i = t.havingStyle(a.sub()), d = ge.wrapFragment(on(r.below, i, t), t), d.classes.push(h + "-arrow-pad"));
    var y = Rs.svgSpan(r, t), g = -t.fontMetrics().axisHeight + 0.5 * y.height, b = -t.fontMetrics().axisHeight - 0.5 * y.height - 0.111;
    (s.depth > 0.25 || r.label === "\\xleftequilibrium") && (b -= s.depth);
    var x;
    if (d) {
      var T = -t.fontMetrics().axisHeight + d.height + 0.5 * y.height + 0.111;
      x = ge.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: s,
          shift: b
        }, {
          type: "elem",
          elem: y,
          shift: g
        }, {
          type: "elem",
          elem: d,
          shift: T
        }]
      }, t);
    } else
      x = ge.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: s,
          shift: b
        }, {
          type: "elem",
          elem: y,
          shift: g
        }]
      }, t);
    return x.children[0].children[0].children[1].classes.push("svg-align"), ge.makeSpan(["mrel", "x-arrow"], [x], t);
  },
  mathmlBuilder(r, t) {
    var a = Rs.mathMLnode(r.label);
    a.setAttribute("minsize", r.label.charAt(0) === "x" ? "1.75em" : "3.0em");
    var i;
    if (r.body) {
      var s = yv(_n(r.body, t));
      if (r.below) {
        var h = yv(_n(r.below, t));
        i = new Ve.MathNode("munderover", [a, h, s]);
      } else
        i = new Ve.MathNode("mover", [a, s]);
    } else if (r.below) {
      var d = yv(_n(r.below, t));
      i = new Ve.MathNode("munder", [a, d]);
    } else
      i = yv(), i = new Ve.MathNode("mover", [a, i]);
    return i;
  }
});
var WL = ge.makeSpan;
function Mw(r, t) {
  var a = Qr(r.body, t, !0);
  return WL([r.mclass], a, t);
}
function _w(r, t) {
  var a, i = Tl(r.body, t);
  return r.mclass === "minner" ? a = new Ve.MathNode("mpadded", i) : r.mclass === "mord" ? r.isCharacterBox ? (a = i[0], a.type = "mi") : a = new Ve.MathNode("mi", i) : (r.isCharacterBox ? (a = i[0], a.type = "mo") : a = new Ve.MathNode("mo", i), r.mclass === "mbin" ? (a.attributes.lspace = "0.22em", a.attributes.rspace = "0.22em") : r.mclass === "mpunct" ? (a.attributes.lspace = "0em", a.attributes.rspace = "0.17em") : r.mclass === "mopen" || r.mclass === "mclose" ? (a.attributes.lspace = "0em", a.attributes.rspace = "0em") : r.mclass === "minner" && (a.attributes.lspace = "0.0556em", a.attributes.width = "+0.1111em")), a;
}
Ke({
  type: "mclass",
  names: ["\\mathord", "\\mathbin", "\\mathrel", "\\mathopen", "\\mathclose", "\\mathpunct", "\\mathinner"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler(r, t) {
    var {
      parser: a,
      funcName: i
    } = r, s = t[0];
    return {
      type: "mclass",
      mode: a.mode,
      mclass: "m" + i.slice(5),
      // TODO(kevinb): don't prefix with 'm'
      body: Sr(s),
      isCharacterBox: dt.isCharacterBox(s)
    };
  },
  htmlBuilder: Mw,
  mathmlBuilder: _w
});
var e3 = (r) => {
  var t = r.type === "ordgroup" && r.body.length ? r.body[0] : r;
  return t.type === "atom" && (t.family === "bin" || t.family === "rel") ? "m" + t.family : "mord";
};
Ke({
  type: "mclass",
  names: ["\\@binrel"],
  props: {
    numArgs: 2
  },
  handler(r, t) {
    var {
      parser: a
    } = r;
    return {
      type: "mclass",
      mode: a.mode,
      mclass: e3(t[0]),
      body: Sr(t[1]),
      isCharacterBox: dt.isCharacterBox(t[1])
    };
  }
});
Ke({
  type: "mclass",
  names: ["\\stackrel", "\\overset", "\\underset"],
  props: {
    numArgs: 2
  },
  handler(r, t) {
    var {
      parser: a,
      funcName: i
    } = r, s = t[1], h = t[0], d;
    i !== "\\stackrel" ? d = e3(s) : d = "mrel";
    var y = {
      type: "op",
      mode: s.mode,
      limits: !0,
      alwaysHandleSupSub: !0,
      parentIsSupSub: !1,
      symbol: !1,
      suppressBaseShift: i !== "\\stackrel",
      body: Sr(s)
    }, g = {
      type: "supsub",
      mode: h.mode,
      base: y,
      sup: i === "\\underset" ? null : h,
      sub: i === "\\underset" ? h : null
    };
    return {
      type: "mclass",
      mode: a.mode,
      mclass: d,
      body: [g],
      isCharacterBox: dt.isCharacterBox(g)
    };
  },
  htmlBuilder: Mw,
  mathmlBuilder: _w
});
Ke({
  type: "pmb",
  names: ["\\pmb"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(r, t) {
    var {
      parser: a
    } = r;
    return {
      type: "pmb",
      mode: a.mode,
      mclass: e3(t[0]),
      body: Sr(t[0])
    };
  },
  htmlBuilder(r, t) {
    var a = Qr(r.body, t, !0), i = ge.makeSpan([r.mclass], a, t);
    return i.style.textShadow = "0.02em 0.01em 0.04px", i;
  },
  mathmlBuilder(r, t) {
    var a = Tl(r.body, t), i = new Ve.MathNode("mstyle", a);
    return i.setAttribute("style", "text-shadow: 0.02em 0.01em 0.04px"), i;
  }
});
var eB = {
  ">": "\\\\cdrightarrow",
  "<": "\\\\cdleftarrow",
  "=": "\\\\cdlongequal",
  A: "\\uparrow",
  V: "\\downarrow",
  "|": "\\Vert",
  ".": "no arrow"
}, I9 = () => ({
  type: "styling",
  body: [],
  mode: "math",
  style: "display"
}), $9 = (r) => r.type === "textord" && r.text === "@", tB = (r, t) => (r.type === "mathord" || r.type === "atom") && r.text === t;
function nB(r, t, a) {
  var i = eB[r];
  switch (i) {
    case "\\\\cdrightarrow":
    case "\\\\cdleftarrow":
      return a.callFunction(i, [t[0]], [t[1]]);
    case "\\uparrow":
    case "\\downarrow": {
      var s = a.callFunction("\\\\cdleft", [t[0]], []), h = {
        type: "atom",
        text: i,
        mode: "math",
        family: "rel"
      }, d = a.callFunction("\\Big", [h], []), y = a.callFunction("\\\\cdright", [t[1]], []), g = {
        type: "ordgroup",
        mode: "math",
        body: [s, d, y]
      };
      return a.callFunction("\\\\cdparent", [g], []);
    }
    case "\\\\cdlongequal":
      return a.callFunction("\\\\cdlongequal", [], []);
    case "\\Vert": {
      var b = {
        type: "textord",
        text: "\\Vert",
        mode: "math"
      };
      return a.callFunction("\\Big", [b], []);
    }
    default:
      return {
        type: "textord",
        text: " ",
        mode: "math"
      };
  }
}
function rB(r) {
  var t = [];
  for (r.gullet.beginGroup(), r.gullet.macros.set("\\cr", "\\\\\\relax"), r.gullet.beginGroup(); ; ) {
    t.push(r.parseExpression(!1, "\\\\")), r.gullet.endGroup(), r.gullet.beginGroup();
    var a = r.fetch().text;
    if (a === "&" || a === "\\\\")
      r.consume();
    else if (a === "\\end") {
      t[t.length - 1].length === 0 && t.pop();
      break;
    } else
      throw new $e("Expected \\\\ or \\cr or \\end", r.nextToken);
  }
  for (var i = [], s = [i], h = 0; h < t.length; h++) {
    for (var d = t[h], y = I9(), g = 0; g < d.length; g++)
      if (!$9(d[g]))
        y.body.push(d[g]);
      else {
        i.push(y), g += 1;
        var b = B7(d[g]).text, x = new Array(2);
        if (x[0] = {
          type: "ordgroup",
          mode: "math",
          body: []
        }, x[1] = {
          type: "ordgroup",
          mode: "math",
          body: []
        }, !("=|.".indexOf(b) > -1)) if ("<>AV".indexOf(b) > -1)
          for (var T = 0; T < 2; T++) {
            for (var R = !0, E = g + 1; E < d.length; E++) {
              if (tB(d[E], b)) {
                R = !1, g = E;
                break;
              }
              if ($9(d[E]))
                throw new $e("Missing a " + b + " character to complete a CD arrow.", d[E]);
              x[T].body.push(d[E]);
            }
            if (R)
              throw new $e("Missing a " + b + " character to complete a CD arrow.", d[g]);
          }
        else
          throw new $e('Expected one of "<>AV=|." after @', d[g]);
        var O = nB(b, x, r), L = {
          type: "styling",
          body: [O],
          mode: "math",
          style: "display"
          // CD is always displaystyle.
        };
        i.push(L), y = I9();
      }
    h % 2 === 0 ? i.push(y) : i.shift(), i = [], s.push(i);
  }
  r.gullet.endGroup(), r.gullet.endGroup();
  var G = new Array(s[0].length).fill({
    type: "align",
    align: "c",
    pregap: 0.25,
    // CD package sets \enskip between columns.
    postgap: 0.25
    // So pre and post each get half an \enskip, i.e. 0.25em.
  });
  return {
    type: "array",
    mode: "math",
    body: s,
    arraystretch: 1,
    addJot: !0,
    rowGaps: [null],
    cols: G,
    colSeparationType: "CD",
    hLinesBeforeRow: new Array(s.length + 1).fill([])
  };
}
Ke({
  type: "cdlabel",
  names: ["\\\\cdleft", "\\\\cdright"],
  props: {
    numArgs: 1
  },
  handler(r, t) {
    var {
      parser: a,
      funcName: i
    } = r;
    return {
      type: "cdlabel",
      mode: a.mode,
      side: i.slice(4),
      label: t[0]
    };
  },
  htmlBuilder(r, t) {
    var a = t.havingStyle(t.style.sup()), i = ge.wrapFragment(on(r.label, a, t), t);
    return i.classes.push("cd-label-" + r.side), i.style.bottom = Fe(0.8 - i.depth), i.height = 0, i.depth = 0, i;
  },
  mathmlBuilder(r, t) {
    var a = new Ve.MathNode("mrow", [_n(r.label, t)]);
    return a = new Ve.MathNode("mpadded", [a]), a.setAttribute("width", "0"), r.side === "left" && a.setAttribute("lspace", "-1width"), a.setAttribute("voffset", "0.7em"), a = new Ve.MathNode("mstyle", [a]), a.setAttribute("displaystyle", "false"), a.setAttribute("scriptlevel", "1"), a;
  }
});
Ke({
  type: "cdlabelparent",
  names: ["\\\\cdparent"],
  props: {
    numArgs: 1
  },
  handler(r, t) {
    var {
      parser: a
    } = r;
    return {
      type: "cdlabelparent",
      mode: a.mode,
      fragment: t[0]
    };
  },
  htmlBuilder(r, t) {
    var a = ge.wrapFragment(on(r.fragment, t), t);
    return a.classes.push("cd-vert-arrow"), a;
  },
  mathmlBuilder(r, t) {
    return new Ve.MathNode("mrow", [_n(r.fragment, t)]);
  }
});
Ke({
  type: "textord",
  names: ["\\@char"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(r, t) {
    for (var {
      parser: a
    } = r, i = Gt(t[0], "ordgroup"), s = i.body, h = "", d = 0; d < s.length; d++) {
      var y = Gt(s[d], "textord");
      h += y.text;
    }
    var g = parseInt(h), b;
    if (isNaN(g))
      throw new $e("\\@char has non-numeric argument " + h);
    if (g < 0 || g >= 1114111)
      throw new $e("\\@char with invalid code point " + h);
    return g <= 65535 ? b = String.fromCharCode(g) : (g -= 65536, b = String.fromCharCode((g >> 10) + 55296, (g & 1023) + 56320)), {
      type: "textord",
      mode: a.mode,
      text: b
    };
  }
});
var Ow = (r, t) => {
  var a = Qr(r.body, t.withColor(r.color), !1);
  return ge.makeFragment(a);
}, Dw = (r, t) => {
  var a = Tl(r.body, t.withColor(r.color)), i = new Ve.MathNode("mstyle", a);
  return i.setAttribute("mathcolor", r.color), i;
};
Ke({
  type: "color",
  names: ["\\textcolor"],
  props: {
    numArgs: 2,
    allowedInText: !0,
    argTypes: ["color", "original"]
  },
  handler(r, t) {
    var {
      parser: a
    } = r, i = Gt(t[0], "color-token").color, s = t[1];
    return {
      type: "color",
      mode: a.mode,
      color: i,
      body: Sr(s)
    };
  },
  htmlBuilder: Ow,
  mathmlBuilder: Dw
});
Ke({
  type: "color",
  names: ["\\color"],
  props: {
    numArgs: 1,
    allowedInText: !0,
    argTypes: ["color"]
  },
  handler(r, t) {
    var {
      parser: a,
      breakOnTokenText: i
    } = r, s = Gt(t[0], "color-token").color;
    a.gullet.macros.set("\\current@color", s);
    var h = a.parseExpression(!0, i);
    return {
      type: "color",
      mode: a.mode,
      color: s,
      body: h
    };
  },
  htmlBuilder: Ow,
  mathmlBuilder: Dw
});
Ke({
  type: "cr",
  names: ["\\\\"],
  props: {
    numArgs: 0,
    numOptionalArgs: 0,
    allowedInText: !0
  },
  handler(r, t, a) {
    var {
      parser: i
    } = r, s = i.gullet.future().text === "[" ? i.parseSizeGroup(!0) : null, h = !i.settings.displayMode || !i.settings.useStrictBehavior("newLineInDisplayMode", "In LaTeX, \\\\ or \\newline does nothing in display mode");
    return {
      type: "cr",
      mode: i.mode,
      newLine: h,
      size: s && Gt(s, "size").value
    };
  },
  // The following builders are called only at the top level,
  // not within tabular/array environments.
  htmlBuilder(r, t) {
    var a = ge.makeSpan(["mspace"], [], t);
    return r.newLine && (a.classes.push("newline"), r.size && (a.style.marginTop = Fe(Wn(r.size, t)))), a;
  },
  mathmlBuilder(r, t) {
    var a = new Ve.MathNode("mspace");
    return r.newLine && (a.setAttribute("linebreak", "newline"), r.size && a.setAttribute("height", Fe(Wn(r.size, t)))), a;
  }
});
var q5 = {
  "\\global": "\\global",
  "\\long": "\\\\globallong",
  "\\\\globallong": "\\\\globallong",
  "\\def": "\\gdef",
  "\\gdef": "\\gdef",
  "\\edef": "\\xdef",
  "\\xdef": "\\xdef",
  "\\let": "\\\\globallet",
  "\\futurelet": "\\\\globalfuture"
}, Nw = (r) => {
  var t = r.text;
  if (/^(?:[\\{}$&#^_]|EOF)$/.test(t))
    throw new $e("Expected a control sequence", r);
  return t;
}, aB = (r) => {
  var t = r.gullet.popToken();
  return t.text === "=" && (t = r.gullet.popToken(), t.text === " " && (t = r.gullet.popToken())), t;
}, Lw = (r, t, a, i) => {
  var s = r.gullet.macros.get(a.text);
  s == null && (a.noexpand = !0, s = {
    tokens: [a],
    numArgs: 0,
    // reproduce the same behavior in expansion
    unexpandable: !r.gullet.isExpandable(a.text)
  }), r.gullet.macros.set(t, s, i);
};
Ke({
  type: "internal",
  names: [
    "\\global",
    "\\long",
    "\\\\globallong"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler(r) {
    var {
      parser: t,
      funcName: a
    } = r;
    t.consumeSpaces();
    var i = t.fetch();
    if (q5[i.text])
      return (a === "\\global" || a === "\\\\globallong") && (i.text = q5[i.text]), Gt(t.parseFunction(), "internal");
    throw new $e("Invalid token after macro prefix", i);
  }
});
Ke({
  type: "internal",
  names: ["\\def", "\\gdef", "\\edef", "\\xdef"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(r) {
    var {
      parser: t,
      funcName: a
    } = r, i = t.gullet.popToken(), s = i.text;
    if (/^(?:[\\{}$&#^_]|EOF)$/.test(s))
      throw new $e("Expected a control sequence", i);
    for (var h = 0, d, y = [[]]; t.gullet.future().text !== "{"; )
      if (i = t.gullet.popToken(), i.text === "#") {
        if (t.gullet.future().text === "{") {
          d = t.gullet.future(), y[h].push("{");
          break;
        }
        if (i = t.gullet.popToken(), !/^[1-9]$/.test(i.text))
          throw new $e('Invalid argument number "' + i.text + '"');
        if (parseInt(i.text) !== h + 1)
          throw new $e('Argument number "' + i.text + '" out of order');
        h++, y.push([]);
      } else {
        if (i.text === "EOF")
          throw new $e("Expected a macro definition");
        y[h].push(i.text);
      }
    var {
      tokens: g
    } = t.gullet.consumeArg();
    return d && g.unshift(d), (a === "\\edef" || a === "\\xdef") && (g = t.gullet.expandTokens(g), g.reverse()), t.gullet.macros.set(s, {
      tokens: g,
      numArgs: h,
      delimiters: y
    }, a === q5[a]), {
      type: "internal",
      mode: t.mode
    };
  }
});
Ke({
  type: "internal",
  names: [
    "\\let",
    "\\\\globallet"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(r) {
    var {
      parser: t,
      funcName: a
    } = r, i = Nw(t.gullet.popToken());
    t.gullet.consumeSpaces();
    var s = aB(t);
    return Lw(t, i, s, a === "\\\\globallet"), {
      type: "internal",
      mode: t.mode
    };
  }
});
Ke({
  type: "internal",
  names: [
    "\\futurelet",
    "\\\\globalfuture"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(r) {
    var {
      parser: t,
      funcName: a
    } = r, i = Nw(t.gullet.popToken()), s = t.gullet.popToken(), h = t.gullet.popToken();
    return Lw(t, i, h, a === "\\\\globalfuture"), t.gullet.pushToken(h), t.gullet.pushToken(s), {
      type: "internal",
      mode: t.mode
    };
  }
});
var qg = function(t, a, i) {
  var s = Bn.math[t] && Bn.math[t].replace, h = _7(s || t, a, i);
  if (!h)
    throw new Error("Unsupported symbol " + t + " and font size " + a + ".");
  return h;
}, U7 = function(t, a, i, s) {
  var h = i.havingBaseStyle(a), d = ge.makeSpan(s.concat(h.sizingClasses(i)), [t], i), y = h.sizeMultiplier / i.sizeMultiplier;
  return d.height *= y, d.depth *= y, d.maxFontSize = h.sizeMultiplier, d;
}, Bw = function(t, a, i) {
  var s = a.havingBaseStyle(i), h = (1 - a.sizeMultiplier / s.sizeMultiplier) * a.fontMetrics().axisHeight;
  t.classes.push("delimcenter"), t.style.top = Fe(h), t.height -= h, t.depth += h;
}, lB = function(t, a, i, s, h, d) {
  var y = ge.makeSymbol(t, "Main-Regular", h, s), g = U7(y, a, s, d);
  return i && Bw(g, s, a), g;
}, iB = function(t, a, i, s) {
  return ge.makeSymbol(t, "Size" + a + "-Regular", i, s);
}, Hw = function(t, a, i, s, h, d) {
  var y = iB(t, a, h, s), g = U7(ge.makeSpan(["delimsizing", "size" + a], [y], s), yt.TEXT, s, d);
  return i && Bw(g, s, yt.TEXT), g;
}, a5 = function(t, a, i) {
  var s;
  a === "Size1-Regular" ? s = "delim-size1" : s = "delim-size4";
  var h = ge.makeSpan(["delimsizinginner", s], [ge.makeSpan([], [ge.makeSymbol(t, a, i)])]);
  return {
    type: "elem",
    elem: h
  };
}, l5 = function(t, a, i) {
  var s = vo["Size4-Regular"][t.charCodeAt(0)] ? vo["Size4-Regular"][t.charCodeAt(0)][4] : vo["Size1-Regular"][t.charCodeAt(0)][4], h = new l0("inner", fL(t, Math.round(1e3 * a))), d = new As([h], {
    width: Fe(s),
    height: Fe(a),
    // Override CSS rule `.katex svg { width: 100% }`
    style: "width:" + Fe(s),
    viewBox: "0 0 " + 1e3 * s + " " + Math.round(1e3 * a),
    preserveAspectRatio: "xMinYMin"
  }), y = ge.makeSvgSpan([], [d], i);
  return y.height = a, y.style.height = Fe(a), y.style.width = Fe(s), {
    type: "elem",
    elem: y
  };
}, j5 = 8e-3, vv = {
  type: "kern",
  size: -1 * j5
}, uB = ["|", "\\lvert", "\\rvert", "\\vert"], oB = ["\\|", "\\lVert", "\\rVert", "\\Vert"], Uw = function(t, a, i, s, h, d) {
  var y, g, b, x, T = "", R = 0;
  y = b = x = t, g = null;
  var E = "Size1-Regular";
  t === "\\uparrow" ? b = x = "⏐" : t === "\\Uparrow" ? b = x = "‖" : t === "\\downarrow" ? y = b = "⏐" : t === "\\Downarrow" ? y = b = "‖" : t === "\\updownarrow" ? (y = "\\uparrow", b = "⏐", x = "\\downarrow") : t === "\\Updownarrow" ? (y = "\\Uparrow", b = "‖", x = "\\Downarrow") : dt.contains(uB, t) ? (b = "∣", T = "vert", R = 333) : dt.contains(oB, t) ? (b = "∥", T = "doublevert", R = 556) : t === "[" || t === "\\lbrack" ? (y = "⎡", b = "⎢", x = "⎣", E = "Size4-Regular", T = "lbrack", R = 667) : t === "]" || t === "\\rbrack" ? (y = "⎤", b = "⎥", x = "⎦", E = "Size4-Regular", T = "rbrack", R = 667) : t === "\\lfloor" || t === "⌊" ? (b = y = "⎢", x = "⎣", E = "Size4-Regular", T = "lfloor", R = 667) : t === "\\lceil" || t === "⌈" ? (y = "⎡", b = x = "⎢", E = "Size4-Regular", T = "lceil", R = 667) : t === "\\rfloor" || t === "⌋" ? (b = y = "⎥", x = "⎦", E = "Size4-Regular", T = "rfloor", R = 667) : t === "\\rceil" || t === "⌉" ? (y = "⎤", b = x = "⎥", E = "Size4-Regular", T = "rceil", R = 667) : t === "(" || t === "\\lparen" ? (y = "⎛", b = "⎜", x = "⎝", E = "Size4-Regular", T = "lparen", R = 875) : t === ")" || t === "\\rparen" ? (y = "⎞", b = "⎟", x = "⎠", E = "Size4-Regular", T = "rparen", R = 875) : t === "\\{" || t === "\\lbrace" ? (y = "⎧", g = "⎨", x = "⎩", b = "⎪", E = "Size4-Regular") : t === "\\}" || t === "\\rbrace" ? (y = "⎫", g = "⎬", x = "⎭", b = "⎪", E = "Size4-Regular") : t === "\\lgroup" || t === "⟮" ? (y = "⎧", x = "⎩", b = "⎪", E = "Size4-Regular") : t === "\\rgroup" || t === "⟯" ? (y = "⎫", x = "⎭", b = "⎪", E = "Size4-Regular") : t === "\\lmoustache" || t === "⎰" ? (y = "⎧", x = "⎭", b = "⎪", E = "Size4-Regular") : (t === "\\rmoustache" || t === "⎱") && (y = "⎫", x = "⎩", b = "⎪", E = "Size4-Regular");
  var O = qg(y, E, h), L = O.height + O.depth, G = qg(b, E, h), V = G.height + G.depth, I = qg(x, E, h), $ = I.height + I.depth, ce = 0, se = 1;
  if (g !== null) {
    var te = qg(g, E, h);
    ce = te.height + te.depth, se = 2;
  }
  var Ce = L + $ + ce, ve = Math.max(0, Math.ceil((a - Ce) / (se * V))), Ne = Ce + ve * se * V, ee = s.fontMetrics().axisHeight;
  i && (ee *= s.sizeMultiplier);
  var De = Ne / 2 - ee, de = [];
  if (T.length > 0) {
    var Ye = Ne - L - $, Te = Math.round(Ne * 1e3), re = hL(T, Math.round(Ye * 1e3)), J = new l0(T, re), X = (R / 1e3).toFixed(3) + "em", W = (Te / 1e3).toFixed(3) + "em", be = new As([J], {
      width: X,
      height: W,
      viewBox: "0 0 " + R + " " + Te
    }), C = ge.makeSvgSpan([], [be], s);
    C.height = Te / 1e3, C.style.width = X, C.style.height = W, de.push({
      type: "elem",
      elem: C
    });
  } else {
    if (de.push(a5(x, E, h)), de.push(vv), g === null) {
      var Y = Ne - L - $ + 2 * j5;
      de.push(l5(b, Y, s));
    } else {
      var ie = (Ne - L - $ - ce) / 2 + 2 * j5;
      de.push(l5(b, ie, s)), de.push(vv), de.push(a5(g, E, h)), de.push(vv), de.push(l5(b, ie, s));
    }
    de.push(vv), de.push(a5(y, E, h));
  }
  var N = s.havingBaseStyle(yt.TEXT), Me = ge.makeVList({
    positionType: "bottom",
    positionData: De,
    children: de
  }, N);
  return U7(ge.makeSpan(["delimsizing", "mult"], [Me], N), yt.TEXT, s, d);
}, i5 = 80, u5 = 0.08, o5 = function(t, a, i, s, h) {
  var d = cL(t, s, i), y = new l0(t, d), g = new As([y], {
    // Note: 1000:1 ratio of viewBox to document em width.
    width: "400em",
    height: Fe(a),
    viewBox: "0 0 400000 " + i,
    preserveAspectRatio: "xMinYMin slice"
  });
  return ge.makeSvgSpan(["hide-tail"], [g], h);
}, sB = function(t, a) {
  var i = a.havingBaseSizing(), s = Vw("\\surd", t * i.sizeMultiplier, Gw, i), h = i.sizeMultiplier, d = Math.max(0, a.minRuleThickness - a.fontMetrics().sqrtRuleThickness), y, g = 0, b = 0, x = 0, T;
  return s.type === "small" ? (x = 1e3 + 1e3 * d + i5, t < 1 ? h = 1 : t < 1.4 && (h = 0.7), g = (1 + d + u5) / h, b = (1 + d) / h, y = o5("sqrtMain", g, x, d, a), y.style.minWidth = "0.853em", T = 0.833 / h) : s.type === "large" ? (x = (1e3 + i5) * Yg[s.size], b = (Yg[s.size] + d) / h, g = (Yg[s.size] + d + u5) / h, y = o5("sqrtSize" + s.size, g, x, d, a), y.style.minWidth = "1.02em", T = 1 / h) : (g = t + d + u5, b = t + d, x = Math.floor(1e3 * t + d) + i5, y = o5("sqrtTall", g, x, d, a), y.style.minWidth = "0.742em", T = 1.056), y.height = b, y.style.height = Fe(g), {
    span: y,
    advanceWidth: T,
    // Calculate the actual line width.
    // This actually should depend on the chosen font -- e.g. \boldmath
    // should use the thicker surd symbols from e.g. KaTeX_Main-Bold, and
    // have thicker rules.
    ruleWidth: (a.fontMetrics().sqrtRuleThickness + d) * h
  };
}, qw = ["(", "\\lparen", ")", "\\rparen", "[", "\\lbrack", "]", "\\rbrack", "\\{", "\\lbrace", "\\}", "\\rbrace", "\\lfloor", "\\rfloor", "⌊", "⌋", "\\lceil", "\\rceil", "⌈", "⌉", "\\surd"], cB = ["\\uparrow", "\\downarrow", "\\updownarrow", "\\Uparrow", "\\Downarrow", "\\Updownarrow", "|", "\\|", "\\vert", "\\Vert", "\\lvert", "\\rvert", "\\lVert", "\\rVert", "\\lgroup", "\\rgroup", "⟮", "⟯", "\\lmoustache", "\\rmoustache", "⎰", "⎱"], jw = ["<", ">", "\\langle", "\\rangle", "/", "\\backslash", "\\lt", "\\gt"], Yg = [0, 1.2, 1.8, 2.4, 3], fB = function(t, a, i, s, h) {
  if (t === "<" || t === "\\lt" || t === "⟨" ? t = "\\langle" : (t === ">" || t === "\\gt" || t === "⟩") && (t = "\\rangle"), dt.contains(qw, t) || dt.contains(jw, t))
    return Hw(t, a, !1, i, s, h);
  if (dt.contains(cB, t))
    return Uw(t, Yg[a], !1, i, s, h);
  throw new $e("Illegal delimiter: '" + t + "'");
}, hB = [{
  type: "small",
  style: yt.SCRIPTSCRIPT
}, {
  type: "small",
  style: yt.SCRIPT
}, {
  type: "small",
  style: yt.TEXT
}, {
  type: "large",
  size: 1
}, {
  type: "large",
  size: 2
}, {
  type: "large",
  size: 3
}, {
  type: "large",
  size: 4
}], dB = [{
  type: "small",
  style: yt.SCRIPTSCRIPT
}, {
  type: "small",
  style: yt.SCRIPT
}, {
  type: "small",
  style: yt.TEXT
}, {
  type: "stack"
}], Gw = [{
  type: "small",
  style: yt.SCRIPTSCRIPT
}, {
  type: "small",
  style: yt.SCRIPT
}, {
  type: "small",
  style: yt.TEXT
}, {
  type: "large",
  size: 1
}, {
  type: "large",
  size: 2
}, {
  type: "large",
  size: 3
}, {
  type: "large",
  size: 4
}, {
  type: "stack"
}], mB = function(t) {
  if (t.type === "small")
    return "Main-Regular";
  if (t.type === "large")
    return "Size" + t.size + "-Regular";
  if (t.type === "stack")
    return "Size4-Regular";
  throw new Error("Add support for delim type '" + t.type + "' here.");
}, Vw = function(t, a, i, s) {
  for (var h = Math.min(2, 3 - s.style.size), d = h; d < i.length && i[d].type !== "stack"; d++) {
    var y = qg(t, mB(i[d]), "math"), g = y.height + y.depth;
    if (i[d].type === "small") {
      var b = s.havingBaseStyle(i[d].style);
      g *= b.sizeMultiplier;
    }
    if (g > a)
      return i[d];
  }
  return i[i.length - 1];
}, Yw = function(t, a, i, s, h, d) {
  t === "<" || t === "\\lt" || t === "⟨" ? t = "\\langle" : (t === ">" || t === "\\gt" || t === "⟩") && (t = "\\rangle");
  var y;
  dt.contains(jw, t) ? y = hB : dt.contains(qw, t) ? y = Gw : y = dB;
  var g = Vw(t, a, y, s);
  return g.type === "small" ? lB(t, g.style, i, s, h, d) : g.type === "large" ? Hw(t, g.size, i, s, h, d) : Uw(t, a, i, s, h, d);
}, pB = function(t, a, i, s, h, d) {
  var y = s.fontMetrics().axisHeight * s.sizeMultiplier, g = 901, b = 5 / s.fontMetrics().ptPerEm, x = Math.max(a - y, i + y), T = Math.max(
    // In real TeX, calculations are done using integral values which are
    // 65536 per pt, or 655360 per em. So, the division here truncates in
    // TeX but doesn't here, producing different results. If we wanted to
    // exactly match TeX's calculation, we could do
    //   Math.floor(655360 * maxDistFromAxis / 500) *
    //    delimiterFactor / 655360
    // (To see the difference, compare
    //    x^{x^{\left(\rule{0.1em}{0.68em}\right)}}
    // in TeX and KaTeX)
    x / 500 * g,
    2 * x - b
  );
  return Yw(t, T, !0, s, h, d);
}, Es = {
  sqrtImage: sB,
  sizedDelim: fB,
  sizeToMaxHeight: Yg,
  customSizedDelim: Yw,
  leftRightDelim: pB
}, X9 = {
  "\\bigl": {
    mclass: "mopen",
    size: 1
  },
  "\\Bigl": {
    mclass: "mopen",
    size: 2
  },
  "\\biggl": {
    mclass: "mopen",
    size: 3
  },
  "\\Biggl": {
    mclass: "mopen",
    size: 4
  },
  "\\bigr": {
    mclass: "mclose",
    size: 1
  },
  "\\Bigr": {
    mclass: "mclose",
    size: 2
  },
  "\\biggr": {
    mclass: "mclose",
    size: 3
  },
  "\\Biggr": {
    mclass: "mclose",
    size: 4
  },
  "\\bigm": {
    mclass: "mrel",
    size: 1
  },
  "\\Bigm": {
    mclass: "mrel",
    size: 2
  },
  "\\biggm": {
    mclass: "mrel",
    size: 3
  },
  "\\Biggm": {
    mclass: "mrel",
    size: 4
  },
  "\\big": {
    mclass: "mord",
    size: 1
  },
  "\\Big": {
    mclass: "mord",
    size: 2
  },
  "\\bigg": {
    mclass: "mord",
    size: 3
  },
  "\\Bigg": {
    mclass: "mord",
    size: 4
  }
}, gB = ["(", "\\lparen", ")", "\\rparen", "[", "\\lbrack", "]", "\\rbrack", "\\{", "\\lbrace", "\\}", "\\rbrace", "\\lfloor", "\\rfloor", "⌊", "⌋", "\\lceil", "\\rceil", "⌈", "⌉", "<", ">", "\\langle", "⟨", "\\rangle", "⟩", "\\lt", "\\gt", "\\lvert", "\\rvert", "\\lVert", "\\rVert", "\\lgroup", "\\rgroup", "⟮", "⟯", "\\lmoustache", "\\rmoustache", "⎰", "⎱", "/", "\\backslash", "|", "\\vert", "\\|", "\\Vert", "\\uparrow", "\\Uparrow", "\\downarrow", "\\Downarrow", "\\updownarrow", "\\Updownarrow", "."];
function t3(r, t) {
  var a = Wv(r);
  if (a && dt.contains(gB, a.text))
    return a;
  throw a ? new $e("Invalid delimiter '" + a.text + "' after '" + t.funcName + "'", r) : new $e("Invalid delimiter type '" + r.type + "'", r);
}
Ke({
  type: "delimsizing",
  names: ["\\bigl", "\\Bigl", "\\biggl", "\\Biggl", "\\bigr", "\\Bigr", "\\biggr", "\\Biggr", "\\bigm", "\\Bigm", "\\biggm", "\\Biggm", "\\big", "\\Big", "\\bigg", "\\Bigg"],
  props: {
    numArgs: 1,
    argTypes: ["primitive"]
  },
  handler: (r, t) => {
    var a = t3(t[0], r);
    return {
      type: "delimsizing",
      mode: r.parser.mode,
      size: X9[r.funcName].size,
      mclass: X9[r.funcName].mclass,
      delim: a.text
    };
  },
  htmlBuilder: (r, t) => r.delim === "." ? ge.makeSpan([r.mclass]) : Es.sizedDelim(r.delim, r.size, t, r.mode, [r.mclass]),
  mathmlBuilder: (r) => {
    var t = [];
    r.delim !== "." && t.push(ji(r.delim, r.mode));
    var a = new Ve.MathNode("mo", t);
    r.mclass === "mopen" || r.mclass === "mclose" ? a.setAttribute("fence", "true") : a.setAttribute("fence", "false"), a.setAttribute("stretchy", "true");
    var i = Fe(Es.sizeToMaxHeight[r.size]);
    return a.setAttribute("minsize", i), a.setAttribute("maxsize", i), a;
  }
});
function Q9(r) {
  if (!r.body)
    throw new Error("Bug: The leftright ParseNode wasn't fully parsed.");
}
Ke({
  type: "leftright-right",
  names: ["\\right"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (r, t) => {
    var a = r.parser.gullet.macros.get("\\current@color");
    if (a && typeof a != "string")
      throw new $e("\\current@color set to non-string in \\right");
    return {
      type: "leftright-right",
      mode: r.parser.mode,
      delim: t3(t[0], r).text,
      color: a
      // undefined if not set via \color
    };
  }
});
Ke({
  type: "leftright",
  names: ["\\left"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (r, t) => {
    var a = t3(t[0], r), i = r.parser;
    ++i.leftrightDepth;
    var s = i.parseExpression(!1);
    --i.leftrightDepth, i.expect("\\right", !1);
    var h = Gt(i.parseFunction(), "leftright-right");
    return {
      type: "leftright",
      mode: i.mode,
      body: s,
      left: a.text,
      right: h.delim,
      rightColor: h.color
    };
  },
  htmlBuilder: (r, t) => {
    Q9(r);
    for (var a = Qr(r.body, t, !0, ["mopen", "mclose"]), i = 0, s = 0, h = !1, d = 0; d < a.length; d++)
      a[d].isMiddle ? h = !0 : (i = Math.max(a[d].height, i), s = Math.max(a[d].depth, s));
    i *= t.sizeMultiplier, s *= t.sizeMultiplier;
    var y;
    if (r.left === "." ? y = Kg(t, ["mopen"]) : y = Es.leftRightDelim(r.left, i, s, t, r.mode, ["mopen"]), a.unshift(y), h)
      for (var g = 1; g < a.length; g++) {
        var b = a[g], x = b.isMiddle;
        x && (a[g] = Es.leftRightDelim(x.delim, i, s, x.options, r.mode, []));
      }
    var T;
    if (r.right === ".")
      T = Kg(t, ["mclose"]);
    else {
      var R = r.rightColor ? t.withColor(r.rightColor) : t;
      T = Es.leftRightDelim(r.right, i, s, R, r.mode, ["mclose"]);
    }
    return a.push(T), ge.makeSpan(["minner"], a, t);
  },
  mathmlBuilder: (r, t) => {
    Q9(r);
    var a = Tl(r.body, t);
    if (r.left !== ".") {
      var i = new Ve.MathNode("mo", [ji(r.left, r.mode)]);
      i.setAttribute("fence", "true"), a.unshift(i);
    }
    if (r.right !== ".") {
      var s = new Ve.MathNode("mo", [ji(r.right, r.mode)]);
      s.setAttribute("fence", "true"), r.rightColor && s.setAttribute("mathcolor", r.rightColor), a.push(s);
    }
    return N7(a);
  }
});
Ke({
  type: "middle",
  names: ["\\middle"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (r, t) => {
    var a = t3(t[0], r);
    if (!r.parser.leftrightDepth)
      throw new $e("\\middle without preceding \\left", a);
    return {
      type: "middle",
      mode: r.parser.mode,
      delim: a.text
    };
  },
  htmlBuilder: (r, t) => {
    var a;
    if (r.delim === ".")
      a = Kg(t, []);
    else {
      a = Es.sizedDelim(r.delim, 1, t, r.mode, []);
      var i = {
        delim: r.delim,
        options: t
      };
      a.isMiddle = i;
    }
    return a;
  },
  mathmlBuilder: (r, t) => {
    var a = r.delim === "\\vert" || r.delim === "|" ? ji("|", "text") : ji(r.delim, r.mode), i = new Ve.MathNode("mo", [a]);
    return i.setAttribute("fence", "true"), i.setAttribute("lspace", "0.05em"), i.setAttribute("rspace", "0.05em"), i;
  }
});
var q7 = (r, t) => {
  var a = ge.wrapFragment(on(r.body, t), t), i = r.label.slice(1), s = t.sizeMultiplier, h, d = 0, y = dt.isCharacterBox(r.body);
  if (i === "sout")
    h = ge.makeSpan(["stretchy", "sout"]), h.height = t.fontMetrics().defaultRuleThickness / s, d = -0.5 * t.fontMetrics().xHeight;
  else if (i === "phase") {
    var g = Wn({
      number: 0.6,
      unit: "pt"
    }, t), b = Wn({
      number: 0.35,
      unit: "ex"
    }, t), x = t.havingBaseSizing();
    s = s / x.sizeMultiplier;
    var T = a.height + a.depth + g + b;
    a.style.paddingLeft = Fe(T / 2 + g);
    var R = Math.floor(1e3 * T * s), E = oL(R), O = new As([new l0("phase", E)], {
      width: "400em",
      height: Fe(R / 1e3),
      viewBox: "0 0 400000 " + R,
      preserveAspectRatio: "xMinYMin slice"
    });
    h = ge.makeSvgSpan(["hide-tail"], [O], t), h.style.height = Fe(T), d = a.depth + g + b;
  } else {
    /cancel/.test(i) ? y || a.classes.push("cancel-pad") : i === "angl" ? a.classes.push("anglpad") : a.classes.push("boxpad");
    var L = 0, G = 0, V = 0;
    /box/.test(i) ? (V = Math.max(
      t.fontMetrics().fboxrule,
      // default
      t.minRuleThickness
      // User override.
    ), L = t.fontMetrics().fboxsep + (i === "colorbox" ? 0 : V), G = L) : i === "angl" ? (V = Math.max(t.fontMetrics().defaultRuleThickness, t.minRuleThickness), L = 4 * V, G = Math.max(0, 0.25 - a.depth)) : (L = y ? 0.2 : 0, G = L), h = Rs.encloseSpan(a, i, L, G, t), /fbox|boxed|fcolorbox/.test(i) ? (h.style.borderStyle = "solid", h.style.borderWidth = Fe(V)) : i === "angl" && V !== 0.049 && (h.style.borderTopWidth = Fe(V), h.style.borderRightWidth = Fe(V)), d = a.depth + G, r.backgroundColor && (h.style.backgroundColor = r.backgroundColor, r.borderColor && (h.style.borderColor = r.borderColor));
  }
  var I;
  if (r.backgroundColor)
    I = ge.makeVList({
      positionType: "individualShift",
      children: [
        // Put the color background behind inner;
        {
          type: "elem",
          elem: h,
          shift: d
        },
        {
          type: "elem",
          elem: a,
          shift: 0
        }
      ]
    }, t);
  else {
    var $ = /cancel|phase/.test(i) ? ["svg-align"] : [];
    I = ge.makeVList({
      positionType: "individualShift",
      children: [
        // Write the \cancel stroke on top of inner.
        {
          type: "elem",
          elem: a,
          shift: 0
        },
        {
          type: "elem",
          elem: h,
          shift: d,
          wrapperClasses: $
        }
      ]
    }, t);
  }
  return /cancel/.test(i) && (I.height = a.height, I.depth = a.depth), /cancel/.test(i) && !y ? ge.makeSpan(["mord", "cancel-lap"], [I], t) : ge.makeSpan(["mord"], [I], t);
}, j7 = (r, t) => {
  var a = 0, i = new Ve.MathNode(r.label.indexOf("colorbox") > -1 ? "mpadded" : "menclose", [_n(r.body, t)]);
  switch (r.label) {
    case "\\cancel":
      i.setAttribute("notation", "updiagonalstrike");
      break;
    case "\\bcancel":
      i.setAttribute("notation", "downdiagonalstrike");
      break;
    case "\\phase":
      i.setAttribute("notation", "phasorangle");
      break;
    case "\\sout":
      i.setAttribute("notation", "horizontalstrike");
      break;
    case "\\fbox":
      i.setAttribute("notation", "box");
      break;
    case "\\angl":
      i.setAttribute("notation", "actuarial");
      break;
    case "\\fcolorbox":
    case "\\colorbox":
      if (a = t.fontMetrics().fboxsep * t.fontMetrics().ptPerEm, i.setAttribute("width", "+" + 2 * a + "pt"), i.setAttribute("height", "+" + 2 * a + "pt"), i.setAttribute("lspace", a + "pt"), i.setAttribute("voffset", a + "pt"), r.label === "\\fcolorbox") {
        var s = Math.max(
          t.fontMetrics().fboxrule,
          // default
          t.minRuleThickness
          // user override
        );
        i.setAttribute("style", "border: " + s + "em solid " + String(r.borderColor));
      }
      break;
    case "\\xcancel":
      i.setAttribute("notation", "updiagonalstrike downdiagonalstrike");
      break;
  }
  return r.backgroundColor && i.setAttribute("mathbackground", r.backgroundColor), i;
};
Ke({
  type: "enclose",
  names: ["\\colorbox"],
  props: {
    numArgs: 2,
    allowedInText: !0,
    argTypes: ["color", "text"]
  },
  handler(r, t, a) {
    var {
      parser: i,
      funcName: s
    } = r, h = Gt(t[0], "color-token").color, d = t[1];
    return {
      type: "enclose",
      mode: i.mode,
      label: s,
      backgroundColor: h,
      body: d
    };
  },
  htmlBuilder: q7,
  mathmlBuilder: j7
});
Ke({
  type: "enclose",
  names: ["\\fcolorbox"],
  props: {
    numArgs: 3,
    allowedInText: !0,
    argTypes: ["color", "color", "text"]
  },
  handler(r, t, a) {
    var {
      parser: i,
      funcName: s
    } = r, h = Gt(t[0], "color-token").color, d = Gt(t[1], "color-token").color, y = t[2];
    return {
      type: "enclose",
      mode: i.mode,
      label: s,
      backgroundColor: d,
      borderColor: h,
      body: y
    };
  },
  htmlBuilder: q7,
  mathmlBuilder: j7
});
Ke({
  type: "enclose",
  names: ["\\fbox"],
  props: {
    numArgs: 1,
    argTypes: ["hbox"],
    allowedInText: !0
  },
  handler(r, t) {
    var {
      parser: a
    } = r;
    return {
      type: "enclose",
      mode: a.mode,
      label: "\\fbox",
      body: t[0]
    };
  }
});
Ke({
  type: "enclose",
  names: ["\\cancel", "\\bcancel", "\\xcancel", "\\sout", "\\phase"],
  props: {
    numArgs: 1
  },
  handler(r, t) {
    var {
      parser: a,
      funcName: i
    } = r, s = t[0];
    return {
      type: "enclose",
      mode: a.mode,
      label: i,
      body: s
    };
  },
  htmlBuilder: q7,
  mathmlBuilder: j7
});
Ke({
  type: "enclose",
  names: ["\\angl"],
  props: {
    numArgs: 1,
    argTypes: ["hbox"],
    allowedInText: !1
  },
  handler(r, t) {
    var {
      parser: a
    } = r;
    return {
      type: "enclose",
      mode: a.mode,
      label: "\\angl",
      body: t[0]
    };
  }
});
var Iw = {};
function xo(r) {
  for (var {
    type: t,
    names: a,
    props: i,
    handler: s,
    htmlBuilder: h,
    mathmlBuilder: d
  } = r, y = {
    type: t,
    numArgs: i.numArgs || 0,
    allowedInText: !1,
    numOptionalArgs: 0,
    handler: s
  }, g = 0; g < a.length; ++g)
    Iw[a[g]] = y;
  h && (Bv[t] = h), d && (Hv[t] = d);
}
var $w = {};
function U(r, t) {
  $w[r] = t;
}
function Z9(r) {
  var t = [];
  r.consumeSpaces();
  var a = r.fetch().text;
  for (a === "\\relax" && (r.consume(), r.consumeSpaces(), a = r.fetch().text); a === "\\hline" || a === "\\hdashline"; )
    r.consume(), t.push(a === "\\hdashline"), r.consumeSpaces(), a = r.fetch().text;
  return t;
}
var n3 = (r) => {
  var t = r.parser.settings;
  if (!t.displayMode)
    throw new $e("{" + r.envName + "} can be used only in display mode.");
};
function G7(r) {
  if (r.indexOf("ed") === -1)
    return r.indexOf("*") === -1;
}
function o0(r, t, a) {
  var {
    hskipBeforeAndAfter: i,
    addJot: s,
    cols: h,
    arraystretch: d,
    colSeparationType: y,
    autoTag: g,
    singleRow: b,
    emptySingleRow: x,
    maxNumCols: T,
    leqno: R
  } = t;
  if (r.gullet.beginGroup(), b || r.gullet.macros.set("\\cr", "\\\\\\relax"), !d) {
    var E = r.gullet.expandMacroAsText("\\arraystretch");
    if (E == null)
      d = 1;
    else if (d = parseFloat(E), !d || d < 0)
      throw new $e("Invalid \\arraystretch: " + E);
  }
  r.gullet.beginGroup();
  var O = [], L = [O], G = [], V = [], I = g != null ? [] : void 0;
  function $() {
    g && r.gullet.macros.set("\\@eqnsw", "1", !0);
  }
  function ce() {
    I && (r.gullet.macros.get("\\df@tag") ? (I.push(r.subparse([new Li("\\df@tag")])), r.gullet.macros.set("\\df@tag", void 0, !0)) : I.push(!!g && r.gullet.macros.get("\\@eqnsw") === "1"));
  }
  for ($(), V.push(Z9(r)); ; ) {
    var se = r.parseExpression(!1, b ? "\\end" : "\\\\");
    r.gullet.endGroup(), r.gullet.beginGroup(), se = {
      type: "ordgroup",
      mode: r.mode,
      body: se
    }, a && (se = {
      type: "styling",
      mode: r.mode,
      style: a,
      body: [se]
    }), O.push(se);
    var te = r.fetch().text;
    if (te === "&") {
      if (T && O.length === T) {
        if (b || y)
          throw new $e("Too many tab characters: &", r.nextToken);
        r.settings.reportNonstrict("textEnv", "Too few columns specified in the {array} column argument.");
      }
      r.consume();
    } else if (te === "\\end") {
      ce(), O.length === 1 && se.type === "styling" && se.body[0].body.length === 0 && (L.length > 1 || !x) && L.pop(), V.length < L.length + 1 && V.push([]);
      break;
    } else if (te === "\\\\") {
      r.consume();
      var Ce = void 0;
      r.gullet.future().text !== " " && (Ce = r.parseSizeGroup(!0)), G.push(Ce ? Ce.value : null), ce(), V.push(Z9(r)), O = [], L.push(O), $();
    } else
      throw new $e("Expected & or \\\\ or \\cr or \\end", r.nextToken);
  }
  return r.gullet.endGroup(), r.gullet.endGroup(), {
    type: "array",
    mode: r.mode,
    addJot: s,
    arraystretch: d,
    body: L,
    cols: h,
    rowGaps: G,
    hskipBeforeAndAfter: i,
    hLinesBeforeRow: V,
    colSeparationType: y,
    tags: I,
    leqno: R
  };
}
function V7(r) {
  return r.slice(0, 1) === "d" ? "display" : "text";
}
var wo = function(t, a) {
  var i, s, h = t.body.length, d = t.hLinesBeforeRow, y = 0, g = new Array(h), b = [], x = Math.max(
    // From LaTeX \showthe\arrayrulewidth. Equals 0.04 em.
    a.fontMetrics().arrayRuleWidth,
    a.minRuleThickness
    // User override.
  ), T = 1 / a.fontMetrics().ptPerEm, R = 5 * T;
  if (t.colSeparationType && t.colSeparationType === "small") {
    var E = a.havingStyle(yt.SCRIPT).sizeMultiplier;
    R = 0.2778 * (E / a.sizeMultiplier);
  }
  var O = t.colSeparationType === "CD" ? Wn({
    number: 3,
    unit: "ex"
  }, a) : 12 * T, L = 3 * T, G = t.arraystretch * O, V = 0.7 * G, I = 0.3 * G, $ = 0;
  function ce(er) {
    for (var sr = 0; sr < er.length; ++sr)
      sr > 0 && ($ += 0.25), b.push({
        pos: $,
        isDashed: er[sr]
      });
  }
  for (ce(d[0]), i = 0; i < t.body.length; ++i) {
    var se = t.body[i], te = V, Ce = I;
    y < se.length && (y = se.length);
    var ve = new Array(se.length);
    for (s = 0; s < se.length; ++s) {
      var Ne = on(se[s], a);
      Ce < Ne.depth && (Ce = Ne.depth), te < Ne.height && (te = Ne.height), ve[s] = Ne;
    }
    var ee = t.rowGaps[i], De = 0;
    ee && (De = Wn(ee, a), De > 0 && (De += I, Ce < De && (Ce = De), De = 0)), t.addJot && (Ce += L), ve.height = te, ve.depth = Ce, $ += te, ve.pos = $, $ += Ce + De, g[i] = ve, ce(d[i + 1]);
  }
  var de = $ / 2 + a.fontMetrics().axisHeight, Ye = t.cols || [], Te = [], re, J, X = [];
  if (t.tags && t.tags.some((er) => er))
    for (i = 0; i < h; ++i) {
      var W = g[i], be = W.pos - de, C = t.tags[i], Y = void 0;
      C === !0 ? Y = ge.makeSpan(["eqn-num"], [], a) : C === !1 ? Y = ge.makeSpan([], [], a) : Y = ge.makeSpan([], Qr(C, a, !0), a), Y.depth = W.depth, Y.height = W.height, X.push({
        type: "elem",
        elem: Y,
        shift: be
      });
    }
  for (
    s = 0, J = 0;
    // Continue while either there are more columns or more column
    // descriptions, so trailing separators don't get lost.
    s < y || J < Ye.length;
    ++s, ++J
  ) {
    for (var ie = Ye[J] || {}, N = !0; ie.type === "separator"; ) {
      if (N || (re = ge.makeSpan(["arraycolsep"], []), re.style.width = Fe(a.fontMetrics().doubleRuleSep), Te.push(re)), ie.separator === "|" || ie.separator === ":") {
        var Me = ie.separator === "|" ? "solid" : "dashed", _e = ge.makeSpan(["vertical-separator"], [], a);
        _e.style.height = Fe($), _e.style.borderRightWidth = Fe(x), _e.style.borderRightStyle = Me, _e.style.margin = "0 " + Fe(-x / 2);
        var Se = $ - de;
        Se && (_e.style.verticalAlign = Fe(-Se)), Te.push(_e);
      } else
        throw new $e("Invalid separator type: " + ie.separator);
      J++, ie = Ye[J] || {}, N = !1;
    }
    if (!(s >= y)) {
      var Ge = void 0;
      (s > 0 || t.hskipBeforeAndAfter) && (Ge = dt.deflt(ie.pregap, R), Ge !== 0 && (re = ge.makeSpan(["arraycolsep"], []), re.style.width = Fe(Ge), Te.push(re)));
      var rt = [];
      for (i = 0; i < h; ++i) {
        var ht = g[i], vt = ht[s];
        if (vt) {
          var St = ht.pos - de;
          vt.depth = ht.depth, vt.height = ht.height, rt.push({
            type: "elem",
            elem: vt,
            shift: St
          });
        }
      }
      rt = ge.makeVList({
        positionType: "individualShift",
        children: rt
      }, a), rt = ge.makeSpan(["col-align-" + (ie.align || "c")], [rt]), Te.push(rt), (s < y - 1 || t.hskipBeforeAndAfter) && (Ge = dt.deflt(ie.postgap, R), Ge !== 0 && (re = ge.makeSpan(["arraycolsep"], []), re.style.width = Fe(Ge), Te.push(re)));
    }
  }
  if (g = ge.makeSpan(["mtable"], Te), b.length > 0) {
    for (var wn = ge.makeLineSpan("hline", a, x), Dr = ge.makeLineSpan("hdashline", a, x), jn = [{
      type: "elem",
      elem: g,
      shift: 0
    }]; b.length > 0; ) {
      var Gn = b.pop(), xr = Gn.pos - de;
      Gn.isDashed ? jn.push({
        type: "elem",
        elem: Dr,
        shift: xr
      }) : jn.push({
        type: "elem",
        elem: wn,
        shift: xr
      });
    }
    g = ge.makeVList({
      positionType: "individualShift",
      children: jn
    }, a);
  }
  if (X.length === 0)
    return ge.makeSpan(["mord"], [g], a);
  var Bt = ge.makeVList({
    positionType: "individualShift",
    children: X
  }, a);
  return Bt = ge.makeSpan(["tag"], [Bt], a), ge.makeFragment([g, Bt]);
}, yB = {
  c: "center ",
  l: "left ",
  r: "right "
}, To = function(t, a) {
  for (var i = [], s = new Ve.MathNode("mtd", [], ["mtr-glue"]), h = new Ve.MathNode("mtd", [], ["mml-eqn-num"]), d = 0; d < t.body.length; d++) {
    for (var y = t.body[d], g = [], b = 0; b < y.length; b++)
      g.push(new Ve.MathNode("mtd", [_n(y[b], a)]));
    t.tags && t.tags[d] && (g.unshift(s), g.push(s), t.leqno ? g.unshift(h) : g.push(h)), i.push(new Ve.MathNode("mtr", g));
  }
  var x = new Ve.MathNode("mtable", i), T = t.arraystretch === 0.5 ? 0.1 : 0.16 + t.arraystretch - 1 + (t.addJot ? 0.09 : 0);
  x.setAttribute("rowspacing", Fe(T));
  var R = "", E = "";
  if (t.cols && t.cols.length > 0) {
    var O = t.cols, L = "", G = !1, V = 0, I = O.length;
    O[0].type === "separator" && (R += "top ", V = 1), O[O.length - 1].type === "separator" && (R += "bottom ", I -= 1);
    for (var $ = V; $ < I; $++)
      O[$].type === "align" ? (E += yB[O[$].align], G && (L += "none "), G = !0) : O[$].type === "separator" && G && (L += O[$].separator === "|" ? "solid " : "dashed ", G = !1);
    x.setAttribute("columnalign", E.trim()), /[sd]/.test(L) && x.setAttribute("columnlines", L.trim());
  }
  if (t.colSeparationType === "align") {
    for (var ce = t.cols || [], se = "", te = 1; te < ce.length; te++)
      se += te % 2 ? "0em " : "1em ";
    x.setAttribute("columnspacing", se.trim());
  } else t.colSeparationType === "alignat" || t.colSeparationType === "gather" ? x.setAttribute("columnspacing", "0em") : t.colSeparationType === "small" ? x.setAttribute("columnspacing", "0.2778em") : t.colSeparationType === "CD" ? x.setAttribute("columnspacing", "0.5em") : x.setAttribute("columnspacing", "1em");
  var Ce = "", ve = t.hLinesBeforeRow;
  R += ve[0].length > 0 ? "left " : "", R += ve[ve.length - 1].length > 0 ? "right " : "";
  for (var Ne = 1; Ne < ve.length - 1; Ne++)
    Ce += ve[Ne].length === 0 ? "none " : ve[Ne][0] ? "dashed " : "solid ";
  return /[sd]/.test(Ce) && x.setAttribute("rowlines", Ce.trim()), R !== "" && (x = new Ve.MathNode("menclose", [x]), x.setAttribute("notation", R.trim())), t.arraystretch && t.arraystretch < 1 && (x = new Ve.MathNode("mstyle", [x]), x.setAttribute("scriptlevel", "1")), x;
}, Xw = function(t, a) {
  t.envName.indexOf("ed") === -1 && n3(t);
  var i = [], s = t.envName.indexOf("at") > -1 ? "alignat" : "align", h = t.envName === "split", d = o0(t.parser, {
    cols: i,
    addJot: !0,
    autoTag: h ? void 0 : G7(t.envName),
    emptySingleRow: !0,
    colSeparationType: s,
    maxNumCols: h ? 2 : void 0,
    leqno: t.parser.settings.leqno
  }, "display"), y, g = 0, b = {
    type: "ordgroup",
    mode: t.mode,
    body: []
  };
  if (a[0] && a[0].type === "ordgroup") {
    for (var x = "", T = 0; T < a[0].body.length; T++) {
      var R = Gt(a[0].body[T], "textord");
      x += R.text;
    }
    y = Number(x), g = y * 2;
  }
  var E = !g;
  d.body.forEach(function(V) {
    for (var I = 1; I < V.length; I += 2) {
      var $ = Gt(V[I], "styling"), ce = Gt($.body[0], "ordgroup");
      ce.body.unshift(b);
    }
    if (E)
      g < V.length && (g = V.length);
    else {
      var se = V.length / 2;
      if (y < se)
        throw new $e("Too many math in a row: " + ("expected " + y + ", but got " + se), V[0]);
    }
  });
  for (var O = 0; O < g; ++O) {
    var L = "r", G = 0;
    O % 2 === 1 ? L = "l" : O > 0 && E && (G = 1), i[O] = {
      type: "align",
      align: L,
      pregap: G,
      postgap: 0
    };
  }
  return d.colSeparationType = E ? "align" : "alignat", d;
};
xo({
  type: "array",
  names: ["array", "darray"],
  props: {
    numArgs: 1
  },
  handler(r, t) {
    var a = Wv(t[0]), i = a ? [t[0]] : Gt(t[0], "ordgroup").body, s = i.map(function(d) {
      var y = B7(d), g = y.text;
      if ("lcr".indexOf(g) !== -1)
        return {
          type: "align",
          align: g
        };
      if (g === "|")
        return {
          type: "separator",
          separator: "|"
        };
      if (g === ":")
        return {
          type: "separator",
          separator: ":"
        };
      throw new $e("Unknown column alignment: " + g, d);
    }), h = {
      cols: s,
      hskipBeforeAndAfter: !0,
      // \@preamble in lttab.dtx
      maxNumCols: s.length
    };
    return o0(r.parser, h, V7(r.envName));
  },
  htmlBuilder: wo,
  mathmlBuilder: To
});
xo({
  type: "array",
  names: ["matrix", "pmatrix", "bmatrix", "Bmatrix", "vmatrix", "Vmatrix", "matrix*", "pmatrix*", "bmatrix*", "Bmatrix*", "vmatrix*", "Vmatrix*"],
  props: {
    numArgs: 0
  },
  handler(r) {
    var t = {
      matrix: null,
      pmatrix: ["(", ")"],
      bmatrix: ["[", "]"],
      Bmatrix: ["\\{", "\\}"],
      vmatrix: ["|", "|"],
      Vmatrix: ["\\Vert", "\\Vert"]
    }[r.envName.replace("*", "")], a = "c", i = {
      hskipBeforeAndAfter: !1,
      cols: [{
        type: "align",
        align: a
      }]
    };
    if (r.envName.charAt(r.envName.length - 1) === "*") {
      var s = r.parser;
      if (s.consumeSpaces(), s.fetch().text === "[") {
        if (s.consume(), s.consumeSpaces(), a = s.fetch().text, "lcr".indexOf(a) === -1)
          throw new $e("Expected l or c or r", s.nextToken);
        s.consume(), s.consumeSpaces(), s.expect("]"), s.consume(), i.cols = [{
          type: "align",
          align: a
        }];
      }
    }
    var h = o0(r.parser, i, V7(r.envName)), d = Math.max(0, ...h.body.map((y) => y.length));
    return h.cols = new Array(d).fill({
      type: "align",
      align: a
    }), t ? {
      type: "leftright",
      mode: r.mode,
      body: [h],
      left: t[0],
      right: t[1],
      rightColor: void 0
      // \right uninfluenced by \color in array
    } : h;
  },
  htmlBuilder: wo,
  mathmlBuilder: To
});
xo({
  type: "array",
  names: ["smallmatrix"],
  props: {
    numArgs: 0
  },
  handler(r) {
    var t = {
      arraystretch: 0.5
    }, a = o0(r.parser, t, "script");
    return a.colSeparationType = "small", a;
  },
  htmlBuilder: wo,
  mathmlBuilder: To
});
xo({
  type: "array",
  names: ["subarray"],
  props: {
    numArgs: 1
  },
  handler(r, t) {
    var a = Wv(t[0]), i = a ? [t[0]] : Gt(t[0], "ordgroup").body, s = i.map(function(d) {
      var y = B7(d), g = y.text;
      if ("lc".indexOf(g) !== -1)
        return {
          type: "align",
          align: g
        };
      throw new $e("Unknown column alignment: " + g, d);
    });
    if (s.length > 1)
      throw new $e("{subarray} can contain only one column");
    var h = {
      cols: s,
      hskipBeforeAndAfter: !1,
      arraystretch: 0.5
    };
    if (h = o0(r.parser, h, "script"), h.body.length > 0 && h.body[0].length > 1)
      throw new $e("{subarray} can contain only one column");
    return h;
  },
  htmlBuilder: wo,
  mathmlBuilder: To
});
xo({
  type: "array",
  names: ["cases", "dcases", "rcases", "drcases"],
  props: {
    numArgs: 0
  },
  handler(r) {
    var t = {
      arraystretch: 1.2,
      cols: [{
        type: "align",
        align: "l",
        pregap: 0,
        // TODO(kevinb) get the current style.
        // For now we use the metrics for TEXT style which is what we were
        // doing before.  Before attempting to get the current style we
        // should look at TeX's behavior especially for \over and matrices.
        postgap: 1
        /* 1em quad */
      }, {
        type: "align",
        align: "l",
        pregap: 0,
        postgap: 0
      }]
    }, a = o0(r.parser, t, V7(r.envName));
    return {
      type: "leftright",
      mode: r.mode,
      body: [a],
      left: r.envName.indexOf("r") > -1 ? "." : "\\{",
      right: r.envName.indexOf("r") > -1 ? "\\}" : ".",
      rightColor: void 0
    };
  },
  htmlBuilder: wo,
  mathmlBuilder: To
});
xo({
  type: "array",
  names: ["align", "align*", "aligned", "split"],
  props: {
    numArgs: 0
  },
  handler: Xw,
  htmlBuilder: wo,
  mathmlBuilder: To
});
xo({
  type: "array",
  names: ["gathered", "gather", "gather*"],
  props: {
    numArgs: 0
  },
  handler(r) {
    dt.contains(["gather", "gather*"], r.envName) && n3(r);
    var t = {
      cols: [{
        type: "align",
        align: "c"
      }],
      addJot: !0,
      colSeparationType: "gather",
      autoTag: G7(r.envName),
      emptySingleRow: !0,
      leqno: r.parser.settings.leqno
    };
    return o0(r.parser, t, "display");
  },
  htmlBuilder: wo,
  mathmlBuilder: To
});
xo({
  type: "array",
  names: ["alignat", "alignat*", "alignedat"],
  props: {
    numArgs: 1
  },
  handler: Xw,
  htmlBuilder: wo,
  mathmlBuilder: To
});
xo({
  type: "array",
  names: ["equation", "equation*"],
  props: {
    numArgs: 0
  },
  handler(r) {
    n3(r);
    var t = {
      autoTag: G7(r.envName),
      emptySingleRow: !0,
      singleRow: !0,
      maxNumCols: 1,
      leqno: r.parser.settings.leqno
    };
    return o0(r.parser, t, "display");
  },
  htmlBuilder: wo,
  mathmlBuilder: To
});
xo({
  type: "array",
  names: ["CD"],
  props: {
    numArgs: 0
  },
  handler(r) {
    return n3(r), rB(r.parser);
  },
  htmlBuilder: wo,
  mathmlBuilder: To
});
U("\\nonumber", "\\gdef\\@eqnsw{0}");
U("\\notag", "\\nonumber");
Ke({
  type: "text",
  // Doesn't matter what this is.
  names: ["\\hline", "\\hdashline"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !0
  },
  handler(r, t) {
    throw new $e(r.funcName + " valid only within array environment");
  }
});
var F9 = Iw;
Ke({
  type: "environment",
  names: ["\\begin", "\\end"],
  props: {
    numArgs: 1,
    argTypes: ["text"]
  },
  handler(r, t) {
    var {
      parser: a,
      funcName: i
    } = r, s = t[0];
    if (s.type !== "ordgroup")
      throw new $e("Invalid environment name", s);
    for (var h = "", d = 0; d < s.body.length; ++d)
      h += Gt(s.body[d], "textord").text;
    if (i === "\\begin") {
      if (!F9.hasOwnProperty(h))
        throw new $e("No such environment: " + h, s);
      var y = F9[h], {
        args: g,
        optArgs: b
      } = a.parseArguments("\\begin{" + h + "}", y), x = {
        mode: a.mode,
        envName: h,
        parser: a
      }, T = y.handler(x, g, b);
      a.expect("\\end", !1);
      var R = a.nextToken, E = Gt(a.parseFunction(), "environment");
      if (E.name !== h)
        throw new $e("Mismatch: \\begin{" + h + "} matched by \\end{" + E.name + "}", R);
      return T;
    }
    return {
      type: "environment",
      mode: a.mode,
      name: h,
      nameGroup: s
    };
  }
});
var Qw = (r, t) => {
  var a = r.font, i = t.withFont(a);
  return on(r.body, i);
}, Zw = (r, t) => {
  var a = r.font, i = t.withFont(a);
  return _n(r.body, i);
}, P9 = {
  "\\Bbb": "\\mathbb",
  "\\bold": "\\mathbf",
  "\\frak": "\\mathfrak",
  "\\bm": "\\boldsymbol"
};
Ke({
  type: "font",
  names: [
    // styles, except \boldsymbol defined below
    "\\mathrm",
    "\\mathit",
    "\\mathbf",
    "\\mathnormal",
    "\\mathsfit",
    // families
    "\\mathbb",
    "\\mathcal",
    "\\mathfrak",
    "\\mathscr",
    "\\mathsf",
    "\\mathtt",
    // aliases, except \bm defined below
    "\\Bbb",
    "\\bold",
    "\\frak"
  ],
  props: {
    numArgs: 1,
    allowedInArgument: !0
  },
  handler: (r, t) => {
    var {
      parser: a,
      funcName: i
    } = r, s = Uv(t[0]), h = i;
    return h in P9 && (h = P9[h]), {
      type: "font",
      mode: a.mode,
      font: h.slice(1),
      body: s
    };
  },
  htmlBuilder: Qw,
  mathmlBuilder: Zw
});
Ke({
  type: "mclass",
  names: ["\\boldsymbol", "\\bm"],
  props: {
    numArgs: 1
  },
  handler: (r, t) => {
    var {
      parser: a
    } = r, i = t[0], s = dt.isCharacterBox(i);
    return {
      type: "mclass",
      mode: a.mode,
      mclass: e3(i),
      body: [{
        type: "font",
        mode: a.mode,
        font: "boldsymbol",
        body: i
      }],
      isCharacterBox: s
    };
  }
});
Ke({
  type: "font",
  names: ["\\rm", "\\sf", "\\tt", "\\bf", "\\it", "\\cal"],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler: (r, t) => {
    var {
      parser: a,
      funcName: i,
      breakOnTokenText: s
    } = r, {
      mode: h
    } = a, d = a.parseExpression(!0, s), y = "math" + i.slice(1);
    return {
      type: "font",
      mode: h,
      font: y,
      body: {
        type: "ordgroup",
        mode: a.mode,
        body: d
      }
    };
  },
  htmlBuilder: Qw,
  mathmlBuilder: Zw
});
var Fw = (r, t) => {
  var a = t;
  return r === "display" ? a = a.id >= yt.SCRIPT.id ? a.text() : yt.DISPLAY : r === "text" && a.size === yt.DISPLAY.size ? a = yt.TEXT : r === "script" ? a = yt.SCRIPT : r === "scriptscript" && (a = yt.SCRIPTSCRIPT), a;
}, Y7 = (r, t) => {
  var a = Fw(r.size, t.style), i = a.fracNum(), s = a.fracDen(), h;
  h = t.havingStyle(i);
  var d = on(r.numer, h, t);
  if (r.continued) {
    var y = 8.5 / t.fontMetrics().ptPerEm, g = 3.5 / t.fontMetrics().ptPerEm;
    d.height = d.height < y ? y : d.height, d.depth = d.depth < g ? g : d.depth;
  }
  h = t.havingStyle(s);
  var b = on(r.denom, h, t), x, T, R;
  r.hasBarLine ? (r.barSize ? (T = Wn(r.barSize, t), x = ge.makeLineSpan("frac-line", t, T)) : x = ge.makeLineSpan("frac-line", t), T = x.height, R = x.height) : (x = null, T = 0, R = t.fontMetrics().defaultRuleThickness);
  var E, O, L;
  a.size === yt.DISPLAY.size || r.size === "display" ? (E = t.fontMetrics().num1, T > 0 ? O = 3 * R : O = 7 * R, L = t.fontMetrics().denom1) : (T > 0 ? (E = t.fontMetrics().num2, O = R) : (E = t.fontMetrics().num3, O = 3 * R), L = t.fontMetrics().denom2);
  var G;
  if (x) {
    var I = t.fontMetrics().axisHeight;
    E - d.depth - (I + 0.5 * T) < O && (E += O - (E - d.depth - (I + 0.5 * T))), I - 0.5 * T - (b.height - L) < O && (L += O - (I - 0.5 * T - (b.height - L)));
    var $ = -(I - 0.5 * T);
    G = ge.makeVList({
      positionType: "individualShift",
      children: [{
        type: "elem",
        elem: b,
        shift: L
      }, {
        type: "elem",
        elem: x,
        shift: $
      }, {
        type: "elem",
        elem: d,
        shift: -E
      }]
    }, t);
  } else {
    var V = E - d.depth - (b.height - L);
    V < O && (E += 0.5 * (O - V), L += 0.5 * (O - V)), G = ge.makeVList({
      positionType: "individualShift",
      children: [{
        type: "elem",
        elem: b,
        shift: L
      }, {
        type: "elem",
        elem: d,
        shift: -E
      }]
    }, t);
  }
  h = t.havingStyle(a), G.height *= h.sizeMultiplier / t.sizeMultiplier, G.depth *= h.sizeMultiplier / t.sizeMultiplier;
  var ce;
  a.size === yt.DISPLAY.size ? ce = t.fontMetrics().delim1 : a.size === yt.SCRIPTSCRIPT.size ? ce = t.havingStyle(yt.SCRIPT).fontMetrics().delim2 : ce = t.fontMetrics().delim2;
  var se, te;
  return r.leftDelim == null ? se = Kg(t, ["mopen"]) : se = Es.customSizedDelim(r.leftDelim, ce, !0, t.havingStyle(a), r.mode, ["mopen"]), r.continued ? te = ge.makeSpan([]) : r.rightDelim == null ? te = Kg(t, ["mclose"]) : te = Es.customSizedDelim(r.rightDelim, ce, !0, t.havingStyle(a), r.mode, ["mclose"]), ge.makeSpan(["mord"].concat(h.sizingClasses(t)), [se, ge.makeSpan(["mfrac"], [G]), te], t);
}, I7 = (r, t) => {
  var a = new Ve.MathNode("mfrac", [_n(r.numer, t), _n(r.denom, t)]);
  if (!r.hasBarLine)
    a.setAttribute("linethickness", "0px");
  else if (r.barSize) {
    var i = Wn(r.barSize, t);
    a.setAttribute("linethickness", Fe(i));
  }
  var s = Fw(r.size, t.style);
  if (s.size !== t.style.size) {
    a = new Ve.MathNode("mstyle", [a]);
    var h = s.size === yt.DISPLAY.size ? "true" : "false";
    a.setAttribute("displaystyle", h), a.setAttribute("scriptlevel", "0");
  }
  if (r.leftDelim != null || r.rightDelim != null) {
    var d = [];
    if (r.leftDelim != null) {
      var y = new Ve.MathNode("mo", [new Ve.TextNode(r.leftDelim.replace("\\", ""))]);
      y.setAttribute("fence", "true"), d.push(y);
    }
    if (d.push(a), r.rightDelim != null) {
      var g = new Ve.MathNode("mo", [new Ve.TextNode(r.rightDelim.replace("\\", ""))]);
      g.setAttribute("fence", "true"), d.push(g);
    }
    return N7(d);
  }
  return a;
};
Ke({
  type: "genfrac",
  names: [
    "\\dfrac",
    "\\frac",
    "\\tfrac",
    "\\dbinom",
    "\\binom",
    "\\tbinom",
    "\\\\atopfrac",
    // can’t be entered directly
    "\\\\bracefrac",
    "\\\\brackfrac"
    // ditto
  ],
  props: {
    numArgs: 2,
    allowedInArgument: !0
  },
  handler: (r, t) => {
    var {
      parser: a,
      funcName: i
    } = r, s = t[0], h = t[1], d, y = null, g = null, b = "auto";
    switch (i) {
      case "\\dfrac":
      case "\\frac":
      case "\\tfrac":
        d = !0;
        break;
      case "\\\\atopfrac":
        d = !1;
        break;
      case "\\dbinom":
      case "\\binom":
      case "\\tbinom":
        d = !1, y = "(", g = ")";
        break;
      case "\\\\bracefrac":
        d = !1, y = "\\{", g = "\\}";
        break;
      case "\\\\brackfrac":
        d = !1, y = "[", g = "]";
        break;
      default:
        throw new Error("Unrecognized genfrac command");
    }
    switch (i) {
      case "\\dfrac":
      case "\\dbinom":
        b = "display";
        break;
      case "\\tfrac":
      case "\\tbinom":
        b = "text";
        break;
    }
    return {
      type: "genfrac",
      mode: a.mode,
      continued: !1,
      numer: s,
      denom: h,
      hasBarLine: d,
      leftDelim: y,
      rightDelim: g,
      size: b,
      barSize: null
    };
  },
  htmlBuilder: Y7,
  mathmlBuilder: I7
});
Ke({
  type: "genfrac",
  names: ["\\cfrac"],
  props: {
    numArgs: 2
  },
  handler: (r, t) => {
    var {
      parser: a,
      funcName: i
    } = r, s = t[0], h = t[1];
    return {
      type: "genfrac",
      mode: a.mode,
      continued: !0,
      numer: s,
      denom: h,
      hasBarLine: !0,
      leftDelim: null,
      rightDelim: null,
      size: "display",
      barSize: null
    };
  }
});
Ke({
  type: "infix",
  names: ["\\over", "\\choose", "\\atop", "\\brace", "\\brack"],
  props: {
    numArgs: 0,
    infix: !0
  },
  handler(r) {
    var {
      parser: t,
      funcName: a,
      token: i
    } = r, s;
    switch (a) {
      case "\\over":
        s = "\\frac";
        break;
      case "\\choose":
        s = "\\binom";
        break;
      case "\\atop":
        s = "\\\\atopfrac";
        break;
      case "\\brace":
        s = "\\\\bracefrac";
        break;
      case "\\brack":
        s = "\\\\brackfrac";
        break;
      default:
        throw new Error("Unrecognized infix genfrac command");
    }
    return {
      type: "infix",
      mode: t.mode,
      replaceWith: s,
      token: i
    };
  }
});
var K9 = ["display", "text", "script", "scriptscript"], J9 = function(t) {
  var a = null;
  return t.length > 0 && (a = t, a = a === "." ? null : a), a;
};
Ke({
  type: "genfrac",
  names: ["\\genfrac"],
  props: {
    numArgs: 6,
    allowedInArgument: !0,
    argTypes: ["math", "math", "size", "text", "math", "math"]
  },
  handler(r, t) {
    var {
      parser: a
    } = r, i = t[4], s = t[5], h = Uv(t[0]), d = h.type === "atom" && h.family === "open" ? J9(h.text) : null, y = Uv(t[1]), g = y.type === "atom" && y.family === "close" ? J9(y.text) : null, b = Gt(t[2], "size"), x, T = null;
    b.isBlank ? x = !0 : (T = b.value, x = T.number > 0);
    var R = "auto", E = t[3];
    if (E.type === "ordgroup") {
      if (E.body.length > 0) {
        var O = Gt(E.body[0], "textord");
        R = K9[Number(O.text)];
      }
    } else
      E = Gt(E, "textord"), R = K9[Number(E.text)];
    return {
      type: "genfrac",
      mode: a.mode,
      numer: i,
      denom: s,
      continued: !1,
      hasBarLine: x,
      barSize: T,
      leftDelim: d,
      rightDelim: g,
      size: R
    };
  },
  htmlBuilder: Y7,
  mathmlBuilder: I7
});
Ke({
  type: "infix",
  names: ["\\above"],
  props: {
    numArgs: 1,
    argTypes: ["size"],
    infix: !0
  },
  handler(r, t) {
    var {
      parser: a,
      funcName: i,
      token: s
    } = r;
    return {
      type: "infix",
      mode: a.mode,
      replaceWith: "\\\\abovefrac",
      size: Gt(t[0], "size").value,
      token: s
    };
  }
});
Ke({
  type: "genfrac",
  names: ["\\\\abovefrac"],
  props: {
    numArgs: 3,
    argTypes: ["math", "size", "math"]
  },
  handler: (r, t) => {
    var {
      parser: a,
      funcName: i
    } = r, s = t[0], h = QN(Gt(t[1], "infix").size), d = t[2], y = h.number > 0;
    return {
      type: "genfrac",
      mode: a.mode,
      numer: s,
      denom: d,
      continued: !1,
      hasBarLine: y,
      barSize: h,
      leftDelim: null,
      rightDelim: null,
      size: "auto"
    };
  },
  htmlBuilder: Y7,
  mathmlBuilder: I7
});
var Pw = (r, t) => {
  var a = t.style, i, s;
  r.type === "supsub" ? (i = r.sup ? on(r.sup, t.havingStyle(a.sup()), t) : on(r.sub, t.havingStyle(a.sub()), t), s = Gt(r.base, "horizBrace")) : s = Gt(r, "horizBrace");
  var h = on(s.base, t.havingBaseStyle(yt.DISPLAY)), d = Rs.svgSpan(s, t), y;
  if (s.isOver ? (y = ge.makeVList({
    positionType: "firstBaseline",
    children: [{
      type: "elem",
      elem: h
    }, {
      type: "kern",
      size: 0.1
    }, {
      type: "elem",
      elem: d
    }]
  }, t), y.children[0].children[0].children[1].classes.push("svg-align")) : (y = ge.makeVList({
    positionType: "bottom",
    positionData: h.depth + 0.1 + d.height,
    children: [{
      type: "elem",
      elem: d
    }, {
      type: "kern",
      size: 0.1
    }, {
      type: "elem",
      elem: h
    }]
  }, t), y.children[0].children[0].children[0].classes.push("svg-align")), i) {
    var g = ge.makeSpan(["mord", s.isOver ? "mover" : "munder"], [y], t);
    s.isOver ? y = ge.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: g
      }, {
        type: "kern",
        size: 0.2
      }, {
        type: "elem",
        elem: i
      }]
    }, t) : y = ge.makeVList({
      positionType: "bottom",
      positionData: g.depth + 0.2 + i.height + i.depth,
      children: [{
        type: "elem",
        elem: i
      }, {
        type: "kern",
        size: 0.2
      }, {
        type: "elem",
        elem: g
      }]
    }, t);
  }
  return ge.makeSpan(["mord", s.isOver ? "mover" : "munder"], [y], t);
}, vB = (r, t) => {
  var a = Rs.mathMLnode(r.label);
  return new Ve.MathNode(r.isOver ? "mover" : "munder", [_n(r.base, t), a]);
};
Ke({
  type: "horizBrace",
  names: ["\\overbrace", "\\underbrace"],
  props: {
    numArgs: 1
  },
  handler(r, t) {
    var {
      parser: a,
      funcName: i
    } = r;
    return {
      type: "horizBrace",
      mode: a.mode,
      label: i,
      isOver: /^\\over/.test(i),
      base: t[0]
    };
  },
  htmlBuilder: Pw,
  mathmlBuilder: vB
});
Ke({
  type: "href",
  names: ["\\href"],
  props: {
    numArgs: 2,
    argTypes: ["url", "original"],
    allowedInText: !0
  },
  handler: (r, t) => {
    var {
      parser: a
    } = r, i = t[1], s = Gt(t[0], "url").url;
    return a.settings.isTrusted({
      command: "\\href",
      url: s
    }) ? {
      type: "href",
      mode: a.mode,
      href: s,
      body: Sr(i)
    } : a.formatUnsupportedCmd("\\href");
  },
  htmlBuilder: (r, t) => {
    var a = Qr(r.body, t, !1);
    return ge.makeAnchor(r.href, [], a, t);
  },
  mathmlBuilder: (r, t) => {
    var a = i0(r.body, t);
    return a instanceof ti || (a = new ti("mrow", [a])), a.setAttribute("href", r.href), a;
  }
});
Ke({
  type: "href",
  names: ["\\url"],
  props: {
    numArgs: 1,
    argTypes: ["url"],
    allowedInText: !0
  },
  handler: (r, t) => {
    var {
      parser: a
    } = r, i = Gt(t[0], "url").url;
    if (!a.settings.isTrusted({
      command: "\\url",
      url: i
    }))
      return a.formatUnsupportedCmd("\\url");
    for (var s = [], h = 0; h < i.length; h++) {
      var d = i[h];
      d === "~" && (d = "\\textasciitilde"), s.push({
        type: "textord",
        mode: "text",
        text: d
      });
    }
    var y = {
      type: "text",
      mode: a.mode,
      font: "\\texttt",
      body: s
    };
    return {
      type: "href",
      mode: a.mode,
      href: i,
      body: Sr(y)
    };
  }
});
Ke({
  type: "hbox",
  names: ["\\hbox"],
  props: {
    numArgs: 1,
    argTypes: ["text"],
    allowedInText: !0,
    primitive: !0
  },
  handler(r, t) {
    var {
      parser: a
    } = r;
    return {
      type: "hbox",
      mode: a.mode,
      body: Sr(t[0])
    };
  },
  htmlBuilder(r, t) {
    var a = Qr(r.body, t, !1);
    return ge.makeFragment(a);
  },
  mathmlBuilder(r, t) {
    return new Ve.MathNode("mrow", Tl(r.body, t));
  }
});
Ke({
  type: "html",
  names: ["\\htmlClass", "\\htmlId", "\\htmlStyle", "\\htmlData"],
  props: {
    numArgs: 2,
    argTypes: ["raw", "original"],
    allowedInText: !0
  },
  handler: (r, t) => {
    var {
      parser: a,
      funcName: i,
      token: s
    } = r, h = Gt(t[0], "raw").string, d = t[1];
    a.settings.strict && a.settings.reportNonstrict("htmlExtension", "HTML extension is disabled on strict mode");
    var y, g = {};
    switch (i) {
      case "\\htmlClass":
        g.class = h, y = {
          command: "\\htmlClass",
          class: h
        };
        break;
      case "\\htmlId":
        g.id = h, y = {
          command: "\\htmlId",
          id: h
        };
        break;
      case "\\htmlStyle":
        g.style = h, y = {
          command: "\\htmlStyle",
          style: h
        };
        break;
      case "\\htmlData": {
        for (var b = h.split(","), x = 0; x < b.length; x++) {
          var T = b[x].split("=");
          if (T.length !== 2)
            throw new $e("Error parsing key-value for \\htmlData");
          g["data-" + T[0].trim()] = T[1].trim();
        }
        y = {
          command: "\\htmlData",
          attributes: g
        };
        break;
      }
      default:
        throw new Error("Unrecognized html command");
    }
    return a.settings.isTrusted(y) ? {
      type: "html",
      mode: a.mode,
      attributes: g,
      body: Sr(d)
    } : a.formatUnsupportedCmd(i);
  },
  htmlBuilder: (r, t) => {
    var a = Qr(r.body, t, !1), i = ["enclosing"];
    r.attributes.class && i.push(...r.attributes.class.trim().split(/\s+/));
    var s = ge.makeSpan(i, a, t);
    for (var h in r.attributes)
      h !== "class" && r.attributes.hasOwnProperty(h) && s.setAttribute(h, r.attributes[h]);
    return s;
  },
  mathmlBuilder: (r, t) => i0(r.body, t)
});
Ke({
  type: "htmlmathml",
  names: ["\\html@mathml"],
  props: {
    numArgs: 2,
    allowedInText: !0
  },
  handler: (r, t) => {
    var {
      parser: a
    } = r;
    return {
      type: "htmlmathml",
      mode: a.mode,
      html: Sr(t[0]),
      mathml: Sr(t[1])
    };
  },
  htmlBuilder: (r, t) => {
    var a = Qr(r.html, t, !1);
    return ge.makeFragment(a);
  },
  mathmlBuilder: (r, t) => i0(r.mathml, t)
});
var s5 = function(t) {
  if (/^[-+]? *(\d+(\.\d*)?|\.\d+)$/.test(t))
    return {
      number: +t,
      unit: "bp"
    };
  var a = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(t);
  if (!a)
    throw new $e("Invalid size: '" + t + "' in \\includegraphics");
  var i = {
    number: +(a[1] + a[2]),
    // sign + magnitude, cast to number
    unit: a[3]
  };
  if (!pw(i))
    throw new $e("Invalid unit: '" + i.unit + "' in \\includegraphics.");
  return i;
};
Ke({
  type: "includegraphics",
  names: ["\\includegraphics"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1,
    argTypes: ["raw", "url"],
    allowedInText: !1
  },
  handler: (r, t, a) => {
    var {
      parser: i
    } = r, s = {
      number: 0,
      unit: "em"
    }, h = {
      number: 0.9,
      unit: "em"
    }, d = {
      number: 0,
      unit: "em"
    }, y = "";
    if (a[0])
      for (var g = Gt(a[0], "raw").string, b = g.split(","), x = 0; x < b.length; x++) {
        var T = b[x].split("=");
        if (T.length === 2) {
          var R = T[1].trim();
          switch (T[0].trim()) {
            case "alt":
              y = R;
              break;
            case "width":
              s = s5(R);
              break;
            case "height":
              h = s5(R);
              break;
            case "totalheight":
              d = s5(R);
              break;
            default:
              throw new $e("Invalid key: '" + T[0] + "' in \\includegraphics.");
          }
        }
      }
    var E = Gt(t[0], "url").url;
    return y === "" && (y = E, y = y.replace(/^.*[\\/]/, ""), y = y.substring(0, y.lastIndexOf("."))), i.settings.isTrusted({
      command: "\\includegraphics",
      url: E
    }) ? {
      type: "includegraphics",
      mode: i.mode,
      alt: y,
      width: s,
      height: h,
      totalheight: d,
      src: E
    } : i.formatUnsupportedCmd("\\includegraphics");
  },
  htmlBuilder: (r, t) => {
    var a = Wn(r.height, t), i = 0;
    r.totalheight.number > 0 && (i = Wn(r.totalheight, t) - a);
    var s = 0;
    r.width.number > 0 && (s = Wn(r.width, t));
    var h = {
      height: Fe(a + i)
    };
    s > 0 && (h.width = Fe(s)), i > 0 && (h.verticalAlign = Fe(-i));
    var d = new vL(r.src, r.alt, h);
    return d.height = a, d.depth = i, d;
  },
  mathmlBuilder: (r, t) => {
    var a = new Ve.MathNode("mglyph", []);
    a.setAttribute("alt", r.alt);
    var i = Wn(r.height, t), s = 0;
    if (r.totalheight.number > 0 && (s = Wn(r.totalheight, t) - i, a.setAttribute("valign", Fe(-s))), a.setAttribute("height", Fe(i + s)), r.width.number > 0) {
      var h = Wn(r.width, t);
      a.setAttribute("width", Fe(h));
    }
    return a.setAttribute("src", r.src), a;
  }
});
Ke({
  type: "kern",
  names: ["\\kern", "\\mkern", "\\hskip", "\\mskip"],
  props: {
    numArgs: 1,
    argTypes: ["size"],
    primitive: !0,
    allowedInText: !0
  },
  handler(r, t) {
    var {
      parser: a,
      funcName: i
    } = r, s = Gt(t[0], "size");
    if (a.settings.strict) {
      var h = i[1] === "m", d = s.value.unit === "mu";
      h ? (d || a.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + i + " supports only mu units, " + ("not " + s.value.unit + " units")), a.mode !== "math" && a.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + i + " works only in math mode")) : d && a.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + i + " doesn't support mu units");
    }
    return {
      type: "kern",
      mode: a.mode,
      dimension: s.value
    };
  },
  htmlBuilder(r, t) {
    return ge.makeGlue(r.dimension, t);
  },
  mathmlBuilder(r, t) {
    var a = Wn(r.dimension, t);
    return new Ve.SpaceNode(a);
  }
});
Ke({
  type: "lap",
  names: ["\\mathllap", "\\mathrlap", "\\mathclap"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (r, t) => {
    var {
      parser: a,
      funcName: i
    } = r, s = t[0];
    return {
      type: "lap",
      mode: a.mode,
      alignment: i.slice(5),
      body: s
    };
  },
  htmlBuilder: (r, t) => {
    var a;
    r.alignment === "clap" ? (a = ge.makeSpan([], [on(r.body, t)]), a = ge.makeSpan(["inner"], [a], t)) : a = ge.makeSpan(["inner"], [on(r.body, t)]);
    var i = ge.makeSpan(["fix"], []), s = ge.makeSpan([r.alignment], [a, i], t), h = ge.makeSpan(["strut"]);
    return h.style.height = Fe(s.height + s.depth), s.depth && (h.style.verticalAlign = Fe(-s.depth)), s.children.unshift(h), s = ge.makeSpan(["thinbox"], [s], t), ge.makeSpan(["mord", "vbox"], [s], t);
  },
  mathmlBuilder: (r, t) => {
    var a = new Ve.MathNode("mpadded", [_n(r.body, t)]);
    if (r.alignment !== "rlap") {
      var i = r.alignment === "llap" ? "-1" : "-0.5";
      a.setAttribute("lspace", i + "width");
    }
    return a.setAttribute("width", "0px"), a;
  }
});
Ke({
  type: "styling",
  names: ["\\(", "$"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1
  },
  handler(r, t) {
    var {
      funcName: a,
      parser: i
    } = r, s = i.mode;
    i.switchMode("math");
    var h = a === "\\(" ? "\\)" : "$", d = i.parseExpression(!1, h);
    return i.expect(h), i.switchMode(s), {
      type: "styling",
      mode: i.mode,
      style: "text",
      body: d
    };
  }
});
Ke({
  type: "text",
  // Doesn't matter what this is.
  names: ["\\)", "\\]"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1
  },
  handler(r, t) {
    throw new $e("Mismatched " + r.funcName);
  }
});
var W9 = (r, t) => {
  switch (t.style.size) {
    case yt.DISPLAY.size:
      return r.display;
    case yt.TEXT.size:
      return r.text;
    case yt.SCRIPT.size:
      return r.script;
    case yt.SCRIPTSCRIPT.size:
      return r.scriptscript;
    default:
      return r.text;
  }
};
Ke({
  type: "mathchoice",
  names: ["\\mathchoice"],
  props: {
    numArgs: 4,
    primitive: !0
  },
  handler: (r, t) => {
    var {
      parser: a
    } = r;
    return {
      type: "mathchoice",
      mode: a.mode,
      display: Sr(t[0]),
      text: Sr(t[1]),
      script: Sr(t[2]),
      scriptscript: Sr(t[3])
    };
  },
  htmlBuilder: (r, t) => {
    var a = W9(r, t), i = Qr(a, t, !1);
    return ge.makeFragment(i);
  },
  mathmlBuilder: (r, t) => {
    var a = W9(r, t);
    return i0(a, t);
  }
});
var Kw = (r, t, a, i, s, h, d) => {
  r = ge.makeSpan([], [r]);
  var y = a && dt.isCharacterBox(a), g, b;
  if (t) {
    var x = on(t, i.havingStyle(s.sup()), i);
    b = {
      elem: x,
      kern: Math.max(i.fontMetrics().bigOpSpacing1, i.fontMetrics().bigOpSpacing3 - x.depth)
    };
  }
  if (a) {
    var T = on(a, i.havingStyle(s.sub()), i);
    g = {
      elem: T,
      kern: Math.max(i.fontMetrics().bigOpSpacing2, i.fontMetrics().bigOpSpacing4 - T.height)
    };
  }
  var R;
  if (b && g) {
    var E = i.fontMetrics().bigOpSpacing5 + g.elem.height + g.elem.depth + g.kern + r.depth + d;
    R = ge.makeVList({
      positionType: "bottom",
      positionData: E,
      children: [{
        type: "kern",
        size: i.fontMetrics().bigOpSpacing5
      }, {
        type: "elem",
        elem: g.elem,
        marginLeft: Fe(-h)
      }, {
        type: "kern",
        size: g.kern
      }, {
        type: "elem",
        elem: r
      }, {
        type: "kern",
        size: b.kern
      }, {
        type: "elem",
        elem: b.elem,
        marginLeft: Fe(h)
      }, {
        type: "kern",
        size: i.fontMetrics().bigOpSpacing5
      }]
    }, i);
  } else if (g) {
    var O = r.height - d;
    R = ge.makeVList({
      positionType: "top",
      positionData: O,
      children: [{
        type: "kern",
        size: i.fontMetrics().bigOpSpacing5
      }, {
        type: "elem",
        elem: g.elem,
        marginLeft: Fe(-h)
      }, {
        type: "kern",
        size: g.kern
      }, {
        type: "elem",
        elem: r
      }]
    }, i);
  } else if (b) {
    var L = r.depth + d;
    R = ge.makeVList({
      positionType: "bottom",
      positionData: L,
      children: [{
        type: "elem",
        elem: r
      }, {
        type: "kern",
        size: b.kern
      }, {
        type: "elem",
        elem: b.elem,
        marginLeft: Fe(h)
      }, {
        type: "kern",
        size: i.fontMetrics().bigOpSpacing5
      }]
    }, i);
  } else
    return r;
  var G = [R];
  if (g && h !== 0 && !y) {
    var V = ge.makeSpan(["mspace"], [], i);
    V.style.marginRight = Fe(h), G.unshift(V);
  }
  return ge.makeSpan(["mop", "op-limits"], G, i);
}, Jw = ["\\smallint"], Nm = (r, t) => {
  var a, i, s = !1, h;
  r.type === "supsub" ? (a = r.sup, i = r.sub, h = Gt(r.base, "op"), s = !0) : h = Gt(r, "op");
  var d = t.style, y = !1;
  d.size === yt.DISPLAY.size && h.symbol && !dt.contains(Jw, h.name) && (y = !0);
  var g;
  if (h.symbol) {
    var b = y ? "Size2-Regular" : "Size1-Regular", x = "";
    if ((h.name === "\\oiint" || h.name === "\\oiiint") && (x = h.name.slice(1), h.name = x === "oiint" ? "\\iint" : "\\iiint"), g = ge.makeSymbol(h.name, b, "math", t, ["mop", "op-symbol", y ? "large-op" : "small-op"]), x.length > 0) {
      var T = g.italic, R = ge.staticSvg(x + "Size" + (y ? "2" : "1"), t);
      g = ge.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: g,
          shift: 0
        }, {
          type: "elem",
          elem: R,
          shift: y ? 0.08 : 0
        }]
      }, t), h.name = "\\" + x, g.classes.unshift("mop"), g.italic = T;
    }
  } else if (h.body) {
    var E = Qr(h.body, t, !0);
    E.length === 1 && E[0] instanceof qi ? (g = E[0], g.classes[0] = "mop") : g = ge.makeSpan(["mop"], E, t);
  } else {
    for (var O = [], L = 1; L < h.name.length; L++)
      O.push(ge.mathsym(h.name[L], h.mode, t));
    g = ge.makeSpan(["mop"], O, t);
  }
  var G = 0, V = 0;
  return (g instanceof qi || h.name === "\\oiint" || h.name === "\\oiiint") && !h.suppressBaseShift && (G = (g.height - g.depth) / 2 - t.fontMetrics().axisHeight, V = g.italic), s ? Kw(g, a, i, t, d, V, G) : (G && (g.style.position = "relative", g.style.top = Fe(G)), g);
}, u4 = (r, t) => {
  var a;
  if (r.symbol)
    a = new ti("mo", [ji(r.name, r.mode)]), dt.contains(Jw, r.name) && a.setAttribute("largeop", "false");
  else if (r.body)
    a = new ti("mo", Tl(r.body, t));
  else {
    a = new ti("mi", [new bo(r.name.slice(1))]);
    var i = new ti("mo", [ji("⁡", "text")]);
    r.parentIsSupSub ? a = new ti("mrow", [a, i]) : a = kw([a, i]);
  }
  return a;
}, bB = {
  "∏": "\\prod",
  "∐": "\\coprod",
  "∑": "\\sum",
  "⋀": "\\bigwedge",
  "⋁": "\\bigvee",
  "⋂": "\\bigcap",
  "⋃": "\\bigcup",
  "⨀": "\\bigodot",
  "⨁": "\\bigoplus",
  "⨂": "\\bigotimes",
  "⨄": "\\biguplus",
  "⨆": "\\bigsqcup"
};
Ke({
  type: "op",
  names: ["\\coprod", "\\bigvee", "\\bigwedge", "\\biguplus", "\\bigcap", "\\bigcup", "\\intop", "\\prod", "\\sum", "\\bigotimes", "\\bigoplus", "\\bigodot", "\\bigsqcup", "\\smallint", "∏", "∐", "∑", "⋀", "⋁", "⋂", "⋃", "⨀", "⨁", "⨂", "⨄", "⨆"],
  props: {
    numArgs: 0
  },
  handler: (r, t) => {
    var {
      parser: a,
      funcName: i
    } = r, s = i;
    return s.length === 1 && (s = bB[s]), {
      type: "op",
      mode: a.mode,
      limits: !0,
      parentIsSupSub: !1,
      symbol: !0,
      name: s
    };
  },
  htmlBuilder: Nm,
  mathmlBuilder: u4
});
Ke({
  type: "op",
  names: ["\\mathop"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (r, t) => {
    var {
      parser: a
    } = r, i = t[0];
    return {
      type: "op",
      mode: a.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !1,
      body: Sr(i)
    };
  },
  htmlBuilder: Nm,
  mathmlBuilder: u4
});
var SB = {
  "∫": "\\int",
  "∬": "\\iint",
  "∭": "\\iiint",
  "∮": "\\oint",
  "∯": "\\oiint",
  "∰": "\\oiiint"
};
Ke({
  type: "op",
  names: ["\\arcsin", "\\arccos", "\\arctan", "\\arctg", "\\arcctg", "\\arg", "\\ch", "\\cos", "\\cosec", "\\cosh", "\\cot", "\\cotg", "\\coth", "\\csc", "\\ctg", "\\cth", "\\deg", "\\dim", "\\exp", "\\hom", "\\ker", "\\lg", "\\ln", "\\log", "\\sec", "\\sin", "\\sinh", "\\sh", "\\tan", "\\tanh", "\\tg", "\\th"],
  props: {
    numArgs: 0
  },
  handler(r) {
    var {
      parser: t,
      funcName: a
    } = r;
    return {
      type: "op",
      mode: t.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !1,
      name: a
    };
  },
  htmlBuilder: Nm,
  mathmlBuilder: u4
});
Ke({
  type: "op",
  names: ["\\det", "\\gcd", "\\inf", "\\lim", "\\max", "\\min", "\\Pr", "\\sup"],
  props: {
    numArgs: 0
  },
  handler(r) {
    var {
      parser: t,
      funcName: a
    } = r;
    return {
      type: "op",
      mode: t.mode,
      limits: !0,
      parentIsSupSub: !1,
      symbol: !1,
      name: a
    };
  },
  htmlBuilder: Nm,
  mathmlBuilder: u4
});
Ke({
  type: "op",
  names: ["\\int", "\\iint", "\\iiint", "\\oint", "\\oiint", "\\oiiint", "∫", "∬", "∭", "∮", "∯", "∰"],
  props: {
    numArgs: 0
  },
  handler(r) {
    var {
      parser: t,
      funcName: a
    } = r, i = a;
    return i.length === 1 && (i = SB[i]), {
      type: "op",
      mode: t.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !0,
      name: i
    };
  },
  htmlBuilder: Nm,
  mathmlBuilder: u4
});
var Ww = (r, t) => {
  var a, i, s = !1, h;
  r.type === "supsub" ? (a = r.sup, i = r.sub, h = Gt(r.base, "operatorname"), s = !0) : h = Gt(r, "operatorname");
  var d;
  if (h.body.length > 0) {
    for (var y = h.body.map((T) => {
      var R = T.text;
      return typeof R == "string" ? {
        type: "textord",
        mode: T.mode,
        text: R
      } : T;
    }), g = Qr(y, t.withFont("mathrm"), !0), b = 0; b < g.length; b++) {
      var x = g[b];
      x instanceof qi && (x.text = x.text.replace(/\u2212/, "-").replace(/\u2217/, "*"));
    }
    d = ge.makeSpan(["mop"], g, t);
  } else
    d = ge.makeSpan(["mop"], [], t);
  return s ? Kw(d, a, i, t, t.style, 0, 0) : d;
}, xB = (r, t) => {
  for (var a = Tl(r.body, t.withFont("mathrm")), i = !0, s = 0; s < a.length; s++) {
    var h = a[s];
    if (!(h instanceof Ve.SpaceNode)) if (h instanceof Ve.MathNode)
      switch (h.type) {
        case "mi":
        case "mn":
        case "ms":
        case "mspace":
        case "mtext":
          break;
        case "mo": {
          var d = h.children[0];
          h.children.length === 1 && d instanceof Ve.TextNode ? d.text = d.text.replace(/\u2212/, "-").replace(/\u2217/, "*") : i = !1;
          break;
        }
        default:
          i = !1;
      }
    else
      i = !1;
  }
  if (i) {
    var y = a.map((x) => x.toText()).join("");
    a = [new Ve.TextNode(y)];
  }
  var g = new Ve.MathNode("mi", a);
  g.setAttribute("mathvariant", "normal");
  var b = new Ve.MathNode("mo", [ji("⁡", "text")]);
  return r.parentIsSupSub ? new Ve.MathNode("mrow", [g, b]) : Ve.newDocumentFragment([g, b]);
};
Ke({
  type: "operatorname",
  names: ["\\operatorname@", "\\operatornamewithlimits"],
  props: {
    numArgs: 1
  },
  handler: (r, t) => {
    var {
      parser: a,
      funcName: i
    } = r, s = t[0];
    return {
      type: "operatorname",
      mode: a.mode,
      body: Sr(s),
      alwaysHandleSupSub: i === "\\operatornamewithlimits",
      limits: !1,
      parentIsSupSub: !1
    };
  },
  htmlBuilder: Ww,
  mathmlBuilder: xB
});
U("\\operatorname", "\\@ifstar\\operatornamewithlimits\\operatorname@");
rh({
  type: "ordgroup",
  htmlBuilder(r, t) {
    return r.semisimple ? ge.makeFragment(Qr(r.body, t, !1)) : ge.makeSpan(["mord"], Qr(r.body, t, !0), t);
  },
  mathmlBuilder(r, t) {
    return i0(r.body, t, !0);
  }
});
Ke({
  type: "overline",
  names: ["\\overline"],
  props: {
    numArgs: 1
  },
  handler(r, t) {
    var {
      parser: a
    } = r, i = t[0];
    return {
      type: "overline",
      mode: a.mode,
      body: i
    };
  },
  htmlBuilder(r, t) {
    var a = on(r.body, t.havingCrampedStyle()), i = ge.makeLineSpan("overline-line", t), s = t.fontMetrics().defaultRuleThickness, h = ge.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: a
      }, {
        type: "kern",
        size: 3 * s
      }, {
        type: "elem",
        elem: i
      }, {
        type: "kern",
        size: s
      }]
    }, t);
    return ge.makeSpan(["mord", "overline"], [h], t);
  },
  mathmlBuilder(r, t) {
    var a = new Ve.MathNode("mo", [new Ve.TextNode("‾")]);
    a.setAttribute("stretchy", "true");
    var i = new Ve.MathNode("mover", [_n(r.body, t), a]);
    return i.setAttribute("accent", "true"), i;
  }
});
Ke({
  type: "phantom",
  names: ["\\phantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (r, t) => {
    var {
      parser: a
    } = r, i = t[0];
    return {
      type: "phantom",
      mode: a.mode,
      body: Sr(i)
    };
  },
  htmlBuilder: (r, t) => {
    var a = Qr(r.body, t.withPhantom(), !1);
    return ge.makeFragment(a);
  },
  mathmlBuilder: (r, t) => {
    var a = Tl(r.body, t);
    return new Ve.MathNode("mphantom", a);
  }
});
Ke({
  type: "hphantom",
  names: ["\\hphantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (r, t) => {
    var {
      parser: a
    } = r, i = t[0];
    return {
      type: "hphantom",
      mode: a.mode,
      body: i
    };
  },
  htmlBuilder: (r, t) => {
    var a = ge.makeSpan([], [on(r.body, t.withPhantom())]);
    if (a.height = 0, a.depth = 0, a.children)
      for (var i = 0; i < a.children.length; i++)
        a.children[i].height = 0, a.children[i].depth = 0;
    return a = ge.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: a
      }]
    }, t), ge.makeSpan(["mord"], [a], t);
  },
  mathmlBuilder: (r, t) => {
    var a = Tl(Sr(r.body), t), i = new Ve.MathNode("mphantom", a), s = new Ve.MathNode("mpadded", [i]);
    return s.setAttribute("height", "0px"), s.setAttribute("depth", "0px"), s;
  }
});
Ke({
  type: "vphantom",
  names: ["\\vphantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (r, t) => {
    var {
      parser: a
    } = r, i = t[0];
    return {
      type: "vphantom",
      mode: a.mode,
      body: i
    };
  },
  htmlBuilder: (r, t) => {
    var a = ge.makeSpan(["inner"], [on(r.body, t.withPhantom())]), i = ge.makeSpan(["fix"], []);
    return ge.makeSpan(["mord", "rlap"], [a, i], t);
  },
  mathmlBuilder: (r, t) => {
    var a = Tl(Sr(r.body), t), i = new Ve.MathNode("mphantom", a), s = new Ve.MathNode("mpadded", [i]);
    return s.setAttribute("width", "0px"), s;
  }
});
Ke({
  type: "raisebox",
  names: ["\\raisebox"],
  props: {
    numArgs: 2,
    argTypes: ["size", "hbox"],
    allowedInText: !0
  },
  handler(r, t) {
    var {
      parser: a
    } = r, i = Gt(t[0], "size").value, s = t[1];
    return {
      type: "raisebox",
      mode: a.mode,
      dy: i,
      body: s
    };
  },
  htmlBuilder(r, t) {
    var a = on(r.body, t), i = Wn(r.dy, t);
    return ge.makeVList({
      positionType: "shift",
      positionData: -i,
      children: [{
        type: "elem",
        elem: a
      }]
    }, t);
  },
  mathmlBuilder(r, t) {
    var a = new Ve.MathNode("mpadded", [_n(r.body, t)]), i = r.dy.number + r.dy.unit;
    return a.setAttribute("voffset", i), a;
  }
});
Ke({
  type: "internal",
  names: ["\\relax"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInArgument: !0
  },
  handler(r) {
    var {
      parser: t
    } = r;
    return {
      type: "internal",
      mode: t.mode
    };
  }
});
Ke({
  type: "rule",
  names: ["\\rule"],
  props: {
    numArgs: 2,
    numOptionalArgs: 1,
    allowedInText: !0,
    allowedInMath: !0,
    argTypes: ["size", "size", "size"]
  },
  handler(r, t, a) {
    var {
      parser: i
    } = r, s = a[0], h = Gt(t[0], "size"), d = Gt(t[1], "size");
    return {
      type: "rule",
      mode: i.mode,
      shift: s && Gt(s, "size").value,
      width: h.value,
      height: d.value
    };
  },
  htmlBuilder(r, t) {
    var a = ge.makeSpan(["mord", "rule"], [], t), i = Wn(r.width, t), s = Wn(r.height, t), h = r.shift ? Wn(r.shift, t) : 0;
    return a.style.borderRightWidth = Fe(i), a.style.borderTopWidth = Fe(s), a.style.bottom = Fe(h), a.width = i, a.height = s + h, a.depth = -h, a.maxFontSize = s * 1.125 * t.sizeMultiplier, a;
  },
  mathmlBuilder(r, t) {
    var a = Wn(r.width, t), i = Wn(r.height, t), s = r.shift ? Wn(r.shift, t) : 0, h = t.color && t.getColor() || "black", d = new Ve.MathNode("mspace");
    d.setAttribute("mathbackground", h), d.setAttribute("width", Fe(a)), d.setAttribute("height", Fe(i));
    var y = new Ve.MathNode("mpadded", [d]);
    return s >= 0 ? y.setAttribute("height", Fe(s)) : (y.setAttribute("height", Fe(s)), y.setAttribute("depth", Fe(-s))), y.setAttribute("voffset", Fe(s)), y;
  }
});
function eT(r, t, a) {
  for (var i = Qr(r, t, !1), s = t.sizeMultiplier / a.sizeMultiplier, h = 0; h < i.length; h++) {
    var d = i[h].classes.indexOf("sizing");
    d < 0 ? Array.prototype.push.apply(i[h].classes, t.sizingClasses(a)) : i[h].classes[d + 1] === "reset-size" + t.size && (i[h].classes[d + 1] = "reset-size" + a.size), i[h].height *= s, i[h].depth *= s;
  }
  return ge.makeFragment(i);
}
var eS = ["\\tiny", "\\sixptsize", "\\scriptsize", "\\footnotesize", "\\small", "\\normalsize", "\\large", "\\Large", "\\LARGE", "\\huge", "\\Huge"], wB = (r, t) => {
  var a = t.havingSize(r.size);
  return eT(r.body, a, t);
};
Ke({
  type: "sizing",
  names: eS,
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler: (r, t) => {
    var {
      breakOnTokenText: a,
      funcName: i,
      parser: s
    } = r, h = s.parseExpression(!1, a);
    return {
      type: "sizing",
      mode: s.mode,
      // Figure out what size to use based on the list of functions above
      size: eS.indexOf(i) + 1,
      body: h
    };
  },
  htmlBuilder: wB,
  mathmlBuilder: (r, t) => {
    var a = t.havingSize(r.size), i = Tl(r.body, a), s = new Ve.MathNode("mstyle", i);
    return s.setAttribute("mathsize", Fe(a.sizeMultiplier)), s;
  }
});
Ke({
  type: "smash",
  names: ["\\smash"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1,
    allowedInText: !0
  },
  handler: (r, t, a) => {
    var {
      parser: i
    } = r, s = !1, h = !1, d = a[0] && Gt(a[0], "ordgroup");
    if (d)
      for (var y = "", g = 0; g < d.body.length; ++g) {
        var b = d.body[g];
        if (y = b.text, y === "t")
          s = !0;
        else if (y === "b")
          h = !0;
        else {
          s = !1, h = !1;
          break;
        }
      }
    else
      s = !0, h = !0;
    var x = t[0];
    return {
      type: "smash",
      mode: i.mode,
      body: x,
      smashHeight: s,
      smashDepth: h
    };
  },
  htmlBuilder: (r, t) => {
    var a = ge.makeSpan([], [on(r.body, t)]);
    if (!r.smashHeight && !r.smashDepth)
      return a;
    if (r.smashHeight && (a.height = 0, a.children))
      for (var i = 0; i < a.children.length; i++)
        a.children[i].height = 0;
    if (r.smashDepth && (a.depth = 0, a.children))
      for (var s = 0; s < a.children.length; s++)
        a.children[s].depth = 0;
    var h = ge.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: a
      }]
    }, t);
    return ge.makeSpan(["mord"], [h], t);
  },
  mathmlBuilder: (r, t) => {
    var a = new Ve.MathNode("mpadded", [_n(r.body, t)]);
    return r.smashHeight && a.setAttribute("height", "0px"), r.smashDepth && a.setAttribute("depth", "0px"), a;
  }
});
Ke({
  type: "sqrt",
  names: ["\\sqrt"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1
  },
  handler(r, t, a) {
    var {
      parser: i
    } = r, s = a[0], h = t[0];
    return {
      type: "sqrt",
      mode: i.mode,
      body: h,
      index: s
    };
  },
  htmlBuilder(r, t) {
    var a = on(r.body, t.havingCrampedStyle());
    a.height === 0 && (a.height = t.fontMetrics().xHeight), a = ge.wrapFragment(a, t);
    var i = t.fontMetrics(), s = i.defaultRuleThickness, h = s;
    t.style.id < yt.TEXT.id && (h = t.fontMetrics().xHeight);
    var d = s + h / 4, y = a.height + a.depth + d + s, {
      span: g,
      ruleWidth: b,
      advanceWidth: x
    } = Es.sqrtImage(y, t), T = g.height - b;
    T > a.height + a.depth + d && (d = (d + T - a.height - a.depth) / 2);
    var R = g.height - a.height - d - b;
    a.style.paddingLeft = Fe(x);
    var E = ge.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: a,
        wrapperClasses: ["svg-align"]
      }, {
        type: "kern",
        size: -(a.height + R)
      }, {
        type: "elem",
        elem: g
      }, {
        type: "kern",
        size: b
      }]
    }, t);
    if (r.index) {
      var O = t.havingStyle(yt.SCRIPTSCRIPT), L = on(r.index, O, t), G = 0.6 * (E.height - E.depth), V = ge.makeVList({
        positionType: "shift",
        positionData: -G,
        children: [{
          type: "elem",
          elem: L
        }]
      }, t), I = ge.makeSpan(["root"], [V]);
      return ge.makeSpan(["mord", "sqrt"], [I, E], t);
    } else
      return ge.makeSpan(["mord", "sqrt"], [E], t);
  },
  mathmlBuilder(r, t) {
    var {
      body: a,
      index: i
    } = r;
    return i ? new Ve.MathNode("mroot", [_n(a, t), _n(i, t)]) : new Ve.MathNode("msqrt", [_n(a, t)]);
  }
});
var tS = {
  display: yt.DISPLAY,
  text: yt.TEXT,
  script: yt.SCRIPT,
  scriptscript: yt.SCRIPTSCRIPT
};
Ke({
  type: "styling",
  names: ["\\displaystyle", "\\textstyle", "\\scriptstyle", "\\scriptscriptstyle"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(r, t) {
    var {
      breakOnTokenText: a,
      funcName: i,
      parser: s
    } = r, h = s.parseExpression(!0, a), d = i.slice(1, i.length - 5);
    return {
      type: "styling",
      mode: s.mode,
      // Figure out what style to use by pulling out the style from
      // the function name
      style: d,
      body: h
    };
  },
  htmlBuilder(r, t) {
    var a = tS[r.style], i = t.havingStyle(a).withFont("");
    return eT(r.body, i, t);
  },
  mathmlBuilder(r, t) {
    var a = tS[r.style], i = t.havingStyle(a), s = Tl(r.body, i), h = new Ve.MathNode("mstyle", s), d = {
      display: ["0", "true"],
      text: ["0", "false"],
      script: ["1", "false"],
      scriptscript: ["2", "false"]
    }, y = d[r.style];
    return h.setAttribute("scriptlevel", y[0]), h.setAttribute("displaystyle", y[1]), h;
  }
});
var TB = function(t, a) {
  var i = t.base;
  if (i)
    if (i.type === "op") {
      var s = i.limits && (a.style.size === yt.DISPLAY.size || i.alwaysHandleSupSub);
      return s ? Nm : null;
    } else if (i.type === "operatorname") {
      var h = i.alwaysHandleSupSub && (a.style.size === yt.DISPLAY.size || i.limits);
      return h ? Ww : null;
    } else {
      if (i.type === "accent")
        return dt.isCharacterBox(i.base) ? H7 : null;
      if (i.type === "horizBrace") {
        var d = !t.sub;
        return d === i.isOver ? Pw : null;
      } else
        return null;
    }
  else return null;
};
rh({
  type: "supsub",
  htmlBuilder(r, t) {
    var a = TB(r, t);
    if (a)
      return a(r, t);
    var {
      base: i,
      sup: s,
      sub: h
    } = r, d = on(i, t), y, g, b = t.fontMetrics(), x = 0, T = 0, R = i && dt.isCharacterBox(i);
    if (s) {
      var E = t.havingStyle(t.style.sup());
      y = on(s, E, t), R || (x = d.height - E.fontMetrics().supDrop * E.sizeMultiplier / t.sizeMultiplier);
    }
    if (h) {
      var O = t.havingStyle(t.style.sub());
      g = on(h, O, t), R || (T = d.depth + O.fontMetrics().subDrop * O.sizeMultiplier / t.sizeMultiplier);
    }
    var L;
    t.style === yt.DISPLAY ? L = b.sup1 : t.style.cramped ? L = b.sup3 : L = b.sup2;
    var G = t.sizeMultiplier, V = Fe(0.5 / b.ptPerEm / G), I = null;
    if (g) {
      var $ = r.base && r.base.type === "op" && r.base.name && (r.base.name === "\\oiint" || r.base.name === "\\oiiint");
      (d instanceof qi || $) && (I = Fe(-d.italic));
    }
    var ce;
    if (y && g) {
      x = Math.max(x, L, y.depth + 0.25 * b.xHeight), T = Math.max(T, b.sub2);
      var se = b.defaultRuleThickness, te = 4 * se;
      if (x - y.depth - (g.height - T) < te) {
        T = te - (x - y.depth) + g.height;
        var Ce = 0.8 * b.xHeight - (x - y.depth);
        Ce > 0 && (x += Ce, T -= Ce);
      }
      var ve = [{
        type: "elem",
        elem: g,
        shift: T,
        marginRight: V,
        marginLeft: I
      }, {
        type: "elem",
        elem: y,
        shift: -x,
        marginRight: V
      }];
      ce = ge.makeVList({
        positionType: "individualShift",
        children: ve
      }, t);
    } else if (g) {
      T = Math.max(T, b.sub1, g.height - 0.8 * b.xHeight);
      var Ne = [{
        type: "elem",
        elem: g,
        marginLeft: I,
        marginRight: V
      }];
      ce = ge.makeVList({
        positionType: "shift",
        positionData: T,
        children: Ne
      }, t);
    } else if (y)
      x = Math.max(x, L, y.depth + 0.25 * b.xHeight), ce = ge.makeVList({
        positionType: "shift",
        positionData: -x,
        children: [{
          type: "elem",
          elem: y,
          marginRight: V
        }]
      }, t);
    else
      throw new Error("supsub must have either sup or sub.");
    var ee = H5(d, "right") || "mord";
    return ge.makeSpan([ee], [d, ge.makeSpan(["msupsub"], [ce])], t);
  },
  mathmlBuilder(r, t) {
    var a = !1, i, s;
    r.base && r.base.type === "horizBrace" && (s = !!r.sup, s === r.base.isOver && (a = !0, i = r.base.isOver)), r.base && (r.base.type === "op" || r.base.type === "operatorname") && (r.base.parentIsSupSub = !0);
    var h = [_n(r.base, t)];
    r.sub && h.push(_n(r.sub, t)), r.sup && h.push(_n(r.sup, t));
    var d;
    if (a)
      d = i ? "mover" : "munder";
    else if (r.sub)
      if (r.sup) {
        var b = r.base;
        b && b.type === "op" && b.limits && t.style === yt.DISPLAY || b && b.type === "operatorname" && b.alwaysHandleSupSub && (t.style === yt.DISPLAY || b.limits) ? d = "munderover" : d = "msubsup";
      } else {
        var g = r.base;
        g && g.type === "op" && g.limits && (t.style === yt.DISPLAY || g.alwaysHandleSupSub) || g && g.type === "operatorname" && g.alwaysHandleSupSub && (g.limits || t.style === yt.DISPLAY) ? d = "munder" : d = "msub";
      }
    else {
      var y = r.base;
      y && y.type === "op" && y.limits && (t.style === yt.DISPLAY || y.alwaysHandleSupSub) || y && y.type === "operatorname" && y.alwaysHandleSupSub && (y.limits || t.style === yt.DISPLAY) ? d = "mover" : d = "msup";
    }
    return new Ve.MathNode(d, h);
  }
});
rh({
  type: "atom",
  htmlBuilder(r, t) {
    return ge.mathsym(r.text, r.mode, t, ["m" + r.family]);
  },
  mathmlBuilder(r, t) {
    var a = new Ve.MathNode("mo", [ji(r.text, r.mode)]);
    if (r.family === "bin") {
      var i = L7(r, t);
      i === "bold-italic" && a.setAttribute("mathvariant", i);
    } else r.family === "punct" ? a.setAttribute("separator", "true") : (r.family === "open" || r.family === "close") && a.setAttribute("stretchy", "false");
    return a;
  }
});
var tT = {
  mi: "italic",
  mn: "normal",
  mtext: "normal"
};
rh({
  type: "mathord",
  htmlBuilder(r, t) {
    return ge.makeOrd(r, t, "mathord");
  },
  mathmlBuilder(r, t) {
    var a = new Ve.MathNode("mi", [ji(r.text, r.mode, t)]), i = L7(r, t) || "italic";
    return i !== tT[a.type] && a.setAttribute("mathvariant", i), a;
  }
});
rh({
  type: "textord",
  htmlBuilder(r, t) {
    return ge.makeOrd(r, t, "textord");
  },
  mathmlBuilder(r, t) {
    var a = ji(r.text, r.mode, t), i = L7(r, t) || "normal", s;
    return r.mode === "text" ? s = new Ve.MathNode("mtext", [a]) : /[0-9]/.test(r.text) ? s = new Ve.MathNode("mn", [a]) : r.text === "\\prime" ? s = new Ve.MathNode("mo", [a]) : s = new Ve.MathNode("mi", [a]), i !== tT[s.type] && s.setAttribute("mathvariant", i), s;
  }
});
var c5 = {
  "\\nobreak": "nobreak",
  "\\allowbreak": "allowbreak"
}, f5 = {
  " ": {},
  "\\ ": {},
  "~": {
    className: "nobreak"
  },
  "\\space": {},
  "\\nobreakspace": {
    className: "nobreak"
  }
};
rh({
  type: "spacing",
  htmlBuilder(r, t) {
    if (f5.hasOwnProperty(r.text)) {
      var a = f5[r.text].className || "";
      if (r.mode === "text") {
        var i = ge.makeOrd(r, t, "textord");
        return i.classes.push(a), i;
      } else
        return ge.makeSpan(["mspace", a], [ge.mathsym(r.text, r.mode, t)], t);
    } else {
      if (c5.hasOwnProperty(r.text))
        return ge.makeSpan(["mspace", c5[r.text]], [], t);
      throw new $e('Unknown type of space "' + r.text + '"');
    }
  },
  mathmlBuilder(r, t) {
    var a;
    if (f5.hasOwnProperty(r.text))
      a = new Ve.MathNode("mtext", [new Ve.TextNode(" ")]);
    else {
      if (c5.hasOwnProperty(r.text))
        return new Ve.MathNode("mspace");
      throw new $e('Unknown type of space "' + r.text + '"');
    }
    return a;
  }
});
var nS = () => {
  var r = new Ve.MathNode("mtd", []);
  return r.setAttribute("width", "50%"), r;
};
rh({
  type: "tag",
  mathmlBuilder(r, t) {
    var a = new Ve.MathNode("mtable", [new Ve.MathNode("mtr", [nS(), new Ve.MathNode("mtd", [i0(r.body, t)]), nS(), new Ve.MathNode("mtd", [i0(r.tag, t)])])]);
    return a.setAttribute("width", "100%"), a;
  }
});
var rS = {
  "\\text": void 0,
  "\\textrm": "textrm",
  "\\textsf": "textsf",
  "\\texttt": "texttt",
  "\\textnormal": "textrm"
}, aS = {
  "\\textbf": "textbf",
  "\\textmd": "textmd"
}, EB = {
  "\\textit": "textit",
  "\\textup": "textup"
}, lS = (r, t) => {
  var a = r.font;
  if (a) {
    if (rS[a])
      return t.withTextFontFamily(rS[a]);
    if (aS[a])
      return t.withTextFontWeight(aS[a]);
    if (a === "\\emph")
      return t.fontShape === "textit" ? t.withTextFontShape("textup") : t.withTextFontShape("textit");
  } else return t;
  return t.withTextFontShape(EB[a]);
};
Ke({
  type: "text",
  names: [
    // Font families
    "\\text",
    "\\textrm",
    "\\textsf",
    "\\texttt",
    "\\textnormal",
    // Font weights
    "\\textbf",
    "\\textmd",
    // Font Shapes
    "\\textit",
    "\\textup",
    "\\emph"
  ],
  props: {
    numArgs: 1,
    argTypes: ["text"],
    allowedInArgument: !0,
    allowedInText: !0
  },
  handler(r, t) {
    var {
      parser: a,
      funcName: i
    } = r, s = t[0];
    return {
      type: "text",
      mode: a.mode,
      body: Sr(s),
      font: i
    };
  },
  htmlBuilder(r, t) {
    var a = lS(r, t), i = Qr(r.body, a, !0);
    return ge.makeSpan(["mord", "text"], i, a);
  },
  mathmlBuilder(r, t) {
    var a = lS(r, t);
    return i0(r.body, a);
  }
});
Ke({
  type: "underline",
  names: ["\\underline"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(r, t) {
    var {
      parser: a
    } = r;
    return {
      type: "underline",
      mode: a.mode,
      body: t[0]
    };
  },
  htmlBuilder(r, t) {
    var a = on(r.body, t), i = ge.makeLineSpan("underline-line", t), s = t.fontMetrics().defaultRuleThickness, h = ge.makeVList({
      positionType: "top",
      positionData: a.height,
      children: [{
        type: "kern",
        size: s
      }, {
        type: "elem",
        elem: i
      }, {
        type: "kern",
        size: 3 * s
      }, {
        type: "elem",
        elem: a
      }]
    }, t);
    return ge.makeSpan(["mord", "underline"], [h], t);
  },
  mathmlBuilder(r, t) {
    var a = new Ve.MathNode("mo", [new Ve.TextNode("‾")]);
    a.setAttribute("stretchy", "true");
    var i = new Ve.MathNode("munder", [_n(r.body, t), a]);
    return i.setAttribute("accentunder", "true"), i;
  }
});
Ke({
  type: "vcenter",
  names: ["\\vcenter"],
  props: {
    numArgs: 1,
    argTypes: ["original"],
    // In LaTeX, \vcenter can act only on a box.
    allowedInText: !1
  },
  handler(r, t) {
    var {
      parser: a
    } = r;
    return {
      type: "vcenter",
      mode: a.mode,
      body: t[0]
    };
  },
  htmlBuilder(r, t) {
    var a = on(r.body, t), i = t.fontMetrics().axisHeight, s = 0.5 * (a.height - i - (a.depth + i));
    return ge.makeVList({
      positionType: "shift",
      positionData: s,
      children: [{
        type: "elem",
        elem: a
      }]
    }, t);
  },
  mathmlBuilder(r, t) {
    return new Ve.MathNode("mpadded", [_n(r.body, t)], ["vcenter"]);
  }
});
Ke({
  type: "verb",
  names: ["\\verb"],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler(r, t, a) {
    throw new $e("\\verb ended by end of line instead of matching delimiter");
  },
  htmlBuilder(r, t) {
    for (var a = iS(r), i = [], s = t.havingStyle(t.style.text()), h = 0; h < a.length; h++) {
      var d = a[h];
      d === "~" && (d = "\\textasciitilde"), i.push(ge.makeSymbol(d, "Typewriter-Regular", r.mode, s, ["mord", "texttt"]));
    }
    return ge.makeSpan(["mord", "text"].concat(s.sizingClasses(t)), ge.tryCombineChars(i), s);
  },
  mathmlBuilder(r, t) {
    var a = new Ve.TextNode(iS(r)), i = new Ve.MathNode("mtext", [a]);
    return i.setAttribute("mathvariant", "monospace"), i;
  }
});
var iS = (r) => r.body.replace(/ /g, r.star ? "␣" : " "), r0 = Ew, nT = `[ \r
	]`, AB = "\\\\[a-zA-Z@]+", kB = "\\\\[^\uD800-\uDFFF]", RB = "(" + AB + ")" + nT + "*", zB = `\\\\(
|[ \r	]+
?)[ \r	]*`, G5 = "[̀-ͯ]", CB = new RegExp(G5 + "+$"), MB = "(" + nT + "+)|" + // whitespace
(zB + "|") + // \whitespace
"([!-\\[\\]-‧‪-퟿豈-￿]" + // single codepoint
(G5 + "*") + // ...plus accents
"|[\uD800-\uDBFF][\uDC00-\uDFFF]" + // surrogate pair
(G5 + "*") + // ...plus accents
"|\\\\verb\\*([^]).*?\\4|\\\\verb([^*a-zA-Z]).*?\\5" + // \verb unstarred
("|" + RB) + // \macroName + spaces
("|" + kB + ")");
class uS {
  // Category codes. The lexer only supports comment characters (14) for now.
  // MacroExpander additionally distinguishes active (13).
  constructor(t, a) {
    this.input = void 0, this.settings = void 0, this.tokenRegex = void 0, this.catcodes = void 0, this.input = t, this.settings = a, this.tokenRegex = new RegExp(MB, "g"), this.catcodes = {
      "%": 14,
      // comment character
      "~": 13
      // active character
    };
  }
  setCatcode(t, a) {
    this.catcodes[t] = a;
  }
  /**
   * This function lexes a single token.
   */
  lex() {
    var t = this.input, a = this.tokenRegex.lastIndex;
    if (a === t.length)
      return new Li("EOF", new ei(this, a, a));
    var i = this.tokenRegex.exec(t);
    if (i === null || i.index !== a)
      throw new $e("Unexpected character: '" + t[a] + "'", new Li(t[a], new ei(this, a, a + 1)));
    var s = i[6] || i[3] || (i[2] ? "\\ " : " ");
    if (this.catcodes[s] === 14) {
      var h = t.indexOf(`
`, this.tokenRegex.lastIndex);
      return h === -1 ? (this.tokenRegex.lastIndex = t.length, this.settings.reportNonstrict("commentAtEnd", "% comment has no terminating newline; LaTeX would fail because of commenting the end of math mode (e.g. $)")) : this.tokenRegex.lastIndex = h + 1, this.lex();
    }
    return new Li(s, new ei(this, a, this.tokenRegex.lastIndex));
  }
}
class _B {
  /**
   * Both arguments are optional.  The first argument is an object of
   * built-in mappings which never change.  The second argument is an object
   * of initial (global-level) mappings, which will constantly change
   * according to any global/top-level `set`s done.
   */
  constructor(t, a) {
    t === void 0 && (t = {}), a === void 0 && (a = {}), this.current = void 0, this.builtins = void 0, this.undefStack = void 0, this.current = a, this.builtins = t, this.undefStack = [];
  }
  /**
   * Start a new nested group, affecting future local `set`s.
   */
  beginGroup() {
    this.undefStack.push({});
  }
  /**
   * End current nested group, restoring values before the group began.
   */
  endGroup() {
    if (this.undefStack.length === 0)
      throw new $e("Unbalanced namespace destruction: attempt to pop global namespace; please report this as a bug");
    var t = this.undefStack.pop();
    for (var a in t)
      t.hasOwnProperty(a) && (t[a] == null ? delete this.current[a] : this.current[a] = t[a]);
  }
  /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */
  endGroups() {
    for (; this.undefStack.length > 0; )
      this.endGroup();
  }
  /**
   * Detect whether `name` has a definition.  Equivalent to
   * `get(name) != null`.
   */
  has(t) {
    return this.current.hasOwnProperty(t) || this.builtins.hasOwnProperty(t);
  }
  /**
   * Get the current value of a name, or `undefined` if there is no value.
   *
   * Note: Do not use `if (namespace.get(...))` to detect whether a macro
   * is defined, as the definition may be the empty string which evaluates
   * to `false` in JavaScript.  Use `if (namespace.get(...) != null)` or
   * `if (namespace.has(...))`.
   */
  get(t) {
    return this.current.hasOwnProperty(t) ? this.current[t] : this.builtins[t];
  }
  /**
   * Set the current value of a name, and optionally set it globally too.
   * Local set() sets the current value and (when appropriate) adds an undo
   * operation to the undo stack.  Global set() may change the undo
   * operation at every level, so takes time linear in their number.
   * A value of undefined means to delete existing definitions.
   */
  set(t, a, i) {
    if (i === void 0 && (i = !1), i) {
      for (var s = 0; s < this.undefStack.length; s++)
        delete this.undefStack[s][t];
      this.undefStack.length > 0 && (this.undefStack[this.undefStack.length - 1][t] = a);
    } else {
      var h = this.undefStack[this.undefStack.length - 1];
      h && !h.hasOwnProperty(t) && (h[t] = this.current[t]);
    }
    a == null ? delete this.current[t] : this.current[t] = a;
  }
}
var OB = $w;
U("\\noexpand", function(r) {
  var t = r.popToken();
  return r.isExpandable(t.text) && (t.noexpand = !0, t.treatAsRelax = !0), {
    tokens: [t],
    numArgs: 0
  };
});
U("\\expandafter", function(r) {
  var t = r.popToken();
  return r.expandOnce(!0), {
    tokens: [t],
    numArgs: 0
  };
});
U("\\@firstoftwo", function(r) {
  var t = r.consumeArgs(2);
  return {
    tokens: t[0],
    numArgs: 0
  };
});
U("\\@secondoftwo", function(r) {
  var t = r.consumeArgs(2);
  return {
    tokens: t[1],
    numArgs: 0
  };
});
U("\\@ifnextchar", function(r) {
  var t = r.consumeArgs(3);
  r.consumeSpaces();
  var a = r.future();
  return t[0].length === 1 && t[0][0].text === a.text ? {
    tokens: t[1],
    numArgs: 0
  } : {
    tokens: t[2],
    numArgs: 0
  };
});
U("\\@ifstar", "\\@ifnextchar *{\\@firstoftwo{#1}}");
U("\\TextOrMath", function(r) {
  var t = r.consumeArgs(2);
  return r.mode === "text" ? {
    tokens: t[0],
    numArgs: 0
  } : {
    tokens: t[1],
    numArgs: 0
  };
});
var oS = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  a: 10,
  A: 10,
  b: 11,
  B: 11,
  c: 12,
  C: 12,
  d: 13,
  D: 13,
  e: 14,
  E: 14,
  f: 15,
  F: 15
};
U("\\char", function(r) {
  var t = r.popToken(), a, i = "";
  if (t.text === "'")
    a = 8, t = r.popToken();
  else if (t.text === '"')
    a = 16, t = r.popToken();
  else if (t.text === "`")
    if (t = r.popToken(), t.text[0] === "\\")
      i = t.text.charCodeAt(1);
    else {
      if (t.text === "EOF")
        throw new $e("\\char` missing argument");
      i = t.text.charCodeAt(0);
    }
  else
    a = 10;
  if (a) {
    if (i = oS[t.text], i == null || i >= a)
      throw new $e("Invalid base-" + a + " digit " + t.text);
    for (var s; (s = oS[r.future().text]) != null && s < a; )
      i *= a, i += s, r.popToken();
  }
  return "\\@char{" + i + "}";
});
var $7 = (r, t, a, i) => {
  var s = r.consumeArg().tokens;
  if (s.length !== 1)
    throw new $e("\\newcommand's first argument must be a macro name");
  var h = s[0].text, d = r.isDefined(h);
  if (d && !t)
    throw new $e("\\newcommand{" + h + "} attempting to redefine " + (h + "; use \\renewcommand"));
  if (!d && !a)
    throw new $e("\\renewcommand{" + h + "} when command " + h + " does not yet exist; use \\newcommand");
  var y = 0;
  if (s = r.consumeArg().tokens, s.length === 1 && s[0].text === "[") {
    for (var g = "", b = r.expandNextToken(); b.text !== "]" && b.text !== "EOF"; )
      g += b.text, b = r.expandNextToken();
    if (!g.match(/^\s*[0-9]+\s*$/))
      throw new $e("Invalid number of arguments: " + g);
    y = parseInt(g), s = r.consumeArg().tokens;
  }
  return d && i || r.macros.set(h, {
    tokens: s,
    numArgs: y
  }), "";
};
U("\\newcommand", (r) => $7(r, !1, !0, !1));
U("\\renewcommand", (r) => $7(r, !0, !1, !1));
U("\\providecommand", (r) => $7(r, !0, !0, !0));
U("\\message", (r) => {
  var t = r.consumeArgs(1)[0];
  return console.log(t.reverse().map((a) => a.text).join("")), "";
});
U("\\errmessage", (r) => {
  var t = r.consumeArgs(1)[0];
  return console.error(t.reverse().map((a) => a.text).join("")), "";
});
U("\\show", (r) => {
  var t = r.popToken(), a = t.text;
  return console.log(t, r.macros.get(a), r0[a], Bn.math[a], Bn.text[a]), "";
});
U("\\bgroup", "{");
U("\\egroup", "}");
U("~", "\\nobreakspace");
U("\\lq", "`");
U("\\rq", "'");
U("\\aa", "\\r a");
U("\\AA", "\\r A");
U("\\textcopyright", "\\html@mathml{\\textcircled{c}}{\\char`©}");
U("\\copyright", "\\TextOrMath{\\textcopyright}{\\text{\\textcopyright}}");
U("\\textregistered", "\\html@mathml{\\textcircled{\\scriptsize R}}{\\char`®}");
U("ℬ", "\\mathscr{B}");
U("ℰ", "\\mathscr{E}");
U("ℱ", "\\mathscr{F}");
U("ℋ", "\\mathscr{H}");
U("ℐ", "\\mathscr{I}");
U("ℒ", "\\mathscr{L}");
U("ℳ", "\\mathscr{M}");
U("ℛ", "\\mathscr{R}");
U("ℭ", "\\mathfrak{C}");
U("ℌ", "\\mathfrak{H}");
U("ℨ", "\\mathfrak{Z}");
U("\\Bbbk", "\\Bbb{k}");
U("·", "\\cdotp");
U("\\llap", "\\mathllap{\\textrm{#1}}");
U("\\rlap", "\\mathrlap{\\textrm{#1}}");
U("\\clap", "\\mathclap{\\textrm{#1}}");
U("\\mathstrut", "\\vphantom{(}");
U("\\underbar", "\\underline{\\text{#1}}");
U("\\not", '\\html@mathml{\\mathrel{\\mathrlap\\@not}}{\\char"338}');
U("\\neq", "\\html@mathml{\\mathrel{\\not=}}{\\mathrel{\\char`≠}}");
U("\\ne", "\\neq");
U("≠", "\\neq");
U("\\notin", "\\html@mathml{\\mathrel{{\\in}\\mathllap{/\\mskip1mu}}}{\\mathrel{\\char`∉}}");
U("∉", "\\notin");
U("≘", "\\html@mathml{\\mathrel{=\\kern{-1em}\\raisebox{0.4em}{$\\scriptsize\\frown$}}}{\\mathrel{\\char`≘}}");
U("≙", "\\html@mathml{\\stackrel{\\tiny\\wedge}{=}}{\\mathrel{\\char`≘}}");
U("≚", "\\html@mathml{\\stackrel{\\tiny\\vee}{=}}{\\mathrel{\\char`≚}}");
U("≛", "\\html@mathml{\\stackrel{\\scriptsize\\star}{=}}{\\mathrel{\\char`≛}}");
U("≝", "\\html@mathml{\\stackrel{\\tiny\\mathrm{def}}{=}}{\\mathrel{\\char`≝}}");
U("≞", "\\html@mathml{\\stackrel{\\tiny\\mathrm{m}}{=}}{\\mathrel{\\char`≞}}");
U("≟", "\\html@mathml{\\stackrel{\\tiny?}{=}}{\\mathrel{\\char`≟}}");
U("⟂", "\\perp");
U("‼", "\\mathclose{!\\mkern-0.8mu!}");
U("∌", "\\notni");
U("⌜", "\\ulcorner");
U("⌝", "\\urcorner");
U("⌞", "\\llcorner");
U("⌟", "\\lrcorner");
U("©", "\\copyright");
U("®", "\\textregistered");
U("️", "\\textregistered");
U("\\ulcorner", '\\html@mathml{\\@ulcorner}{\\mathop{\\char"231c}}');
U("\\urcorner", '\\html@mathml{\\@urcorner}{\\mathop{\\char"231d}}');
U("\\llcorner", '\\html@mathml{\\@llcorner}{\\mathop{\\char"231e}}');
U("\\lrcorner", '\\html@mathml{\\@lrcorner}{\\mathop{\\char"231f}}');
U("\\vdots", "{\\varvdots\\rule{0pt}{15pt}}");
U("⋮", "\\vdots");
U("\\varGamma", "\\mathit{\\Gamma}");
U("\\varDelta", "\\mathit{\\Delta}");
U("\\varTheta", "\\mathit{\\Theta}");
U("\\varLambda", "\\mathit{\\Lambda}");
U("\\varXi", "\\mathit{\\Xi}");
U("\\varPi", "\\mathit{\\Pi}");
U("\\varSigma", "\\mathit{\\Sigma}");
U("\\varUpsilon", "\\mathit{\\Upsilon}");
U("\\varPhi", "\\mathit{\\Phi}");
U("\\varPsi", "\\mathit{\\Psi}");
U("\\varOmega", "\\mathit{\\Omega}");
U("\\substack", "\\begin{subarray}{c}#1\\end{subarray}");
U("\\colon", "\\nobreak\\mskip2mu\\mathpunct{}\\mathchoice{\\mkern-3mu}{\\mkern-3mu}{}{}{:}\\mskip6mu\\relax");
U("\\boxed", "\\fbox{$\\displaystyle{#1}$}");
U("\\iff", "\\DOTSB\\;\\Longleftrightarrow\\;");
U("\\implies", "\\DOTSB\\;\\Longrightarrow\\;");
U("\\impliedby", "\\DOTSB\\;\\Longleftarrow\\;");
U("\\dddot", "{\\overset{\\raisebox{-0.1ex}{\\normalsize ...}}{#1}}");
U("\\ddddot", "{\\overset{\\raisebox{-0.1ex}{\\normalsize ....}}{#1}}");
var sS = {
  ",": "\\dotsc",
  "\\not": "\\dotsb",
  // \keybin@ checks for the following:
  "+": "\\dotsb",
  "=": "\\dotsb",
  "<": "\\dotsb",
  ">": "\\dotsb",
  "-": "\\dotsb",
  "*": "\\dotsb",
  ":": "\\dotsb",
  // Symbols whose definition starts with \DOTSB:
  "\\DOTSB": "\\dotsb",
  "\\coprod": "\\dotsb",
  "\\bigvee": "\\dotsb",
  "\\bigwedge": "\\dotsb",
  "\\biguplus": "\\dotsb",
  "\\bigcap": "\\dotsb",
  "\\bigcup": "\\dotsb",
  "\\prod": "\\dotsb",
  "\\sum": "\\dotsb",
  "\\bigotimes": "\\dotsb",
  "\\bigoplus": "\\dotsb",
  "\\bigodot": "\\dotsb",
  "\\bigsqcup": "\\dotsb",
  "\\And": "\\dotsb",
  "\\longrightarrow": "\\dotsb",
  "\\Longrightarrow": "\\dotsb",
  "\\longleftarrow": "\\dotsb",
  "\\Longleftarrow": "\\dotsb",
  "\\longleftrightarrow": "\\dotsb",
  "\\Longleftrightarrow": "\\dotsb",
  "\\mapsto": "\\dotsb",
  "\\longmapsto": "\\dotsb",
  "\\hookrightarrow": "\\dotsb",
  "\\doteq": "\\dotsb",
  // Symbols whose definition starts with \mathbin:
  "\\mathbin": "\\dotsb",
  // Symbols whose definition starts with \mathrel:
  "\\mathrel": "\\dotsb",
  "\\relbar": "\\dotsb",
  "\\Relbar": "\\dotsb",
  "\\xrightarrow": "\\dotsb",
  "\\xleftarrow": "\\dotsb",
  // Symbols whose definition starts with \DOTSI:
  "\\DOTSI": "\\dotsi",
  "\\int": "\\dotsi",
  "\\oint": "\\dotsi",
  "\\iint": "\\dotsi",
  "\\iiint": "\\dotsi",
  "\\iiiint": "\\dotsi",
  "\\idotsint": "\\dotsi",
  // Symbols whose definition starts with \DOTSX:
  "\\DOTSX": "\\dotsx"
};
U("\\dots", function(r) {
  var t = "\\dotso", a = r.expandAfterFuture().text;
  return a in sS ? t = sS[a] : (a.slice(0, 4) === "\\not" || a in Bn.math && dt.contains(["bin", "rel"], Bn.math[a].group)) && (t = "\\dotsb"), t;
});
var X7 = {
  // \rightdelim@ checks for the following:
  ")": !0,
  "]": !0,
  "\\rbrack": !0,
  "\\}": !0,
  "\\rbrace": !0,
  "\\rangle": !0,
  "\\rceil": !0,
  "\\rfloor": !0,
  "\\rgroup": !0,
  "\\rmoustache": !0,
  "\\right": !0,
  "\\bigr": !0,
  "\\biggr": !0,
  "\\Bigr": !0,
  "\\Biggr": !0,
  // \extra@ also tests for the following:
  $: !0,
  // \extrap@ checks for the following:
  ";": !0,
  ".": !0,
  ",": !0
};
U("\\dotso", function(r) {
  var t = r.future().text;
  return t in X7 ? "\\ldots\\," : "\\ldots";
});
U("\\dotsc", function(r) {
  var t = r.future().text;
  return t in X7 && t !== "," ? "\\ldots\\," : "\\ldots";
});
U("\\cdots", function(r) {
  var t = r.future().text;
  return t in X7 ? "\\@cdots\\," : "\\@cdots";
});
U("\\dotsb", "\\cdots");
U("\\dotsm", "\\cdots");
U("\\dotsi", "\\!\\cdots");
U("\\dotsx", "\\ldots\\,");
U("\\DOTSI", "\\relax");
U("\\DOTSB", "\\relax");
U("\\DOTSX", "\\relax");
U("\\tmspace", "\\TextOrMath{\\kern#1#3}{\\mskip#1#2}\\relax");
U("\\,", "\\tmspace+{3mu}{.1667em}");
U("\\thinspace", "\\,");
U("\\>", "\\mskip{4mu}");
U("\\:", "\\tmspace+{4mu}{.2222em}");
U("\\medspace", "\\:");
U("\\;", "\\tmspace+{5mu}{.2777em}");
U("\\thickspace", "\\;");
U("\\!", "\\tmspace-{3mu}{.1667em}");
U("\\negthinspace", "\\!");
U("\\negmedspace", "\\tmspace-{4mu}{.2222em}");
U("\\negthickspace", "\\tmspace-{5mu}{.277em}");
U("\\enspace", "\\kern.5em ");
U("\\enskip", "\\hskip.5em\\relax");
U("\\quad", "\\hskip1em\\relax");
U("\\qquad", "\\hskip2em\\relax");
U("\\tag", "\\@ifstar\\tag@literal\\tag@paren");
U("\\tag@paren", "\\tag@literal{({#1})}");
U("\\tag@literal", (r) => {
  if (r.macros.get("\\df@tag"))
    throw new $e("Multiple \\tag");
  return "\\gdef\\df@tag{\\text{#1}}";
});
U("\\bmod", "\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}\\mathbin{\\rm mod}\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}");
U("\\pod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern8mu}{\\mkern8mu}{\\mkern8mu}(#1)");
U("\\pmod", "\\pod{{\\rm mod}\\mkern6mu#1}");
U("\\mod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern12mu}{\\mkern12mu}{\\mkern12mu}{\\rm mod}\\,\\,#1");
U("\\newline", "\\\\\\relax");
U("\\TeX", "\\textrm{\\html@mathml{T\\kern-.1667em\\raisebox{-.5ex}{E}\\kern-.125emX}{TeX}}");
var rT = Fe(vo["Main-Regular"][84][1] - 0.7 * vo["Main-Regular"][65][1]);
U("\\LaTeX", "\\textrm{\\html@mathml{" + ("L\\kern-.36em\\raisebox{" + rT + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{LaTeX}}");
U("\\KaTeX", "\\textrm{\\html@mathml{" + ("K\\kern-.17em\\raisebox{" + rT + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{KaTeX}}");
U("\\hspace", "\\@ifstar\\@hspacer\\@hspace");
U("\\@hspace", "\\hskip #1\\relax");
U("\\@hspacer", "\\rule{0pt}{0pt}\\hskip #1\\relax");
U("\\ordinarycolon", ":");
U("\\vcentcolon", "\\mathrel{\\mathop\\ordinarycolon}");
U("\\dblcolon", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-.9mu}\\vcentcolon}}{\\mathop{\\char"2237}}');
U("\\coloneqq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2254}}');
U("\\Coloneqq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2237\\char"3d}}');
U("\\coloneq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"3a\\char"2212}}');
U("\\Coloneq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"2237\\char"2212}}');
U("\\eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2255}}');
U("\\Eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"3d\\char"2237}}');
U("\\eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2239}}');
U("\\Eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"2212\\char"2237}}');
U("\\colonapprox", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"3a\\char"2248}}');
U("\\Colonapprox", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"2237\\char"2248}}');
U("\\colonsim", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"3a\\char"223c}}');
U("\\Colonsim", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"2237\\char"223c}}');
U("∷", "\\dblcolon");
U("∹", "\\eqcolon");
U("≔", "\\coloneqq");
U("≕", "\\eqqcolon");
U("⩴", "\\Coloneqq");
U("\\ratio", "\\vcentcolon");
U("\\coloncolon", "\\dblcolon");
U("\\colonequals", "\\coloneqq");
U("\\coloncolonequals", "\\Coloneqq");
U("\\equalscolon", "\\eqqcolon");
U("\\equalscoloncolon", "\\Eqqcolon");
U("\\colonminus", "\\coloneq");
U("\\coloncolonminus", "\\Coloneq");
U("\\minuscolon", "\\eqcolon");
U("\\minuscoloncolon", "\\Eqcolon");
U("\\coloncolonapprox", "\\Colonapprox");
U("\\coloncolonsim", "\\Colonsim");
U("\\simcolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
U("\\simcoloncolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\dblcolon}");
U("\\approxcolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
U("\\approxcoloncolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\dblcolon}");
U("\\notni", "\\html@mathml{\\not\\ni}{\\mathrel{\\char`∌}}");
U("\\limsup", "\\DOTSB\\operatorname*{lim\\,sup}");
U("\\liminf", "\\DOTSB\\operatorname*{lim\\,inf}");
U("\\injlim", "\\DOTSB\\operatorname*{inj\\,lim}");
U("\\projlim", "\\DOTSB\\operatorname*{proj\\,lim}");
U("\\varlimsup", "\\DOTSB\\operatorname*{\\overline{lim}}");
U("\\varliminf", "\\DOTSB\\operatorname*{\\underline{lim}}");
U("\\varinjlim", "\\DOTSB\\operatorname*{\\underrightarrow{lim}}");
U("\\varprojlim", "\\DOTSB\\operatorname*{\\underleftarrow{lim}}");
U("\\gvertneqq", "\\html@mathml{\\@gvertneqq}{≩}");
U("\\lvertneqq", "\\html@mathml{\\@lvertneqq}{≨}");
U("\\ngeqq", "\\html@mathml{\\@ngeqq}{≱}");
U("\\ngeqslant", "\\html@mathml{\\@ngeqslant}{≱}");
U("\\nleqq", "\\html@mathml{\\@nleqq}{≰}");
U("\\nleqslant", "\\html@mathml{\\@nleqslant}{≰}");
U("\\nshortmid", "\\html@mathml{\\@nshortmid}{∤}");
U("\\nshortparallel", "\\html@mathml{\\@nshortparallel}{∦}");
U("\\nsubseteqq", "\\html@mathml{\\@nsubseteqq}{⊈}");
U("\\nsupseteqq", "\\html@mathml{\\@nsupseteqq}{⊉}");
U("\\varsubsetneq", "\\html@mathml{\\@varsubsetneq}{⊊}");
U("\\varsubsetneqq", "\\html@mathml{\\@varsubsetneqq}{⫋}");
U("\\varsupsetneq", "\\html@mathml{\\@varsupsetneq}{⊋}");
U("\\varsupsetneqq", "\\html@mathml{\\@varsupsetneqq}{⫌}");
U("\\imath", "\\html@mathml{\\@imath}{ı}");
U("\\jmath", "\\html@mathml{\\@jmath}{ȷ}");
U("\\llbracket", "\\html@mathml{\\mathopen{[\\mkern-3.2mu[}}{\\mathopen{\\char`⟦}}");
U("\\rrbracket", "\\html@mathml{\\mathclose{]\\mkern-3.2mu]}}{\\mathclose{\\char`⟧}}");
U("⟦", "\\llbracket");
U("⟧", "\\rrbracket");
U("\\lBrace", "\\html@mathml{\\mathopen{\\{\\mkern-3.2mu[}}{\\mathopen{\\char`⦃}}");
U("\\rBrace", "\\html@mathml{\\mathclose{]\\mkern-3.2mu\\}}}{\\mathclose{\\char`⦄}}");
U("⦃", "\\lBrace");
U("⦄", "\\rBrace");
U("\\minuso", "\\mathbin{\\html@mathml{{\\mathrlap{\\mathchoice{\\kern{0.145em}}{\\kern{0.145em}}{\\kern{0.1015em}}{\\kern{0.0725em}}\\circ}{-}}}{\\char`⦵}}");
U("⦵", "\\minuso");
U("\\darr", "\\downarrow");
U("\\dArr", "\\Downarrow");
U("\\Darr", "\\Downarrow");
U("\\lang", "\\langle");
U("\\rang", "\\rangle");
U("\\uarr", "\\uparrow");
U("\\uArr", "\\Uparrow");
U("\\Uarr", "\\Uparrow");
U("\\N", "\\mathbb{N}");
U("\\R", "\\mathbb{R}");
U("\\Z", "\\mathbb{Z}");
U("\\alef", "\\aleph");
U("\\alefsym", "\\aleph");
U("\\Alpha", "\\mathrm{A}");
U("\\Beta", "\\mathrm{B}");
U("\\bull", "\\bullet");
U("\\Chi", "\\mathrm{X}");
U("\\clubs", "\\clubsuit");
U("\\cnums", "\\mathbb{C}");
U("\\Complex", "\\mathbb{C}");
U("\\Dagger", "\\ddagger");
U("\\diamonds", "\\diamondsuit");
U("\\empty", "\\emptyset");
U("\\Epsilon", "\\mathrm{E}");
U("\\Eta", "\\mathrm{H}");
U("\\exist", "\\exists");
U("\\harr", "\\leftrightarrow");
U("\\hArr", "\\Leftrightarrow");
U("\\Harr", "\\Leftrightarrow");
U("\\hearts", "\\heartsuit");
U("\\image", "\\Im");
U("\\infin", "\\infty");
U("\\Iota", "\\mathrm{I}");
U("\\isin", "\\in");
U("\\Kappa", "\\mathrm{K}");
U("\\larr", "\\leftarrow");
U("\\lArr", "\\Leftarrow");
U("\\Larr", "\\Leftarrow");
U("\\lrarr", "\\leftrightarrow");
U("\\lrArr", "\\Leftrightarrow");
U("\\Lrarr", "\\Leftrightarrow");
U("\\Mu", "\\mathrm{M}");
U("\\natnums", "\\mathbb{N}");
U("\\Nu", "\\mathrm{N}");
U("\\Omicron", "\\mathrm{O}");
U("\\plusmn", "\\pm");
U("\\rarr", "\\rightarrow");
U("\\rArr", "\\Rightarrow");
U("\\Rarr", "\\Rightarrow");
U("\\real", "\\Re");
U("\\reals", "\\mathbb{R}");
U("\\Reals", "\\mathbb{R}");
U("\\Rho", "\\mathrm{P}");
U("\\sdot", "\\cdot");
U("\\sect", "\\S");
U("\\spades", "\\spadesuit");
U("\\sub", "\\subset");
U("\\sube", "\\subseteq");
U("\\supe", "\\supseteq");
U("\\Tau", "\\mathrm{T}");
U("\\thetasym", "\\vartheta");
U("\\weierp", "\\wp");
U("\\Zeta", "\\mathrm{Z}");
U("\\argmin", "\\DOTSB\\operatorname*{arg\\,min}");
U("\\argmax", "\\DOTSB\\operatorname*{arg\\,max}");
U("\\plim", "\\DOTSB\\mathop{\\operatorname{plim}}\\limits");
U("\\bra", "\\mathinner{\\langle{#1}|}");
U("\\ket", "\\mathinner{|{#1}\\rangle}");
U("\\braket", "\\mathinner{\\langle{#1}\\rangle}");
U("\\Bra", "\\left\\langle#1\\right|");
U("\\Ket", "\\left|#1\\right\\rangle");
var aT = (r) => (t) => {
  var a = t.consumeArg().tokens, i = t.consumeArg().tokens, s = t.consumeArg().tokens, h = t.consumeArg().tokens, d = t.macros.get("|"), y = t.macros.get("\\|");
  t.macros.beginGroup();
  var g = (T) => (R) => {
    r && (R.macros.set("|", d), s.length && R.macros.set("\\|", y));
    var E = T;
    if (!T && s.length) {
      var O = R.future();
      O.text === "|" && (R.popToken(), E = !0);
    }
    return {
      tokens: E ? s : i,
      numArgs: 0
    };
  };
  t.macros.set("|", g(!1)), s.length && t.macros.set("\\|", g(!0));
  var b = t.consumeArg().tokens, x = t.expandTokens([
    ...h,
    ...b,
    ...a
    // reversed
  ]);
  return t.macros.endGroup(), {
    tokens: x.reverse(),
    numArgs: 0
  };
};
U("\\bra@ket", aT(!1));
U("\\bra@set", aT(!0));
U("\\Braket", "\\bra@ket{\\left\\langle}{\\,\\middle\\vert\\,}{\\,\\middle\\vert\\,}{\\right\\rangle}");
U("\\Set", "\\bra@set{\\left\\{\\:}{\\;\\middle\\vert\\;}{\\;\\middle\\Vert\\;}{\\:\\right\\}}");
U("\\set", "\\bra@set{\\{\\,}{\\mid}{}{\\,\\}}");
U("\\angln", "{\\angl n}");
U("\\blue", "\\textcolor{##6495ed}{#1}");
U("\\orange", "\\textcolor{##ffa500}{#1}");
U("\\pink", "\\textcolor{##ff00af}{#1}");
U("\\red", "\\textcolor{##df0030}{#1}");
U("\\green", "\\textcolor{##28ae7b}{#1}");
U("\\gray", "\\textcolor{gray}{#1}");
U("\\purple", "\\textcolor{##9d38bd}{#1}");
U("\\blueA", "\\textcolor{##ccfaff}{#1}");
U("\\blueB", "\\textcolor{##80f6ff}{#1}");
U("\\blueC", "\\textcolor{##63d9ea}{#1}");
U("\\blueD", "\\textcolor{##11accd}{#1}");
U("\\blueE", "\\textcolor{##0c7f99}{#1}");
U("\\tealA", "\\textcolor{##94fff5}{#1}");
U("\\tealB", "\\textcolor{##26edd5}{#1}");
U("\\tealC", "\\textcolor{##01d1c1}{#1}");
U("\\tealD", "\\textcolor{##01a995}{#1}");
U("\\tealE", "\\textcolor{##208170}{#1}");
U("\\greenA", "\\textcolor{##b6ffb0}{#1}");
U("\\greenB", "\\textcolor{##8af281}{#1}");
U("\\greenC", "\\textcolor{##74cf70}{#1}");
U("\\greenD", "\\textcolor{##1fab54}{#1}");
U("\\greenE", "\\textcolor{##0d923f}{#1}");
U("\\goldA", "\\textcolor{##ffd0a9}{#1}");
U("\\goldB", "\\textcolor{##ffbb71}{#1}");
U("\\goldC", "\\textcolor{##ff9c39}{#1}");
U("\\goldD", "\\textcolor{##e07d10}{#1}");
U("\\goldE", "\\textcolor{##a75a05}{#1}");
U("\\redA", "\\textcolor{##fca9a9}{#1}");
U("\\redB", "\\textcolor{##ff8482}{#1}");
U("\\redC", "\\textcolor{##f9685d}{#1}");
U("\\redD", "\\textcolor{##e84d39}{#1}");
U("\\redE", "\\textcolor{##bc2612}{#1}");
U("\\maroonA", "\\textcolor{##ffbde0}{#1}");
U("\\maroonB", "\\textcolor{##ff92c6}{#1}");
U("\\maroonC", "\\textcolor{##ed5fa6}{#1}");
U("\\maroonD", "\\textcolor{##ca337c}{#1}");
U("\\maroonE", "\\textcolor{##9e034e}{#1}");
U("\\purpleA", "\\textcolor{##ddd7ff}{#1}");
U("\\purpleB", "\\textcolor{##c6b9fc}{#1}");
U("\\purpleC", "\\textcolor{##aa87ff}{#1}");
U("\\purpleD", "\\textcolor{##7854ab}{#1}");
U("\\purpleE", "\\textcolor{##543b78}{#1}");
U("\\mintA", "\\textcolor{##f5f9e8}{#1}");
U("\\mintB", "\\textcolor{##edf2df}{#1}");
U("\\mintC", "\\textcolor{##e0e5cc}{#1}");
U("\\grayA", "\\textcolor{##f6f7f7}{#1}");
U("\\grayB", "\\textcolor{##f0f1f2}{#1}");
U("\\grayC", "\\textcolor{##e3e5e6}{#1}");
U("\\grayD", "\\textcolor{##d6d8da}{#1}");
U("\\grayE", "\\textcolor{##babec2}{#1}");
U("\\grayF", "\\textcolor{##888d93}{#1}");
U("\\grayG", "\\textcolor{##626569}{#1}");
U("\\grayH", "\\textcolor{##3b3e40}{#1}");
U("\\grayI", "\\textcolor{##21242c}{#1}");
U("\\kaBlue", "\\textcolor{##314453}{#1}");
U("\\kaGreen", "\\textcolor{##71B307}{#1}");
var lT = {
  "^": !0,
  // Parser.js
  _: !0,
  // Parser.js
  "\\limits": !0,
  // Parser.js
  "\\nolimits": !0
  // Parser.js
};
class DB {
  constructor(t, a, i) {
    this.settings = void 0, this.expansionCount = void 0, this.lexer = void 0, this.macros = void 0, this.stack = void 0, this.mode = void 0, this.settings = a, this.expansionCount = 0, this.feed(t), this.macros = new _B(OB, a.macros), this.mode = i, this.stack = [];
  }
  /**
   * Feed a new input string to the same MacroExpander
   * (with existing macros etc.).
   */
  feed(t) {
    this.lexer = new uS(t, this.settings);
  }
  /**
   * Switches between "text" and "math" modes.
   */
  switchMode(t) {
    this.mode = t;
  }
  /**
   * Start a new group nesting within all namespaces.
   */
  beginGroup() {
    this.macros.beginGroup();
  }
  /**
   * End current group nesting within all namespaces.
   */
  endGroup() {
    this.macros.endGroup();
  }
  /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */
  endGroups() {
    this.macros.endGroups();
  }
  /**
   * Returns the topmost token on the stack, without expanding it.
   * Similar in behavior to TeX's `\futurelet`.
   */
  future() {
    return this.stack.length === 0 && this.pushToken(this.lexer.lex()), this.stack[this.stack.length - 1];
  }
  /**
   * Remove and return the next unexpanded token.
   */
  popToken() {
    return this.future(), this.stack.pop();
  }
  /**
   * Add a given token to the token stack.  In particular, this get be used
   * to put back a token returned from one of the other methods.
   */
  pushToken(t) {
    this.stack.push(t);
  }
  /**
   * Append an array of tokens to the token stack.
   */
  pushTokens(t) {
    this.stack.push(...t);
  }
  /**
   * Find an macro argument without expanding tokens and append the array of
   * tokens to the token stack. Uses Token as a container for the result.
   */
  scanArgument(t) {
    var a, i, s;
    if (t) {
      if (this.consumeSpaces(), this.future().text !== "[")
        return null;
      a = this.popToken(), {
        tokens: s,
        end: i
      } = this.consumeArg(["]"]);
    } else
      ({
        tokens: s,
        start: a,
        end: i
      } = this.consumeArg());
    return this.pushToken(new Li("EOF", i.loc)), this.pushTokens(s), a.range(i, "");
  }
  /**
   * Consume all following space tokens, without expansion.
   */
  consumeSpaces() {
    for (; ; ) {
      var t = this.future();
      if (t.text === " ")
        this.stack.pop();
      else
        break;
    }
  }
  /**
   * Consume an argument from the token stream, and return the resulting array
   * of tokens and start/end token.
   */
  consumeArg(t) {
    var a = [], i = t && t.length > 0;
    i || this.consumeSpaces();
    var s = this.future(), h, d = 0, y = 0;
    do {
      if (h = this.popToken(), a.push(h), h.text === "{")
        ++d;
      else if (h.text === "}") {
        if (--d, d === -1)
          throw new $e("Extra }", h);
      } else if (h.text === "EOF")
        throw new $e("Unexpected end of input in a macro argument, expected '" + (t && i ? t[y] : "}") + "'", h);
      if (t && i)
        if ((d === 0 || d === 1 && t[y] === "{") && h.text === t[y]) {
          if (++y, y === t.length) {
            a.splice(-y, y);
            break;
          }
        } else
          y = 0;
    } while (d !== 0 || i);
    return s.text === "{" && a[a.length - 1].text === "}" && (a.pop(), a.shift()), a.reverse(), {
      tokens: a,
      start: s,
      end: h
    };
  }
  /**
   * Consume the specified number of (delimited) arguments from the token
   * stream and return the resulting array of arguments.
   */
  consumeArgs(t, a) {
    if (a) {
      if (a.length !== t + 1)
        throw new $e("The length of delimiters doesn't match the number of args!");
      for (var i = a[0], s = 0; s < i.length; s++) {
        var h = this.popToken();
        if (i[s] !== h.text)
          throw new $e("Use of the macro doesn't match its definition", h);
      }
    }
    for (var d = [], y = 0; y < t; y++)
      d.push(this.consumeArg(a && a[y + 1]).tokens);
    return d;
  }
  /**
   * Increment `expansionCount` by the specified amount.
   * Throw an error if it exceeds `maxExpand`.
   */
  countExpansion(t) {
    if (this.expansionCount += t, this.expansionCount > this.settings.maxExpand)
      throw new $e("Too many expansions: infinite loop or need to increase maxExpand setting");
  }
  /**
   * Expand the next token only once if possible.
   *
   * If the token is expanded, the resulting tokens will be pushed onto
   * the stack in reverse order, and the number of such tokens will be
   * returned.  This number might be zero or positive.
   *
   * If not, the return value is `false`, and the next token remains at the
   * top of the stack.
   *
   * In either case, the next token will be on the top of the stack,
   * or the stack will be empty (in case of empty expansion
   * and no other tokens).
   *
   * Used to implement `expandAfterFuture` and `expandNextToken`.
   *
   * If expandableOnly, only expandable tokens are expanded and
   * an undefined control sequence results in an error.
   */
  expandOnce(t) {
    var a = this.popToken(), i = a.text, s = a.noexpand ? null : this._getExpansion(i);
    if (s == null || t && s.unexpandable) {
      if (t && s == null && i[0] === "\\" && !this.isDefined(i))
        throw new $e("Undefined control sequence: " + i);
      return this.pushToken(a), !1;
    }
    this.countExpansion(1);
    var h = s.tokens, d = this.consumeArgs(s.numArgs, s.delimiters);
    if (s.numArgs) {
      h = h.slice();
      for (var y = h.length - 1; y >= 0; --y) {
        var g = h[y];
        if (g.text === "#") {
          if (y === 0)
            throw new $e("Incomplete placeholder at end of macro body", g);
          if (g = h[--y], g.text === "#")
            h.splice(y + 1, 1);
          else if (/^[1-9]$/.test(g.text))
            h.splice(y, 2, ...d[+g.text - 1]);
          else
            throw new $e("Not a valid argument number", g);
        }
      }
    }
    return this.pushTokens(h), h.length;
  }
  /**
   * Expand the next token only once (if possible), and return the resulting
   * top token on the stack (without removing anything from the stack).
   * Similar in behavior to TeX's `\expandafter\futurelet`.
   * Equivalent to expandOnce() followed by future().
   */
  expandAfterFuture() {
    return this.expandOnce(), this.future();
  }
  /**
   * Recursively expand first token, then return first non-expandable token.
   */
  expandNextToken() {
    for (; ; )
      if (this.expandOnce() === !1) {
        var t = this.stack.pop();
        return t.treatAsRelax && (t.text = "\\relax"), t;
      }
    throw new Error();
  }
  /**
   * Fully expand the given macro name and return the resulting list of
   * tokens, or return `undefined` if no such macro is defined.
   */
  expandMacro(t) {
    return this.macros.has(t) ? this.expandTokens([new Li(t)]) : void 0;
  }
  /**
   * Fully expand the given token stream and return the resulting list of
   * tokens.  Note that the input tokens are in reverse order, but the
   * output tokens are in forward order.
   */
  expandTokens(t) {
    var a = [], i = this.stack.length;
    for (this.pushTokens(t); this.stack.length > i; )
      if (this.expandOnce(!0) === !1) {
        var s = this.stack.pop();
        s.treatAsRelax && (s.noexpand = !1, s.treatAsRelax = !1), a.push(s);
      }
    return this.countExpansion(a.length), a;
  }
  /**
   * Fully expand the given macro name and return the result as a string,
   * or return `undefined` if no such macro is defined.
   */
  expandMacroAsText(t) {
    var a = this.expandMacro(t);
    return a && a.map((i) => i.text).join("");
  }
  /**
   * Returns the expanded macro as a reversed array of tokens and a macro
   * argument count.  Or returns `null` if no such macro.
   */
  _getExpansion(t) {
    var a = this.macros.get(t);
    if (a == null)
      return a;
    if (t.length === 1) {
      var i = this.lexer.catcodes[t];
      if (i != null && i !== 13)
        return;
    }
    var s = typeof a == "function" ? a(this) : a;
    if (typeof s == "string") {
      var h = 0;
      if (s.indexOf("#") !== -1)
        for (var d = s.replace(/##/g, ""); d.indexOf("#" + (h + 1)) !== -1; )
          ++h;
      for (var y = new uS(s, this.settings), g = [], b = y.lex(); b.text !== "EOF"; )
        g.push(b), b = y.lex();
      g.reverse();
      var x = {
        tokens: g,
        numArgs: h
      };
      return x;
    }
    return s;
  }
  /**
   * Determine whether a command is currently "defined" (has some
   * functionality), meaning that it's a macro (in the current group),
   * a function, a symbol, or one of the special commands listed in
   * `implicitCommands`.
   */
  isDefined(t) {
    return this.macros.has(t) || r0.hasOwnProperty(t) || Bn.math.hasOwnProperty(t) || Bn.text.hasOwnProperty(t) || lT.hasOwnProperty(t);
  }
  /**
   * Determine whether a command is expandable.
   */
  isExpandable(t) {
    var a = this.macros.get(t);
    return a != null ? typeof a == "string" || typeof a == "function" || !a.unexpandable : r0.hasOwnProperty(t) && !r0[t].primitive;
  }
}
var cS = /^[₊₋₌₍₎₀₁₂₃₄₅₆₇₈₉ₐₑₕᵢⱼₖₗₘₙₒₚᵣₛₜᵤᵥₓᵦᵧᵨᵩᵪ]/, bv = Object.freeze({
  "₊": "+",
  "₋": "-",
  "₌": "=",
  "₍": "(",
  "₎": ")",
  "₀": "0",
  "₁": "1",
  "₂": "2",
  "₃": "3",
  "₄": "4",
  "₅": "5",
  "₆": "6",
  "₇": "7",
  "₈": "8",
  "₉": "9",
  "ₐ": "a",
  "ₑ": "e",
  "ₕ": "h",
  "ᵢ": "i",
  "ⱼ": "j",
  "ₖ": "k",
  "ₗ": "l",
  "ₘ": "m",
  "ₙ": "n",
  "ₒ": "o",
  "ₚ": "p",
  "ᵣ": "r",
  "ₛ": "s",
  "ₜ": "t",
  "ᵤ": "u",
  "ᵥ": "v",
  "ₓ": "x",
  "ᵦ": "β",
  "ᵧ": "γ",
  "ᵨ": "ρ",
  "ᵩ": "ϕ",
  "ᵪ": "χ",
  "⁺": "+",
  "⁻": "-",
  "⁼": "=",
  "⁽": "(",
  "⁾": ")",
  "⁰": "0",
  "¹": "1",
  "²": "2",
  "³": "3",
  "⁴": "4",
  "⁵": "5",
  "⁶": "6",
  "⁷": "7",
  "⁸": "8",
  "⁹": "9",
  "ᴬ": "A",
  "ᴮ": "B",
  "ᴰ": "D",
  "ᴱ": "E",
  "ᴳ": "G",
  "ᴴ": "H",
  "ᴵ": "I",
  "ᴶ": "J",
  "ᴷ": "K",
  "ᴸ": "L",
  "ᴹ": "M",
  "ᴺ": "N",
  "ᴼ": "O",
  "ᴾ": "P",
  "ᴿ": "R",
  "ᵀ": "T",
  "ᵁ": "U",
  "ⱽ": "V",
  "ᵂ": "W",
  "ᵃ": "a",
  "ᵇ": "b",
  "ᶜ": "c",
  "ᵈ": "d",
  "ᵉ": "e",
  "ᶠ": "f",
  "ᵍ": "g",
  ʰ: "h",
  "ⁱ": "i",
  ʲ: "j",
  "ᵏ": "k",
  ˡ: "l",
  "ᵐ": "m",
  ⁿ: "n",
  "ᵒ": "o",
  "ᵖ": "p",
  ʳ: "r",
  ˢ: "s",
  "ᵗ": "t",
  "ᵘ": "u",
  "ᵛ": "v",
  ʷ: "w",
  ˣ: "x",
  ʸ: "y",
  "ᶻ": "z",
  "ᵝ": "β",
  "ᵞ": "γ",
  "ᵟ": "δ",
  "ᵠ": "ϕ",
  "ᵡ": "χ",
  "ᶿ": "θ"
}), h5 = {
  "́": {
    text: "\\'",
    math: "\\acute"
  },
  "̀": {
    text: "\\`",
    math: "\\grave"
  },
  "̈": {
    text: '\\"',
    math: "\\ddot"
  },
  "̃": {
    text: "\\~",
    math: "\\tilde"
  },
  "̄": {
    text: "\\=",
    math: "\\bar"
  },
  "̆": {
    text: "\\u",
    math: "\\breve"
  },
  "̌": {
    text: "\\v",
    math: "\\check"
  },
  "̂": {
    text: "\\^",
    math: "\\hat"
  },
  "̇": {
    text: "\\.",
    math: "\\dot"
  },
  "̊": {
    text: "\\r",
    math: "\\mathring"
  },
  "̋": {
    text: "\\H"
  },
  "̧": {
    text: "\\c"
  }
}, fS = {
  á: "á",
  à: "à",
  ä: "ä",
  ǟ: "ǟ",
  ã: "ã",
  ā: "ā",
  ă: "ă",
  ắ: "ắ",
  ằ: "ằ",
  ẵ: "ẵ",
  ǎ: "ǎ",
  â: "â",
  ấ: "ấ",
  ầ: "ầ",
  ẫ: "ẫ",
  ȧ: "ȧ",
  ǡ: "ǡ",
  å: "å",
  ǻ: "ǻ",
  ḃ: "ḃ",
  ć: "ć",
  ḉ: "ḉ",
  č: "č",
  ĉ: "ĉ",
  ċ: "ċ",
  ç: "ç",
  ď: "ď",
  ḋ: "ḋ",
  ḑ: "ḑ",
  é: "é",
  è: "è",
  ë: "ë",
  ẽ: "ẽ",
  ē: "ē",
  ḗ: "ḗ",
  ḕ: "ḕ",
  ĕ: "ĕ",
  ḝ: "ḝ",
  ě: "ě",
  ê: "ê",
  ế: "ế",
  ề: "ề",
  ễ: "ễ",
  ė: "ė",
  ȩ: "ȩ",
  ḟ: "ḟ",
  ǵ: "ǵ",
  ḡ: "ḡ",
  ğ: "ğ",
  ǧ: "ǧ",
  ĝ: "ĝ",
  ġ: "ġ",
  ģ: "ģ",
  ḧ: "ḧ",
  ȟ: "ȟ",
  ĥ: "ĥ",
  ḣ: "ḣ",
  ḩ: "ḩ",
  í: "í",
  ì: "ì",
  ï: "ï",
  ḯ: "ḯ",
  ĩ: "ĩ",
  ī: "ī",
  ĭ: "ĭ",
  ǐ: "ǐ",
  î: "î",
  ǰ: "ǰ",
  ĵ: "ĵ",
  ḱ: "ḱ",
  ǩ: "ǩ",
  ķ: "ķ",
  ĺ: "ĺ",
  ľ: "ľ",
  ļ: "ļ",
  ḿ: "ḿ",
  ṁ: "ṁ",
  ń: "ń",
  ǹ: "ǹ",
  ñ: "ñ",
  ň: "ň",
  ṅ: "ṅ",
  ņ: "ņ",
  ó: "ó",
  ò: "ò",
  ö: "ö",
  ȫ: "ȫ",
  õ: "õ",
  ṍ: "ṍ",
  ṏ: "ṏ",
  ȭ: "ȭ",
  ō: "ō",
  ṓ: "ṓ",
  ṑ: "ṑ",
  ŏ: "ŏ",
  ǒ: "ǒ",
  ô: "ô",
  ố: "ố",
  ồ: "ồ",
  ỗ: "ỗ",
  ȯ: "ȯ",
  ȱ: "ȱ",
  ő: "ő",
  ṕ: "ṕ",
  ṗ: "ṗ",
  ŕ: "ŕ",
  ř: "ř",
  ṙ: "ṙ",
  ŗ: "ŗ",
  ś: "ś",
  ṥ: "ṥ",
  š: "š",
  ṧ: "ṧ",
  ŝ: "ŝ",
  ṡ: "ṡ",
  ş: "ş",
  ẗ: "ẗ",
  ť: "ť",
  ṫ: "ṫ",
  ţ: "ţ",
  ú: "ú",
  ù: "ù",
  ü: "ü",
  ǘ: "ǘ",
  ǜ: "ǜ",
  ǖ: "ǖ",
  ǚ: "ǚ",
  ũ: "ũ",
  ṹ: "ṹ",
  ū: "ū",
  ṻ: "ṻ",
  ŭ: "ŭ",
  ǔ: "ǔ",
  û: "û",
  ů: "ů",
  ű: "ű",
  ṽ: "ṽ",
  ẃ: "ẃ",
  ẁ: "ẁ",
  ẅ: "ẅ",
  ŵ: "ŵ",
  ẇ: "ẇ",
  ẘ: "ẘ",
  ẍ: "ẍ",
  ẋ: "ẋ",
  ý: "ý",
  ỳ: "ỳ",
  ÿ: "ÿ",
  ỹ: "ỹ",
  ȳ: "ȳ",
  ŷ: "ŷ",
  ẏ: "ẏ",
  ẙ: "ẙ",
  ź: "ź",
  ž: "ž",
  ẑ: "ẑ",
  ż: "ż",
  Á: "Á",
  À: "À",
  Ä: "Ä",
  Ǟ: "Ǟ",
  Ã: "Ã",
  Ā: "Ā",
  Ă: "Ă",
  Ắ: "Ắ",
  Ằ: "Ằ",
  Ẵ: "Ẵ",
  Ǎ: "Ǎ",
  Â: "Â",
  Ấ: "Ấ",
  Ầ: "Ầ",
  Ẫ: "Ẫ",
  Ȧ: "Ȧ",
  Ǡ: "Ǡ",
  Å: "Å",
  Ǻ: "Ǻ",
  Ḃ: "Ḃ",
  Ć: "Ć",
  Ḉ: "Ḉ",
  Č: "Č",
  Ĉ: "Ĉ",
  Ċ: "Ċ",
  Ç: "Ç",
  Ď: "Ď",
  Ḋ: "Ḋ",
  Ḑ: "Ḑ",
  É: "É",
  È: "È",
  Ë: "Ë",
  Ẽ: "Ẽ",
  Ē: "Ē",
  Ḗ: "Ḗ",
  Ḕ: "Ḕ",
  Ĕ: "Ĕ",
  Ḝ: "Ḝ",
  Ě: "Ě",
  Ê: "Ê",
  Ế: "Ế",
  Ề: "Ề",
  Ễ: "Ễ",
  Ė: "Ė",
  Ȩ: "Ȩ",
  Ḟ: "Ḟ",
  Ǵ: "Ǵ",
  Ḡ: "Ḡ",
  Ğ: "Ğ",
  Ǧ: "Ǧ",
  Ĝ: "Ĝ",
  Ġ: "Ġ",
  Ģ: "Ģ",
  Ḧ: "Ḧ",
  Ȟ: "Ȟ",
  Ĥ: "Ĥ",
  Ḣ: "Ḣ",
  Ḩ: "Ḩ",
  Í: "Í",
  Ì: "Ì",
  Ï: "Ï",
  Ḯ: "Ḯ",
  Ĩ: "Ĩ",
  Ī: "Ī",
  Ĭ: "Ĭ",
  Ǐ: "Ǐ",
  Î: "Î",
  İ: "İ",
  Ĵ: "Ĵ",
  Ḱ: "Ḱ",
  Ǩ: "Ǩ",
  Ķ: "Ķ",
  Ĺ: "Ĺ",
  Ľ: "Ľ",
  Ļ: "Ļ",
  Ḿ: "Ḿ",
  Ṁ: "Ṁ",
  Ń: "Ń",
  Ǹ: "Ǹ",
  Ñ: "Ñ",
  Ň: "Ň",
  Ṅ: "Ṅ",
  Ņ: "Ņ",
  Ó: "Ó",
  Ò: "Ò",
  Ö: "Ö",
  Ȫ: "Ȫ",
  Õ: "Õ",
  Ṍ: "Ṍ",
  Ṏ: "Ṏ",
  Ȭ: "Ȭ",
  Ō: "Ō",
  Ṓ: "Ṓ",
  Ṑ: "Ṑ",
  Ŏ: "Ŏ",
  Ǒ: "Ǒ",
  Ô: "Ô",
  Ố: "Ố",
  Ồ: "Ồ",
  Ỗ: "Ỗ",
  Ȯ: "Ȯ",
  Ȱ: "Ȱ",
  Ő: "Ő",
  Ṕ: "Ṕ",
  Ṗ: "Ṗ",
  Ŕ: "Ŕ",
  Ř: "Ř",
  Ṙ: "Ṙ",
  Ŗ: "Ŗ",
  Ś: "Ś",
  Ṥ: "Ṥ",
  Š: "Š",
  Ṧ: "Ṧ",
  Ŝ: "Ŝ",
  Ṡ: "Ṡ",
  Ş: "Ş",
  Ť: "Ť",
  Ṫ: "Ṫ",
  Ţ: "Ţ",
  Ú: "Ú",
  Ù: "Ù",
  Ü: "Ü",
  Ǘ: "Ǘ",
  Ǜ: "Ǜ",
  Ǖ: "Ǖ",
  Ǚ: "Ǚ",
  Ũ: "Ũ",
  Ṹ: "Ṹ",
  Ū: "Ū",
  Ṻ: "Ṻ",
  Ŭ: "Ŭ",
  Ǔ: "Ǔ",
  Û: "Û",
  Ů: "Ů",
  Ű: "Ű",
  Ṽ: "Ṽ",
  Ẃ: "Ẃ",
  Ẁ: "Ẁ",
  Ẅ: "Ẅ",
  Ŵ: "Ŵ",
  Ẇ: "Ẇ",
  Ẍ: "Ẍ",
  Ẋ: "Ẋ",
  Ý: "Ý",
  Ỳ: "Ỳ",
  Ÿ: "Ÿ",
  Ỹ: "Ỹ",
  Ȳ: "Ȳ",
  Ŷ: "Ŷ",
  Ẏ: "Ẏ",
  Ź: "Ź",
  Ž: "Ž",
  Ẑ: "Ẑ",
  Ż: "Ż",
  ά: "ά",
  ὰ: "ὰ",
  ᾱ: "ᾱ",
  ᾰ: "ᾰ",
  έ: "έ",
  ὲ: "ὲ",
  ή: "ή",
  ὴ: "ὴ",
  ί: "ί",
  ὶ: "ὶ",
  ϊ: "ϊ",
  ΐ: "ΐ",
  ῒ: "ῒ",
  ῑ: "ῑ",
  ῐ: "ῐ",
  ό: "ό",
  ὸ: "ὸ",
  ύ: "ύ",
  ὺ: "ὺ",
  ϋ: "ϋ",
  ΰ: "ΰ",
  ῢ: "ῢ",
  ῡ: "ῡ",
  ῠ: "ῠ",
  ώ: "ώ",
  ὼ: "ὼ",
  Ύ: "Ύ",
  Ὺ: "Ὺ",
  Ϋ: "Ϋ",
  Ῡ: "Ῡ",
  Ῠ: "Ῠ",
  Ώ: "Ώ",
  Ὼ: "Ὼ"
};
class r3 {
  constructor(t, a) {
    this.mode = void 0, this.gullet = void 0, this.settings = void 0, this.leftrightDepth = void 0, this.nextToken = void 0, this.mode = "math", this.gullet = new DB(t, a, this.mode), this.settings = a, this.leftrightDepth = 0;
  }
  /**
   * Checks a result to make sure it has the right type, and throws an
   * appropriate error otherwise.
   */
  expect(t, a) {
    if (a === void 0 && (a = !0), this.fetch().text !== t)
      throw new $e("Expected '" + t + "', got '" + this.fetch().text + "'", this.fetch());
    a && this.consume();
  }
  /**
   * Discards the current lookahead token, considering it consumed.
   */
  consume() {
    this.nextToken = null;
  }
  /**
   * Return the current lookahead token, or if there isn't one (at the
   * beginning, or if the previous lookahead token was consume()d),
   * fetch the next token as the new lookahead token and return it.
   */
  fetch() {
    return this.nextToken == null && (this.nextToken = this.gullet.expandNextToken()), this.nextToken;
  }
  /**
   * Switches between "text" and "math" modes.
   */
  switchMode(t) {
    this.mode = t, this.gullet.switchMode(t);
  }
  /**
   * Main parsing function, which parses an entire input.
   */
  parse() {
    this.settings.globalGroup || this.gullet.beginGroup(), this.settings.colorIsTextColor && this.gullet.macros.set("\\color", "\\textcolor");
    try {
      var t = this.parseExpression(!1);
      return this.expect("EOF"), this.settings.globalGroup || this.gullet.endGroup(), t;
    } finally {
      this.gullet.endGroups();
    }
  }
  /**
   * Fully parse a separate sequence of tokens as a separate job.
   * Tokens should be specified in reverse order, as in a MacroDefinition.
   */
  subparse(t) {
    var a = this.nextToken;
    this.consume(), this.gullet.pushToken(new Li("}")), this.gullet.pushTokens(t);
    var i = this.parseExpression(!1);
    return this.expect("}"), this.nextToken = a, i;
  }
  /**
   * Parses an "expression", which is a list of atoms.
   *
   * `breakOnInfix`: Should the parsing stop when we hit infix nodes? This
   *                 happens when functions have higher precedence han infix
   *                 nodes in implicit parses.
   *
   * `breakOnTokenText`: The text of the token that the expression should end
   *                     with, or `null` if something else should end the
   *                     expression.
   */
  parseExpression(t, a) {
    for (var i = []; ; ) {
      this.mode === "math" && this.consumeSpaces();
      var s = this.fetch();
      if (r3.endOfExpression.indexOf(s.text) !== -1 || a && s.text === a || t && r0[s.text] && r0[s.text].infix)
        break;
      var h = this.parseAtom(a);
      if (h) {
        if (h.type === "internal")
          continue;
      } else break;
      i.push(h);
    }
    return this.mode === "text" && this.formLigatures(i), this.handleInfixNodes(i);
  }
  /**
   * Rewrites infix operators such as \over with corresponding commands such
   * as \frac.
   *
   * There can only be one infix operator per group.  If there's more than one
   * then the expression is ambiguous.  This can be resolved by adding {}.
   */
  handleInfixNodes(t) {
    for (var a = -1, i, s = 0; s < t.length; s++)
      if (t[s].type === "infix") {
        if (a !== -1)
          throw new $e("only one infix operator per group", t[s].token);
        a = s, i = t[s].replaceWith;
      }
    if (a !== -1 && i) {
      var h, d, y = t.slice(0, a), g = t.slice(a + 1);
      y.length === 1 && y[0].type === "ordgroup" ? h = y[0] : h = {
        type: "ordgroup",
        mode: this.mode,
        body: y
      }, g.length === 1 && g[0].type === "ordgroup" ? d = g[0] : d = {
        type: "ordgroup",
        mode: this.mode,
        body: g
      };
      var b;
      return i === "\\\\abovefrac" ? b = this.callFunction(i, [h, t[a], d], []) : b = this.callFunction(i, [h, d], []), [b];
    } else
      return t;
  }
  /**
   * Handle a subscript or superscript with nice errors.
   */
  handleSupSubscript(t) {
    var a = this.fetch(), i = a.text;
    this.consume(), this.consumeSpaces();
    var s;
    do {
      var h;
      s = this.parseGroup(t);
    } while (((h = s) == null ? void 0 : h.type) === "internal");
    if (!s)
      throw new $e("Expected group after '" + i + "'", a);
    return s;
  }
  /**
   * Converts the textual input of an unsupported command into a text node
   * contained within a color node whose color is determined by errorColor
   */
  formatUnsupportedCmd(t) {
    for (var a = [], i = 0; i < t.length; i++)
      a.push({
        type: "textord",
        mode: "text",
        text: t[i]
      });
    var s = {
      type: "text",
      mode: this.mode,
      body: a
    }, h = {
      type: "color",
      mode: this.mode,
      color: this.settings.errorColor,
      body: [s]
    };
    return h;
  }
  /**
   * Parses a group with optional super/subscripts.
   */
  parseAtom(t) {
    var a = this.parseGroup("atom", t);
    if ((a == null ? void 0 : a.type) === "internal" || this.mode === "text")
      return a;
    for (var i, s; ; ) {
      this.consumeSpaces();
      var h = this.fetch();
      if (h.text === "\\limits" || h.text === "\\nolimits") {
        if (a && a.type === "op") {
          var d = h.text === "\\limits";
          a.limits = d, a.alwaysHandleSupSub = !0;
        } else if (a && a.type === "operatorname")
          a.alwaysHandleSupSub && (a.limits = h.text === "\\limits");
        else
          throw new $e("Limit controls must follow a math operator", h);
        this.consume();
      } else if (h.text === "^") {
        if (i)
          throw new $e("Double superscript", h);
        i = this.handleSupSubscript("superscript");
      } else if (h.text === "_") {
        if (s)
          throw new $e("Double subscript", h);
        s = this.handleSupSubscript("subscript");
      } else if (h.text === "'") {
        if (i)
          throw new $e("Double superscript", h);
        var y = {
          type: "textord",
          mode: this.mode,
          text: "\\prime"
        }, g = [y];
        for (this.consume(); this.fetch().text === "'"; )
          g.push(y), this.consume();
        this.fetch().text === "^" && g.push(this.handleSupSubscript("superscript")), i = {
          type: "ordgroup",
          mode: this.mode,
          body: g
        };
      } else if (bv[h.text]) {
        var b = cS.test(h.text), x = [];
        for (x.push(new Li(bv[h.text])), this.consume(); ; ) {
          var T = this.fetch().text;
          if (!bv[T] || cS.test(T) !== b)
            break;
          x.unshift(new Li(bv[T])), this.consume();
        }
        var R = this.subparse(x);
        b ? s = {
          type: "ordgroup",
          mode: "math",
          body: R
        } : i = {
          type: "ordgroup",
          mode: "math",
          body: R
        };
      } else
        break;
    }
    return i || s ? {
      type: "supsub",
      mode: this.mode,
      base: a,
      sup: i,
      sub: s
    } : a;
  }
  /**
   * Parses an entire function, including its base and all of its arguments.
   */
  parseFunction(t, a) {
    var i = this.fetch(), s = i.text, h = r0[s];
    if (!h)
      return null;
    if (this.consume(), a && a !== "atom" && !h.allowedInArgument)
      throw new $e("Got function '" + s + "' with no arguments" + (a ? " as " + a : ""), i);
    if (this.mode === "text" && !h.allowedInText)
      throw new $e("Can't use function '" + s + "' in text mode", i);
    if (this.mode === "math" && h.allowedInMath === !1)
      throw new $e("Can't use function '" + s + "' in math mode", i);
    var {
      args: d,
      optArgs: y
    } = this.parseArguments(s, h);
    return this.callFunction(s, d, y, i, t);
  }
  /**
   * Call a function handler with a suitable context and arguments.
   */
  callFunction(t, a, i, s, h) {
    var d = {
      funcName: t,
      parser: this,
      token: s,
      breakOnTokenText: h
    }, y = r0[t];
    if (y && y.handler)
      return y.handler(d, a, i);
    throw new $e("No function handler for " + t);
  }
  /**
   * Parses the arguments of a function or environment
   */
  parseArguments(t, a) {
    var i = a.numArgs + a.numOptionalArgs;
    if (i === 0)
      return {
        args: [],
        optArgs: []
      };
    for (var s = [], h = [], d = 0; d < i; d++) {
      var y = a.argTypes && a.argTypes[d], g = d < a.numOptionalArgs;
      (a.primitive && y == null || // \sqrt expands into primitive if optional argument doesn't exist
      a.type === "sqrt" && d === 1 && h[0] == null) && (y = "primitive");
      var b = this.parseGroupOfType("argument to '" + t + "'", y, g);
      if (g)
        h.push(b);
      else if (b != null)
        s.push(b);
      else
        throw new $e("Null argument, please report this as a bug");
    }
    return {
      args: s,
      optArgs: h
    };
  }
  /**
   * Parses a group when the mode is changing.
   */
  parseGroupOfType(t, a, i) {
    switch (a) {
      case "color":
        return this.parseColorGroup(i);
      case "size":
        return this.parseSizeGroup(i);
      case "url":
        return this.parseUrlGroup(i);
      case "math":
      case "text":
        return this.parseArgumentGroup(i, a);
      case "hbox": {
        var s = this.parseArgumentGroup(i, "text");
        return s != null ? {
          type: "styling",
          mode: s.mode,
          body: [s],
          style: "text"
          // simulate \textstyle
        } : null;
      }
      case "raw": {
        var h = this.parseStringGroup("raw", i);
        return h != null ? {
          type: "raw",
          mode: "text",
          string: h.text
        } : null;
      }
      case "primitive": {
        if (i)
          throw new $e("A primitive argument cannot be optional");
        var d = this.parseGroup(t);
        if (d == null)
          throw new $e("Expected group as " + t, this.fetch());
        return d;
      }
      case "original":
      case null:
      case void 0:
        return this.parseArgumentGroup(i);
      default:
        throw new $e("Unknown group type as " + t, this.fetch());
    }
  }
  /**
   * Discard any space tokens, fetching the next non-space token.
   */
  consumeSpaces() {
    for (; this.fetch().text === " "; )
      this.consume();
  }
  /**
   * Parses a group, essentially returning the string formed by the
   * brace-enclosed tokens plus some position information.
   */
  parseStringGroup(t, a) {
    var i = this.gullet.scanArgument(a);
    if (i == null)
      return null;
    for (var s = "", h; (h = this.fetch()).text !== "EOF"; )
      s += h.text, this.consume();
    return this.consume(), i.text = s, i;
  }
  /**
   * Parses a regex-delimited group: the largest sequence of tokens
   * whose concatenated strings match `regex`. Returns the string
   * formed by the tokens plus some position information.
   */
  parseRegexGroup(t, a) {
    for (var i = this.fetch(), s = i, h = "", d; (d = this.fetch()).text !== "EOF" && t.test(h + d.text); )
      s = d, h += s.text, this.consume();
    if (h === "")
      throw new $e("Invalid " + a + ": '" + i.text + "'", i);
    return i.range(s, h);
  }
  /**
   * Parses a color description.
   */
  parseColorGroup(t) {
    var a = this.parseStringGroup("color", t);
    if (a == null)
      return null;
    var i = /^(#[a-f0-9]{3}|#?[a-f0-9]{6}|[a-z]+)$/i.exec(a.text);
    if (!i)
      throw new $e("Invalid color: '" + a.text + "'", a);
    var s = i[0];
    return /^[0-9a-f]{6}$/i.test(s) && (s = "#" + s), {
      type: "color-token",
      mode: this.mode,
      color: s
    };
  }
  /**
   * Parses a size specification, consisting of magnitude and unit.
   */
  parseSizeGroup(t) {
    var a, i = !1;
    if (this.gullet.consumeSpaces(), !t && this.gullet.future().text !== "{" ? a = this.parseRegexGroup(/^[-+]? *(?:$|\d+|\d+\.\d*|\.\d*) *[a-z]{0,2} *$/, "size") : a = this.parseStringGroup("size", t), !a)
      return null;
    !t && a.text.length === 0 && (a.text = "0pt", i = !0);
    var s = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(a.text);
    if (!s)
      throw new $e("Invalid size: '" + a.text + "'", a);
    var h = {
      number: +(s[1] + s[2]),
      // sign + magnitude, cast to number
      unit: s[3]
    };
    if (!pw(h))
      throw new $e("Invalid unit: '" + h.unit + "'", a);
    return {
      type: "size",
      mode: this.mode,
      value: h,
      isBlank: i
    };
  }
  /**
   * Parses an URL, checking escaped letters and allowed protocols,
   * and setting the catcode of % as an active character (as in \hyperref).
   */
  parseUrlGroup(t) {
    this.gullet.lexer.setCatcode("%", 13), this.gullet.lexer.setCatcode("~", 12);
    var a = this.parseStringGroup("url", t);
    if (this.gullet.lexer.setCatcode("%", 14), this.gullet.lexer.setCatcode("~", 13), a == null)
      return null;
    var i = a.text.replace(/\\([#$%&~_^{}])/g, "$1");
    return {
      type: "url",
      mode: this.mode,
      url: i
    };
  }
  /**
   * Parses an argument with the mode specified.
   */
  parseArgumentGroup(t, a) {
    var i = this.gullet.scanArgument(t);
    if (i == null)
      return null;
    var s = this.mode;
    a && this.switchMode(a), this.gullet.beginGroup();
    var h = this.parseExpression(!1, "EOF");
    this.expect("EOF"), this.gullet.endGroup();
    var d = {
      type: "ordgroup",
      mode: this.mode,
      loc: i.loc,
      body: h
    };
    return a && this.switchMode(s), d;
  }
  /**
   * Parses an ordinary group, which is either a single nucleus (like "x")
   * or an expression in braces (like "{x+y}") or an implicit group, a group
   * that starts at the current position, and ends right before a higher explicit
   * group ends, or at EOF.
   */
  parseGroup(t, a) {
    var i = this.fetch(), s = i.text, h;
    if (s === "{" || s === "\\begingroup") {
      this.consume();
      var d = s === "{" ? "}" : "\\endgroup";
      this.gullet.beginGroup();
      var y = this.parseExpression(!1, d), g = this.fetch();
      this.expect(d), this.gullet.endGroup(), h = {
        type: "ordgroup",
        mode: this.mode,
        loc: ei.range(i, g),
        body: y,
        // A group formed by \begingroup...\endgroup is a semi-simple group
        // which doesn't affect spacing in math mode, i.e., is transparent.
        // https://tex.stackexchange.com/questions/1930/when-should-one-
        // use-begingroup-instead-of-bgroup
        semisimple: s === "\\begingroup" || void 0
      };
    } else if (h = this.parseFunction(a, t) || this.parseSymbol(), h == null && s[0] === "\\" && !lT.hasOwnProperty(s)) {
      if (this.settings.throwOnError)
        throw new $e("Undefined control sequence: " + s, i);
      h = this.formatUnsupportedCmd(s), this.consume();
    }
    return h;
  }
  /**
   * Form ligature-like combinations of characters for text mode.
   * This includes inputs like "--", "---", "``" and "''".
   * The result will simply replace multiple textord nodes with a single
   * character in each value by a single textord node having multiple
   * characters in its value.  The representation is still ASCII source.
   * The group will be modified in place.
   */
  formLigatures(t) {
    for (var a = t.length - 1, i = 0; i < a; ++i) {
      var s = t[i], h = s.text;
      h === "-" && t[i + 1].text === "-" && (i + 1 < a && t[i + 2].text === "-" ? (t.splice(i, 3, {
        type: "textord",
        mode: "text",
        loc: ei.range(s, t[i + 2]),
        text: "---"
      }), a -= 2) : (t.splice(i, 2, {
        type: "textord",
        mode: "text",
        loc: ei.range(s, t[i + 1]),
        text: "--"
      }), a -= 1)), (h === "'" || h === "`") && t[i + 1].text === h && (t.splice(i, 2, {
        type: "textord",
        mode: "text",
        loc: ei.range(s, t[i + 1]),
        text: h + h
      }), a -= 1);
    }
  }
  /**
   * Parse a single symbol out of the string. Here, we handle single character
   * symbols and special functions like \verb.
   */
  parseSymbol() {
    var t = this.fetch(), a = t.text;
    if (/^\\verb[^a-zA-Z]/.test(a)) {
      this.consume();
      var i = a.slice(5), s = i.charAt(0) === "*";
      if (s && (i = i.slice(1)), i.length < 2 || i.charAt(0) !== i.slice(-1))
        throw new $e(`\\verb assertion failed --
                    please report what input caused this bug`);
      return i = i.slice(1, -1), {
        type: "verb",
        mode: "text",
        body: i,
        star: s
      };
    }
    fS.hasOwnProperty(a[0]) && !Bn[this.mode][a[0]] && (this.settings.strict && this.mode === "math" && this.settings.reportNonstrict("unicodeTextInMathMode", 'Accented Unicode text character "' + a[0] + '" used in math mode', t), a = fS[a[0]] + a.slice(1));
    var h = CB.exec(a);
    h && (a = a.substring(0, h.index), a === "i" ? a = "ı" : a === "j" && (a = "ȷ"));
    var d;
    if (Bn[this.mode][a]) {
      this.settings.strict && this.mode === "math" && B5.indexOf(a) >= 0 && this.settings.reportNonstrict("unicodeTextInMathMode", 'Latin-1/Unicode text character "' + a[0] + '" used in math mode', t);
      var y = Bn[this.mode][a].group, g = ei.range(t), b;
      if (xL.hasOwnProperty(y)) {
        var x = y;
        b = {
          type: "atom",
          mode: this.mode,
          family: x,
          loc: g,
          text: a
        };
      } else
        b = {
          type: y,
          mode: this.mode,
          loc: g,
          text: a
        };
      d = b;
    } else if (a.charCodeAt(0) >= 128)
      this.settings.strict && (mw(a.charCodeAt(0)) ? this.mode === "math" && this.settings.reportNonstrict("unicodeTextInMathMode", 'Unicode text character "' + a[0] + '" used in math mode', t) : this.settings.reportNonstrict("unknownSymbol", 'Unrecognized Unicode character "' + a[0] + '"' + (" (" + a.charCodeAt(0) + ")"), t)), d = {
        type: "textord",
        mode: "text",
        loc: ei.range(t),
        text: a
      };
    else
      return null;
    if (this.consume(), h)
      for (var T = 0; T < h[0].length; T++) {
        var R = h[0][T];
        if (!h5[R])
          throw new $e("Unknown accent ' " + R + "'", t);
        var E = h5[R][this.mode] || h5[R].text;
        if (!E)
          throw new $e("Accent " + R + " unsupported in " + this.mode + " mode", t);
        d = {
          type: "accent",
          mode: this.mode,
          loc: ei.range(t),
          label: E,
          isStretchy: !1,
          isShifty: !0,
          // $FlowFixMe
          base: d
        };
      }
    return d;
  }
}
r3.endOfExpression = ["}", "\\endgroup", "\\end", "\\right", "&"];
var Q7 = function(t, a) {
  if (!(typeof t == "string" || t instanceof String))
    throw new TypeError("KaTeX can only parse string typed expression");
  var i = new r3(t, a);
  delete i.gullet.macros.current["\\df@tag"];
  var s = i.parse();
  if (delete i.gullet.macros.current["\\current@color"], delete i.gullet.macros.current["\\color"], i.gullet.macros.get("\\df@tag")) {
    if (!a.displayMode)
      throw new $e("\\tag works only in display equations");
    s = [{
      type: "tag",
      mode: "text",
      body: s,
      tag: i.subparse([new Li("\\df@tag")])
    }];
  }
  return s;
}, iT = function(t, a, i) {
  a.textContent = "";
  var s = Z7(t, i).toNode();
  a.appendChild(s);
};
typeof document < "u" && document.compatMode !== "CSS1Compat" && (typeof console < "u" && console.warn("Warning: KaTeX doesn't work in quirks mode. Make sure your website has a suitable doctype."), iT = function() {
  throw new $e("KaTeX doesn't work in quirks mode.");
});
var NB = function(t, a) {
  var i = Z7(t, a).toMarkup();
  return i;
}, LB = function(t, a) {
  var i = new C7(a);
  return Q7(t, i);
}, uT = function(t, a, i) {
  if (i.throwOnError || !(t instanceof $e))
    throw t;
  var s = ge.makeSpan(["katex-error"], [new qi(a)]);
  return s.setAttribute("title", t.toString()), s.setAttribute("style", "color:" + i.errorColor), s;
}, Z7 = function(t, a) {
  var i = new C7(a);
  try {
    var s = Q7(t, i);
    return IL(s, t, i);
  } catch (h) {
    return uT(h, t, i);
  }
}, BB = function(t, a) {
  var i = new C7(a);
  try {
    var s = Q7(t, i);
    return $L(s, t, i);
  } catch (h) {
    return uT(h, t, i);
  }
}, HB = "0.16.22", UB = {
  Span: i4,
  Anchor: O7,
  SymbolNode: qi,
  SvgNode: As,
  PathNode: l0,
  LineNode: L5
}, hS = {
  /**
   * Current KaTeX version
   */
  version: HB,
  /**
   * Renders the given LaTeX into an HTML+MathML combination, and adds
   * it as a child to the specified DOM node.
   */
  render: iT,
  /**
   * Renders the given LaTeX into an HTML+MathML combination string,
   * for sending to the client.
   */
  renderToString: NB,
  /**
   * KaTeX error, usually during parsing.
   */
  ParseError: $e,
  /**
   * The schema of Settings
   */
  SETTINGS_SCHEMA: kv,
  /**
   * Parses the given LaTeX into KaTeX's internal parse tree structure,
   * without rendering to HTML or MathML.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __parse: LB,
  /**
   * Renders the given LaTeX into an HTML+MathML internal DOM tree
   * representation, without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __renderToDomTree: Z7,
  /**
   * Renders the given LaTeX into an HTML internal DOM tree representation,
   * without MathML and without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __renderToHTMLTree: BB,
  /**
   * extends internal font metrics object with a new object
   * each key in the new object represents a font name
  */
  __setFontMetrics: dL,
  /**
   * adds a new symbol to builtin symbols table
   */
  __defineSymbol: A,
  /**
   * adds a new function to builtin function list,
   * which directly produce parse tree elements
   * and have their own html/mathml builders
   */
  __defineFunction: Ke,
  /**
   * adds a new macro to builtin macro list
   */
  __defineMacro: U,
  /**
   * Expose the dom tree node types, which can be useful for type checking nodes.
   *
   * NOTE: These methods are not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __domTree: UB
};
const qB = {}, jB = [];
function GB(r) {
  const t = r || qB;
  return function(a, i) {
    w7(a, "element", function(s, h) {
      const d = Array.isArray(s.properties.className) ? s.properties.className : jB, y = d.includes("language-math"), g = d.includes("math-display"), b = d.includes("math-inline");
      let x = g;
      if (!y && !g && !b)
        return;
      let T = h[h.length - 1], R = s;
      if (s.tagName === "code" && y && T && T.type === "element" && T.tagName === "pre" && (R = T, T = h[h.length - 2], x = !0), !T) return;
      const E = ON(R, { whitespace: "pre" });
      let O;
      try {
        O = hS.renderToString(E, {
          ...t,
          displayMode: x,
          throwOnError: !0
        });
      } catch (G) {
        const V = (
          /** @type {Error} */
          G
        ), I = V.name.toLowerCase();
        i.message("Could not render math with KaTeX", {
          ancestors: [...h, s],
          cause: V,
          place: s.position,
          ruleId: I,
          source: "rehype-katex"
        });
        try {
          O = hS.renderToString(E, {
            ...t,
            displayMode: x,
            strict: "ignore",
            throwOnError: !1
          });
        } catch {
          O = [
            {
              type: "element",
              tagName: "span",
              properties: {
                className: ["katex-error"],
                style: "color:" + (t.errorColor || "#cc0000"),
                title: String(G)
              },
              children: [{ type: "text", value: E }]
            }
          ];
        }
      }
      typeof O == "string" && (O = /** @type {Array<ElementContent>} */
      EN(O).children);
      const L = T.children.indexOf(R);
      return T.children.splice(L, 1, ...O), Dx;
    });
  };
}
function VB() {
  return {
    enter: {
      mathFlow: r,
      mathFlowFenceMeta: t,
      mathText: h
    },
    exit: {
      mathFlow: s,
      mathFlowFence: i,
      mathFlowFenceMeta: a,
      mathFlowValue: y,
      mathText: d,
      mathTextData: y
    }
  };
  function r(g) {
    const b = {
      type: "element",
      tagName: "code",
      properties: { className: ["language-math", "math-display"] },
      children: []
    };
    this.enter(
      {
        type: "math",
        meta: null,
        value: "",
        data: { hName: "pre", hChildren: [b] }
      },
      g
    );
  }
  function t() {
    this.buffer();
  }
  function a() {
    const g = this.resume(), b = this.stack[this.stack.length - 1];
    b.type, b.meta = g;
  }
  function i() {
    this.data.mathFlowInside || (this.buffer(), this.data.mathFlowInside = !0);
  }
  function s(g) {
    const b = this.resume().replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), x = this.stack[this.stack.length - 1];
    x.type, this.exit(g), x.value = b;
    const T = (
      /** @type {HastElement} */
      x.data.hChildren[0]
    );
    T.type, T.tagName, T.children.push({ type: "text", value: b }), this.data.mathFlowInside = void 0;
  }
  function h(g) {
    this.enter(
      {
        type: "inlineMath",
        value: "",
        data: {
          hName: "code",
          hProperties: { className: ["language-math", "math-inline"] },
          hChildren: []
        }
      },
      g
    ), this.buffer();
  }
  function d(g) {
    const b = this.resume(), x = this.stack[this.stack.length - 1];
    x.type, this.exit(g), x.value = b, /** @type {Array<HastElementContent>} */
    // @ts-expect-error: we defined it in `enterMathFlow`.
    x.data.hChildren.push({ type: "text", value: b });
  }
  function y(g) {
    this.config.enter.data.call(this, g), this.config.exit.data.call(this, g);
  }
}
function YB(r) {
  let t = (r || {}).singleDollarTextMath;
  return t == null && (t = !0), i.peek = s, {
    unsafe: [
      { character: "\r", inConstruct: "mathFlowMeta" },
      { character: `
`, inConstruct: "mathFlowMeta" },
      {
        character: "$",
        after: t ? void 0 : "\\$",
        inConstruct: "phrasing"
      },
      { character: "$", inConstruct: "mathFlowMeta" },
      { atBreak: !0, character: "$", after: "\\$" }
    ],
    handlers: { math: a, inlineMath: i }
  };
  function a(h, d, y, g) {
    const b = h.value || "", x = y.createTracker(g), T = "$".repeat(Math.max(jx(b, "$") + 1, 2)), R = y.enter("mathFlow");
    let E = x.move(T);
    if (h.meta) {
      const O = y.enter("mathFlowMeta");
      E += x.move(
        y.safe(h.meta, {
          after: `
`,
          before: E,
          encode: ["$"],
          ...x.current()
        })
      ), O();
    }
    return E += x.move(`
`), b && (E += x.move(b + `
`)), E += x.move(T), R(), E;
  }
  function i(h, d, y) {
    let g = h.value || "", b = 1;
    for (t || b++; new RegExp("(^|[^$])" + "\\$".repeat(b) + "([^$]|$)").test(g); )
      b++;
    const x = "$".repeat(b);
    // Contains non-space.
    /[^ \r\n]/.test(g) && // Starts with space and ends with space.
    (/^[ \r\n]/.test(g) && /[ \r\n]$/.test(g) || // Starts or ends with dollar.
    /^\$|\$$/.test(g)) && (g = " " + g + " ");
    let T = -1;
    for (; ++T < y.unsafe.length; ) {
      const R = y.unsafe[T];
      if (!R.atBreak) continue;
      const E = y.compilePattern(R);
      let O;
      for (; O = E.exec(g); ) {
        let L = O.index;
        g.codePointAt(L) === 10 && g.codePointAt(L - 1) === 13 && L--, g = g.slice(0, L) + " " + g.slice(O.index + 1);
      }
    }
    return x + g + x;
  }
  function s() {
    return "$";
  }
}
const IB = {
  tokenize: $B,
  concrete: !0,
  name: "mathFlow"
}, dS = {
  tokenize: XB,
  partial: !0
};
function $B(r, t, a) {
  const i = this, s = i.events[i.events.length - 1], h = s && s[1].type === "linePrefix" ? s[2].sliceSerialize(s[1], !0).length : 0;
  let d = 0;
  return y;
  function y(I) {
    return r.enter("mathFlow"), r.enter("mathFlowFence"), r.enter("mathFlowFenceSequence"), g(I);
  }
  function g(I) {
    return I === 36 ? (r.consume(I), d++, g) : d < 2 ? a(I) : (r.exit("mathFlowFenceSequence"), Ft(r, b, "whitespace")(I));
  }
  function b(I) {
    return I === null || ft(I) ? T(I) : (r.enter("mathFlowFenceMeta"), r.enter("chunkString", {
      contentType: "string"
    }), x(I));
  }
  function x(I) {
    return I === null || ft(I) ? (r.exit("chunkString"), r.exit("mathFlowFenceMeta"), T(I)) : I === 36 ? a(I) : (r.consume(I), x);
  }
  function T(I) {
    return r.exit("mathFlowFence"), i.interrupt ? t(I) : r.attempt(dS, R, G)(I);
  }
  function R(I) {
    return r.attempt({
      tokenize: V,
      partial: !0
    }, G, E)(I);
  }
  function E(I) {
    return (h ? Ft(r, O, "linePrefix", h + 1) : O)(I);
  }
  function O(I) {
    return I === null ? G(I) : ft(I) ? r.attempt(dS, R, G)(I) : (r.enter("mathFlowValue"), L(I));
  }
  function L(I) {
    return I === null || ft(I) ? (r.exit("mathFlowValue"), O(I)) : (r.consume(I), L);
  }
  function G(I) {
    return r.exit("mathFlow"), t(I);
  }
  function V(I, $, ce) {
    let se = 0;
    return Ft(I, te, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
    function te(Ne) {
      return I.enter("mathFlowFence"), I.enter("mathFlowFenceSequence"), Ce(Ne);
    }
    function Ce(Ne) {
      return Ne === 36 ? (se++, I.consume(Ne), Ce) : se < d ? ce(Ne) : (I.exit("mathFlowFenceSequence"), Ft(I, ve, "whitespace")(Ne));
    }
    function ve(Ne) {
      return Ne === null || ft(Ne) ? (I.exit("mathFlowFence"), $(Ne)) : ce(Ne);
    }
  }
}
function XB(r, t, a) {
  const i = this;
  return s;
  function s(d) {
    return d === null ? t(d) : (r.enter("lineEnding"), r.consume(d), r.exit("lineEnding"), h);
  }
  function h(d) {
    return i.parser.lazy[i.now().line] ? a(d) : t(d);
  }
}
function QB(r) {
  let a = (r || {}).singleDollarTextMath;
  return a == null && (a = !0), {
    tokenize: i,
    resolve: ZB,
    previous: FB,
    name: "mathText"
  };
  function i(s, h, d) {
    let y = 0, g, b;
    return x;
    function x(L) {
      return s.enter("mathText"), s.enter("mathTextSequence"), T(L);
    }
    function T(L) {
      return L === 36 ? (s.consume(L), y++, T) : y < 2 && !a ? d(L) : (s.exit("mathTextSequence"), R(L));
    }
    function R(L) {
      return L === null ? d(L) : L === 36 ? (b = s.enter("mathTextSequence"), g = 0, O(L)) : L === 32 ? (s.enter("space"), s.consume(L), s.exit("space"), R) : ft(L) ? (s.enter("lineEnding"), s.consume(L), s.exit("lineEnding"), R) : (s.enter("mathTextData"), E(L));
    }
    function E(L) {
      return L === null || L === 32 || L === 36 || ft(L) ? (s.exit("mathTextData"), R(L)) : (s.consume(L), E);
    }
    function O(L) {
      return L === 36 ? (s.consume(L), g++, O) : g === y ? (s.exit("mathTextSequence"), s.exit("mathText"), h(L)) : (b.type = "mathTextData", E(L));
    }
  }
}
function ZB(r) {
  let t = r.length - 4, a = 3, i, s;
  if ((r[a][1].type === "lineEnding" || r[a][1].type === "space") && (r[t][1].type === "lineEnding" || r[t][1].type === "space")) {
    for (i = a; ++i < t; )
      if (r[i][1].type === "mathTextData") {
        r[t][1].type = "mathTextPadding", r[a][1].type = "mathTextPadding", a += 2, t -= 2;
        break;
      }
  }
  for (i = a - 1, t++; ++i <= t; )
    s === void 0 ? i !== t && r[i][1].type !== "lineEnding" && (s = i) : (i === t || r[i][1].type === "lineEnding") && (r[s][1].type = "mathTextData", i !== s + 2 && (r[s][1].end = r[i - 1][1].end, r.splice(s + 2, i - s - 2), t -= i - s - 2, i = s + 2), s = void 0);
  return r;
}
function FB(r) {
  return r !== 36 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function PB(r) {
  return {
    flow: {
      36: IB
    },
    text: {
      36: QB(r)
    }
  };
}
const KB = {};
function JB(r) {
  const t = (
    /** @type {Processor} */
    this
  ), a = r || KB, i = t.data(), s = i.micromarkExtensions || (i.micromarkExtensions = []), h = i.fromMarkdownExtensions || (i.fromMarkdownExtensions = []), d = i.toMarkdownExtensions || (i.toMarkdownExtensions = []);
  s.push(PB(a)), h.push(VB()), d.push(YB(a));
}
function oT(r) {
  var t, a, i = "";
  if (typeof r == "string" || typeof r == "number") i += r;
  else if (typeof r == "object") if (Array.isArray(r)) {
    var s = r.length;
    for (t = 0; t < s; t++) r[t] && (a = oT(r[t])) && (i && (i += " "), i += a);
  } else for (a in r) r[a] && (i && (i += " "), i += a);
  return i;
}
function WB() {
  for (var r, t, a = 0, i = "", s = arguments.length; a < s; a++) (r = arguments[a]) && (t = oT(r)) && (i && (i += " "), i += t);
  return i;
}
const F7 = "-", eH = (r) => {
  const t = nH(r), {
    conflictingClassGroups: a,
    conflictingClassGroupModifiers: i
  } = r;
  return {
    getClassGroupId: (d) => {
      const y = d.split(F7);
      return y[0] === "" && y.length !== 1 && y.shift(), sT(y, t) || tH(d);
    },
    getConflictingClassGroupIds: (d, y) => {
      const g = a[d] || [];
      return y && i[d] ? [...g, ...i[d]] : g;
    }
  };
}, sT = (r, t) => {
  var d;
  if (r.length === 0)
    return t.classGroupId;
  const a = r[0], i = t.nextPart.get(a), s = i ? sT(r.slice(1), i) : void 0;
  if (s)
    return s;
  if (t.validators.length === 0)
    return;
  const h = r.join(F7);
  return (d = t.validators.find(({
    validator: y
  }) => y(h))) == null ? void 0 : d.classGroupId;
}, mS = /^\[(.+)\]$/, tH = (r) => {
  if (mS.test(r)) {
    const t = mS.exec(r)[1], a = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (a)
      return "arbitrary.." + a;
  }
}, nH = (r) => {
  const {
    theme: t,
    classGroups: a
  } = r, i = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const s in a)
    V5(a[s], i, s, t);
  return i;
}, V5 = (r, t, a, i) => {
  r.forEach((s) => {
    if (typeof s == "string") {
      const h = s === "" ? t : pS(t, s);
      h.classGroupId = a;
      return;
    }
    if (typeof s == "function") {
      if (rH(s)) {
        V5(s(i), t, a, i);
        return;
      }
      t.validators.push({
        validator: s,
        classGroupId: a
      });
      return;
    }
    Object.entries(s).forEach(([h, d]) => {
      V5(d, pS(t, h), a, i);
    });
  });
}, pS = (r, t) => {
  let a = r;
  return t.split(F7).forEach((i) => {
    a.nextPart.has(i) || a.nextPart.set(i, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), a = a.nextPart.get(i);
  }), a;
}, rH = (r) => r.isThemeGetter, aH = (r) => {
  if (r < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, a = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  const s = (h, d) => {
    a.set(h, d), t++, t > r && (t = 0, i = a, a = /* @__PURE__ */ new Map());
  };
  return {
    get(h) {
      let d = a.get(h);
      if (d !== void 0)
        return d;
      if ((d = i.get(h)) !== void 0)
        return s(h, d), d;
    },
    set(h, d) {
      a.has(h) ? a.set(h, d) : s(h, d);
    }
  };
}, Y5 = "!", I5 = ":", lH = I5.length, iH = (r) => {
  const {
    prefix: t,
    experimentalParseClassName: a
  } = r;
  let i = (s) => {
    const h = [];
    let d = 0, y = 0, g = 0, b;
    for (let O = 0; O < s.length; O++) {
      let L = s[O];
      if (d === 0 && y === 0) {
        if (L === I5) {
          h.push(s.slice(g, O)), g = O + lH;
          continue;
        }
        if (L === "/") {
          b = O;
          continue;
        }
      }
      L === "[" ? d++ : L === "]" ? d-- : L === "(" ? y++ : L === ")" && y--;
    }
    const x = h.length === 0 ? s : s.substring(g), T = uH(x), R = T !== x, E = b && b > g ? b - g : void 0;
    return {
      modifiers: h,
      hasImportantModifier: R,
      baseClassName: T,
      maybePostfixModifierPosition: E
    };
  };
  if (t) {
    const s = t + I5, h = i;
    i = (d) => d.startsWith(s) ? h(d.substring(s.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: d,
      maybePostfixModifierPosition: void 0
    };
  }
  if (a) {
    const s = i;
    i = (h) => a({
      className: h,
      parseClassName: s
    });
  }
  return i;
}, uH = (r) => r.endsWith(Y5) ? r.substring(0, r.length - 1) : r.startsWith(Y5) ? r.substring(1) : r, oH = (r) => {
  const t = Object.fromEntries(r.orderSensitiveModifiers.map((i) => [i, !0]));
  return (i) => {
    if (i.length <= 1)
      return i;
    const s = [];
    let h = [];
    return i.forEach((d) => {
      d[0] === "[" || t[d] ? (s.push(...h.sort(), d), h = []) : h.push(d);
    }), s.push(...h.sort()), s;
  };
}, sH = (r) => ({
  cache: aH(r.cacheSize),
  parseClassName: iH(r),
  sortModifiers: oH(r),
  ...eH(r)
}), cH = /\s+/, fH = (r, t) => {
  const {
    parseClassName: a,
    getClassGroupId: i,
    getConflictingClassGroupIds: s,
    sortModifiers: h
  } = t, d = [], y = r.trim().split(cH);
  let g = "";
  for (let b = y.length - 1; b >= 0; b -= 1) {
    const x = y[b], {
      isExternal: T,
      modifiers: R,
      hasImportantModifier: E,
      baseClassName: O,
      maybePostfixModifierPosition: L
    } = a(x);
    if (T) {
      g = x + (g.length > 0 ? " " + g : g);
      continue;
    }
    let G = !!L, V = i(G ? O.substring(0, L) : O);
    if (!V) {
      if (!G) {
        g = x + (g.length > 0 ? " " + g : g);
        continue;
      }
      if (V = i(O), !V) {
        g = x + (g.length > 0 ? " " + g : g);
        continue;
      }
      G = !1;
    }
    const I = h(R).join(":"), $ = E ? I + Y5 : I, ce = $ + V;
    if (d.includes(ce))
      continue;
    d.push(ce);
    const se = s(V, G);
    for (let te = 0; te < se.length; ++te) {
      const Ce = se[te];
      d.push($ + Ce);
    }
    g = x + (g.length > 0 ? " " + g : g);
  }
  return g;
};
function hH() {
  let r = 0, t, a, i = "";
  for (; r < arguments.length; )
    (t = arguments[r++]) && (a = cT(t)) && (i && (i += " "), i += a);
  return i;
}
const cT = (r) => {
  if (typeof r == "string")
    return r;
  let t, a = "";
  for (let i = 0; i < r.length; i++)
    r[i] && (t = cT(r[i])) && (a && (a += " "), a += t);
  return a;
};
function dH(r, ...t) {
  let a, i, s, h = d;
  function d(g) {
    const b = t.reduce((x, T) => T(x), r());
    return a = sH(b), i = a.cache.get, s = a.cache.set, h = y, y(g);
  }
  function y(g) {
    const b = i(g);
    if (b)
      return b;
    const x = fH(g, a);
    return s(g, x), x;
  }
  return function() {
    return h(hH.apply(null, arguments));
  };
}
const $r = (r) => {
  const t = (a) => a[r] || [];
  return t.isThemeGetter = !0, t;
}, fT = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, hT = /^\((?:(\w[\w-]*):)?(.+)\)$/i, mH = /^\d+\/\d+$/, pH = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, gH = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, yH = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, vH = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, bH = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, wm = (r) => mH.test(r), Xt = (r) => !!r && !Number.isNaN(Number(r)), n0 = (r) => !!r && Number.isInteger(Number(r)), d5 = (r) => r.endsWith("%") && Xt(r.slice(0, -1)), xs = (r) => pH.test(r), SH = () => !0, xH = (r) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  gH.test(r) && !yH.test(r)
), dT = () => !1, wH = (r) => vH.test(r), TH = (r) => bH.test(r), EH = (r) => !lt(r) && !it(r), AH = (r) => Lm(r, gT, dT), lt = (r) => fT.test(r), Pf = (r) => Lm(r, yT, xH), m5 = (r) => Lm(r, MH, Xt), gS = (r) => Lm(r, mT, dT), kH = (r) => Lm(r, pT, TH), Sv = (r) => Lm(r, vT, wH), it = (r) => hT.test(r), Bg = (r) => Bm(r, yT), RH = (r) => Bm(r, _H), yS = (r) => Bm(r, mT), zH = (r) => Bm(r, gT), CH = (r) => Bm(r, pT), xv = (r) => Bm(r, vT, !0), Lm = (r, t, a) => {
  const i = fT.exec(r);
  return i ? i[1] ? t(i[1]) : a(i[2]) : !1;
}, Bm = (r, t, a = !1) => {
  const i = hT.exec(r);
  return i ? i[1] ? t(i[1]) : a : !1;
}, mT = (r) => r === "position" || r === "percentage", pT = (r) => r === "image" || r === "url", gT = (r) => r === "length" || r === "size" || r === "bg-size", yT = (r) => r === "length", MH = (r) => r === "number", _H = (r) => r === "family-name", vT = (r) => r === "shadow", OH = () => {
  const r = $r("color"), t = $r("font"), a = $r("text"), i = $r("font-weight"), s = $r("tracking"), h = $r("leading"), d = $r("breakpoint"), y = $r("container"), g = $r("spacing"), b = $r("radius"), x = $r("shadow"), T = $r("inset-shadow"), R = $r("text-shadow"), E = $r("drop-shadow"), O = $r("blur"), L = $r("perspective"), G = $r("aspect"), V = $r("ease"), I = $r("animate"), $ = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], ce = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], se = () => [...ce(), it, lt], te = () => ["auto", "hidden", "clip", "visible", "scroll"], Ce = () => ["auto", "contain", "none"], ve = () => [it, lt, g], Ne = () => [wm, "full", "auto", ...ve()], ee = () => [n0, "none", "subgrid", it, lt], De = () => ["auto", {
    span: ["full", n0, it, lt]
  }, n0, it, lt], de = () => [n0, "auto", it, lt], Ye = () => ["auto", "min", "max", "fr", it, lt], Te = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], re = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], J = () => ["auto", ...ve()], X = () => [wm, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...ve()], W = () => [r, it, lt], be = () => [...ce(), yS, gS, {
    position: [it, lt]
  }], C = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], Y = () => ["auto", "cover", "contain", zH, AH, {
    size: [it, lt]
  }], ie = () => [d5, Bg, Pf], N = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    b,
    it,
    lt
  ], Me = () => ["", Xt, Bg, Pf], _e = () => ["solid", "dashed", "dotted", "double"], Se = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], Ge = () => [Xt, d5, yS, gS], rt = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    O,
    it,
    lt
  ], ht = () => ["none", Xt, it, lt], vt = () => ["none", Xt, it, lt], St = () => [Xt, it, lt], wn = () => [wm, "full", ...ve()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [xs],
      breakpoint: [xs],
      color: [SH],
      container: [xs],
      "drop-shadow": [xs],
      ease: ["in", "out", "in-out"],
      font: [EH],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [xs],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [xs],
      shadow: [xs],
      spacing: ["px", Xt],
      text: [xs],
      "text-shadow": [xs],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", wm, lt, it, G]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Xt, lt, it, y]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": $()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": $()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: se()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: te()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": te()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": te()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: Ce()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": Ce()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": Ce()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: Ne()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": Ne()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": Ne()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: Ne()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: Ne()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: Ne()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: Ne()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: Ne()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: Ne()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [n0, "auto", it, lt]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [wm, "full", "auto", y, ...ve()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [Xt, wm, "auto", "initial", "none", lt]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", Xt, it, lt]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", Xt, it, lt]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [n0, "first", "last", "none", it, lt]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": ee()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: De()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": de()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": de()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": ee()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: De()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": de()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": de()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": Ye()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": Ye()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: ve()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": ve()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": ve()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...Te(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...re(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...re()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...Te()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...re(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...re(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": Te()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...re(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...re()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: ve()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: ve()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: ve()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: ve()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: ve()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: ve()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: ve()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: ve()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: ve()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: J()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: J()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: J()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: J()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: J()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: J()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: J()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: J()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: J()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": ve()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": ve()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: X()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [y, "screen", ...X()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          y,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...X()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          y,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [d]
          },
          ...X()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...X()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...X()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...X()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", a, Bg, Pf]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [i, it, m5]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", d5, lt]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [RH, lt, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [s, it, lt]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [Xt, "none", it, m5]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          h,
          ...ve()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", it, lt]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", it, lt]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: W()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: W()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [..._e(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [Xt, "from-font", "auto", it, Pf]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: W()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [Xt, "auto", it, lt]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: ve()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", it, lt]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", it, lt]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: be()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: C()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: Y()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, n0, it, lt],
          radial: ["", it, lt],
          conic: [n0, it, lt]
        }, CH, kH]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: W()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: ie()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: ie()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: ie()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: W()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: W()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: W()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: N()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": N()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": N()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": N()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": N()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": N()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": N()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": N()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": N()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": N()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": N()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": N()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": N()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": N()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": N()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: Me()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": Me()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": Me()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": Me()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": Me()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": Me()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": Me()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": Me()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": Me()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": Me()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": Me()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [..._e(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [..._e(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: W()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": W()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": W()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": W()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": W()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": W()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": W()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": W()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": W()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: W()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [..._e(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Xt, it, lt]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", Xt, Bg, Pf]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: W()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          x,
          xv,
          Sv
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: W()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", T, xv, Sv]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": W()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: Me()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: W()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [Xt, Pf]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": W()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": Me()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": W()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", R, xv, Sv]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": W()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [Xt, it, lt]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Se(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Se()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [Xt]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": Ge()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": Ge()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": W()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": W()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": Ge()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": Ge()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": W()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": W()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": Ge()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": Ge()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": W()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": W()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": Ge()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": Ge()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": W()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": W()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": Ge()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": Ge()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": W()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": W()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": Ge()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": Ge()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": W()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": W()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": Ge()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": Ge()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": W()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": W()
      }],
      "mask-image-radial": [{
        "mask-radial": [it, lt]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": Ge()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": Ge()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": W()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": W()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": ce()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [Xt]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": Ge()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": Ge()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": W()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": W()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: be()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: C()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: Y()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", it, lt]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          it,
          lt
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: rt()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [Xt, it, lt]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [Xt, it, lt]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          E,
          xv,
          Sv
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": W()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", Xt, it, lt]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [Xt, it, lt]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", Xt, it, lt]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [Xt, it, lt]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", Xt, it, lt]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          it,
          lt
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": rt()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [Xt, it, lt]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [Xt, it, lt]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", Xt, it, lt]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [Xt, it, lt]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", Xt, it, lt]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [Xt, it, lt]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [Xt, it, lt]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", Xt, it, lt]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": ve()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": ve()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": ve()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", it, lt]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [Xt, "initial", it, lt]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", V, it, lt]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [Xt, it, lt]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", I, it, lt]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [L, it, lt]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": se()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: ht()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": ht()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": ht()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": ht()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: vt()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": vt()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": vt()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": vt()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: St()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": St()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": St()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [it, lt, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: se()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: wn()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": wn()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": wn()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": wn()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: W()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: W()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", it, lt]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": ve()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": ve()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": ve()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": ve()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": ve()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": ve()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": ve()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": ve()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": ve()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": ve()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": ve()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": ve()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": ve()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": ve()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": ve()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": ve()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": ve()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": ve()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", it, lt]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...W()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Xt, Bg, Pf, m5]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...W()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, DH = /* @__PURE__ */ dH(OH);
function Xr(...r) {
  return DH(WB(r));
}
const NH = {
  h1: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "h1",
    {
      className: Xr(
        "mb-8 scroll-m-20 text-4xl font-extrabold tracking-tight last:mb-0",
        r
      ),
      ...a
    }
  ),
  h2: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "h2",
    {
      className: Xr(
        "mt-8 mb-4 scroll-m-20 text-3xl font-semibold tracking-tight first:mt-0 last:mb-0",
        r
      ),
      ...a
    }
  ),
  h3: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "h3",
    {
      className: Xr(
        "mt-6 mb-4 scroll-m-20 text-2xl font-semibold tracking-tight first:mt-0 last:mb-0",
        r
      ),
      ...a
    }
  ),
  h4: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "h4",
    {
      className: Xr(
        "mt-6 mb-4 scroll-m-20 text-xl font-semibold tracking-tight first:mt-0 last:mb-0",
        r
      ),
      ...a
    }
  ),
  h5: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "h5",
    {
      className: Xr(
        "my-4 text-lg font-semibold first:mt-0 last:mb-0",
        r
      ),
      ...a
    }
  ),
  h6: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "h6",
    {
      className: Xr("my-4 font-semibold first:mt-0 last:mb-0", r),
      ...a
    }
  ),
  p: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "p",
    {
      className: Xr("leading-7 first:mt-0 last:mb-0", r),
      ...a
    }
  ),
  a: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "a",
    {
      className: Xr(
        "text-primary font-medium underline underline-offset-4",
        r
      ),
      ...a
    }
  ),
  blockquote: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "blockquote",
    {
      className: Xr("border-l-2 pl-6 italic", r),
      ...a
    }
  ),
  ul: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "ul",
    {
      className: Xr("my-2 ml-2 list-disc [&>li]:mt-1", r),
      ...a
    }
  ),
  ol: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "ol",
    {
      className: Xr("my-2 ml-2 list-decimal [&>li]:mt-1", r),
      ...a
    }
  ),
  hr: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "hr",
    {
      className: Xr("my-5 border-b", r),
      ...a
    }
  ),
  table: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "table",
    {
      className: Xr(
        "my-5 w-full border-separate border-spacing-0 overflow-y-auto",
        r
      ),
      ...a
    }
  ),
  th: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "th",
    {
      className: Xr(
        "bg-muted px-4 py-2 text-left font-bold first:rounded-tl-lg last:rounded-tr-lg [&[align=center]]:text-center [&[align=right]]:text-right",
        r
      ),
      ...a
    }
  ),
  td: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "td",
    {
      className: Xr(
        "border-b border-l px-4 py-2 text-left last:border-r [&[align=center]]:text-center [&[align=right]]:text-right",
        r
      ),
      ...a
    }
  ),
  tr: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "tr",
    {
      className: Xr(
        "m-0 border-b p-0 first:border-t [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg",
        r
      ),
      ...a
    }
  ),
  sup: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "sup",
    {
      className: Xr("[&>a]:text-xs [&>a]:no-underline", r),
      ...a
    }
  ),
  pre: ({ className: r, node: t, ...a }) => /* @__PURE__ */ He.jsx(
    "pre",
    {
      className: Xr(
        "max-w-4xl overflow-x-auto rounded-lg bg-black text-white",
        r
      ),
      ...a
    }
  ),
  code: ({
    className: r,
    children: t,
    node: a,
    ...i
  }) => /* @__PURE__ */ He.jsx("pre", { className: Xr("max-w-4xl overflow-x-auto rounded-lg bg-black text-white", r), children: /* @__PURE__ */ He.jsx("code", { ...i, children: t }) })
}, LH = ({ children: r }) => /* @__PURE__ */ He.jsx("div", { className: "markdown-content", children: /* @__PURE__ */ He.jsx(
  K_,
  {
    remarkPlugins: [sN, JB],
    rehypePlugins: [GB],
    components: NH,
    children: r
  }
) }), bT = zt.memo(LH), BH = ({ initialTitle: r, resourcePath: t = "/", initializeHidden: a = !1 }) => {
  const {
    messages: i,
    inputValue: s,
    setInputValue: h,
    setIsMinimized: d,
    messagesEndRef: y,
    handleSendMessage: g,
    isLoading: b
  } = PS(), { setThreadId: x } = o7(), [T, R] = br.useState(!1), [E, O] = br.useState(null), [L, G] = br.useState(a);
  br.useEffect(() => {
    d(a);
  }, [a, d]), br.useEffect(() => {
    T && O(Xg());
  }, [T]);
  const V = (ce) => {
    x(ce), R(!1);
  }, I = () => G(!0), $ = () => G(!1);
  return L ? /* @__PURE__ */ He.jsxs("div", { className: "minimized-widget-bar", onClick: $, children: [
    /* @__PURE__ */ He.jsx("img", { src: `${t}robot.png`, alt: "Chatbot", className: "minimized-robot-image" }),
    /* @__PURE__ */ He.jsx("span", { className: "minimized-heading", children: r || Cv })
  ] }) : /* @__PURE__ */ He.jsxs("div", { className: "page-layout homepage-widget-scope", style: { position: "relative" }, children: [
    /* @__PURE__ */ He.jsx("div", { className: "robot-column", children: /* @__PURE__ */ He.jsx("img", { src: `${t}robot.png`, alt: "AI Assistant", className: "robot-image" }) }),
    /* @__PURE__ */ He.jsxs("div", { className: "main-area-content", children: [
      /* @__PURE__ */ He.jsxs("div", { className: "hp-welcome-and-icons-row", children: [
        /* @__PURE__ */ He.jsx("div", { className: "content-header", children: /* @__PURE__ */ He.jsx("h1", { className: "welcome-heading", children: r || Cv }) }),
        /* @__PURE__ */ He.jsxs("div", { className: "header-icons-inline", children: [
          /* @__PURE__ */ He.jsx(
            "img",
            {
              src: `${t}history-icon.svg`,
              alt: "History",
              className: "header-icon",
              onClick: () => R(!0),
              style: { cursor: "pointer" }
            }
          ),
          /* @__PURE__ */ He.jsx("img", { src: `${t}close-icon.svg`, alt: "Close", className: "header-icon", onClick: I })
        ] })
      ] }),
      T && /* @__PURE__ */ He.jsxs(
        "div",
        {
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "auto",
            minHeight: "400px",
            maxHeight: "600px",
            background: "rgba(255,255,255,0.97)",
            zIndex: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start"
          },
          children: [
            /* @__PURE__ */ He.jsx("div", { style: { width: "100%", textAlign: "right", padding: "0 20px" }, children: /* @__PURE__ */ He.jsx(
              "button",
              {
                onClick: () => R(!1),
                style: { fontSize: 22, background: "none", border: "none", cursor: "pointer" },
                title: "Zavřít historii",
                children: "×"
              }
            ) }),
            /* @__PURE__ */ He.jsxs("div", { style: { display: "flex", alignItems: "center", marginTop: 6, marginBottom: 4 }, children: [
              /* @__PURE__ */ He.jsx("img", { src: `${t}robot.png`, alt: "Robot", style: { width: 32, height: 32, marginRight: 10 } }),
              /* @__PURE__ */ He.jsx(
                "div",
                {
                  style: {
                    background: "#8b4c9b",
                    color: "white",
                    borderRadius: 14,
                    padding: "7px 16px",
                    fontSize: "1em",
                    fontWeight: 500,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                    maxWidth: 220,
                    textAlign: "center"
                  },
                  children: "Historie konverzace"
                }
              )
            ] }),
            /* @__PURE__ */ He.jsx("div", { style: { marginTop: 0, width: "100%", maxWidth: 600, minHeight: 200, textAlign: "center", maxHeight: 400, overflowY: "auto" }, children: E && (E.length > 0 ? /* @__PURE__ */ He.jsx("ul", { style: { marginTop: 10, padding: 0, listStyle: "none" }, children: E.map((ce) => /* @__PURE__ */ He.jsx("li", { style: { padding: "10px 0", borderBottom: "1px solid #eee" }, children: /* @__PURE__ */ He.jsxs(
              "button",
              {
                onClick: () => V(ce.threadId),
                style: {
                  background: "#f8f8f8",
                  border: "1px solid #ddd",
                  borderRadius: 10,
                  padding: "10px 16px",
                  width: "100%",
                  textAlign: "left",
                  cursor: "pointer",
                  fontWeight: 500,
                  fontSize: "1em",
                  transition: "background 0.15s"
                },
                children: [
                  /* @__PURE__ */ He.jsx("div", { style: { fontSize: "0.9em", color: "#888", fontWeight: 400 }, children: new Date(ce.createdAt).toLocaleString() }),
                  /* @__PURE__ */ He.jsx("div", { style: { fontSize: "1em", color: "#222", fontWeight: 500, marginTop: 4 }, children: ce.title || /* @__PURE__ */ He.jsx("span", { style: { color: "#bbb" }, children: "(bez názvu)" }) })
                ]
              }
            ) }, ce.threadId)) }) : /* @__PURE__ */ He.jsx("div", { style: { marginTop: 20, color: "#888" }, children: "Žádné předchozí konverzace nebyly nalezeny." })) })
          ]
        }
      ),
      /* @__PURE__ */ He.jsxs("div", { className: "chat-widget", children: [
        /* @__PURE__ */ He.jsxs("div", { className: "chat-messages", children: [
          i.filter((ce) => ce.type !== "tool").map((ce) => /* @__PURE__ */ He.jsx(
            "div",
            {
              className: `message-bubble ${ce.type === "human" ? "user-message" : ""} ${ce.type === "ai" ? "ai-message" : ""} ${ce.type === "system" ? "system-message" : ""}`,
              children: /* @__PURE__ */ He.jsx("div", { className: "message-content", children: /* @__PURE__ */ He.jsx(bT, { children: ce.content }) })
            },
            ce.id
          )),
          /* @__PURE__ */ He.jsx("div", { ref: y })
        ] }),
        /* @__PURE__ */ He.jsxs("div", { className: "chat-input-container", children: [
          /* @__PURE__ */ He.jsx(
            "input",
            {
              type: "text",
              className: "chat-input",
              placeholder: "Zeptej se na cokoliv..",
              value: s,
              onChange: (ce) => h(ce.target.value),
              onKeyDown: (ce) => {
                ce.key === "Enter" && !ce.shiftKey && (ce.preventDefault(), g());
              },
              disabled: b
            }
          ),
          /* @__PURE__ */ He.jsx(
            "button",
            {
              className: "send-button",
              onClick: g,
              disabled: !s.trim() || b,
              children: /* @__PURE__ */ He.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ He.jsx("path", { d: "M2 12L20 12M20 12L14 6M20 12L14 18", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) })
            }
          )
        ] })
      ] })
    ] })
  ] });
}, HH = ({ initialTitle: r, resourcePath: t = "/", initializeHidden: a = !1, isAdmin: i = !1 }) => {
  const s = r || Cv, {
    messages: h,
    inputValue: d,
    setInputValue: y,
    messagesEndRef: g,
    handleSendMessage: b,
    isLoading: x,
    handleCancel: T,
    handleNewChat: R
  } = PS(), { setThreadId: E, threadId: O } = o7(), [L, G] = br.useState(!1), [V, I] = br.useState(null), [$, ce] = br.useState(!1);
  br.useEffect(() => {
    ce(!!x);
  }, [x]);
  const se = br.useRef(null), te = br.useRef(x);
  br.useEffect(() => {
    var re;
    te.current && !x && ((re = se.current) == null || re.focus()), te.current = x;
  }, [x]), br.useEffect(() => {
    L && I(Xg());
  }, [L]);
  const Ce = (re) => {
    E(re), G(!1);
  }, [ve, Ne] = br.useState(!a), [ee, De] = br.useState(!a);
  br.useEffect(() => {
    window._pendingLeftSideWidgetCallbacks && (window.leftSideWidgetCallbacks = window._pendingLeftSideWidgetCallbacks, delete window._pendingLeftSideWidgetCallbacks);
  }, []);
  const de = br.useCallback(() => {
    De(!0), setTimeout(() => {
      var re;
      (re = window.leftSideWidgetCallbacks) != null && re.onBeforeOpen ? window.leftSideWidgetCallbacks.onBeforeOpen(() => {
        Ne(!0);
      }) : Ne(!0);
    }, 50);
  }, []), Ye = br.useCallback(() => {
    var re;
    (re = window.leftSideWidgetCallbacks) != null && re.onBeforeClose ? window.leftSideWidgetCallbacks.onBeforeClose(() => {
      Ne(!1), De(!1);
    }) : (Ne(!1), De(!1));
  }, []), Te = br.useCallback(() => {
    ve ? Ye() : de();
  }, [ve, de, Ye]);
  return br.useEffect(() => (window.toggleLeftSideWidget = Te, window.setLeftSideWidgetCallbacks = (re) => {
    window.leftSideWidgetCallbacks = re;
  }, () => {
    delete window.toggleLeftSideWidget, delete window.setLeftSideWidgetCallbacks;
  }), [Te]), ee ? /* @__PURE__ */ He.jsxs("div", { className: `left-side-widget-layout leftside-widget-scope${ve ? " show-width" : " hide-width"}`, style: { position: "relative" }, children: [
    /* @__PURE__ */ He.jsxs("div", { className: "ls-top-bar", children: [
      /* @__PURE__ */ He.jsx("div", { className: "ls-top-bar-left", children: /* @__PURE__ */ He.jsx("span", { className: "ls-icon ls-icon-newchat", title: "Nový chat", onClick: R, style: { cursor: "pointer" }, children: /* @__PURE__ */ He.jsx("img", { src: `${t}svg/newchat.svg`, alt: "Nový chat", width: 32, height: 32 }) }) }),
      /* @__PURE__ */ He.jsxs("div", { className: "ls-top-bar-right", children: [
        /* @__PURE__ */ He.jsx("span", { className: "ls-icon ls-icon-history", title: "Historie", onClick: () => G(!0), style: { cursor: "pointer" }, children: /* @__PURE__ */ He.jsx("img", { src: `${t}svg/history-leftside.svg`, alt: "Historie", width: 32, height: 32 }) }),
        /* @__PURE__ */ He.jsx("span", { className: "ls-icon ls-icon-close", title: "Zavřít", onClick: Te, children: /* @__PURE__ */ He.jsx("img", { src: `${t}svg/close-leftside.svg`, alt: "Zavřít", width: 32, height: 32 }) })
      ] })
    ] }),
    L && /* @__PURE__ */ He.jsxs("div", { style: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "auto",
      minHeight: "400px",
      maxHeight: "600px",
      background: "rgba(255,255,255,0.97)",
      zIndex: 10,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start"
    }, children: [
      /* @__PURE__ */ He.jsx("div", { style: { width: "100%", textAlign: "right", padding: "0 20px" }, children: /* @__PURE__ */ He.jsx("button", { onClick: () => G(!1), style: { fontSize: 22, background: "none", border: "none", cursor: "pointer" }, title: "Zavřít historii", children: "×" }) }),
      /* @__PURE__ */ He.jsxs("div", { style: { display: "flex", alignItems: "center", marginTop: 6, marginBottom: 4 }, children: [
        /* @__PURE__ */ He.jsx("img", { src: `${t}robot.png`, alt: "Robot", style: { width: 32, height: 32, marginRight: 10 } }),
        /* @__PURE__ */ He.jsx("div", { style: {
          background: "#8b4c9b",
          color: "white",
          borderRadius: 14,
          padding: "7px 16px",
          fontSize: "1em",
          fontWeight: 500,
          boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
          maxWidth: 220,
          textAlign: "center"
        }, children: "Historie konverzace" })
      ] }),
      /* @__PURE__ */ He.jsx("div", { style: { marginTop: 0, width: "100%", maxWidth: 600, minHeight: 200, textAlign: "center", maxHeight: 400, overflowY: "auto" }, children: V && (V.length > 0 ? /* @__PURE__ */ He.jsx("ul", { style: { marginTop: 10, padding: 0, listStyle: "none" }, children: V.map((re) => /* @__PURE__ */ He.jsx("li", { style: { padding: "10px 0", borderBottom: "1px solid #eee" }, children: /* @__PURE__ */ He.jsxs(
        "button",
        {
          onClick: () => Ce(re.threadId),
          style: {
            background: "#f8f8f8",
            border: "1px solid #ddd",
            borderRadius: 10,
            padding: "10px 16px",
            width: "100%",
            textAlign: "left",
            cursor: "pointer",
            fontWeight: 500,
            fontSize: "1em",
            transition: "background 0.15s"
          },
          children: [
            /* @__PURE__ */ He.jsx("div", { style: { fontSize: "0.9em", color: "#888", fontWeight: 400 }, children: new Date(re.createdAt).toLocaleString() }),
            /* @__PURE__ */ He.jsx("div", { style: { fontSize: "1em", color: "#222", fontWeight: 500, marginTop: 4 }, children: re.title || /* @__PURE__ */ He.jsx("span", { style: { color: "#bbb" }, children: "(bez názvu)" }) })
          ]
        }
      ) }, re.threadId)) }) : /* @__PURE__ */ He.jsx("div", { style: { marginTop: 20, color: "#888" }, children: "Žádné předchozí konverzace nebyly nalezeny." })) })
    ] }),
    /* @__PURE__ */ He.jsxs("div", { className: "ls-header", children: [
      /* @__PURE__ */ He.jsx("img", { src: `${t}robot.png`, alt: "Robot", className: "ls-robot-avatar" }),
      /* @__PURE__ */ He.jsx("div", { className: "ls-title-bubble", children: s })
    ] }),
    /* @__PURE__ */ He.jsxs("div", { className: "ls-messages-area", children: [
      h.filter((re) => (re.type !== "tool" || i) && re.content && re.content.trim() !== "").map((re) => /* @__PURE__ */ He.jsx(
        "div",
        {
          className: `ls-message-bubble ${re.type === "human" ? "ls-user-message" : ""} ${re.type === "ai" ? "ls-ai-message" : ""} 
              ${re.type === "tool" ? "ls-tool-message" : ""}
              ${re.type === "system" ? "ls-system-message" : ""}`,
          children: /* @__PURE__ */ He.jsx("div", { className: "ls-message-content", children: /* @__PURE__ */ He.jsx(bT, { children: re.content }) })
        },
        re.id
      )),
      $ && /* @__PURE__ */ He.jsx("div", { style: { color: "#888", textAlign: "center", margin: "10px 0", fontSize: "0.95em" }, children: "Pracuji..." }),
      /* @__PURE__ */ He.jsx("div", { ref: g })
    ] }),
    /* @__PURE__ */ He.jsxs("div", { className: "ls-input-area", children: [
      /* @__PURE__ */ He.jsx(
        "input",
        {
          ref: se,
          type: "text",
          placeholder: "Zeptej se na cokoliv...",
          className: "ls-input-field",
          value: d,
          onChange: (re) => y(re.target.value),
          onKeyDown: (re) => {
            re.key === "Enter" && !re.shiftKey && !x && (re.preventDefault(), b());
          },
          disabled: x
        }
      ),
      x ? /* @__PURE__ */ He.jsx("button", { className: "ls-cancel-button", onClick: T, title: "Zastavit", children: /* @__PURE__ */ He.jsx("img", { src: `${t}svg/stop.svg`, alt: "Zastavit", width: 20, height: 20 }) }) : /* @__PURE__ */ He.jsx(
        "button",
        {
          className: "ls-send-button",
          onClick: b,
          disabled: !d.trim() || x,
          children: /* @__PURE__ */ He.jsx("img", { src: `${t}svg/send.svg`, alt: "Odeslat", width: 20, height: 20 })
        }
      )
    ] }),
    i && O && /* @__PURE__ */ He.jsxs("div", { className: "ls-thread-id", children: [
      "Thread ID: ",
      O
    ] })
  ] }) : null;
}, UH = ({
  apiUrl: r,
  assistantId: t,
  authHash: a,
  initialTitle: i,
  widgetType: s,
  resourcePath: h = "/",
  // Default
  initializeHidden: d = !1,
  // přidáno
  isAdmin: y = !1
}) => {
  const g = s || window.widgetType || "homepage", [b, x] = zt.useState(i || wR());
  zt.useEffect(() => {
    i && x(i);
    const R = TR(x);
    return () => R();
  }, [i]);
  let T;
  switch (g) {
    case "leftSide":
      T = HH;
      break;
    case "homepage":
    default:
      T = BH;
      break;
  }
  return /* @__PURE__ */ He.jsx(
    pR,
    {
      apiUrl: r,
      assistantId: t,
      authHash: a,
      children: /* @__PURE__ */ He.jsx(
        T,
        {
          initialTitle: b,
          resourcePath: h,
          initializeHidden: d,
          isAdmin: y
        }
      )
    }
  );
};
class qH {
  constructor() {
    Ky(this, "root");
    Ky(this, "initialized", !1);
    // Flag to track initialization
    Ky(this, "resourcePath", "/");
  }
  // Default
  init(t) {
    if (this.initialized)
      return;
    const a = document.getElementById(t.elementId);
    if (!a) {
      console.error(`Element with id "${t.elementId}" not found`);
      return;
    }
    typeof window.setLeftSideWidgetCallbacks == "function" ? window.setLeftSideWidgetCallbacks({
      onBeforeOpen: t.onBeforeOpen,
      onBeforeClose: t.onBeforeClose
    }) : window._pendingLeftSideWidgetCallbacks = {
      onBeforeOpen: t.onBeforeOpen,
      onBeforeClose: t.onBeforeClose
    }, this.resourcePath = t.resourcePath || "/", this.root = GE.createRoot(a), this.root.render(
      /* @__PURE__ */ He.jsx(br.StrictMode, { children: /* @__PURE__ */ He.jsx(
        UH,
        {
          apiUrl: t.apiUrl,
          assistantId: t.assistantId,
          authHash: t.authHash,
          initialTitle: t.initialTitle,
          widgetType: t.widgetType,
          resourcePath: this.resourcePath,
          initializeHidden: t.initializeHidden,
          isAdmin: t.isAdmin
        }
      ) })
    ), this.initialized = !0;
  }
  setTitle(t) {
    xR(t);
  }
  toggleLeftSideWidget() {
    typeof window.toggleLeftSideWidget == "function" && window.toggleLeftSideWidget();
  }
}
const jH = new qH();
window.ChatWidget = jH;
window.initChatWidget && window.initChatWidget();
export {
  jH as default
};
